
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1n9DL", function(module, exports) {

$parcel$export(module.exports, "IssueSelect", () => $dc11768a03a17ec4$export$8ffbc9ffbaf94408);
$parcel$export(module.exports, "default", () => $dc11768a03a17ec4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6Yf0q = parcelRequire("6Yf0q");

var $hEORc = parcelRequire("hEORc");

var $eSzwT = parcelRequire("eSzwT");
const $dc11768a03a17ec4$var$EXCLUDED_ISSUE_IDS = [];
const $dc11768a03a17ec4$export$8ffbc9ffbaf94408 = ({ isDisabled: isDisabled, autoFocus: autoFocus, projectId: projectId, excludedProjectTypes: excludedProjectTypes, excludedIssueIds: excludedIssueIds = $dc11768a03a17ec4$var$EXCLUDED_ISSUE_IDS, hideArchived: hideArchived, isIdeasSelect: isIdeasSelect, placeholder: placeholder, defaultOptions: defaultOptions, onIssueSelected: onIssueSelected, isAttachedToBody: isAttachedToBody, renderOptionIconAfter: renderOptionIconAfter, onProjectChanged: onProjectChanged })=>{
    const [selectedIssue, setSelectedIssue] = (0, $eJOHy.useState)(undefined);
    const selectedIssueKey = (0, $eSzwT.useSelectedIssueKey)();
    const [{ archivedField: archivedField }] = (0, $hEORc.useArchivedFieldsConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Yf0q.IssueSelect), {
        archivedFieldLabel: archivedField?.label,
        selectedIssueKey: selectedIssueKey,
        isDisabled: isDisabled,
        autoFocus: autoFocus,
        placeholder: placeholder,
        defaultOptions: defaultOptions,
        isAttachedToBody: isAttachedToBody,
        selectedIssue: selectedIssue,
        setSelectedIssue: setSelectedIssue,
        projectId: projectId,
        excludedProjectTypes: excludedProjectTypes,
        onIssueSelected: onIssueSelected,
        excludedIssueIds: excludedIssueIds,
        renderOptionIconAfter: renderOptionIconAfter,
        hideArchived: hideArchived,
        isIdeasSelect: isIdeasSelect,
        onProjectChanged: onProjectChanged
    });
};
var // adding default export for importCond in jira/src/packages/polaris/lib/issue-select/src/ui/index.tsx, can be removed when fy26_nike_box_bundle_decrease_project is cleaned up
$dc11768a03a17ec4$export$2e2bcd8739ae039 = $dc11768a03a17ec4$export$8ffbc9ffbaf94408;

});
parcelRegister("6Yf0q", function(module, exports) {

$parcel$export(module.exports, "IssueSelect", () => $abbd1345faf0f255$export$8ffbc9ffbaf94408);

var $eJOHy = parcelRequire("eJOHy");

var $crnx3 = parcelRequire("crnx3");

var $c4OV1 = parcelRequire("c4OV1");

var $dPMMf = parcelRequire("dPMMf");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lvKO5 = parcelRequire("lvKO5");

var $dPqXv = parcelRequire("dPqXv");

var $bMbWf = parcelRequire("bMbWf");

var $HM5Jk = parcelRequire("HM5Jk");

var $9CRQU = parcelRequire("9CRQU");
const $abbd1345faf0f255$var$EXCLUDED_ISSUE_IDS = [];
const $abbd1345faf0f255$export$8ffbc9ffbaf94408 = ({ archivedFieldLabel: archivedFieldLabel, selectedIssueKey: selectedIssueKey, isDisabled: isDisabled, autoFocus: autoFocus, projectId: projectId, excludedProjectTypes: excludedProjectTypes, excludedIssueIds: excludedIssueIds = $abbd1345faf0f255$var$EXCLUDED_ISSUE_IDS, hideArchived: hideArchived, placeholder: placeholder, defaultOptions: defaultOptions, onIssueSelected: onIssueSelected, isAttachedToBody: isAttachedToBody = false, renderOptionIconAfter: renderOptionIconAfter, onProjectChanged: onProjectChanged, selectedIssue: selectedIssue, setSelectedIssue: setSelectedIssue, isIdeasSelect: isIdeasSelect = false })=>{
    const [inputString, setInputString] = (0, $eJOHy.useState)('');
    const [internalDefaultOptions, setInternalDefaultOptions] = (0, $eJOHy.useState)(defaultOptions);
    const [options, setOptions] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [menuIsOpen, setMenuIsOpen] = (0, $eJOHy.useState)(false);
    const [issueExactKey, setIssueExactKey] = (0, $eJOHy.useState)(undefined);
    const [fetchQuery$, setFetchQuery$] = (0, $eJOHy.useState)(undefined);
    const fetchIssues = (0, $9CRQU.useFetchIssues)(isIdeasSelect, selectedIssueKey, archivedFieldLabel);
    const { cloudName: cloudName } = (0, $lvKO5.useTenantContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const { query$: query$, unsubscribe: unsubscribe } = (0, $9CRQU.createFetchQuery)(setIsLoading, excludedIssueIds, fetchIssues, setOptions, setInternalDefaultOptions, defaultOptions);
        setFetchQuery$(query$);
        return ()=>unsubscribe();
    }, [
        defaultOptions,
        excludedIssueIds,
        fetchIssues
    ]);
    // trigger search on initial render (and whenever external props change)
    (0, $eJOHy.useEffect)(()=>{
        // to be improved with POL-10020
        // Don't call once again, when projectId is undefined and it's still loading - to handle copy & paste link case
        if (isLoading && projectId === undefined) return;
        fetchQuery$?.next({
            query: '%',
            currentProjectId: projectId,
            currentExcludedProjectTypes: excludedProjectTypes,
            hideArchivedIssues: hideArchived,
            isImmediate: true,
            isInitialLoading: true
        });
    // Dont't fire it when isLoading is changed
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        excludedProjectTypes,
        fetchQuery$,
        hideArchived,
        projectId
    ]);
    const noOptionsMessage = ()=>{
        if (isLoading) return formatMessage((0, $bMbWf.default).isLoading);
        if (inputString !== undefined) return isIdeasSelect ? formatMessage((0, $bMbWf.default).noIdeasFound) : formatMessage((0, $7jTnu.fg)('polaris-issue-terminology-refresh') ? (0, $bMbWf.default).noIssuesFoundIssueTermRefresh : (0, $bMbWf.default).noIssuesFound);
        return formatMessage((0, $7jTnu.fg)('polaris-issue-terminology-refresh') ? (0, $bMbWf.default).typeToSearchIssueTermRefresh : (0, $bMbWf.default).typeToSearch);
    };
    const handleChange = (0, $eJOHy.useCallback)((selection)=>{
        if (selection === null) {
            setSelectedIssue && setSelectedIssue(undefined);
            onIssueSelected(undefined);
        } else {
            setSelectedIssue && setSelectedIssue(selection);
            onIssueSelected(selection);
        }
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issue', {
            selectedIssueId: selection?.item?.id.toString()
        });
    }, [
        onIssueSelected,
        createAnalyticsEvent,
        setSelectedIssue
    ]);
    const handleInputChange = (0, $eJOHy.useCallback)((inputValue)=>{
        if (inputValue !== inputString) {
            if (inputValue !== undefined && inputValue.trim().length > 0) {
                setOptions([]);
                const { searchString: searchString, isExactIssueSearchKey: isExactIssueSearchKey } = (0, $9CRQU.getSearchParams)(inputValue);
                isExactIssueSearchKey ? setIssueExactKey(searchString) : setIssueExactKey(undefined);
                // to handle copy & paste use case, only when there is an exact issue key
                if (isExactIssueSearchKey) {
                    setInputString(inputValue.trim());
                    onProjectChanged?.(undefined); // to be improved with POL-10020
                    fetchQuery$?.next({
                        query: searchString,
                        currentExcludedProjectTypes: excludedProjectTypes,
                        hideArchivedIssues: hideArchived,
                        issueKeySearch: true,
                        currentProjectId: undefined
                    });
                } else {
                    setInputString(searchString);
                    fetchQuery$?.next({
                        query: searchString,
                        currentExcludedProjectTypes: excludedProjectTypes,
                        hideArchivedIssues: hideArchived,
                        issueKeySearch: isExactIssueSearchKey,
                        currentProjectId: projectId
                    });
                }
            } else {
                // wildcard search when input is undefined or empty
                setIssueExactKey(undefined);
                setInputString(inputValue);
                fetchQuery$?.next({
                    query: '%',
                    currentProjectId: projectId,
                    currentExcludedProjectTypes: excludedProjectTypes,
                    hideArchivedIssues: hideArchived
                });
            }
        }
    }, [
        excludedProjectTypes,
        fetchQuery$,
        hideArchived,
        inputString,
        projectId,
        onProjectChanged
    ]);
    const onMenuOpen = (0, $eJOHy.useCallback)(()=>{
        setMenuIsOpen(true);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdown'
        }), 'issuesList');
    }, [
        createAnalyticsEvent
    ]);
    const onMenuClose = (0, $eJOHy.useCallback)(()=>{
        setMenuIsOpen(false);
    }, []);
    const groupedOptions = (0, $eJOHy.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($crnx3)))([
            defaultOptions !== undefined && {
                label: defaultOptions.label,
                options: defaultOptions.options.filter((option)=>!option.item?.id || !excludedIssueIds.includes(option.item?.id))
            },
            {
                label: isIdeasSelect ? formatMessage((0, $bMbWf.default).optionIdeasGroupSuggestions, {
                    cloudName: cloudName
                }) : formatMessage((0, $7jTnu.fg)('polaris-issue-terminology-refresh') ? (0, $bMbWf.default).optionGroupSuggestionsIssueTermRefresh : (0, $bMbWf.default).optionGroupSuggestions, {
                    cloudName: cloudName
                }),
                options: options || []
            }
        ]);
    }, [
        isIdeasSelect,
        cloudName,
        excludedIssueIds,
        defaultOptions,
        formatMessage,
        options
    ]);
    const filterOptionOnlyWhenIssueExactKey = (0, $eJOHy.useCallback)((option)=>option.data?.item?.key === issueExactKey, [
        issueExactKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'false'.
        isMulti: isIdeasSelect,
        testId: "polaris-lib-issue-select.ui.select",
        isDisabled: isDisabled,
        autoFocus: autoFocus,
        spacing: "compact",
        isSearchable: true,
        isLoading: isLoading,
        isClearable: true,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder !== undefined && placeholder !== null ? placeholder : formatMessage((0, $7jTnu.fg)('polaris-issue-terminology-refresh') ? (0, $bMbWf.default).issuePickerPlaceholderIssueTermRefresh : (0, $bMbWf.default).issuePickerPlaceholder),
        filterOption: issueExactKey ? filterOptionOnlyWhenIssueExactKey : undefined,
        defaultOptions: internalDefaultOptions,
        onChange: handleChange,
        value: selectedIssue,
        onInputChange: handleInputChange,
        inputValue: inputString,
        components: {
            Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $HM5Jk.Option), {
                    ...props,
                    renderIconAfter: renderOptionIconAfter
                }),
            SingleValue: isIdeasSelect ? undefined : (0, $HM5Jk.SelectedOption),
            // Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - error TS2322: Type '(props: MultiValueProps<IssueOption>) => React.JSX.Element' is not assignable to type 'ComponentType<MultiValueProps<IssueOption, false, GroupBase<IssueOption>>> | undefined'.
            MultiValue: isIdeasSelect ? (0, $HM5Jk.MultiSelectedOption) : undefined,
            DropdownIndicator: isIdeasSelect ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null) : undefined,
            Menu: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPqXv.LoadingMenu), props)
        },
        options: groupedOptions,
        menuIsOpen: menuIsOpen,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        menuShouldScrollIntoView: false,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: isAttachedToBody ? document.body : undefined,
        styles: {
            // without properly set zIndex value dropdown with options is cut inside modal dialogs
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Ignored via go/DSP-18766
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $dPMMf.layers).modal
                }),
            valueContainer: (base)=>({
                    ...base,
                    display: 'flex'
                }),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menu: (base)=>({
                    ...base,
                    zIndex: 99
                }),
            input: (base)=>({
                    ...base,
                    flex: 0,
                    height: isIdeasSelect ? '36px' : undefined
                }),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            placeholder: (base)=>({
                    ...base,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%',
                    position: 'absolute'
                })
        }
    });
};
$abbd1345faf0f255$export$8ffbc9ffbaf94408.defaultProps = {
    isAttachedToBody: false
};

});
parcelRegister("dPqXv", function(module, exports) {

$parcel$export(module.exports, "LoadingMenu", () => $01f620bcc44684fa$export$dab1248df0cdf0ab);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");
const $01f620bcc44684fa$export$6dd418ccd532615a = (props)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Menu, rest, children);
};
const $01f620bcc44684fa$export$dab1248df0cdf0ab = (props)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($01f620bcc44684fa$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($01f620bcc44684fa$export$6dd418ccd532615a, rest, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $01f620bcc44684fa$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bMbWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $543578e27c93d6b7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $543578e27c93d6b7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noIssuesFound: {
        "id": "polaris-lib-issue-select.no-issues-found",
        "defaultMessage": "No issues found"
    },
    noIssuesFoundIssueTermRefresh: {
        "id": "polaris-lib-issue-select.no-issues-found-issue-term-refresh",
        "defaultMessage": "No work items found"
    },
    noIdeasFound: {
        "id": "polaris-lib-issue-select.no-ideas-found",
        "defaultMessage": "No ideas found"
    },
    typeToSearch: {
        "id": "polaris-lib-issue-select.type-to-search",
        "defaultMessage": "Type to search for an issue"
    },
    typeToSearchIssueTermRefresh: {
        "id": "polaris-lib-issue-select.type-to-search-issue-term-refresh",
        "defaultMessage": "Type to search for a work item"
    },
    issuePickerPlaceholder: {
        "id": "polaris-lib-issue-select.issue-picker-placeholder",
        "defaultMessage": "Search for an issue"
    },
    issuePickerPlaceholderIssueTermRefresh: {
        "id": "polaris-lib-issue-select.issue-picker-placeholder-issue-term-refresh",
        "defaultMessage": "Search for a work item"
    },
    optionGroupSuggestions: {
        "id": "polaris-lib-issue-select.option-group-suggestions",
        "defaultMessage": "Issues in {cloudName}"
    },
    optionGroupSuggestionsIssueTermRefresh: {
        "id": "polaris-lib-issue-select.option-group-suggestions-issue-term-refresh",
        "defaultMessage": "Work items in {cloudName}"
    },
    optionIdeasGroupSuggestions: {
        "id": "polaris-lib-issue-select.option-ideas-group-suggestions",
        "defaultMessage": "Ideas in {cloudName}"
    },
    isLoading: {
        "id": "polaris-lib-issue-select.is-loading",
        "defaultMessage": "Loading ..."
    },
    issuePickerDefaultGroupLabel: {
        "id": "polaris-lib-issue-select.issue-picker-default-group-label",
        "defaultMessage": "In this project"
    }
});

});

parcelRegister("HM5Jk", function(module, exports) {

$parcel$export(module.exports, "Option", () => $ccfeffcc23e8684d$export$36d18380658d5d20);
$parcel$export(module.exports, "SelectedOption", () => $ccfeffcc23e8684d$export$ee46739492ed18b5);
$parcel$export(module.exports, "MultiSelectedOption", () => $ccfeffcc23e8684d$export$dd23e99a584572e8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3cMgR = parcelRequire("3cMgR");

var $6XEne = parcelRequire("6XEne");
const $ccfeffcc23e8684d$export$36d18380658d5d20 = (props)=>{
    const { data: data, renderIconAfter: renderIconAfter, innerProps: { ref: ref, ...innerProps } } = props;
    const { item: item } = data;
    const summaryRef = (0, $eJOHy.useRef)(null);
    const [isSummaryOverflown, setIsSummaryOverflown] = (0, $eJOHy.useState)(false);
    const summary = data?.item?.summaryText ?? data.label;
    const iconAfter = renderIconAfter?.(data);
    (0, $eJOHy.useEffect)(()=>{
        if (summaryRef.current) {
            const isOverflown = summaryRef.current?.offsetWidth < summaryRef.current?.scrollWidth;
            setIsSummaryOverflown(isOverflown);
        }
    }, [
        summary
    ]);
    if (!item) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Container, {
        ...innerProps,
        "data-testid": "polaris-lib-issue-select.ui.option.container",
        hasHoverEffects: true,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        ref: ref,
        "data-component-selector": "container-7fF9"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$SummaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Summary, null, props.data.label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Container, {
        ...innerProps,
        "data-testid": "polaris-lib-issue-select.ui.option.container",
        hasHoverEffects: true,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        ref: ref,
        "data-component-selector": "container-7fF9"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Icon, {
        src: item.img,
        alt: "type"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Key, {
        limitWidth: true,
        title: item.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "UNSAFE_small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, item.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Summary, {
        truncate: !iconAfter,
        ref: summaryRef,
        "data-component-selector": "summary-kE63"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, item.summaryText)), !!iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$IconAfterWrapper, {
        isSummaryOverflown: isSummaryOverflown
    }, iconAfter));
};
const $ccfeffcc23e8684d$export$ee46739492ed18b5 = (props)=>{
    const issue = props.data.item;
    if (!issue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Container, {
        hasHoverEffects: true,
        "data-component-selector": "container-7fF9"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$SummaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Summary, {
        "data-component-selector": "summary-kE63"
    }, props.data.label))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Container, {
        hasHoverEffects: false,
        "data-component-selector": "container-7fF9"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Icon, {
        src: issue.img,
        alt: "type"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Key, {
        limitWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "UNSAFE_small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, issue.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Summary, {
        "data-component-selector": "summary-kE63"
    }, issue.summaryText)));
};
const $ccfeffcc23e8684d$export$dd23e99a584572e8 = (props)=>{
    const issue = props.data.item;
    if (!issue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MultiValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$MultiValueOptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$SummaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "UNSAFE_small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, props.data.label))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MultiValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$MultiValueOptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$IdeaIcon, {
        src: issue.img,
        alt: "type"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$IdeaKey, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "UNSAFE_small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, issue.key))));
};
const $ccfeffcc23e8684d$export$62fb5a65af3c7e8e = (props)=>{
    const { innerProps: innerProps, hasHoverEffects: hasHoverEffects, isOptionSelected: isOptionSelected } = props;
    const propsOfContainer = {
        hasHoverEffects: hasHoverEffects,
        isOptionSelected: isOptionSelected
    };
    if (innerProps) {
        const { ref: ref, ...restOfInnerProps } = innerProps;
        propsOfContainer.innerProps = {
            ...restOfInnerProps
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        propsOfContainer.ref = ref;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Container, propsOfContainer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Icon, {
        src: props.img,
        alt: "type"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Key, {
        limitWidth: true,
        title: props.issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "UNSAFE_small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, props.issueKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ccfeffcc23e8684d$var$Summary, {
        title: props.summary
    }, props.summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ccfeffcc23e8684d$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _2hwxu2gc _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $ccfeffcc23e8684d$var$Key = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { limitWidth: limitWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug _2hwx1b66 _1bto1l2s _o5721q9c",
            __cmplp.limitWidth ? "_1bsbys9h" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $ccfeffcc23e8684d$var$SummaryWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $ccfeffcc23e8684d$var$Summary = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { truncate: truncate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_4mf77m": (0, $awdRS.default)(__cmplp.truncate !== false && 'ellipsis')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _p12f1osq _o5721q9c _y3gn1e5h _1bto1y1r",
            __cmplp.className
        ])
    });
});
const $ccfeffcc23e8684d$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOptionSelected: isOptionSelected, hasHoverEffects: hasHoverEffects, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_up0dw1": (0, $awdRS.default)(__cmplp.hasHoverEffects && 'pointer'),
            "--_1y83z18": (0, $awdRS.default)(__cmplp.hasHoverEffects && '0.3s'),
            "--_1aak9qf": (0, $awdRS.default)(__cmplp.hasHoverEffects && "var(--ds-background-neutral-subtle-hovered, #091E420F)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _v564157c _1e0c1txw _4cvr1h6o _vchhusvi _1ul9idpf _80om1r1d _irr3sw1k",
            __cmplp.isOptionSelected ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_1yt41b66",
            __cmplp.className
        ])
    });
});
const $ccfeffcc23e8684d$var$IconAfterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSummaryOverflown: isSummaryOverflown, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fadwsr": (0, $awdRS.default)(__cmplp.isSummaryOverflown && `-6px 1px 9px 2px ${"var(--ds-surface-overlay, #FFFFFF)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoftgi _2hwxutpp _16qs1wst",
            __cmplp.className
        ])
    });
});
const $ccfeffcc23e8684d$var$MultiValueOptionContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _syaz1fxt _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _vchhusvi _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $ccfeffcc23e8684d$var$IdeaIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz",
            __cmplp.className
        ])
    });
});
const $ccfeffcc23e8684d$var$IdeaKey = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug _18u01b66 _1bto1l2s _o5721q9c _1bsb1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9CRQU", function(module, exports) {

$parcel$export(module.exports, "useFetchIssues", () => $3a1ce3ce8734da8f$export$3add18773171fc59);
$parcel$export(module.exports, "getSearchParams", () => $3a1ce3ce8734da8f$export$7a660ea2ca5c1d6b);
$parcel$export(module.exports, "createFetchQuery", () => $3a1ce3ce8734da8f$export$9624e0f85862b53);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("1h54Q");
parcelRequire("1AyD5");
parcelRequire("bl9yo");
parcelRequire("1o2WJ");
parcelRequire("d2zWP");

var $8dH3d = parcelRequire("8dH3d");

var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");

var $lakH9 = parcelRequire("lakH9");

var $jQHpp = parcelRequire("jQHpp");
const $3a1ce3ce8734da8f$export$3add18773171fc59 = (isIdeasSearch, issueKey, archivedFieldLabel)=>(0, $eJOHy.useCallback)(({ projectId: projectId, search: search, excludedProjectTypes: excludedProjectTypes, hideArchived: hideArchived, exactIssueKeySearch: exactIssueKeySearch, excludedIssueIds: excludedIssueIds })=>{
        if (isIdeasSearch) return (0, $lakH9.fetchIdeasSuggestions)({
            issueKey: issueKey || '',
            query: search,
            exactIssueKeySearch: exactIssueKeySearch
        }).then((issues)=>issues.map((issue)=>({
                    label: issue.summaryText,
                    value: `${issue.key} ${issue.summaryText}`,
                    item: issue
                })));
        return (0, $jQHpp.fetchIssueSuggestions)({
            issueKey: issueKey || '',
            projectId: projectId,
            excludedIssueIds: excludedIssueIds,
            query: search,
            excludedProjectTypes: excludedProjectTypes,
            archivedFieldLabel: hideArchived ? archivedFieldLabel : undefined,
            exactIssueKeySearch: exactIssueKeySearch
        }).then((issues)=>issues.map((issue)=>({
                    label: issue.summaryText,
                    value: `${issue.key} ${issue.summaryText}`,
                    item: issue
                })));
    }, [
        isIdeasSearch,
        issueKey,
        archivedFieldLabel
    ]);
const $3a1ce3ce8734da8f$export$7a660ea2ca5c1d6b = (inputValue)=>{
    const issueKeyMatch = inputValue.match(/(browse\/|selectedIssue=|\/queues\/issue\/|\/queues\/.+\/.+\/)*(?<issueKey>([A-Z][A-Z0-9]+)-([0-9]+))/);
    let searchString = inputValue;
    let isExactIssueSearchKey = false;
    if (issueKeyMatch != null && issueKeyMatch.groups?.issueKey != null) {
        searchString = issueKeyMatch.groups.issueKey;
        isExactIssueSearchKey = true;
    }
    return {
        searchString: searchString,
        isExactIssueSearchKey: isExactIssueSearchKey
    };
};
const $3a1ce3ce8734da8f$export$9624e0f85862b53 = (setIsLoading, excludedIssueIds, fetchIssues, setOptions, setInternalDefaultOptions, defaultOptions)=>{
    const query$ = new (0, $6WhQS.Subject)();
    const subscription = query$.map((x)=>{
        setIsLoading(true);
        return x;
    }).debounce(({ isImmediate: isImmediate })=>isImmediate ? (0, $7kixv.Observable).empty() : (0, $7kixv.Observable).timer(750)).switchMap(({ query: query, currentProjectId: currentProjectId, isInitialLoading: isInitialLoading, currentExcludedProjectTypes: currentExcludedProjectTypes, hideArchivedIssues: hideArchivedIssues, issueKeySearch: issueKeySearch })=>fetchIssues({
            projectId: currentProjectId,
            search: query,
            excludedProjectTypes: currentExcludedProjectTypes,
            hideArchived: hideArchivedIssues,
            exactIssueKeySearch: issueKeySearch,
            excludedIssueIds: excludedIssueIds
        }).then((suggestions)=>({
                suggestions: suggestions,
                isInitialLoading: isInitialLoading
            }))).subscribe(({ suggestions: suggestions, isInitialLoading: isInitialLoading })=>{
        if (defaultOptions !== undefined && isInitialLoading) setInternalDefaultOptions(suggestions);
        if (defaultOptions !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(suggestions)) {
            const newSuggestions = suggestions.filter((fetchedItem)=>!defaultOptions.options.find((defaultItem)=>defaultItem.item?.id === fetchedItem.item?.id));
            setOptions(newSuggestions);
        } else setOptions(suggestions);
        setIsLoading(false);
    });
    return {
        query$: query$,
        unsubscribe: ()=>subscription.unsubscribe()
    };
};

});
parcelRegister("lakH9", function(module, exports) {

$parcel$export(module.exports, "fetchIdeasSuggestions", () => $2acb41ee8a60769a$export$4342bb4a8b67d028);

var $1Ozm9 = parcelRequire("1Ozm9");

var $b5oGV = parcelRequire("b5oGV");

var $ln6Iy = parcelRequire("ln6Iy");
const $2acb41ee8a60769a$var$transformIssueSuggestionItems = ({ sections: sections = [] } = {
    sections: []
})=>sections.map((section)=>section.issues).filter((issues)=>!!issues).reduce((flatten, current)=>flatten.concat(current.map((issue)=>issue)), []).reduce((uniq, current)=>// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        uniq.findIndex((item)=>item.id === current.id) < 0 ? [
            ...uniq,
            current
        ] : uniq, []);
const $2acb41ee8a60769a$var$getIdeasPickerUrl = (currentJQL, issueKey, query)=>{
    return `/rest/api/2/issue/picker?currentIssueKey=${issueKey}&query=${encodeURI(query)}&currentJQL=${encodeURI(currentJQL)}`;
};
const $2acb41ee8a60769a$var$JIRA_ISSUE_KEY_REGEX = /^([A-Z][A-Z0-9]+)-([0-9]*)$/i;
const $2acb41ee8a60769a$var$parseProjectKey = (query)=>{
    if (query) {
        const parsedGroups = $2acb41ee8a60769a$var$JIRA_ISSUE_KEY_REGEX.exec(query);
        if (parsedGroups && parsedGroups.length === 3) return parsedGroups[1];
    }
    return undefined;
};
// next-gen JSD issues may not have the resolution field and instead use statusCategory,
// but all others (classic JSD/JSW, next-gen JSW) prefer resolution
const $2acb41ee8a60769a$var$unresolvedAndOrder = '(resolution = Unresolved OR statusCategory != Done) ORDER BY priority DESC, updated DESC';
const $2acb41ee8a60769a$var$getIssueKeyClause = (issueKey)=>`issueKey="${issueKey}"`;
const $2acb41ee8a60769a$var$getUrlForIdeasSelect = (issueKey, query, exactIssueKeySearch)=>{
    let currentJQL = '';
    currentJQL = `project in projectsWhereUserHasPermission("Link Issues") AND projectType="${0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT}" AND ${exactIssueKeySearch === true ? $2acb41ee8a60769a$var$getIssueKeyClause(query) : $2acb41ee8a60769a$var$unresolvedAndOrder}`;
    const projectKey = $2acb41ee8a60769a$var$parseProjectKey(query);
    if (projectKey !== undefined) currentJQL = `project = "${projectKey.toUpperCase()}" AND ${currentJQL}`;
    return $2acb41ee8a60769a$var$getIdeasPickerUrl(currentJQL, issueKey, query);
};
const $2acb41ee8a60769a$export$4342bb4a8b67d028 = ({ issueKey: issueKey, query: query, exactIssueKeySearch: exactIssueKeySearch })=>{
    const queryUrl = $2acb41ee8a60769a$var$getUrlForIdeasSelect(issueKey, query, exactIssueKeySearch);
    (0, $b5oGV.experience).issues.loadIssuePickerIssuesRest.start();
    return (0, $1Ozm9.default)(queryUrl).then((response)=>{
        (0, $b5oGV.experience).issues.loadIssuePickerIssuesRest.success();
        return $2acb41ee8a60769a$var$transformIssueSuggestionItems(response);
    }).catch((error)=>{
        (0, $b5oGV.experience).issues.loadIssuePickerIssuesRest.failure(error);
        throw error;
    });
};

});

parcelRegister("jQHpp", function(module, exports) {

$parcel$export(module.exports, "fetchIssueSuggestions", () => $2e6206119345f983$export$e19ca69e6ae29a6b);

var $8dH3d = parcelRequire("8dH3d");

var $dw68A = parcelRequire("dw68A");

var $1Ozm9 = parcelRequire("1Ozm9");

var $b5oGV = parcelRequire("b5oGV");
const $2e6206119345f983$export$6aa565e50df61177 = 'Dropdown';
const $2e6206119345f983$export$2b9ee7163e124831 = (archivedFieldLabel)=>`( "${archivedFieldLabel}[${$2e6206119345f983$export$6aa565e50df61177}]" = EMPTY )`;
const $2e6206119345f983$var$transformIssueSuggestionItems = ({ sections: sections = [] } = {
    sections: []
})=>sections.map((section)=>section.issues).filter((issues)=>!!issues).reduce((flatten, current)=>flatten.concat(current.map((issue)=>issue)), []).reduce((uniq, current)=>// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        uniq.findIndex((item)=>item.id === current.id) < 0 ? [
            ...uniq,
            current
        ] : uniq, []);
const $2e6206119345f983$var$getIssuePickerUrl = (currentJQL, issueKey, projectId, query)=>{
    const projectIdParamValue = projectId !== undefined ? `&currentProjectId=${projectId}` : '';
    // on hello and other large instances, returning subtasks results in a faster sql query and is aligned
    // with the behavior of jira software, hence the query param showSubTasks=true
    return `/rest/api/2/issue/picker?currentIssueKey=${issueKey}${projectIdParamValue}&showSubTasks=true&query=${encodeURI(query)}&currentJQL=${encodeURI(currentJQL)}`;
};
const $2e6206119345f983$var$JIRA_ISSUE_KEY_REGEX = /^([A-Z][A-Z0-9]+)-([0-9]*)$/i;
const $2e6206119345f983$var$parseProjectKey = (query)=>{
    if (query) {
        const parsedGroups = $2e6206119345f983$var$JIRA_ISSUE_KEY_REGEX.exec(query);
        if (parsedGroups && parsedGroups.length === 3) return parsedGroups[1];
    }
    return undefined;
};
// next-gen JSD issues may not have the resolution field and instead use statusCategory,
// but all others (classic JSD/JSW, next-gen JSW) prefer resolution
const $2e6206119345f983$var$unresolvedAndOrder = '(resolution = Unresolved OR statusCategory != Done) ORDER BY priority DESC, updated DESC';
const $2e6206119345f983$var$getIssueKeyClause = (issueKey)=>`issueKey="${issueKey}"`;
const $2e6206119345f983$var$getUrlForIssueSelect = (issueKey, projectId, excludedIssueIds, query, excludedProjectTypes, archivedFieldLabel, exactIssueKeySearch)=>{
    let currentJQL = `project in projectsWhereUserHasPermission("Link Issues") AND ${exactIssueKeySearch === true ? $2e6206119345f983$var$getIssueKeyClause(query) : $2e6206119345f983$var$unresolvedAndOrder}`;
    if (excludedIssueIds !== undefined && excludedIssueIds.length > 0) {
        const ids = (0, (/*@__PURE__*/$parcel$interopDefault($dw68A)))(excludedIssueIds, ',');
        currentJQL = `id NOT IN (${ids}) AND ${currentJQL}`;
    }
    const projectKey = $2e6206119345f983$var$parseProjectKey(query);
    if (projectKey !== undefined) currentJQL = `project = "${projectKey.toUpperCase()}" AND ${currentJQL}`;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(excludedProjectTypes)) currentJQL = `projectType NOT IN (${(0, (/*@__PURE__*/$parcel$interopDefault($dw68A)))(excludedProjectTypes, ',')}) AND ${currentJQL}`;
    if (archivedFieldLabel !== undefined && exactIssueKeySearch !== true) currentJQL = `${$2e6206119345f983$export$2b9ee7163e124831(archivedFieldLabel)} AND ${currentJQL}`;
    return $2e6206119345f983$var$getIssuePickerUrl(currentJQL, issueKey, projectId, query);
};
const $2e6206119345f983$export$e19ca69e6ae29a6b = ({ issueKey: issueKey, projectId: projectId, excludedIssueIds: excludedIssueIds, query: query, excludedProjectTypes: excludedProjectTypes, archivedFieldLabel: archivedFieldLabel, exactIssueKeySearch: exactIssueKeySearch })=>{
    const queryUrl = $2e6206119345f983$var$getUrlForIssueSelect(issueKey, projectId, excludedIssueIds, query, excludedProjectTypes, archivedFieldLabel, exactIssueKeySearch);
    (0, $b5oGV.experience).issues.loadIssuePickerIssuesRest.start();
    return (0, $1Ozm9.default)(queryUrl).then((response)=>{
        (0, $b5oGV.experience).issues.loadIssuePickerIssuesRest.success();
        return $2e6206119345f983$var$transformIssueSuggestionItems(response);
    }).catch((error)=>{
        (0, $b5oGV.experience).issues.loadIssuePickerIssuesRest.failure(error);
        throw error;
    });
};

});
parcelRegister("dw68A", function(module, exports) {
/** Used for built-in method references. */ var $9d730652fe58b493$var$arrayProto = Array.prototype;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9d730652fe58b493$var$nativeJoin = $9d730652fe58b493$var$arrayProto.join;
/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */ function $9d730652fe58b493$var$join(array, separator) {
    return array == null ? '' : $9d730652fe58b493$var$nativeJoin.call(array, separator);
}
module.exports = $9d730652fe58b493$var$join;

});




parcelRegister("hEORc", function(module, exports) {

$parcel$export(module.exports, "useAllFieldsArray", () => $027ed0b5600a1d36$export$dcbbd260085480e6);
$parcel$export(module.exports, "useField", () => $027ed0b5600a1d36$export$294aa081a6c6f55d);
$parcel$export(module.exports, "useFieldsByKey", () => $027ed0b5600a1d36$export$5cea10117f9ab1cf);
$parcel$export(module.exports, "useVisibleFieldsByKey", () => $027ed0b5600a1d36$export$1ae1bae5bb03b213);
$parcel$export(module.exports, "useFieldsArray", () => $027ed0b5600a1d36$export$d37b74004263ca37);
$parcel$export(module.exports, "useGlobalFieldsInUseArray", () => $027ed0b5600a1d36$export$c81b402476b17aa1);
$parcel$export(module.exports, "useFieldKeys", () => $027ed0b5600a1d36$export$c91f2882ecc9e96);
$parcel$export(module.exports, "useDescriptionField", () => $027ed0b5600a1d36$export$832230e7edbf37aa);
$parcel$export(module.exports, "useFieldOfType", () => $027ed0b5600a1d36$export$834d822973d5b3e3);
$parcel$export(module.exports, "useAtlasFieldsEnabled", () => $027ed0b5600a1d36$export$5007eb2ccda6a9b4);
$parcel$export(module.exports, "useAllDeliveryFields", () => $027ed0b5600a1d36$export$17362e74ae1e52c7);
$parcel$export(module.exports, "useAllDeliveryFieldsWithData", () => $027ed0b5600a1d36$export$4105c98124b9f3d4);
$parcel$export(module.exports, "useFieldType", () => $027ed0b5600a1d36$export$510fec451a6dfab7);
$parcel$export(module.exports, "useIsDeliveryFieldType", () => $027ed0b5600a1d36$export$9e2fc60e79c74391);
$parcel$export(module.exports, "useFieldLabel", () => $027ed0b5600a1d36$export$ea64292063d19935);
$parcel$export(module.exports, "useIsSystemField", () => $027ed0b5600a1d36$export$67605904c0b73720);
$parcel$export(module.exports, "useAllConnectionFieldKeys", () => $027ed0b5600a1d36$export$f579212bf0eca70);
$parcel$export(module.exports, "useAllConnectionFields", () => $027ed0b5600a1d36$export$e56b163e7b81104a);
$parcel$export(module.exports, "useIsConnectionCompatibleSystemField", () => $027ed0b5600a1d36$export$20d9c771eb8e02cd);
$parcel$export(module.exports, "useConnectionsFieldsAssociations", () => $027ed0b5600a1d36$export$962b453608ef97b1);
$parcel$export(module.exports, "useIsGlobalCustomField", () => $027ed0b5600a1d36$export$9b021ff69f5e957a);
$parcel$export(module.exports, "useIsGlobalSystemField", () => $027ed0b5600a1d36$export$d113dbb7d7c0a5fa);
$parcel$export(module.exports, "useIsGlobalNonSystemField", () => $027ed0b5600a1d36$export$b243df34ea7a1c8f);
$parcel$export(module.exports, "useFieldPlay", () => $027ed0b5600a1d36$export$ad7a4e9c78a3a99);
$parcel$export(module.exports, "useIsReadOnlyFieldForGrouping", () => $027ed0b5600a1d36$export$fcf964009a5b1c31);
$parcel$export(module.exports, "useIsCreatingIdeasForGroupingSupported", () => $027ed0b5600a1d36$export$7a60129d011241e9);
$parcel$export(module.exports, "useIsDeletable", () => $027ed0b5600a1d36$export$e14ff1f21e7ce8a9);
$parcel$export(module.exports, "useFieldEditable", () => $027ed0b5600a1d36$export$9cc247e7d73d3e41);
$parcel$export(module.exports, "useAllEditableFields", () => $027ed0b5600a1d36$export$1d80e8377fdcf533);
$parcel$export(module.exports, "useFieldFormula", () => $027ed0b5600a1d36$export$1e32d280c6a52c6d);
$parcel$export(module.exports, "useFieldPresentation", () => $027ed0b5600a1d36$export$4f778fe88cd4b74b);
$parcel$export(module.exports, "useHasFieldFormula", () => $027ed0b5600a1d36$export$141840c45c29d83d);
$parcel$export(module.exports, "useFieldTypeIcon", () => $027ed0b5600a1d36$export$dc8276c414bd566b);
$parcel$export(module.exports, "useFieldTypes", () => $027ed0b5600a1d36$export$525153244eb07c87);
$parcel$export(module.exports, "useNewlyAddedGlobalFields", () => $027ed0b5600a1d36$export$b4b982d754d2c91);
$parcel$export(module.exports, "useFieldDescription", () => $027ed0b5600a1d36$export$a4c269b2393edbad);
$parcel$export(module.exports, "useFieldEmoji", () => $027ed0b5600a1d36$export$dd434aee3e47a744);
$parcel$export(module.exports, "useIsHidden", () => $027ed0b5600a1d36$export$b5d7cc18bb8d2b59);
$parcel$export(module.exports, "useIsRestricted", () => $027ed0b5600a1d36$export$dce9575cd8216640);
$parcel$export(module.exports, "useArchivedFieldsConfig", () => $027ed0b5600a1d36$export$56bef3a24d16f71c);
$parcel$export(module.exports, "useIsArchivingEnabled", () => $027ed0b5600a1d36$export$e87dd42fc3e134f);
$parcel$export(module.exports, "useFieldKeysOfType", () => $027ed0b5600a1d36$export$72b0855d7f4a238d);
$parcel$export(module.exports, "useFieldCount", () => $027ed0b5600a1d36$export$e3e3ef1261680bfe);
$parcel$export(module.exports, "useGlobalFieldCount", () => $027ed0b5600a1d36$export$8476656039804aa6);
$parcel$export(module.exports, "useFieldByKey", () => $027ed0b5600a1d36$export$f431a5318936bfd9);
$parcel$export(module.exports, "useStringFields", () => $027ed0b5600a1d36$export$3ff759f842ebb0a9);
$parcel$export(module.exports, "useHasFieldsError", () => $027ed0b5600a1d36$export$32f5eb389b17b5ba);
$parcel$export(module.exports, "useHighlightedFields", () => $027ed0b5600a1d36$export$6c5b80e45f198d35);
$parcel$export(module.exports, "useConnectionFieldIssueTypeIds", () => $027ed0b5600a1d36$export$a7998eea8602cc4b);
$parcel$export(module.exports, "useConnectionFieldHighlightedFieldKey", () => $027ed0b5600a1d36$export$79228682ae8327c3);
$parcel$export(module.exports, "useConnectionFieldIssueViewLayoutSort", () => $027ed0b5600a1d36$export$7f0b09aac2b09584);
$parcel$export(module.exports, "useConnectionFieldHighlightableFieldsList", () => $027ed0b5600a1d36$export$a9cfa8890bf0a3ab);
$parcel$export(module.exports, "useIsConnectionFieldFilterConfigured", () => $027ed0b5600a1d36$export$fdd4c70831140d5c);
$parcel$export(module.exports, "useConnectionFieldsForIssueType", () => $027ed0b5600a1d36$export$cd7a8fc8ede971fd);
$parcel$export(module.exports, "useUniqConnectionFieldsProjectIds", () => $027ed0b5600a1d36$export$2aba1bbc927e5732);
$parcel$export(module.exports, "useProjectIdsForConnectedAtlasFields", () => $027ed0b5600a1d36$export$461ea4d1b352e461);
$parcel$export(module.exports, "useFieldsLoading", () => $027ed0b5600a1d36$export$c11e66c27c8138a8);
$parcel$export(module.exports, "useFieldsForPinning", () => $027ed0b5600a1d36$export$c299230a5a89c765);

var $eTBmS = parcelRequire("eTBmS");


var $iJq0l = parcelRequire("iJq0l");

var $9h1Bv = parcelRequire("9h1Bv");

var $3Jfcg = parcelRequire("3Jfcg");

var $9XFdQ = parcelRequire("9XFdQ");

var $hQR6K = parcelRequire("hQR6K");

var $ey7Lz = parcelRequire("ey7Lz");

var $bNW0R = parcelRequire("bNW0R");

var $NBKfp = parcelRequire("NBKfp");
const $027ed0b5600a1d36$export$dcbbd260085480e6 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getAllFieldArray)
});
const $027ed0b5600a1d36$export$294aa081a6c6f55d = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (state, key)=>(0, $bNW0R.getAllFields)(state)[key]
});
const $027ed0b5600a1d36$export$5cea10117f9ab1cf = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getAllFields)
});
const $027ed0b5600a1d36$export$1ae1bae5bb03b213 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getAllVisibleFields)
});
const $027ed0b5600a1d36$export$d37b74004263ca37 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getFieldArray)
});
const $027ed0b5600a1d36$export$c81b402476b17aa1 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getGlobalFieldsInUseArray)
});
const $027ed0b5600a1d36$export$c91f2882ecc9e96 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getFieldKeys)
});
const $027ed0b5600a1d36$export$832230e7edbf37aa = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (state)=>(0, $bNW0R.getFieldArray)(state).find((field)=>field.key === (0, $9a5f06039e1dff5a$export$d6749ecf5a14d5b))
});
const $027ed0b5600a1d36$export$834d822973d5b3e3 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldOfType));
const $027ed0b5600a1d36$export$5007eb2ccda6a9b4 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getAtlasFieldsEnabled)
});
const $027ed0b5600a1d36$export$3da96c4009e089ca = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (state)=>(0, $bNW0R.getFieldArray)(state).find((field)=>field.key === (0, $9a5f06039e1dff5a$export$dd03acb09519222))
});
const $027ed0b5600a1d36$export$17362e74ae1e52c7 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (state)=>(0, $bNW0R.getFieldArray)(state).filter((field)=>(0, $eTBmS.isDeliveryFieldType)(field.type)).map(({ key: key })=>key)
});
const $027ed0b5600a1d36$export$4105c98124b9f3d4 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.createGetAllDeliveryFieldsWithData)
});
const $027ed0b5600a1d36$export$510fec451a6dfab7 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldType));
const $027ed0b5600a1d36$export$9e2fc60e79c74391 = (fieldKey)=>{
    const fieldType = $027ed0b5600a1d36$export$510fec451a6dfab7(fieldKey);
    return !fieldKey || !fieldType ? false : (0, $eTBmS.isDeliveryFieldType)(fieldType);
};
const $027ed0b5600a1d36$export$ea64292063d19935 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldLabel));
const $027ed0b5600a1d36$export$67605904c0b73720 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetIsSystemField));
const $027ed0b5600a1d36$export$f579212bf0eca70 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getAllConnectionFieldKeys));
const $027ed0b5600a1d36$export$e56b163e7b81104a = (0, $NBKfp.createFieldHook)((0, $bNW0R.getAllConnectionFields));
const $027ed0b5600a1d36$export$20d9c771eb8e02cd = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createIsConnectionCompatibleSystemField));
const $027ed0b5600a1d36$export$962b453608ef97b1 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getConnectionsFieldsAssociations)
});
const $027ed0b5600a1d36$export$9b021ff69f5e957a = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createIsGlobalCustomField));
const $027ed0b5600a1d36$export$d113dbb7d7c0a5fa = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createIsGlobalSystemField));
const $027ed0b5600a1d36$export$b243df34ea7a1c8f = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createIsGlobalNonSystemField));
const $027ed0b5600a1d36$export$ad7a4e9c78a3a99 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldPlay));
const $027ed0b5600a1d36$export$fcf964009a5b1c31 = (fieldKey)=>{
    const fieldType = $027ed0b5600a1d36$export$510fec451a6dfab7(fieldKey);
    return fieldType === (0, $eTBmS.FIELD_TYPES).REACTIONS || fieldType === (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT_STATUS;
};
const $027ed0b5600a1d36$export$7a60129d011241e9 = (fieldKey)=>{
    const fieldType = $027ed0b5600a1d36$export$510fec451a6dfab7(fieldKey);
    return (0, $ey7Lz.isCreatingIdeasGroupBySupported)(fieldType);
};
const $027ed0b5600a1d36$export$e14ff1f21e7ce8a9 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetIsDeletable));
const $027ed0b5600a1d36$export$9cc247e7d73d3e41 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetEditable));
const $027ed0b5600a1d36$export$1d80e8377fdcf533 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getAllEditableFields));
const $027ed0b5600a1d36$export$1e32d280c6a52c6d = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldFormula));
const $027ed0b5600a1d36$export$4f778fe88cd4b74b = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldPresentation));
const $027ed0b5600a1d36$export$141840c45c29d83d = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createHasFieldFormula));
const $027ed0b5600a1d36$export$dc8276c414bd566b = (0, $NBKfp.createHigherLevelFieldHook2)((0, $bNW0R.getFieldTypeIcon));
const $027ed0b5600a1d36$export$fa3a053d9c0d95bc = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getFieldLabels)
});
const $027ed0b5600a1d36$export$525153244eb07c87 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getNewFieldTypes)
});
const $027ed0b5600a1d36$export$b4b982d754d2c91 = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getNewlyAddedGlobalFields)
});
const $027ed0b5600a1d36$export$a4c269b2393edbad = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldDescription));
const $027ed0b5600a1d36$export$dd434aee3e47a744 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldEmoji));
const $027ed0b5600a1d36$export$b5d7cc18bb8d2b59 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldHidden));
const $027ed0b5600a1d36$export$dce9575cd8216640 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldRestricted));
const $027ed0b5600a1d36$export$56bef3a24d16f71c = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getArchivedFieldsConfig)
});
const $027ed0b5600a1d36$export$e87dd42fc3e134f = (0, $iJq0l.createHook)((0, $hQR6K.FieldStore), {
    selector: (0, $bNW0R.getIsArchivingEnabled)
});
const $027ed0b5600a1d36$export$2ba146c1d044af3 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldByPlayId));
const $027ed0b5600a1d36$export$72b0855d7f4a238d = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldKeysOfType));
const $027ed0b5600a1d36$export$e3e3ef1261680bfe = (0, $NBKfp.createFieldHook)((0, $bNW0R.getFieldCount));
const $027ed0b5600a1d36$export$8476656039804aa6 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getGlobalFieldCount));
const $027ed0b5600a1d36$export$f431a5318936bfd9 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetFieldByKey));
const $027ed0b5600a1d36$export$3ff759f842ebb0a9 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getAllStringFields));
const $027ed0b5600a1d36$export$32f5eb389b17b5ba = (0, $NBKfp.createFieldHook)((0, $bNW0R.getHasFieldsError));
const $027ed0b5600a1d36$export$6c5b80e45f198d35 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getHighlightedFields));
const $027ed0b5600a1d36$export$9995b8b61cca8c8b = (0, $NBKfp.createFieldHook)((0, $bNW0R.createGetFieldCountByType));
const $027ed0b5600a1d36$var$useConnectionFieldIssueTypeIdsInternal = (0, $NBKfp.createHigherLevelFieldHook3)((0, $bNW0R.createGetConnectionFieldIssueTypeIds));
const $027ed0b5600a1d36$export$a7998eea8602cc4b = (fieldKey)=>{
    const allIssueTypesByProjectId = (0, $9h1Bv.useAllIssueTypesByProjectId)();
    const container = (0, $3Jfcg.useEnvironmentContainer)();
    const allowedProjectIds = container?.type === (0, $9XFdQ.PolarisEnvironmentContainerTypes).PROJECT ? [
        container.projectId
    ] : [];
    return $027ed0b5600a1d36$var$useConnectionFieldIssueTypeIdsInternal(fieldKey, allIssueTypesByProjectId, allowedProjectIds);
};
const $027ed0b5600a1d36$export$f0c6e38346e76464 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetConnectionFieldIssueTypeNameFilter));
const $027ed0b5600a1d36$export$79228682ae8327c3 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetConnectionFieldHighlightedFieldKey));
const $027ed0b5600a1d36$export$7f0b09aac2b09584 = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetConnectionFieldIssueViewLayoutSort));
const $027ed0b5600a1d36$export$a9cfa8890bf0a3ab = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetConnectionFieldHighlightableFieldsList));
const $027ed0b5600a1d36$export$fdd4c70831140d5c = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createIsConnectionFieldFilterConfigured));
const $027ed0b5600a1d36$export$cd7a8fc8ede971fd = (0, $NBKfp.createHigherLevelFieldHook)((0, $bNW0R.createGetConnectionFieldsForIssueType));
const $027ed0b5600a1d36$export$2aba1bbc927e5732 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getUniqConnectionFieldsProjectIds));
const $027ed0b5600a1d36$export$461ea4d1b352e461 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getProjectIdsForConnectedAtlasFields));
const $027ed0b5600a1d36$export$c11e66c27c8138a8 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getFieldsLoading));
const $027ed0b5600a1d36$export$c299230a5a89c765 = (0, $NBKfp.createFieldHook)((0, $bNW0R.getFieldsForPinning));

});
parcelRegister("eTBmS", function(module, exports) {

$parcel$export(module.exports, "isDeliveryFieldType", () => $2993f1bacde97931$export$b385e3f09b435844);
$parcel$export(module.exports, "FIELD_TYPES", () => $2993f1bacde97931$export$afad353d00ed07eb);
$parcel$export(module.exports, "FIELD_TYPES_CATEGORIES", () => $2993f1bacde97931$export$d750d1973f382c74);
$parcel$export(module.exports, "GLOBAL_SYSTEM_FIELD_TYPES", () => $2993f1bacde97931$export$b088dac07b311768);
$parcel$export(module.exports, "GLOBAL_FIELD_TYPES", () => $2993f1bacde97931$export$447529f60ce12253);
$parcel$export(module.exports, "JIRA_API_FIELD_TYPES", () => $2993f1bacde97931$export$2dd6be6fd8a6584e);
$parcel$export(module.exports, "isSystemFieldType", () => $2993f1bacde97931$export$89ca1a31640552e2);

var $e3EnI = parcelRequire("e3EnI");
const $2993f1bacde97931$export$b385e3f09b435844 = (fieldType)=>fieldType === $2993f1bacde97931$export$afad353d00ed07eb.DELIVERY_PROGRESS || fieldType === $2993f1bacde97931$export$afad353d00ed07eb.DELIVERY_STATUS;
const $2993f1bacde97931$export$d750d1973f382c74 = {
    ARCHIVED: [
        (0, $e3EnI.ARCHIVED_BY_FIELD_TYPE),
        (0, $e3EnI.ARCHIVED_FIELD_TYPE),
        (0, $e3EnI.ARCHIVED_ON_FIELD_TYPE)
    ],
    ATLAS: [
        (0, $e3EnI.ATLAS_GOAL_FIELD_TYPE),
        (0, $e3EnI.ATLAS_PROJECT_FIELD_TYPE),
        (0, $e3EnI.ATLAS_PROJECT_STATUS_FIELD_TYPE),
        (0, $e3EnI.PLATFORM_GOALS_FIELD_TYPE),
        (0, $e3EnI.PLATFORM_PROJECT_FIELD_TYPE),
        (0, $e3EnI.PLATFORM_PROJECT_STATUS_FIELD_TYPE)
    ],
    USER: [
        (0, $e3EnI.ASSIGNEE_FIELD_TYPE),
        (0, $e3EnI.CREATOR_FIELD_TYPE),
        (0, $e3EnI.REPORTER_FIELD_TYPE)
    ]
};
const $2993f1bacde97931$export$b088dac07b311768 = {
    PLATFORM_GOALS: (0, $e3EnI.PLATFORM_GOALS_FIELD_TYPE),
    INSIGHTS_GLOBAL: (0, $e3EnI.INSIGHTS_GLOBAL_FIELD_TYPE),
    LINKED_ISSUES_GLOBAL: (0, $e3EnI.LINKED_ISSUES_GLOBAL_FIELD_TYPE),
    DELIVERY_PROGRESS_GLOBAL: (0, $e3EnI.DELIVERY_PROGRESS_GLOBAL_FIELD_TYPE),
    DELIVERY_STATUS_GLOBAL: (0, $e3EnI.DELIVERY_STATUS_GLOBAL_FIELD_TYPE),
    ISSUE_COMMENTS_GLOBAL: (0, $e3EnI.ISSUE_COMMENTS_GLOBAL_FIELD_TYPE),
    PLATFORM_PROJECT: (0, $e3EnI.PLATFORM_PROJECT_FIELD_TYPE),
    PLATFORM_PROJECT_STATUS: (0, $e3EnI.PLATFORM_PROJECT_STATUS_FIELD_TYPE)
};
const $2993f1bacde97931$export$447529f60ce12253 = {
    ...$2993f1bacde97931$export$b088dac07b311768,
    CONNECTION: (0, $e3EnI.CONNECTION_FIELD_TYPE),
    CHECKBOX: (0, $e3EnI.CHECKBOX_FIELD_TYPE),
    FORMULA: (0, $e3EnI.FORMULA_FIELD_TYPE),
    INTERVAL: (0, $e3EnI.INTERVAL_FIELD_TYPE),
    HYPERLINK: (0, $e3EnI.HYPERLINK_FIELD_TYPE),
    MULTI_SELECT: (0, $e3EnI.MULTI_SELECT_FIELD_TYPE),
    JSW_MULTI_SELECT: (0, $e3EnI.JSW_MULTI_SELECT_FIELD_TYPE),
    NUMBER: (0, $e3EnI.NUMBER_FIELD_TYPE),
    RATING: (0, $e3EnI.RATING_FIELD_TYPE),
    REACTIONS: (0, $e3EnI.REACTIONS_FIELD_TYPE),
    SHORT_TEXT: (0, $e3EnI.SHORT_TEXT_FIELD_TYPE),
    SINGLE_SELECT: (0, $e3EnI.SINGLE_SELECT_FIELD_TYPE),
    SLIDER: (0, $e3EnI.SLIDER_FIELD_TYPE),
    JSW_PEOPLE: (0, $e3EnI.JSW_PEOPLE_FIELD_TYPE),
    TEAM: (0, $e3EnI.TEAM_FIELD_TYPE)
};
const $2993f1bacde97931$var$SHARED_FIELD_TYPES = {
    ...$2993f1bacde97931$export$447529f60ce12253,
    ASSIGNEE: (0, $e3EnI.ASSIGNEE_FIELD_TYPE),
    CF_DEVELOPMENT: (0, $e3EnI.CF_DEVELOPMENT_FIELD_TYPE),
    CREATED: (0, $e3EnI.CREATED_FIELD_TYPE),
    CREATOR: (0, $e3EnI.CREATOR_FIELD_TYPE),
    CUSTOM_LABELS: (0, $e3EnI.CUSTOM_LABELS_FIELD_TYPE),
    DATE: (0, $e3EnI.DATE_FIELD_TYPE),
    DESCRIPTION: (0, $e3EnI.DESCRIPTION_FIELD_TYPE),
    ISSUE_ID: (0, $e3EnI.ISSUE_ID_FIELD_TYPE),
    ISSUE_KEY: (0, $e3EnI.ISSUE_KEY_FIELD_TYPE),
    ISSUE_LINKS: (0, $e3EnI.ISSUE_LINKS_FIELD_TYPE),
    ISSUE_TYPE: (0, $e3EnI.ISSUE_TYPE_FIELD_TYPE),
    LABELS: (0, $e3EnI.LABELS_FIELD_TYPE),
    PEOPLE: (0, $e3EnI.PEOPLE_FIELD_TYPE),
    PRIORITY: (0, $e3EnI.PRIORITY_FIELD_TYPE),
    PROJECT: (0, $e3EnI.PROJECT_FIELD_TYPE),
    RANK: (0, $e3EnI.RANK_FIELD_TYPE),
    REPORTER: (0, $e3EnI.REPORTER_FIELD_TYPE),
    STATUS: (0, $e3EnI.STATUS_FIELD_TYPE),
    SUMMARY: (0, $e3EnI.SUMMARY_FIELD_TYPE),
    UPDATED: (0, $e3EnI.UPDATED_FIELD_TYPE),
    VOTES: (0, $e3EnI.VOTES_FIELD_TYPE),
    CONNECTION: (0, $e3EnI.CONNECTION_FIELD_TYPE)
};
const $2993f1bacde97931$export$2dd6be6fd8a6584e = {
    ...$2993f1bacde97931$var$SHARED_FIELD_TYPES,
    EXTERNAL_REFERENCE: (0, $e3EnI.EXTERNAL_REFERENCE_FIELD_TYPE),
    DATE_TIME: (0, $e3EnI.DATE_TIME_FIELD_TYPE)
};
const $2993f1bacde97931$export$afad353d00ed07eb = {
    ...$2993f1bacde97931$var$SHARED_FIELD_TYPES,
    ARCHIVED_BY: (0, $e3EnI.ARCHIVED_BY_FIELD_TYPE),
    ARCHIVED_ON: (0, $e3EnI.ARCHIVED_ON_FIELD_TYPE),
    ARCHIVED: (0, $e3EnI.ARCHIVED_FIELD_TYPE),
    ATLAS_GOAL: (0, $e3EnI.ATLAS_GOAL_FIELD_TYPE),
    ATLAS_PROJECT_STATUS: (0, $e3EnI.ATLAS_PROJECT_STATUS_FIELD_TYPE),
    ATLAS_PROJECT: (0, $e3EnI.ATLAS_PROJECT_FIELD_TYPE),
    DELIVERY_PROGRESS: (0, $e3EnI.DELIVERY_PROGRESS_FIELD_TYPE),
    DELIVERY_STATUS: (0, $e3EnI.DELIVERY_STATUS_FIELD_TYPE),
    INSIGHTS: (0, $e3EnI.INSIGHTS_FIELD_TYPE),
    ISSUE_COMMENTS: (0, $e3EnI.ISSUE_COMMENTS_FIELD_TYPE),
    LINKED_ISSUES: (0, $e3EnI.LINKED_ISSUES_FIELD_TYPE),
    CONNECTION: (0, $e3EnI.CONNECTION_FIELD_TYPE)
};
const $2993f1bacde97931$var$JPD_SYSTEM_FIELDS = new Set([
    $2993f1bacde97931$export$afad353d00ed07eb.ASSIGNEE,
    $2993f1bacde97931$export$afad353d00ed07eb.CREATOR,
    $2993f1bacde97931$export$afad353d00ed07eb.CREATED,
    $2993f1bacde97931$export$afad353d00ed07eb.DESCRIPTION,
    $2993f1bacde97931$export$afad353d00ed07eb.ISSUE_ID,
    $2993f1bacde97931$export$afad353d00ed07eb.ISSUE_KEY,
    $2993f1bacde97931$export$afad353d00ed07eb.ISSUE_TYPE,
    $2993f1bacde97931$export$afad353d00ed07eb.LABELS,
    $2993f1bacde97931$export$afad353d00ed07eb.UPDATED,
    $2993f1bacde97931$export$afad353d00ed07eb.PROJECT,
    $2993f1bacde97931$export$afad353d00ed07eb.REPORTER,
    $2993f1bacde97931$export$afad353d00ed07eb.STATUS,
    $2993f1bacde97931$export$afad353d00ed07eb.SUMMARY,
    $2993f1bacde97931$export$afad353d00ed07eb.PLATFORM_GOALS,
    $2993f1bacde97931$export$afad353d00ed07eb.ARCHIVED,
    $2993f1bacde97931$export$afad353d00ed07eb.ARCHIVED_BY,
    $2993f1bacde97931$export$afad353d00ed07eb.ARCHIVED_ON,
    $2993f1bacde97931$export$afad353d00ed07eb.ATLAS_GOAL,
    $2993f1bacde97931$export$afad353d00ed07eb.ATLAS_PROJECT,
    $2993f1bacde97931$export$afad353d00ed07eb.ATLAS_PROJECT_STATUS,
    $2993f1bacde97931$export$afad353d00ed07eb.DELIVERY_PROGRESS,
    $2993f1bacde97931$export$afad353d00ed07eb.DELIVERY_STATUS,
    $2993f1bacde97931$export$afad353d00ed07eb.INSIGHTS,
    $2993f1bacde97931$export$afad353d00ed07eb.ISSUE_COMMENTS,
    $2993f1bacde97931$export$afad353d00ed07eb.LINKED_ISSUES
]);
const $2993f1bacde97931$export$89ca1a31640552e2 = (fieldType)=>{
    if (!fieldType) return false;
    return $2993f1bacde97931$var$JPD_SYSTEM_FIELDS.has(fieldType);
};

});
parcelRegister("e3EnI", function(module, exports) {

$parcel$export(module.exports, "POLARIS_SUB_TYPES", () => $b1f3d4c377a1eb89$export$cfc148b2220b4b0a);
$parcel$export(module.exports, "ISSUE_KEY_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$114d477a62682d99);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$56eae1056efd4899);
$parcel$export(module.exports, "ASSIGNEE_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$4c3373bd4e7ce49);
$parcel$export(module.exports, "CREATED_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$6080024602952834);
$parcel$export(module.exports, "CREATOR_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$1fd56353bd4f3359);
$parcel$export(module.exports, "STATUS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$a8fd621cc81b8a87);
$parcel$export(module.exports, "SUMMARY_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$394fb015dc5fe3a6);
$parcel$export(module.exports, "UPDATED_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$f1e36909b9abc7ae);
$parcel$export(module.exports, "LABELS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$535e3a8909d94d7);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$8e942cdeb60da463);
$parcel$export(module.exports, "REPORTER_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$649e75b7e16bad5);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$6e523e653cfad88b);
$parcel$export(module.exports, "PRIORITY_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$94a7d67a5a5f8b91);
$parcel$export(module.exports, "PROJECT_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$59321dbc9abd49f6);
$parcel$export(module.exports, "SHORT_TEXT_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$4351cd1d22652b1a);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$6f327bf99e20320);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$d8b50f59220c7580);
$parcel$export(module.exports, "HYPERLINK_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$11bd130492e7e8fa);
$parcel$export(module.exports, "CUSTOM_LABELS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$70390cd97300fa7c);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$dbe52b9d883d2625);
$parcel$export(module.exports, "MULTI_SELECT_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$285f65e5a586c1f);
$parcel$export(module.exports, "JSW_MULTI_SELECT_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$993bff918bc0ccf9);
$parcel$export(module.exports, "PEOPLE_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$e6980d07822314f1);
$parcel$export(module.exports, "JSW_PEOPLE_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$576a5badd33db282);
$parcel$export(module.exports, "CF_DEVELOPMENT_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$84237b8631f32952);
$parcel$export(module.exports, "TEAM_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$8b4226e50de933af);
$parcel$export(module.exports, "PLATFORM_GOALS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$46330bbb9e79249a);
$parcel$export(module.exports, "EXTERNAL_REFERENCE_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$f9de0221eabe6544);
$parcel$export(module.exports, "DATE_TIME_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$57563ae45f267ea);
$parcel$export(module.exports, "RATING_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$e7ac06f6e8312);
$parcel$export(module.exports, "SLIDER_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$4767128ebe2e61f2);
$parcel$export(module.exports, "FORMULA_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$b76a32055cbf69ab);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$ee975373b7797e8a);
$parcel$export(module.exports, "INTERVAL_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$c84a198a180fccff);
$parcel$export(module.exports, "REACTIONS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$c764f86fa417259);
$parcel$export(module.exports, "VOTES_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$1e82e7f0bb2a4d3a);
$parcel$export(module.exports, "CONNECTION_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$fa15f5b6b1f12728);
$parcel$export(module.exports, "INSIGHTS_GLOBAL_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$e1fa455631272e5);
$parcel$export(module.exports, "LINKED_ISSUES_GLOBAL_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$bb7b58786e7c2ca2);
$parcel$export(module.exports, "DELIVERY_PROGRESS_GLOBAL_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$ec4212f8bb763fb0);
$parcel$export(module.exports, "DELIVERY_STATUS_GLOBAL_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$eaad3e1a7da0e7dd);
$parcel$export(module.exports, "PLATFORM_PROJECT_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$7331d606c99d93d4);
$parcel$export(module.exports, "PLATFORM_PROJECT_STATUS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$ed0633195f5ede22);
$parcel$export(module.exports, "ISSUE_COMMENTS_GLOBAL_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$833c8a257428420);
$parcel$export(module.exports, "ISSUE_ID_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$14fe1cd05e6b89a8);
$parcel$export(module.exports, "ATLAS_PROJECT_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$a9fdf6d427f0b0e0);
$parcel$export(module.exports, "ATLAS_GOAL_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$e00b96bb82a6852d);
$parcel$export(module.exports, "ATLAS_PROJECT_STATUS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$21de5bb510b09c2a);
$parcel$export(module.exports, "DELIVERY_PROGRESS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$82ddf4546784b7b0);
$parcel$export(module.exports, "LINKED_ISSUES_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$4ddacfb406fb8d2b);
$parcel$export(module.exports, "ARCHIVED_BY_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$f4da6f1fcbcd2fc);
$parcel$export(module.exports, "ARCHIVED_ON_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$9cc7f39e571681e7);
$parcel$export(module.exports, "ARCHIVED_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$22d28d6b5ff5bdfa);
$parcel$export(module.exports, "ISSUE_COMMENTS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$5e50b332b75c1f4c);
$parcel$export(module.exports, "INSIGHTS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$dc8f533597c79afe);
$parcel$export(module.exports, "DELIVERY_STATUS_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$ce2dea1ae61139a8);
$parcel$export(module.exports, "RANK_FIELD_TYPE", () => $b1f3d4c377a1eb89$export$e2f39ba7110fd946);
const $b1f3d4c377a1eb89$export$cfc148b2220b4b0a = {
    ARCHIVED: 'ARCHIVED',
    ARCHIVED_BY: 'ARCHIVED_BY',
    ARCHIVED_ON: 'ARCHIVED_ON',
    DELIVERY_PROGRESS: 'DELIVERY_PROGRESS',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    ISSUE_COMMENTS: 'ISSUE_COMMENTS',
    LINKED_ISSUES: 'LINKED_ISSUES',
    NUM_DATA_POINTS: 'NUM_DATA_POINTS',
    ATLAS_GOAL: 'ATLAS_GOAL',
    ATLAS_PROJECT: 'ATLAS_PROJECT',
    ATLAS_PROJECT_STATUS: 'ATLAS_PROJECT_STATUS'
};
const $b1f3d4c377a1eb89$export$114d477a62682d99 = 'key'; // issuekey also works.
const $b1f3d4c377a1eb89$export$56eae1056efd4899 = 'description';
const $b1f3d4c377a1eb89$export$4c3373bd4e7ce49 = 'assignee';
const $b1f3d4c377a1eb89$export$6080024602952834 = 'created';
const $b1f3d4c377a1eb89$export$1fd56353bd4f3359 = 'creator';
const $b1f3d4c377a1eb89$export$a8fd621cc81b8a87 = 'status';
const $b1f3d4c377a1eb89$export$394fb015dc5fe3a6 = 'summary';
const $b1f3d4c377a1eb89$export$f1e36909b9abc7ae = 'updated';
const $b1f3d4c377a1eb89$export$535e3a8909d94d7 = 'labels';
const $b1f3d4c377a1eb89$export$8e942cdeb60da463 = 'issuetype';
const $b1f3d4c377a1eb89$export$649e75b7e16bad5 = 'reporter';
const $b1f3d4c377a1eb89$export$6e523e653cfad88b = 'issuelinks';
const $b1f3d4c377a1eb89$export$94a7d67a5a5f8b91 = 'priority';
const $b1f3d4c377a1eb89$export$59321dbc9abd49f6 = 'project';
const $b1f3d4c377a1eb89$export$4351cd1d22652b1a = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $b1f3d4c377a1eb89$export$6f327bf99e20320 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $b1f3d4c377a1eb89$export$d8b50f59220c7580 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $b1f3d4c377a1eb89$export$11bd130492e7e8fa = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $b1f3d4c377a1eb89$export$70390cd97300fa7c = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $b1f3d4c377a1eb89$export$dbe52b9d883d2625 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $b1f3d4c377a1eb89$export$285f65e5a586c1f = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $b1f3d4c377a1eb89$export$993bff918bc0ccf9 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $b1f3d4c377a1eb89$export$e6980d07822314f1 = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $b1f3d4c377a1eb89$export$576a5badd33db282 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $b1f3d4c377a1eb89$export$84237b8631f32952 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $b1f3d4c377a1eb89$export$8b4226e50de933af = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $b1f3d4c377a1eb89$export$46330bbb9e79249a = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $b1f3d4c377a1eb89$export$f9de0221eabe6544 = 'jira.polaris:external-reference';
const $b1f3d4c377a1eb89$export$57563ae45f267ea = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $b1f3d4c377a1eb89$export$e7ac06f6e8312 = 'jira.polaris:rating';
const $b1f3d4c377a1eb89$export$4767128ebe2e61f2 = 'jira.polaris:slider';
const $b1f3d4c377a1eb89$export$b76a32055cbf69ab = 'jira.polaris:formula';
const $b1f3d4c377a1eb89$export$ee975373b7797e8a = 'jira.polaris:boolean';
const $b1f3d4c377a1eb89$export$c84a198a180fccff = 'jira.polaris:interval';
const $b1f3d4c377a1eb89$export$c764f86fa417259 = 'jira.polaris:reactions';
const $b1f3d4c377a1eb89$export$1e82e7f0bb2a4d3a = 'jira.polaris:votes';
const $b1f3d4c377a1eb89$export$fa15f5b6b1f12728 = 'jira.polaris:connection';
const $b1f3d4c377a1eb89$export$e1fa455631272e5 = 'jira.polaris:count-insights';
const $b1f3d4c377a1eb89$export$bb7b58786e7c2ca2 = 'jira.polaris:count-linked-issues';
const $b1f3d4c377a1eb89$export$ec4212f8bb763fb0 = 'jira.polaris:delivery-progress';
const $b1f3d4c377a1eb89$export$eaad3e1a7da0e7dd = 'jira.polaris:delivery-status';
const $b1f3d4c377a1eb89$export$7331d606c99d93d4 = 'jira.polaris:atlassian-project';
const $b1f3d4c377a1eb89$export$ed0633195f5ede22 = 'jira.polaris:atlassian-project-status';
const $b1f3d4c377a1eb89$export$833c8a257428420 = 'jira.polaris:count-issue-comments';
const $b1f3d4c377a1eb89$export$14fe1cd05e6b89a8 = 'issueid';
const $b1f3d4c377a1eb89$export$a9fdf6d427f0b0e0 = 'atlasProject';
const $b1f3d4c377a1eb89$export$e00b96bb82a6852d = 'atlasGoal';
const $b1f3d4c377a1eb89$export$21de5bb510b09c2a = 'atlasProjectStatus';
const $b1f3d4c377a1eb89$export$82ddf4546784b7b0 = 'deliveryProgress';
const $b1f3d4c377a1eb89$export$4ddacfb406fb8d2b = 'linkedIssues';
const $b1f3d4c377a1eb89$export$f4da6f1fcbcd2fc = 'archivedBy';
const $b1f3d4c377a1eb89$export$9cc7f39e571681e7 = 'archivedOn';
const $b1f3d4c377a1eb89$export$22d28d6b5ff5bdfa = 'archived';
const $b1f3d4c377a1eb89$export$5e50b332b75c1f4c = 'issueComments'; // issue comments count
const $b1f3d4c377a1eb89$export$dc8f533597c79afe = 'numDataPoints';
const $b1f3d4c377a1eb89$export$ce2dea1ae61139a8 = 'deliveryStatus';
const $b1f3d4c377a1eb89$export$e2f39ba7110fd946 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';

});


const $9a5f06039e1dff5a$export$3aafeb2daa00df8b = 'key';
const $9a5f06039e1dff5a$export$48927a8f78b0130e = 'issueid';
const $9a5f06039e1dff5a$export$469f8bf472cb9ca = 'summary';
const $9a5f06039e1dff5a$export$29157f6cae91bb2f = 'status';
const $9a5f06039e1dff5a$export$dd03acb09519222 = 'issuetype';
const $9a5f06039e1dff5a$export$ed9d952d27dea151 = 'labels';
const $9a5f06039e1dff5a$export$1f3d7d17213e853b = 'votes';
const $9a5f06039e1dff5a$export$cb59b69c70ea9e18 = 'reporter';
const $9a5f06039e1dff5a$export$d6749ecf5a14d5b = 'description';
const $9a5f06039e1dff5a$export$7e67ea07bd31e757 = 'assignee';
const $9a5f06039e1dff5a$export$4b6f00f5eeabd293 = 'creator';
const $9a5f06039e1dff5a$export$16313363fca8abe5 = 'created';
const $9a5f06039e1dff5a$export$77c57adf6bed37b8 = 'updated';
const $9a5f06039e1dff5a$export$1fd24e9c03ef9b18 = 'project';

parcelRegister("9h1Bv", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesActions", () => $8fe39d942de86013$export$8748a77548356db8);
$parcel$export(module.exports, "useAllIssueTypesById", () => $8fe39d942de86013$export$bb3bddcbabc87129);
$parcel$export(module.exports, "useIssueTypesProjectIds", () => $8fe39d942de86013$export$dd0dd59b660a1e4);
$parcel$export(module.exports, "useAllIssueTypeIds", () => $8fe39d942de86013$export$ef415bb7a1b6a479);
$parcel$export(module.exports, "useAllIssueTypeIdsByProjectId", () => $8fe39d942de86013$export$48168bdb536ebd8c);
$parcel$export(module.exports, "useAllIssueTypesByProjectId", () => $8fe39d942de86013$export$b63556251c014141);
$parcel$export(module.exports, "useIssueTypeIdsForProject", () => $8fe39d942de86013$export$89c4ec728abd6d72);
$parcel$export(module.exports, "useIssueTypesForProject", () => $8fe39d942de86013$export$1cef051df1838099);
$parcel$export(module.exports, "useIssueTypesForProjectIds", () => $8fe39d942de86013$export$ab262f3c263d63f4);
$parcel$export(module.exports, "useIssueTypeIdForProject", () => $8fe39d942de86013$export$54a84af513817d94);
$parcel$export(module.exports, "useIssueTypeName", () => $8fe39d942de86013$export$ec3ac562fe41f8db);
$parcel$export(module.exports, "useIssueTypeDescription", () => $8fe39d942de86013$export$d6e733a19eae99d);
$parcel$export(module.exports, "useIssueTypeAvatarId", () => $8fe39d942de86013$export$d3cd0f314915ab90);
$parcel$export(module.exports, "useIsIssueTypeDeletable", () => $8fe39d942de86013$export$5cc5a14a165ffc68);
$parcel$export(module.exports, "useIsIssueTypeEditable", () => $8fe39d942de86013$export$b4c92f9ba36a536e);
$parcel$export(module.exports, "useIssueTypeProjectId", () => $8fe39d942de86013$export$cd4dff2fdb5c9877);
$parcel$export(module.exports, "useIssueTypeValuesForProject", () => $8fe39d942de86013$export$c55bbfadb5d8b5da);
$parcel$export(module.exports, "useIssueTypeValue", () => $8fe39d942de86013$export$798b621777f46d13);
$parcel$export(module.exports, "useIssueTypeValuesForProjectIds", () => $8fe39d942de86013$export$abaecfe2dee8c04a);
$parcel$export(module.exports, "useAllIssueTypeValuesById", () => $8fe39d942de86013$export$4bb11ad73c81e599);
$parcel$export(module.exports, "useHasProjectCustomIssueTypes", () => $8fe39d942de86013$export$3fc0643a546c76d0);
$parcel$export(module.exports, "useIssueTypeByNameAndProjectIds", () => $8fe39d942de86013$export$309b535a40496c46);
$parcel$export(module.exports, "useValidTransitionIssueTypeTargetNames", () => $8fe39d942de86013$export$7a2e81e8bca30117);
$parcel$export(module.exports, "useIssueTypePinnedFieldKeys", () => $8fe39d942de86013$export$5f3f38dbb1c1d6aa);

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $jGHed = parcelRequire("jGHed");

var $58MXj = parcelRequire("58MXj");
const $8fe39d942de86013$var$EMPTY = [];
const $8fe39d942de86013$var$initialState = {
    issueTypesById: {},
    issueTypesByProjectId: {}
};
const $8fe39d942de86013$var$Store = (0, $GtRbT.createStore)({
    initialState: $8fe39d942de86013$var$initialState,
    actions: $58MXj.actions,
    name: 'PolarisIssueTypesStore'
});
const $8fe39d942de86013$export$8748a77548356db8 = (0, $iJq0l.createActionsHook)($8fe39d942de86013$var$Store);
const $8fe39d942de86013$var$getAllIssueTypesById = (state)=>state.issueTypesById;
const $8fe39d942de86013$var$getAllIssueTypeIds = (state)=>Object.keys(state.issueTypesById);
const $8fe39d942de86013$var$getAllIssueTypeIdsByProjectId = (state)=>state.issueTypesByProjectId;
const $8fe39d942de86013$export$bb3bddcbabc87129 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getAllIssueTypesById
});
const $8fe39d942de86013$var$getProjectIds = (0, $4MchI.createSelector)($8fe39d942de86013$var$getAllIssueTypeIdsByProjectId, (issueTypesByProjectId)=>Object.keys(issueTypesByProjectId));
const $8fe39d942de86013$export$dd0dd59b660a1e4 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getProjectIds
});
const $8fe39d942de86013$export$ef415bb7a1b6a479 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getAllIssueTypeIds
});
const $8fe39d942de86013$export$48168bdb536ebd8c = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getAllIssueTypeIdsByProjectId
});
const $8fe39d942de86013$var$getAllIssueTypesByProjectId = (0, $4MchI.createSelector)($8fe39d942de86013$var$getAllIssueTypeIdsByProjectId, $8fe39d942de86013$var$getAllIssueTypesById, (issueTypesByProjectId, issueTypesById)=>{
    return Object.keys(issueTypesByProjectId).reduce((acc, projectId)=>{
        acc[projectId] = issueTypesByProjectId[projectId]?.map((issueTypeId)=>issueTypesById[issueTypeId]).filter(Boolean);
        return acc;
    }, {});
});
const $8fe39d942de86013$export$b63556251c014141 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getAllIssueTypesByProjectId
});
const $8fe39d942de86013$var$getIssueTypeIdsForProject = (state, { projectId: projectId })=>{
    if (projectId === undefined) return $8fe39d942de86013$var$EMPTY;
    return state.issueTypesByProjectId[projectId] || $8fe39d942de86013$var$EMPTY;
};
const $8fe39d942de86013$var$getIssueTypeIdsForProjectIds = (state, { projectIds: projectIds })=>{
    return projectIds.flatMap((projectId)=>state.issueTypesByProjectId[projectId] || $8fe39d942de86013$var$EMPTY);
};
const $8fe39d942de86013$export$89c4ec728abd6d72 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getIssueTypeIdsForProject
});
const $8fe39d942de86013$var$getIssueTypesForProject = (0, $4MchI.createSelector)($8fe39d942de86013$var$getAllIssueTypesById, $8fe39d942de86013$var$getIssueTypeIdsForProject, (issueTypesById, issueTypeIds)=>issueTypeIds.map((issueTypeId)=>issueTypesById[issueTypeId]).filter(Boolean));
const $8fe39d942de86013$export$1cef051df1838099 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getIssueTypesForProject
});
const $8fe39d942de86013$var$getIssueTypesForProjectIds = (0, $4MchI.createSelector)($8fe39d942de86013$var$getAllIssueTypesById, $8fe39d942de86013$var$getIssueTypeIdsForProjectIds, (issueTypesById, issueTypeIds)=>issueTypeIds.map((issueTypeId)=>issueTypesById[issueTypeId]).filter(Boolean));
const $8fe39d942de86013$export$ab262f3c263d63f4 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getIssueTypesForProjectIds
});
const $8fe39d942de86013$export$54a84af513817d94 = ({ projectId: projectId })=>{
    const issueTypeIds = $8fe39d942de86013$export$89c4ec728abd6d72({
        projectId: projectId
    });
    return issueTypeIds.length > 0 ? issueTypeIds[0] : undefined;
};
const $8fe39d942de86013$export$ec3ac562fe41f8db = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.name
});
const $8fe39d942de86013$export$d6e733a19eae99d = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.description
});
const $8fe39d942de86013$export$d3cd0f314915ab90 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.avatarId
});
const $8fe39d942de86013$export$5cc5a14a165ffc68 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.operation.deletable === true
});
const $8fe39d942de86013$export$b4c92f9ba36a536e = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.operation.editable === true
});
const $8fe39d942de86013$export$cd4dff2fdb5c9877 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: (state, { issueTypeId: issueTypeId })=>Object.keys(state.issueTypesByProjectId).find((projectId)=>state.issueTypesByProjectId[projectId]?.includes(issueTypeId))
});
const $8fe39d942de86013$var$transformToFieldValue = ({ id: id, name: name, avatarId: avatarId })=>({
        id: id,
        name: name,
        iconUrl: (0, $jGHed.makeAvatarUrlFromId)(avatarId)
    });
const $8fe39d942de86013$var$getIssueTypeValuesForProject = (0, $4MchI.createSelector)($8fe39d942de86013$var$getIssueTypesForProject, (issueTypes)=>issueTypes.map($8fe39d942de86013$var$transformToFieldValue));
const $8fe39d942de86013$export$c55bbfadb5d8b5da = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getIssueTypeValuesForProject
});
const $8fe39d942de86013$var$getIssueTypeValue = (state, { issueTypeId: issueTypeId })=>{
    if (!issueTypeId) return undefined;
    const issueType = state.issueTypesById[issueTypeId];
    if (!issueType) return undefined;
    return $8fe39d942de86013$var$transformToFieldValue(issueType);
};
const $8fe39d942de86013$export$798b621777f46d13 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getIssueTypeValue
});
const $8fe39d942de86013$var$getIssueTypeValuesForProjectIds = (0, $4MchI.createSelector)($8fe39d942de86013$var$getIssueTypesForProjectIds, (issueTypes)=>issueTypes.map($8fe39d942de86013$var$transformToFieldValue));
const $8fe39d942de86013$export$abaecfe2dee8c04a = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getIssueTypeValuesForProjectIds
});
const $8fe39d942de86013$var$getAllIssueTypeValuesById = (0, $4MchI.createSelector)($8fe39d942de86013$var$getAllIssueTypesById, (allIssueTypes)=>{
    const issueTypeMap = new Map();
    Object.values(allIssueTypes).forEach((issueType)=>{
        issueType && issueTypeMap.set(issueType.id, $8fe39d942de86013$var$transformToFieldValue(issueType));
    });
    return issueTypeMap;
});
const $8fe39d942de86013$export$4bb11ad73c81e599 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getAllIssueTypeValuesById
});
const $8fe39d942de86013$var$hasProjectCustomIssueTypes = (0, $4MchI.createSelector)($8fe39d942de86013$var$getIssueTypeIdsForProject, (issueTypeIds)=>issueTypeIds.length > 1);
const $8fe39d942de86013$export$3fc0643a546c76d0 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$hasProjectCustomIssueTypes
});
const $8fe39d942de86013$var$getIssueTypeByNameAndProjectIds = (state, { name: name, projectIds: projectIds })=>{
    if (!name || !projectIds) return;
    for (const projectId of projectIds){
        const issueTypeId = state.issueTypesByProjectId[projectId]?.find((id)=>state.issueTypesById[id]?.name === name);
        if (issueTypeId) return state.issueTypesById[issueTypeId];
    }
};
const $8fe39d942de86013$export$309b535a40496c46 = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getIssueTypeByNameAndProjectIds
});
const $8fe39d942de86013$export$7a2e81e8bca30117 = ({ projectId: projectId })=>{
    const allIssueTypeIdsByProjectId = $8fe39d942de86013$export$48168bdb536ebd8c();
    const allIssueTypesById = $8fe39d942de86013$export$bb3bddcbabc87129();
    if (!projectId) return [];
    return allIssueTypeIdsByProjectId[projectId]?.map((issueTypeId)=>allIssueTypesById[issueTypeId]?.name).filter(Boolean) ?? [];
};
const $8fe39d942de86013$var$getIssueTypePinnedFieldKeys = (state, { issueTypeId: issueTypeId })=>state.issueTypesById[issueTypeId]?.pinnedFields || [];
const $8fe39d942de86013$export$5f3f38dbb1c1d6aa = (0, $iJq0l.createStateHook)($8fe39d942de86013$var$Store, {
    selector: $8fe39d942de86013$var$getIssueTypePinnedFieldKeys
});

});
parcelRegister("jGHed", function(module, exports) {

$parcel$export(module.exports, "issueTypeAvatarSizesMap", () => $c78d8a6cd9905c19$export$e5a269c2eaf3cbbd);
$parcel$export(module.exports, "makeAvatarUrlFromId", () => $c78d8a6cd9905c19$export$28c6330f346167cc);
const $c78d8a6cd9905c19$export$e5a269c2eaf3cbbd = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40
};
const $c78d8a6cd9905c19$export$28c6330f346167cc = (id, size)=>{
    return `/rest/api/2/universal_avatar/view/type/issuetype/avatar/${id}${size ? `?size=${size}` : ''}`;
};

});

parcelRegister("58MXj", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f41da0b4261ea26b$export$e324594224ef24da);

var $jFNiQ = parcelRequire("jFNiQ");

var $5sDtB = parcelRequire("5sDtB");

var $1jA2Q = parcelRequire("1jA2Q");

var $ivbVl = parcelRequire("ivbVl");

var $65Jhr = parcelRequire("65Jhr");

var $5wIhK = parcelRequire("5wIhK");
const $f41da0b4261ea26b$export$e324594224ef24da = {
    fetchIssueTypesForProjects: $1jA2Q.fetchIssueTypesForProjects,
    updateIssueType: $5wIhK.updateIssueType,
    createIssueType: $jFNiQ.createIssueType,
    deleteIssueType: $5sDtB.deleteIssueType,
    populateIssueTypes: $65Jhr.populateIssueTypes,
    togglePinnedField: $ivbVl.togglePinnedField,
    updatePinnedFields: $ivbVl.updatePinnedFields
};

});
parcelRegister("jFNiQ", function(module, exports) {

$parcel$export(module.exports, "createIssueType", () => $aafd992667bd2054$export$9557596bf5429867);

var $6Yd06 = parcelRequire("6Yd06");

var $b5oGV = parcelRequire("b5oGV");

var $8KUFq = parcelRequire("8KUFq");

var $fVlmn = parcelRequire("fVlmn");

var $7jTnu = parcelRequire("7jTnu");

var $9lAkP = parcelRequire("9lAkP");
const $aafd992667bd2054$var$transformIssueType = (rest)=>({
        id: String(rest.id),
        name: rest.name,
        entityId: rest.entityId,
        description: rest.description,
        avatarId: String(rest.avatarId),
        hierarchyLevel: rest.hierarchyLevel,
        operation: {
            deletable: true,
            editable: true
        },
        pinnedFields: (0, $7jTnu.fg)('jpd-types-pinned-fields') ? [] : undefined
    });
const $aafd992667bd2054$export$9557596bf5429867 = (projectId, data)=>async ({ setState: setState, getState: getState })=>{
        (0, $b5oGV.experience).issueTypes.issueTypeCreate.start();
        try {
            const result = await (0, $9lAkP.performCreateIssueType)(projectId, {
                name: data.name,
                description: data.description,
                avatarId: Number(data.avatarId)
            });
            const newIssueType = $aafd992667bd2054$var$transformIssueType(result);
            const state = getState();
            setState({
                issueTypesById: {
                    ...state.issueTypesById,
                    [newIssueType.id]: newIssueType
                },
                issueTypesByProjectId: {
                    ...state.issueTypesByProjectId,
                    [projectId]: [
                        ...state.issueTypesByProjectId[projectId] ?? [],
                        newIssueType.id
                    ]
                }
            });
            (0, $b5oGV.experience).issueTypes.issueTypeCreate.success();
            return newIssueType;
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while creating issue type');
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isConflictError)(error)) (0, $b5oGV.experience).issueTypes.issueTypeCreate.abort();
            else (0, $b5oGV.experience).issueTypes.issueTypeCreate.failure(error);
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.create-issue-type', 'Failed to create issue type', error);
            throw error;
        }
    };

});
parcelRegister("6Yd06", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerDataWrapper", () => $010050cb32520e49$export$ebd6466ba18b2f3a);

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");




const $010050cb32520e49$export$ebd6466ba18b2f3a = async (location, message, event)=>{
    const modifiedEvent = event;
    if ((0, $7jTnu.fg)('jpd_sentry_fetch_error_fix')) {
        if (modifiedEvent instanceof (0, $1uIew.default) && modifiedEvent.originalResponse && // We can't guarantee that response object is always in unread state when we try to log it
        !modifiedEvent.originalResponse?.bodyUsed) {
            const originalResponseText = await modifiedEvent.originalResponse.text();
            modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
            delete modifiedEvent.originalResponse;
        }
    } else if (modifiedEvent instanceof (0, $1uIew.default) && modifiedEvent.originalResponse) {
        const originalResponseText = await modifiedEvent.originalResponse.text();
        modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
        delete modifiedEvent.originalResponse;
    }
    (0, $eSnSE.default).safeErrorWithoutCustomerData(location, message, modifiedEvent);
    // Returning the modified error so the original response text can be used in the error handler
    return modifiedEvent;
};

});

parcelRegister("fVlmn", function(module, exports) {

$parcel$export(module.exports, "isPermissionError", () => $bff2287ffa2d3eb9$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $bff2287ffa2d3eb9$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $bff2287ffa2d3eb9$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $bff2287ffa2d3eb9$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isClientClosedError", () => $bff2287ffa2d3eb9$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $bff2287ffa2d3eb9$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConflictError", () => $bff2287ffa2d3eb9$export$b43c7b888ac6458);
$parcel$export(module.exports, "isConfigError", () => $bff2287ffa2d3eb9$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $bff2287ffa2d3eb9$export$8548546c0aa631e6);

var $exWdq = parcelRequire("exWdq");

var $4sprp = parcelRequire("4sprp");

var $jUVzX = parcelRequire("jUVzX");
const $bff2287ffa2d3eb9$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || // that's probably obsolete
        safeMessage.includes('status code 403') // that's probably obsolete
        ;
    });
    return false;
};
const $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $bff2287ffa2d3eb9$export$a8908c3867f6f20b = (errorObject)=>{
    return $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(error)) || false;
};
const $bff2287ffa2d3eb9$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $bff2287ffa2d3eb9$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $bff2287ffa2d3eb9$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $bff2287ffa2d3eb9$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $bff2287ffa2d3eb9$export$b43c7b888ac6458 = (errorObject)=>errorObject.statusCode === 409;
const $bff2287ffa2d3eb9$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $bff2287ffa2d3eb9$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});
parcelRegister("jUVzX", function(module, exports) {

var $202ak = parcelRequire("202ak");

var $1lM9j = parcelRequire("1lM9j");

var $2DwDI = parcelRequire("2DwDI");

var $4sprp = parcelRequire("4sprp");

var $eA1it = parcelRequire("eA1it");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $e7ffe9447e10a1ca$var$some(collection, predicate, guard) {
    var func = $4sprp(collection) ? $202ak : $2DwDI;
    if (guard && $eA1it(collection, predicate, guard)) predicate = undefined;
    return func(collection, $1lM9j(predicate, 3));
}
module.exports = $e7ffe9447e10a1ca$var$some;

});
parcelRegister("2DwDI", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $1eb88ace25f55b0d$var$baseSome(collection, predicate) {
    var result;
    $c3u3c(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $1eb88ace25f55b0d$var$baseSome;

});



parcelRegister("9lAkP", function(module, exports) {

$parcel$export(module.exports, "performCreateIssueType", () => $b653439d7a0851e7$export$4b90dd56614eadf8);

var $jGzN3 = parcelRequire("jGzN3");
const $b653439d7a0851e7$export$4b90dd56614eadf8 = (projectId, data)=>{
    return (0, $jGzN3.performPostRequest)(`/rest/polaris/v2/project/${projectId}/settings/issuetype`, {
        body: JSON.stringify(data)
    });
};

});


parcelRegister("5sDtB", function(module, exports) {

$parcel$export(module.exports, "deleteIssueType", () => $19ecb7be9409b096$export$5aaa67231e589913);

var $huH03 = parcelRequire("huH03");

var $jFHCE = parcelRequire("jFHCE");

var $3l9kN = parcelRequire("3l9kN");

var $6Yd06 = parcelRequire("6Yd06");

var $b5oGV = parcelRequire("b5oGV");

var $8KUFq = parcelRequire("8KUFq");

var $fVlmn = parcelRequire("fVlmn");

var $2Hdmd = parcelRequire("2Hdmd");
const $19ecb7be9409b096$export$5aaa67231e589913 = (issueTypeId, projectId)=>async ({ dispatch: dispatch })=>{
        (0, $b5oGV.experience).issueTypes.issueTypeDelete.start();
        try {
            await (0, $2Hdmd.performDeleteIssueType)(issueTypeId, projectId);
            dispatch($19ecb7be9409b096$var$deleteIssueTypeFromStateOnly(issueTypeId));
            (0, $b5oGV.experience).issueTypes.issueTypeDelete.success();
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while deleting issue type');
            if ((0, $fVlmn.isNotFoundError)(error)) {
                (0, $b5oGV.experience).issueTypes.issueTypeDelete.abort();
                dispatch($19ecb7be9409b096$var$deleteIssueTypeFromStateOnly(issueTypeId));
            } else if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isConflictError)(error)) (0, $b5oGV.experience).issueTypes.issueTypeDelete.abort();
            else (0, $b5oGV.experience).issueTypes.issueTypeDelete.failure(error);
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.delete-issue-type', 'Failed to delete issue type', error);
            throw error;
        }
    };
const $19ecb7be9409b096$var$deleteIssueTypeFromStateOnly = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            issueTypesById: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state.issueTypesById, issueTypeId),
            issueTypesByProjectId: (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(state.issueTypesByProjectId, (issueTypeIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(issueTypeIds, issueTypeId))
        });
    };

});
parcelRegister("3l9kN", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $26ea92e191963c80$var$without = $l76qh(function(array, values) {
    return $d1ShJ(array) ? $leN9Q(array, values) : [];
});
module.exports = $26ea92e191963c80$var$without;

});

parcelRegister("2Hdmd", function(module, exports) {

$parcel$export(module.exports, "performDeleteIssueType", () => $af308eb47b3ae757$export$228c421060a1ae62);

var $jGzN3 = parcelRequire("jGzN3");
const $af308eb47b3ae757$export$228c421060a1ae62 = (issueTypeId, projectId)=>{
    return (0, $jGzN3.performDeleteRequest)(`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}`);
};

});


parcelRegister("1jA2Q", function(module, exports) {

$parcel$export(module.exports, "fetchIssueTypesForProjects", () => $beb605431a8ff29b$export$59b6e6b26485fa83);

var $9g7yh = parcelRequire("9g7yh");

var $lsLcV = parcelRequire("lsLcV");

var $k2MWf = parcelRequire("k2MWf");

var $6Yd06 = parcelRequire("6Yd06");

var $b5oGV = parcelRequire("b5oGV");

var $8KUFq = parcelRequire("8KUFq");

var $eSnSE = parcelRequire("eSnSE");

var $6TK3G = parcelRequire("6TK3G");

var $Ph10w = parcelRequire("Ph10w");
const $beb605431a8ff29b$var$PROJECT_IDS_LIMIT = 50;
const $beb605431a8ff29b$var$BATCH_SIZE = 5;
const $beb605431a8ff29b$export$59b6e6b26485fa83 = (projectIds)=>async ({ setState: setState, getState: getState })=>{
        (0, $b5oGV.experience).issueTypes.issueTypesForProjectsLoad.start();
        const prevState = getState();
        try {
            setState({
                issueTypesByProjectId: {
                    ...prevState.issueTypesByProjectId,
                    ...projectIds.reduce((acc, projectId)=>{
                        acc[projectId] = [];
                        return acc;
                    }, {})
                }
            });
            (0, $eSnSE.default).safeInfoWithoutCustomerData('polaris.issue-types.actions.fetch-issue-types-for-projects', 'Fetching issue types for projects', {
                projectIdsCount: projectIds.length
            });
            const projectIdsChunks = (0, (/*@__PURE__*/$parcel$interopDefault($lsLcV)))(projectIds, $beb605431a8ff29b$var$PROJECT_IDS_LIMIT);
            const batchResponse = await (0, $k2MWf.runInBatch)(projectIdsChunks.map((ids)=>()=>(0, $6TK3G.performGetIssueTypesForProjects)(ids)), $beb605431a8ff29b$var$BATCH_SIZE);
            const projects = batchResponse.map((c)=>c.projects).flat();
            const { issueTypesById: issueTypesById, issueTypesByProjectId: issueTypesByProjectId } = projects.reduce((acc, { projectId: projectId, issueTypes: issueTypes })=>({
                    issueTypesById: {
                        ...acc.issueTypesById,
                        ...(0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(issueTypes.map((0, $Ph10w.transformIssueTypeResponse)), ({ id: id })=>id)
                    },
                    issueTypesByProjectId: {
                        ...acc.issueTypesByProjectId,
                        [projectId]: issueTypes.map(({ id: id })=>String(id))
                    }
                }), {
                issueTypesById: {},
                issueTypesByProjectId: {}
            });
            setState({
                issueTypesById: {
                    ...getState().issueTypesById,
                    ...issueTypesById
                },
                issueTypesByProjectId: {
                    ...getState().issueTypesByProjectId,
                    ...issueTypesByProjectId
                }
            });
            (0, $b5oGV.experience).issueTypes.issueTypesForProjectsLoad.success();
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while fetching issue types for projects');
            if ((0, $8KUFq.isClientFetchError)(error)) (0, $b5oGV.experience).issueTypes.issueTypesForProjectsLoad.abort();
            else (0, $b5oGV.experience).issueTypes.issueTypesForProjectsLoad.failure(error);
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.fetch-issue-types-for-projects', 'Failed to fetch issue types for projects', error);
            throw error;
        }
    };

});
parcelRegister("lsLcV", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");

var $eA1it = parcelRequire("eA1it");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fa00d4eb66826668$var$nativeCeil = Math.ceil, $fa00d4eb66826668$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $fa00d4eb66826668$var$chunk(array, size, guard) {
    if (guard ? $eA1it(array, size, guard) : size === undefined) size = 1;
    else size = $fa00d4eb66826668$var$nativeMax($c9FP3(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($fa00d4eb66826668$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $1FqKq(array, index, index += size);
    return result;
}
module.exports = $fa00d4eb66826668$var$chunk;

});

parcelRegister("k2MWf", function(module, exports) {

$parcel$export(module.exports, "runInBatch", () => $41050f0d4140e911$export$450a3350fc58ff82);

var $lsLcV = parcelRequire("lsLcV");

var $1yBwF = parcelRequire("1yBwF");

var $fSg1O = parcelRequire("fSg1O");
const $41050f0d4140e911$var$executeBatchesRecursively = (remainingChunks)=>{
    const currentChunk = (0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(remainingChunks) || [];
    const nextChunks = (0, (/*@__PURE__*/$parcel$interopDefault($fSg1O)))(remainingChunks);
    return Promise.all(currentChunk.map((promiseProvider)=>promiseProvider())).then((results)=>{
        if (nextChunks.length > 0) return $41050f0d4140e911$var$executeBatchesRecursively(nextChunks).then((recursiveResults)=>[
                ...results,
                ...recursiveResults
            ]);
        return results;
    });
};
const $41050f0d4140e911$export$450a3350fc58ff82 = (promises, batchSize)=>{
    if (promises.length === 0) return Promise.resolve([]);
    const batches = (0, (/*@__PURE__*/$parcel$interopDefault($lsLcV)))(promises, batchSize);
    return $41050f0d4140e911$var$executeBatchesRecursively(batches);
};

});
parcelRegister("1yBwF", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $1226134b15e074ee$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $1226134b15e074ee$var$head;

});

parcelRegister("fSg1O", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");
/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */ function $b8e855046bc5b9cf$var$tail(array) {
    var length = array == null ? 0 : array.length;
    return length ? $1FqKq(array, 1, length) : [];
}
module.exports = $b8e855046bc5b9cf$var$tail;

});


parcelRegister("6TK3G", function(module, exports) {

$parcel$export(module.exports, "performGetIssueTypesForProjects", () => $94f994c23c6529b5$export$e47c37e7ea368000);

var $1Ozm9 = parcelRequire("1Ozm9");

var $7bPX5 = parcelRequire("7bPX5");

var $9WQUR = parcelRequire("9WQUR");

var $8NIsa = parcelRequire("8NIsa");
const $94f994c23c6529b5$export$e47c37e7ea368000 = (projectIds)=>{
    if (!projectIds.length) throw new Error('No project ids provided');
    // Try to get from early fetch cache first
    const earlyFetchResponse = (0, $9WQUR.getEarlyFetchResponse)(projectIds);
    if (earlyFetchResponse) return (0, $7bPX5.wrapPromiseWithFetchInteraction)(earlyFetchResponse, 'earlyScript/getIssueTypesForProjects').catch(()=>{
        // If the cached promise fails, fall back to a regular fetch
        return (0, $1Ozm9.default)((0, $8NIsa.getIssueTypesForProjectsUrl)(projectIds));
    });
    // Fallback to regular fetch if not in cache
    return (0, $1Ozm9.default)((0, $8NIsa.getIssueTypesForProjectsUrl)(projectIds));
};

});
parcelRegister("7bPX5", function(module, exports) {

$parcel$export(module.exports, "wrapPromiseWithFetchInteraction", () => $9cc989f2d7142f1a$export$6819d892dfd1cee3);

var $2QO3b = parcelRequire("2QO3b");
const $9cc989f2d7142f1a$export$6819d892dfd1cee3 = (promise, name, type = 'fetch')=>{
    const fetchStartTime = performance.now();
    return promise.then((response)=>{
        (0, $2QO3b.addSpanToAll)(type, name, [
            {
                name: 'network'
            },
            {
                name: 'jpdApp'
            }
        ], fetchStartTime, performance.now());
        return response;
    });
};

});

parcelRegister("9WQUR", function(module, exports) {

$parcel$export(module.exports, "getEarlyFetchResponse", () => $e1d45f24425f4e3f$export$b9d6f7ad3c414536);
$parcel$export(module.exports, "runGetIssueTypesForProjectsEarlyScript", () => $e1d45f24425f4e3f$export$f8e676bff6de4a13);

var $cSmYj = parcelRequire("cSmYj");

var $57UeM = parcelRequire("57UeM");

var $9LGqd = parcelRequire("9LGqd");

var $f209B = parcelRequire("f209B");

var $1yxJh = parcelRequire("1yxJh");

var $g0d52 = parcelRequire("g0d52");

var $j874X = parcelRequire("j874X");

var $8NIsa = parcelRequire("8NIsa");
// Create a type-specific early fetch cache for issue types
const $e1d45f24425f4e3f$var$earlyFetchCache = (0, $57UeM.createEarlyFetchCache)({
    paramsEqualityFn: (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(a.map(String), b.map(String))
});
const $e1d45f24425f4e3f$export$b9d6f7ad3c414536 = (projectIds)=>{
    return $e1d45f24425f4e3f$var$earlyFetchCache.getCachedResponse(projectIds);
};
/**
 * Helper function to fetch issue types with proper type
 */ const $e1d45f24425f4e3f$var$fetchIssueTypesForProjects = (projectIds)=>{
    if (!projectIds.length) throw new Error('No project ids provided');
    const url = (0, $8NIsa.getIssueTypesForProjectsUrl)(projectIds);
    return (0, $9LGqd.fetchData)({
        url: url,
        method: 'GET'
    });
};
const $e1d45f24425f4e3f$export$b27be2640a8307fd = (projectIds)=>{
    // Execute the actual fetch for issue types
    const response = $e1d45f24425f4e3f$var$fetchIssueTypesForProjects(projectIds);
    // Store the fetch promise in the cache
    $e1d45f24425f4e3f$var$earlyFetchCache.setCacheResponse(response, projectIds);
};
function $e1d45f24425f4e3f$export$f8e676bff6de4a13(location) {
    // Parse the location to extract the necessary parameters
    const projectKey = (0, $j874X.getProjectKeyFromLocation)(location);
    if (!projectKey) return false;
    // Use cached projectId if available, otherwise wait for SPA_STATE
    (0, $g0d52.getProjectIdFromMap)(projectKey, (0, $f209B.waitForGlobalVariable)).then((projectId)=>{
        if (projectId) // For now, we fetch issue types for the current project
        // This can be extended to handle multiple projects if needed
        $e1d45f24425f4e3f$export$b27be2640a8307fd([
            String(projectId)
        ]);
    }).catch((error)=>{
        (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping', 'Error fetching issue types', error instanceof Error ? error : new Error(String(error)));
    });
    return true;
}

});
parcelRegister("57UeM", function(module, exports) {

$parcel$export(module.exports, "createEarlyFetchCache", () => $d5a32272036b5c8d$export$64bbd812926dd865);

var $cSmYj = parcelRequire("cSmYj");
class $d5a32272036b5c8d$export$60288a72c0bd9021 {
    constructor(options){
        this.paramsEqualityFn = options.paramsEqualityFn || this.defaultParamsEqual;
        this.cache = {
            response: null,
            accessed: false,
            params: null
        };
    }
    /**
	 * Default parameter comparison function
	 * Deep compares two parameter objects to ensure they are equivalent
	 */ defaultParamsEqual(paramsA, paramsB) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(paramsA, paramsB);
    }
    /**
	 * Compares two parameter objects using the configured comparison function
	 */ areParamsEqual(paramsA, paramsB) {
        return this.paramsEqualityFn(paramsA, paramsB);
    }
    /**
	 * Clears the early fetch cache
	 * This function can be called to reset the cache when needed
	 */ clearCache() {
        this.cache.response = null;
        this.cache.accessed = false;
        this.cache.params = null;
    }
    /**
	 * Sets the response in the cache with the associated parameters
	 */ setCacheResponse(response, params) {
        this.cache.response = response;
        this.cache.params = params;
        this.cache.accessed = false;
    }
    /**
	 * Gets the cached response if it matches the provided parameters and marks it as accessed
	 * The cache will be automatically cleared after the promise resolves and has been accessed
	 */ getCachedResponse(params) {
        // Check if there's no response
        if (!this.cache.response) return null;
        // Check if params match the cached params
        if (!this.cache.params || !this.areParamsEqual(this.cache.params, params)) {
            this.clearCache();
            return null;
        }
        // Set up promise settlement handler only on first access to avoid multiple handlers
        if (!this.cache.accessed) {
            // Mark as accessed
            this.cache.accessed = true;
            // Set up promise settlement handler to clear cache after promise settles
            this.cache.response.finally(()=>{
                // Clear cache when promise has settled (resolved or rejected)
                this.clearCache();
            });
        }
        return this.cache.response;
    }
}
function $d5a32272036b5c8d$export$64bbd812926dd865(options) {
    return new $d5a32272036b5c8d$export$60288a72c0bd9021(options);
}

});

parcelRegister("9LGqd", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $6b26af223dd55249$export$8134c072fddab6a5);

var $fiPhB = parcelRequire("fiPhB");

var $lRE0G = parcelRequire("lRE0G");

var $hr3bU = parcelRequire("hr3bU");
const $6b26af223dd55249$export$8134c072fddab6a5 = ({ url: url, body: body, method: method = 'GET', headers: headers })=>{
    (0, $lRE0G.setMark)('jira.fe-spa.jpd.early-preload:start');
    return fetch(url, {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            Accept: [
                'application/json',
                'text/javascript'
            ].join(','),
            ...(0, $fiPhB.getActiveTraceHttpRequestHeaders)(),
            ...headers
        },
        method: method,
        body: body
    }).then((response)=>{
        (0, $lRE0G.setMark)('jira.fe-spa.jpd.early-preload:end');
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = (0, $lRE0G.getTraceId)(response);
                throw new (0, $hr3bU.FetchError)(status, str, traceId || undefined);
            });
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });
};

});
parcelRegister("lRE0G", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $641fb0b52c9a46e4$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $641fb0b52c9a46e4$export$e88cb5bfb57ce9c4);

const $641fb0b52c9a46e4$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $641fb0b52c9a46e4$var$TRACE_ID_HEADER = 'atl-traceid';
const $641fb0b52c9a46e4$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $641fb0b52c9a46e4$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($641fb0b52c9a46e4$var$TRACE_ID_HEADER) || response.headers.get($641fb0b52c9a46e4$var$TRACE_ID_HEADER_MICROS);

});


parcelRegister("f209B", function(module, exports) {

$parcel$export(module.exports, "waitForGlobalVariable", () => $2ac6820def87aa2b$export$8ef1adf6e9aa0f76);

var $1yxJh = parcelRequire("1yxJh");
const $2ac6820def87aa2b$export$8ef1adf6e9aa0f76 = (varName, timeout = 2000)=>{
    const start = performance.now();
    let promise = new Promise((resolve, reject)=>{
        let rafId;
        let timeoutId;
        let completed = false;
        /**
		 * Cleanup function to cancel animation frames and clear timeouts
		 */ const cleanup = ()=>{
            if (rafId) cancelAnimationFrame(rafId);
            if (timeoutId) clearTimeout(timeoutId);
        };
        /**
		 * Check if the variable is available on the window object
		 */ const check = ()=>{
            // Check if variable exists and is not undefined
            const windowObj = globalThis?.window;
            if (windowObj && Reflect.has(windowObj, varName)) {
                const value = Reflect.get(windowObj, varName);
                if (value !== undefined) {
                    completed = true;
                    cleanup();
                    resolve(value);
                    return;
                }
            }
            // Continue polling using requestAnimationFrame
            rafId = requestAnimationFrame(check);
        };
        // Set up timeout to reject if variable is not found
        timeoutId = setTimeout(()=>{
            if (!completed) {
                completed = true;
                cleanup();
                reject(new Error(`Variable ${varName} not found within ${timeout}ms`));
            }
        }, timeout);
        // Start checking for the variable
        check();
    });
    promise = promise.then((value)=>{
        (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordMetric('custom', 'global-variable-polling', [
            {
                name: 'jpdApp'
            },
            {
                name: 'earlyScript'
            }
        ], start, performance.now());
        return value;
    });
    return promise;
};

});
parcelRegister("1yxJh", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptObservabilityCache", () => $35f6a8a5ac0bf49c$export$50bbab1d25016c83);
// Types for the cache entries
class $35f6a8a5ac0bf49c$export$c22cddd926aebf66 {
    // Error methods following the same pattern as flags.tsx
    recordError(location, message, error) {
        const entry = {
            location: location,
            message: message,
            error: error
        };
        this.errors.push(entry);
        this.trimErrors();
    }
    // Metric methods following the same pattern as addSpanToAll
    recordMetric(spanType, name, tags, start, end, size) {
        const entry = {
            spanType: spanType,
            name: name,
            tags: tags,
            start: start,
            end: end,
            size: size
        };
        this.metrics.push(entry);
        this.trimMetrics();
    }
    // Retrieval methods
    getErrors() {
        return [
            ...this.errors
        ];
    }
    getMetrics() {
        return [
            ...this.metrics
        ];
    }
    // Clear methods
    clearErrors() {
        this.errors = [];
    }
    clearMetrics() {
        this.metrics = [];
    }
    clearAll() {
        this.clearErrors();
        this.clearMetrics();
    }
    // Utility methods for cache maintenance
    trimErrors() {
        if (this.errors.length > this.maxEntries) this.errors = this.errors.slice(-this.maxEntries);
    }
    trimMetrics() {
        if (this.metrics.length > this.maxEntries) this.metrics = this.metrics.slice(-this.maxEntries);
    }
    constructor(){
        this.errors = [];
        this.metrics = [];
        this.maxEntries = 1000 // Prevent unlimited growth
        ;
    }
}
// Export singleton instance
let $35f6a8a5ac0bf49c$var$earlyScriptObservabilityCache = null;
const $35f6a8a5ac0bf49c$export$50bbab1d25016c83 = ()=>{
    if (!$35f6a8a5ac0bf49c$var$earlyScriptObservabilityCache) $35f6a8a5ac0bf49c$var$earlyScriptObservabilityCache = new $35f6a8a5ac0bf49c$export$c22cddd926aebf66();
    return $35f6a8a5ac0bf49c$var$earlyScriptObservabilityCache;
};

});


parcelRegister("g0d52", function(module, exports) {

$parcel$export(module.exports, "setProjectIdMapping", () => $37a84eac697eeefb$export$ba6a56c6c4bc8990);
$parcel$export(module.exports, "getProjectIdFromMap", () => $37a84eac697eeefb$export$7c93669a4602f775);

var $gOPmF = parcelRequire("gOPmF");

var $1yxJh = parcelRequire("1yxJh");

// Singleton pattern for database initialization
let $37a84eac697eeefb$var$dbInstance = null;
// Cache for individual project ID lookups
const $37a84eac697eeefb$var$projectIdCache = new Map();
const $37a84eac697eeefb$export$28e7436902e0cf8b = ()=>{
    if (!globalThis.indexedDB) throw new Error('IndexedDB not supported');
    if ($37a84eac697eeefb$var$dbInstance) return $37a84eac697eeefb$var$dbInstance;
    $37a84eac697eeefb$var$dbInstance = new Promise((resolve, reject)=>{
        const request = indexedDB.open((0, $f2dff6c40ff99596$export$3c22ff8b64b8f565), (0, $f2dff6c40ff99596$export$6a9022b4c5fcea02));
        request.onerror = ()=>{
            // Reset the singleton on error so we can retry
            $37a84eac697eeefb$var$dbInstance = null;
            reject(request.error);
        };
        request.onsuccess = ()=>resolve(request.result);
        request.onupgradeneeded = (_event)=>{
            const db = request.result;
            if (!db.objectStoreNames.contains((0, $f2dff6c40ff99596$export$cd79d01fb3d2f506))) db.createObjectStore((0, $f2dff6c40ff99596$export$cd79d01fb3d2f506), {
                keyPath: 'projectKey'
            });
        };
    });
    return $37a84eac697eeefb$var$dbInstance;
};
/**
 * Get project ID mapping from IndexedDB
 */ const $37a84eac697eeefb$var$getProjectIdMappingFromStorage = async (operation)=>{
    try {
        const db = await $37a84eac697eeefb$export$28e7436902e0cf8b();
        const transaction = db.transaction([
            (0, $f2dff6c40ff99596$export$cd79d01fb3d2f506)
        ], 'readonly');
        const store = transaction.objectStore((0, $f2dff6c40ff99596$export$cd79d01fb3d2f506));
        const result = await Promise.race([
            new Promise((resolve)=>{
                const start = performance.now();
                const request = store.getAll();
                request.onsuccess = ()=>{
                    const records = request.result;
                    const mapping = {};
                    if (Array.isArray(records)) records.forEach((record)=>{
                        mapping[record.projectKey] = record.projectId;
                    });
                    resolve(mapping);
                    (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordMetric('custom', `get-project-id-mapping-from-indexdb-success-on-${operation}`, [
                        {
                            name: 'jpdApp'
                        },
                        {
                            name: 'earlyScript'
                        }
                    ], start, performance.now());
                };
                request.onerror = ()=>{
                    (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'IndexedDB getAll error');
                    resolve({});
                };
            }),
            new Promise((_, reject)=>setTimeout(()=>reject(new Error('IndexedDB read timed out')), (0, $f2dff6c40ff99596$export$c0c8fb0813dd1d2a)))
        ]);
        return result;
    } catch (error) {
        (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'Error getting projectId from IndexedDB', error instanceof Error ? error : new Error(String(error)));
        // do nothing
        return {};
    }
};
/**
 * Set project ID mapping in IndexedDB
 */ const $37a84eac697eeefb$var$setProjectIdMappingToStorage = async (mapping)=>{
    try {
        const start = performance.now();
        const db = await $37a84eac697eeefb$export$28e7436902e0cf8b();
        const transaction = db.transaction([
            (0, $f2dff6c40ff99596$export$cd79d01fb3d2f506)
        ], 'readwrite');
        const store = transaction.objectStore((0, $f2dff6c40ff99596$export$cd79d01fb3d2f506));
        // Clear existing data
        await new Promise((resolve, reject)=>{
            const clearRequest = store.clear();
            clearRequest.onsuccess = ()=>resolve();
            clearRequest.onerror = ()=>{
                (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'IndexedDB clear error');
                reject(clearRequest.error);
            };
        });
        // Add new data
        const promises = Object.entries(mapping).map(([projectKey, projectId])=>{
            return new Promise((resolve, reject)=>{
                const addRequest = store.add({
                    projectKey: projectKey,
                    projectId: projectId
                });
                addRequest.onsuccess = ()=>resolve();
                addRequest.onerror = ()=>{
                    (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'IndexedDB add error');
                    reject(addRequest.error);
                };
            });
        });
        await Promise.all(promises);
        (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordMetric('custom', 'set-project-id-mapping-to-indexdb', [
            {
                name: 'jpdApp'
            },
            {
                name: 'earlyScript'
            }
        ], start, performance.now());
    } catch (error) {
        (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.project-id-mapping.indexdb', 'Error setting projectId in IndexedDB', error instanceof Error ? error : new Error(String(error)));
    }
};
const $37a84eac697eeefb$export$7c2e93c291d763b0 = async (projectKey)=>{
    const start = performance.now();
    const mapping = await $37a84eac697eeefb$var$getProjectIdMappingFromStorage('read');
    (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordMetric('custom', 'get-project-id-from-map', [
        {
            name: 'jpdApp'
        },
        {
            name: 'earlyScript'
        }
    ], start, performance.now());
    return mapping[projectKey] || null;
};
const $37a84eac697eeefb$export$ba6a56c6c4bc8990 = async (projectKey, projectId)=>{
    const start = performance.now();
    const mapping = await $37a84eac697eeefb$var$getProjectIdMappingFromStorage('write');
    // Check if the mapping already exists with the same value
    if (mapping?.[projectKey] === projectId) // Mapping already exists with the correct value, no need to update
    return;
    mapping[projectKey] = projectId;
    await $37a84eac697eeefb$var$setProjectIdMappingToStorage(mapping);
    (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordMetric('custom', 'set-project-id-mapping', [
        {
            name: 'jpdApp'
        },
        {
            name: 'earlyScript'
        }
    ], start, performance.now());
};
const $37a84eac697eeefb$export$7c93669a4602f775 = async (projectKey, waitForGlobalVariable)=>{
    // Check cache first
    const cached = $37a84eac697eeefb$var$projectIdCache.get(projectKey);
    if (cached && Date.now() < cached.expiry) return cached.promise;
    const createPromise = async ()=>{
        // First, try to get from mapping
        const mappedProjectId = await $37a84eac697eeefb$export$7c2e93c291d763b0(projectKey);
        if (mappedProjectId !== null) return mappedProjectId;
        // If not in mapping, wait for SPA_STATE and extract projectId
        try {
            await waitForGlobalVariable('SPA_STATE');
            const projectId = (0, $gOPmF.getProjectIdFromSpaState)(projectKey);
            if (projectId) return projectId;
        } catch (error) {
            (0, $1yxJh.getEarlyScriptObservabilityCache)()?.recordError('polaris.early-fetch-cache.wait-for-global-variable', 'Error getting projectId from SPA_STATE', error instanceof Error ? error : new Error(String(error)));
        }
        return null;
    };
    const promise = createPromise();
    // Cache the promise
    $37a84eac697eeefb$var$projectIdCache.set(projectKey, {
        promise: promise,
        expiry: Date.now() + (0, $f2dff6c40ff99596$export$eca93c456abcab01)
    });
    return promise;
};

});
parcelRegister("gOPmF", function(module, exports) {

$parcel$export(module.exports, "getProjectIdFromSpaState", () => $ecd613e58efc2273$export$769767595ecc1f62);
const $ecd613e58efc2273$export$769767595ecc1f62 = (projectKey)=>{
    return globalThis?.window?.SPA_STATE?.PROJECT_CONTEXT?.[projectKey]?.data?.projectId;
};

});

const $f2dff6c40ff99596$export$3c22ff8b64b8f565 = 'jpd-store';
const $f2dff6c40ff99596$export$6a9022b4c5fcea02 = 1;
const $f2dff6c40ff99596$export$cd79d01fb3d2f506 = 'project-key-to-id-mapping';
const $f2dff6c40ff99596$export$c0c8fb0813dd1d2a = 1000;
const $f2dff6c40ff99596$export$eca93c456abcab01 = 5000;


parcelRegister("j874X", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyFromLocation", () => $c3da0a2c67910d6d$export$60093b596b9566ef);
$parcel$export(module.exports, "getViewIdFromLocation", () => $c3da0a2c67910d6d$export$9ba58cbeffd45843);
$parcel$export(module.exports, "getIssueKeyFromLocation", () => $c3da0a2c67910d6d$export$a12d8f0ecf6910fc);
/**
 * Extracts project key from the URL path
 * Pattern matches: /jira/polaris/projects/{projectKey}/...
 * @param location The location object to extract from
 * @returns The project key if found, null otherwise
 */ const $c3da0a2c67910d6d$export$60093b596b9566ef = (location)=>{
    // Handle empty or invalid location
    if (!location || !location.pathname) return null;
    // Get the pathname and remove trailing slash if present
    let pathname = location.pathname;
    if (pathname.endsWith('/') && pathname.length > 1) pathname = pathname.slice(0, -1);
    // Simple regex to extract projectKey from polaris ideas URLs
    // Pattern matches: /jira/polaris/projects/{projectKey}/ideas/...
    const regex = /\/jira\/polaris\/projects\/([^/]+)\/ideas/;
    const match = pathname.match(regex);
    // Return projectKey if found, otherwise null
    return match ? match[1] : null;
};
const $c3da0a2c67910d6d$export$9ba58cbeffd45843 = (location)=>{
    // Handle empty or invalid location
    if (!location || !location.pathname) return null;
    // Get the pathname and remove trailing slash if present
    let pathname = location.pathname;
    if (pathname.endsWith('/') && pathname.length > 1) pathname = pathname.slice(0, -1);
    // Simple regex to extract viewId from polaris ideas view URLs
    // Pattern matches: /jira/polaris/projects/{projectKey}/ideas/view/{viewId}
    const regex = /\/jira\/polaris\/projects\/[^/]+\/ideas\/view\/([^/]+)/;
    const match = pathname.match(regex);
    // Return viewId if found, otherwise null
    return match ? match[1] : null;
};
function $c3da0a2c67910d6d$export$a12d8f0ecf6910fc(location) {
    if (location.search) {
        const params = new URLSearchParams(location.search);
        return params.get('selectedIssue');
    }
    return null;
}

});

parcelRegister("8NIsa", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesForProjectsUrl", () => $a4c680338f40ee9f$export$683fd3ef7e0e9232);
const $a4c680338f40ee9f$export$683fd3ef7e0e9232 = (projectIds)=>{
    const queryParams = new URLSearchParams();
    projectIds.forEach((projectId)=>{
        queryParams.append('projectId', projectId);
    });
    const operationParam = '&operation=GetIssueTypesForProjects';
    return `/rest/polaris/v2/project/settings/issuetype?${queryParams.toString()}${operationParam}`;
};

});



parcelRegister("Ph10w", function(module, exports) {

$parcel$export(module.exports, "transformIssueTypeResponse", () => $8fccbebb38f7071e$export$724e01f0c9c0f809);
$parcel$export(module.exports, "isUpdatingRemovedIssueTypeError", () => $8fccbebb38f7071e$export$57621b943c7aa3fd);

var $1uIew = parcelRequire("1uIew");

var $7jTnu = parcelRequire("7jTnu");
const $8fccbebb38f7071e$export$724e01f0c9c0f809 = (rest)=>({
        id: String(rest.id),
        name: rest.name,
        entityId: rest.entityId,
        description: rest.description,
        avatarId: String(rest.avatarId),
        hierarchyLevel: rest.hierarchyLevel,
        operation: {
            deletable: rest.operation.deletable,
            editable: rest.operation.editable
        },
        pinnedFields: (0, $7jTnu.fg)('jpd-types-pinned-fields') ? rest.pinnedFields : undefined
    });
const $8fccbebb38f7071e$export$57621b943c7aa3fd = (errorObject)=>errorObject instanceof (0, $1uIew.default) && errorObject.statusCode === 412;

});


parcelRegister("ivbVl", function(module, exports) {

$parcel$export(module.exports, "updatePinnedFields", () => $ae587a918215b093$export$dcb231762343ac0c);
$parcel$export(module.exports, "togglePinnedField", () => $ae587a918215b093$export$81a81e7b93f7de83);

var $6Yd06 = parcelRequire("6Yd06");

var $b5oGV = parcelRequire("b5oGV");

var $8KUFq = parcelRequire("8KUFq");

var $fVlmn = parcelRequire("fVlmn");

var $atxCj = parcelRequire("atxCj");
const $ae587a918215b093$export$dcb231762343ac0c = ({ issueTypeId: issueTypeId, pinnedFields: pinnedFields })=>async ({ setState: setState, getState: getState })=>{
        (0, $b5oGV.experience).issueTypes.issueTypePinnedFieldsUpdate.start();
        const state = getState();
        try {
            const issueType = state.issueTypesById[issueTypeId];
            const projectId = Object.keys(state.issueTypesByProjectId).find((id)=>state.issueTypesByProjectId[id]?.includes(issueTypeId));
            if (!issueType) throw new Error(`Issue type with ID ${issueTypeId} not found`);
            if (!projectId) throw new Error(`Project ID for issue type ${issueTypeId} not found`);
            setState({
                issueTypesById: {
                    ...state.issueTypesById,
                    [issueTypeId]: {
                        ...issueType,
                        pinnedFields: pinnedFields
                    }
                }
            });
            await (0, $atxCj.performUpdatePinnedFields)({
                projectId: projectId,
                issueTypeId: issueTypeId,
                pinnedFields: pinnedFields
            });
        } catch (maybeError) {
            // revert optimistic update
            setState(state);
            const error = maybeError instanceof Error ? maybeError : new Error('Error while updating pinned fields');
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isNotFoundError)(error)) (0, $b5oGV.experience).issueTypes.issueTypePinnedFieldsUpdate.abort();
            else (0, $b5oGV.experience).issueTypes.issueTypePinnedFieldsUpdate.failure(error);
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.update-pinned-field', 'Failed to update pinned fields', error);
            throw error;
        }
    };
const $ae587a918215b093$export$81a81e7b93f7de83 = ({ issueTypeId: issueTypeId, fieldKey: fieldKey })=>async ({ getState: getState, dispatch: dispatch })=>{
        const state = getState();
        const pinnedFields = state.issueTypesById[issueTypeId]?.pinnedFields ?? [];
        const isPinned = pinnedFields.includes(fieldKey);
        const updatedPinnedFields = isPinned ? pinnedFields.filter((key)=>key !== fieldKey) : [
            ...pinnedFields,
            fieldKey
        ];
        await dispatch($ae587a918215b093$export$dcb231762343ac0c({
            issueTypeId: issueTypeId,
            pinnedFields: updatedPinnedFields
        }));
    };

});
parcelRegister("atxCj", function(module, exports) {

$parcel$export(module.exports, "performUpdatePinnedFields", () => $50aafb682d6c459a$export$1131639a53d9c2dc);

var $jGzN3 = parcelRequire("jGzN3");
const $50aafb682d6c459a$export$1131639a53d9c2dc = ({ projectId: projectId, issueTypeId: issueTypeId, pinnedFields: pinnedFields })=>(0, $jGzN3.performPutRequest)(`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}/pinned-fields`, {
        body: JSON.stringify({
            pinnedFields: pinnedFields
        })
    });

});


parcelRegister("65Jhr", function(module, exports) {

$parcel$export(module.exports, "populateIssueTypes", () => $ebb47daedd3d2041$export$f3fcdeef00a622aa);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $ebb47daedd3d2041$export$f3fcdeef00a622aa = ({ issueTypes: issueTypes })=>async ({ setState: setState })=>{
        const issueTypesById = {};
        const issueTypesByProjectId = {};
        issueTypes.forEach((issueType)=>{
            issueTypesById[issueType.id] = issueType;
            if (!issueTypesByProjectId[issueType.projectId]) issueTypesByProjectId[issueType.projectId] = [];
            issueTypesByProjectId[issueType.projectId].push(issueType.id);
        });
        setState({
            issueTypesById: issueTypesById,
            issueTypesByProjectId: issueTypesByProjectId
        });
    };

});

parcelRegister("5wIhK", function(module, exports) {

$parcel$export(module.exports, "updateIssueType", () => $7a5686feaa171288$export$7c611e2970463da4);

var $6Yd06 = parcelRequire("6Yd06");

var $b5oGV = parcelRequire("b5oGV");

var $8KUFq = parcelRequire("8KUFq");

var $fVlmn = parcelRequire("fVlmn");

var $3vphk = parcelRequire("3vphk");

var $Ph10w = parcelRequire("Ph10w");
const $7a5686feaa171288$export$7c611e2970463da4 = (issueTypeId, projectId, update)=>async ({ setState: setState, getState: getState })=>{
        (0, $b5oGV.experience).issueTypes.issueTypeUpdate.start();
        const state = getState();
        const currentIssueType = state.issueTypesById[issueTypeId];
        if (!currentIssueType) return;
        setState({
            issueTypesById: {
                ...state.issueTypesById,
                [issueTypeId]: {
                    ...currentIssueType,
                    ...update
                }
            }
        });
        try {
            await (0, $3vphk.performUpdateIssueType)(issueTypeId, projectId, {
                name: update.name,
                description: update.description,
                avatarId: Number(update.avatarId)
            });
            (0, $b5oGV.experience).issueTypes.issueTypeUpdate.success();
        } catch (maybeError) {
            const error = maybeError instanceof Error ? maybeError : new Error('Error while updating issue type');
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isConflictError)(error) || (0, $Ph10w.isUpdatingRemovedIssueTypeError)(error)) (0, $b5oGV.experience).issueTypes.issueTypeUpdate.abort();
            else (0, $b5oGV.experience).issueTypes.issueTypeUpdate.failure(error);
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue-types.actions.update-issue-type', 'Failed to update issue type', error);
            setState(state);
            throw error;
        }
    };

});
parcelRegister("3vphk", function(module, exports) {

$parcel$export(module.exports, "performUpdateIssueType", () => $d5b861ab786dde4d$export$8faf8e16b0bcf0b3);

var $jGzN3 = parcelRequire("jGzN3");
const $d5b861ab786dde4d$export$8faf8e16b0bcf0b3 = (issueTypeId, projectId, update)=>{
    return (0, $jGzN3.performPutRequest)(`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}`, {
        body: JSON.stringify(update)
    });
};

});




parcelRegister("3Jfcg", function(module, exports) {

$parcel$export(module.exports, "useActions", () => $40345c2e71c9a3a1$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useEnvironmentContainer", () => $40345c2e71c9a3a1$export$e56db71314b509dc);
$parcel$export(module.exports, "useEnvironmentContainerId", () => $40345c2e71c9a3a1$export$344f61c54a71a2e2);
$parcel$export(module.exports, "useContainerAri", () => $40345c2e71c9a3a1$export$fa482684d80284db);
$parcel$export(module.exports, "useHasEnvironmentContainerError", () => $40345c2e71c9a3a1$export$63896abf8138b626);
$parcel$export(module.exports, "useIsEnvironmentContainerAvailable", () => $40345c2e71c9a3a1$export$a3cb3b3ca4401bed);

var $gtr2v = parcelRequire("gtr2v");

var $lvKO5 = parcelRequire("lvKO5");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9XFdQ = parcelRequire("9XFdQ");
const $40345c2e71c9a3a1$var$initialState = {
    loading: true,
    data: undefined,
    error: undefined
};
const $40345c2e71c9a3a1$var$Store = (0, $GtRbT.createStore)({
    initialState: $40345c2e71c9a3a1$var$initialState,
    actions: {
        setLoading: (loading)=>({ setState: setState })=>{
                setState({
                    loading: loading
                });
            },
        setError: (error)=>({ setState: setState })=>{
                setState({
                    error: error
                });
            },
        setData: (data)=>({ setState: setState })=>{
                setState({
                    data: data
                });
            },
        setProjectIdForView: (projectId)=>({ setState: setState, getState: getState })=>{
                const data = getState().data;
                if (data?.type === (0, $9XFdQ.PolarisEnvironmentContainerTypes).VIEW) setState({
                    data: {
                        ...data,
                        projectId: projectId
                    }
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState($40345c2e71c9a3a1$var$initialState);
            }
    },
    name: 'jpd-environment-datacontainer'
});
const $40345c2e71c9a3a1$export$bc923229a7fa61e7 = (0, $iJq0l.createActionsHook)($40345c2e71c9a3a1$var$Store);
const $40345c2e71c9a3a1$export$e56db71314b509dc = (0, $iJq0l.createStateHook)($40345c2e71c9a3a1$var$Store, {
    selector: (state)=>state.data
});
const $40345c2e71c9a3a1$export$344f61c54a71a2e2 = (0, $iJq0l.createStateHook)($40345c2e71c9a3a1$var$Store, {
    selector: (state)=>state.data?.id
});
const $40345c2e71c9a3a1$export$fa482684d80284db = ()=>{
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const container = $40345c2e71c9a3a1$export$e56db71314b509dc();
    const createARI = (resourceType, resourceId)=>(0, $gtr2v.AnyAri).create({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: resourceType,
            resourceId: resourceId
        }).toString();
    switch(container?.type){
        case (0, $9XFdQ.PolarisEnvironmentContainerTypes).PROJECT:
            return container.projectAri.toString();
        case (0, $9XFdQ.PolarisEnvironmentContainerTypes).COLLECTION:
            return createARI('collection', container.collectionId);
        case (0, $9XFdQ.PolarisEnvironmentContainerTypes).VIEW:
            return createARI('view', container.viewId);
        default:
            return '';
    }
};
const $40345c2e71c9a3a1$export$63896abf8138b626 = (0, $iJq0l.createStateHook)($40345c2e71c9a3a1$var$Store, {
    selector: (state)=>!state.loading && (state.error || !state.data)
});
const $40345c2e71c9a3a1$export$a3cb3b3ca4401bed = (0, $iJq0l.createStateHook)($40345c2e71c9a3a1$var$Store, {
    selector: (state, containerType)=>{
        if (containerType) return !state.loading && state.data !== undefined && state.data.type === containerType;
        return !state.loading && state.data !== undefined;
    }
});

});
parcelRegister("9XFdQ", function(module, exports) {

$parcel$export(module.exports, "PolarisEnvironmentContainerTypes", () => $3f09eaff1df355bd$export$11730091c497ed31);
const $3f09eaff1df355bd$export$11730091c497ed31 = {
    PROJECT: 'PROJECT',
    VIEW: 'VIEW',
    COLLECTION: 'COLLECTION'
};

});


parcelRegister("hQR6K", function(module, exports) {

$parcel$export(module.exports, "FieldStore", () => $82058c3b4c11a1c4$export$4ad445d34451ebf6);
$parcel$export(module.exports, "useFieldActions", () => $82058c3b4c11a1c4$export$e8302bcaff9f6eae);
$parcel$export(module.exports, "createFieldHook", () => $82058c3b4c11a1c4$export$4cddd3725060adbc);
$parcel$export(module.exports, "createHigherLevelFieldHook", () => $82058c3b4c11a1c4$export$67d6a9af20f2969f);
$parcel$export(module.exports, "FieldContainer", () => $82058c3b4c11a1c4$export$b5c4b0e7cd7f148b);

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $k4JXX = parcelRequire("k4JXX");

var $gKi1P = parcelRequire("gKi1P");

var $3iP9N = parcelRequire("3iP9N");

var $6ANnh = parcelRequire("6ANnh");
const $82058c3b4c11a1c4$var$initialState = {
    meta: {
        initialized: false,
        loading: false,
        loadingSnippetProviders: false,
        error: undefined,
        loadingProps: undefined,
        projectIsNotOnboardedError: false,
        scheduleFieldsReload: false,
        connectionsLoadingFieldsAssociations: []
    },
    fields: {},
    fieldValueDecorations: {},
    snippetProviders: undefined,
    highlightedFields: [],
    containerProps: undefined,
    throttledFetchSnippetProviders: undefined,
    newlyAddedGlobalFields: [],
    connectionsFieldsAssociations: {}
};
const $82058c3b4c11a1c4$export$4ad445d34451ebf6 = (0, $jxALV.createPolarisStore)({
    initialState: $82058c3b4c11a1c4$var$initialState,
    actions: $gKi1P.actions,
    name: 'PolarisFieldStore'
});
const { Container: $82058c3b4c11a1c4$var$Container, useActions: $82058c3b4c11a1c4$var$useActions, createHook: $82058c3b4c11a1c4$var$createHook, createHigherLevelHook: $82058c3b4c11a1c4$var$createHigherLevelHook } = (0, $YvHeB.createJpdContainer)($82058c3b4c11a1c4$export$4ad445d34451ebf6, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $3iP9N.loadFields)());
            dispatch((0, $k4JXX.throttledFetchSnippetProviders)());
        },
    onUpdate: ()=>({ dispatch: dispatch, getState: getState }, props)=>{
            const { prevContainerProps: prevContainerProps } = getState();
            if (prevContainerProps?.issueTypeIds && props.issueTypeIds !== prevContainerProps.issueTypeIds) dispatch((0, $6ANnh.syncFieldsIssueTypes)());
            dispatch((0, $3iP9N.loadFields)());
            dispatch((0, $k4JXX.throttledFetchSnippetProviders)());
        }
});
const $82058c3b4c11a1c4$export$e8302bcaff9f6eae = $82058c3b4c11a1c4$var$useActions;
const $82058c3b4c11a1c4$export$4cddd3725060adbc = $82058c3b4c11a1c4$var$createHook;
const $82058c3b4c11a1c4$export$67d6a9af20f2969f = $82058c3b4c11a1c4$var$createHigherLevelHook;
const $82058c3b4c11a1c4$export$b5c4b0e7cd7f148b = $82058c3b4c11a1c4$var$Container;

});
parcelRegister("YvHeB", function(module, exports) {

$parcel$export(module.exports, "createJpdContainer", () => $7499141d40d19115$export$7ed5db99dcc39128);

var $5PQOA = parcelRequire("5PQOA");

var $3degy = parcelRequire("3degy");

var $iJq0l = parcelRequire("iJq0l");

var $9bKio = parcelRequire("9bKio");
const $7499141d40d19115$var$createSelectorHook = (store, selector)=>{
    const innerHook = (0, $iJq0l.createHook)(store, {
        selector: (state)=>selector(state, state.containerProps)
    });
    return ()=>{
        const [val] = innerHook();
        return val;
    };
};
const $7499141d40d19115$export$757252247e722815 = (store, selectorCreator)=>{
    // TODO POL-2195 memoize one is not suitable for this task, as it will only memoize the last invocation. while this
    //               improves subsequent calls with the same argument set, it does not improve calls with different args
    //               this case should be solved with a generic memoization lib, e.g. reselect (4.1+) or moize
    //               discussion: https://hello.atlassian.net/wiki/spaces/TGR/pages/1416371989/Dependency+review+moize
    const memoizedSelectorCreator = (0, $3degy.cacheSelectorCreator)(selectorCreator);
    // TODO POL-2195 in the meantime, we can use lodash/memoize to at least solve the 1-ary case,
    //               which should be 99% of our selector creators anyway
    const monadicSelectorCreatorMemoized = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))(selectorCreator);
    const rssHook = (0, $iJq0l.createHook)(store, {
        selector: (state, args)=>{
            if (args.length <= 1) return monadicSelectorCreatorMemoized(...args)(state, state.containerProps);
            return memoizedSelectorCreator(...args)(state, state.containerProps);
        }
    });
    return (...args)=>{
        // @ts-expect-error - TS2345 - Argument of type 'SelectorCreatorArgs' is not assignable to parameter
        const [val] = rssHook(args);
        return val;
    };
};
const $7499141d40d19115$export$7ed5db99dcc39128 = (store, options)=>{
    const Container = (0, $9bKio.createContainerWithContext)(store, options);
    const useEmptyState = (0, $iJq0l.createHook)(store, {
        selector: null
    });
    const useActions = ()=>{
        const [, actions] = useEmptyState();
        return actions;
    };
    return {
        createHook: (selector)=>$7499141d40d19115$var$createSelectorHook(store, selector),
        createHigherLevelHook: (selectorCreator)=>$7499141d40d19115$export$757252247e722815(store, selectorCreator),
        useActions: useActions,
        Container: Container
    };
};

});
parcelRegister("3degy", function(module, exports) {

$parcel$export(module.exports, "cacheSelectorCreator", () => $5efa69f054078620$export$413433974f0869c3);
$parcel$export(module.exports, "getCacheValue", () => $5efa69f054078620$export$e15acfbd8ab989dd);
let $5efa69f054078620$var$cache = new WeakMap();
let $5efa69f054078620$var$jsonEqualityMap = new WeakMap();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5efa69f054078620$var$getValueFromJsonEqualityCache = (f, value, options)=>{
    if (options?.useJsonEquality !== true) return value;
    if (!$5efa69f054078620$var$jsonEqualityMap.has(f)) $5efa69f054078620$var$jsonEqualityMap.set(f, new Map());
    const storage = $5efa69f054078620$var$jsonEqualityMap.get(f);
    try {
        const key = JSON.stringify(value);
        if (storage.has(key)) return storage.get(key);
        storage.set(key, value);
    } catch  {
    // do nothing
    }
    return value;
};
function $5efa69f054078620$export$413433974f0869c3(f, options) {
    if (f.__isCachedSelectorCreator === true) return f;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cacheFunction = (...args)=>{
        if ($5efa69f054078620$var$cache.has(f)) {
            let lastNode = $5efa69f054078620$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $5efa69f054078620$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) {
                    lastNode = null;
                    break;
                }
                lastNode = lastNode.args.get(value);
            }
            if (lastNode?.selector) return lastNode.selector;
        }
        const maybeSelector = f(...args);
        if (typeof maybeSelector?.resultFunc === 'function' || typeof maybeSelector === 'function') {
            if (!$5efa69f054078620$var$cache.has(f)) $5efa69f054078620$var$cache.set(f, {
                args: new Map(),
                selector: null
            });
            let lastNode = $5efa69f054078620$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $5efa69f054078620$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) lastNode.args.set(value, {
                    args: new Map(),
                    selector: null
                });
                lastNode = lastNode.args.get(value);
            }
            lastNode.selector = maybeSelector;
        }
        return maybeSelector;
    };
    cacheFunction.__isCachedSelectorCreator = true;
    cacheFunction.__origin = f;
    cacheFunction.displayName = f.name || f.displayName;
    return cacheFunction;
}
const $5efa69f054078620$export$e2575ed62a2f107b = ()=>$5efa69f054078620$var$cache;
const $5efa69f054078620$export$e15acfbd8ab989dd = (key)=>$5efa69f054078620$var$cache.get(key);
const $5efa69f054078620$export$6e5dca841bdf93e3 = ()=>{
    $5efa69f054078620$var$cache = new WeakMap();
    $5efa69f054078620$var$jsonEqualityMap = new WeakMap();
};

});

parcelRegister("9bKio", function(module, exports) {

$parcel$export(module.exports, "createContainerWithContext", () => $5c9c76096353f4fd$export$ce6d80db779db7dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");

var $kBbPj = parcelRequire("kBbPj");
const $5c9c76096353f4fd$export$ce6d80db779db7dc = (store, options)=>(0, $6E16M.createContainer)(store, {
        ...options,
        onInit: ()=>(api, containerProps)=>{
                (0, $kBbPj.batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props
                    });
                    options?.onInit && dispatch(options.onInit());
                })(api, containerProps);
            },
        onUpdate: ()=>(api, containerProps)=>{
                (0, $kBbPj.batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                    const prevContainerProps = getState().containerProps;
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props,
                        prevContainerProps: prevContainerProps
                    });
                    options?.onUpdate && dispatch(options.onUpdate());
                })(api, containerProps);
            }
    });

});
parcelRegister("kBbPj", function(module, exports) {

$parcel$export(module.exports, "batchStateUpdates", () => $bb22704e5822629d$export$4f8b20404a906ca3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $bb22704e5822629d$export$4f8b20404a906ca3 = (cb)=>(api, containerProps)=>{
        let finalized = false;
        let localState = api.getState();
        const setState = (newState)=>{
            if (finalized) {
                api.setState(newState);
                return;
            }
            localState = {
                ...localState,
                ...newState
            };
        };
        const getState = ()=>finalized ? api.getState() : localState;
        const dispatch = (action)=>finalized ? action(api, containerProps) : action({
                dispatch: dispatch,
                setState: setState,
                getState: getState
            }, containerProps);
        const patchedApi = {
            setState: setState,
            getState: getState,
            dispatch: dispatch
        };
        cb(patchedApi, containerProps);
        finalized = true;
        api.setState({
            ...localState
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        localState = null;
    };

});



parcelRegister("jxALV", function(module, exports) {

$parcel$export(module.exports, "createPolarisStore", () => $ebab0452a2995ce1$export$425650453fa3c52a);

var $huH03 = parcelRequire("huH03");

var $GtRbT = parcelRequire("GtRbT");
const $ebab0452a2995ce1$export$425650453fa3c52a = ({ initialState: initialState, actions: actions, name: name })=>{
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const wrappedActions = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(actions, (actionCreator)=>(...args)=>{
            try {
                const actionFct = actionCreator(...args);
                return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
                storeAction, props)=>{
                    try {
                        return actionFct(storeAction, props);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        props.onActionFailed(error);
                        throw error;
                    }
                };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
                storeAction, props)=>{
                    props.onActionFailed(error);
                    throw error;
                };
            }
        });
    return (0, $GtRbT.createStore)({
        initialState: initialState,
        actions: wrappedActions,
        name: name
    });
};

});

parcelRegister("k4JXX", function(module, exports) {

$parcel$export(module.exports, "throttledFetchSnippetProviders", () => $fd3c2b7e87e16875$export$b6b23958a0786a81);
$parcel$export(module.exports, "fetchArchivedSnippetProviders", () => $fd3c2b7e87e16875$export$72d2ece9b5657d07);

var $9g7yh = parcelRequire("9g7yh");

var $6DCNy = parcelRequire("6DCNy");
const $fd3c2b7e87e16875$var$fetchSnippetProvidersInternal = (refetch, archivedOnly)=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { onFieldLoadingFailed: onFieldLoadingFailed, fieldRemote: fieldRemote, containerAri: containerAri })=>{
        if (containerAri === undefined) return;
        if (getState().meta.loadingSnippetProviders === true && !archivedOnly) return;
        if (getState().snippetProviders !== undefined && !refetch && !archivedOnly) return;
        try {
            if (getState().throttledFetchSnippetProviders === undefined && !archivedOnly) {
                setState({
                    throttledFetchSnippetProviders: (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((rf, onlyArchived)=>{
                        dispatch($fd3c2b7e87e16875$var$fetchSnippetProvidersInternal(rf, onlyArchived));
                    }, 60000, {
                        trailing: false,
                        leading: true
                    })
                });
                dispatch($fd3c2b7e87e16875$export$b6b23958a0786a81(refetch));
                return;
            }
            if (!archivedOnly) setState({
                meta: {
                    ...getState().meta,
                    loadingSnippetProviders: true
                }
            });
            const archivedMode = archivedOnly ? 'ARCHIVED_ONLY' : 'ACTIVE_ONLY';
            const snippetProviders = await fieldRemote.fetchSnippetProviders(archivedMode);
            const existingSnippetProviders = getState().snippetProviders || [];
            const snippetProvidersById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(snippetProviders, 'id');
            existingSnippetProviders.map((snippetProvider)=>{
                if (snippetProvidersById[snippetProvider.id]) {
                    delete snippetProvidersById[snippetProvider.id];
                    return snippetProvidersById[snippetProvider.id];
                }
                return snippetProvidersById;
            });
            setState({
                snippetProviders: [
                    ...existingSnippetProviders,
                    ...Object.values(snippetProvidersById)
                ],
                meta: {
                    ...getState().meta,
                    loadingSnippetProviders: false
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setState({
                meta: {
                    ...getState().meta,
                    loadingSnippetProviders: false
                }
            });
            onFieldLoadingFailed(e);
        }
    };
const $fd3c2b7e87e16875$export$72d2ece9b5657d07 = ()=>async ({ dispatch: dispatch })=>{
        dispatch($fd3c2b7e87e16875$var$fetchSnippetProvidersInternal(false, true));
    };
const $fd3c2b7e87e16875$export$b6b23958a0786a81 = (refetch = false)=>async ({ getState: getState, dispatch: dispatch })=>{
        if (getState().throttledFetchSnippetProviders === undefined) {
            dispatch($fd3c2b7e87e16875$var$fetchSnippetProvidersInternal(refetch, false));
            return;
        }
        getState().throttledFetchSnippetProviders?.(refetch, false);
    };

});

parcelRegister("gKi1P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $16b57e3db40e4598$export$e324594224ef24da);

var $gfCeR = parcelRequire("gfCeR");

var $aTipJ = parcelRequire("aTipJ");

var $2k5D4 = parcelRequire("2k5D4");

var $3gu89 = parcelRequire("3gu89");

var $1XYZv = parcelRequire("1XYZv");

var $e2a0f = parcelRequire("e2a0f");

var $k4JXX = parcelRequire("k4JXX");

var $4VXAA = parcelRequire("4VXAA");

var $hZEtq = parcelRequire("hZEtq");

var $khyGs = parcelRequire("khyGs");

var $28IiO = parcelRequire("28IiO");

var $3iP9N = parcelRequire("3iP9N");

var $4D6DW = parcelRequire("4D6DW");

var $izS0k = parcelRequire("izS0k");

var $22Ip8 = parcelRequire("22Ip8");

var $7vrjT = parcelRequire("7vrjT");

var $attZ8 = parcelRequire("attZ8");

var $1E7II = parcelRequire("1E7II");

var $2U7AD = parcelRequire("2U7AD");

var $hcoNB = parcelRequire("hcoNB");

var $3GhfL = parcelRequire("3GhfL");

var $1Pjrd = parcelRequire("1Pjrd");

var $jyyuH = parcelRequire("jyyuH");

var $6ANnh = parcelRequire("6ANnh");

var $5LMfW = parcelRequire("5LMfW");

var $lRsv0 = parcelRequire("lRsv0");

var $2MIG4 = parcelRequire("2MIG4");

var $9XY3j = parcelRequire("9XY3j");

var $4betO = parcelRequire("4betO");

var $h0KXW = parcelRequire("h0KXW");

var $ldzeh = parcelRequire("ldzeh");

var $89HFt = parcelRequire("89HFt");

var $fOkFa = parcelRequire("fOkFa");
const $16b57e3db40e4598$export$e324594224ef24da = {
    addOption: $attZ8.addOption,
    createCalculatedField: $aTipJ.createCalculatedField,
    createField: $aTipJ.createField,
    createPlayField: $aTipJ.createPlayField,
    createConnectionField: $aTipJ.createConnectionField,
    createValueDecoration: $2k5D4.createValueDecoration,
    createValueDecorationBulk: $2k5D4.createValueDecorationBulk,
    deleteField: $e2a0f.deleteField,
    deleteFieldLocally: $e2a0f.deleteFieldLocally,
    deleteOption: $1E7II.deleteOption,
    deleteValueDecoration: $3gu89.deleteValueDecoration,
    deleteAllValueDecorations: $3gu89.deleteAllValueDecorations,
    throttledFetchSnippetProviders: $k4JXX.throttledFetchSnippetProviders,
    fetchArchivedSnippetProviders: $k4JXX.fetchArchivedSnippetProviders,
    loadFields: $3iP9N.loadFields,
    loadSelectedFields: $22Ip8.loadSelectedFields,
    rankOptions: $2U7AD.rankOptions,
    renameOption: $hcoNB.renameOption,
    updateFieldFormula: $4betO.updateFieldFormula,
    updateDeliveryFieldPresentation: $lRsv0.updateDeliveryFieldPresentation,
    updateDescription: $2MIG4.updateDescription,
    updateEmoji: $9XY3j.updateEmoji,
    updateFieldOptionWeight: $jyyuH.updateFieldOptionWeight,
    updateFieldOptionWeightType: $1Pjrd.updateFieldOptionWeightType,
    updateFieldOptionAutoFormattingDisabled: $3GhfL.updateFieldOptionAutoFormattingDisabled,
    updateLabel: $h0KXW.updateLabel,
    updateValueDecoration: $1XYZv.updateValueDecoration,
    updatePlayFieldParameters: $aTipJ.updatePlayFieldParameters,
    updatePlayField: $ldzeh.updatePlayField,
    updateUserFieldDisplayMode: $fOkFa.updateUserFieldDisplayMode,
    updateIntervalFieldSource: $28IiO.updateIntervalFieldSource,
    updateDeliveryDateSelectedField: $khyGs.updateDeliveryDateSelectedField,
    updateDeliveryDateAggregationType: $hZEtq.updateDeliveryDateAggregationType,
    updateSystemFieldHidden: $89HFt.updateSystemFieldHidden,
    associateGlobalFields: $gfCeR.associateGlobalFields,
    setNewlyAddedGlobalFields: $7vrjT.setNewlyAddedGlobalFields,
    resetNewlyAddedGlobalFields: $7vrjT.resetNewlyAddedGlobalFields,
    setHighlightedFields: $4VXAA.setHighlightedFields,
    resetHighlightedFields: $4VXAA.resetHighlightedFields,
    loadGlobalLabels: $izS0k.loadGlobalLabels,
    updateConnectionFieldFilter: $5LMfW.updateConnectionFieldFilter,
    updateConnectionFieldIssueViewLayout: $5LMfW.updateConnectionFieldIssueViewLayout,
    syncFieldsIssueTypes: $6ANnh.syncFieldsIssueTypes,
    loadGlobalFieldsAssociations: $4D6DW.loadGlobalFieldsAssociations
};

});
parcelRegister("gfCeR", function(module, exports) {

$parcel$export(module.exports, "associateGlobalFields", () => $6bb0ceebd75f6adb$export$9d121f7dfa52c35a);

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $gCeeo = parcelRequire("gCeeo");

var $22Ip8 = parcelRequire("22Ip8");

var $7vrjT = parcelRequire("7vrjT");
const $6bb0ceebd75f6adb$export$9d121f7dfa52c35a = (fieldKeys, dependencies = [])=>async ({ dispatch: dispatch }, { projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, globalFieldRemote: globalFieldRemote })=>{
        if (projectId === undefined) throw new Error('cannot associate field for unknown project');
        await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).globalFieldsAdministration.globalFieldAssociate, ()=>globalFieldRemote.addGlobalFieldsToProject({
                fieldKeys: fieldKeys,
                projectId: projectId
            }));
        const allNewFields = [
            ...fieldKeys,
            ...dependencies
        ];
        await dispatch((0, $22Ip8.loadSelectedFields)(allNewFields));
        dispatch((0, $7vrjT.setNewlyAddedGlobalFields)(allNewFields));
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'field associated', {
            issueFieldKeys: fieldKeys
        });
    };

});
parcelRegister("22Ip8", function(module, exports) {

$parcel$export(module.exports, "loadSelectedFields", () => $5ec3e957981aae51$export$bded8cd1c374b27d);

var $eTBmS = parcelRequire("eTBmS");
const $5ec3e957981aae51$export$bded8cd1c374b27d = (fieldKeys, loadOnlyIfFieldsKnown)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        const shouldRefetch = !loadOnlyIfFieldsKnown || fieldKeys.every((fieldKey)=>fieldKey in getState().fields);
        if (!shouldRefetch) return [];
        const fieldData = await fieldRemote.fetchFields(fieldKeys);
        const updatedFields = $5ec3e957981aae51$var$preprocessFields(getState().fields, fieldData.fields);
        setState({
            fields: {
                ...getState().fields,
                ...updatedFields
            },
            fieldValueDecorations: {
                ...getState().fieldValueDecorations,
                ...fieldData.fieldValueDecorations
            }
        });
        return Object.values(updatedFields);
    };
const $5ec3e957981aae51$var$preprocessFields = (currentFields, newFields)=>{
    const updatedFields = {};
    for (const field of Object.values(newFields)){
        let updatedField = field;
        const outdatedField = currentFields[field.key];
        const isGlobalLabelsField = updatedField.type === (0, $eTBmS.FIELD_TYPES).CUSTOM_LABELS && updatedField.custom && updatedField.global;
        if (isGlobalLabelsField && outdatedField?.options?.length) // keep loaded global labels
        updatedField = {
            ...updatedField,
            options: outdatedField.options
        };
        updatedFields[field.key] = updatedField;
    }
    return updatedFields;
};

});

parcelRegister("7vrjT", function(module, exports) {

$parcel$export(module.exports, "setNewlyAddedGlobalFields", () => $6a19d41be14fc7d5$export$30bea066a076a4e2);
$parcel$export(module.exports, "resetNewlyAddedGlobalFields", () => $6a19d41be14fc7d5$export$218470d90b3b9e76);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $6a19d41be14fc7d5$export$30bea066a076a4e2 = (fieldKeys)=>async ({ setState: setState })=>{
        setState({
            newlyAddedGlobalFields: fieldKeys
        });
    };
const $6a19d41be14fc7d5$export$218470d90b3b9e76 = ()=>async ({ setState: setState })=>{
        setState({
            newlyAddedGlobalFields: []
        });
    };

});


parcelRegister("aTipJ", function(module, exports) {

$parcel$export(module.exports, "createField", () => $300c0dfc580f9a7b$export$17fc0a47da34544a);
$parcel$export(module.exports, "createConnectionField", () => $300c0dfc580f9a7b$export$33d95ef524f03d07);
$parcel$export(module.exports, "createCalculatedField", () => $300c0dfc580f9a7b$export$1d77878d72c7c60);
$parcel$export(module.exports, "createPlayField", () => $300c0dfc580f9a7b$export$255b12a413a0ece5);
$parcel$export(module.exports, "updatePlayFieldParameters", () => $300c0dfc580f9a7b$export$cba5a7c7e64ded21);

var $1yBwF = parcelRequire("1yBwF");

var $3osLr = parcelRequire("3osLr");

var $1uIew = parcelRequire("1uIew");

var $hz26H = parcelRequire("hz26H");

var $fljS9 = parcelRequire("fljS9");

var $aqxDR = parcelRequire("aqxDR");

var $6Yd06 = parcelRequire("6Yd06");

var $7jTnu = parcelRequire("7jTnu");
const $300c0dfc580f9a7b$var$createProjectAri = (siteId, projectId)=>(0, $3osLr.JiraProjectAri).create({
        projectId: String(projectId),
        siteId: siteId
    }).toString();
const $300c0dfc580f9a7b$var$updateState = (newFields, getState, setState)=>{
    const state = getState();
    const newState = {
        fields: {
            ...state.fields,
            ...newFields.fields
        },
        fieldValueDecorations: {
            ...state.fieldValueDecorations,
            ...newFields.fieldValueDecorations
        }
    };
    setState(newState);
    return newFields.fields[Object.keys(newFields.fields)[0]];
};
const $300c0dfc580f9a7b$var$handleFetchError = async (err, callback)=>{
    const { statusCode: statusCode, originalResponse: originalResponse } = err;
    if (statusCode === 409 && originalResponse) {
        const responseJson = await originalResponse.json();
        const errorString = responseJson?.error;
        if ((0, $hz26H.isDuplicateFieldNameError)(errorString)) throw new (0, $hz26H.DuplicateNameError)(errorString, [
            {
                error: errorString
            }
        ], statusCode);
        // for now the entity limit error only relies on the statuscode 409, so this is the only else case currently
        const error = new (0, $fljS9.EntityLimitError)(errorString, [
            {
                error: errorString
            }
        ], statusCode, (0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT);
        callback(error);
        throw error;
    }
    throw err;
};
const $300c0dfc580f9a7b$export$17fc0a47da34544a = (name, type, configuration)=>async ({ getState: getState, setState: setState }, { projectId: projectId, issueTypeIds: issueTypeIds, fieldRemote: fieldRemote, onFieldUpdateFailed: onFieldUpdateFailed })=>{
        const issueTypeId = (0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(issueTypeIds);
        if (issueTypeId === undefined || issueTypeIds === undefined || issueTypeIds.length === 0) throw new Error('cannot create field for unknown issue type');
        if (projectId === undefined) throw new Error('cannot create field for unknown project');
        try {
            const fieldsData = await fieldRemote.createField({
                issueTypeIds: issueTypeIds,
                name: name.trim(),
                type: type,
                configuration: configuration
            });
            return $300c0dfc580f9a7b$var$updateState(fieldsData, getState, setState);
        } catch (err) {
            if (err instanceof (0, $1uIew.default)) await $300c0dfc580f9a7b$var$handleFetchError(err, onFieldUpdateFailed);
            throw err;
        }
    };
const $300c0dfc580f9a7b$export$33d95ef524f03d07 = (name, type, configuration)=>async ({ dispatch: dispatch })=>{
        try {
            return await dispatch($300c0dfc580f9a7b$export$17fc0a47da34544a(name, type, {
                issueTypeFilters: (0, $7jTnu.fg)('jpd-connection-fields-on-types-screen') ? configuration?.issueTypeFilters ?? [] : []
            }));
        } catch (error) {
            if (error instanceof Error) (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.field.actions.create-field.connection', 'Failed to create a connection field', error);
            throw error;
        }
    };
const $300c0dfc580f9a7b$export$1d77878d72c7c60 = (name, formula)=>async ({ getState: getState, setState: setState }, { issueTypeIds: issueTypeIds, fieldRemote: fieldRemote, onFieldUpdateFailed: onFieldUpdateFailed })=>{
        const issueTypeId = (0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(issueTypeIds);
        if (issueTypeId === undefined || issueTypeIds === undefined || issueTypeIds.length === 0) throw new Error('cannot create field for unknown issue type');
        try {
            const fieldsData = await fieldRemote.createCalculatedField({
                label: name.trim(),
                formula: formula,
                issueTypeIds: issueTypeIds
            });
            return $300c0dfc580f9a7b$var$updateState(fieldsData, getState, setState);
        } catch (err) {
            if (err instanceof (0, $1uIew.default)) await $300c0dfc580f9a7b$var$handleFetchError(err, onFieldUpdateFailed);
            throw err;
        }
    };
const $300c0dfc580f9a7b$export$255b12a413a0ece5 = (name, maxSpend, kind = 'PolarisBudgetAllocationPlay')=>async ({ getState: getState, setState: setState }, { onActionFailed: onActionFailed, onFieldUpdateFailed: onFieldUpdateFailed, cloudId: cloudId, projectId: projectId, fieldRemote: fieldRemote, issueTypeIds: issueTypeIds })=>{
        try {
            const issueTypeId = (0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(issueTypeIds);
            if (issueTypeId === undefined || issueTypeIds === undefined || issueTypeIds.length === 0) throw new Error('cannot create field for unknown issue type');
            const fieldsData = await fieldRemote.createPlayField({
                kind: kind,
                label: name.trim(),
                parameters: {
                    maxSpend: maxSpend
                },
                project: $300c0dfc580f9a7b$var$createProjectAri(cloudId, projectId),
                issueTypeIds: issueTypeIds
            });
            return $300c0dfc580f9a7b$var$updateState(fieldsData, getState, setState);
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Unknown error');
            const entityLimitError = (0, $fljS9.getEntityLimitError)(error);
            if (entityLimitError) onFieldUpdateFailed(entityLimitError);
            else onActionFailed(error);
            throw error;
        }
    };
const $300c0dfc580f9a7b$export$cba5a7c7e64ded21 = (id, parameters)=>({ getState: getState, setState: setState })=>{
        const { fields: fields } = getState();
        Object.keys(fields).forEach((key)=>{
            const field = fields[key];
            if (field.play?.id === id) fields[key] = {
                ...field,
                play: {
                    ...field.play,
                    parameters: parameters
                }
            };
        });
        setState({
            fields: {
                ...fields
            }
        });
    };

});
parcelRegister("hz26H", function(module, exports) {

$parcel$export(module.exports, "DuplicateNameError", () => $37435cc8777ec3f0$export$d649d5f2acb6db01);
$parcel$export(module.exports, "isDuplicateFieldNameError", () => $37435cc8777ec3f0$export$d40fc83bfbdf5161);

var $fJuTR = parcelRequire("fJuTR");
const $37435cc8777ec3f0$var$DUPLICATE_FIELD_NAME_ERROR = 'Duplicate field name';
class $37435cc8777ec3f0$export$d649d5f2acb6db01 extends (0, $fJuTR.default) {
    constructor(message, errors = [], statusCode = null){
        super(message, {
            cause: errors[0]
        }), this.name = 'DuplicateNameError';
        this.errors = errors;
        this.statusCode = statusCode;
    }
}
const $37435cc8777ec3f0$export$d40fc83bfbdf5161 = (errorMessage)=>errorMessage === $37435cc8777ec3f0$var$DUPLICATE_FIELD_NAME_ERROR;

});

parcelRegister("fljS9", function(module, exports) {

$parcel$export(module.exports, "EntityLimitError", () => $0eae3c589bda6c5f$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $0eae3c589bda6c5f$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $0eae3c589bda6c5f$export$cf58cbb2768ea4f);

var $eezJL = parcelRequire("eezJL");

var $fJuTR = parcelRequire("fJuTR");

var $ivX8j = parcelRequire("ivX8j");

var $aqxDR = parcelRequire("aqxDR");
class $0eae3c589bda6c5f$export$c4e01b2c2ba95919 extends (0, $fJuTR.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
const $0eae3c589bda6c5f$export$13f6f9a6b905ebbd = (error)=>{
    // If already an EntityLimitError, return it
    if (error instanceof $0eae3c589bda6c5f$export$c4e01b2c2ba95919) return error;
    // If not an ApolloError, return null as we can't handle it
    if (!(error instanceof (0, $eezJL.ApolloError))) return null;
    // Get first entity limit error
    const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
    // If no entity limit error or no extensions, return null
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entityLimitErrorType = (0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $0eae3c589bda6c5f$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $0eae3c589bda6c5f$export$cf58cbb2768ea4f = (error)=>(0, $ivX8j.default)[error.type] || null;

});
parcelRegister("ivX8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb7ce4790658e33$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");

var $aqxDR = parcelRequire("aqxDR");
var $6fb7ce4790658e33$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    /* eslint-disable jira/i18n/id-named-by-package */ [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
        "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
        "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
        "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    }
});

});
parcelRegister("aqxDR", function(module, exports) {

$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $ef36341caf3b8cc4$export$a197d88688faa32c);
const $ef36341caf3b8cc4$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};

});




parcelRegister("2k5D4", function(module, exports) {

$parcel$export(module.exports, "createValueDecoration", () => $0dd9ad744d3b7a9b$export$47ba83e40776877b);
$parcel$export(module.exports, "createValueDecorationBulk", () => $0dd9ad744d3b7a9b$export$b68f071dd4cb812d);

var $jKSVG = parcelRequire("jKSVG");

var $5tOWS = parcelRequire("5tOWS");

var $1I887 = parcelRequire("1I887");

var $680fE = parcelRequire("680fE");
const $0dd9ad744d3b7a9b$export$47ba83e40776877b = (createProps)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, onDecorationUpdateFailed: onDecorationUpdateFailed, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { fieldKey: fieldKey, backgroundColor: backgroundColor, highlightContainer: highlightContainer, emoji: emoji, logic: logic } = createProps;
        const state = getState();
        const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
        const field = fields[fieldKey];
        const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
        const localDecorationId = (0, $jKSVG.generateLocalDecorationId)();
        const newValueDecorations = [
            ...existingValueDecorations
        ];
        newValueDecorations.push({
            localDecorationId: localDecorationId,
            backgroundColor: backgroundColor,
            emoji: emoji,
            highlightContainer: highlightContainer,
            logic: logic
        });
        setState({
            fieldValueDecorations: {
                ...fieldValueDecorations,
                [fieldKey]: newValueDecorations
            }
        });
        try {
            await (0, $680fE.performJiraConfigurationUpdate)({
                fieldKey: fieldKey,
                fieldRemote: fieldRemote,
                existingDecorations: existingValueDecorations,
                newDecorations: newValueDecorations,
                isGlobalSystemField: (0, $5tOWS.isGlobalSystemField)(field)
            });
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type
            });
        } catch (error) {
            setState({
                fieldValueDecorations: {
                    ...getState().fieldValueDecorations,
                    [fieldKey]: existingValueDecorations
                }
            });
            onDecorationUpdateFailed(error instanceof Error ? error : new Error('Failed to create value decoration'));
        }
        return localDecorationId;
    };
const $0dd9ad744d3b7a9b$export$b68f071dd4cb812d = (createProps)=>(stateParams, propParams)=>{
        const { getState: getState, setState: setState } = stateParams;
        const { fieldRemote: fieldRemote, onDecorationUpdateFailed: onDecorationUpdateFailed, createAnalyticsEvent: createAnalyticsEvent } = propParams;
        const { fieldKey: fieldKey, decorations: decorations } = createProps;
        const state = getState();
        const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
        const field = fields[fieldKey];
        const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
        const newValueDecorations = [
            ...existingValueDecorations
        ];
        const localDecorationIds = [];
        decorations.forEach((decoration)=>{
            const { backgroundColor: backgroundColor, highlightContainer: highlightContainer, emoji: emoji, logic: logic } = decoration;
            const localDecorationId = (0, $jKSVG.generateLocalDecorationId)();
            localDecorationIds.push(localDecorationId);
            newValueDecorations.push({
                localDecorationId: localDecorationId,
                backgroundColor: backgroundColor,
                emoji: emoji,
                highlightContainer: highlightContainer,
                logic: logic
            });
        });
        (0, $680fE.performJiraConfigurationUpdate)({
            fieldKey: fieldKey,
            fieldRemote: fieldRemote,
            existingDecorations: existingValueDecorations,
            newDecorations: newValueDecorations,
            isGlobalSystemField: (0, $5tOWS.isGlobalSystemField)(field)
        }).catch((error)=>{
            onDecorationUpdateFailed(error);
        });
        setState({
            fieldValueDecorations: {
                ...fieldValueDecorations,
                [fieldKey]: newValueDecorations
            }
        });
        (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
            issueFieldKey: fieldKey,
            issueFieldType: field.type
        });
        return localDecorationIds;
    };

});
parcelRegister("jKSVG", function(module, exports) {

$parcel$export(module.exports, "generateLocalDecorationId", () => $de2fd9a28e425f13$export$9680935a700c2c34);
$parcel$export(module.exports, "containsLogic", () => $de2fd9a28e425f13$export$41f0457eb13a2b9);

var $jPROM = parcelRequire("jPROM");

var $aXKmr = parcelRequire("aXKmr");
const $de2fd9a28e425f13$export$9680935a700c2c34 = ()=>(0, $aXKmr.v4)();
const $de2fd9a28e425f13$export$41f0457eb13a2b9 = (decoration)=>{
    return !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(decoration.logic);
};

});

parcelRegister("5tOWS", function(module, exports) {

$parcel$export(module.exports, "getFieldId", () => $5f549187dbef294a$export$f4457e83c74ac000);
$parcel$export(module.exports, "fieldCanBeHidden", () => $5f549187dbef294a$export$9da5531535a06a9e);
$parcel$export(module.exports, "canHaveValuesCopiedToGlobalField", () => $5f549187dbef294a$export$3356aa19195d3185);
$parcel$export(module.exports, "eligibleCopyTargetFilterPredicate", () => $5f549187dbef294a$export$8d71c4715545b632);
$parcel$export(module.exports, "isGlobalSystemField", () => $5f549187dbef294a$export$92ddaa0fb1252ade);
$parcel$export(module.exports, "isGlobalNonSystemField", () => $5f549187dbef294a$export$506e497e6a42b28);
$parcel$export(module.exports, "isGlobalSystemFieldWithProjectLevelConfiguration", () => $5f549187dbef294a$export$31095e7cae078af2);

var $eTBmS = parcelRequire("eTBmS");

var $6jMAv = parcelRequire("6jMAv");
const $5f549187dbef294a$export$386ed4140989cc75 = (key)=>key;
const $5f549187dbef294a$export$f4457e83c74ac000 = (fieldKey)=>{
    const customFieldPrefix = 'customfield_';
    if (!fieldKey || !fieldKey.startsWith(customFieldPrefix)) return '';
    return fieldKey.replace(customFieldPrefix, '');
};
const $5f549187dbef294a$var$FIELDS_CANNOT_BE_HIDDEN = new Set([
    (0, $eTBmS.FIELD_TYPES).SUMMARY,
    (0, $eTBmS.FIELD_TYPES).ISSUE_KEY,
    (0, $eTBmS.FIELD_TYPES).CREATED
]);
const $5f549187dbef294a$export$9da5531535a06a9e = (fieldType)=>{
    if (!fieldType || !(0, $eTBmS.isSystemFieldType)(fieldType)) return false;
    return !$5f549187dbef294a$var$FIELDS_CANNOT_BE_HIDDEN.has(fieldType);
};
const $5f549187dbef294a$var$FIELDS_CANNOT_BE_MAPPED_TO_GLOBAL = new Set([
    (0, $eTBmS.FIELD_TYPES).FORMULA,
    (0, $eTBmS.FIELD_TYPES).REACTIONS,
    (0, $eTBmS.FIELD_TYPES).VOTES
]);
const $5f549187dbef294a$export$3356aa19195d3185 = (fieldType)=>fieldType && !(0, $eTBmS.isSystemFieldType)(fieldType) && !$5f549187dbef294a$var$FIELDS_CANNOT_BE_MAPPED_TO_GLOBAL.has(fieldType);
const $5f549187dbef294a$export$8d71c4715545b632 = ({ from: sourceFieldType, to: targetFieldType })=>{
    if (targetFieldType === sourceFieldType) return true;
    return sourceFieldType === (0, $eTBmS.FIELD_TYPES).MULTI_SELECT && targetFieldType === (0, $eTBmS.FIELD_TYPES).JSW_MULTI_SELECT || sourceFieldType === (0, $eTBmS.FIELD_TYPES).PEOPLE && targetFieldType === (0, $eTBmS.FIELD_TYPES).JSW_PEOPLE;
};
const $5f549187dbef294a$var$SYSTEM_FIELDS = new Set([
    (0, $eTBmS.FIELD_TYPES).ISSUE_COMMENTS,
    (0, $eTBmS.FIELD_TYPES).INSIGHTS,
    (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES,
    (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS,
    (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS,
    (0, $eTBmS.FIELD_TYPES).ARCHIVED,
    (0, $eTBmS.FIELD_TYPES).ARCHIVED_ON,
    (0, $eTBmS.FIELD_TYPES).ARCHIVED_BY,
    (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL,
    (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT,
    (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT_STATUS,
    (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS,
    (0, $eTBmS.FIELD_TYPES).INSIGHTS_GLOBAL,
    (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES_GLOBAL,
    (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS_GLOBAL,
    (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS_GLOBAL,
    (0, $eTBmS.FIELD_TYPES).ISSUE_COMMENTS_GLOBAL,
    (0, $eTBmS.FIELD_TYPES).PLATFORM_PROJECT,
    (0, $eTBmS.FIELD_TYPES).PLATFORM_PROJECT_STATUS
]);
const $5f549187dbef294a$var$SYSTEM_FIELDS_WITH_PROJECT_CONFIGURATION = new Set([
    (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES,
    (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS,
    (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS,
    (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES_GLOBAL,
    (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS_GLOBAL,
    (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS_GLOBAL
]);
const $5f549187dbef294a$export$92ddaa0fb1252ade = ({ global: global, custom: custom, type: type, stableId: stableId })=>{
    if (global && custom && ($5f549187dbef294a$var$SYSTEM_FIELDS.has(type) || (0, $6jMAv.isGlobalSystemFieldStableId)(stableId))) return true;
    return false;
};
const $5f549187dbef294a$export$506e497e6a42b28 = ({ global: global, custom: custom, type: type, stableId: stableId })=>{
    if (global && custom && !($5f549187dbef294a$var$SYSTEM_FIELDS.has(type) || (0, $6jMAv.isGlobalSystemFieldStableId)(stableId))) return true;
    return false;
};
const $5f549187dbef294a$export$31095e7cae078af2 = (field)=>{
    return $5f549187dbef294a$export$92ddaa0fb1252ade(field) && $5f549187dbef294a$var$SYSTEM_FIELDS_WITH_PROJECT_CONFIGURATION.has(field.type);
};

});
parcelRegister("6jMAv", function(module, exports) {

$parcel$export(module.exports, "STABLE_IDS", () => $b5ba56512cab3639$export$3c40e95743b409fd);
$parcel$export(module.exports, "isGlobalSystemFieldStableId", () => $b5ba56512cab3639$export$db403227c18eb65d);

const $b5ba56512cab3639$export$3c40e95743b409fd = {
    PLATFORM_PROJECT: (0, $e45ac50dcabae759$export$48c1a69bd5564b65),
    PLATFORM_PROJECT_STATUS: (0, $e45ac50dcabae759$export$cd1b6ac45f51c6e5),
    ISSUE_COMMENTS: (0, $e45ac50dcabae759$export$798c9f93a02ce7dd),
    DELIVERY_PROGRESS: (0, $e45ac50dcabae759$export$5c86841152c9af38),
    DELIVERY_STATUS: (0, $e45ac50dcabae759$export$c41983369cfe1a19),
    ARCHIVED: (0, $e45ac50dcabae759$export$292571c17f71a537),
    ARCHIVED_BY: (0, $e45ac50dcabae759$export$cf35a0b8c5585b51),
    ARCHIVED_ON: (0, $e45ac50dcabae759$export$c520a2556c6211c),
    INSIGHTS: (0, $e45ac50dcabae759$export$1866edc9dadf522f),
    LINKED_ISSUES: (0, $e45ac50dcabae759$export$1200cfbac4072d9a)
};
const $b5ba56512cab3639$var$GLOBAL_SYSTEM_FIELDS_STABLE_IDS = new Set([
    (0, $e45ac50dcabae759$export$48c1a69bd5564b65),
    (0, $e45ac50dcabae759$export$cd1b6ac45f51c6e5),
    (0, $e45ac50dcabae759$export$798c9f93a02ce7dd),
    (0, $e45ac50dcabae759$export$5c86841152c9af38),
    (0, $e45ac50dcabae759$export$c41983369cfe1a19),
    (0, $e45ac50dcabae759$export$292571c17f71a537),
    (0, $e45ac50dcabae759$export$cf35a0b8c5585b51),
    (0, $e45ac50dcabae759$export$c520a2556c6211c),
    (0, $e45ac50dcabae759$export$1866edc9dadf522f),
    (0, $e45ac50dcabae759$export$1200cfbac4072d9a)
]);
const $b5ba56512cab3639$export$db403227c18eb65d = (stableId)=>stableId ? $b5ba56512cab3639$var$GLOBAL_SYSTEM_FIELDS_STABLE_IDS.has(stableId) : false;

});
const $e45ac50dcabae759$export$48c1a69bd5564b65 = 'sfid:jira-product-discovery:atlassian-project';
const $e45ac50dcabae759$export$cd1b6ac45f51c6e5 = 'sfid:jira-product-discovery:atlassian-project-status';
const $e45ac50dcabae759$export$798c9f93a02ce7dd = 'sfid:jira-product-discovery:count-issue-comments';
const $e45ac50dcabae759$export$5c86841152c9af38 = 'sfid:jira-product-discovery:delivery-progress';
const $e45ac50dcabae759$export$c41983369cfe1a19 = 'sfid:jira-product-discovery:delivery-status';
const $e45ac50dcabae759$export$292571c17f71a537 = 'sfid:jira-product-discovery:archived';
const $e45ac50dcabae759$export$cf35a0b8c5585b51 = 'sfid:jira-product-discovery:archived-by';
const $e45ac50dcabae759$export$c520a2556c6211c = 'sfid:jira-product-discovery:archived-on';
const $e45ac50dcabae759$export$1866edc9dadf522f = 'sfid:jira-product-discovery:count-insights';
const $e45ac50dcabae759$export$1200cfbac4072d9a = 'sfid:jira-product-discovery:count-linked-issues';



parcelRegister("1I887", function(module, exports) {

$parcel$export(module.exports, "fireCompoundAnalyticsEvent", () => $ba1ddd8cc736f006$export$48a7e5476d8e07b1);
$parcel$export(module.exports, "fireAnalyticsEventForIssueUpdate", () => $ba1ddd8cc736f006$export$d051bc7a06e14ff4);
$parcel$export(module.exports, "useViewOpenedAnalytics", () => $ba1ddd8cc736f006$export$c44f82646ff7d9c9);

var $eJOHy = parcelRequire("eJOHy");

var $1rzja = parcelRequire("1rzja");

var $ln6Iy = parcelRequire("ln6Iy");

var $gCeeo = parcelRequire("gCeeo");

var $3Ku0X = parcelRequire("3Ku0X");

var $kbqkd = parcelRequire("kbqkd");

var $hkIDZ = parcelRequire("hkIDZ");

var $cjZxC = parcelRequire("cjZxC");

var $93GPK = parcelRequire("93GPK");

var $BqC4G = parcelRequire("BqC4G");

var $amr66 = parcelRequire("amr66");

var $kej4n = parcelRequire("kej4n");

var $7C4iB = parcelRequire("7C4iB");

var $jd3e6 = parcelRequire("jd3e6");
const $ba1ddd8cc736f006$var$mapViewKindToType = (viewKind)=>{
    const map = {
        TABLE: 'List'
    };
    return map[viewKind] ?? (0, (/*@__PURE__*/$parcel$interopDefault($1rzja)))(viewKind);
};
const $ba1ddd8cc736f006$export$48a7e5476d8e07b1 = {
    View: $jd3e6.View,
    ViewHeader: $7C4iB.ViewHeader,
    IdeaView: $93GPK.IdeaView,
    FieldConfig: $hkIDZ.FieldConfig,
    Field: $cjZxC.Field,
    BoardView: $kbqkd.BoardView,
    ListView: $BqC4G.ListView,
    MatrixView: $amr66.MatrixView,
    TimelineView: $kej4n.TimelineView,
    IdeaCommentCreated: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/yM5d3g_Uey9JJ_eD0aOn3b3fD7s
        (0, $3Ku0X.sendPendoTrackEvent)('idea_comment_created');
        // https://data-portal.internal.atlassian.com/analytics/registry/168
        (0, $gCeeo.fireTrackAnalytics)(event, 'comment created');
    },
    IdeaCommentUpdated: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/1363
        (0, $gCeeo.fireTrackAnalytics)(event, 'comment updated');
    },
    IdeaCommentDeleted: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/1364
        (0, $gCeeo.fireTrackAnalytics)(event, 'comment deleted');
    },
    IdeaCreated: (event, issueId, attributes)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/xpkc3Fne_s-qq2bS3vILQyJQnNs
        (0, $3Ku0X.sendPendoTrackEvent)('idea_created');
        // https://data-portal.internal.atlassian.com/analytics/registry/871
        (0, $gCeeo.fireTrackAnalytics)(event, 'issue created', String(issueId), {
            ...attributes,
            projectType: (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)
        });
    },
    IdeaFieldUpdated: (event, fieldType, actionType)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/H3xT1i_BL7YwQIXK8Wtw792AQwo
        (0, $3Ku0X.sendPendoTrackEvent)('idea_field_updated');
        // https://data-portal.internal.atlassian.com/analytics/registry/47658
        (0, $gCeeo.fireTrackAnalytics)(event, 'fieldValue updated', {
            fieldType: fieldType,
            actionType: actionType
        });
    },
    IdeaDescriptionUpdated: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/l93NMzXG9zkSFeDPIZecMkSwNxQ
        (0, $3Ku0X.sendPendoTrackEvent)('idea_description_updated');
        // https://data-portal.internal.atlassian.com/analytics/registry/47087
        (0, $gCeeo.fireTrackAnalytics)(event, 'ideaDescription updated');
    },
    RightSidebarFieldListViewOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/qwLEc_xbDbYQUJrrm3rnaimAl28
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarFieldListView opened');
    },
    RightSidebarIssueCommentsOpened: (event)=>{
        // there are no separate sidebar for comments, it opens Idea and selects comments section
        // https://app.pendo.io/s/4758009750487040/trackevents/p2-VEQ3cO21s4mmhIfY_66_aFYA
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarIssueComments opened');
        (0, $gCeeo.fireUIAnalytics)(event, 'rightSidebarIssueComments opened');
    },
    RightSidebarIssueInsightsOpened: (event)=>{
        // there are no separate sidebar for comments, it opens Idea and selects insights section
        // https://app.pendo.io/s/4758009750487040/trackevents/sGThOdFKoBxg8J_liR0JaC7DXwE
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarIssueInsights opened');
        (0, $gCeeo.fireUIAnalytics)(event, 'rightSidebarIssueInsights opened');
    },
    RightSidebarFieldEditViewOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/DQP_0kv1ub59wQZ_mI05gd9eUNA
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarFieldEditView opened');
    },
    RightSidebarFieldCreateViewOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/5DhE-prOX7zgx38JEKNstW3s2Ng
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarFieldCreateView opened');
        // https://data-portal.internal.atlassian.com/analytics/registry/47091
        (0, $gCeeo.fireUIAnalytics)(event, 'rightSidebarFieldCreateView opened');
    },
    RightSidebarFieldOptionOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/igbtQ-93jOjhhDLi032TTYep18U
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarFieldOption opened');
        (0, $gCeeo.fireUIAnalytics)(event, 'rightSidebarFieldOption opened');
    },
    RightSidebarFieldsFieldToggled: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewFields updated fieldToggled');
    },
    RightSidebarFieldsFieldSorted: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewFields updated fieldSorted');
    },
    RightSidebarFieldsFieldHidden: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'viewFields updated fieldHidden'
        });
    },
    RightSidebarFieldsFieldAdded: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewFields updated fieldAdded');
    },
    RightSidebarOnFilterOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/W8B_-btramlDqbmwblM0sgJ3VMs
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarOnFilter opened');
    },
    RightSidebarOnIdeaOpened: (event)=>{
        // Does not trigger
        // https://app.pendo.io/s/4758009750487040/trackevents/6Hd4O0gOTewIXzIIRbneohkhyxc
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarOnIdea opened');
        (0, $gCeeo.fireUIAnalytics)(event, 'rightSidebarOnIdea opened');
    },
    RightSidebarOnPlayOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/5Mo7NsNavjXsrJ8CzICmEx6XQ3E
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarOnPlay opened');
        // https://data-portal.internal.atlassian.com/analytics/registry/47093
        (0, $gCeeo.fireUIAnalytics)(event, 'rightSidebarOnPlay opened');
    },
    RightSidebarOnSortOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/H0HJy3Pb03AFe4FUhziY3RtbePk
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarOnSort opened');
    },
    RightSidebarViewSortFieldAdded: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewSort updated fieldAdded');
    },
    RightSidebarViewSortFieldRemoved: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewSort updated fieldRemoved');
    },
    RightSidebarViewSortDirectionChanged: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewSort updated directionChanged');
    },
    RightSidebarViewSortReset: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewSort updated sortReset');
    },
    RightSidebarViewSortFieldsReordered: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewSort updated fieldsReordered');
    },
    RightSidebarViewSortFieldsChanged: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewSort updated fieldsChanged');
    },
    RightSidebarGroupByColumnsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/un0GJBhSAansp_VkWBMpM5IsZF4
        (0, $3Ku0X.sendPendoTrackEvent)('openGroupByOptions opened');
    },
    RightSidebarGroupByRowsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/G7DQd6x0J_7WC1WI7seQw-J-GfY
        (0, $3Ku0X.sendPendoTrackEvent)('openVerticalGroupByOptions opened');
    },
    RightSidebarGroupByRowsFieldChanged: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'viewFields updated groupByRowFieldChanged'
        });
    },
    RightSidebarGroupByColumnsFieldChanged: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewFields updated groupByColumnFieldChanged');
    },
    OpenMatrixXAxisOptionsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/yBOlM340T4ZzqcDSGc2XJF2ZRxc
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarMatrixXAxisOptions opened');
    },
    OpenMatrixYAxisOptionsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/SL0S3e_8qSbkVLO-O_QjUfvcDQk
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarMatrixYAxisOptions opened');
    },
    OpenMatrixZAxisOptionsOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/ZnMVz7jumv61RhfycYSPqZ75KFw
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarMatrixZAxisOptions opened');
    },
    RightSidebarClosed: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/4Qy9buugg-OhEldeBO2__dpJ-Ok
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'rightSidebar closed'
        });
    },
    HyperlinkFieldMaxLengthError: (event)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('hyperlink_field_max_length_error');
        (0, $gCeeo.fireTrackAnalytics)(event, 'error occurred', 'hyperlinkFieldMaxLengthError');
    },
    RightSidebarIdeaTemplatesOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/HjknfGpnKMead8RV2_o3O0IQDSA
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarIdeaTemplates opened');
        // https://data-portal.internal.atlassian.com/analytics/registry/47101
        (0, $gCeeo.fireUIAnalytics)(event, 'rightSidebarIdeaTemplates opened');
    },
    RightSidebarIdeasBucketOpened: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/ljVwr3Sv_MYCLsa3UHcOHaD3fNA
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'rightSidebarIdeasBucketOpened opened'
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/47102
        (0, $gCeeo.fireUIAnalytics)(event, 'rightSidebarIdeasBucket opened');
    },
    RightSidebarTimelineConfigOpened: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/CwJbzYOhkl68z6y843U6qziVc6M
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'rightSidebarTimelineConfig opened'
        });
    },
    RightSidebarFieldOptionsSearchOccured: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('rightSidebarFieldOptionsSearch occured');
    },
    IdeaDescriptionTemplatesButtonClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/JchzwUn3TuabHi4MyumsDRqBQwU
        (0, $3Ku0X.sendPendoTrackEvent)('ideaDescriptionTemplatesButton clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47104
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplatesButton');
    },
    IdeaDescriptionTemplateApplyClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/KdZV3lpa_O_MOZyzsSub8T0syH4
        (0, $3Ku0X.sendPendoTrackEvent)('ideaDescriptionTemplateApply clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47105
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplateApply');
    },
    IdeaDescriptionTemplateCreateClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/iDYpmhRk8iYXew9zsLep7s7Bfb4
        (0, $3Ku0X.sendPendoTrackEvent)('ideaDescriptionTemplateCreate clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47106
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplateCreate');
    },
    IdeaDescriptionTemplateUpdateClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/Y-cdYKUd1JzkhvvS3_u-vo-XmKg
        (0, $3Ku0X.sendPendoTrackEvent)('ideaDescriptionTemplateUpdate clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47107
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplateUpdate');
    },
    IdeaDescriptionTemplateDeleteClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/Eg4_nuY5UbatLwwO1pI5pCU7SMg
        (0, $3Ku0X.sendPendoTrackEvent)('ideaDescriptionTemplateDelete clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47108
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'ideaDescriptionTemplateDelete');
    },
    IdeaDescriptionTemplateApplied: (event, templateId)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/nTQAWILD5CRM2qYw_xH732QrEws
        // https://app.pendo.io/s/4758009750487040/trackevents/crl2tr_HaEyOJpcM9a9qR4YFFx4
        // https://app.pendo.io/s/4758009750487040/trackevents/BVmG9LifMmegmliDAjGlab0NzvQ
        // https://app.pendo.io/s/4758009750487040/trackevents/wTLKudshXTHg45sd2ZsKRC90t_U
        // https://app.pendo.io/s/4758009750487040/trackevents/ilWZEZJMAX4ozUbyEzRW93ZL5sw
        (0, $3Ku0X.sendPendoTrackEvent)(`applyDescriptionTemplate${templateId || ''} clicked`);
        // https://data-portal.internal.atlassian.com/analytics/registry/47109
        (0, $gCeeo.fireTrackAnalytics)(event, 'ideaDescriptionTemplate applied', templateId || '');
    },
    SortChangeToViewRankButtonClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/FqF53XXrRrC5a5tmcjDt6CyjLEE
        (0, $3Ku0X.sendPendoTrackEvent)('viewRankButton clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47110
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'sortChangeToViewRankButton');
    },
    SortChangeToProjectRankButtonClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/ayeJj95x4OuyqD-dg33FITDD0-Q
        (0, $3Ku0X.sendPendoTrackEvent)('changeToProjectRankButton clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47111
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'sortChangeToProjectRankButton');
    },
    SortChangeToProjectRankAndCommitButtonClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/mqPhVSm3WfHFO6xueL7FjerRVVQ
        (0, $3Ku0X.sendPendoTrackEvent)('changeToProjectAndCommitRankButton clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47112
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'sortChangeToProjectAndCommitRankButton');
    },
    IdeaRankedInView: ()=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/Rmc-JGgcaUg6_W5FAwHYzTjNaGs
        (0, $3Ku0X.sendPendoTrackEvent)('per-view-rank_updated');
    },
    MatrixBubbleTooltipDisplayed: (event, issueAnalyticsData)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('matrixViewBubbleTooltip displayed');
        // https://data-portal.internal.atlassian.com/analytics/registry/50600
        (0, $gCeeo.fireUIAnalytics)(event, 'tooltip displayed', 'matrixViewBubble', issueAnalyticsData || {});
    },
    ViewControls: {
        openColumnsSidebarButtonClicked: (event, attributes = {})=>{
            // https://app.pendo.io/s/4758009750487040/trackevents/5e7xyzPg4xscjaCRIt0bzKVNbYk
            (0, $3Ku0X.sendPendoTrackEvent)('openColumnsSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51152
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'columns', attributes);
        },
        openGroupBySidebarButtonClicked: (event)=>{
            // https://app.pendo.io/s/4758009750487040/trackevents/yc-bdFY4nzRIB8HGZFg8nmHLaMw
            (0, $3Ku0X.sendPendoTrackEvent)('openGroupBySidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51098
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'groupBy');
        },
        openFieldsSidebarButtonClicked: (event)=>{
            // https://app.pendo.io/s/4758009750487040/trackevents/XNr3dWjVg28g4Ap2AfrjTSao5vU
            (0, $3Ku0X.sendPendoTrackEvent)('openFieldsSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51106
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'fields');
        },
        openFilterSidebarButtonClicked: (event)=>{
            // https://app.pendo.io/s/4758009750487040/trackevents/lkQcHgUcckvv4fqRwH5kH43uj0c
            (0, $3Ku0X.sendPendoTrackEvent)('openFilterSidebarButton clicked');
            // data-portal.internal.atlassian.com/analytics/registry/51100
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'filter');
        },
        openSortSidebarButtonClicked: (event)=>{
            (0, $3Ku0X.sendPendoTrackEvent)('openSortSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51102
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'sort');
        },
        openMatrixXAxisSidebarButtonClicked: (event, attributes = {})=>{
            (0, $3Ku0X.sendPendoTrackEvent)('openMatrixXSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51111
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'xAxis', attributes);
        },
        openMatrixYAxisSidebarButtonClicked: (event, attributes = {})=>{
            (0, $3Ku0X.sendPendoTrackEvent)('openMatrixYSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51112
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'yAxis', attributes);
        },
        openMatrixZAxisSidebarButtonClicked: (event)=>{
            (0, $3Ku0X.sendPendoTrackEvent)('openMatrixZSidebarButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/51115
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'size');
        }
    },
    NavSidebarPlusDropdownitemClicked: (event, viewKind)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/nu1EELTcS0GLr-UHw567_0k4ICk BOARD
        // https://app.pendo.io/s/4758009750487040/trackevents/G4co93jddFLvabbue_FGZlaLaZY MATRIX
        // https://app.pendo.io/s/4758009750487040/trackevents/wafmt5zQbXNRsxAVYtUhBpU85x0 SECTION
        // https://app.pendo.io/s/4758009750487040/trackevents/Md7wujC7XbHk6fcqv2jhB_UmDOQ TABLE
        // https://app.pendo.io/s/4758009750487040/trackevents/994nTMJuZg69jlOiJDdKi147MnA TIMELINE
        (0, $3Ku0X.sendPendoTrackEvent)(`navSidebarPlusButtonItem ${viewKind}`);
        // https://data-portal.internal.atlassian.com/analytics/registry/51025
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'createViewOrSection', {
            selectedActionItem: `create${$ba1ddd8cc736f006$var$mapViewKindToType(viewKind)}`
        });
    // archive this old event https://data-portal.internal.atlassian.com/analytics/registry/32259
    },
    NavSidebarCreateViewDropdownitemClicked: (event, viewKind)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/0EdRA1ITiMFiOSSEp3-dtavyZbo BOARD
        // https://app.pendo.io/s/4758009750487040/trackevents/gzxdZw-0LQeC2g89asY7Np7HLhI MATRIX
        // https://app.pendo.io/s/4758009750487040/trackevents/BkizrhPyoBdyyEvEIVXmLMn91kk SECTION
        // https://app.pendo.io/s/4758009750487040/trackevents/nX3mY7GocKIxPz5Zb4jqE9Wmr-o TABLE
        // https://app.pendo.io/s/4758009750487040/trackevents/SNnVX1fmm7aKSrSOqEt2zx2VWJY TIMELINE
        (0, $3Ku0X.sendPendoTrackEvent)(`navSidebarCreateViewButtonItem ${viewKind}`);
        // https://data-portal.internal.atlassian.com/analytics/registry/51025
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'createViewOrSection', {
            selectedActionItem: `create${$ba1ddd8cc736f006$var$mapViewKindToType(viewKind)}`
        });
    // archive this old event https://data-portal.internal.atlassian.com/analytics/registry/32259
    },
    NavSidebarViewKebabCloneViewAsListClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/lJG7R-6iywlELtqR6-ixHOp4MQo
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar cloneViewAsListKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'cloneAsList'
        });
    },
    NavSidebarViewKebabCloneViewAsBoardClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/HA4TEsBJklVPQDHvABXaSh3yhts
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar cloneViewAsBoardKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'cloneAsBoard'
        });
    },
    NavSidebarViewKebabCloneViewAsMatrixClicked: (event)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar cloneViewAsMatrixKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'cloneAsMatrix'
        });
    },
    NavSidebarViewKebabCloneViewAsTimelineClicked: (event)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar cloneViewAsTimelineKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'cloneAsTimeline'
        });
    },
    NavSidebarViewKebabDeleteViewClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/nCqpRV9mZzGZbxRlFtNBUc0J2Ik
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar deleteViewKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'delete'
        });
    },
    NavSidebarViewKebabRenameViewClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/qov7DM6puEYBB-gy-KtJomlxLb8
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar renameViewKebab clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'rename'
        });
    },
    NavSidebarViewEmojiRemove: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/gRjWMaouDLTuByt85NPGsNiq0oU
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar removeEmoji clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/51085
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewActionItem', {
            selectedActionItem: 'removeEmoji'
        });
    },
    NavSidebarViewEmojiAdd: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/OXnJYJtQaJDwoj1Wu9KnkFaoDUE
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar addEmoji clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry
        (0, $gCeeo.fireUIAnalytics)(event, 'navSidebarItem clicked', 'viewAddEmoji');
    },
    NavSidebarViewClicked: (event, viewKind = '')=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/0PGTFtKgeZmnnSyt6eue3hkZZlM BOARD
        // https://app.pendo.io/s/4758009750487040/trackevents/qXWj21iEeMmo21WvKVW951KZhTo MATRIX
        // https://app.pendo.io/s/4758009750487040/trackevents/xeRrNQmZIZvnUtaRWu4S8lsQQL8 TABLE
        // https://app.pendo.io/s/4758009750487040/trackevents/LoEQ2kACHWa-hBGwG2NcwPP4eCw TIMELINE
        (0, $3Ku0X.sendPendoTrackEvent)(`navSidebar ${viewKind} clicked`);
        // https://data-portal.internal.atlassian.com/analytics/registry/47126
        (0, $gCeeo.fireUIAnalytics)(event, 'navSidebarItem clicked', 'view', {
            viewKind: viewKind
        });
    },
    NavSidebarArchiveViewClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/uZq6qCPnbyTKB84D9kI2c1xY2lM ARCHIVE
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar ARCHIVE clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47126
        (0, $gCeeo.fireUIAnalytics)(event, 'navSidebarItem clicked', 'view', {
            viewKind: 'ARCHIVE'
        });
    },
    NavSidebarSettingsClicked: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/Bh7L9c2N2UYwt3THvgqrihcH0q0 settings
        (0, $3Ku0X.sendPendoTrackEvent)('navSidebar settings clicked');
        // https://data-portal.internal.atlassian.com/analytics/registry/47126
        (0, $gCeeo.fireUIAnalytics)(event, 'navSidebarItem clicked', 'settings');
    },
    TimelineGranularityChanged: (event, attributes)=>{
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timelineGranularity clicked',
            attributes: attributes
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'timelineGranularity', attributes);
    },
    TimelineGroupToggled: (event)=>{
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timelineGroup clicked'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'timelineGroup clicked', 'view');
    },
    TimelineRangeChanged: (event, attributes)=>{
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timelineRange changed',
            attributes: attributes
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'timelineRange changed', 'settings', attributes);
    },
    TimelineFieldKeyChanged: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('timelineFieldKey changed');
    },
    DateFilterTypeChanged: (event)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('dateFilterType changed');
        (0, $gCeeo.fireUIAnalytics)(event, 'dateFilterType changed', 'settings');
    },
    ReactionAddedReactionsField: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('reaction added');
    },
    ReactionRemovedReactionsField: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('reaction removed');
    }
};
const $ba1ddd8cc736f006$export$d051bc7a06e14ff4 = (event, issueId, attributes)=>{
    event.context.push({
        objectId: issueId,
        objectType: 'issue'
    });
    issueId ? (0, $gCeeo.fireTrackAnalytics)(event, 'issue updated', issueId, attributes) : (0, $gCeeo.fireTrackAnalytics)(event, 'issue updated', attributes);
};
const $ba1ddd8cc736f006$export$c44f82646ff7d9c9 = ({ viewId: viewId, viewAccessLevel: viewAccessLevel, isViewPermissionsEnabled: isViewPermissionsEnabled, isViewConfigured: isViewConfigured, analyticsCallback: analyticsCallback, isSharedView: isSharedView })=>{
    const previousCurrentViewId = (0, $eJOHy.useRef)(undefined);
    const previousViewAccessLevel = (0, $eJOHy.useRef)(undefined);
    const previousIsViewConfigured = (0, $eJOHy.useRef)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (isSharedView) return;
        if (viewId !== previousCurrentViewId.current || isViewConfigured !== previousIsViewConfigured.current) {
            previousCurrentViewId.current = viewId;
            previousIsViewConfigured.current = isViewConfigured;
            previousViewAccessLevel.current = undefined;
        }
        if (isViewPermissionsEnabled) {
            if (viewAccessLevel !== undefined && previousViewAccessLevel.current === undefined) {
                analyticsCallback(viewAccessLevel);
                previousViewAccessLevel.current = viewAccessLevel;
            }
        } else analyticsCallback(undefined);
    }, [
        isViewPermissionsEnabled,
        viewId,
        viewAccessLevel,
        analyticsCallback,
        isViewConfigured,
        isSharedView
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isSharedView) analyticsCallback(undefined);
    }, [
        isSharedView,
        analyticsCallback
    ]);
};

});
parcelRegister("3Ku0X", function(module, exports) {

$parcel$export(module.exports, "sendPendoTrackEvent", () => $bf10dcacb821430c$export$c6da4636619f7369);
$parcel$export(module.exports, "updatePendoVisitorOptions", () => $bf10dcacb821430c$export$862313c5bc1d6788);

var $87WyO = parcelRequire("87WyO");
const $bf10dcacb821430c$var$QUEUE_LIMIT = 50;
let $bf10dcacb821430c$var$queue = [];
const $bf10dcacb821430c$var$waitForPendoReadiness = ()=>{
    // This code should not execute on the server.
    if (false) return;
    const interval = setInterval(()=>{
        if ((0, $87WyO.isPendoReady)()) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            $bf10dcacb821430c$var$queue.forEach(([event, attributes])=>window?.pendo?.track(event, attributes));
            $bf10dcacb821430c$var$queue = [];
            clearInterval(interval);
        }
    }, 1000);
};
function $bf10dcacb821430c$export$c6da4636619f7369(event, properties) {
    let pendoEvent;
    let attributes;
    if (typeof event === 'string') {
        pendoEvent = event;
        attributes = properties;
    } else {
        const fullEvent = [
            event.source,
            event.actionSubjectAndAction,
            event.actionSubjectId
        ].filter((part)=>part !== undefined).join(' - ');
        pendoEvent = fullEvent;
        attributes = event.attributes;
    }
    try {
        if ((0, $87WyO.isPendoReady)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.pendo.track(pendoEvent, attributes);
        else {
            $bf10dcacb821430c$var$queue.length < $bf10dcacb821430c$var$QUEUE_LIMIT && $bf10dcacb821430c$var$queue.push([
                pendoEvent,
                attributes
            ]);
            $bf10dcacb821430c$var$waitForPendoReadiness();
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $87WyO.logError)('pendoTrackEvent', err);
    }
}
const $bf10dcacb821430c$export$862313c5bc1d6788 = (metadata)=>{
    try {
        if ((0, $87WyO.isPendoReady)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.pendo.updateOptions(metadata);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $87WyO.logError)('pendoUpdateOptions', err);
    }
};

});
parcelRegister("87WyO", function(module, exports) {

$parcel$export(module.exports, "logError", () => $7c614b2352d1dc75$export$58da9968c3170cb1);
$parcel$export(module.exports, "isPendoReady", () => $7c614b2352d1dc75$export$3f386d356f8c718f);

var $gYnSx = parcelRequire("gYnSx");

var $6Yd06 = parcelRequire("6Yd06");
const $7c614b2352d1dc75$export$58da9968c3170cb1 = (errorSubject, error)=>{
    const ERROR_ID = 'polaris-error';
    (0, $gYnSx.default)({
        meta: {
            id: ERROR_ID,
            teamName: 'polaris'
        },
        attributes: {
            subject: errorSubject
        },
        error: error
    });
    (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)(`${ERROR_ID}.${errorSubject}`, error.message, error);
};
const $7c614b2352d1dc75$export$3f386d356f8c718f = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.pendo?.isReady && typeof window.pendo.isReady === 'function' && window.pendo.isReady();

});


parcelRegister("kbqkd", function(module, exports) {

$parcel$export(module.exports, "BoardView", () => $d3faaddb524074c9$export$373e09b633948dc);

var $gCeeo = parcelRequire("gCeeo");

var $3Ku0X = parcelRequire("3Ku0X");
const $d3faaddb524074c9$export$373e09b633948dc = {
    opened: (event, accessLevel)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/qM00ZERYuH-iFTxMnCfYLZpuKgQ
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'boardView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/51089
        (0, $gCeeo.fireScreenAnalytics)(event, {
            accessLevel: accessLevel
        });
    },
    cardDropped: (event, attributes = {})=>{
        (0, $3Ku0X.sendPendoTrackEvent)('boardViewCard dropped');
        // https://data-portal.internal.atlassian.com/analytics/registry/50694
        (0, $gCeeo.fireUIAnalytics)(event, 'card dragged', 'idea', attributes);
    },
    columnDropped: (event, attributes)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('boardViewColumn dropped');
        // https://data-portal.internal.atlassian.com/analytics/registry/50789
        (0, $gCeeo.fireUIAnalytics)(event, 'column dragged', 'fieldValue', attributes);
    },
    fieldValueUpdatedByDragBetweenColumns: (fieldType)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(`fieldValue updated ${fieldType} boardDragBetweenColumns`);
    },
    fieldValueUpdatedByDragBetweenSwimlanes: (fieldType)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(`fieldValue updated ${fieldType} boardDragBetweenSwimlanes`);
    },
    searchOrCreateClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/75136
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'boardColumnSearchOrCreate', {});
    },
    searchOrCreateNewIdeaClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/75135
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'boardColumnSearchOrCreateNewIdea', {});
    }
};

});

parcelRegister("hkIDZ", function(module, exports) {

$parcel$export(module.exports, "FieldConfig", () => $0d5def19f37a77b4$export$2655f228c0cb3e13);

var $gCeeo = parcelRequire("gCeeo");

var $lLx26 = parcelRequire("lLx26");
const $0d5def19f37a77b4$export$2655f228c0cb3e13 = {
    labelChangedSuccess: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'label'
                }
            ],
            ...attributes
        });
    },
    labelChangedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $gCeeo.fireTrackAnalytics)(event, 'fieldConfig updated', 'labelChanged', {
            result: (0, $lLx26.RESULTS).FAILURE
        });
    },
    emojiChangedSuccess: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'emoji'
                }
            ],
            ...attributes
        });
    },
    emojiChangedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $gCeeo.fireTrackAnalytics)(event, 'fieldConfig updated', 'emojiChanged', {
            result: (0, $lLx26.RESULTS).FAILURE
        });
    },
    descriptionChangedSuccess: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'description'
                }
            ],
            ...attributes
        });
    },
    descriptionChangedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $gCeeo.fireTrackAnalytics)(event, 'fieldConfig updated', 'descriptionChanged', {
            result: (0, $lLx26.RESULTS).FAILURE
        });
    },
    fieldDeletedSuccess: (event, attributes)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/51170
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueField deleted', attributes);
    },
    fieldDeletedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $gCeeo.fireTrackAnalytics)(event, 'fieldConfig updated', 'fieldDeleted', {
            result: (0, $lLx26.RESULTS).FAILURE
        });
    },
    optionLabelChanged: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionLabel'
                }
            ],
            ...attributes
        });
    },
    optionCreatedSuccess: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionLabel',
                    updateType: 'created'
                }
            ],
            ...attributes
        });
    },
    optionCreatedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $gCeeo.fireTrackAnalytics)(event, 'fieldConfig updated', 'optionCreated', {
            result: (0, $lLx26.RESULTS).FAILURE
        });
    },
    optionDeletedSuccess: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionLabel',
                    updateType: 'deleted'
                }
            ],
            ...attributes
        });
    },
    optionDeletedFailure: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47519
        (0, $gCeeo.fireTrackAnalytics)(event, 'fieldConfig updated', 'optionDeleted', {
            result: (0, $lLx26.RESULTS).FAILURE
        });
    },
    optionWeightChanged: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionWeight'
                }
            ],
            ...attributes
        });
    },
    optionRankChanged: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionRank'
                }
            ],
            ...attributes
        });
    },
    optionWeightTypeChanged: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'optionWeightType'
                }
            ],
            ...attributes
        });
    },
    valueDecorationChanged: (event, attributes)=>{
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
            updatedItems: [
                {
                    name: 'fieldValueDecorations'
                }
            ],
            ...attributes
        });
    }
};

});
parcelRegister("lLx26", function(module, exports) {

$parcel$export(module.exports, "RESULTS", () => $0f1091055ae27740$export$190fdd7c86e5a6c7);
const $0f1091055ae27740$export$190fdd7c86e5a6c7 = {
    SUCCESS: 'success',
    FAILURE: 'failure'
};

});


parcelRegister("cjZxC", function(module, exports) {

$parcel$export(module.exports, "Field", () => $fea58653be686235$export$a455218a85c89869);

var $gCeeo = parcelRequire("gCeeo");

var $lLx26 = parcelRequire("lLx26");
const $fea58653be686235$export$a455218a85c89869 = {
    createdSuccess: (event, attributes)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/51308
        (0, $gCeeo.fireTrackAnalytics)(event, 'issueField created', attributes);
    },
    createdFailure: (event, fieldType)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47737
        (0, $gCeeo.fireTrackAnalytics)(event, 'ideaField created', {
            result: (0, $lLx26.RESULTS).FAILURE,
            fieldType: fieldType
        });
    }
};

});

parcelRegister("93GPK", function(module, exports) {

$parcel$export(module.exports, "IdeaView", () => $e26c80586379f5c1$export$b0c41ca9ce1c19e6);

var $gCeeo = parcelRequire("gCeeo");

var $3Ku0X = parcelRequire("3Ku0X");
const $e26c80586379f5c1$export$b0c41ca9ce1c19e6 = {
    copyIdeaLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47650
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'copyIdeaLinkButton');
    },
    copyIdeaCommentLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/48687
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'copyIdeaCommentLinkButton');
    },
    copyIdeaInsightLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/50374
        (0, $gCeeo.fireUIAnalytics)(event, 'icon clicked', 'copyIdeaInsightLink');
    },
    viewed: (event)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/n5034S7jQww7n-LViD6ZpHEP3xM
        (0, $3Ku0X.sendPendoTrackEvent)('idea_opened');
        // Fullscreen: https://data-portal.internal.atlassian.com/analytics/registry/893
        // Sidebar: https://data-portal.internal.atlassian.com/analytics/registry/51086
        (0, $gCeeo.fireScreenAnalytics)(event);
    },
    tabClicked: (event, issueViewSection)=>{
        let actionSubjectId = issueViewSection;
        if (issueViewSection === 'capture') actionSubjectId = 'insights';
        else if (issueViewSection === 'deliver') actionSubjectId = 'delivery';
        (0, $gCeeo.fireUIAnalytics)(event, 'tab clicked', actionSubjectId);
    },
    DeliveryTab: {
        createDeliveryTicketButtonClicked: (event, isFromHint = false)=>{
            (0, $3Ku0X.sendPendoTrackEvent)('ideaViewDeliveryCreateDeliveryTicketButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/50485
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'createDeliveryTicket', {
                isFromHint: isFromHint
            });
        },
        linkDeliveryTicketButtonClicked: (event, isFromHint = false)=>{
            (0, $3Ku0X.sendPendoTrackEvent)('ideaViewDeliveryLinkDeliveryTicketButton clicked');
            // https://data-portal.internal.atlassian.com/analytics/registry/50507
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'addDeliveryTicket', {
                isFromHint: isFromHint
            });
        },
        deliveryTicketsHintClosed: (event)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50733
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'closeDeliveryTicketsHint');
        },
        learnMoreButtonClicked: (event, isFromHint = false)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50732
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'learnMoreAboutDeliveryTickets', {
                isFromHint: isFromHint
            });
        }
    },
    InsightsTab: {
        createInsightButtonClicked: (event, isFromHint = false)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50336
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'createInsight', {
                isFromHint: isFromHint
            });
        },
        createInsightHintClosed: (event)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50739
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'closeCreateInsightsHint');
        },
        createInsightLearnMoreButtonClicked: (event, isFromHint = false)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50738
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'learnMoreCreateInsightsTickets', {
                isFromHint: isFromHint
            });
        },
        addLinkToInsightsHintClosed: (event)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50741
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'closeAddLinkToInsightsHint');
        },
        addLinkToInsightsLearnMoreButtonClicked: (event, isFromHint = false)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/50740
            (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'learnMoreAddLinkToInsights', {
                isFromHint: isFromHint
            });
        }
    }
};

});

parcelRegister("BqC4G", function(module, exports) {

$parcel$export(module.exports, "ListView", () => $5b6fc96d57e45fad$export$84d0dd190d551cd1);

var $gCeeo = parcelRequire("gCeeo");

var $3Ku0X = parcelRequire("3Ku0X");
const $5b6fc96d57e45fad$export$84d0dd190d551cd1 = {
    opened: (event, accessLevel)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/M2-9XepSbr5FNP9yFynxrzIQUZQ
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'listView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/51087
        (0, $gCeeo.fireScreenAnalytics)(event, {
            accessLevel: accessLevel
        });
    },
    fieldValueUpdatedByDragBetweenSwimlanes: (fieldType)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(`fieldValue updated ${fieldType} listDragBetweenSwimlanes`);
    },
    fieldValueUpdatedByInlineEdit: (fieldType)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(`fieldValue updated ${fieldType} listInlineEdit`);
    },
    columnActionItemClicked: (event, attributes)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(`listViewColumnActionItem ${attributes.selectedActionItem}`);
        (0, $gCeeo.fireUIAnalytics)(event, 'dropdownItem clicked', 'viewFieldActions', attributes);
    },
    learnMoreAboutArchiveButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/56971
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'learnMoreAboutArchivingIdeas', {});
    },
    addIdeaFixedBottomRowClicked: (event, grouped)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/75128
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'addIdeaFixedRow', {
            grouped: grouped
        });
    }
};

});

parcelRegister("amr66", function(module, exports) {

$parcel$export(module.exports, "MatrixView", () => $131b1616eb497905$export$3f8d83934fd139e9);

var $gCeeo = parcelRequire("gCeeo");

var $3Ku0X = parcelRequire("3Ku0X");
const $131b1616eb497905$export$3f8d83934fd139e9 = {
    opened: (event, accessLevel)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/5PATMUbxnbpQjTatZdHcElQVLqw
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'matrixView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/51088
        (0, $gCeeo.fireScreenAnalytics)(event, {
            accessLevel: accessLevel
        });
    },
    fieldUpdatedByDragWithinXAxis: (fieldType)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(`fieldValue updated ${fieldType} matrixDragXAxis`);
    },
    fieldUpdatedByDragWithinYAxis: (fieldType)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(`fieldValue updated ${fieldType} matrixDragYAxis`);
    }
};

});

parcelRegister("kej4n", function(module, exports) {

$parcel$export(module.exports, "TimelineView", () => $828e398b1a9f2536$export$4e254246a3a175f9);

var $gCeeo = parcelRequire("gCeeo");

var $3Ku0X = parcelRequire("3Ku0X");
const $828e398b1a9f2536$export$4e254246a3a175f9 = {
    opened: (event, itemCount, timelineLength, accessLevel)=>{
        // https://app.pendo.io/s/4758009750487040/trackevents/zzYGsTOijWyY1VfJ56VtLUI-Rzw
        (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timelineView opened',
            attributes: {
                accessLevel: accessLevel || ''
            }
        });
        if (itemCount <= 10) (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline[0to10] opened'
        });
        else if (itemCount <= 25) (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline(10to25] opened'
        });
        else if (itemCount <= 50) (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline(25to50] opened'
        });
        else if (itemCount <= 100) (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline(50to100] opened'
        });
        else (0, $3Ku0X.sendPendoTrackEvent)({
            actionSubjectAndAction: 'timeline>100 opened'
        });
        // https://data-portal.internal.atlassian.com/analytics/registry/51090
        (0, $gCeeo.fireScreenAnalytics)(event, {
            itemCount: itemCount,
            timelineLength: timelineLength,
            accessLevel: accessLevel
        });
    }
};

});

parcelRegister("7C4iB", function(module, exports) {

$parcel$export(module.exports, "ViewHeader", () => $8da3cc6b150162f4$export$96d5c22d305e32a0);

var $gCeeo = parcelRequire("gCeeo");
const $8da3cc6b150162f4$export$96d5c22d305e32a0 = {
    copyViewLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47649
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'copyViewLinkButton');
    }
};

});

parcelRegister("jd3e6", function(module, exports) {

$parcel$export(module.exports, "View", () => $ade5a60844ab7cad$export$27a5bd065ad55220);

var $gCeeo = parcelRequire("gCeeo");

var $3Ku0X = parcelRequire("3Ku0X");

var $lLx26 = parcelRequire("lLx26");
const $ade5a60844ab7cad$export$27a5bd065ad55220 = {
    createdSuccess: (event, viewKind)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47738
        (0, $gCeeo.fireTrackAnalytics)(event, 'view created', {
            result: (0, $lLx26.RESULTS).SUCCESS,
            targetViewKind: viewKind
        });
    },
    createdFailure: (event, viewKind)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47738
        (0, $gCeeo.fireTrackAnalytics)(event, 'view created', {
            result: (0, $lLx26.RESULTS).FAILURE,
            targetViewKind: viewKind
        });
    },
    nameChanged: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47648
        (0, $gCeeo.fireTrackAnalytics)(event, 'view updated', {
            updatedItems: [
                {
                    name: 'name'
                }
            ]
        });
    },
    emojiChanged: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/47648
        (0, $gCeeo.fireTrackAnalytics)(event, 'view updated', 'emojiChanged');
    },
    copyViewCommentLinkButtonClicked: (event)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/48689
        (0, $gCeeo.fireUIAnalytics)(event, 'button clicked', 'copyViewCommentLinkButton');
    },
    viewSettingsOpened: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewSettings opened');
    },
    autosaveChanged: (event, isEnabled)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(isEnabled ? 'autosave enabled' : 'autosave disabled');
        (0, $gCeeo.fireUIAnalytics)(event, 'autosave changed', {
            isEnabled: isEnabled
        });
    },
    unsavedChangesReset: (event)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('unsavedChanges reset');
        (0, $gCeeo.fireUIAnalytics)(event, 'unsavedChanges reset');
    },
    unsavedChangesSave: (event)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('unsavedChanges saved');
        (0, $gCeeo.fireUIAnalytics)(event, 'unsavedChanges saved');
    },
    unsavedChangesSaveAsNew: (event)=>{
        (0, $3Ku0X.sendPendoTrackEvent)('unsavedChanges savedAsNew');
        (0, $gCeeo.fireUIAnalytics)(event, 'unsavedChanges savedAsNew');
    },
    viewLayoutSettingOpened: ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)('viewLayoutSetting opened');
    },
    viewLayoutChanged: (event, layoutType)=>{
        (0, $3Ku0X.sendPendoTrackEvent)(`view layout changed - ${layoutType.toLowerCase()}`);
        (0, $gCeeo.fireUIAnalytics)(event, 'viewLayout changed', {
            layoutType: layoutType
        });
    }
};

});


parcelRegister("680fE", function(module, exports) {

$parcel$export(module.exports, "remapValueDecorations", () => $2a76da977cf87656$export$366e4db7f45672a6);
$parcel$export(module.exports, "performJiraConfigurationUpdate", () => $2a76da977cf87656$export$72f886ca488f3f78);
const $2a76da977cf87656$export$366e4db7f45672a6 = (decorations)=>decorations.length > 0 ? {
        valueDecorations: decorations.map((decoration)=>({
                ...decoration.backgroundColor ? {
                    backgroundColor: decoration.backgroundColor
                } : {},
                ...decoration.emoji ? {
                    emoji: decoration.emoji
                } : {},
                highlightContainer: decoration.highlightContainer,
                logic: decoration.logic
            }))
    } : {};
const $2a76da977cf87656$export$72f886ca488f3f78 = ({ fieldKey: fieldKey, fieldRemote: fieldRemote, existingDecorations: existingDecorations, newDecorations: newDecorations, isGlobalSystemField: isGlobalSystemFieldArg })=>{
    const oldConfiguration = $2a76da977cf87656$export$366e4db7f45672a6(existingDecorations);
    const configuration = $2a76da977cf87656$export$366e4db7f45672a6(newDecorations);
    return fieldRemote.updateFieldConfiguration({
        fieldKey: fieldKey,
        oldConfiguration: oldConfiguration,
        configuration: configuration,
        type: 'updateFieldDecorations',
        isGlobalSystemField: isGlobalSystemFieldArg
    });
};

});


parcelRegister("3gu89", function(module, exports) {

$parcel$export(module.exports, "deleteValueDecoration", () => $ee629d5b68648047$export$7c9c473571e097ae);
$parcel$export(module.exports, "deleteAllValueDecorations", () => $ee629d5b68648047$export$b56439617c923c6b);

var $5tOWS = parcelRequire("5tOWS");

var $1I887 = parcelRequire("1I887");

var $680fE = parcelRequire("680fE");
const $ee629d5b68648047$export$7c9c473571e097ae = (fieldKey, localDecorationId)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent, onDecorationUpdateFailed: onDecorationUpdateFailed })=>{
        const state = getState();
        const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
        const field = fields[fieldKey];
        const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
        const newValueDecorations = [
            ...existingValueDecorations
        ];
        const decorationIdx = newValueDecorations.findIndex(({ localDecorationId: id })=>localDecorationId === id);
        newValueDecorations.splice(decorationIdx, 1);
        setState({
            fieldValueDecorations: {
                ...fieldValueDecorations,
                [fieldKey]: newValueDecorations
            }
        });
        try {
            try {
                await (0, $680fE.performJiraConfigurationUpdate)({
                    fieldKey: fieldKey,
                    fieldRemote: fieldRemote,
                    existingDecorations: existingValueDecorations,
                    newDecorations: newValueDecorations,
                    isGlobalSystemField: (0, $5tOWS.isGlobalSystemField)(field)
                });
                (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: field.type
                });
            } catch (error) {
                setState({
                    fieldValueDecorations: {
                        ...getState().fieldValueDecorations,
                        [fieldKey]: existingValueDecorations
                    }
                });
                throw error;
            }
        } catch (error) {
            onDecorationUpdateFailed(error instanceof Error ? error : new Error('Failed to delete value decoration'));
        }
    };
const $ee629d5b68648047$export$b56439617c923c6b = ({ fieldKey: fieldKey })=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            const state = getState();
            const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
            const field = fields[fieldKey];
            const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
            setState({
                fieldValueDecorations: {
                    ...fieldValueDecorations,
                    [fieldKey]: []
                }
            });
            await (0, $680fE.performJiraConfigurationUpdate)({
                fieldKey: fieldKey,
                fieldRemote: fieldRemote,
                existingDecorations: existingValueDecorations,
                newDecorations: [],
                isGlobalSystemField: (0, $5tOWS.isGlobalSystemField)(field)
            });
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            onFieldUpdateFailed(e);
        }
        return undefined;
    };

});

parcelRegister("1XYZv", function(module, exports) {

$parcel$export(module.exports, "updateValueDecoration", () => $5036f1eec1edd1f8$export$57375c08ef65980a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ddUcD = parcelRequire("ddUcD");
const $5036f1eec1edd1f8$export$57375c08ef65980a = (updateProps)=>({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, onDecorationUpdateFailed: onDecorationUpdateFailed, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $ddUcD.updateInternal)(updateProps, fieldRemote, getState, setState, onDecorationUpdateFailed, createAnalyticsEvent);
    };

});
parcelRegister("ddUcD", function(module, exports) {

$parcel$export(module.exports, "updateInternal", () => $719ccfcc31f4c493$export$335aa5770c9dcf5b);

var $5tOWS = parcelRequire("5tOWS");

var $1I887 = parcelRequire("1I887");

var $680fE = parcelRequire("680fE");
const $719ccfcc31f4c493$export$335aa5770c9dcf5b = async (updateProps, fieldRemote, getState, setState, onDecorationUpdateFailed, createAnalyticsEvent)=>{
    const { fieldKey: fieldKey, localDecorationId: localDecorationId } = updateProps;
    const state = getState();
    const { fieldValueDecorations: fieldValueDecorations, fields: fields } = state;
    const field = fields[fieldKey];
    const existingValueDecorations = fieldValueDecorations[fieldKey] || [];
    const itemIndex = existingValueDecorations.findIndex((decoration)=>decoration.localDecorationId === localDecorationId);
    if (itemIndex === -1) // noop update of non-existing id
    return;
    const oldDecoration = existingValueDecorations[itemIndex];
    const newValueDecorations = [
        ...existingValueDecorations
    ];
    newValueDecorations[itemIndex] = {
        ...oldDecoration,
        ...updateProps
    };
    setState({
        fieldValueDecorations: {
            ...fieldValueDecorations,
            [fieldKey]: newValueDecorations
        }
    });
    try {
        try {
            await (0, $680fE.performJiraConfigurationUpdate)({
                fieldKey: fieldKey,
                fieldRemote: fieldRemote,
                existingDecorations: existingValueDecorations,
                newDecorations: newValueDecorations,
                isGlobalSystemField: (0, $5tOWS.isGlobalSystemField)(field)
            });
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type
            });
        } catch (error) {
            setState({
                fieldValueDecorations: {
                    ...getState().fieldValueDecorations,
                    [fieldKey]: existingValueDecorations
                }
            });
            throw error;
        }
    } catch (error) {
        onDecorationUpdateFailed(error instanceof Error ? error : new Error('Failed to update value decoration'));
    }
};

});


parcelRegister("e2a0f", function(module, exports) {

$parcel$export(module.exports, "deleteFieldLocally", () => $ce36804f811f6e96$export$35c076545da7e74c);
$parcel$export(module.exports, "deleteField", () => $ce36804f811f6e96$export$2bbad96c62fdba3e);

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $1I887 = parcelRequire("1I887");
const $ce36804f811f6e96$export$35c076545da7e74c = (fieldKey)=>async ({ getState: getState, setState: setState })=>{
        const updatedFields = {
            ...getState().fields
        };
        delete updatedFields[fieldKey];
        const updatedDecorations = {
            ...getState().fieldValueDecorations
        };
        delete updatedDecorations[fieldKey];
        setState({
            fields: updatedFields,
            fieldValueDecorations: updatedDecorations
        });
    };
const $ce36804f811f6e96$export$2bbad96c62fdba3e = (fieldKey, onSuccess, onError)=>async ({ getState: getState, dispatch: dispatch }, { onFieldUpdateFailed: onFieldUpdateFailed, deletePlay: deletePlay, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote, globalFieldRemote: globalFieldRemote, projectId: projectId })=>{
        try {
            const currFieldMap = getState().fields;
            const { key: key, custom: custom, global: global } = currFieldMap[fieldKey];
            const deletedFieldPlay = currFieldMap[fieldKey]?.play;
            const isGlobalField = custom && global;
            if (!isGlobalField) await fieldRemote.deleteField({
                fieldKey: key,
                deletePlayId: deletedFieldPlay?.id
            });
            else {
                if (!projectId) throw new Error('project id is not available');
                await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).globalFieldsAdministration.globalFieldUnassociate, ()=>globalFieldRemote.removeGlobalFieldFromProject({
                        fieldKey: key,
                        projectId: projectId
                    }));
            }
            // FE state only removal of play; this has no side effects
            if (deletedFieldPlay) deletePlay(deletedFieldPlay);
            dispatch($ce36804f811f6e96$export$35c076545da7e74c(fieldKey));
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.fieldDeletedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: currFieldMap[fieldKey]?.type,
                isGlobalField: isGlobalField
            });
            onSuccess?.();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.fieldDeletedFailure(createAnalyticsEvent({}));
            onError?.(e);
            onFieldUpdateFailed(e);
        }
        return undefined;
    };

});

parcelRegister("4VXAA", function(module, exports) {

$parcel$export(module.exports, "setHighlightedFields", () => $8e6c886313980521$export$b4de1af02e09ac7);
$parcel$export(module.exports, "resetHighlightedFields", () => $8e6c886313980521$export$697691a15f1ded39);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $8e6c886313980521$export$b4de1af02e09ac7 = (fieldKeys)=>async ({ setState: setState })=>{
        setState({
            highlightedFields: [
                ...fieldKeys
            ]
        });
    };
const $8e6c886313980521$export$697691a15f1ded39 = ()=>({ getState: getState, setState: setState })=>{
        if (getState().highlightedFields.length > 0) setState({
            highlightedFields: []
        });
    };

});

parcelRegister("hZEtq", function(module, exports) {

$parcel$export(module.exports, "updateDeliveryDateAggregationType", () => $f0bbcc23ca50ffc3$export$9593c3851a66ed74);

var $gCeeo = parcelRequire("gCeeo");

var $bNW0R = parcelRequire("bNW0R");
const $f0bbcc23ca50ffc3$export$9593c3851a66ed74 = (fieldKey, aggregationType, contextAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        const state = getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const currentField = (0, $bNW0R.createGetFieldByKey)(fieldKey)(state);
        const oldConfiguration = currentField.configuration ? currentField.configuration : {};
        const newConfiguration = {
            ...currentField.configuration
        };
        if (aggregationType) newConfiguration.aggregationType = aggregationType;
        else delete newConfiguration.aggregationType;
        const fields = {
            ...getState().fields
        };
        fields[fieldKey] = {
            ...fields[fieldKey],
            configuration: newConfiguration
        };
        setState({
            fields: fields
        });
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfiguration,
            configuration: newConfiguration,
            type: 'updateDeliveryDateAggregationType'
        });
        (0, $gCeeo.fireTrackAnalytics)(contextAnalyticsEvent, 'issueFields updated', {
            issueFieldKey: fieldKey,
            issueFieldType: currentField.type,
            updatedItems: [
                {
                    name: 'aggregationType'
                }
            ]
        });
    };

});
parcelRegister("bNW0R", function(module, exports) {

$parcel$export(module.exports, "getAllFields", () => $9eb9accda8500b20$export$d90c0acb4bf7532e);
$parcel$export(module.exports, "getAllFieldArray", () => $9eb9accda8500b20$export$367adca86e2ec47c);
$parcel$export(module.exports, "getAllVisibleFields", () => $9eb9accda8500b20$export$bde76c894b9b669b);
$parcel$export(module.exports, "getGlobalFieldsInUseArray", () => $9eb9accda8500b20$export$9fe2ffdc49a260cd);
$parcel$export(module.exports, "getFieldCount", () => $9eb9accda8500b20$export$23da09631eea700d);
$parcel$export(module.exports, "getGlobalFieldCount", () => $9eb9accda8500b20$export$a314f7fd2cfbe1e3);
$parcel$export(module.exports, "getAtlasFieldsEnabled", () => $9eb9accda8500b20$export$ed944ac7cf49a521);
$parcel$export(module.exports, "getNewlyAddedGlobalFields", () => $9eb9accda8500b20$export$87e7305c7ba63c24);
$parcel$export(module.exports, "getArchivedFieldsConfig", () => $9eb9accda8500b20$export$292fa83c763b98e3);
$parcel$export(module.exports, "getIsArchivingEnabled", () => $9eb9accda8500b20$export$b3fd159b04ba8fc1);
$parcel$export(module.exports, "getFieldLabels", () => $9eb9accda8500b20$export$ad84c8179191fc90);
$parcel$export(module.exports, "getNewFieldTypes", () => $9eb9accda8500b20$export$5b5c91d414e3b813);
$parcel$export(module.exports, "getFieldKeys", () => $9eb9accda8500b20$export$3a997aec30de5223);
$parcel$export(module.exports, "createGetFieldByKey", () => $9eb9accda8500b20$export$f0d43ae105c44a16);
$parcel$export(module.exports, "getFieldArray", () => $9eb9accda8500b20$export$26b8f64e04953389);
$parcel$export(module.exports, "createGetFieldType", () => $9eb9accda8500b20$export$cbdf4c7acce43aed);
$parcel$export(module.exports, "createGetFieldLabel", () => $9eb9accda8500b20$export$c690e8b384bae5e8);
$parcel$export(module.exports, "createGetIsSystemField", () => $9eb9accda8500b20$export$b95ca9bb53fcdfef);
$parcel$export(module.exports, "createIsConnectionCompatibleSystemField", () => $9eb9accda8500b20$export$d04d20ad5c11047d);
$parcel$export(module.exports, "getConnectionsFieldsAssociations", () => $9eb9accda8500b20$export$503e8c7201146811);
$parcel$export(module.exports, "createIsGlobalCustomField", () => $9eb9accda8500b20$export$b0a0a8781d8c536f);
$parcel$export(module.exports, "createIsGlobalSystemField", () => $9eb9accda8500b20$export$8f9f8fcec4e7e493);
$parcel$export(module.exports, "createIsGlobalNonSystemField", () => $9eb9accda8500b20$export$fe2f6ee73e67fe69);
$parcel$export(module.exports, "createGetFieldPlay", () => $9eb9accda8500b20$export$ed356202b542678e);
$parcel$export(module.exports, "createGetEditable", () => $9eb9accda8500b20$export$c0736d3defdc2d16);
$parcel$export(module.exports, "createGetFieldOfType", () => $9eb9accda8500b20$export$8ab6e7aafdab7605);
$parcel$export(module.exports, "createGetIsDeletable", () => $9eb9accda8500b20$export$db3f1e906529485e);
$parcel$export(module.exports, "createGetFieldDescription", () => $9eb9accda8500b20$export$c3a80db9f8f140f0);
$parcel$export(module.exports, "createGetFieldEmoji", () => $9eb9accda8500b20$export$67716b47d053849d);
$parcel$export(module.exports, "createGetFieldFormula", () => $9eb9accda8500b20$export$e7b67da153139180);
$parcel$export(module.exports, "createGetFieldPresentation", () => $9eb9accda8500b20$export$133c26f694dfc813);
$parcel$export(module.exports, "createGetFieldByPlayId", () => $9eb9accda8500b20$export$45b3e7fa07622627);
$parcel$export(module.exports, "createGetFieldKeysOfType", () => $9eb9accda8500b20$export$e75cb7c95fc7fe3c);
$parcel$export(module.exports, "createHasFieldFormula", () => $9eb9accda8500b20$export$1bd166026bf50a1e);
$parcel$export(module.exports, "createGetFieldHidden", () => $9eb9accda8500b20$export$185ec73baae348f);
$parcel$export(module.exports, "createGetFieldRestricted", () => $9eb9accda8500b20$export$d095f4e3ba265ab2);
$parcel$export(module.exports, "createGetFieldCountByType", () => $9eb9accda8500b20$export$71732c74215f52ad);
$parcel$export(module.exports, "getFieldTypeIcon", () => $9eb9accda8500b20$export$8746027cc5b4845);
$parcel$export(module.exports, "getAllEditableFields", () => $9eb9accda8500b20$export$5b3d0f4437e26fb1);
$parcel$export(module.exports, "getAllStringFields", () => $9eb9accda8500b20$export$30d3db0fb1ab5766);
$parcel$export(module.exports, "getHasFieldsError", () => $9eb9accda8500b20$export$534bf4b83eda4c1);
$parcel$export(module.exports, "getFieldsLoading", () => $9eb9accda8500b20$export$37340e201eeb3a5b);
$parcel$export(module.exports, "getHighlightedFields", () => $9eb9accda8500b20$export$50e456d0fb04ed15);
$parcel$export(module.exports, "getUniqConnectionFieldsProjectIds", () => $9eb9accda8500b20$export$6512893092dfd1cb);
$parcel$export(module.exports, "getProjectIdsForConnectedAtlasFields", () => $9eb9accda8500b20$export$49930db522e7bea5);
$parcel$export(module.exports, "createGetConnectionFieldIssueTypeNameFilter", () => $9eb9accda8500b20$export$9d5df2c0892bb7cb);
$parcel$export(module.exports, "createGetConnectionFieldIssueTypeIds", () => $9eb9accda8500b20$export$332fc2cda09b9bcc);
$parcel$export(module.exports, "createGetConnectionFieldHighlightedFieldKey", () => $9eb9accda8500b20$export$4c247cf31d8b79eb);
$parcel$export(module.exports, "createGetConnectionFieldIssueViewLayoutSort", () => $9eb9accda8500b20$export$4f9730e5ef9855a7);
$parcel$export(module.exports, "getAllConnectionFields", () => $9eb9accda8500b20$export$baa586b00433c23e);
$parcel$export(module.exports, "createGetConnectionFieldsForIssueType", () => $9eb9accda8500b20$export$11ae620ecc7356a6);
$parcel$export(module.exports, "getAllConnectionFieldKeys", () => $9eb9accda8500b20$export$c2d811fb03075299);
$parcel$export(module.exports, "createGetConnectionFieldHighlightableFieldsList", () => $9eb9accda8500b20$export$d1a2cf787eb5e01b);
$parcel$export(module.exports, "createIsConnectionFieldFilterConfigured", () => $9eb9accda8500b20$export$7e09d857dfcb2ec9);
$parcel$export(module.exports, "createGetAllDeliveryFieldsWithData", () => $9eb9accda8500b20$export$5cf0804338f3284c);
$parcel$export(module.exports, "getFieldsForPinning", () => $9eb9accda8500b20$export$dc97c1fe18b97578);

var $ahm5r = parcelRequire("ahm5r");

var $huH03 = parcelRequire("huH03");

var $9pL9Y = parcelRequire("9pL9Y");

var $eTBmS = parcelRequire("eTBmS");

var $evg82 = parcelRequire("evg82");

var $ivkPv = parcelRequire("ivkPv");

var $43e1r = parcelRequire("43e1r");

var $5tOWS = parcelRequire("5tOWS");

var $e27qv = parcelRequire("e27qv");
const $9eb9accda8500b20$export$d90c0acb4bf7532e = (0, $ahm5r.createSelector)((state)=>state.fields, (state)=>state.containerProps?.isAtlasIntegrationEnabled, (state)=>state.containerProps?.isCollectionView, (fields, isAtlasIntegrationEnabled, isCollectionView)=>isAtlasIntegrationEnabled || isCollectionView ? fields : Object.keys(fields).map((key)=>fields[key]).filter((field)=>!(0, $eTBmS.FIELD_TYPES_CATEGORIES).ATLAS.some((type)=>type === field.type)).reduce((result, field)=>Object.assign(result, {
            [field.key]: field
        }), {}));
const $9eb9accda8500b20$export$d5523731e7fe4ded = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$d90c0acb4bf7532e, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(fields, (field)=>!(0, $eTBmS.FIELD_TYPES_CATEGORIES).ARCHIVED.some((type)=>type === field.type)));
const $9eb9accda8500b20$export$367adca86e2ec47c = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$d90c0acb4bf7532e, (fields)=>Object.values(fields));
const $9eb9accda8500b20$export$bde76c894b9b669b = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$d90c0acb4bf7532e, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(fields, (field)=>{
        const isHidden = field.configuration?.hidden;
        const isRestricted = field.hasRestrictedContext;
        return !isHidden && !isRestricted;
    }));
const $9eb9accda8500b20$export$9fe2ffdc49a260cd = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.filter((field)=>field.global && !field.hasRestrictedContext));
const $9eb9accda8500b20$export$23da09631eea700d = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.length);
const $9eb9accda8500b20$export$a314f7fd2cfbe1e3 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.filter((f)=>f.global && f.custom).length);
const $9eb9accda8500b20$export$f3602eb1483982a3 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.find((f)=>f.type === (0, $eTBmS.FIELD_TYPES).ARCHIVED && f.global));
const $9eb9accda8500b20$export$fed7b2b824265a77 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.find((f)=>f.type === (0, $eTBmS.FIELD_TYPES).ARCHIVED_BY && f.global));
const $9eb9accda8500b20$export$37636b4ecbc35eae = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.find((f)=>f.type === (0, $eTBmS.FIELD_TYPES).ARCHIVED_ON && f.global));
const $9eb9accda8500b20$export$2fbb07b5166c6040 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.find((field)=>field.type === (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE));
const $9eb9accda8500b20$export$ed944ac7cf49a521 = (0, $ahm5r.createSelector)((state)=>state.fields, (fields)=>Object.keys(fields).map((key)=>fields[key]).find((field)=>field.type === (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT || field.type === (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL) !== undefined);
const $9eb9accda8500b20$export$87e7305c7ba63c24 = (state)=>state.newlyAddedGlobalFields;
const $9eb9accda8500b20$export$292fa83c763b98e3 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$f3602eb1483982a3, $9eb9accda8500b20$export$fed7b2b824265a77, $9eb9accda8500b20$export$37636b4ecbc35eae, (archivedField, archivedByField, archivedOnField)=>({
        archivedField: archivedField,
        archivedByField: archivedByField,
        archivedOnField: archivedOnField
    }));
const $9eb9accda8500b20$export$b3fd159b04ba8fc1 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$f3602eb1483982a3, $9eb9accda8500b20$export$fed7b2b824265a77, $9eb9accda8500b20$export$37636b4ecbc35eae, (archivedField, archivedByField, archivedOnField)=>archivedField !== undefined && archivedByField !== undefined && archivedOnField !== undefined);
const $9eb9accda8500b20$export$ad84c8179191fc90 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(fields, (field)=>field.label));
const $9eb9accda8500b20$export$5b5c91d414e3b813 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(fields, (field)=>field.type));
const $9eb9accda8500b20$export$3a997aec30de5223 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fieldMap)=>Object.keys(fieldMap));
const $9eb9accda8500b20$export$f0d43ae105c44a16 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fieldKey ? fields[fieldKey] : undefined);
const $9eb9accda8500b20$export$26b8f64e04953389 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>Object.values(fields));
const $9eb9accda8500b20$export$cbdf4c7acce43aed = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fieldKey !== undefined ? fields[fieldKey]?.type : undefined);
const $9eb9accda8500b20$export$c690e8b384bae5e8 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fieldKey !== undefined ? fields[fieldKey]?.label : undefined);
const $9eb9accda8500b20$var$getConnectionCompatibleSystemFields = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>{
    const supportedTypes = [
        (0, $eTBmS.FIELD_TYPES).ASSIGNEE,
        (0, $eTBmS.FIELD_TYPES).LABELS,
        (0, $eTBmS.FIELD_TYPES).REPORTER,
        (0, $eTBmS.FIELD_TYPES).STATUS,
        (0, $eTBmS.FIELD_TYPES).CREATED,
        (0, $eTBmS.FIELD_TYPES).CREATOR,
        (0, $eTBmS.FIELD_TYPES).UPDATED,
        (0, $eTBmS.FIELD_TYPES).ISSUE_KEY,
        (0, $eTBmS.FIELD_TYPES).PROJECT
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(fields, (field)=>supportedTypes.includes(field.type) || (0, $5tOWS.isGlobalSystemField)(field));
});
const $9eb9accda8500b20$export$b95ca9bb53fcdfef = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fieldKey !== undefined ? (0, $eTBmS.isSystemFieldType)(fields[fieldKey].type) : false);
const $9eb9accda8500b20$export$d04d20ad5c11047d = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$var$getConnectionCompatibleSystemFields, (fields)=>{
        if (fieldKey === undefined) return false;
        const field = fields[fieldKey];
        if (field === undefined) return false;
        return true;
    });
const $9eb9accda8500b20$export$503e8c7201146811 = (state)=>state.connectionsFieldsAssociations;
const $9eb9accda8500b20$export$b0a0a8781d8c536f = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fieldKey !== undefined ? (fields[fieldKey]?.global && fields[fieldKey]?.custom) ?? false : false);
const $9eb9accda8500b20$export$8f9f8fcec4e7e493 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>{
        if (fieldKey === undefined || !fields[fieldKey]) return false;
        const field = fields[fieldKey];
        return (0, $5tOWS.isGlobalSystemField)(field);
    });
const $9eb9accda8500b20$export$fe2f6ee73e67fe69 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>{
        if (fieldKey === undefined || !fields[fieldKey]) return false;
        const field = fields[fieldKey];
        return (0, $5tOWS.isGlobalNonSystemField)(field);
    });
const $9eb9accda8500b20$export$ed356202b542678e = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fieldKey !== undefined ? fields[fieldKey]?.play : undefined);
const $9eb9accda8500b20$export$c0736d3defdc2d16 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fieldKey !== undefined ? fields[fieldKey]?.editable : false);
const $9eb9accda8500b20$export$8ab6e7aafdab7605 = (ofType)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.find((field)=>field.type === ofType));
const $9eb9accda8500b20$export$db3f1e906529485e = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>{
        if (fieldKey === undefined || fields[fieldKey] === undefined) return false;
        return !(0, $eTBmS.isSystemFieldType)(fields[fieldKey].type);
    });
const $9eb9accda8500b20$export$c3a80db9f8f140f0 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>{
        const fixedDescriptionFields = [
            'summary',
            'assignee',
            'created',
            'creator',
            'key',
            'reporter',
            'status',
            'updated',
            'labels'
        ];
        const value = fields[fieldKey]?.description ?? '';
        return {
            value: value,
            adf: (0, $ivkPv.parseAdfString)(value),
            fixed: fixedDescriptionFields.includes(fieldKey)
        };
    });
const $9eb9accda8500b20$export$67716b47d053849d = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fields[fieldKey]?.emoji);
const $9eb9accda8500b20$export$e7b67da153139180 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fields[fieldKey]?.formula);
const $9eb9accda8500b20$export$133c26f694dfc813 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>fieldKey !== undefined ? fields[fieldKey]?.presentation : undefined);
const $9eb9accda8500b20$export$45b3e7fa07622627 = (playId)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, (fields)=>Object.keys(fields).map((key)=>fields[key]).find(({ play: play })=>play?.id === playId));
const $9eb9accda8500b20$export$e75cb7c95fc7fe3c = (ofType)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.filter(({ type: type })=>ofType === type).map(({ key: key })=>key));
const $9eb9accda8500b20$export$1bd166026bf50a1e = (fieldKey)=>{
    const getFieldFormula = $9eb9accda8500b20$export$e7b67da153139180(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldFormula, (fieldFormula)=>!!fieldFormula);
};
const $9eb9accda8500b20$export$7828213198a538a2 = (fieldKey)=>{
    const getFieldByKey = $9eb9accda8500b20$export$f0d43ae105c44a16(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldByKey, (field)=>field?.configuration);
};
const $9eb9accda8500b20$export$185ec73baae348f = (fieldKey)=>{
    const getFieldConfiguration = $9eb9accda8500b20$export$7828213198a538a2(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldConfiguration, (configuration)=>configuration?.hidden ?? false);
};
const $9eb9accda8500b20$export$d095f4e3ba265ab2 = (fieldKey)=>{
    const getFieldByKey = $9eb9accda8500b20$export$f0d43ae105c44a16(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldByKey, (field)=>!!field?.hasRestrictedContext);
};
const $9eb9accda8500b20$export$a39dee5f7c34c244 = (fieldKey)=>{
    const getFieldConfiguration = $9eb9accda8500b20$export$7828213198a538a2(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldConfiguration, (configuration)=>configuration?.optionWeightType !== undefined);
};
const $9eb9accda8500b20$export$71732c74215f52ad = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>{
    const count = {
        standardCount: 0,
        votesCount: 0
    };
    fields.forEach(({ type: type })=>{
        if (type === (0, $eTBmS.FIELD_TYPES).VOTES) count.votesCount++;
        else count.standardCount++;
    });
    return count;
});
const $9eb9accda8500b20$export$8746027cc5b4845 = (fieldKey, iconProps)=>{
    const getFieldType = $9eb9accda8500b20$export$cbdf4c7acce43aed(fieldKey);
    const getFieldConfiguration = $9eb9accda8500b20$export$7828213198a538a2(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldType, getFieldConfiguration, (fieldType, configuration)=>(0, $e27qv.iconForPolarisFieldType)(fieldType, iconProps, configuration));
};
const $9eb9accda8500b20$export$5b3d0f4437e26fb1 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.filter((field)=>field.editable).map(({ key: key })=>key));
const $9eb9accda8500b20$export$30d3db0fb1ab5766 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.filter((field)=>field.type === (0, $eTBmS.FIELD_TYPES).SHORT_TEXT));
const $9eb9accda8500b20$export$534bf4b83eda4c1 = (state)=>state.meta.error !== undefined;
const $9eb9accda8500b20$export$37340e201eeb3a5b = (state)=>state.meta.loading;
const $9eb9accda8500b20$export$50e456d0fb04ed15 = (state)=>state.highlightedFields;
const $9eb9accda8500b20$var$createGetConnectionFieldFilters = (fieldKey)=>{
    const getFieldConfiguration = $9eb9accda8500b20$export$7828213198a538a2(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldConfiguration, (configuration)=>configuration?.issueTypeFilters || []);
};
const $9eb9accda8500b20$export$6512893092dfd1cb = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>{
    const allProjectIds = fields.map((f)=>{
        const filter = f.configuration?.issueTypeFilters?.[0];
        if (filter && (0, $evg82.isIssueTypeNameFilter)(filter)) return filter.projectIds;
        return null;
    }).filter(Boolean).flat();
    return [
        ...new Set(allProjectIds)
    ];
});
const $9eb9accda8500b20$export$49930db522e7bea5 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.reduce((acc, field)=>{
        if (field.type !== (0, $eTBmS.FIELD_TYPES).CONNECTION) return acc;
        const highlightedFieldKey = field.configuration?.issueViewLayout?.fields?.[0];
        if (!highlightedFieldKey) return acc;
        const highlightedField = fields.find((f)=>f.key === highlightedFieldKey);
        if (highlightedField?.type === (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT || highlightedField?.type === (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS) {
            const filter = field.configuration?.issueTypeFilters?.[0];
            if (filter && (0, $evg82.isIssueTypeNameFilter)(filter)) acc.push(...filter.projectIds);
        }
        return acc;
    }, []));
const $9eb9accda8500b20$export$9d5df2c0892bb7cb = (fieldKey)=>{
    const getConnectionFieldFilters = $9eb9accda8500b20$var$createGetConnectionFieldFilters(fieldKey);
    return (0, $ahm5r.createSelector)(getConnectionFieldFilters, (filters)=>filters.find((0, $evg82.isIssueTypeNameFilter)) ?? {
            type: 'name',
            names: [],
            projectIds: []
        });
};
const $9eb9accda8500b20$export$332fc2cda09b9bcc = (fieldKey, allIssueTypesByProjectId, allowedProjectIds)=>{
    const getConnectionFieldFilters = $9eb9accda8500b20$var$createGetConnectionFieldFilters(fieldKey);
    return (0, $ahm5r.createSelector)(getConnectionFieldFilters, (filters)=>{
        const issueTypeNameFilter = filters.find((0, $evg82.isIssueTypeNameFilter));
        if (issueTypeNameFilter) return issueTypeNameFilter.projectIds.reduce((acc, projectId)=>{
            if (!allowedProjectIds.includes(projectId)) return acc;
            const issueTypesForProject = allIssueTypesByProjectId[projectId];
            if (issueTypesForProject) acc.push(...issueTypesForProject.filter((issueType)=>issueTypeNameFilter.names.includes(issueType.name)).map(({ id: id })=>id));
            return acc;
        }, []);
        return [];
    });
};
const $9eb9accda8500b20$var$createGetConnectionFieldIssueViewLayoutConfig = (fieldKey)=>{
    const getFieldConfiguration = $9eb9accda8500b20$export$7828213198a538a2(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldConfiguration, (configuration)=>configuration?.issueViewLayout);
};
const $9eb9accda8500b20$export$4c247cf31d8b79eb = (fieldKey)=>{
    const getConnectionFieldIssueViewLayoutConfig = $9eb9accda8500b20$var$createGetConnectionFieldIssueViewLayoutConfig(fieldKey);
    return (0, $ahm5r.createSelector)(getConnectionFieldIssueViewLayoutConfig, $9eb9accda8500b20$export$d5523731e7fe4ded, (issueViewLayout, allFields)=>{
        const highlightedFieldKey = issueViewLayout?.fields?.[0];
        return highlightedFieldKey ? allFields[highlightedFieldKey]?.key : undefined;
    });
};
const $9eb9accda8500b20$export$4f9730e5ef9855a7 = (fieldKey)=>{
    const getConnectionFieldIssueViewLayoutConfig = $9eb9accda8500b20$var$createGetConnectionFieldIssueViewLayoutConfig(fieldKey);
    return (0, $ahm5r.createSelector)(getConnectionFieldIssueViewLayoutConfig, (issueViewLayout)=>issueViewLayout?.sort?.[0]);
};
const $9eb9accda8500b20$export$baa586b00433c23e = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$367adca86e2ec47c, (fields)=>fields.filter((field)=>field.type === (0, $eTBmS.FIELD_TYPES).CONNECTION));
const $9eb9accda8500b20$var$EMPTY_CONNECTION_FIELDS = [];
const $9eb9accda8500b20$export$11ae620ecc7356a6 = ({ projectId: projectId, name: name })=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$baa586b00433c23e, (fields)=>{
        if (!projectId || !name) return $9eb9accda8500b20$var$EMPTY_CONNECTION_FIELDS;
        return fields.filter(({ configuration: configuration })=>{
            if (!configuration || !configuration.issueTypeFilters) return false;
            return configuration.issueTypeFilters.some((filter)=>{
                if ((0, $evg82.isIssueTypeNameFilter)(filter)) return filter.projectIds.includes(projectId) && filter.names.includes(name);
                return false;
            });
        });
    });
const $9eb9accda8500b20$export$c2d811fb03075299 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$baa586b00433c23e, (fields)=>fields.map(({ key: key })=>key));
const $9eb9accda8500b20$export$d1a2cf787eb5e01b = (connectionFieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$export$d5523731e7fe4ded, $9eb9accda8500b20$var$getConnectionCompatibleSystemFields, (allFields, connectionCompatibleSystemFields)=>{
        const excludedFieldTypes = [
            ...(0, $eTBmS.FIELD_TYPES_CATEGORIES).ARCHIVED,
            (0, $eTBmS.FIELD_TYPES).DESCRIPTION,
            (0, $eTBmS.FIELD_TYPES).ISSUE_ID,
            (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE,
            (0, $eTBmS.FIELD_TYPES).CONNECTION,
            (0, $eTBmS.FIELD_TYPES).SUMMARY
        ];
        const isConnectionFieldGlobal = allFields[connectionFieldKey].global === true;
        return Object.values(allFields).filter(({ type: type, global: global, key: key })=>!excludedFieldTypes.includes(type) && (isConnectionFieldGlobal ? global || connectionCompatibleSystemFields[key] !== undefined : true));
    });
const $9eb9accda8500b20$export$7e09d857dfcb2ec9 = (fieldKey)=>(0, $ahm5r.createSelector)($9eb9accda8500b20$var$createGetConnectionFieldFilters(fieldKey), $9eb9accda8500b20$export$2fbb07b5166c6040, (filters, issueTypeField)=>{
        if (!issueTypeField?.issueTypes || filters.length === 0) return false;
        return filters.every((filter)=>{
            if ((0, $evg82.isIssueTypeNameFilter)(filter)) return filter.names.length > 0;
            return true;
        });
    });
const $9eb9accda8500b20$export$5cf0804338f3284c = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$26b8f64e04953389, (fieldsArray)=>{
    return fieldsArray.filter((field)=>(0, $eTBmS.isDeliveryFieldType)(field.type) && (!field.formula || (0, $43e1r.isLinkedIssuesFormula)(field.formula))).map((field)=>({
            key: field.key,
            type: field.type,
            formula: field.formula,
            presentation: field.presentation
        }));
});
const $9eb9accda8500b20$export$dc97c1fe18b97578 = (0, $ahm5r.createSelector)($9eb9accda8500b20$export$26b8f64e04953389, (fields)=>{
    const excludedFieldTypes = [
        ...(0, $eTBmS.FIELD_TYPES_CATEGORIES).ARCHIVED,
        (0, $eTBmS.FIELD_TYPES).DESCRIPTION,
        (0, $eTBmS.FIELD_TYPES).ISSUE_ID,
        (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE,
        (0, $eTBmS.FIELD_TYPES).CONNECTION,
        (0, $eTBmS.FIELD_TYPES).ISSUE_COMMENTS
    ];
    return fields.filter(({ type: type })=>!excludedFieldTypes.some((t)=>t === type)).sort((a, b)=>a.label.localeCompare(b.label));
});

});
parcelRegister("evg82", function(module, exports) {

$parcel$export(module.exports, "isIssueTypeNameFilter", () => $86e07cc436608b49$export$d122ccde9280af01);
const $86e07cc436608b49$export$d122ccde9280af01 = (filter)=>filter.type === 'name';

});

parcelRegister("ivkPv", function(module, exports) {

$parcel$export(module.exports, "getMediaIds", () => $c4fc6ab987c49a2b$export$4400af30140f0400);
$parcel$export(module.exports, "getAllMediaIdsFromComments", () => $c4fc6ab987c49a2b$export$e0543afc3cffefe7);
$parcel$export(module.exports, "parseAdfString", () => $c4fc6ab987c49a2b$export$e9523343c1a01d8b);
$parcel$export(module.exports, "isEmpty", () => $c4fc6ab987c49a2b$export$dd1bc94b04021eeb);

var $aX8Tx = parcelRequire("aX8Tx");

var $4GHTb = parcelRequire("4GHTb");
var $h9WvI = parcelRequire("h9WvI");

var $0mclG = parcelRequire("0mclG");

var $dk7W5 = parcelRequire("dk7W5");
const $c4fc6ab987c49a2b$export$4400af30140f0400 = (doc)=>{
    const mediaIds = [];
    if (doc !== undefined && doc !== null && !(0, $dk7W5.isOnlyWhitespaceAdf)(doc)) (0, $0mclG.traverse)(doc, {
        media: (node)=>{
            if (!node.attrs?.id || node.attrs.collection === undefined) return;
            mediaIds.push(node.attrs.id);
        }
    });
    return mediaIds;
};
const $c4fc6ab987c49a2b$export$e0543afc3cffefe7 = (comments)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(comments.map((comment)=>$c4fc6ab987c49a2b$export$4400af30140f0400(comment.body)));
const $c4fc6ab987c49a2b$export$e9523343c1a01d8b = (value)=>{
    if (!value) return 0, $dk7W5.emptyAdfObject;
    try {
        // case when value is string representation of a number
        if (!Number.isNaN(Number(value))) return (0, $4GHTb.doc)((0, $h9WvI.paragraph)(value));
        return JSON.parse(value);
    // this catch is needed for old descriptions that were saved as primitive strings and cannot be parsed as a JSON
    } catch (e) {
        return (0, $4GHTb.doc)((0, $h9WvI.paragraph)(value));
    }
};
const $c4fc6ab987c49a2b$export$dd1bc94b04021eeb = (0, $dk7W5.isOnlyWhitespaceAdf);

});

parcelRegister("43e1r", function(module, exports) {

$parcel$export(module.exports, "isLinkedIssuesFormula", () => $ea83571cfb86de2a$export$9e80a7e668f590b1);

const $ea83571cfb86de2a$export$9e80a7e668f590b1 = (formula)=>formula.template === (0, $7cea11814386b820$export$d4a53b12a729584d);

});
const $7cea11814386b820$export$d4a53b12a729584d = 'linked_issues';
const $7cea11814386b820$export$b531e22742c09b3d = 'num_linked_issues';
const $7cea11814386b820$export$642e23a2c402ffe1 = 'progress';
const $7cea11814386b820$export$aea281fb9ce2bcae = 'status';
const $7cea11814386b820$export$405b6d72f2d243a9 = 'story_points';
const $7cea11814386b820$export$8775696968c9b13c = 'issue_count';


parcelRegister("e27qv", function(module, exports) {

$parcel$export(module.exports, "iconForPolarisFieldType", () => $059fac97641078d5$export$d457606e54e7c075);
$parcel$export(module.exports, "PolarisIconType", () => $059fac97641078d5$export$5e8403eb012fd9d);
$parcel$export(module.exports, "PolarisIcon", () => $059fac97641078d5$export$a79f21f423588858);
$parcel$export(module.exports, "ViewItemIcon", () => $059fac97641078d5$export$5dbff0380d392fbc);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fL0In = parcelRequire("fL0In");

var $eALjj = parcelRequire("eALjj");

var $lgMTT = parcelRequire("lgMTT");

var $bpdtz = parcelRequire("bpdtz");

var $eTBmS = parcelRequire("eTBmS");

var $6SinZ = parcelRequire("6SinZ");

var $7jTnu = parcelRequire("7jTnu");

var $6TozN = parcelRequire("6TozN");

var $jtLmc = parcelRequire("jtLmc");

var $2jRou = parcelRequire("2jRou");

var $5ne3w = parcelRequire("5ne3w");

var $kftBk = parcelRequire("kftBk");

var $kko7Q = parcelRequire("kko7Q");

var $fYRcn = parcelRequire("fYRcn");

var $eaYM7 = parcelRequire("eaYM7");

var $4krao = parcelRequire("4krao");

var $1ONa8 = parcelRequire("1ONa8");

var $cUNBG = parcelRequire("cUNBG");

var $42Nw2 = parcelRequire("42Nw2");

var $ib9io = parcelRequire("ib9io");

var $e1T25 = parcelRequire("e1T25");

var $6WnKC = parcelRequire("6WnKC");

var $eC3gk = parcelRequire("eC3gk");

var $gUS76 = parcelRequire("gUS76");

var $2mDKP = parcelRequire("2mDKP");

var $96F3M = parcelRequire("96F3M");

var $ibVao = parcelRequire("ibVao");

var $iIfHg = parcelRequire("iIfHg");

var $9T1P9 = parcelRequire("9T1P9");

var $aw4q2 = parcelRequire("aw4q2");

var $5YGaD = parcelRequire("5YGaD");

var $1GvZz = parcelRequire("1GvZz");

var $cmZJ6 = parcelRequire("cmZJ6");

var $kwOe9 = parcelRequire("kwOe9");

var $6Xyzb = parcelRequire("6Xyzb");

var $18m5p = parcelRequire("18m5p");

var $4ox8U = parcelRequire("4ox8U");

var $acgxI = parcelRequire("acgxI");

var $5V4kG = parcelRequire("5V4kG");

var $ejOB8 = parcelRequire("ejOB8");

var $bJG9v = parcelRequire("bJG9v");

var $97auk = parcelRequire("97auk");

var $4oanQ = parcelRequire("4oanQ");

var $10owg = parcelRequire("10owg");

var $7m90E = parcelRequire("7m90E");

var $g0HEW = parcelRequire("g0HEW");

var $76LBd = parcelRequire("76LBd");

var $3T4vj = parcelRequire("3T4vj");

var $khZIV = parcelRequire("khZIV");
const $059fac97641078d5$var$FIELD_TYPE_GLYPH_MAPPING = {
    [(0, $eTBmS.FIELD_TYPES).ASSIGNEE]: [
        (0, $cmZJ6.peopleGlyph),
        'assignee'
    ],
    [(0, $eTBmS.FIELD_TYPES).CREATOR]: [
        (0, $cmZJ6.peopleGlyph),
        'creator'
    ],
    [(0, $eTBmS.FIELD_TYPES).REPORTER]: [
        (0, $cmZJ6.peopleGlyph),
        'reporter'
    ],
    [(0, $eTBmS.FIELD_TYPES).SUMMARY]: [
        (0, $ejOB8.shortTextGlyph),
        'summary'
    ],
    [(0, $eTBmS.FIELD_TYPES).ISSUE_ID]: [
        (0, $eC3gk.hiddenGlyph),
        'issue id'
    ],
    [(0, $eTBmS.FIELD_TYPES).STATUS]: [
        (0, $4oanQ.statusGlyph),
        'status'
    ],
    [(0, $eTBmS.FIELD_TYPES).ISSUE_KEY]: [
        (0, $96F3M.keyGlyph),
        'issue key'
    ],
    [(0, $eTBmS.FIELD_TYPES).ISSUE_TYPE]: [
        (0, $2mDKP.issueTypeGlyph),
        'issue type'
    ],
    [(0, $eTBmS.FIELD_TYPES).SHORT_TEXT]: [
        (0, $ejOB8.shortTextGlyph),
        'short text'
    ],
    [(0, $eTBmS.FIELD_TYPES).HYPERLINK]: [
        (0, $9T1P9.linkGlyph),
        'hyperlink'
    ],
    [(0, $eTBmS.FIELD_TYPES).DATE]: [
        (0, $cUNBG.dateGlyph),
        'date'
    ],
    [(0, $eTBmS.FIELD_TYPES).INTERVAL]: [
        (0, $1ONa8.dateIntervalGlyph),
        'date interval'
    ],
    [(0, $eTBmS.FIELD_TYPES).NUMBER]: [
        (0, $1GvZz.numberGlyph),
        'number'
    ],
    [(0, $eTBmS.FIELD_TYPES).UPDATED]: [
        (0, $g0HEW.timeStampGlyph),
        'updated'
    ],
    [(0, $eTBmS.FIELD_TYPES).CREATED]: [
        (0, $g0HEW.timeStampGlyph),
        'created'
    ],
    [(0, $eTBmS.FIELD_TYPES).LABELS]: [
        (0, $ibVao.labelGlyph),
        'labels'
    ],
    [(0, $eTBmS.FIELD_TYPES).CUSTOM_LABELS]: [
        (0, $ibVao.labelGlyph),
        'labels'
    ],
    [(0, $eTBmS.FIELD_TYPES).SINGLE_SELECT]: [
        (0, $ib9io.dropdownGlyph),
        'single select dropdown'
    ],
    [(0, $eTBmS.FIELD_TYPES).MULTI_SELECT]: [
        (0, $ib9io.dropdownGlyph),
        'multi select dropdown'
    ],
    [(0, $eTBmS.FIELD_TYPES).JSW_MULTI_SELECT]: [
        (0, $ib9io.dropdownGlyph),
        'multi select dropdown'
    ],
    [(0, $eTBmS.FIELD_TYPES).PEOPLE]: [
        (0, $cmZJ6.peopleGlyph),
        'users'
    ],
    [(0, $eTBmS.FIELD_TYPES).JSW_PEOPLE]: [
        (0, $cmZJ6.peopleGlyph),
        'users'
    ],
    [(0, $eTBmS.FIELD_TYPES).REACTIONS]: [
        (0, $4ox8U.reactionGlyph),
        'reactions'
    ],
    [(0, $eTBmS.FIELD_TYPES).CHECKBOX]: [
        (0, $kftBk.checkboxGlyph),
        'checkbox'
    ],
    [(0, $eTBmS.FIELD_TYPES).SLIDER]: [
        (0, $bJG9v.sliderGlyph),
        'slider'
    ],
    [(0, $eTBmS.FIELD_TYPES).RATING]: [
        (0, $18m5p.ratingGlyph),
        'rating'
    ],
    [(0, $eTBmS.FIELD_TYPES).FORMULA]: [
        (0, $6WnKC.formulaGlyph),
        'formula'
    ],
    [(0, $eTBmS.FIELD_TYPES).VOTES]: [
        (0, $iIfHg.likeIconFilledGlyph),
        'play'
    ],
    [(0, $eTBmS.FIELD_TYPES).ISSUE_COMMENTS]: [
        (0, $eaYM7.commentGlyph),
        'comments'
    ],
    [(0, $eTBmS.FIELD_TYPES).LINKED_ISSUES]: [
        (0, $9T1P9.linkGlyph),
        'linked issues'
    ],
    [(0, $eTBmS.FIELD_TYPES).INSIGHTS]: [
        (0, $gUS76.insightsGlyph),
        'insights'
    ],
    [(0, $eTBmS.FIELD_TYPES).ATLAS_GOAL]: [
        (0, $e1T25.atlasGoalGlyph),
        'Atlas goals'
    ],
    [(0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT]: [
        (0, $e1T25.atlasProjectGlyph),
        'Atlas project'
    ],
    [(0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT_STATUS]: [
        (0, $e1T25.atlasProjectStatusGlyph),
        'Atlas project status'
    ],
    [(0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS]: [
        (0, $e1T25.atlasGoalGlyph),
        'goals'
    ],
    [(0, $eTBmS.FIELD_TYPES).PROJECT]: [
        (0, $6Xyzb.projectGlyph),
        'project'
    ]
};
const $059fac97641078d5$var$isFieldTypeGlyphMappingKey = (fieldType)=>fieldType in $059fac97641078d5$var$FIELD_TYPE_GLYPH_MAPPING;
const $059fac97641078d5$export$d457606e54e7c075 = (fieldType, iconProps, configuration)=>{
    // we need 'isWeightedField' because some field types map to multiple icons, eg. MULTI_SELECT_FIELD_TYPE
    const isWeightedField = configuration?.optionWeightType !== undefined;
    const iconPropsInner = iconProps ?? {};
    if (fieldType === undefined) return null;
    if (isWeightedField === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: (0, $acgxI.scalesGlyph),
        size: "small",
        label: "weight",
        ...iconPropsInner
    });
    if (fieldType === (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($059fac97641078d5$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.JiraIcon), {
        size: "small",
        ...iconPropsInner,
        label: "delivery status"
    }));
    if (fieldType === (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($059fac97641078d5$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.JiraIcon), {
        size: "small",
        ...iconPropsInner,
        label: "delivery progress"
    }));
    if ($059fac97641078d5$var$isFieldTypeGlyphMappingKey(fieldType)) {
        const [glyph, label] = $059fac97641078d5$var$FIELD_TYPE_GLYPH_MAPPING[fieldType];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
            glyph: glyph,
            size: "small",
            label: label,
            ...iconPropsInner
        });
    }
    if (fieldType === (0, $eTBmS.FIELD_TYPES).DESCRIPTION) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
        label: "overview",
        color: "var(--ds-icon, #44546F)",
        ...iconPropsInner
    });
    if (fieldType === (0, $eTBmS.FIELD_TYPES).CONNECTION) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khZIV.ConnectionFieldIcon), {
        issueTypeFilters: configuration?.issueTypeFilters
    });
    if (fieldType === (0, $eTBmS.FIELD_TYPES).TEAM) return(// eslint-disable-next-line jira/i18n/text-wrapped-in-format-message
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
        label: "team",
        ...iconPropsInner
    }));
    return null;
};
const $059fac97641078d5$export$5e8403eb012fd9d = {
    ChevronRight: 'PolarisIconChevronRight',
    ChevronUp: 'PolarisIconChevronUp',
    Datapoint: 'PolarisIconDatapoint',
    Board: 'PolarisIconBoard',
    Matrix: 'PolarisIconMatrix',
    Timeline: 'PolarisIconTimeline',
    BulletList: 'PolarisIconBulletList',
    Visible: 'PolarisIconVisible',
    Hidden: 'PolarisIconHidden',
    Scales: 'PolarisIconScales',
    Downvote: 'PolarisIconDownvote',
    Upvote: 'PolarisIconUpvote',
    Poll: 'PolarisIconPoll',
    Switch: 'PolarisIconSwitch',
    AutosaveOff: 'PolarisIconAutosaveOff',
    AutosaveOn: 'PolarisIconAutosaveOn',
    SortMatrixAsc: 'PolarisIconSortMatrixAsc',
    SortMatrixDesc: 'PolarisIconSortMatrixDesc',
    CardLayout: 'PolarisIconCardLayout',
    MergeIdeas: 'PolarisIconMergeIdeas',
    DeliveryTickets: 'PolarisIconDeliveryTickets',
    SetUpXAxis: 'PolarisIconSetUpXAxis',
    SetUpYAxis: 'PolarisIconSetUpYAxis',
    Project: 'PolarisIconProject'
};
const $059fac97641078d5$export$a79f21f423588858 = (props)=>{
    switch(props.name){
        case $059fac97641078d5$export$5e8403eb012fd9d.ChevronRight:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $kko7Q.chevronRightGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.ChevronUp:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $fYRcn.chevronUpGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Datapoint:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $4krao.datapointGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Board:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $jtLmc.boardGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Matrix:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $aw4q2.matrixGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Timeline:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $7m90E.timelineGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.BulletList:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $2jRou.bulletListGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Visible:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $3T4vj.visibleGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Hidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $eC3gk.hiddenGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Scales:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $acgxI.scalesGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Downvote:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $76LBd.upvoteGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Upvote:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $76LBd.upvoteGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Poll:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $kwOe9.pollGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Switch:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $10owg.switchGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.AutosaveOff:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $6TozN.autosaveOffGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.AutosaveOn:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $6TozN.autosaveOnGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.SortMatrixAsc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $97auk.sortAscMatrixGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.SortMatrixDesc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $97auk.sortDescMatrixGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.CardLayout:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $5ne3w.cardLayoutGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.MergeIdeas:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $5YGaD.mergeIdeasGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.DeliveryTickets:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $42Nw2.deliveryTicketsGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.SetUpXAxis:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $5V4kG.setUpXAxisGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.SetUpYAxis:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $5V4kG.setUpYAxisGlyph),
                ...props
            });
        case $059fac97641078d5$export$5e8403eb012fd9d.Project:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: (0, $6Xyzb.projectGlyph),
                ...props
            });
        default:
            return null;
    }
};
const $059fac97641078d5$export$5dbff0380d392fbc = ({ viewKind: viewKind, size: size })=>{
    if (viewKind === (0, $6SinZ.VIEW_KIND_TABLE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($059fac97641078d5$export$a79f21f423588858, {
        name: $059fac97641078d5$export$5e8403eb012fd9d.BulletList,
        size: size ?? 'medium',
        label: ""
    });
    if (viewKind === (0, $6SinZ.VIEW_KIND_BOARD)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($059fac97641078d5$export$a79f21f423588858, {
        name: $059fac97641078d5$export$5e8403eb012fd9d.Board,
        size: size ?? 'medium',
        label: ""
    });
    if (viewKind === (0, $6SinZ.VIEW_KIND_MATRIX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($059fac97641078d5$export$a79f21f423588858, {
        name: $059fac97641078d5$export$5e8403eb012fd9d.Matrix,
        size: size ?? 'medium',
        label: ""
    });
    if (viewKind === (0, $6SinZ.VIEW_KIND_TIMELINE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($059fac97641078d5$export$a79f21f423588858, {
        name: $059fac97641078d5$export$5e8403eb012fd9d.Timeline,
        size: size ?? 'medium',
        label: ""
    });
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $059fac97641078d5$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_w8l5pxbi _1752pxbi _e2oopxbi _1xjxpxbi _1b941txw _14ca1h6o",
            (0, $7jTnu.fg)('jpd-pulsar-list-view-grid-replacement') && "_vr2wpfqs",
            __cmplp.className
        ])
    });
});
const $059fac97641078d5$export$8f56439194ef8d79 = (providedProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
            ...props,
            ...providedProps
        });

});
parcelRegister("6SinZ", function(module, exports) {

$parcel$export(module.exports, "VIEW_KIND_TABLE", () => $72ec8bad55edc66f$export$76e8cbc60f99881d);
$parcel$export(module.exports, "VIEW_KIND_BOARD", () => $72ec8bad55edc66f$export$1ad049af934b4509);
$parcel$export(module.exports, "VIEW_KIND_MATRIX", () => $72ec8bad55edc66f$export$2b0330ebc4df6bb5);
$parcel$export(module.exports, "VIEW_KIND_TIMELINE", () => $72ec8bad55edc66f$export$b536e56a69266159);
$parcel$export(module.exports, "VIEW_KIND_SECTION", () => $72ec8bad55edc66f$export$4f6053f7f1423a0c);
$parcel$export(module.exports, "VIEW_KIND_TWOXTWO", () => $72ec8bad55edc66f$export$84ce1bdcbd34dd0c);
$parcel$export(module.exports, "PROPERTY_LOADING_STATE", () => $72ec8bad55edc66f$export$94e2c990a618478f);
const $72ec8bad55edc66f$export$76e8cbc60f99881d = 'TABLE';
const $72ec8bad55edc66f$export$1ad049af934b4509 = 'BOARD';
const $72ec8bad55edc66f$export$2b0330ebc4df6bb5 = 'MATRIX';
const $72ec8bad55edc66f$export$b536e56a69266159 = 'TIMELINE';
const $72ec8bad55edc66f$export$4f6053f7f1423a0c = 'SECTION';
const $72ec8bad55edc66f$export$84ce1bdcbd34dd0c = 'TWOXTWO';
const $72ec8bad55edc66f$export$94e2c990a618478f = {
    LOADING: 'LOADING',
    LOADED: 'LOADED',
    ERROR: 'ERROR'
};

});

parcelRegister("6TozN", function(module, exports) {

$parcel$export(module.exports, "autosaveOffGlyph", () => $50e40259d1b15ffe$export$b5cd12a2bcab99c3);
$parcel$export(module.exports, "autosaveOnGlyph", () => $50e40259d1b15ffe$export$ca975f435a4e5738);

var $eJOHy = parcelRequire("eJOHy");
const $50e40259d1b15ffe$export$b5cd12a2bcab99c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "m6.973 5.221.747-.747a5.214 5.214 0 0 0-3.863 1.543C2.443 7.43 1.96 9.48 2.569 11.282a.87.87 0 0 1-.53 1.08.806.806 0 0 1-1.059-.486C.17 9.475.812 6.74 2.697 4.856c1.451-1.45 3.41-2.17 5.34-2.046L6.972 1.743A.822.822 0 0 1 8.133.581l2.262 2.263a.904.904 0 0 1-.001 1.277l-2.26 2.26a.82.82 0 0 1-1.16-1.16ZM9.606 19.34l2.26-2.26a.82.82 0 0 1 1.16 1.16l-.745.746c1.4.05 2.809-.49 3.861-1.542 1.414-1.414 1.896-3.463 1.288-5.265a.87.87 0 0 1 .991-1.118.786.786 0 0 1 .598.525c.81 2.4.168 5.134-1.716 7.018-1.452 1.452-3.411 2.171-5.341 2.047l1.067 1.067a.822.822 0 0 1-1.162 1.162l-2.262-2.262a.904.904 0 0 1 0-1.278Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.708 19.442a.997.997 0 0 1-1.631-.326.996.996 0 0 1 .216-1.09l5.893-5.892L8.64 7.73h2.722l.057.172 4.88-4.88a.996.996 0 0 1 1.412.003.996.996 0 0 1 .002 1.412L2.708 19.442Zm7.088-9.918.328-.328-.118-.43-.21.758Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "m9.97 14.294-.113-.001 2.759-2.76L14 15.73h-2.075l-.432-1.582a8.36 8.36 0 0 1-1.523.146Z"
    }));
const $50e40259d1b15ffe$export$ca975f435a4e5738 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "m7.72 4.744-.747.747a.82.82 0 0 0 1.16 1.16l2.261-2.26a.904.904 0 0 0 .001-1.278L8.133.851A.822.822 0 1 0 6.97 2.013L8.038 3.08c-1.93-.125-3.89.595-5.341 2.046C.812 7.011.169 9.744.98 12.146c.146.432.62.65 1.059.486a.87.87 0 0 0 .53-1.08C1.961 9.75 2.443 7.7 3.857 6.286A5.214 5.214 0 0 1 7.72 4.744ZM11.866 17.35l-2.26 2.26a.904.904 0 0 0-.001 1.277l2.262 2.263a.821.821 0 1 0 1.162-1.162l-1.067-1.068c1.93.125 3.89-.595 5.34-2.046 1.885-1.885 2.528-4.618 1.717-7.019a.786.786 0 0 0-.598-.525.82.82 0 0 0-.462.039.87.87 0 0 0-.53 1.08c.609 1.802.127 3.85-1.287 5.264a5.213 5.213 0 0 1-3.861 1.543l.745-.746a.82.82 0 0 0-1.16-1.16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.493 14.417a8.36 8.36 0 0 1-1.523.146c-.48 0-.947-.049-1.463-.134L8.075 16H6l2.639-8h2.722L14 16h-2.075l-.432-1.583Zm-2.59-1.388a8.42 8.42 0 0 0 1.067.073c.36 0 .732-.024 1.127-.085l-1.091-3.982-1.103 3.994Z",
        clipRule: "evenodd"
    }));

});

parcelRegister("jtLmc", function(module, exports) {

$parcel$export(module.exports, "boardGlyph", () => $7e2353618cb54d78$export$669acf0e57565b4f);

var $eJOHy = parcelRequire("eJOHy");
const $7e2353618cb54d78$export$669acf0e57565b4f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fill: "currentColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 11H12.004C12 11 12 5 12 5H3.996C4 5 4 11 4 11ZM3 4.997C3 4.4465 3.449 4 3.995 4H12.005C12.554 4 13 4.4475 13 4.997V11.003C12.9996 11.267 12.8947 11.52 12.7083 11.7068C12.5218 11.8937 12.269 11.9991 12.005 12H3.995C3.73093 11.9995 3.47785 11.8942 3.29131 11.7073C3.10477 11.5204 3 11.2671 3 11.003V4.997Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 5V11H7V5H6ZM9 5V11H10V5H9Z"
    })));

});

parcelRegister("2jRou", function(module, exports) {

$parcel$export(module.exports, "bulletListGlyph", () => $f90bd487d4089fd8$export$a6a7f7b7c0399a2a);

var $eJOHy = parcelRequire("eJOHy");
const $f90bd487d4089fd8$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.1667 10.6667H7.16667C6.70643 10.6667 6.33333 11.0398 6.33333 11.5C6.33333 11.9602 6.70643 12.3333 7.16667 12.3333H12.1667C12.6269 12.3333 13 11.9602 13 11.5C13 11.0398 12.6269 10.6667 12.1667 10.6667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.66667 11.5C4.66667 11.0398 4.29357 10.6667 3.83333 10.6667C3.3731 10.6667 3 11.0398 3 11.5C3 11.9602 3.3731 12.3333 3.83333 12.3333C4.29357 12.3333 4.66667 11.9602 4.66667 11.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.1667 7.33333H7.16667C6.70643 7.33333 6.33333 7.70643 6.33333 8.16667C6.33333 8.6269 6.70643 9 7.16667 9H12.1667C12.6269 9 13 8.6269 13 8.16667C13 7.70643 12.6269 7.33333 12.1667 7.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.66667 8.16667C4.66667 7.70643 4.29357 7.33333 3.83333 7.33333C3.3731 7.33333 3 7.70643 3 8.16667C3 8.6269 3.3731 9 3.83333 9C4.29357 9 4.66667 8.6269 4.66667 8.16667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.1667 4H7.16667C6.70643 4 6.33333 4.3731 6.33333 4.83333C6.33333 5.29357 6.70643 5.66667 7.16667 5.66667H12.1667C12.6269 5.66667 13 5.29357 13 4.83333C13 4.3731 12.6269 4 12.1667 4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.66667 4.83333C4.66667 4.3731 4.29357 4 3.83333 4C3.3731 4 3 4.3731 3 4.83333C3 5.29357 3.3731 5.66667 3.83333 5.66667C4.29357 5.66667 4.66667 5.29357 4.66667 4.83333Z",
        fill: "currentColor"
    }));

});

parcelRegister("5ne3w", function(module, exports) {

$parcel$export(module.exports, "cardLayoutGlyph", () => $87c5e2a5292b263c$export$db0f2d702cac4ae9);

var $eJOHy = parcelRequire("eJOHy");
const $87c5e2a5292b263c$export$db0f2d702cac4ae9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillOpacity: ".01",
        d: "M0 0h24v24H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5h14a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2Zm0 12h6a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Zm0-8h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "m17.11 10.776-.657.944a.604.604 0 1 1-.854-.855l1.581-1.581A.617.617 0 0 1 17.715 9c.232 0 .433.115.534.284l1.581 1.581a.605.605 0 0 1-.854.855l-.657-.944v5.48c0 .294-.27.533-.604.533-.334 0-.605-.239-.605-.533v-5.48Zm1.139 7.845a.617.617 0 0 1-.534.284.617.617 0 0 1-.535-.284L15.6 17.039a.604.604 0 0 1 .854-.855l.657.945v-2.225c0-.294.27-.533.605-.533.333 0 .604.239.604.533v2.225l.657-.945a.605.605 0 0 1 .854.855l-1.581 1.582Z"
    }));

});

parcelRegister("kftBk", function(module, exports) {

$parcel$export(module.exports, "checkboxGlyph", () => $cc1b95547d5e20f3$export$747056db840f2e62);

var $eJOHy = parcelRequire("eJOHy");
const $cc1b95547d5e20f3$export$747056db840f2e62 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2ZM0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3ZM5.71929 7.30529C5.62704 7.20978 5.5167 7.1336 5.39469 7.08119C5.27269 7.02878 5.14147 7.00119 5.00869 7.00004C4.87591 6.99888 4.74423 7.02419 4.62133 7.07447C4.49844 7.12475 4.38679 7.199 4.29289 7.29289C4.199 7.38679 4.12475 7.49844 4.07447 7.62133C4.02419 7.74423 3.99888 7.87591 4.00004 8.00869C4.00119 8.14147 4.02878 8.27269 4.08119 8.39469C4.1336 8.5167 4.20978 8.62704 4.30529 8.71929L6.30529 10.7193C6.49282 10.9068 6.74712 11.0121 7.01229 11.0121C7.27745 11.0121 7.53176 10.9068 7.71929 10.7193L11.7193 6.71929C11.8148 6.62704 11.891 6.5167 11.9434 6.39469C11.9958 6.27269 12.0234 6.14147 12.0245 6.00869C12.0257 5.87591 12.0004 5.74423 11.9501 5.62133C11.8998 5.49844 11.8256 5.38679 11.7317 5.29289C11.6378 5.199 11.5261 5.12475 11.4032 5.07447C11.2803 5.02419 11.1487 4.99888 11.0159 5.00004C10.8831 5.00119 10.7519 5.02878 10.6299 5.08119C10.5079 5.1336 10.3975 5.20978 10.3053 5.30529L7.01229 8.59829L5.71929 7.30529Z",
        fill: "currentColor"
    }));

});

parcelRegister("kko7Q", function(module, exports) {

$parcel$export(module.exports, "chevronRightGlyph", () => $3ffa52ba4fa98538$export$52a64ce081d4ec56);

var $eJOHy = parcelRequire("eJOHy");
const $3ffa52ba4fa98538$export$52a64ce081d4ec56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M10.4714 7.52861C10.7131 7.77036 10.7304 8.15159 10.5232 8.41327L10.4714 8.47142L7.13807 11.8047C6.87772 12.0651 6.45561 12.0651 6.19526 11.8047C5.95351 11.563 5.93624 11.1818 6.14346 10.9201L6.19526 10.8619L9.05717 7.99954L6.19526 5.13809C5.95351 4.89634 5.93624 4.5151 6.14346 4.25342L6.19526 4.19529C6.43702 3.95353 6.81824 3.93625 7.07992 4.14347L7.13807 4.19529L10.4714 7.52861Z",
        fill: "currentColor"
    }));

});

parcelRegister("fYRcn", function(module, exports) {

$parcel$export(module.exports, "chevronUpGlyph", () => $cd6d9a871a6297f3$export$16048e54de89de25);

var $eJOHy = parcelRequire("eJOHy");
const $cd6d9a871a6297f3$export$16048e54de89de25 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.8314 8.48301L6.43781 12.9157C6.15759 13.199 6.00043 13.5814 6.00043 13.9799C6.00043 14.3784 6.15759 14.7609 6.43781 15.0442C6.57543 15.184 6.73947 15.2949 6.92038 15.3707C7.1013 15.4464 7.29547 15.4854 7.49159 15.4854C7.68772 15.4854 7.88189 15.4464 8.0628 15.3707C8.24371 15.2949 8.40775 15.184 8.54537 15.0442L11.9925 11.5686L15.4531 15.0592C15.5911 15.1989 15.7554 15.3097 15.9365 15.3854C16.1177 15.4611 16.3121 15.5 16.5084 15.5C16.7047 15.5 16.899 15.4611 17.0802 15.3854C17.2613 15.3097 17.4257 15.1989 17.5637 15.0592C17.8435 14.7757 18.0004 14.3933 18.0004 13.9949C18.0004 13.5965 17.8435 13.2142 17.5637 12.9307L13.1535 8.48301C12.8434 8.17444 12.424 8.00084 11.9865 8C11.568 8 11.151 8.1605 10.8314 8.48301Z",
        fill: "currentColor"
    }));

});

parcelRegister("eaYM7", function(module, exports) {

$parcel$export(module.exports, "commentGlyph", () => $f20df41e06c7059b$export$835d228e2a9d6a93);

var $eJOHy = parcelRequire("eJOHy");
const $f20df41e06c7059b$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.776 11.6782C5.776 8.97778 8.568 6.78044 12 6.78044C15.432 6.78044 18.224 8.97778 18.224 11.6782C18.224 14.3796 15.432 16.576 12 16.576C8.568 16.576 5.776 14.3796 5.776 11.6782ZM18.9671 18.5858V18.584C18.9671 18.584 17.5769 16.5751 18.2853 15.8142L18.2524 15.832C19.3431 14.6907 20 13.248 20 11.6782C20 7.99644 16.4116 5 12 5C7.58844 5 4 7.99556 4 11.6782C4 15.3609 7.58844 18.3573 12 18.3573C13.2622 18.3573 14.4533 18.104 15.5173 17.6676C16.4089 18.576 17.5502 19.0649 18.3973 19.1956L18.3991 19.1929C18.4458 19.2104 18.495 19.2203 18.5449 19.2222C18.6205 19.2222 18.6949 19.2035 18.7615 19.1677C18.8281 19.1319 18.8847 19.0802 18.9265 19.0171C18.9682 18.9541 18.9937 18.8817 19.0006 18.8065C19.0075 18.7312 18.9966 18.6554 18.9671 18.5858Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15.5556 9.44444H8.44444C7.95352 9.44444 7.55556 9.84241 7.55556 10.3333C7.55556 10.8243 7.95352 11.2222 8.44444 11.2222H15.5556C16.0465 11.2222 16.4444 10.8243 16.4444 10.3333C16.4444 9.84241 16.0465 9.44444 15.5556 9.44444Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.1111 12.1111H8.44444C7.95352 12.1111 7.55556 12.5091 7.55556 13C7.55556 13.4909 7.95352 13.8889 8.44444 13.8889H11.1111C11.602 13.8889 12 13.4909 12 13C12 12.5091 11.602 12.1111 11.1111 12.1111Z",
        fill: "currentColor"
    }));

});

parcelRegister("4krao", function(module, exports) {

$parcel$export(module.exports, "datapointGlyph", () => $59bdbc492d66945f$export$b8ebe0da04ea148b);

var $eJOHy = parcelRequire("eJOHy");
const $59bdbc492d66945f$export$b8ebe0da04ea148b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.9667 14.2686C13.1609 14.4627 13.4242 14.5717 13.6988 14.5717C13.9733 14.5717 14.2367 14.4627 14.4308 14.2686L18.5726 10.1268C18.6715 10.0313 18.7503 9.91706 18.8046 9.79073C18.8589 9.6644 18.8874 9.52853 18.8886 9.39105C18.8898 9.25356 18.8636 9.11722 18.8116 8.98997C18.7595 8.86272 18.6826 8.74711 18.5854 8.64989C18.4882 8.55267 18.3726 8.47579 18.2453 8.42372C18.1181 8.37166 17.9817 8.34546 17.8442 8.34666C17.7067 8.34785 17.5709 8.37642 17.4446 8.43068C17.3182 8.48495 17.204 8.56383 17.1085 8.66272L13.6988 12.0724L11.3245 9.69816C11.1304 9.50404 10.867 9.395 10.5925 9.395C10.3179 9.395 10.0546 9.50404 9.86043 9.69816L5.7187 13.8399C5.53009 14.0352 5.42572 14.2967 5.42808 14.5682C5.43044 14.8397 5.53933 15.0994 5.73131 15.2914C5.92329 15.4834 6.18299 15.5922 6.45447 15.5946C6.72596 15.597 6.98751 15.4926 7.1828 15.304L10.5925 11.8943L12.9667 14.2686Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "18.1896",
        cy: "8.90176",
        r: "1.81042",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "13.6505",
        cy: "13.2697",
        r: "1.81042",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "10.5582",
        cy: "10.6119",
        r: "1.81042",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "5.81042",
        cy: "15.0983",
        r: "1.81042",
        fill: "currentColor"
    }));

});

parcelRegister("1ONa8", function(module, exports) {

$parcel$export(module.exports, "dateIntervalGlyph", () => $b58fe21129b28203$export$26441e0a5dba0178);

var $eJOHy = parcelRequire("eJOHy");
const $b58fe21129b28203$export$26441e0a5dba0178 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.00002 8.51C6.00002 8.228 6.22902 8 6.50002 8H17.5C17.776 8 18 8.228 18 8.51V17.49C18 17.772 17.771 18 17.5 18H6.50002C6.43371 17.9993 6.36817 17.9856 6.30715 17.9597C6.24613 17.9337 6.19082 17.8959 6.14439 17.8486C6.09796 17.8012 6.06132 17.7452 6.03655 17.6836C6.01178 17.6221 5.99937 17.5563 6.00002 17.49V8.51ZM8.00003 11.505V12.495C8.00003 12.786 8.22603 13 8.50503 13H9.49502C9.56164 13.0011 9.62779 12.9888 9.68955 12.9638C9.75131 12.9388 9.80741 12.9016 9.85452 12.8545C9.90163 12.8074 9.93879 12.7513 9.96379 12.6895C9.98878 12.6278 10.0011 12.5616 10 12.495V11.505C10.0011 11.4384 9.98878 11.3722 9.96379 11.3105C9.93879 11.2487 9.90163 11.1926 9.85452 11.1455C9.80741 11.0984 9.75131 11.0612 9.68955 11.0362C9.62779 11.0112 9.56164 10.9989 9.49502 11H8.50503C8.43841 10.9989 8.37226 11.0112 8.3105 11.0362C8.24874 11.0612 8.19264 11.0984 8.14553 11.1455C8.09842 11.1926 8.06126 11.2487 8.03626 11.3105C8.01127 11.3722 7.99894 11.4384 8.00003 11.505V11.505ZM11 11.505V12.495C11 12.786 11.226 13 11.505 13H12.495C12.5616 13.0011 12.6278 12.9888 12.6896 12.9638C12.7513 12.9388 12.8074 12.9016 12.8545 12.8545C12.9016 12.8074 12.9388 12.7513 12.9638 12.6895C12.9888 12.6278 13.0011 12.5616 13 12.495V11.505C13.0011 11.4384 12.9888 11.3722 12.9638 11.3105C12.9388 11.2487 12.9016 11.1926 12.8545 11.1455C12.8074 11.0984 12.7513 11.0612 12.6896 11.0362C12.6278 11.0112 12.5616 10.9989 12.495 11H11.505C11.4384 10.9989 11.3723 11.0112 11.3105 11.0362C11.2487 11.0612 11.1926 11.0984 11.1455 11.1455C11.0984 11.1926 11.0613 11.2487 11.0363 11.3105C11.0113 11.3722 10.9989 11.4384 11 11.505V11.505ZM8.00003 14.505V15.495C8.00003 15.786 8.22603 16 8.50503 16H9.49502C9.56164 16.0011 9.62779 15.9888 9.68955 15.9638C9.75131 15.9388 9.80741 15.9016 9.85452 15.8545C9.90163 15.8074 9.93879 15.7513 9.96379 15.6895C9.98878 15.6278 10.0011 15.5616 10 15.495V14.505C10.0011 14.4384 9.98878 14.3722 9.96379 14.3105C9.93879 14.2487 9.90163 14.1926 9.85452 14.1455C9.80741 14.0984 9.75131 14.0612 9.68955 14.0362C9.62779 14.0112 9.56164 13.9989 9.49502 14H8.50503C8.43841 13.9989 8.37226 14.0112 8.3105 14.0362C8.24874 14.0612 8.19264 14.0984 8.14553 14.1455C8.09842 14.1926 8.06126 14.2487 8.03626 14.3105C8.01127 14.3722 7.99894 14.4384 8.00003 14.505V14.505ZM7.50003 8V9H10.5V8H7.50003ZM13.5 8V9H16.5V8H13.5ZM14 6.505C14 6.226 14.214 6 14.505 6H15.495C15.774 6 16 6.214 16 6.505V8H14V6.505ZM8.00003 6.505C8.00003 6.226 8.21403 6 8.50503 6H9.49502C9.77402 6 10 6.214 10 6.505V8H8.00003V6.505Z",
        fill: "currentColor"
    }));

});

parcelRegister("cUNBG", function(module, exports) {

$parcel$export(module.exports, "dateGlyph", () => $ac0274173c021671$export$54ae6633cc16eed1);

var $eJOHy = parcelRequire("eJOHy");
const $ac0274173c021671$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.77333 5.77778H18.2267C19.2062 5.77778 20 6.57333 20 7.55022V18.2276C20 18.4604 19.9541 18.6909 19.865 18.906C19.7759 19.1211 19.6452 19.3166 19.4805 19.4812C19.3159 19.6458 19.1204 19.7763 18.9052 19.8653C18.6901 19.9544 18.4595 20.0001 18.2267 20H5.77333C5.30317 20 4.85225 19.8133 4.51971 19.4809C4.18717 19.1485 4.00024 18.6977 4 18.2276V7.55022C4 6.57156 4.79289 5.77778 5.77333 5.77778ZM5.77778 9.33333V17.3333C5.77778 17.5691 5.87143 17.7952 6.03813 17.9619C6.20483 18.1286 6.43092 18.2222 6.66667 18.2222H17.3333C17.5691 18.2222 17.7952 18.1286 17.9619 17.9619C18.1286 17.7952 18.2222 17.5691 18.2222 17.3333V9.33333H5.77778ZM6.66667 4.88889C6.66667 4.65314 6.76032 4.42705 6.92702 4.26035C7.09372 4.09365 7.31981 4 7.55556 4C7.7913 4 8.0174 4.09365 8.18409 4.26035C8.35079 4.42705 8.44444 4.65314 8.44444 4.88889V5.77778H6.66667V4.88889ZM15.5556 4.88889C15.5556 4.65314 15.6492 4.42705 15.8159 4.26035C15.9826 4.09365 16.2087 4 16.4444 4C16.6802 4 16.9063 4.09365 17.073 4.26035C17.2397 4.42705 17.3333 4.65314 17.3333 4.88889V5.77778H15.5556V4.88889ZM7.55556 12.8889V11.1102H9.33333V12.8889H7.55556ZM14.6667 12.8889V11.1102H16.4444V12.8889H14.6667ZM11.1111 12.8889V11.1102H12.8898V12.8889H11.1111ZM7.55556 16.4444V14.6667H9.33333V16.4444H7.55556ZM11.1111 16.4444V14.6667H12.8898V16.4444H11.1111ZM14.6667 16.4444V14.6667H16.4444V16.4444H14.6667Z",
        fill: "currentColor"
    }));

});

parcelRegister("42Nw2", function(module, exports) {

$parcel$export(module.exports, "deliveryTicketsGlyph", () => $d38ed3e19f5b5e9e$export$6014753f01dee0d);

var $eJOHy = parcelRequire("eJOHy");
const $d38ed3e19f5b5e9e$export$6014753f01dee0d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.625 9.401h3.064c.997 0 1.811.803 1.811 1.8-.1.446-.113.504-.148.542l-.017.016-.085.13c-.054.077-.128.18-.223.306l-.4.527-.334.433-.629.807c-.524.67-1.052 1.34-1.581 2.008l-.049.061c-.99 1.25-1.98 2.498-2.973 3.744l-.28.35-.073.083c-.344.344-.679.566-.985.685-.19.074-.37.108-.535.108a1.807 1.807 0 0 1-1.813-1.8v-4.626H6.438l-.168-.014c-.95-.16-1.77-.75-1.77-1.76 0-.526.188-.77 3.375-4.769l.093-.117a667.96 667.96 0 0 1 2.976-3.699l.324-.397.197-.21a1.81 1.81 0 0 1 3.08.665c.053.17.08.348.08.527v4.6Zm-2-4.083v6.083h4.495a400.352 400.352 0 0 1-2.606 3.33l-.048.06-1.602 2.019-1.367 1.717-.122.154v-6.106H6.843c.379-.508 1.023-1.323 2.596-3.296l.046-.059.047-.058c.74-.928 1.484-1.854 2.23-2.778l.863-1.066Z",
        clipRule: "evenodd"
    }));

});

parcelRegister("ib9io", function(module, exports) {

$parcel$export(module.exports, "dropdownGlyph", () => $65824b932ea27530$export$d298f123ec74117c);

var $eJOHy = parcelRequire("eJOHy");
const $65824b932ea27530$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5255 16.5255C15.3253 17.7257 13.6974 18.4 12 18.4C10.3026 18.4 8.67475 17.7257 7.47452 16.5255C6.27428 15.3253 5.6 13.6974 5.6 12C5.6 10.3026 6.27428 8.67475 7.47452 7.47452C8.67475 6.27428 10.3026 5.6 12 5.6C13.6974 5.6 15.3253 6.27428 16.5255 7.47452C17.7257 8.67475 18.4 10.3026 18.4 12C18.4 13.6974 17.7257 15.3253 16.5255 16.5255ZM4 12C4 16.4184 7.5816 20 12 20C16.4184 20 20 16.4184 20 12C20 7.5816 16.4184 4 12 4C7.5816 4 4 7.5816 4 12ZM9.0336 10.6344C8.88415 10.7855 8.80033 10.9895 8.80033 11.202C8.80033 11.4145 8.88415 11.6185 9.0336 11.7696L11.3848 14.1416C11.5592 14.3136 11.7848 14.3992 12.008 14.3992C12.2312 14.3992 12.4528 14.3136 12.6232 14.1416L14.9672 11.7776C15.1165 11.6264 15.2001 11.4225 15.2001 11.21C15.2001 10.9975 15.1165 10.7936 14.9672 10.6424C14.8937 10.5679 14.8062 10.5087 14.7096 10.4683C14.6131 10.4278 14.5095 10.407 14.4048 10.407C14.3001 10.407 14.1965 10.4278 14.1 10.4683C14.0034 10.5087 13.9159 10.5679 13.8424 10.6424L12.004 12.496L10.1584 10.6344C10.0848 10.5602 9.99716 10.5012 9.90064 10.461C9.80411 10.4208 9.70057 10.4001 9.596 10.4001C9.49143 10.4001 9.38789 10.4208 9.29136 10.461C9.19483 10.5012 9.10723 10.5602 9.0336 10.6344Z",
        fill: "currentColor"
    }));

});

parcelRegister("e1T25", function(module, exports) {

$parcel$export(module.exports, "atlasProjectGlyph", () => $a9a17f1d26b2a3cf$export$27e1adb59623ce35);
$parcel$export(module.exports, "atlasProjectStatusGlyph", () => $a9a17f1d26b2a3cf$export$70579ef037a67c66);
$parcel$export(module.exports, "atlasGoalGlyph", () => $a9a17f1d26b2a3cf$export$a7752c864486c841);

var $eJOHy = parcelRequire("eJOHy");
const $a9a17f1d26b2a3cf$export$27e1adb59623ce35 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 3.00001C13.5 2.72386 13.2761 2.50001 13 2.50001L10.5178 2.5C10.3852 2.5 10.258 2.55268 10.1642 2.64645L7.78033 5.03034C7.63968 5.17099 7.44891 5.25001 7.25 5.25001L3.01777 5.25001C2.88516 5.25001 2.75798 5.30269 2.66421 5.39646L2.31066 5.75001L4.03033 7.46968C4.32322 7.76257 4.32322 8.23745 4.03033 8.53034L1.78033 10.7803L0.719669 9.71968L2.43934 8.00001L0.71967 6.28034C0.426777 5.98745 0.426777 5.51257 0.71967 5.21968L1.60355 4.3358C1.97863 3.96072 2.48733 3.75001 3.01777 3.75001L6.93934 3.75001L9.10355 1.58579C9.47863 1.21071 9.98734 0.999999 10.5178 1L13 1.00001C14.1046 1.00001 15 1.89544 15 3L15 5.48225C15 6.01268 14.7893 6.52139 14.4142 6.89646L12.25 9.06068L12.25 12.9823C12.25 13.5127 12.0393 14.0214 11.6642 14.3965L10.7803 15.2803C10.6397 15.421 10.4489 15.5 10.25 15.5C10.0511 15.5 9.86032 15.421 9.71967 15.2803L8 13.5607L6.28033 15.2803L5.21967 14.2197L7.46967 11.9697C7.61032 11.829 7.80109 11.75 8 11.75C8.19891 11.75 8.38968 11.829 8.53033 11.9697L10.25 13.6894L10.6036 13.3358C10.6973 13.242 10.75 13.1149 10.75 12.9823L10.75 8.75002C10.75 8.5511 10.829 8.36034 10.9697 8.21969L13.3536 5.8358C13.4473 5.74204 13.5 5.61486 13.5 5.48225L13.5 3.00001ZM6.78033 10.2803L1.78033 15.2803L0.71967 14.2197L5.71967 9.21968L6.78033 10.2803Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.5 4.62501C12.5 5.24633 11.9963 5.75001 11.375 5.75001C10.7537 5.75001 10.25 5.24633 10.25 4.62501C10.25 4.00369 10.7537 3.50001 11.375 3.50001C11.9963 3.50001 12.5 4.00369 12.5 4.62501Z",
        fill: "currentColor"
    }));
const $a9a17f1d26b2a3cf$export$70579ef037a67c66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 2.625C3.5 1.17525 4.67525 0 6.125 0H9.875C11.3247 0 12.5 1.17525 12.5 2.625V11.375C12.5 12.8247 11.3247 14 9.875 14H8.75V16H7.25L7.25 14H6.125C4.67525 14 3.5 12.8247 3.5 11.375V2.625ZM6.125 1.5C5.50368 1.5 5 2.00368 5 2.625V11.375C5 11.9963 5.50368 12.5 6.125 12.5H9.875C10.4963 12.5 11 11.9963 11 11.375V2.625C11 2.00368 10.4963 1.5 9.875 1.5H6.125ZM6.5 4.75C6.5 3.92157 7.17157 3.25 8 3.25C8.82843 3.25 9.5 3.92157 9.5 4.75C9.5 5.57843 8.82843 6.25 8 6.25C7.17157 6.25 6.5 5.57843 6.5 4.75ZM6.5 9.25C6.5 8.42157 7.17157 7.75 8 7.75C8.82843 7.75 9.5 8.42157 9.5 9.25C9.5 10.0784 8.82843 10.75 8 10.75C7.17157 10.75 6.5 10.0784 6.5 9.25Z",
        fill: "currentColor"
    }));
const $a9a17f1d26b2a3cf$export$a7752c864486c841 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5ZM4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8Z",
        fill: "currentColor"
    }));

});

parcelRegister("6WnKC", function(module, exports) {

$parcel$export(module.exports, "formulaGlyph", () => $36f349e266bf91f1$export$2bd8d6a12707bbca);

var $eJOHy = parcelRequire("eJOHy");
const $36f349e266bf91f1$export$2bd8d6a12707bbca = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2579 6.55387C9.45642 6.55387 9.0148 6.93008 8.85123 7.79697L8.77041 8.24723C8.75286 8.34502 8.82803 8.43488 8.92738 8.43488H10.1646C10.4612 8.43488 10.6864 8.70197 10.6362 8.99428L10.5224 9.65672C10.483 9.88635 10.2839 10.0542 10.0509 10.0542H8.59248C8.51509 10.0542 8.44887 10.1097 8.43543 10.186L6.7946 19.4891C6.75427 19.7178 6.55561 19.8845 6.32344 19.8845H5.47856C5.1814 19.8845 4.95613 19.6164 5.00727 19.3237L6.59408 10.2411C6.61113 10.1435 6.53603 10.0542 6.43698 10.0542H6.01665C5.72006 10.0542 5.49493 9.78709 5.54512 9.49478L5.65887 8.83234C5.6983 8.60271 5.89741 8.43488 6.1304 8.43488H6.78653C6.86428 8.43488 6.9307 8.37881 6.94374 8.30216L7.05201 7.66612C7.33007 6.07953 8.19697 5 10.1925 5C10.485 5 10.7247 5.01922 10.9272 5.04724C11.1781 5.08196 11.3363 5.32569 11.2929 5.57523L11.1937 6.1456C11.1471 6.41311 10.8868 6.58865 10.6161 6.56779C10.4999 6.55883 10.3789 6.55387 10.2579 6.55387ZM17.7688 15.9934C17.9369 16.312 17.7058 16.6949 17.3456 16.6949H16.7477C16.3184 16.6949 15.927 16.4487 15.7413 16.0615L14.5998 13.6824C14.5493 13.5771 14.4065 13.56 14.3326 13.6504L12.1765 16.2855C11.9645 16.5447 11.6474 16.6949 11.3125 16.6949H10.743C10.331 16.6949 10.1117 16.2088 10.3844 15.8999L13.3048 12.5918C13.3493 12.5413 13.3574 12.4683 13.325 12.4094L11.5283 9.14394C11.3529 8.82509 11.5836 8.43488 11.9475 8.43488H12.5256C12.9484 8.43488 13.3349 8.67378 13.524 9.05197L14.6932 11.3902C14.7446 11.493 14.8845 11.5093 14.9582 11.4211L17.1172 8.83569C17.3293 8.58169 17.6431 8.43488 17.974 8.43488H18.5206C18.9348 8.43488 19.1533 8.92538 18.8763 9.23328L16.0051 12.425C15.9604 12.4747 15.9514 12.5469 15.9826 12.606L17.7688 15.9934Z",
        fill: "currentColor"
    }));

});

parcelRegister("eC3gk", function(module, exports) {

$parcel$export(module.exports, "hiddenGlyph", () => $802edee4c8b399c6$export$a20e687678823cec);

var $eJOHy = parcelRequire("eJOHy");
const $802edee4c8b399c6$export$a20e687678823cec = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.2071 3.61907C21.5976 4.00959 21.5976 4.64275 21.2071 5.03328L4.70711 21.5333C4.31658 21.9238 3.68342 21.9238 3.29289 21.5333C2.90237 21.1428 2.90237 20.5096 3.29289 20.1191L19.7929 3.61907C20.1834 3.22854 20.8166 3.22854 21.2071 3.61907Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.1619 5.25008C14.8945 4.67646 13.4849 4.32617 12 4.32617H12.001C6.48 4.32617 2 9.16717 2 12.3262C2 13.7123 2.92324 15.4673 4.43188 16.9801L5.85543 15.5565C4.68982 14.3795 4.001 13.1022 4.001 12.3262C4.001 10.3252 7.46 6.32617 12.001 6.32617C12.9154 6.32617 13.7969 6.49966 14.6193 6.79262L16.1619 5.25008ZM16.5131 7.72727L17.9659 6.27452C18.1973 6.43493 18.4211 6.60231 18.6365 6.77548L17.2019 8.21008C16.9822 8.04196 16.7522 7.88033 16.5131 7.72727ZM12.9757 8.43624C12.6564 8.35395 12.3218 8.31017 11.977 8.31017C9.771 8.31017 7.977 10.1042 7.977 12.3102C7.977 12.6549 8.0208 12.9895 8.10313 13.3088L12.9757 8.43624ZM7.4026 16.8378L5.96313 18.2773C6.19088 18.4398 6.42608 18.5957 6.66807 18.7439L8.12972 17.2822C7.87835 17.1436 7.63571 16.9947 7.4026 16.8378ZM9.76817 15.6438C9.53617 15.4896 9.32112 15.3118 9.12645 15.1139L10.5402 13.7002C10.7364 13.903 10.9751 14.0645 11.2417 14.1702L9.76817 15.6438ZM10.1498 18.0906L8.56336 19.677C9.64041 20.0854 10.7994 20.3262 12 20.3262C17.423 20.3262 22 15.4122 22 12.3262C22 11.0666 21.2878 9.53974 20.0815 8.15889L18.6599 9.58049C19.5044 10.5623 19.999 11.5771 19.999 12.3262C19.999 14.0662 16.537 18.3262 12.001 18.3262H12C11.3597 18.3262 10.7407 18.2413 10.1498 18.0906ZM15.9767 12.2637C15.9769 12.2791 15.977 12.2946 15.977 12.3102C15.977 14.5162 14.184 16.3102 11.977 16.3102C11.9615 16.3102 11.946 16.3101 11.9305 16.3099L15.9767 12.2637ZM15.3108 10.1012C15.1566 9.86917 14.9788 9.65411 14.7809 9.45944L13.3672 10.8732C13.57 11.0694 13.7315 11.3081 13.8371 11.5748L15.3108 10.1012Z",
        fill: "currentColor"
    }));

});

parcelRegister("gUS76", function(module, exports) {

$parcel$export(module.exports, "insightsGlyph", () => $7874c85b28d68f4b$export$a50b34c2fa26415e);

var $eJOHy = parcelRequire("eJOHy");
const $7874c85b28d68f4b$export$a50b34c2fa26415e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "11",
        viewBox: "0 0 16 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16 2.58776C16 3.58763 15.1894 4.39818 14.1896 4.39818C14.1246 4.39818 14.0605 4.39476 13.9973 4.38809L11.4607 6.92467L11.461 6.95571C11.461 7.95558 10.6504 8.76613 9.65057 8.76613C8.6507 8.76613 7.84015 7.95558 7.84015 6.95571C7.84015 6.91418 7.84155 6.87297 7.8443 6.83213L7.05226 6.04009C6.89521 6.08454 6.72949 6.10832 6.55822 6.10832C6.40649 6.10832 6.25913 6.08966 6.11829 6.0545L3.6077 8.56509C3.61637 8.63694 3.62083 8.71008 3.62083 8.78426C3.62083 9.78413 2.81028 10.5947 1.81042 10.5947C0.810551 10.5947 0 9.78413 0 8.78426C0 7.7844 0.810551 6.97385 1.81042 6.97385C1.9525 6.97385 2.09076 6.99021 2.22342 7.02117L4.75756 4.48703C4.75111 4.42487 4.7478 4.36177 4.7478 4.2979C4.7478 3.29804 5.55835 2.48749 6.55822 2.48749C7.55808 2.48749 8.36864 3.29804 8.36864 4.2979C8.36864 4.34027 8.36718 4.3823 8.36432 4.42395L9.15447 5.21411C9.31213 5.16929 9.47854 5.14529 9.65057 5.14529C9.84965 5.14529 10.0412 5.17743 10.2204 5.23679L12.4323 3.0249C12.3976 2.88491 12.3792 2.73849 12.3792 2.58776C12.3792 1.58789 13.1897 0.777344 14.1896 0.777344C15.1894 0.777344 16 1.58789 16 2.58776Z",
        fill: "currentColor"
    }));

});

parcelRegister("2mDKP", function(module, exports) {

$parcel$export(module.exports, "issueTypeGlyph", () => $881e799fc22a000d$export$4addf6feba40bda0);

var $eJOHy = parcelRequire("eJOHy");
const $881e799fc22a000d$export$4addf6feba40bda0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 2.25C4.42893 2.25 2.75 3.92893 2.75 6C2.75 7.81422 4.03832 9.32753 5.75 9.67499V7.25C5.75 6.14543 6.64543 5.25 7.75 5.25H10.175C9.82753 3.53832 8.31422 2.25 6.5 2.25ZM11.6968 5.25C11.3329 2.70578 9.14485 0.75 6.5 0.75C3.6005 0.75 1.25 3.1005 1.25 6C1.25 8.64485 3.20578 10.8329 5.75 11.1968V13C5.75 14.1046 6.64543 15 7.75 15H13.5C14.6046 15 15.5 14.1046 15.5 13V7.25C15.5 6.14543 14.6046 5.25 13.5 5.25H11.6968ZM7.75 6.75C7.47386 6.75 7.25 6.97386 7.25 7.25V13C7.25 13.2761 7.47386 13.5 7.75 13.5H13.5C13.7761 13.5 14 13.2761 14 13V7.25C14 6.97386 13.7761 6.75 13.5 6.75H7.75Z",
        fill: "currentColor"
    }));

});

parcelRegister("96F3M", function(module, exports) {

$parcel$export(module.exports, "keyGlyph", () => $02d96898b55c5ef6$export$161505f4144f811b);

var $eJOHy = parcelRequire("eJOHy");
const $02d96898b55c5ef6$export$161505f4144f811b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.22889 14.8718V13.0773L5.81078 12.3774L7.51577 14.8718H8.98881L6.69786 11.5717L8.83825 9H7.47101L5.30214 11.6368H5.22889V9H4V14.8718H5.22889Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13.8067 13.8586H11.1455V12.3733H13.6562V11.4293H11.1455V10.0132H13.8067V9H9.91658V14.8718H13.8067V13.8586Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.9573 14.8718V12.6785L20 9H18.6694L17.3795 11.47H17.3062L16.0122 9H14.6816L16.7284 12.6785V14.8718H17.9573Z",
        fill: "currentColor"
    }));

});

parcelRegister("ibVao", function(module, exports) {

$parcel$export(module.exports, "labelGlyph", () => $3136da26c8f04a66$export$fc64eea29ed0831d);

var $eJOHy = parcelRequire("eJOHy");
const $3136da26c8f04a66$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M10.6445 10.6463C10.4961 10.7972 10.3193 10.9172 10.1243 10.9994C9.92932 11.0816 9.71997 11.1243 9.50835 11.1252C9.29673 11.1261 9.08703 11.085 8.89135 11.0045C8.69568 10.9239 8.51789 10.8053 8.36825 10.6557C8.21861 10.5061 8.10009 10.3283 8.0195 10.1326C7.93892 9.93693 7.89788 9.72723 7.89875 9.51561C7.89963 9.30399 7.94239 9.09464 8.02458 8.89963C8.10677 8.70462 8.22675 8.52782 8.37762 8.37942C8.67836 8.07868 9.08625 7.90972 9.51156 7.90972C9.93687 7.90972 10.3448 8.07868 10.6455 8.37942C10.9462 8.68016 11.1152 9.08805 11.1152 9.51336C11.1152 9.93867 10.9462 10.3466 10.6455 10.6473M11.2671 5.01079L7.21914 5.5881C6.80686 5.64729 6.42491 5.83864 6.13065 6.13342C5.8364 6.42819 5.64572 6.81048 5.58727 7.22287L5.00995 11.2708C4.98853 11.4186 5.00181 11.5694 5.04873 11.7112C5.09566 11.8529 5.17495 11.9819 5.28033 12.0877L11.9146 18.721C12.0039 18.8105 12.11 18.8814 12.2267 18.9298C12.3434 18.9782 12.4685 19.0032 12.5949 19.0032C12.7213 19.0032 12.8464 18.9782 12.9631 18.9298C13.0799 18.8814 13.1859 18.8105 13.2752 18.721L18.7183 13.2779C18.8987 13.0975 19 12.8528 19 12.5977C19 12.3425 18.8987 12.0978 18.7183 11.9174L12.084 5.28213C11.9784 5.17628 11.8496 5.09655 11.7078 5.04928C11.5659 5.002 11.415 4.9885 11.2671 5.00983V5.01079Z",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }));

});

parcelRegister("iIfHg", function(module, exports) {

$parcel$export(module.exports, "likeIconFilledGlyph", () => $8a7330aecfd8e581$export$d579242b773658ff);

var $eJOHy = parcelRequire("eJOHy");
const $8a7330aecfd8e581$export$d579242b773658ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        id: "like-filled-a",
        d: "M4.00029867,12.0000031 L4.00029867,19.0000031 C3.99379083,19.2619469 4.0938648,19.5154845 4.27800285,19.7035645 C4.46214091,19.8916445 4.71487577,19.9984685 4.97933941,20.0000031 L5.99875297,20.0000031 L5.99875297,11.0000031 L4.97933941,11.0000031 C4.71487577,11.0015345 4.46214091,11.1083586 4.27800285,11.2964386 C4.0938648,11.4845186 3.99379083,11.7380562 4.00029867,12.0000031 Z M19.2814088,11.0400031 C18.7031035,10.3648275 17.8537454,9.97663317 16.959972,9.97900342 L14.3256459,9.97900342 C14.3660187,9.79800348 14.4063915,9.61900354 14.4366711,9.4470036 C14.9514245,6.5130046 14.4366711,5.44700497 13.9320109,4.85300517 C13.4705845,4.31076256 12.7907146,3.99849428 12.0748615,4 C10.5305357,4.05274499 9.2630356,5.22781051 9.10745966,6.75100452 C8.71382472,8.59000389 8.6532655,8.75100384 8.13851212,9.47600359 L7.37142865,10.5650032 C7.13702441,10.900368 7.01037109,11.2980817 7.00807332,11.7060028 L7.00807332,17.9790007 C7.0094101,18.5107601 7.22390249,19.0202137 7.60436426,19.3952867 C7.98482603,19.7703597 8.50009148,19.9803277 9.03680723,19.9790426 L16.2837274,19.9790426 C17.7690249,19.9867984 19.0398298,18.9240081 19.2814088,17.4720009 L19.9576535,13.4720022 C20.1064636,12.6021375 19.8588502,11.7116379 19.2814088,11.0400031 Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("use", {
        fill: "currentColor",
        xlinkHref: "#like-filled-a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "inherit",
        d: "M17.2829545,17.140001 C17.2013522,17.6232979 16.7783039,17.9768163 16.2837274,17.9750077 L9.03680723,17.9750077 L9.03680723,11.7060028 L9.8038907,10.6170032 C10.5252697,9.572607 10.9727451,8.36664508 11.105914,7.1080044 C11.1422788,6.56547046 11.3606605,5.89943888 12.0748615,6.00000478 C12.7890625,6.10057068 12.6501741,7.91600412 12.4382168,9.10000372 C12.2228565,10.0810361 11.9326853,11.0444672 11.5702013,11.9820027 L16.959972,11.9740027 C17.2574249,11.9729101 17.5402185,12.1018688 17.7328364,12.3264423 C17.9254544,12.5510157 18.0082813,12.848334 17.9591992,13.1390023 L17.2829545,17.140001 Z"
    })));

});

parcelRegister("9T1P9", function(module, exports) {

$parcel$export(module.exports, "linkGlyph", () => $66ef5863c0141fde$export$a5fad9a16577917b);

var $eJOHy = parcelRequire("eJOHy");
const $66ef5863c0141fde$export$a5fad9a16577917b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.856 5.457l-.937.92a1.002 1.002 0 000 1.437 1.047 1.047 0 001.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 01.203 3.81l-2.903 2.852a2.646 2.646 0 01-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 00-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.144 19.543l.937-.92a1.002 1.002 0 000-1.437 1.047 1.047 0 00-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 01-.203-3.81l2.903-2.852a2.646 2.646 0 013.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 00.357 6.82c1.893 1.517 4.695 1.226 6.422-.47"
    })));

});

parcelRegister("aw4q2", function(module, exports) {

$parcel$export(module.exports, "matrixGlyph", () => $7acef842e315fb89$export$1f216f54d87dd5ab);

var $eJOHy = parcelRequire("eJOHy");
const $7acef842e315fb89$export$1f216f54d87dd5ab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.995 18H19C19.2652 18 19.5196 18.1054 19.7071 18.2929C19.8946 18.4804 20 18.7348 20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H6.995C6.19899 19.9976 5.43646 19.6794 4.8749 19.1152C4.31335 18.551 3.99868 17.787 4 16.991V5C4 4.73478 4.10536 4.48043 4.2929 4.29289C4.48043 4.10536 4.73479 4 5 4C5.26522 4 5.51957 4.10536 5.70711 4.29289C5.89465 4.48043 6 4.73478 6 5V16.991C6 17.548 6.448 18 6.995 18ZM8 8C8 6.89543 8.89543 6 10 6C11.1046 6 12 6.89543 12 8C12 9.10457 11.1046 10 10 10C8.89543 10 8 9.10457 8 8ZM17 10C16.4477 10 16 10.4477 16 11C16 11.5523 16.4477 12 17 12C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10ZM12.5 13C11.6716 13 11 13.6716 11 14.5C11 15.3284 11.6716 16 12.5 16C13.3284 16 14 15.3284 14 14.5C14 13.6716 13.3284 13 12.5 13Z",
        fill: "currentColor"
    }));

});

parcelRegister("5YGaD", function(module, exports) {

$parcel$export(module.exports, "mergeIdeasGlyph", () => $fd8e54078e1deaa4$export$33c5f1d07135f3ff);

var $eJOHy = parcelRequire("eJOHy");
const $fd8e54078e1deaa4$export$33c5f1d07135f3ff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "M16.59 13.943a.957.957 0 1 0 1.346 1.357l2.832-2.808a1.053 1.053 0 0 0 .01-1.486l-2.843-2.82a.958.958 0 0 0-1.35 1.361l2.22 2.2-2.215 2.196Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "M4.706 5.295a.998.998 0 0 0-1.415-.001c-.39.39-.387 1.028.004 1.419l5.233 5.232c.393.394 1.158.713 1.71.713H20.26v-2H10.07L4.706 5.295Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "M4.706 5.295a.998.998 0 0 0-1.415-.001c-.39.39-.387 1.028.004 1.419l5.233 5.232c.393.394 1.158.713 1.71.713H20.26v-2H10.07L4.706 5.295Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        d: "M4.706 5.295a.998.998 0 0 0-1.415-.001c-.39.39-.387 1.028.004 1.419l5.233 5.232c.393.394 1.158.713 1.71.713H20.26v-2H10.07L4.706 5.295Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m7.083 13-3.788 3.787a1.006 1.006 0 0 0 .32 1.637.997.997 0 0 0 1.091-.22l4.1-4.1c-.47-.106-.98-.36-1.278-.659L7.083 13Zm12.178-.158v-.684H9.07l-.572-.572.031-.031c.393-.394 1.158-.713 1.71-.713H20.26v2h-1Z",
        clipRule: "evenodd"
    }));

});

parcelRegister("1GvZz", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $e494d7b666050ae7$export$b368272069fe93ea);

var $eJOHy = parcelRequire("eJOHy");
const $e494d7b666050ae7$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.4413 8C16.3689 8 15.5302 8.54147 15.1904 9.29529L16.3477 9.91108C16.5601 9.53948 16.8786 9.30591 17.4094 9.30591C17.9509 9.30591 18.3756 9.65627 18.3756 10.1871C18.3756 10.6649 18.0783 11.0471 17.4307 11.0471H16.783V12.2256H17.3139C18.1102 12.2256 18.5136 12.6715 18.5136 13.1918C18.5136 13.8076 18.0146 14.1685 17.4307 14.1685C16.7724 14.1685 16.3689 13.8607 16.1778 13.3404L14.925 13.8607C15.2754 14.7843 16.2415 15.4638 17.5368 15.4638C18.9489 15.4638 20 14.6569 20 13.3935C20 12.5441 19.5435 11.939 18.8427 11.6098V11.5886C19.4267 11.2488 19.7877 10.6543 19.7877 9.95355C19.7877 8.70073 18.7366 8 17.4413 8ZM7.36563 8.08494H6.20836L4 9.66689L4.69011 10.7392L5.91108 9.82614V15.3789H7.36563V8.08494ZM11.4214 8C10.2004 8 9.42535 8.60518 9.00066 9.38023L10.0411 10.1234C10.3597 9.59257 10.795 9.33776 11.3046 9.33776C11.8779 9.33776 12.2814 9.76244 12.2814 10.3251C12.2814 10.9091 11.8885 11.4081 11.3046 12.0345L9.03251 14.434L9.05375 15.3789H13.8102V14.0624H11.1453V14.0411L12.5255 12.6184C13.4705 11.6417 13.7359 10.994 13.7359 10.1659C13.7359 8.8069 12.6317 8 11.4214 8Z",
        fill: "currentColor"
    }));

});

parcelRegister("cmZJ6", function(module, exports) {

$parcel$export(module.exports, "peopleGlyph", () => $ec5b715b6badd258$export$2ade78849d2113ea);

var $eJOHy = parcelRequire("eJOHy");
const $ec5b715b6badd258$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.062 13.93C11.158 13.93 10.611 13.196 10.611 11.985C10.611 10.759 11.149 10.033 12.077 10.033C13.005 10.033 13.499 10.797 13.499 12C13.499 13.195 12.997 13.93 12.061 13.93H12.062ZM12 5C8.075 5 5 8.075 5 12C5 16.596 8.522 19 12 19C12.874 19 13.614 18.91 14.26 18.721C14.4417 18.6576 14.5922 18.5269 14.6804 18.3558C14.7686 18.1848 14.7877 17.9863 14.7338 17.8016C14.6799 17.6168 14.5571 17.4598 14.3908 17.3629C14.2245 17.266 14.0273 17.2367 13.84 17.281C13.332 17.428 12.73 17.501 12 17.501C9.352 17.501 6.5 15.779 6.5 12.001C6.5 8.916 8.917 6.501 12 6.501C15.24 6.501 17.5 8.453 17.5 11.251C17.5 13.296 16.457 14.251 15.752 14.251C15.744 14.251 15 14.141 15 13.501V9.501C15 9.30209 14.921 9.11132 14.7803 8.97067C14.6397 8.83002 14.4489 8.751 14.25 8.751C14.0511 8.751 13.8603 8.83002 13.7197 8.97067C13.579 9.11132 13.5 9.30209 13.5 9.501V9.688C13.154 9.103 12.484 8.736 11.705 8.736C10.102 8.736 9 10.04 9 11.938C9 13.922 10.103 15.25 11.753 15.25C12.618 15.25 13.263 14.863 13.618 14.174C13.952 15.19 14.988 15.75 15.75 15.75C17.348 15.75 19 14.067 19 11.25C19 7.628 16.058 5 12 5Z",
        fill: "currentColor"
    }));

});

parcelRegister("kwOe9", function(module, exports) {

$parcel$export(module.exports, "pollGlyph", () => $a92ce4c6c634dbe2$export$7613d8d3644b528c);

var $eJOHy = parcelRequire("eJOHy");
const $a92ce4c6c634dbe2$export$7613d8d3644b528c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "0.33728",
        y: "0.349976",
        width: "13.2684",
        height: "13.3",
        rx: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.32363 5.18502L3.88859 7.64752C3.73328 7.80493 3.64618 8.01738 3.64618 8.23877C3.64618 8.46015 3.73328 8.67261 3.88859 8.83002C3.96486 8.90765 4.05577 8.96929 4.15604 9.01137C4.2563 9.05345 4.36392 9.07512 4.47261 9.07512C4.58131 9.07512 4.68892 9.05345 4.78919 9.01137C4.88945 8.96929 4.98037 8.90765 5.05664 8.83002L6.9671 6.89919L8.88503 8.83835C8.96151 8.91593 9.05258 8.97752 9.15298 9.01956C9.25337 9.0616 9.36109 9.08324 9.46989 9.08324C9.5787 9.08324 9.68642 9.0616 9.78681 9.01956C9.88721 8.97752 9.97828 8.91593 10.0548 8.83835C10.2099 8.68084 10.2968 8.46842 10.2968 8.2471C10.2968 8.02578 10.2099 7.81337 10.0548 7.65585L7.61057 5.18502C7.4387 5.01359 7.20623 4.91715 6.96377 4.91669C6.73182 4.91669 6.50071 5.00585 6.32363 5.18502Z",
        fill: "white"
    }));

});

parcelRegister("6Xyzb", function(module, exports) {

$parcel$export(module.exports, "projectGlyph", () => $7031529993ced372$export$186325d5cb98f5a8);

var $eJOHy = parcelRequire("eJOHy");
const $7031529993ced372$export$186325d5cb98f5a8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        clipPath: "url(#clip0_2381_27797)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.3492 1.9234C14.3492 1.77165 14.226 1.64863 14.0741 1.64863H10.9613C10.8884 1.64863 10.8184 1.67758 10.7668 1.72911L7.54583 4.94589L2.99068 4.9459C2.91771 4.94589 2.84773 4.97484 2.79613 5.02637L2.33456 5.48735L3.69638 6.8474C4.2336 7.38393 4.2336 8.25381 3.69638 8.79033L1.16728 11.3161L0 10.1504L2.33456 7.81887L0.972732 6.45882C0.435507 5.92229 0.435507 5.05241 0.972732 4.51588L1.62886 3.86062C1.99003 3.49991 2.4799 3.29726 2.99068 3.29726L6.86205 3.29726L9.59952 0.563352C9.9607 0.202644 10.4506 0 10.9613 0H14.0741C15.1377 -5.24086e-07 16 0.861136 16 1.9234L16 5.03209C16 5.54221 15.7971 6.03144 15.4359 6.39214L12.6822 9.14223V13.0086C12.6822 13.5187 12.4793 14.0079 12.1182 14.3686L11.4782 15.0077C10.941 15.5442 10.07 15.5442 9.53277 15.0077L8.17094 13.6477L5.81554 16L4.64826 14.8342L7.19821 12.2876C7.73544 11.7511 8.60645 11.7511 9.14367 12.2876L10.5055 13.6477L10.9509 13.2029C11.0025 13.1513 11.0315 13.0814 11.0315 13.0086V8.45935L14.2686 5.22639C14.3202 5.17486 14.3492 5.10497 14.3492 5.03209V1.9234Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.84 4.71017C12.4103 5.13939 11.7134 5.13939 11.2837 4.71017C10.8539 4.28095 10.8539 3.58505 11.2837 3.15583C11.7134 2.72661 12.4103 2.72661 12.84 3.15583C13.2698 3.58505 13.2698 4.28095 12.84 4.71017Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.83642 8.98468L0.267066 14.5468L1.43434 15.7125L7.0037 10.1504L5.83642 8.98468Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("clipPath", {
        id: "clip0_2381_27797"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));

});

parcelRegister("18m5p", function(module, exports) {

$parcel$export(module.exports, "ratingGlyph", () => $b8dd2112ad1777a7$export$2d7108f282e9f737);

var $eJOHy = parcelRequire("eJOHy");
const $b8dd2112ad1777a7$export$2d7108f282e9f737 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.25 6C18.2165 6 19 6.7835 19 7.75V16.5C19 17.4665 18.2165 18.25 17.25 18.25C16.2835 18.25 15.5 17.4665 15.5 16.5V7.75C15.5 6.7835 16.2835 6 17.25 6ZM13.75 11.25C13.75 10.2835 12.9665 9.5 12 9.5C11.0335 9.5 10.25 10.2835 10.25 11.25V16.5C10.25 17.4665 11.0335 18.25 12 18.25C12.9665 18.25 13.75 17.4665 13.75 16.5V11.25ZM8.5 14.75C8.5 13.7835 7.7165 13 6.75 13C5.7835 13 5 13.7835 5 14.75V16.5C5 17.4665 5.7835 18.25 6.75 18.25C7.7165 18.25 8.5 17.4665 8.5 16.5V14.75Z",
        fill: "currentColor"
    }));

});

parcelRegister("4ox8U", function(module, exports) {

$parcel$export(module.exports, "reactionGlyph", () => $0f82426122c16df8$export$f81959c0291a3036);

var $eJOHy = parcelRequire("eJOHy");
const $0f82426122c16df8$export$f81959c0291a3036 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "3 3 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 10.8181 3.23279 9.64778 3.68508 8.55585C4.13738 7.46392 4.80031 6.47177 5.63604 5.63604C6.47177 4.80031 7.46392 4.13738 8.55585 3.68508C9.64778 3.23279 10.8181 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21ZM12 19C12.9193 19 13.8295 18.8189 14.6788 18.4672C15.5281 18.1154 16.2997 17.5998 16.9497 16.9497C17.5998 16.2997 18.1154 15.5281 18.4672 14.6788C18.8189 13.8295 19 12.9193 19 12C19 11.0807 18.8189 10.1705 18.4672 9.32122C18.1154 8.47194 17.5998 7.70026 16.9497 7.05025C16.2997 6.40024 15.5281 5.88463 14.6788 5.53284C13.8295 5.18106 12.9193 5 12 5C10.1435 5 8.36301 5.7375 7.05025 7.05025C5.7375 8.36301 5 10.1435 5 12C5 13.8565 5.7375 15.637 7.05025 16.9497C8.36301 18.2625 10.1435 19 12 19V19ZM8.05 14.197C7.883 13.72 8.152 13.206 8.651 13.047C9.151 12.888 9.69 13.146 9.856 13.622C9.916 13.796 10.081 14.109 10.351 14.418C10.777 14.906 11.307 15.182 12 15.182C12.693 15.182 13.223 14.906 13.65 14.418C13.92 14.108 14.083 13.796 14.144 13.622C14.31 13.146 14.85 12.888 15.349 13.047C15.848 13.206 16.117 13.72 15.951 14.197C15.7598 14.7068 15.4753 15.1765 15.112 15.582C14.348 16.458 13.306 17 12 17C10.694 17 9.652 16.458 8.888 15.582C8.52472 15.1765 8.2402 14.7068 8.049 14.197H8.05ZM9.5 11C9.10218 11 8.72064 10.842 8.43934 10.5607C8.15804 10.2794 8 9.89782 8 9.5C8 9.10218 8.15804 8.72064 8.43934 8.43934C8.72064 8.15804 9.10218 8 9.5 8C9.89782 8 10.2794 8.15804 10.5607 8.43934C10.842 8.72064 11 9.10218 11 9.5C11 9.89782 10.842 10.2794 10.5607 10.5607C10.2794 10.842 9.89782 11 9.5 11ZM14.5 11C14.1022 11 13.7206 10.842 13.4393 10.5607C13.158 10.2794 13 9.89782 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8C14.8978 8 15.2794 8.15804 15.5607 8.43934C15.842 8.72064 16 9.10218 16 9.5C16 9.89782 15.842 10.2794 15.5607 10.5607C15.2794 10.842 14.8978 11 14.5 11Z",
        fill: "currentColor"
    }));

});

parcelRegister("acgxI", function(module, exports) {

$parcel$export(module.exports, "scalesGlyph", () => $2019a331f7810685$export$cf98522838fde478);

var $eJOHy = parcelRequire("eJOHy");
const $2019a331f7810685$export$cf98522838fde478 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M2.6154 15.282C2.47407 15.6226 2.0834 15.7826 1.7434 15.6413C1.4034 15.4993 1.24273 15.1093 1.38407 14.7693L4.46207 6.41064C4.6034 6.07064 4.99407 5.90997 5.3334 6.0513C5.6734 6.1933 5.83407 6.5833 5.69273 6.9233L2.6154 15.282Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.28191 14.7693C9.42324 15.1093 9.26258 15.4993 8.92258 15.6413C8.58258 15.7826 8.19258 15.6226 8.05058 15.282L4.97391 6.92331C4.83258 6.58331 4.99324 6.19331 5.33324 6.05131C5.67324 5.90998 6.06324 6.07065 6.20524 6.41065L9.28191 14.7693ZM15.9492 15.282C15.8072 15.6226 15.4166 15.7826 15.0766 15.6413C14.7366 15.4993 14.5766 15.1093 14.7179 14.7693L17.7952 6.40998C17.9366 6.07065 18.3266 5.90998 18.6666 6.05131C19.0066 6.19331 19.1679 6.58331 19.0259 6.92331L15.9492 15.282V15.282Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M22.6154 14.7693C22.7568 15.1093 22.5968 15.4993 22.2568 15.6413C21.9168 15.7826 21.5261 15.6226 21.3841 15.282L18.3074 6.9233C18.1654 6.5833 18.3268 6.1933 18.6668 6.0513C19.0068 5.90997 19.3968 6.07064 19.5381 6.41064L22.6154 14.7693V14.7693Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.90467 14.6667H0.762C0.341333 14.6667 0 15.0074 0 15.4287C0 17.1114 2.388 18.4761 5.33333 18.4761C8.27867 18.4761 10.6667 17.1114 10.6667 15.4287C10.6667 15.0074 10.3253 14.6667 9.90467 14.6667ZM16 22.6667H8C7.632 22.6667 7.33333 22.3687 7.33333 22.0001C7.33333 20.5274 9.42267 19.3334 12 19.3334C14.5773 19.3334 16.6667 20.5274 16.6667 22.0001C16.6667 22.3687 16.3687 22.6667 16 22.6667ZM23.238 14.6667H14.0953C13.674 14.6667 13.3333 15.0074 13.3333 15.4287C13.3333 17.1114 15.7207 18.4761 18.6667 18.4761C21.6127 18.4761 24 17.1114 24 15.4287C24 15.0074 23.6593 14.6667 23.238 14.6667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.6666 1.99992C12.6666 1.63192 12.3686 1.33325 11.9999 1.33325C11.6319 1.33325 11.3333 1.63192 11.3333 1.99992V19.9999C11.3333 20.3686 11.6319 20.6666 11.9999 20.6666C12.3686 20.6666 12.6666 20.3686 12.6666 19.9999V1.99992Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.0001 3.99992C12.7365 3.99992 13.3334 3.40296 13.3334 2.66659C13.3334 1.93021 12.7365 1.33325 12.0001 1.33325C11.2637 1.33325 10.6667 1.93021 10.6667 2.66659C10.6667 3.40296 11.2637 3.99992 12.0001 3.99992Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.33333 7.99992C6.06971 7.99992 6.66667 7.40296 6.66667 6.66659C6.66667 5.93021 6.06971 5.33325 5.33333 5.33325C4.59695 5.33325 4 5.93021 4 6.66659C4 7.40296 4.59695 7.99992 5.33333 7.99992Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M18.6666 7.99992C19.403 7.99992 19.9999 7.40296 19.9999 6.66659C19.9999 5.93021 19.403 5.33325 18.6666 5.33325C17.9302 5.33325 17.3333 5.93021 17.3333 6.66659C17.3333 7.40296 17.9302 7.99992 18.6666 7.99992Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M18.6666 6.66667C18.6666 7.40267 18.6666 6.66667 11.9999 6.66667C5.33325 6.66667 5.33325 7.40267 5.33325 6.66667C5.33325 5.93067 7.33325 4 11.9999 4C16.6666 4 18.6666 5.93067 18.6666 6.66667Z",
        fill: "currentColor"
    }));

});

parcelRegister("5V4kG", function(module, exports) {

$parcel$export(module.exports, "setUpXAxisGlyph", () => $d8a70d634b0cd5e2$export$ec8d9455a0407f05);
$parcel$export(module.exports, "setUpYAxisGlyph", () => $d8a70d634b0cd5e2$export$a18db6c135f629d9);

var $eJOHy = parcelRequire("eJOHy");
const $d8a70d634b0cd5e2$export$ec8d9455a0407f05 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3.392 1.607a1 1 0 0 1 2 0v10a1 1 0 1 1-2 0v-10Z",
        fill: "var(--ds-icon-accent-gray, #758195)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3.685.858a1 1 0 1 1 1.414 1.414L2.271 5.1A1 1 0 1 1 .856 3.686L3.685.858Z",
        fill: "var(--ds-icon-accent-gray, #758195)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3.685 2.272A1 1 0 1 1 5.099.858l2.829 2.828A1 1 0 0 1 6.513 5.1L3.685 2.272Z",
        fill: "var(--ds-icon-accent-gray, #758195)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.393 10.607a1 1 0 1 1 0 2h-10a1 1 0 1 1 0-2h10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15.142 10.9a1 1 0 1 1-1.415 1.414L10.9 9.486a1 1 0 0 1 1.414-1.415l2.829 2.829Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13.727 10.9a1 1 0 1 1 1.415 1.414l-2.829 2.829a1 1 0 0 1-1.414-1.415l2.829-2.828Z",
        fill: "currentColor"
    }));
const $d8a70d634b0cd5e2$export$a18db6c135f629d9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.393 10.607a1 1 0 1 1 0 2h-10a1 1 0 1 1 0-2h10Z",
        fill: "var(--ds-icon-accent-gray, #758195)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15.142 10.9a1 1 0 0 1-1.414 1.414l-2.829-2.829a1 1 0 1 1 1.415-1.414l2.828 2.828Z",
        fill: "var(--ds-icon-accent-gray, #758195)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13.728 10.9a1 1 0 1 1 1.414 1.414l-2.828 2.828a1 1 0 0 1-1.415-1.414l2.829-2.829Z",
        fill: "var(--ds-icon-accent-gray, #758195)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3.392 1.607a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0v-10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3.685.858a1 1 0 1 1 1.414 1.414L2.271 5.1A1 1 0 1 1 .856 3.686L3.685.858Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3.685 2.272A1 1 0 1 1 5.099.858l2.829 2.828A1 1 0 0 1 6.513 5.1L3.685 2.272Z",
        fill: "currentColor"
    }));

});

parcelRegister("ejOB8", function(module, exports) {

$parcel$export(module.exports, "shortTextGlyph", () => $d104f5b7988fbb57$export$1c6cf19eb34bcc14);

var $eJOHy = parcelRequire("eJOHy");
const $d104f5b7988fbb57$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.90017 6.94518L4.02337 15.4183C4.0008 15.4851 3.99446 15.5563 4.00486 15.626C4.01526 15.6958 4.04211 15.762 4.08318 15.8193C4.12425 15.8766 4.17837 15.9234 4.24106 15.9556C4.30376 15.9879 4.37323 16.0048 4.44373 16.0049H5.3609C5.50353 16.0049 5.6424 15.9591 5.7571 15.8743C5.8718 15.7895 5.95628 15.6702 5.99812 15.5338L6.57401 13.6613H9.89518L10.4702 15.5338C10.512 15.6702 10.5965 15.7895 10.7112 15.8743C10.8259 15.9591 10.9648 16.0049 11.1074 16.0049H12.0966C12.1671 16.0048 12.2365 15.9879 12.2992 15.9556C12.3619 15.9234 12.416 15.8766 12.4571 15.8193C12.4982 15.762 12.525 15.6958 12.5354 15.626C12.5458 15.5563 12.5395 15.4851 12.5169 15.4183L9.63478 6.94429C9.57486 6.7687 9.46148 6.61627 9.31055 6.50837C9.15961 6.40047 8.9787 6.34251 8.79316 6.34262H7.7418C7.55615 6.34257 7.37516 6.40066 7.22421 6.50873C7.07326 6.6168 6.95995 6.76942 6.90017 6.94518ZM8.21193 8.19117H8.25726L9.46948 12.1487H6.99971L8.21193 8.19117ZM18.0883 10.0068V9.71623C18.0883 9.48052 18.182 9.25447 18.3487 9.0878C18.5153 8.92113 18.7414 8.8275 18.9771 8.8275H19.1113C19.347 8.8275 19.573 8.92113 19.7397 9.0878C19.9064 9.25447 20 9.48052 20 9.71623V15.1179C20 15.3536 19.9064 15.5797 19.7397 15.7463C19.573 15.913 19.347 16.0066 19.1113 16.0066H18.9771C18.7414 16.0066 18.5153 15.913 18.3487 15.7463C18.182 15.5797 18.0883 15.3536 18.0883 15.1179V14.8406H18.0101C17.6618 15.6174 16.9152 16.1195 15.8612 16.1195C14.106 16.1195 12.9986 14.686 12.9986 12.4028C12.9986 10.1401 14.1131 8.71463 15.8612 8.71463C16.9028 8.71463 17.6618 9.24342 18.0101 10.0068H18.0883V10.0068ZM18.0484 12.4171C18.0484 11.1106 17.4396 10.2806 16.4895 10.2806C15.5404 10.2806 14.9565 11.0982 14.9565 12.4171C14.9565 13.7422 15.5404 14.5456 16.4895 14.5456C17.4458 14.5456 18.0484 13.7359 18.0484 12.4171Z",
        fill: "currentColor"
    }));

});

parcelRegister("bJG9v", function(module, exports) {

$parcel$export(module.exports, "sliderGlyph", () => $2455ca412aaa00d9$export$5692f596ef132c32);

var $eJOHy = parcelRequire("eJOHy");
const $2455ca412aaa00d9$export$5692f596ef132c32 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 5C6.55229 5 7 4.55228 7 4C7 3.44772 6.55229 3 6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5ZM6 7C7.30622 7 8.41746 6.16519 8.82929 5H15C15.5523 5 16 4.55228 16 4C16 3.44772 15.5523 3 15 3H8.82929C8.41746 1.83481 7.30622 1 6 1C4.69378 1 3.58254 1.83481 3.17071 3H1C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5H3.17071C3.58254 6.16519 4.69378 7 6 7ZM10 11C9.44771 11 9 11.4477 9 12C9 12.5523 9.44771 13 10 13C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11ZM10 9C8.69378 9 7.58254 9.83481 7.17071 11L1 11C0.447714 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13L7.17071 13C7.58254 14.1652 8.69378 15 10 15C11.3062 15 12.4175 14.1652 12.8293 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H12.8293C12.4175 9.83481 11.3062 9 10 9Z",
        fill: "currentColor"
    }));

});

parcelRegister("97auk", function(module, exports) {

$parcel$export(module.exports, "sortAscMatrixGlyph", () => $b03335920df2b282$export$ab10425340e01420);
$parcel$export(module.exports, "sortDescMatrixGlyph", () => $b03335920df2b282$export$8bec0ec196f8276e);

var $eJOHy = parcelRequire("eJOHy");
const $b03335920df2b282$export$ab10425340e01420 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 4C5.7 4 5.4 4.1 5.2 4.3L2.3 7.2C1.9 7.6 1.9 8.3 2.3 8.7C2.7 9.1 3.3 9.1 3.7 8.7L5 7.4L5 19.1C5 19.6 5.4 20 6 20C6.6 20 7 19.6 7 19.1L7 7.4L8.3 8.7C8.7 9.1 9.3 9.1 9.7 8.7C10.1 8.3 10.1 7.6 9.7 7.2L6.8 4.3C6.6 4.1 6.3 4 6 4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13 19L21 19C21.6 19 22 18.6 22 18C22 17.4 21.6 17 21 17L13 17C12.4 17 12 17.4 12 18C12 18.6 12.4 19 13 19Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13 11L18 11C18.6 11 19 11.4 19 12C19 12.6 18.6 13 18 13L13 13C12.4 13 12 12.6 12 12C12 11.4 12.4 11 13 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16 5L13 5C12.4 5 12 5.4 12 6C12 6.6 12.4 7 13 7L16 7C16.6 7 17 6.6 17 6C17 5.4 16.6 5 16 5Z",
        fill: "currentColor"
    }));
const $b03335920df2b282$export$8bec0ec196f8276e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 20C5.7 20 5.4 19.9 5.2 19.7L2.3 16.8C1.9 16.4 1.9 15.7 2.3 15.3C2.7 14.9 3.3 14.9 3.7 15.3L5 16.6V4.9C5 4.4 5.4 4 6 4C6.6 4 7 4.4 7 4.9V16.6L8.3 15.3C8.7 14.9 9.3 14.9 9.7 15.3C10.1 15.7 10.1 16.4 9.7 16.8L6.8 19.7C6.6 19.9 6.3 20 6 20Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13 5H21C21.6 5 22 5.4 22 6C22 6.6 21.6 7 21 7H13C12.4 7 12 6.6 12 6C12 5.4 12.4 5 13 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13 13H18C18.6 13 19 12.6 19 12C19 11.4 18.6 11 18 11H13C12.4 11 12 11.4 12 12C12 12.6 12.4 13 13 13Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16 19H13C12.4 19 12 18.6 12 18C12 17.4 12.4 17 13 17H16C16.6 17 17 17.4 17 18C17 18.6 16.6 19 16 19Z",
        fill: "currentColor"
    }));

});

parcelRegister("4oanQ", function(module, exports) {

$parcel$export(module.exports, "statusGlyph", () => $3b1c15fb0afe7886$export$18247f10a9c5505b);

var $eJOHy = parcelRequire("eJOHy");
const $3b1c15fb0afe7886$export$18247f10a9c5505b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5255 16.5255C15.3253 17.7257 13.6974 18.4 12 18.4C10.3026 18.4 8.67475 17.7257 7.47452 16.5255C6.27428 15.3253 5.6 13.6974 5.6 12C5.6 10.3026 6.27428 8.67475 7.47452 7.47452C8.67475 6.27428 10.3026 5.6 12 5.6C13.6974 5.6 15.3253 6.27428 16.5255 7.47452C17.7257 8.67475 18.4 10.3026 18.4 12C18.4 13.6974 17.7257 15.3253 16.5255 16.5255ZM4 12C4 16.4184 7.5816 20 12 20C16.4184 20 20 16.4184 20 12C20 7.5816 16.4184 4 12 4C7.5816 4 4 7.5816 4 12ZM12.2517 9.23528C12.1017 9.38659 12.0176 9.591 12.0176 9.80404C12.0176 10.0171 12.1017 10.2215 12.2517 10.3728L13.2685 11.3959H8.80075C8.35838 11.3959 8 11.7559 8 12.1999C8 12.6439 8.35838 13.0038 8.80075 13.0038H13.2685L12.2517 14.027C12.1017 14.1783 12.0176 14.3827 12.0176 14.5957C12.0176 14.8088 12.1017 15.0132 12.2517 15.1645C12.4019 15.3145 12.6054 15.3988 12.8177 15.3988C13.0299 15.3988 13.2335 15.3145 13.3836 15.1645L15.7659 12.7686C15.9159 12.6173 16 12.4129 16 12.1999C16 11.9868 15.9159 11.7824 15.7659 11.6311L13.3836 9.23528C13.3095 9.16071 13.2213 9.10154 13.1241 9.06116C13.027 9.02079 12.9229 9 12.8177 9C12.7125 9 12.6083 9.02079 12.5112 9.06116C12.4141 9.10154 12.3259 9.16071 12.2517 9.23528Z",
        fill: "currentColor"
    }));

});

parcelRegister("10owg", function(module, exports) {

$parcel$export(module.exports, "switchGlyph", () => $dbfe32a455bbbec7$export$38ef90ae72047d20);

var $eJOHy = parcelRequire("eJOHy");
const $dbfe32a455bbbec7$export$38ef90ae72047d20 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.2927 0.293135C11.683 -0.097523 12.3162 -0.097739 12.7069 0.292652L15.7069 3.29061L15.7901 3.38478C15.8065 3.40593 15.822 3.42759 15.8365 3.44969C15.8396 3.45646 15.8435 3.46257 15.8473 3.46871C15.8623 3.49043 15.8755 3.51343 15.8876 3.5368C15.8922 3.54775 15.8978 3.55883 15.9031 3.57001C15.9148 3.59257 15.9245 3.61528 15.9333 3.63825C15.9374 3.65076 15.9421 3.66354 15.9465 3.67645C15.9549 3.69947 15.9619 3.72278 15.968 3.74626C15.9713 3.76084 15.9748 3.77552 15.978 3.79033C15.9828 3.81167 15.9867 3.83337 15.9898 3.85515C15.9964 3.90238 16 3.95078 16 4L15.9961 3.90937C15.9978 3.92874 15.999 3.94816 15.9995 3.96759L16 4C16 4.01122 15.9998 4.0224 15.9994 4.03354C15.9988 4.04932 15.9979 4.06498 15.9966 4.08062C15.9948 4.10513 15.992 4.12919 15.9884 4.15298C15.986 4.16598 15.9835 4.17966 15.9808 4.19329C15.9758 4.2213 15.9693 4.24832 15.9617 4.27489C15.9587 4.2833 15.956 4.29199 15.9533 4.30065C15.945 4.3292 15.9349 4.35701 15.9235 4.38421C15.9189 4.39319 15.9149 4.4025 15.9107 4.41175C15.8563 4.5338 15.7776 4.64241 15.6811 4.73218L12.7073 7.70687L12.6132 7.79009C12.221 8.09525 11.6537 8.06771 11.2931 7.70735L11.2099 7.61317C10.9048 7.22098 10.9323 6.65374 11.2927 6.29313L12.584 5H1L0.883379 4.99327C0.38604 4.93551 0 4.51284 0 4C0 3.44772 0.447715 3 1 3H12.586L11.2931 1.70735L11.2099 1.61317C10.9048 1.22098 10.9323 0.653741 11.2927 0.293135Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.70735 8.29313C4.31696 7.90248 3.68379 7.90226 3.29313 8.29265L0.293135 11.2906L0.209914 11.3848C0.19346 11.4059 0.177972 11.4276 0.163452 11.4497C0.160442 11.4565 0.156515 11.4626 0.152653 11.4687C0.137665 11.4904 0.124527 11.5134 0.112375 11.5368C0.107781 11.5478 0.102243 11.5588 0.0969067 11.57C0.0852222 11.5926 0.0755053 11.6153 0.0666666 11.6382C0.0625782 11.6508 0.0579128 11.6635 0.053503 11.6764C0.0450611 11.6995 0.0381117 11.7228 0.0320282 11.7463C0.0286627 11.7608 0.0251751 11.7755 0.0220165 11.7903C0.0171585 11.8117 0.0133133 11.8334 0.0101881 11.8552C0.00355625 11.9024 0 11.9508 0 12L0.0039072 11.9094C0.0021944 11.9287 0.00104523 11.9482 0.000458717 11.9676L0 12C0 12.0112 0.000185013 12.0224 0.000552177 12.0335C0.00119019 12.0493 0.00211239 12.065 0.00340176 12.0806C0.00516224 12.1051 0.00797653 12.1292 0.0116282 12.153C0.014039 12.166 0.0164547 12.1797 0.0191565 12.1933C0.0241671 12.2213 0.0306768 12.2483 0.0382576 12.2749C0.0413313 12.2833 0.0439529 12.292 0.0466957 12.3007C0.0549803 12.3292 0.0651426 12.357 0.0764723 12.3842C0.0810766 12.3932 0.0851307 12.4025 0.0893335 12.4118C0.143727 12.5338 0.222425 12.6424 0.318884 12.7322L3.29265 15.7069L3.38683 15.7901C3.77902 16.0952 4.34626 16.0677 4.70687 15.7073L4.79009 15.6132C5.09525 15.221 5.06771 14.6537 4.70735 14.2931L3.416 13H15L15.1166 12.9933C15.614 12.9355 16 12.5128 16 12C16 11.4477 15.5523 11 15 11H3.414L4.70687 9.70735L4.79009 9.61317C5.09525 9.22098 5.06771 8.65374 4.70735 8.29313Z",
        fill: "currentColor"
    }));

});

parcelRegister("7m90E", function(module, exports) {

$parcel$export(module.exports, "timelineGlyph", () => $53e9e53f80681a68$export$39d896c52e566737);

var $eJOHy = parcelRequire("eJOHy");
const $53e9e53f80681a68$export$39d896c52e566737 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "25",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M.5 0h24v24H.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "4.5",
        y: "5",
        width: "12",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "7.5",
        y: "9",
        width: "12",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "5.5",
        y: "13",
        width: "12",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "8.5",
        y: "17",
        width: "12",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});

parcelRegister("g0HEW", function(module, exports) {

$parcel$export(module.exports, "timeStampGlyph", () => $0224d4ac2331beb6$export$98a4a461fe316fce);

var $eJOHy = parcelRequire("eJOHy");
const $0224d4ac2331beb6$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4C7.588 4 4 7.588 4 12C4 16.412 7.588 20 12 20C16.412 20 20 16.412 20 12C20 7.588 16.412 4 12 4ZM12 18.222C10.3505 18.2199 8.76911 17.5637 7.60272 16.3973C6.43633 15.2309 5.78012 13.6495 5.778 12C5.78012 10.3505 6.43633 8.76911 7.60272 7.60272C8.76911 6.43633 10.3505 5.78012 12 5.778C13.6495 5.78012 15.2309 6.43633 16.3973 7.60272C17.5637 8.76911 18.2199 10.3505 18.222 12C18.2199 13.6495 17.5637 15.2309 16.3973 16.3973C15.2309 17.5637 13.6495 18.2199 12 18.222V18.222ZM12.889 11.632V8.448C12.889 7.959 12.489 7.559 12 7.559C11.511 7.559 11.111 7.959 11.111 8.449V12.004C11.111 12.252 11.214 12.475 11.379 12.637L13.574 14.831C13.741 14.9972 13.9669 15.0904 14.2025 15.0904C14.4381 15.0904 14.664 14.9972 14.831 14.831C14.9969 14.6641 15.0899 14.4383 15.0899 14.203C15.0899 13.9677 14.9969 13.7419 14.831 13.575L12.889 11.632V11.632Z",
        fill: "currentColor"
    }));

});

parcelRegister("76LBd", function(module, exports) {

$parcel$export(module.exports, "upvoteGlyph", () => $bc578b071ff8073c$export$1480e696e99a53ae);

var $eJOHy = parcelRequire("eJOHy");
const $bc578b071ff8073c$export$1480e696e99a53ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "10",
        viewBox: "0 0 16 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15.5749 7.42198L9.00169 0.444771H9.00026C8.73188 0.159985 8.36793 0 7.98845 0C7.60896 0 7.24502 0.159985 6.97664 0.444771L0.404905 7.42198C0.143634 7.70498 -0.00186729 8.08598 1.81198e-05 8.48221C0.00190353 8.87843 0.151024 9.25786 0.414975 9.53803C0.678926 9.81821 1.03638 9.9765 1.40966 9.9785L7.98845 9.99998H14.576C14.7633 10.001 14.9489 9.96258 15.1221 9.88697C15.2953 9.81137 15.4526 9.70007 15.585 9.55952C15.7174 9.41896 15.8223 9.25194 15.8935 9.0681C15.9647 8.88427 16.0009 8.68727 16 8.4885C15.999 8.28973 15.961 8.09313 15.888 7.91006C15.815 7.727 15.7086 7.56111 15.5749 7.42198Z",
        fill: "currentColor"
    }));

});

parcelRegister("3T4vj", function(module, exports) {

$parcel$export(module.exports, "visibleGlyph", () => $9bd1108dbf9f2c25$export$be0c8a08b07ce4a9);

var $eJOHy = parcelRequire("eJOHy");
const $9bd1108dbf9f2c25$export$be0c8a08b07ce4a9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99992 12.0001C4.97592 12.0001 2.66725 9.16008 2.66725 8.00008C2.66725 6.66608 4.97325 4.00008 8.00059 4.00008C10.9179 4.00008 13.3326 6.64875 13.3326 8.00008C13.3326 9.16008 11.0246 12.0001 8.00059 12.0001H7.99992ZM8.00059 2.66675C4.31992 2.66675 1.33325 5.89408 1.33325 8.00008C1.33325 10.0574 4.38392 13.3334 7.99992 13.3334C11.6153 13.3334 14.6666 10.0574 14.6666 8.00008C14.6666 5.89408 11.6799 2.66675 7.99992 2.66675",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.98459 9.32275C7.24925 9.32275 6.65125 8.72475 6.65125 7.98941C6.65125 7.25408 7.24925 6.65608 7.98459 6.65608C8.72059 6.65608 9.31792 7.25408 9.31792 7.98941C9.31792 8.72475 8.72059 9.32275 7.98459 9.32275ZM7.98459 5.32275C6.51392 5.32275 5.31792 6.51875 5.31792 7.98941C5.31792 9.46008 6.51392 10.6561 7.98459 10.6561C9.45592 10.6561 10.6513 9.46008 10.6513 7.98941C10.6513 6.51875 9.45592 5.32275 7.98459 5.32275Z",
        fill: "currentColor"
    }));

});

parcelRegister("khZIV", function(module, exports) {

$parcel$export(module.exports, "ConnectionFieldIcon", () => $b68f03840aa3c186$export$965fc0557919aad0);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $4aDUk = parcelRequire("4aDUk");

var $gNdf2 = parcelRequire("gNdf2");

var $evg82 = parcelRequire("evg82");

var $9h1Bv = parcelRequire("9h1Bv");

var $lRq8t = parcelRequire("lRq8t");

var $he4Rg = parcelRequire("he4Rg");
const $b68f03840aa3c186$export$965fc0557919aad0 = ({ issueTypeFilters: issueTypeFilters = [] })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issueTypeNameFilter = issueTypeFilters.find((0, $evg82.isIssueTypeNameFilter));
    const issueTypeByName = (0, $9h1Bv.useIssueTypeByNameAndProjectIds)({
        name: issueTypeNameFilter?.names[0],
        projectIds: issueTypeNameFilter?.projectIds
    });
    if (issueTypeByName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNdf2.IssueTypeIcon), {
        issueTypeId: issueTypeByName.id
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))), {
        label: formatMessage((0, $he4Rg.messages).connection),
        color: "var(--ds-icon)"
    });
};

});
parcelRegister("gNdf2", function(module, exports) {

$parcel$export(module.exports, "IssueTypeIcon", () => $61279be6f3fcac0a$export$f315b19fd9da0750);

var $eJOHy = parcelRequire("eJOHy");

var $lC3pF = parcelRequire("lC3pF");

var $9h1Bv = parcelRequire("9h1Bv");

var $khB1H = parcelRequire("khB1H");
const $61279be6f3fcac0a$export$f315b19fd9da0750 = ({ issueTypeId: issueTypeId, size: size = 'xsmall' })=>{
    const avatarId = (0, $9h1Bv.useIssueTypeAvatarId)({
        issueTypeId: issueTypeId
    });
    const issueTypeName = (0, $9h1Bv.useIssueTypeName)({
        issueTypeId: issueTypeId
    });
    if (avatarId === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lC3pF.default), {
        appearance: "square",
        size: size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khB1H.IssueTypeAvatar), {
        avatarId: avatarId,
        size: size,
        name: issueTypeName
    });
};

});
parcelRegister("khB1H", function(module, exports) {

$parcel$export(module.exports, "IssueTypeAvatar", () => $1f11bc67b10c0939$export$8d42ebda734216f7);

var $eJOHy = parcelRequire("eJOHy");

var $jGHed = parcelRequire("jGHed");
const $1f11bc67b10c0939$export$8d42ebda734216f7 = ({ avatarId: avatarId, size: size, name: name = '' })=>{
    const sizeInPx = (0, $jGHed.issueTypeAvatarSizesMap)[size];
    const avatarUrl = (0, $jGHed.makeAvatarUrlFromId)(avatarId, size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: avatarUrl,
        alt: name,
        width: sizeInPx,
        height: sizeInPx
    });
};

});


parcelRegister("he4Rg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f7f252c24b4bd6f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2f7f252c24b4bd6f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    connection: {
        "id": "polaris-component-glyphs.glyphs.connection.connection",
        "defaultMessage": "Connection"
    }
});

});





parcelRegister("khyGs", function(module, exports) {

$parcel$export(module.exports, "updateDeliveryDateSelectedField", () => $84bf5c4b1606c993$export$424642c0e1b678c3);

var $gCeeo = parcelRequire("gCeeo");

var $bNW0R = parcelRequire("bNW0R");
const $84bf5c4b1606c993$export$424642c0e1b678c3 = (fieldKey, selectedFieldKey, contextAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        const state = getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const currentField = (0, $bNW0R.createGetFieldByKey)(fieldKey)(state);
        const oldConfiguration = currentField.configuration ? currentField.configuration : {};
        const newConfiguration = {
            ...currentField.configuration
        };
        if (selectedFieldKey) newConfiguration.customfieldKey = selectedFieldKey;
        else delete newConfiguration.customfieldKey;
        const fields = {
            ...getState().fields
        };
        fields[fieldKey] = {
            ...fields[fieldKey],
            configuration: newConfiguration
        };
        setState({
            fields: fields
        });
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfiguration,
            configuration: newConfiguration,
            type: 'updateDeliveryDateSelectedField'
        });
        (0, $gCeeo.fireTrackAnalytics)(contextAnalyticsEvent, 'issueFields updated', {
            issueFieldKey: fieldKey,
            issueFieldType: currentField.type,
            updatedItems: [
                {
                    name: 'customfieldKey'
                }
            ]
        });
    };

});

parcelRegister("28IiO", function(module, exports) {

$parcel$export(module.exports, "updateIntervalFieldSource", () => $bb8fe7c249a41140$export$9915f5b3600d481);

var $gCeeo = parcelRequire("gCeeo");

var $bNW0R = parcelRequire("bNW0R");
const $bb8fe7c249a41140$export$9915f5b3600d481 = (fieldKey, source, contextAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        const state = getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const currentField = (0, $bNW0R.createGetFieldByKey)(fieldKey)(state);
        const oldConfiguration = currentField.configuration ? currentField.configuration : {};
        const newConfiguration = {
            ...currentField.configuration
        };
        if (source) newConfiguration.source = source;
        else {
            delete newConfiguration.source;
            delete newConfiguration.aggregationType;
            delete newConfiguration.customfieldKey;
        }
        const fields = {
            ...getState().fields
        };
        fields[fieldKey] = {
            ...fields[fieldKey],
            configuration: newConfiguration
        };
        setState({
            fields: fields
        });
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfiguration,
            configuration: newConfiguration,
            type: 'updateIntervalFieldSource'
        });
        (0, $gCeeo.fireTrackAnalytics)(contextAnalyticsEvent, 'issueFields updated', {
            issueFieldKey: fieldKey,
            issueFieldType: currentField.type,
            updatedItems: source ? [
                {
                    name: 'source'
                }
            ] : [
                {
                    name: 'source'
                },
                {
                    name: 'aggregationType'
                },
                {
                    name: 'customfieldKey'
                }
            ]
        });
    };

});

parcelRegister("3iP9N", function(module, exports) {

$parcel$export(module.exports, "loadFields", () => $ca0d0ea6b76a3a5d$export$6c106ef18bd092b8);

var $5zHFN = parcelRequire("5zHFN");

var $g1rXq = parcelRequire("g1rXq");

var $8okDh = parcelRequire("8okDh");
// Error message: [...] API-9998 permission check failed [...]
const $ca0d0ea6b76a3a5d$var$isPermissionCheckError = (error)=>error instanceof Error ? error.message.search('API-9998') !== -1 : false;
const $ca0d0ea6b76a3a5d$var$detectAndHandleCyclicFormulaDependency = (containerProps, fields)=>{
    const cyclicFieldLabels = Object.values(fields).map((field)=>field.hasCyclicFormulaDependency ? field.label : undefined).filter(Boolean);
    if (cyclicFieldLabels.length > 0) containerProps.onCyclicFormulaDependencyDetected(cyclicFieldLabels);
};
const $ca0d0ea6b76a3a5d$export$6c106ef18bd092b8 = (forceReload, scheduledReload)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, containerProps)=>{
        const { containerAri: containerAri, isProjectOnboarded: isProjectOnboarded, fieldRemote: fieldRemote, isSiteAdmin: isSiteAdmin } = containerProps;
        const loadingProps = {
            containerAri: containerAri,
            isProjectOnboarded: isProjectOnboarded
        };
        const { meta: { loadingProps: previousLoadingProps, loading: isLoadingInProgress, initialized: initialized } } = getState();
        // Only load again when the props this function depends on have changed
        if (forceReload !== true && (0, $5zHFN.isShallowEqual)(loadingProps, previousLoadingProps)) {
            if (!getState().meta.projectIsNotOnboardedError) return;
        }
        if (forceReload !== true && !scheduledReload) {
            if (initialized) return;
            if (isLoadingInProgress) {
                setState({
                    meta: {
                        ...getState().meta,
                        scheduleFieldsReload: true
                    }
                });
                return;
            }
        }
        (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_FIELDS_START));
        setState({
            meta: {
                ...getState().meta,
                initialized: false,
                loading: true,
                error: undefined,
                loadingProps: loadingProps,
                projectIsNotOnboardedError: false
            }
        });
        try {
            const fieldData = await fieldRemote.fetchAllFields();
            (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_FIELDS_END));
            setState({
                meta: {
                    ...getState().meta,
                    initialized: true,
                    loading: false,
                    scheduleFieldsReload: false,
                    projectIsNotOnboardedError: false,
                    error: undefined,
                    loadingProps: loadingProps
                },
                ...fieldData
            });
            $ca0d0ea6b76a3a5d$var$detectAndHandleCyclicFormulaDependency(containerProps, fieldData.fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_FIELDS_END));
            if (error instanceof (0, $g1rXq.RemoteFieldsNotInitializedError)) {
                const scheduleFieldsReload = getState().meta.scheduleFieldsReload;
                if (!getState().meta.initialized || forceReload === true) {
                    setState({
                        meta: {
                            ...getState().meta,
                            initialized: false,
                            loading: false,
                            scheduleFieldsReload: false,
                            projectIsNotOnboardedError: true
                        }
                    });
                    if (scheduleFieldsReload) {
                        setState({
                            meta: {
                                ...getState().meta,
                                loading: false,
                                scheduleFieldsReload: false
                            }
                        });
                        dispatch($ca0d0ea6b76a3a5d$export$6c106ef18bd092b8(false, true));
                    }
                }
                // we return early here,
                // we want to try loading again since the project is still loading
                return;
            }
            const scheduleFieldsReload = getState().meta.scheduleFieldsReload;
            setState({
                meta: {
                    ...getState().meta,
                    initialized: false,
                    loading: false,
                    error: error,
                    scheduleFieldsReload: false,
                    projectIsNotOnboardedError: false,
                    loadingProps: undefined
                },
                fields: {},
                fieldValueDecorations: {}
            });
            if (scheduleFieldsReload) {
                dispatch($ca0d0ea6b76a3a5d$export$6c106ef18bd092b8(false, true));
                return;
            }
            if (error instanceof (0, $g1rXq.AccessForbiddenError)) return;
            if (error instanceof (0, $g1rXq.SharedViewFieldsUnavailableError) || error instanceof (0, $g1rXq.SharedViewAuthenticationMissingError)) return;
            if ($ca0d0ea6b76a3a5d$var$isPermissionCheckError(error) && isSiteAdmin) // shallow perms error for site admins as they still need to access setting page
            // even without project permissions
            return;
            containerProps.onFieldLoadingFailed(error);
        }
    };

});
parcelRegister("5zHFN", function(module, exports) {

$parcel$export(module.exports, "isShallowEqual", () => $5a87fd5baf9e9250$export$2225b4c39d37f8b3);

var $exWdq = parcelRequire("exWdq");

var $4sprp = parcelRequire("4sprp");

var $4c94y = parcelRequire("4c94y");

var $jvwCK = parcelRequire("jvwCK");
const $5a87fd5baf9e9250$export$2225b4c39d37f8b3 = (a, b, debug = false)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(b)) {
        if (a.length !== b.length) {
            if (debug) // eslint-disable-next-line no-console
            console.log('arrays not of equal length', a, b);
            return false;
        }
        return a.every((value, index)=>{
            if (value !== b[index]) {
                if (debug) // eslint-disable-next-line no-console
                console.log(`[${index}]`, value, '!=', b[index]);
                return false;
            }
            return true;
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(a),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(b)
    ]).every((key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(b, key)) {
            if (debug) // eslint-disable-next-line no-console
            console.log('property missing in [arg2]', key);
            return false;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(a, key)) {
            if (debug) // eslint-disable-next-line no-console
            console.log('property missing in [arg1]', key);
            return false;
        }
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
        if (!Object.is(a[key], b[key])) {
            if (debug) /* eslint-disable-next-line no-console */ // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
            console.log(`[${key}]`, a[key], '!=', b[key]);
            return false;
        }
        return true;
    });
};

});

parcelRegister("g1rXq", function(module, exports) {

$parcel$export(module.exports, "SharedViewFieldsUnavailableError", () => $5f81ea679145f947$export$8455a765a5451e58);
$parcel$export(module.exports, "SharedViewAuthenticationMissingError", () => $5f81ea679145f947$export$c50803463abdf78b);
$parcel$export(module.exports, "RemoteFieldsNotInitializedError", () => $5f81ea679145f947$export$c7d5832f2a965ec7);
$parcel$export(module.exports, "AccessForbiddenError", () => $5f81ea679145f947$export$b8482e3dee2b654c);
/* eslint-disable max-classes-per-file */ 
var $1uIew = parcelRequire("1uIew");
class $5f81ea679145f947$export$8455a765a5451e58 extends (0, $1uIew.default) {
}
class $5f81ea679145f947$export$c50803463abdf78b extends Error {
}
class $5f81ea679145f947$export$c7d5832f2a965ec7 extends Error {
}
class $5f81ea679145f947$export$b8482e3dee2b654c extends Error {
}

});

parcelRegister("8okDh", function(module, exports) {

$parcel$export(module.exports, "PAGE_LOAD_MARK_INITIAL_RENDER_START", () => $6b924b2dad5a4c16$export$d94e22e398b40d3e);
$parcel$export(module.exports, "PAGE_LOAD_MARK_INITIAL_RENDER_END", () => $6b924b2dad5a4c16$export$25faf068e86e1827);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_VIEWS_START", () => $6b924b2dad5a4c16$export$b6e521c1c735f819);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_VIEWS_END", () => $6b924b2dad5a4c16$export$2d39e56eb6bc61e2);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_PROJECT_START", () => $6b924b2dad5a4c16$export$e9ade44ad4706ce2);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_PROJECT_END", () => $6b924b2dad5a4c16$export$62ccc5c18b320a1c);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_INSIGHTS_START", () => $6b924b2dad5a4c16$export$143502466d17e9b1);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_INSIGHTS_END", () => $6b924b2dad5a4c16$export$a8581b9dacd8996a);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_FIELDS_START", () => $6b924b2dad5a4c16$export$bbdca1640a59e683);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_FIELDS_END", () => $6b924b2dad5a4c16$export$77c443b5622981d3);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_ISSUES_START", () => $6b924b2dad5a4c16$export$5899a9a7e5194e40);
$parcel$export(module.exports, "PAGE_LOAD_MARK_LOAD_ISSUES_END", () => $6b924b2dad5a4c16$export$b33e4b126300862b);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_VIEW_MAIN_START", () => $6b924b2dad5a4c16$export$7cb35720e348e7d6);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_VIEW_MAIN_END", () => $6b924b2dad5a4c16$export$346e293d7601d12);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_LIST_VIEW_START", () => $6b924b2dad5a4c16$export$7cb16aaae52cb7c4);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_LIST_VIEW_END", () => $6b924b2dad5a4c16$export$c00320feb79e362);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_BOARD_VIEW_START", () => $6b924b2dad5a4c16$export$804cba7c4155c239);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_BOARD_VIEW_END", () => $6b924b2dad5a4c16$export$92f49e88c0cf9398);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_MATRIX_VIEW_START", () => $6b924b2dad5a4c16$export$c7df8588815a5dff);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_MATRIX_VIEW_END", () => $6b924b2dad5a4c16$export$6d58a19b2a5a7d6c);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_TIMELINE_VIEW_START", () => $6b924b2dad5a4c16$export$5c41eba619cf4422);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_TIMELINE_VIEW_END", () => $6b924b2dad5a4c16$export$70d7f5af83b810d1);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_BOARD_SWIMLANE_VIEW_START", () => $6b924b2dad5a4c16$export$f287ddc953d21ba2);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_BOARD_SWIMLANE_VIEW_END", () => $6b924b2dad5a4c16$export$a2ceee803729727c);
$parcel$export(module.exports, "getJpdProjectPageLoadMetric", () => $6b924b2dad5a4c16$export$fd6d36ad90baf6f6);
$parcel$export(module.exports, "jpdProjectPageLoad", () => $6b924b2dad5a4c16$export$ba35263e5f55f1c8);
$parcel$export(module.exports, "jpdProjectPageLoadPermissionsStart", () => $6b924b2dad5a4c16$export$e8787017048b5d03);
$parcel$export(module.exports, "jpdProjectPageLoadPermissionsEnd", () => $6b924b2dad5a4c16$export$e12eec0846d40def);

var $hqYEY = parcelRequire("hqYEY");
const $6b924b2dad5a4c16$export$d94e22e398b40d3e = 'PAGE_LOAD_MARK_INITIAL_RENDER_START';
const $6b924b2dad5a4c16$export$25faf068e86e1827 = 'PAGE_LOAD_MARK_INITIAL_RENDER_END';
const $6b924b2dad5a4c16$export$4ba1c1d0a3f1fcf9 = 'PAGE_LOAD_MARK_LOAD_PERMISSIONS_START';
const $6b924b2dad5a4c16$export$c68cd8d9163d8024 = 'PAGE_LOAD_MARK_LOAD_PERMISSIONS_END';
const $6b924b2dad5a4c16$export$b6e521c1c735f819 = 'PAGE_LOAD_MARK_LOAD_VIEWS_START';
const $6b924b2dad5a4c16$export$2d39e56eb6bc61e2 = 'PAGE_LOAD_MARK_LOAD_VIEWS_END';
const $6b924b2dad5a4c16$export$e9ade44ad4706ce2 = 'PAGE_LOAD_MARK_LOAD_PROJECT_START';
const $6b924b2dad5a4c16$export$62ccc5c18b320a1c = 'PAGE_LOAD_MARK_LOAD_PROJECT_END';
const $6b924b2dad5a4c16$export$143502466d17e9b1 = 'PAGE_LOAD_MARK_LOAD_INSIGHTS_START';
const $6b924b2dad5a4c16$export$a8581b9dacd8996a = 'PAGE_LOAD_MARK_LOAD_INSIGHTS_END';
const $6b924b2dad5a4c16$export$bbdca1640a59e683 = 'PAGE_LOAD_MARK_LOAD_FIELDS_START';
const $6b924b2dad5a4c16$export$77c443b5622981d3 = 'PAGE_LOAD_MARK_LOAD_FIELDS_END';
const $6b924b2dad5a4c16$export$5899a9a7e5194e40 = 'PAGE_LOAD_MARK_LOAD_ISSUES_START';
const $6b924b2dad5a4c16$export$b33e4b126300862b = 'PAGE_LOAD_MARK_LOAD_ISSUES_END';
const $6b924b2dad5a4c16$export$7cb35720e348e7d6 = 'PAGE_LOAD_MARK_RENDER_VIEW_MAIN_START';
const $6b924b2dad5a4c16$export$346e293d7601d12 = 'PAGE_LOAD_MARK_RENDER_VIEW_MAIN_END';
const $6b924b2dad5a4c16$export$7cb16aaae52cb7c4 = 'PAGE_LOAD_MARK_RENDER_LIST_VIEW_START';
const $6b924b2dad5a4c16$export$c00320feb79e362 = 'PAGE_LOAD_MARK_RENDER_LIST_VIEW_END';
const $6b924b2dad5a4c16$export$804cba7c4155c239 = 'PAGE_LOAD_MARK_RENDER_BOARD_VIEW_START';
const $6b924b2dad5a4c16$export$92f49e88c0cf9398 = 'PAGE_LOAD_MARK_RENDER_BOARD_VIEW_END';
const $6b924b2dad5a4c16$export$c7df8588815a5dff = 'PAGE_LOAD_MARK_RENDER_MATRIX_VIEW_START';
const $6b924b2dad5a4c16$export$6d58a19b2a5a7d6c = 'PAGE_LOAD_MARK_RENDER_MATRIX_VIEW_END';
const $6b924b2dad5a4c16$export$5c41eba619cf4422 = 'PAGE_LOAD_MARK_RENDER_TIMELINE_VIEW_START';
const $6b924b2dad5a4c16$export$70d7f5af83b810d1 = 'PAGE_LOAD_MARK_RENDER_TIMELINE_VIEW_END';
const $6b924b2dad5a4c16$export$f287ddc953d21ba2 = 'PAGE_LOAD_MARK_RENDER_BOARD_SWIMLANE_VIEW_START';
const $6b924b2dad5a4c16$export$a2ceee803729727c = 'PAGE_LOAD_MARK_RENDER_BOARD_SWIMLANE_VIEW_END';
const $6b924b2dad5a4c16$var$isSharedView = ()=>/\/jira\/discovery\/share\/views\/[a-zA-Z0-9-]+/.test(globalThis.location?.href);
// Lazily initialize the metric because it depends on the URL
let $6b924b2dad5a4c16$var$jpdProjectPageLoadMetric;
function $6b924b2dad5a4c16$export$fd6d36ad90baf6f6() {
    if ($6b924b2dad5a4c16$var$jpdProjectPageLoadMetric != null) return $6b924b2dad5a4c16$var$jpdProjectPageLoadMetric;
    $6b924b2dad5a4c16$var$jpdProjectPageLoadMetric = (0, $hqYEY.metrics).pageLoad({
        key: $6b924b2dad5a4c16$var$isSharedView() ? 'jpd.shared-view' : 'jpd.project',
        featureFlags: [],
        timings: [
            {
                key: 'product/initial-render',
                startMark: $6b924b2dad5a4c16$export$d94e22e398b40d3e,
                endMark: $6b924b2dad5a4c16$export$25faf068e86e1827
            },
            {
                key: 'product/load-permissions',
                startMark: $6b924b2dad5a4c16$export$4ba1c1d0a3f1fcf9,
                endMark: $6b924b2dad5a4c16$export$c68cd8d9163d8024
            },
            {
                key: 'product/load-views',
                startMark: $6b924b2dad5a4c16$export$b6e521c1c735f819,
                endMark: $6b924b2dad5a4c16$export$2d39e56eb6bc61e2
            },
            {
                key: 'product/load-project',
                startMark: $6b924b2dad5a4c16$export$e9ade44ad4706ce2,
                endMark: $6b924b2dad5a4c16$export$62ccc5c18b320a1c
            },
            {
                key: 'product/load-insights',
                startMark: $6b924b2dad5a4c16$export$143502466d17e9b1,
                endMark: $6b924b2dad5a4c16$export$a8581b9dacd8996a
            },
            {
                key: 'product/load-fields',
                startMark: $6b924b2dad5a4c16$export$bbdca1640a59e683,
                endMark: $6b924b2dad5a4c16$export$77c443b5622981d3
            },
            {
                key: 'product/load-issues',
                startMark: $6b924b2dad5a4c16$export$5899a9a7e5194e40,
                endMark: $6b924b2dad5a4c16$export$b33e4b126300862b
            },
            {
                key: 'product/render-view-main',
                startMark: $6b924b2dad5a4c16$export$7cb35720e348e7d6,
                endMark: $6b924b2dad5a4c16$export$346e293d7601d12
            },
            {
                key: 'product/render-list-view',
                startMark: $6b924b2dad5a4c16$export$7cb16aaae52cb7c4,
                endMark: $6b924b2dad5a4c16$export$c00320feb79e362
            },
            {
                key: 'product/render-board-view',
                startMark: $6b924b2dad5a4c16$export$804cba7c4155c239,
                endMark: $6b924b2dad5a4c16$export$92f49e88c0cf9398
            },
            {
                key: 'product/render-board-swimlane-view',
                startMark: $6b924b2dad5a4c16$export$f287ddc953d21ba2,
                endMark: $6b924b2dad5a4c16$export$a2ceee803729727c
            },
            {
                key: 'product/render-matrix-view',
                startMark: $6b924b2dad5a4c16$export$c7df8588815a5dff,
                endMark: $6b924b2dad5a4c16$export$6d58a19b2a5a7d6c
            },
            {
                key: 'product/render-timeline-view',
                startMark: $6b924b2dad5a4c16$export$5c41eba619cf4422,
                endMark: $6b924b2dad5a4c16$export$70d7f5af83b810d1
            }
        ]
    });
    return $6b924b2dad5a4c16$var$jpdProjectPageLoadMetric;
}
const $6b924b2dad5a4c16$export$ba35263e5f55f1c8 = {
    mark (...args) {
        $6b924b2dad5a4c16$export$fd6d36ad90baf6f6().mark(...args);
    }
};
const $6b924b2dad5a4c16$export$e8787017048b5d03 = ()=>{
    $6b924b2dad5a4c16$export$ba35263e5f55f1c8.mark($6b924b2dad5a4c16$export$4ba1c1d0a3f1fcf9);
};
const $6b924b2dad5a4c16$export$e12eec0846d40def = ()=>{
    $6b924b2dad5a4c16$export$ba35263e5f55f1c8.mark($6b924b2dad5a4c16$export$c68cd8d9163d8024);
};

});


parcelRegister("4D6DW", function(module, exports) {

$parcel$export(module.exports, "loadGlobalFieldsAssociations", () => $1728b7d5ec60a07f$export$8214750359741669);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6Yd06 = parcelRequire("6Yd06");
const $1728b7d5ec60a07f$export$8214750359741669 = (fieldKeys)=>async ({ getState: getState, setState: setState }, { globalFieldRemote: globalFieldRemote })=>{
        const { meta: { connectionsLoadingFieldsAssociations: connectionsLoadingFieldsAssociations }, connectionsFieldsAssociations: connectionsFieldsAssociations } = getState();
        const fieldKeysToSend = fieldKeys.filter((fieldKey)=>!connectionsFieldsAssociations[fieldKey] && !connectionsLoadingFieldsAssociations.includes(fieldKey));
        if (!fieldKeysToSend.length) return;
        setState({
            meta: {
                ...getState().meta,
                connectionsLoadingFieldsAssociations: [
                    ...getState().meta.connectionsLoadingFieldsAssociations,
                    ...fieldKeysToSend
                ]
            }
        });
        try {
            const result = await globalFieldRemote.getProjectsForFields({
                fieldKeys: fieldKeysToSend
            });
            const remappedFields = Object.entries(result).reduce((acc, [fieldKey, projects])=>{
                const issueIdsFromProjects = projects.reduce((accInner, project)=>{
                    if (project.issueTypes) return accInner.concat(project.issueTypes.map(({ id: id })=>String(id)));
                    return accInner;
                }, []);
                acc[fieldKey] = issueIdsFromProjects;
                return acc;
            }, {});
            setState({
                meta: {
                    ...getState().meta,
                    connectionsLoadingFieldsAssociations: getState().meta.connectionsLoadingFieldsAssociations.filter((key)=>fieldKeysToSend.includes(key))
                },
                connectionsFieldsAssociations: {
                    ...getState().connectionsFieldsAssociations,
                    ...remappedFields
                }
            });
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.fields.connections.loadGlobalFieldsAssociations', 'Failed to load global fields associations for connection highlighted fields', error instanceof Error ? error : new Error('Error while loading global fields associations for connection highlighted fields'));
            setState({
                meta: {
                    ...getState().meta,
                    connectionsLoadingFieldsAssociations: getState().meta.connectionsLoadingFieldsAssociations.filter((key)=>fieldKeysToSend.includes(key))
                }
            });
        }
    };

});

parcelRegister("izS0k", function(module, exports) {

$parcel$export(module.exports, "loadGlobalLabels", () => $a14607be2dbbfa45$export$c6682f53b5f48ef8);

var $eTBmS = parcelRequire("eTBmS");
const $a14607be2dbbfa45$export$c6682f53b5f48ef8 = (fieldKey)=>async ({ getState: getState, setState: setState }, { globalFieldRemote: globalFieldRemote })=>{
        const labelField = getState().fields[fieldKey];
        if (labelField.type !== (0, $eTBmS.FIELD_TYPES).CUSTOM_LABELS || !labelField?.global) return;
        if (labelField.options !== undefined) // global labels are already loaded
        return;
        try {
            const globalLabels = await globalFieldRemote.getGlobalLabels({
                fieldKey: fieldKey
            });
            const fields = getState().fields;
            setState({
                fields: {
                    ...fields,
                    [labelField.key]: {
                        ...fields[labelField.key],
                        options: globalLabels.map((label)=>({
                                id: label,
                                jiraOptionId: label,
                                value: label,
                                weight: 1
                            })),
                        meta: {
                            ...fields[labelField.key]?.meta,
                            globalLabels: {
                                error: false
                            }
                        }
                    }
                }
            });
        } catch (err) {
            const fields = getState().fields;
            setState({
                fields: {
                    ...fields,
                    [labelField.key]: {
                        ...fields[labelField.key],
                        options: [],
                        meta: {
                            ...fields[labelField.key]?.meta,
                            globalLabels: {
                                error: true
                            }
                        }
                    }
                }
            });
            throw err;
        }
    };

});

parcelRegister("attZ8", function(module, exports) {

$parcel$export(module.exports, "addOption", () => $fe5217ca83a099d1$export$97a332cdbb9101b1);

var $1uIew = parcelRequire("1uIew");

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $1I887 = parcelRequire("1I887");

var $fljS9 = parcelRequire("fljS9");

var $aqxDR = parcelRequire("aqxDR");


var $3iP9N = parcelRequire("3iP9N");
const $fe5217ca83a099d1$var$fieldOptionUpdateExperience = (0, $8XCY1.createExperienceWithMetaType)((0, $b5oGV.experience).fieldsSidebar.fieldOptionUpdate, 'addOption', (err)=>`FieldOptionUpdate: ${err?.message ?? 'generic error'}`);
const $fe5217ca83a099d1$export$97a332cdbb9101b1 = (fieldKey, newOption)=>({ getState: getState, setState: setState, dispatch: dispatch }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        if (projectId === undefined) return Promise.resolve(undefined);
        $fe5217ca83a099d1$var$fieldOptionUpdateExperience.start();
        return fieldRemote.addFieldOption({
            fieldKey: fieldKey,
            newOption: newOption
        }).then((jiraOptionId)=>{
            dispatch((0, $3iP9N.loadFields)());
            const state = getState();
            const newOptions = [
                ...state?.fields?.[fieldKey]?.options || [],
                {
                    id: String(jiraOptionId),
                    jiraOptionId: String(jiraOptionId),
                    value: newOption,
                    weight: (0, $9d5cc7e3eef4bc6a$export$841473baf38a5476)
                }
            ];
            const fields = {
                ...state?.fields ?? {},
                [fieldKey]: {
                    ...state?.fields?.[fieldKey],
                    options: newOptions
                }
            };
            setState({
                fields: fields
            });
            $fe5217ca83a099d1$var$fieldOptionUpdateExperience.success();
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.optionCreatedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: fields[fieldKey].type,
                fieldValueId: jiraOptionId
            });
            return jiraOptionId;
        }).catch((err)=>{
            let ufoExperienceResolved = false;
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.optionCreatedFailure(createAnalyticsEvent({}));
            let error = err;
            if (err instanceof (0, $1uIew.default)) {
                const { message: message, statusCode: statusCode } = err;
                if (statusCode === 409) {
                    error = new (0, $fljS9.EntityLimitError)(message, [
                        {
                            error: message
                        }
                    ], statusCode, (0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD);
                    $fe5217ca83a099d1$var$fieldOptionUpdateExperience.abort(err);
                    ufoExperienceResolved = true;
                }
            }
            if (!ufoExperienceResolved) {
                $fe5217ca83a099d1$var$fieldOptionUpdateExperience.failure(err);
                ufoExperienceResolved = true;
            }
            onFieldUpdateFailed(error);
            return undefined;
        });
    };

});
const $9d5cc7e3eef4bc6a$export$841473baf38a5476 = 1;


parcelRegister("1E7II", function(module, exports) {

$parcel$export(module.exports, "deleteOption", () => $93576dafe41ac66c$export$1717f994e126a0c5);

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $1I887 = parcelRequire("1I887");

var $58GSG = parcelRequire("58GSG");

var $680fE = parcelRequire("680fE");
const $93576dafe41ac66c$var$fieldOptionUpdateExperience = (0, $8XCY1.createExperienceWithMetaType)((0, $b5oGV.experience).fieldsSidebar.fieldOptionUpdate, 'deleteOption', (err)=>`FieldOptionUpdate: ${err?.message ?? 'generic error'}`);
const $93576dafe41ac66c$export$1717f994e126a0c5 = (fieldKey, jiraOptionId)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        const state = getState();
        const field = state.fields[fieldKey];
        const previousOptions = field.options;
        const { valueDecorations: valueDecorations, ...previousConfig } = field?.configuration ?? {};
        const previousOptionWeights = previousConfig.optionWeights ?? [];
        const newOptions = previousOptions?.filter(({ jiraOptionId: optionId })=>optionId !== jiraOptionId);
        if (newOptions === undefined || newOptions.length === 0) // do nothing, the last option cannot be deleted
        return;
        const previousValueDecorations = state.fieldValueDecorations[fieldKey] || [];
        const appliedDecoration = (0, $58GSG.getAppliedDecoration)(previousValueDecorations, jiraOptionId);
        const newValueDecorations = [
            ...previousValueDecorations.filter((decoration)=>decoration.localDecorationId !== appliedDecoration?.localDecorationId)
        ];
        const jiraOptionIdNumber = parseInt(jiraOptionId, 10);
        const newOptionWeights = previousOptionWeights.filter(({ optionId: optionId })=>optionId !== jiraOptionIdNumber);
        const newConfig = {
            ...previousConfig,
            optionWeights: newOptionWeights
        };
        setState({
            fields: {
                ...state.fields,
                [fieldKey]: {
                    ...field,
                    options: newOptions,
                    configuration: newConfig
                }
            },
            fieldValueDecorations: {
                ...state.fieldValueDecorations,
                [fieldKey]: newValueDecorations
            }
        });
        if (projectId !== undefined) try {
            $93576dafe41ac66c$var$fieldOptionUpdateExperience.start();
            await fieldRemote.deleteFieldOption({
                fieldKey: fieldKey,
                optionId: jiraOptionIdNumber
            });
            $93576dafe41ac66c$var$fieldOptionUpdateExperience.success();
            fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                oldConfiguration: {
                    ...previousOptionWeights.length > 0 ? {
                        optionWeights: previousOptionWeights
                    } : {},
                    ...(0, $680fE.remapValueDecorations)(previousValueDecorations)
                },
                configuration: {
                    ...newOptionWeights.length > 0 ? {
                        optionWeights: newOptionWeights
                    } : {},
                    ...(0, $680fE.remapValueDecorations)(newValueDecorations)
                },
                type: 'deleteOptionRelatedFieldConfiguration'
            }).then(()=>{
                (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.optionWeightChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: field.type,
                    fieldValueId: jiraOptionId
                });
                (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.valueDecorationChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: field.type
                });
            }).catch(onFieldUpdateFailed);
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.optionDeletedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type,
                fieldValueId: jiraOptionId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.optionDeletedFailure(createAnalyticsEvent({}));
            $93576dafe41ac66c$var$fieldOptionUpdateExperience.failure(err);
            onFieldUpdateFailed(err);
        }
    };

});
parcelRegister("58GSG", function(module, exports) {

$parcel$export(module.exports, "getAppliedDecoration", () => $e83c7d128f55e185$export$f09d56952b1fe9bc);
$parcel$export(module.exports, "getAppliedDecorations", () => $e83c7d128f55e185$export$370901a43154af);
$parcel$export(module.exports, "getAppliedNumberDecoration", () => $e83c7d128f55e185$export$de8f59b5038e4e6f);
$parcel$export(module.exports, "getAppliedDateDecoration", () => $e83c7d128f55e185$export$de751034a645f2e);
$parcel$export(module.exports, "getAppliedIntervalDecoration", () => $e83c7d128f55e185$export$8aa279f68ac07db4);

var $lw3Pj = parcelRequire("lw3Pj");
var $2InI0 = parcelRequire("2InI0");

var $LFmXM = parcelRequire("LFmXM");

var $dO9h7 = parcelRequire("dO9h7");

var $8o0OR = parcelRequire("8o0OR");

var $5nCuN = parcelRequire("5nCuN");

var $5ttNf = parcelRequire("5ttNf");
const $e83c7d128f55e185$export$f09d56952b1fe9bc = (0, $LFmXM.default)((decorations, value)=>{
    if (decorations !== undefined && value !== undefined) return decorations.find((decoration)=>(0, $8o0OR.applyOptionLogic)(decoration.logic, value));
    return undefined;
});
const $e83c7d128f55e185$export$370901a43154af = (0, $LFmXM.default)((decorations, values)=>{
    const decorationMap = {};
    for (const value of values)decorationMap[value] = $e83c7d128f55e185$export$f09d56952b1fe9bc(decorations, value);
    return decorationMap;
});
const $e83c7d128f55e185$export$de8f59b5038e4e6f = (decorations, value)=>{
    if (decorations !== undefined && value !== undefined) return decorations.find((decoration)=>(0, $5ttNf.applyNumberLogic)(decoration.logic, value));
    return undefined;
};
const $e83c7d128f55e185$export$de751034a645f2e = (0, $LFmXM.default)((decorations, value, locale)=>{
    if (decorations !== undefined && value !== undefined) {
        const given = (0, $2InI0.default)(new Date((0, $dO9h7.formatWithLocale)(new Date(value), 'dd MMMM yyyy HH:mm', locale)));
        const current = (0, $2InI0.default)(new Date((0, $dO9h7.formatWithLocale)(new Date(), 'dd MMMM yyyy HH:mm', locale)));
        const diffDays = (0, $lw3Pj.default)(given, current);
        return decorations.find((decoration)=>(0, $5nCuN.applyDateTimeLogic)(decoration.logic, diffDays));
    }
    return undefined;
});
const $e83c7d128f55e185$export$8aa279f68ac07db4 = (0, $LFmXM.default)((decorations, value, locale)=>{
    if (decorations !== undefined && value !== undefined) {
        const startDate = (0, $2InI0.default)(new Date((0, $dO9h7.formatWithLocale)(new Date(value?.start), 'dd MMMM yyyy HH:mm', locale)));
        const endDate = (0, $2InI0.default)(new Date((0, $dO9h7.formatWithLocale)(new Date(value?.end), 'dd MMMM yyyy HH:mm', locale)));
        const current = (0, $2InI0.default)(new Date((0, $dO9h7.formatWithLocale)(new Date(), 'dd MMMM yyyy HH:mm', locale)));
        const diffDaysBeforeStart = (0, $lw3Pj.default)(startDate, current);
        const diffDaysBeforeEnd = (0, $lw3Pj.default)(endDate, current);
        return decorations.find((decoration)=>(0, $5nCuN.applyDateTimeIntervalLogic)({
                logic: decoration.logic,
                diffDaysBeforeStart: diffDaysBeforeStart,
                diffDaysBeforeEnd: diffDaysBeforeEnd
            }));
    }
    return undefined;
});

});
parcelRegister("8o0OR", function(module, exports) {

$parcel$export(module.exports, "applyOptionLogic", () => $774da6df3fb0e316$export$85febbc27cec9e66);
$parcel$export(module.exports, "getOptionLogicValue", () => $774da6df3fb0e316$export$129617db118f502f);

var $lmp26 = parcelRequire("lmp26");

var $2eRrM = parcelRequire("2eRrM");
const $774da6df3fb0e316$var$LABEL_LOGIC_PATTERN = {
    [(0, $lmp26.JsonLogicOperator).EQ]: [
        '@',
        {
            var: 'label'
        }
    ]
};
const $774da6df3fb0e316$var$isLabelLogic = (logic)=>{
    return (0, $2eRrM.default).rule_like(logic, $774da6df3fb0e316$var$LABEL_LOGIC_PATTERN);
};
const $774da6df3fb0e316$export$85febbc27cec9e66 = (logic, value)=>{
    const logicVarName = $774da6df3fb0e316$var$isLabelLogic(logic) ? 'label' : 'id';
    return (0, $2eRrM.default).apply(logic, {
        [logicVarName]: value
    });
};
const $774da6df3fb0e316$export$129617db118f502f = (logic)=>{
    const [value] = (0, $2eRrM.default).get_values(logic);
    return value;
};

});
parcelRegister("lmp26", function(module, exports) {

$parcel$export(module.exports, "JsonLogicOperator", () => $d5c32071d67f38ea$export$861a3fa6bc9fa962);
const $d5c32071d67f38ea$var$LOGICEQ = '==';
const $d5c32071d67f38ea$var$LOGICGT = '>';
const $d5c32071d67f38ea$var$LOGICLT = '<';
const $d5c32071d67f38ea$var$LOGICGTE = '>=';
const $d5c32071d67f38ea$var$LOGICLTE = '<=';
const $d5c32071d67f38ea$export$861a3fa6bc9fa962 = {
    EQ: $d5c32071d67f38ea$var$LOGICEQ,
    GT: $d5c32071d67f38ea$var$LOGICGT,
    LT: $d5c32071d67f38ea$var$LOGICLT,
    GTE: $d5c32071d67f38ea$var$LOGICGTE,
    LTE: $d5c32071d67f38ea$var$LOGICLTE
};

});

parcelRegister("2eRrM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f08e9afbc102b87$export$2e2bcd8739ae039);
/*
eslint-disable
prefer-arrow-callback,
vars-on-top,
no-var,
eqeqeq,
prefer-rest-params,
no-console,
no-else-return,
camelcase,
prefer-spread,
prefer-template,
object-shorthand,
no-prototype-builtins,
@typescript-eslint/no-this-alias
*/ var $4f08e9afbc102b87$export$2e2bcd8739ae039 = (()=>{
    /**
	 * Return an array that contains no duplicates (original not modified)
	 * @param  {array} array   Original reference array
	 * @returns {array}         New array with no duplicates
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function arrayUnique(array) {
        var a = [];
        for(var i = 0, l = array.length; i < l; i++)if (a.indexOf(array[i]) === -1) a.push(array[i]);
        return a;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var operations = {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        '==': function(a, b) {
            return a == b;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        '===': function(a, b) {
            return a === b;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        '!=': function(a, b) {
            return a != b;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        '!==': function(a, b) {
            return a !== b;
        },
        '>': function(a, b) {
            return a > b;
        },
        '>=': function(a, b) {
            return a >= b;
        },
        '<': function(a, b, c) {
            return c === undefined ? a < b : a < b && b < c;
        },
        '<=': function(a, b, c) {
            return c === undefined ? a <= b : a <= b && b <= c;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        '!!': function(a) {
            return truthy(a);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        '!': function(a) {
            return !truthy(a);
        },
        '%': function(a, b) {
            return a % b;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        log: function(a) {
            console.log(a);
            return a;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        in: function(a, b) {
            if (!b || typeof b.indexOf === 'undefined') return false;
            return b.indexOf(a) !== -1;
        },
        cat: function() {
            return Array.prototype.join.call(arguments, '');
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        substr: function(source, start, end) {
            if (end < 0) {
                // JavaScript doesn't support negative end, this emulates PHP behavior
                var temp = String(source).substr(start);
                return temp.substr(0, temp.length + end);
            }
            return String(source).substr(start, end);
        },
        '+': function() {
            return Array.prototype.reduce.call(arguments, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function(a, b) {
                return parseFloat(a) + parseFloat(b);
            }, 0);
        },
        '*': function() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return Array.prototype.reduce.call(arguments, function(a, b) {
                return parseFloat(a) * parseFloat(b);
            });
        },
        '-': function(a, b) {
            if (b === undefined) return -a;
            else return a - b;
        },
        '/': function(a, b) {
            return a / b;
        },
        min: function() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return Math.min.apply(this, arguments);
        },
        max: function() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return Math.max.apply(this, arguments);
        },
        merge: function() {
            return Array.prototype.reduce.call(arguments, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function(a, b) {
                return a.concat(b);
            }, []);
        },
        var: function(a, b) {
            var not_found = b === undefined ? null : b;
            var data = this;
            if (typeof a === 'undefined' || a === '' || a === null) return data;
            var sub_props = String(a).split('.');
            for(var i = 0; i < sub_props.length; i++){
                if (data === null || data === undefined) return not_found;
                // Descending into data
                data = data[sub_props[i]];
                if (data === undefined) return not_found;
            }
            return data;
        },
        missing: function() {
            /*
              Missing can receive many keys as many arguments, like {"missing:[1,2]}
              Missing can also receive *one* argument that is an array of keys,
              which typically happens if it's actually acting on the output of another command
              (like 'if' or 'merge')
              */ var missing = [];
            var keys = Array.isArray(arguments[0]) ? arguments[0] : arguments;
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                var value = apply({
                    var: key
                }, this);
                if (value === null || value === '') missing.push(key);
            }
            return missing;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        missing_some: function(need_count, options) {
            // missing_some takes two arguments, how many (minimum) items must be present, and an array of keys (just like 'missing') to check for presence.
            var are_missing = apply({
                missing: options
            }, this);
            if (options.length - are_missing.length >= need_count) return [];
            else return are_missing;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const is_logic = function(logic) {
        return typeof logic === 'object' && // An object
        logic !== null && // but not null
        !Array.isArray(logic) && // and not an array
        Object.keys(logic).length === 1 // with exactly one key
        ;
    };
    /*
    This helper will defer to the JsonLogic spec as a tie-breaker when different language interpreters define different behavior for the truthiness of primitives.  E.g., PHP considers empty arrays to be falsy, but Javascript considers them to be truthy. JsonLogic, as an ecosystem, needs one consistent answer.

    Spec and rationale here: http://jsonlogic.com/truthy
    */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const truthy = function(value) {
        if (Array.isArray(value) && value.length === 0) return false;
        return !!value;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const get_operator = function(logic) {
        return Object.keys(logic)[0];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const get_values = function(logic) {
        return logic[get_operator(logic)];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const apply = function(logic, data) {
        // Does this array contain logic? Only one way to find out.
        if (Array.isArray(logic)) return logic.map(function(l) {
            return apply(l, data);
        });
        // You've recursed to a primitive, stop!
        if (!is_logic(logic)) return logic;
        var op = get_operator(logic);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var values = logic[op];
        var i;
        var current;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var scopedLogic;
        var scopedData;
        var initial;
        // easy syntax for unary operators, like {"var" : "x"} instead of strict {"var" : ["x"]}
        if (!Array.isArray(values)) values = [
            values
        ];
        // 'if', 'and', and 'or' violate the normal rule of depth-first calculating consequents, let each manage recursion as needed.
        if (op === 'if' || op == '?:') {
            /* 'if' should be called with a odd number of parameters, 3 or greater
              This works on the pattern:
              if( 0 ){ 1 }else{ 2 };
              if( 0 ){ 1 }else if( 2 ){ 3 }else{ 4 };
              if( 0 ){ 1 }else if( 2 ){ 3 }else if( 4 ){ 5 }else{ 6 };

              The implementation is:
              For pairs of values (0,1 then 2,3 then 4,5 etc)
              If the first evaluates truthy, evaluate and return the second
              If the first evaluates falsy, jump to the next pair (e.g, 0,1 to 2,3)
              given one parameter, evaluate and return it. (it's an Else and all the If/ElseIf were false)
              given 0 parameters, return NULL (not great practice, but there was no Else)
              */ for(i = 0; i < values.length - 1; i += 2){
                if (truthy(apply(values[i], data))) return apply(values[i + 1], data);
            }
            if (values.length === i + 1) return apply(values[i], data);
            return null;
        } else if (op === 'and') {
            // Return first falsy, or last
            for(i = 0; i < values.length; i += 1){
                current = apply(values[i], data);
                if (!truthy(current)) return current;
            }
            return current; // Last
        } else if (op === 'or') {
            // Return first truthy, or last
            for(i = 0; i < values.length; i += 1){
                current = apply(values[i], data);
                if (truthy(current)) return current;
            }
            return current; // Last
        } else if (op === 'filter') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            if (!Array.isArray(scopedData)) return [];
            // Return only the elements from the array in the first argument,
            // that return truthy when passed to the logic in the second argument.
            // For parity with JavaScript, reindex the returned array
            return scopedData.filter(function(datum) {
                return truthy(apply(scopedLogic, datum));
            });
        } else if (op === 'map') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            if (!Array.isArray(scopedData)) return [];
            return scopedData.map(function(datum) {
                return apply(scopedLogic, datum);
            });
        } else if (op === 'reduce') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            initial = typeof values[2] !== 'undefined' ? apply(values[2], data) : null;
            if (!Array.isArray(scopedData)) return initial;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
            return scopedData.reduce(function(accumulator, current) {
                return apply(scopedLogic, {
                    current: current,
                    accumulator: accumulator
                });
            }, initial);
        } else if (op === 'all') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            // All of an empty set is false. Note, some and none have correct fallback after the for loop
            if (!Array.isArray(scopedData) || !scopedData.length) return false;
            for(i = 0; i < scopedData.length; i += 1){
                if (!truthy(apply(scopedLogic, scopedData[i]))) return false; // First falsy, short circuit
            }
            return true; // All were truthy
        } else if (op === 'none') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            if (!Array.isArray(scopedData) || !scopedData.length) return true;
            for(i = 0; i < scopedData.length; i += 1){
                if (truthy(apply(scopedLogic, scopedData[i]))) return false; // First truthy, short circuit
            }
            return true; // None were truthy
        } else if (op === 'some') {
            scopedData = apply(values[0], data);
            scopedLogic = values[1];
            if (!Array.isArray(scopedData) || !scopedData.length) return false;
            for(i = 0; i < scopedData.length; i += 1){
                if (truthy(apply(scopedLogic, scopedData[i]))) return true; // First truthy, short circuit
            }
            return false; // None were truthy
        }
        // Everyone else gets immediate depth-first recursion
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        values = values.map(function(val) {
            return apply(val, data);
        });
        // The operation is called with "data" bound to its "this" and "values" passed as arguments.
        // Structured commands like % or > can name formal arguments while flexible commands (like missing or merge) can operate on the pseudo-array arguments
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments
        if (operations.hasOwnProperty(op) && typeof operations[op] === 'function') return operations[op].apply(data, values);
        else if (op.indexOf('.') > 0) {
            // Contains a dot, and not in the 0th position
            var sub_ops = String(op).split('.');
            var operation = operations;
            for(i = 0; i < sub_ops.length; i++){
                if (!operation.hasOwnProperty(sub_ops[i])) throw new Error('Unrecognized operation ' + op + ' (failed at ' + sub_ops.slice(0, i + 1).join('.') + ')');
                // Descending into operations
                operation = operation[sub_ops[i]];
            }
            return operation.apply(data, values);
        }
        throw new Error('Unrecognized operation ' + op);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const uses_data = function(logic) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var collection = [];
        if (is_logic(logic)) {
            var op = get_operator(logic);
            var values = logic[op];
            if (!Array.isArray(values)) values = [
                values
            ];
            if (op === 'var') // This doesn't cover the case where the arg to var is itself a rule.
            collection.push(values[0]);
            else // Recursion!
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            values.forEach(function(val) {
                collection.push.apply(collection, uses_data(val));
            });
        }
        return arrayUnique(collection);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const add_operation = function(name, code) {
        operations[name] = code;
    };
    const rm_operation = function(name) {
        delete operations[name];
    };
    const rule_like = function(rule, pattern) {
        // console.log("Is ". JSON.stringify(rule) . " like " . JSON.stringify(pattern) . "?");
        if (pattern === rule) return true;
         // TODO : Deep object equivalency?
        if (pattern === '@') return true;
         // Wildcard!
        if (pattern === 'number') return typeof rule === 'number';
        if (pattern === 'string') return typeof rule === 'string';
        if (pattern === 'array') // !logic test might be superfluous in JavaScript
        return Array.isArray(rule) && !is_logic(rule);
        if (is_logic(pattern)) {
            if (is_logic(rule)) {
                var pattern_op = get_operator(pattern);
                var rule_op = get_operator(rule);
                if (pattern_op === '@' || pattern_op === rule_op) // echo "\nOperators match, go deeper\n";
                return rule_like(get_values(rule), get_values(pattern));
            }
            return false; // pattern is logic, rule isn't, can't be eq
        }
        if (Array.isArray(pattern)) {
            if (Array.isArray(rule)) {
                if (pattern.length !== rule.length) return false;
                /*
                  Note, array order MATTERS, because we're using this array test logic to consider arguments, where order can matter. (e.g., + is commutative, but '-' or 'if' or 'var' are NOT)
                */ for(var i = 0; i < pattern.length; i += 1){
                    // If any fail, we fail
                    if (!rule_like(rule[i], pattern[i])) return false;
                }
                return true; // If they *all* passed, we pass
            } else return false; // Pattern is array, rule isn't
        }
        // Not logic, not array, not a === match for rule.
        return false;
    };
    return {
        is_logic: is_logic,
        truthy: truthy,
        get_operator: get_operator,
        get_values: get_values,
        apply: apply,
        uses_data: uses_data,
        add_operation: add_operation,
        rm_operation: rm_operation,
        rule_like: rule_like
    };
})();

});


parcelRegister("5nCuN", function(module, exports) {

$parcel$export(module.exports, "applyDateTimeLogic", () => $8352fb185dec6ed2$export$77232984bf4c4f4a);
$parcel$export(module.exports, "applyDateTimeIntervalLogic", () => $8352fb185dec6ed2$export$6eabdf0ec7333ea3);

var $2eRrM = parcelRequire("2eRrM");

var $kAH44 = parcelRequire("kAH44");
const $8352fb185dec6ed2$export$77232984bf4c4f4a = (logic, daysUntilDueDate)=>{
    return (0, $2eRrM.default).apply(logic, {
        daysUntilDueDate: daysUntilDueDate
    });
};
const $8352fb185dec6ed2$export$6eabdf0ec7333ea3 = ({ logic: logic, diffDaysBeforeStart: diffDaysBeforeStart, diffDaysBeforeEnd: diffDaysBeforeEnd })=>{
    if ((0, $kAH44.isDateOverdueOption)(logic)) return $8352fb185dec6ed2$export$77232984bf4c4f4a(logic, diffDaysBeforeEnd);
    const [gt, _, lt] = (0, $2eRrM.default).get_values(logic);
    return diffDaysBeforeEnd > gt && diffDaysBeforeStart < lt;
};

});
parcelRegister("kAH44", function(module, exports) {

$parcel$export(module.exports, "isDateComingSoonOption", () => $c90975e400f63b42$export$2f2cb858f35d536d);
$parcel$export(module.exports, "isDateOverdueOption", () => $c90975e400f63b42$export$3de00231afdb801b);

var $lmp26 = parcelRequire("lmp26");

var $2eRrM = parcelRequire("2eRrM");
const $c90975e400f63b42$var$DATE_COMING_SOON_LOGIC_PATTERN = {
    [(0, $lmp26.JsonLogicOperator).LT]: [
        '@',
        {
            var: 'daysUntilDueDate'
        },
        '@'
    ]
};
const $c90975e400f63b42$export$2f2cb858f35d536d = (logic)=>{
    return (0, $2eRrM.default).rule_like(logic, $c90975e400f63b42$var$DATE_COMING_SOON_LOGIC_PATTERN);
};
const $c90975e400f63b42$var$DATE_OVERDUE_LOGIC_PATTERN = {
    [(0, $lmp26.JsonLogicOperator).LT]: [
        {
            var: 'daysUntilDueDate'
        },
        '@'
    ]
};
const $c90975e400f63b42$export$3de00231afdb801b = (logic)=>{
    return (0, $2eRrM.default).rule_like(logic, $c90975e400f63b42$var$DATE_OVERDUE_LOGIC_PATTERN);
};

});


parcelRegister("5ttNf", function(module, exports) {

$parcel$export(module.exports, "createBetweenLogic", () => $3e6b1daca7bdd67e$export$153a0838eec97535);
$parcel$export(module.exports, "createLessThanLogic", () => $3e6b1daca7bdd67e$export$bfa1ea1051fe6adf);
$parcel$export(module.exports, "createGreaterThanLogic", () => $3e6b1daca7bdd67e$export$1dc320f7a543e731);
$parcel$export(module.exports, "createDefaultLogic", () => $3e6b1daca7bdd67e$export$12b2f01a3cb3b7ce);
$parcel$export(module.exports, "applyNumberLogic", () => $3e6b1daca7bdd67e$export$2b440e3245160710);

var $lmp26 = parcelRequire("lmp26");

var $2eRrM = parcelRequire("2eRrM");
const $3e6b1daca7bdd67e$export$153a0838eec97535 = (gte = 0, lte = 0)=>{
    return {
        [(0, $lmp26.JsonLogicOperator).LTE]: [
            gte,
            {
                var: 'value'
            },
            lte
        ]
    };
};
const $3e6b1daca7bdd67e$export$bfa1ea1051fe6adf = (lte = 0)=>{
    return {
        [(0, $lmp26.JsonLogicOperator).LT]: [
            {
                var: 'value'
            },
            lte
        ]
    };
};
const $3e6b1daca7bdd67e$export$1dc320f7a543e731 = (gte = 0)=>{
    return {
        [(0, $lmp26.JsonLogicOperator).GT]: [
            {
                var: 'value'
            },
            gte
        ]
    };
};
const $3e6b1daca7bdd67e$export$12b2f01a3cb3b7ce = (type)=>{
    switch(type){
        case 'GT':
            return $3e6b1daca7bdd67e$export$1dc320f7a543e731();
        case 'LT':
            return $3e6b1daca7bdd67e$export$bfa1ea1051fe6adf();
        case 'BT':
            return $3e6b1daca7bdd67e$export$153a0838eec97535();
        default:
            throw new Error('Invalid range type');
    }
};
const $3e6b1daca7bdd67e$export$2b440e3245160710 = (logic, value)=>{
    return (0, $2eRrM.default).apply(logic, {
        value: value
    });
};

});



parcelRegister("2U7AD", function(module, exports) {

$parcel$export(module.exports, "rankOptions", () => $d9e36a03c1c307c1$export$ab95c94e35e6cca5);

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $1I887 = parcelRequire("1I887");
const $d9e36a03c1c307c1$var$fieldOptionUpdateExperience = (0, $8XCY1.createExperienceWithMetaType)((0, $b5oGV.experience).fieldsSidebar.fieldOptionUpdate, 'rankOptions', (err)=>`FieldOptionUpdate: ${err?.message ?? 'generic error'}`);
const $d9e36a03c1c307c1$export$ab95c94e35e6cca5 = (fieldKey, rankedOptionIds)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        const state = getState();
        const previousOptions = state.fields[fieldKey].options;
        if (previousOptions === undefined) return;
        const newOptions = rankedOptionIds.map((id)=>previousOptions.find((option)=>option.jiraOptionId === id)).filter(Boolean);
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                options: newOptions
            }
        };
        setState({
            fields: fields
        });
        if (projectId !== undefined) {
            $d9e36a03c1c307c1$var$fieldOptionUpdateExperience.start();
            fieldRemote.updateFieldOptionRank({
                fieldKey: fieldKey,
                rankedOptionIds: newOptions.map((option)=>option.jiraOptionId)
            }).then(()=>{
                $d9e36a03c1c307c1$var$fieldOptionUpdateExperience.success();
                (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.optionRankChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: fields[fieldKey].type
                });
            }).catch((error)=>{
                $d9e36a03c1c307c1$var$fieldOptionUpdateExperience.failure(error);
                onFieldUpdateFailed(error);
            });
        }
    };

});

parcelRegister("hcoNB", function(module, exports) {

$parcel$export(module.exports, "renameOption", () => $7b78756cf953394b$export$1aa1b0b279ea3939);

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $1I887 = parcelRequire("1I887");
const $7b78756cf953394b$var$fieldOptionUpdateExperience = (0, $8XCY1.createExperienceWithMetaType)((0, $b5oGV.experience).fieldsSidebar.fieldOptionUpdate, 'renameOption', (err)=>`FieldOptionUpdate: ${err?.message ?? 'generic error'}`);
const $7b78756cf953394b$export$1aa1b0b279ea3939 = (fieldKey, jiraOptionId, newValue)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        const state = getState();
        const previousOptions = state.fields[fieldKey].options;
        const newOptions = previousOptions?.map((option)=>{
            if (option.jiraOptionId === jiraOptionId) return {
                ...option,
                value: newValue
            };
            return option;
        });
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                options: newOptions
            }
        };
        setState({
            fields: fields
        });
        if (projectId !== undefined) {
            $7b78756cf953394b$var$fieldOptionUpdateExperience.start();
            fieldRemote.renameFieldOption({
                fieldKey: fieldKey,
                newTitle: newValue,
                optionId: +jiraOptionId
            }).then(()=>{
                $7b78756cf953394b$var$fieldOptionUpdateExperience.success();
                (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.optionLabelChanged(createAnalyticsEvent({}), {
                    issueFieldKey: fieldKey,
                    issueFieldType: fields[fieldKey].type,
                    fieldValueId: jiraOptionId
                });
            }).catch((error)=>{
                $7b78756cf953394b$var$fieldOptionUpdateExperience.failure(error);
                onFieldUpdateFailed(error);
            });
        }
    };

});

parcelRegister("3GhfL", function(module, exports) {

$parcel$export(module.exports, "updateFieldOptionAutoFormattingDisabled", () => $31341dcc9c9d6d98$export$7e73e7c429f4b347);
const $31341dcc9c9d6d98$export$7e73e7c429f4b347 = (fieldKey, newValue)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, fieldRemote: fieldRemote })=>{
        const state = getState();
        const field = state.fields[fieldKey];
        const oldValue = field.configuration?.optionAutoFormatDisabled;
        if (projectId === undefined) return;
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...field,
                configuration: {
                    ...field.configuration,
                    optionAutoFormatDisabled: newValue
                }
            }
        };
        setState({
            fields: fields
        });
        return fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldValue !== undefined ? {
                optionAutoFormatDisabled: oldValue
            } : {},
            configuration: newValue !== undefined ? {
                optionAutoFormatDisabled: newValue
            } : {},
            type: 'updateFieldOptionAutoFormattingDisabled'
        }).catch((err)=>{
            const currentState = getState();
            const currentFieldsData = {
                ...currentState.fields,
                [fieldKey]: {
                    ...currentState.fields[fieldKey],
                    configuration: {
                        ...currentState.fields[fieldKey].configuration,
                        optionAutoFormatDisabled: oldValue
                    }
                }
            };
            setState({
                fields: currentFieldsData
            });
            onFieldUpdateFailed(err);
        });
    };

});

parcelRegister("1Pjrd", function(module, exports) {

$parcel$export(module.exports, "updateFieldOptionWeightType", () => $40d2d51c57b034ee$export$da6c1255c64ed808);

var $gCeeo = parcelRequire("gCeeo");

var $bNW0R = parcelRequire("bNW0R");

const $40d2d51c57b034ee$export$da6c1255c64ed808 = (fieldKey, newOptionWeightType)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const field = (0, $bNW0R.createGetFieldByKey)(fieldKey)(getState());
        if (!field) return undefined;
        const oldConfiguration = field.configuration;
        const newConfiguration = {
            ...field.configuration,
            optionWeightType: newOptionWeightType
        };
        const oldOptions = field.options;
        let newOptions = field.options;
        const isWeightingRemoved = newOptionWeightType === undefined;
        if (isWeightingRemoved) {
            newConfiguration.optionWeights = (field.configuration?.optionWeights || []).map((e)=>({
                    ...e,
                    weight: (0, $9d5cc7e3eef4bc6a$export$841473baf38a5476)
                }));
            newOptions = newOptions?.map((optionItem)=>({
                    ...optionItem,
                    weight: (0, $9d5cc7e3eef4bc6a$export$841473baf38a5476)
                }));
        }
        try {
            const fields = {
                ...getState().fields
            };
            fields[fieldKey] = {
                ...fields[fieldKey],
                configuration: newConfiguration,
                options: newOptions
            };
            setState({
                fields: fields
            });
            await fieldRemote.updateFieldConfiguration({
                oldConfiguration: oldConfiguration ?? {},
                configuration: newConfiguration,
                fieldKey: field.key,
                type: 'updateFieldOptionWeightType'
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
                issueFieldKey: fieldKey,
                issueFieldType: field.type,
                updatedItems: Object.keys(newConfiguration).map((name)=>({
                        name: name
                    }))
            });
            return undefined;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const fields = {
                ...getState().fields
            };
            fields[fieldKey] = {
                ...fields[fieldKey],
                configuration: oldConfiguration,
                options: oldOptions
            };
            setState({
                fields: fields
            });
            onFieldUpdateFailed(err);
            return err;
        }
    };

});

parcelRegister("jyyuH", function(module, exports) {

$parcel$export(module.exports, "updateFieldOptionWeight", () => $0abb62dc0c6a55a5$export$aacb3d2067112884);

var $1I887 = parcelRequire("1I887");

var $6yBOC = parcelRequire("6yBOC");
const $0abb62dc0c6a55a5$export$aacb3d2067112884 = (fieldKey, jiraOptionId, newWeight)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, fieldRemote: fieldRemote })=>{
        if (projectId === undefined) return;
        const state = getState();
        const field = state.fields[fieldKey];
        const previousOptions = field.options;
        const optionIds = previousOptions?.map((option)=>option.id) || [];
        const newOptions = previousOptions?.map((option)=>{
            if (option.jiraOptionId === jiraOptionId) return {
                ...option,
                weight: newWeight
            };
            return option;
        });
        const jiraOptionIdNumber = parseInt(jiraOptionId, 10);
        // We need to get the real api configuration to be able to correctly apply the patch to the server
        const oldConfigurationOptions = field.configuration?.optionWeights ?? [];
        // {weight: 3, optionId: 10067}
        const hasOldConfigWeight = oldConfigurationOptions.find((option)=>option.optionId === jiraOptionIdNumber);
        let newConfigurationOptions;
        if (hasOldConfigWeight) newConfigurationOptions = oldConfigurationOptions?.map((option)=>{
            if (option.optionId === jiraOptionIdNumber) return {
                ...option,
                weight: newWeight
            };
            return option;
        });
        else newConfigurationOptions = [
            ...oldConfigurationOptions,
            {
                weight: newWeight,
                optionId: parseInt(jiraOptionId, 10)
            }
        ];
        newConfigurationOptions = (0, $6yBOC.sanitizeOptionWeights)(newConfigurationOptions, optionIds);
        const fields = {
            ...state.fields,
            [fieldKey]: {
                ...field,
                options: newOptions,
                configuration: {
                    ...state.fields[fieldKey].configuration,
                    optionWeights: newConfigurationOptions
                }
            }
        };
        setState({
            fields: fields
        });
        return fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfigurationOptions?.length > 0 ? {
                optionWeights: oldConfigurationOptions
            } : {},
            configuration: newConfigurationOptions.length > 0 ? {
                optionWeights: newConfigurationOptions
            } : {},
            type: 'updateFieldOptionWeight'
        }).then(()=>{
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.optionWeightChanged(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: fields[fieldKey].type,
                fieldValueId: jiraOptionId
            });
        }).catch((err)=>{
            const currentFields = {
                ...getState().fields
            };
            currentFields[fieldKey] = {
                ...currentFields[fieldKey],
                options: previousOptions,
                configuration: {
                    ...currentFields[fieldKey].configuration,
                    optionWeights: oldConfigurationOptions?.length > 0 ? oldConfigurationOptions : undefined
                }
            };
            setState({
                fields: currentFields
            });
            onFieldUpdateFailed(err);
        });
    };

});
parcelRegister("6yBOC", function(module, exports) {

$parcel$export(module.exports, "sanitizeOptionWeights", () => $26a63a42e98266a4$export$38737a04fd8c7aea);
/**
 * Removes obsolete and duplicated option weights originating from select and multiselect fields.
 * https://pi-dev-sandbox.atlassian.net/browse/POL-7929
 */ const $26a63a42e98266a4$export$38737a04fd8c7aea = (fieldOptions, optionIds)=>{
    const existingOptionIds = {};
    return fieldOptions.filter(({ optionId: optionId })=>{
        if (!optionIds.includes(optionId.toString())) return false;
        if (existingOptionIds[optionId.toString()]) return false;
        existingOptionIds[optionId.toString()] = true;
        return true;
    });
};

});


parcelRegister("6ANnh", function(module, exports) {

$parcel$export(module.exports, "syncFieldsIssueTypes", () => $761c7b425874968a$export$d7a3173c9ec3a590);

var $huH03 = parcelRequire("huH03");
const $761c7b425874968a$export$d7a3173c9ec3a590 = ()=>({ setState: setState, getState: getState }, { issueTypeIds: issueTypeIds = [] })=>{
        setState({
            fields: (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(getState().fields, (field)=>({
                    ...field,
                    issueTypes: issueTypeIds
                }))
        });
    };

});

parcelRegister("5LMfW", function(module, exports) {

$parcel$export(module.exports, "updateConnectionFieldFilter", () => $72623694732fee47$export$c640d81da10e7f54);
$parcel$export(module.exports, "updateConnectionFieldIssueViewLayout", () => $72623694732fee47$export$1d6ee092ed076358);

var $evg82 = parcelRequire("evg82");

var $6Yd06 = parcelRequire("6Yd06");


var $3z31F = parcelRequire("3z31F");

var $7jTnu = parcelRequire("7jTnu");

var $bNW0R = parcelRequire("bNW0R");
const $72623694732fee47$export$c640d81da10e7f54 = (fieldKey, filter)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote })=>{
        const state = getState();
        const currentField = (0, $bNW0R.createGetFieldByKey)(fieldKey)(state);
        if (!currentField) return;
        const newConfiguration = {
            ...currentField.configuration,
            issueTypeFilters: filter && (0, $evg82.isIssueTypeNameFilter)(filter) ? [
                filter
            ] : []
        };
        try {
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: {
                        ...currentField,
                        configuration: newConfiguration
                    }
                }
            });
            await fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                oldConfiguration: currentField.configuration || {},
                configuration: newConfiguration,
                type: 'updateConnectionField'
            });
        } catch (error) {
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: currentField
                }
            });
            if (error instanceof Error) {
                (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.field.actions.update-field-configuration.connection.issue-filters', 'Failed to update connection field issue filters', error);
                onFieldUpdateFailed(error);
            }
        }
    };
const $72623694732fee47$export$1d6ee092ed076358 = (fieldKey, config)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, globalFieldRemote: globalFieldRemote, isSharedView: isSharedView })=>{
        const state = getState();
        const currentField = (0, $bNW0R.createGetFieldByKey)(fieldKey)(state);
        if (!currentField) return;
        const currentConfiguration = currentField.configuration || {};
        let issueViewLayoutFields;
        if (config.selectedFieldKey === undefined) issueViewLayoutFields = currentConfiguration.issueViewLayout?.fields || [];
        else if (config.selectedFieldKey === null) issueViewLayoutFields = [];
        else issueViewLayoutFields = [
            config.selectedFieldKey
        ];
        let issueViewLayoutSort;
        if (config.selectedFieldKey === null && currentConfiguration.issueViewLayout?.sort?.[0]?.fieldKey !== (0, $9a5f06039e1dff5a$export$469f8bf472cb9ca)) issueViewLayoutSort = [];
        else if (config.sort === undefined) issueViewLayoutSort = currentConfiguration.issueViewLayout?.sort || [];
        else if (config.sort === null) issueViewLayoutSort = [];
        else issueViewLayoutSort = [
            config.sort
        ];
        const newConfiguration = {
            ...currentConfiguration,
            issueViewLayout: {
                fields: issueViewLayoutFields,
                sort: issueViewLayoutSort
            }
        };
        try {
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: {
                        ...currentField,
                        configuration: newConfiguration
                    }
                }
            });
            if ((0, $7jTnu.fg)('jpd-connections-support-on-published-views')) {
                if (isSharedView) return;
            }
            if (currentField.global) await globalFieldRemote.updateGlobalFieldConfiguration({
                fieldKey: fieldKey,
                patch: (0, $3z31F.createJsonPatch)(currentConfiguration, newConfiguration)
            });
            else await fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                oldConfiguration: currentConfiguration,
                configuration: newConfiguration,
                type: 'updateConnectionField'
            });
        } catch (error) {
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: currentField
                }
            });
            if (error instanceof Error) {
                (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.field.actions.update-field-configuration.connection.issue-view-layout', 'Failed to update connection field issue view layout', error);
                onFieldUpdateFailed(error);
            }
        }
    };

});
parcelRegister("3z31F", function(module, exports) {

$parcel$export(module.exports, "createJsonPatch", () => $2e70f95ac68f400f$export$cc0934c8c9651d07);

var $cSmYj = parcelRequire("cSmYj");
const $2e70f95ac68f400f$export$cc0934c8c9651d07 = (oldObject, newObject)=>{
    // undefined value for undefined is not a valid value in JSON schema
    // stringify and parse to deep clone the objects to get rid of
    // undefined values are removed when stringified, or replaced with null when makes sense
    const oldObj = JSON.parse(JSON.stringify(oldObject));
    const newObj = JSON.parse(JSON.stringify(newObject));
    const patch = [];
    for (const [oldKey, value] of Object.entries(oldObj)){
        if (!(oldKey in newObj)) patch.push({
            op: 'remove',
            path: `/${oldKey}`
        });
        else if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(value, newObj[oldKey])) patch.push({
            op: 'replace',
            value: newObj[oldKey],
            path: `/${oldKey}`
        });
    }
    for (const [key, value] of Object.entries(newObj))if (!(key in oldObj)) patch.push({
        op: 'add',
        path: `/${key}`,
        value: value
    });
    return patch;
};

});


parcelRegister("lRsv0", function(module, exports) {

$parcel$export(module.exports, "updateDeliveryFieldPresentation", () => $91a3cbd08cbbce23$export$5a0c65e78b5a9b0f);

var $gCeeo = parcelRequire("gCeeo");

var $5tOWS = parcelRequire("5tOWS");

var $bNW0R = parcelRequire("bNW0R");
const $91a3cbd08cbbce23$export$5a0c65e78b5a9b0f = (fieldKey, presentation)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const currentField = (0, $bNW0R.createGetFieldByKey)(fieldKey)(state);
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
            updatedItems: [
                {
                    name: 'presentation'
                }
            ],
            issueFieldKey: currentField.key,
            issueFieldType: currentField.type
        });
        setState({
            fields: {
                ...state.fields,
                [fieldKey]: {
                    ...state.fields[fieldKey],
                    presentation: {
                        type: presentation
                    }
                }
            }
        });
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: currentField.presentation ? {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                polarisPresentation: currentField.presentation.type
            } : {},
            configuration: {
                polarisPresentation: presentation
            },
            type: 'updateDeliveryFieldPresentation',
            isGlobalSystemField: (0, $5tOWS.isGlobalSystemField)(currentField)
        });
    };

});

parcelRegister("2MIG4", function(module, exports) {

$parcel$export(module.exports, "updateDescription", () => $046a8de8f934ab84$export$989a858ef0c8fda5);

var $1I887 = parcelRequire("1I887");
const $046a8de8f934ab84$var$getUpdatedState = (state, fieldKey, description)=>({
        ...state,
        fields: {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                description: description
            }
        }
    });
const $046a8de8f934ab84$export$989a858ef0c8fda5 = (fieldKey, description, createAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote })=>{
        const state = getState();
        const oldDescription = state.fields[fieldKey].description;
        if (!state.fields[fieldKey] || state.fields[fieldKey].description === description) return;
        setState($046a8de8f934ab84$var$getUpdatedState(state, fieldKey, description));
        try {
            const newFieldState = await fieldRemote.updateField({
                fieldKey: fieldKey,
                description: description
            });
            setState($046a8de8f934ab84$var$getUpdatedState(getState(), fieldKey, newFieldState.description));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState($046a8de8f934ab84$var$getUpdatedState(getState(), fieldKey, oldDescription));
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.descriptionChangedFailure(createAnalyticsEvent({}));
            onFieldUpdateFailed(err);
            return;
        }
        (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.descriptionChangedSuccess(createAnalyticsEvent({}), {
            issueFieldKey: fieldKey,
            issueFieldType: state.fields[fieldKey].type
        });
    };

});

parcelRegister("9XY3j", function(module, exports) {

$parcel$export(module.exports, "updateEmoji", () => $fa1134279fa4e0b3$export$b5424c372b533bed);

var $1I887 = parcelRequire("1I887");
const $fa1134279fa4e0b3$var$getUpdatedState = (state, fieldKey, emoji)=>({
        ...state,
        fields: {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                emoji: emoji
            }
        }
    });
const $fa1134279fa4e0b3$export$b5424c372b533bed = (fieldKey, emoji, createAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote })=>{
        const state = getState();
        const field = state.fields[fieldKey];
        const oldEmoji = field.emoji;
        if (!field || field.emoji === emoji) return;
        setState($fa1134279fa4e0b3$var$getUpdatedState(state, fieldKey, emoji));
        try {
            await fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                oldConfiguration: oldEmoji ? {
                    emoji: oldEmoji
                } : {},
                configuration: emoji ? {
                    emoji: emoji
                } : {},
                type: 'updateEmoji'
            });
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.emojiChangedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: field.type
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState($fa1134279fa4e0b3$var$getUpdatedState(getState(), fieldKey, oldEmoji));
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.emojiChangedFailure(createAnalyticsEvent({}));
            onFieldUpdateFailed(err);
        }
    };

});

parcelRegister("4betO", function(module, exports) {

$parcel$export(module.exports, "updateFieldFormula", () => $811fb11d31e0cbd2$export$ae0ab6f53041dfe5);

var $gCeeo = parcelRequire("gCeeo");

var $5tOWS = parcelRequire("5tOWS");
const $811fb11d31e0cbd2$export$ae0ab6f53041dfe5 = (fieldKey, formula, abortSignal)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        const currentField = state.fields[fieldKey];
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
            updatedItems: [
                {
                    name: 'formula'
                }
            ],
            issueFieldKey: currentField.key,
            issueFieldType: currentField.type
        });
        const oldConfiguration = currentField.formula ? {
            polarisFormula: currentField.formula
        } : {};
        const configuration = {
            polarisFormula: formula
        };
        await fieldRemote.updateFieldConfiguration({
            fieldKey: fieldKey,
            oldConfiguration: oldConfiguration,
            configuration: configuration,
            type: 'updateFieldFormula',
            isGlobalSystemField: (0, $5tOWS.isGlobalSystemField)(currentField)
        }, abortSignal);
        const newField = {
            ...currentField,
            formula: formula,
            configuration: {
                ...currentField.configuration,
                ...configuration
            }
        };
        setState({
            fields: {
                ...getState().fields,
                [fieldKey]: newField
            }
        });
        return newField;
    };

});

parcelRegister("h0KXW", function(module, exports) {

$parcel$export(module.exports, "updateLabel", () => $e9ae9b0a41fcf18b$export$b823280c6eab17e9);

var $1I887 = parcelRequire("1I887");
const $e9ae9b0a41fcf18b$var$getUpdatedState = (state, fieldKey, label)=>({
        ...state,
        fields: {
            ...state.fields,
            [fieldKey]: {
                ...state.fields[fieldKey],
                label: label
            }
        }
    });
const $e9ae9b0a41fcf18b$export$b823280c6eab17e9 = (fieldKey, label, createAnalyticsEvent)=>async ({ getState: getState, setState: setState }, { fieldRemote: fieldRemote })=>{
        try {
            const state = getState();
            if (!state.fields[fieldKey] || state.fields[fieldKey].label === label) return false;
            await fieldRemote.updateField({
                fieldKey: fieldKey,
                name: label
            });
            setState($e9ae9b0a41fcf18b$var$getUpdatedState(getState(), fieldKey, label));
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.labelChangedSuccess(createAnalyticsEvent({}), {
                issueFieldKey: fieldKey,
                issueFieldType: state.fields[fieldKey].type
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $1I887.fireCompoundAnalyticsEvent).FieldConfig.labelChangedFailure(createAnalyticsEvent({}));
            return e;
        }
    };

});

parcelRegister("ldzeh", function(module, exports) {

$parcel$export(module.exports, "updatePlayField", () => $ce32ffafbec5308c$export$870e1a1a0d62147f);

var $gCeeo = parcelRequire("gCeeo");
const $ce32ffafbec5308c$export$870e1a1a0d62147f = (fieldKey, maxSpend)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        const field = state.fields[fieldKey];
        try {
            if (field?.play?.id === undefined) {
                onFieldUpdateFailed(new Error('Updated failed: field without id cannot be updated'));
                return;
            }
            await fieldRemote.updatePlayField({
                id: field.play.id,
                parameters: {
                    maxSpend: maxSpend
                }
            });
            const oldMaxSpend = field.play?.parameters?.maxSpend;
            await fieldRemote.updateFieldConfiguration({
                fieldKey: fieldKey,
                configuration: {
                    maxSpend: maxSpend
                },
                oldConfiguration: oldMaxSpend ? {
                    maxSpend: oldMaxSpend
                } : {},
                type: 'updatePlayField'
            });
            setState({
                fields: {
                    ...state.fields,
                    [fieldKey]: {
                        ...field,
                        play: {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            ...field.play,
                            parameters: {
                                ...field.play?.parameters,
                                maxSpend: maxSpend
                            }
                        }
                    }
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
                updatedItems: [
                    {
                        name: 'play.maxSpend'
                    }
                ],
                issueFieldKey: fieldKey,
                issueFieldType: field?.type
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onFieldUpdateFailed(error);
        }
    };

});

parcelRegister("89HFt", function(module, exports) {

$parcel$export(module.exports, "updateSystemFieldHidden", () => $827edc64aaedcd1b$export$2a6a1ba980ab5158);

var $5tOWS = parcelRequire("5tOWS");

var $gCeeo = parcelRequire("gCeeo");

var $bNW0R = parcelRequire("bNW0R");
const $827edc64aaedcd1b$export$2a6a1ba980ab5158 = (fieldKey, hidden)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const field = (0, $bNW0R.createGetFieldByKey)(fieldKey)(getState());
        if (!field || !(0, $5tOWS.fieldCanBeHidden)(field.type) || field.configuration?.hidden === hidden) return;
        try {
            const configuration = {
                ...field.configuration,
                hidden: hidden
            };
            const fields = {
                ...getState().fields
            };
            setState({
                fields: {
                    ...fields,
                    [fieldKey]: {
                        ...fields[fieldKey],
                        configuration: configuration
                    }
                }
            });
            try {
                await fieldRemote.updateFieldConfiguration({
                    oldConfiguration: field.configuration ?? {},
                    configuration: configuration,
                    fieldKey: field.key,
                    type: 'updateSystemFieldHidden',
                    isGlobalSystemField: (0, $5tOWS.isGlobalSystemField)(field)
                });
            } catch (error) {
                const currentState = getState();
                const currentFields = currentState.fields;
                setState({
                    fields: {
                        ...currentFields,
                        [fieldKey]: {
                            ...currentFields[fieldKey],
                            configuration: {
                                ...currentFields[fieldKey].configuration,
                                hidden: field.configuration?.hidden ?? !hidden
                            }
                        }
                    }
                });
                throw error;
            }
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
                issueFieldKey: fieldKey,
                issueFieldType: field.type,
                updatedItems: [
                    {
                        name: 'hidden'
                    }
                ]
            });
        } catch (error) {
            onFieldUpdateFailed(error instanceof Error ? error : new Error('failed to update system field hidden'));
            throw error;
        }
    };

});

parcelRegister("fOkFa", function(module, exports) {

$parcel$export(module.exports, "updateUserFieldDisplayMode", () => $e6e608958ae0d2bc$export$4e721c33f5dab30);

var $gCeeo = parcelRequire("gCeeo");

var $bNW0R = parcelRequire("bNW0R");
const $e6e608958ae0d2bc$export$4e721c33f5dab30 = (fieldKey, displayMode, localUpdate = false)=>async ({ getState: getState, setState: setState }, { onFieldUpdateFailed: onFieldUpdateFailed, fieldRemote: fieldRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            const field = (0, $bNW0R.createGetFieldByKey)(fieldKey)(getState());
            if (!field) return undefined;
            const configuration = {
                ...field.configuration,
                displayMode: displayMode
            };
            if (!localUpdate) await fieldRemote.updateFieldConfiguration({
                oldConfiguration: field.configuration ?? {},
                configuration: configuration,
                fieldKey: field.key,
                type: 'updateUserFieldDisplayMode'
            });
            const fields = {
                ...getState().fields
            };
            fields[fieldKey] = {
                ...fields[fieldKey],
                configuration: configuration
            };
            setState({
                fields: fields
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueFields updated', {
                issueFieldKey: fieldKey,
                issueFieldType: field.type,
                updatedItems: [
                    {
                        name: 'displayMode'
                    }
                ]
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            onFieldUpdateFailed(err);
        }
    };

});



parcelRegister("ey7Lz", function(module, exports) {

$parcel$export(module.exports, "isCreatingIdeasGroupBySupported", () => $5cbe3061142812c2$export$6486157efc72d13);

var $eTBmS = parcelRequire("eTBmS");
// This is done by design as we limit fields that can be used here inside
// the array only to fields that supports grouping
const $5cbe3061142812c2$var$CREATING_IDEAS_GROUP_BY_NOT_SUPPORTED_FIELD_TYPES = [
    (0, $eTBmS.FIELD_TYPES).FORMULA,
    (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES,
    (0, $eTBmS.FIELD_TYPES).INSIGHTS,
    (0, $eTBmS.FIELD_TYPES).CREATOR,
    (0, $eTBmS.FIELD_TYPES).REPORTER,
    (0, $eTBmS.FIELD_TYPES).REACTIONS
];
const $5cbe3061142812c2$export$6486157efc72d13 = (fieldType)=>{
    if (fieldType === undefined) return true;
    const notSupported = $5cbe3061142812c2$var$CREATING_IDEAS_GROUP_BY_NOT_SUPPORTED_FIELD_TYPES.some((item)=>item === fieldType);
    return !notSupported;
};

});

parcelRegister("NBKfp", function(module, exports) {

$parcel$export(module.exports, "createFieldHook", () => $86842ab17ee6092f$export$4cddd3725060adbc);
$parcel$export(module.exports, "createHigherLevelFieldHook", () => $86842ab17ee6092f$export$67d6a9af20f2969f);
$parcel$export(module.exports, "createHigherLevelFieldHook2", () => $86842ab17ee6092f$export$18156830b448602e);
$parcel$export(module.exports, "createHigherLevelFieldHook3", () => $86842ab17ee6092f$export$a2bc3ef72fea1e90);

var $hQR6K = parcelRequire("hQR6K");
const $86842ab17ee6092f$export$4cddd3725060adbc = (0, $hQR6K.createFieldHook);
const $86842ab17ee6092f$export$67d6a9af20f2969f = (selectorCreator)=>(0, $hQR6K.createHigherLevelFieldHook)(selectorCreator);
const $86842ab17ee6092f$export$18156830b448602e = (selectorCreator)=>(0, $hQR6K.createHigherLevelFieldHook)(selectorCreator);
const $86842ab17ee6092f$export$a2bc3ef72fea1e90 = (selectorCreator)=>(0, $hQR6K.createHigherLevelFieldHook)(selectorCreator);

});


parcelRegister("eSzwT", function(module, exports) {

$parcel$export(module.exports, "useIssueKey", () => $87c7445a16bec686$export$22108eca27445997);
$parcel$export(module.exports, "useSafeIssueKey", () => $87c7445a16bec686$export$116ac9de56b839b1);
$parcel$export(module.exports, "useSafeJiraIssueId", () => $87c7445a16bec686$export$e882b9c510f60b34);
$parcel$export(module.exports, "useSummary", () => $87c7445a16bec686$export$80b235df19ed566d);
$parcel$export(module.exports, "useDescription", () => $87c7445a16bec686$export$f8aeda7b10753fa1);
$parcel$export(module.exports, "useIssueAnalyticsAttributes", () => $87c7445a16bec686$export$4bf12515bf99caba);
$parcel$export(module.exports, "useIssueType", () => $87c7445a16bec686$export$6c4c9b3e84687e41);
$parcel$export(module.exports, "useStatus", () => $87c7445a16bec686$export$53cc6abb6942ce72);
$parcel$export(module.exports, "useIssueCreatedProperty", () => $87c7445a16bec686$export$581ee3ea831de972);
$parcel$export(module.exports, "useIdeasInCreation", () => $87c7445a16bec686$export$de54acc4521c9e8);
$parcel$export(module.exports, "useIdeasInCreationGrouped", () => $87c7445a16bec686$export$37eec6ee9de620f1);
$parcel$export(module.exports, "useStringValue", () => $87c7445a16bec686$export$aed6e690a280afcc);
$parcel$export(module.exports, "useTeamValue", () => $87c7445a16bec686$export$a500c3196042288e);
$parcel$export(module.exports, "useIsSelectedIssueAvailable", () => $87c7445a16bec686$export$f070c6903e27d6f2);
$parcel$export(module.exports, "useSelectedIssue", () => $87c7445a16bec686$export$6dca1907c3f07ead);
$parcel$export(module.exports, "useSelectedIssueStringValue", () => $87c7445a16bec686$export$f09b0a2282e598f3);
$parcel$export(module.exports, "useSelectedIssuesIntervalDateValues", () => $87c7445a16bec686$export$75961026da86fb54);
$parcel$export(module.exports, "useSelectedIssueStatusValue", () => $87c7445a16bec686$export$f3b5874349b7a98e);
$parcel$export(module.exports, "useSelectedIssueUserValue", () => $87c7445a16bec686$export$1726f45f60e23539);
$parcel$export(module.exports, "useSelectedIssueTeamValue", () => $87c7445a16bec686$export$4fa960c5c6fd87e2);
$parcel$export(module.exports, "useSelectedIssueSummary", () => $87c7445a16bec686$export$8199a5dd62184496);
$parcel$export(module.exports, "useSelectedIssueKey", () => $87c7445a16bec686$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useSelectedIssueJiraId", () => $87c7445a16bec686$export$e563fe99d8e5dadf);
$parcel$export(module.exports, "useSelectedIssueId", () => $87c7445a16bec686$export$f956c01a5c5aa395);
$parcel$export(module.exports, "useSelectedIssueIssueType", () => $87c7445a16bec686$export$7e6b3d8c90e19ccd);
$parcel$export(module.exports, "useSelectedIssueProject", () => $87c7445a16bec686$export$799bfea1927e4236);
$parcel$export(module.exports, "useSelectedIssueProjectId", () => $87c7445a16bec686$export$e4630b095b29174e);
$parcel$export(module.exports, "useSelectedIssueProjectAri", () => $87c7445a16bec686$export$ea8b8577f5e45fa1);
$parcel$export(module.exports, "useNumberValue", () => $87c7445a16bec686$export$da16f2aebdc441d4);
$parcel$export(module.exports, "useProjectValue", () => $87c7445a16bec686$export$3baa71aec6ee674f);
$parcel$export(module.exports, "useExternalReferenceValue", () => $87c7445a16bec686$export$a327848e3c58aa74);
$parcel$export(module.exports, "usePlatformGoalsValue", () => $87c7445a16bec686$export$8bfa5dff7a8eef7a);
$parcel$export(module.exports, "useAllGoalsAri", () => $87c7445a16bec686$export$2496a93bddb10f72);
$parcel$export(module.exports, "useExternalReferencePropertyValue", () => $87c7445a16bec686$export$681d3d2b083d1bf7);
$parcel$export(module.exports, "useAllExternalReferencesPropertiesForProvider", () => $87c7445a16bec686$export$ff2574eb4f327600);
$parcel$export(module.exports, "useIsSelectedIssueArchived", () => $87c7445a16bec686$export$ee3f505e1ac301e3);
$parcel$export(module.exports, "useIsIssueArchived", () => $87c7445a16bec686$export$f3bed644fce04952);
$parcel$export(module.exports, "useStringListValue", () => $87c7445a16bec686$export$3a24218c14ef87e6);
$parcel$export(module.exports, "useUser", () => $87c7445a16bec686$export$23bbbc4533528f03);
$parcel$export(module.exports, "useUserByAccountId", () => $87c7445a16bec686$export$7e7f5cda13adcb96);
$parcel$export(module.exports, "useUsersByAccountId", () => $87c7445a16bec686$export$1d27f6d63cc58174);
$parcel$export(module.exports, "usePeople", () => $87c7445a16bec686$export$47398a0b12dd3d0);
$parcel$export(module.exports, "usePeopleByAccountId", () => $87c7445a16bec686$export$5d48317bd12c700a);
$parcel$export(module.exports, "usePeopleTransformed", () => $87c7445a16bec686$export$d3795932a4e3272d);
$parcel$export(module.exports, "useSingleSelect", () => $87c7445a16bec686$export$8c09207f46b4a494);
$parcel$export(module.exports, "useMultiSelect", () => $87c7445a16bec686$export$efbfa63d6e989c0e);
$parcel$export(module.exports, "useSummaries", () => $87c7445a16bec686$export$5e39ab3b299d6105);
$parcel$export(module.exports, "useProjects", () => $87c7445a16bec686$export$39d4f31fc4866d70);
$parcel$export(module.exports, "useKeys", () => $87c7445a16bec686$export$2006064841430665);
$parcel$export(module.exports, "useIssueTypes", () => $87c7445a16bec686$export$8bbc5cc35915a21b);
$parcel$export(module.exports, "useSelectedIssueLinkedIssueData", () => $87c7445a16bec686$export$c5b3f5f014eb54b2);
$parcel$export(module.exports, "useLinkedProgress", () => $87c7445a16bec686$export$157d990913723e8);
$parcel$export(module.exports, "useLinkedDeliveryIssuesCount", () => $87c7445a16bec686$export$f4b19532275ccb3);
$parcel$export(module.exports, "useLinkedDeliveryIssuesExist", () => $87c7445a16bec686$export$9c1d04fa491ce1b);
$parcel$export(module.exports, "useSelectedIssueLinkedProgress", () => $87c7445a16bec686$export$f20f22fbbf16940e);
$parcel$export(module.exports, "useSingleLinkedStatus", () => $87c7445a16bec686$export$638d5862bd2fac8f);
$parcel$export(module.exports, "useSingleIssueDeliveryDate", () => $87c7445a16bec686$export$16fdbe4e163c3f24);
$parcel$export(module.exports, "useKeyProperties", () => $87c7445a16bec686$export$dd3aa2fa976a602d);
$parcel$export(module.exports, "useAllProperties", () => $87c7445a16bec686$export$2b2eff789e9f243a);
$parcel$export(module.exports, "useIsFieldAssociatedToIssue", () => $87c7445a16bec686$export$105b4a25703f68d8);
$parcel$export(module.exports, "useIsDeliveryTicketLinkedInProject", () => $87c7445a16bec686$export$28d9cae6169adb0b);

var $eJOHy = parcelRequire("eJOHy");

var $3osLr = parcelRequire("3osLr");

var $lvKO5 = parcelRequire("lvKO5");

var $ePUpL = parcelRequire("ePUpL");

var $2HLUa = parcelRequire("2HLUa");

var $hYLdy = parcelRequire("hYLdy");

var $1YLsD = parcelRequire("1YLsD");

var $gWoBr = parcelRequire("gWoBr");

var $hEORc = parcelRequire("hEORc");

var $4TCfW = parcelRequire("4TCfW");

var $53OVi = parcelRequire("53OVi");

var $5rDh3 = parcelRequire("5rDh3");
const $87c7445a16bec686$export$22108eca27445997 = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetKeySelector));
const $87c7445a16bec686$export$116ac9de56b839b1 = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createSafeGetKeySelector));
const $87c7445a16bec686$export$e882b9c510f60b34 = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createSafeGetJiraIdSelector));
const $87c7445a16bec686$export$80b235df19ed566d = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetSummary));
const $87c7445a16bec686$export$f8aeda7b10753fa1 = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetDescription));
const $87c7445a16bec686$export$4bf12515bf99caba = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetIssueAnalyticsAttributes));
const $87c7445a16bec686$export$6c4c9b3e84687e41 = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetIssueType));
const $87c7445a16bec686$export$53cc6abb6942ce72 = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetStatus));
const $87c7445a16bec686$export$581ee3ea831de972 = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetIssueCreationStateProperties));
const $87c7445a16bec686$export$de54acc4521c9e8 = (0, $gWoBr.createIssueHook)((0, $4TCfW.getIdeasInCreation));
const $87c7445a16bec686$export$37eec6ee9de620f1 = (0, $gWoBr.createIssueHook)((0, $4TCfW.getIdeasInCreationGrouped));
const $87c7445a16bec686$export$aed6e690a280afcc = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetStringValueSelector));
const $87c7445a16bec686$export$a500c3196042288e = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetTeamSelector));
const $87c7445a16bec686$export$f070c6903e27d6f2 = (0, $gWoBr.createIssueHook)((0, $4TCfW.hasSelectedLocalIssueId));
const $87c7445a16bec686$export$6dca1907c3f07ead = (0, $gWoBr.createIssueHook)((0, $4TCfW.getSelectedIssueLocalIssueId));
const $87c7445a16bec686$export$f09b0a2282e598f3 = (0, $gWoBr.createSelectedIssueHook)((0, $4TCfW.createGetStringValueSelector));
const $87c7445a16bec686$export$75961026da86fb54 = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetIntervalDateValuesSelector));
const $87c7445a16bec686$export$f3b5874349b7a98e = (0, $gWoBr.createSelectedIssueHook)((0, $4TCfW.createGetSingularStatusSelectorForSelectedIssueHook));
const $87c7445a16bec686$export$1726f45f60e23539 = (0, $gWoBr.createSelectedIssueHook)((0, $4TCfW.createGetUserSelector));
const $87c7445a16bec686$export$4fa960c5c6fd87e2 = (0, $gWoBr.createSelectedIssueHook)((0, $4TCfW.createGetTeamSelector));
const $87c7445a16bec686$export$8199a5dd62184496 = (0, $gWoBr.createSelectedIssueHook2)((0, $4TCfW.createGetSummary));
const $87c7445a16bec686$export$7cedcbfb2da7e49d = (0, $gWoBr.createIssueHook)((0, $4TCfW.getSelectedIssue));
const $87c7445a16bec686$export$e563fe99d8e5dadf = (0, $gWoBr.createIssueHook)((0, $4TCfW.getSelectedIssueJiraId));
const $87c7445a16bec686$export$f956c01a5c5aa395 = (0, $gWoBr.createSelectedIssueHook2)((0, $4TCfW.createGetIdSelector));
const $87c7445a16bec686$export$7e6b3d8c90e19ccd = (0, $gWoBr.createSelectedIssueHook2)((0, $4TCfW.createGetIssueType));
const $87c7445a16bec686$export$799bfea1927e4236 = (0, $gWoBr.createSelectedIssueHook2)((0, $4TCfW.createGetProjectSelector));
const $87c7445a16bec686$export$e4630b095b29174e = (0, $gWoBr.createSelectedIssueHook2)((0, $4TCfW.createGetProjectIdSelector));
const $87c7445a16bec686$export$ea8b8577f5e45fa1 = ()=>{
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const projectId = $87c7445a16bec686$export$799bfea1927e4236()?.id;
    if (!projectId) return;
    return (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString();
};
const $87c7445a16bec686$var$useNumberValueInternal = (0, $gWoBr.createHigherLevelIssueHook3)((0, $4TCfW.createGetNumberValueSelector));
const $87c7445a16bec686$export$da16f2aebdc441d4 = (fieldKey, localIssueId)=>{
    const field = (0, $2HLUa.useField)(fieldKey);
    const isDynamicFieldIsInitialized = (0, $ePUpL.useIsDynamicFieldIsInitialized)(fieldKey);
    const isSingleIssueLoaded = (0, $1YLsD.useIsSingleIssueLoaded)();
    const isInitialized = (0, $hYLdy.useIsInitialized)();
    return {
        value: $87c7445a16bec686$var$useNumberValueInternal(fieldKey, localIssueId, isDynamicFieldIsInitialized),
        initialized: isDynamicFieldIsInitialized || !field?.formula || isSingleIssueLoaded && !isInitialized
    };
};
const $87c7445a16bec686$export$3baa71aec6ee674f = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetProjectSelector));
const $87c7445a16bec686$export$a327848e3c58aa74 = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetExternalReferencesValueSelector));
const $87c7445a16bec686$export$8bfa5dff7a8eef7a = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetPlatformGoalsValueSelector));
const $87c7445a16bec686$export$2496a93bddb10f72 = (0, $gWoBr.createIssueHook)((0, $4TCfW.getAllGoalsAri));
const $87c7445a16bec686$export$681d3d2b083d1bf7 = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetExternalReferencePropertyValueSelector));
const $87c7445a16bec686$export$fb63dcf4acbe8a86 = (0, $gWoBr.createIssueHook)((0, $4TCfW.getAllExternalReferencesPropertiesByProvider));
const $87c7445a16bec686$export$ff2574eb4f327600 = (provider)=>{
    const allExternalReferencesPropertiesByProvider = $87c7445a16bec686$export$fb63dcf4acbe8a86();
    return (0, $eJOHy.useMemo)(()=>provider ? allExternalReferencesPropertiesByProvider[provider] || [] : [], [
        allExternalReferencesPropertiesByProvider,
        provider
    ]);
};
const $87c7445a16bec686$var$useIsSelectedIssueArchivedSelector = (0, $gWoBr.createSelectedIssueHook2)((0, $4TCfW.createGetIsArchivedSelector));
const $87c7445a16bec686$export$ee3f505e1ac301e3 = ()=>{
    const isArchived = $87c7445a16bec686$var$useIsSelectedIssueArchivedSelector();
    return isArchived === true;
};
const $87c7445a16bec686$export$f3bed644fce04952 = (0, $gWoBr.createHigherLevelIssueHook)((0, $4TCfW.createGetIsArchivedSelector));
const $87c7445a16bec686$export$3a24218c14ef87e6 = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetStringListValueSelector));
const $87c7445a16bec686$export$23bbbc4533528f03 = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetUserSelector));
const $87c7445a16bec686$export$7e7f5cda13adcb96 = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetUserByAccountIdSelector));
const $87c7445a16bec686$export$1d27f6d63cc58174 = (0, $gWoBr.createHigherLevelIssueHook)((0, $5rDh3.createGetUsersByAccountIdSelector));
const $87c7445a16bec686$export$47398a0b12dd3d0 = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetPeopleSelector));
const $87c7445a16bec686$export$5d48317bd12c700a = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetPeopleByAccountIdSelector));
const $87c7445a16bec686$export$d3795932a4e3272d = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetPeopleTransformedSelector));
const $87c7445a16bec686$export$8c09207f46b4a494 = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetSingleOptionSelector));
const $87c7445a16bec686$export$efbfa63d6e989c0e = (0, $gWoBr.createHigherLevelIssueHook2)((0, $4TCfW.createGetMultiOptionSelector));
const $87c7445a16bec686$var$getMultiSelects = (state)=>state.properties.multiSelect;
const $87c7445a16bec686$export$680c8096b2e8a7af = (0, $gWoBr.createIssueHook)($87c7445a16bec686$var$getMultiSelects);
const $87c7445a16bec686$var$getSummaries = (state)=>state.properties.string.summary;
const $87c7445a16bec686$export$5e39ab3b299d6105 = (0, $gWoBr.createIssueHook)($87c7445a16bec686$var$getSummaries);
const $87c7445a16bec686$var$getProjects = (state)=>state.properties.projects.project;
const $87c7445a16bec686$export$39d4f31fc4866d70 = (0, $gWoBr.createIssueHook)($87c7445a16bec686$var$getProjects);
const $87c7445a16bec686$export$74743eda5dda3ccf = (state)=>state.properties.string.key;
const $87c7445a16bec686$export$2006064841430665 = (0, $gWoBr.createIssueHook)($87c7445a16bec686$export$74743eda5dda3ccf);
const $87c7445a16bec686$var$getIssueTypes = (state)=>state.properties.issueType.issuetype;
const $87c7445a16bec686$export$8bbc5cc35915a21b = (0, $gWoBr.createIssueHook)($87c7445a16bec686$var$getIssueTypes);
const $87c7445a16bec686$export$2c069093df41970c = (0, $gWoBr.createHigherLevelIssueHook)((0, $53OVi.createGetLinkedIssueData));
const $87c7445a16bec686$export$c5b3f5f014eb54b2 = (0, $gWoBr.createSelectedIssueHook2)((0, $53OVi.createGetLinkedIssueData));
const $87c7445a16bec686$export$157d990913723e8 = (0, $gWoBr.createHigherLevelIssueHook)((0, $53OVi.createGetLinkedProgress));
const $87c7445a16bec686$export$f4b19532275ccb3 = (0, $gWoBr.createHigherLevelIssueHook)((0, $53OVi.createGetLinkedDeliveryTicketsCount));
const $87c7445a16bec686$export$9c1d04fa491ce1b = (0, $gWoBr.createHigherLevelIssueHook)((0, $53OVi.createGetLinkedDeliveryIssuesExist));
const $87c7445a16bec686$export$f20f22fbbf16940e = (0, $gWoBr.createSelectedIssueHook2)((0, $53OVi.createGetLinkedProgress));
const $87c7445a16bec686$export$638d5862bd2fac8f = (issueId)=>{
    const externalIssueData = $87c7445a16bec686$export$2c069093df41970c(issueId);
    const issueDeliveryProgress = $87c7445a16bec686$export$157d990913723e8(issueId);
    return (0, $eJOHy.useMemo)(()=>{
        const { singleStatus: singleStatus, total: total } = issueDeliveryProgress;
        if (total === 1) {
            if (singleStatus) return singleStatus;
            if (externalIssueData.length === 1) return {
                name: externalIssueData[0].status.name,
                category: externalIssueData[0].status.statusCategory.key
            };
        }
        return undefined;
    }, [
        externalIssueData,
        issueDeliveryProgress
    ]);
};
const $87c7445a16bec686$export$16fdbe4e163c3f24 = (0, $gWoBr.createHigherLevelIssueHook3)((0, $53OVi.createGetAggregatedDeliveryDate));
const $87c7445a16bec686$export$dd3aa2fa976a602d = (0, $gWoBr.createIssueHook)((0, $4TCfW.getKeyProperties));
const $87c7445a16bec686$export$2b2eff789e9f243a = (0, $gWoBr.createIssueHook)((0, $4TCfW.getProperties));
const $87c7445a16bec686$var$useIsFieldAssociatedToIssueInternal = (0, $gWoBr.createHigherLevelIssueHook3)((0, $4TCfW.createIsFieldAssociatedToIssue));
const $87c7445a16bec686$export$105b4a25703f68d8 = (fieldKey, localIssueId)=>{
    const [connectionsFieldsAssociations] = (0, $hEORc.useConnectionsFieldsAssociations)();
    return $87c7445a16bec686$var$useIsFieldAssociatedToIssueInternal(fieldKey, localIssueId, connectionsFieldsAssociations);
};
const $87c7445a16bec686$export$28d9cae6169adb0b = (0, $gWoBr.createIssueHook)((0, $4TCfW.getIsDeliveryTicketLinkedInProject));

});
parcelRegister("ePUpL", function(module, exports) {

$parcel$export(module.exports, "DynamicFieldContainer", () => $250b7ad750229ef3$export$df7eaabf90a59a1);
$parcel$export(module.exports, "useActions", () => $250b7ad750229ef3$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useIsDynamicFieldIsInitialized", () => $250b7ad750229ef3$export$5bb32d23c1673d0);

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $hGdc8 = parcelRequire("hGdc8");

var $7Mgg6 = parcelRequire("7Mgg6");
const $250b7ad750229ef3$var$actions = {
    markDynamicFieldAsInitialized: $7Mgg6.markDynamicFieldAsInitialized,
    initialized: $hGdc8.initialized
};
const $250b7ad750229ef3$var$initialState = {
    dynamicPropertiesInitialized: {},
    initialized: false,
    containerProps: undefined
};
const $250b7ad750229ef3$var$DynamicFieldStore = (0, $jxALV.createPolarisStore)({
    initialState: $250b7ad750229ef3$var$initialState,
    actions: $250b7ad750229ef3$var$actions,
    name: 'PolariDynamicFieldStore'
});
const { Container: $250b7ad750229ef3$export$df7eaabf90a59a1, useActions: $250b7ad750229ef3$export$bc923229a7fa61e7, createHigherLevelHook: $250b7ad750229ef3$var$createHigherLevelHook } = (0, $YvHeB.createJpdContainer)($250b7ad750229ef3$var$DynamicFieldStore);
const $250b7ad750229ef3$export$5bb32d23c1673d0 = $250b7ad750229ef3$var$createHigherLevelHook((fieldKey)=>(state)=>state.initialized === true && state.dynamicPropertiesInitialized[fieldKey] === true);

});
parcelRegister("hGdc8", function(module, exports) {

$parcel$export(module.exports, "initialized", () => $cbab81bf8d487f7e$export$a9944645ccb5faf8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cbab81bf8d487f7e$export$a9944645ccb5faf8 = ()=>({ getState: getState, setState: setState })=>{
        const wasInitilized = getState().initialized;
        if (!wasInitilized) setState({
            initialized: true
        });
        return wasInitilized === true ? Promise.resolve() : undefined;
    };

});

parcelRegister("7Mgg6", function(module, exports) {

$parcel$export(module.exports, "markDynamicFieldAsInitialized", () => $0c0537bae179e82c$export$785ee2dd2b15d11b);
const $0c0537bae179e82c$export$785ee2dd2b15d11b = (fieldId)=>({ getState: getState, setState: setState })=>{
        setState({
            dynamicPropertiesInitialized: {
                ...getState().dynamicPropertiesInitialized,
                [fieldId]: true
            }
        });
    };

});


parcelRegister("2HLUa", function(module, exports) {

$parcel$export(module.exports, "useFieldOptionsWithAriResolved", () => $c2229a66e7a223fb$export$56286f2a51fffd4a);
$parcel$export(module.exports, "useField", () => $c2229a66e7a223fb$export$294aa081a6c6f55d);
$parcel$export(module.exports, "useFieldMapping", () => $c2229a66e7a223fb$export$1ab3166fb7856c74);
$parcel$export(module.exports, "useIsWeightedField", () => $c2229a66e7a223fb$export$53e8a11198965a97);
$parcel$export(module.exports, "useFieldLabel", () => $c2229a66e7a223fb$export$ea64292063d19935);
$parcel$export(module.exports, "useIssueIdField", () => $c2229a66e7a223fb$export$8fbd34cf4d3af9c0);
$parcel$export(module.exports, "useAllFieldValues", () => $c2229a66e7a223fb$export$7d5bf74b98b90233);
$parcel$export(module.exports, "useSortedDistinctIssueStatuses", () => $c2229a66e7a223fb$export$a3817fe58f5bb798);
$parcel$export(module.exports, "useIssuesStatusesById", () => $c2229a66e7a223fb$export$2af2345772c8c180);

var $2Wt2d = parcelRequire("2Wt2d");

var $iehDF = parcelRequire("iehDF");

var $gWoBr = parcelRequire("gWoBr");
const $c2229a66e7a223fb$export$56286f2a51fffd4a = (0, $gWoBr.createHigherLevelIssueHook)((0, $iehDF.createGetFieldOptionsWithAriResolved));
const $c2229a66e7a223fb$export$294aa081a6c6f55d = (0, $gWoBr.createHigherLevelIssueHook)((0, $iehDF.createGetField));
const $c2229a66e7a223fb$export$1ab3166fb7856c74 = (0, $gWoBr.createHigherLevelIssueHook)((0, $iehDF.createGetFieldMapping));
const $c2229a66e7a223fb$export$53e8a11198965a97 = (0, $gWoBr.createHigherLevelIssueHook)((0, $iehDF.createGetIsWeightedField));
const $c2229a66e7a223fb$export$ea64292063d19935 = (0, $gWoBr.createHigherLevelIssueHook3)((0, $iehDF.createGetFieldLabel));
const $c2229a66e7a223fb$export$8fbd34cf4d3af9c0 = (0, $gWoBr.createIssueHook)((0, $2Wt2d.getIssueIdField));
const $c2229a66e7a223fb$export$7d5bf74b98b90233 = (0, $gWoBr.createHigherLevelIssueHook)((0, $iehDF.getAllFieldValues));
const $c2229a66e7a223fb$export$a3817fe58f5bb798 = (0, $gWoBr.createIssueHook)((0, $iehDF.getSortedDistinctIssueStatuses));
const $c2229a66e7a223fb$export$2af2345772c8c180 = (0, $gWoBr.createIssueHook)((0, $iehDF.getIssuesStatusById));
const $c2229a66e7a223fb$export$b04168640fa2d995 = (0, $gWoBr.createIssueHook)((0, $iehDF.getIssuesSimiliarStatusIdsByStatusId));

});
parcelRegister("2Wt2d", function(module, exports) {

$parcel$export(module.exports, "getIssueIdField", () => $f32119b1a8f8234e$export$dc6f09aabd901f39);
$parcel$export(module.exports, "getDescriptionField", () => $f32119b1a8f8234e$export$81116995e48339b7);
$parcel$export(module.exports, "getPlatformGoalsField", () => $f32119b1a8f8234e$export$c9a4a58627338b79);
$parcel$export(module.exports, "getCreatorField", () => $f32119b1a8f8234e$export$774c28f4939e497);
$parcel$export(module.exports, "getCreatedField", () => $f32119b1a8f8234e$export$5063a3adcd886aef);

var $ahm5r = parcelRequire("ahm5r");

var $6kS6u = parcelRequire("6kS6u");

var $eTBmS = parcelRequire("eTBmS");
const $f32119b1a8f8234e$var$NO_FIELDS = [];
const $f32119b1a8f8234e$var$getFields = (0, $ahm5r.createSelector)((state, props)=>props?.fields, (fields)=>fields || $f32119b1a8f8234e$var$NO_FIELDS);
const $f32119b1a8f8234e$export$24feea41fb1fac18 = (condition)=>(0, $ahm5r.createSelector)($f32119b1a8f8234e$var$getFields, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(fields, condition));
const $f32119b1a8f8234e$export$aeb26b81af727338 = $f32119b1a8f8234e$export$24feea41fb1fac18(({ type: type })=>type === (0, $eTBmS.FIELD_TYPES).SUMMARY);
const $f32119b1a8f8234e$export$dc6f09aabd901f39 = $f32119b1a8f8234e$export$24feea41fb1fac18(({ type: type })=>type === (0, $eTBmS.FIELD_TYPES).ISSUE_ID);
const $f32119b1a8f8234e$export$81116995e48339b7 = $f32119b1a8f8234e$export$24feea41fb1fac18(({ type: type })=>type === (0, $eTBmS.FIELD_TYPES).DESCRIPTION);
const $f32119b1a8f8234e$export$c9a4a58627338b79 = $f32119b1a8f8234e$export$24feea41fb1fac18(({ type: type })=>type === (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS);
const $f32119b1a8f8234e$export$774c28f4939e497 = $f32119b1a8f8234e$export$24feea41fb1fac18(({ type: type })=>type === (0, $eTBmS.FIELD_TYPES).CREATOR);
const $f32119b1a8f8234e$export$5063a3adcd886aef = $f32119b1a8f8234e$export$24feea41fb1fac18(({ type: type })=>type === (0, $eTBmS.FIELD_TYPES).CREATED);

});

parcelRegister("iehDF", function(module, exports) {

$parcel$export(module.exports, "getFields", () => $4480088d2f4862d2$export$d5523731e7fe4ded);
$parcel$export(module.exports, "getAllFieldsByKey", () => $4480088d2f4862d2$export$5fb743abec84430b);
$parcel$export(module.exports, "createGetFieldOfType", () => $4480088d2f4862d2$export$8ab6e7aafdab7605);
$parcel$export(module.exports, "createGetFieldsOfType", () => $4480088d2f4862d2$export$5cf87a70cd2bd17c);
$parcel$export(module.exports, "getFieldKeys", () => $4480088d2f4862d2$export$3a997aec30de5223);
$parcel$export(module.exports, "createGetField", () => $4480088d2f4862d2$export$296c07692b6c7f60);
$parcel$export(module.exports, "createGetFieldOptions", () => $4480088d2f4862d2$export$21482f52b24953a6);
$parcel$export(module.exports, "createGetFieldOptionsWithAriResolved", () => $4480088d2f4862d2$export$3dddf77f7ea99348);
$parcel$export(module.exports, "createGetFieldOptionsWithAriResolvedById", () => $4480088d2f4862d2$export$4dfefb8e70531474);
$parcel$export(module.exports, "getArchivedFieldMappings", () => $4480088d2f4862d2$export$ea9a3a8cd0965b29);
$parcel$export(module.exports, "getNumberFieldMappings", () => $4480088d2f4862d2$export$91cac74d39b4c9cd);
$parcel$export(module.exports, "getStringFieldMappings", () => $4480088d2f4862d2$export$b54fa74425d69ac);
$parcel$export(module.exports, "getFieldMappings", () => $4480088d2f4862d2$export$66f6fdea88035e13);
$parcel$export(module.exports, "getVisibleFieldMappings", () => $4480088d2f4862d2$export$b8a90a0afedd92a0);
$parcel$export(module.exports, "getFieldMappingsAsList", () => $4480088d2f4862d2$export$320a3ac662fd75b6);
$parcel$export(module.exports, "createGetFieldMapping", () => $4480088d2f4862d2$export$1a0001497c77a141);
$parcel$export(module.exports, "getAllFieldValues", () => $4480088d2f4862d2$export$ca816807f226f116);
$parcel$export(module.exports, "getIssuesStatusById", () => $4480088d2f4862d2$export$6065763eedc63705);
$parcel$export(module.exports, "getSortedDistinctIssueStatuses", () => $4480088d2f4862d2$export$36cf447116f15567);
$parcel$export(module.exports, "getIssuesSimiliarStatusIdsByStatusId", () => $4480088d2f4862d2$export$cb72d0235ff03b62);
$parcel$export(module.exports, "createGetFieldLabel", () => $4480088d2f4862d2$export$c690e8b384bae5e8);
$parcel$export(module.exports, "createGetIsWeightedField", () => $4480088d2f4862d2$export$3495371c196e677d);
$parcel$export(module.exports, "getDeliveryCalculationStrategy", () => $4480088d2f4862d2$export$eeb2034ba20d4772);
$parcel$export(module.exports, "getDeliveryCalculationMode", () => $4480088d2f4862d2$export$d77107a54165ff8);
$parcel$export(module.exports, "getConfiguredConnectionFieldsKeys", () => $4480088d2f4862d2$export$abbb03aa02fb6049);
$parcel$export(module.exports, "getConnectionFieldMappings", () => $4480088d2f4862d2$export$f9e70564b64459f0);

var $ahm5r = parcelRequire("ahm5r");

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $dQ0E3 = parcelRequire("dQ0E3");

var $40zJW = parcelRequire("40zJW");

var $eTBmS = parcelRequire("eTBmS");


var $nFHtT = parcelRequire("nFHtT");

var $3degy = parcelRequire("3degy");

var $7jTnu = parcelRequire("7jTnu");

var $7WE8s = parcelRequire("7WE8s");

var $T9VAH = parcelRequire("T9VAH");

var $dNCRE = parcelRequire("dNCRE");

var $2yCra = parcelRequire("2yCra");
const $4480088d2f4862d2$var$NO_FIELDS = [];
const $4480088d2f4862d2$export$d5523731e7fe4ded = (0, $ahm5r.createSelector)((_state, props)=>props?.fields, (fields)=>{
    if (!fields) return $4480088d2f4862d2$var$NO_FIELDS;
    return fields.filter((field)=>{
        const isHidden = field.configuration?.hidden;
        const isRestricted = field.hasRestrictedContext;
        return !isHidden && !isRestricted;
    });
});
const $4480088d2f4862d2$var$getAllFields = (0, $ahm5r.createSelector)((_state, props)=>props?.fields, (fields)=>fields || $4480088d2f4862d2$var$NO_FIELDS);
const $4480088d2f4862d2$export$5fb743abec84430b = (0, $ahm5r.createSelector)($4480088d2f4862d2$var$getAllFields, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(fields, (field)=>field.key));
const $4480088d2f4862d2$export$8ab6e7aafdab7605 = (type)=>(0, $ahm5r.createSelector)($4480088d2f4862d2$export$d5523731e7fe4ded, (fields)=>fields.find((field)=>field.type === type));
const $4480088d2f4862d2$export$5cf87a70cd2bd17c = (type)=>(0, $ahm5r.createSelector)($4480088d2f4862d2$export$d5523731e7fe4ded, (fields)=>fields.filter((field)=>field.type === type));
const $4480088d2f4862d2$export$3a997aec30de5223 = (0, $ahm5r.createSelector)($4480088d2f4862d2$export$d5523731e7fe4ded, (_, props)=>props.rankField, (fields, rankField)=>fields?.map((field)=>field.key).concat(rankField || '').filter((str)=>str.length > 0) || []);
const $4480088d2f4862d2$export$296c07692b6c7f60 = (fieldKey)=>(0, $ahm5r.createSelector)($4480088d2f4862d2$export$5fb743abec84430b, (fields)=>fieldKey !== undefined ? fields[fieldKey] : undefined);
const $4480088d2f4862d2$export$21482f52b24953a6 = (fieldKey)=>{
    const getField = $4480088d2f4862d2$export$296c07692b6c7f60(fieldKey);
    return (0, $ahm5r.createSelector)(getField, (_, props)=>props, (field)=>field?.options);
};
const $4480088d2f4862d2$export$3dddf77f7ea99348 = (0, $3degy.cacheSelectorCreator)((fieldKey)=>{
    const getFieldOptions = $4480088d2f4862d2$export$21482f52b24953a6(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldOptions, (options)=>{
        if (options === undefined) return [];
        return options.reduce((agg, { jiraOptionId: jiraOptionId, value: value, weight: weight })=>[
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...agg,
                {
                    id: jiraOptionId,
                    value: value,
                    weight: weight
                }
            ], []);
    });
});
const $4480088d2f4862d2$export$4dfefb8e70531474 = (0, $3degy.cacheSelectorCreator)((fieldKey)=>{
    const getGetFieldOptionsWithAriResolved = $4480088d2f4862d2$export$3dddf77f7ea99348(fieldKey);
    return (0, $ahm5r.createSelector)(getGetFieldOptionsWithAriResolved, (options)=>options.length ? (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(options, ({ id: id })=>id) : undefined);
});
const $4480088d2f4862d2$export$91251f833cf7cb25 = (mappingFactory, fieldTypesCondition)=>(0, $ahm5r.createSelector)($4480088d2f4862d2$export$d5523731e7fe4ded, // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
    ({ containerProps: containerProps })=>containerProps?.issuesRemote, (fields, issuesRemote)=>fields.filter(({ type: type })=>fieldTypesCondition.includes(type)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((agg, field)=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...agg,
                [field.key]: mappingFactory(issuesRemote, field)
            }), {}));
const $4480088d2f4862d2$export$ea9a3a8cd0965b29 = $4480088d2f4862d2$export$91251f833cf7cb25((0, $7WE8s.archivedMapping), [
    (0, $eTBmS.FIELD_TYPES).ARCHIVED
]);
const $4480088d2f4862d2$export$91cac74d39b4c9cd = $4480088d2f4862d2$export$91251f833cf7cb25((0, $dNCRE.numberMapping), [
    (0, $eTBmS.FIELD_TYPES).CHECKBOX,
    (0, $eTBmS.FIELD_TYPES).FORMULA,
    (0, $eTBmS.FIELD_TYPES).INSIGHTS,
    (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES,
    (0, $eTBmS.FIELD_TYPES).NUMBER,
    (0, $eTBmS.FIELD_TYPES).RATING,
    (0, $eTBmS.FIELD_TYPES).SLIDER
]);
const $4480088d2f4862d2$export$b54fa74425d69ac = $4480088d2f4862d2$export$91251f833cf7cb25((0, $2yCra.stringMapping), [
    (0, $eTBmS.FIELD_TYPES).SHORT_TEXT,
    (0, $eTBmS.FIELD_TYPES).SUMMARY,
    (0, $eTBmS.FIELD_TYPES).HYPERLINK,
    (0, $eTBmS.FIELD_TYPES).CREATED,
    (0, $eTBmS.FIELD_TYPES).UPDATED,
    (0, $eTBmS.FIELD_TYPES).DATE
]);
const $4480088d2f4862d2$export$66f6fdea88035e13 = (0, $ahm5r.createSelector)($4480088d2f4862d2$var$getAllFields, // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
({ containerProps: containerProps })=>containerProps?.issuesRemote, (fields, issuesRemote)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    fields.reduce((agg, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...agg,
            [field.key]: (0, $T9VAH.fieldMapping)(issuesRemote, fields, field)
        }), {}));
const $4480088d2f4862d2$export$b8a90a0afedd92a0 = (0, $ahm5r.createSelector)($4480088d2f4862d2$var$getAllFields, // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
({ containerProps: containerProps })=>containerProps?.issuesRemote, (fields, issuesRemote)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    fields.reduce((agg, field)=>{
        const isHidden = field?.configuration?.hidden;
        const isRestricted = field?.hasRestrictedContext;
        if (isHidden || isRestricted) return agg;
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...agg,
            [field.key]: (0, $T9VAH.fieldMapping)(issuesRemote, fields, field)
        };
    }, {}));
const $4480088d2f4862d2$export$320a3ac662fd75b6 = (0, $ahm5r.createSelector)($4480088d2f4862d2$export$66f6fdea88035e13, (0, (/*@__PURE__*/$parcel$interopDefault($40zJW))));
const $4480088d2f4862d2$export$1a0001497c77a141 = (fieldKey)=>(0, $ahm5r.createSelector)($4480088d2f4862d2$export$66f6fdea88035e13, (fieldMappings)=>fieldKey !== undefined ? fieldMappings[fieldKey] : undefined);
const $4480088d2f4862d2$export$ca816807f226f116 = (fieldKey)=>(0, $ahm5r.createSelector)($4480088d2f4862d2$export$1a0001497c77a141(fieldKey), (state, props)=>({
            state: state,
            props: props
        }), (mapping, { state: state, props: props })=>mapping ? Object.values(mapping.getAllValues(state, props)).filter(Boolean) : []);
const $4480088d2f4862d2$export$6065763eedc63705 = (0, $ahm5r.createSelector)((state)=>state.properties.status[0, $9a5f06039e1dff5a$export$29157f6cae91bb2f], (statusProperties)=>(0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(Object.values(statusProperties ?? {}).filter((status)=>!!status), 'id'));
const $4480088d2f4862d2$var$getStatusById = (_, props)=>props?.statusesById;
const $4480088d2f4862d2$var$EMPTY_SORTED_DISTINCT_ISSUE_STATUSES = [];
const $4480088d2f4862d2$export$36cf447116f15567 = (0, $ahm5r.createSelector)($4480088d2f4862d2$export$1a0001497c77a141((0, $9a5f06039e1dff5a$export$29157f6cae91bb2f)), $4480088d2f4862d2$export$6065763eedc63705, $4480088d2f4862d2$var$getStatusById, (mapping, issuesStatusById, statusesByIdNEW)=>{
    const statusesById = (0, $7jTnu.fg)('jpd-aurora-roadmap-inline-edit') ? statusesByIdNEW : issuesStatusById;
    return mapping && statusesById ? (0, (/*@__PURE__*/$parcel$interopDefault($dQ0E3)))(Object.values(statusesById), (x, y)=>mapping.comparator(x, y, 'ASC') === 0).sort((x, y)=>mapping.comparator(x, y, 'ASC')) : $4480088d2f4862d2$var$EMPTY_SORTED_DISTINCT_ISSUE_STATUSES;
});
const $4480088d2f4862d2$var$EMPTY_ISSUES_SIMILIAR_STATUS_IDS_BY_STATUS_ID = {};
const $4480088d2f4862d2$export$cb72d0235ff03b62 = (0, $ahm5r.createSelector)($4480088d2f4862d2$export$1a0001497c77a141((0, $9a5f06039e1dff5a$export$29157f6cae91bb2f)), $4480088d2f4862d2$export$6065763eedc63705, $4480088d2f4862d2$var$getStatusById, (mapping, issuesStatusById, statusesByIdNEW)=>{
    const statusesById = (0, $7jTnu.fg)('jpd-aurora-roadmap-inline-edit') ? statusesByIdNEW : issuesStatusById;
    if (!mapping || !statusesById) return $4480088d2f4862d2$var$EMPTY_ISSUES_SIMILIAR_STATUS_IDS_BY_STATUS_ID;
    const statuses = Object.values(statusesById);
    const isStatusEqual = (x)=>(y)=>mapping.comparator(x, y, 'ASC') === 0;
    const similarStatusesIdsBystatusId = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(statusesById, (status)=>statuses.filter(isStatusEqual(status)).map(({ id: id })=>id));
    return similarStatusesIdsBystatusId;
});
const $4480088d2f4862d2$export$c690e8b384bae5e8 = (fieldKey, groupIdentity, fieldValue)=>{
    const getFieldMapping = $4480088d2f4862d2$export$1a0001497c77a141(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldMapping, (mapping)=>groupIdentity !== undefined ? mapping?.getLabel(groupIdentity, fieldValue) : undefined);
};
const $4480088d2f4862d2$export$3495371c196e677d = (fieldKey)=>{
    const getFieldOptionsWithAriResolved = $4480088d2f4862d2$export$3dddf77f7ea99348(fieldKey);
    return (0, $ahm5r.createSelector)(getFieldOptionsWithAriResolved, (options = [])=>options.some((option)=>option.weight !== 1));
};
const $4480088d2f4862d2$export$57707e8f8a7ce482 = (0, $ahm5r.createSelector)($4480088d2f4862d2$export$d5523731e7fe4ded, (fields)=>fields?.find((field)=>field.type === (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS));
const $4480088d2f4862d2$export$eeb2034ba20d4772 = (0, $ahm5r.createSelector)($4480088d2f4862d2$export$57707e8f8a7ce482, (field)=>field?.presentation?.type || (0, $nFHtT.DELIVERY_CALCULATION_STRATEGIES).DEFAULT);
const $4480088d2f4862d2$export$d77107a54165ff8 = (0, $ahm5r.createSelector)($4480088d2f4862d2$export$57707e8f8a7ce482, (field)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    field?.formula?.parameters?.calculationMode || (0, $nFHtT.DELIVERY_CALCULATION_MODE).ISSUE_COUNT);
const $4480088d2f4862d2$export$abbb03aa02fb6049 = (0, $ahm5r.createSelector)($4480088d2f4862d2$var$getAllFields, (fields)=>fields.reduce((res, field)=>{
        if (field.type === (0, $eTBmS.FIELD_TYPES).CONNECTION && field.configuration?.issueTypeFilters && field.configuration?.issueTypeFilters.length > 0) res.push(field.key);
        return res;
    }, []));
const $4480088d2f4862d2$export$f9e70564b64459f0 = (0, $ahm5r.createSelector)($4480088d2f4862d2$export$66f6fdea88035e13, (mappings)=>{
    const connectionMappings = {};
    Object.entries(mappings).forEach(([fieldKey, mapping])=>{
        if (mapping.field?.type === (0, $eTBmS.FIELD_TYPES).CONNECTION) connectionMappings[fieldKey] = mapping;
    });
    return connectionMappings;
});

});
parcelRegister("dQ0E3", function(module, exports) {

var $1txRh = parcelRequire("1txRh");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function $a130a1c1c30b127c$var$uniqWith(array, comparator) {
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return array && array.length ? $1txRh(array, undefined, comparator) : [];
}
module.exports = $a130a1c1c30b127c$var$uniqWith;

});

parcelRegister("nFHtT", function(module, exports) {

$parcel$export(module.exports, "DELIVERY_CALCULATION_STRATEGIES", () => $cc478bb5154a443b$export$19d4594f9da89a6b);
$parcel$export(module.exports, "DELIVERY_CALCULATION_MODE", () => $cc478bb5154a443b$export$84e6f0ef88a96a0c);
const $cc478bb5154a443b$export$19d4594f9da89a6b = {
    DEFAULT: 'default',
    SIMPLE: 'simple'
};
const $cc478bb5154a443b$export$84e6f0ef88a96a0c = {
    ISSUE_COUNT: 'issue_count',
    STORY_POINTS: 'story_points'
};

});

parcelRegister("7WE8s", function(module, exports) {

$parcel$export(module.exports, "archivedMapping", () => $f97497d955cd08b0$export$10b30035c2ffe751);

var $4as7b = parcelRequire("4as7b");

var $19ZHc = parcelRequire("19ZHc");
const $f97497d955cd08b0$export$10b30035c2ffe751 = (issuesRemote, field)=>{
    const optionsById = {
        [field.archivedOption?.jiraOptionId || '']: field.archivedOption
    };
    return {
        ...(0, $19ZHc.optionMapping)(issuesRemote, field),
        ...(0, $4as7b.jiraArchivedMapping)(issuesRemote, field),
        getLabel: (groupIdentity)=>optionsById[groupIdentity]?.value
    };
};

});
parcelRegister("4as7b", function(module, exports) {

$parcel$export(module.exports, "jiraArchivedMapping", () => $762c7bcb98c5e757$export$8b67250bc837d1ca);

var $exWdq = parcelRequire("exWdq");


var $6kymH = parcelRequire("6kymH");
const $762c7bcb98c5e757$export$8b67250bc837d1ca = (issuesRemote, field)=>{
    const optionsById = {
        [field.archivedOption?.jiraOptionId || '']: field.archivedOption
    };
    return {
        ...(0, $6kymH.jiraOptionMapping)(issuesRemote, field),
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(optionsById, issue.fields[field.key].id) ? {
                id: issue.fields[field.key].id
            } : undefined,
        getFieldValueForJiraBulkUpdate: (value)=>({
                [(0, $a5b1a7a0b618efd3$export$b292c6d76ae63c4f)]: {
                    fieldId: field.key,
                    option: {
                        optionId: value ? optionsById[value.id]?.id ?? -1 : -1
                    }
                }
            })
    };
};

});
const $a5b1a7a0b618efd3$export$b292c6d76ae63c4f = 'singleSelectFields';
const $a5b1a7a0b618efd3$export$8efc9eeb05d66b6 = 'multipleSelectFields';
const $a5b1a7a0b618efd3$export$7c1ec18baec3fed = 'singleSelectClearableUserPickerFields';
const $a5b1a7a0b618efd3$export$7c3ddc4a9b4f0dcf = 'multipleSelectClearableUserPickerFields';
const $a5b1a7a0b618efd3$export$352ccc39b0d151be = 'atlassianTeamFields';
const $a5b1a7a0b618efd3$export$79b91d4669dcadcb = 'labelsFields';
const $a5b1a7a0b618efd3$export$4e8bcd47a31d751c = 'clearableNumberFields';
const $a5b1a7a0b618efd3$export$a0e01ba2ebef17f2 = 'singleLineTextFields';

parcelRegister("6kymH", function(module, exports) {

$parcel$export(module.exports, "jiraOptionMapping", () => $47f1d53d32647352$export$b85266113d8cfa39);

var $exWdq = parcelRequire("exWdq");

var $9g7yh = parcelRequire("9g7yh");

var $8JqDY = parcelRequire("8JqDY");

const $47f1d53d32647352$export$b85266113d8cfa39 = (issuesRemote, field)=>{
    const optionsById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(field.options, ({ jiraOptionId: jiraOptionId })=>jiraOptionId);
    return {
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(optionsById, issue.fields[field.key].id) ? {
                id: issue.fields[field.key].id
            } : undefined,
        getFieldValueForJiraUpdate: (value)=>{
            if (value === undefined) return null;
            return {
                ...value,
                value: optionsById[value.id]?.value
            };
        },
        getFieldValueForJiraBulkUpdate: (value)=>({
                [(0, $a5b1a7a0b618efd3$export$b292c6d76ae63c4f)]: {
                    fieldId: field.key,
                    option: {
                        optionId: value ? optionsById[value.id].jiraOptionId : -1
                    }
                }
            }),
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    };
};

});
parcelRegister("8JqDY", function(module, exports) {

$parcel$export(module.exports, "defaultJiraUpdateService", () => $e2b3b76eb64eb0d7$export$4d4604b0c6109b45);
$parcel$export(module.exports, "noopJiraUpdateService", () => $e2b3b76eb64eb0d7$export$151f53ef714ec04f);

var $3Ku0X = parcelRequire("3Ku0X");

var $cOgsk = parcelRequire("cOgsk");
const $e2b3b76eb64eb0d7$export$4d4604b0c6109b45 = (issuesRemote, fieldKey)=>({
        getJiraUpdateService: (issueKey, value)=>{
            if (fieldKey === undefined) return Promise.reject(new Error('No jira field key'));
            (0, $3Ku0X.sendPendoTrackEvent)((0, $cOgsk.EVENTS).IdeaFieldUpdated);
            return issuesRemote.updateIssueField({
                issueKey: issueKey,
                fieldKey: fieldKey,
                value: value
            });
        }
    });
const $e2b3b76eb64eb0d7$export$151f53ef714ec04f = {
    getJiraUpdateService: ()=>Promise.resolve()
};

});
parcelRegister("cOgsk", function(module, exports) {

$parcel$export(module.exports, "EVENTS", () => $5fb797083ce8e563$export$fa3d5b535a2458a1);
const $5fb797083ce8e563$export$fa3d5b535a2458a1 = {
    IdeaFieldUpdated: 'idea_field_updated'
};

});




parcelRegister("19ZHc", function(module, exports) {

$parcel$export(module.exports, "optionMapping", () => $6713d0c424381b50$export$5dcede8283f4044a);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $9g7yh = parcelRequire("9g7yh");

var $d3vFW = parcelRequire("d3vFW");

var $LFmXM = parcelRequire("LFmXM");

var $2Ejzu = parcelRequire("2Ejzu");

var $6kymH = parcelRequire("6kymH");

var $5UhJY = parcelRequire("5UhJY");

var $iG19c = parcelRequire("iG19c");

var $dhag4 = parcelRequire("dhag4");

var $eQ9dE = parcelRequire("eQ9dE");
const $6713d0c424381b50$var$optionMappingInternal = (issuesRemote, field)=>{
    const optionsById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(field.options, ({ jiraOptionId: jiraOptionId })=>jiraOptionId);
    const valueAccessor = (state, props, issueId)=>state.properties.singleSelect[field.key]?.[issueId];
    const valueAccessorToExport = (state, props, issueId, options)=>{
        const selected = valueAccessor(state, props, issueId);
        return selected ? options.find((opt)=>opt.jiraOptionId === selected.id)?.value : '';
    };
    return {
        ...(0, $6kymH.jiraOptionMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.singleSelect, [
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: LocalIssueId, value?: IssueOptionProperty) => { singleSelect: { [x: string]: Record<string, IssueOptionProperty> | { [x: string]: IssueOptionProperty | undefined; }; }; ... 17 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: IssueOptionProperty | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.singleSelect[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.singleSelect[field.key][issueId], value)) return maps;
            return {
                ...maps,
                singleSelect: {
                    ...maps.singleSelect,
                    [field.key]: {
                        ...maps.singleSelect[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'singleSelect'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: (0, $5UhJY.createCombinedComparator)([
            (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.numberComparator)((0, $dhag4.getOptionWeight)(field, a), (0, $dhag4.getOptionWeight)(field, b), direction)),
            (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.numberComparator)((0, $dhag4.getOptionIndex)(field, a), (0, $dhag4.getOptionIndex)(field, b), direction))
        ]),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.singleSelect[field.key] ?? {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.singleSelect[fieldKey], (ids, singleSelect)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: singleSelect !== undefined && singleSelect[issueId] !== undefined ? [
                            {
                                groupIdentity: singleSelect[issueId].id,
                                value: singleSelect[issueId]
                            }
                        ] : []
                    }), {})),
        getGroupIdentities: (state, _, issueId)=>state.properties.singleSelect[field.key] !== undefined && state.properties.singleSelect[field.key][issueId] !== undefined ? [
                {
                    groupIdentity: state.properties.singleSelect[field.key][issueId].id,
                    value: state.properties.singleSelect[field.key][issueId]
                }
            ] : [],
        getRollupOperations: ()=>[
                (0, $2Ejzu.COUNT_ROLLUP),
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP),
                (0, $2Ejzu.AVG_ROLLUP),
                (0, $2Ejzu.MEDIAN_ROLLUP),
                (0, $2Ejzu.SUM_ROLLUP)
            ],
        allowEmptyGroup: true,
        getLabel: (groupIdentity)=>optionsById[groupIdentity]?.value,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueContainsFilter = (0, $iG19c.createStringValueContainsFilter)(filter);
                if (stringValueContainsFilter === undefined) return undefined;
                return (value, state, props, localIssueId)=>stringValueContainsFilter(value?.id, state, props, localIssueId);
            }
            return undefined;
        },
        getWeight: (groupIdentity)=>optionsById[groupIdentity]?.weight
    };
};
const $6713d0c424381b50$export$5dcede8283f4044a = (0, $LFmXM.default)($6713d0c424381b50$var$optionMappingInternal);

});
parcelRegister("2Ejzu", function(module, exports) {

$parcel$export(module.exports, "AVG_ROLLUP", () => $788250feb9da65f3$export$e6b8a87deeb798af);
$parcel$export(module.exports, "COUNT_ROLLUP", () => $788250feb9da65f3$export$86be1f756c976d3a);
$parcel$export(module.exports, "EMPTY_ROLLUP", () => $788250feb9da65f3$export$d30f67759ab36a26);
$parcel$export(module.exports, "FILLED_ROLLUP", () => $788250feb9da65f3$export$3b98dc5808f4afcf);
$parcel$export(module.exports, "MAX_ROLLUP", () => $788250feb9da65f3$export$e493cee3c7e703f5);
$parcel$export(module.exports, "MEDIAN_ROLLUP", () => $788250feb9da65f3$export$c5c48c2840a39f9);
$parcel$export(module.exports, "MIN_ROLLUP", () => $788250feb9da65f3$export$b3eb9112e642c493);
$parcel$export(module.exports, "RANGE_ROLLUP", () => $788250feb9da65f3$export$1717fe05785b1c50);
$parcel$export(module.exports, "SUM_ROLLUP", () => $788250feb9da65f3$export$899e5f5be6bd3d41);
/**
 * Field rollup operations.
 */ const $788250feb9da65f3$export$e6b8a87deeb798af = 'AVG';
const $788250feb9da65f3$export$86be1f756c976d3a = 'COUNT';
const $788250feb9da65f3$export$d30f67759ab36a26 = 'EMPTY';
const $788250feb9da65f3$export$3b98dc5808f4afcf = 'FILLED';
const $788250feb9da65f3$export$e493cee3c7e703f5 = 'MAX';
const $788250feb9da65f3$export$c5c48c2840a39f9 = 'MEDIAN';
const $788250feb9da65f3$export$b3eb9112e642c493 = 'MIN';
const $788250feb9da65f3$export$1717fe05785b1c50 = 'RANGE';
const $788250feb9da65f3$export$899e5f5be6bd3d41 = 'SUM';
const $788250feb9da65f3$export$20dcc45aa21bb7e = {
    AVG_ROLLUP: $788250feb9da65f3$export$e6b8a87deeb798af,
    COUNT_ROLLUP: $788250feb9da65f3$export$86be1f756c976d3a,
    EMPTY_ROLLUP: $788250feb9da65f3$export$d30f67759ab36a26,
    FILLED_ROLLUP: $788250feb9da65f3$export$3b98dc5808f4afcf,
    MAX_ROLLUP: $788250feb9da65f3$export$e493cee3c7e703f5,
    MEDIAN_ROLLUP: $788250feb9da65f3$export$c5c48c2840a39f9,
    MIN_ROLLUP: $788250feb9da65f3$export$b3eb9112e642c493,
    RANGE_ROLLUP: $788250feb9da65f3$export$1717fe05785b1c50,
    SUM_ROLLUP: $788250feb9da65f3$export$899e5f5be6bd3d41
};

});

parcelRegister("5UhJY", function(module, exports) {

$parcel$export(module.exports, "factor", () => $16112186837c58a1$export$4564c084226129f7);
$parcel$export(module.exports, "createCombinedComparator", () => $16112186837c58a1$export$cb40b705a6de4166);
$parcel$export(module.exports, "nullSafeComparator", () => $16112186837c58a1$export$c1076e341971ccc0);
$parcel$export(module.exports, "stringComparator", () => $16112186837c58a1$export$9e983cea7d35d91f);
$parcel$export(module.exports, "stringListComparator", () => $16112186837c58a1$export$787af7cd2bfdfc00);
$parcel$export(module.exports, "safeStringListComparator", () => $16112186837c58a1$export$96d0bd4f8b5e2170);
$parcel$export(module.exports, "numberComparator", () => $16112186837c58a1$export$a990c01b949a832a);
$parcel$export(module.exports, "numberListComparator", () => $16112186837c58a1$export$a93b745ae826077e);
$parcel$export(module.exports, "weightedListComparator", () => $16112186837c58a1$export$23d3a0c741511798);
$parcel$export(module.exports, "statusCategoryAggregateComparator", () => $16112186837c58a1$export$bbd037d2100a587f);

var $kVGTc = parcelRequire("kVGTc");
const $16112186837c58a1$export$4564c084226129f7 = (direction)=>direction === 'ASC' ? 1 : -1;
const $16112186837c58a1$export$cb40b705a6de4166 = (comparators)=>(a, b, direction)=>{
        for (const comparator of comparators){
            const val = comparator(a, b, direction);
            if (val !== 0) return val;
        }
        return 0;
    };
const $16112186837c58a1$export$c1076e341971ccc0 = (comparator)=>(a, b, direction)=>{
        if (a === undefined && b === undefined) return 0;
        if (a === undefined) return 1;
        if (b === undefined) return -1;
        return comparator(a, b, direction);
    };
const $16112186837c58a1$export$9e983cea7d35d91f = $16112186837c58a1$export$c1076e341971ccc0((a, b, direction)=>{
    const comparableA = (0, (/*@__PURE__*/$parcel$interopDefault($kVGTc)))(a);
    const comparableB = (0, (/*@__PURE__*/$parcel$interopDefault($kVGTc)))(b);
    if (comparableA < comparableB) return -1 * $16112186837c58a1$export$4564c084226129f7(direction);
    if (comparableB < comparableA) return $16112186837c58a1$export$4564c084226129f7(direction);
    return 0;
});
const $16112186837c58a1$var$compareLength = (a, b, direction)=>{
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0) return 1;
    if (b.length === 0) return -1;
    return (a.length - b.length) * $16112186837c58a1$export$4564c084226129f7(direction);
};
const $16112186837c58a1$export$787af7cd2bfdfc00 = $16112186837c58a1$export$c1076e341971ccc0((a, b, direction)=>{
    for(let i = 0; i < Math.min(a.length, b.length); i += 1){
        const elementVal = $16112186837c58a1$export$9e983cea7d35d91f(a[i], b[i], direction);
        if (elementVal !== 0) return elementVal;
    }
    return $16112186837c58a1$var$compareLength(a, b, direction);
});
const $16112186837c58a1$export$96d0bd4f8b5e2170 = $16112186837c58a1$export$c1076e341971ccc0((a, b, direction)=>{
    for(let i = 0; i < Math.min(a.length, b.length); i += 1){
        const elementVal = $16112186837c58a1$export$9e983cea7d35d91f(a[i], b[i], direction);
        if (elementVal !== 0) return elementVal;
    }
    return $16112186837c58a1$var$compareLength(a, b, direction);
});
const $16112186837c58a1$export$a990c01b949a832a = $16112186837c58a1$export$c1076e341971ccc0((a, b, direction)=>(a - b) * $16112186837c58a1$export$4564c084226129f7(direction));
const $16112186837c58a1$export$a93b745ae826077e = $16112186837c58a1$export$c1076e341971ccc0((a, b, direction)=>{
    for(let i = 0; i < Math.min(a.length, b.length); i += 1){
        const elementVal = $16112186837c58a1$export$a990c01b949a832a(a[i], b[i], direction);
        if (elementVal !== 0) return elementVal;
    }
    return $16112186837c58a1$var$compareLength(a, b, direction);
});
const $16112186837c58a1$export$23d3a0c741511798 = $16112186837c58a1$export$c1076e341971ccc0((a, b, direction)=>{
    const reducer = (acc, curVal = 0)=>acc + curVal;
    const aWeight = a.reduce(reducer, 0);
    const bWeight = b.reduce(reducer, 0);
    return $16112186837c58a1$export$a990c01b949a832a(aWeight, bWeight, direction);
});
const $16112186837c58a1$export$bbd037d2100a587f = $16112186837c58a1$export$c1076e341971ccc0((status1, status2, direction)=>{
    const diff = status1.reduce((a, b)=>a + b, 0) - status2.reduce((a, b)=>a + b, 0);
    if (diff !== 0) return diff * $16112186837c58a1$export$4564c084226129f7(direction);
    for(let i = 0; i < 3; i += 1){
        if (status1[i] - status2[i] !== 0) return (status1[i] - status2[i]) * $16112186837c58a1$export$4564c084226129f7(direction);
    }
    return 0;
});

});
parcelRegister("kVGTc", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */ function $f3ca66758f700113$var$toLower(value) {
    return $cz1WF(value).toLowerCase();
}
module.exports = $f3ca66758f700113$var$toLower;

});


parcelRegister("iG19c", function(module, exports) {

$parcel$export(module.exports, "createDisjunctTextChunkFilter", () => $4547ae28839f97a4$export$1a2b8e6a59e4e260);
$parcel$export(module.exports, "createConjunctTextChunkFilter", () => $4547ae28839f97a4$export$3a1797993cc214ca);
$parcel$export(module.exports, "createStringValueIntersectionFilter", () => $4547ae28839f97a4$export$a81d31bc7581691e);
$parcel$export(module.exports, "createStringValueContainsFilter", () => $4547ae28839f97a4$export$bec63f36a1549e9d);
$parcel$export(module.exports, "createStringValuesContainsFilter", () => $4547ae28839f97a4$export$ed7aaa8485e8367d);

var $KSas2 = parcelRequire("KSas2");

var $aX8Tx = parcelRequire("aX8Tx");

var $7BEaI = parcelRequire("7BEaI");

var $jUVzX = parcelRequire("jUVzX");

var $kVGTc = parcelRequire("kVGTc");

var $jvwCK = parcelRequire("jvwCK");
const $4547ae28839f97a4$export$93f7ca4437082eaa = (filter)=>{
    const chunks = [];
    if (filter.type === 'TEXT' || filter.type === 'FIELD') filter.values.forEach((value)=>{
        if (value.stringValue !== undefined) chunks.push((0, (/*@__PURE__*/$parcel$interopDefault($kVGTc)))(value.stringValue).trim().split(/\s+/));
        else chunks.push(undefined);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))((0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(chunks));
};
const $4547ae28839f97a4$export$1a2b8e6a59e4e260 = (filter)=>{
    if (filter.type !== 'FIELD' && filter.type !== 'TEXT') return undefined;
    const chunks = $4547ae28839f97a4$export$93f7ca4437082eaa(filter);
    return (value)=>{
        if (value === undefined) return chunks.includes(undefined);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(chunks, (chunk)=>chunk !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($kVGTc)))(value).includes(chunk));
    };
};
const $4547ae28839f97a4$export$3a1797993cc214ca = (filter)=>{
    if (filter.type !== 'FIELD' && filter.type !== 'TEXT') return undefined;
    const chunks = $4547ae28839f97a4$export$93f7ca4437082eaa(filter);
    return (value)=>{
        if (value === undefined) return chunks.includes(undefined);
        return (0, (/*@__PURE__*/$parcel$interopDefault($KSas2)))(chunks, (chunk)=>chunk !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($kVGTc)))(value).includes(chunk));
    };
};
const $4547ae28839f97a4$export$a81d31bc7581691e = (filter)=>{
    if (filter.type !== 'FIELD' && filter.type !== 'TEXT') return undefined;
    if (filter.values.length === 0) return undefined;
    return (values)=>{
        const stringValues = filter.values.map(({ stringValue: stringValue })=>stringValue);
        if (values === undefined || values.length === 0) return stringValues.includes(undefined);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(values, stringValues).length > 0;
    };
};
const $4547ae28839f97a4$export$bec63f36a1549e9d = (filter)=>{
    const intersectionFilter = $4547ae28839f97a4$export$a81d31bc7581691e(filter);
    if (intersectionFilter === undefined) return undefined;
    return (value, state, props, localIssueId)=>intersectionFilter(value !== undefined ? [
            value
        ] : undefined, state, props, localIssueId);
};
const $4547ae28839f97a4$export$ed7aaa8485e8367d = (filter)=>{
    const intersectionFilter = $4547ae28839f97a4$export$a81d31bc7581691e(filter);
    if (intersectionFilter === undefined) return undefined;
    return (values, state, props, localIssueId)=>intersectionFilter(values, state, props, localIssueId);
};
const $4547ae28839f97a4$export$3b872a2685e5610b = (filter)=>{
    if (filter.type !== 'TEXT' && filter.localId !== 'quick') return undefined;
    // quick filter only contains 1 entry
    const filterValue = filter.values[0]?.stringValue;
    if (filterValue === undefined) return undefined;
    return (value)=>{
        if (value === undefined) return value === filterValue;
        return value.toLowerCase().includes(filterValue.toLowerCase());
    };
};

});

parcelRegister("dhag4", function(module, exports) {

$parcel$export(module.exports, "getOptionIndex", () => $8e00957190b455a4$export$2921b90f3ed1b63a);
$parcel$export(module.exports, "getOptionWeight", () => $8e00957190b455a4$export$a7e130d27ea21efc);

var $gyBpf = parcelRequire("gyBpf");
const $8e00957190b455a4$export$2921b90f3ed1b63a = (field, optionProperty)=>{
    if (field.options !== undefined && optionProperty !== undefined) {
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(field.options, (option)=>option.jiraOptionId === optionProperty.id);
        if (index !== -1) return index;
    }
    return undefined;
};
const $8e00957190b455a4$export$a7e130d27ea21efc = (field, optionProperty)=>{
    const index = $8e00957190b455a4$export$2921b90f3ed1b63a(field, optionProperty);
    if (index !== undefined && index !== -1) return field.options?.[index].weight;
    return undefined;
};

});

parcelRegister("eQ9dE", function(module, exports) {

$parcel$export(module.exports, "removePropertyValue", () => $cf9cfb8e60dee0c9$export$16e4263eff1f4847);

var $jFHCE = parcelRequire("jFHCE");
const $cf9cfb8e60dee0c9$export$16e4263eff1f4847 = (fieldKey, maps, issueId, mappingKey)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type
    if (maps[mappingKey][fieldKey] && maps[mappingKey][fieldKey][issueId] === undefined) return maps;
    if (mappingKey === 'issueMetadata' || mappingKey === 'lexoRank') {
        const idToValueMap = maps[mappingKey];
        const newIdToValueMap = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(idToValueMap, issueId);
        return {
            ...maps,
            [mappingKey]: newIdToValueMap
        };
    }
    const idToValueMap = maps[mappingKey][fieldKey];
    const newIdToValueMap = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(idToValueMap, issueId);
    return {
        ...maps,
        [mappingKey]: {
            ...maps[mappingKey],
            [fieldKey]: {
                ...newIdToValueMap
            }
        }
    };
};

});



parcelRegister("T9VAH", function(module, exports) {

$parcel$export(module.exports, "fieldMapping", () => $9417de97cf48de9b$export$8d72f8979be8176);

var $12DRg = parcelRequire("12DRg");

var $7jTnu = parcelRequire("7jTnu");

var $eTBmS = parcelRequire("eTBmS");

var $8JqDY = parcelRequire("8JqDY");

var $7WE8s = parcelRequire("7WE8s");

var $5rITV = parcelRequire("5rITV");

var $3DqTy = parcelRequire("3DqTy");

var $bULQD = parcelRequire("bULQD");

var $lRhTm = parcelRequire("lRhTm");

var $di66p = parcelRequire("di66p");

var $75BXd = parcelRequire("75BXd");

var $fuKtm = parcelRequire("fuKtm");

var $2kAlY = parcelRequire("2kAlY");

var $7rydk = parcelRequire("7rydk");

var $8n006 = parcelRequire("8n006");

var $4bgQz = parcelRequire("4bgQz");

var $O0bZK = parcelRequire("O0bZK");

var $86Qd4 = parcelRequire("86Qd4");

var $5A071 = parcelRequire("5A071");

var $cCH8F = parcelRequire("cCH8F");

var $dNCRE = parcelRequire("dNCRE");

var $19ZHc = parcelRequire("19ZHc");

var $3MqVY = parcelRequire("3MqVY");

var $9f4hf = parcelRequire("9f4hf");

var $2Rap6 = parcelRequire("2Rap6");

var $jvW2K = parcelRequire("jvW2K");

var $fF3ZV = parcelRequire("fF3ZV");

var $2yCra = parcelRequire("2yCra");

var $hWYml = parcelRequire("hWYml");

var $795ti = parcelRequire("795ti");

var $2hqtf = parcelRequire("2hqtf");
const $9417de97cf48de9b$var$DEFAULT_MAPPING = {
    field: undefined,
    getValueFromJiraIssue: ()=>undefined,
    getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
    setMutable: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    setImmutable: (propertyMaps)=>propertyMaps,
    remove: (propertyMaps)=>propertyMaps,
    modifyImmutableIfMultiValueField: (propertyMaps)=>propertyMaps,
    comparator: ()=>0,
    valueAccessor: ()=>undefined,
    valueAccessorToExport: ()=>'',
    getAllValues: ()=>({}),
    getGroupIdentities: ()=>[],
    getGroupIdentitiesSelector: ()=>()=>({}),
    rollupOperations: ()=>[],
    allowEmptyGroup: false,
    isMultiValueField: false,
    isSupportedByIssueUpdateApi: false,
    getLabel: ()=>undefined,
    getFilter: ()=>undefined,
    ...(0, $8JqDY.noopJiraUpdateService)
};
const $9417de97cf48de9b$export$8d72f8979be8176 = (issuesRemote, allFields, field)=>{
    switch(field?.type){
        case (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE:
            return (0, $4bgQz.issueTypeMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).ISSUE_KEY:
            return (0, $8n006.issueKeyMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).ISSUE_ID:
            return (0, $7rydk.issueIdMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).DATE:
        case (0, $eTBmS.FIELD_TYPES).UPDATED:
        case (0, $eTBmS.FIELD_TYPES).CREATED:
            return (0, $bULQD.dateMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).SUMMARY:
        case (0, $eTBmS.FIELD_TYPES).SHORT_TEXT:
        case (0, $eTBmS.FIELD_TYPES).HYPERLINK:
        case (0, $eTBmS.FIELD_TYPES).ARCHIVED_ON:
            return (0, $2yCra.stringMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).ASSIGNEE:
        case (0, $eTBmS.FIELD_TYPES).CREATOR:
        case (0, $eTBmS.FIELD_TYPES).REPORTER:
            return (0, $795ti.userMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).PEOPLE:
        case (0, $eTBmS.FIELD_TYPES).JSW_PEOPLE:
        case (0, $eTBmS.FIELD_TYPES).ARCHIVED_BY:
            return (0, $2hqtf.usersMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).ARCHIVED:
            return (0, $7WE8s.archivedMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).SINGLE_SELECT:
            return (0, $19ZHc.optionMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).MULTI_SELECT:
        case (0, $eTBmS.FIELD_TYPES).JSW_MULTI_SELECT:
            return (0, $3MqVY.optionsMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).LABELS:
        case (0, $eTBmS.FIELD_TYPES).CUSTOM_LABELS:
            return (0, $O0bZK.labelsMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL:
        case (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT:
            return (0, $75BXd.externalReferenceMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT_STATUS:
            return (0, $di66p.externalReferencePropertyMapping)(issuesRemote, field, allFields);
        case (0, $eTBmS.FIELD_TYPES).INSIGHTS:
            return (0, $cCH8F.numDataPointsMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).NUMBER:
        case (0, $eTBmS.FIELD_TYPES).SLIDER:
        case (0, $eTBmS.FIELD_TYPES).RATING:
        case (0, $eTBmS.FIELD_TYPES).CHECKBOX:
        case (0, $eTBmS.FIELD_TYPES).FORMULA:
        case (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES:
            return (0, $dNCRE.numberMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).STATUS:
            return (0, $fF3ZV.statusMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS:
            return (0, $5A071.linkedDeliveryIssuesStatusMapping)(field);
        case (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS:
            return (0, $86Qd4.linkedIssuesProgressMapping)(field);
        case (0, $eTBmS.FIELD_TYPES).DESCRIPTION:
            return (0, $lRhTm.documentMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).ISSUE_COMMENTS:
            return (0, $5rITV.commentsCountMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).VOTES:
            return (0, $9f4hf.playMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).INTERVAL:
            return (0, $2kAlY.intervalStringMapping)(issuesRemote, field, allFields);
        case (0, $eTBmS.FIELD_TYPES).REACTIONS:
            return (0, $jvW2K.reactionsMapping)(issuesRemote, field);
        case (0, $eTBmS.FIELD_TYPES).PROJECT:
            return (0, $2Rap6.projectMapping)(field);
        case (0, $eTBmS.FIELD_TYPES).CONNECTION:
            return (0, $3DqTy.connectionMapping)(field);
        case (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS:
            if ((0, $7jTnu.fg)('jpd_platform_goals_field_support')) return (0, $fuKtm.goalsMapping)(field);
            return $9417de97cf48de9b$var$DEFAULT_MAPPING;
        case (0, $eTBmS.FIELD_TYPES).TEAM:
            return (0, $hWYml.teamMapping)(issuesRemote, field);
        default:
            return $9417de97cf48de9b$var$DEFAULT_MAPPING;
    }
};

});
parcelRegister("5rITV", function(module, exports) {

$parcel$export(module.exports, "commentsCountMapping", () => $fda5acec94244c13$export$b87f0dcebc01d00f);

var $2Ejzu = parcelRequire("2Ejzu");

var $feobD = parcelRequire("feobD");

var $5UhJY = parcelRequire("5UhJY");

var $eO7G9 = parcelRequire("eO7G9");
const $fda5acec94244c13$export$b87f0dcebc01d00f = (issuesRemote, field)=>{
    const valueAccessor = (state, props, issueId)=>(0, $feobD.createGetCommentsCount)(issueId)(state);
    const valueAccessorToExport = (state, props, issueId)=>`${state.properties.issueMetadata[issueId]?.comments.count || 0}`;
    return {
        ...(0, $eO7G9.defaultMapping),
        field: field,
        comparator: (0, $5UhJY.numberComparator),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getRollupOperations: ()=>[
                (0, $2Ejzu.COUNT_ROLLUP),
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP)
            ]
    };
};

});
parcelRegister("feobD", function(module, exports) {

$parcel$export(module.exports, "createGetCommentsCount", () => $4954b5de753e2674$export$5d1b9daad2ac7b1c);
$parcel$export(module.exports, "createGetCommentsCounts", () => $4954b5de753e2674$export$2eb1eb7377aebdbe);
$parcel$export(module.exports, "createGetTimestampCurrentUserSeenComments", () => $4954b5de753e2674$export$f2d835208b943096);
$parcel$export(module.exports, "createIsIssueHavingUnseenComments", () => $4954b5de753e2674$export$9e23c25d1d118890);

var $ahm5r = parcelRequire("ahm5r");

var $hw9ct = parcelRequire("hw9ct");
const $4954b5de753e2674$var$getIssueMetadataProperties = (state)=>state.properties.issueMetadata;
const $4954b5de753e2674$var$getCurrentUser = (state, props)=>props?.currentUser;
const $4954b5de753e2674$var$getCommentsMetadataMap = (state)=>state.properties.commentsMetadata;
const $4954b5de753e2674$export$5d1b9daad2ac7b1c = (id)=>(state)=>$4954b5de753e2674$var$getIssueMetadataProperties(state)[id]?.comments.count || 0;
const $4954b5de753e2674$var$createGetLatestCommentCreatedTimestamp = (id)=>(state)=>$4954b5de753e2674$var$getIssueMetadataProperties(state)[id]?.comments.lastCreated || undefined;
const $4954b5de753e2674$var$createGetLatestCommentAuthor = (id)=>(state)=>$4954b5de753e2674$var$getIssueMetadataProperties(state)[id]?.comments.lastCreatedAuthor || undefined;
const $4954b5de753e2674$export$2eb1eb7377aebdbe = (ids)=>(state)=>{
        const commentIdsCount = {};
        ids.forEach((id)=>{
            commentIdsCount[id] = $4954b5de753e2674$export$5d1b9daad2ac7b1c(id)(state);
        });
        return commentIdsCount;
    };
const $4954b5de753e2674$export$f2d835208b943096 = (localIssueId)=>(state)=>$4954b5de753e2674$var$getCommentsMetadataMap(state)[localIssueId]?.timestampCurrentUserSeenComments;
const $4954b5de753e2674$export$9e23c25d1d118890 = (localIssueId)=>(0, $ahm5r.createSelector)($4954b5de753e2674$export$f2d835208b943096(localIssueId), $4954b5de753e2674$export$5d1b9daad2ac7b1c(localIssueId), $4954b5de753e2674$var$createGetLatestCommentCreatedTimestamp(localIssueId), $4954b5de753e2674$var$createGetLatestCommentAuthor(localIssueId), $4954b5de753e2674$var$getCurrentUser, (0, $hw9ct.getIsSharedView), (timestampCurrentUserSeenComments, commentsCount, latestCreatedTimestamp, latestAuthor, currentUser, isSharedView)=>{
        // TODO: Remove this check when we have support for "last viewed" in shared views https://pi-dev-sandbox.atlassian.net/browse/POL-6124
        if (isSharedView) return false;
        if (commentsCount === 0 || currentUser === undefined) return false;
        if (timestampCurrentUserSeenComments === undefined || latestCreatedTimestamp === undefined || latestAuthor === undefined) return true;
        return new Date(latestCreatedTimestamp).getTime() > timestampCurrentUserSeenComments && latestAuthor !== currentUser;
    });

});
parcelRegister("hw9ct", function(module, exports) {

$parcel$export(module.exports, "getCurrentViewSelectedIssueIds", () => $047147899cd25eb2$export$3449c543e4c8c2e7);
$parcel$export(module.exports, "getIsSharedView", () => $047147899cd25eb2$export$d1a1b90d4cdb689d);

var $ahm5r = parcelRequire("ahm5r");
const $047147899cd25eb2$var$EMPTY_COLLECTION = [];
const $047147899cd25eb2$export$3449c543e4c8c2e7 = (state)=>state.containerProps?.currentViewSelectedIssueId || $047147899cd25eb2$var$EMPTY_COLLECTION;
const $047147899cd25eb2$export$aeed1cd47b44b249 = (localIssueId)=>(0, $ahm5r.createSelector)($047147899cd25eb2$export$3449c543e4c8c2e7, (selected)=>selected.includes(localIssueId));
const $047147899cd25eb2$export$d1a1b90d4cdb689d = (state, props)=>props?.isSharedView;

});


parcelRegister("eO7G9", function(module, exports) {

$parcel$export(module.exports, "defaultMapping", () => $1a4cfbe6cc277e4b$export$cf432e6ce8fbbb14);

var $12DRg = parcelRequire("12DRg");

var $8JqDY = parcelRequire("8JqDY");
const $1a4cfbe6cc277e4b$export$cf432e6ce8fbbb14 = {
    field: undefined,
    getValueFromJiraIssue: ()=>undefined,
    getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
    setMutable: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    setImmutable: (propertyMaps)=>propertyMaps,
    remove: (propertyMaps)=>propertyMaps,
    modifyImmutableIfMultiValueField: (propertyMaps)=>propertyMaps,
    comparator: ()=>0,
    valueAccessor: ()=>undefined,
    valueAccessorToExport: ()=>'',
    getAllValues: ()=>({}),
    getGroupIdentitiesSelector: (_fieldKey, _issueIdsSelector)=>()=>({}),
    getGroupIdentities: ()=>[],
    allowEmptyGroup: false,
    isMultiValueField: false,
    isSupportedByIssueUpdateApi: false,
    getLabel: ()=>undefined,
    getFilter: ()=>undefined,
    ...(0, $8JqDY.noopJiraUpdateService)
};

});


parcelRegister("3DqTy", function(module, exports) {

$parcel$export(module.exports, "isConnectionFieldValue", () => $a8a72c618c65671d$export$73f794f8c64af190);
$parcel$export(module.exports, "connectionMapping", () => $a8a72c618c65671d$export$1ea6b73370bbaa30);

var $ahm5r = parcelRequire("ahm5r");

var $apIeD = parcelRequire("apIeD");

var $cSmYj = parcelRequire("cSmYj");

var $d3vFW = parcelRequire("d3vFW");

var $jOCpp = parcelRequire("jOCpp");

var $LFmXM = parcelRequire("LFmXM");


var $5UhJY = parcelRequire("5UhJY");

var $iG19c = parcelRequire("iG19c");

var $eO7G9 = parcelRequire("eO7G9");

const $a8a72c618c65671d$export$73f794f8c64af190 = (value)=>typeof value === 'object' && value !== null && 'id' in value;
const $a8a72c618c65671d$var$mapValueToEntityValue = (state, id)=>{
    const localIssueIdsMap = state.properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e] ?? {};
    const mappedIssueIdEntry = Object.entries(localIssueIdsMap).find(([_, issueId])=>issueId === id);
    const localIssueId = mappedIssueIdEntry?.[0];
    const summary = localIssueId ? state.properties.string[0, $9a5f06039e1dff5a$export$469f8bf472cb9ca]?.[localIssueId] : undefined;
    return summary;
};
const $a8a72c618c65671d$var$connectionMappingInternal = (field)=>{
    const valueAccessor = (state, props, localIssueId)=>state.properties.connection[field.key]?.[localIssueId] || [];
    const valueAccessorToExport = (state, props, localIssueId)=>valueAccessor(state, props, localIssueId)?.map(({ id: id })=>$a8a72c618c65671d$var$mapValueToEntityValue(state, parseInt(id, 10))).filter(Boolean).join((0, $f62adc0d5402ab46$export$187b08d552477205));
    return {
        ...(0, $eO7G9.defaultMapping),
        getValueFromJiraIssue: (issue)=>{
            const connections = issue.fields[field.key];
            if (!Array.isArray(connections)) return undefined;
            return connections.map((id)=>({
                    id: id.toString()
                }));
        },
        field: field,
        valueAccessor: valueAccessor,
        getAllValues: (state)=>state.properties.connection[field.key] ? state.properties.connection[field.key] : {},
        valueAccessorToExport: valueAccessorToExport,
        setMutable: (maps, localIssueId, value = [])=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.connection, [
                field.key,
                localIssueId
            ], value),
        setImmutable: (maps, localIssueId, value = [])=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.connection[field.key]?.[localIssueId], value)) return maps;
            return {
                ...maps,
                connection: {
                    ...maps.connection,
                    [field.key]: {
                        ...maps.connection[field.key],
                        [localIssueId]: value
                    }
                }
            };
        },
        modifyImmutableIfMultiValueField: (maps, localIssueId, addValues = [], removeValues = [])=>{
            const currentValue = maps.connection[field.key]?.[localIssueId] || [];
            return {
                ...maps,
                connection: {
                    ...maps.connection,
                    [field.key]: {
                        ...maps.connection[field.key],
                        [localIssueId]: (0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))([
                            ...(0, (/*@__PURE__*/$parcel$interopDefault($apIeD)))(currentValue, removeValues, 'id'),
                            ...addValues
                        ], 'id')
                    }
                }
            };
        },
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.connection[fieldKey], (ids, connection)=>ids.reduce((result, localIssueId)=>Object.assign(result, {
                        [localIssueId]: connection?.[localIssueId]?.map((value)=>({
                                groupIdentity: value.id,
                                value: [
                                    value
                                ]
                            })) || []
                    }), {})),
        allowEmptyGroup: true,
        isMultiValueField: true,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueIntersectionFilter = (0, $iG19c.createStringValueIntersectionFilter)(filter);
                if (stringValueIntersectionFilter === undefined) return undefined;
                return (value, store, props, localIssueId)=>stringValueIntersectionFilter(value?.map(({ id: id })=>id), store, props, localIssueId);
            }
            return undefined;
        },
        comparatorWithMapping (state, _, a, b, direction) {
            const mappedA = a?.map(({ id: id })=>$a8a72c618c65671d$var$mapValueToEntityValue(state, parseInt(id, 10))).filter(Boolean);
            const mappedB = b?.map(({ id: id })=>$a8a72c618c65671d$var$mapValueToEntityValue(state, parseInt(id, 10))).filter(Boolean);
            return (0, $5UhJY.createCombinedComparator)([
                // first compare number of linked issues
                (a1 = [], b1 = [], dir)=>(0, $5UhJY.numberComparator)(a1.length, b1.length, dir),
                // then compare by summaries of linked issues
                (0, $5UhJY.safeStringListComparator)
            ])(mappedA, mappedB, direction);
        }
    };
};
const $a8a72c618c65671d$export$1ea6b73370bbaa30 = (0, $LFmXM.default)($a8a72c618c65671d$var$connectionMappingInternal);

});
const $f62adc0d5402ab46$export$187b08d552477205 = ', ';
const $f62adc0d5402ab46$export$a7c73c90c36f0ba2 = ' | ';


parcelRegister("bULQD", function(module, exports) {

$parcel$export(module.exports, "dateMapping", () => $e2cff0f2d43e5985$export$dd8d4634cf58a6ab);

var $ahm5r = parcelRequire("ahm5r");

var $d3vFW = parcelRequire("d3vFW");

var $dO9h7 = parcelRequire("dO9h7");

var $2Ejzu = parcelRequire("2Ejzu");

var $lCenk = parcelRequire("lCenk");

var $5UhJY = parcelRequire("5UhJY");

var $eQ9dE = parcelRequire("eQ9dE");

var $2yCra = parcelRequire("2yCra");
const $e2cff0f2d43e5985$export$dd8d4634cf58a6ab = (issuesRemote, field)=>{
    const basicDateMapping = (0, $2yCra.stringMapping)(issuesRemote, field);
    const valueAccessorToExport = (state, props, issueId, locale)=>{
        const stringDate = basicDateMapping.valueAccessor(state, props, issueId);
        return stringDate ? (0, $dO9h7.formatWithLocale)(new Date(stringDate), 'MMM dd, yyyy hh:mm a', locale) : '';
    };
    return {
        ...(0, $lCenk.jiraStringMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps, [
                'string',
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: string, value: string | undefined) => { string: { [x: string]: Record<string, string> | { [x: string]: string | undefined; }; }; ... 17 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: string | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.string[field.key] && maps.string[field.key][issueId] === value) return maps;
            return {
                ...maps,
                string: {
                    ...maps.string,
                    [field.key]: {
                        ...maps.string[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'string'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: (0, $5UhJY.stringComparator),
        valueAccessor: basicDateMapping.valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.string[field.key] ? state.properties.string[field.key] : {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.string[fieldKey], (ids, string)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: string !== undefined && string[issueId] !== undefined ? [
                            {
                                groupIdentity: string[issueId],
                                value: string[issueId]
                            }
                        ] : []
                    }), {})),
        getGroupIdentities: (state, props, issueId)=>{
            const stringProperties = state.properties.string;
            const value = stringProperties[field.key] && stringProperties[field.key][issueId];
            return value !== undefined ? [
                {
                    groupIdentity: value,
                    value: value
                }
            ] : [];
        },
        getRollupOperations: ()=>[
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP)
            ],
        allowEmptyGroup: true,
        getLabel: (groupIdentity, value)=>value,
        getFilter: ()=>undefined
    };
};

});
parcelRegister("lCenk", function(module, exports) {

$parcel$export(module.exports, "jiraStringMapping", () => $6f22642c0fd03934$export$f122de19e5c9a001);

var $8JqDY = parcelRequire("8JqDY");

const $6f22642c0fd03934$export$f122de19e5c9a001 = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] ?? undefined,
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        getFieldValueForJiraBulkUpdate: (value)=>({
                [(0, $a5b1a7a0b618efd3$export$a0e01ba2ebef17f2)]: {
                    fieldId: field.key,
                    text: value ?? ''
                }
            }),
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    });

});

parcelRegister("2yCra", function(module, exports) {

$parcel$export(module.exports, "stringMapping", () => $b8fa8686d454d4c9$export$205ce0ddc9953c05);

var $ahm5r = parcelRequire("ahm5r");

var $d3vFW = parcelRequire("d3vFW");

var $2Ejzu = parcelRequire("2Ejzu");

var $lCenk = parcelRequire("lCenk");

var $5UhJY = parcelRequire("5UhJY");

var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $b8fa8686d454d4c9$export$205ce0ddc9953c05 = (issuesRemote, field)=>{
    const valueAccessor = (state, props, issueId)=>state.properties.string[field.key] !== undefined ? state.properties.string[field.key][issueId] : undefined;
    const valueAccessorToExport = (state, props, issueId)=>valueAccessor(state, props, issueId) || '';
    return {
        ...(0, $lCenk.jiraStringMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps, [
                'string',
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: string, value: string | undefined) => { string: { [x: string]: Record<string, string> | { [x: string]: string | undefined; }; }; ... 17 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: string | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.string[field.key] && maps.string[field.key][issueId] === value) return maps;
            return {
                ...maps,
                string: {
                    ...maps.string,
                    [field.key]: {
                        ...maps.string[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'string'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: (0, $5UhJY.stringComparator),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.string[field.key] ? state.properties.string[field.key] : {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.string[fieldKey], (ids, string)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: string !== undefined && string[issueId] !== undefined ? [
                            {
                                groupIdentity: string[issueId],
                                value: string[issueId]
                            }
                        ] : []
                    }), {})),
        getGroupIdentities: (state, props, issueId)=>{
            const stringProperties = state.properties.string;
            const value = stringProperties[field.key] && stringProperties[field.key][issueId];
            return value !== undefined ? [
                {
                    groupIdentity: value,
                    value: value
                }
            ] : [];
        },
        getRollupOperations: ()=>[
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP)
            ],
        allowEmptyGroup: true,
        getLabel: (groupIdentity, value)=>value,
        getFilter: (filter)=>{
            // special handling for summary
            if (filter.type === 'TEXT' && field.key === 'summary') {
                const filterFunction = filter.localId === 'quick' ? (0, $iG19c.createConjunctTextChunkFilter)(filter) : (0, $iG19c.createDisjunctTextChunkFilter)(filter);
                if (filterFunction !== undefined) return {
                    filterId: filter.localId,
                    filterFunction: filterFunction,
                    disjunctionIdentifier: 'TEXT'
                };
            }
            return undefined;
        }
    };
};

});


parcelRegister("lRhTm", function(module, exports) {

$parcel$export(module.exports, "documentMapping", () => $7f83a62bb9d0a386$export$736d96e53a8f054a);

var $d3vFW = parcelRequire("d3vFW");

var $cX2BT = parcelRequire("cX2BT");

var $eQ9dE = parcelRequire("eQ9dE");
const $7f83a62bb9d0a386$export$736d96e53a8f054a = (issuesRemote, field)=>({
        ...(0, $cX2BT.jiraDocumentMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps, [
                'document',
                field.key,
                issueId
            ], value),
        setImmutable: (maps, issueId, value)=>{
            if (maps.document[field.key] && maps.document[field.key][issueId] === value) return maps;
            return {
                ...maps,
                document: {
                    ...maps.document,
                    [field.key]: {
                        ...maps.document[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'document'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: ()=>0,
        valueAccessor: (state, props, issueId)=>state.properties.document[field.key] !== undefined ? state.properties.document[field.key][issueId] : undefined,
        valueAccessorToExport: (state, props, issueId)=>state.properties.document[field.key] !== undefined ? state.properties.document[field.key][issueId]?.type : undefined,
        getAllValues: (state)=>state.properties.document[field.key] ? state.properties.document[field.key] : {},
        getGroupIdentitiesSelector: (_fieldKey, _issueIdsSelector)=>()=>({}),
        getGroupIdentities: ()=>[],
        allowEmptyGroup: false,
        getLabel: ()=>undefined,
        getFilter: ()=>undefined
    });

});
parcelRegister("cX2BT", function(module, exports) {

$parcel$export(module.exports, "jiraDocumentMapping", () => $e26a0d68d3e7f569$export$f59eabc3b1aee715);
const $e26a0d68d3e7f569$export$f59eabc3b1aee715 = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] ?? undefined,
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: false,
        getJiraUpdateService: (issueKey, value)=>issuesRemote.updateIssueDescription({
                issueKey: issueKey,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                description: value
            })
    });

});


parcelRegister("di66p", function(module, exports) {

$parcel$export(module.exports, "externalReferencePropertyMapping", () => $58d5bdd165de0396$export$513be1ff64bbb2f3);

var $ahm5r = parcelRequire("ahm5r");


var $5UhJY = parcelRequire("5UhJY");

var $1pFTn = parcelRequire("1pFTn");

var $iG19c = parcelRequire("iG19c");

var $eO7G9 = parcelRequire("eO7G9");

var $75BXd = parcelRequire("75BXd");
const $58d5bdd165de0396$var$mapPropertyToSort = (v, property)=>{
    switch(property){
        case 'state':
            return (0, $1pFTn.getExternalReferencePropertyIdentificator)(v);
        default:
            return undefined;
    }
};
const $58d5bdd165de0396$var$mapPropertyToLabel = (v, property)=>{
    switch(property){
        case 'state':
            return (0, $1pFTn.getExternalReferencePropertyLabel)(v);
        default:
            return undefined;
    }
};
const $58d5bdd165de0396$var$mapEntityToProperty = (v, property)=>{
    if (!v) return undefined;
    switch(property){
        case 'state':
            return v.state;
        default:
    }
    return undefined;
};
const $58d5bdd165de0396$export$513be1ff64bbb2f3 = (issuesRemote, field, allFields)=>{
    const { formula: formula } = field;
    if (formula?.template !== (0, $0b259e00d11f2126$export$cd9f8eb3bb2ff570)) return {
        ...(0, $eO7G9.defaultMapping)
    };
    const propertyField = allFields.find((f)=>f.key === formula?.parameters?.externalReferenceFieldKey);
    if (!propertyField) return {
        ...(0, $eO7G9.defaultMapping)
    };
    // AtlasGoalDetailsWithUsedFields_state | AtlasProjectDetailstWithUsedFields_state
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const valueAccessor = (state, props, localIssueId)=>{
        const externalReferenceValue = (0, $75BXd.externalReferenceMapping)(issuesRemote, propertyField).valueAccessor(state, props, localIssueId);
        if (!externalReferenceValue) return undefined;
        if (Array.isArray(externalReferenceValue)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return externalReferenceValue.map((id)=>$58d5bdd165de0396$var$mapEntityToProperty(state.properties.externalReferenceEntities[id], formula?.parameters?.property)).filter(Boolean);
        const property = $58d5bdd165de0396$var$mapEntityToProperty(state.properties.externalReferenceEntities[externalReferenceValue], formula?.parameters?.property);
        if (!property) return undefined;
        return property;
    };
    const valueAccessorToExport = (state, props, localIssueId)=>valueAccessor(state, props, localIssueId)?.label || '';
    return {
        ...(0, $eO7G9.defaultMapping),
        field: field,
        allowEmptyGroup: true,
        getDependencyValues: (state)=>state.properties.externalReferenceEntities,
        comparatorWithMapping (state, props, a, b, direction) {
            let aValues = [];
            if (a !== undefined) {
                if (field.configuration?.isMulti) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                aValues = a;
                else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                aValues = [
                    a
                ];
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const aValuesStr = aValues.map((v)=>$58d5bdd165de0396$var$mapPropertyToSort(v, formula?.parameters?.property)).filter(Boolean);
            let bValues = [];
            if (b !== undefined) {
                if (field.configuration?.isMulti) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                bValues = b;
                else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                bValues = [
                    b
                ];
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const bValuesStr = bValues.map((v)=>$58d5bdd165de0396$var$mapPropertyToSort(v, formula?.parameters?.property)).filter(Boolean);
            return (0, $5UhJY.safeStringListComparator)(aValuesStr, bValuesStr, direction);
        },
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)((0, $75BXd.getGroupIdentitiesSelector)(propertyField.key, issueIdsSelector), (state)=>state.properties.externalReferenceEntities, (groupIdentities, externalReferenceEntities)=>Object.keys(groupIdentities).reduce((result, issueId)=>{
                    const mapped = groupIdentities[issueId].map((groupIdentitity)=>{
                        const property = $58d5bdd165de0396$var$mapEntityToProperty(externalReferenceEntities[groupIdentitity.groupIdentity], formula?.parameters?.property);
                        if (!property) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        return undefined;
                        return {
                            groupIdentity: (0, $1pFTn.getExternalReferencePropertyIdentificator)(property),
                            value: property
                        };
                    }).filter(Boolean);
                    return Object.assign(result, {
                        [issueId]: mapped
                    });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                }, {})),
        getGroupIdentities: (state, props, localIssueId)=>{
            const groupIdentities = (0, $75BXd.externalReferenceMapping)(issuesRemote, propertyField).getGroupIdentities(state, props, localIssueId);
            const mapped = groupIdentities.map((groupIdentitity)=>{
                const property = $58d5bdd165de0396$var$mapEntityToProperty(state.properties.externalReferenceEntities[groupIdentitity.groupIdentity], formula?.parameters?.property);
                if (!property) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return undefined;
                return {
                    groupIdentity: (0, $1pFTn.getExternalReferencePropertyIdentificator)(property),
                    value: property
                };
            }).filter(Boolean);
            return mapped;
        },
        getLabel: (_, value)=>{
            if (Array.isArray(value)) return value.length === 1 ? $58d5bdd165de0396$var$mapPropertyToLabel(value[0], formula?.parameters?.property) : undefined;
            return value !== undefined && $58d5bdd165de0396$var$mapPropertyToLabel(value, formula?.parameters?.property);
        },
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueIntersectionFilter = (0, $iG19c.createStringValueIntersectionFilter)(filter);
                if (stringValueIntersectionFilter === undefined) return undefined;
                return (value, state, props, localIssueId)=>{
                    if (value === undefined) return stringValueIntersectionFilter([], state, props, localIssueId);
                    const valueAsArray = Array.isArray(value) ? value : [
                        value
                    ];
                    return stringValueIntersectionFilter(valueAsArray.map((v)=>(0, $1pFTn.getExternalReferencePropertyIdentificator)(v)), state, props, localIssueId);
                };
            }
            return undefined;
        }
    };
};

});
const $0b259e00d11f2126$export$cd9f8eb3bb2ff570 = 'external-reference-property';

parcelRegister("1pFTn", function(module, exports) {

$parcel$export(module.exports, "getExternalReferencePropertyLabel", () => $5d9aa7a981792156$export$c1dade48cbdcd80c);
$parcel$export(module.exports, "getExternalReferencePropertyIdentificator", () => $5d9aa7a981792156$export$6f27952863597e22);

var $eSnSE = parcelRequire("eSnSE");
const $5d9aa7a981792156$export$c1dade48cbdcd80c = (property)=>{
    switch(property.__typename){
        case 'TownsquareGoalState':
        case 'TownsquareProjectState':
            return property.label;
        default:
            (0, $eSnSE.default).safeWarnWithoutCustomerData('external-reference-property-label.failure', 'Failed to match external reference property type to defined label');
            return undefined;
    }
};
const $5d9aa7a981792156$export$6f27952863597e22 = (property)=>{
    switch(property.__typename){
        case 'TownsquareGoalState':
        case 'TownsquareProjectState':
            return property.value;
        default:
            (0, $eSnSE.default).safeWarnWithoutCustomerData('external-reference-property-identificator.failure', 'Failed to match external reference property type to defined identificator');
            return undefined;
    }
};

});

parcelRegister("75BXd", function(module, exports) {

$parcel$export(module.exports, "getGroupIdentitiesSelector", () => $9b41d4cf164c9d41$export$183a100d216914d2);
$parcel$export(module.exports, "externalReferenceMapping", () => $9b41d4cf164c9d41$export$7d75004abe429389);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $d3vFW = parcelRequire("d3vFW");

var $5zHFN = parcelRequire("5zHFN");

var $bwp95 = parcelRequire("bwp95");

var $5UhJY = parcelRequire("5UhJY");


var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $9b41d4cf164c9d41$var$mapValueToEntityValue = (state, value)=>state.properties.externalReferenceEntities[value]?.name;
const $9b41d4cf164c9d41$var$getGroupIdentitiesForIssue = (externalReference, issueId)=>{
    const values = externalReference?.[issueId];
    if (!values) return [];
    if (Array.isArray(values)) return values.map((value)=>({
            groupIdentity: value,
            value: [
                value
            ]
        }));
    return [
        {
            groupIdentity: values,
            value: values
        }
    ];
};
const $9b41d4cf164c9d41$export$183a100d216914d2 = (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.externalReference[fieldKey], (ids, externalReference)=>ids.reduce((result, issueId)=>Object.assign(result, {
                [issueId]: $9b41d4cf164c9d41$var$getGroupIdentitiesForIssue(externalReference, issueId)
            }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {}));
const $9b41d4cf164c9d41$export$7d75004abe429389 = (issuesRemote, field)=>{
    const valueAccessor = (state, props, issueId)=>state.properties.externalReference[field.key] !== undefined ? state.properties.externalReference[field.key][issueId] : undefined;
    const valueAccessorToExport = (state, props, issueId)=>{
        const value = valueAccessor(state, props, issueId) || '';
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Array.isArray(value) ? value.join((0, $f62adc0d5402ab46$export$187b08d552477205)) : value;
    };
    return {
        ...(0, $bwp95.jiraExternalReferenceMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.externalReference, [
                field.key,
                issueId
            ], value),
        setImmutable: (maps, issueId, value)=>{
            if (maps.externalReference[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.externalReference[field.key][issueId], value)) return maps;
            return {
                ...maps,
                externalReference: {
                    ...maps.externalReference,
                    [field.key]: {
                        ...maps.externalReference[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'externalReference'),
        modifyImmutableIfMultiValueField: (maps, issueId, addValues, removeValues = [])=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const oldValues = maps.externalReference[field.key]?.[issueId] || [];
            const definedAddValues = addValues || [];
            const newValues = oldValues.filter((oldValue)=>(Array.isArray(removeValues) ? removeValues : [
                    removeValues
                ]).findIndex((removeValue)=>oldValue === removeValue) < 0).concat((Array.isArray(definedAddValues) ? definedAddValues : [
                definedAddValues
            ]).filter((newValue)=>oldValues.findIndex((oldValue)=>oldValue === newValue) < 0));
            if ((0, $5zHFN.isShallowEqual)(newValues, oldValues)) return maps;
            return {
                ...maps,
                externalReference: {
                    ...maps.externalReference,
                    [field.key]: {
                        ...maps.externalReference[field.key],
                        [issueId]: newValues
                    }
                }
            };
        },
        comparator: ()=>0,
        comparatorWithMapping (state, props, a, b, direction) {
            let aValues = [];
            if (a !== undefined) {
                if (field.configuration?.isMulti) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                aValues = a;
                else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                aValues = [
                    a
                ];
            }
            let bValues = [];
            if (b !== undefined) {
                if (field.configuration?.isMulti) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                bValues = b;
                else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                bValues = [
                    b
                ];
            }
            const mappedA = aValues.map((v)=>$9b41d4cf164c9d41$var$mapValueToEntityValue(state, v)).filter((v)=>Boolean(v));
            const mappedB = bValues.map((v)=>$9b41d4cf164c9d41$var$mapValueToEntityValue(state, v)).filter((v)=>Boolean(v));
            const rank = (0, $5UhJY.safeStringListComparator)(mappedA, mappedB, direction);
            return rank;
        },
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            state.properties.externalReference[field.key] ? state.properties.externalReference[field.key] : {},
        getDependencyValues: (state)=>state.properties.externalReferenceEntities,
        getGroupIdentitiesSelector: $9b41d4cf164c9d41$export$183a100d216914d2,
        getGroupIdentities: (state, props, issueId)=>$9b41d4cf164c9d41$var$getGroupIdentitiesForIssue(state.properties.externalReference[field.key], issueId),
        allowEmptyGroup: true,
        getLabel: (groupIdentity, value)=>{
            if (Array.isArray(value)) return value[0] || groupIdentity;
            return value || groupIdentity;
        },
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueIntersectionFilter = (0, $iG19c.createStringValueIntersectionFilter)(filter);
                if (stringValueIntersectionFilter === undefined) return undefined;
                return (value, props, state, localIssueId)=>{
                    if (value === undefined) return stringValueIntersectionFilter([], props, state, localIssueId);
                    const valueAsArray = Array.isArray(value) ? value : [
                        value
                    ];
                    return stringValueIntersectionFilter(valueAsArray, props, state, localIssueId);
                };
            }
            return undefined;
        }
    };
};

});
parcelRegister("bwp95", function(module, exports) {

$parcel$export(module.exports, "jiraExternalReferenceMapping", () => $e1a0fa292e7239e0$export$a56b7c9cb9aa101a);

var $8JqDY = parcelRequire("8JqDY");

const $e1a0fa292e7239e0$export$a56b7c9cb9aa101a = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>{
            const value = issue.fields[field.key] ? issue.fields[field.key] : undefined;
            if (field.configuration?.isMulti) try {
                return JSON.parse(value);
            } catch (err) {
                return [];
            }
            else return value;
        },
        getFieldValueForJiraUpdate: (value)=>{
            if (value === undefined) return null;
            if (!Array.isArray(value)) return value;
            if (Array.isArray(value) && value.length === 0) return null;
            return JSON.stringify(value);
        },
        getFieldValueForJiraBulkUpdate: (value)=>{
            let text = '';
            if (value !== undefined) {
                if (Array.isArray(value) && value.length > 0) text = JSON.stringify(value);
                else if (!Array.isArray(value)) text = value;
            }
            return {
                [(0, $a5b1a7a0b618efd3$export$a0e01ba2ebef17f2)]: {
                    fieldId: field.key,
                    text: text
                }
            };
        },
        isMultiValueField: field.configuration?.isMulti || false,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    });

});



parcelRegister("fuKtm", function(module, exports) {

$parcel$export(module.exports, "goalsMapping", () => $e1649fbbdb1d63ed$export$4406b553809c3dd6);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $d3vFW = parcelRequire("d3vFW");

var $5zHFN = parcelRequire("5zHFN");

var $5UhJY = parcelRequire("5UhJY");

var $eO7G9 = parcelRequire("eO7G9");

var $iG19c = parcelRequire("iG19c");
const $e1649fbbdb1d63ed$var$mapValueToEntityValue = (state, value)=>state.properties.externalReferenceEntities[value]?.name;
const $e1649fbbdb1d63ed$var$getGroupIdentitiesForIssue = (goals, issueId)=>{
    const values = goals?.[issueId];
    if (!values) return [];
    if (Array.isArray(values)) return values.map((value)=>({
            groupIdentity: value,
            value: [
                value
            ]
        }));
    return [
        {
            groupIdentity: values,
            value: values
        }
    ];
};
const $e1649fbbdb1d63ed$export$183a100d216914d2 = (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.goals[fieldKey], (ids, goals)=>ids.reduce((result, issueId)=>Object.assign(result, {
                [issueId]: $e1649fbbdb1d63ed$var$getGroupIdentitiesForIssue(goals, issueId)
            }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {}));
const $e1649fbbdb1d63ed$export$4406b553809c3dd6 = (field)=>{
    const valueAccessor = (state, props, issueId)=>state.properties?.goals[field.key] !== undefined ? state.properties.goals[field.key][issueId] : undefined;
    return {
        ...(0, $eO7G9.defaultMapping),
        field: field,
        allowEmptyGroup: true,
        isMultiValueField: true,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] ? issue.fields[field.key] : undefined,
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.goals, [
                field.key,
                issueId
            ], value),
        setImmutable: (maps, issueId, value)=>{
            if (maps.goals[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.goals[field.key][issueId], value)) return maps;
            return {
                ...maps,
                goals: {
                    ...maps.goals,
                    [field.key]: {
                        ...maps.goals[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (propertyMaps)=>propertyMaps,
        modifyImmutableIfMultiValueField: (maps, issueId, addValues, removeValues = [])=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const oldValues = maps.goals[field.key]?.[issueId] || [];
            const definedAddValues = addValues || [];
            const newValues = oldValues.filter((oldValue)=>(Array.isArray(removeValues) ? removeValues : [
                    removeValues
                ]).findIndex((removeValue)=>oldValue === removeValue) < 0).concat((Array.isArray(definedAddValues) ? definedAddValues : [
                definedAddValues
            ]).filter((newValue)=>oldValues.findIndex((oldValue)=>oldValue === newValue) < 0));
            if ((0, $5zHFN.isShallowEqual)(newValues, oldValues)) return maps;
            return {
                ...maps,
                goals: {
                    ...maps.goals,
                    [field.key]: {
                        ...maps.goals[field.key],
                        [issueId]: newValues
                    }
                }
            };
        },
        comparator: ()=>0,
        comparatorWithMapping (state, props, a, b, direction) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mappedA = (a || []).map((v)=>$e1649fbbdb1d63ed$var$mapValueToEntityValue(state, v)).filter(Boolean);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mappedB = (b || []).map((v)=>$e1649fbbdb1d63ed$var$mapValueToEntityValue(state, v)).filter(Boolean);
            return (0, $5UhJY.safeStringListComparator)(mappedA, mappedB, direction);
        },
        valueAccessor: valueAccessor,
        getAllValues: (state)=>state.properties.goals[field.key] ? state.properties.goals[field.key] : {},
        getDependencyValues: (state)=>state.properties.externalReferenceEntities,
        getGroupIdentitiesSelector: $e1649fbbdb1d63ed$export$183a100d216914d2,
        getGroupIdentities: (state, props, issueId)=>$e1649fbbdb1d63ed$var$getGroupIdentitiesForIssue(state.properties.goals[field.key], issueId),
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueIntersectionFilter = (0, $iG19c.createStringValueIntersectionFilter)(filter);
                if (stringValueIntersectionFilter === undefined) return undefined;
                return (value, props, state, localIssueId)=>{
                    if (value === undefined) return stringValueIntersectionFilter([], props, state, localIssueId);
                    return stringValueIntersectionFilter(value, props, state, localIssueId);
                };
            }
            return undefined;
        },
        getLabel: (groupIdentity, value)=>{
            if (Array.isArray(value)) return value[0] || groupIdentity;
            return value || groupIdentity;
        }
    };
};

});

parcelRegister("2kAlY", function(module, exports) {

$parcel$export(module.exports, "intervalStringMapping", () => $918195353a7e389f$export$a1ec72f9a3d66984);

var $KSas2 = parcelRequire("KSas2");

var $3ZrK1 = parcelRequire("3ZrK1");

var $eTBmS = parcelRequire("eTBmS");

var $8Z1Mi = parcelRequire("8Z1Mi");

var $2Ejzu = parcelRequire("2Ejzu");

var $8m4OM = parcelRequire("8m4OM");

var $62tnP = parcelRequire("62tnP");

var $au10R = parcelRequire("au10R");

var $7jTnu = parcelRequire("7jTnu");

var $gfYxH = parcelRequire("gfYxH");

var $4qiFT = parcelRequire("4qiFT");

var $75BXd = parcelRequire("75BXd");

var $2yCra = parcelRequire("2yCra");

var $2UXb1 = parcelRequire("2UXb1");
const $918195353a7e389f$export$a1ec72f9a3d66984 = (issuesRemote, field, allFields)=>{
    const basicStringMapping = (0, $2yCra.stringMapping)(issuesRemote, field);
    const atlasProjectField = field.configuration?.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).ATLAS_PROJECT_TARGET_DATE && allFields.find((f)=>f.type === (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT);
    const valueAccessor = (state, props, localIssueId)=>{
        if (atlasProjectField) {
            const externalReferenceValue = (0, $75BXd.externalReferenceMapping)(issuesRemote, atlasProjectField).valueAccessor(state, props, localIssueId);
            if (typeof externalReferenceValue === 'string') {
                const entity = state.properties.externalReferenceEntities[externalReferenceValue];
                switch(field.configuration?.source){
                    case (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).ATLAS_PROJECT_TARGET_DATE:
                        if (entity && entity.dueDate?.dateRange?.start && entity.dueDate?.dateRange?.end && entity.state?.value !== 'pending') return JSON.stringify({
                            start: new Date(entity.dueDate.dateRange.start).toISOString().slice(0, 10),
                            end: new Date(entity.dueDate.dateRange.end).toISOString().slice(0, 10)
                        });
                        break;
                    default:
                }
            }
        }
        if (field.configuration?.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).DELIVERY_DATE) {
            const customFieldKey = field?.configuration?.customfieldKey;
            const aggregationType = field?.configuration?.aggregationType;
            if (customFieldKey && aggregationType) {
                const value = state.properties.aggregatedDeliveryDates[localIssueId]?.find((v)=>v.fieldKey === customFieldKey && v.aggregationType.toLowerCase() === aggregationType?.toLowerCase());
                const intervalValue = (0, $3ZrK1.timestampAggDateToInterval)(value, props?.locale, props?.timezone);
                if (intervalValue) return JSON.stringify(intervalValue);
            }
        }
        return basicStringMapping.valueAccessor(state, props, localIssueId);
    };
    const valueAccessorToExport = (state, props, localIssueId)=>{
        const value = valueAccessor(state, props, localIssueId);
        const parsedInterval = (0, $62tnP.tryParseIntervalString)(value);
        if (!parsedInterval) return '';
        if ((0, $7jTnu.fg)('polaris_pol-14239_custom_quarters')) {
            const locale = (0, $4qiFT.standardizeLocale)(props?.locale || 'en_US');
            const intl = (0, $gfYxH.getIntl)({
                locale: locale
            });
            return (0, $au10R.renderDateString)(parsedInterval, undefined, intl.formatMessage, intl.formatDate);
        }
        return (0, $au10R.renderDateString)(parsedInterval);
    };
    return {
        ...basicStringMapping,
        getDependencyValues: (state)=>{
            if (field.configuration?.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).DELIVERY_DATE) return state.properties.aggregatedDeliveryDates;
            return state.properties.externalReferenceEntities;
        },
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        valueAccessorRealValues: basicStringMapping.valueAccessor,
        getValueFromJiraIssue: (issue)=>{
            if (issue.fields[field.key] === null) return undefined;
            const interval = (0, $62tnP.tryParseIntervalString)(issue.fields[field.key]);
            return interval ? JSON.stringify(interval) : undefined;
        },
        getFilter: (filter)=>{
            if (filter.type === 'INTERVAL' && filter.field === field.key) {
                const filterFunctions = filter.values.map((0, $2UXb1.createFilterFunction)((0, $8m4OM.MONTH)));
                return (value, state, props, localIssueId)=>(0, (/*@__PURE__*/$parcel$interopDefault($KSas2)))(filterFunctions, (filterFunction)=>filterFunction(value, state, props, localIssueId));
            }
            return undefined;
        },
        getRollupOperations: ()=>[
                (0, $2Ejzu.RANGE_ROLLUP),
                (0, $2Ejzu.MIN_ROLLUP),
                (0, $2Ejzu.MAX_ROLLUP)
            ]
    };
};

});
parcelRegister("3ZrK1", function(module, exports) {

$parcel$export(module.exports, "timestampAggDateToInterval", () => $b69dc41bfe6c7e17$export$eff050361a0b2229);

var $dO9h7 = parcelRequire("dO9h7");
const $b69dc41bfe6c7e17$var$DATE_FORMAT = 'yyyy-MM-dd';
const $b69dc41bfe6c7e17$var$DATE_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $b69dc41bfe6c7e17$var$DATE_TIME_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $b69dc41bfe6c7e17$var$stringDateToInterval = (date)=>({
        start: date,
        end: date
    });
const $b69dc41bfe6c7e17$export$eff050361a0b2229 = (dateRaw, locale = 'en_US', timezone = 'UTC')=>{
    if (!dateRaw) return undefined;
    if (!dateRaw.date) return undefined;
    if (dateRaw.fieldType === $b69dc41bfe6c7e17$var$DATE_FIELD_TYPE) return $b69dc41bfe6c7e17$var$stringDateToInterval((0, $dO9h7.formatTimezonedWithLocale)(new Date(dateRaw.date), $b69dc41bfe6c7e17$var$DATE_FORMAT, locale, 'UTC'));
    if (dateRaw.fieldType === $b69dc41bfe6c7e17$var$DATE_TIME_FIELD_TYPE) return $b69dc41bfe6c7e17$var$stringDateToInterval((0, $dO9h7.formatTimezonedWithLocale)(new Date(dateRaw.date), $b69dc41bfe6c7e17$var$DATE_FORMAT, locale, timezone));
};

});

parcelRegister("8Z1Mi", function(module, exports) {

$parcel$export(module.exports, "INTERVAL_FIELD_SOURCES", () => $c89507c67e66672d$export$32d458d2bb06643c);
const $c89507c67e66672d$var$INTERVAL_FIELD_SOURCE_MANUAL = 'MANUAL';
const $c89507c67e66672d$var$INTERVAL_FIELD_SOURCE_ATLAS_PROJECT_START_DATE = 'ATLAS_PROJECT_START_DATE';
const $c89507c67e66672d$var$INTERVAL_FIELD_SOURCE_ATLAS_PROJECT_TARGET_DATE = 'ATLAS_PROJECT_TARGET_DATE';
const $c89507c67e66672d$var$INTERVAL_FIELD_SOURCE_DELIVERY_DATE = 'DELIVERY_DATE';
const $c89507c67e66672d$export$32d458d2bb06643c = {
    MANUAL: $c89507c67e66672d$var$INTERVAL_FIELD_SOURCE_MANUAL,
    ATLAS_PROJECT_START_DATE: $c89507c67e66672d$var$INTERVAL_FIELD_SOURCE_ATLAS_PROJECT_START_DATE,
    ATLAS_PROJECT_TARGET_DATE: $c89507c67e66672d$var$INTERVAL_FIELD_SOURCE_ATLAS_PROJECT_TARGET_DATE,
    DELIVERY_DATE: $c89507c67e66672d$var$INTERVAL_FIELD_SOURCE_DELIVERY_DATE
};

});

parcelRegister("8m4OM", function(module, exports) {

$parcel$export(module.exports, "NUMERIC_FIELD_FILTER", () => $afcaf403ee0ee700$export$3aebb683eeef1499);
$parcel$export(module.exports, "GENERIC_FIELD_FILTER", () => $afcaf403ee0ee700$export$7953c28690fb1213);
$parcel$export(module.exports, "TEXT_FIELD_FILTER", () => $afcaf403ee0ee700$export$dfb428b2ad446d31);
$parcel$export(module.exports, "CONNECTION_FIELD_FILTER", () => $afcaf403ee0ee700$export$5770c22f062583b8);
$parcel$export(module.exports, "END_AFTER_NOW", () => $afcaf403ee0ee700$export$638adeef33537a68);
$parcel$export(module.exports, "END_BEFORE_NOW", () => $afcaf403ee0ee700$export$30befb0fa6893059);
$parcel$export(module.exports, "START_AFTER_NOW", () => $afcaf403ee0ee700$export$7359752f4a980247);
$parcel$export(module.exports, "START_BEFORE_NOW", () => $afcaf403ee0ee700$export$f06e771ea660fbad);
$parcel$export(module.exports, "INTERVAL_FILTER_OPERATOR_CODES", () => $afcaf403ee0ee700$export$c7020595b90e17e);
$parcel$export(module.exports, "INTERVAL_FILTER_PERIOD_DAY", () => $afcaf403ee0ee700$export$8ed9e80cde8b7891);
$parcel$export(module.exports, "INTERVAL_FILTER_PERIOD_WEEK", () => $afcaf403ee0ee700$export$7b5eb8b28b028f59);
$parcel$export(module.exports, "INTERVAL_FILTER_PERIOD_MONTH", () => $afcaf403ee0ee700$export$8e4683b7dd898c2e);
$parcel$export(module.exports, "INTERVAL_FILTER_PERIOD_YEAR", () => $afcaf403ee0ee700$export$449f451688379d1d);
$parcel$export(module.exports, "INTERVAL_FILTER_DATE_TYPE_START", () => $afcaf403ee0ee700$export$ba95e6b199c67252);
$parcel$export(module.exports, "INTERVAL_FILTER_DATE_TYPE_END", () => $afcaf403ee0ee700$export$1b7cc75ce838353c);
$parcel$export(module.exports, "INTERVAL_FILTER_TIME_PAST", () => $afcaf403ee0ee700$export$4acb69139aaa59ce);
$parcel$export(module.exports, "INTERVAL_FILTER_TIME_NEXT", () => $afcaf403ee0ee700$export$c50699fcea31b0ed);
$parcel$export(module.exports, "INTERVAL_FILTER_TIME_CURRENT", () => $afcaf403ee0ee700$export$3f209a2d3dfe3901);
$parcel$export(module.exports, "INTERVAL_FIELD_FILTER", () => $afcaf403ee0ee700$export$ea2ab227e6a480aa);
$parcel$export(module.exports, "MONTH", () => $afcaf403ee0ee700$export$fa5253a4540f3e3a);
$parcel$export(module.exports, "DAY", () => $afcaf403ee0ee700$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "CONNECTION_FIELD_FILTER_BOARD_COLUMN", () => $afcaf403ee0ee700$export$5e4fef5543ab23da);
$parcel$export(module.exports, "CONNECTION_FIELD_FILTER_VIEW_GROUP", () => $afcaf403ee0ee700$export$91704b1686df52d);
const $afcaf403ee0ee700$export$3aebb683eeef1499 = 'NUMBER';
const $afcaf403ee0ee700$export$7953c28690fb1213 = 'FIELD';
const $afcaf403ee0ee700$export$dfb428b2ad446d31 = 'TEXT';
const $afcaf403ee0ee700$export$5770c22f062583b8 = 'CONNECTION_FIELD';
const $afcaf403ee0ee700$export$638adeef33537a68 = 'END_AFTER_NOW';
const $afcaf403ee0ee700$export$30befb0fa6893059 = 'END_BEFORE_NOW';
const $afcaf403ee0ee700$export$7359752f4a980247 = 'START_AFTER_NOW';
const $afcaf403ee0ee700$export$f06e771ea660fbad = 'START_BEFORE_NOW';
const $afcaf403ee0ee700$export$c7020595b90e17e = [
    $afcaf403ee0ee700$export$638adeef33537a68,
    $afcaf403ee0ee700$export$30befb0fa6893059,
    $afcaf403ee0ee700$export$7359752f4a980247,
    $afcaf403ee0ee700$export$f06e771ea660fbad
];
const $afcaf403ee0ee700$export$8ed9e80cde8b7891 = 'day';
const $afcaf403ee0ee700$export$7b5eb8b28b028f59 = 'week';
const $afcaf403ee0ee700$export$8e4683b7dd898c2e = 'month';
const $afcaf403ee0ee700$export$449f451688379d1d = 'year';
const $afcaf403ee0ee700$export$ba95e6b199c67252 = 'startIntervalDate';
const $afcaf403ee0ee700$export$1b7cc75ce838353c = 'endIntervalDate';
const $afcaf403ee0ee700$export$4acb69139aaa59ce = 'past';
const $afcaf403ee0ee700$export$c50699fcea31b0ed = 'next';
const $afcaf403ee0ee700$export$3f209a2d3dfe3901 = 'current';
const $afcaf403ee0ee700$export$ea2ab227e6a480aa = 'INTERVAL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $afcaf403ee0ee700$var$QUARTER = 'QUARTER';
const $afcaf403ee0ee700$export$fa5253a4540f3e3a = 'MONTH';
const $afcaf403ee0ee700$export$1a58b8d7f494dd72 = 'DAY';
const $afcaf403ee0ee700$export$5e4fef5543ab23da = 'BOARD_COLUMN';
const $afcaf403ee0ee700$export$91704b1686df52d = 'VIEW_GROUP';

});

parcelRegister("62tnP", function(module, exports) {

$parcel$export(module.exports, "RELATIVE", () => $fb030660c44df83e$export$91389b1eb9882ae7);
$parcel$export(module.exports, "getADGTimestampDisplaySetting", () => $fb030660c44df83e$export$e89759fbd7b8f45a);
$parcel$export(module.exports, "getRelativeValueAndUnit", () => $fb030660c44df83e$export$1408df75620c8f9f);
$parcel$export(module.exports, "tryParseIntervalString", () => $fb030660c44df83e$export$e854878b6ff992b4);

var $8RQlO = parcelRequire("8RQlO");
var $bf0oy = parcelRequire("bf0oy");
var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $6Yd06 = parcelRequire("6Yd06");
const $fb030660c44df83e$export$91389b1eb9882ae7 = 'RELATIVE';
const $fb030660c44df83e$export$8cd2c3eb7eeb9644 = 'ABSOLUTE';
const $fb030660c44df83e$var$getDaysElapsed = (date)=>(Date.now() - new Date(date).getTime()) / 86400000;
const $fb030660c44df83e$export$e89759fbd7b8f45a = (date)=>$fb030660c44df83e$var$getDaysElapsed(date) < 8 ? $fb030660c44df83e$export$91389b1eb9882ae7 : $fb030660c44df83e$export$8cd2c3eb7eeb9644;
const $fb030660c44df83e$var$MINUTE = 60;
const $fb030660c44df83e$var$HOUR = 3600;
const $fb030660c44df83e$var$DAY = 86400;
// stolen from react-intl
function $fb030660c44df83e$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $fb030660c44df83e$var$MINUTE;
        case 'hour':
            return $fb030660c44df83e$var$HOUR;
        default:
            return $fb030660c44df83e$var$DAY;
    }
}
const $fb030660c44df83e$var$selectUnit = (seconds)=>{
    const absValue = Math.abs(seconds);
    if (absValue < $fb030660c44df83e$var$MINUTE) return 'second';
    if (absValue < $fb030660c44df83e$var$HOUR) return 'minute';
    if (absValue < $fb030660c44df83e$var$DAY) return 'hour';
    return 'day';
};
const $fb030660c44df83e$export$1408df75620c8f9f = (date)=>{
    const seconds = Math.round((new Date(date).getTime() - Date.now()) / 1000);
    const unit = $fb030660c44df83e$var$selectUnit(seconds);
    const unitDuration = $fb030660c44df83e$var$getDurationInSeconds(unit);
    const value = Math.round(seconds / unitDuration);
    return [
        value,
        unit
    ];
};
const $fb030660c44df83e$export$62bcad98e749626 = (onboardedAt)=>{
    if (!onboardedAt) return false;
    const now = new Date();
    const then = new Date(onboardedAt);
    return (0, $bf0oy.default)(now, (0, $8RQlO.default)(then, 7));
};
const $fb030660c44df83e$var$isValidIsoDateString = (value)=>value && (0, $dBLX0.default)((0, $kQ82p.default)(value));
const $fb030660c44df83e$export$e854878b6ff992b4 = (value)=>{
    if (!value) return undefined;
    if ($fb030660c44df83e$var$isValidIsoDateString(value)) return {
        start: value,
        end: value
    };
    try {
        const parsedValue = JSON.parse(value);
        if (!$fb030660c44df83e$var$isValidIsoDateString(parsedValue.start) || !$fb030660c44df83e$var$isValidIsoDateString(parsedValue.end)) return undefined;
        return {
            start: parsedValue.start,
            end: parsedValue.end
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris-error.lib-date-time.tryParseIntervalString', 'Failed to parse Interval JSON', error);
        return undefined;
    }
};

});

parcelRegister("au10R", function(module, exports) {

$parcel$export(module.exports, "DATETIME_FORMAT", () => $88df8d81618cbb33$export$ae1dc8cbcf481d8e);
$parcel$export(module.exports, "DATE_FORMAT", () => $88df8d81618cbb33$export$45c85543ba71221d);
$parcel$export(module.exports, "DATE_FORMAT_DFNS", () => $88df8d81618cbb33$export$af59fe3705acbbda);
$parcel$export(module.exports, "formatMonthAndYearDate", () => $88df8d81618cbb33$export$2ebd9a5a504d8727);
$parcel$export(module.exports, "formatQuarterAndYearDate", () => $88df8d81618cbb33$export$bff7db6ee98b52d0);
$parcel$export(module.exports, "formatIsoLocalDate", () => $88df8d81618cbb33$export$576edf138d340b5d);
$parcel$export(module.exports, "FuzzyScale", () => $88df8d81618cbb33$export$ad6c00ff936d910d);
$parcel$export(module.exports, "getFuzzyScale", () => $88df8d81618cbb33$export$32c50ab22112d6ce);
$parcel$export(module.exports, "renderDateString", () => $88df8d81618cbb33$export$3a6708e815f1ccd1);
$parcel$export(module.exports, "useAdgCompliantRelativeDate", () => $88df8d81618cbb33$export$c58300bf2e9dbfa1);
$parcel$export(module.exports, "FormattedDate", () => $88df8d81618cbb33$export$40ae3194919d16b);
$parcel$export(module.exports, "useRenderDateString", () => $88df8d81618cbb33$export$9be0e8872c679cdd);

var $eJOHy = parcelRequire("eJOHy");

var $lw3Pj = parcelRequire("lw3Pj");
var $6UlJv = parcelRequire("6UlJv");
var $9TE87 = parcelRequire("9TE87");
var $fTjQo = parcelRequire("fTjQo");
var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");
var $4RKz5 = parcelRequire("4RKz5");
var $aUcJF = parcelRequire("aUcJF");

var $1ili3 = parcelRequire("1ili3");

var $lRq8t = parcelRequire("lRq8t");

var $dO9h7 = parcelRequire("dO9h7");

var $7jTnu = parcelRequire("7jTnu");

var $5UziZ = parcelRequire("5UziZ");

var $62tnP = parcelRequire("62tnP");
const $88df8d81618cbb33$export$ae1dc8cbcf481d8e = 'LLL d, yyyy hh:mm a';
const $88df8d81618cbb33$export$45c85543ba71221d = 'LLL d, yyyy';
const $88df8d81618cbb33$export$af59fe3705acbbda = 'MMM D, YYYY';
const $88df8d81618cbb33$export$ab8da37e29943dac = 'MMM d, yyyy';
const $88df8d81618cbb33$export$7aa8df5d3355fa4a = 'MMM';
const $88df8d81618cbb33$export$e8d0682eb7d102dc = 'MMM, yyyy';
const $88df8d81618cbb33$export$9aaac72defac9929 = 'MMM yyyy';
// this will only work for Dates that are in UTC. It won't work with DateTimes as those are timezone aware
const $88df8d81618cbb33$var$formatWithLocale = (date, dateFormat, locale)=>{
    return (0, $dO9h7.formatTimezonedWithLocale)(date, dateFormat, locale || 'en_US', 'UTC');
};
const $88df8d81618cbb33$export$9b0e8a03930c4b1e = (date, locale)=>$88df8d81618cbb33$var$formatWithLocale(date, $88df8d81618cbb33$export$ab8da37e29943dac, locale);
const $88df8d81618cbb33$export$cec1db3fd4087308 = (date, locale)=>$88df8d81618cbb33$var$formatWithLocale(date, $88df8d81618cbb33$export$e8d0682eb7d102dc, locale);
const $88df8d81618cbb33$export$2ebd9a5a504d8727 = (date, locale)=>$88df8d81618cbb33$var$formatWithLocale(date, $88df8d81618cbb33$export$9aaac72defac9929, locale);
const $88df8d81618cbb33$export$bff7db6ee98b52d0 = (date, locale)=>{
    const startOfQuarterDate = (0, $1ili3.default)((0, $aUcJF.default)(date), 'UTC');
    const endOfQuarterDate = (0, $1ili3.default)((0, $9TE87.default)(date), 'UTC');
    return `${$88df8d81618cbb33$var$formatWithLocale(startOfQuarterDate, $88df8d81618cbb33$export$7aa8df5d3355fa4a)}-${$88df8d81618cbb33$var$formatWithLocale(endOfQuarterDate, $88df8d81618cbb33$export$9aaac72defac9929, locale)}`;
};
const $88df8d81618cbb33$export$ba73273900396e5b = (date, formatMessage, formatDate)=>{
    if (!date || !date.start || !date.end) return '';
    const quarterStart = (0, $4RKz5.default)((0, $kQ82p.default)(date.start));
    const quarterEnd = (0, $6UlJv.default)((0, $kQ82p.default)(date.end));
    const startYear = quarterStart.getFullYear();
    const endYear = quarterEnd.getFullYear();
    if (startYear < endYear) return formatMessage((0, $5UziZ.messages).quarterDisplayWithYearRange, {
        startMonth: formatDate(quarterStart, {
            month: 'short'
        }),
        endMonth: formatDate(quarterEnd, {
            month: 'short'
        }),
        startYear: startYear,
        endYear: endYear
    });
    return formatMessage((0, $5UziZ.messages).quarterDisplay, {
        startMonth: formatDate(quarterStart, {
            month: 'short'
        }),
        endMonth: formatDate(quarterEnd, {
            month: 'short'
        }),
        year: startYear
    });
};
const $88df8d81618cbb33$export$65cbe7f37a8de928 = (date, locale)=>{
    const startOfQuarterDate = (0, $1ili3.default)((0, $aUcJF.default)(date), 'UTC');
    const endOfQuarterDate = (0, $1ili3.default)((0, $9TE87.default)(date), 'UTC');
    return `${$88df8d81618cbb33$var$formatWithLocale(startOfQuarterDate, $88df8d81618cbb33$export$7aa8df5d3355fa4a)}-${$88df8d81618cbb33$var$formatWithLocale(endOfQuarterDate, $88df8d81618cbb33$export$e8d0682eb7d102dc, locale)}`;
};
const $88df8d81618cbb33$export$576edf138d340b5d = (date)=>(0, $fTjQo.default)(date, {
        representation: 'date'
    });
var $88df8d81618cbb33$export$ad6c00ff936d910d = /*#__PURE__*/ function(FuzzyScale) {
    FuzzyScale["DAY"] = "day";
    FuzzyScale["MONTH"] = "month";
    FuzzyScale["QUARTER"] = "quarter";
    return FuzzyScale;
}({});
const $88df8d81618cbb33$var$MONTH_THRESHOLD = 31;
const $88df8d81618cbb33$var$DAY_THRESHOLD = 1;
const $88df8d81618cbb33$export$32c50ab22112d6ce = (dateObj)=>{
    if (dateObj) {
        const dateDiff = (0, $lw3Pj.default)(new Date(dateObj.end), new Date(dateObj.start));
        if (dateDiff < $88df8d81618cbb33$var$DAY_THRESHOLD) return "day";
        if (dateDiff <= $88df8d81618cbb33$var$MONTH_THRESHOLD) return "month";
        return "quarter";
    }
    // If date is somehow undefined, we'll show quarters picker by default
    return "quarter";
};
const $88df8d81618cbb33$export$3a6708e815f1ccd1 = (interval, placeholder, formatMessage, formatDate)=>{
    if (!interval) return placeholder;
    const endDate = (0, $1ili3.default)(interval.end.slice(0, 10), 'UTC');
    if (!(0, $dBLX0.default)(endDate)) return placeholder;
    switch($88df8d81618cbb33$export$32c50ab22112d6ce(interval)){
        case "day":
            return $88df8d81618cbb33$export$9b0e8a03930c4b1e(endDate);
        case "quarter":
            return formatMessage && formatDate && (0, $7jTnu.fg)('polaris_pol-14239_custom_quarters') ? $88df8d81618cbb33$export$ba73273900396e5b(interval, formatMessage, formatDate) : $88df8d81618cbb33$export$65cbe7f37a8de928(endDate);
        default:
        case "month":
            return $88df8d81618cbb33$export$cec1db3fd4087308(endDate);
    }
};
const $88df8d81618cbb33$export$c58300bf2e9dbfa1 = (date)=>{
    const { formatDate: formatDate, formatRelativeTime: formatRelativeTime, formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useMemo)(()=>{
        if (date === null || date === undefined) return undefined;
        if ((0, $62tnP.getADGTimestampDisplaySetting)(date) === (0, $62tnP.RELATIVE)) {
            const [value, unit] = (0, $62tnP.getRelativeValueAndUnit)(date);
            if (unit === 'second' && value < 60 && value > -60) return formatMessage((0, $5UziZ.messages).justNow);
            return formatRelativeTime(value, unit);
        }
        return formatDate(date, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }, [
        date,
        formatDate,
        formatRelativeTime,
        formatMessage
    ]);
};
const $88df8d81618cbb33$export$40ae3194919d16b = ({ date: date })=>{
    const formatted = $88df8d81618cbb33$export$c58300bf2e9dbfa1(date);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatted);
};
const $88df8d81618cbb33$export$9be0e8872c679cdd = ()=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formattedRenderDateString = (0, $eJOHy.useCallback)((dateString, placeholder)=>{
        return $88df8d81618cbb33$export$3a6708e815f1ccd1(dateString, placeholder, formatMessage, formatDate);
    }, [
        formatDate,
        formatMessage
    ]);
    return formattedRenderDateString;
};

});
parcelRegister("5UziZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $43debda27bc41506$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $43debda27bc41506$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    justNow: {
        "id": "polaris-lib-date-time.just-now",
        "defaultMessage": "just now"
    },
    quarterDisplay: {
        "id": "polaris-lib-date-time.quarter-display",
        "defaultMessage": "{startMonth}-{endMonth}, {year}"
    },
    quarterDisplayWithYearRange: {
        "id": "polaris-lib-date-time.quarter-display-with-year-range",
        "defaultMessage": "{startMonth}-{endMonth}, {startYear}-{endYear}"
    }
});

});


parcelRegister("gfYxH", function(module, exports) {

$parcel$export(module.exports, "getIntl", () => $7e0882b3a42f1fb4$export$51771ec7613ad564);

var $4nehu = parcelRequire("4nehu");
var $99KvW = parcelRequire("99KvW");
const $7e0882b3a42f1fb4$var$cache = (0, $99KvW.createIntlCache)();
const $7e0882b3a42f1fb4$export$51771ec7613ad564 = (config)=>(0, $4nehu.createIntl)(config, $7e0882b3a42f1fb4$var$cache);

});

parcelRegister("2UXb1", function(module, exports) {

$parcel$export(module.exports, "createFilterFunction", () => $5fb817d0b8d40d01$export$5b4da3e2bd753e6);
$parcel$export(module.exports, "createDateFilterFunction", () => $5fb817d0b8d40d01$export$add128d2fbf2f344);

var $dtgHw = parcelRequire("dtgHw");
var $1xngw = parcelRequire("1xngw");
var $6UlJv = parcelRequire("6UlJv");
var $4lOsp = parcelRequire("4lOsp");
var $ggr5t = parcelRequire("ggr5t");
var $bf0oy = parcelRequire("bf0oy");
var $lncFc = parcelRequire("lncFc");
var $bDAx9 = parcelRequire("bDAx9");
var $8b7GZ = parcelRequire("8b7GZ");
var $7ZNZa = parcelRequire("7ZNZa");
var $kQ82p = parcelRequire("kQ82p");
var $2InI0 = parcelRequire("2InI0");
var $4RKz5 = parcelRequire("4RKz5");
var $5IPrF = parcelRequire("5IPrF");
var $2MnGH = parcelRequire("2MnGH");
var $8XZn3 = parcelRequire("8XZn3");

var $7jTnu = parcelRequire("7jTnu");

var $8m4OM = parcelRequire("8m4OM");

var $4dsfo = parcelRequire("4dsfo");

var $62tnP = parcelRequire("62tnP");
const $5fb817d0b8d40d01$var$matchPastTimeHorizon = (dateToCheck, horizon, now)=>{
    return (0, $lncFc.default)(dateToCheck, now) || (0, $lncFc.default)(dateToCheck, horizon) || (0, $bf0oy.default)(horizon, dateToCheck) && (0, $bf0oy.default)(dateToCheck, now);
};
const $5fb817d0b8d40d01$var$matchFutureTimeHorizon = (dateToCheck, horizon, now)=>{
    return (0, $lncFc.default)(dateToCheck, now) || (0, $lncFc.default)(dateToCheck, horizon) || (0, $bf0oy.default)(now, dateToCheck) && (0, $bf0oy.default)(dateToCheck, horizon);
};
const $5fb817d0b8d40d01$export$b050485644593c18 = (interval, period)=>(startDate, endDate, now = new Date())=>{
        let horizon;
        switch(period){
            case 0, $8m4OM.MONTH:
                horizon = (0, $4RKz5.default)((0, $8XZn3.default)(now, {
                    months: interval
                }));
                break;
            case 0, $8m4OM.DAY:
                horizon = (0, $2InI0.default)((0, $8XZn3.default)(now, {
                    days: interval
                }));
                break;
            default:
                throw new Error('Unknown period for interval filter function');
        }
        return $5fb817d0b8d40d01$var$matchPastTimeHorizon(startDate, horizon, now);
    };
const $5fb817d0b8d40d01$export$d612d006560ad3d0 = (interval, period)=>(startDate, endDate, now = new Date())=>{
        let horizon;
        switch(period){
            case 0, $8m4OM.MONTH:
                horizon = (0, $6UlJv.default)((0, $dtgHw.default)(now, {
                    months: interval
                }));
                break;
            case 0, $8m4OM.DAY:
                horizon = (0, $1xngw.default)((0, $dtgHw.default)(now, {
                    days: interval
                }));
                break;
            default:
                throw new Error('Unknown period for interval filter function');
        }
        return $5fb817d0b8d40d01$var$matchFutureTimeHorizon(startDate, horizon, now);
    };
const $5fb817d0b8d40d01$export$bc79068a0eaaf7ec = (interval, period)=>(startDate, endDate, now = new Date())=>{
        let horizon;
        switch(period){
            case 0, $8m4OM.MONTH:
                horizon = (0, $4RKz5.default)((0, $8XZn3.default)(now, {
                    months: interval
                }));
                break;
            case 0, $8m4OM.DAY:
                horizon = (0, $2InI0.default)((0, $8XZn3.default)(now, {
                    days: interval
                }));
                break;
            default:
                throw new Error('Unknown period for interval filter function');
        }
        return $5fb817d0b8d40d01$var$matchPastTimeHorizon(endDate, horizon, now);
    };
const $5fb817d0b8d40d01$export$43856c39b3a15a67 = (interval, period)=>(startDate, endDate, now = new Date())=>{
        let horizon;
        switch(period){
            case 0, $8m4OM.MONTH:
                horizon = (0, $6UlJv.default)((0, $dtgHw.default)(now, {
                    months: interval
                }));
                break;
            case 0, $8m4OM.DAY:
                horizon = (0, $1xngw.default)((0, $dtgHw.default)(now, {
                    days: interval
                }));
                break;
            default:
                throw new Error('Unknown period for interval filter function');
        }
        return $5fb817d0b8d40d01$var$matchFutureTimeHorizon(endDate, horizon, now);
    };
const $5fb817d0b8d40d01$export$7b571fa4867c575b = (expectedStartDateIsoString, expectedEndDateIsoString)=>(startDate, endDate)=>{
        if (expectedStartDateIsoString && expectedEndDateIsoString) {
            const expectedStartDate = (0, $kQ82p.default)(expectedStartDateIsoString);
            const expectedEndDate = (0, $kQ82p.default)(expectedEndDateIsoString);
            return ((0, $lncFc.default)(expectedStartDate, startDate) || (0, $bf0oy.default)(expectedStartDate, startDate)) && ((0, $lncFc.default)(expectedEndDate, endDate) || (0, $bf0oy.default)(endDate, expectedEndDate));
        }
        if (expectedStartDateIsoString) {
            const expectedStartDate = (0, $kQ82p.default)(expectedStartDateIsoString);
            return (0, $lncFc.default)(expectedStartDate, startDate) || (0, $bf0oy.default)(expectedStartDate, startDate);
        }
        if (expectedEndDateIsoString) {
            const expectedEndDate = (0, $kQ82p.default)(expectedEndDateIsoString);
            return (0, $lncFc.default)(expectedEndDate, endDate) || (0, $bf0oy.default)(endDate, expectedEndDate);
        }
        return true;
    };
const $5fb817d0b8d40d01$export$9b6538d1a7065541 = (intervalDateType, period, time, n = 0)=>(startDate, endDate, now = new Date())=>{
        const dateToCheck = intervalDateType === (0, $8m4OM.INTERVAL_FILTER_DATE_TYPE_START) ? startDate : endDate;
        switch(period){
            case 0, $8m4OM.INTERVAL_FILTER_PERIOD_DAY:
                switch(time){
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_PAST:
                        {
                            const horizon = (0, $2InI0.default)((0, $8XZn3.default)(now, {
                                days: n
                            }));
                            return $5fb817d0b8d40d01$var$matchPastTimeHorizon(dateToCheck, horizon, now);
                        }
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_CURRENT:
                        return (0, $lncFc.default)(dateToCheck, now);
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_NEXT:
                        {
                            const horizon = (0, $1xngw.default)((0, $dtgHw.default)(now, {
                                days: n
                            }));
                            return $5fb817d0b8d40d01$var$matchFutureTimeHorizon(dateToCheck, horizon, now);
                        }
                    default:
                        throw new Error('Unknown time for period: day in interval rolling dates filter function');
                }
            case 0, $8m4OM.INTERVAL_FILTER_PERIOD_WEEK:
                switch(time){
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_PAST:
                        {
                            const horizon = (0, $5IPrF.default)((0, $8XZn3.default)(now, {
                                weeks: n
                            }));
                            return $5fb817d0b8d40d01$var$matchPastTimeHorizon(dateToCheck, horizon, now);
                        }
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_CURRENT:
                        return (0, $8b7GZ.default)(dateToCheck, now);
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_NEXT:
                        {
                            const horizon = (0, $4lOsp.default)((0, $dtgHw.default)(now, {
                                weeks: n
                            }));
                            return $5fb817d0b8d40d01$var$matchFutureTimeHorizon(dateToCheck, horizon, now);
                        }
                    default:
                        throw new Error('Unknown time for period: week in interval rolling dates filter function');
                }
            case 0, $8m4OM.INTERVAL_FILTER_PERIOD_MONTH:
                switch(time){
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_PAST:
                        {
                            const horizon = (0, $4RKz5.default)((0, $8XZn3.default)(now, {
                                months: n
                            }));
                            return $5fb817d0b8d40d01$var$matchPastTimeHorizon(dateToCheck, horizon, now);
                        }
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_CURRENT:
                        return (0, $bDAx9.default)(dateToCheck, now);
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_NEXT:
                        {
                            const horizon = (0, $6UlJv.default)((0, $dtgHw.default)(now, {
                                months: n
                            }));
                            return $5fb817d0b8d40d01$var$matchFutureTimeHorizon(dateToCheck, horizon, now);
                        }
                    default:
                        throw new Error('Unknown time for period: month in interval rolling dates filter function');
                }
            case 0, $8m4OM.INTERVAL_FILTER_PERIOD_YEAR:
                switch(time){
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_PAST:
                        {
                            const horizon = (0, $2MnGH.default)((0, $8XZn3.default)(now, {
                                years: n
                            }));
                            return $5fb817d0b8d40d01$var$matchPastTimeHorizon(dateToCheck, horizon, now);
                        }
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_CURRENT:
                        return (0, $7ZNZa.default)(dateToCheck, now);
                    case 0, $8m4OM.INTERVAL_FILTER_TIME_NEXT:
                        {
                            const horizon = (0, $ggr5t.default)((0, $dtgHw.default)(now, {
                                years: n
                            }));
                            return $5fb817d0b8d40d01$var$matchFutureTimeHorizon(dateToCheck, horizon, now);
                        }
                    default:
                        throw new Error('Unknown time for period: year in interval rolling dates filter function');
                }
            default:
                throw new Error('Unknown period for interval rolling dates filter function');
        }
    };
const $5fb817d0b8d40d01$var$createStringParsingIntervalFilter = (wrappedIntervalFilter, filterValue)=>(value)=>{
        if ((0, $7jTnu.fg)('polaris_better_date_filters')) {
            if ((0, $4dsfo.isIntervalFieldFilterEmptyValue)(filterValue)) return value === undefined;
        }
        if (value === undefined) return false;
        const parsedInterval = (0, $62tnP.tryParseIntervalString)(value);
        if (parsedInterval) return wrappedIntervalFilter((0, $kQ82p.default)(parsedInterval.start), (0, $kQ82p.default)(parsedInterval.end));
        return false;
    };
const $5fb817d0b8d40d01$var$createStringParsingDateFilter = (wrappedIntervalFilter, filterValue)=>(value)=>{
        if ((0, $7jTnu.fg)('polaris_better_date_filters')) {
            if ((0, $4dsfo.isIntervalFieldFilterEmptyValue)(filterValue)) return value === undefined;
        }
        if (value === undefined) return false;
        try {
            return wrappedIntervalFilter((0, $kQ82p.default)(value), (0, $kQ82p.default)(value));
        } catch (err) {
            return false;
        }
    };
const $5fb817d0b8d40d01$var$getWrappedFilterFunctionLegacy = (filterValue, period)=>{
    const pass = ()=>true;
    if (!(0, $4dsfo.isIntervalFieldFilterLegacyValue)(filterValue)) return pass;
    switch(filterValue.operator){
        case 0, $8m4OM.START_BEFORE_NOW:
            return $5fb817d0b8d40d01$export$b050485644593c18(filterValue.numericValue, period);
        case 0, $8m4OM.START_AFTER_NOW:
            return $5fb817d0b8d40d01$export$d612d006560ad3d0(filterValue.numericValue, period);
        case 0, $8m4OM.END_BEFORE_NOW:
            return $5fb817d0b8d40d01$export$bc79068a0eaaf7ec(filterValue.numericValue, period);
        case 0, $8m4OM.END_AFTER_NOW:
            return $5fb817d0b8d40d01$export$43856c39b3a15a67(filterValue.numericValue, period);
        default:
            return pass;
    }
};
const $5fb817d0b8d40d01$var$getWrappedFilterFunctionNext = (filterValue, period)=>{
    const pass = ()=>true;
    if ((0, $4dsfo.isIntervalFieldFilterLegacyValue)(filterValue)) switch(filterValue.operator){
        case 0, $8m4OM.START_BEFORE_NOW:
            return $5fb817d0b8d40d01$export$b050485644593c18(filterValue.numericValue, period);
        case 0, $8m4OM.START_AFTER_NOW:
            return $5fb817d0b8d40d01$export$d612d006560ad3d0(filterValue.numericValue, period);
        case 0, $8m4OM.END_BEFORE_NOW:
            return $5fb817d0b8d40d01$export$bc79068a0eaaf7ec(filterValue.numericValue, period);
        case 0, $8m4OM.END_AFTER_NOW:
            return $5fb817d0b8d40d01$export$43856c39b3a15a67(filterValue.numericValue, period);
        default:
    }
    if ((0, $4dsfo.isIntervalFieldFilterAbsoluteDatesValue)(filterValue)) return $5fb817d0b8d40d01$export$7b571fa4867c575b(filterValue.start, filterValue.end);
    if ((0, $4dsfo.isIntervalFieldFilterRollingDatesCurrentValue)(filterValue)) return $5fb817d0b8d40d01$export$9b6538d1a7065541(filterValue.intervalDateType, filterValue.period, filterValue.time);
    if ((0, $4dsfo.isIntervalFieldFilterRollingDatesPastNextValue)(filterValue)) return $5fb817d0b8d40d01$export$9b6538d1a7065541(filterValue.intervalDateType, filterValue.period, filterValue.time, filterValue.numericValue);
    return pass;
};
const $5fb817d0b8d40d01$export$5b4da3e2bd753e6 = (period)=>(filterValueOperator)=>{
        const getWrappedFilterFunction = (0, $7jTnu.fg)('polaris_better_date_filters') ? $5fb817d0b8d40d01$var$getWrappedFilterFunctionNext : $5fb817d0b8d40d01$var$getWrappedFilterFunctionLegacy;
        return $5fb817d0b8d40d01$var$createStringParsingIntervalFilter(getWrappedFilterFunction(filterValueOperator, period), filterValueOperator);
    };
const $5fb817d0b8d40d01$export$add128d2fbf2f344 = (pediod)=>(filterValueOperator)=>{
        const getWrappedFilterFunction = (0, $7jTnu.fg)('polaris_better_date_filters') ? $5fb817d0b8d40d01$var$getWrappedFilterFunctionNext : $5fb817d0b8d40d01$var$getWrappedFilterFunctionLegacy;
        return $5fb817d0b8d40d01$var$createStringParsingDateFilter(getWrappedFilterFunction(filterValueOperator, pediod), filterValueOperator);
    };

});
parcelRegister("4dsfo", function(module, exports) {

$parcel$export(module.exports, "isIntervalFieldFilterLegacy", () => $c4b2bd1378359e84$export$453b2b447c957fa1);
$parcel$export(module.exports, "isIntervalFieldFilterLegacyValue", () => $c4b2bd1378359e84$export$d36e971d87f7c4a3);
$parcel$export(module.exports, "isIntervalFieldFilterEmpty", () => $c4b2bd1378359e84$export$d818d21767db59f7);
$parcel$export(module.exports, "isIntervalFieldFilterEmptyValue", () => $c4b2bd1378359e84$export$6c8c8a96bfedc1ca);
$parcel$export(module.exports, "isIntervalFieldFilterAbsoluteDatesValue", () => $c4b2bd1378359e84$export$58f79cd53548b713);
$parcel$export(module.exports, "isIntervalFieldFilterRollingDatesCurrentValue", () => $c4b2bd1378359e84$export$8a5ef845e301097);
$parcel$export(module.exports, "isIntervalFieldFilterRollingDatesPastNextValue", () => $c4b2bd1378359e84$export$6af8ca37aed5ff7);
$parcel$export(module.exports, "isArrayIntervalFieldFilterLegacyValue", () => $c4b2bd1378359e84$export$e38c70d956db7841);

var $8m4OM = parcelRequire("8m4OM");
function $c4b2bd1378359e84$var$createIsIntervalFieldFilter(fn) {
    return function isIntervalFieldFilter(filter) {
        return filter.values.length === 0 || filter.values.some((value)=>fn(value));
    };
}
const $c4b2bd1378359e84$export$453b2b447c957fa1 = $c4b2bd1378359e84$var$createIsIntervalFieldFilter($c4b2bd1378359e84$export$d36e971d87f7c4a3);
const $c4b2bd1378359e84$export$d818d21767db59f7 = $c4b2bd1378359e84$var$createIsIntervalFieldFilter($c4b2bd1378359e84$export$6c8c8a96bfedc1ca);
function $c4b2bd1378359e84$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $c4b2bd1378359e84$export$d36e971d87f7c4a3(value) {
    return (0, $8m4OM.INTERVAL_FILTER_OPERATOR_CODES).some((operator)=>$c4b2bd1378359e84$var$isObject(value) && 'operator' in value && value.operator === operator);
}
function $c4b2bd1378359e84$export$58f79cd53548b713(value) {
    return $c4b2bd1378359e84$var$isObject(value) && 'type' in value && value.type === 'ABSOLUTE_DATES';
}
function $c4b2bd1378359e84$export$8a5ef845e301097(value) {
    return $c4b2bd1378359e84$var$isObject(value) && 'type' in value && value.type === 'ROLLING_DATES' && 'time' in value && value.time === (0, $8m4OM.INTERVAL_FILTER_TIME_CURRENT);
}
function $c4b2bd1378359e84$export$6af8ca37aed5ff7(value) {
    return $c4b2bd1378359e84$var$isObject(value) && 'type' in value && value.type === 'ROLLING_DATES' && 'time' in value && value.time !== (0, $8m4OM.INTERVAL_FILTER_TIME_CURRENT);
}
function $c4b2bd1378359e84$export$6c8c8a96bfedc1ca(value) {
    return 'operator' in value && value.operator === 'EQ';
}
function $c4b2bd1378359e84$export$e38c70d956db7841(arr) {
    if (arr.length > 0) return $c4b2bd1378359e84$export$d36e971d87f7c4a3(arr[0]);
    return true;
}

});



parcelRegister("7rydk", function(module, exports) {

$parcel$export(module.exports, "issueIdMapping", () => $851f3b6716023fa5$export$346004086a9f6764);

var $aASL0 = parcelRequire("aASL0");

var $5UhJY = parcelRequire("5UhJY");

var $dNCRE = parcelRequire("dNCRE");
const $851f3b6716023fa5$export$346004086a9f6764 = (issuesRemote, field)=>{
    const basicNumberMapping = (0, $dNCRE.numberMapping)(issuesRemote, field);
    return {
        ...(0, $aASL0.jiraIssueIdMapping)(issuesRemote, field),
        setMutable: basicNumberMapping.setMutable,
        setImmutable: basicNumberMapping.setImmutable,
        remove: basicNumberMapping.remove,
        modifyImmutableIfMultiValueField: basicNumberMapping.modifyImmutableIfMultiValueField,
        comparator: (0, $5UhJY.numberComparator),
        valueAccessor: basicNumberMapping.valueAccessor,
        valueAccessorToExport: basicNumberMapping.valueAccessorToExport,
        getAllValues: basicNumberMapping.getAllValues,
        getGroupIdentities: basicNumberMapping.getGroupIdentities,
        getGroupIdentitiesSelector: basicNumberMapping.getGroupIdentitiesSelector,
        allowEmptyGroup: false,
        getLabel: (groupIdentity, value)=>String(value),
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                const excludedIds = filter.values.map(({ stringValue: stringValue })=>+stringValue);
                return (issueId)=>issueId === undefined || !excludedIds.includes(issueId);
            }
            return undefined;
        }
    };
};

});
parcelRegister("aASL0", function(module, exports) {

$parcel$export(module.exports, "jiraIssueIdMapping", () => $c615d55970c646cd$export$dbf2ee5d3bb864ae);

var $8JqDY = parcelRequire("8JqDY");

var $9GpIe = parcelRequire("9GpIe");
const $c615d55970c646cd$export$dbf2ee5d3bb864ae = (issuesRemote, field)=>{
    const baseMapping = (0, $9GpIe.jiraNumberMapping)(issuesRemote, field);
    return {
        field: field,
        getValueFromJiraIssue: (issue)=>Number(issue.id),
        getFieldValueForJiraUpdate: baseMapping.getFieldValueForJiraUpdate,
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: false,
        ...(0, $8JqDY.noopJiraUpdateService)
    };
};

});
parcelRegister("9GpIe", function(module, exports) {

$parcel$export(module.exports, "jiraNumberMapping", () => $a4f280a20231526d$export$2c3c43b7a53117f7);

var $eTBmS = parcelRequire("eTBmS");

var $8JqDY = parcelRequire("8JqDY");

const $a4f280a20231526d$export$2c3c43b7a53117f7 = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>{
            if (issue.fields[field.key] !== null && issue.fields[field.key] !== undefined) return issue.fields[field.key];
            if (field.type === (0, $eTBmS.FIELD_TYPES).RATING || field.type === (0, $eTBmS.FIELD_TYPES).CHECKBOX) return 0;
            return undefined;
        },
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        getFieldValueForJiraBulkUpdate: (value)=>({
                [(0, $a5b1a7a0b618efd3$export$4e8bcd47a31d751c)]: {
                    fieldId: field.key,
                    value: value !== undefined ? value : null
                }
            }),
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    });

});


parcelRegister("dNCRE", function(module, exports) {

$parcel$export(module.exports, "numberMapping", () => $3bdab0affaf9c927$export$d56ec019b132ebf6);

var $ahm5r = parcelRequire("ahm5r");

var $KSas2 = parcelRequire("KSas2");

var $d3vFW = parcelRequire("d3vFW");

var $LFmXM = parcelRequire("LFmXM");

var $eTBmS = parcelRequire("eTBmS");

var $2Ejzu = parcelRequire("2Ejzu");

var $9GpIe = parcelRequire("9GpIe");

var $5UhJY = parcelRequire("5UhJY");

var $eQ9dE = parcelRequire("eQ9dE");

var $kArEw = parcelRequire("kArEw");
const $3bdab0affaf9c927$var$isPresentationalNumberField = (field)=>field.type === (0, $eTBmS.FIELD_TYPES).RATING || field.type === (0, $eTBmS.FIELD_TYPES).CHECKBOX;
const $3bdab0affaf9c927$var$numberMappingInternal = (issuesRemote, field)=>{
    const valueAccessor = (state, props, issueId)=>{
        if (field.formula === undefined) {
            const fieldValue = state.properties.number[field.key]?.[issueId];
            return $3bdab0affaf9c927$var$isPresentationalNumberField(field) && fieldValue === undefined ? 0 : fieldValue;
        }
        let val;
        const numberDynamicProperties = state.dynamicProperties.numberValue;
        if (numberDynamicProperties[field.key] !== undefined) val = numberDynamicProperties[field.key](issueId)?.(state, props);
        if (field.type === (0, $eTBmS.FIELD_TYPES).CHECKBOX) return val !== undefined && val >= 1 ? 1 : 0;
        // Not displaying Infinity. It's the result of a division by 0, so not possible.
        if (val === Infinity) return undefined;
        return val;
    };
    const valueAccessorToExport = (state, props, issueId)=>{
        const stringNumber = (0, $kArEw.isFieldInsights)(field) ? state.properties.insights?.[issueId]?.length : valueAccessor(state, props, issueId);
        return `${(0, $kArEw.roundOneDecimal)(stringNumber || 0)}`;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const EMPTY = {};
    return {
        ...(0, $9GpIe.jiraNumberMapping)(issuesRemote, field),
        getAllValues: (state, props)=>{
            if (field.formula === undefined) return state.properties.number[field.key] ? state.properties.number[field.key] : {};
            if (state.dynamicProperties.numberValues[field.key] === undefined) return EMPTY;
            return state.dynamicProperties.numberValues[field.key](state, props);
        },
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps, [
                'number',
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: LocalIssueId, value?: number) => { number: { [x: string]: Record<string, number> | { [x: string]: number | undefined; }; }; string: PropertyMap<string>; stringList: PropertyMap<...>; ... 15 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: number | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.number[field.key] && maps.number[field.key][issueId] === value) return maps;
            return {
                ...maps,
                number: {
                    ...maps.number,
                    [field.key]: {
                        ...maps.number[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'number'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: (0, $5UhJY.numberComparator),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state, (ids, state)=>ids.reduce((result, issueId)=>{
                    const value = valueAccessor(state, state.containerProps, issueId);
                    return Object.assign(result, {
                        [issueId]: value !== undefined ? [
                            {
                                groupIdentity: `${value}`,
                                value: value
                            }
                        ] : []
                    });
                }, {})),
        getGroupIdentities: (state, props, issueId)=>{
            const value = valueAccessor(state, props, issueId);
            if (value !== undefined) return [
                {
                    groupIdentity: `${value}`,
                    value: value
                }
            ];
            return [];
        },
        getRollupOperations: ()=>[
                (0, $2Ejzu.AVG_ROLLUP),
                (0, $2Ejzu.MEDIAN_ROLLUP),
                (0, $2Ejzu.SUM_ROLLUP)
            ],
        allowEmptyGroup: field.type !== (0, $eTBmS.FIELD_TYPES).RATING && field.type !== (0, $eTBmS.FIELD_TYPES).CHECKBOX,
        getLabel: (groupIdentity, value)=>String(value),
        getFilter: (filter)=>{
            if (filter.type === 'NUMBER' && filter.field === field.key) return (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($KSas2)))(filter.values, ({ operator: operator, numericValue: numericValue })=>{
                    switch(operator){
                        case 'EQ':
                            return numericValue === value || $3bdab0affaf9c927$var$isPresentationalNumberField(field) && value === 0 && numericValue === undefined;
                        case 'NEQ':
                            return numericValue !== value;
                        case 'LT':
                            return numericValue !== undefined && value !== undefined && value < numericValue;
                        case 'GT':
                            return numericValue !== undefined && value !== undefined && value > numericValue;
                        case 'LTE':
                            return numericValue !== undefined && value !== undefined && value <= numericValue;
                        case 'GTE':
                            return numericValue !== undefined && value !== undefined && value >= numericValue;
                        default:
                            return true;
                    }
                });
            return undefined;
        }
    };
};
const $3bdab0affaf9c927$export$d56ec019b132ebf6 = (0, $LFmXM.default)($3bdab0affaf9c927$var$numberMappingInternal);

});
parcelRegister("kArEw", function(module, exports) {

$parcel$export(module.exports, "isFieldInsights", () => $288507b462193d29$export$17c47159dc49f82b);
$parcel$export(module.exports, "roundOneDecimal", () => $288507b462193d29$export$ed6509e3892c1e57);

var $eTBmS = parcelRequire("eTBmS");
const $288507b462193d29$export$17c47159dc49f82b = (field)=>field.type === (0, $eTBmS.FIELD_TYPES).INSIGHTS;
const $288507b462193d29$export$ed6509e3892c1e57 = (value)=>Math.round(value * 10) / 10;

});



parcelRegister("8n006", function(module, exports) {

$parcel$export(module.exports, "issueKeyMapping", () => $e95790558ff876d5$export$c0cb15172e1e917a);

var $n5UdS = parcelRequire("n5UdS");

var $5UhJY = parcelRequire("5UhJY");

var $iG19c = parcelRequire("iG19c");

var $2yCra = parcelRequire("2yCra");
const $e95790558ff876d5$export$c0cb15172e1e917a = (issuesRemote, field)=>{
    const basicStringMapping = (0, $2yCra.stringMapping)(issuesRemote, field);
    return {
        ...(0, $n5UdS.jiraIssueKeyMapping)(issuesRemote, field),
        setMutable: basicStringMapping.setMutable,
        setImmutable: basicStringMapping.setImmutable,
        remove: basicStringMapping.remove,
        modifyImmutableIfMultiValueField: basicStringMapping.modifyImmutableIfMultiValueField,
        comparator: (a, b, direction)=>{
            const extractKeyNumPart = (key)=>key !== undefined ? +key.substring(key.indexOf('-') + 1) : undefined;
            return (0, $5UhJY.numberComparator)(extractKeyNumPart(a), extractKeyNumPart(b), direction);
        },
        valueAccessor: basicStringMapping.valueAccessor,
        valueAccessorToExport: basicStringMapping.valueAccessorToExport,
        getAllValues: basicStringMapping.getAllValues,
        getGroupIdentities: basicStringMapping.getGroupIdentities,
        getGroupIdentitiesSelector: basicStringMapping.getGroupIdentitiesSelector,
        allowEmptyGroup: false,
        getLabel: (groupIdentity, value)=>value,
        getFilter: (filter)=>{
            if (filter.type === 'TEXT') {
                const filterFunction = (0, $iG19c.createDisjunctTextChunkFilter)(filter);
                if (filterFunction !== undefined) return {
                    filterId: filter.localId,
                    filterFunction: filterFunction,
                    disjunctionIdentifier: 'TEXT'
                };
            }
            return undefined;
        }
    };
};

});
parcelRegister("n5UdS", function(module, exports) {

$parcel$export(module.exports, "jiraIssueKeyMapping", () => $acb20e0a791ddbf6$export$d42a003d96cd540f);

var $8JqDY = parcelRequire("8JqDY");

var $lCenk = parcelRequire("lCenk");
const $acb20e0a791ddbf6$export$d42a003d96cd540f = (issuesRemote, field)=>{
    const baseMapping = (0, $lCenk.jiraStringMapping)(issuesRemote, field);
    return {
        field: field,
        getValueFromJiraIssue: (issue)=>issue.key,
        getFieldValueForJiraUpdate: baseMapping.getFieldValueForJiraUpdate,
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: false,
        ...(0, $8JqDY.noopJiraUpdateService)
    };
};

});


parcelRegister("4bgQz", function(module, exports) {

$parcel$export(module.exports, "issueTypeMapping", () => $f5185661a1f50a45$export$694c3332d290c1f3);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $d3vFW = parcelRequire("d3vFW");

var $2lKm2 = parcelRequire("2lKm2");

var $5UhJY = parcelRequire("5UhJY");

var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $f5185661a1f50a45$export$694c3332d290c1f3 = (issuesRemote, field)=>({
        ...(0, $2lKm2.jiraIssueTypeMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.issueType, [
                field.key,
                issueId
            ], value),
        setImmutable: (maps, issueId, value)=>{
            if (maps.issueType[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.issueType[field.key][issueId], value)) return maps;
            return {
                ...maps,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                issueType: {
                    ...maps.issueType,
                    [field.key]: {
                        ...maps.issueType[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'issueType'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.stringComparator)(a.name, b.name, direction)),
        valueAccessor: (state, props, issueId)=>state.properties.issueType[field.key] !== undefined ? state.properties.issueType[field.key][issueId] : undefined,
        valueAccessorToExport: (state, props, issueId)=>state.properties.issueType[field.key] !== undefined && state.properties.issueType[field.key][issueId] ? `${state.properties.issueType[field.key][issueId].name}` : '',
        getAllValues: (state)=>state.properties.issueType[field.key] ? state.properties.issueType[field.key] : {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.issueType[fieldKey], (ids, issueType)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: issueType !== undefined && issueType[issueId] !== undefined ? [
                            {
                                groupIdentity: issueType[issueId].name,
                                value: issueType[issueId]
                            }
                        ] : []
                    }), {})),
        getGroupIdentities: (state, props, issueId)=>state.properties.issueType[field.key] !== undefined && state.properties.issueType[field.key][issueId] !== undefined ? [
                {
                    groupIdentity: state.properties.issueType[field.key][issueId].name,
                    value: state.properties.issueType[field.key][issueId]
                }
            ] : [],
        allowEmptyGroup: false,
        getLabel: (groupIdentity, value)=>value?.name,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueIntersectionFilter = (0, $iG19c.createStringValueIntersectionFilter)(filter);
                if (stringValueIntersectionFilter === undefined) return undefined;
                return (value, store, props, localIssueId)=>{
                    return stringValueIntersectionFilter(value ? [
                        value.name
                    ] : undefined, store, props, localIssueId);
                };
            }
            return undefined;
        }
    });

});
parcelRegister("2lKm2", function(module, exports) {

$parcel$export(module.exports, "jiraIssueTypeMapping", () => $216625ac18cf6681$export$99173018cd4621b4);

var $7jTnu = parcelRequire("7jTnu");

var $8JqDY = parcelRequire("8JqDY");
const $216625ac18cf6681$export$99173018cd4621b4 = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key],
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        getFieldValueForJiraBulkUpdate: ({ id: id })=>({
                issueType: {
                    id: field.key,
                    issueTypeId: id
                }
            }),
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: (0, $7jTnu.fg)('jpd-issue-type-in-fields-bulk-update'),
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    });

});


parcelRegister("O0bZK", function(module, exports) {

$parcel$export(module.exports, "labelsMapping", () => $c6bd97abab550e56$export$9e107f393273ce55);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $d3vFW = parcelRequire("d3vFW");

var $2Ejzu = parcelRequire("2Ejzu");

var $lTW4M = parcelRequire("lTW4M");

var $5UhJY = parcelRequire("5UhJY");


var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $c6bd97abab550e56$export$9e107f393273ce55 = (issuesRemote, field)=>{
    const valueAccessor = (state, props, issueId)=>{
        const labelsMap = state.properties.stringList[field.key];
        // normal and published views use different search endpoints, that return different labels order,
        // to have same order and sorting in both views, we sort labels on the FE
        return labelsMap && [
            ...labelsMap[issueId] ?? []
        ].sort();
    };
    const valueAccessorToExport = (state, props, issueId)=>valueAccessor(state, props, issueId)?.join((0, $f62adc0d5402ab46$export$187b08d552477205)) || '';
    return {
        field: // @ts-expect-error - TS2783 - 'field' is specified more than once, so this usage will be overwritten.
        field,
        ...(0, $lTW4M.jiraLabelsMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps, [
                'stringList',
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: LocalIssueId, value?: string[]) => { stringList: { [x: string]: Record<string, string[]> | { [x: string]: string[] | undefined; }; }; number: PropertyMap<number>; string: PropertyMap<...>; ... 15 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: string[] | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.stringList[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.stringList[field.key][issueId], value)) return maps;
            return {
                ...maps,
                stringList: {
                    ...maps.stringList,
                    [field.key]: {
                        ...maps.stringList[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'stringList'),
        modifyImmutableIfMultiValueField: (maps, issueId, addValues, removeValues = [])=>{
            if (!addValues || addValues.length === 0) return maps;
            const oldValues = (maps.stringList[field.key] || {})[issueId] || [];
            const newValues = oldValues.filter((oldValue)=>!removeValues.includes(oldValue)).concat(addValues.filter((newValue)=>oldValues.findIndex((oldValue)=>oldValue === newValue) < 0));
            return {
                ...maps,
                stringList: {
                    ...maps.stringList,
                    [field.key]: {
                        ...maps.stringList[field.key],
                        [issueId]: newValues
                    }
                }
            };
        },
        comparator: (0, $5UhJY.safeStringListComparator),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>{
            if (state.properties.stringList[field.key] !== undefined) return state.properties.stringList[field.key];
            return {};
        },
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.stringList[fieldKey], (ids, stringList)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: stringList !== undefined && stringList[issueId] !== undefined ? stringList[issueId].map((label)=>({
                                groupIdentity: label,
                                value: [
                                    label
                                ]
                            })) : []
                    }), {})),
        getGroupIdentities: (state, props, issueId)=>{
            const value = state.properties.stringList[field.key] && state.properties.stringList[field.key][issueId];
            return value !== undefined ? value.map((label)=>({
                    groupIdentity: label,
                    value: [
                        label
                    ]
                })) : [];
        },
        getRollupOperations: ()=>[
                (0, $2Ejzu.COUNT_ROLLUP),
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP)
            ],
        allowEmptyGroup: true,
        getLabel: (groupIdentity)=>groupIdentity,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) return (0, $iG19c.createStringValueIntersectionFilter)(filter);
            return undefined;
        }
    };
};

});
parcelRegister("lTW4M", function(module, exports) {

$parcel$export(module.exports, "jiraLabelsMapping", () => $fa6c0afa7404c8e1$export$f9e386d9ed639961);

var $8JqDY = parcelRequire("8JqDY");

const $fa6c0afa7404c8e1$export$f9e386d9ed639961 = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] ?? undefined,
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        getFieldValueForJiraBulkUpdate: (value)=>{
            const labels = value.map((label)=>({
                    name: label
                }));
            return {
                [(0, $a5b1a7a0b618efd3$export$79b91d4669dcadcb)]: {
                    fieldId: field.key,
                    labels: labels,
                    bulkEditMultiSelectFieldOption: labels.length > 0 ? 'REPLACE' : 'REMOVE_ALL'
                }
            };
        },
        isMultiValueField: true,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    });

});


parcelRegister("86Qd4", function(module, exports) {

$parcel$export(module.exports, "linkedIssuesProgressMapping", () => $7e1fc1f942fa5f2b$export$a05613267bee9838);

var $3u8vk = parcelRequire("3u8vk");

var $nFHtT = parcelRequire("nFHtT");

var $8m4OM = parcelRequire("8m4OM");

var $7jTnu = parcelRequire("7jTnu");

var $53OVi = parcelRequire("53OVi");

var $5UhJY = parcelRequire("5UhJY");


var $eO7G9 = parcelRequire("eO7G9");

var $cdpMB = parcelRequire("cdpMB");
const $7e1fc1f942fa5f2b$export$96988177debb23e0 = (0, $5UhJY.nullSafeComparator)((progress1, progress2, direction)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const categoryKeys = [
        (0, $3u8vk.DONE),
        (0, $3u8vk.IN_PROGRESS),
        (0, $3u8vk.TODO)
    ];
    for (const key of categoryKeys){
        const percentage1 = progress1.total > 0 ? (progress1.distribution[key] || 0) / progress1.total : 0;
        const percentage2 = progress2.total > 0 ? (progress2.distribution[key] || 0) / progress2.total : 0;
        if (percentage1 - percentage2 !== 0) return (percentage1 - percentage2) * (0, $5UhJY.factor)(direction);
    }
    return 0;
});
const $7e1fc1f942fa5f2b$export$a05613267bee9838 = (field)=>{
    const valueAccessor = (state, _, issueId)=>{
        const linkedDeliveryIssuesExist = (0, $53OVi.createGetLinkedDeliveryIssuesExist)(issueId)(state);
        if (!linkedDeliveryIssuesExist) return undefined;
        const linkedProgress = (0, $53OVi.createGetLinkedProgress)(issueId)(state);
        return linkedProgress;
    };
    const valueAccessorToExport = (state, props, issueId, deliveryValuesExport)=>{
        const { statusCategories: statusCategories, formatMessage: formatMessage, messages: messages } = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        deliveryValuesExport;
        const progress = valueAccessor(state, props, issueId);
        const linkedDeliveryIssuesExist = (0, $53OVi.createGetLinkedDeliveryIssuesExist)(issueId)(state);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const calculationMode = field?.formula?.parameters?.calculationMode;
        if (linkedDeliveryIssuesExist && progress?.total === 0) return formatMessage(messages.unestimated);
        if (!progress || !statusCategories || progress.total === 0) return '';
        // Upon FG cleanup this can be simplified to a tertiary operator
        let tooltipMessage = (0, $7jTnu.fg)('polaris-issue-terminology-refresh') ? messages.deliveryProgressTooltipIssueTermRefresh : messages.deliveryProgressTooltip;
        if (calculationMode === (0, $nFHtT.DELIVERY_CALCULATION_MODE).STORY_POINTS) tooltipMessage = messages.deliveryTooltipStoryPoints;
        const deliveryProgressList = progress.singleStatus && progress.total > 0 ? [
            statusCategories[progress.singleStatus.category]
        ] : [
            statusCategories[0, $3u8vk.DONE],
            statusCategories[0, $3u8vk.IN_PROGRESS],
            statusCategories[0, $3u8vk.TODO]
        ];
        return deliveryProgressList.map(({ key: key, name: name })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            formatMessage(tooltipMessage, {
                count: progress.distribution[key] || 0,
                category: name,
                total: progress.total
            })).join((0, $f62adc0d5402ab46$export$a7c73c90c36f0ba2));
    };
    return {
        ...(0, $eO7G9.defaultMapping),
        field: field,
        comparator: $7e1fc1f942fa5f2b$export$96988177debb23e0,
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getFilter: (filter)=>filter.type === (0, $8m4OM.NUMERIC_FIELD_FILTER) && filter.field === field.key ? (0, $cdpMB.createFilterFunction)(filter.values) : undefined
    };
};

});
parcelRegister("3u8vk", function(module, exports) {

$parcel$export(module.exports, "NO_CATEGORY", () => $cbccc7ca4e1ab8b0$export$485b1216c42d8d4);
$parcel$export(module.exports, "TODO", () => $cbccc7ca4e1ab8b0$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $cbccc7ca4e1ab8b0$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $cbccc7ca4e1ab8b0$export$71efb3495f6084f2);
$parcel$export(module.exports, "toKnownStatusCategoryKey", () => $cbccc7ca4e1ab8b0$export$5c519d441315174d);
$parcel$export(module.exports, "toKnownStatusCategoryMap", () => $cbccc7ca4e1ab8b0$export$f9bb0af4e0bd71de);
const $cbccc7ca4e1ab8b0$export$485b1216c42d8d4 = 'undefined';
const $cbccc7ca4e1ab8b0$export$aa456a5030160740 = 'new';
const $cbccc7ca4e1ab8b0$export$5a9ac66c2785cc13 = 'indeterminate';
const $cbccc7ca4e1ab8b0$export$71efb3495f6084f2 = 'done';
const $cbccc7ca4e1ab8b0$export$5c519d441315174d = (rawCategoryKey)=>{
    switch(rawCategoryKey){
        case $cbccc7ca4e1ab8b0$export$aa456a5030160740:
            return $cbccc7ca4e1ab8b0$export$aa456a5030160740;
        case $cbccc7ca4e1ab8b0$export$5a9ac66c2785cc13:
            return $cbccc7ca4e1ab8b0$export$5a9ac66c2785cc13;
        case $cbccc7ca4e1ab8b0$export$71efb3495f6084f2:
            return $cbccc7ca4e1ab8b0$export$71efb3495f6084f2;
        default:
            return $cbccc7ca4e1ab8b0$export$485b1216c42d8d4;
    }
};
const $cbccc7ca4e1ab8b0$export$f9bb0af4e0bd71de = (categories)=>{
    const unsafeMap = {};
    categories.forEach((category)=>{
        unsafeMap[$cbccc7ca4e1ab8b0$export$5c519d441315174d(category.key)] = category;
    });
    if (!unsafeMap[$cbccc7ca4e1ab8b0$export$aa456a5030160740] || !unsafeMap[$cbccc7ca4e1ab8b0$export$5a9ac66c2785cc13] || !unsafeMap[$cbccc7ca4e1ab8b0$export$71efb3495f6084f2] || !unsafeMap[$cbccc7ca4e1ab8b0$export$485b1216c42d8d4]) return undefined;
    return {
        [$cbccc7ca4e1ab8b0$export$aa456a5030160740]: unsafeMap[$cbccc7ca4e1ab8b0$export$aa456a5030160740],
        [$cbccc7ca4e1ab8b0$export$5a9ac66c2785cc13]: unsafeMap[$cbccc7ca4e1ab8b0$export$5a9ac66c2785cc13],
        [$cbccc7ca4e1ab8b0$export$71efb3495f6084f2]: unsafeMap[$cbccc7ca4e1ab8b0$export$71efb3495f6084f2],
        [$cbccc7ca4e1ab8b0$export$485b1216c42d8d4]: unsafeMap[$cbccc7ca4e1ab8b0$export$485b1216c42d8d4]
    };
};

});

parcelRegister("53OVi", function(module, exports) {

$parcel$export(module.exports, "getAggregatedDeliveryDates", () => $a71338da9dbf6d6a$export$317760609bb47a08);
$parcel$export(module.exports, "getExternalIssueData", () => $a71338da9dbf6d6a$export$55647b4d0179569f);
$parcel$export(module.exports, "createGetLinkedIssueData", () => $a71338da9dbf6d6a$export$ef29eaec720dc5e8);
$parcel$export(module.exports, "createGetLinkedIssuesCount", () => $a71338da9dbf6d6a$export$2ffe0e6424cbc6bc);
$parcel$export(module.exports, "createGetLinkedDeliveryIssuesExist", () => $a71338da9dbf6d6a$export$e5308255c3626d7a);
$parcel$export(module.exports, "createGetLinkedProgress", () => $a71338da9dbf6d6a$export$fada4c8be756fc1e);
$parcel$export(module.exports, "createGetLinkedDeliveryTicketsCount", () => $a71338da9dbf6d6a$export$795bcd13b16a4ca3);
$parcel$export(module.exports, "createGetAggregatedDeliveryDate", () => $a71338da9dbf6d6a$export$7599f9903d652d11);
$parcel$export(module.exports, "getExternalIssueProjects", () => $a71338da9dbf6d6a$export$e16d8962604c7826);

var $ahm5r = parcelRequire("ahm5r");

var $79hL0 = parcelRequire("79hL0");

var $jvwCK = parcelRequire("jvwCK");

var $7jTnu = parcelRequire("7jTnu");

var $emfB5 = parcelRequire("emfB5");

var $3degy = parcelRequire("3degy");
const $a71338da9dbf6d6a$var$EMPTY_LINKED_PROGRESS = {
    total: 0,
    distribution: {}
};
const $a71338da9dbf6d6a$var$getAggregatedDeliveryProgress = (state)=>state.properties.aggregatedDeliveryProgress;
const $a71338da9dbf6d6a$export$317760609bb47a08 = (state)=>state.properties.aggregatedDeliveryDates;
const $a71338da9dbf6d6a$export$55647b4d0179569f = (state)=>state.externalIssueData;
const $a71338da9dbf6d6a$export$5693db381833568a = (state)=>state.properties.linkedDeliveryIssues;
const $a71338da9dbf6d6a$export$f9d1136821a8d6c1 = (state)=>state.properties.issueMetadata;
const $a71338da9dbf6d6a$var$EMPTY = [];
const $a71338da9dbf6d6a$export$ef29eaec720dc5e8 = (id)=>(0, $ahm5r.createSelector)($a71338da9dbf6d6a$export$5693db381833568a, $a71338da9dbf6d6a$export$55647b4d0179569f, (linkedIssues, externalIssueData)=>linkedIssues[id] ? linkedIssues[id].map((linkedIssueId)=>externalIssueData[linkedIssueId]).filter(Boolean) : $a71338da9dbf6d6a$var$EMPTY);
const $a71338da9dbf6d6a$export$2ffe0e6424cbc6bc = (id)=>(0, $ahm5r.createSelector)($a71338da9dbf6d6a$export$f9d1136821a8d6c1, (issueMetadata)=>issueMetadata[id]?.issueLinks.count || 0);
const $a71338da9dbf6d6a$export$e5308255c3626d7a = (id)=>(0, $ahm5r.createSelector)($a71338da9dbf6d6a$var$getAggregatedDeliveryProgress, (aggregatedDeliveryProgress)=>aggregatedDeliveryProgress && aggregatedDeliveryProgress[id] !== undefined);
const $a71338da9dbf6d6a$export$f93885ceb2618c1 = (issueId)=>(0, $ahm5r.createSelector)($a71338da9dbf6d6a$export$5693db381833568a, $a71338da9dbf6d6a$var$getAggregatedDeliveryProgress, (linkedIssuesMap, aggregatedDeliveryProgress)=>{
        if (issueId === undefined || linkedIssuesMap[issueId] === undefined && !(0, $7jTnu.fg)('jpd-use-polaris-issues-search-endpoint-v2')) return $a71338da9dbf6d6a$var$EMPTY_LINKED_PROGRESS;
        if (aggregatedDeliveryProgress && aggregatedDeliveryProgress[issueId]) return (0, $emfB5.issuesProgressFromAggregate)(aggregatedDeliveryProgress[issueId]);
        return (0, $emfB5.issuesProgressFromAggregate)([
            0,
            0,
            0
        ]);
    });
const $a71338da9dbf6d6a$export$fada4c8be756fc1e = (0, $3degy.cacheSelectorCreator)((issueId)=>$a71338da9dbf6d6a$export$f93885ceb2618c1(issueId));
const $a71338da9dbf6d6a$export$795bcd13b16a4ca3 = (id)=>(0, $ahm5r.createSelector)($a71338da9dbf6d6a$export$5693db381833568a, (linkedIssues)=>linkedIssues[id]?.length || 0);
const $a71338da9dbf6d6a$export$bde92a60b76be616 = (issueId)=>(0, $ahm5r.createSelector)($a71338da9dbf6d6a$export$5693db381833568a, $a71338da9dbf6d6a$export$317760609bb47a08, (linkedIssuesMap, aggregatedDeliveryDates)=>{
        if (issueId === undefined || linkedIssuesMap[issueId] === undefined && !(0, $7jTnu.fg)('jpd-use-polaris-issues-search-endpoint-v2')) return undefined;
        if (aggregatedDeliveryDates && aggregatedDeliveryDates[issueId]) return aggregatedDeliveryDates[issueId];
        return undefined;
    });
const $a71338da9dbf6d6a$export$b03200403d9bdd2d = (0, $3degy.cacheSelectorCreator)((issueId)=>$a71338da9dbf6d6a$export$bde92a60b76be616(issueId));
const $a71338da9dbf6d6a$export$7599f9903d652d11 = (issueId, fieldKey, aggregationType)=>(0, $ahm5r.createSelector)($a71338da9dbf6d6a$export$b03200403d9bdd2d(issueId), (aggregatedDeliveryDates)=>{
        if (!aggregatedDeliveryDates) return undefined;
        if (!fieldKey || !aggregationType) return undefined;
        return aggregatedDeliveryDates.find((date)=>date.aggregationType.toLowerCase() === aggregationType?.toLowerCase() && date.fieldKey === fieldKey && date.date);
    });
const $a71338da9dbf6d6a$export$e16d8962604c7826 = (0, $ahm5r.createSelector)($a71338da9dbf6d6a$export$55647b4d0179569f, (externalIssueDataMap)=>{
    const allProjectIds = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))((0, (/*@__PURE__*/$parcel$interopDefault($79hL0)))(externalIssueDataMap, ({ projectId: projectId })=>projectId));
    return allProjectIds.filter(Boolean);
});

});
parcelRegister("emfB5", function(module, exports) {

$parcel$export(module.exports, "issuesProgressFromAggregate", () => $8646069f56411034$export$f719579e6a59fb70);
const $8646069f56411034$export$cccbfff245e1973d = Object.freeze({
    total: 0,
    distribution: {}
});
const $8646069f56411034$var$getSingleStatusFromAggregated = (aggregated)=>{
    if (aggregated[0] + aggregated[1] + aggregated[2] !== 1) return undefined;
    switch(1){
        case aggregated[0]:
            return {
                category: 'new'
            };
        case aggregated[1]:
            return {
                category: 'indeterminate'
            };
        case aggregated[2]:
            return {
                category: 'done'
            };
        default:
            return undefined;
    }
};
const $8646069f56411034$export$f719579e6a59fb70 = (aggregated)=>({
        total: aggregated.reduce((a, b)=>a + b, 0),
        distribution: {
            new: aggregated[0],
            indeterminate: aggregated[1],
            done: aggregated[2]
        },
        singleStatus: $8646069f56411034$var$getSingleStatusFromAggregated(aggregated)
    });

});


parcelRegister("cdpMB", function(module, exports) {

$parcel$export(module.exports, "createFilterFunction", () => $e3df0722adb0c08a$export$5b4da3e2bd753e6);

var $35Lrf = parcelRequire("35Lrf");
const $e3df0722adb0c08a$export$5b4da3e2bd753e6 = (values)=>(value)=>{
        if (value === undefined) return (0, $35Lrf.evaluateNumericFilterValues)(values, 0);
        // if total progress exists but the value is unestimated
        if (value.total === 0) return (0, $35Lrf.evaluateNumericFilterValues)(values, 1);
        return (0, $35Lrf.evaluateNumericFilterValues)(values, value.total);
    };

});
parcelRegister("35Lrf", function(module, exports) {

$parcel$export(module.exports, "createStartAfterNowValue", () => $ff702e97d5ea03b4$export$c7bd75bff7bf15ae);
$parcel$export(module.exports, "createStartBeforeNowValue", () => $ff702e97d5ea03b4$export$416cd558c32810cd);
$parcel$export(module.exports, "createEndAfterNowValue", () => $ff702e97d5ea03b4$export$3b45f92cc727eec1);
$parcel$export(module.exports, "createEndBeforeNowValue", () => $ff702e97d5ea03b4$export$e87b738b0d46ab7f);
$parcel$export(module.exports, "intervalAbsoluteDatesFilter", () => $ff702e97d5ea03b4$export$55000d50a540f0f2);
$parcel$export(module.exports, "intervalRollingDatesFilters", () => $ff702e97d5ea03b4$export$6e791374cbdd7e02);
$parcel$export(module.exports, "intervalEmptyFilter", () => $ff702e97d5ea03b4$export$552c8ea4b5bbd558);
$parcel$export(module.exports, "evaluateNumericFilterValues", () => $ff702e97d5ea03b4$export$f22b9b9fa9247757);

var $8m4OM = parcelRequire("8m4OM");
const $ff702e97d5ea03b4$export$c7bd75bff7bf15ae = (numericValue)=>({
        operator: (0, $8m4OM.START_AFTER_NOW),
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$416cd558c32810cd = (numericValue)=>({
        operator: (0, $8m4OM.START_BEFORE_NOW),
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$3b45f92cc727eec1 = (numericValue)=>({
        operator: (0, $8m4OM.END_AFTER_NOW),
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$e87b738b0d46ab7f = (numericValue)=>({
        operator: (0, $8m4OM.END_BEFORE_NOW),
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$55000d50a540f0f2 = ({ start: start, end: end })=>({
        type: 'ABSOLUTE_DATES',
        start: start,
        end: end
    });
function $ff702e97d5ea03b4$export$6e791374cbdd7e02(arg) {
    return {
        type: 'ROLLING_DATES',
        ...arg
    };
}
const $ff702e97d5ea03b4$export$552c8ea4b5bbd558 = ()=>({
        operator: 'EQ',
        text: null,
        value: null
    });
const $ff702e97d5ea03b4$export$b2dd723c536e906e = (numericValue)=>({
        operator: 'LT',
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$81835e0c73d29a27 = (numericValue)=>({
        operator: 'LTE',
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$4ebfa397b2265f9f = (numericValue)=>({
        operator: 'GT',
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$110f5cf6ad646780 = (numericValue)=>({
        operator: 'GTE',
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$7dcfa2fa19aebdc7 = (numericValue)=>({
        operator: 'EQ',
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$e577e4f410250e08 = (numericValue)=>({
        operator: 'NEQ',
        numericValue: numericValue
    });
const $ff702e97d5ea03b4$export$f22b9b9fa9247757 = (filterValues, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
value)=>filterValues.find(({ operator: operator, numericValue: numericValue })=>{
        switch(operator){
            case 'LTE':
                return !(numericValue === value) && (numericValue === undefined || value === undefined || !(value < numericValue));
            case 'GTE':
                return !(numericValue === value) && (numericValue === undefined || value === undefined || !(value > numericValue));
            case 'LT':
                return numericValue === undefined || value === undefined || !(value < numericValue);
            case 'GT':
                return numericValue === undefined || value === undefined || !(value > numericValue);
            case 'EQ':
                return numericValue !== value;
            case 'NEQ':
                return numericValue === value;
            default:
                return false;
        }
    }) === undefined;

});



parcelRegister("5A071", function(module, exports) {

$parcel$export(module.exports, "linkedDeliveryIssuesStatusMapping", () => $10dfcc3bfddb07f7$export$8693967fa01bfa06);

var $3u8vk = parcelRequire("3u8vk");

var $nFHtT = parcelRequire("nFHtT");

var $8m4OM = parcelRequire("8m4OM");

var $53OVi = parcelRequire("53OVi");

var $5UhJY = parcelRequire("5UhJY");


var $eO7G9 = parcelRequire("eO7G9");

var $dFniz = parcelRequire("dFniz");
const $10dfcc3bfddb07f7$export$8693967fa01bfa06 = (field)=>{
    const valueAccessor = (state, _, issueId)=>state.properties.aggregatedDeliveryProgress[issueId];
    const valueAccessorToExport = (state, props, issueId, deliveryValuesExport)=>{
        const { statusCategories: statusCategories, formatMessage: formatMessage, messages: messages } = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        deliveryValuesExport;
        const progress = valueAccessor(state, props, issueId);
        const linkedDeliveryIssuesExist = (0, $53OVi.createGetLinkedDeliveryIssuesExist)(issueId)(state);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const calculationMode = field?.formula?.parameters?.calculationMode;
        if (!progress || progress.length === 0 || !statusCategories) return '';
        const tooltipMessage = calculationMode === (0, $nFHtT.DELIVERY_CALCULATION_MODE).STORY_POINTS ? messages.deliveryTooltipStoryPoints : messages.deliveryStatusTooltip;
        const categoriesNames = [
            statusCategories[0, $3u8vk.TODO].name,
            statusCategories[0, $3u8vk.IN_PROGRESS].name,
            statusCategories[0, $3u8vk.DONE].name
        ];
        let totalIssues = 0;
        const multipleStatus = progress.map((count, index)=>{
            totalIssues += count;
            return {
                name: categoriesNames[index],
                count: count
            };
        });
        if (linkedDeliveryIssuesExist && totalIssues === 0) return formatMessage(messages.unestimated);
        if (totalIssues === 0) return '';
        const singleStatus = multipleStatus.find(({ count: count })=>count === 1);
        if (singleStatus && totalIssues === 1) // This will create a formatted messages for single tickets
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return formatMessage(tooltipMessage, {
            count: singleStatus.count,
            category: singleStatus.name,
            total: 1
        });
        return multipleStatus.map(({ name: name, count: count })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            formatMessage(tooltipMessage, {
                count: count,
                category: name,
                total: totalIssues
            })).join((0, $f62adc0d5402ab46$export$a7c73c90c36f0ba2));
    };
    return {
        ...(0, $eO7G9.defaultMapping),
        field: field,
        comparator: (0, $5UhJY.statusCategoryAggregateComparator),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getFilter: (filter)=>filter.type === (0, $8m4OM.NUMERIC_FIELD_FILTER) && filter.field === field.key ? (0, $dFniz.createFilterFunction)(filter.values) : undefined
    };
};

});
parcelRegister("dFniz", function(module, exports) {

$parcel$export(module.exports, "createFilterFunction", () => $3f4c1151b999c9fe$export$5b4da3e2bd753e6);

var $35Lrf = parcelRequire("35Lrf");
const $3f4c1151b999c9fe$export$5b4da3e2bd753e6 = (values)=>(value)=>{
        if (value === undefined) return (0, $35Lrf.evaluateNumericFilterValues)(values, 0);
        const totalLinkedTickets = value.reduce((a, b)=>a + b, 0);
        // if value exists but unestimated
        if (totalLinkedTickets === 0) return (0, $35Lrf.evaluateNumericFilterValues)(values, 1);
        return (0, $35Lrf.evaluateNumericFilterValues)(values, totalLinkedTickets);
    };

});


parcelRegister("cCH8F", function(module, exports) {

$parcel$export(module.exports, "numDataPointsMapping", () => $db626d818047192b$export$43c791fa4fbb03e);

var $KSas2 = parcelRequire("KSas2");

var $dCU5j = parcelRequire("dCU5j");

var $jUVzX = parcelRequire("jUVzX");

var $8m4OM = parcelRequire("8m4OM");

var $2UXb1 = parcelRequire("2UXb1");

var $dNCRE = parcelRequire("dNCRE");
const $db626d818047192b$export$43c791fa4fbb03e = (issuesRemote, field)=>{
    const numberMappings = (0, $dNCRE.numberMapping)(issuesRemote, field);
    return {
        ...numberMappings,
        getFilter: (filter)=>{
            if (filter.type === 'INTERVAL' && filter.field === field.key) {
                const filterFunctions = filter.values.map((0, $2UXb1.createDateFilterFunction)((0, $8m4OM.DAY)));
                return (value, state, props, localIssueId)=>{
                    if (!filterFunctions.length) return true;
                    const dates = state.dynamicProperties.dateValue[field.key](localIssueId)?.(state, props);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($KSas2)))(filterFunctions, (filterFunction)=>(0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(dates, (date)=>filterFunction(date, state, props, localIssueId)));
                };
            }
            return (value, state, props, localIssueId)=>{
                const filterFunc = numberMappings.getFilter(filter);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(filterFunc)) {
                    let valueInternal = value;
                    if (value === 0 && filter.type === 'NUMBER' && filter.values?.length && filter.values[0].operator === 'EQ') valueInternal = undefined; // POL-5290 Keep behavior for empty filter
                    return filterFunc(valueInternal, state, props, localIssueId);
                }
                return true;
            };
        }
    };
};

});

parcelRegister("3MqVY", function(module, exports) {

$parcel$export(module.exports, "optionsMapping", () => $244b0fa9f286cb64$export$cddddec9dbe3981c);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $9g7yh = parcelRequire("9g7yh");

var $d3vFW = parcelRequire("d3vFW");

var $2Ejzu = parcelRequire("2Ejzu");

var $5zHFN = parcelRequire("5zHFN");

var $a6Yft = parcelRequire("a6Yft");

var $5UhJY = parcelRequire("5UhJY");


var $iG19c = parcelRequire("iG19c");

var $dhag4 = parcelRequire("dhag4");

var $eQ9dE = parcelRequire("eQ9dE");
const $244b0fa9f286cb64$export$cddddec9dbe3981c = (issuesRemote, field)=>{
    const optionsById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(field.options, ({ jiraOptionId: jiraOptionId })=>jiraOptionId);
    const valueAccessor = (state, props, issueId)=>{
        return state.properties.multiSelect[field.key]?.[issueId] || [];
    };
    const valueAccessorToExport = (state, props, issueId, options)=>{
        const value = valueAccessor(state, props, issueId);
        const selectedList = value ? value.map((selection)=>selection.id) : undefined;
        return selectedList ? options.filter((opt)=>selectedList.includes(opt.jiraOptionId)).map((opt)=>opt.value).join((0, $f62adc0d5402ab46$export$187b08d552477205)) : '';
    };
    return {
        ...(0, $a6Yft.jiraOptionsMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.multiSelect, [
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: LocalIssueId, value?: IssueOptionProperty[]) => { multiSelect: { [x: string]: Record<string, IssueOptionProperty[]> | { [x: string]: IssueOptionProperty[] | undefined; }; }; ... 17 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: IssueOptionProperty[] | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.multiSelect[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.multiSelect[field.key][issueId], value)) return maps;
            return {
                ...maps,
                multiSelect: {
                    ...maps.multiSelect,
                    [field.key]: {
                        ...maps.multiSelect[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'multiSelect'),
        modifyImmutableIfMultiValueField: (maps, issueId, addValues, removeValues = [])=>{
            const oldValues = (maps.multiSelect[field.key] || {})[issueId] || [];
            const newValues = oldValues.filter((oldValue)=>removeValues.findIndex((removeValue)=>oldValue.id === removeValue.id) < 0).concat((addValues || []).filter((newValue)=>oldValues.findIndex((oldValue)=>oldValue.id === newValue.id) < 0));
            if ((0, $5zHFN.isShallowEqual)(newValues, oldValues)) return maps;
            return {
                ...maps,
                multiSelect: {
                    ...maps.multiSelect,
                    [field.key]: {
                        ...maps.multiSelect[field.key],
                        [issueId]: newValues
                    }
                }
            };
        },
        comparator: (0, $5UhJY.createCombinedComparator)([
            (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.weightedListComparator)(a.map((optionProperty)=>(0, $dhag4.getOptionWeight)(field, optionProperty)), b.map((optionProperty)=>(0, $dhag4.getOptionWeight)(field, optionProperty)), direction)),
            (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.numberListComparator)(a.map((optionProperty)=>(0, $dhag4.getOptionIndex)(field, optionProperty)), b.map((optionProperty)=>(0, $dhag4.getOptionIndex)(field, optionProperty)), direction))
        ]),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.multiSelect[field.key] ?? {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.multiSelect[fieldKey], (ids, multiSelect)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: multiSelect?.[issueId]?.map((value)=>({
                                groupIdentity: value.id,
                                value: [
                                    value
                                ]
                            })) ?? []
                    }), {})),
        getGroupIdentities: (state, _, issueId)=>state.properties.multiSelect[field.key]?.[issueId]?.map((value)=>({
                    groupIdentity: value.id,
                    value: [
                        value
                    ]
                })) ?? [],
        getRollupOperations: ()=>{
            const isWeightedField = field.options?.some(({ weight: weight })=>weight !== 1);
            return isWeightedField ? [
                (0, $2Ejzu.AVG_ROLLUP),
                (0, $2Ejzu.MEDIAN_ROLLUP),
                (0, $2Ejzu.SUM_ROLLUP)
            ] : [
                (0, $2Ejzu.COUNT_ROLLUP),
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP)
            ];
        },
        allowEmptyGroup: true,
        getLabel: (groupIdentity)=>optionsById[groupIdentity]?.value,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueIntersectionFilter = (0, $iG19c.createStringValueIntersectionFilter)(filter);
                if (stringValueIntersectionFilter === undefined) return undefined;
                return (value, store, props, localIssueId)=>stringValueIntersectionFilter(value?.map(({ id: id })=>id), store, props, localIssueId);
            }
            return undefined;
        },
        getWeight: (groupIdentity)=>optionsById[groupIdentity]?.weight
    };
};

});
parcelRegister("a6Yft", function(module, exports) {

$parcel$export(module.exports, "jiraOptionsMapping", () => $d02e1276615e9007$export$2f3cfe9894447b23);

var $exWdq = parcelRequire("exWdq");

var $9g7yh = parcelRequire("9g7yh");

var $8JqDY = parcelRequire("8JqDY");

const $d02e1276615e9007$export$2f3cfe9894447b23 = (issuesRemote, field)=>{
    const optionsById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(field.options, ({ jiraOptionId: jiraOptionId })=>jiraOptionId);
    return {
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] ? issue.fields[field.key].map(({ id: id })=>({
                    id: id
                })).filter(({ id: id })=>(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(optionsById, id)) : undefined,
        getFieldValueForJiraUpdate: (value)=>{
            if (value === undefined) return null;
            return value.map((item)=>({
                    ...item,
                    value: optionsById[item.id]?.value
                }));
        },
        getFieldValueForJiraBulkUpdate: (value)=>{
            const options = [];
            value.forEach((option)=>{
                const optionId = optionsById[option.id].jiraOptionId;
                if (optionId) options.push({
                    optionId: optionId
                });
            });
            return {
                [(0, $a5b1a7a0b618efd3$export$8efc9eeb05d66b6)]: {
                    fieldId: field.key,
                    options: options
                }
            };
        },
        isMultiValueField: true,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    };
};

});


parcelRegister("9f4hf", function(module, exports) {

$parcel$export(module.exports, "playMapping", () => $02a58c8e379279d4$export$1c2aed32fd4f2e21);

var $ahm5r = parcelRequire("ahm5r");

var $12DRg = parcelRequire("12DRg");

var $9pL9Y = parcelRequire("9pL9Y");

var $8JqDY = parcelRequire("8JqDY");

var $5UhJY = parcelRequire("5UhJY");
const $02a58c8e379279d4$export$1c2aed32fd4f2e21 = (issuesRemote, field)=>{
    const valueAccessor = (state, props, issueId)=>{
        const numberDynamicProperties = state.dynamicProperties.numberValue;
        if (numberDynamicProperties[field.key] !== undefined) {
            const val = numberDynamicProperties[field.key](issueId)?.(state, props);
            return val;
        }
        return undefined;
    };
    const valueAccessorToExport = (state, props, issueId)=>`${valueAccessor(state, props, issueId) || ''}`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const EMPTY = {};
    const getAllValuesWithoutUndefined = (0, $ahm5r.createSelector)((state, props)=>state.dynamicProperties.numberValues[field.key](state, props), (values)=>(0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(values, (value)=>value !== undefined));
    return {
        field: field,
        getValueFromJiraIssue: ()=>undefined,
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        setMutable: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        setImmutable: (propertyMaps)=>propertyMaps,
        remove: (propertyMaps)=>propertyMaps,
        modifyImmutableIfMultiValueField: (propertyMaps)=>propertyMaps,
        comparator: (0, $5UhJY.numberComparator),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state, props)=>{
            if (state.dynamicProperties.numberValues[field.key] === undefined) return EMPTY;
            return getAllValuesWithoutUndefined(state, props);
        },
        getGroupIdentitiesSelector: (_fieldKey, _issueIdsSelector)=>()=>({}),
        getGroupIdentities: ()=>[],
        allowEmptyGroup: false,
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: false,
        getLabel: ()=>undefined,
        getFilter: ()=>undefined,
        ...(0, $8JqDY.noopJiraUpdateService)
    };
};

});

parcelRegister("2Rap6", function(module, exports) {

$parcel$export(module.exports, "projectMapping", () => $243096cb257047d6$export$7bd186a6c665f50b);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $jFHCE = parcelRequire("jFHCE");

var $d3vFW = parcelRequire("d3vFW");

var $hn2h1 = parcelRequire("hn2h1");

var $5UhJY = parcelRequire("5UhJY");

var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $243096cb257047d6$export$7bd186a6c665f50b = (field)=>{
    const valueAccessor = (state, props, issueId)=>state.properties.projects[field.key] !== undefined ? state.properties.projects[field.key][issueId] : undefined;
    const valueAccessorToExport = (state, props, issueId)=>{
        const project = valueAccessor(state, props, issueId);
        if (!project) return '';
        return project.key;
    };
    return {
        ...(0, $hn2h1.jiraProjectMapping)(field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.projects, [
                field.key,
                issueId
            ], value),
        setImmutable: (maps, issueId, value)=>{
            if (maps.projects[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.projects[field.key][issueId], value)) return maps;
            if (value === undefined) return {
                ...maps,
                projects: {
                    ...maps.projects,
                    [field.key]: {
                        ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(maps.projects[field.key], [
                            issueId
                        ])
                    }
                }
            };
            return {
                ...maps,
                projects: {
                    ...maps.projects,
                    [field.key]: {
                        ...maps.projects[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'projects'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.stringComparator)(a.name, b.name, direction)),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.projects[field.key] ? state.properties.projects[field.key] : {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.projects[fieldKey], (ids, projects)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: projects !== undefined && projects[issueId] !== undefined ? [
                            {
                                groupIdentity: projects[issueId].id,
                                value: projects[issueId]
                            }
                        ] : []
                    }), {})),
        getGroupIdentities: (state, props, issueId)=>state.properties.projects[field.key] !== undefined && state.properties.projects[field.key][issueId] !== undefined ? [
                {
                    groupIdentity: state.properties.projects[field.key][issueId].id,
                    value: state.properties.projects[field.key][issueId]
                }
            ] : [],
        allowEmptyGroup: false,
        getLabel: (groupIdentity, value)=>value?.name,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueContainsFilter = (0, $iG19c.createStringValueContainsFilter)(filter);
                if (stringValueContainsFilter === undefined) return undefined;
                return (value, state, props, localIssueId)=>stringValueContainsFilter(value?.id, state, props, localIssueId);
            }
            return undefined;
        }
    };
};

});
parcelRegister("hn2h1", function(module, exports) {

$parcel$export(module.exports, "jiraProjectMapping", () => $9e59122ab75c4769$export$68bd93c861e5648d);

var $8JqDY = parcelRequire("8JqDY");
const $9e59122ab75c4769$export$68bd93c861e5648d = (field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] ?? undefined,
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: false,
        ...(0, $8JqDY.noopJiraUpdateService)
    });

});


parcelRegister("jvW2K", function(module, exports) {

$parcel$export(module.exports, "reactionsMapping", () => $552dc04dbd5f2ef5$export$5d7b209ad0a78220);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $12DRg = parcelRequire("12DRg");

var $5zHFN = parcelRequire("5zHFN");

var $5UhJY = parcelRequire("5UhJY");


var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $552dc04dbd5f2ef5$export$5d7b209ad0a78220 = (issuesRemote, field)=>{
    const valueAccessor = (state, props, issueId)=>state.properties.reactions[field.key] !== undefined ? state.properties.reactions[field.key][issueId] : undefined;
    const valueAccessorToExport = (state, props, issueId)=>{
        const reactions = valueAccessor(state, props, issueId)?.map(({ id: id })=>id) || [];
        return reactions.join((0, $f62adc0d5402ab46$export$187b08d552477205));
    };
    return {
        field: field,
        setMutable: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: LocalIssueId, value?: IssueOptionProperty[]) => { multiSelect: { [x: string]: Record<string, IssueOptionProperty[]> | { [x: string]: IssueOptionProperty[] | undefined; }; }; ... 17 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: IssueOptionProperty[] | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.reactions[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.reactions[field.key][issueId], value)) return maps;
            return {
                ...maps,
                reactions: {
                    ...maps.reactions,
                    [field.key]: {
                        ...maps.reactions[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'reactions'),
        modifyImmutableIfMultiValueField: (maps, issueId, addValues, removeValues = [])=>{
            const oldValues = (maps.reactions[field.key] || {})[issueId] || [];
            const newValues = oldValues.filter((oldValue)=>removeValues.findIndex((removeValue)=>oldValue.id === removeValue.id) < 0).concat((addValues || []).filter((newValue)=>oldValues.findIndex((oldValue)=>oldValue.id === newValue.id) < 0));
            if ((0, $5zHFN.isShallowEqual)(newValues, oldValues)) return maps;
            return {
                ...maps,
                reactions: {
                    ...maps.reactions,
                    [field.key]: {
                        ...maps.reactions[field.key],
                        [issueId]: newValues
                    }
                }
            };
        },
        comparator: (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.numberComparator)(a.reduce((sum, reaction)=>sum + reaction.count, 0), b.reduce((sum, reaction)=>sum + reaction.count, 0), direction)),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.reactions[field.key] ? state.properties.reactions[field.key] : {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.reactions[fieldKey], (ids, reactions)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: reactions !== undefined && reactions[issueId] !== undefined ? reactions[issueId].map((value)=>({
                                groupIdentity: value.id,
                                value: [
                                    value
                                ]
                            })) : []
                    }), {})),
        getGroupIdentities: (state, props, issueId)=>state.properties.reactions[field.key] !== undefined && state.properties.reactions[field.key][issueId] !== undefined ? state.properties.reactions[field.key][issueId].map((value)=>({
                    groupIdentity: value.id,
                    value: [
                        value
                    ]
                })) : [],
        allowEmptyGroup: true,
        getValueFromJiraIssue: ()=>undefined,
        getLabel: ()=>undefined,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueIntersectionFilter = (0, $iG19c.createStringValueIntersectionFilter)(filter);
                if (stringValueIntersectionFilter === undefined) return undefined;
                return (value, state, props, localIssueId)=>stringValueIntersectionFilter(value?.map(({ id: id })=>id), state, props, localIssueId);
            }
            return undefined;
        }
    };
};

});

parcelRegister("fF3ZV", function(module, exports) {

$parcel$export(module.exports, "statusMapping", () => $65c431e1b04cd4b4$export$8246dbc49caec39e);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $d3vFW = parcelRequire("d3vFW");

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");

var $fGI3K = parcelRequire("fGI3K");

var $5UhJY = parcelRequire("5UhJY");

var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $65c431e1b04cd4b4$var$getStatusList = (valuesObject)=>Object.values(valuesObject);
const $65c431e1b04cd4b4$var$getStatusListMemoized = (0, $LFmXM.default)($65c431e1b04cd4b4$var$getStatusList);
const $65c431e1b04cd4b4$var$getSimilarStatusIdsByStatusId = (values, comparator)=>{
    const statusesById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(values, 'id');
    return (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(statusesById, (statusA)=>values.filter((statusB)=>comparator(statusA, statusB, 'ASC') === 0).map(({ id: id })=>id));
};
const $65c431e1b04cd4b4$var$getSimilarStatusIdsByStatusIdMemoized = (0, $LFmXM.default)($65c431e1b04cd4b4$var$getSimilarStatusIdsByStatusId);
const $65c431e1b04cd4b4$export$8246dbc49caec39e = (issuesRemote, field)=>{
    const valueAccessor = (state, props, issueId)=>state.properties.status[field.key] !== undefined ? state.properties.status[field.key][issueId] : undefined;
    const valueAccessorToExport = (state, props, issueId)=>valueAccessor(state, props, issueId)?.name || '';
    const getAllValues = (state)=>state.properties.status[field.key] ? state.properties.status[field.key] : {};
    const comparator = (0, $5UhJY.nullSafeComparator)((a, b, direction)=>{
        // inverse order on key results in correct category order
        const category = (0, $5UhJY.stringComparator)(b.statusCategory.key, a.statusCategory.key, direction);
        if (category !== 0) return category;
        return (0, $5UhJY.stringComparator)(a.name, b.name, direction);
    });
    return {
        ...(0, $fGI3K.jiraStatusMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.status, [
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: LocalIssueId, value?: IssueStatusProperty) => { status: { [x: string]: Record<string, IssueStatusProperty> | { [x: string]: IssueStatusProperty | undefined; }; }; ... 17 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: IssueStatusProperty | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.status[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.status[field.key][issueId], value)) return maps;
            return {
                ...maps,
                status: {
                    ...maps.status,
                    [field.key]: {
                        ...maps.status[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'status'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: comparator,
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: getAllValues,
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.status[fieldKey], (ids, status)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: status !== undefined && status[issueId] !== undefined ? [
                            {
                                groupIdentity: status[issueId].id,
                                value: status[issueId]
                            }
                        ] : []
                    }), {})),
        getGroupIdentities: (state, props, issueId)=>state.properties.status[field.key] !== undefined && state.properties.status[field.key][issueId] !== undefined ? [
                {
                    groupIdentity: state.properties.status[field.key][issueId].id,
                    value: state.properties.status[field.key][issueId]
                }
            ] : [],
        allowEmptyGroup: false,
        getLabel: (groupIdentity, value)=>value?.name,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueContainsFilter = (0, $iG19c.createStringValueContainsFilter)(filter);
                const stringValuesContainsFilter = (0, $iG19c.createStringValuesContainsFilter)(filter);
                if (stringValueContainsFilter === undefined || stringValuesContainsFilter === undefined) return undefined;
                return (value, state, props, localIssueId)=>{
                    if (props?.isCollectionView) {
                        const allStatuses = $65c431e1b04cd4b4$var$getStatusListMemoized((0, $7jTnu.fg)('jpd-aurora-roadmap-inline-edit') ? props?.statusesById ?? {} : getAllValues(state, props));
                        const similarStatusIdsByStatusId = $65c431e1b04cd4b4$var$getSimilarStatusIdsByStatusIdMemoized(allStatuses, comparator);
                        const similarIds = value?.id ? similarStatusIdsByStatusId[value.id] : undefined;
                        return stringValuesContainsFilter(similarIds, state, props, localIssueId);
                    }
                    return stringValueContainsFilter(value?.id, state, props, localIssueId);
                };
            }
            return undefined;
        }
    };
};

});
parcelRegister("fGI3K", function(module, exports) {

$parcel$export(module.exports, "jiraStatusMapping", () => $23c0f0920c6fbf4d$export$e90e0edf128b19d1);

var $8JqDY = parcelRequire("8JqDY");
const $23c0f0920c6fbf4d$export$e90e0edf128b19d1 = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] ?? undefined,
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: false,
        ...(0, $8JqDY.noopJiraUpdateService)
    });

});


parcelRegister("hWYml", function(module, exports) {

$parcel$export(module.exports, "teamMapping", () => $4e8842ee7509db02$export$15c4b24f42e8fbe2);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $d3vFW = parcelRequire("d3vFW");

var $2Ejzu = parcelRequire("2Ejzu");

var $8m4OM = parcelRequire("8m4OM");

var $cfKZ8 = parcelRequire("cfKZ8");

var $5UhJY = parcelRequire("5UhJY");

var $eQ9dE = parcelRequire("eQ9dE");

var $iG19c = parcelRequire("iG19c");
const $4e8842ee7509db02$export$15c4b24f42e8fbe2 = (issuesRemote, field)=>{
    const valueAccessor = (state, _props, issueId)=>state.properties.team[field.key]?.[issueId];
    const valueAccessorToExport = (state, props, issueId)=>{
        const team = valueAccessor(state, props, issueId);
        return team?.name || '';
    };
    return {
        ...(0, $cfKZ8.jiraTeamMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.team, [
                field.key,
                issueId
            ], value),
        setImmutable: (maps, issueId, value)=>{
            if (maps.team[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.team[field.key][issueId], value)) return maps;
            return {
                ...maps,
                team: {
                    ...maps.team,
                    [field.key]: {
                        ...maps.team[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'team'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.stringComparator)(a?.name, b?.name, direction)),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.team[field.key] ?? {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.team[fieldKey], (issueIds, team)=>issueIds.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: team?.[issueId] ? [
                            {
                                groupIdentity: team[issueId]?.id ?? '',
                                value: team[issueId]
                            }
                        ] : []
                    }), {})),
        getGroupIdentities: (state, _props, issueId)=>state.properties.team[field.key] !== undefined && state.properties.team[field.key][issueId] !== undefined ? [
                {
                    groupIdentity: state.properties.team[field.key][issueId]?.id ?? '',
                    value: state.properties.team[field.key][issueId]
                }
            ] : [],
        getRollupOperations: ()=>[
                (0, $2Ejzu.COUNT_ROLLUP),
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP)
            ],
        allowEmptyGroup: true,
        getLabel: (_groupIdentity, value)=>value?.name ?? '',
        getFilter: (filter)=>{
            if (filter.type === (0, $8m4OM.GENERIC_FIELD_FILTER) && filter.field === field.key) {
                const stringValueContainsFilter = (0, $iG19c.createStringValueContainsFilter)(filter);
                if (stringValueContainsFilter === undefined) return undefined;
                return (value, state, props, localIssueId)=>stringValueContainsFilter(value?.id, state, props, localIssueId);
            }
            return undefined;
        }
    };
};

});
parcelRegister("cfKZ8", function(module, exports) {

$parcel$export(module.exports, "jiraTeamMapping", () => $a9a259c6a546174b$export$16b4e063beb946da);

var $g2g1R = parcelRequire("g2g1R");

var $8JqDY = parcelRequire("8JqDY");

const $a9a259c6a546174b$export$16b4e063beb946da = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>{
            return issue.fields[field.key];
        },
        getFieldValueForJiraUpdate: (value)=>{
            if (!value) return null;
            return (0, $g2g1R.extractId)(value.id);
        },
        getFieldValueForJiraBulkUpdate: (value)=>{
            return {
                [(0, $a5b1a7a0b618efd3$export$352ccc39b0d151be)]: {
                    fieldId: field.key,
                    team: {
                        teamId: value?.id ? (0, $g2g1R.extractId)(value.id) : ''
                    }
                }
            };
        },
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    });

});
parcelRegister("g2g1R", function(module, exports) {

$parcel$export(module.exports, "extractId", () => $5efdb315647ad4fd$export$48729e990f352663);
/**
 * extracts team id from ari
 * the update endpoint expects an id, but we receive an ari when searching for teams
 */ const $5efdb315647ad4fd$export$48729e990f352663 = (teamId)=>teamId?.split('/').pop();

});



parcelRegister("795ti", function(module, exports) {

$parcel$export(module.exports, "userMapping", () => $2aafec1fc0cfb5b2$export$879c54ec9accdd9e);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $d3vFW = parcelRequire("d3vFW");

var $2Ejzu = parcelRequire("2Ejzu");

var $8O1CT = parcelRequire("8O1CT");

var $5UhJY = parcelRequire("5UhJY");

var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $2aafec1fc0cfb5b2$export$879c54ec9accdd9e = (issuesRemote, field)=>{
    const valueAccessor = (state, _props, issueId)=>state.properties.user[field.key] !== undefined ? state.properties.user[field.key][issueId] : undefined;
    const valueAccessorToExport = (state, props, issueId)=>{
        const user = valueAccessor(state, props, issueId);
        return user?.displayName || ''; // '' = Unassigned
    };
    return {
        ...(0, $8O1CT.jiraUserMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.user, [
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: LocalIssueId, value?: IssueUserProperty) => { user: { [x: string]: Record<string, IssueUserProperty> | { [x: string]: IssueUserProperty | undefined; }; }; ... 17 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: IssueUserProperty | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.user[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.user[field.key][issueId], value)) return maps;
            return {
                ...maps,
                user: {
                    ...maps.user,
                    [field.key]: {
                        ...maps.user[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'user'),
        modifyImmutableIfMultiValueField: (maps)=>maps,
        comparator: (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.stringComparator)(a.displayName, b.displayName, direction)),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.user[field.key] ? state.properties.user[field.key] : {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.user[fieldKey], (ids, user)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: user !== undefined && user[issueId] !== undefined ? [
                            {
                                groupIdentity: user[issueId].accountId,
                                value: user[issueId]
                            }
                        ] : []
                    }), {})),
        getGroupIdentities: (state, _props, issueId)=>state.properties.user[field.key] !== undefined && state.properties.user[field.key][issueId] !== undefined ? [
                {
                    groupIdentity: state.properties.user[field.key][issueId].accountId,
                    value: state.properties.user[field.key][issueId]
                }
            ] : [],
        getRollupOperations: ()=>[
                (0, $2Ejzu.COUNT_ROLLUP),
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP)
            ],
        allowEmptyGroup: true,
        getLabel: (_groupIdentity, value)=>value?.displayName,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueContainsFilter = (0, $iG19c.createStringValueContainsFilter)(filter);
                if (stringValueContainsFilter === undefined) return undefined;
                return (value, state, props, localIssueId)=>stringValueContainsFilter(value?.accountId, state, props, localIssueId);
            }
            return undefined;
        }
    };
};

});
parcelRegister("8O1CT", function(module, exports) {

$parcel$export(module.exports, "jiraUserMapping", () => $c1e2ec5b3ec51d53$export$ec59ce6dae4cebd0);

var $4sprp = parcelRequire("4sprp");

var $8JqDY = parcelRequire("8JqDY");

const $c1e2ec5b3ec51d53$export$ec59ce6dae4cebd0 = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>{
            const jiraValue = issue.fields[field.key] ?? undefined;
            if (jiraValue === undefined) return undefined;
            // special handling because single user fields are sometimes handled by jira as collection fields
            // we don't know this unless we actually encounter a user array here. in that case, take the first
            // value
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(jiraValue) && jiraValue.length > 0) return jiraValue[0];
            return jiraValue;
        },
        getFieldValueForJiraUpdate: (value)=>{
            // custom fields can only be people fields, but if the value is restricted to a single user,
            // it shows up here as a User-field
            if (field.key.startsWith('customfield_')) return value !== undefined ? [
                value
            ] : [];
            return value !== undefined ? value : null;
        },
        getFieldValueForJiraBulkUpdate: (value)=>{
            const accountId = value?.accountId;
            return {
                [(0, $a5b1a7a0b618efd3$export$7c1ec18baec3fed)]: {
                    fieldId: field.key,
                    user: accountId ? {
                        accountId: accountId
                    } : null
                }
            };
        },
        isMultiValueField: false,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    });

});


parcelRegister("2hqtf", function(module, exports) {

$parcel$export(module.exports, "usersMapping", () => $a4c7d6605e4fbd2e$export$113ad05b3e7bebd6);

var $ahm5r = parcelRequire("ahm5r");

var $1yBwF = parcelRequire("1yBwF");

var $cSmYj = parcelRequire("cSmYj");

var $d3vFW = parcelRequire("d3vFW");

var $2Ejzu = parcelRequire("2Ejzu");

var $cWQHQ = parcelRequire("cWQHQ");

var $5UhJY = parcelRequire("5UhJY");


var $iG19c = parcelRequire("iG19c");

var $eQ9dE = parcelRequire("eQ9dE");
const $a4c7d6605e4fbd2e$export$113ad05b3e7bebd6 = (issuesRemote, field)=>{
    const valueAccessor = (state, _, issueId)=>state.properties.people[field.key]?.[issueId];
    const valueAccessorToExport = (state, props, issueId)=>{
        const value = valueAccessor(state, props, issueId);
        return value?.map((user)=>user.displayName).join((0, $f62adc0d5402ab46$export$187b08d552477205)) || '';
    };
    return {
        ...(0, $cWQHQ.jiraUsersMapping)(issuesRemote, field),
        setMutable: (maps, issueId, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(maps.people, [
                field.key,
                issueId
            ], value),
        // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '(maps: PropertyMaps, issueId: LocalIssueId, value?: IssueUserProperty[]) => { people: { [x: string]: Record<string, IssueUserProperty[]> | { [x: string]: IssueUserProperty[] | undefined; }; }; ... 17 more ...; commentsMetadata: CommentsMetadataMap; }' is not assignable to type '(arg1: PropertyMaps, arg2: string, arg3: IssueUserProperty[] | undefined) => PropertyMaps'.
        setImmutable: (maps, issueId, value)=>{
            if (maps.people[field.key] && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(maps.people[field.key][issueId], value)) return maps;
            return {
                ...maps,
                people: {
                    ...maps.people,
                    [field.key]: {
                        ...maps.people[field.key],
                        [issueId]: value
                    }
                }
            };
        },
        remove: (maps, issueId)=>(0, $eQ9dE.removePropertyValue)(field.key, maps, issueId, 'people'),
        modifyImmutableIfMultiValueField: (maps, issueId, addValues, removeValues = [])=>{
            if (!addValues || addValues.length === 0) return maps;
            const oldValues = (maps.people[field.key] || {})[issueId] || [];
            const newValues = oldValues.filter((oldValue)=>removeValues.findIndex((removeValue)=>oldValue.accountId === removeValue.accountId) < 0).concat(addValues.filter((newValue)=>oldValues.findIndex((oldValue)=>oldValue.accountId === newValue.accountId) < 0));
            return {
                ...maps,
                people: {
                    ...maps.people,
                    [field.key]: {
                        ...maps.people[field.key],
                        [issueId]: newValues
                    }
                }
            };
        },
        comparator: (0, $5UhJY.nullSafeComparator)((a, b, direction)=>(0, $5UhJY.stringListComparator)(a.map(({ displayName: displayName })=>displayName), b.map(({ displayName: displayName })=>displayName), direction)),
        valueAccessor: valueAccessor,
        valueAccessorToExport: valueAccessorToExport,
        getAllValues: (state)=>state.properties.people[field.key] ? state.properties.people[field.key] : {},
        getGroupIdentitiesSelector: (fieldKey, issueIdsSelector)=>(0, $ahm5r.createSelector)(issueIdsSelector, (state)=>state.properties.people[fieldKey], (ids, people)=>ids.reduce((result, issueId)=>Object.assign(result, {
                        [issueId]: people !== undefined && people[issueId] !== undefined ? people[issueId].map((value)=>({
                                groupIdentity: value.accountId,
                                value: [
                                    value
                                ]
                            })) : []
                    }), {})),
        getGroupIdentities: (state, props, issueId)=>state.properties.people[field.key] !== undefined && state.properties.people[field.key][issueId] !== undefined ? state.properties.people[field.key][issueId].map((value)=>({
                    groupIdentity: value.accountId,
                    value: [
                        value
                    ]
                })) : [],
        getRollupOperations: ()=>[
                (0, $2Ejzu.COUNT_ROLLUP),
                (0, $2Ejzu.EMPTY_ROLLUP),
                (0, $2Ejzu.FILLED_ROLLUP)
            ],
        allowEmptyGroup: true,
        getLabel: (groupIdentity, value)=>(0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(value)?.displayName,
        getFilter: (filter)=>{
            if (filter.type === 'FIELD' && filter.field === field.key) {
                const stringValueIntersectionFilter = (0, $iG19c.createStringValueIntersectionFilter)(filter);
                if (stringValueIntersectionFilter === undefined) return undefined;
                return (value, state, props, localIssueId)=>stringValueIntersectionFilter(value?.map(({ accountId: accountId })=>accountId), state, props, localIssueId);
            }
            return undefined;
        }
    };
};

});
parcelRegister("cWQHQ", function(module, exports) {

$parcel$export(module.exports, "jiraUsersMapping", () => $55da7aa6280bd752$export$28d6cf5b488a38cb);

var $8JqDY = parcelRequire("8JqDY");

const $55da7aa6280bd752$export$28d6cf5b488a38cb = (issuesRemote, field)=>({
        field: field,
        getValueFromJiraIssue: (issue)=>issue.fields[field.key] ?? undefined,
        getFieldValueForJiraUpdate: (value)=>value !== undefined ? value : null,
        getFieldValueForJiraBulkUpdate: (value)=>{
            const users = value?.map(({ accountId: accountId })=>({
                    accountId: accountId
                })) ?? [];
            return {
                [(0, $a5b1a7a0b618efd3$export$7c3ddc4a9b4f0dcf)]: {
                    fieldId: field.key,
                    users: users.length > 0 ? users : null
                }
            };
        },
        isMultiValueField: true,
        isSupportedByIssueUpdateApi: true,
        ...(0, $8JqDY.defaultJiraUpdateService)(issuesRemote, field.key)
    });

});




parcelRegister("gWoBr", function(module, exports) {

$parcel$export(module.exports, "createIssueHook", () => $542f0c6019b036b2$export$b8b7a79731dc3b1d);
$parcel$export(module.exports, "createHigherLevelIssueHook", () => $542f0c6019b036b2$export$68af772baa73fccd);
$parcel$export(module.exports, "createHigherLevelIssueHook2", () => $542f0c6019b036b2$export$73384f3a56d8310);
$parcel$export(module.exports, "createHigherLevelIssueHook3", () => $542f0c6019b036b2$export$95a198927b638cfb);
$parcel$export(module.exports, "createHigherLevelIssueHook4", () => $542f0c6019b036b2$export$edf435b43b3baa91);
$parcel$export(module.exports, "createSelectedIssueHook", () => $542f0c6019b036b2$export$6ad7a72e2d4b82bb);
$parcel$export(module.exports, "createSelectedIssueHook2", () => $542f0c6019b036b2$export$51a57c24c4cd7cf6);

var $3degy = parcelRequire("3degy");

var $4nbzJ = parcelRequire("4nbzJ");

var $4TCfW = parcelRequire("4TCfW");
const $542f0c6019b036b2$export$b8b7a79731dc3b1d = (0, $4nbzJ.createIssueHook);
const $542f0c6019b036b2$export$68af772baa73fccd = (selectorCreator)=>(0, $4nbzJ.createHigherLevelIssueHook)(selectorCreator);
const $542f0c6019b036b2$export$73384f3a56d8310 = (selectorCreator)=>(0, $4nbzJ.createHigherLevelIssueHook)(selectorCreator);
const $542f0c6019b036b2$export$95a198927b638cfb = (selectorCreator)=>(0, $4nbzJ.createHigherLevelIssueHook)(selectorCreator);
const $542f0c6019b036b2$export$edf435b43b3baa91 = (selectorCreator)=>(0, $4nbzJ.createHigherLevelIssueHook)(selectorCreator);
const $542f0c6019b036b2$export$6ad7a72e2d4b82bb = (selectorCreator)=>{
    const memoizedSelectorCreator = (0, $3degy.cacheSelectorCreator)(selectorCreator);
    return (0, $4nbzJ.createHigherLevelIssueHook)((fieldKey)=>(state, props)=>{
            const selectedIssueId = (0, $4TCfW.getSelectedIssueLocalIssueId)(state);
            if (selectedIssueId === undefined) return undefined;
            const selector = memoizedSelectorCreator(fieldKey, selectedIssueId);
            return selector(state, props);
        });
};
const $542f0c6019b036b2$export$51a57c24c4cd7cf6 = (selectorCreator)=>{
    const memoizedSelectorCreator = (0, $3degy.cacheSelectorCreator)(selectorCreator);
    return (0, $4nbzJ.createIssueHook)((state, props)=>{
        const selectedIssueId = (0, $4TCfW.getSelectedIssueLocalIssueId)(state);
        if (selectedIssueId === undefined) return undefined;
        const selector = memoizedSelectorCreator(selectedIssueId);
        return selector(state, props);
    });
};

});
parcelRegister("4nbzJ", function(module, exports) {

$parcel$export(module.exports, "useIssueActions", () => $c0bd9d408dd9e79d$export$24ed4669f1fc8775);
$parcel$export(module.exports, "createIssueHook", () => $c0bd9d408dd9e79d$export$b8b7a79731dc3b1d);
$parcel$export(module.exports, "createHigherLevelIssueHook", () => $c0bd9d408dd9e79d$export$68af772baa73fccd);
$parcel$export(module.exports, "IssuesSweetStateContainer", () => $c0bd9d408dd9e79d$export$b8ac8c2c3d6acfdf);
$parcel$export(module.exports, "IssueIdeaContextHandler", () => $c0bd9d408dd9e79d$export$508c5b9b6e90028f);
$parcel$export(module.exports, "useIssueStore", () => $c0bd9d408dd9e79d$export$443ced5c338ee79);
$parcel$export(module.exports, "SharedViewIssueTypesLoader", () => $c0bd9d408dd9e79d$export$dbb737cbafd0a17d);
$parcel$export(module.exports, "IssuesLoader", () => $c0bd9d408dd9e79d$export$619ecc6604950c74);

var $eJOHy = parcelRequire("eJOHy");

var $7BEaI = parcelRequire("7BEaI");

var $cSmYj = parcelRequire("cSmYj");

var $4c94y = parcelRequire("4c94y");

var $jFHCE = parcelRequire("jFHCE");

var $7jTnu = parcelRequire("7jTnu");

var $ghXpo = parcelRequire("ghXpo");

var $eTBmS = parcelRequire("eTBmS");

var $5zHFN = parcelRequire("5zHFN");

var $cmN5o = parcelRequire("cmN5o");

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $iJq0l = parcelRequire("iJq0l");

var $9h1Bv = parcelRequire("9h1Bv");

var $hQR6K = parcelRequire("hQR6K");

var $hEORc = parcelRequire("hEORc");

var $apXQz = parcelRequire("apXQz");

var $avFSu = parcelRequire("avFSu");

var $4znIY = parcelRequire("4znIY");

var $1jdTF = parcelRequire("1jdTF");

var $9AO22 = parcelRequire("9AO22");

var $jfPj4 = parcelRequire("jfPj4");

var $amUSo = parcelRequire("amUSo");
const $c0bd9d408dd9e79d$export$d0830824dfa9cb3b = (0, $jxALV.createPolarisStore)({
    initialState: {
        ...(0, $amUSo.EMPTY_STATE)
    },
    actions: $9AO22.default,
    name: 'PolarisIssueStore'
});
const $c0bd9d408dd9e79d$var$onUpdateContainer = ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
    const { rankField: rankField, projectId: projectId, issueTypeIds: issueTypeIds, fields: fields = [], polarisIssueLinkType: polarisIssueLinkType, selectedIssue: selectedIssue, singleIdeaVisible: singleIdeaVisible } = props;
    const changedProps = (0, $cmN5o.getChangedProps)(props, getState().prevContainerProps);
    const onlySelectedIssueChanged = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(changedProps, [
        'currentViewSelectedIssueId'
    ]);
    if (changedProps.includes('plays')) {
        // since getChangedProps does a shallow check, 'plays' is added to changedProps even with no actual changes
        // it then causes the contributions in the issue store to be overwritten with the stale data in the project store
        // we still want the code here to execute the first time around as the initial loading takes place in the project store
        const playContributionsChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(props.plays, getState().prevContainerProps?.plays);
        playContributionsChanged && dispatch((0, $9AO22.default).updatePlayContributionsFromProps());
    }
    if (changedProps.includes('insights')) dispatch((0, $9AO22.default).updateInsightsFromProps());
    setState({
        selectedIssue: selectedIssue,
        externalIssueRanking: props.externalIssueRanking
    });
    if (!onlySelectedIssueChanged) dispatch((0, $9AO22.default).resetLastUpdatedIssueIds());
    if (selectedIssue === undefined) dispatch((0, $9AO22.default).clearCreatedProperty());
    if (!getState().meta.fullDeliveryDataInitialized && !singleIdeaVisible && getState().prevContainerProps && getState().prevContainerProps?.singleIdeaVisible) dispatch((0, $9AO22.default).loadDeliveryProgress());
    const newLoadingPropsWithoutFields = {
        rankField: rankField,
        projectId: projectId,
        issueTypeIds: issueTypeIds,
        polarisIssueLinkType: polarisIssueLinkType
    };
    const newFieldKeys = (0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(fields);
    const oldFieldKeys = getState().meta.loadingProps?.fieldKeys || [];
    const oldLoadingPropsWithoutFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(getState().meta.loadingProps, 'fieldKeys');
    if ((0, $5zHFN.isShallowEqual)(oldLoadingPropsWithoutFields, newLoadingPropsWithoutFields) && (0, $5zHFN.isShallowEqual)(oldFieldKeys, newFieldKeys)) {
        setState({
            meta: {
                ...getState().meta,
                loadingProps: {
                    ...newLoadingPropsWithoutFields,
                    fieldKeys: newFieldKeys
                }
            }
        });
        // do nothing, loading props have not changed
        return;
    }
    setState({
        meta: {
            ...getState().meta,
            loadingProps: {
                ...newLoadingPropsWithoutFields,
                fieldKeys: newFieldKeys
            }
        }
    });
    const isInitialized = oldFieldKeys.length > 0;
    const lastCreatedField = isInitialized && newFieldKeys.length > oldFieldKeys.length ? fields[fields.length - 1] : undefined;
    const newCheckboxOrRatingField = lastCreatedField && (lastCreatedField.type === (0, $eTBmS.FIELD_TYPES).CHECKBOX || lastCreatedField.type === (0, $eTBmS.FIELD_TYPES).RATING) ? lastCreatedField : undefined;
    // checkbox and rating fields should be present in the properties
    // after they are created for the card height calculation since
    // a value of undefined is treated like a value of 0
    if (newCheckboxOrRatingField) dispatch((0, $9AO22.default).dispatch((0, $jfPj4.updateCheckboxOrRatingNumberFieldMapping)(newCheckboxOrRatingField)));
    if (!onlySelectedIssueChanged) dispatch((0, $9AO22.default).resetLastUpdatedIssueIds());
    if (props.fields !== undefined && props.fields.length > 0) // create dynamic field selectors. the factory functions are solely based on the available fields, so
    // we can safely create them here, even before the ideas have been loaded
    dispatch((0, $9AO22.default).createDynamicFieldSelectors());
};
const { Container: $c0bd9d408dd9e79d$var$Container, useActions: $c0bd9d408dd9e79d$var$useActions, createHook: $c0bd9d408dd9e79d$var$createHook, createHigherLevelHook: $c0bd9d408dd9e79d$var$createHigherLevelHook } = (0, $YvHeB.createJpdContainer)($c0bd9d408dd9e79d$export$d0830824dfa9cb3b, {
    onUpdate: ()=>$c0bd9d408dd9e79d$var$onUpdateContainer,
    onInit: ()=>$c0bd9d408dd9e79d$var$onUpdateContainer
});
const $c0bd9d408dd9e79d$export$24ed4669f1fc8775 = $c0bd9d408dd9e79d$var$useActions;
const $c0bd9d408dd9e79d$export$b8b7a79731dc3b1d = $c0bd9d408dd9e79d$var$createHook;
const $c0bd9d408dd9e79d$export$68af772baa73fccd = $c0bd9d408dd9e79d$var$createHigherLevelHook;
const $c0bd9d408dd9e79d$export$b8ac8c2c3d6acfdf = $c0bd9d408dd9e79d$var$Container;
const $c0bd9d408dd9e79d$export$508c5b9b6e90028f = ({ context: context })=>{
    const { register: register, unregister: unregister } = context;
    const { updateInsights: updateInsights } = $c0bd9d408dd9e79d$export$24ed4669f1fc8775();
    const listener = (0, $eJOHy.useMemo)(()=>({
            onUpdateInsight: ({ jiraIssueId: jiraIssueId, insights: insights })=>{
                updateInsights(jiraIssueId, insights);
            }
        }), [
        updateInsights
    ]);
    (0, $eJOHy.useEffect)(()=>{
        register(listener);
        return ()=>unregister(listener);
    }, [
        listener,
        register,
        unregister
    ]);
    return null;
};
const $c0bd9d408dd9e79d$export$443ced5c338ee79 = (0, $iJq0l.createHook)($c0bd9d408dd9e79d$export$d0830824dfa9cb3b);
const $c0bd9d408dd9e79d$var$EMPTY_TYPE_PROJECT_MAP = {};
const $c0bd9d408dd9e79d$export$dbb737cbafd0a17d = ()=>{
    const [{ prefechedIssueTypes: prefechedIssueTypes, meta: meta, issueTypeProjectMap: issueTypeProjectMap = $c0bd9d408dd9e79d$var$EMPTY_TYPE_PROJECT_MAP }, { getContainerProps: getContainerProps }] = $c0bd9d408dd9e79d$export$443ced5c338ee79();
    const { populateIssueTypes: populateIssueTypes } = (0, $9h1Bv.useIssueTypesActions)();
    const { projectIds: projectIds } = getContainerProps();
    const { loading: loading } = meta;
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && prefechedIssueTypes && projectIds && projectIds.length === 1) populateIssueTypes({
            issueTypes: prefechedIssueTypes.map((issueType)=>{
                const projectId = issueTypeProjectMap[issueType.id] ?? projectIds[0];
                return {
                    ...issueType,
                    projectId: (0, $7jTnu.fg)('jpd-connections-support-on-published-views') ? String(projectId) : projectIds[0],
                    avatarId: String(issueType.avatarId),
                    operation: {
                        deletable: false,
                        editable: false
                    }
                };
            })
        });
    }, [
        loading,
        populateIssueTypes,
        prefechedIssueTypes,
        projectIds,
        issueTypeProjectMap
    ]);
    return null;
};
const $c0bd9d408dd9e79d$export$619ecc6604950c74 = ()=>{
    const [{ prefechedIssues: prefechedIssues, archivedIssues: archivedIssues, meta: meta }, { loadIssues: loadIssues, initialize: initialize, initializeArchived: initializeArchived, loadArchivedIssues: loadArchivedIssues, getContainerProps: getContainerProps }] = $c0bd9d408dd9e79d$export$443ced5c338ee79();
    const { fields: fields, permissionsLoaded: permissionsLoaded, hasNoProjectPermissions: hasNoProjectPermissions, onIssueLoadingFailed: onIssueLoadingFailed, isSharedView: isSharedView, selectedIssue: selectedIssue, projectId: projectId, containsArchived: containsArchived } = getContainerProps();
    const { initialized: initialized, loading: loading, error: error } = meta;
    const isViewsLoading = (0, $avFSu.useIsViewsLoading)();
    const viewsLoaded = !isSharedView || !isViewsLoading;
    const issueViewLayout = (0, $apXQz.useIssueViewLayout)();
    const ideaIsOpenInFullscreen = selectedIssue && issueViewLayout === undefined;
    const [newlyAddedGlobalFields] = (0, $hEORc.useNewlyAddedGlobalFields)();
    const allViewFields = (0, $4znIY.useAllViewFields)();
    const jiraRankFieldKey = (0, $1jdTF.useJiraRankFieldKey)();
    const { refreshIssues: refreshIssues } = $c0bd9d408dd9e79d$export$24ed4669f1fc8775();
    const { resetNewlyAddedGlobalFields: resetNewlyAddedGlobalFields } = (0, $hQR6K.useFieldActions)();
    const fieldKeys = (0, $eJOHy.useMemo)(()=>fields?.map(({ key: key })=>key), [
        fields
    ]);
    const fieldKeyToAriMapPromise = (0, $ghXpo.useFieldKeyToAriMapAsync)({
        fieldKeys: fieldKeys
    });
    (0, $eJOHy.useMemo)(()=>{
        // triggering the error callback only:
        // - when permissions are loaded
        // - when the user has access to the project
        // otherwise we shallow the error has user is not supposed to call the issue loading anyway.
        // Site admins is a special case are they can access project settings while not having access to the project
        if (error && permissionsLoaded) {
            if (!hasNoProjectPermissions) onIssueLoadingFailed(error);
        }
    }, [
        error,
        permissionsLoaded,
        hasNoProjectPermissions,
        onIssueLoadingFailed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldLoadIssues = isSharedView || !ideaIsOpenInFullscreen;
        if (shouldLoadIssues && !archivedIssues && containsArchived) loadArchivedIssues();
        if (initialized && fields && fields.length && archivedIssues && viewsLoaded) initializeArchived(fieldKeyToAriMapPromise);
        if (initialized) return;
        if (shouldLoadIssues && !prefechedIssues && !loading) loadIssues();
        if (fields && fields.length && prefechedIssues && viewsLoaded) {
            if (!jiraRankFieldKey) return;
            initialize(fieldKeyToAriMapPromise);
        }
    }, [
        containsArchived,
        isSharedView,
        projectId,
        initialized,
        prefechedIssues,
        archivedIssues,
        loading,
        fields,
        viewsLoaded,
        loadIssues,
        loadArchivedIssues,
        initialize,
        initializeArchived,
        ideaIsOpenInFullscreen,
        fieldKeyToAriMapPromise,
        jiraRankFieldKey
    ]);
    // When adding a global field that has been used in the past, we need to refresh issues
    // This is to be able to render the values assigned to those fields
    // Otherwise we'd potentially cause users to override existing data since they'd see an empty field and edit away
    (0, $eJOHy.useEffect)(()=>{
        if (!viewsLoaded || !newlyAddedGlobalFields?.length) return;
        const newlyAddedGlobalFieldsUsedInViews = (0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(newlyAddedGlobalFields, allViewFields);
        if (!newlyAddedGlobalFieldsUsedInViews.length) return;
        refreshIssues({
            refreshAllLoaded: true,
            loadIssueDeliveryProgress: false
        });
        resetNewlyAddedGlobalFields();
    }, [
        viewsLoaded,
        newlyAddedGlobalFields,
        resetNewlyAddedGlobalFields,
        allViewFields,
        refreshIssues
    ]);
    return null;
};

});
parcelRegister("ghXpo", function(module, exports) {

$parcel$export(module.exports, "useActions", () => $b1a6ad92e0355de7$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useFieldAri", () => $b1a6ad92e0355de7$export$87d018e012388211);
$parcel$export(module.exports, "useFieldKeyToAriMapAsync", () => $b1a6ad92e0355de7$export$33a893b8a17afd19);

var $12DRg = parcelRequire("12DRg");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");
const $b1a6ad92e0355de7$var$createPromiseState = ()=>{
    let resolve = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let reject = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const promise = new Promise((pr, rj)=>{
        resolve = pr;
        reject = rj;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
const $b1a6ad92e0355de7$var$initialState = {
    // ensure loading state until we have a proper loading state (e.g. for cases where projectId is initially undefined)
    isDependencyLoading: true,
    fieldIdMap: undefined,
    cloudId: undefined,
    promise: $b1a6ad92e0355de7$var$createPromiseState()
};
const $b1a6ad92e0355de7$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $b1a6ad92e0355de7$var$initialState,
    actions: {
        updateMapping: (cloudId, isLoading, fieldIdMap)=>({ getState: getState, setState: setState })=>{
                const nextState = {
                    fieldIdMap: fieldIdMap,
                    cloudId: cloudId,
                    isDependencyLoading: isLoading
                };
                setState(nextState);
                if (!isLoading && fieldIdMap !== undefined) getState().promise.resolve(nextState);
            }
    },
    name: 'polaris-field-ari-store'
});
const $b1a6ad92e0355de7$export$bc923229a7fa61e7 = (0, $iJq0l.createActionsHook)($b1a6ad92e0355de7$export$390f32400eaf98c9);
const $b1a6ad92e0355de7$var$getFieldAris = (state, fieldKeys)=>{
    const map = {};
    if (fieldKeys === undefined || state.fieldIdMap === undefined) return undefined;
    fieldKeys.forEach((fieldKey)=>{
        const legacyFieldId = state.fieldIdMap?.[fieldKey];
        map[fieldKey] = legacyFieldId || `ari:cloud:jira:${state.cloudId}:jira-field/${fieldKey}`;
    });
    return map;
};
const $b1a6ad92e0355de7$var$getFieldAri = (state, fieldKey)=>{
    if (fieldKey === undefined || !state.cloudId) return undefined;
    return $b1a6ad92e0355de7$var$getFieldAris(state, [
        fieldKey
    ])?.[fieldKey];
};
const $b1a6ad92e0355de7$export$87d018e012388211 = (0, $iJq0l.createStateHook)($b1a6ad92e0355de7$export$390f32400eaf98c9, {
    selector: $b1a6ad92e0355de7$var$getFieldAri
});
const $b1a6ad92e0355de7$export$33a893b8a17afd19 = (0, $iJq0l.createStateHook)($b1a6ad92e0355de7$export$390f32400eaf98c9, {
    selector: (state, { fieldKeys: fieldKeys })=>state.promise.promise.then((resolvedState)=>{
            if ((0, $7jTnu.fg)('polaris_loading_reactions_fix')) {
                const nextState = {
                    ...state,
                    fieldIdMap: state.fieldIdMap === undefined && resolvedState.fieldIdMap ? resolvedState.fieldIdMap : state.fieldIdMap,
                    cloudId: state.cloudId === undefined && resolvedState.cloudId ? resolvedState.cloudId : state.cloudId
                };
                return $b1a6ad92e0355de7$var$getFieldAris(nextState, fieldKeys) || {};
            }
            return $b1a6ad92e0355de7$var$getFieldAris(state, fieldKeys) || {};
        })
});

});

parcelRegister("cmN5o", function(module, exports) {

$parcel$export(module.exports, "getChangedProps", () => $a66c63d43b2ffce1$export$931518c59b4a7083);
function $a66c63d43b2ffce1$export$931518c59b4a7083(current, prev) {
    if (current === undefined || current === null || typeof current !== 'object' || typeof prev !== 'object') return [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(current).filter((key)=>current?.[key] !== undefined && current?.[key] !== prev?.[key]);
}

});

parcelRegister("apXQz", function(module, exports) {

$parcel$export(module.exports, "PolarisRouteContainer", () => $d05b4c167eb4b83e$export$835836449342021c);
$parcel$export(module.exports, "usePolarisQuery", () => $d05b4c167eb4b83e$export$a0561749ea6366a9);
$parcel$export(module.exports, "useFullscreenQueryParameter", () => $d05b4c167eb4b83e$export$c3af6aa037072338);
$parcel$export(module.exports, "useSidebarQueryParameter", () => $d05b4c167eb4b83e$export$3d7c7b8ad6e012db);
$parcel$export(module.exports, "useIssueTypeIdQueryParameter", () => $d05b4c167eb4b83e$export$e153bdcdf29670a1);
$parcel$export(module.exports, "useRoadmapQueryParameter", () => $d05b4c167eb4b83e$export$6d8407e4a22e5eb3);
$parcel$export(module.exports, "useSelectedIssueQueryParameter", () => $d05b4c167eb4b83e$export$567c36d062d58de4);
$parcel$export(module.exports, "useIsIssueOpenInFullscreen", () => $d05b4c167eb4b83e$export$605125b912bc3cb9);
$parcel$export(module.exports, "useIsIssueOpenInSidebar", () => $d05b4c167eb4b83e$export$d889138060b442eb);
$parcel$export(module.exports, "useIssueViewLayout", () => $d05b4c167eb4b83e$export$8ae00b4e58626e94);
$parcel$export(module.exports, "useIssueViewSection", () => $d05b4c167eb4b83e$export$711cefe410e03ef5);
$parcel$export(module.exports, "useCurrentPolarisRoute", () => $d05b4c167eb4b83e$export$fd6cdb023846ec7a);
$parcel$export(module.exports, "useCurrentPolarisRouteSection", () => $d05b4c167eb4b83e$export$144b5fe3cd41790c);
$parcel$export(module.exports, "usePolarisRouter", () => $d05b4c167eb4b83e$export$b98a36d9fd4e7222);

var $eJOHy = parcelRequire("eJOHy");

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $gCY1z = parcelRequire("gCY1z");
var $83DiZ = parcelRequire("83DiZ");

var $5xmeX = parcelRequire("5xmeX");

var $g150O = parcelRequire("g150O");

var $kTmHj = parcelRequire("kTmHj");
var $8rYUw = parcelRequire("8rYUw");
var $gbYTG = parcelRequire("gbYTG");

var $3EGZm = parcelRequire("3EGZm");

var $e6XlU = parcelRequire("e6XlU");

var $7a8xH = parcelRequire("7a8xH");
const $d05b4c167eb4b83e$var$initialState = {
    containerProps: undefined
};
const $d05b4c167eb4b83e$export$feb26c1e73b87394 = (0, $jxALV.createPolarisStore)({
    initialState: $d05b4c167eb4b83e$var$initialState,
    actions: $kTmHj,
    name: 'PolarisRouteStore'
});
const { Container: $d05b4c167eb4b83e$var$Container, useActions: $d05b4c167eb4b83e$var$useActions, createHook: $d05b4c167eb4b83e$var$createHook } = (0, $YvHeB.createJpdContainer)($d05b4c167eb4b83e$export$feb26c1e73b87394, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($8rYUw.init());
            dispatch($gbYTG.updateDebouncedRouterActions());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($gbYTG.updateDebouncedRouterActions());
        }
});
const $d05b4c167eb4b83e$export$835836449342021c = (props)=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    const section = (0, $7a8xH.useUrlSection)();
    const resource = (0, $7a8xH.useUrlResource)();
    const { push: push, replace: replace } = (0, $83DiZ.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d05b4c167eb4b83e$var$Container, {
        ...props,
        query: query,
        section: section,
        resource: resource,
        useNativePushMethod: push,
        useNativeReplaceMethod: replace
    }, props.children);
};
const $d05b4c167eb4b83e$export$a0561749ea6366a9 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getPolarisQuerySelector));
const $d05b4c167eb4b83e$export$c3af6aa037072338 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getFullscreenQueryParameter));
const $d05b4c167eb4b83e$export$3d7c7b8ad6e012db = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getSidebarQueryParameter));
const $d05b4c167eb4b83e$export$e153bdcdf29670a1 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIssueTypeIdQueryParameter));
const $d05b4c167eb4b83e$export$6d8407e4a22e5eb3 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getRoadmapQueryParameter));
const $d05b4c167eb4b83e$export$567c36d062d58de4 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getSelectedIssueQueryParameter));
const $d05b4c167eb4b83e$export$605125b912bc3cb9 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIsIssueOpenInFullscreen));
const $d05b4c167eb4b83e$export$d889138060b442eb = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIsIssueOpenInSidebar));
const $d05b4c167eb4b83e$export$8ae00b4e58626e94 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIssueViewLayout));
const $d05b4c167eb4b83e$export$885b67caee31103a = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIssueViewSection));
const $d05b4c167eb4b83e$export$711cefe410e03ef5 = ()=>{
    const issueViewSection = $d05b4c167eb4b83e$export$885b67caee31103a();
    const isSharedView = (0, $5xmeX.useIsSharedView)();
    const sharingSettings = (0, $g150O.useCurrentViewSharingSettings)();
    if (!isSharedView) return issueViewSection;
    if (!sharingSettings?.showIdeaComments && issueViewSection === 'comments' || !sharingSettings?.showIdeaInsights && issueViewSection === 'capture') return 0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR;
    return issueViewSection;
};
const $d05b4c167eb4b83e$export$fd6cdb023846ec7a = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getCurrentRouteSelector));
const $d05b4c167eb4b83e$export$144b5fe3cd41790c = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getCurrentRouteSectionSelector));
const $d05b4c167eb4b83e$export$b98a36d9fd4e7222 = ()=>{
    const { routeTo: routeTo, setQuery: setQuery, closeIssueView: closeIssueView, openIssueView: openIssueView } = $d05b4c167eb4b83e$var$useActions();
    return (0, $eJOHy.useMemo)(()=>({
            routeTo: routeTo,
            setQuery: setQuery,
            closeIssueView: closeIssueView,
            openIssueView: openIssueView
        }), [
        routeTo,
        setQuery,
        closeIssueView,
        openIssueView
    ]);
};

});
parcelRegister("5xmeX", function(module, exports) {

$parcel$export(module.exports, "PolarisEnvironmentProvider", () => $4fc4ce8293658f41$export$95b1e1d8730969e);
$parcel$export(module.exports, "useIsEmbedded", () => $4fc4ce8293658f41$export$77140ffa938f9fd1);
$parcel$export(module.exports, "useIsSharedView", () => $4fc4ce8293658f41$export$19a346ab6c5052b2);
$parcel$export(module.exports, "useIsCollectionView", () => $4fc4ce8293658f41$export$653454b45dadb2a8);

var $eJOHy = parcelRequire("eJOHy");
const $4fc4ce8293658f41$var$initialState = {
    embedded: undefined,
    isSharedView: undefined,
    isCollectionView: undefined
};
const $4fc4ce8293658f41$var$PolarisEnvironmentContext = /*#__PURE__*/ (0, $eJOHy.createContext)($4fc4ce8293658f41$var$initialState);
const $4fc4ce8293658f41$export$95b1e1d8730969e = ({ children: children, embedded: embedded = false, isSharedView: isSharedView = false, isCollectionView: isCollectionView = false })=>{
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            embedded: embedded,
            isSharedView: isSharedView,
            isCollectionView: isCollectionView
        }), [
        embedded,
        isSharedView,
        isCollectionView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4fc4ce8293658f41$var$PolarisEnvironmentContext.Provider, {
        value: contextValue
    }, children);
};
const $4fc4ce8293658f41$export$77140ffa938f9fd1 = ()=>{
    const { embedded: embedded } = (0, $eJOHy.useContext)($4fc4ce8293658f41$var$PolarisEnvironmentContext);
    return embedded === true;
};
const $4fc4ce8293658f41$export$19a346ab6c5052b2 = ()=>{
    const { isSharedView: isSharedView } = (0, $eJOHy.useContext)($4fc4ce8293658f41$var$PolarisEnvironmentContext);
    return isSharedView === true;
};
const $4fc4ce8293658f41$export$653454b45dadb2a8 = ()=>{
    const { isCollectionView: isCollectionView } = (0, $eJOHy.useContext)($4fc4ce8293658f41$var$PolarisEnvironmentContext);
    return isCollectionView === true;
};

});

parcelRegister("g150O", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentViewSharingSettingsInitialLoading", () => $a2efd1795594c28c$export$24d19581f52b2bac);
$parcel$export(module.exports, "useCurrentViewSharingSettings", () => $a2efd1795594c28c$export$e010169e1bebed20);
$parcel$export(module.exports, "useCurrentViewSharingStakeholders", () => $a2efd1795594c28c$export$8afacc6445a9f29d);
$parcel$export(module.exports, "usePublicSharingControls", () => $a2efd1795594c28c$export$f5e51b1e513c7a19);
$parcel$export(module.exports, "useIdeaDescriptionFieldKey", () => $a2efd1795594c28c$export$a95feff8ba9c77d2);
$parcel$export(module.exports, "useHasCurrentViewSharingSettingsError", () => $a2efd1795594c28c$export$a4c4a7f472c1449a);
$parcel$export(module.exports, "useHasCurrentViewSharingError", () => $a2efd1795594c28c$export$ed37db0f58966dec);
$parcel$export(module.exports, "useIsSharingOnSiteEnabled", () => $a2efd1795594c28c$export$5603541acb0905d);
$parcel$export(module.exports, "useIsSharingSiteConfigLoading", () => $a2efd1795594c28c$export$cd795923d8f612d5);
$parcel$export(module.exports, "useProjectAccessLevel", () => $a2efd1795594c28c$export$e262f937bd216199);
$parcel$export(module.exports, "useIsPublishDialogContentLoading", () => $a2efd1795594c28c$export$4a54198358826b6b);
$parcel$export(module.exports, "useIsSitePublicSharingLoading", () => $a2efd1795594c28c$export$f1d239607895ab30);
$parcel$export(module.exports, "useIsCurrentViewPublicSharingEnabled", () => $a2efd1795594c28c$export$9e4ecc370892bc0b);
$parcel$export(module.exports, "useIsSitePublicSharingEnabled", () => $a2efd1795594c28c$export$c2bf49dff0e5754f);

var $fVyje = parcelRequire("fVyje");

var $7BzKB = parcelRequire("7BzKB");
const $a2efd1795594c28c$export$24d19581f52b2bac = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsCurrentViewSharingSettingsInitialLoading));
const $a2efd1795594c28c$export$e060903268c10657 = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsCurrentViewSharingInitialLoading));
const $a2efd1795594c28c$export$e010169e1bebed20 = (0, $fVyje.createSharingHook)((0, $7BzKB.getCurrentViewSharingSettings));
const $a2efd1795594c28c$export$8afacc6445a9f29d = (0, $fVyje.createSharingHook)((0, $7BzKB.getCurrentViewSharingStakeholders));
const $a2efd1795594c28c$export$f5e51b1e513c7a19 = (0, $fVyje.createSharingHook)((0, $7BzKB.getPublicSharingControls));
const $a2efd1795594c28c$export$a95feff8ba9c77d2 = (0, $fVyje.createSharingHook)((0, $7BzKB.getIdeaDescriptionFieldKey));
const $a2efd1795594c28c$export$a4c4a7f472c1449a = (0, $fVyje.createSharingHook)((0, $7BzKB.hasCurrentViewSharingSettingsError));
const $a2efd1795594c28c$export$ed37db0f58966dec = (0, $fVyje.createSharingHook)((0, $7BzKB.hasCurrentViewSharingError));
const $a2efd1795594c28c$export$5603541acb0905d = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsSharingOnSiteEnabled));
const $a2efd1795594c28c$export$cd795923d8f612d5 = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsSharingSiteConfigLoading));
const $a2efd1795594c28c$export$e262f937bd216199 = (0, $fVyje.createSharingHook)((0, $7BzKB.getProjectAccessLevel));
const $a2efd1795594c28c$export$4a54198358826b6b = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsPublishDialogContentLoading));
const $a2efd1795594c28c$export$f1d239607895ab30 = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsSitePublicSharingLoading));
const $a2efd1795594c28c$export$9e4ecc370892bc0b = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsCurrentViewPublicSharingEnabled));
const $a2efd1795594c28c$export$c2bf49dff0e5754f = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsSitePublicSharingEnabled));

});
parcelRegister("fVyje", function(module, exports) {

$parcel$export(module.exports, "Container", () => $1a2420d855163030$export$42a852a2b6b56249);
$parcel$export(module.exports, "createSharingHook", () => $1a2420d855163030$export$80a8f4ec77855db9);
$parcel$export(module.exports, "useSharingActions", () => $1a2420d855163030$export$45260f05810c82ae);

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $42uL4 = parcelRequire("42uL4");

var $ij0Yh = parcelRequire("ij0Yh");
var $3Z0eD = parcelRequire("3Z0eD");
var $1bMxm = parcelRequire("1bMxm");
const $1a2420d855163030$export$d4c72bab9d6cc13a = Object.freeze({
    sharingSettings: {},
    sharingStakeholders: {},
    siteConfig: {
        isEnabled: false,
        isLoading: false,
        error: undefined
    },
    sitePublicSharingConfig: {
        isEnabled: false,
        isLoading: false,
        error: undefined
    },
    projectAccessLevel: undefined,
    containerProps: undefined,
    prevContainerProps: undefined
});
const $1a2420d855163030$var$SharingStore = (0, $jxALV.createPolarisStore)({
    initialState: $1a2420d855163030$export$d4c72bab9d6cc13a,
    actions: (0, $1bMxm.publicActions),
    name: 'SharingStore'
});
const $1a2420d855163030$var$onInit = ()=>({ dispatch: dispatch, setState: setState }, { edition: edition, permissions: permissions })=>{
        if ((0, $42uL4.publishFeatureDisabled)(edition)) return;
        dispatch($3Z0eD.loadSharingSiteConfig());
        setState({
            permissions: permissions
        });
        dispatch((0, $1bMxm.privateActions).loadSitePublicSharingConfig());
        dispatch($ij0Yh.loadProjectAccessLevel());
    };
const $1a2420d855163030$var$onUpdate = ()=>({ setState: setState }, { permissions: permissions })=>{
        // In case permissions are not yet loaded onInit
        setState({
            permissions: permissions
        });
    };
const { Container: $1a2420d855163030$export$42a852a2b6b56249, createHook: $1a2420d855163030$var$createHook, useActions: $1a2420d855163030$var$useActions } = (0, $YvHeB.createJpdContainer)($1a2420d855163030$var$SharingStore, {
    onInit: $1a2420d855163030$var$onInit,
    onUpdate: $1a2420d855163030$var$onUpdate
});
const $1a2420d855163030$export$80a8f4ec77855db9 = $1a2420d855163030$var$createHook;
const $1a2420d855163030$export$45260f05810c82ae = $1a2420d855163030$var$useActions;

});
parcelRegister("42uL4", function(module, exports) {

$parcel$export(module.exports, "publishFeatureDisabled", () => $90dfe72160b05a84$export$941f8069ccf8e337);

var $a9ldn = parcelRequire("a9ldn");
const $90dfe72160b05a84$export$941f8069ccf8e337 = (edition)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    edition && [
        (0, $a9ldn.UNLICENSED),
        (0, $a9ldn.FREE_EDITION)
    ].includes(edition);

});

parcelRegister("ij0Yh", function(module, exports) {

$parcel$export(module.exports, "loadProjectAccessLevel", () => $5638963ba7414485$export$16808681673565f0);
$parcel$export(module.exports, "setProjectAccessLevel", () => $5638963ba7414485$export$89aeb751af3ee244);

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $eqs4m = parcelRequire("eqs4m");
const $5638963ba7414485$export$16808681673565f0 = ()=>async ({ setState: setState }, { isSharedView: isSharedView, projectId: projectId })=>{
        if (isSharedView || !projectId) return;
        try {
            const level = await (0, $eqs4m.fetchProjectAccessLevel)(projectId);
            setState({
                projectAccessLevel: level?.type
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-project-access-level', error));
        }
    };
const $5638963ba7414485$export$89aeb751af3ee244 = (projectAccessLevel)=>({ setState: setState })=>{
        setState({
            projectAccessLevel: projectAccessLevel
        });
    };

});
parcelRegister("7e8wG", function(module, exports) {

$parcel$export(module.exports, "createErrorAnalytics", () => $85bd9b8631bfa06e$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $85bd9b8631bfa06e$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $85bd9b8631bfa06e$export$4e01d30cacaf82b8);

var $eJOHy = parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $jdqdp = parcelRequire("jdqdp");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $6x8n3 = parcelRequire("6x8n3");

var $fljS9 = parcelRequire("fljS9");

var $95Ew5 = parcelRequire("95Ew5");

var $fVlmn = parcelRequire("fVlmn");
const $85bd9b8631bfa06e$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $85bd9b8631bfa06e$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $fVlmn.getMetadata)(errorObject));
};
const $85bd9b8631bfa06e$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).serverLoadFailedDescription)
        });
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $fljS9.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $fljS9.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage((0, $95Ew5.default).entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $fVlmn.isPermissionError)(errorObject)) return error({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).permissionErrorDescription)
        });
        if ((0, $fVlmn.isConfigError)(errorObject)) return error({
            title: formatMessage((0, $95Ew5.default).configErrorTitle),
            description: formatMessage((0, $95Ew5.default).configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).errorDescription)
        });
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).errorPossibleAccessLoss)
        });
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $85bd9b8631bfa06e$var$usePossibleAccessLossError();
    const generalActionFailedError = $85bd9b8631bfa06e$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $85bd9b8631bfa06e$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $85bd9b8631bfa06e$var$useGeneralDataLoadingFailedHandling();
    return (0, $eJOHy.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $85bd9b8631bfa06e$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { error: error } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("6x8n3", function(module, exports) {

$parcel$export(module.exports, "useNotifications", () => $3e2a0a021f792948$export$53d5ca6c3f53e109);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $3TFuO = parcelRequire("3TFuO");

var $1NG86 = parcelRequire("1NG86");

var $aMGpU = parcelRequire("aMGpU");
var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");
const $3e2a0a021f792948$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $aXKmr.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $3e2a0a021f792948$var$customFlag = (notification, onDismiss)=>$3e2a0a021f792948$var$customFlagCommon(notification, onDismiss, (0, $22c3C.default));
const $3e2a0a021f792948$var$customAutoDismissFlag = (notification, onDismiss)=>$3e2a0a021f792948$var$customFlagCommon(notification, onDismiss, (0, $aMGpU.default));
const $3e2a0a021f792948$var$success = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$var$errorWithRefresh = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$var$error = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    return (0, $eJOHy.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$customFlag(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$success(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$errorWithRefresh(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$error(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("aMGpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $de87e4d7cff07061$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $a9cht = parcelRequire("a9cht");
const $de87e4d7cff07061$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $de87e4d7cff07061$export$2e2bcd8739ae039 = $de87e4d7cff07061$var$AkAutoDismissFlag;

});


parcelRegister("95Ew5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7342b98ba959b1d3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7342b98ba959b1d3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "polaris-lib-errors.controllers.error-title",
        "defaultMessage": "Something went wrong."
    },
    permissionErrorDescription: {
        "id": "polaris-lib-errors.controllers.permission-error-description",
        "defaultMessage": "You may not have the permissions required to perform this operation."
    },
    configErrorTitle: {
        "id": "polaris-lib-errors.controllers.config-error-title",
        "defaultMessage": "We couldn't save that."
    },
    configErrorDescription: {
        "id": "polaris-lib-errors.controllers.config-error-description",
        "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
    },
    serverLoadFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-load-failed-description",
        "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
    },
    serverUpdateFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-update-failed-description",
        "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
    },
    errorDescription: {
        "id": "polaris-lib-errors.controllers.error-description",
        "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
    },
    workflowLoadingFailedDescription: {
        "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
        "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
    },
    errorPossibleAccessLoss: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss",
        "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
    },
    cyclicFormulaFieldDescription: {
        "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
        "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
    },
    entityLimitErrorTitle: {
        "id": "polaris-lib-errors.controllers.entity-limit-error-title",
        "defaultMessage": "You\u2019ve hit a limit"
    }
});

});


parcelRegister("eqs4m", function(module, exports) {

$parcel$export(module.exports, "fetchProjectAccessLevel", () => $78eac8f1d70b3bae$export$c1e51f4f79456e2e);

var $1Ozm9 = parcelRequire("1Ozm9");
const $78eac8f1d70b3bae$var$transformType = (value)=>value === 'OPEN' || value === 'LIMITED' || value === 'PRIVATE' || value === 'FREE' ? value : 'UNKNOWN';
const $78eac8f1d70b3bae$var$transform = (response)=>{
    if (response.accessLevel === undefined) return undefined;
    return {
        type: $78eac8f1d70b3bae$var$transformType(response.accessLevel.value),
        label: response.accessLevel.displayName,
        description: response.accessLevel.description,
        iconName: response.accessLevel.iconName
    };
};
const $78eac8f1d70b3bae$export$c1e51f4f79456e2e = (projectId)=>(0, $1Ozm9.default)(`/rest/internal/simplified/1.0/projects/${projectId}/summary`, {
        method: 'GET'
    }).then($78eac8f1d70b3bae$var$transform);

});


parcelRegister("3Z0eD", function(module, exports) {

$parcel$export(module.exports, "loadSharingSiteConfig", () => $d7a5358050919049$export$85c251450f7886f9);

var $gYnSx = parcelRequire("gYnSx");

var $b5oGV = parcelRequire("b5oGV");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $dylkx = parcelRequire("dylkx");

var $8KUFq = parcelRequire("8KUFq");
const $d7a5358050919049$export$85c251450f7886f9 = ()=>async ({ setState: setState }, { isSharedView: isSharedView })=>{
        if (isSharedView) {
            setState({
                siteConfig: {
                    isEnabled: true,
                    isLoading: false,
                    error: undefined
                }
            });
            return;
        }
        setState({
            siteConfig: {
                isEnabled: false,
                isLoading: true,
                error: undefined
            }
        });
        try {
            (0, $b5oGV.experience).sharing.loadSiteConfig.start();
            const { enabled: enabled } = await (0, $dylkx.fetchSiteSharingConfig)();
            setState({
                siteConfig: {
                    isEnabled: enabled,
                    isLoading: false,
                    error: undefined
                }
            });
            (0, $b5oGV.experience).sharing.loadSiteConfig.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                siteConfig: {
                    isEnabled: false,
                    isLoading: false,
                    error: error
                }
            });
            if ((0, $fVlmn.isPermissionError)(error) || (0, $fVlmn.isNotFoundError)(error) || (0, $8KUFq.isClientFetchError)(error)) (0, $b5oGV.experience).sharing.loadSiteConfig.abort(error);
            else (0, $b5oGV.experience).sharing.loadSiteConfig.failure(error);
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-sharing-site-config-action', error));
        }
    };

});
parcelRegister("dylkx", function(module, exports) {

$parcel$export(module.exports, "fetchSiteSharingConfig", () => $cd0566e434528c1f$export$28c58aa760b45b2f);
$parcel$export(module.exports, "enableSharingOnSite", () => $cd0566e434528c1f$export$9a5ce37e4cd6948a);
$parcel$export(module.exports, "disableSharingOnSite", () => $cd0566e434528c1f$export$20b3e963cde336ea);
$parcel$export(module.exports, "fetchSitePublicSharingConfig", () => $cd0566e434528c1f$export$d88e9e9de94a1689);
$parcel$export(module.exports, "enablePublicSharingOnSite", () => $cd0566e434528c1f$export$a39f2019d2db95d2);
$parcel$export(module.exports, "disablePublicSharingOnSite", () => $cd0566e434528c1f$export$5c0263c3f0e2deff);

var $1Ozm9 = parcelRequire("1Ozm9");

var $jGzN3 = parcelRequire("jGzN3");

var $68Jjc = parcelRequire("68Jjc");
const $cd0566e434528c1f$export$28c58aa760b45b2f = ()=>(0, $1Ozm9.default)((0, $68Jjc.SITE_SHARING_CONFIG_URL));
const $cd0566e434528c1f$export$9a5ce37e4cd6948a = ()=>(0, $jGzN3.performPutRequest)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/enable`);
const $cd0566e434528c1f$export$20b3e963cde336ea = ()=>(0, $jGzN3.performPutRequest)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/disable`);
const $cd0566e434528c1f$export$d88e9e9de94a1689 = ()=>(0, $1Ozm9.default)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/public`);
const $cd0566e434528c1f$export$a39f2019d2db95d2 = ()=>(0, $jGzN3.performPutRequest)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/public/enable`);
const $cd0566e434528c1f$export$5c0263c3f0e2deff = ()=>(0, $jGzN3.performPutRequest)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/public/disable`);

});
parcelRegister("68Jjc", function(module, exports) {

$parcel$export(module.exports, "SITE_SHARING_CONFIG_URL", () => $8c1414213ff5f65c$export$f27e6cd6ae0b6f49);
const $8c1414213ff5f65c$export$d3c2b1c9aa071f82 = {
    ANYONE: 'ANYONE',
    ORGANIZATION: 'ORGANIZATION'
};
const $8c1414213ff5f65c$export$f27e6cd6ae0b6f49 = '/rest/polaris/views/sharing/config';

});



parcelRegister("1bMxm", function(module, exports) {

$parcel$export(module.exports, "privateActions", () => $6e020bf52bf3739a$export$3f1be494d407b77a);
$parcel$export(module.exports, "publicActions", () => $6e020bf52bf3739a$export$8705b583fa097d24);

var $fa62R = parcelRequire("fa62R");

var $ij0Yh = parcelRequire("ij0Yh");

var $03d5M = parcelRequire("03d5M");

var $3Z0eD = parcelRequire("3Z0eD");

var $54qZO = parcelRequire("54qZO");

var $fJgAQ = parcelRequire("fJgAQ");



var $3Z0eD = parcelRequire("3Z0eD");

var $ij0Yh = parcelRequire("ij0Yh");

const $6e020bf52bf3739a$export$3f1be494d407b77a = {
    loadSitePublicSharingConfig: $fa62R.loadSitePublicSharingConfig
};
const $6e020bf52bf3739a$export$8705b583fa097d24 = {
    loadSharingSettings: $03d5M.loadSharingSettings,
    updateSharingSettings: $03d5M.updateSharingSettings,
    addSharingStakeholders: $54qZO.addSharingStakeholders,
    loadSharingStakeholders: $54qZO.loadSharingStakeholders,
    removeSharingStakeholders: $54qZO.removeSharingStakeholders,
    loadSharingSiteConfig: $3Z0eD.loadSharingSiteConfig,
    setProjectAccessLevel: $ij0Yh.setProjectAccessLevel,
    loadProjectAccessLevel: $ij0Yh.loadProjectAccessLevel,
    deletePublishedView: $fJgAQ.deletePublishedView
};

});
parcelRegister("fa62R", function(module, exports) {

$parcel$export(module.exports, "loadSitePublicSharingConfig", () => $7d2a8f518a193145$export$85d654471364d5f1);

var $gYnSx = parcelRequire("gYnSx");

var $b5oGV = parcelRequire("b5oGV");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $dylkx = parcelRequire("dylkx");

var $8KUFq = parcelRequire("8KUFq");
const $7d2a8f518a193145$export$85d654471364d5f1 = ()=>async ({ setState: setState })=>{
        setState({
            sitePublicSharingConfig: {
                isEnabled: false,
                isLoading: true,
                error: undefined
            }
        });
        try {
            (0, $b5oGV.experience).sharing.loadSitePublicSharingConfig.start();
            const { enabled: enabled } = await (0, $dylkx.fetchSitePublicSharingConfig)();
            setState({
                sitePublicSharingConfig: {
                    isEnabled: enabled,
                    isLoading: false,
                    error: undefined
                }
            });
            (0, $b5oGV.experience).sharing.loadSitePublicSharingConfig.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                sitePublicSharingConfig: {
                    isEnabled: false,
                    isLoading: false,
                    error: error
                }
            });
            if ((0, $fVlmn.isPermissionError)(error) || (0, $fVlmn.isNotFoundError)(error) || (0, $8KUFq.isClientFetchError)(error)) (0, $b5oGV.experience).sharing.loadSitePublicSharingConfig.abort(error);
            else (0, $b5oGV.experience).sharing.loadSitePublicSharingConfig.failure(error);
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-site-public-sharing-config-action', error));
        }
    };

});

parcelRegister("03d5M", function(module, exports) {

$parcel$export(module.exports, "updateSharingSettings", () => $7e01f113dcba2650$export$69a9d91d9040f402);
$parcel$export(module.exports, "loadSharingSettings", () => $7e01f113dcba2650$export$38e4cff581c355ad);

var $cSmYj = parcelRequire("cSmYj");

var $gYnSx = parcelRequire("gYnSx");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $gCeeo = parcelRequire("gCeeo");

var $8KUFq = parcelRequire("8KUFq");

var $1uIew = parcelRequire("1uIew");

var $7BzKB = parcelRequire("7BzKB");

var $2fKlW = parcelRequire("2fKlW");
// this logic is needed when custom description field was removed,
// in such case we don't want to send this value to jpd-views-service to avoid 400 error
const $7e01f113dcba2650$var$sanitizeSettings = (settings, fields)=>{
    if (settings.ideaDescription.fieldKey) {
        const descriptionFieldExists = fields.some(({ key: key })=>key === settings.ideaDescription.fieldKey);
        if (!descriptionFieldExists) {
            const { ideaDescription: ideaDescription, ...rest } = settings;
            return rest;
        }
    }
    return settings;
};
// Rationale for this helper:
// We use a single endpoint for fetching the settings but two distinct ones
// to update them. Since updateSharingSettings action processes combined
// settings object we need to figure out which services to call based on
// the settings object properties diff.
const $7e01f113dcba2650$var$callSharingSettingsServices = async (viewRemote, viewUUID, newSettings, oldSettings)=>{
    const { publicSharingEnabled: newValueOfPublicSharingEnabled, ...incomingSettings } = newSettings;
    const { publicSharingEnabled: oldValueOfPublicSharingEnabled, ...existingSettings } = oldSettings ?? {};
    const requestPromises = [];
    const result = {
        publicAccessChanged: false,
        publishedChanged: false
    };
    if (newValueOfPublicSharingEnabled !== undefined && newValueOfPublicSharingEnabled !== oldValueOfPublicSharingEnabled) {
        requestPromises.push(viewRemote.updatePublicSharingSettings(viewUUID, {
            enabled: newValueOfPublicSharingEnabled
        }));
        result.publicAccessChanged = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(incomingSettings, existingSettings)) {
        requestPromises.push(viewRemote.updateSharingSettings(viewUUID, newSettings));
        result.publishedChanged = true;
    }
    await Promise.all(requestPromises);
    return result;
};
/**
 * Since public sharing is not an atomic action (we need to check 2 independent settings to establish if the view
 * is being shared publicly with the link) this function single reponsibility is to compare previous and next settings
 * on update and see if the view is becoming public, stops being public or the settings change does not impact
 * the view public sharing status.
 */ const $7e01f113dcba2650$var$getSettingsUpdateOutcome = async (prevSettings, newSettings)=>{
    const wasSharedPublicly = prevSettings?.publicSharingEnabled === true && prevSettings?.sharingLinkEnabled === true;
    if (wasSharedPublicly) {
        const willStopBeingShared = newSettings.publicSharingEnabled === false || newSettings?.sharingLinkEnabled === false;
        if (willStopBeingShared) return 'PUBLIC_SHARING_DISABLED';
    } else {
        const combinedPublicSharingSettings = {
            publicSharingEnabled: newSettings.publicSharingEnabled ?? prevSettings?.publicSharingEnabled ?? false,
            sharingLinkEnabled: newSettings.sharingLinkEnabled ?? prevSettings?.sharingLinkEnabled ?? false
        };
        const willBecomeSharedPublicly = combinedPublicSharingSettings.publicSharingEnabled === true && combinedPublicSharingSettings.sharingLinkEnabled === true;
        if (willBecomeSharedPublicly) return 'PUBLIC_SHARING_ENABLED';
    }
    return 'PUBLIC_SHARING_UNCHANGED';
};
const $7e01f113dcba2650$export$69a9d91d9040f402 = (viewUUID, settings)=>async ({ dispatch: dispatch, getState: getState }, { viewRemote: viewRemote, onActionFailed: onActionFailed, fields: fields = [], createAnalyticsEvent: createAnalyticsEvent })=>{
        const prevSettings = (0, $7BzKB.getCurrentViewSharingSettings)(getState());
        const newSettings = $7e01f113dcba2650$var$sanitizeSettings(settings, fields);
        try {
            (0, $b5oGV.experience).sharing.updateSettings.start();
            // Optimistic update
            dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
                settings: settings
            }));
            const { publicAccessChanged: publicAccessChanged, publishedChanged: publishedChanged } = await $7e01f113dcba2650$var$callSharingSettingsServices(viewRemote, viewUUID, newSettings, prevSettings);
            const isPublic = newSettings.publicSharingEnabled === true;
            const isPublished = newSettings.sharingLinkEnabled === true;
            if (publicAccessChanged) {
                const eventName = isPublic ? 'view becomesPublic' : 'view becomesNotPublic';
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), eventName, {
                    isPublished: isPublished
                });
                (0, $3Ku0X.sendPendoTrackEvent)({
                    actionSubjectAndAction: eventName,
                    attributes: {
                        isPublished: isPublished
                    }
                });
            }
            if (publishedChanged) {
                const eventName = isPublished ? 'view published' : 'view unpublished';
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), eventName, {
                    isPublic: isPublic
                });
                (0, $3Ku0X.sendPendoTrackEvent)({
                    actionSubjectAndAction: eventName,
                    attributes: {
                        isPublic: isPublic
                    }
                });
            }
            (0, $b5oGV.experience).sharing.updateSettings.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // Bringing back the old settings
            dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
                settings: prevSettings
            }));
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error) || (0, $fVlmn.isNotFoundError)(error) || (0, $1uIew.isValidationError)(error)) (0, $b5oGV.experience).sharing.updateSettings.abort(error);
            else (0, $b5oGV.experience).sharing.updateSettings.failure(error);
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.update-settings-action', error));
            onActionFailed(error);
        }
        const publicSharingControls = (0, $7BzKB.getPublicSharingControls)(getState());
        const isPublicSharingDisabledByGlobalConfig = publicSharingControls.status === 'disabled' && publicSharingControls.reason === 'global-configuration';
        if (!isPublicSharingDisabledByGlobalConfig) return {
            publicSharingStatus: await $7e01f113dcba2650$var$getSettingsUpdateOutcome(prevSettings, settings)
        };
    };
const $7e01f113dcba2650$export$38e4cff581c355ad = (viewUUID)=>async ({ getState: getState, dispatch: dispatch }, { isSharedView: isSharedView, onLoadFailed: onLoadFailed, onLoadViewComments: onLoadViewComments, viewRemote: viewRemote })=>{
        const isSharingSettingsInitialLoading = (0, $7BzKB.getIsCurrentViewSharingSettingsInitialLoading)(getState());
        const isSharingSettingsLoading = (0, $7BzKB.getIsCurrentViewSharingSettingLoading)(getState());
        if (!isSharingSettingsInitialLoading && isSharingSettingsLoading) return;
        dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
            isLoading: true
        }));
        try {
            (0, $b5oGV.experience).sharing.loadSettings.start();
            const settings = await viewRemote.fetchSharingSettings(viewUUID);
            dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
                settings: settings
            }));
            (0, $b5oGV.experience).sharing.loadSettings.success();
            if (isSharedView && settings.showViewComments) onLoadViewComments?.();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if ((0, $fVlmn.isNotFoundError)(error) || (0, $fVlmn.isClientClosedError)(error) || (0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error)) (0, $b5oGV.experience).sharing.loadSettings.abort(error);
            else (0, $b5oGV.experience).sharing.loadSettings.failure(error);
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-settings-action', error));
            dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
                settings: undefined,
                error: error
            }));
            if (isSharedView) onLoadFailed(error);
        }
    };

});
parcelRegister("7BzKB", function(module, exports) {

$parcel$export(module.exports, "getIsSharingSiteConfigLoading", () => $954f2b654593806d$export$c9bef8b7e68b15aa);
$parcel$export(module.exports, "getIsSitePublicSharingLoading", () => $954f2b654593806d$export$e6d8b7b929ecf8e8);
$parcel$export(module.exports, "getIsSitePublicSharingEnabled", () => $954f2b654593806d$export$80cfe27fbdebd361);
$parcel$export(module.exports, "getIsCurrentViewPublicSharingEnabled", () => $954f2b654593806d$export$9da2ae248c7e3039);
$parcel$export(module.exports, "getProjectAccessLevel", () => $954f2b654593806d$export$f5f97c28ee230e06);
$parcel$export(module.exports, "getIsSharingOnSiteEnabled", () => $954f2b654593806d$export$2a292862c2d52f48);
$parcel$export(module.exports, "getCurrentViewSharingSettings", () => $954f2b654593806d$export$731dc0886ad97eeb);
$parcel$export(module.exports, "getPublicSharingControls", () => $954f2b654593806d$export$188eeb7105615837);
$parcel$export(module.exports, "getCurrentViewSharingStakeholders", () => $954f2b654593806d$export$65f25f8b5bc681f);
$parcel$export(module.exports, "getIsCurrentViewSharingSettingLoading", () => $954f2b654593806d$export$6f058b53c796dd7a);
$parcel$export(module.exports, "getIsCurrentViewSharingStakeholdersLoading", () => $954f2b654593806d$export$ff4eae65813c5f5e);
$parcel$export(module.exports, "getIsCurrentViewSharingSettingsInitialLoading", () => $954f2b654593806d$export$9fc5badc0a169630);
$parcel$export(module.exports, "getIsCurrentViewSharingStakeholdersInitialLoading", () => $954f2b654593806d$export$5b5786000e919f7);
$parcel$export(module.exports, "getIsCurrentViewSharingInitialLoading", () => $954f2b654593806d$export$787ffe6cfb2ef381);
$parcel$export(module.exports, "getIdeaDescriptionFieldKey", () => $954f2b654593806d$export$7b92127bf4e36b2d);
$parcel$export(module.exports, "getCurrentViewSharingLinkEnabled", () => $954f2b654593806d$export$3b2e0cd80d69f473);
$parcel$export(module.exports, "hasCurrentViewSharingSettingsError", () => $954f2b654593806d$export$57ba084aec18bf70);
$parcel$export(module.exports, "hasCurrentViewSharingError", () => $954f2b654593806d$export$a11d8d14f5a90504);
$parcel$export(module.exports, "getIsPublishDialogContentLoading", () => $954f2b654593806d$export$b74c50d75ffb3249);

var $ahm5r = parcelRequire("ahm5r");

const $954f2b654593806d$var$getCurrentViewUUID = (state)=>state.containerProps?.viewUUID;
const $954f2b654593806d$var$getViewsSharingSettings = (state)=>state.sharingSettings;
const $954f2b654593806d$var$getViewsSharingStakeholders = (state)=>state.sharingStakeholders;
const $954f2b654593806d$var$getPermissions = (state)=>state.permissions;
const $954f2b654593806d$var$getCurrentViewSettings = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewUUID, $954f2b654593806d$var$getViewsSharingSettings, (viewUUID, sharingSettings)=>viewUUID ? sharingSettings[viewUUID] : undefined);
const $954f2b654593806d$var$getCurrentViewStakeholders = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewUUID, $954f2b654593806d$var$getViewsSharingStakeholders, (viewUUID, sharingStakeholders)=>viewUUID ? sharingStakeholders[viewUUID] : undefined);
const $954f2b654593806d$var$getSharingSiteConfig = (state)=>state.siteConfig;
const $954f2b654593806d$export$c9bef8b7e68b15aa = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSharingSiteConfig, (config)=>config.isLoading);
const $954f2b654593806d$var$getSitePublicSharingConfig = (state)=>state.sitePublicSharingConfig;
const $954f2b654593806d$export$e6d8b7b929ecf8e8 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSitePublicSharingConfig, ({ isLoading: isLoading })=>isLoading);
const $954f2b654593806d$export$80cfe27fbdebd361 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSitePublicSharingConfig, ({ isEnabled: isEnabled })=>isEnabled);
const $954f2b654593806d$var$getSitePublicSharingError = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSitePublicSharingConfig, ({ error: error })=>error);
const $954f2b654593806d$export$9da2ae248c7e3039 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewSettings, (sharing)=>sharing?.settings?.publicSharingEnabled === true);
const $954f2b654593806d$export$f5f97c28ee230e06 = (state)=>state.projectAccessLevel;
const $954f2b654593806d$var$getSharingSiteConfigError = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSharingSiteConfig, (config)=>config.error);
const $954f2b654593806d$export$2a292862c2d52f48 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSharingSiteConfig, (config)=>config.isEnabled);
const $954f2b654593806d$export$731dc0886ad97eeb = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewSettings, $954f2b654593806d$export$f5f97c28ee230e06, (sharing, projectAccessLevel)=>{
    if (!sharing?.settings) return;
    const { settings: settings } = sharing;
    const hasSiteAccessLevel = projectAccessLevel && [
        'OPEN',
        'LIMITED'
    ].includes(projectAccessLevel);
    return {
        ...settings,
        generalAccessLevel: hasSiteAccessLevel ? (0, $8152430c5d79e444$export$41147fc9605520e9) : settings.generalAccessLevel
    };
});
const $954f2b654593806d$export$188eeb7105615837 = (0, $ahm5r.createSelector)([
    $954f2b654593806d$export$80cfe27fbdebd361,
    $954f2b654593806d$var$getPermissions
], (isSitePublicSharingEnabled, permissions)=>{
    if (isSitePublicSharingEnabled === false) return {
        status: 'disabled',
        reason: 'global-configuration'
    };
    if (permissions?.canPublishPublicDiscoveryViews !== true) return {
        status: 'disabled',
        reason: 'missing-permissions'
    };
    return {
        status: 'enabled'
    };
});
const $954f2b654593806d$export$65f25f8b5bc681f = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewStakeholders, (sharing)=>sharing?.stakeholders);
const $954f2b654593806d$export$6f058b53c796dd7a = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewSettings, (sharingSettings)=>sharingSettings?.isLoading === true);
const $954f2b654593806d$export$ff4eae65813c5f5e = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewStakeholders, (sharingStakeholders)=>sharingStakeholders?.isLoading === true);
const $954f2b654593806d$export$9fc5badc0a169630 = (0, $ahm5r.createSelector)($954f2b654593806d$export$6f058b53c796dd7a, $954f2b654593806d$export$731dc0886ad97eeb, (isLoading, settings)=>isLoading && settings === undefined);
const $954f2b654593806d$export$5b5786000e919f7 = (0, $ahm5r.createSelector)($954f2b654593806d$export$ff4eae65813c5f5e, $954f2b654593806d$export$65f25f8b5bc681f, (isLoading, stakeholders)=>isLoading && stakeholders === undefined);
const $954f2b654593806d$export$787ffe6cfb2ef381 = (0, $ahm5r.createSelector)($954f2b654593806d$export$9fc5badc0a169630, $954f2b654593806d$export$5b5786000e919f7, (isSettingsInitialLoading, isStakeholdersInitialLoading)=>isSettingsInitialLoading || isStakeholdersInitialLoading);
const $954f2b654593806d$export$7b92127bf4e36b2d = (0, $ahm5r.createSelector)($954f2b654593806d$export$731dc0886ad97eeb, (settings)=>settings?.ideaDescription.fieldKey);
const $954f2b654593806d$export$3b2e0cd80d69f473 = (0, $ahm5r.createSelector)($954f2b654593806d$export$731dc0886ad97eeb, (settings)=>settings?.sharingLinkEnabled);
const $954f2b654593806d$export$57ba084aec18bf70 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewSettings, $954f2b654593806d$var$getSharingSiteConfigError, $954f2b654593806d$var$getSitePublicSharingError, (sharingSettings, siteConfigError, sitePublicSharingError)=>sharingSettings?.error && sharingSettings.error.statusCode !== 404 || siteConfigError !== undefined || sitePublicSharingError !== undefined);
const $954f2b654593806d$export$a11d8d14f5a90504 = (0, $ahm5r.createSelector)($954f2b654593806d$export$57ba084aec18bf70, $954f2b654593806d$var$getCurrentViewStakeholders, (hasSettingsError, sharingStakeholders)=>sharingStakeholders?.error && sharingStakeholders.error.statusCode !== 404 || hasSettingsError);
const $954f2b654593806d$export$b74c50d75ffb3249 = (0, $ahm5r.createSelector)($954f2b654593806d$export$2a292862c2d52f48, $954f2b654593806d$export$80cfe27fbdebd361, $954f2b654593806d$export$787ffe6cfb2ef381, $954f2b654593806d$export$c9bef8b7e68b15aa, $954f2b654593806d$export$e6d8b7b929ecf8e8, (isSharingEnabledOnSite, isSitePublicSharingEnabled, isSharingInitialLoading, isSharingSiteConfigLoading, isSitePublicSharingLoading)=>isSharingEnabledOnSite && isSitePublicSharingEnabled && isSharingInitialLoading || isSharingSiteConfigLoading || isSitePublicSharingLoading);

});
const $8152430c5d79e444$export$41147fc9605520e9 = 'SITE';
const $8152430c5d79e444$export$137f231420cea7e9 = 'PROJECT';


parcelRegister("2fKlW", function(module, exports) {

$parcel$export(module.exports, "setSharingSettingsForView", () => $eb344f49a627d175$export$eb537ef0ff4cef7b);
$parcel$export(module.exports, "setSharingStakeholdersForView", () => $eb344f49a627d175$export$efe3b3704c70e658);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $eb344f49a627d175$export$eb537ef0ff4cef7b = (viewUUID, sharing = {})=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const viewSharingToUpdate = state.sharingSettings[viewUUID];
        setState({
            sharingSettings: {
                ...state.sharingSettings,
                [viewUUID]: {
                    isLoading: sharing.isLoading || false,
                    settings: sharing.settings || viewSharingToUpdate?.settings,
                    error: sharing.error
                }
            }
        });
    };
const $eb344f49a627d175$export$efe3b3704c70e658 = (viewUUID, sharing = {})=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const viewSharingToUpdate = state.sharingStakeholders[viewUUID];
        setState({
            sharingStakeholders: {
                ...state.sharingStakeholders,
                [viewUUID]: {
                    isLoading: sharing.isLoading || false,
                    stakeholders: sharing.stakeholders || viewSharingToUpdate?.stakeholders,
                    error: sharing.error
                }
            }
        });
    };

});


parcelRegister("54qZO", function(module, exports) {

$parcel$export(module.exports, "loadSharingStakeholders", () => $5f1576dc1cc9db81$export$98e678eadf48ced1);
$parcel$export(module.exports, "addSharingStakeholders", () => $5f1576dc1cc9db81$export$60473b7d5ed25db0);
$parcel$export(module.exports, "removeSharingStakeholders", () => $5f1576dc1cc9db81$export$4938ea46db8995e9);

var $gYnSx = parcelRequire("gYnSx");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $gCeeo = parcelRequire("gCeeo");

var $8KUFq = parcelRequire("8KUFq");

var $fVlmn = parcelRequire("fVlmn");

var $7BzKB = parcelRequire("7BzKB");

var $2fKlW = parcelRequire("2fKlW");
const $5f1576dc1cc9db81$export$98e678eadf48ced1 = (viewUUID, { viewAri: viewAri, viewKind: viewKind })=>async ({ getState: getState, dispatch: dispatch }, { viewRemote: viewRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const isSharingStakeholdersLoading = (0, $7BzKB.getIsCurrentViewSharingStakeholdersLoading)(getState());
        const isSharingStakeholdersInitialLoading = (0, $7BzKB.getIsCurrentViewSharingStakeholdersInitialLoading)(getState());
        if (!isSharingStakeholdersInitialLoading && isSharingStakeholdersLoading) return;
        dispatch((0, $2fKlW.setSharingStakeholdersForView)(viewUUID, {
            isLoading: true
        }));
        try {
            (0, $b5oGV.experience).sharing.loadStakeholders.start();
            const stakeholders = await viewRemote.fetchSharingStakeholders(viewUUID);
            dispatch((0, $2fKlW.setSharingStakeholdersForView)(viewUUID, {
                stakeholders: stakeholders
            }));
            const sharingLinkEnabled = (0, $7BzKB.getCurrentViewSharingLinkEnabled)(getState());
            const analyticsAttributes = {
                stakeholdersCount: stakeholders.users.length,
                groupsCount: stakeholders.groups.length,
                isPublished: sharingLinkEnabled === true
            };
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({
                containers: {
                    view: {
                        id: viewAri || '',
                        type: viewKind?.toLowerCase() || ''
                    }
                }
            }), 'stakeholdersList loaded', analyticsAttributes);
            (0, $3Ku0X.sendPendoTrackEvent)({
                actionSubjectAndAction: 'stakeholdersList loaded',
                attributes: analyticsAttributes
            });
            (0, $b5oGV.experience).sharing.loadStakeholders.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-stakeholders-action', error));
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error)) (0, $b5oGV.experience).sharing.loadStakeholders.abort(error);
            else (0, $b5oGV.experience).sharing.loadStakeholders.failure(error);
            dispatch((0, $2fKlW.setSharingStakeholdersForView)(viewUUID, {
                stakeholders: undefined,
                error: error
            }));
        }
    };
const $5f1576dc1cc9db81$export$60473b7d5ed25db0 = (viewUUID, { accountIds: accountIds, emails: emails, groupIds: groupIds }, viewAnalyticsData)=>async ({ dispatch: dispatch }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
        try {
            (0, $b5oGV.experience).sharing.addStakeholders.start();
            const { failures: failures } = await viewRemote.addSharingStakeholders(viewUUID, {
                accountIds: accountIds,
                emails: emails,
                groupIds: groupIds
            });
            await dispatch($5f1576dc1cc9db81$export$98e678eadf48ced1(viewUUID, viewAnalyticsData));
            (0, $b5oGV.experience).sharing.addStakeholders.success();
            return [
                ...failures?.accountIds || [],
                ...failures?.emails || []
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.add-stakeholders-action', error));
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error)) (0, $b5oGV.experience).sharing.addStakeholders.abort(error);
            else (0, $b5oGV.experience).sharing.addStakeholders.failure(error);
            onActionFailed(error);
            return [
                ...accountIds,
                ...emails,
                ...groupIds
            ];
        }
    };
const $5f1576dc1cc9db81$export$4938ea46db8995e9 = (viewUUID, { accountIds: accountIds, groupIds: groupIds })=>async ({ getState: getState, dispatch: dispatch }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
        const state = getState();
        const stakeholders = state.sharingStakeholders[viewUUID]?.stakeholders;
        if (!stakeholders) return;
        try {
            (0, $b5oGV.experience).sharing.removeStakeholders.start();
            await viewRemote.removeSharingStakeholders(viewUUID, {
                accountIds: accountIds,
                groupIds: groupIds
            });
            dispatch((0, $2fKlW.setSharingStakeholdersForView)(viewUUID, {
                stakeholders: {
                    users: stakeholders.users.filter(({ id: id })=>!accountIds.includes(id)),
                    groups: stakeholders.groups.filter(({ id: id })=>!groupIds.includes(id))
                }
            }));
            (0, $b5oGV.experience).sharing.removeStakeholders.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.remove-stakeholders-action', error));
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error)) (0, $b5oGV.experience).sharing.removeStakeholders.abort(error);
            else (0, $b5oGV.experience).sharing.removeStakeholders.failure(error);
            onActionFailed(error);
        }
    };

});

parcelRegister("fJgAQ", function(module, exports) {

$parcel$export(module.exports, "deletePublishedView", () => $d8d7db15ba7c97d2$export$221f60f553707aa8);

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");
const $d8d7db15ba7c97d2$export$221f60f553707aa8 = (viewUUID)=>async (_, { viewRemote: viewRemote })=>{
        try {
            viewUUID && await viewRemote.deleteView(viewUUID);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.delete-published-view-action', error));
        }
    };

});




parcelRegister("kTmHj", function(module, exports) {

$parcel$export(module.exports, "setQuery", () => (parcelRequire("aa1G1")).setQuery);
$parcel$export(module.exports, "routeTo", () => (parcelRequire("of4ZB")).routeTo);
$parcel$export(module.exports, "updateDebouncedRouterActions", () => (parcelRequire("gbYTG")).updateDebouncedRouterActions);
$parcel$export(module.exports, "init", () => (parcelRequire("8rYUw")).init);
$parcel$export(module.exports, "closeIssueView", () => (parcelRequire("dhnQW")).closeIssueView);
$parcel$export(module.exports, "openIssueView", () => (parcelRequire("6SHOe")).openIssueView);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $aa1G1 = parcelRequire("aa1G1");

var $of4ZB = parcelRequire("of4ZB");

var $gbYTG = parcelRequire("gbYTG");

var $8rYUw = parcelRequire("8rYUw");

var $dhnQW = parcelRequire("dhnQW");

var $6SHOe = parcelRequire("6SHOe");

});
parcelRegister("aa1G1", function(module, exports) {

$parcel$export(module.exports, "setQuery", () => $619f7d6a74740af8$export$f3b215b0b382f63b);

var $cSmYj = parcelRequire("cSmYj");

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");

var $3EGZm = parcelRequire("3EGZm");

var $2DPPQ = parcelRequire("2DPPQ");
const $619f7d6a74740af8$export$f3b215b0b382f63b = (newQuery, updateMethod = 'push')=>({ getState: getState })=>{
        const currentQuery = (0, $3EGZm.getPolarisQuerySelector)(getState());
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(currentQuery, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))), (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(newQuery, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))))) return;
        const updatedQuery = newQuery === undefined ? {} : {
            ...currentQuery,
            ...newQuery
        };
        if (updateMethod === 'push') (0, $2DPPQ.default).push(null, updatedQuery);
        else if (updateMethod === 'replace') (0, $2DPPQ.default).replace(null, updatedQuery);
    };

});
parcelRegister("3EGZm", function(module, exports) {

$parcel$export(module.exports, "getCurrentRouteSelector", () => $301f6e82cd0b4e61$export$6ed54c4577135f20);
$parcel$export(module.exports, "getCurrentRouteSectionSelector", () => $301f6e82cd0b4e61$export$e89b8890e02ec45e);
$parcel$export(module.exports, "getPolarisQuerySelector", () => $301f6e82cd0b4e61$export$22f15478f7158013);
$parcel$export(module.exports, "getFullscreenQueryParameter", () => $301f6e82cd0b4e61$export$2f80254b69843b80);
$parcel$export(module.exports, "getSelectedIssueQueryParameter", () => $301f6e82cd0b4e61$export$98dec4fb5dc92495);
$parcel$export(module.exports, "getIssueTypeIdQueryParameter", () => $301f6e82cd0b4e61$export$24444cbecc766a00);
$parcel$export(module.exports, "getSidebarQueryParameter", () => $301f6e82cd0b4e61$export$4a1e7cde96b78c66);
$parcel$export(module.exports, "getRoadmapQueryParameter", () => $301f6e82cd0b4e61$export$ff036e0f4253074b);
$parcel$export(module.exports, "getIssueViewLayout", () => $301f6e82cd0b4e61$export$bef822310ccdf5ea);
$parcel$export(module.exports, "getIsIssueOpenInFullscreen", () => $301f6e82cd0b4e61$export$654211dcd797740);
$parcel$export(module.exports, "getIsIssueOpenInSidebar", () => $301f6e82cd0b4e61$export$2f14425c0214c341);
$parcel$export(module.exports, "getIssueViewSection", () => $301f6e82cd0b4e61$export$efd29462b8885d3b);

var $ahm5r = parcelRequire("ahm5r");

var $kF1zg = parcelRequire("kF1zg");


var $e6XlU = parcelRequire("e6XlU");
const $301f6e82cd0b4e61$export$52f9a505981b3b1a = (state)=>state.containerProps;
const $301f6e82cd0b4e61$var$getConfiguredRouteSelector = (0, $ahm5r.createSelector)((state)=>state.containerProps?.resource, (state)=>state.containerProps?.section, (state)=>state.routeFromStorage, (resource, section, routeFromStorage)=>{
    if (section !== undefined && section !== null) return {
        section: section,
        resource: resource
    };
    return routeFromStorage;
});
const $301f6e82cd0b4e61$var$getDefaultRouteSelector = (0, $ahm5r.createSelector)((state)=>state.containerProps?.defaultSection, (state)=>state.containerProps?.defaultResource, (section, resource)=>({
        section: section || (0, $446867fcb16be82a$export$4fce57eba3db1f42),
        resource: resource
    }));
const $301f6e82cd0b4e61$var$getHasSelectedIssueQueryParameter = (0, $ahm5r.createSelector)((state)=>state.containerProps?.query.selectedIssue, (selectedIssue)=>selectedIssue !== undefined && !!(0, $e6XlU.POLARIS_QUERY_VALID_VALUES).selectedIssue(selectedIssue));
const $301f6e82cd0b4e61$export$6ed54c4577135f20 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$var$getDefaultRouteSelector, $301f6e82cd0b4e61$var$getConfiguredRouteSelector, $301f6e82cd0b4e61$var$getHasSelectedIssueQueryParameter, (state)=>state.containerProps?.allowedSections, (defaultRoute, configuredRoute, hasSelectedIssueQueryParam, allowedSections)=>{
    if (configuredRoute !== undefined && configuredRoute.section !== undefined && allowedSections?.includes(configuredRoute.section) && !(configuredRoute.section !== (0, $446867fcb16be82a$export$4fce57eba3db1f42) && hasSelectedIssueQueryParam)) return configuredRoute;
    return defaultRoute;
});
const $301f6e82cd0b4e61$export$e89b8890e02ec45e = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$6ed54c4577135f20, (currentRoute)=>currentRoute.section);
const $301f6e82cd0b4e61$var$getQueryValidValues = (state)=>state.containerProps?.queryValidValues;
const $301f6e82cd0b4e61$export$22f15478f7158013 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$var$getQueryValidValues, (0, $ahm5r.createStructuredSelector)((0, $kF1zg.getTypedKeys)((0, $e6XlU.POLARIS_QUERY_VALID_VALUES)).reduce((result, key)=>Object.assign(result, {
        [key]: (0, $ahm5r.createSelector)((state)=>state.containerProps?.query[key], (queryValue)=>{
            if (!queryValue) return undefined;
            const validator = (0, $e6XlU.POLARIS_QUERY_VALID_VALUES)[key];
            return validator(queryValue) ? queryValue : undefined;
        })
    }), {})), (queryValidValues, values)=>{
    const query = {};
    if (!queryValidValues) return query;
    return Object.keys(queryValidValues).reduce((result, key)=>{
        if (values[key] !== undefined) return Object.assign(result, {
            [key]: values[key]
        });
        return result;
    }, query);
});
const $301f6e82cd0b4e61$export$3c0b42d742ff4f88 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.issueViewLayout);
const $301f6e82cd0b4e61$export$12070c9eae7402b0 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.issueViewSection);
const $301f6e82cd0b4e61$export$2f80254b69843b80 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.fullscreen === 'true');
const $301f6e82cd0b4e61$export$98dec4fb5dc92495 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.selectedIssue);
const $301f6e82cd0b4e61$export$24444cbecc766a00 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.issueTypeId);
const $301f6e82cd0b4e61$export$4a1e7cde96b78c66 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.sidebar);
const $301f6e82cd0b4e61$export$ff036e0f4253074b = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.roadmap);
const $301f6e82cd0b4e61$export$bef822310ccdf5ea = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$3c0b42d742ff4f88, (issueViewLayout)=>issueViewLayout === (0, $e6XlU.POLARIS_QUERY_ISSUE_VIEW_SIDEBAR) ? issueViewLayout : undefined);
const $301f6e82cd0b4e61$export$654211dcd797740 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$bef822310ccdf5ea, $301f6e82cd0b4e61$export$98dec4fb5dc92495, (issueViewLayout, selectedIssue)=>issueViewLayout === undefined && selectedIssue !== undefined);
const $301f6e82cd0b4e61$export$2f14425c0214c341 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$bef822310ccdf5ea, $301f6e82cd0b4e61$export$98dec4fb5dc92495, (issueViewLayout, selectedIssue)=>issueViewLayout !== undefined && selectedIssue !== undefined);
const $301f6e82cd0b4e61$export$efd29462b8885d3b = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$2f14425c0214c341, $301f6e82cd0b4e61$export$12070c9eae7402b0, $301f6e82cd0b4e61$export$98dec4fb5dc92495, (isIssueOpenInSidebar, issueViewSection, selectedIssue)=>{
    if (selectedIssue === undefined) return undefined;
    return isIssueOpenInSidebar ? issueViewSection ?? (0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR) : issueViewSection ?? (0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN);
});

});
const $446867fcb16be82a$export$4fce57eba3db1f42 = 'view';

parcelRegister("e6XlU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR", () => $e146381bfb078229$export$fc856e90af6063b7);
$parcel$export(module.exports, "DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN", () => $e146381bfb078229$export$44ed4fbe898cb41a);
$parcel$export(module.exports, "POLARIS_QUERY_ISSUE_VIEW_SIDEBAR", () => $e146381bfb078229$export$66d4646147c88e69);
$parcel$export(module.exports, "POLARIS_QUERY_VALID_VALUES", () => $e146381bfb078229$export$f6bbbc8ed0d13331);
const $e146381bfb078229$export$fc856e90af6063b7 = 'overview';
const $e146381bfb078229$export$44ed4fbe898cb41a = 'comments';
const $e146381bfb078229$export$66d4646147c88e69 = 'sidebar';
const $e146381bfb078229$var$POLARIS_QUERY_ISSUE_VIEW_SECTIONS = [
    'overview',
    'capture',
    'comments',
    'deliver',
    'history',
    'connections'
].reduce((result, section)=>Object.assign(result, {
        [section]: true
    }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
{});
const $e146381bfb078229$export$f6bbbc8ed0d13331 = {
    selectedIssue: (value)=>typeof value === 'string',
    issueViewLayout: (value)=>value === $e146381bfb078229$export$66d4646147c88e69,
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'IssueViewSection'.
    issueViewSection: (value)=>$e146381bfb078229$var$POLARIS_QUERY_ISSUE_VIEW_SECTIONS[value],
    fullscreen: (value)=>value === 'true',
    viewCommentId: (value)=>typeof value === 'string',
    previewRole: (value)=>typeof value === 'string',
    landingViewRank: (value)=>typeof value === 'string',
    openIdeaCreationModal: (value)=>value === 'true',
    sidebar: (value)=>value === 'settings' || value === 'about',
    roadmap: (value)=>value !== '',
    issueTypeId: (value)=>value !== ''
};

});


parcelRegister("2DPPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6dd63bce47cd5d2$export$2e2bcd8739ae039);

var $cxpIO = parcelRequire("cxpIO");
class $a6dd63bce47cd5d2$export$843577d117cf4ba3 {
    constructor(){
        this.pushTimeout = undefined;
        this.replaceTimeout = undefined;
        this.currentPath = undefined;
        this.currentQuery = undefined;
        this.newPath = undefined;
        this.newQuery = undefined;
        this.nativePush = undefined;
        this.nativeReplace = undefined;
    }
    setCurrentState(currentPath, currentQuery) {
        this.currentPath = currentPath;
        this.currentQuery = currentQuery;
    }
    setNativeRouterMethods(nativePush, nativeReplace) {
        this.nativePush = nativePush;
        this.nativeReplace = nativeReplace;
    }
    setNewState(newPath, newQuery) {
        this.newQuery = newQuery ?? this.newQuery ?? this.currentQuery ?? {};
        this.newPath = newPath ?? this.newPath ?? this.currentPath;
    }
    resetNewState() {
        this.newQuery = undefined;
        this.newPath = undefined;
    }
    getNewUrl() {
        return `${this.newPath ?? ''}${(0, $cxpIO.createQueryStringPostfix)(this.newQuery ?? {})}`;
    }
    clearTimeouts() {
        clearTimeout(this.pushTimeout);
        clearTimeout(this.replaceTimeout);
    }
    push(newPath, newQuery) {
        this.setNewState(newPath, newQuery);
        this.clearTimeouts();
        this.pushTimeout = setTimeout(()=>{
            this.pushTimeout = undefined;
            this.nativePush?.(this.getNewUrl());
            this.resetNewState();
        }, 0);
    }
    replace(newPath, newQuery) {
        this.setNewState(newPath, newQuery);
        this.clearTimeouts();
        this.replaceTimeout = setTimeout(()=>{
            this.replaceTimeout = undefined;
            this.nativeReplace?.(this.getNewUrl());
            this.resetNewState();
        }, 0);
    }
}
// global debounce function in order to catch all usages of push() and replace()
const $a6dd63bce47cd5d2$var$debouncedRouterActions = new $a6dd63bce47cd5d2$export$843577d117cf4ba3();
var $a6dd63bce47cd5d2$export$2e2bcd8739ae039 = $a6dd63bce47cd5d2$var$debouncedRouterActions;

});
parcelRegister("cxpIO", function(module, exports) {

$parcel$export(module.exports, "createQueryStringPostfix", () => $36f232912babeac2$export$c6cd7780eb5a242f);

var $dw68A = parcelRequire("dw68A");

var $3zv7S = parcelRequire("3zv7S");
const $36f232912babeac2$export$c6cd7780eb5a242f = (query, keysToDrop)=>{
    // @ts-expect-error - TS2769 - No overload matches this call.
    const paramsList = (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(query, (agg, val, key)=>{
        if (val === undefined || keysToDrop && keysToDrop.includes(key)) return agg;
        return [
            ...agg,
            `${key}=${val}`
        ];
    }, []);
    if (paramsList.length === 0) return '';
    const flatGetParams = (0, (/*@__PURE__*/$parcel$interopDefault($dw68A)))(paramsList, '&');
    return `?${flatGetParams}`;
};

});
parcelRegister("3zv7S", function(module, exports) {

var $2x6Yt = parcelRequire("2x6Yt");

var $c3u3c = parcelRequire("c3u3c");

var $1lM9j = parcelRequire("1lM9j");

var $aiJg7 = parcelRequire("aiJg7");

var $4sprp = parcelRequire("4sprp");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $299cc8f655bd088e$var$reduce(collection, iteratee, accumulator) {
    var func = $4sprp(collection) ? $2x6Yt : $aiJg7, initAccum = arguments.length < 3;
    return func(collection, $1lM9j(iteratee, 4), accumulator, initAccum, $c3u3c);
}
module.exports = $299cc8f655bd088e$var$reduce;

});
parcelRegister("aiJg7", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $77feb151e6770379$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $77feb151e6770379$var$baseReduce;

});





parcelRegister("of4ZB", function(module, exports) {

$parcel$export(module.exports, "routeTo", () => $5af5c020377f9bbd$export$7464a66e30a44643);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3EGZm = parcelRequire("3EGZm");

var $2DPPQ = parcelRequire("2DPPQ");

var $cxpIO = parcelRequire("cxpIO");

var $haA3H = parcelRequire("haA3H");
const $5af5c020377f9bbd$export$7464a66e30a44643 = (route, params)=>({ getState: getState }, { getAppUrl: getAppUrl, storageKey: storageKey, useNativeReplaceMethod: useNativeReplaceMethod })=>{
        const routeParams = {
            clearParameters: true,
            replaceInHistory: false,
            saveStorageRouteSlug: true,
            ...params
        };
        const { clearParameters: clearParameters, replaceInHistory: replaceInHistory, saveStorageRouteSlug: saveStorageRouteSlug } = routeParams;
        const currentRoute = (0, $3EGZm.getCurrentRouteSelector)(getState());
        const currentQuery = (0, $3EGZm.getPolarisQuerySelector)(getState());
        if (route.section === currentRoute.section && route.resource === currentRoute.resource) // same route, early exit
        return;
        const url = `${getAppUrl(route)}${clearParameters ? '' : (0, $cxpIO.createQueryStringPostfix)(currentQuery)}`;
        if (replaceInHistory) useNativeReplaceMethod(url);
        else (0, $2DPPQ.default).push(getAppUrl(route), clearParameters ? {} : undefined);
        if (saveStorageRouteSlug && storageKey !== undefined) (0, $haA3H.setStorageRouteSlug)({
            ...route,
            storageKey: storageKey
        });
    };

});
parcelRegister("haA3H", function(module, exports) {

$parcel$export(module.exports, "setStorageRouteSlug", () => $b4a3eb6c229d0d79$export$a22fe837277f4dd0);
$parcel$export(module.exports, "getStorageRouteSlugWithLegacySupport", () => $b4a3eb6c229d0d79$export$ca6a8f450b3093a6);
$parcel$export(module.exports, "getStorageRouteSlug", () => $b4a3eb6c229d0d79$export$bba59e976bdd53ea);

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
const $b4a3eb6c229d0d79$var$storage = (0, $dnU6V.createLocalStorageProvider)('polaris');
const $b4a3eb6c229d0d79$var$ROUTE_SLUG_STORAGE_KEY = 'routeslug';
const $b4a3eb6c229d0d79$export$a22fe837277f4dd0 = (route)=>{
    if ((0, $7jTnu.fg)('polaris_functional_storage_killswitch')) return;
    $b4a3eb6c229d0d79$var$storage.set($b4a3eb6c229d0d79$var$ROUTE_SLUG_STORAGE_KEY, route);
};
const $b4a3eb6c229d0d79$export$ca6a8f450b3093a6 = ()=>{
    if ((0, $7jTnu.fg)('polaris_functional_storage_killswitch')) return;
    const localRouteSlug = $b4a3eb6c229d0d79$var$storage.get('routeslug');
    if (localRouteSlug !== null && localRouteSlug !== undefined) return localRouteSlug;
    const legacyLocalRouteSlug = $b4a3eb6c229d0d79$var$storage.get('viewslug');
    if (legacyLocalRouteSlug !== null && legacyLocalRouteSlug !== undefined) return {
        section: legacyLocalRouteSlug.section,
        resource: legacyLocalRouteSlug.id
    };
    return undefined;
};
const $b4a3eb6c229d0d79$export$bba59e976bdd53ea = ()=>{
    if ((0, $7jTnu.fg)('polaris_functional_storage_killswitch')) return;
    return $b4a3eb6c229d0d79$var$storage.get($b4a3eb6c229d0d79$var$ROUTE_SLUG_STORAGE_KEY);
};

});


parcelRegister("gbYTG", function(module, exports) {

$parcel$export(module.exports, "updateDebouncedRouterActions", () => $d69c7f2482163fea$export$e203da31a87d8a65);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3EGZm = parcelRequire("3EGZm");

var $2DPPQ = parcelRequire("2DPPQ");
const $d69c7f2482163fea$export$e203da31a87d8a65 = ()=>({ getState: getState }, { getAppUrl: getAppUrl, useNativePushMethod: useNativePushMethod, useNativeReplaceMethod: useNativeReplaceMethod })=>{
        (0, $2DPPQ.default).setNativeRouterMethods(useNativePushMethod, useNativeReplaceMethod);
        const currentQuery = (0, $3EGZm.getPolarisQuerySelector)(getState());
        const currentRoute = (0, $3EGZm.getCurrentRouteSelector)(getState());
        const path = getAppUrl?.(currentRoute);
        if (getAppUrl !== undefined) (0, $2DPPQ.default).setCurrentState(path, currentQuery);
    };

});

parcelRegister("8rYUw", function(module, exports) {

$parcel$export(module.exports, "init", () => $4de1af4526f85389$export$2cd8252107eb640b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");


var $3EGZm = parcelRequire("3EGZm");

var $cxpIO = parcelRequire("cxpIO");

var $haA3H = parcelRequire("haA3H");
const $4de1af4526f85389$export$2cd8252107eb640b = ()=>({ getState: getState, setState: setState }, { getAppUrl: getAppUrl, storageKey: storageKey, section: section, useNativeReplaceMethod: useNativeReplaceMethod })=>{
        const storage = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? (0, $haA3H.getStorageRouteSlug)() : (0, $haA3H.getStorageRouteSlugWithLegacySupport)();
        // use storage route only if it's related to current project
        if (storage && storage.storageKey === storageKey) {
            setState({
                routeFromStorage: {
                    section: storage.section,
                    resource: storage.resource
                }
            });
            const currentQuery = (0, $3EGZm.getPolarisQuerySelector)(getState());
            if (storage === undefined || section !== undefined || storage.section === 'settings' && storage.resource === 'workflow' || storage.section !== (0, $446867fcb16be82a$export$4fce57eba3db1f42) && currentQuery.selectedIssue || storage.storageKey !== undefined && storage.storageKey !== storageKey || storageKey === undefined || getAppUrl === undefined) return;
            useNativeReplaceMethod(`${getAppUrl({
                resource: storage.resource,
                section: storage.section
            })}${(0, $cxpIO.createQueryStringPostfix)(currentQuery)}`);
        }
    };

});

parcelRegister("dhnQW", function(module, exports) {

$parcel$export(module.exports, "closeIssueView", () => $3400a72246cd239f$export$ba15dd71fa7afe95);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $aa1G1 = parcelRequire("aa1G1");
const $3400a72246cd239f$export$ba15dd71fa7afe95 = ()=>({ dispatch: dispatch })=>{
        dispatch((0, $aa1G1.setQuery)({
            selectedIssue: undefined,
            issueViewLayout: undefined,
            issueViewSection: undefined,
            viewCommentId: undefined
        }));
    };

});

parcelRegister("6SHOe", function(module, exports) {

$parcel$export(module.exports, "openIssueView", () => $93a1443f3697b1db$export$611cbcf98e4cfb6e);

var $b5oGV = parcelRequire("b5oGV");

var $3EGZm = parcelRequire("3EGZm");

var $e6XlU = parcelRequire("e6XlU");

var $aa1G1 = parcelRequire("aa1G1");
const $93a1443f3697b1db$var$getNextSection = ({ layout: layout, section: ideaViewSection }, currSidebarSection)=>{
    if (layout === 'sidebar') return ideaViewSection ?? currSidebarSection ?? (0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR);
    return ideaViewSection ?? (0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN);
};
const $93a1443f3697b1db$export$611cbcf98e4cfb6e = (issueKey, { layout: layout, section: ideaViewSection } = {})=>({ dispatch: dispatch, getState: getState }, { section: section })=>{
        const query = (0, $3EGZm.getPolarisQuerySelector)(getState());
        // replace state instead of push if only change tab
        const updateQueryMethod = issueKey === query?.selectedIssue && layout === query?.issueViewLayout && section !== query?.issueViewSection ? 'replace' : 'push';
        if (updateQueryMethod === 'push') {
            (0, $b5oGV.experience).ideaView.pageSegmentLoad.abort();
            (0, $b5oGV.experience).ideaView.pageSegmentLoad.start();
        }
        dispatch((0, $aa1G1.setQuery)({
            selectedIssue: issueKey,
            issueViewLayout: layout,
            issueViewSection: $93a1443f3697b1db$var$getNextSection({
                layout: layout,
                section: ideaViewSection
            }, query.issueViewSection),
            viewCommentId: undefined
        }, updateQueryMethod));
    };

});


parcelRegister("7a8xH", function(module, exports) {

$parcel$export(module.exports, "useUrlSection", () => $c906b70bebfc4367$export$47d0b879d0f8a136);
$parcel$export(module.exports, "useUrlResource", () => $c906b70bebfc4367$export$cf5a91dc1cc71b53);

var $2FqDG = parcelRequire("2FqDG");


const $c906b70bebfc4367$export$47d0b879d0f8a136 = ()=>{
    const [section] = (0, $2FqDG.usePathParam)('section');
    return section === 'views' ? 'view' : section;
};
const $c906b70bebfc4367$export$cf5a91dc1cc71b53 = ()=>{
    const [resource] = (0, $2FqDG.usePathParam)('resource');
    return resource;
};

});


parcelRegister("avFSu", function(module, exports) {

$parcel$export(module.exports, "useIsViewsLoading", () => $a1cca76de2232346$export$404be7717f5d29e6);

var $6Mk0X = parcelRequire("6Mk0X");

var $a7FjO = parcelRequire("a7FjO");
const $a1cca76de2232346$export$404be7717f5d29e6 = (0, $a7FjO.createViewHook)((0, $6Mk0X.isViewsLoading));

});
parcelRegister("6Mk0X", function(module, exports) {

$parcel$export(module.exports, "isViewsLoading", () => $d1c5bb7124270dcb$export$d908f720933c056e);
$parcel$export(module.exports, "getDeliveryDataFetchError", () => $d1c5bb7124270dcb$export$db60479ca7d442b2);
const $d1c5bb7124270dcb$export$d908f720933c056e = (state)=>state.meta.loading;
const $d1c5bb7124270dcb$export$db60479ca7d442b2 = (state)=>state.meta.deliveryDataFetchError;

});

parcelRegister("a7FjO", function(module, exports) {

$parcel$export(module.exports, "createViewHook", () => $9451816a7a4e200f$export$a0dbac351bbf710a);
$parcel$export(module.exports, "createHigherLevelViewHook", () => $9451816a7a4e200f$export$5273bba48581bfc2);

var $Xp2c2 = parcelRequire("Xp2c2");
const $9451816a7a4e200f$export$a0dbac351bbf710a = (0, $Xp2c2.createViewHook);
const $9451816a7a4e200f$export$5273bba48581bfc2 = (selectorCreator)=>(0, $Xp2c2.createHigherLevelViewHook)(selectorCreator);

});
parcelRegister("Xp2c2", function(module, exports) {

$parcel$export(module.exports, "createViewHook", () => $ba3bfcea34bce038$export$a0dbac351bbf710a);
$parcel$export(module.exports, "createHigherLevelViewHook", () => $ba3bfcea34bce038$export$5273bba48581bfc2);
$parcel$export(module.exports, "useViewActions", () => $ba3bfcea34bce038$export$8bf8bf45ee2d86e4);
$parcel$export(module.exports, "InnerViewContainer", () => $ba3bfcea34bce038$export$5aabefc5089a8c3f);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $exWdq = parcelRequire("exWdq");

var $12DRg = parcelRequire("12DRg");

var $6zXPf = parcelRequire("6zXPf");

var $8oKDI = parcelRequire("8oKDI");

var $i9xQN = parcelRequire("i9xQN");

var $1V8kw = parcelRequire("1V8kw");

var $6x8n3 = parcelRequire("6x8n3");

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $2zEZy = parcelRequire("2zEZy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $jDdjf = parcelRequire("jDdjf");

var $kmMXp = parcelRequire("kmMXp");

var $6BmVy = parcelRequire("6BmVy");


var $jiBgT = parcelRequire("jiBgT");

var $kYdmg = parcelRequire("kYdmg");

var $8uL8I = parcelRequire("8uL8I");

var $7buaW = parcelRequire("7buaW");

var $k1VCL = parcelRequire("k1VCL");

var $2zM3c = parcelRequire("2zM3c");
const $ba3bfcea34bce038$export$ca6edce86ee14be8 = (0, $jxALV.createPolarisStore)({
    name: 'PolarisViewStore',
    initialState: $k1VCL.initialState,
    actions: $8uL8I.actions
});
const { Container: $ba3bfcea34bce038$var$Container, useActions: $ba3bfcea34bce038$var$useActions, createHook: $ba3bfcea34bce038$var$createHook, createHigherLevelHook: $ba3bfcea34bce038$var$createHigherLevelHook } = (0, $YvHeB.createJpdContainer)($ba3bfcea34bce038$export$ca6edce86ee14be8, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $7buaW.loadViews)(true));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { currentViewSlug: currentViewSlug })=>{
            dispatch((0, $7buaW.loadViews)());
            if ((0, $6zXPf.getWillShowNav4)() && currentViewSlug) dispatch((0, $kYdmg.setCurrentViewFromRoute)());
        }
});
const $ba3bfcea34bce038$export$a0dbac351bbf710a = $ba3bfcea34bce038$var$createHook;
const $ba3bfcea34bce038$export$5273bba48581bfc2 = $ba3bfcea34bce038$var$createHigherLevelHook;
const $ba3bfcea34bce038$var$ViewSweetStateContainer = $ba3bfcea34bce038$var$Container;
const $ba3bfcea34bce038$export$8bf8bf45ee2d86e4 = $ba3bfcea34bce038$var$useActions;
const $ba3bfcea34bce038$var$useDebouncedRefreshViewComments = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { loadViewComments: loadViewComments } = $ba3bfcea34bce038$export$8bf8bf45ee2d86e4();
    const cloudId = (0, $kmMXp.useCloudId)();
    return (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const funcCache = {};
        return (viewIdOrAri)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(funcCache, viewIdOrAri)) funcCache[viewIdOrAri] = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'JpdJiraRealtimeEvent refreshViewComments');
                const ari = (0, $8oKDI.toAri)(viewIdOrAri) || (0, $jDdjf.createViewAri)(cloudId, viewIdOrAri);
                loadViewComments(ari, true);
            }, (0, $c91d3dca4b4a5f9e$export$6b2efece5b1a2158));
            funcCache[viewIdOrAri]();
        };
    }, [
        cloudId,
        createAnalyticsEvent,
        loadViewComments
    ]);
};
const $ba3bfcea34bce038$var$ViewContainerInternal = ({ fields: fields })=>{
    const onRefreshViewComments = $ba3bfcea34bce038$var$useDebouncedRefreshViewComments();
    const { deleteViewFromState: deleteViewFromState, loadView: loadView, refreshArrangementInformation: refreshArrangementInformation, refreshViewsRanks: refreshViewsRanks, deleteSectionFromState: deleteSectionFromState, loadSection: loadSection } = $ba3bfcea34bce038$export$8bf8bf45ee2d86e4();
    const { showFlag: showFlag } = (0, $6x8n3.useNotifications)();
    const currentUserId = (0, $jiBgT.useCurrentUserAccountId)();
    const projectId = (0, $i9xQN.useProjectIdUnsafe)();
    const cloudId = (0, $kmMXp.useCloudId)();
    const handleDeleteView = (0, $eJOHy.useCallback)(async (id, viewUUID, userId)=>{
        const { isCurrentView: isCurrentView } = deleteViewFromState(id);
        if (isCurrentView && userId !== currentUserId) {
            const userName = await (0, $6BmVy.getUserName)(userId);
            showFlag({
                messageId: 'polaris-common.controllers.views.show-flag.warning.view-deleted',
                messageType: 'transactional',
                id: 'polaris.real-time-event-delete-view',
                type: 'warning',
                title: [
                    (0, $2zM3c.default).viewDeleted,
                    {
                        userName: userName
                    }
                ],
                isAutoDismiss: true
            });
        }
    }, [
        deleteViewFromState,
        showFlag,
        currentUserId
    ]);
    const handleCreateView = (0, $eJOHy.useMemo)(()=>async (id, uuid, view)=>{
            const remoteView = view ? (0, $2zEZy.transformView)(view, fields) : view;
            await loadView(id, remoteView);
        }, [
        loadView,
        fields
    ]);
    const handleUpdateView = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const funcCache = {};
        const callback = async (props)=>{
            const { viewId: viewId, userId: userId, changes: changes, view: view } = props;
            if ((0, $6zXPf.getWillShowNav4)() && (changes?.includes('name') || changes?.includes('emoji')) && changes?.includes('*') && changes?.length === 2) // We don't need to update the the main app state for name and emoji changes when nav4 is enabled
            return;
            const remoteView = view ? (0, $2zEZy.transformView)(view, fields) : undefined;
            const { isDraftReset: isDraftReset } = await loadView(viewId, remoteView);
            if (userId === currentUserId) return;
            const userName = await (0, $6BmVy.getUserName)(userId);
            if (isDraftReset) showFlag({
                messageId: 'polaris-common.controllers.views.show-flag.warning.view-updated',
                messageType: 'transactional',
                id: 'polaris.real-time-event-update-view',
                type: 'warning',
                title: [
                    (0, $2zM3c.default).viewUpdated,
                    {
                        userName: userName
                    }
                ],
                isAutoDismiss: true
            });
        };
        return (props)=>{
            const { viewId: viewId, view: view } = props;
            if (view) {
                callback(props);
                return;
            }
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(funcCache, viewId)) funcCache[viewId] = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(callback, (0, $c91d3dca4b4a5f9e$export$6b2efece5b1a2158));
            funcCache[viewId](props);
        };
    }, [
        loadView,
        showFlag,
        fields,
        currentUserId
    ]);
    const handleUpdateViewArrangementInfo = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const funcCache = {};
        return (id)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(funcCache, id)) funcCache[id] = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
                const viewAri = (0, $jDdjf.createViewAri)(cloudId, id.toString());
                refreshArrangementInformation(viewAri);
            }, (0, $c91d3dca4b4a5f9e$export$6b2efece5b1a2158));
            funcCache[id]();
        };
    }, [
        cloudId,
        refreshArrangementInformation
    ]);
    const debouncedRefreshViewsRanks = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(refreshViewsRanks, (0, $c91d3dca4b4a5f9e$export$6b2efece5b1a2158)), [
        refreshViewsRanks
    ]);
    const handleRefreshViewsRanks = (0, $eJOHy.useCallback)(()=>debouncedRefreshViewsRanks(), [
        debouncedRefreshViewsRanks
    ]);
    const handleRefreshViewSetsRanks = (0, $eJOHy.useCallback)(()=>debouncedRefreshViewsRanks(), [
        debouncedRefreshViewsRanks
    ]);
    const handleCreateViewSet = (0, $eJOHy.useCallback)((id)=>loadSection(id), [
        loadSection
    ]);
    const handleUpdateViewSet = (0, $eJOHy.useCallback)((id)=>loadSection(id, true), [
        loadSection
    ]);
    const handleDeleteViewSet = (0, $eJOHy.useCallback)((id)=>deleteSectionFromState(id), [
        deleteSectionFromState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1V8kw.ViewRealtimeHandler), {
        projectId: projectId,
        onRefreshViewComments: onRefreshViewComments,
        onDeleteView: handleDeleteView,
        onCreateView: handleCreateView,
        onUpdateView: handleUpdateView,
        onUpdateViewArrangementInfo: handleUpdateViewArrangementInfo,
        // We don't need to update the the main app state for views sets changes when nav4 is enabled
        onCreateViewSet: (0, $6zXPf.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : handleCreateViewSet,
        onDeleteViewSet: (0, $6zXPf.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : handleDeleteViewSet,
        onUpdateViewSet: (0, $6zXPf.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : handleUpdateViewSet,
        onUpdateViewsRanks: (0, $6zXPf.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : handleRefreshViewsRanks,
        onUpdateViewSetsRanks: (0, $6zXPf.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : handleRefreshViewSetsRanks
    }));
};
const $ba3bfcea34bce038$export$5aabefc5089a8c3f = (props)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba3bfcea34bce038$var$ViewSweetStateContainer, rest, rest.isSharedView ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba3bfcea34bce038$var$ViewContainerInternal, {
        fields: props.fields
    }), children);
};

});
parcelRegister("i9xQN", function(module, exports) {

$parcel$export(module.exports, "useProjectKeyUnsafe", () => $ab379669dffbf3b6$export$cc8ee22ee3f2f318);
$parcel$export(module.exports, "useProjectId", () => $ab379669dffbf3b6$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectIdUnsafe", () => $ab379669dffbf3b6$export$cc20886ed30182f);
$parcel$export(module.exports, "useProjectAri", () => $ab379669dffbf3b6$export$8688254b761eadc4);
$parcel$export(module.exports, "useProjectAriUnsafe", () => $ab379669dffbf3b6$export$a3ec673e48048bbe);
$parcel$export(module.exports, "useIsInCollectionContainer", () => $ab379669dffbf3b6$export$42a2e0275a4c8d25);
$parcel$export(module.exports, "useEnvironmentContainer", () => (parcelRequire("3Jfcg")).useEnvironmentContainer);

var $3Jfcg = parcelRequire("3Jfcg");

var $9XFdQ = parcelRequire("9XFdQ");



var $9XFdQ = parcelRequire("9XFdQ");
const $ab379669dffbf3b6$export$f87be37f8e8be65 = ()=>{
    const container = (0, $3Jfcg.useEnvironmentContainer)();
    if (container?.type === (0, $9XFdQ.PolarisEnvironmentContainerTypes).PROJECT) return container.projectKey;
    return undefined;
};
const $ab379669dffbf3b6$export$cc8ee22ee3f2f318 = ()=>{
    const projectKey = $ab379669dffbf3b6$export$f87be37f8e8be65();
    return projectKey || '';
};
const $ab379669dffbf3b6$export$16d1475ed6c26568 = ()=>{
    const container = (0, $3Jfcg.useEnvironmentContainer)();
    if (container?.type === (0, $9XFdQ.PolarisEnvironmentContainerTypes).PROJECT) return container.projectId;
    return undefined;
};
const $ab379669dffbf3b6$export$cc20886ed30182f = ()=>{
    const projectId = $ab379669dffbf3b6$export$16d1475ed6c26568();
    return projectId || '';
};
const $ab379669dffbf3b6$export$8688254b761eadc4 = ()=>{
    const container = (0, $3Jfcg.useEnvironmentContainer)();
    if (container?.type === (0, $9XFdQ.PolarisEnvironmentContainerTypes).PROJECT) return container.projectAri.toString();
    return undefined;
};
const $ab379669dffbf3b6$export$a3ec673e48048bbe = (fallbackAri = '')=>{
    const projectAri = $ab379669dffbf3b6$export$8688254b761eadc4();
    return projectAri || fallbackAri;
};
const $ab379669dffbf3b6$export$42a2e0275a4c8d25 = ()=>{
    const container = (0, $3Jfcg.useEnvironmentContainer)();
    return container?.type === (0, $9XFdQ.PolarisEnvironmentContainerTypes).COLLECTION;
};
const $ab379669dffbf3b6$export$46245f35ef91e9c0 = ()=>{
    const container = (0, $3Jfcg.useEnvironmentContainer)();
    return container?.type === (0, $9XFdQ.PolarisEnvironmentContainerTypes).VIEW;
};

});

parcelRegister("1V8kw", function(module, exports) {

$parcel$export(module.exports, "ViewRealtimeHandler", () => $bc9e5f92a9cad919$export$3f0dc95239c6c49e);

var $eJOHy = parcelRequire("eJOHy");

var $4jVkB = parcelRequire("4jVkB");

var $2wImr = parcelRequire("2wImr");

var $ftN6c = parcelRequire("ftN6c");

var $aFz1q = parcelRequire("aFz1q");

var $cU7LI = parcelRequire("cU7LI");

var $geEXa = parcelRequire("geEXa");

var $jszQC = parcelRequire("jszQC");
const $bc9e5f92a9cad919$export$3f0dc95239c6c49e = /*#__PURE__*/ (0, $eJOHy.memo)(({ projectId: projectId, onRefreshViewComments: onRefreshViewComments, onDeleteView: onDeleteView, onCreateView: onCreateView, onUpdateView: onUpdateView, onUpdateViewArrangementInfo: onUpdateViewArrangementInfo, onUpdateViewsRanks: onUpdateViewsRanks, onCreateViewSet: onCreateViewSet, onDeleteViewSet: onDeleteViewSet, onUpdateViewSet: onUpdateViewSet, onUpdateViewSetsRanks: onUpdateViewSetsRanks })=>{
    const projectChannels = (0, $2wImr.useRealtimeProjectChannel)(projectId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onReceive = (0, $eJOHy.useCallback)((event)=>{
        if ((0, $geEXa.isViewCommentEvent)(event)) {
            const viewId = event.payload.viewAri || event.payload.viewId;
            onRefreshViewComments(viewId);
        }
        if ((0, $geEXa.isViewEvent)(event)) {
            const { viewId: viewId, viewUUID: viewUUID, changes: changes, userId: userId, view: view } = event.payload;
            switch(event.type){
                case 0, $cU7LI.VIEW_DELETED_EVENT:
                    onDeleteView(viewId, viewUUID, userId);
                    break;
                case 0, $cU7LI.VIEW_CREATED_EVENT:
                    {
                        const viewFromPayload = view && (0, $jszQC.validateViewPayload)((0, $jszQC.enrichViewPayload)(view), createAnalyticsEvent, (0, $jszQC.onValidationError)) ? (0, $jszQC.enrichViewPayload)(view) : null;
                        onCreateView(viewId, viewUUID, viewFromPayload);
                        break;
                    }
                case 0, $cU7LI.VIEW_UPDATED_EVENT:
                    if (changes?.includes('*')) {
                        const viewFromPayload = view && (0, $jszQC.validateViewPayload)((0, $jszQC.enrichViewPayload)(view), createAnalyticsEvent, (0, $jszQC.onValidationError)) ? (0, $jszQC.enrichViewPayload)(view) : null;
                        onUpdateView({
                            ...event.payload,
                            view: viewFromPayload
                        });
                        return;
                    }
                    if (changes?.includes('arrangement-info')) onUpdateViewArrangementInfo(viewId, viewUUID);
                    if (changes?.includes('rank')) onUpdateViewsRanks();
                    break;
                default:
                    break;
            }
            return;
        }
        if ((0, $geEXa.isViewSetEvent)(event)) {
            const { viewSetId: viewSetId, viewSetUUID: viewSetUUID, changes: changes } = event.payload;
            switch(event.type){
                case 0, $cU7LI.VIEWSET_DELETED_EVENT:
                    onDeleteViewSet(viewSetId, viewSetUUID);
                    break;
                case 0, $cU7LI.VIEWSET_CREATED_EVENT:
                    onCreateViewSet(viewSetId, viewSetUUID);
                    break;
                case 0, $cU7LI.VIEWSET_UPDATED_EVENT:
                    if (changes?.includes('*')) {
                        onUpdateViewSet(viewSetId, viewSetUUID);
                        return;
                    }
                    if (changes?.includes('rank')) onUpdateViewSetsRanks();
                    break;
                default:
                    break;
            }
        }
    }, [
        onRefreshViewComments,
        onDeleteView,
        createAnalyticsEvent,
        onCreateView,
        onUpdateView,
        onUpdateViewArrangementInfo,
        onUpdateViewsRanks,
        onDeleteViewSet,
        onCreateViewSet,
        onUpdateViewSet,
        onUpdateViewSetsRanks
    ]);
    const [onReceiveWithQueue, clearEvents] = (0, $4jVkB.useWrappedRealtimeHandlerWithQueue)(// TODO: Temporary assertion to simplify migration, drop after jpd_issue_subscription_migration
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    onReceive);
    (0, $eJOHy.useEffect)(()=>()=>clearEvents(), [
        clearEvents
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFz1q.default), {
        appId: (0, $cU7LI.PREFIXED_APP_ID),
        channels: projectChannels,
        events: (0, $cU7LI.VIEW_EVENTS),
        onReceive: onReceiveWithQueue
    });
});

});
parcelRegister("4jVkB", function(module, exports) {

$parcel$export(module.exports, "useAreRealtimeQueueQuotasExceeded", () => $1e68f8a14cab2862$export$36fe5a4323a90d90);
$parcel$export(module.exports, "useWrappedRealtimeHandlerWithQueue", () => $1e68f8a14cab2862$export$9292ffdb703ac323);

var $eJOHy = parcelRequire("eJOHy");

var $j68Qv = parcelRequire("j68Qv");
const $1e68f8a14cab2862$export$36fe5a4323a90d90 = ()=>{
    const { areQueueQuotasExceeded: areQueueQuotasExceeded, eventsInQueue: eventsInQueue } = (0, $j68Qv.useRealtimeQueueContext)();
    return {
        areQueueQuotasExceeded: areQueueQuotasExceeded,
        eventsInQueue: eventsInQueue
    };
};
const $1e68f8a14cab2862$export$9292ffdb703ac323 = (handler, config, shouldSkipEvent)=>{
    const { queue: queue } = (0, $j68Qv.useRealtimeQueueContext)();
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        ref.current = handler;
        // set queue config
        config && queue.setConfig(config);
    }, [
        ref,
        handler,
        config,
        queue
    ]);
    const onReceive = (0, $eJOHy.useCallback)((event)=>{
        if (shouldSkipEvent && shouldSkipEvent(event)) return;
        ref.current && queue.addEvent(ref, event);
    }, [
        queue,
        ref,
        shouldSkipEvent
    ]);
    const clearEvents = (0, $eJOHy.useCallback)(()=>{
        ref.current && queue.clearEvents(ref);
    }, [
        queue
    ]);
    return [
        onReceive,
        clearEvents
    ];
};

});
parcelRegister("j68Qv", function(module, exports) {

$parcel$export(module.exports, "useRealtimeQueueContext", () => $6ddecbe7559e030e$export$929412727745be3c);
$parcel$export(module.exports, "RealtimeQueueContextProvider", () => $6ddecbe7559e030e$export$b4d42701795c9303);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $hmUIy = parcelRequire("hmUIy");
const $6ddecbe7559e030e$var$RealtimeQueueContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $6ddecbe7559e030e$export$929412727745be3c = ()=>{
    const context = (0, $eJOHy.useContext)($6ddecbe7559e030e$var$RealtimeQueueContext);
    if (context === undefined) throw new Error('useRealtimeQueueContext must be used within a RealtimeQueueContextProvider');
    return context;
};
const $6ddecbe7559e030e$var$registry = new Map();
const $6ddecbe7559e030e$export$b4d42701795c9303 = ({ children: children, scope: scope })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [eventsInQueue, setEventsInQueue] = (0, $eJOHy.useState)(0);
    const [initialScope] = (0, $eJOHy.useState)(scope);
    const [areQueueQuotasExceeded, setAreQueueQuotasExceeded] = (0, $eJOHy.useState)(false);
    const queue = (0, $eJOHy.useMemo)(()=>{
        if (initialScope && $6ddecbe7559e030e$var$registry.has(initialScope)) {
            const queueFromRegistry = $6ddecbe7559e030e$var$registry.get(initialScope);
            if (queueFromRegistry) return queueFromRegistry;
        }
        const newQueue = (0, $hmUIy.createQueue)(createAnalyticsEvent, (eventsInQueueParam)=>{
            setEventsInQueue(eventsInQueueParam);
            setAreQueueQuotasExceeded(true);
        });
        if (initialScope) $6ddecbe7559e030e$var$registry.set(initialScope, newQueue);
        return newQueue;
    }, [
        createAnalyticsEvent,
        initialScope
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            if (initialScope) {
                const queueFromRegistry = $6ddecbe7559e030e$var$registry.get(initialScope);
                if (queueFromRegistry?.isEmpty()) $6ddecbe7559e030e$var$registry.delete(initialScope);
            }
        }, [
        initialScope
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return queue.start();
    }, [
        queue
    ]);
    const value = (0, $fAZgY.useMemoWithCondition)(()=>({
            queue: queue,
            eventsInQueue: eventsInQueue,
            areQueueQuotasExceeded: areQueueQuotasExceeded
        }), [
        areQueueQuotasExceeded,
        eventsInQueue,
        queue
    ], ()=>(0, $7jTnu.fg)('jfp_magma_jpd-perf-improvement'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ddecbe7559e030e$var$RealtimeQueueContext.Provider, {
        value: value
    }, children);
};

});
parcelRegister("hmUIy", function(module, exports) {

$parcel$export(module.exports, "createQueue", () => $74970b0331136934$export$d16acf4b6e75743d);

var $cSmYj = parcelRequire("cSmYj");

var $jzYet = parcelRequire("jzYet");

var $db71w = parcelRequire("db71w");

var $4ZTyO = parcelRequire("4ZTyO");

var $cel8I = parcelRequire("cel8I");
/**
 * Events counter for realtime events in the last period of time
 * Stores the number of events per interval
 *
 * @param periodSize period size in ms
 * @param intervalSize interval size in ms
 */ const $74970b0331136934$var$EventsCounter = (periodSize = 60000, intervalSize = 5000)=>{
    const counter = new Map();
    const getIntervalKey = (timestamp)=>Math.floor(timestamp / intervalSize) * intervalSize;
    return {
        updateEventsCount (eventType, timestamp, count = 1) {
            const intervalKey = getIntervalKey(timestamp);
            // Get or create the events count Map for the given eventType
            const typeCounts = counter.get(eventType) ?? new Map();
            typeCounts.set(intervalKey, (typeCounts.get(intervalKey) ?? 0) + count);
            counter.set(eventType, typeCounts);
            // Purge old events for all event types
            const cutoffTimestamp = timestamp - periodSize;
            counter.forEach((typeCountsMap, _)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                typeCountsMap.forEach((__, key)=>{
                    if (key < cutoffTimestamp) typeCountsMap.delete(key);
                });
            });
        },
        getEventsCount (eventType) {
            let totalCount = 0;
            const cutoffTimestamp = Date.now() - periodSize;
            const typeCounts = counter.get(eventType);
            if (typeCounts) {
                for (const [key, count] of typeCounts.entries())if (key >= cutoffTimestamp) totalCount += count;
            }
            return totalCount;
        }
    };
};
/**
 * Rate limits for realtime events by event type
 */ const $74970b0331136934$var$RateLimits = ()=>{
    const lastEventTimestamp = new Map();
    const eventsCounter1m = $74970b0331136934$var$EventsCounter((0, $db71w.TIME_WINDOW_1M));
    const eventsCounter5m = $74970b0331136934$var$EventsCounter((0, $db71w.TIME_WINDOW_5M));
    function calculateDelay(eventType, initialDelay) {
        const delayIncreaseFactor = (1 + Math.sqrt(5)) / 2;
        const events1m = eventsCounter1m.getEventsCount(eventType);
        // exponential increase factor based on the number of events in the last minute
        const delayGrowthRate = Math.pow(delayIncreaseFactor, events1m);
        // Bound delay within a reasonable range
        const minDelay = 0; // 0ms
        const maxDelay = 15000; // 15s
        const delay = Math.floor(initialDelay * delayGrowthRate);
        return Math.max(minDelay, Math.min(delay, maxDelay));
    }
    function hasDelayLimitExceeded(eventType, initialDelay) {
        if (initialDelay === 0) return false;
        const headEventTimestamp = lastEventTimestamp.get(eventType);
        // if there are no events in the last minute, there is no delay
        if (!headEventTimestamp) return false;
        const currentDelay = calculateDelay(eventType, initialDelay);
        if (Date.now() - headEventTimestamp <= currentDelay) return true;
        return false;
    }
    function hasRateLimitBeenExceeded1m(eventType, eventsQueueLimit) {
        return eventsCounter1m.getEventsCount(eventType) >= eventsQueueLimit;
    }
    function hasRateLimitBeenExceeded5m(eventType, eventsQueueLimit) {
        return eventsCounter5m.getEventsCount(eventType) >= eventsQueueLimit * 2;
    }
    function update(eventType) {
        const currentTime = Date.now();
        lastEventTimestamp.set(eventType, currentTime);
        eventsCounter1m.updateEventsCount(eventType, currentTime);
        eventsCounter5m.updateEventsCount(eventType, currentTime);
    }
    return {
        hasDelayLimitExceeded: hasDelayLimitExceeded,
        hasRateLimitBeenExceeded1m: hasRateLimitBeenExceeded1m,
        hasRateLimitBeenExceeded5m: hasRateLimitBeenExceeded5m,
        update: update
    };
};
const $74970b0331136934$export$d16acf4b6e75743d = (createAnalyticsEvent, onQueueQuotasExceeded)=>{
    let queueConfig = {
        bundleEvents: {},
        batchSizes: {}
    };
    const queueAnalytics = (0, $4ZTyO.createQueueAnalytics)(createAnalyticsEvent);
    const reatimeQueue = new Map();
    const rateLimits = $74970b0331136934$var$RateLimits();
    let isWindowFocused = (0, $jzYet.isPageVisible)();
    let windowLastFocusedTime = 0;
    let quotasExceeded = false;
    const onVisibilityChange = ()=>{
        const prevIsWindowFocused = isWindowFocused;
        isWindowFocused = (0, $jzYet.isPageVisible)();
        const hasMovedFocusAway = !isWindowFocused && prevIsWindowFocused;
        // run the code in the next tick because addEvent is called after onVisibilityChange
        setTimeout(()=>{
            if (hasMovedFocusAway) windowLastFocusedTime = Date.now();
            else {
                const timeElapsedSinceLastWindowFocus = Date.now() - windowLastFocusedTime;
                const isQueueFull = getQueue().length > (0, $db71w.REALTIME_EVENTS_QUEUE_INACTIVE_QUOTA);
                if (timeElapsedSinceLastWindowFocus > (0, $db71w.MIN_QUOTA_CHECK_INACTIVE_TIME) && isQueueFull) {
                    quotasExceeded = true;
                    onQueueQuotasExceeded?.(getQueue().length);
                }
            }
        });
    };
    const getLimit = ()=>{
        // if tab is inactive for more than 2 minutes, limit is 1
        if (!isWindowFocused && windowLastFocusedTime + (0, $db71w.INACTIVE_TAB_INTERVAL) < Date.now()) return 1;
        return (0, $cel8I.getRealtimeEventsQueueLimit)();
    };
    // Collects all events from all handlers
    const getQueue = ()=>[
            ...reatimeQueue.keys()
        ].reduce((acc, handler)=>{
            const handlerQueue = reatimeQueue.get(handler);
            if (!handlerQueue) return acc;
            const handlerEvents = Object.keys(handlerQueue).reduce((handlerEventsAcc, eventType)=>handlerEventsAcc.concat(handlerQueue[eventType].events), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            []);
            return acc.concat(handlerEvents);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, []);
    const isBatchedEvent = (eventType)=>(queueConfig.batchSizes?.[eventType] ?? 0) > 1;
    const isRateLimitExemptEvent = (eventType)=>queueConfig.batchSizes?.[eventType] === Number.MAX_VALUE;
    const checkIfRateLimitExceeded = (eventType)=>{
        if (isRateLimitExemptEvent(eventType)) return false;
        if (isBatchedEvent(eventType) && rateLimits.hasDelayLimitExceeded(eventType, (0, $cel8I.getRealtimeEventsQueueJitterForBatch)())) return true;
        if (rateLimits.hasDelayLimitExceeded(eventType, (0, $cel8I.getRealtimeEventsQueueJitter)())) return true;
        if (rateLimits.hasRateLimitBeenExceeded1m(eventType, getLimit())) return true;
        if (rateLimits.hasRateLimitBeenExceeded5m(eventType, getLimit())) return true;
        return false;
    };
    return {
        start: ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener((0, $jzYet.supportedVisiblityEvent), onVisibilityChange);
            const resetAnalytics = queueAnalytics.setup(isWindowFocused);
            const queueInterval = setInterval(()=>{
                if (quotasExceeded) {
                    cleanupListeners();
                    return;
                }
                const eventsInQueue = getQueue();
                queueAnalytics.update(eventsInQueue);
                if (!reatimeQueue.size) return;
                for (const [handler, handlerQueue] of reatimeQueue.entries())for (const eventType of Object.keys(handlerQueue)){
                    if (checkIfRateLimitExceeded(eventType)) return;
                    const { events: events } = handlerQueue[eventType];
                    // remove empty event type queue and skip if no events
                    if (!events.length) {
                        delete handlerQueue[eventType];
                        return;
                    }
                    const batchSize = queueConfig.batchSizes?.[eventType] ?? 1;
                    const eventsToProcess = events.splice(0, batchSize);
                    // process events with handler
                    handler.current?.({
                        type: eventType,
                        payload: isBatchedEvent(eventType) ? eventsToProcess : eventsToProcess[0].payload
                    });
                    // remove empty event type queue
                    if (!events.length) delete handlerQueue[eventType];
                    rateLimits.update(eventType);
                }
            }, (0, $db71w.QUEUE_INTERVAL));
            const cleanupListeners = ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener((0, $jzYet.supportedVisiblityEvent), onVisibilityChange);
                resetAnalytics();
                clearInterval(queueInterval);
            };
            // Cleanup intervals and listeners
            return cleanupListeners;
        },
        addEvent: (ref, event)=>{
            const eventsInQueue = getQueue();
            queueAnalytics.addEvent(event, eventsInQueue);
            const eventType = queueConfig.bundleEvents[event.type]?.bundledEventName ?? event.type;
            // Init queue for handler
            if (!reatimeQueue.has(ref)) reatimeQueue.set(ref, {
                [eventType]: {
                    time: Date.now(),
                    events: []
                }
            });
            else if (!reatimeQueue.get(ref)?.[eventType]) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            reatimeQueue.get(ref)[eventType] = {
                time: Date.now(),
                events: []
            };
            if ((reatimeQueue.get(ref)?.[eventType]?.events.length || 0) > (0, $db71w.QUEUE_HANDLER_LIMIT)) {
                quotasExceeded = true;
                onQueueQuotasExceeded?.(eventsInQueue.length);
                // overloaded, drop event
                return;
            }
            const events = reatimeQueue.get(ref)?.[eventType]?.events;
            // Check if event is already in queue to avoid duplicates if not add event to queue
            if (events) {
                const eventIndex = events.findIndex((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, $cel8I.eventPayloadToCompareDuplicates)(e), (0, $cel8I.eventPayloadToCompareDuplicates)(event)));
                if (eventIndex === -1) events.push(event);
                else // replace with new event
                events.splice(eventIndex, 1, event);
            }
        },
        clearEvents: (ref)=>{
            reatimeQueue.delete(ref);
        },
        setConfig: (config)=>{
            queueConfig = config;
        },
        // when all listeners are removed, the queue is empty
        isEmpty: ()=>reatimeQueue.size === 0
    };
};

});
parcelRegister("db71w", function(module, exports) {

$parcel$export(module.exports, "QUEUE_HANDLER_LIMIT", () => $6d10bf98df820b91$export$21196a159f1b69ec);
$parcel$export(module.exports, "QUEUE_INTERVAL", () => $6d10bf98df820b91$export$baca1ed73a0ec99e);
$parcel$export(module.exports, "VOLUME_STATISTIC_INTERVAL", () => $6d10bf98df820b91$export$8e5041f6cc060ace);
$parcel$export(module.exports, "STATISTIC_INTERVAL", () => $6d10bf98df820b91$export$4a8fb5e78624f677);
$parcel$export(module.exports, "TIME_WINDOW_1M", () => $6d10bf98df820b91$export$64263c276cdf0890);
$parcel$export(module.exports, "TIME_WINDOW_5M", () => $6d10bf98df820b91$export$a7f182df119deecb);
$parcel$export(module.exports, "INACTIVE_TAB_INTERVAL", () => $6d10bf98df820b91$export$b204fc941f7bb9d8);
$parcel$export(module.exports, "MIN_QUOTA_CHECK_INACTIVE_TIME", () => $6d10bf98df820b91$export$ed61c80a0cd972a6);
$parcel$export(module.exports, "REALTIME_EVENTS_QUEUE_INACTIVE_QUOTA", () => $6d10bf98df820b91$export$87b9921f20e6978c);
const $6d10bf98df820b91$export$21196a159f1b69ec = 1000;
const $6d10bf98df820b91$export$baca1ed73a0ec99e = 100;
const $6d10bf98df820b91$export$8e5041f6cc060ace = 120000;
const $6d10bf98df820b91$export$4a8fb5e78624f677 = 600000;
const $6d10bf98df820b91$export$64263c276cdf0890 = 60000;
const $6d10bf98df820b91$export$a7f182df119deecb = 300000;
const $6d10bf98df820b91$export$b204fc941f7bb9d8 = 120000;
const $6d10bf98df820b91$export$ed61c80a0cd972a6 = 300000;
const $6d10bf98df820b91$export$87b9921f20e6978c = 100;

});

parcelRegister("4ZTyO", function(module, exports) {

$parcel$export(module.exports, "createQueueAnalytics", () => $12f8d737063e818a$export$e8519e059b19312a);

var $fqICx = parcelRequire("fqICx");

var $aXKmr = parcelRequire("aXKmr");

var $gCeeo = parcelRequire("gCeeo");

var $db71w = parcelRequire("db71w");
const $12f8d737063e818a$var$initialTime = Date.now();
const $12f8d737063e818a$var$tabId = (0, $aXKmr.v4)();
const $12f8d737063e818a$var$getBucket = (measurement)=>{
    switch(true){
        case measurement <= 10:
            return '0-10';
        case measurement <= 25:
            return '10-25';
        case measurement <= 50:
            return '25-50';
        case measurement <= 100:
            return '50-100';
        case measurement <= 250:
            return '100-250';
        case measurement <= 500:
            return '250-500';
        default:
            return '500+';
    }
};
const $12f8d737063e818a$var$getEventsCountByType = (events)=>events.reduce((result, type)=>Object.assign(result, {
            [type]: result[type] ? result[type] + 1 : 1
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
const $12f8d737063e818a$var$getTimeAfterLoadInSeconds = ()=>(Date.now() - $12f8d737063e818a$var$initialTime) / 1000;
const $12f8d737063e818a$export$a51fb9acf6d53de0 = (statistic, isWindowFocused, createAnalyticsEvent)=>{
    if (!createAnalyticsEvent) return;
    if (statistic.maxCalls1m.length) {
        const aggregatedEvents = $12f8d737063e818a$var$getEventsCountByType(statistic.maxCalls1m);
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'realtimeQueueIntervalVolume tracked', {
            bucket: $12f8d737063e818a$var$getBucket(statistic.maxCalls1m.length),
            interval: '1m',
            volume: statistic.maxCalls1m.length,
            tab: isWindowFocused ? 'active' : 'inactive',
            tabId: $12f8d737063e818a$var$tabId,
            timeAfterLoadInSeconds: $12f8d737063e818a$var$getTimeAfterLoadInSeconds(),
            events: aggregatedEvents
        });
    }
    if (statistic.maxCalls5m.length) {
        const aggregatedEvents = $12f8d737063e818a$var$getEventsCountByType(statistic.maxCalls5m);
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'realtimeQueueIntervalVolume tracked', {
            bucket: $12f8d737063e818a$var$getBucket(statistic.maxCalls5m.length),
            interval: '5m',
            volume: statistic.maxCalls5m.length,
            tab: isWindowFocused ? 'active' : 'inactive',
            tabId: $12f8d737063e818a$var$tabId,
            timeAfterLoadInSeconds: $12f8d737063e818a$var$getTimeAfterLoadInSeconds(),
            events: aggregatedEvents
        });
    }
    if (statistic.maxQueueSize) {
        const aggregatedEvents = $12f8d737063e818a$var$getEventsCountByType(statistic.currentQueue.map((event)=>event.type));
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'realtimeQueueSize tracked', {
            bucket: $12f8d737063e818a$var$getBucket(statistic.currentQueue.length),
            maxBucket: $12f8d737063e818a$var$getBucket(statistic.maxQueueSize),
            queueSize: statistic.currentQueue.length,
            maxQueueSize: statistic.maxQueueSize,
            tab: isWindowFocused ? 'active' : 'inactive',
            tabId: $12f8d737063e818a$var$tabId,
            timeAfterLoadInSeconds: $12f8d737063e818a$var$getTimeAfterLoadInSeconds(),
            events: aggregatedEvents
        });
    }
};
const $12f8d737063e818a$export$fb3179bd1b63b2e8 = (events, isWindowFocused, createAnalyticsEvent)=>{
    if (!createAnalyticsEvent) return;
    if (!events.length) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const searchParams = new URLSearchParams(window.location.search);
    const aggregatedEvents = $12f8d737063e818a$var$getEventsCountByType(events);
    (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'realtimeEventVolume tracked', {
        bucket: $12f8d737063e818a$var$getBucket(events.length),
        volume: events.length,
        tab: isWindowFocused ? 'active' : 'inactive',
        tabId: $12f8d737063e818a$var$tabId,
        queryParams: [
            ...searchParams.keys()
        ].reduce((acc, key)=>Object.assign(acc, {
                [key]: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                searchParams.get(key) && /\d+/.test(searchParams.get(key)) ? '<param>' : searchParams.get(key)
            }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {}),
        timeAfterLoadInSeconds: $12f8d737063e818a$var$getTimeAfterLoadInSeconds(),
        events: aggregatedEvents
    });
};
const $12f8d737063e818a$export$e8519e059b19312a = (createAnalyticsEvent)=>{
    const volume = {
        headEventTime5m: 0,
        headEventTime1m: 0,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        calls5m: [],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        calls1m: [],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        calls: []
    };
    const statistic = {
        currentQueue: [],
        maxCalls1m: [],
        maxCalls5m: [],
        maxQueueSize: 0
    };
    return {
        addEvent: (event, eventsInQueue)=>{
            if (volume.calls1m.length === 0) volume.headEventTime1m = Date.now();
            if (volume.calls5m.length === 0) {
                volume.headEventTime5m = Date.now();
                volume.headEventTime1m = Date.now();
            }
            volume.calls1m.push(event.type);
            volume.calls5m.push(event.type);
            volume.calls.push(event.type);
            statistic.currentQueue = eventsInQueue;
            if (eventsInQueue.length > statistic.maxQueueSize) statistic.maxQueueSize = eventsInQueue.length;
        },
        setup: (isWindowFocused)=>{
            const staticticsInterval = setInterval(()=>{
                $12f8d737063e818a$export$a51fb9acf6d53de0((0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(statistic), isWindowFocused, createAnalyticsEvent);
                statistic.currentQueue = [];
                statistic.maxCalls1m = [];
                statistic.maxCalls5m = [];
                statistic.maxQueueSize = 0;
            }, (0, $db71w.STATISTIC_INTERVAL));
            const volumeStaticticsInterval = setInterval(()=>{
                $12f8d737063e818a$export$fb3179bd1b63b2e8([
                    ...volume.calls
                ], isWindowFocused, createAnalyticsEvent);
                volume.calls = [];
            }, (0, $db71w.VOLUME_STATISTIC_INTERVAL));
            // Cleanup intervals and listeners
            return ()=>{
                clearInterval(staticticsInterval);
                clearInterval(volumeStaticticsInterval);
            };
        },
        update: (eventsInQueue)=>{
            statistic.currentQueue = eventsInQueue;
            if (eventsInQueue.length > statistic.maxQueueSize) statistic.maxQueueSize = eventsInQueue.length;
            if (volume.calls1m.length > 0 && volume.headEventTime1m + (0, $db71w.TIME_WINDOW_1M) < Date.now()) {
                if (volume.calls1m.length > statistic.maxCalls1m.length) statistic.maxCalls1m = volume.calls1m;
                volume.calls1m = [];
            }
            if (volume.calls5m.length > 0 && volume.headEventTime5m + (0, $db71w.TIME_WINDOW_5M) < Date.now()) {
                if (volume.calls5m.length > statistic.maxCalls5m.length) statistic.maxCalls5m = volume.calls5m;
                volume.calls5m = [];
                volume.calls1m = [];
            }
        }
    };
};

});

parcelRegister("cel8I", function(module, exports) {

$parcel$export(module.exports, "getRealtimeEventsQueueLimit", () => $b31f6689fa0e3a24$export$43d2e711b8bdfe93);
$parcel$export(module.exports, "getRealtimeEventsQueueJitter", () => $b31f6689fa0e3a24$export$74d6ada765a227a0);
$parcel$export(module.exports, "getRealtimeEventsQueueJitterForBatch", () => $b31f6689fa0e3a24$export$367ad1a5b9f04b64);
$parcel$export(module.exports, "eventPayloadToCompareDuplicates", () => $b31f6689fa0e3a24$export$ac67201cef13428);
const $b31f6689fa0e3a24$export$43d2e711b8bdfe93 = ()=>100;
const $b31f6689fa0e3a24$export$74d6ada765a227a0 = ()=>50;
const $b31f6689fa0e3a24$export$367ad1a5b9f04b64 = ()=>2000;
const $b31f6689fa0e3a24$export$ac67201cef13428 = (event)=>{
    switch(event.type){
        case 'avi:polaris:created:insight':
        case 'avi:polaris:updated:insight':
            {
                const { insight: insight, updatedTime: updatedTime, ...other } = event.payload;
                return {
                    ...event,
                    payload: {
                        ...other
                    }
                };
            }
        case 'avi:polaris:created:view':
        case 'avi:polaris:updated:view':
            {
                const { view: view, ...other } = event.payload;
                return {
                    ...event,
                    payload: {
                        ...other
                    }
                };
            }
        default:
            return event;
    }
};

});




parcelRegister("2wImr", function(module, exports) {

$parcel$export(module.exports, "useRealtimeChannels", () => $97c976ab98c404a1$export$12bb9444e2743d3f);
$parcel$export(module.exports, "useRealtimeProjectChannel", () => $97c976ab98c404a1$export$bfd6836745588c34);

var $eJOHy = parcelRequire("eJOHy");

var $e9bHy = parcelRequire("e9bHy");

var $kEUB1 = parcelRequire("kEUB1");
const $97c976ab98c404a1$export$12bb9444e2743d3f = (containerId, containerType)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $eJOHy.useMemo)(()=>{
        if (containerId === undefined) return [];
        if (containerType === 'PROJECT') return [
            (0, $e9bHy.buildChannelString)(cloudId, String(containerId))
        ];
        if (containerType === 'ISSUE') return [
            `ari:cloud:jira:${cloudId}:issue/${containerId}`
        ];
        return [];
    }, [
        cloudId,
        containerId,
        containerType
    ]);
};
const $97c976ab98c404a1$export$bfd6836745588c34 = (projectId)=>$97c976ab98c404a1$export$12bb9444e2743d3f(projectId, 'PROJECT');

});
parcelRegister("e9bHy", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $ba331ec1f89231c5$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $ba331ec1f89231c5$export$354e43de513ff5);

var $hWeHP = parcelRequire("hWeHP");

const $ba331ec1f89231c5$export$f795b2d9ba365882 = ()=>(0, $hWeHP.default)('ajs-fabric-realtime-url') || (0, $560b7a8a985dcf79$export$92ffb25149c24a33);
const $ba331ec1f89231c5$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});
const $560b7a8a985dcf79$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $560b7a8a985dcf79$export$13ac40d1a5475532 = 'JIRA';



parcelRegister("aFz1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $99b5d7dccfd44664$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fFj4a = parcelRequire("fFj4a");

var $h35Ia = parcelRequire("h35Ia");
class $99b5d7dccfd44664$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h35Ia.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFj4a.RealtimeClient), {
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args), this.onEventReceive = (eventType, payload)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event);
        };
    }
}

});
parcelRegister("fFj4a", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $d48437a516f31928$export$e680ceb7b9fcc184);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $hjf2q = parcelRequire("hjf2q");

var $2bjD8 = parcelRequire("2bjD8");

var $hwRlc = parcelRequire("hwRlc");
// eslint-disable-next-line jira/react/no-class-components
class $d48437a516f31928$var$RealtimeClientView extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.onReceiveEvent = (event, payload)=>{
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        }, this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        }, this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        }, this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        }, this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $d48437a516f31928$var$withAnalytics = (0, $hjf2q.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $d48437a516f31928$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))($d48437a516f31928$var$withAnalytics, (0, $hwRlc.withPubSubClient), (0, $2bjD8.asClientOnly))($d48437a516f31928$var$RealtimeClientView);
var $d48437a516f31928$export$2e2bcd8739ae039 = $d48437a516f31928$export$e680ceb7b9fcc184;

});
parcelRegister("2bjD8", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $950a3b8420e26de8$export$95cd02374de3431);

var $eJOHy = parcelRequire("eJOHy");
function $950a3b8420e26de8$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, props);
    };
}
var $950a3b8420e26de8$export$2e2bcd8739ae039 = $950a3b8420e26de8$export$95cd02374de3431;

});

parcelRegister("hwRlc", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $98243d002ea8fbbc$export$32d968d4900ae3cd);

var $eJOHy = parcelRequire("eJOHy");

var $dxuPz = parcelRequire("dxuPz");
function $98243d002ea8fbbc$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxuPz.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $98243d002ea8fbbc$export$2e2bcd8739ae039 = $98243d002ea8fbbc$export$32d968d4900ae3cd;

});
parcelRegister("dxuPz", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $fc73c2bcc0691cdb$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $fc73c2bcc0691cdb$export$b3bffd4bb7da6b8f);

var $eJOHy = parcelRequire("eJOHy");
const $fc73c2bcc0691cdb$var$defaultContext = {
    client: null
};
const { Provider: $fc73c2bcc0691cdb$export$2881499e37b75b9a, Consumer: $fc73c2bcc0691cdb$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $eJOHy.createContext)($fc73c2bcc0691cdb$var$defaultContext);

});



parcelRegister("h35Ia", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $bf8a5956ff92a48f$export$64d242981d970821);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");

var $hjf2q = parcelRequire("hjf2q");

var $2Mqjh = parcelRequire("2Mqjh");


var $dxuPz = parcelRequire("dxuPz");

var $7qdYF = parcelRequire("7qdYF");

var $2z1zW = parcelRequire("2z1zW");

const $bf8a5956ff92a48f$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("fVORd")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $560b7a8a985dcf79$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $bf8a5956ff92a48f$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $eSnSE.default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
    });
const $bf8a5956ff92a48f$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $eSnSE.default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $bf8a5956ff92a48f$var$RealtimeProviderView extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            host: (0, $560b7a8a985dcf79$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels } = this.props;
        this.isComponentMounted = true;
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((analyticsClient)=>$bf8a5956ff92a48f$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$bf8a5956ff92a48f$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            $bf8a5956ff92a48f$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
            $bf8a5956ff92a48f$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $bf8a5956ff92a48f$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
    }
    render() {
        if ((0, $7jTnu.fg)('jfp_magma_jpd-perf-improvement')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxuPz.Provider), {
            value: this.state
        }, this.props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxuPz.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            client: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result.currentChannels));
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result.currentChannels));
        }, this.isComponentMounted = false;
    }
}
const $bf8a5956ff92a48f$var$withAnalytics = (0, $hjf2q.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $bf8a5956ff92a48f$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))($bf8a5956ff92a48f$var$withAnalytics, (0, $7qdYF.withHost), (0, $2z1zW.withRuntimeProvider))($bf8a5956ff92a48f$var$RealtimeProviderView);
var $bf8a5956ff92a48f$export$2e2bcd8739ae039 = $bf8a5956ff92a48f$export$64d242981d970821;

});
parcelRegister("7qdYF", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $8793c0267301abe2$export$b2d89aaea1461cd9);

var $eJOHy = parcelRequire("eJOHy");

var $e9bHy = parcelRequire("e9bHy");
function $8793c0267301abe2$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            host: (0, $e9bHy.getDefaultPubSubHost)()
        });
}
var $8793c0267301abe2$export$2e2bcd8739ae039 = $8793c0267301abe2$export$b2d89aaea1461cd9;

});

parcelRegister("2z1zW", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $ef7f585697f9665a$export$4b38d0b01368c3f4);

var $eJOHy = parcelRequire("eJOHy");
function $ef7f585697f9665a$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, props);
    };
}
var $ef7f585697f9665a$export$2e2bcd8739ae039 = $ef7f585697f9665a$export$4b38d0b01368c3f4;

});

parcelRegister("fVORd", function(module, exports) {

let $b993a1111f9e616d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b993a1111f9e616d$var$load("04yPF").then(()=>parcelRequire('4sIJZ'));

});



parcelRegister("cU7LI", function(module, exports) {

$parcel$export(module.exports, "PREFIXED_APP_ID", () => $53c927bff46c999d$export$89f3052b64ea7986);
$parcel$export(module.exports, "VIEW_COMMENT_CREATED_EVENT", () => $53c927bff46c999d$export$f4934664d0db2b77);
$parcel$export(module.exports, "VIEW_COMMENT_DELETED_EVENT", () => $53c927bff46c999d$export$7285c56ab5c74c0);
$parcel$export(module.exports, "VIEW_COMMENT_UPDATED_EVENT", () => $53c927bff46c999d$export$6fefdb4175167cc0);
$parcel$export(module.exports, "VIEW_CREATED_EVENT", () => $53c927bff46c999d$export$8e6a0fba387b6554);
$parcel$export(module.exports, "VIEW_DELETED_EVENT", () => $53c927bff46c999d$export$7842c2b30cea6f69);
$parcel$export(module.exports, "VIEW_UPDATED_EVENT", () => $53c927bff46c999d$export$b8740a1c379058a0);
$parcel$export(module.exports, "VIEWSET_CREATED_EVENT", () => $53c927bff46c999d$export$b03e05fa379e148e);
$parcel$export(module.exports, "VIEWSET_DELETED_EVENT", () => $53c927bff46c999d$export$539965fcfba77ae4);
$parcel$export(module.exports, "VIEWSET_UPDATED_EVENT", () => $53c927bff46c999d$export$4b14acb2b73fddb6);
$parcel$export(module.exports, "VIEW_EVENTS", () => $53c927bff46c999d$export$d15b74e1f5cb0e9c);

const $53c927bff46c999d$export$89f3052b64ea7986 = `${(0, $31e61dfd47410e1f$export$6355c0002005282a)}ideas`;
const $53c927bff46c999d$export$f4934664d0db2b77 = 'avi:polaris:created:comment';
const $53c927bff46c999d$export$7285c56ab5c74c0 = 'avi:polaris:deleted:comment';
const $53c927bff46c999d$export$6fefdb4175167cc0 = 'avi:polaris:updated:comment';
const $53c927bff46c999d$export$8e6a0fba387b6554 = 'avi:polaris:created:view';
const $53c927bff46c999d$export$7842c2b30cea6f69 = 'avi:polaris:deleted:view';
const $53c927bff46c999d$export$b8740a1c379058a0 = 'avi:polaris:updated:view';
const $53c927bff46c999d$export$b03e05fa379e148e = 'avi:polaris:created:viewset';
const $53c927bff46c999d$export$539965fcfba77ae4 = 'avi:polaris:deleted:viewset';
const $53c927bff46c999d$export$4b14acb2b73fddb6 = 'avi:polaris:updated:viewset';
const $53c927bff46c999d$export$d15b74e1f5cb0e9c = [
    $53c927bff46c999d$export$f4934664d0db2b77,
    $53c927bff46c999d$export$7285c56ab5c74c0,
    $53c927bff46c999d$export$6fefdb4175167cc0,
    $53c927bff46c999d$export$8e6a0fba387b6554,
    $53c927bff46c999d$export$7842c2b30cea6f69,
    $53c927bff46c999d$export$b8740a1c379058a0,
    $53c927bff46c999d$export$b03e05fa379e148e,
    $53c927bff46c999d$export$539965fcfba77ae4,
    $53c927bff46c999d$export$4b14acb2b73fddb6
];

});
const $31e61dfd47410e1f$export$6355c0002005282a = 'polaris-';


parcelRegister("geEXa", function(module, exports) {

$parcel$export(module.exports, "isViewCommentEvent", () => $0a285d6c6db7b4db$export$519e5d60965af0a8);
$parcel$export(module.exports, "isViewEvent", () => $0a285d6c6db7b4db$export$f529fe1e131a3a42);
$parcel$export(module.exports, "isViewSetEvent", () => $0a285d6c6db7b4db$export$d069c24d333b1bb2);

var $cU7LI = parcelRequire("cU7LI");
function $0a285d6c6db7b4db$export$519e5d60965af0a8(event) {
    return event.type === (0, $cU7LI.VIEW_COMMENT_CREATED_EVENT) || event.type === (0, $cU7LI.VIEW_COMMENT_UPDATED_EVENT) || event.type === (0, $cU7LI.VIEW_COMMENT_DELETED_EVENT);
}
function $0a285d6c6db7b4db$export$f529fe1e131a3a42(event) {
    return event.type === (0, $cU7LI.VIEW_CREATED_EVENT) || event.type === (0, $cU7LI.VIEW_UPDATED_EVENT) || event.type === (0, $cU7LI.VIEW_DELETED_EVENT);
}
function $0a285d6c6db7b4db$export$d069c24d333b1bb2(event) {
    return event.type === (0, $cU7LI.VIEWSET_CREATED_EVENT) || event.type === (0, $cU7LI.VIEWSET_DELETED_EVENT) || event.type === (0, $cU7LI.VIEWSET_UPDATED_EVENT);
}

});

parcelRegister("jszQC", function(module, exports) {

$parcel$export(module.exports, "validateViewPayload", () => $0606b4220b24e227$export$a28d0b4f3a5f9bb0);
$parcel$export(module.exports, "enrichViewPayload", () => $0606b4220b24e227$export$adbc379129f5d3ad);
$parcel$export(module.exports, "onValidationError", () => $0606b4220b24e227$export$caaff534cb4765f2);

var $ifBQy = parcelRequire("ifBQy");

var $eezJL = parcelRequire("eezJL");

var $7oe8F = parcelRequire("7oe8F");

var $g9yYQ = parcelRequire("g9yYQ");

var $gCeeo = parcelRequire("gCeeo");

var $1fQNI = parcelRequire("1fQNI");

var $6Yd06 = parcelRequire("6Yd06");
// Initialize Apollo Client with an in-memory cache
const $0606b4220b24e227$var$client = new (0, $eezJL.ApolloClient)({
    cache: new (0, $ifBQy.InMemoryCache)({}),
    link: (0, $7oe8F.ApolloLink).from([
        (0, $1fQNI.UFOLoggerLink)
    ])
});
function $0606b4220b24e227$export$a28d0b4f3a5f9bb0(event, createAnalyticsEvent, onError, fragment = (0, $g9yYQ.ViewFragment)) {
    try {
        $0606b4220b24e227$var$client.writeFragment({
            fragmentName: 'EdgeView',
            fragment: fragment,
            data: event,
            id: `PolarisView:${event.id}`,
            variables: {
                isShareViewDialogEnabled: true,
                skipDescription: false
            }
        });
        const result = $0606b4220b24e227$var$client.cache.readFragment({
            fragmentName: 'EdgeView',
            fragment: fragment,
            id: `PolarisView:${event.id}`,
            variables: {
                isShareViewDialogEnabled: true,
                skipDescription: false
            }
        });
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'realtimeViewPayload validated', {
            viewId: event.id,
            viewKeys: Object.keys(event).join(', '),
            hasResult: result !== null
        });
        return result !== null;
    } catch (err) {
        onError?.(err, event);
        return false;
    } finally{
        $0606b4220b24e227$var$client.cache.restore({});
    }
}
function $0606b4220b24e227$export$adbc379129f5d3ad(view) {
    return {
        ...view,
        // we don't receive this field from the server
        lastCommentsViewedTimestamp: null
    };
}
const $0606b4220b24e227$export$caaff534cb4765f2 = (error, event)=>{
    (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.view-realtime-handler', 'View payload validation failed', {
        error: error instanceof Error ? error.toString() : undefined,
        viewId: event.id,
        viewKeys: Object.keys(event).join(', ')
    });
};

});
parcelRegister("g9yYQ", function(module, exports) {

$parcel$export(module.exports, "ViewFragment", () => $ea8fd48cc3eebf19$export$2cfc225f457f1fab);
$parcel$export(module.exports, "fetchProject", () => $ea8fd48cc3eebf19$export$525bc467aeb111d5);
$parcel$export(module.exports, "useProjectFetcher", () => $ea8fd48cc3eebf19$export$3fef97270b5dce0c);

var $eJOHy = parcelRequire("eJOHy");

var $1fMqv = parcelRequire("1fMqv");

var $kuAvn = parcelRequire("kuAvn");

var $eezJL = parcelRequire("eezJL");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7bPX5 = parcelRequire("7bPX5");

var $huIQ9 = parcelRequire("huIQ9");

var $2EzOr = parcelRequire("2EzOr");
const $ea8fd48cc3eebf19$export$2cfc225f457f1fab = (0, $kuAvn.default)`
  fragment EdgeView on PolarisView {
    __typename
    id
    xid
    name
    emoji
    description @skip(if: $skipDescription)
    uuid @include(if: $isShareViewDialogEnabled)
    containsArchived
    immutable
    visualizationType
    lastCommentsViewedTimestamp
    sortMode
    hideEmptyGroups
    hideEmptyColumns
    groupBy {
        __typename
        key: jiraFieldKey
    }
    verticalGroupBy {
        __typename
        key: jiraFieldKey
    }
    groupValues {
        ...EdgeGroupValue
    }
    verticalGroupValues {
        ...EdgeGroupValue
    }
    sort {
        ...EdgeSorted
    }
    fields {
        __typename
        key: jiraFieldKey
    }
    hidden {
        __typename
        key: jiraFieldKey
    }
    filter {
        ...EdgeFilter
    }
    tableColumnSizes {
        ...EdgeColumnSizes
    }
    fieldRollups {
        ...EdgeFieldRollups
    }
    matrixConfig {
        __typename
        axes {
            __typename
            dimension
            field {
                __typename
                key: jiraFieldKey
            }
            fieldOptions {
                ...EdgeGroupValue
            }
            reversed
        }
    }
    timelineConfig {
        __typename
        summaryCardField {
            __typename
            key: jiraFieldKey
        }
        startDateField {
            __typename
            key: jiraFieldKey
        }
        dueDateField {
            __typename
            key: jiraFieldKey
        }
        mode
        startTimestamp
        endTimestamp
    }
    rank
    viewSetId
    enabledAutoSave
    layoutType
    createdAt
    updatedAt
  }


  fragment EdgeColumnSizes on PolarisViewTableColumnSize {
      __typename
      field {
          __typename
          key: jiraFieldKey
      }
      size
  }

  fragment EdgeFieldRollups on PolarisViewFieldRollup {
      __typename
      field {
          __typename
          key: jiraFieldKey
      }
      rollup
  }

  fragment EdgeSorted on PolarisSortField {
      __typename
      order
      field {
          __typename
          key: jiraFieldKey
      }
    }

  fragment EdgeFilter on PolarisViewFilter {
      __typename
      type: kind
      field {
          __typename
          key: jiraFieldKey
      }
      values {
          ...EdgeFilterValue
      }
  }

  fragment EdgeFilterValue on PolarisViewFilterValue {
      __typename
      stringValue
      numericValue
      enumValue
      operator
  }

  fragment EdgeGroupValue on PolarisGroupValue {
      __typename
      label
      id
  }
`;
/**
 * GraphQL query for fetching project configuration data
 * This is the main query used to fetch project details, viewsets, and other configuration
 *
 * ❗❗❗ If making changes here, ensure to update the corresponding ./early-scripts/constants.tsx
 */ const $ea8fd48cc3eebf19$var$PROJECT_CONFIG_QUERY = (0, $kuAvn.default)`
  query jira_polaris_ProjectQuery_reduced(
    $ari: ID!,
    $skipIdeaTypes: Boolean!,
    $isShareViewDialogEnabled: Boolean!,
    $skipDescription: Boolean!,
  ) {
    polarisProject(id: $ari) {
      ...EdgeProjectConfigReducedGQL
    }
  }

  fragment EdgeProjectConfigReducedGQL on PolarisProject {
      __typename
      id
      rankField
      onboarded
      selectedDeliveryProject
      viewsets {
        __typename
        id
        name
        type
        views {
          ...EdgeView
        }
        viewsets {
          __typename
          id
          name
          type
          rank
          views {
            ...EdgeView
          }
        }
      }
      ideaTypes @skip(if: $skipIdeaTypes) {
        __typename
        id
        name
        iconUrl
      }
      onboardTemplate
      onboardedAt
  }
  ${$ea8fd48cc3eebf19$export$2cfc225f457f1fab}
`;
/**
 * Helper function to perform the actual Apollo query
 */ const $ea8fd48cc3eebf19$var$performApolloQuery = async (apolloClient, variables, noCache)=>{
    return apolloClient.query({
        query: $ea8fd48cc3eebf19$var$PROJECT_CONFIG_QUERY,
        variables: variables,
        fetchPolicy: noCache ? 'network-only' : 'cache-first'
    });
};
const $ea8fd48cc3eebf19$export$525bc467aeb111d5 = async (apolloClient, createAnalyticsEvent, projectAri, noCache, fireAnalyticsEvent)=>{
    const fetchStart = new Date();
    // Query parameters
    const queryParams = {
        ari: projectAri,
        skipIdeaTypes: true,
        isShareViewDialogEnabled: true,
        skipDescription: true
    };
    let result;
    const earlyResponsePromise = (0, $2EzOr.getEarlyFetchResponse)(queryParams);
    if (earlyResponsePromise) try {
        // Use the early fetched data
        const data = await (0, $7bPX5.wrapPromiseWithFetchInteraction)(earlyResponsePromise, 'earlyScript/jira_polaris_ProjectQuery_reduced');
        // Create a result object matching the Apollo result structure
        result = {
            data: data,
            loading: false,
            networkStatus: (0, $eezJL.NetworkStatus).ready,
            stale: false
        };
        // Write the early fetched data to Apollo cache
        apolloClient.writeQuery({
            query: $ea8fd48cc3eebf19$var$PROJECT_CONFIG_QUERY,
            variables: queryParams,
            data: data
        });
    } catch (error) {
        // Fall back to normal Apollo query on error
        result = await $ea8fd48cc3eebf19$var$performApolloQuery(apolloClient, queryParams, noCache);
    }
    else // No early fetch data, use normal Apollo query
    result = await $ea8fd48cc3eebf19$var$performApolloQuery(apolloClient, queryParams, noCache);
    if (result.errors !== undefined) throw new Error(`project-config.fetch-error:${result.errors.map((e)=>e.message).join(', ')}`);
    if (fireAnalyticsEvent === true) {
        const analyticsData = (0, $huIQ9.createAnalyticsEventPayload)({
            projectAri: projectAri,
            durationMs: new Date().getTime() - fetchStart.getTime(),
            data: result.data
        });
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'JpdFetchProjectConfig succeeded', analyticsData);
    }
    if (!result.data?.polarisProject) throw new Error('project-config.fetch-error: no data or no data node');
    return result.data.polarisProject;
};
const $ea8fd48cc3eebf19$export$3fef97270b5dce0c = ()=>{
    const client = (0, $1fMqv.useApolloClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fetcher = (0, $eJOHy.useCallback)(async (ari, noCache, fireAnalyticsEvent)=>$ea8fd48cc3eebf19$export$525bc467aeb111d5(client, createAnalyticsEvent, ari, noCache, fireAnalyticsEvent), [
        client,
        createAnalyticsEvent
    ]);
    return [
        fetcher
    ];
};

});
parcelRegister("huIQ9", function(module, exports) {

$parcel$export(module.exports, "createAnalyticsEventPayload", () => $1af75bb60e81f8a6$export$9a9577b55cc5933b);

var $jPROM = parcelRequire("jPROM");

var $3zv7S = parcelRequire("3zv7S");

var $8oKDI = parcelRequire("8oKDI");
const $1af75bb60e81f8a6$var$getViewSetAndViewsCount = (viewsets)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(viewsets)) return {
        viewsCount: 0,
        viewsetsCount: 0
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(viewsets, (acc, viewset)=>{
        // @ts-expect-error - Property 'viewsets' does not exist on type 'readonly jira_polaris_ProjectQuery_reduced_polarisProject_viewsets_viewsets[]
        const childrenCounts = $1af75bb60e81f8a6$var$getViewSetAndViewsCount(viewset.viewsets);
        return {
            viewsCount: acc.viewsCount + // @ts-expect-error - Property 'views' does not exist on type 'readonly jira_polaris_ProjectQuery_reduced_polarisProject_viewsets_viewsets[]
            (viewset.views?.length || 0) + childrenCounts.viewsCount,
            viewsetsCount: acc.viewsetsCount + 1 + childrenCounts.viewsetsCount
        };
    }, {
        viewsCount: 0,
        viewsetsCount: 0
    });
};
const $1af75bb60e81f8a6$export$9a9577b55cc5933b = (props)=>{
    const { projectAri: projectAri, durationMs: durationMs, data: data } = props;
    try {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(data) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(data.polarisProject)) {
            const { onboarded: onboarded, viewsets: viewsets } = data.polarisProject;
            const { cloudId: cloudId, resourceId: resourceId } = (0, $8oKDI.getAriConfig)(projectAri);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const { hostname: hostname } = window.location;
            const viewSetsAndViewsCount = $1af75bb60e81f8a6$var$getViewSetAndViewsCount(viewsets);
            return {
                durationMs: durationMs,
                onboarded: onboarded,
                cloudId: cloudId,
                hostname: hostname,
                projectId: resourceId,
                viewsets: viewSetsAndViewsCount.viewsetsCount,
                views: viewSetsAndViewsCount.viewsCount
            };
        }
        return {
            durationMs: durationMs
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return {
            durationMs: durationMs,
            analyticsDataError: e
        };
    }
};

});

parcelRegister("2EzOr", function(module, exports) {

$parcel$export(module.exports, "getEarlyFetchResponse", () => $9f6a79e123e06126$export$b9d6f7ad3c414536);
$parcel$export(module.exports, "runProjectConfigEarlyScript", () => $9f6a79e123e06126$export$d54a1a2344eae219);

var $57UeM = parcelRequire("57UeM");

var $7Yk0V = parcelRequire("7Yk0V");

var $9LGqd = parcelRequire("9LGqd");

// Create a type-specific early fetch cache for Project Config
const $9f6a79e123e06126$var$earlyFetchCache = (0, $57UeM.createEarlyFetchCache)({});
const $9f6a79e123e06126$export$b9d6f7ad3c414536 = (params)=>{
    return $9f6a79e123e06126$var$earlyFetchCache.getCachedResponse(params);
};
const $9f6a79e123e06126$export$191ccffcb853424f = (projectAri)=>{
    // Create fetch parameters for the project config query
    const queryParams = {
        ari: projectAri,
        skipIdeaTypes: true,
        isShareViewDialogEnabled: true,
        skipDescription: true
    };
    // Create the fetch promise without awaiting it
    const fetchPromise = (0, $9LGqd.fetchData)({
        url: '/gateway/api/graphql?operation=jira_polaris_ProjectQuery_reduced',
        method: 'POST',
        body: JSON.stringify({
            operationName: 'jira_polaris_ProjectQuery_reduced',
            query: (0, $cbb503bfc97141d9$export$324472077e88eb3e).replace(/\n/g, ' ').trim(),
            variables: queryParams
        }),
        headers: {
            'X-ExperimentalApi': [
                'polaris-v0',
                'Townsquare'
            ]
        }
    });
    // Transform the promise to handle errors and extract data
    const dataPromise = fetchPromise.then((result)=>{
        if (result.errors) throw new Error(`GraphQL errors: ${JSON.stringify(result.errors)}`);
        return result.data;
    });
    // Immediately store the promise in the cache
    $9f6a79e123e06126$var$earlyFetchCache.setCacheResponse(dataPromise, queryParams);
    return dataPromise;
};
function $9f6a79e123e06126$export$d54a1a2344eae219(projectId) {
    // Get the project ARI
    const projectAri = (0, $7Yk0V.getProjectAri)(projectId);
    if (!projectAri) return null;
    // Prefetch the project config data
    return $9f6a79e123e06126$export$191ccffcb853424f(projectAri);
}

});
parcelRegister("7Yk0V", function(module, exports) {

$parcel$export(module.exports, "getProjectAri", () => $2ec9d2989bd14425$export$1029c05cae8fb823);
$parcel$export(module.exports, "getViewAri", () => $2ec9d2989bd14425$export$80529a47d985c51);

var $3osLr = parcelRequire("3osLr");

var $gtr2v = parcelRequire("gtr2v");

var $2p2Qe = parcelRequire("2p2Qe");
const $2ec9d2989bd14425$export$1029c05cae8fb823 = (projectId)=>{
    const cloudId = (0, $2p2Qe.getCloudIdFromDocument)();
    if (!projectId || !cloudId) return null;
    try {
        return (0, $3osLr.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString();
    } catch (error) {
        // Return null if ARI creation fails (e.g., invalid projectId format)
        return null;
    }
};
const $2ec9d2989bd14425$export$80529a47d985c51 = (viewId)=>{
    const cloudId = (0, $2p2Qe.getCloudIdFromDocument)();
    if (!viewId || !cloudId) return null;
    try {
        return (0, $gtr2v.AnyAri).create({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'view',
            resourceId: viewId
        }).toString();
    } catch (error) {
        // Return null if ARI creation fails (e.g., invalid viewId format)
        return null;
    }
};

});
parcelRegister("2p2Qe", function(module, exports) {

$parcel$export(module.exports, "getCloudIdFromDocument", () => $7452f628c2b367ed$export$40c572cbc6511a55);
/**
 * Gets the cloudId from document
 * cloudId is stored in a meta tag with name "ajs-cloud-id" generated by SSR
 */ const $7452f628c2b367ed$export$40c572cbc6511a55 = ()=>{
    const metaTag = globalThis.document?.querySelector('meta[name="ajs-cloud-id"]');
    if (metaTag && metaTag.getAttribute('content')) return metaTag.getAttribute('content');
    // Fallback to null if not found
    return null;
};

});


/**
 * GraphQL fragment string for view data structure
 * Contains the common view fields used in project config queries
 *
 * ❗❗❗ If making changes here, ensure to update the corresponding fragments in ../index.tsx
 */ const $cbb503bfc97141d9$export$c521ba123270e2f8 = `
  fragment EdgeView on PolarisView {
    __typename
    id
    xid
    name
    emoji
    description @skip(if: $skipDescription)
    uuid @include(if: $isShareViewDialogEnabled)
    containsArchived
    immutable
    visualizationType
    lastCommentsViewedTimestamp
    sortMode
    hideEmptyGroups
    hideEmptyColumns
    groupBy {
        __typename
        key: jiraFieldKey
    }
    verticalGroupBy {
        __typename
        key: jiraFieldKey
    }
    groupValues {
        ...EdgeGroupValue
    }
    verticalGroupValues {
        ...EdgeGroupValue
    }
    sort {
        ...EdgeSorted
    }
    fields {
        __typename
        key: jiraFieldKey
    }
    hidden {
        __typename
        key: jiraFieldKey
    }
    filter {
        ...EdgeFilter
    }
    tableColumnSizes {
        ...EdgeColumnSizes
    }
    fieldRollups {
        ...EdgeFieldRollups
    }
    matrixConfig {
        __typename
        axes {
            __typename
            dimension
            field {
                __typename
                key: jiraFieldKey
            }
            fieldOptions {
                ...EdgeGroupValue
            }
            reversed
        }
    }
    timelineConfig {
        __typename
        summaryCardField {
            __typename
            key: jiraFieldKey
        }
        startDateField {
            __typename
            key: jiraFieldKey
        }
        dueDateField {
            __typename
            key: jiraFieldKey
        }
        mode
        startTimestamp
        endTimestamp
    }
    rank
    viewSetId
    enabledAutoSave
    layoutType
    createdAt
    updatedAt
  }


  fragment EdgeColumnSizes on PolarisViewTableColumnSize {
      __typename
      field {
          __typename
          key: jiraFieldKey
      }
      size
  }

  fragment EdgeFieldRollups on PolarisViewFieldRollup {
      __typename
      field {
          __typename
          key: jiraFieldKey
      }
      rollup
  }

  fragment EdgeSorted on PolarisSortField {
      __typename
      order
      field {
          __typename
          key: jiraFieldKey
      }
    }

  fragment EdgeFilter on PolarisViewFilter {
      __typename
      type: kind
      field {
          __typename
          key: jiraFieldKey
      }
      values {
          ...EdgeFilterValue
      }
  }

  fragment EdgeFilterValue on PolarisViewFilterValue {
      __typename
      stringValue
      numericValue
      enumValue
      operator
  }

  fragment EdgeGroupValue on PolarisGroupValue {
      __typename
      label
      id
  }
`;
const $cbb503bfc97141d9$export$324472077e88eb3e = `
  query jira_polaris_ProjectQuery_reduced(
    $ari: ID!,
    $skipIdeaTypes: Boolean!,
    $isShareViewDialogEnabled: Boolean!,
    $skipDescription: Boolean!,
  ) {
    polarisProject(id: $ari) {
      ...EdgeProjectConfigReducedGQL
    }
  }

  fragment EdgeProjectConfigReducedGQL on PolarisProject {
      __typename
      id
      rankField
      onboarded
      selectedDeliveryProject
      viewsets {
        __typename
        id
        name
        type
        views {
          ...EdgeView
        }
        viewsets {
          __typename
          id
          name
          type
          rank
          views {
            ...EdgeView
          }
        }
      }
      ideaTypes @skip(if: $skipIdeaTypes) {
        __typename
        id
        name
        iconUrl
      }
      onboardTemplate
      onboardedAt
  }
  ${$cbb503bfc97141d9$export$c521ba123270e2f8}
`;





parcelRegister("2zEZy", function(module, exports) {

$parcel$export(module.exports, "transformView", () => $9a2d5ac0a1447c4a$export$601ea8be46c5c28c);
$parcel$export(module.exports, "transformViewSets", () => $9a2d5ac0a1447c4a$export$a1dcf90bc3c40fe2);

var $guEFH = parcelRequire("guEFH");

var $8oKDI = parcelRequire("8oKDI");


var $8m4OM = parcelRequire("8m4OM");


var $bHZrQ = parcelRequire("bHZrQ");

var $7jTnu = parcelRequire("7jTnu");

var $fSFXe = parcelRequire("fSFXe");

var $btZbH = parcelRequire("btZbH");
const $9a2d5ac0a1447c4a$var$getIsAutosaveEnabled = (gqlView)=>{
    return typeof gqlView.enabledAutoSave === 'boolean' ? gqlView.enabledAutoSave : true;
};
const $9a2d5ac0a1447c4a$export$9ede8943883756f7 = (gqlView, getField)=>{
    if (gqlView.visualizationType !== 'TIMELINE') return undefined;
    // return defaults if timelineConfig is not defined
    if (!gqlView.timelineConfig) return {
        startDateField: undefined,
        dueDateField: undefined,
        mode: (0, $bHZrQ.PolarisTimelineMode).QUARTERS
    };
    return {
        startDateField: getField(gqlView.timelineConfig.startDateField),
        dueDateField: getField(gqlView.timelineConfig.dueDateField),
        mode: gqlView.timelineConfig.mode,
        startTimestamp: gqlView.timelineConfig.startTimestamp,
        endTimestamp: gqlView.timelineConfig.endTimestamp,
        summaryCardField: getField(gqlView.timelineConfig.summaryCardField)
    };
};
const $9a2d5ac0a1447c4a$var$transformFilter = (gqlFilter, getField)=>{
    if (!gqlFilter) return [];
    const transformed = [];
    gqlFilter.forEach((filter)=>{
        if (filter?.values.length !== 0) {
            const resolvedField = getField(filter.field);
            switch(filter.type){
                case (0, $btZbH.FILTER_KIND).FIELD_IDENTITY:
                    if (resolvedField !== undefined) {
                        const filterValues = [];
                        filter.values.forEach((fv)=>{
                            if (fv !== null && fv !== undefined) filterValues.push({
                                stringValue: fv.stringValue !== null && fv.stringValue !== '' ? fv.stringValue : undefined
                            });
                        });
                        transformed.push({
                            type: (0, $8m4OM.GENERIC_FIELD_FILTER),
                            field: resolvedField.key,
                            fieldType: resolvedField.type,
                            values: filterValues
                        });
                    }
                    break;
                case (0, $btZbH.FILTER_KIND).FIELD_NUMERIC:
                    if (resolvedField !== undefined) {
                        const filterValues = [];
                        filter.values.forEach((fv)=>{
                            if (fv?.operator === 'EQ' || fv?.operator === 'GT' || fv?.operator === 'LT' || fv?.operator === 'GTE' || fv?.operator === 'LTE' || fv?.operator === 'NEQ') filterValues.push({
                                numericValue: fv.numericValue !== null ? fv.numericValue : undefined,
                                operator: fv.operator
                            });
                        });
                        transformed.push({
                            type: (0, $8m4OM.NUMERIC_FIELD_FILTER),
                            field: resolvedField.key,
                            fieldType: resolvedField.type,
                            values: filterValues
                        });
                    }
                    break;
                case (0, $btZbH.FILTER_KIND).INTERVAL:
                    if (resolvedField !== undefined) transformed.push((0, $fSFXe.transformIntervalFilter)(filter.values, resolvedField.key));
                    break;
                case (0, $btZbH.FILTER_KIND).TEXT:
                    {
                        const filterValues = [];
                        filter.values.forEach((fv)=>{
                            if (fv !== null && fv !== undefined) filterValues.push({
                                stringValue: fv.stringValue !== null ? fv.stringValue : undefined
                            });
                        });
                        transformed.push({
                            type: (0, $8m4OM.TEXT_FIELD_FILTER),
                            values: filterValues
                        });
                        break;
                    }
                case (0, $btZbH.FILTER_KIND).CONNECTION_FIELD_IDENTITY:
                    if (resolvedField !== undefined) {
                        const filterValues = [];
                        filter.values.forEach((fv)=>{
                            if (fv !== null && fv !== undefined && fv.enumValue !== undefined) {
                                if (fv.enumValue === (0, $8m4OM.CONNECTION_FIELD_FILTER_BOARD_COLUMN) || fv.enumValue === (0, $8m4OM.CONNECTION_FIELD_FILTER_VIEW_GROUP)) filterValues.push({
                                    enumValue: fv.enumValue
                                });
                            }
                        });
                        transformed.push({
                            type: (0, $8m4OM.CONNECTION_FIELD_FILTER),
                            field: resolvedField.key,
                            fieldType: resolvedField.type,
                            values: filterValues
                        });
                    }
                    break;
                default:
            }
        }
    });
    return transformed;
};
const $9a2d5ac0a1447c4a$var$transformFilterGroups = (gqlFilter, gqlFilterGroups, getField)=>{
    const allIssuesFilter = $9a2d5ac0a1447c4a$var$transformFilter(gqlFilter, getField);
    return [
        ...allIssuesFilter.length > 0 ? [
            {
                groupFilter: undefined,
                filters: allIssuesFilter
            }
        ] : []
    ];
};
const $9a2d5ac0a1447c4a$var$transformGroupValues = (groupValues)=>{
    if (groupValues === undefined || groupValues === null) return [];
    const transformed = [];
    groupValues.forEach((value)=>{
        if (value !== null && value !== undefined) transformed.push({
            id: value.id !== null ? value.id : undefined,
            label: value.label !== null ? value.label : undefined
        });
    });
    return transformed;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9a2d5ac0a1447c4a$var$transformDescription = (description)=>description !== null ? description : undefined;
const $9a2d5ac0a1447c4a$var$transformMatrixConfig = (matrixConfig, getField)=>{
    if (!matrixConfig) return undefined;
    const axes = matrixConfig.axes?.map((axis)=>({
            dimension: axis.dimension,
            field: getField(axis.field),
            fieldOptions: $9a2d5ac0a1447c4a$var$transformGroupValues(axis.fieldOptions) ?? [],
            reversed: axis.reversed
        })) ?? [];
    return {
        axes: axes
    };
};
const $9a2d5ac0a1447c4a$var$extractSortMode = (sortMode, sortFieldsLength)=>{
    if (sortMode === 'FIELDS_SORT' && sortFieldsLength > 0) return 0, $f3f1bd644cfe4e35$export$46fe69a6d17f56c4;
    if (sortMode === 'VIEW_RANK') return 0, $f3f1bd644cfe4e35$export$a95cb1c0dd162f95;
    return 0, $f3f1bd644cfe4e35$export$b751518930c382de;
};
const $9a2d5ac0a1447c4a$var$transformTableColumnSizes = (tableColumnSizes, getField)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    tableColumnSizes.map(({ field: field, size: size })=>({
            fieldKey: getField(field)?.key,
            size: size
        })).filter(({ fieldKey: fieldKey })=>!!fieldKey);
const $9a2d5ac0a1447c4a$var$transformFieldRollups = (fieldRollups, getField)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    fieldRollups.map(({ field: field, rollup: rollup })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const rollupOperation = rollup;
        return {
            fieldKey: getField(field)?.key,
            rollup: rollupOperation
        };
    }).filter(({ fieldKey: fieldKey })=>!!fieldKey);
const $9a2d5ac0a1447c4a$export$601ea8be46c5c28c = (gqlView, fieldsByKey)=>{
    const getField = (field)=>{
        if (!field?.key) return undefined;
        return fieldsByKey[field.key];
    };
    const resolvedGroupByKey = getField(gqlView.groupBy)?.key;
    const resolvedVerticalGroupByKey = getField(gqlView.verticalGroupBy)?.key;
    const resolvedFieldKeys = (gqlView.fields || []).map(getField).filter(Boolean).map(({ key: key })=>key).filter(Boolean);
    // defensive measure following past customer incidents as this would break a lot of functionnality
    // https://pi-dev-sandbox.atlassian.net/browse/POL-7518
    if (!resolvedFieldKeys.includes((0, $9a5f06039e1dff5a$export$469f8bf472cb9ca))) resolvedFieldKeys.unshift((0, $9a5f06039e1dff5a$export$469f8bf472cb9ca));
    const resolvedHiddenFieldKeys = (gqlView.hidden || []).map(getField).filter(Boolean).map(({ key: key })=>key).filter(Boolean);
    const resolvedSortBy = gqlView.sort ? gqlView.sort.map((s)=>({
            asc: s.order === 'ASC',
            fieldKey: getField(s.field)?.key
        })).filter((s)=>!!s.fieldKey) : undefined;
    const groupValues = $9a2d5ac0a1447c4a$var$transformGroupValues(gqlView.groupValues);
    const verticalGroupValues = $9a2d5ac0a1447c4a$var$transformGroupValues(gqlView.verticalGroupValues);
    const filter = (0, $7jTnu.fg)('jpd_filter_groups_by_issue_type') ? [] : $9a2d5ac0a1447c4a$var$transformFilter(gqlView.filter, getField);
    const filterGroups = (0, $7jTnu.fg)('jpd_filter_groups_by_issue_type') ? $9a2d5ac0a1447c4a$var$transformFilterGroups(gqlView.filter, [], getField) : [];
    const viewId = (0, $8oKDI.toAri)(gqlView.id);
    if (viewId === undefined) throw new Error(`Expected ARI for viewId, got: '${gqlView.id}'`);
    const description = $9a2d5ac0a1447c4a$var$transformDescription(gqlView.description);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        viewId: viewId,
        viewLegacyId: gqlView.xid,
        kind: gqlView.visualizationType,
        title: gqlView.name,
        uuid: gqlView.uuid,
        emoji: gqlView.emoji,
        description: description,
        editable: !gqlView.immutable,
        filter: filter,
        filterGroups: filterGroups,
        fields: resolvedFieldKeys,
        hidden: resolvedHiddenFieldKeys,
        fieldRollups: $9a2d5ac0a1447c4a$var$transformFieldRollups(gqlView.fieldRollups ?? [], getField),
        groupBy: resolvedGroupByKey,
        verticalGroupBy: resolvedVerticalGroupByKey,
        groupValues: groupValues,
        verticalGroupValues: verticalGroupValues,
        hideEmptyGroups: !!gqlView.hideEmptyGroups,
        hideEmptyColumns: !!gqlView.hideEmptyColumns,
        containsArchived: gqlView.containsArchived,
        rank: gqlView.rank,
        sortBy: resolvedSortBy,
        sortMode: $9a2d5ac0a1447c4a$var$extractSortMode(gqlView.sortMode, resolvedSortBy?.length ?? 0),
        viewSetId: gqlView.viewSetId,
        lastCommentsViewedTimestamp: gqlView.lastCommentsViewedTimestamp === null ? undefined : (0, $guEFH.default)(new Date(gqlView.lastCommentsViewedTimestamp)),
        tableColumnSizes: $9a2d5ac0a1447c4a$var$transformTableColumnSizes(gqlView.tableColumnSizes ?? [], getField),
        matrixConfig: $9a2d5ac0a1447c4a$var$transformMatrixConfig(gqlView.matrixConfig, getField),
        timelineConfig: $9a2d5ac0a1447c4a$export$9ede8943883756f7(gqlView, getField),
        isAutosaveEnabled: $9a2d5ac0a1447c4a$var$getIsAutosaveEnabled(gqlView),
        layoutType: gqlView.layoutType,
        createdAtTimestamp: gqlView.createdAt,
        updatedAtTimestamp: gqlView.updatedAt
    };
};
const $9a2d5ac0a1447c4a$var$transformViews = (views, fieldsByKey)=>views.map((gqlView)=>$9a2d5ac0a1447c4a$export$601ea8be46c5c28c(gqlView, fieldsByKey))// Sort array of views based on rank
    .sort(({ rank: rankA }, { rank: rankB })=>rankA - rankB);
const $9a2d5ac0a1447c4a$export$a1dcf90bc3c40fe2 = (gqViewSets, fields, currentViewSlug, checkIsViewCollapsed)=>gqViewSets.map((gqViewSet)=>{
        const remoteViews = $9a2d5ac0a1447c4a$var$transformViews(gqViewSet.views, fields);
        // Transform views inside sections
        const transformedViewSets = gqViewSet.viewsets?.map((vSet)=>{
            const transformedViews = $9a2d5ac0a1447c4a$var$transformViews(vSet.views, fields);
            const isCollapsed = checkIsViewCollapsed(transformedViews, currentViewSlug);
            return {
                ...vSet,
                views: transformedViews,
                collapsed: isCollapsed
            };
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            id: gqViewSet.id,
            name: gqViewSet.name,
            type: gqViewSet.type,
            views: remoteViews,
            viewSets: transformedViewSets,
            collapsed: false,
            rank: 0
        };
    });

});
/** This sort mode is the default global mode based on LexoRank */ const $f3f1bd644cfe4e35$export$b751518930c382de = 'projectRank';
const $f3f1bd644cfe4e35$export$a95cb1c0dd162f95 = 'viewRank';
const $f3f1bd644cfe4e35$export$46fe69a6d17f56c4 = 'fieldSort';

parcelRegister("bHZrQ", function(module, exports) {

$parcel$export(module.exports, "PolarisTimelineMode", () => $71fa54021b9f5ba7$export$14a23e97810cf04b);
$parcel$export(module.exports, "NO_GROUPING_GROUP_ID", () => $71fa54021b9f5ba7$export$7785f63e3e3df83b);
// TODO: go/restrict-enums
var $71fa54021b9f5ba7$export$14a23e97810cf04b = /*#__PURE__*/ function(PolarisTimelineMode) {
    PolarisTimelineMode["MONTHS"] = "MONTHS";
    PolarisTimelineMode["QUARTERS"] = "QUARTERS";
    return PolarisTimelineMode;
}({});
const $71fa54021b9f5ba7$export$7785f63e3e3df83b = 'NO_GROUPING';

});

parcelRegister("fSFXe", function(module, exports) {

$parcel$export(module.exports, "transformIntervalFilter", () => $9994c11f8d915da3$export$a89d1358c9522c95);

var $7jTnu = parcelRequire("7jTnu");

var $8m4OM = parcelRequire("8m4OM");

var $4dsfo = parcelRequire("4dsfo");
const $9994c11f8d915da3$var$transformIntervalFilterOperatorsLegacy = (inputValues)=>{
    const outputValues = [];
    inputValues.forEach((value)=>{
        if (value?.operator === (0, $8m4OM.END_AFTER_NOW) || value?.operator === (0, $8m4OM.END_BEFORE_NOW) || value?.operator === (0, $8m4OM.START_AFTER_NOW) || value?.operator === (0, $8m4OM.START_BEFORE_NOW)) outputValues.push({
            numericValue: value.numericValue !== null ? value.numericValue : 0,
            operator: value.operator
        });
    });
    return outputValues;
};
const $9994c11f8d915da3$var$transformIntervalFilterOperatorsNext = (inputValues)=>{
    const outputValues = [];
    inputValues.forEach((gqlValue)=>{
        if (gqlValue.operator === (0, $8m4OM.END_AFTER_NOW) || gqlValue.operator === (0, $8m4OM.END_BEFORE_NOW) || gqlValue.operator === (0, $8m4OM.START_AFTER_NOW) || gqlValue.operator === (0, $8m4OM.START_BEFORE_NOW)) {
            const filterValue = {
                numericValue: gqlValue.numericValue !== null ? gqlValue.numericValue : 0,
                operator: gqlValue.operator
            };
            outputValues.push(filterValue);
            return;
        }
        if (gqlValue.operator === 'EQ' && gqlValue.numericValue === null) {
            const filterValue = {
                operator: gqlValue.operator,
                value: null,
                text: null
            };
            outputValues.push(filterValue);
            return;
        }
        if (gqlValue.operator === null && gqlValue.stringValue) {
            let filterValue;
            try {
                filterValue = JSON.parse(gqlValue.stringValue);
            } catch  {
            // do nothing
            }
            if (filterValue && ((0, $4dsfo.isIntervalFieldFilterAbsoluteDatesValue)(filterValue) || (0, $4dsfo.isIntervalFieldFilterRollingDatesCurrentValue)(filterValue) || (0, $4dsfo.isIntervalFieldFilterRollingDatesPastNextValue)(filterValue))) outputValues.push(filterValue);
        }
    });
    return outputValues;
};
const $9994c11f8d915da3$export$a89d1358c9522c95 = (gqlValues, fieldKey)=>{
    const values = (0, $7jTnu.fg)('polaris_better_date_filters') ? $9994c11f8d915da3$var$transformIntervalFilterOperatorsNext(gqlValues) : $9994c11f8d915da3$var$transformIntervalFilterOperatorsLegacy(gqlValues);
    const base = {
        type: (0, $8m4OM.INTERVAL_FIELD_FILTER),
        field: fieldKey
    };
    // Unfortunately, the manual control flow analysis here is required
    // because otherwise TypeScript compiler is unable to correctly
    // determine the typing of the union types
    // @see https://github.com/microsoft/TypeScript/issues/30581
    // @see https://github.com/microsoft/TypeScript/issues/25051
    //
    // The other way around to "reduce" the code size and avoid
    // multiple type guards is to use type assertion
    // @see https://stackoverflow.com/a/64467314
    for (const value of values){
        if ((0, $4dsfo.isIntervalFieldFilterLegacyValue)(value)) return {
            ...base,
            values: [
                value
            ]
        };
        if ((0, $4dsfo.isIntervalFieldFilterAbsoluteDatesValue)(value)) return {
            ...base,
            values: [
                value
            ]
        };
        if ((0, $4dsfo.isIntervalFieldFilterRollingDatesCurrentValue)(value)) return {
            ...base,
            values: [
                value
            ]
        };
        if ((0, $4dsfo.isIntervalFieldFilterRollingDatesPastNextValue)(value)) return {
            ...base,
            values: [
                value
            ]
        };
        if ((0, $4dsfo.isIntervalFieldFilterEmptyValue)(value)) return {
            ...base,
            values: [
                value
            ]
        };
    }
    return {
        ...base,
        values: []
    };
};

});

parcelRegister("btZbH", function(module, exports) {

$parcel$export(module.exports, "FILTER_KIND", () => $5e59610b1db69c74$export$3c6f634eaf477c42);
const $5e59610b1db69c74$export$3c6f634eaf477c42 = {
    FIELD_IDENTITY: 'FIELD_IDENTITY',
    FIELD_NUMERIC: 'FIELD_NUMERIC',
    TEXT: 'TEXT',
    INTERVAL: 'INTERVAL',
    CONNECTION_FIELD_IDENTITY: 'CONNECTION_FIELD_IDENTITY'
};

});


parcelRegister("jDdjf", function(module, exports) {

$parcel$export(module.exports, "createProjectAri", () => $eddbf07f942dc321$export$e12cf9774899f456);
$parcel$export(module.exports, "createIssueAri", () => $eddbf07f942dc321$export$6b0ec881a3540845);
$parcel$export(module.exports, "createIssueFieldValueAriWithFieldKey", () => $eddbf07f942dc321$export$cfb7c5aed457acf0);
$parcel$export(module.exports, "createViewAri", () => $eddbf07f942dc321$export$8e9e81ca81fb9409);
$parcel$export(module.exports, "createViewSetAri", () => $eddbf07f942dc321$export$ecff88502b704ae1);
$parcel$export(module.exports, "cloudifyViewAri", () => $eddbf07f942dc321$export$249628ec1ad607cc);

var $8oKDI = parcelRequire("8oKDI");
const $eddbf07f942dc321$export$e12cf9774899f456 = (cloudId, projectId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: projectId
    });
const $eddbf07f942dc321$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });
const $eddbf07f942dc321$export$cfb7c5aed457acf0 = (cloudId, issueId, fieldKey)=>{
    const ariWithoutFieldKey = (0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issuefieldvalue',
        resourceId: issueId
    });
    return `${ariWithoutFieldKey}/${fieldKey}`;
};
const $eddbf07f942dc321$export$8e9e81ca81fb9409 = (cloudId, viewId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'view',
        resourceId: viewId
    });
const $eddbf07f942dc321$export$66600f07ac652656 = (cloudId, jiraOptionId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'option',
        resourceId: jiraOptionId
    });
const $eddbf07f942dc321$export$ecff88502b704ae1 = (cloudId, viewSetId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'viewset',
        resourceId: viewSetId
    });
const $eddbf07f942dc321$export$249628ec1ad607cc = (cloudId, viewAri)=>{
    const ari = (0, $8oKDI.toAri)(viewAri);
    if (ari === undefined) return viewAri; // return unchanged in this case, we can't even parse it
    const viewAriConfig = (0, $8oKDI.getAriConfig)(ari);
    const viewAriWithCloud = viewAriConfig.workspaceId != null ? `ari:cloud:jira:${cloudId}:view/${viewAriConfig.workspaceId}/${viewAriConfig.resourceId}` : `ari:cloud:jira:${cloudId}:view/${viewAriConfig.resourceId}`;
    return viewAriWithCloud;
};

});

parcelRegister("kmMXp", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $32ddbb277aed37a2$export$3901076af3749fa9);
$parcel$export(module.exports, "useCloudId", () => $32ddbb277aed37a2$export$9da0f7c65f28ed16);

var $lvKO5 = parcelRequire("lvKO5");
const $32ddbb277aed37a2$export$3901076af3749fa9 = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $lvKO5.useTenantContext)();
    return atlassianAccountId || undefined;
};
const $32ddbb277aed37a2$export$9da0f7c65f28ed16 = ()=>{
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    return cloudId;
};

});

parcelRegister("6BmVy", function(module, exports) {

$parcel$export(module.exports, "getUserName", () => $f770615335657280$export$c1fb9bac27b52cdd);

var $1Ozm9 = parcelRequire("1Ozm9");
const $f770615335657280$var$getUserFullEndpoint = (accountId = '')=>`/rest/api/3/user?accountId=${encodeURIComponent(accountId)}`;
const $f770615335657280$export$7cbf767827cd68ba = (accountId = '')=>{
    if (!accountId) return Promise.resolve({
        userId: '',
        name: '',
        avatar: '',
        email: ''
    });
    return (0, $1Ozm9.default)($f770615335657280$var$getUserFullEndpoint(accountId)).then((user)=>({
            email: user.emailAddress,
            name: user.displayName,
            userId: user.accountId,
            avatar: user.avatarUrls['48x48']
        }));
};
const $f770615335657280$export$c1fb9bac27b52cdd = async (userId)=>{
    let userName;
    try {
        const user = await $f770615335657280$export$7cbf767827cd68ba(userId);
        userName = user.name || undefined;
    } catch (error) {
        userName = undefined;
    }
    return userName;
};

});

const $c91d3dca4b4a5f9e$export$6b2efece5b1a2158 = 2000;

parcelRegister("jiBgT", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $aafd86224bbb7d8e$export$3901076af3749fa9);
$parcel$export(module.exports, "useCurrentUserTimezone", () => $aafd86224bbb7d8e$export$658449cd23a1e455);
$parcel$export(module.exports, "useCurrentUserAccountId", () => $aafd86224bbb7d8e$export$5e77528633a961dd);
$parcel$export(module.exports, "useCurrentUserAvatar", () => $aafd86224bbb7d8e$export$50bb8adf3f82323);
$parcel$export(module.exports, "useCurrentUserDisplayName", () => $aafd86224bbb7d8e$export$b85c70edd241de91);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");

var $c9f6v = parcelRequire("c9f6v");
const $aafd86224bbb7d8e$export$3901076af3749fa9 = ()=>{
    const [{ data: data, error: error, loading: loading }, { fetch: fetch }] = (0, $c9f6v.useUserSubscriber)();
    const { atlassianAccountId: atlassianAccountId } = (0, $lvKO5.useTenantContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (atlassianAccountId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: atlassianAccountId
            },
            header: {}
        }, false);
    }, [
        atlassianAccountId,
        fetch
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: data,
            error: error,
            loading: loading
        }), [
        data,
        error,
        loading
    ]);
};
const $aafd86224bbb7d8e$export$658449cd23a1e455 = ()=>{
    const { data: data, error: error, loading: loading } = $aafd86224bbb7d8e$export$3901076af3749fa9();
    if (loading || error) return '';
    return data?.timeZone || '';
};
const $aafd86224bbb7d8e$export$5e77528633a961dd = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $lvKO5.useTenantContext)();
    return atlassianAccountId;
};
const $aafd86224bbb7d8e$export$50bb8adf3f82323 = ()=>{
    const { data: data, error: error, loading: loading } = $aafd86224bbb7d8e$export$3901076af3749fa9();
    if (loading || error) return undefined;
    return data?.avatarUrls['32x32'];
};
const $aafd86224bbb7d8e$export$b85c70edd241de91 = ()=>{
    const { data: data, error: error, loading: loading } = $aafd86224bbb7d8e$export$3901076af3749fa9();
    if (loading || error) return undefined;
    return data?.displayName;
};

});

parcelRegister("kYdmg", function(module, exports) {

$parcel$export(module.exports, "setCurrentViewFromRoute", () => $99b987ced95bfac5$export$2919e6e8a7dcb8d7);
$parcel$export(module.exports, "setCurrentView", () => $99b987ced95bfac5$export$f090a900c52a5279);

var $cGzYX = parcelRequire("cGzYX");

var $6SinZ = parcelRequire("6SinZ");

var $k1pTi = parcelRequire("k1pTi");

var $6Mk0X = parcelRequire("6Mk0X");

var $7DWfj = parcelRequire("7DWfj");


var $hJWAv = parcelRequire("hJWAv");

var $8BCIS = parcelRequire("8BCIS");

var $4GgU4 = parcelRequire("4GgU4");

var $gxJaN = parcelRequire("gxJaN");

var $hbBW0 = parcelRequire("hbBW0");

var $egEA8 = parcelRequire("egEA8");

var $cyCtl = parcelRequire("cyCtl");
const $99b987ced95bfac5$export$2919e6e8a7dcb8d7 = ()=>({ dispatch: dispatch, getState: getState }, { currentViewSlug: currentViewSlug })=>{
        if (currentViewSlug && currentViewSlug !== getState().prevContainerProps?.currentViewSlug) {
            const view = (0, $7DWfj.getViewBySlug)(getState(), currentViewSlug);
            if (!view) return;
            dispatch($99b987ced95bfac5$export$f090a900c52a5279(view.id, true));
        }
    };
const $99b987ced95bfac5$export$f090a900c52a5279 = (id, ignoreRouting = false)=>({ dispatch: dispatch, getState: getState }, { router: router, fields: fields })=>{
        const view = (0, $7DWfj.getViewById)(getState(), id);
        if (view !== undefined) {
            const { viewId: viewId, uuid: uuid, slug: slug } = view;
            if (viewId !== undefined) {
                (0, $cyCtl.trackAtlasAnalytics)(view, fields);
                dispatch((0, $8BCIS.loadViewComments)(viewId));
                dispatch((0, $hbBW0.refreshIssueRanking)(viewId));
                if (view.kind === (0, $6SinZ.VIEW_KIND_TIMELINE)) {
                    dispatch((0, $egEA8.refreshArrangementInformation)(viewId));
                    if (uuid) dispatch((0, $gxJaN.loadViewMarkers)(uuid));
                }
                dispatch((0, $hJWAv.resetDraft)(viewId));
            }
            if ((0, $6Mk0X.getDeliveryDataFetchError)(getState()) && (0, $cGzYX.hasFieldKeyDependingOnDeliveryData)(view.fields, fields)) dispatch((0, $4GgU4.showStoredDeliveryDataFetchError)());
            (0, $k1pTi.startCurrentViewLoadExperience)(view.kind);
            if (ignoreRouting) return;
            router.routeTo({
                section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
                resource: slug
            }, {
                clearParameters: false
            });
        }
    };

});
parcelRegister("cGzYX", function(module, exports) {

$parcel$export(module.exports, "hasFieldKeyDependingOnDeliveryData", () => $a75a83c09f6de4af$export$c8edb096bd4713c6);

var $eTBmS = parcelRequire("eTBmS");

var $1sSJh = parcelRequire("1sSJh");
const $a75a83c09f6de4af$var$isDependingOnDeliveryData = (field)=>(0, $eTBmS.isDeliveryFieldType)(field.type) || (0, $1sSJh.isIntervalFieldWithDeliveryDateConfig)(field);
const $a75a83c09f6de4af$export$c8edb096bd4713c6 = (fieldKeys, fields)=>!!fieldKeys.find((fieldKey)=>fields[fieldKey] && $a75a83c09f6de4af$var$isDependingOnDeliveryData(fields[fieldKey]));

});
parcelRegister("1sSJh", function(module, exports) {

$parcel$export(module.exports, "isIntervalFieldSourcesKey", () => $eb000bd491df15f3$export$92f77cba7c01c50d);
$parcel$export(module.exports, "isIntervalFieldWithDeliveryDateConfig", () => $eb000bd491df15f3$export$6a7402cf653b09f6);

var $eTBmS = parcelRequire("eTBmS");

var $8Z1Mi = parcelRequire("8Z1Mi");
const $eb000bd491df15f3$export$92f77cba7c01c50d = (source)=>source in (0, $8Z1Mi.INTERVAL_FIELD_SOURCES);
const $eb000bd491df15f3$var$isValidDeliveryDateConfiguration = (configuration)=>!!(configuration && configuration.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).DELIVERY_DATE && configuration.customfieldKey && configuration.aggregationType);
const $eb000bd491df15f3$export$6a7402cf653b09f6 = (field)=>field.type === (0, $eTBmS.FIELD_TYPES).INTERVAL && $eb000bd491df15f3$var$isValidDeliveryDateConfiguration(field.configuration);

});


parcelRegister("k1pTi", function(module, exports) {

$parcel$export(module.exports, "startCurrentViewLoadExperience", () => $8827bd73aad4397a$export$1683b5fa44f815dc);

var $6SinZ = parcelRequire("6SinZ");

var $b5oGV = parcelRequire("b5oGV");
const $8827bd73aad4397a$export$1683b5fa44f815dc = (viewKind)=>{
    switch(viewKind){
        case 0, $6SinZ.VIEW_KIND_MATRIX:
            (0, $b5oGV.experience).matrixView.pageSegmentLoad.start();
            break;
        case 0, $6SinZ.VIEW_KIND_TIMELINE:
            (0, $b5oGV.experience).timelineView.pageSegmentLoad.start();
            break;
        case 0, $6SinZ.VIEW_KIND_BOARD:
            (0, $b5oGV.experience).boardView.pageSegmentLoad.start();
            break;
        case 0, $6SinZ.VIEW_KIND_TABLE:
            (0, $b5oGV.experience).listView.pageSegmentLoad.start();
            break;
        default:
    }
};

});

parcelRegister("7DWfj", function(module, exports) {

$parcel$export(module.exports, "getHasCurrentView", () => $78bc96f931ebc4a2$export$fb42d512f96b69f5);
$parcel$export(module.exports, "getCurrentUser", () => $78bc96f931ebc4a2$export$e5432d4c8eb97ea7);
$parcel$export(module.exports, "getViewById", () => $78bc96f931ebc4a2$export$b292b237cbc170ca);
$parcel$export(module.exports, "getViewBySlug", () => $78bc96f931ebc4a2$export$15cefaa41def2877);
$parcel$export(module.exports, "createGetViewByAri", () => $78bc96f931ebc4a2$export$55bda6541a6557f8);
$parcel$export(module.exports, "createGetViewUUID", () => $78bc96f931ebc4a2$export$3b32e8d000ac99a9);
$parcel$export(module.exports, "createGetViewAri", () => $78bc96f931ebc4a2$export$2b6540a779f33a60);
$parcel$export(module.exports, "createGetViewEmoji", () => $78bc96f931ebc4a2$export$c9f430c2adc93c4d);
$parcel$export(module.exports, "createGetViewSlug", () => $78bc96f931ebc4a2$export$e28d9a9419883306);
$parcel$export(module.exports, "createGetViewKind", () => $78bc96f931ebc4a2$export$490f11a9f60e1d2d);
$parcel$export(module.exports, "createGetViewTitle", () => $78bc96f931ebc4a2$export$788b32f0aca78ff7);
$parcel$export(module.exports, "createGetViewContainsArchived", () => $78bc96f931ebc4a2$export$527fd01494440032);
$parcel$export(module.exports, "createGetViewFilter", () => $78bc96f931ebc4a2$export$3713e782770729a3);
$parcel$export(module.exports, "createGetViewFilterLength", () => $78bc96f931ebc4a2$export$2ab7baa50629d6b0);
$parcel$export(module.exports, "createGetViewFilterTypes", () => $78bc96f931ebc4a2$export$3704251952d11127);
$parcel$export(module.exports, "createGetViewFieldKeysByAri", () => $78bc96f931ebc4a2$export$9e7a3d1f496162a2);
$parcel$export(module.exports, "createGetViewFieldTypes", () => $78bc96f931ebc4a2$export$4b7a2151738c757f);
$parcel$export(module.exports, "createGetViewFieldKeys", () => $78bc96f931ebc4a2$export$c904f8d614a4ae5b);
$parcel$export(module.exports, "createGetViewGroupBy", () => $78bc96f931ebc4a2$export$c29470b326146c42);
$parcel$export(module.exports, "createGetViewGroupValues", () => $78bc96f931ebc4a2$export$a4f01abe188c861a);
$parcel$export(module.exports, "createGetViewSortFieldTypes", () => $78bc96f931ebc4a2$export$fe03d9a2e48bd56a);
$parcel$export(module.exports, "isActionField", () => $78bc96f931ebc4a2$export$3829f6c73fbc6039);
$parcel$export(module.exports, "createGetValidIssueSubmissionFormFieldKeys", () => $78bc96f931ebc4a2$export$177964427e24f6bd);
$parcel$export(module.exports, "createGetInvalidIssueSubmissionFormFieldLabels", () => $78bc96f931ebc4a2$export$d638f45e501fe77a);
$parcel$export(module.exports, "getCurrentViewFieldKeys", () => $78bc96f931ebc4a2$export$5deee6eecdef28aa);
$parcel$export(module.exports, "isDeliveryFieldVisibleInCurrentView", () => $78bc96f931ebc4a2$export$742eb07931315b26);
$parcel$export(module.exports, "getCurrentViewHiddenFieldKeys", () => $78bc96f931ebc4a2$export$e4ac9753870615f4);
$parcel$export(module.exports, "getCurrentViewLastCommentsViewedTimestamp", () => $78bc96f931ebc4a2$export$509ead0c1141dcfa);
$parcel$export(module.exports, "getCurrentViewCollapsedSwimlanes", () => $78bc96f931ebc4a2$export$d46ae1e0539c339c);
$parcel$export(module.exports, "areCurrentViewAllSwimlanesCollapsed", () => $78bc96f931ebc4a2$export$bf2faccc8bbcee64);
$parcel$export(module.exports, "getAllViewFields", () => $78bc96f931ebc4a2$export$4cc0589a2cd7e9af);
$parcel$export(module.exports, "getCurrentViewFields", () => $78bc96f931ebc4a2$export$47ac98259b572961);
$parcel$export(module.exports, "getCurrentViewHiddenFields", () => $78bc96f931ebc4a2$export$f20a9a94c2ec146);
$parcel$export(module.exports, "getCurrentViewVisibleFields", () => $78bc96f931ebc4a2$export$97a619b33ce3ded3);
$parcel$export(module.exports, "getCurrentViewVisibleFieldKeys", () => $78bc96f931ebc4a2$export$8a0969a8df60d661);
$parcel$export(module.exports, "getCurrentViewColumnIds", () => $78bc96f931ebc4a2$export$80266a367f8ed604);
$parcel$export(module.exports, "isFieldVisibleInCurrentView", () => $78bc96f931ebc4a2$export$d45e1adbfb770a2b);
$parcel$export(module.exports, "getCurrentViewVisibleIssueActionFields", () => $78bc96f931ebc4a2$export$249d5bbd02d6a21a);
$parcel$export(module.exports, "getCurrentViewFieldCount", () => $78bc96f931ebc4a2$export$9e129ad4903b343d);
$parcel$export(module.exports, "getCurrentViewId", () => $78bc96f931ebc4a2$export$82af78b39fe26cb4);
$parcel$export(module.exports, "getCurrentViewSlug", () => $78bc96f931ebc4a2$export$3620af87af35c7dc);
$parcel$export(module.exports, "getIsCurrentViewAvailable", () => $78bc96f931ebc4a2$export$84743e653db92ae7);
$parcel$export(module.exports, "getCurrentViewContainsArchived", () => $78bc96f931ebc4a2$export$d88d1c02b6f47fba);
$parcel$export(module.exports, "getCurrentViewProjectId", () => $78bc96f931ebc4a2$export$2550a142dae738f3);
$parcel$export(module.exports, "getCurrentViewAri", () => $78bc96f931ebc4a2$export$1957b69ba873885d);
$parcel$export(module.exports, "getCurrentViewKind", () => $78bc96f931ebc4a2$export$14b5884b73d4c24a);
$parcel$export(module.exports, "getPreviousViewKind", () => $78bc96f931ebc4a2$export$5cf483d1181e2d45);
$parcel$export(module.exports, "getCurrentViewSortBy", () => $78bc96f931ebc4a2$export$45399b2e5a4487d);
$parcel$export(module.exports, "getCurrentViewPermanentSortBy", () => $78bc96f931ebc4a2$export$6a9deaf79d2bcba7);
$parcel$export(module.exports, "getCurrentViewSortFields", () => $78bc96f931ebc4a2$export$9636ffe082c6da);
$parcel$export(module.exports, "getCurrentViewSortByField", () => $78bc96f931ebc4a2$export$88544817f6ef5863);
$parcel$export(module.exports, "getCurrentViewSortByFieldCount", () => $78bc96f931ebc4a2$export$9eeae4d05c971729);
$parcel$export(module.exports, "getPinnedViewActionFieldKeys", () => $78bc96f931ebc4a2$export$85b0507774163699);
$parcel$export(module.exports, "getCurrentViewActionFieldKeys", () => $78bc96f931ebc4a2$export$cb7fb0b451962e3c);
$parcel$export(module.exports, "isLastView", () => $78bc96f931ebc4a2$export$4db2131e6b9ab04a);
$parcel$export(module.exports, "extractViewAnalyticsData", () => $78bc96f931ebc4a2$export$7d4a12189b84283);
$parcel$export(module.exports, "getViewAnalyticsData", () => $78bc96f931ebc4a2$export$dcdd9c0da6a006e0);
$parcel$export(module.exports, "isCurrentViewGeneratedByTemplate", () => $78bc96f931ebc4a2$export$67c0158e80f35f98);
$parcel$export(module.exports, "getCurrentViewGroupBy", () => $78bc96f931ebc4a2$export$fdd08873e7716038);
$parcel$export(module.exports, "getCurrentHideEmptyGroups", () => $78bc96f931ebc4a2$export$9953b111ff99a74);
$parcel$export(module.exports, "getCurrentHideEmptyBoardColumns", () => $78bc96f931ebc4a2$export$661ad1fd7c9bcacd);
$parcel$export(module.exports, "getCurrentViewVerticalGroupBy", () => $78bc96f931ebc4a2$export$cd811f73544dbedc);
$parcel$export(module.exports, "getCurrentViewGroupValues", () => $78bc96f931ebc4a2$export$6f536293aa2407aa);
$parcel$export(module.exports, "getCurrentViewVerticalGroupValues", () => $78bc96f931ebc4a2$export$6ce934d6e3cbb4e4);
$parcel$export(module.exports, "getCurrentViewSelectedIssueIds", () => $78bc96f931ebc4a2$export$3449c543e4c8c2e7);
$parcel$export(module.exports, "getCurrentViewBulkEditHoveredFieldKey", () => $78bc96f931ebc4a2$export$f5c7e403463388a8);
$parcel$export(module.exports, "getCurrentViewSelectedIssueIdsAsList", () => $78bc96f931ebc4a2$export$a1ca996c95dcf9d4);
$parcel$export(module.exports, "getCurrentViewTitle", () => $78bc96f931ebc4a2$export$702f36692874000d);
$parcel$export(module.exports, "getCurrentViewUUID", () => $78bc96f931ebc4a2$export$9e7d2fdea05b6028);
$parcel$export(module.exports, "getCurrentViewRank", () => $78bc96f931ebc4a2$export$abe9464677e19d1d);
$parcel$export(module.exports, "getCurrentViewEmoji", () => $78bc96f931ebc4a2$export$93d119bdd22b34fc);
$parcel$export(module.exports, "getCurrentViewDescription", () => $78bc96f931ebc4a2$export$8c13869d46b0622f);
$parcel$export(module.exports, "getIsCurrentViewDescriptionEmpty", () => $78bc96f931ebc4a2$export$cd0402e4e41296f0);
$parcel$export(module.exports, "getCurrentViewIsEditingTitle", () => $78bc96f931ebc4a2$export$d0711de671003f6a);
$parcel$export(module.exports, "getCurrentViewDescriptionLoadingStatus", () => $78bc96f931ebc4a2$export$3299ca0c86c7687a);
$parcel$export(module.exports, "getArchiveViewId", () => $78bc96f931ebc4a2$export$389b8f0f6fc12bad);
$parcel$export(module.exports, "getViewsCountFromViewSetTypes", () => $78bc96f931ebc4a2$export$5df07d5c26f19edd);
$parcel$export(module.exports, "createGetViewSetName", () => $78bc96f931ebc4a2$export$8955c91b175cd);
$parcel$export(module.exports, "getViewTypeCount", () => $78bc96f931ebc4a2$export$71a025d290fd023b);
$parcel$export(module.exports, "isCurrentViewGroupedList", () => $78bc96f931ebc4a2$export$36dfb53222a9fbfc);
$parcel$export(module.exports, "getHasUnsavedChanges", () => $78bc96f931ebc4a2$export$3f7fa559324504c7);
$parcel$export(module.exports, "getCurrentViewLayoutType", () => $78bc96f931ebc4a2$export$5e6bfe8e46f4d32a);
$parcel$export(module.exports, "getAllViewsNameAndIds", () => $78bc96f931ebc4a2$export$522001e1f60744c7);
$parcel$export(module.exports, "getCurrentViewConfigured", () => $78bc96f931ebc4a2$export$275ff2f48e1e4afe);
$parcel$export(module.exports, "getCurrentViewRankFieldKey", () => $78bc96f931ebc4a2$export$d553c8b41ef8c982);
$parcel$export(module.exports, "getCurrentViewFieldsUnsupportedForSharing", () => $78bc96f931ebc4a2$export$4d756be203bb7c34);
$parcel$export(module.exports, "getStatusCategoriesForPublishedView", () => $78bc96f931ebc4a2$export$fb021aac8c548174);
$parcel$export(module.exports, "getCurrentViewAccessLevel", () => $78bc96f931ebc4a2$export$33023b71e69dabc8);
$parcel$export(module.exports, "getCurrentViewLastSelectedIssueTypeId", () => $78bc96f931ebc4a2$export$85d9a83367d4e48d);
$parcel$export(module.exports, "getCurrentViewConnectionFieldKeys", () => $78bc96f931ebc4a2$export$7c3684527d3a0453);
$parcel$export(module.exports, "getCurrentViewHasConnectionFields", () => $78bc96f931ebc4a2$export$f27fa30a1f12b491);
$parcel$export(module.exports, "getCurrentViewHasGlobalConnectionFields", () => $78bc96f931ebc4a2$export$b579b5cf6b615b20);
$parcel$export(module.exports, "createGetCurrentViewHasCrossProjectConnectionFields", () => $78bc96f931ebc4a2$export$2ddc75abc9202a58);
$parcel$export(module.exports, "getCurrentViewHasAtlasFieldsInConfig", () => $78bc96f931ebc4a2$export$4e38fd1a392c98a7);
$parcel$export(module.exports, "getCurrentViewHasStatusFieldsInConfig", () => $78bc96f931ebc4a2$export$e72cd4b22e9368a);
$parcel$export(module.exports, "getCurrentViewHasTypeField", () => $78bc96f931ebc4a2$export$9285b2a850d3897b);
$parcel$export(module.exports, "getViewsHasAtlasFieldsInConfig", () => $78bc96f931ebc4a2$export$78344501bd90c219);
$parcel$export(module.exports, "getCurrentViewConnectionFieldsIssueTypes", () => $78bc96f931ebc4a2$export$254a3e5c3a7ea24d);

var $ahm5r = parcelRequire("ahm5r");

var $5Mipf = parcelRequire("5Mipf");

var $aX8Tx = parcelRequire("aX8Tx");

var $exWdq = parcelRequire("exWdq");

var $9g7yh = parcelRequire("9g7yh");

var $4c94y = parcelRequire("4c94y");

var $jvwCK = parcelRequire("jvwCK");

var $jOCpp = parcelRequire("jOCpp");

var $bf0oy = parcelRequire("bf0oy");

var $cGzYX = parcelRequire("cGzYX");

var $eTBmS = parcelRequire("eTBmS");

var $8Z1Mi = parcelRequire("8Z1Mi");

var $8m4OM = parcelRequire("8m4OM");

var $6SinZ = parcelRequire("6SinZ");

var $f38tt = parcelRequire("f38tt");



var $evg82 = parcelRequire("evg82");

var $7jTnu = parcelRequire("7jTnu");

var $hsfc2 = parcelRequire("hsfc2");

var $7M0xf = parcelRequire("7M0xf");

var $238Vi = parcelRequire("238Vi");

var $1vVGo = parcelRequire("1vVGo");

var $jYCU4 = parcelRequire("jYCU4");

var $mJiEA = parcelRequire("mJiEA");

var $9PAQN = parcelRequire("9PAQN");






const $78bc96f931ebc4a2$var$EMPTY = [];
const $78bc96f931ebc4a2$var$EMPTY_FIELD_KEYS = [];
const $78bc96f931ebc4a2$export$fb42d512f96b69f5 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view !== undefined);
const $78bc96f931ebc4a2$export$e5432d4c8eb97ea7 = (state, props)=>props?.currentUser;
const $78bc96f931ebc4a2$export$b292b237cbc170ca = (state, localViewIdOrUuid)=>(0, $hsfc2.findView)(state.viewSets, ({ id: id, uuid: uuid })=>id === localViewIdOrUuid || uuid === localViewIdOrUuid);
const $78bc96f931ebc4a2$export$15cefaa41def2877 = (state, viewSlug)=>(0, $hsfc2.findView)(state.viewSets, ({ slug: slug })=>slug === viewSlug);
const $78bc96f931ebc4a2$export$55bda6541a6557f8 = (ari)=>(0, $ahm5r.createSelector)((state)=>state.viewSets, (viewSets)=>(0, $hsfc2.findView)(viewSets, ({ viewId: viewId })=>viewId === ari));
const $78bc96f931ebc4a2$var$createGetViewById = (viewId)=>(0, $ahm5r.createSelector)((state)=>state.viewSets, (viewSets)=>(0, $hsfc2.findView)(viewSets, ({ id: id })=>id === viewId));
const $78bc96f931ebc4a2$export$3b32e8d000ac99a9 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.uuid);
const $78bc96f931ebc4a2$export$2b6540a779f33a60 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.viewId);
const $78bc96f931ebc4a2$export$c9f430c2adc93c4d = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.emoji);
const $78bc96f931ebc4a2$export$e28d9a9419883306 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.slug);
const $78bc96f931ebc4a2$export$490f11a9f60e1d2d = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.kind);
const $78bc96f931ebc4a2$export$788b32f0aca78ff7 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.title);
const $78bc96f931ebc4a2$export$527fd01494440032 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.containsArchived !== undefined ? view.containsArchived : false);
const $78bc96f931ebc4a2$export$3713e782770729a3 = (viewAri)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$55bda6541a6557f8(viewAri), (view)=>view?.filter);
const $78bc96f931ebc4a2$export$2ab7baa50629d6b0 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.filter.length);
const $78bc96f931ebc4a2$export$3704251952d11127 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (0, $7M0xf.getFields), (view, allFields)=>view?.filter.filter((f)=>f.type === 'FIELD').map((f)=>{
            if ('field' in f && f.field !== undefined && allFields[f.field] !== undefined) return allFields[f.field].type;
            return f.type;
        }));
const $78bc96f931ebc4a2$var$createGetViewFieldKeysRaw = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.fields);
const $78bc96f931ebc4a2$var$createGetViewFieldKeysRawByViewAri = (viewAri)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$55bda6541a6557f8(viewAri), (view)=>view?.fields);
const $78bc96f931ebc4a2$var$createGetViewFields = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewFieldKeysRaw(viewId), (0, $7M0xf.getFields), (fieldKeys, fields)=>{
        if (fieldKeys === undefined) return $78bc96f931ebc4a2$var$EMPTY;
        return fieldKeys.filter((fieldKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, fieldKey)).map((fieldKey)=>fields[fieldKey]);
    });
const $78bc96f931ebc4a2$var$createGetViewFieldsByAri = (viewAri)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewFieldKeysRawByViewAri(viewAri), (0, $7M0xf.getFields), (fieldKeys, fields)=>{
        if (fieldKeys === undefined) return $78bc96f931ebc4a2$var$EMPTY;
        return fieldKeys.filter((fieldKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, fieldKey)).map((fieldKey)=>fields[fieldKey]);
    });
const $78bc96f931ebc4a2$export$9e7a3d1f496162a2 = (viewAri)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewFieldsByAri(viewAri), (viewFields)=>viewFields.map((f)=>f.key));
const $78bc96f931ebc4a2$export$4b7a2151738c757f = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewFields(viewId), (viewFields)=>viewFields.map((f)=>f.type));
const $78bc96f931ebc4a2$export$c904f8d614a4ae5b = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewFields(viewId), (viewFields)=>viewFields.map((f)=>f.key));
const $78bc96f931ebc4a2$export$d3107f640557afe5 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.sortBy);
const $78bc96f931ebc4a2$export$c29470b326146c42 = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (0, $7M0xf.getFields), (view, fields)=>view?.groupBy !== undefined ? fields[view.groupBy] : undefined);
const $78bc96f931ebc4a2$export$a4f01abe188c861a = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewById(viewId), (view)=>view?.groupValues);
const $78bc96f931ebc4a2$export$fe03d9a2e48bd56a = (viewId)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$d3107f640557afe5(viewId), (0, $7M0xf.getFields), (sortBy, allFields)=>sortBy !== undefined ? sortBy.filter((sf)=>allFields[sf.fieldKey]).map((sf)=>allFields[sf.fieldKey]).map((sf)=>sf.type) : [
            'rank'
        ]);
const $78bc96f931ebc4a2$export$3829f6c73fbc6039 = ({ type: type })=>[
        (0, $eTBmS.FIELD_TYPES).ISSUE_COMMENTS,
        (0, $eTBmS.FIELD_TYPES).VOTES,
        (0, $eTBmS.FIELD_TYPES).REACTIONS,
        (0, $eTBmS.FIELD_TYPES).INSIGHTS
    ].some((t)=>t === type);
const $78bc96f931ebc4a2$var$isIdeaSharingUnshareableFields = (field)=>{
    const { type: type } = field;
    return $78bc96f931ebc4a2$export$3829f6c73fbc6039(field) || type === (0, $eTBmS.FIELD_TYPES).STATUS || type === (0, $eTBmS.FIELD_TYPES).ASSIGNEE || type === (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL || type === (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT || type === (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT_STATUS || type === (0, $eTBmS.FIELD_TYPES).CREATOR || type === (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS;
};
const $78bc96f931ebc4a2$var$isValidFieldForIssueSubmissionForm = (field)=>!$78bc96f931ebc4a2$var$isIdeaSharingUnshareableFields(field) && field.formula === undefined;
const $78bc96f931ebc4a2$export$177964427e24f6bd = (viewAri)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewFieldsByAri(viewAri), (fields)=>{
        const DEFAULT_FIELD_KEYS = [
            (0, $9a5f06039e1dff5a$export$dd03acb09519222),
            (0, $9a5f06039e1dff5a$export$469f8bf472cb9ca),
            (0, $9a5f06039e1dff5a$export$d6749ecf5a14d5b)
        ];
        const viewFieldKeys = fields.filter((field)=>$78bc96f931ebc4a2$var$isValidFieldForIssueSubmissionForm(field)).map((field)=>field.key);
        return [
            ...new Set([
                ...DEFAULT_FIELD_KEYS,
                ...viewFieldKeys
            ])
        ];
    });
const $78bc96f931ebc4a2$export$d638f45e501fe77a = (viewAri)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewFieldsByAri(viewAri), (fields)=>fields.filter((field)=>!$78bc96f931ebc4a2$var$isValidFieldForIssueSubmissionForm(field)).map((field)=>field.label));
const $78bc96f931ebc4a2$export$5deee6eecdef28aa = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (fields, view, draft, isAutosaveEnabled)=>{
    if (isAutosaveEnabled) {
        const viewFields = view?.fields?.filter((viewField)=>fields[viewField]);
        return viewFields ?? $78bc96f931ebc4a2$var$EMPTY_FIELD_KEYS;
    }
    const draftFields = draft?.fields?.filter((viewField)=>fields[viewField]);
    return draftFields ?? $78bc96f931ebc4a2$var$EMPTY_FIELD_KEYS;
});
const $78bc96f931ebc4a2$export$742eb07931315b26 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$5deee6eecdef28aa, (0, $7M0xf.getFields), (0, $cGzYX.hasFieldKeyDependingOnDeliveryData));
const $78bc96f931ebc4a2$export$e4ac9753870615f4 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view?.hidden : draft?.hidden) ?? $78bc96f931ebc4a2$var$EMPTY_FIELD_KEYS);
const $78bc96f931ebc4a2$export$509ead0c1141dcfa = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.lastCommentsViewedTimestamp);
const $78bc96f931ebc4a2$export$d46ae1e0539c339c = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.collapsedSwimlanes || {});
const $78bc96f931ebc4a2$export$bf2faccc8bbcee64 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$d46ae1e0539c339c, (collapsedSwimlanes)=>Object.values(collapsedSwimlanes).every((isCollapsed)=>isCollapsed));
const $78bc96f931ebc4a2$export$4cc0589a2cd7e9af = (0, $ahm5r.createSelector)((state)=>state.viewSets, (viewSets)=>{
    const viewSet = viewSets.find((set)=>set.type === 'PRIORITIZE');
    if (!viewSet) return [];
    const fieldsUsedInViews = viewSet.views.map((view)=>view.fields).flat();
    return (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(fieldsUsedInViews);
});
const $78bc96f931ebc4a2$export$47ac98259b572961 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$5deee6eecdef28aa, (0, $7M0xf.getFields), (fieldKeys, fields)=>{
    if (fieldKeys === undefined) return $78bc96f931ebc4a2$var$EMPTY;
    return fieldKeys.filter((fieldKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, fieldKey)).map((fieldKey)=>fields[fieldKey]);
});
const $78bc96f931ebc4a2$export$f20a9a94c2ec146 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$e4ac9753870615f4, (0, $7M0xf.getFields), (fieldKeys, fields)=>{
    if (fieldKeys === undefined) return $78bc96f931ebc4a2$var$EMPTY;
    return fieldKeys.filter((fieldKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, fieldKey)).map((fieldKey)=>fields[fieldKey]);
});
const $78bc96f931ebc4a2$export$97a619b33ce3ded3 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$f20a9a94c2ec146, $78bc96f931ebc4a2$export$47ac98259b572961, (hiddenFields, fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($5Mipf)))(fields, hiddenFields, (a, b)=>a.key === b.key));
const $78bc96f931ebc4a2$export$8a0969a8df60d661 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$97a619b33ce3ded3, (fields)=>fields.map(({ key: key })=>key));
// Introduced for jpd-pulsar-list-view-grid-replacement FG
const $78bc96f931ebc4a2$var$KEYS_OF_FIELDS_THAT_ARE_MERGED_INTO_SUMMARY_COLUMN = [
    (0, $9a5f06039e1dff5a$export$dd03acb09519222),
    (0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b)
];
const $78bc96f931ebc4a2$export$80266a367f8ed604 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$8a0969a8df60d661, (fieldKeys)=>fieldKeys.filter((key)=>!$78bc96f931ebc4a2$var$KEYS_OF_FIELDS_THAT_ARE_MERGED_INTO_SUMMARY_COLUMN.includes(key)));
const $78bc96f931ebc4a2$export$d45e1adbfb770a2b = (fieldKey)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$8a0969a8df60d661, (visibleFieldKeys)=>visibleFieldKeys.includes(fieldKey));
const $78bc96f931ebc4a2$export$249d5bbd02d6a21a = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$97a619b33ce3ded3, (visibleFields)=>visibleFields.filter($78bc96f931ebc4a2$export$3829f6c73fbc6039));
const $78bc96f931ebc4a2$export$e040417e081e34a6 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$249d5bbd02d6a21a, (actionFields)=>actionFields.map(({ key: key })=>key));
const $78bc96f931ebc4a2$export$9e129ad4903b343d = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$47ac98259b572961, (fields)=>fields.length);
const $78bc96f931ebc4a2$export$82af78b39fe26cb4 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.id);
const $78bc96f931ebc4a2$export$3620af87af35c7dc = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.slug);
const $78bc96f931ebc4a2$export$84743e653db92ae7 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$82af78b39fe26cb4, $78bc96f931ebc4a2$export$3620af87af35c7dc, (viewId, viewSlug)=>viewId !== undefined && viewSlug !== undefined);
const $78bc96f931ebc4a2$export$d88d1c02b6f47fba = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.containsArchived || false);
const $78bc96f931ebc4a2$export$2550a142dae738f3 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.projectId);
const $78bc96f931ebc4a2$export$1957b69ba873885d = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.viewId);
const $78bc96f931ebc4a2$export$14b5884b73d4c24a = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.kind);
const $78bc96f931ebc4a2$export$5cf483d1181e2d45 = (0, $ahm5r.createSelector)((0, $1vVGo.getPreviousView), (view)=>view?.kind);
const $78bc96f931ebc4a2$export$45399b2e5a4487d = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (fields, view, draft, isAutosaveEnabled)=>{
    if (isAutosaveEnabled) return view?.sortBy?.filter((sortField)=>fields[sortField.fieldKey]);
    return draft?.sortBy?.filter((sortField)=>fields[sortField.fieldKey]);
});
const $78bc96f931ebc4a2$export$6a9deaf79d2bcba7 = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (fields, view, draft, isAutosaveEnabled)=>{
    if (isAutosaveEnabled) return view?.sortBy?.filter((sortField)=>fields[sortField.fieldKey]);
    return draft?.sortBy?.filter((sortField)=>fields[sortField.fieldKey]);
});
const $78bc96f931ebc4a2$export$9636ffe082c6da = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$45399b2e5a4487d, (0, $7M0xf.getFields), (currentViewSortBy = [], fieldsByKey)=>currentViewSortBy.map(({ fieldKey: fieldKey })=>fieldsByKey[fieldKey]));
const $78bc96f931ebc4a2$export$88544817f6ef5863 = (fieldKey)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$45399b2e5a4487d, (sortBy)=>fieldKey === undefined ? undefined : sortBy?.find((sortItem)=>sortItem.fieldKey === fieldKey));
const $78bc96f931ebc4a2$export$9eeae4d05c971729 = (state, props)=>$78bc96f931ebc4a2$export$45399b2e5a4487d(state, props)?.length || 0;
const $78bc96f931ebc4a2$export$85b0507774163699 = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (0, $9PAQN.getPinnedViewFields), (fields, pinnedFieldKeys)=>pinnedFieldKeys.filter((fieldKey)=>$78bc96f931ebc4a2$export$3829f6c73fbc6039(fields[fieldKey])));
const $78bc96f931ebc4a2$export$cb7fb0b451962e3c = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$97a619b33ce3ded3, (fields)=>fields.filter((field)=>$78bc96f931ebc4a2$export$3829f6c73fbc6039(field)).map((field)=>field.key));
const $78bc96f931ebc4a2$export$4db2131e6b9ab04a = (0, $ahm5r.createSelector)((state)=>state.viewSets, (viewSets)=>{
    let viewCount = 0;
    viewSets.forEach((viewSet)=>{
        viewCount += viewSet.views.length;
    });
    return viewCount < 2;
});
const $78bc96f931ebc4a2$export$8c527c04c08005aa = (0, $ahm5r.createSelector)((state)=>state.viewSets, (viewSets)=>(0, $hsfc2.findView)(viewSets, (v)=>v.containsArchived));
const $78bc96f931ebc4a2$var$getFilterFields = (view)=>{
    const filterFields = view?.filter.filter((f)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        f.field !== undefined);
    return filterFields.map((f)=>f.field);
};
// <type>(:<source>)(.<configuration>)
const $78bc96f931ebc4a2$var$fieldToCompositeFieldType = (field)=>{
    if (!field) return;
    if (field.type === (0, $eTBmS.FIELD_TYPES).INTERVAL) {
        const sourceOrEmpty = field?.configuration?.source ? `:${field.configuration?.source}` : '';
        const aggregationOrEmpty = field?.configuration?.aggregationType ? `.${field.configuration?.aggregationType}` : '';
        return `${field.type}${sourceOrEmpty}${aggregationOrEmpty}`;
    }
    return field.type;
};
const $78bc96f931ebc4a2$var$getGlobalFieldsFromViewFields = (viewFields, allFields)=>(0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
        ...(viewFields.viewSortFields || []).map((f)=>f.fieldKey),
        viewFields.viewGroupByField,
        ...viewFields.viewShownFields,
        ...viewFields.viewFilterFields,
        viewFields.viewColumnField,
        viewFields.viewXAxisField,
        viewFields.viewYAxisField,
        viewFields.viewZAxisField,
        viewFields.viewTimelineStartDateField,
        viewFields.viewTimelineTargetDateField
    ].filter(Boolean).filter((fieldKey)=>allFields[fieldKey]?.global && allFields[fieldKey]?.custom));
const $78bc96f931ebc4a2$export$4246e8ef38e23d3 = (view, projectOnboardedAt)=>view.createdAtTimestamp && projectOnboardedAt ? (0, $bf0oy.default)(new Date(view.createdAtTimestamp), new Date(projectOnboardedAt)) : undefined;
const $78bc96f931ebc4a2$export$7d4a12189b84283 = (view, isShared = false, projectOnboardedAt, fields = {})=>{
    if (!view) return undefined;
    const fieldTypes = view.fields.map((fieldKey)=>$78bc96f931ebc4a2$var$fieldToCompositeFieldType(fields[fieldKey]));
    const viewFields = {
        viewId: view.slug,
        viewSortFields: view.sortBy,
        viewGroupByField: view.verticalGroupBy,
        viewShownFields: view.fields,
        viewFilterFields: $78bc96f931ebc4a2$var$getFilterFields(view),
        viewColumnField: view.groupBy,
        viewXAxisField: view.matrixConfig?.axes?.find((axis)=>axis.dimension === 'x')?.field?.key,
        viewYAxisField: view.matrixConfig?.axes?.find((axis)=>axis.dimension === 'y')?.field?.key,
        viewZAxisField: view.matrixConfig?.axes?.find((axis)=>axis.dimension === 'z')?.field?.key,
        viewTimelineStartDateField: view.timelineConfig?.startDateField?.key,
        viewTimelineTargetDateField: view.timelineConfig?.dueDateField?.key
    };
    const viewGlobalFields = $78bc96f931ebc4a2$var$getGlobalFieldsFromViewFields(viewFields, fields);
    return {
        containers: {
            view: {
                id: view.viewId ?? '',
                type: view.kind.toLowerCase()
            }
        },
        attributes: {
            ...viewFields,
            viewGlobalFields: viewGlobalFields,
            viewHasDescription: !!view.description,
            viewShownFieldTypes: fieldTypes,
            viewTimelineGranularity: view.timelineConfig?.mode,
            viewIsTemplateGenerated: $78bc96f931ebc4a2$export$4246e8ef38e23d3(view, projectOnboardedAt),
            viewOpenedAsPublished: isShared,
            cardLayout: view.layoutType,
            viewHasConnectionFields: fieldTypes.includes((0, $eTBmS.FIELD_TYPES).CONNECTION)
        }
    };
};
const $78bc96f931ebc4a2$export$dcdd9c0da6a006e0 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (state, props)=>props?.isSharedView, (state, props)=>props?.projectOnboardedAt, (0, $7M0xf.getFields), $78bc96f931ebc4a2$export$7d4a12189b84283);
const $78bc96f931ebc4a2$export$67c0158e80f35f98 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (state, props)=>props?.projectOnboardedAt, (view, projectOnboardedAt)=>{
    if (!view) return false;
    return $78bc96f931ebc4a2$export$4246e8ef38e23d3(view, projectOnboardedAt);
});
const $78bc96f931ebc4a2$export$fdd08873e7716038 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $7M0xf.getFields), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, fields, isAutosaveEnabled)=>{
    const groupByFieldKey = isAutosaveEnabled ? view?.groupBy : draft?.groupBy;
    return groupByFieldKey !== undefined ? fields[groupByFieldKey] : undefined;
});
const $78bc96f931ebc4a2$export$9953b111ff99a74 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view : draft)?.hideEmptyGroups || false);
const $78bc96f931ebc4a2$export$661ad1fd7c9bcacd = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view : draft)?.hideEmptyColumns || false);
const $78bc96f931ebc4a2$export$cd811f73544dbedc = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $7M0xf.getFields), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, fields, isAutosaveEnabled)=>{
    const verticalGroupByFieldKey = isAutosaveEnabled ? view?.verticalGroupBy : draft?.verticalGroupBy;
    return verticalGroupByFieldKey !== undefined ? fields[verticalGroupByFieldKey] : undefined;
});
const $78bc96f931ebc4a2$var$EMPTY_GROUPS = [];
const $78bc96f931ebc4a2$export$6f536293aa2407aa = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view?.groupValues : draft?.groupValues) || $78bc96f931ebc4a2$var$EMPTY_GROUPS);
const $78bc96f931ebc4a2$export$6ce934d6e3cbb4e4 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view?.verticalGroupValues : draft?.verticalGroupValues) || $78bc96f931ebc4a2$var$EMPTY_GROUPS);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $78bc96f931ebc4a2$var$EMPTY_COLLECTION = {};
const $78bc96f931ebc4a2$export$3449c543e4c8c2e7 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.selectedIssues || $78bc96f931ebc4a2$var$EMPTY_COLLECTION);
const $78bc96f931ebc4a2$export$f5c7e403463388a8 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.bulkEditHoveredFieldKey);
const $78bc96f931ebc4a2$export$a1ca996c95dcf9d4 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>(0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(view?.selectedIssues || $78bc96f931ebc4a2$var$EMPTY_COLLECTION));
const $78bc96f931ebc4a2$export$702f36692874000d = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.title);
const $78bc96f931ebc4a2$export$9e7d2fdea05b6028 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.uuid);
const $78bc96f931ebc4a2$export$abe9464677e19d1d = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.rank);
const $78bc96f931ebc4a2$export$93d119bdd22b34fc = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.emoji);
const $78bc96f931ebc4a2$export$8c13869d46b0622f = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.description);
const $78bc96f931ebc4a2$export$cd0402e4e41296f0 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>!view?.description?.content?.length);
const $78bc96f931ebc4a2$export$d0711de671003f6a = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.isEditingTitle || false);
const $78bc96f931ebc4a2$export$3299ca0c86c7687a = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.descriptionLoadingStatus);
const $78bc96f931ebc4a2$export$389b8f0f6fc12bad = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$8c527c04c08005aa, (view)=>view?.id);
const $78bc96f931ebc4a2$var$extractViewsFromSet = (viewSet)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))([
        ...viewSet.views,
        ...(viewSet.viewSets || []).map($78bc96f931ebc4a2$var$extractViewsFromSet)
    ]);
const $78bc96f931ebc4a2$var$extractViewSetsFromSet = (viewSet)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))([
        viewSet,
        ...(viewSet.viewSets || []).map($78bc96f931ebc4a2$var$extractViewSetsFromSet)
    ]);
const $78bc96f931ebc4a2$var$getAllViewsFlat = (0, $ahm5r.createSelector)((state)=>state.viewSets, (sets)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))([
        ...sets.map($78bc96f931ebc4a2$var$extractViewsFromSet)
    ]));
const $78bc96f931ebc4a2$var$getAllViewSetsFlat = (0, $ahm5r.createSelector)((state)=>state.viewSets, (sets)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(sets.map($78bc96f931ebc4a2$var$extractViewSetsFromSet)));
const $78bc96f931ebc4a2$var$createGetViewSetById = (id)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getAllViewSetsFlat, (viewSets)=>viewSets.find((element)=>element.id === id));
const $78bc96f931ebc4a2$var$getAllViewsFromViewSetTypes = (types)=>(0, $ahm5r.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (state)=>state.viewSets, (sets)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))([
            ...sets.filter((set)=>types.includes(set.type)).map($78bc96f931ebc4a2$var$extractViewsFromSet)
        ]));
const $78bc96f931ebc4a2$export$5df07d5c26f19edd = (types)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getAllViewsFromViewSetTypes(types), (views)=>views.length);
const $78bc96f931ebc4a2$export$8955c91b175cd = (id)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$createGetViewSetById(id), (set)=>set?.name);
const $78bc96f931ebc4a2$export$71a025d290fd023b = (kind)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getAllViewsFlat, (all)=>all.filter((view)=>view.kind === kind).length);
const $78bc96f931ebc4a2$export$36dfb53222a9fbfc = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $78bc96f931ebc4a2$export$cd811f73544dbedc, (view, verticalGroupBy)=>view?.kind === (0, $6SinZ.VIEW_KIND_TABLE) && verticalGroupBy !== undefined);
const $78bc96f931ebc4a2$export$3f7fa559324504c7 = (state)=>state.hasUnsavedChanges;
const $78bc96f931ebc4a2$export$5e6bfe8e46f4d32a = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view?.layoutType : draft?.layoutType) ?? (view?.kind === (0, $6SinZ.VIEW_KIND_TIMELINE) ? (0, $f38tt.ViewLayoutType).SUMMARY : (0, $f38tt.ViewLayoutType).DETAILED));
const $78bc96f931ebc4a2$export$522001e1f60744c7 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getAllViewsFlat, (0, $9PAQN.getPinnedViewId), (views, pinnedViewId)=>views.filter(({ viewId: viewId, id: id })=>!!viewId && id !== pinnedViewId).filter(({ containsArchived: containsArchived })=>!containsArchived).map(({ viewId: viewId, title: title })=>({
            id: viewId || '',
            title: title
        })));
const $78bc96f931ebc4a2$export$a08426d9ff4b6674 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$fdd08873e7716038, (groupByField)=>Boolean(groupByField));
const $78bc96f931ebc4a2$export$275ff2f48e1e4afe = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$14b5884b73d4c24a, (0, $jYCU4.getMatrixViewConfigured), (0, $mJiEA.getTimelineViewConfigured), $78bc96f931ebc4a2$export$a08426d9ff4b6674, (viewKind, isMatrixViewConfigured, isTimelineViewConfigured, isBoardViewConfigured)=>{
    switch(viewKind){
        case 0, $6SinZ.VIEW_KIND_MATRIX:
            return isMatrixViewConfigured;
        case 0, $6SinZ.VIEW_KIND_TIMELINE:
            return isTimelineViewConfigured;
        case 0, $6SinZ.VIEW_KIND_BOARD:
            return isBoardViewConfigured;
        default:
            return true;
    }
});
const $78bc96f931ebc4a2$export$d553c8b41ef8c982 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.rankFieldKey);
const $78bc96f931ebc4a2$var$mapKeysToFields = (fields, fieldKeys)=>fieldKeys.reduce((acc, fieldKey)=>{
        if (!fieldKey) return acc;
        const field = fields[fieldKey];
        if (field) acc.push(field);
        return acc;
    }, []);
const $78bc96f931ebc4a2$var$getUnsupportedFields = (fields)=>{
    const unsupportedFields = [
        (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL,
        (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT,
        (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT_STATUS,
        (0, $eTBmS.FIELD_TYPES).VOTES,
        (0, $eTBmS.FIELD_TYPES).REACTIONS,
        ...(0, $7jTnu.fg)('jpd-connections-support-on-published-views') ? [] : [
            (0, $eTBmS.FIELD_TYPES).CONNECTION
        ],
        (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS
    ];
    const supportedFormulaFields = [
        (0, $aeaf2088ea4ff36f$export$108e90ec85b77a23)
    ];
    return fields.filter(({ type: type, formula: formula, configuration: configuration })=>{
        const isDeliveryField = type === (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS || type === (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS;
        const isUnsupportedFormula = !!formula && !supportedFormulaFields.includes(formula?.template) && !isDeliveryField;
        const isAtlasBasedDate = type === (0, $eTBmS.FIELD_TYPES).INTERVAL && (configuration?.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).ATLAS_PROJECT_START_DATE || configuration?.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).ATLAS_PROJECT_TARGET_DATE);
        // Check if field is an unsupported formula field or a field of the given type
        return isUnsupportedFormula || unsupportedFields.some((t)=>t === type) || isAtlasBasedDate;
    });
};
const $78bc96f931ebc4a2$export$4d756be203bb7c34 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $7M0xf.getFields), (currentView, allFields)=>{
    const currentViewFieldKeys = currentView?.fields || [];
    const currentViewHiddenFieldKeys = currentView?.hidden || [];
    const currentViewVisibleFieldKeys = currentViewFieldKeys.filter((key)=>!currentViewHiddenFieldKeys.includes(key));
    const currentViewVisibleFields = $78bc96f931ebc4a2$var$mapKeysToFields(allFields, currentViewVisibleFieldKeys);
    const groupByField = currentView?.groupBy ? allFields[currentView?.groupBy] : undefined;
    const verticalGroupByField = currentView?.verticalGroupBy ? allFields[currentView?.verticalGroupBy] : undefined;
    const matrixAxes = (currentView?.matrixConfig?.axes || []).map(({ field: field })=>field);
    const currentViewFilterFields = $78bc96f931ebc4a2$var$mapKeysToFields(allFields, (currentView?.filter || []).map((filter)=>filter.type === (0, $8m4OM.GENERIC_FIELD_FILTER) || filter.type === (0, $8m4OM.NUMERIC_FIELD_FILTER) || filter.type === (0, $8m4OM.INTERVAL_FIELD_FILTER) ? filter.field : undefined));
    const currentViewSortFields = $78bc96f931ebc4a2$var$mapKeysToFields(allFields, (currentView?.sortBy || []).map(({ fieldKey: fieldKey })=>fieldKey));
    const usedFields = [
        groupByField,
        verticalGroupByField,
        ...matrixAxes,
        ...currentViewFilterFields,
        ...currentViewSortFields,
        currentView?.timelineConfig?.startDateField,
        currentView?.timelineConfig?.dueDateField
    ].filter(Boolean);
    const usedUniqueMisconfiguredViewFields = (0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(usedFields, 'key');
    const usedViewFields = [
        ...currentViewVisibleFields
    ].filter(Boolean);
    return {
        viewUnsupportedFields: $78bc96f931ebc4a2$var$getUnsupportedFields(usedViewFields),
        misconfiguredViewUnsupportedFields: $78bc96f931ebc4a2$var$getUnsupportedFields(usedUniqueMisconfiguredViewFields)
    };
});
const $78bc96f931ebc4a2$export$fb021aac8c548174 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(view)=>(0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(view?.statusCategories, ({ key: key })=>key));
const $78bc96f931ebc4a2$export$33023b71e69dabc8 = (state)=>state.accessLevel;
const $78bc96f931ebc4a2$export$85d9a83367d4e48d = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.lastSelectedIssueTypeId);
const $78bc96f931ebc4a2$var$getCurrentViewConnectionFields = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$97a619b33ce3ded3, (visibleFields)=>visibleFields.filter((field)=>field.type === (0, $eTBmS.FIELD_TYPES).CONNECTION));
const $78bc96f931ebc4a2$export$7c3684527d3a0453 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getCurrentViewConnectionFields, (connectionFields)=>connectionFields.map(({ key: key })=>key));
const $78bc96f931ebc4a2$export$f27fa30a1f12b491 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getCurrentViewConnectionFields, (connectionFields)=>connectionFields.length > 0);
const $78bc96f931ebc4a2$export$b579b5cf6b615b20 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getCurrentViewConnectionFields, (connectionFields)=>connectionFields.some((field)=>field.global === true));
const $78bc96f931ebc4a2$export$2ddc75abc9202a58 = (projectIds)=>(0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getCurrentViewConnectionFields, (connectionFields)=>connectionFields.some((field)=>{
            const issueTypeFilters = field.configuration?.issueTypeFilters?.find((0, $evg82.isIssueTypeNameFilter));
            return issueTypeFilters?.projectIds && issueTypeFilters.projectIds.length > 0 && issueTypeFilters.projectIds.some((projectId)=>!projectIds.includes(projectId));
        }));
/**
 * Utility function to check if a view has fields of specific types in use
 * (in GroupBy, VerticalGroupBy, Sort, or Filter configurations)
 */ const $78bc96f931ebc4a2$var$viewHasFieldTypesInUse = (currentView, allFields, fieldTypesChecker, filterTypes = [
    (0, $8m4OM.GENERIC_FIELD_FILTER)
])=>{
    if (!currentView) return false;
    // Check GroupBy fields
    const groupByField = currentView.groupBy ? allFields[currentView.groupBy] : undefined;
    if (groupByField && fieldTypesChecker(groupByField.type)) return true;
    // Check Vertical GroupBy fields
    const verticalGroupByField = currentView.verticalGroupBy ? allFields[currentView.verticalGroupBy] : undefined;
    if (verticalGroupByField && fieldTypesChecker(verticalGroupByField.type)) return true;
    // Check Sort fields
    const sortFields = currentView.sortBy || [];
    for (const sortField of sortFields){
        const field = allFields[sortField.fieldKey];
        if (field && fieldTypesChecker(field.type)) return true;
    }
    // Check Filter fields
    const filters = currentView.filter || [];
    for (const filter of filters)if (filterTypes.includes(filter.type) && 'field' in filter && filter.field) {
        const field = allFields[filter.field];
        if (field && fieldTypesChecker(field.type)) return true;
    }
    return false;
};
const $78bc96f931ebc4a2$export$4e38fd1a392c98a7 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $7M0xf.getFields), (currentView, allFields)=>{
    const atlasFieldTypes = (0, $eTBmS.FIELD_TYPES_CATEGORIES).ATLAS;
    return $78bc96f931ebc4a2$var$viewHasFieldTypesInUse(currentView, allFields, (fieldType)=>atlasFieldTypes.includes(fieldType));
});
const $78bc96f931ebc4a2$export$e72cd4b22e9368a = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $7M0xf.getFields), (currentView, allFields)=>{
    return $78bc96f931ebc4a2$var$viewHasFieldTypesInUse(currentView, allFields, (fieldType)=>fieldType === (0, $eTBmS.FIELD_TYPES).STATUS);
});
const $78bc96f931ebc4a2$export$9285b2a850d3897b = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$47ac98259b572961, (currentViewFields)=>currentViewFields.some(({ type: type })=>type === (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE));
const $78bc96f931ebc4a2$export$78344501bd90c219 = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$export$4cc0589a2cd7e9af, (0, $7M0xf.getFields), (allViewsFields, allFields)=>{
    const atlasFieldTypes = (0, $eTBmS.FIELD_TYPES_CATEGORIES).ATLAS;
    return allViewsFields.some((field)=>atlasFieldTypes.includes(allFields[field]?.type));
});
const $78bc96f931ebc4a2$export$254a3e5c3a7ea24d = (0, $ahm5r.createSelector)($78bc96f931ebc4a2$var$getCurrentViewConnectionFields, (state, props)=>props?.issueTypes, (fields, issueTypes)=>{
    return fields.reduce((acc, field)=>{
        const connectionFieldIssueTypes = field.configuration?.issueTypeFilters?.find((0, $evg82.isIssueTypeNameFilter))?.names;
        if (connectionFieldIssueTypes) acc.push(...connectionFieldIssueTypes.filter((issueType)=>issueTypes?.some(({ name: name })=>name === issueType)));
        return acc;
    }, []);
});

});
parcelRegister("5Mipf", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $72Qfa = parcelRequire("72Qfa");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");

var $1ilzu = parcelRequire("1ilzu");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $434fb68dd08edf97$var$differenceWith = $l76qh(function(array, values) {
    var comparator = $1ilzu(values);
    if ($d1ShJ(comparator)) comparator = undefined;
    return $d1ShJ(array) ? $leN9Q(array, $72Qfa(values, 1, $d1ShJ, true), undefined, comparator) : [];
});
module.exports = $434fb68dd08edf97$var$differenceWith;

});

parcelRegister("f38tt", function(module, exports) {

$parcel$export(module.exports, "ViewLayoutType", () => $814d945a59ceb1d7$export$85a62327b8e43f13);
// TODO: go/restrict-enums
var $814d945a59ceb1d7$export$85a62327b8e43f13 = /*#__PURE__*/ function(ViewLayoutType) {
    ViewLayoutType["SUMMARY"] = "SUMMARY";
    ViewLayoutType["COMPACT"] = "COMPACT";
    ViewLayoutType["DETAILED"] = "DETAILED";
    return ViewLayoutType;
}({});

});

const $aeaf2088ea4ff36f$export$f17d7e115b6ae321 = 'roll_up';
const $aeaf2088ea4ff36f$export$5d7d62d9b7ba30ec = 'weighted_score';
const $aeaf2088ea4ff36f$export$2249da22adcc9519 = 'custom';
const $aeaf2088ea4ff36f$export$37cbbfafd34f49a = 'field';
const $aeaf2088ea4ff36f$export$c6e7460b4182fbc2 = 'num_data_points';
const $aeaf2088ea4ff36f$export$16be63da8bf6d106 = 'property_agg';
const $aeaf2088ea4ff36f$export$d1b88cfba145653c = 'num_linked_issues';
const $aeaf2088ea4ff36f$export$108e90ec85b77a23 = 'num_issue_comments';
const $aeaf2088ea4ff36f$export$aea281fb9ce2bcae = 'linked_issues_status';
const $aeaf2088ea4ff36f$export$642e23a2c402ffe1 = 'linked_issues_progress';
const $aeaf2088ea4ff36f$export$4c529bf2cb4c9417 = 'num_data_points';
const $aeaf2088ea4ff36f$export$aadd17fbe0128c8c = 'play_agg';

parcelRegister("hsfc2", function(module, exports) {

$parcel$export(module.exports, "currentViewFilter", () => $ebd0e36d052e92c3$export$a65367d2c5fc2db3);
$parcel$export(module.exports, "doesViewMatchSlug", () => $ebd0e36d052e92c3$export$2f1798595734f4e0);
$parcel$export(module.exports, "internRemoteView", () => $ebd0e36d052e92c3$export$9b4bc4a28209cd8a);
$parcel$export(module.exports, "findView", () => $ebd0e36d052e92c3$export$788469894fae0ba2);
$parcel$export(module.exports, "findViewWithSlug", () => $ebd0e36d052e92c3$export$d5b622b4f5807fef);
$parcel$export(module.exports, "findViewSet", () => $ebd0e36d052e92c3$export$33b66aad4c000182);
$parcel$export(module.exports, "checkIsViewCollapsed", () => $ebd0e36d052e92c3$export$7be5cf09bad6fe7f);
$parcel$export(module.exports, "getFirstAvailableViewIdInViewSet", () => $ebd0e36d052e92c3$export$c12221e36bd83b86);
$parcel$export(module.exports, "createNewViewEntity", () => $ebd0e36d052e92c3$export$542756c222088a92);

var $80xRm = parcelRequire("80xRm");

var $aXKmr = parcelRequire("aXKmr");

var $6zXPf = parcelRequire("6zXPf");

var $8oKDI = parcelRequire("8oKDI");


var $6SinZ = parcelRequire("6SinZ");

var $f38tt = parcelRequire("f38tt");

var $cse5N = parcelRequire("cse5N");

var $2Qu2F = parcelRequire("2Qu2F");

var $e1eg1 = parcelRequire("e1eg1");
const $ebd0e36d052e92c3$var$ARCHIVED_VIEW_SLUG = 'archived';
const $ebd0e36d052e92c3$export$a65367d2c5fc2db3 = (currentViewSlug)=>(view)=>{
        if ((0, $6zXPf.getWillShowNav4)() && currentViewSlug === $ebd0e36d052e92c3$var$ARCHIVED_VIEW_SLUG && view.containsArchived) return true;
        return view.slug !== undefined && currentViewSlug !== undefined && view.slug === currentViewSlug;
    };
const $ebd0e36d052e92c3$export$eb380eb758e0f1f4 = (view)=>{
    if (!view.viewId) return undefined;
    try {
        const parsed = (0, $8oKDI.getAriConfig)(view.viewId);
        if (parsed) return parsed.resourceId;
        throw new Error('Unable to parse ari');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $e1eg1.logViewError)('utils.getViewSlug', Object.assign(error, {
            viewId: view.viewId
        }));
    }
    return undefined;
};
const $ebd0e36d052e92c3$export$2f1798595734f4e0 = (view, slug)=>{
    const viewSlug = $ebd0e36d052e92c3$export$eb380eb758e0f1f4(view);
    if (viewSlug !== undefined && slug !== undefined && viewSlug === slug) return true;
    if (view.uuid !== undefined && slug !== undefined && view.uuid === slug) return true;
    if ((0, $6zXPf.getWillShowNav4)() && view.containsArchived && slug === $ebd0e36d052e92c3$var$ARCHIVED_VIEW_SLUG) return true;
    const xid = parseInt(slug, 10);
    if (!Number.isNaN(xid)) {
        if (view.viewLegacyId !== undefined && xid === view.viewLegacyId) return true;
    }
    return false;
};
const $ebd0e36d052e92c3$export$9b4bc4a28209cd8a = (fields, view, isSharedView, isCollectionView)=>{
    const remoteView = isSharedView ? {
        ...view,
        filter: [],
        filterGroups: [],
        initialFilter: view.filter
    } : {
        ...view
    };
    let slug = isCollectionView ? remoteView.uuid : $ebd0e36d052e92c3$export$eb380eb758e0f1f4(remoteView);
    if ((0, $6zXPf.getWillShowNav4)()) slug = $ebd0e36d052e92c3$export$eb380eb758e0f1f4(remoteView);
    return {
        ...remoteView,
        id: remoteView.id || (0, $cse5N.generateLocalViewId)(),
        slug: slug,
        saving: false,
        modified: false,
        isEditingTitle: remoteView.isEditingTitle ?? false,
        selectedIssues: remoteView.selectedIssues || {},
        collapsedSwimlanes: remoteView.collapsedSwimlanes || {},
        draft: (0, $2Qu2F.getAutosaveAffectedViewConfigurations)(remoteView),
        bulkEditHoveredFieldKey: undefined
    };
};
const $ebd0e36d052e92c3$export$13099af28bec19ab = (a, b)=>a.rank - b.rank;
const $ebd0e36d052e92c3$export$291a99b999f49030 = (views)=>{
    const newViews = [
        ...views
    ];
    newViews.sort($ebd0e36d052e92c3$export$13099af28bec19ab);
    return newViews;
};
const $ebd0e36d052e92c3$export$788469894fae0ba2 = (viewSets, predicate)=>{
    for (const viewSet of viewSets){
        const view = viewSet.views.find(predicate);
        if (view) return view;
        for (const vSet of viewSet.viewSets || []){
            const viewSetView = vSet.views.find(predicate);
            if (viewSetView) return viewSetView;
        }
    }
    return undefined;
};
const $ebd0e36d052e92c3$export$d5b622b4f5807fef = (viewSets, slug)=>slug === undefined ? undefined : $ebd0e36d052e92c3$export$788469894fae0ba2(viewSets, (view)=>$ebd0e36d052e92c3$export$2f1798595734f4e0(view, slug));
const $ebd0e36d052e92c3$export$33b66aad4c000182 = (viewSets, predicate)=>{
    for (const viewSet of viewSets){
        const result = viewSet.viewSets?.find(predicate);
        if (result) return result;
    }
    return viewSets.find(predicate);
};
const $ebd0e36d052e92c3$export$7be5cf09bad6fe7f = (views, currentViewSlug)=>currentViewSlug !== undefined && views.findIndex((v)=>$ebd0e36d052e92c3$export$2f1798595734f4e0(v, currentViewSlug)) !== -1;
const $ebd0e36d052e92c3$var$findFirstNotEmptySection = (viewSets)=>{
    const sections = viewSets.filter((v)=>v.type === 'SECTION' && v.views.length > 0);
    return (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(sections, (s)=>s.rank)[0];
};
const $ebd0e36d052e92c3$export$c12221e36bd83b86 = (viewSets)=>(viewSetType)=>{
        const viewSet = $ebd0e36d052e92c3$export$33b66aad4c000182(viewSets, (v)=>v.type === viewSetType);
        if (viewSet === undefined) return undefined;
        if (viewSet.views.length > 0) return {
            view: viewSet.views[0]
        };
        const section = $ebd0e36d052e92c3$var$findFirstNotEmptySection(viewSet.viewSets ?? []);
        if (section === undefined) return undefined;
        return {
            view: section.views[0],
            sectionId: section.id
        };
    };
const $ebd0e36d052e92c3$var$getNewViewFields = (viewKind, isCollectionView)=>{
    if (isCollectionView) return [
        (0, $9a5f06039e1dff5a$export$469f8bf472cb9ca),
        (0, $9a5f06039e1dff5a$export$1fd24e9c03ef9b18)
    ];
    if (viewKind === (0, $6SinZ.VIEW_KIND_TIMELINE)) return [
        (0, $9a5f06039e1dff5a$export$469f8bf472cb9ca)
    ];
    return [
        (0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b),
        (0, $9a5f06039e1dff5a$export$469f8bf472cb9ca)
    ];
};
const $ebd0e36d052e92c3$export$542756c222088a92 = (viewSetId, kind, title, rank, isCollectionView)=>{
    const view = {
        kind: kind,
        viewSetId: viewSetId,
        collapsedSwimlanes: {},
        comments: [],
        markers: [],
        containsArchived: false,
        description: undefined,
        editable: true,
        fields: $ebd0e36d052e92c3$var$getNewViewFields(kind, !!isCollectionView),
        filter: [],
        filterGroups: [],
        groupBy: undefined,
        groupValues: [],
        fieldRollups: [],
        hidden: [],
        id: (0, $aXKmr.v4)(),
        isEditingTitle: true,
        lastCommentsViewedTimestamp: undefined,
        modified: true,
        rank: rank,
        saveError: undefined,
        saving: false,
        selectedIssues: {},
        sortBy: undefined,
        title: title,
        emoji: undefined,
        verticalGroupValues: [],
        viewId: undefined,
        tableColumnSizes: [],
        bulkEditHoveredFieldKey: undefined,
        hideEmptyGroups: false,
        hideEmptyColumns: false,
        isAutosaveEnabled: !isCollectionView,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        draft: {},
        layoutType: (0, $f38tt.ViewLayoutType).DETAILED,
        createdAtTimestamp: new Date().toISOString(),
        updatedAtTimestamp: null,
        configError: undefined
    };
    view.commentsLoadingStatus = (0, $6SinZ.PROPERTY_LOADING_STATE).LOADED;
    return view;
};

});
parcelRegister("80xRm", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $4ppQ2 = parcelRequire("4ppQ2");

var $l76qh = parcelRequire("l76qh");

var $eA1it = parcelRequire("eA1it");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5d48969fb93c8520$var$sortBy = $l76qh(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $eA1it(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $eA1it(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $4ppQ2(collection, $72Qfa(iteratees, 1), []);
});
module.exports = $5d48969fb93c8520$var$sortBy;

});

parcelRegister("cse5N", function(module, exports) {

$parcel$export(module.exports, "generateLocalViewId", () => $716cad468d4b0ce3$export$ce00fd9c0e44f7b0);

var $aXKmr = parcelRequire("aXKmr");
const $716cad468d4b0ce3$export$ce00fd9c0e44f7b0 = ()=>(0, $aXKmr.v4)();

});

parcelRegister("2Qu2F", function(module, exports) {

$parcel$export(module.exports, "getTimelineConfigDraft", () => $f1279346e7ceb191$export$11c53c82a88e1714);
$parcel$export(module.exports, "getAutosaveAffectedViewConfigurations", () => $f1279346e7ceb191$export$8f59c94c93645393);
$parcel$export(module.exports, "applyDraftToView", () => $f1279346e7ceb191$export$4427ce2287fe7cae);

var $8sbs2 = parcelRequire("8sbs2");

var $bHZrQ = parcelRequire("bHZrQ");
const $f1279346e7ceb191$var$AUTOSAVE_AFFECTED_VIEW_CONFIGURATIONS = [
    'verticalGroupBy',
    'verticalGroupValues',
    'groupBy',
    'groupValues',
    'filter',
    'filterGroups',
    'sortBy',
    'sortMode',
    'fields',
    'hidden',
    'matrixConfig',
    'timelineConfig',
    'hideEmptyGroups',
    'hideEmptyColumns',
    'fieldRollups',
    'layoutType'
];
const $f1279346e7ceb191$var$AUTOSAVE_AFFECTED_TIMELINE_CONFIGURATIONS = [
    'startDateField',
    'dueDateField',
    'startTimestamp',
    'endTimestamp',
    'mode',
    'summaryCardField'
];
const $f1279346e7ceb191$export$11c53c82a88e1714 = (timelineConfig = {
    startDateField: undefined,
    dueDateField: undefined,
    startTimestamp: undefined,
    endTimestamp: undefined,
    summaryCardField: undefined,
    mode: (0, $bHZrQ.PolarisTimelineMode).QUARTERS
})=>(0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(timelineConfig, $f1279346e7ceb191$var$AUTOSAVE_AFFECTED_TIMELINE_CONFIGURATIONS);
const $f1279346e7ceb191$export$8f59c94c93645393 = (view)=>$f1279346e7ceb191$var$AUTOSAVE_AFFECTED_VIEW_CONFIGURATIONS.reduce((acc, key)=>({
            ...acc,
            [key]: key === 'timelineConfig' ? $f1279346e7ceb191$export$11c53c82a88e1714(view.timelineConfig) : view[key]
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
const $f1279346e7ceb191$export$4427ce2287fe7cae = (view)=>{
    const newView = {
        ...view,
        ...view.draft
    };
    if (view.timelineConfig) newView.timelineConfig = {
        ...view.timelineConfig,
        ...view.draft?.timelineConfig || {}
    };
    return newView;
};

});

parcelRegister("e1eg1", function(module, exports) {

$parcel$export(module.exports, "logViewError", () => $dc644d54b6ca21a9$export$5bf666551d55cd30);

var $57ulE = parcelRequire("57ulE");
const $dc644d54b6ca21a9$var$VIEW_ERROR_PREFIX = 'controllers.view';
const $dc644d54b6ca21a9$export$5bf666551d55cd30 = (postfix, error)=>{
    (0, $57ulE.logPolarisError)(`${$dc644d54b6ca21a9$var$VIEW_ERROR_PREFIX}.${postfix}`, error);
};

});
parcelRegister("57ulE", function(module, exports) {

$parcel$export(module.exports, "logPolarisError", () => $18797bb8dc2c0d30$export$8f7428316baed756);

var $6Yd06 = parcelRequire("6Yd06");


const $18797bb8dc2c0d30$var$ERROR_PREFIX = 'polaris-error';
const $18797bb8dc2c0d30$export$8f7428316baed756 = (postfix, error)=>{
    // TODO: Determine some test function to determine if an error is 'interesting' to us and filter
    // the rest.
    (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)(`${$18797bb8dc2c0d30$var$ERROR_PREFIX}.${postfix}`, error.message, error);
};

});



parcelRegister("7M0xf", function(module, exports) {

$parcel$export(module.exports, "getFields", () => $8a4bf4b6d0c85def$export$d5523731e7fe4ded);
$parcel$export(module.exports, "getFieldsForViewControls", () => $8a4bf4b6d0c85def$export$82d50ad5d27e46a6);
$parcel$export(module.exports, "getAllFieldsForViewControls", () => $8a4bf4b6d0c85def$export$844ecb4caac11db4);
$parcel$export(module.exports, "getAllFieldsForViewControlsCountByType", () => $8a4bf4b6d0c85def$export$a7f220cf67fce748);
$parcel$export(module.exports, "createGetFieldByType", () => $8a4bf4b6d0c85def$export$ea7596343ed62ef7);
$parcel$export(module.exports, "createGetFieldForFieldKey", () => $8a4bf4b6d0c85def$export$90650ed7d358eaaf);

var $ahm5r = parcelRequire("ahm5r");

var $9pL9Y = parcelRequire("9pL9Y");

var $6kS6u = parcelRequire("6kS6u");

var $eTBmS = parcelRequire("eTBmS");
const $8a4bf4b6d0c85def$var$EMPTY_FIELDS = Object.freeze({});
const $8a4bf4b6d0c85def$var$getAllFields = (0, $ahm5r.createSelector)((_, props)=>props?.fields, (fields)=>{
    if (!fields) return $8a4bf4b6d0c85def$var$EMPTY_FIELDS;
    return fields;
});
const $8a4bf4b6d0c85def$export$d5523731e7fe4ded = (0, $ahm5r.createSelector)($8a4bf4b6d0c85def$var$getAllFields, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(fields, (field)=>{
        const isHidden = field.configuration?.hidden;
        const isRestricted = field.hasRestrictedContext;
        return !isHidden && !isRestricted;
    }));
const $8a4bf4b6d0c85def$var$UNSUPPORTED_FIELD_TYPES = [
    ...(0, $eTBmS.FIELD_TYPES_CATEGORIES).ARCHIVED,
    (0, $eTBmS.FIELD_TYPES).DESCRIPTION,
    (0, $eTBmS.FIELD_TYPES).ISSUE_ID
];
const $8a4bf4b6d0c85def$var$getSupportedFields = (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(fields, ({ type: type })=>!$8a4bf4b6d0c85def$var$UNSUPPORTED_FIELD_TYPES.some((t)=>t === type));
const $8a4bf4b6d0c85def$export$82d50ad5d27e46a6 = (0, $ahm5r.createSelector)($8a4bf4b6d0c85def$export$d5523731e7fe4ded, $8a4bf4b6d0c85def$var$getSupportedFields);
const $8a4bf4b6d0c85def$export$844ecb4caac11db4 = (0, $ahm5r.createSelector)($8a4bf4b6d0c85def$var$getAllFields, $8a4bf4b6d0c85def$var$getSupportedFields);
const $8a4bf4b6d0c85def$export$a7f220cf67fce748 = (0, $ahm5r.createSelector)($8a4bf4b6d0c85def$export$844ecb4caac11db4, (fields)=>{
    const count = {
        totalFieldsCount: Object.values(fields).length,
        votesFieldsCount: 0
    };
    for (const field of Object.values(fields))if (field.type === (0, $eTBmS.FIELD_TYPES).VOTES) count.votesFieldsCount++;
    return count;
});
const $8a4bf4b6d0c85def$export$ea7596343ed62ef7 = (fieldType)=>(0, $ahm5r.createSelector)($8a4bf4b6d0c85def$var$getAllFields, (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(fields, (field)=>field.type === fieldType));
const $8a4bf4b6d0c85def$export$90650ed7d358eaaf = (fieldKey)=>(0, $ahm5r.createSelector)($8a4bf4b6d0c85def$export$d5523731e7fe4ded, (fields)=>fieldKey === undefined ? undefined : fields[fieldKey]);

});

parcelRegister("238Vi", function(module, exports) {

$parcel$export(module.exports, "isCurrentViewAutosaveEnabled", () => $8cd02ceb6680a693$export$b3bb2cf9a028bfd9);
$parcel$export(module.exports, "getCurrentViewDraft", () => $8cd02ceb6680a693$export$f716ccc2e86f3a34);
$parcel$export(module.exports, "hasVerticalGroupByUnsavedChanges", () => $8cd02ceb6680a693$export$fe61a9fc9ef91f9b);
$parcel$export(module.exports, "hasGroupByUnsavedChanges", () => $8cd02ceb6680a693$export$871718a549b7f1e7);
$parcel$export(module.exports, "hasFieldRollupUnsavedChanges", () => $8cd02ceb6680a693$export$756be7d8d3466f1b);
$parcel$export(module.exports, "hasFiltersUnsavedChanges", () => $8cd02ceb6680a693$export$371c0ad31256b0e8);
$parcel$export(module.exports, "hasSortUnsavedChanges", () => $8cd02ceb6680a693$export$1b5def21abaa69ef);
$parcel$export(module.exports, "hasFieldsUnsavedChanges", () => $8cd02ceb6680a693$export$ee9af4449de5959d);
$parcel$export(module.exports, "hasMatrixXAxisUnsavedChanges", () => $8cd02ceb6680a693$export$52ffb710472948af);
$parcel$export(module.exports, "hasMatrixYAxisUnsavedChanges", () => $8cd02ceb6680a693$export$414289ec7d1aae83);
$parcel$export(module.exports, "hasMatrixZAxisUnsavedChanges", () => $8cd02ceb6680a693$export$77405dd2297da33f);
$parcel$export(module.exports, "hasTimelineConfigUnsavedChanges", () => $8cd02ceb6680a693$export$9e17e383affa80e9);
$parcel$export(module.exports, "hasLayoutTypeUnsavedChanges", () => $8cd02ceb6680a693$export$814447fe4153cdd4);
$parcel$export(module.exports, "hasViewUnsavedChanges", () => $8cd02ceb6680a693$export$b897fea8705d2700);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $6SinZ = parcelRequire("6SinZ");

var $f38tt = parcelRequire("f38tt");

var $7jTnu = parcelRequire("7jTnu");

var $2Qu2F = parcelRequire("2Qu2F");

var $1vVGo = parcelRequire("1vVGo");

var $jAuoP = parcelRequire("jAuoP");
const $8cd02ceb6680a693$export$b3bb2cf9a028bfd9 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (state, props)=>props?.isSharedView, (0, $jAuoP.getCanManageCurrentView), (view, isSharedView, hasManageCurrentViewPermission)=>!!view?.isAutosaveEnabled && !isSharedView && hasManageCurrentViewPermission);
const $8cd02ceb6680a693$export$f716ccc2e86f3a34 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.draft);
const $8cd02ceb6680a693$export$4df916748637760f = (configurations)=>(0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $8cd02ceb6680a693$export$f716ccc2e86f3a34, $8cd02ceb6680a693$export$b3bb2cf9a028bfd9, (view, draft, isAutosaveEnabled)=>view !== undefined && draft !== undefined && !isAutosaveEnabled && configurations.some((configuration)=>!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(draft[configuration], view[configuration])));
const $8cd02ceb6680a693$export$fe61a9fc9ef91f9b = $8cd02ceb6680a693$export$4df916748637760f([
    'verticalGroupBy',
    'verticalGroupValues',
    'hideEmptyGroups'
]);
const $8cd02ceb6680a693$export$871718a549b7f1e7 = $8cd02ceb6680a693$export$4df916748637760f([
    'groupBy',
    'groupValues',
    'hideEmptyColumns'
]);
const $8cd02ceb6680a693$export$756be7d8d3466f1b = $8cd02ceb6680a693$export$4df916748637760f([
    'fieldRollups'
]);
const $8cd02ceb6680a693$export$371c0ad31256b0e8 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $8cd02ceb6680a693$export$f716ccc2e86f3a34, $8cd02ceb6680a693$export$b3bb2cf9a028bfd9, (view, draft, isAutosaveEnabled)=>{
    if ((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type')) // TODO: change this after https://pi-dev-sandbox.atlassian.net/browse/POL-13889 and quick filter is moved to groups
    return view !== undefined && draft !== undefined && !isAutosaveEnabled && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(view.filterGroups, draft.filterGroups);
    return view !== undefined && draft !== undefined && !isAutosaveEnabled && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(view.filter.filter((f)=>!(f.type === 'TEXT' && f.localId === 'quick')), draft.filter?.filter((f)=>!(f.type === 'TEXT' && f.localId === 'quick')));
});
const $8cd02ceb6680a693$export$1b5def21abaa69ef = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $8cd02ceb6680a693$export$f716ccc2e86f3a34, $8cd02ceb6680a693$export$b3bb2cf9a028bfd9, (view, draft, isAutosaveEnabled)=>{
    return view !== undefined && draft !== undefined && !isAutosaveEnabled && (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(draft.sortBy, view.sortBy) || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(draft.sortMode, view.sortMode));
});
const $8cd02ceb6680a693$export$1635a98744ed5274 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $8cd02ceb6680a693$export$f716ccc2e86f3a34, $8cd02ceb6680a693$export$b3bb2cf9a028bfd9, (view, draft, isAutosaveEnabled)=>view !== undefined && draft !== undefined && !isAutosaveEnabled && view.kind === (0, $6SinZ.VIEW_KIND_TIMELINE) && view.timelineConfig?.summaryCardField?.key !== draft.timelineConfig?.summaryCardField?.key);
const $8cd02ceb6680a693$export$ee9af4449de5959d = (0, $ahm5r.createSelector)($8cd02ceb6680a693$export$4df916748637760f([
    'fields',
    'hidden'
]), $8cd02ceb6680a693$export$1635a98744ed5274, (fieldsUnsavedChanges, summaryCardFieldUnsavedChanges)=>fieldsUnsavedChanges || summaryCardFieldUnsavedChanges);
const $8cd02ceb6680a693$var$isDraftForMatrixAxisChanged = (dimension)=>(0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $8cd02ceb6680a693$export$f716ccc2e86f3a34, $8cd02ceb6680a693$export$b3bb2cf9a028bfd9, (view, draft, isAutosaveEnabled)=>view !== undefined && draft !== undefined && !isAutosaveEnabled && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(view.matrixConfig?.axes.find((axis)=>axis.dimension === dimension), draft.matrixConfig?.axes.find((axis)=>axis.dimension === dimension)));
const $8cd02ceb6680a693$export$52ffb710472948af = $8cd02ceb6680a693$var$isDraftForMatrixAxisChanged('x');
const $8cd02ceb6680a693$export$414289ec7d1aae83 = $8cd02ceb6680a693$var$isDraftForMatrixAxisChanged('y');
const $8cd02ceb6680a693$export$77405dd2297da33f = $8cd02ceb6680a693$var$isDraftForMatrixAxisChanged('z');
const $8cd02ceb6680a693$export$9e17e383affa80e9 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $8cd02ceb6680a693$export$f716ccc2e86f3a34, $8cd02ceb6680a693$export$b3bb2cf9a028bfd9, (view, draft, isAutosaveEnabled)=>{
    const { summaryCardField: summaryCardField, ...config } = (0, $2Qu2F.getTimelineConfigDraft)(view?.timelineConfig);
    const { summaryCardField: draftSummaryCardField, ...draftConfig } = (0, $2Qu2F.getTimelineConfigDraft)(draft?.timelineConfig);
    return view !== undefined && draft !== undefined && !isAutosaveEnabled && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, $2Qu2F.getTimelineConfigDraft)(config), (0, $2Qu2F.getTimelineConfigDraft)(draftConfig));
});
const $8cd02ceb6680a693$export$814447fe4153cdd4 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $8cd02ceb6680a693$export$f716ccc2e86f3a34, $8cd02ceb6680a693$export$b3bb2cf9a028bfd9, (view, draft, isAutosaveEnabled)=>view !== undefined && draft !== undefined && !isAutosaveEnabled && (view.layoutType === null ? view.layoutType !== draft.layoutType && (view.kind === (0, $6SinZ.VIEW_KIND_TIMELINE) ? draft.layoutType !== (0, $f38tt.ViewLayoutType).SUMMARY : draft.layoutType !== (0, $f38tt.ViewLayoutType).DETAILED) : view.layoutType !== draft.layoutType));
const $8cd02ceb6680a693$export$b897fea8705d2700 = (0, $ahm5r.createSelector)($8cd02ceb6680a693$export$b3bb2cf9a028bfd9, $8cd02ceb6680a693$export$fe61a9fc9ef91f9b, $8cd02ceb6680a693$export$871718a549b7f1e7, $8cd02ceb6680a693$export$371c0ad31256b0e8, $8cd02ceb6680a693$export$1b5def21abaa69ef, $8cd02ceb6680a693$export$ee9af4449de5959d, $8cd02ceb6680a693$export$52ffb710472948af, $8cd02ceb6680a693$export$414289ec7d1aae83, $8cd02ceb6680a693$export$77405dd2297da33f, $8cd02ceb6680a693$export$9e17e383affa80e9, $8cd02ceb6680a693$export$756be7d8d3466f1b, $8cd02ceb6680a693$export$814447fe4153cdd4, (isAutosaveEnabled, ...unsavedChanges)=>!isAutosaveEnabled && unsavedChanges.some(Boolean));

});
parcelRegister("1vVGo", function(module, exports) {

$parcel$export(module.exports, "getCurrentView", () => $c566d32a291ece69$export$9cefbcd123319241);
$parcel$export(module.exports, "getPreviousView", () => $c566d32a291ece69$export$4e7b3ccc9cdd022);
$parcel$export(module.exports, "hasSharedViewConfigError", () => $c566d32a291ece69$export$8b79e6abc8b319b5);

var $ahm5r = parcelRequire("ahm5r");

var $hsfc2 = parcelRequire("hsfc2");
const $c566d32a291ece69$export$9cefbcd123319241 = (0, $ahm5r.createSelector)((state)=>state.viewSets, (_, props)=>props?.currentViewSlug, (0, $hsfc2.findViewWithSlug));
const $c566d32a291ece69$export$4e7b3ccc9cdd022 = (0, $ahm5r.createSelector)((state)=>state.viewSets, (_, props)=>props?.currentViewSlug, (state)=>state?.prevContainerProps?.currentViewSlug, (viewSets, currentViewSlug, prevViewSlug)=>{
    if (prevViewSlug === currentViewSlug) return undefined;
    return (0, $hsfc2.findViewWithSlug)(viewSets, prevViewSlug);
});
const $c566d32a291ece69$export$487c0e841e8de18e = (0, $ahm5r.createSelector)($c566d32a291ece69$export$9cefbcd123319241, (view)=>view?.configError);
const $c566d32a291ece69$export$8b79e6abc8b319b5 = (0, $ahm5r.createSelector)($c566d32a291ece69$export$487c0e841e8de18e, (configError)=>configError !== undefined);

});

parcelRegister("jAuoP", function(module, exports) {

$parcel$export(module.exports, "getCanManageCurrentView", () => $2383f5014aa65267$export$a2c6a5b99d4f4701);
const $2383f5014aa65267$export$a2c6a5b99d4f4701 = (state)=>!!state.hasManageCurrentViewPermission;

});


parcelRegister("jYCU4", function(module, exports) {

$parcel$export(module.exports, "getCurrentViewMatrixConfig", () => $da49dec2a7292065$export$14a965b2c5bd7e6c);
$parcel$export(module.exports, "getCurrentViewXAxisField", () => $da49dec2a7292065$export$cbe2a5b9c914973a);
$parcel$export(module.exports, "getCurrentViewXAxis", () => $da49dec2a7292065$export$fe630e89ec84215f);
$parcel$export(module.exports, "getCurrentViewYAxisField", () => $da49dec2a7292065$export$2e87ce8ba3116f85);
$parcel$export(module.exports, "getCurrentViewYAxis", () => $da49dec2a7292065$export$25499612e9c3bed3);
$parcel$export(module.exports, "getCurrentViewZAxisField", () => $da49dec2a7292065$export$72b4a372b7c751fa);
$parcel$export(module.exports, "getCurrentViewZAxis", () => $da49dec2a7292065$export$1c73ebc7cdf89a24);
$parcel$export(module.exports, "getMatrixViewConfigured", () => $da49dec2a7292065$export$1864aa835dc06298);
$parcel$export(module.exports, "getMatrixFieldOptions", () => $da49dec2a7292065$export$b2590aed6cc5abb5);
$parcel$export(module.exports, "getMatrixOptionsHasReverseOrder", () => $da49dec2a7292065$export$265b95357c56532);

var $ahm5r = parcelRequire("ahm5r");

var $7M0xf = parcelRequire("7M0xf");

var $238Vi = parcelRequire("238Vi");

var $1vVGo = parcelRequire("1vVGo");
const $da49dec2a7292065$export$14a965b2c5bd7e6c = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>isAutosaveEnabled ? view?.matrixConfig : draft?.matrixConfig);
const $da49dec2a7292065$var$getCurrentViewAxes = (0, $ahm5r.createSelector)($da49dec2a7292065$export$14a965b2c5bd7e6c, (matrixConfig)=>matrixConfig?.axes);
const $da49dec2a7292065$export$cbe2a5b9c914973a = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), $da49dec2a7292065$var$getCurrentViewAxes, (fields, axes)=>{
    const axisField = axes?.find((axis)=>axis.dimension === 'x')?.field;
    if (axisField && fields[axisField.key]) return axisField;
});
const $da49dec2a7292065$export$fe630e89ec84215f = (0, $ahm5r.createSelector)($da49dec2a7292065$export$cbe2a5b9c914973a, (field)=>field?.key);
const $da49dec2a7292065$export$2e87ce8ba3116f85 = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), $da49dec2a7292065$var$getCurrentViewAxes, (fields, axes)=>{
    const axisField = axes?.find((axis)=>axis.dimension === 'y')?.field;
    if (axisField && fields[axisField.key]) return axisField;
});
const $da49dec2a7292065$export$25499612e9c3bed3 = (0, $ahm5r.createSelector)($da49dec2a7292065$export$2e87ce8ba3116f85, (field)=>field?.key);
const $da49dec2a7292065$export$72b4a372b7c751fa = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), $da49dec2a7292065$var$getCurrentViewAxes, (fields, axes)=>{
    const axisField = axes?.find((axis)=>axis.dimension === 'z')?.field;
    if (axisField && fields[axisField.key]) return axisField;
});
const $da49dec2a7292065$export$1c73ebc7cdf89a24 = (0, $ahm5r.createSelector)($da49dec2a7292065$export$72b4a372b7c751fa, (field)=>field?.key);
const $da49dec2a7292065$export$1864aa835dc06298 = (0, $ahm5r.createSelector)($da49dec2a7292065$export$fe630e89ec84215f, $da49dec2a7292065$export$25499612e9c3bed3, (xAxis, yAxis)=>xAxis !== undefined && yAxis !== undefined);
const $da49dec2a7292065$var$EMPTY_GROUPS = [];
const $da49dec2a7292065$export$b2590aed6cc5abb5 = (dimension)=>(0, $ahm5r.createSelector)($da49dec2a7292065$var$getCurrentViewAxes, (axes)=>axes?.find((axis)=>axis.dimension === dimension)?.fieldOptions || $da49dec2a7292065$var$EMPTY_GROUPS);
const $da49dec2a7292065$export$265b95357c56532 = (dimension)=>(0, $ahm5r.createSelector)($da49dec2a7292065$var$getCurrentViewAxes, (axes)=>axes?.find((axis)=>axis.dimension === dimension)?.reversed || false);

});

parcelRegister("mJiEA", function(module, exports) {

$parcel$export(module.exports, "getCurrentViewTimelineModeOrDefault", () => $98cbd6218a5998df$export$a9ae76b98dfe06a0);
$parcel$export(module.exports, "getCurrentViewTimelineStartDateField", () => $98cbd6218a5998df$export$a34f7735f1270401);
$parcel$export(module.exports, "getCurrentViewTimelineEndDateField", () => $98cbd6218a5998df$export$4bff8afa571e78e9);
$parcel$export(module.exports, "getCurrentViewTimelineIntervalStartDate", () => $98cbd6218a5998df$export$223c1d4a2d1a1c8c);
$parcel$export(module.exports, "getCurrentViewTimelineIntervalEndDate", () => $98cbd6218a5998df$export$8f2995cbed33e4f7);
$parcel$export(module.exports, "getCurrentViewArrangementInformation", () => $98cbd6218a5998df$export$4376ed7c1f219c53);
$parcel$export(module.exports, "getTimelineViewConfigured", () => $98cbd6218a5998df$export$e7f77f5921134121);
$parcel$export(module.exports, "getCurrentViewSummaryCardField", () => $98cbd6218a5998df$export$30b005f57984e38f);
$parcel$export(module.exports, "getCurrentViewSummaryCardFieldKey", () => $98cbd6218a5998df$export$eff2b7ea34775460);
$parcel$export(module.exports, "getCurrentViewTimelineMarkers", () => $98cbd6218a5998df$export$ab9834c02962045f);

var $ahm5r = parcelRequire("ahm5r");

var $bHZrQ = parcelRequire("bHZrQ");

var $7M0xf = parcelRequire("7M0xf");

var $238Vi = parcelRequire("238Vi");

var $1vVGo = parcelRequire("1vVGo");
const $98cbd6218a5998df$export$a9ae76b98dfe06a0 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view : draft)?.timelineConfig?.mode || (0, $bHZrQ.PolarisTimelineMode).QUARTERS);
const $98cbd6218a5998df$export$a34f7735f1270401 = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (fields, view, draft, isAutosaveEnabled)=>{
    const dateField = (isAutosaveEnabled ? view : draft)?.timelineConfig?.startDateField;
    if (dateField && fields[dateField.key]) return dateField;
});
const $98cbd6218a5998df$export$4bff8afa571e78e9 = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (fields, view, draft, isAutosaveEnabled)=>{
    const dateField = (isAutosaveEnabled ? view : draft)?.timelineConfig?.dueDateField;
    if (dateField && fields[dateField.key]) return dateField;
});
const $98cbd6218a5998df$export$223c1d4a2d1a1c8c = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view : draft)?.timelineConfig?.startTimestamp);
const $98cbd6218a5998df$export$8f2995cbed33e4f7 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>(isAutosaveEnabled ? view : draft)?.timelineConfig?.endTimestamp);
const $98cbd6218a5998df$export$4376ed7c1f219c53 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.timelineConfig?.arrangementInformation);
const $98cbd6218a5998df$export$e7f77f5921134121 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), $98cbd6218a5998df$export$a9ae76b98dfe06a0, $98cbd6218a5998df$export$a34f7735f1270401, $98cbd6218a5998df$export$4bff8afa571e78e9, (view, mode, startDate, endDate)=>Boolean(view?.id && startDate?.key && endDate?.key && mode));
const $98cbd6218a5998df$export$30b005f57984e38f = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (fields, view, draft, isAutosaveEnabled)=>{
    const field = (isAutosaveEnabled ? view : draft)?.timelineConfig?.summaryCardField;
    if (!field || !fields?.[field.key]) return null;
    return field;
});
const $98cbd6218a5998df$export$eff2b7ea34775460 = (0, $ahm5r.createSelector)($98cbd6218a5998df$export$30b005f57984e38f, (field)=>field?.key);
const $98cbd6218a5998df$export$ab9834c02962045f = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.markers || []);

});

parcelRegister("9PAQN", function(module, exports) {

$parcel$export(module.exports, "createGetViewSet", () => $73a0413869817e13$export$7c001e139b515668);
$parcel$export(module.exports, "createGetViewIdsInSet", () => $73a0413869817e13$export$a4dfeb85ade20f0d);
$parcel$export(module.exports, "getViewCount", () => $73a0413869817e13$export$cf952a1809704f8b);
$parcel$export(module.exports, "getPrioritizeViewCount", () => $73a0413869817e13$export$c2db6af50b4bf31a);
$parcel$export(module.exports, "getViewsetsCount", () => $73a0413869817e13$export$3ab39915fc57999c);
$parcel$export(module.exports, "getAllIdeasViewId", () => $73a0413869817e13$export$c329812b6b6f2798);
$parcel$export(module.exports, "getViewSlugByRank", () => $73a0413869817e13$export$6971c8e340062ba4);
$parcel$export(module.exports, "getPinnedViewId", () => $73a0413869817e13$export$12956aeed9d738bd);
$parcel$export(module.exports, "getPinnedViewFields", () => $73a0413869817e13$export$54a4980995097374);
$parcel$export(module.exports, "getPinnedViewFieldsForSmartCard", () => $73a0413869817e13$export$4352b4190f79d445);
$parcel$export(module.exports, "getIsCurrentViewInCaptureSet", () => $73a0413869817e13$export$e3032392fcdec663);
$parcel$export(module.exports, "getSystemViewsContainingArchived", () => $73a0413869817e13$export$7ba9211868dc6f17);
$parcel$export(module.exports, "getSystemViewsNotContainingArchived", () => $73a0413869817e13$export$cd3cc4f66324ec62);
$parcel$export(module.exports, "getViewIdsConfiguredByField", () => $73a0413869817e13$export$d28574233610ce77);
$parcel$export(module.exports, "getHasViewSetsError", () => $73a0413869817e13$export$74f23eebf02ba5ad);
$parcel$export(module.exports, "getPrioritizeViews", () => $73a0413869817e13$export$3e984248ac6f3abe);

var $ahm5r = parcelRequire("ahm5r");

var $1yBwF = parcelRequire("1yBwF");

var $a97Xf = parcelRequire("a97Xf");

var $7jTnu = parcelRequire("7jTnu");

var $dNpTr = parcelRequire("dNpTr");

var $7M0xf = parcelRequire("7M0xf");

var $1vVGo = parcelRequire("1vVGo");
const $73a0413869817e13$export$80579cbb7beb2028 = (state)=>state.viewSets;
const $73a0413869817e13$export$5fb2101b6a5b9adb = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.viewSetId);
const $73a0413869817e13$export$7c001e139b515668 = (viewSetType)=>(0, $ahm5r.createSelector)($73a0413869817e13$export$80579cbb7beb2028, (viewSets)=>viewSets.find((element)=>element.type === viewSetType));
const $73a0413869817e13$export$a4dfeb85ade20f0d = (viewSetType)=>(0, $dNpTr.wrapWithDeepEqualityCheck)((0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668(viewSetType), (viewSet)=>(viewSet?.views || []).map(({ id: id })=>id)));
const $73a0413869817e13$export$cf952a1809704f8b = (0, $ahm5r.createSelector)($73a0413869817e13$export$80579cbb7beb2028, (viewSets)=>{
    const countViewsRecursive = (viewSet)=>viewSet.views.length + (0, (/*@__PURE__*/$parcel$interopDefault($a97Xf)))((viewSet.viewSets || []).map((set)=>countViewsRecursive(set)));
    return (0, (/*@__PURE__*/$parcel$interopDefault($a97Xf)))(viewSets.map((set)=>countViewsRecursive(set)));
});
const $73a0413869817e13$export$c2db6af50b4bf31a = (0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('PRIORITIZE'), (prioritizeViewSet)=>{
    if (!prioritizeViewSet) return 0;
    const countViewsRecursive = (viewSet)=>viewSet.views.length + (viewSet.viewSets || []).reduce((acc, set)=>acc + countViewsRecursive(set), 0);
    return prioritizeViewSet.views.length + (prioritizeViewSet.viewSets || []).reduce((acc, set)=>acc + countViewsRecursive(set), 0);
});
const $73a0413869817e13$export$3ab39915fc57999c = (0, $ahm5r.createSelector)($73a0413869817e13$export$80579cbb7beb2028, (viewSets)=>{
    const countViewSetsRecursive = (viewSet)=>1 + (0, (/*@__PURE__*/$parcel$interopDefault($a97Xf)))((viewSet.viewSets || []).map((set)=>countViewSetsRecursive(set)));
    return (0, (/*@__PURE__*/$parcel$interopDefault($a97Xf)))(viewSets.map((set)=>countViewSetsRecursive(set)));
});
const $73a0413869817e13$var$getAllIdeasView = (0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('PRIORITIZE'), (viewSet)=>(0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(viewSet?.views));
const $73a0413869817e13$export$c329812b6b6f2798 = (0, $ahm5r.createSelector)($73a0413869817e13$var$getAllIdeasView, (view)=>view?.id);
const $73a0413869817e13$export$6971c8e340062ba4 = (rank)=>(0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('PRIORITIZE'), (viewSet)=>{
        if (!rank) return undefined;
        if (!(0, $7jTnu.fg)('jpd_deep_link_views_by_rank')) {
            const rankNumber = +rank;
            return viewSet?.views.find((view)=>view.rank === rankNumber)?.slug;
        }
        const [firstLevelRank, secondLevelRank] = rank.split('.').map((r)=>parseInt(r, 10));
        if (Number.isNaN(firstLevelRank) || Number.isNaN(secondLevelRank)) return undefined;
        if (firstLevelRank && !secondLevelRank) // e.g. "1" or "2" in old format
        return viewSet?.views.find((view)=>view.rank === firstLevelRank)?.slug;
        if (firstLevelRank === 0 && secondLevelRank) // e.g. "0.1" or "0.2" in new format is the same as  "1" or "2" in old format
        return viewSet?.views.find((view)=>view.rank === secondLevelRank)?.slug;
        if (firstLevelRank && secondLevelRank) // e.g. "1.1" or "1.2"
        return viewSet?.viewSets?.find((set)=>set.rank === firstLevelRank)?.views.find((view)=>view.rank === secondLevelRank)?.slug;
    });
const $73a0413869817e13$var$getPinnedView = (0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('SINGLE'), (viewSet)=>(0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(viewSet?.views));
const $73a0413869817e13$var$getPinnedViewFieldsStableReference = (0, $ahm5r.createSelector)($73a0413869817e13$var$getPinnedView, (view)=>view?.fields || []);
const $73a0413869817e13$export$12956aeed9d738bd = (0, $ahm5r.createSelector)($73a0413869817e13$var$getPinnedView, (view)=>view?.id);
const $73a0413869817e13$export$54a4980995097374 = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), $73a0413869817e13$var$getPinnedViewFieldsStableReference, (fields, viewFields)=>viewFields.filter((pinnedField)=>fields[pinnedField]));
const $73a0413869817e13$export$4352b4190f79d445 = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), $73a0413869817e13$export$54a4980995097374, (fields, pinnedFields)=>pinnedFields.map((fieldKey)=>fields[fieldKey]));
const $73a0413869817e13$export$e3032392fcdec663 = (0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('CAPTURE'), $73a0413869817e13$export$5fb2101b6a5b9adb, (captureSet, currentViewSetId)=>{
    if (captureSet === undefined || currentViewSetId === undefined) return false;
    return captureSet.id === currentViewSetId;
});
const $73a0413869817e13$export$7ba9211868dc6f17 = (0, $dNpTr.wrapWithDeepEqualityCheck)((0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('SYSTEM'), (viewSet)=>(viewSet?.views || []).filter((view)=>view.containsArchived).map(({ id: id })=>id)));
const $73a0413869817e13$export$cd3cc4f66324ec62 = (0, $dNpTr.wrapWithDeepEqualityCheck)((0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('SYSTEM'), (viewSet)=>(viewSet?.views || []).filter((view)=>!view.containsArchived).map(({ id: id })=>id)));
const $73a0413869817e13$var$isFieldValueFilter = (filter)=>'field' in filter;
const $73a0413869817e13$export$d28574233610ce77 = (fieldKey)=>(0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('PRIORITIZE'), (viewSet)=>{
        const viewIds = [];
        const findUsage = ({ filter: filter, filterGroups: filterGroups, sortBy: sortBy, verticalGroupBy: verticalGroupBy, groupBy: groupBy, id: id, timelineConfig: timelineConfig, matrixConfig: matrixConfig, fields: fields })=>{
            const inFields = fields?.find((f)=>f === fieldKey);
            const inFilter = filter.find((f)=>$73a0413869817e13$var$isFieldValueFilter(f) && f.field === fieldKey);
            const inFilterGroups = filterGroups.some((group)=>group.filters.some((f)=>$73a0413869817e13$var$isFieldValueFilter(f) && f.field === fieldKey));
            const inSort = sortBy?.find((s)=>s.fieldKey === fieldKey);
            const inGroup = verticalGroupBy === fieldKey || groupBy === fieldKey;
            const inTimelineConfig = timelineConfig?.startDateField?.key === fieldKey || timelineConfig?.dueDateField?.key === fieldKey;
            const inMatrixConfig = matrixConfig?.axes.some((a)=>a.field?.key === fieldKey);
            const isUsed = (0, $7jTnu.fg)('jpd_filter_groups_by_issue_type') ? inFields || inFilterGroups || inSort || inGroup || inTimelineConfig || inMatrixConfig : inFields || inFilter || inSort || inGroup || inTimelineConfig || inMatrixConfig;
            if (isUsed) viewIds.push(id);
        };
        viewSet?.views.forEach(findUsage);
        viewSet?.viewSets?.forEach((subSet)=>{
            subSet.views.forEach(findUsage);
        });
        return viewIds;
    });
const $73a0413869817e13$export$74f23eebf02ba5ad = (state)=>state.meta.error !== undefined;
const $73a0413869817e13$export$3e984248ac6f3abe = (0, $ahm5r.createSelector)($73a0413869817e13$export$7c001e139b515668('PRIORITIZE'), (viewSet)=>{
    const views = [];
    viewSet?.views.forEach((view)=>views.push(view));
    viewSet?.viewSets?.forEach((subSet)=>{
        subSet.views.forEach((view)=>views.push(view));
    });
    return views;
});

});
parcelRegister("a97Xf", function(module, exports) {

var $2VN7o = parcelRequire("2VN7o");

var $d7YnM = parcelRequire("d7YnM");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $7630ea44eac67729$var$sum(array) {
    return array && array.length ? $2VN7o(array, $d7YnM) : 0;
}
module.exports = $7630ea44eac67729$var$sum;

});

parcelRegister("dNpTr", function(module, exports) {

$parcel$export(module.exports, "createDeepEqualitySelector", () => $cb0b82c25e2cce80$export$d7fccf3d8a001e88);
$parcel$export(module.exports, "wrapWithDeepEqualityCheck", () => $cb0b82c25e2cce80$export$c53985a4c3830da9);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");
const $cb0b82c25e2cce80$export$d7fccf3d8a001e88 = (0, $ahm5r.createSelectorCreator)((0, $ahm5r.defaultMemoize), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
const $cb0b82c25e2cce80$export$c53985a4c3830da9 = (selector)=>$cb0b82c25e2cce80$export$d7fccf3d8a001e88(selector, (result)=>result);

});



parcelRegister("hJWAv", function(module, exports) {

$parcel$export(module.exports, "resetDraft", () => $25455e4f86db117f$export$bdc758a1cae3cbe9);

var $2Qu2F = parcelRequire("2Qu2F");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $25455e4f86db117f$export$bdc758a1cae3cbe9 = (viewId)=>({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const state = getState();
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(state.viewSets, viewId ? (view)=>view.viewId === viewId : (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                draft: (0, $2Qu2F.getAutosaveAffectedViewConfigurations)(view)
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };

});
parcelRegister("gJX7c", function(module, exports) {

$parcel$export(module.exports, "updateViewState", () => $89e8547f98d9ef59$export$70b2933b1cbabae7);
const $89e8547f98d9ef59$export$70b2933b1cbabae7 = (currentViewSets, predicate, mutation)=>{
    let changedView;
    let currentView;
    const mutateView = (view)=>{
        if (predicate(view)) {
            currentView = view;
            changedView = mutation(view);
            return changedView;
        }
        return view;
    };
    const newViewSets = currentViewSets.map((element)=>{
        const views = element.views.map(mutateView);
        const viewSets = element.viewSets?.map((viewSet)=>({
                ...viewSet,
                views: viewSet.views.map(mutateView)
            }));
        return {
            ...element,
            views: views,
            viewSets: viewSets
        };
    });
    return {
        changedView: changedView,
        currentView: currentView,
        viewSets: changedView !== currentView ? newViewSets : currentViewSets
    };
};

});


parcelRegister("8BCIS", function(module, exports) {

$parcel$export(module.exports, "loadViewComments", () => $736321ee11b712ae$export$35e9103854bca8fb);

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $1itML = parcelRequire("1itML");

var $6SinZ = parcelRequire("6SinZ");

var $7DWfj = parcelRequire("7DWfj");

var $gJX7c = parcelRequire("gJX7c");

var $8pL9X = parcelRequire("8pL9X");
const $736321ee11b712ae$export$35e9103854bca8fb = (viewId, forceRefresh = false)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote })=>{
        try {
            const currentView = (0, $7DWfj.createGetViewByAri)(viewId)(getState());
            const commentsAreLoaded = currentView?.commentsLoadingStatus === (0, $6SinZ.PROPERTY_LOADING_STATE).LOADED;
            const commentsAreLoading = currentView?.commentsLoadingStatus === (0, $6SinZ.PROPERTY_LOADING_STATE).LOADING;
            if (!forceRefresh && commentsAreLoaded) // don't load comments if we already have them
            return;
            if (commentsAreLoading) // don't load comments if it is currently already loading
            return;
            if (viewRemote.fetchViewComments !== undefined) {
                const fetchCommentsTimestamp = forceRefresh ? Date.now() : undefined;
                const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, (view)=>({
                        ...view,
                        fetchCommentsTimestamp: fetchCommentsTimestamp,
                        commentsLoadingStatus: (0, $6SinZ.PROPERTY_LOADING_STATE).LOADING
                    }));
                if (changedView) setState({
                    viewSets: viewSets
                });
                const data = await viewRemote.fetchViewComments(viewId);
                const { changedView: changedViewAfterCreation, viewSets: viewSetsAfterCreation } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId && view.fetchCommentsTimestamp === fetchCommentsTimestamp, (view)=>({
                        ...view,
                        comments: data.comments.map((0, $8pL9X.internViewComment)),
                        fetchCommentsTimestamp: undefined,
                        commentsLoadingStatus: (0, $6SinZ.PROPERTY_LOADING_STATE).LOADED
                    }));
                if (changedViewAfterCreation) setState({
                    viewSets: viewSetsAfterCreation
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.views.actions.comments.load-view-comments', error));
            const { viewSets: viewSetsAfterErrorUpdate } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, (view)=>({
                    ...view,
                    commentsLoadingStatus: (0, $6SinZ.PROPERTY_LOADING_STATE).ERROR
                }));
            setState({
                viewSets: viewSetsAfterErrorUpdate
            });
            if (!(error instanceof (0, $1itML.ViewNotFoundError))) throw error;
        }
    };

});
parcelRegister("1itML", function(module, exports) {

$parcel$export(module.exports, "ViewNotFoundError", () => $b8874e07220faf96$export$80339230f0f0d9c1);
class $b8874e07220faf96$export$80339230f0f0d9c1 extends Error {
    constructor(message){
        super(message);
        this.name = 'ViewNotFoundError';
        this.skipSentry = true;
    }
}

});

parcelRegister("8pL9X", function(module, exports) {

$parcel$export(module.exports, "internViewComment", () => $6b088867153444b2$export$66bfa32644409401);
// note that we are turning this not into our own kind of User, but rather into a CommentUser
// for compatibility with idea/issue comments which come from Jira and not from AGG
const $6b088867153444b2$var$internUser = (user)=>{
    if (!user) return {
        accountId: 'unknown',
        avatarUrls: {
            '16x16': '#',
            '24x24': '#',
            '32x32': '#',
            '48x48': '#'
        },
        displayName: 'Unknown user',
        active: false
    };
    return {
        accountId: user.accountId,
        avatarUrls: {
            '16x16': user.picture,
            '24x24': user.picture,
            '32x32': user.picture,
            '48x48': user.picture
        },
        displayName: user.name,
        active: true
    };
};
const $6b088867153444b2$export$66bfa32644409401 = (comment)=>{
    const author = $6b088867153444b2$var$internUser(comment.account);
    return {
        id: comment.id,
        author: author,
        body: comment.content,
        created: comment.created,
        updated: comment.created === comment.updated ? undefined : comment.updated,
        updateAuthor: comment.created === comment.updated ? undefined : author
    };
};

});


parcelRegister("4GgU4", function(module, exports) {

$parcel$export(module.exports, "handleDeliveryDataFetchError", () => $d8df6ed588a40eb1$export$2de3397b1ed18880);
$parcel$export(module.exports, "showStoredDeliveryDataFetchError", () => $d8df6ed588a40eb1$export$c6b2f73a80051e4a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6Mk0X = parcelRequire("6Mk0X");

var $7DWfj = parcelRequire("7DWfj");
const $d8df6ed588a40eb1$export$2de3397b1ed18880 = (error)=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        if (!props.delayDeliveryDataFetchFailedNotification || (0, $7DWfj.isDeliveryFieldVisibleInCurrentView)(state, props)) props.onDeliveryDataFetchFailed(error);
        else setState({
            ...state,
            meta: {
                ...state.meta,
                deliveryDataFetchError: error
            }
        });
    };
const $d8df6ed588a40eb1$export$c6b2f73a80051e4a = ()=>({ getState: getState, setState: setState }, { onDeliveryDataFetchFailed: onDeliveryDataFetchFailed })=>{
        const state = getState();
        const deliveryDataFetchError = (0, $6Mk0X.getDeliveryDataFetchError)(state);
        if (deliveryDataFetchError) {
            onDeliveryDataFetchFailed(deliveryDataFetchError);
            setState({
                ...state,
                meta: {
                    ...state.meta,
                    deliveryDataFetchError: undefined
                }
            });
        }
    };

});

parcelRegister("gxJaN", function(module, exports) {

$parcel$export(module.exports, "loadViewMarkers", () => $2aa7a9fe1de11b36$export$e3e97ea1bd161438);
$parcel$export(module.exports, "createViewMarker", () => $2aa7a9fe1de11b36$export$f13d55f67d3a8467);
$parcel$export(module.exports, "updateViewMarker", () => $2aa7a9fe1de11b36$export$cd6ad8ab989a7806);
$parcel$export(module.exports, "deleteViewMarker", () => $2aa7a9fe1de11b36$export$76a96534ac714008);

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $gJX7c = parcelRequire("gJX7c");
const $2aa7a9fe1de11b36$export$e3e97ea1bd161438 = (uuid)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
        try {
            const markers = await viewRemote.fetchViewMarkers(uuid);
            const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.uuid === uuid, (view)=>({
                    ...view,
                    markers: markers
                }));
            if (changedView) setState({
                viewSets: viewSets
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.view.actions.markers.load', error));
                onActionFailed(error);
            }
        }
    };
const $2aa7a9fe1de11b36$export$f13d55f67d3a8467 = (uuid, marker)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
        try {
            const createdMarker = await viewRemote.createViewMarker(uuid, marker);
            const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.uuid === uuid, (view)=>({
                    ...view,
                    markers: [
                        ...view.markers || [],
                        createdMarker
                    ]
                }));
            if (changedView) setState({
                viewSets: viewSets
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.view.actions.markers.create', error));
                onActionFailed(error);
            }
            throw error;
        }
    };
const $2aa7a9fe1de11b36$export$cd6ad8ab989a7806 = (uuid, updateMarker)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
        try {
            await viewRemote.updateViewMarker(uuid, updateMarker);
            const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.uuid === uuid, (view)=>({
                    ...view,
                    markers: (view.markers || []).map((marker)=>marker.id === updateMarker.id ? updateMarker : marker)
                }));
            if (changedView) setState({
                viewSets: viewSets
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.view.actions.markers.update', error));
                onActionFailed(error);
            }
            throw error;
        }
    };
const $2aa7a9fe1de11b36$export$76a96534ac714008 = (uuid, markerId)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
        try {
            await viewRemote.deleteViewMarker(uuid, markerId);
            const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.uuid === uuid, (view)=>({
                    ...view,
                    markers: (view.markers || []).filter((marker)=>marker.id !== markerId)
                }));
            if (changedView) setState({
                viewSets: viewSets
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.view.actions.markers.delete', error));
                onActionFailed(error);
            }
            throw error;
        }
    };

});

parcelRegister("hbBW0", function(module, exports) {

$parcel$export(module.exports, "refreshIssueRanking", () => $f67a4b3dfbfaf2e5$export$76776bbd8cdf3558);

var $5zHFN = parcelRequire("5zHFN");

var $ljej9 = parcelRequire("ljej9");

var $6AI7I = parcelRequire("6AI7I");

var $e1eg1 = parcelRequire("e1eg1");

var $gJX7c = parcelRequire("gJX7c");
const $f67a4b3dfbfaf2e5$export$76776bbd8cdf3558 = (viewId)=>async ({ getState: getState, setState: setState }, { onViewLoadingFailed: onViewLoadingFailed, rankingRemote: rankingRemote })=>{
        if (!(0, $6AI7I.isViewInViewRankSortMode)(getState(), viewId)) return;
        rankingRemote.get({
            listId: viewId
        }).then((remoteRanking)=>{
            let modified = false;
            const viewMutation = (view)=>{
                const newIssueRanking = remoteRanking ? (0, $ljej9.toIssueIdArray)(remoteRanking) : undefined;
                if ((0, $5zHFN.isShallowEqual)(newIssueRanking, view.issueRanking)) return view;
                modified = true;
                return {
                    ...view,
                    issueRanking: newIssueRanking
                };
            };
            const { viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, viewMutation);
            if (modified) setState({
                viewSets: viewSets
            });
        }).catch((error)=>{
            (0, $e1eg1.logViewError)('refresh-ranking', error);
            onViewLoadingFailed(error);
        });
    };

});
parcelRegister("6AI7I", function(module, exports) {

$parcel$export(module.exports, "getCurrentViewSortMode", () => $37b661fe805572d7$export$bdc88eaaad4e78d);
$parcel$export(module.exports, "isViewInViewRankSortMode", () => $37b661fe805572d7$export$5c8ec10434f6fe57);
$parcel$export(module.exports, "isCurrentViewSortModeViewRank", () => $37b661fe805572d7$export$1f9723fd7c3e4e2b);
$parcel$export(module.exports, "getCurrentViewIssueRanking", () => $37b661fe805572d7$export$432b209718c54d6f);
$parcel$export(module.exports, "isManualIdeaRankingPossibleInCurrentView", () => $37b661fe805572d7$export$f6f56da269481be2);

var $ahm5r = parcelRequire("ahm5r");


var $hsfc2 = parcelRequire("hsfc2");

var $2PfqD = parcelRequire("2PfqD");

var $7M0xf = parcelRequire("7M0xf");

var $238Vi = parcelRequire("238Vi");

var $1vVGo = parcelRequire("1vVGo");
const $37b661fe805572d7$export$bdc88eaaad4e78d = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (fields, view, draft, isAutosaveEnabled)=>{
    const config = isAutosaveEnabled ? view : draft;
    return config !== undefined ? (0, $2PfqD.getSortMode)(config, fields) : undefined;
});
const $37b661fe805572d7$var$getViewByViewId = (state, viewAri)=>(0, $hsfc2.findView)(state.viewSets, ({ viewId: viewId })=>viewId === viewAri);
const $37b661fe805572d7$export$5c8ec10434f6fe57 = (state, viewAri)=>{
    const view = $37b661fe805572d7$var$getViewByViewId(state, viewAri);
    return (view?.isAutosaveEnabled === false ? view.draft : view)?.sortMode === (0, $f3f1bd644cfe4e35$export$a95cb1c0dd162f95);
};
const $37b661fe805572d7$export$1f9723fd7c3e4e2b = (state, props)=>$37b661fe805572d7$export$bdc88eaaad4e78d(state, props) === (0, $f3f1bd644cfe4e35$export$a95cb1c0dd162f95);
const $37b661fe805572d7$export$432b209718c54d6f = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.issueRanking);
const $37b661fe805572d7$export$f6f56da269481be2 = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (0, $238Vi.getCurrentViewDraft), (0, $238Vi.isCurrentViewAutosaveEnabled), (view, draft, isAutosaveEnabled)=>{
    return (isAutosaveEnabled ? view : draft)?.sortMode !== (0, $f3f1bd644cfe4e35$export$46fe69a6d17f56c4);
});

});
parcelRegister("2PfqD", function(module, exports) {

$parcel$export(module.exports, "getSortMode", () => $553958b56e822599$export$f4fe898ec2ac87e3);
$parcel$export(module.exports, "withSortFieldsSet", () => $553958b56e822599$export$b147fbc94461fda4);
$parcel$export(module.exports, "withProjectRankMode", () => $553958b56e822599$export$d5cb4c1c6130141);
$parcel$export(module.exports, "withViewRankMode", () => $553958b56e822599$export$1d9a5c687ec3e235);
$parcel$export(module.exports, "withMovedIssue", () => $553958b56e822599$export$847628668b1df5f8);
$parcel$export(module.exports, "withInsertedIssue", () => $553958b56e822599$export$ccf358ae9fedcd43);
$parcel$export(module.exports, "withInsertedIssuesBulk", () => $553958b56e822599$export$f25826d78bd3a4c);
$parcel$export(module.exports, "withMovedIssuesToTop", () => $553958b56e822599$export$9a2ff09329e530af);

var $7B8wM = parcelRequire("7B8wM");

const $553958b56e822599$export$f4fe898ec2ac87e3 = (config, fields)=>{
    // a sortBy field can be unavailable in the current view
    // e.g. a global field that has been first picked as the sortBy field and then unassociated
    const availableSortByFields = config.sortBy?.filter((field)=>fields[field.fieldKey]);
    if (config.sortMode === (0, $f3f1bd644cfe4e35$export$46fe69a6d17f56c4) && availableSortByFields?.length === 0) return 0, $f3f1bd644cfe4e35$export$b751518930c382de;
    if (config.sortMode !== undefined) return config.sortMode;
    return config.sortBy ? (0, $f3f1bd644cfe4e35$export$46fe69a6d17f56c4) : (0, $f3f1bd644cfe4e35$export$b751518930c382de);
};
const $553958b56e822599$export$b147fbc94461fda4 = (config, fields)=>{
    if (fields === undefined) return {
        sortMode: config.sortMode === (0, $f3f1bd644cfe4e35$export$46fe69a6d17f56c4) || config.sortMode === undefined ? (0, $f3f1bd644cfe4e35$export$b751518930c382de) : config.sortMode,
        sortBy: undefined,
        issueRanking: config.issueRanking
    };
    return {
        sortMode: (0, $f3f1bd644cfe4e35$export$46fe69a6d17f56c4),
        sortBy: fields,
        issueRanking: config.issueRanking
    };
};
const $553958b56e822599$export$d5cb4c1c6130141 = (config, clearIssueRanking = false)=>({
        sortMode: (0, $f3f1bd644cfe4e35$export$b751518930c382de),
        sortBy: undefined,
        issueRanking: clearIssueRanking ? undefined : config.issueRanking
    });
const $553958b56e822599$export$1d9a5c687ec3e235 = (config, issueRanking, overrideCurrentIssueRanking = false)=>({
        sortMode: (0, $f3f1bd644cfe4e35$export$a95cb1c0dd162f95),
        sortBy: undefined,
        issueRanking: overrideCurrentIssueRanking ? issueRanking : config.issueRanking || issueRanking
    });
const $553958b56e822599$export$847628668b1df5f8 = (config, id, destinationBeforeId, destinationAfterId, sortedIds)=>{
    const ids = [
        ...sortedIds
    ];
    const itemIndex = (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(ids, id);
    ids.splice(itemIndex, 1);
    const toIndex = destinationBeforeId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(ids, destinationBeforeId) : (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(ids, destinationAfterId) + 1;
    ids.splice(toIndex, 0, id);
    return {
        sortMode: config.sortMode,
        sortBy: config.sortBy,
        issueRanking: ids
    };
};
const $553958b56e822599$var$getBaseSorting = (viewIssueRanking, sortedIssueIdsOnCreation)=>sortedIssueIdsOnCreation.length > viewIssueRanking.length ? sortedIssueIdsOnCreation : viewIssueRanking;
const $553958b56e822599$export$ccf358ae9fedcd43 = (config, id, index, sortedIssueIdsOnCreation)=>{
    const ids = [
        ...$553958b56e822599$var$getBaseSorting(config.issueRanking || [], sortedIssueIdsOnCreation)
    ];
    ids.splice(index, 0, id);
    return {
        sortMode: config.sortMode,
        sortBy: config.sortBy,
        issueRanking: ids
    };
};
const $553958b56e822599$export$f25826d78bd3a4c = (config, id, index, sortedIssueIdsOnCreation)=>{
    const ids = [
        ...$553958b56e822599$var$getBaseSorting(config.issueRanking || [], sortedIssueIdsOnCreation)
    ];
    ids.splice(index, 0, ...id);
    return {
        sortMode: config.sortMode,
        sortBy: config.sortBy,
        issueRanking: ids
    };
};
const $553958b56e822599$export$9a2ff09329e530af = (config, movedIds, sortedIds)=>({
        sortMode: config.sortMode,
        sortBy: config.sortBy,
        issueRanking: [
            ...movedIds,
            ...sortedIds.filter((id)=>!movedIds.includes(id))
        ]
    });

});
parcelRegister("7B8wM", function(module, exports) {

var $kEE3x = parcelRequire("kEE3x");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $58829a82ef533fd1$var$nativeMax = Math.max;
/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */ function $58829a82ef533fd1$var$indexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $c9FP3(fromIndex);
    if (index < 0) index = $58829a82ef533fd1$var$nativeMax(length + index, 0);
    return $kEE3x(array, value, index);
}
module.exports = $58829a82ef533fd1$var$indexOf;

});




parcelRegister("egEA8", function(module, exports) {

$parcel$export(module.exports, "refreshArrangementInformation", () => $e1e899cc046874ec$export$9316dc1d332e947b);
$parcel$export(module.exports, "updateArrangementInformation", () => $e1e899cc046874ec$export$839e4036bfda610a);
$parcel$export(module.exports, "setArrangementInformation", () => $e1e899cc046874ec$export$cce50b445d5d6a63);

var $cSmYj = parcelRequire("cSmYj");

var $1O6Yz = parcelRequire("1O6Yz");

var $bHZrQ = parcelRequire("bHZrQ");

var $1vVGo = parcelRequire("1vVGo");

var $7DWfj = parcelRequire("7DWfj");

var $mJiEA = parcelRequire("mJiEA");

var $e1eg1 = parcelRequire("e1eg1");

var $gJX7c = parcelRequire("gJX7c");
const $e1e899cc046874ec$var$createViewMutation = (arrangementInformation = {})=>(view)=>{
        if (!view.timelineConfig || (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(arrangementInformation, view.timelineConfig?.arrangementInformation)) return view;
        try {
            return {
                ...view,
                timelineConfig: {
                    ...view.timelineConfig,
                    arrangementInformation: arrangementInformation
                }
            };
        } catch (error) {
            return view;
        }
    };
const $e1e899cc046874ec$var$tryParseArrangementString = (arrangementString)=>{
    try {
        return arrangementString ? JSON.parse(arrangementString) : undefined;
    } catch (error) {
        return undefined;
    }
};
const $e1e899cc046874ec$export$9316dc1d332e947b = (viewId)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote, onViewLoadingFailed: onViewLoadingFailed, fields: fields })=>{
        viewRemote.fetchArrangementInfo(viewId, fields).then((arrangementString)=>{
            const { viewSets: viewSets, currentView: currentView, changedView: changedView } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, $e1e899cc046874ec$var$createViewMutation($e1e899cc046874ec$var$tryParseArrangementString(arrangementString)));
            if (currentView === changedView) return;
            setState({
                viewSets: viewSets
            });
        }).catch((error)=>{
            (0, $e1eg1.logViewError)('refresh-arrangement', error);
            onViewLoadingFailed(error);
        });
    };
const $e1e899cc046874ec$var$createNewRemoteArrangementString = (remoteArrangementString, fieldKey, groupValueIdToIdArrangement)=>JSON.stringify({
        ...$e1e899cc046874ec$var$tryParseArrangementString(remoteArrangementString) || {},
        [fieldKey]: groupValueIdToIdArrangement || {}
    });
const $e1e899cc046874ec$export$839e4036bfda610a = (groupValueIdToIdArrangement)=>async ({ getState: getState, setState: setState }, props)=>{
        const view = (0, $1vVGo.getCurrentView)(getState(), props);
        if (view?.viewId === undefined) return;
        const { viewId: viewId } = view;
        const arrangementInfo = (0, $mJiEA.getCurrentViewArrangementInformation)(getState(), props) || {};
        const groupingKey = (0, $7DWfj.getCurrentViewVerticalGroupBy)(getState(), props)?.key || (0, $bHZrQ.NO_GROUPING_GROUP_ID);
        const newArrangementInfo = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, arrangementInfo, {
            [groupingKey]: groupValueIdToIdArrangement
        });
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (v)=>v.viewId === viewId, $e1e899cc046874ec$var$createViewMutation(newArrangementInfo));
        if (changedView === currentView) return;
        setState({
            viewSets: viewSets
        });
        props.viewRemote.fetchArrangementInfo(viewId, props.fields).then((remoteArrangementString)=>{
            props.viewRemote.updateArrangementInfo({
                viewId: props.isCollectionView && view.uuid ? view.uuid : viewId,
                arrangement: $e1e899cc046874ec$var$createNewRemoteArrangementString(remoteArrangementString, groupingKey, newArrangementInfo[groupingKey])
            });
        }).catch((error)=>{
            (0, $e1eg1.logViewError)('update-arrangement', error);
            props.onViewLoadingFailed(error);
        });
    };
const $e1e899cc046874ec$export$cce50b445d5d6a63 = (viewId, arrangementInformation)=>({ getState: getState, setState: setState })=>{
        const { viewSets: viewSets, changedView: changedView } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, $e1e899cc046874ec$var$createViewMutation(arrangementInformation));
        if (changedView) setState({
            viewSets: viewSets
        });
    };

});

parcelRegister("cyCtl", function(module, exports) {

$parcel$export(module.exports, "trackAtlasAnalytics", () => $7270f6e2a10ca7b3$export$25118c8dfa2e278f);
$parcel$export(module.exports, "trackAtlasSiteAnalytics", () => $7270f6e2a10ca7b3$export$13b5af120b0293c7);

var $eTBmS = parcelRequire("eTBmS");

var $3Ku0X = parcelRequire("3Ku0X");

var $gCeeo = parcelRequire("gCeeo");
const $7270f6e2a10ca7b3$export$25118c8dfa2e278f = (view, fields)=>{
    if (view.groupBy && fields[view.groupBy]?.configuration?.provider) (0, $3Ku0X.sendPendoTrackEvent)(`${fields[view.groupBy]?.configuration?.provider}_grouped_by_view mounted`);
    if (view.verticalGroupBy && fields[view.verticalGroupBy]?.configuration?.provider) (0, $3Ku0X.sendPendoTrackEvent)(`${fields[view.verticalGroupBy]?.configuration?.provider}_vertically_grouped_by_view mounted`);
    view.fields?.forEach((fieldkey)=>{
        if (fields[fieldkey]?.configuration?.provider) (0, $3Ku0X.sendPendoTrackEvent)(`${fields[fieldkey]?.configuration?.provider}_field_in_view mounted`);
    });
};
const $7270f6e2a10ca7b3$export$13b5af120b0293c7 = (view, fields, cloudId, createAnalyticsEvent)=>{
    const atlasConfiguredFields = view.fields?.filter((fieldKey)=>(fields[fieldKey]?.type === (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL || fields[fieldKey]?.type === (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT) && fields[fieldKey]?.configuration?.cloudId !== undefined);
    if (!atlasConfiguredFields || !atlasConfiguredFields.length) return;
    const isSameAtlasSite = atlasConfiguredFields.some((fieldKey)=>cloudId === fields[fieldKey]?.configuration?.cloudId);
    if (isSameAtlasSite) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'atlasFields loaded', 'sameAtlasSiteConfig');
    else (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'atlasFields loaded', 'differentAtlasSiteConfig');
};

});


parcelRegister("8uL8I", function(module, exports) {

$parcel$export(module.exports, "actions", () => $aaa7f65e3a7a3d28$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $2oTIU = parcelRequire("2oTIU");

var $gFtrn = parcelRequire("gFtrn");

var $hJWAv = parcelRequire("hJWAv");

var $jJQVE = parcelRequire("jJQVE");

var $jhZdK = parcelRequire("jhZdK");

var $8bBCP = parcelRequire("8bBCP");

var $8BCIS = parcelRequire("8BCIS");

var $KnEQx = parcelRequire("KnEQx");

var $kYdmg = parcelRequire("kYdmg");

var $dUql0 = parcelRequire("dUql0");

var $4GgU4 = parcelRequire("4GgU4");

var $fypYM = parcelRequire("fypYM");
var $ee86w = parcelRequire("ee86w");

var $LFH9i = parcelRequire("LFH9i");

var $d7HT7 = parcelRequire("d7HT7");

var $2OOCq = parcelRequire("2OOCq");

var $f3aih = parcelRequire("f3aih");

var $ksLZv = parcelRequire("ksLZv");

var $4Tjok = parcelRequire("4Tjok");

var $c4GFV = parcelRequire("c4GFV");

var $bmUNY = parcelRequire("bmUNY");

var $7buaW = parcelRequire("7buaW");

var $gxJaN = parcelRequire("gxJaN");

var $cvur5 = parcelRequire("cvur5");

var $bDsnq = parcelRequire("bDsnq");

var $bzPYi = parcelRequire("bzPYi");

var $8vhs6 = parcelRequire("8vhs6");

var $fQ9h5 = parcelRequire("fQ9h5");

var $Mrqhh = parcelRequire("Mrqhh");

var $9zEQq = parcelRequire("9zEQq");


var $gI1h5 = parcelRequire("gI1h5");

var $eQSXY = parcelRequire("eQSXY");

var $gJziQ = parcelRequire("gJziQ");

var $egEA8 = parcelRequire("egEA8");

var $2uYQG = parcelRequire("2uYQG");

var $dnEJE = parcelRequire("dnEJE");

var $eG9EU = parcelRequire("eG9EU");

var $1H8iA = parcelRequire("1H8iA");
const $aaa7f65e3a7a3d28$export$e324594224ef24da = {
    setGroupBy: $4Tjok.setGroupBy,
    setHideEmptyColumns: $4Tjok.setHideEmptyColumns,
    updateFilters: $2OOCq.updateFilters,
    setHideEmptyGroups: $4Tjok.setHideEmptyGroups,
    setStartDateField: $2uYQG.setStartDateField,
    setEndDateField: $2uYQG.setEndDateField,
    setStartTimelineIntervalDate: $2uYQG.setStartTimelineIntervalDate,
    setEndTimelineIntervalDate: $2uYQG.setEndTimelineIntervalDate,
    setVerticalGroupBy: $4Tjok.setVerticalGroupBy,
    setVerticalGroupValues: $4Tjok.setVerticalGroupValues,
    setGroupValues: $4Tjok.setGroupValues,
    setFieldValues: $cvur5.setFieldValues,
    setFieldValuesReverseOrder: $cvur5.setFieldValuesReverseOrder,
    setViewColumns: $d7HT7.setViewColumns,
    sortViewField: $d7HT7.sortViewField,
    updateViewField: $d7HT7.updateViewField,
    hideViewField: $d7HT7.hideViewField,
    toggleViewField: $d7HT7.toggleViewField,
    removeFieldFromView: $d7HT7.removeFieldFromView,
    setPermanentSortFieldsOfCurrentView: $gI1h5.setPermanentSortFieldsOfCurrentView,
    setSortModeOfCurrentViewToProjectRank: $gI1h5.setSortModeOfCurrentViewToProjectRank,
    setSortModeOfCurrentViewToViewRank: $gI1h5.setSortModeOfCurrentViewToViewRank,
    moveIssueInCurrentView: $gI1h5.moveIssueInCurrentView,
    moveIssuesToTopOfCurrentView: $gI1h5.moveIssuesToTopOfCurrentView,
    insertIssueAtIndexInCurrentView: $gI1h5.insertIssueAtIndexInCurrentView,
    insertBulkIssueAtIndexInCurrentView: $gI1h5.insertBulkIssueAtIndexInCurrentView,
    setCurrentView: $kYdmg.setCurrentView,
    deleteView: $dUql0.deleteView,
    deleteViewFromState: $dUql0.deleteViewFromState,
    renameView: $dnEJE.renameView,
    addViewEmoji: $dnEJE.addViewEmoji,
    renameCurrentView: $dnEJE.renameCurrentView,
    addCurrentViewEmoji: $dnEJE.addCurrentViewEmoji,
    rankViews: $fQ9h5.rankViews,
    refreshViewsRanks: $fQ9h5.refreshViewsRanks,
    setEditCurrentViewTitle: $dnEJE.setEditCurrentViewTitle,
    cloneView: $jJQVE.cloneView,
    cloneCurrentView: $jJQVE.cloneCurrentView,
    saveCurrentUnsavedViewAsNew: $jJQVE.saveCurrentUnsavedViewAsNew,
    createNewView: $KnEQx.createNewView,
    updateFieldFilter: $2OOCq.updateFieldFilter,
    updateConnectionFieldFilter: $f3aih.updateConnectionFieldFilter,
    clearFieldFilter: $2OOCq.clearFieldFilter,
    clearFilter: $2OOCq.clearFilter,
    updateNumericFilter: $2OOCq.updateNumericFilter,
    updateQuickSearchFilter: $2OOCq.updateQuickSearchFilter,
    clearAllFilters: $2OOCq.clearAllFilters,
    removeFilterFromGroups: $2OOCq.removeFilterFromGroups,
    clearSelection: $c4GFV.clearSelection,
    toggleSelection: $c4GFV.toggleSelection,
    setSelection: $c4GFV.setSelection,
    changeViewDescription: $fypYM.changeViewDescription,
    toogleSwimlane: $eQSXY.toogleSwimlane,
    toggleAllSwimlanes: $eQSXY.toggleAllSwimlanes,
    initSwimlanes: $eQSXY.initSwimlanes,
    createSection: $Mrqhh.createSection,
    saveSection: $Mrqhh.saveSection,
    deleteSection: $Mrqhh.deleteSection,
    deleteSectionFromState: $Mrqhh.deleteSectionFromState,
    loadSection: $Mrqhh.loadSection,
    loadViewComments: $8BCIS.loadViewComments,
    loadViewDescription: $ee86w.loadViewDescription,
    createViewComment: $8bBCP.createViewComment,
    updateViewComment: $8bBCP.updateViewComment,
    deleteViewComment: $8bBCP.deleteViewComment,
    seenViewComments: $8bBCP.seenViewComments,
    resizeFieldColumn: $jhZdK.resizeFieldColumn,
    setMatrixXAxis: $bDsnq.setMatrixXAxis,
    setMatrixYAxis: $bDsnq.setMatrixYAxis,
    setMatrixZAxis: $bDsnq.setMatrixZAxis,
    switchMatrixXAndYAxis: $bzPYi.switchMatrixXAndYAxis,
    setTimelineMode: $2uYQG.setTimelineMode,
    /**
	 * this action has no side effects. It is a helper accessor to get the container
	 * props in through the hook API and forwarded to the reselect selectors
	 */ getContainerProps: ()=>(ops, props)=>props,
    setUnsavedChanges: $eG9EU.setUnsavedChanges,
    refreshArrangementInformation: $egEA8.refreshArrangementInformation,
    updateArrangementInformation: $egEA8.updateArrangementInformation,
    setArrangementInformation: $egEA8.setArrangementInformation,
    updateIntervalFilter: $ksLZv.updateIntervalFilter,
    setAutosaveEnabled: $gFtrn.setAutosaveEnabled,
    resetDraft: $hJWAv.resetDraft,
    setDraft: $gFtrn.setDraft,
    saveUnsavedChanges: $gFtrn.saveUnsavedChanges,
    setHoveredFieldKeyForBulkEdit: $jhZdK.setHoveredFieldKeyForBulkEdit,
    setRollupFieldsValue: $LFH9i.setRollupFieldsValue,
    loadView: $7buaW.loadView,
    setLayoutType: $bmUNY.setLayoutType,
    handleDeliveryDataFetchError: $4GgU4.handleDeliveryDataFetchError,
    setSummaryCardField: $2uYQG.setSummaryCardField,
    syncViewsWithNavigation: $gJziQ.syncViewsWithNavigation,
    loadViewMarkers: $gxJaN.loadViewMarkers,
    createViewMarker: $gxJaN.createViewMarker,
    updateViewMarker: $gxJaN.updateViewMarker,
    deleteViewMarker: $gxJaN.deleteViewMarker,
    setForceReloadViewOnNextUpdate: $9zEQq.setForceReloadViewOnNextUpdate,
    setHasManageCurrentViewPermission: $8vhs6.setHasManageCurrentViewPermission,
    setCurrentViewAccessLevel: $2oTIU.setCurrentViewAccessLevel,
    setLastSelectedIssueTypeId: $1H8iA.setLastSelectedIssueTypeId
};

});
parcelRegister("2oTIU", function(module, exports) {

$parcel$export(module.exports, "setCurrentViewAccessLevel", () => $5c3d793ce8aa7efe$export$fdf6dae458d064e9);
const $5c3d793ce8aa7efe$export$fdf6dae458d064e9 = (accessLevel)=>async ({ setState: setState })=>{
        setState({
            accessLevel: accessLevel
        });
    };

});

parcelRegister("gFtrn", function(module, exports) {

$parcel$export(module.exports, "setDraft", () => $b8c88c127a7bec38$export$d0a055548fc92923);
$parcel$export(module.exports, "setAutosaveEnabled", () => $b8c88c127a7bec38$export$9ae214af10cdab43);
$parcel$export(module.exports, "saveUnsavedChanges", () => $b8c88c127a7bec38$export$920e919dea75a175);

var $hpem9 = parcelRequire("hpem9");

var $2Qu2F = parcelRequire("2Qu2F");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");

var $hJWAv = parcelRequire("hJWAv");
const $b8c88c127a7bec38$export$d0a055548fc92923 = (draft)=>({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const state = getState();
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(state.viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                draft: draft
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };
const $b8c88c127a7bec38$export$9ae214af10cdab43 = (isAutosaveEnabled)=>({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                modified: true,
                isAutosaveEnabled: isAutosaveEnabled
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveView)(changedView.id));
            dispatch((0, $hJWAv.resetDraft)());
        }
    };
const $b8c88c127a7bec38$export$920e919dea75a175 = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...(0, $2Qu2F.applyDraftToView)(view),
                modified: true
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveView)(changedView.id));
        }
    };

});
parcelRegister("hpem9", function(module, exports) {

$parcel$export(module.exports, "saveView", () => $75742eca6ead5bbb$export$5c85e4ea5ae8a7f2);
$parcel$export(module.exports, "saveViewWithAutoSave", () => $75742eca6ead5bbb$export$adedd74f346607bf);

var $3s8bj = parcelRequire("3s8bj");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $8KUFq = parcelRequire("8KUFq");

var $8oKDI = parcelRequire("8oKDI");

var $8m4OM = parcelRequire("8m4OM");

var $4dsfo = parcelRequire("4dsfo");

var $b5oGV = parcelRequire("b5oGV");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $eKYK5 = parcelRequire("eKYK5");

var $1itML = parcelRequire("1itML");

var $btZbH = parcelRequire("btZbH");

var $9PAQN = parcelRequire("9PAQN");

var $dUql0 = parcelRequire("dUql0");

var $e1eg1 = parcelRequire("e1eg1");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");

var $hOj1o = parcelRequire("hOj1o");
const $75742eca6ead5bbb$export$f8f57af5372f6acb = (id)=>async ({ getState: getState, setState: setState })=>{
        const { viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.id === id, (view)=>({
                ...view,
                saving: true,
                saveError: undefined,
                modified: false
            }));
        setState({
            viewSets: viewSets
        });
    };
const $75742eca6ead5bbb$export$619e9b4acba2efef = ({ id: id, error: error, viewId: viewId, uuid: uuid, updatedAt: updatedAt, onAfterSave: onAfterSave })=>async ({ getState: getState, setState: setState })=>{
        const viewAriConfig = viewId !== undefined ? (0, $8oKDI.getAriConfig)(viewId) : undefined;
        const { viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.id === id, (view)=>({
                ...view,
                updatedAtTimestamp: updatedAt,
                viewId: viewId !== undefined ? viewId : view.viewId,
                uuid: uuid !== undefined ? uuid : view.uuid,
                slug: viewAriConfig !== undefined ? viewAriConfig.resourceId : view.slug,
                saveError: error,
                saving: false
            }));
        if (onAfterSave !== undefined) {
            const updatedView = (0, $hsfc2.findView)(viewSets || [], ({ id: vid })=>id === vid);
            onAfterSave(updatedView);
        }
        setState({
            viewSets: viewSets
        });
    };
const $75742eca6ead5bbb$var$transformIntervalFilter = (filter)=>{
    if (!(0, $7jTnu.fg)('polaris_better_date_filters')) {
        if ((0, $4dsfo.isIntervalFieldFilterLegacy)(filter)) return {
            kind: (0, $btZbH.FILTER_KIND).INTERVAL,
            field: filter.field,
            values: filter.values.map((value)=>({
                    value: value.numericValue !== undefined ? value.numericValue : null,
                    operator: value.operator
                }))
        };
    }
    if ((0, $4dsfo.isIntervalFieldFilterLegacy)(filter)) return {
        kind: (0, $btZbH.FILTER_KIND).INTERVAL,
        field: filter.field,
        values: filter.values.map((value)=>({
                value: value.numericValue !== undefined ? value.numericValue : null,
                operator: value.operator
            }))
    };
    if ((0, $4dsfo.isIntervalFieldFilterEmpty)(filter)) return {
        kind: (0, $btZbH.FILTER_KIND).INTERVAL,
        field: filter.field,
        values: filter.values.map((value)=>({
                text: null,
                value: null,
                operator: value.operator
            }))
    };
    return {
        kind: (0, $btZbH.FILTER_KIND).INTERVAL,
        field: filter.field,
        values: filter.values.map((value)=>({
                text: JSON.stringify(value),
                value: null
            }))
    };
};
const $75742eca6ead5bbb$var$transformFilterForSave = (filters)=>filters.reduce((acc, filter)=>{
        // All filters must have a field except for text ones
        if (filter.type !== (0, $8m4OM.TEXT_FIELD_FILTER) && !filter.field) return acc;
        let newFilter;
        switch(filter.type){
            case 0, $8m4OM.GENERIC_FIELD_FILTER:
                newFilter = {
                    kind: (0, $btZbH.FILTER_KIND).FIELD_IDENTITY,
                    field: filter.field,
                    values: filter.values.map((fv)=>({
                            text: fv.stringValue !== undefined ? fv.stringValue : null
                        }))
                };
                break;
            case 0, $8m4OM.NUMERIC_FIELD_FILTER:
                newFilter = {
                    kind: (0, $btZbH.FILTER_KIND).FIELD_NUMERIC,
                    field: filter.field,
                    values: filter.values.map((fv)=>({
                            value: fv.numericValue !== undefined ? fv.numericValue : null,
                            operator: fv.operator
                        }))
                };
                break;
            case 0, $8m4OM.INTERVAL_FIELD_FILTER:
                newFilter = $75742eca6ead5bbb$var$transformIntervalFilter(filter);
                break;
            case 0, $8m4OM.TEXT_FIELD_FILTER:
                if (filter.localId !== 'quick') newFilter = {
                    kind: (0, $btZbH.FILTER_KIND).TEXT,
                    values: filter.values.map((fv)=>({
                            text: fv.stringValue !== undefined ? fv.stringValue : null
                        }))
                };
                break;
            case 0, $8m4OM.CONNECTION_FIELD_FILTER:
                newFilter = {
                    kind: (0, $btZbH.FILTER_KIND).CONNECTION_FIELD_IDENTITY,
                    field: filter.field,
                    values: filter.values.filter((fv)=>fv.enumValue !== undefined)
                };
                break;
            default:
        }
        if (newFilter) acc.push(newFilter);
        return acc;
    }, []);
const $75742eca6ead5bbb$var$transformDescriptionForSave = (description)=>description ?? null;
const $75742eca6ead5bbb$var$transformSortForSave = (sort = [])=>sort.filter(({ fieldKey: fieldKey })=>fieldKey).map(({ asc: asc, fieldKey: fieldKey })=>({
            order: asc ? 'ASC' : 'DESC',
            field: fieldKey
        }));
const $75742eca6ead5bbb$var$transformMatrixConfigForSave = (matrixConfig)=>{
    if (!matrixConfig?.axes) return undefined;
    return {
        axes: matrixConfig.axes.map(({ field: field, dimension: dimension, fieldOptions: fieldOptions, reversed: reversed })=>field?.key && dimension ? {
                field: field.key,
                dimension: dimension,
                fieldOptions: fieldOptions,
                reversed: reversed
            } : null).filter(Boolean)
    };
};
const $75742eca6ead5bbb$var$transformTimelineConfigForSave = (timelineConfig)=>{
    if (!timelineConfig) return undefined;
    return {
        startDateField: timelineConfig.startDateField?.key,
        dueDateField: timelineConfig.dueDateField?.key,
        mode: timelineConfig.mode,
        startTimestamp: timelineConfig.startTimestamp,
        endTimestamp: timelineConfig.endTimestamp,
        summaryCardField: timelineConfig.summaryCardField?.key
    };
};
const $75742eca6ead5bbb$var$transformTableColumnSizes = (tableColumnSizes)=>{
    if (!tableColumnSizes) return undefined;
    return tableColumnSizes.filter(({ fieldKey: fieldKey })=>fieldKey).map(({ fieldKey: fieldKey, size: size })=>({
            field: fieldKey,
            size: size
        }));
};
const $75742eca6ead5bbb$var$transformFieldRollups = (fieldRollups)=>{
    if (!fieldRollups) return undefined;
    return fieldRollups.filter(({ fieldKey: fieldKey })=>fieldKey).map(({ fieldKey: fieldKey, rollup: rollup })=>({
            field: fieldKey,
            rollup: rollup
        }));
};
const $75742eca6ead5bbb$var$DEBOUNCE_DELAY = 600;
const $75742eca6ead5bbb$var$debouncedApiCallMap = {};
const $75742eca6ead5bbb$var$debouncedSaveViewInternal = (dispatch, id, onAfterSave, shouldIgnoreAutosave = true)=>{
    const key = `${id}:${shouldIgnoreAutosave}`;
    if ($75742eca6ead5bbb$var$debouncedApiCallMap[key] === undefined) $75742eca6ead5bbb$var$debouncedApiCallMap[key] = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((fn)=>fn(), $75742eca6ead5bbb$var$DEBOUNCE_DELAY);
    // For each field option, we debounce the api call (but not the local store state update)
    $75742eca6ead5bbb$var$debouncedApiCallMap[key](()=>{
        dispatch($75742eca6ead5bbb$var$saveViewInternal(id, onAfterSave, shouldIgnoreAutosave));
    });
};
const $75742eca6ead5bbb$var$saveViewInternal = (id, onAfterSave, shouldIgnoreAutosave = true, recursiveSaves = 3)=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const state = getState();
        const { viewRemote: viewRemote, onViewUpdateFailed: onViewUpdateFailed, fields: fields } = props;
        const view = (0, $hsfc2.findView)(state.viewSets, (v)=>v.id === id);
        if (view && !view.saving && view.modified) {
            dispatch($75742eca6ead5bbb$export$f8f57af5372f6acb(view.id));
            let hadError = false;
            try {
                if (view.viewId === undefined) {
                    const { viewId: viewId, uuid: uuid } = await viewRemote.createView({
                        name: view.title,
                        description: $75742eca6ead5bbb$var$transformDescriptionForSave(view.description),
                        fields: view.fields,
                        hidden: view.hidden,
                        groupBy: view.groupBy ?? null,
                        verticalGroupBy: view.verticalGroupBy ?? null,
                        groupValues: view.groupValues,
                        verticalGroupValues: view.verticalGroupValues,
                        hideEmptyGroups: view.hideEmptyGroups,
                        hideEmptyColumns: view.hideEmptyColumns,
                        fieldRollups: $75742eca6ead5bbb$var$transformFieldRollups(view.fieldRollups),
                        filter: $75742eca6ead5bbb$var$transformFilterForSave(view.filter),
                        sort: $75742eca6ead5bbb$var$transformSortForSave(view.sortBy),
                        sortMode: view.sortMode,
                        tableColumnSizes: $75742eca6ead5bbb$var$transformTableColumnSizes(view.tableColumnSizes),
                        matrixConfig: $75742eca6ead5bbb$var$transformMatrixConfigForSave(view.matrixConfig),
                        timelineConfig: $75742eca6ead5bbb$var$transformTimelineConfigForSave(view.timelineConfig),
                        projectAri: view.viewSetId,
                        kind: view.kind,
                        enabledAutoSave: true,
                        layoutType: view.layoutType
                    });
                    dispatch($75742eca6ead5bbb$export$619e9b4acba2efef({
                        id: id,
                        viewId: viewId,
                        uuid: uuid,
                        updatedAt: null,
                        onAfterSave: onAfterSave
                    }));
                } else {
                    const pinnedViewId = (0, $9PAQN.getPinnedViewId)(state);
                    const isCurrentViewPinned = view.id === pinnedViewId;
                    const isAutosaveEnabled = isCurrentViewPinned || view.isAutosaveEnabled;
                    if (!isAutosaveEnabled && !isCurrentViewPinned && !shouldIgnoreAutosave) {
                        dispatch($75742eca6ead5bbb$export$619e9b4acba2efef({
                            id: id,
                            onAfterSave: onAfterSave,
                            updatedAt: view.updatedAtTimestamp
                        }));
                        return;
                    }
                    try {
                        (0, $b5oGV.experience).view.updateView.start();
                        const { node: { updatedAt: updatedAt } } = await viewRemote.updateView({
                            uuid: view.uuid,
                            viewId: view.viewId,
                            name: view.title,
                            emoji: view.emoji,
                            description: $75742eca6ead5bbb$var$transformDescriptionForSave(view.description),
                            fields: view.fields,
                            hidden: view.hidden,
                            groupBy: view.groupBy ?? null,
                            verticalGroupBy: view.verticalGroupBy ?? null,
                            groupValues: view.groupValues,
                            verticalGroupValues: view.verticalGroupValues,
                            hideEmptyGroups: view.hideEmptyGroups,
                            hideEmptyColumns: view.hideEmptyColumns,
                            fieldRollups: $75742eca6ead5bbb$var$transformFieldRollups(view.fieldRollups),
                            filter: $75742eca6ead5bbb$var$transformFilterForSave(view.filter),
                            sort: $75742eca6ead5bbb$var$transformSortForSave(view.sortBy),
                            sortMode: view.sortMode,
                            tableColumnSizes: $75742eca6ead5bbb$var$transformTableColumnSizes(view.tableColumnSizes),
                            matrixConfig: $75742eca6ead5bbb$var$transformMatrixConfigForSave(view.matrixConfig),
                            timelineConfig: $75742eca6ead5bbb$var$transformTimelineConfigForSave(view.timelineConfig),
                            lastCommentsViewedTimestamp: view.lastCommentsViewedTimestamp !== undefined ? new Date(view.lastCommentsViewedTimestamp).toISOString() : null,
                            enabledAutoSave: isAutosaveEnabled,
                            layoutType: view.layoutType
                        });
                        dispatch($75742eca6ead5bbb$export$619e9b4acba2efef({
                            id: id,
                            onAfterSave: onAfterSave,
                            updatedAt: updatedAt
                        }));
                        (0, $b5oGV.experience).view.updateView.success();
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        if ((0, $fVlmn.isPermissionError)(error) || (0, $8KUFq.isClientFetchError)(error)) (0, $b5oGV.experience).view.updateView.abort(error);
                        else (0, $b5oGV.experience).view.updateView.failure(error);
                        throw error;
                    }
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $e1eg1.logViewError)('actions.save', Object.assign(error, {
                    viewId: view.viewId
                }));
                hadError = true;
                dispatch($75742eca6ead5bbb$export$619e9b4acba2efef({
                    id: id,
                    error: error,
                    onAfterSave: onAfterSave,
                    updatedAt: view.updatedAtTimestamp
                }));
                onViewUpdateFailed(error);
                if (view.viewId && !(error instanceof (0, $1itML.ViewNotFoundError))) viewRemote.fetchView(view.viewId, fields).then((remoteView)=>{
                    const errorWithChangeData = new Error((0, $hOj1o.createUpdateErrorMessageLogSafe)(view, remoteView, props));
                    (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.viewUpdateFailed', errorWithChangeData));
                    (0, $e1eg1.logViewError)('actions.save', errorWithChangeData);
                }).catch((fetchError)=>{
                    if (fetchError instanceof (0, $eKYK5.AccessNotPermittedError)) dispatch((0, $dUql0.deleteView)(view.id, true));
                    (0, $e1eg1.logViewError)('actions.save', Object.assign(fetchError, {
                        viewId: view.viewId
                    }));
                });
                else (0, $e1eg1.logViewError)('actions.save', error);
                if (error instanceof (0, $1itML.ViewNotFoundError) && view.id) dispatch((0, $dUql0.deleteView)(view.id, true));
            }
            // If an error occured on save wait until the next user action before attempting to save
            // again to prevent getting in a tight loop of errors.
            if (!hadError && recursiveSaves > 0) // Recurse to see if there are more modifications to be saved
            dispatch($75742eca6ead5bbb$var$saveViewInternal(id, undefined, shouldIgnoreAutosave, recursiveSaves - 1));
        }
    };
const $75742eca6ead5bbb$export$5c85e4ea5ae8a7f2 = (id, onAfterSave)=>async ({ dispatch: dispatch })=>{
        $75742eca6ead5bbb$var$debouncedSaveViewInternal(dispatch, id, onAfterSave, true);
    };
const $75742eca6ead5bbb$export$adedd74f346607bf = (id, onAfterSave)=>async ({ dispatch: dispatch })=>{
        $75742eca6ead5bbb$var$debouncedSaveViewInternal(dispatch, id, onAfterSave, false);
    };

});
parcelRegister("eKYK5", function(module, exports) {

$parcel$export(module.exports, "AccessNotPermittedError", () => $17a97f9d4592ee3f$export$68b83931eafbef3);
$parcel$export(module.exports, "isAccessNotPermittedError", () => $17a97f9d4592ee3f$export$1e52ed32dc60901b);

var $1uIew = parcelRequire("1uIew");
class $17a97f9d4592ee3f$export$68b83931eafbef3 extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'AccessNotPermittedError';
        this.cause = cause;
        this.skipSentry = true;
    }
}
const $17a97f9d4592ee3f$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $17a97f9d4592ee3f$var$isForbiddenFetchError = (error)=>error instanceof (0, $1uIew.default) && error.statusCode === 403;
const $17a97f9d4592ee3f$var$isGraphqlForbiddenError = (error)=>$17a97f9d4592ee3f$var$isObject(error) && Array.isArray(error.graphQLErrors) && error.graphQLErrors.length === 1 && error.graphQLErrors[0].extensions?.statusCode === 403;
const $17a97f9d4592ee3f$export$1e52ed32dc60901b = (error)=>{
    if ($17a97f9d4592ee3f$var$isForbiddenFetchError(error) || $17a97f9d4592ee3f$var$isGraphqlForbiddenError(error)) return true;
    return false;
};

});

parcelRegister("dUql0", function(module, exports) {

$parcel$export(module.exports, "deleteView", () => $38b16db257c511c7$export$443d89549b135c95);
$parcel$export(module.exports, "deleteViewFromState", () => $38b16db257c511c7$export$59843b4833b739ab);

var $8KUFq = parcelRequire("8KUFq");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $fVlmn = parcelRequire("fVlmn");

var $1itML = parcelRequire("1itML");

var $gCeeo = parcelRequire("gCeeo");

var $jDdjf = parcelRequire("jDdjf");

var $1vVGo = parcelRequire("1vVGo");

var $7DWfj = parcelRequire("7DWfj");

var $kYdmg = parcelRequire("kYdmg");

var $Mrqhh = parcelRequire("Mrqhh");

var $e1eg1 = parcelRequire("e1eg1");

var $hsfc2 = parcelRequire("hsfc2");

var $9vY0e = parcelRequire("9vY0e");
const $38b16db257c511c7$export$443d89549b135c95 = (id, updateStateOnly = false)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { viewSets: viewSets } = getState();
        const viewToDelete = (0, $hsfc2.findView)(viewSets, (v)=>v.id === id);
        const viewSet = (0, $hsfc2.findViewSet)(getState().viewSets, (v)=>v.id === viewToDelete?.viewSetId);
        const currentView = (0, $1vVGo.getCurrentView)(getState(), props);
        if (viewToDelete && viewSet) {
            const newViewSets = viewSets.map((v)=>({
                    ...v,
                    views: v.id === viewSet.id ? v.views.filter((view)=>view.id !== id) : v.views,
                    viewSets: v.viewSets?.map((vSet)=>({
                            ...vSet,
                            views: vSet.id === viewSet.id ? vSet.views.filter((view)=>view.id !== id) : vSet.views
                        }))
                }));
            setState({
                viewSets: newViewSets
            });
            // if we are deleting the current view, set the new current as first of the current view set
            // or fallback to All Ideas view
            if (viewToDelete.id === currentView?.id) {
                const currentViewSet = (0, $hsfc2.findViewSet)(newViewSets, (v)=>v.id === viewToDelete.viewSetId);
                let newCurrentViewId = currentViewSet?.views?.[0]?.id;
                if (newCurrentViewId === undefined) {
                    const getFirstAvailableViewIdInViewSetWithType = (0, $hsfc2.getFirstAvailableViewIdInViewSet)(newViewSets);
                    const newCurrentViewData = getFirstAvailableViewIdInViewSetWithType('CAPTURE') ?? getFirstAvailableViewIdInViewSetWithType('PRIORITIZE');
                    newCurrentViewId = newCurrentViewData?.view?.id;
                    if (newCurrentViewData?.sectionId) dispatch((0, $Mrqhh.updateState)({
                        id: newCurrentViewData?.sectionId,
                        collapsed: true
                    }));
                }
                // newCurrentViewId would never be null since there will always be a capture or a prioritize view
                // as we disable deleting the last one
                dispatch((0, $kYdmg.setCurrentView)(newCurrentViewId ?? ''));
            }
            const viewIdToDelete = (0, $9vY0e.getUniversalViewId)(viewToDelete);
            if (viewIdToDelete) props.onSyncViewDeletion(viewIdToDelete, viewToDelete.kind);
            if (!updateStateOnly && viewToDelete.viewId) try {
                (0, $b5oGV.experience).view.deleteView.start();
                viewToDelete.uuid && await props.viewRemote.deleteView(viewToDelete.uuid);
                const analyticsData = (0, $7DWfj.extractViewAnalyticsData)(viewToDelete);
                (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({
                    containers: analyticsData?.containers
                }), 'view deleted', analyticsData?.attributes || {});
                (0, $3Ku0X.sendPendoTrackEvent)({
                    actionSubjectAndAction: 'view deleted',
                    attributes: {
                        viewId: viewToDelete.slug || ''
                    }
                });
                (0, $b5oGV.experience).view.deleteView.success();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $e1eg1.logViewError)('actions.delete', Object.assign(error, {
                    viewId: viewToDelete.viewId
                }));
                if (error instanceof (0, $1itML.ViewNotFoundError)) {
                    (0, $b5oGV.experience).view.deleteView.abort(error);
                    return; // we don't need to revert it / show an error as the view doesn't exist anyway
                }
                if ((0, $fVlmn.isPermissionError)(error) || (0, $8KUFq.isClientFetchError)(error)) (0, $b5oGV.experience).view.deleteView.abort(error);
                else (0, $b5oGV.experience).view.deleteView.failure(error);
                props.onViewUpdateFailed(error);
                setState({
                    viewSets: getState().viewSets.map((v)=>({
                            ...v,
                            views: v.id === viewSet.id ? [
                                ...v.views,
                                viewToDelete
                            ] : v.views,
                            viewSets: v.viewSets?.map((vSet)=>({
                                    ...vSet,
                                    views: vSet.id === viewSet.id ? [
                                        ...vSet.views,
                                        viewToDelete
                                    ] : vSet.views
                                }))
                        }))
                });
            }
        }
    };
const $38b16db257c511c7$export$59843b4833b739ab = (id)=>({ getState: getState, dispatch: dispatch }, props)=>{
        const state = getState();
        const viewAri = (0, $jDdjf.createViewAri)(props.cloudId, id.toString());
        const viewToDelete = (0, $7DWfj.createGetViewByAri)(viewAri)(state);
        const currentViewId = (0, $7DWfj.getCurrentViewId)(state, props);
        if (!viewToDelete?.id) return {
            isCurrentView: false
        };
        dispatch($38b16db257c511c7$export$443d89549b135c95(viewToDelete.id, true));
        return {
            isCurrentView: currentViewId === viewToDelete.id
        };
    };

});
parcelRegister("Mrqhh", function(module, exports) {

$parcel$export(module.exports, "updateState", () => $d080cc7f30e4e52a$export$4971331372cec95a);
$parcel$export(module.exports, "createSection", () => $d080cc7f30e4e52a$export$f3a183bf2efcc835);
$parcel$export(module.exports, "saveSection", () => $d080cc7f30e4e52a$export$49a6d8e410a3c29);
$parcel$export(module.exports, "deleteSection", () => $d080cc7f30e4e52a$export$f79b8f1a1f301f41);
$parcel$export(module.exports, "deleteSectionFromState", () => $d080cc7f30e4e52a$export$6ea474f01b25717c);
$parcel$export(module.exports, "loadSection", () => $d080cc7f30e4e52a$export$f080c6c55896f739);

var $8oKDI = parcelRequire("8oKDI");

var $gCeeo = parcelRequire("gCeeo");

var $jDdjf = parcelRequire("jDdjf");

var $e1eg1 = parcelRequire("e1eg1");

var $8UUZn = parcelRequire("8UUZn");

var $hsfc2 = parcelRequire("hsfc2");

var $1lXcs = parcelRequire("1lXcs");
const $d080cc7f30e4e52a$export$4971331372cec95a = ({ id: id, newId: newId = null, name: name, collapsed: collapsed })=>async ({ getState: getState, setState: setState })=>{
        const { viewSets: viewSets } = (0, $8UUZn.updateViewSetState)(getState().viewSets, (viewSet)=>viewSet.id === id, (viewSet)=>{
            const newViewSet = {
                ...viewSet
            };
            newId && Object.assign(newViewSet, {
                id: newId
            });
            name !== undefined && Object.assign(newViewSet, {
                name: name
            });
            collapsed !== undefined && Object.assign(newViewSet, {
                collapsed: collapsed
            });
            return newViewSet;
        });
        setState({
            viewSets: viewSets
        });
    };
const $d080cc7f30e4e52a$var$viewsetRankList = (viewSet)=>{
    const viewRanks = viewSet.views.map((view)=>view.rank);
    if (viewSet.viewSets === undefined) return viewRanks;
    return [
        ...viewRanks,
        ...viewSet.viewSets.map((viewset)=>viewset.rank)
    ];
};
const $d080cc7f30e4e52a$var$nextRankInViewset = (viewSet)=>{
    const rankList = $d080cc7f30e4e52a$var$viewsetRankList(viewSet);
    return 1 + rankList.reduce((a, b)=>Math.max(a, b), rankList.length);
};
const $d080cc7f30e4e52a$export$f3a183bf2efcc835 = ()=>async ({ getState: getState, setState: setState })=>{
        const { viewSets: viewSets } = getState();
        const prioritizeViewSet = (0, $hsfc2.findViewSet)(viewSets, (v)=>v.type === 'PRIORITIZE');
        if (prioritizeViewSet) {
            const viewSet = {
                name: '',
                id: (0, $8oKDI.createAri)({
                    resourceOwner: 'polaris',
                    cloudId: 'tmp',
                    resourceType: 'polaris-viewset-tmp',
                    resourceId: `${prioritizeViewSet.id + Math.random() * 1000}`
                }),
                type: 'SECTION',
                collapsed: false,
                rank: $d080cc7f30e4e52a$var$nextRankInViewset(prioritizeViewSet),
                views: []
            };
            const updatedViewSet = viewSets.map((v)=>{
                if (v.id === prioritizeViewSet.id) return {
                    ...v,
                    viewSets: [
                        ...prioritizeViewSet.viewSets || [],
                        viewSet
                    ]
                };
                return v;
            });
            setState({
                viewSets: updatedViewSet
            });
        }
    };
const $d080cc7f30e4e52a$export$49a6d8e410a3c29 = ({ id: id, name: name, collapsed: collapsed, isReadOnly: isReadOnly = false })=>async ({ getState: getState, dispatch: dispatch }, { viewRemote: viewRemote, onViewUpdateFailed: onViewUpdateFailed, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { viewSets: viewSets } = getState();
        const prioritizeViewSet = (0, $hsfc2.findViewSet)(viewSets, (v)=>v.type === 'PRIORITIZE');
        if (prioritizeViewSet) try {
            if (id.includes('polaris-viewset-tmp') && name !== undefined) {
                dispatch($d080cc7f30e4e52a$export$4971331372cec95a({
                    id: id,
                    name: name,
                    collapsed: collapsed
                }));
                if (!isReadOnly) {
                    const { viewSetId: viewSetId } = await viewRemote.createViewSet({
                        projectAri: prioritizeViewSet.id,
                        name: name
                    });
                    dispatch($d080cc7f30e4e52a$export$4971331372cec95a({
                        id: id,
                        name: name,
                        collapsed: collapsed,
                        newId: viewSetId
                    }));
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSection created', {
                        viewSectionId: viewSetId
                    });
                }
            } else {
                dispatch($d080cc7f30e4e52a$export$4971331372cec95a({
                    id: id,
                    name: name,
                    collapsed: collapsed
                }));
                const ari = (0, $8oKDI.toAri)(id);
                if (ari && !isReadOnly) {
                    await viewRemote.updateViewSet({
                        name: name,
                        viewSetId: ari
                    });
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSection updated', {
                        updatedItems: [
                            {
                                name: 'name'
                            }
                        ],
                        viewSectionId: id
                    });
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $e1eg1.logViewError)('actions.sections.save', Object.assign(error));
            onViewUpdateFailed(error);
        }
    };
const $d080cc7f30e4e52a$export$f79b8f1a1f301f41 = (id, updateStateOnly = false)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote, onViewUpdateFailed: onViewUpdateFailed, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { viewSets: viewSets } = getState();
        const prioritizeViewSet = (0, $hsfc2.findViewSet)(viewSets, (v)=>v.type === 'PRIORITIZE');
        if (prioritizeViewSet) try {
            const updatedViewSet = viewSets.map((v)=>{
                if (v.id === prioritizeViewSet.id) return {
                    ...v,
                    viewSets: (prioritizeViewSet.viewSets || []).filter((vs)=>vs.id !== id)
                };
                return v;
            });
            setState({
                viewSets: updatedViewSet
            });
            if (!id.includes('polaris-viewset-tmp') && !updateStateOnly) {
                await viewRemote.deleteViewSet(id);
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSection deleted', {
                    viewSectionId: id
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $e1eg1.logViewError)('actions.sections.save', Object.assign(error));
            onViewUpdateFailed(error);
        }
    };
const $d080cc7f30e4e52a$export$6ea474f01b25717c = (id)=>({ dispatch: dispatch }, props)=>{
        const viewSetAri = (0, $jDdjf.createViewSetAri)(props.cloudId, id.toString());
        dispatch($d080cc7f30e4e52a$export$f79b8f1a1f301f41(viewSetAri, true));
    };
const $d080cc7f30e4e52a$export$f080c6c55896f739 = (viewSetId, shouldUpdate = false)=>async ({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const { viewRemote: viewRemote, onViewUpdateFailed: onViewUpdateFailed } = props;
        const { viewSets: viewSets } = state;
        const viewSetAri = (0, $jDdjf.createViewSetAri)(props.cloudId, viewSetId.toString());
        const existingViewSet = (0, $hsfc2.findViewSet)(viewSets, ({ id: id })=>id === viewSetAri);
        if (existingViewSet !== undefined && !shouldUpdate) return;
        try {
            const result = await viewRemote.fetchViewSets();
            const prioritizeViewSet = result.viewsets.find(({ type: type })=>type === 'PRIORITIZE');
            const newViewSet = prioritizeViewSet?.viewsets.find(({ id: id })=>viewSetAri === id);
            if (!newViewSet) return;
            const updatedViewSet = getState().viewSets.map((rootViewSet)=>{
                if (rootViewSet.type !== 'PRIORITIZE') return rootViewSet;
                return {
                    ...rootViewSet,
                    viewSets: (0, $1lXcs.upsertViewSet)(rootViewSet.viewSets || [], {
                        ...newViewSet,
                        type: 'SECTION',
                        collapsed: false,
                        views: []
                    })
                };
            });
            setState({
                viewSets: updatedViewSet
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onViewUpdateFailed(error);
        }
    };

});
parcelRegister("8UUZn", function(module, exports) {

$parcel$export(module.exports, "updateViewSetState", () => $ea2074f240ef67bd$export$864a35a23a3b40cd);
const $ea2074f240ef67bd$export$864a35a23a3b40cd = (currentViewSets, predicate, mutation)=>{
    let changedViewSet;
    const newViewSets = currentViewSets.map((element)=>{
        const viewSets = (element.viewSets || []).map((vSet)=>{
            if (predicate(vSet)) {
                changedViewSet = mutation(vSet);
                return changedViewSet;
            }
            return vSet;
        });
        return {
            ...element,
            viewSets: viewSets
        };
    });
    return {
        changedViewSet: changedViewSet,
        viewSets: newViewSets
    };
};

});

parcelRegister("1lXcs", function(module, exports) {

$parcel$export(module.exports, "upsertViewSet", () => $cf1a521c00a71359$export$3e92b78b5ca60441);
const $cf1a521c00a71359$export$3e92b78b5ca60441 = (viewSets, newViewSet)=>{
    let isExisting = false;
    const updatedViewSets = viewSets.map((viewSet)=>{
        if (viewSet.id === newViewSet.id) {
            isExisting = true;
            return {
                ...newViewSet,
                views: viewSet.views,
                collapsed: viewSet.collapsed
            };
        }
        return viewSet;
    });
    return isExisting ? updatedViewSets : [
        ...updatedViewSets,
        newViewSet
    ];
};

});


parcelRegister("9vY0e", function(module, exports) {

$parcel$export(module.exports, "getUniversalViewId", () => $c791528e7561728a$export$dc8c70b6e4faaf78);

var $gtr2v = parcelRequire("gtr2v");
const $c791528e7561728a$export$dc8c70b6e4faaf78 = (view)=>{
    if (view.viewId) // `viewId` contains the correct identifier for both:
    // - Projects & Collections.
    //
    // Project's viewId will look like:
    // - `ari:cloud:jira:d8c41c27-ad95-40f9-9e69-2497900efdbe:view/1052268`
    //
    // while collection's view will look like:
    // `ari:cloud:jira:d8c41c27-ad95-40f9-9e69-2497900efdbe:view/3a6710d6-ffb4-4e19-8a92-a7012d8a777f`
    //
    // By parsing `ari` and taking `resourceId` we will always get correct `viewId`
    return (0, $gtr2v.AnyAri).parse(view.viewId).resourceId;
    return undefined;
};

});


parcelRegister("hOj1o", function(module, exports) {

$parcel$export(module.exports, "createUpdateErrorMessageLogSafe", () => $1961d713fb291378$export$82a970540cebda41);
const $1961d713fb291378$var$getChangedProperties = (view, remoteView)=>{
    const changed = [];
    for(const property in remoteView)// @ts-expect-error - TS7053
    if (JSON.stringify(view[property]) !== JSON.stringify(remoteView[property])) changed.push(property);
    return changed;
};
const $1961d713fb291378$var$getInterestingProps = (props)=>({
        isSharedView: props.isSharedView,
        hasNoProjectPermissions: props.hasNoProjectPermissions,
        hasManageViewsPermission: props.hasManageViewsPermission
    });
const $1961d713fb291378$export$82a970540cebda41 = (view, remoteView, props)=>`props: ${JSON.stringify($1961d713fb291378$var$getInterestingProps(props))} changed: ${JSON.stringify($1961d713fb291378$var$getChangedProperties(view, remoteView))}`;

});



parcelRegister("jJQVE", function(module, exports) {

$parcel$export(module.exports, "cloneCurrentView", () => $485ef070045cef0d$export$8ae07600cab4fe4f);
$parcel$export(module.exports, "cloneView", () => $485ef070045cef0d$export$de60ce8ef9a4993b);
$parcel$export(module.exports, "saveCurrentUnsavedViewAsNew", () => $485ef070045cef0d$export$8adc7d2e276aef41);

var $8dH3d = parcelRequire("8dH3d");

var $iPZok = parcelRequire("iPZok");


var $6SinZ = parcelRequire("6SinZ");

var $gCeeo = parcelRequire("gCeeo");

var $1vVGo = parcelRequire("1vVGo");

var $7DWfj = parcelRequire("7DWfj");


var $hJWAv = parcelRequire("hJWAv");

var $ee86w = parcelRequire("ee86w");

var $hpem9 = parcelRequire("hpem9");

var $2Qu2F = parcelRequire("2Qu2F");

var $e1eg1 = parcelRequire("e1eg1");

var $hsfc2 = parcelRequire("hsfc2");
const $485ef070045cef0d$var$addFieldIfNotExists = (fields, fieldKey)=>{
    if (fieldKey === undefined) return;
    const fieldExists = fields.some((existingFieldKey)=>existingFieldKey === fieldKey);
    if (!fieldExists) fields.push(fieldKey);
};
const $485ef070045cef0d$var$createNewView = (currentView, kind, currentViewSet, groupByField)=>{
    const view = {
        ...currentView,
        kind: kind,
        id: `${currentView.id + Math.random() * 5}`,
        title: (0, $iPZok.makeNewTitle)(currentView.title),
        editable: true,
        modified: true,
        saving: false,
        saveError: undefined,
        isEditingTitle: true,
        groupBy: undefined,
        verticalGroupBy: undefined,
        hideEmptyGroups: false,
        hideEmptyColumns: false,
        fields: [
            ...currentView.fields
        ],
        viewId: undefined,
        viewLegacyId: undefined,
        rank: currentViewSet.views.length + 1,
        bulkEditHoveredFieldKey: undefined,
        matrixConfig: undefined,
        timelineConfig: undefined,
        emoji: undefined,
        groupValues: [],
        verticalGroupValues: [],
        isAutosaveEnabled: true
    };
    if ([
        (0, $6SinZ.VIEW_KIND_BOARD),
        (0, $6SinZ.VIEW_KIND_TABLE)
    ].includes(currentView.kind) && [
        (0, $6SinZ.VIEW_KIND_BOARD),
        (0, $6SinZ.VIEW_KIND_TABLE)
    ].includes(kind)) {
        view.groupBy = groupByField ?? currentView.groupBy;
        view.groupValues = currentView.groupValues;
        view.verticalGroupBy = currentView.verticalGroupBy;
        view.verticalGroupValues = currentView.verticalGroupValues;
        if (currentView.verticalGroupBy !== undefined) $485ef070045cef0d$var$addFieldIfNotExists(view.fields, currentView.verticalGroupBy);
    }
    const { matrixConfig: matrixConfig } = currentView;
    if (currentView.kind === (0, $6SinZ.VIEW_KIND_MATRIX) && matrixConfig !== undefined) {
        if (kind === (0, $6SinZ.VIEW_KIND_TABLE) || kind === (0, $6SinZ.VIEW_KIND_BOARD)) matrixConfig.axes?.forEach((axis)=>{
            $485ef070045cef0d$var$addFieldIfNotExists(view.fields, axis.field?.key);
        });
        else if (kind === (0, $6SinZ.VIEW_KIND_MATRIX)) view.matrixConfig = {
            axes: [
                ...matrixConfig.axes
            ]
        };
    }
    const { timelineConfig: timelineConfig } = currentView;
    if (currentView.kind === (0, $6SinZ.VIEW_KIND_TIMELINE) && timelineConfig !== undefined) {
        view.verticalGroupBy = currentView.verticalGroupBy;
        view.verticalGroupValues = currentView.verticalGroupValues;
        // markers shouldn't be copied when cloning a timeline
        view.markers = [];
        if (kind === (0, $6SinZ.VIEW_KIND_TABLE) || kind === (0, $6SinZ.VIEW_KIND_BOARD)) [
            timelineConfig?.startDateField,
            timelineConfig?.dueDateField
        ].forEach((field)=>{
            if (field?.key) $485ef070045cef0d$var$addFieldIfNotExists(view.fields, field.key);
        });
        else if (kind === (0, $6SinZ.VIEW_KIND_TIMELINE)) view.timelineConfig = {
            ...timelineConfig
        };
    }
    view.draft = (0, $2Qu2F.getAutosaveAffectedViewConfigurations)(view);
    if (view.kind !== (0, $6SinZ.VIEW_KIND_MATRIX)) view.hideEmptyGroups = currentView.hideEmptyGroups;
    if (view.kind === (0, $6SinZ.VIEW_KIND_BOARD) && currentView.kind === (0, $6SinZ.VIEW_KIND_BOARD)) view.hideEmptyColumns = currentView.hideEmptyColumns;
    return view;
};
const $485ef070045cef0d$var$updateState = (currentViewSet, view, { getState: getState, setState: setState })=>{
    const updatedViewSets = getState().viewSets.map((viewSet)=>({
            ...viewSet,
            views: viewSet.id === currentViewSet.id ? [
                ...viewSet.views,
                view
            ] : viewSet.views,
            viewSets: viewSet?.viewSets?.map((vSet)=>({
                    ...vSet,
                    views: vSet.id === currentViewSet.id ? [
                        ...vSet.views,
                        view
                    ] : vSet.views
                }))
        }));
    setState({
        viewSets: updatedViewSets
    });
};
const $485ef070045cef0d$export$6c0a4eb5c24ff427 = ({ viewRemote: viewRemote, rankingRemote: rankingRemote, router: router, onViewUpdateFailed: onViewUpdateFailed })=>(savedView)=>{
        const remoteRequests = [];
        if (savedView?.sortMode === (0, $f3f1bd644cfe4e35$export$a95cb1c0dd162f95) && savedView?.viewId !== undefined) remoteRequests.push(rankingRemote.create({
            listId: savedView.viewId,
            items: savedView.issueRanking || []
        }).catch(onViewUpdateFailed));
        if (savedView?.kind === (0, $6SinZ.VIEW_KIND_TIMELINE)) {
            const currentArrangementInfo = savedView.timelineConfig?.arrangementInformation;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(currentArrangementInfo) && savedView.viewId !== undefined) remoteRequests.push(viewRemote.updateArrangementInfo({
                viewId: savedView.viewId,
                arrangement: JSON.stringify(currentArrangementInfo)
            }).catch((error)=>{
                (0, $e1eg1.logViewError)('apply-current-arrangement', error);
                onViewUpdateFailed(error);
            }));
        }
        if (savedView !== undefined) router.routeTo({
            section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
            resource: savedView.slug
        });
        return Promise.all(remoteRequests);
    };
const $485ef070045cef0d$var$cloneGivenView = (view, kind, groupByField, api, props, onSuccess, onError)=>{
    const viewSet = (0, $hsfc2.findViewSet)(api.getState().viewSets, (v)=>v.id === view.viewSetId);
    if (!viewSet) return;
    const clone = $485ef070045cef0d$var$createNewView(view, kind, viewSet, groupByField);
    $485ef070045cef0d$var$updateState(viewSet, clone, api);
    return api.dispatch((0, $hpem9.saveView)(clone.id, (savedView)=>{
        if (savedView?.saveError) onError?.(savedView.saveError);
        else {
            $485ef070045cef0d$export$6c0a4eb5c24ff427(props)(savedView).then(onSuccess).catch(onError);
            if (savedView) {
                const analyticsData = (0, $7DWfj.extractViewAnalyticsData)(savedView);
                (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({
                    containers: analyticsData?.containers
                }), 'view created', {
                    createdFrom: view.viewId,
                    ...analyticsData?.attributes
                });
                api.dispatch((0, $ee86w.loadViewDescription)(String(savedView.viewId), true));
            }
        }
    }));
};
const $485ef070045cef0d$export$8ae07600cab4fe4f = (kind, groupByField, onSuccess, onError)=>async (api, props)=>{
        const currentView = (0, $1vVGo.getCurrentView)({
            ...api.getState()
        }, props);
        currentView && $485ef070045cef0d$var$cloneGivenView(currentView, kind, groupByField, api, props, onSuccess, onError);
    };
const $485ef070045cef0d$export$de60ce8ef9a4993b = (id, kind, onSuccess, onError)=>async (api, props)=>{
        const view = (0, $hsfc2.findView)(api.getState().viewSets, (v)=>v.id === id);
        const descriptionIsLoaded = view?.descriptionLoadingStatus === (0, $6SinZ.PROPERTY_LOADING_STATE).LOADED;
        if (!descriptionIsLoaded) {
            await api.dispatch((0, $ee86w.loadViewDescription)(String(view?.viewId)));
            const viewUpdated = (0, $hsfc2.findView)(api.getState().viewSets, (v)=>v.id === id);
            viewUpdated && $485ef070045cef0d$var$cloneGivenView(viewUpdated, kind, undefined, api, props, onSuccess, onError);
        } else view && $485ef070045cef0d$var$cloneGivenView(view, kind, undefined, api, props, onSuccess, onError);
    };
const $485ef070045cef0d$export$8adc7d2e276aef41 = ()=>(api, props)=>{
        const currentView = (0, $1vVGo.getCurrentView)({
            ...api.getState()
        }, props);
        if (currentView) {
            api.dispatch((0, $hJWAv.resetDraft)(currentView.viewId));
            $485ef070045cef0d$var$cloneGivenView((0, $2Qu2F.applyDraftToView)(currentView), currentView.kind, undefined, api, props);
        }
    };

});
parcelRegister("iPZok", function(module, exports) {

$parcel$export(module.exports, "updateProjectState", () => $7dcf348b1498f39e$export$bb40ae6a02942a3a);
$parcel$export(module.exports, "modifyView", () => $7dcf348b1498f39e$export$d47a9f66421ac6ac);
$parcel$export(module.exports, "findViewBy", () => $7dcf348b1498f39e$export$9e84431b7511903a);
$parcel$export(module.exports, "findView", () => $7dcf348b1498f39e$export$788469894fae0ba2);
$parcel$export(module.exports, "transformRemoteView", () => $7dcf348b1498f39e$export$8a96915f5142e7ef);
$parcel$export(module.exports, "createFakeId", () => $7dcf348b1498f39e$export$999fd399aac8ece2);
$parcel$export(module.exports, "isFakeId", () => $7dcf348b1498f39e$export$3f040eb4c68fedd0);
$parcel$export(module.exports, "makeNewTitle", () => $7dcf348b1498f39e$export$e06c4d163e5a74cb);

var $aXKmr = parcelRequire("aXKmr");

var $ag9Yx = parcelRequire("ag9Yx");
const $7dcf348b1498f39e$export$bb40ae6a02942a3a = (state, projectId, projectState)=>({
        ...state,
        projects: {
            ...state.projects,
            [projectId]: {
                ...state.projects[projectId],
                ...projectState
            }
        }
    });
const $7dcf348b1498f39e$export$d47a9f66421ac6ac = (state, projectId, modify)=>$7dcf348b1498f39e$export$bb40ae6a02942a3a(state, projectId, {
        views: state.projects[projectId].views.map((view)=>{
            const newView = modify(view);
            if (newView === view && view.views) return {
                ...newView,
                views: view.views?.map(modify)
            };
            return newView;
        })
    });
const $7dcf348b1498f39e$export$9e84431b7511903a = (projectState, by)=>{
    let found = projectState.views.find((view)=>by(view));
    if (!found) {
        let parent;
        projectState.views.some((view)=>{
            if (view.views) return view.views.some((innerView)=>{
                if (by(innerView)) {
                    found = innerView;
                    parent = view;
                    return true;
                }
                return false;
            });
            return false;
        });
        return {
            view: found,
            parent: parent
        };
    }
    return {
        view: found,
        parent: undefined
    };
};
const $7dcf348b1498f39e$export$788469894fae0ba2 = (projectState, localId)=>$7dcf348b1498f39e$export$9e84431b7511903a(projectState, (view)=>view.localId === localId);
const $7dcf348b1498f39e$export$8a96915f5142e7ef = (remoteView)=>({
        ...remoteView,
        views: remoteView.views?.map($7dcf348b1498f39e$export$8a96915f5142e7ef),
        localId: (0, $aXKmr.v4)(),
        isExpanded: false
    });
const $7dcf348b1498f39e$var$FAKE_ID_PREFIX = 'fake';
const $7dcf348b1498f39e$export$999fd399aac8ece2 = (name)=>`${$7dcf348b1498f39e$var$FAKE_ID_PREFIX}-${name}-${(0, $aXKmr.v4)()}`;
const $7dcf348b1498f39e$export$3f040eb4c68fedd0 = (id)=>id.startsWith($7dcf348b1498f39e$var$FAKE_ID_PREFIX);
const $7dcf348b1498f39e$export$e06c4d163e5a74cb = (titleSeed)=>{
    const suffix = ' Copy';
    return titleSeed !== undefined ? `${titleSeed.substr(0, (0, $ag9Yx.VIEW_NAME_MAX_LENGTH) - suffix.length)}${suffix}` : 'New View';
};

});
parcelRegister("ag9Yx", function(module, exports) {

$parcel$export(module.exports, "CONTAINER", () => $134d18b31ef93c15$export$33d8c916a600c5e9);
$parcel$export(module.exports, "VIEW_NAME_MAX_LENGTH", () => $134d18b31ef93c15$export$27ce0e417db39a5c);
const $134d18b31ef93c15$export$33d8c916a600c5e9 = {
    PROJECT: 'PROJECT',
    SECTION: 'SECTION',
    COLLECTION: 'COLLECTION'
};
const $134d18b31ef93c15$export$27ce0e417db39a5c = 100;

});


parcelRegister("ee86w", function(module, exports) {

$parcel$export(module.exports, "loadViewDescription", () => $0b0dd56f3ae4d944$export$cc0ab9799685fd68);

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $1itML = parcelRequire("1itML");

var $6SinZ = parcelRequire("6SinZ");

var $7DWfj = parcelRequire("7DWfj");

var $gJX7c = parcelRequire("gJX7c");
const $0b0dd56f3ae4d944$export$cc0ab9799685fd68 = (viewId, forceRefresh = false)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote })=>{
        const currentView = (0, $7DWfj.createGetViewByAri)(viewId)(getState());
        const descriptionIsLoaded = currentView?.descriptionLoadingStatus === (0, $6SinZ.PROPERTY_LOADING_STATE).LOADED;
        const descriptionIsLoading = currentView?.descriptionLoadingStatus === (0, $6SinZ.PROPERTY_LOADING_STATE).LOADING;
        if (!forceRefresh && descriptionIsLoaded) // don't load description if we already have them
        return;
        if (descriptionIsLoading) // don't load description if it is currently already loading
        return;
        const { viewSets: viewSetsAfterUpdate } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, (view)=>({
                ...view,
                descriptionLoadingStatus: (0, $6SinZ.PROPERTY_LOADING_STATE).LOADING
            }));
        setState({
            viewSets: viewSetsAfterUpdate
        });
        if (viewRemote.fetchViewDescription !== undefined) try {
            const data = await viewRemote.fetchViewDescription(viewId);
            const { changedView: changedView, viewSets: viewSetsAfterCreation } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, (view)=>({
                    ...view,
                    description: data?.description,
                    descriptionLoadingStatus: (0, $6SinZ.PROPERTY_LOADING_STATE).LOADED
                }));
            if (changedView) setState({
                viewSets: viewSetsAfterCreation
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.views.actions.description.load-view-description', error));
            // remove loading state
            const { viewSets: viewSetsAfterErrorUpdate } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, (view)=>({
                    ...view,
                    descriptionLoadingStatus: (0, $6SinZ.PROPERTY_LOADING_STATE).ERROR
                }));
            setState({
                viewSets: viewSetsAfterErrorUpdate
            });
            if (!(error instanceof (0, $1itML.ViewNotFoundError))) throw error;
        }
    };

});


parcelRegister("jhZdK", function(module, exports) {

$parcel$export(module.exports, "resizeFieldColumn", () => $ea62765a69a7f515$export$ee0db1ad3abe970c);
$parcel$export(module.exports, "setHoveredFieldKeyForBulkEdit", () => $ea62765a69a7f515$export$584fe6a122878b1);

var $eHEbM = parcelRequire("eHEbM");

var $HXbds = parcelRequire("HXbds");

var $3xiug = parcelRequire("3xiug");

var $hpem9 = parcelRequire("hpem9");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $ea62765a69a7f515$export$ee0db1ad3abe970c = (id, fieldKey, size)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.id === id, (view)=>{
            const fieldColIdx = (0, (/*@__PURE__*/$parcel$interopDefault($eHEbM)))([
                'fieldKey',
                fieldKey
            ], view.tableColumnSizes);
            const tableColumnSizes = (0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))([], 'tableColumnSizes', view);
            const fieldSizeObj = {
                fieldKey: fieldKey,
                size: size
            };
            let newTableColumnSizes = [];
            if (fieldColIdx !== -1) newTableColumnSizes = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))(fieldColIdx, fieldSizeObj, tableColumnSizes);
            else newTableColumnSizes = [
                ...tableColumnSizes,
                fieldSizeObj
            ];
            return {
                ...view,
                tableColumnSizes: newTableColumnSizes,
                modified: true
            };
        });
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveView)(changedView.id));
        }
    };
const $ea62765a69a7f515$export$584fe6a122878b1 = (bulkEditHoveredFieldKey)=>({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                bulkEditHoveredFieldKey: bulkEditHoveredFieldKey
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };

});
parcelRegister("eHEbM", function(module, exports) {

var $dyMwB = parcelRequire("dyMwB");

var $ab4441908a434f85$var$func = $dyMwB('findIndex', (parcelRequire("gyBpf")));

$ab4441908a434f85$var$func.placeholder = (parcelRequire("k1T10"));
module.exports = $ab4441908a434f85$var$func;

});

parcelRegister("HXbds", function(module, exports) {

var $dyMwB = parcelRequire("dyMwB");

var $0841ec29cdb206d8$var$func = $dyMwB('getOr', (parcelRequire("9Dhvc")));

$0841ec29cdb206d8$var$func.placeholder = (parcelRequire("k1T10"));
module.exports = $0841ec29cdb206d8$var$func;

});

parcelRegister("3xiug", function(module, exports) {

var $dyMwB = parcelRequire("dyMwB");

var $2932cb5717fdaad1$var$func = $dyMwB('set', (parcelRequire("d3vFW")));

$2932cb5717fdaad1$var$func.placeholder = (parcelRequire("k1T10"));
module.exports = $2932cb5717fdaad1$var$func;

});


parcelRegister("8bBCP", function(module, exports) {

$parcel$export(module.exports, "seenViewComments", () => $02a0da6f38e2c4f7$export$974ad8b7c4e22bbe);
$parcel$export(module.exports, "createViewComment", () => $02a0da6f38e2c4f7$export$950d2d55f4d5f55b);
$parcel$export(module.exports, "updateViewComment", () => $02a0da6f38e2c4f7$export$d9db0659d1273a74);
$parcel$export(module.exports, "deleteViewComment", () => $02a0da6f38e2c4f7$export$a0ffc04b3a4c320b);

var $8oKDI = parcelRequire("8oKDI");

var $hpem9 = parcelRequire("hpem9");

var $gJX7c = parcelRequire("gJX7c");

var $8BCIS = parcelRequire("8BCIS");

var $8pL9X = parcelRequire("8pL9X");
const $02a0da6f38e2c4f7$export$974ad8b7c4e22bbe = (viewId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const lastCommentsViewedTimestamp = Date.now();
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, (view)=>({
                ...view,
                modified: true,
                lastCommentsViewedTimestamp: lastCommentsViewedTimestamp
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveView)(changedView.id));
        }
    };
const $02a0da6f38e2c4f7$export$950d2d55f4d5f55b = (viewIdString, content)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { viewRemote: viewRemote, onViewUpdateFailed: onViewUpdateFailed })=>{
        if (viewRemote.createViewComment !== undefined) {
            const viewId = (0, $8oKDI.toAri)(viewIdString);
            if (viewId === undefined) throw new Error(`view argument must be a polaris view ARI, not "${viewIdString}"`);
            try {
                const result = await viewRemote.createViewComment({
                    viewId: viewId,
                    content: content
                });
                // throw new Error(`TODO createViewComment "${viewIdString}" -> ${viewId}`);
                const lastCommentsViewedTimestamp = Date.now();
                const { currentView: currentView, changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.viewId === viewId, (view)=>({
                        ...view,
                        modified: true,
                        fetchCommentsTimestamp: undefined,
                        comments: [
                            (0, $8pL9X.internViewComment)(result),
                            ...view.comments || []
                        ],
                        lastCommentsViewedTimestamp: lastCommentsViewedTimestamp
                    }));
                if (currentView?.viewId !== undefined && currentView?.fetchCommentsTimestamp !== undefined) dispatch((0, $8BCIS.loadViewComments)(currentView.viewId, true));
                if (changedView) {
                    setState({
                        viewSets: viewSets
                    });
                    dispatch((0, $hpem9.saveView)(changedView.id));
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Unknown error');
                onViewUpdateFailed(error);
            }
        }
    };
const $02a0da6f38e2c4f7$export$d9db0659d1273a74 = (commentIdString, update)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { viewRemote: viewRemote })=>{
        if (viewRemote.updateViewComment !== undefined) {
            const commentId = (0, $8oKDI.toAri)(commentIdString);
            if (commentId === undefined) throw new Error(`comment argument must be a polaris comment ARI, not "${commentIdString}"`);
            const result = await viewRemote.updateViewComment({
                commentId: commentId,
                update: update
            });
            const updatedComment = (0, $8pL9X.internViewComment)(result);
            const { currentView: currentView, changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>!!view.comments?.find((comment)=>comment.id === commentId), (view)=>({
                    ...view,
                    fetchCommentsTimestamp: undefined,
                    comments: (view.comments || []).map((comment)=>comment.id === commentId ? updatedComment : comment)
                }));
            if (currentView?.viewId !== undefined && currentView?.fetchCommentsTimestamp !== undefined) dispatch((0, $8BCIS.loadViewComments)(currentView.viewId, true));
            if (changedView) setState({
                viewSets: viewSets
            });
        }
    };
const $02a0da6f38e2c4f7$export$a0ffc04b3a4c320b = (commentIdString)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { viewRemote: viewRemote })=>{
        if (viewRemote.deleteViewComment !== undefined) {
            const commentId = (0, $8oKDI.toAri)(commentIdString);
            if (commentId === undefined) throw new Error(`comment argument must be a polaris comment ARI, not "${commentIdString}"`);
            await viewRemote.deleteViewComment(commentId);
            const { currentView: currentView, changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>!!view.comments?.find((comment)=>comment.id === commentId), (view)=>({
                    ...view,
                    fetchCommentsTimestamp: undefined,
                    comments: (view.comments || []).filter((comment)=>comment.id !== commentId)
                }));
            if (currentView?.viewId !== undefined && currentView?.fetchCommentsTimestamp !== undefined) dispatch((0, $8BCIS.loadViewComments)(currentView.viewId, true));
            if (changedView) setState({
                viewSets: viewSets
            });
        }
    };

});

parcelRegister("KnEQx", function(module, exports) {

$parcel$export(module.exports, "createNewView", () => $2d0f382d1dff0381$export$4f87dbce5a995529);

var $iPZok = parcelRequire("iPZok");

var $bHZrQ = parcelRequire("bHZrQ");

var $6SinZ = parcelRequire("6SinZ");

var $f38tt = parcelRequire("f38tt");

var $3Ku0X = parcelRequire("3Ku0X");

var $gCeeo = parcelRequire("gCeeo");

var $7DWfj = parcelRequire("7DWfj");


var $hpem9 = parcelRequire("hpem9");

var $2Qu2F = parcelRequire("2Qu2F");

var $hsfc2 = parcelRequire("hsfc2");
const $2d0f382d1dff0381$var$viewsetRankList = (viewSet)=>{
    const viewRanks = viewSet.views.map((view)=>view.rank);
    if (viewSet.viewSets === undefined) return viewRanks;
    return [
        ...viewRanks,
        ...viewSet.viewSets.map((viewset)=>viewset.rank)
    ];
};
const $2d0f382d1dff0381$var$nextRankInViewset = (viewSet)=>{
    const rankList = $2d0f382d1dff0381$var$viewsetRankList(viewSet);
    return 1 + rankList.reduce((a, b)=>Math.max(a, b), rankList.length);
};
const $2d0f382d1dff0381$export$4f87dbce5a995529 = (kind, parentId, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { viewSets: viewSets } = getState();
        const { router: router, isCollectionView: isCollectionView } = props;
        // currently we can only create views within the PRIORITIZE viewSet - in the future the action should take the viewset id as a parameter
        const prioritizeViewSet = (0, $hsfc2.findViewSet)(viewSets, (v)=>v.type === 'PRIORITIZE');
        const containerViewSet = parentId === undefined ? prioritizeViewSet : (0, $hsfc2.findViewSet)(viewSets, (vs)=>vs.id === parentId);
        if (prioritizeViewSet && containerViewSet) {
            const viewSetId = parentId ?? prioritizeViewSet.id;
            const view = (0, $hsfc2.createNewViewEntity)(viewSetId, kind, (0, $iPZok.makeNewTitle)(), $2d0f382d1dff0381$var$nextRankInViewset(containerViewSet), isCollectionView || false);
            if (kind === (0, $6SinZ.VIEW_KIND_TIMELINE)) {
                view.layoutType = (0, $f38tt.ViewLayoutType).SUMMARY;
                view.timelineConfig = {
                    startDateField: undefined,
                    dueDateField: undefined,
                    mode: (0, $bHZrQ.PolarisTimelineMode).QUARTERS,
                    startTimestamp: undefined,
                    endTimestamp: undefined,
                    arrangementInformation: {},
                    summaryCardField: undefined
                };
            }
            view.draft = (0, $2Qu2F.getAutosaveAffectedViewConfigurations)(view);
            const updatedViewSet = viewSets.map((v)=>{
                if (v.id === prioritizeViewSet.id) return {
                    ...v,
                    views: viewSetId === prioritizeViewSet.id ? [
                        ...prioritizeViewSet.views || [],
                        view
                    ] : prioritizeViewSet.views,
                    viewSets: prioritizeViewSet.viewSets?.map((vSet)=>{
                        if (viewSetId === vSet.id) return {
                            ...vSet,
                            views: [
                                ...vSet.views || [],
                                view
                            ]
                        };
                        return vSet;
                    })
                };
                return v;
            });
            setState({
                viewSets: updatedViewSet
            });
            // Save it... and always make the cloned view the current view
            dispatch((0, $hpem9.saveView)(view.id, (savedView)=>{
                if (savedView !== undefined) {
                    if (savedView.saveError) onError?.(savedView.saveError);
                    else {
                        onSuccess?.();
                        const analyticsData = (0, $7DWfj.extractViewAnalyticsData)(savedView);
                        (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({
                            containers: analyticsData?.containers
                        }), 'view created', analyticsData?.attributes || {});
                        (0, $3Ku0X.sendPendoTrackEvent)({
                            actionSubjectAndAction: 'view created',
                            attributes: {
                                viewId: savedView.slug || ''
                            }
                        });
                    }
                    router.routeTo({
                        section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
                        resource: savedView.slug
                    });
                }
            }));
        }
    };

});

parcelRegister("fypYM", function(module, exports) {

$parcel$export(module.exports, "changeViewDescription", () => $a210a894d386f12a$export$8d23520868f9d94b);

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");

var $ee86w = parcelRequire("ee86w");
const $a210a894d386f12a$export$8d23520868f9d94b = (description, onSuccess, onError)=>({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                description: description,
                isEditingTitle: false,
                modified: true
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveView)(changedView.id, (view)=>{
                if (!view) {
                    onError && onError(new Error('No such view'));
                    return;
                }
                if (view.saveError && onError) {
                    onError(view?.saveError);
                    return;
                }
                if (onSuccess) onSuccess();
                (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                    updatedItems: [
                        {
                            name: 'description'
                        }
                    ]
                });
            }));
        }
    };

});
parcelRegister("dVuZs", function(module, exports) {

$parcel$export(module.exports, "fireViewUpdatedEvent", () => $7ec52d3f014be4ba$export$1c589faf88e5218c);

var $3Ku0X = parcelRequire("3Ku0X");

var $gCeeo = parcelRequire("gCeeo");

var $7DWfj = parcelRequire("7DWfj");
const $7ec52d3f014be4ba$var$getUpdatedItems = (items)=>items?.map(({ name: name, oldVal: oldVal, newVal: newVal })=>`name: ${name}, oldVal: ${oldVal}, newVal: ${newVal}`).join(', ') ?? '';
const $7ec52d3f014be4ba$export$1c589faf88e5218c = (createAnalyticsEvent, view, attributes)=>{
    const analyticsData = (0, $7DWfj.extractViewAnalyticsData)(view);
    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({
        containers: analyticsData?.containers
    }), 'view updated', {
        ...analyticsData?.attributes,
        ...attributes
    });
    (0, $3Ku0X.sendPendoTrackEvent)({
        actionSubjectAndAction: 'view updated',
        attributes: {
            updatedItems: $7ec52d3f014be4ba$var$getUpdatedItems(attributes.updatedItems)
        }
    });
};

});


parcelRegister("LFH9i", function(module, exports) {

$parcel$export(module.exports, "setRollupFieldsValue", () => $f24ef85e2a625f27$export$671b47e0287465f8);

var $hpem9 = parcelRequire("hpem9");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $f24ef85e2a625f27$export$671b47e0287465f8 = (fieldKey, rollup)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const viewMutation = (view)=>{
            const { isAutosaveEnabled: isAutosaveEnabled } = view;
            const fieldRollups = isAutosaveEnabled ? view.fieldRollups : view.draft.fieldRollups;
            const newFieldRollups = fieldRollups.filter((val)=>val.fieldKey !== fieldKey);
            if (rollup !== null) newFieldRollups.push({
                fieldKey: fieldKey,
                rollup: rollup
            });
            return {
                ...view,
                fieldRollups: isAutosaveEnabled ? newFieldRollups : view.fieldRollups,
                modified: isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    fieldRollups: newFieldRollups
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
        }
    };

});

parcelRegister("d7HT7", function(module, exports) {

$parcel$export(module.exports, "setViewColumns", () => $d172c71b7a245ff8$export$52ca09c81057a908);
$parcel$export(module.exports, "removeFieldFromView", () => $d172c71b7a245ff8$export$5d8cb7904eb9a3a1);
$parcel$export(module.exports, "updateViewField", () => $d172c71b7a245ff8$export$a9eb882dd6f1cd8f);
$parcel$export(module.exports, "sortViewField", () => $d172c71b7a245ff8$export$959c898c74bed5a1);
$parcel$export(module.exports, "toggleViewField", () => $d172c71b7a245ff8$export$2a281736894d3053);
$parcel$export(module.exports, "hideViewField", () => $d172c71b7a245ff8$export$f2dad5cb50d095b6);

var $1GmOk = parcelRequire("1GmOk");

var $3l9kN = parcelRequire("3l9kN");

var $cGzYX = parcelRequire("cGzYX");

var $6Mk0X = parcelRequire("6Mk0X");

var $7DWfj = parcelRequire("7DWfj");

var $mJiEA = parcelRequire("mJiEA");

var $9PAQN = parcelRequire("9PAQN");

var $4GgU4 = parcelRequire("4GgU4");

var $hpem9 = parcelRequire("hpem9");

var $2uYQG = parcelRequire("2uYQG");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $d172c71b7a245ff8$var$updateView = ({ fields: fields, hidden: hidden }, viewSelectorPredicate, onAfterSave)=>async ({ dispatch: dispatch, getState: getState, setState: setState }, props)=>{
        const predicate = viewSelectorPredicate !== undefined ? viewSelectorPredicate : (0, $hsfc2.currentViewFilter)(props.currentViewSlug);
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, predicate, (view)=>{
            const changedProperties = {
                ...fields ? {
                    fields: fields
                } : {},
                ...hidden ? {
                    hidden: hidden
                } : {}
            };
            return {
                ...view,
                ...view.isAutosaveEnabled ? changedProperties : {},
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    ...changedProperties
                }
            };
        });
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            const updatedItems = [];
            const hiddenLengthChanged = currentView?.hidden.length !== changedView?.hidden.length;
            const fieldsLengthChanged = currentView?.fields.length !== changedView?.fields.length;
            const fieldsReoredred = !hiddenLengthChanged && !fieldsLengthChanged;
            if ((0, $6Mk0X.getDeliveryDataFetchError)(getState()) && (0, $cGzYX.hasFieldKeyDependingOnDeliveryData)(changedView.fields, props.fields)) dispatch((0, $4GgU4.showStoredDeliveryDataFetchError)());
            if (hiddenLengthChanged) updatedItems.push({
                name: 'hidden',
                oldVal: currentView?.hidden,
                newVal: changedView.hidden
            });
            if (fieldsLengthChanged || fieldsReoredred) updatedItems.push({
                name: 'fields',
                oldVal: currentView?.fields,
                newVal: changedView.fields
            });
            (0, $dVuZs.fireViewUpdatedEvent)(props.createAnalyticsEvent, changedView, {
                updatedItems: updatedItems
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, onAfterSave));
        }
    };
const $d172c71b7a245ff8$export$52ca09c81057a908 = (fields, viewSelectorPredicate)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        const fieldsKeys = fields.map(({ key: key })=>key);
        if (fieldsKeys.length > 0) {
            const predicate = viewSelectorPredicate !== undefined ? viewSelectorPredicate : (0, $hsfc2.currentViewFilter)(currentViewSlug);
            const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(state.viewSets, predicate, (view)=>{
                const pinnedViewId = (0, $9PAQN.getPinnedViewId)(state);
                const isCurrentViewPinned = view.id === pinnedViewId;
                const isAutosaveEnabled = isCurrentViewPinned || view.isAutosaveEnabled;
                return {
                    ...view,
                    fields: isAutosaveEnabled ? fieldsKeys : view.fields,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        fields: fieldsKeys
                    }
                };
            });
            if (changedView) {
                setState({
                    viewSets: viewSets
                });
                (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                    updatedItems: [
                        {
                            name: 'fields',
                            oldVal: currentView?.fields,
                            newVal: changedView.fields
                        }
                    ]
                });
                dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            }
        }
    };
const $d172c71b7a245ff8$export$5d8cb7904eb9a3a1 = (fieldKey)=>({ getState: getState, dispatch: dispatch }, props)=>{
        if (fieldKey === undefined) return;
        const currentFields = (0, $7DWfj.getCurrentViewFields)(getState(), props);
        const newFields = currentFields.filter((field)=>field.key !== fieldKey) || [];
        dispatch($d172c71b7a245ff8$export$52ca09c81057a908(newFields));
    };
const $d172c71b7a245ff8$export$a9eb882dd6f1cd8f = ({ fields: fields })=>async ({ dispatch: dispatch })=>{
        dispatch($d172c71b7a245ff8$var$updateView({
            fields: fields
        }));
    };
const $d172c71b7a245ff8$export$959c898c74bed5a1 = ({ fieldKey: fieldKey, movedToKey: movedToKey })=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const currentViewFieldKeys = (0, $7DWfj.getCurrentViewFieldKeys)(getState(), props);
        const sortedFields = [
            ...currentViewFieldKeys
        ];
        const oldIndex = sortedFields.indexOf(fieldKey);
        const newIndex = sortedFields.indexOf(movedToKey);
        if (oldIndex === -1 && newIndex === -1) sortedFields.push(fieldKey);
        else if (oldIndex > -1) {
            sortedFields.splice(oldIndex, 1);
            sortedFields.splice(newIndex, 0, fieldKey);
        } else if (newIndex > -1) sortedFields.splice(newIndex, 0, fieldKey);
        dispatch($d172c71b7a245ff8$var$updateView({
            fields: sortedFields
        }));
    };
const $d172c71b7a245ff8$export$2a281736894d3053 = ({ fieldKey: fieldKey, isChecked: isChecked }, viewSelectorPredicate, onAfterSave)=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const currentViewFieldKeys = (0, $7DWfj.getCurrentViewFieldKeys)(getState(), props);
        const fields = isChecked ? (0, (/*@__PURE__*/$parcel$interopDefault($1GmOk)))((0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(currentViewFieldKeys, fieldKey), [
            fieldKey
        ]) : (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(currentViewFieldKeys, fieldKey);
        const currentViewHiddenFieldKeys = (0, $7DWfj.getCurrentViewHiddenFieldKeys)(getState(), props);
        const hidden = isChecked ? (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(currentViewHiddenFieldKeys, fieldKey) : (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(currentViewHiddenFieldKeys, fieldKey);
        dispatch($d172c71b7a245ff8$var$updateView({
            fields: fields,
            hidden: hidden
        }, viewSelectorPredicate, onAfterSave));
        const summaryCardField = (0, $mJiEA.getCurrentViewSummaryCardField)(getState(), props);
        if (!isChecked && summaryCardField?.key === fieldKey) dispatch((0, $2uYQG.setSummaryCardField)(undefined));
    };
const $d172c71b7a245ff8$export$f2dad5cb50d095b6 = (fieldKey, viewSelectorPredicate, onAfterSave)=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const currentViewHiddenFieldKeys = (0, $7DWfj.getCurrentViewHiddenFieldKeys)(getState(), props);
        const hidden = currentViewHiddenFieldKeys.includes(fieldKey) ? (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(currentViewHiddenFieldKeys, fieldKey) : (0, (/*@__PURE__*/$parcel$interopDefault($1GmOk)))(currentViewHiddenFieldKeys, [
            fieldKey
        ]);
        dispatch($d172c71b7a245ff8$var$updateView({
            hidden: hidden
        }, viewSelectorPredicate, onAfterSave));
    };

});
parcelRegister("1GmOk", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $l76qh = parcelRequire("l76qh");

var $1txRh = parcelRequire("1txRh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $139b686d7d12ae9b$var$union = $l76qh(function(arrays) {
    return $1txRh($72Qfa(arrays, 1, $d1ShJ, true));
});
module.exports = $139b686d7d12ae9b$var$union;

});

parcelRegister("2uYQG", function(module, exports) {

$parcel$export(module.exports, "setTimelineMode", () => $96c47100b2660d24$export$a3936c3a6c7236f0);
$parcel$export(module.exports, "setStartDateField", () => $96c47100b2660d24$export$2c84577005b6b27a);
$parcel$export(module.exports, "setEndDateField", () => $96c47100b2660d24$export$4ab32cd3118fb69c);
$parcel$export(module.exports, "setStartTimelineIntervalDate", () => $96c47100b2660d24$export$3e1c0c2acdfd477);
$parcel$export(module.exports, "setEndTimelineIntervalDate", () => $96c47100b2660d24$export$b9fbcd13a67f8bdb);
$parcel$export(module.exports, "updateSummaryCardFieldInView", () => $96c47100b2660d24$export$81e7ac11eeb27a11);
$parcel$export(module.exports, "setSummaryCardField", () => $96c47100b2660d24$export$ce92a297988a9fb2);

var $hmO6M = parcelRequire("hmO6M");
var $57raR = parcelRequire("57raR");

var $bHZrQ = parcelRequire("bHZrQ");

var $7jTnu = parcelRequire("7jTnu");

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");

const $96c47100b2660d24$var$defaultDraftTimelineConfig = {
    dueDateField: undefined,
    endTimestamp: undefined,
    startDateField: undefined,
    startTimestamp: undefined,
    mode: (0, $bHZrQ.PolarisTimelineMode).QUARTERS,
    summaryCardField: undefined
};
const $96c47100b2660d24$export$a3936c3a6c7236f0 = (mode)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const viewMutation = (view)=>{
            if (!view.timelineConfig) return view;
            return {
                ...view,
                modified: view.timelineConfig?.mode !== mode && view.isAutosaveEnabled,
                timelineConfig: {
                    ...view.timelineConfig,
                    mode: view.isAutosaveEnabled ? mode : view.timelineConfig.mode
                },
                draft: {
                    ...view.draft,
                    timelineConfig: {
                        ...view.draft.timelineConfig || $96c47100b2660d24$var$defaultDraftTimelineConfig,
                        mode: mode
                    }
                }
            };
        };
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'timelineConfig.mode',
                        oldVal: currentView?.timelineConfig?.mode,
                        newVal: changedView.timelineConfig?.mode
                    }
                ]
            });
        }
    };
const $96c47100b2660d24$export$2c84577005b6b27a = (fieldKey)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, fields: fields, createAnalyticsEvent: createAnalyticsEvent })=>{
        const startDateField = fields[fieldKey];
        const viewMutation = (view)=>{
            if (!view.timelineConfig) return view;
            return {
                ...view,
                modified: view.timelineConfig?.startDateField !== startDateField && view.isAutosaveEnabled,
                timelineConfig: {
                    ...view.timelineConfig,
                    startDateField: view.isAutosaveEnabled ? startDateField : view.timelineConfig.startDateField
                },
                draft: {
                    ...view.draft,
                    timelineConfig: {
                        ...view.draft.timelineConfig || $96c47100b2660d24$var$defaultDraftTimelineConfig,
                        startDateField: startDateField
                    }
                }
            };
        };
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'timelineConfig.startDateField',
                        oldVal: currentView?.timelineConfig?.startDateField?.key,
                        newVal: changedView.timelineConfig?.startDateField?.key
                    }
                ]
            });
        }
    };
const $96c47100b2660d24$export$4ab32cd3118fb69c = (fieldKey)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, fields: fields, createAnalyticsEvent: createAnalyticsEvent })=>{
        const dueDateField = fields[fieldKey];
        const viewMutation = (view)=>{
            if (!view.timelineConfig) return view;
            return {
                ...view,
                modified: view.timelineConfig?.dueDateField !== dueDateField && view.isAutosaveEnabled,
                timelineConfig: {
                    ...view.timelineConfig,
                    dueDateField: view.isAutosaveEnabled ? dueDateField : view.timelineConfig.dueDateField
                },
                draft: {
                    ...view.draft,
                    timelineConfig: {
                        ...view.draft.timelineConfig || $96c47100b2660d24$var$defaultDraftTimelineConfig,
                        dueDateField: dueDateField
                    }
                }
            };
        };
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'timelineConfig.dueDateField',
                        oldVal: currentView?.timelineConfig?.dueDateField?.key,
                        newVal: changedView.timelineConfig?.dueDateField?.key
                    }
                ]
            });
        }
    };
const $96c47100b2660d24$export$3e1c0c2acdfd477 = (startTimestamp, financialYearInitialMonth)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const viewMutation = (view)=>{
            if (!view.timelineConfig) return view;
            let adjustedStartTimestamp = startTimestamp;
            if (financialYearInitialMonth && financialYearInitialMonth !== 1 && (0, $7jTnu.fg)('polaris_pol-14239_custom_quarters')) {
                const date = new Date(startTimestamp);
                const currentMonth = date.getMonth() + 1;
                const quarterIndex = Math.floor((currentMonth - (financialYearInitialMonth - 1) + 12) % 12 / 3);
                const quarterStartMonth = (financialYearInitialMonth - 1 + quarterIndex * 3) % 12;
                date.setMonth(quarterStartMonth);
                adjustedStartTimestamp = (0, $57raR.default)(date, 'yyyy-MM-dd');
            }
            return {
                ...view,
                modified: view.timelineConfig?.startTimestamp !== adjustedStartTimestamp && view.isAutosaveEnabled,
                timelineConfig: {
                    ...view.timelineConfig,
                    startTimestamp: view.isAutosaveEnabled ? adjustedStartTimestamp : view.timelineConfig.startTimestamp
                },
                draft: {
                    ...view.draft,
                    timelineConfig: {
                        ...view.draft.timelineConfig || $96c47100b2660d24$var$defaultDraftTimelineConfig,
                        startTimestamp: adjustedStartTimestamp
                    }
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'timelineConfig.startTimestamp'
                    }
                ]
            });
        }
    };
const $96c47100b2660d24$export$b9fbcd13a67f8bdb = (endTimestamp, financialYearInitialMonth)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const viewMutation = (view)=>{
            if (!view.timelineConfig) return view;
            let adjustedEndTimestamp = endTimestamp;
            if (financialYearInitialMonth && financialYearInitialMonth !== 1 && (0, $7jTnu.fg)('polaris_pol-14239_custom_quarters')) {
                const date = new Date(endTimestamp);
                const currentMonth = date.getMonth() + 1;
                const quarterIndex = Math.floor((currentMonth - (financialYearInitialMonth - 1) + 12) % 12 / 3);
                const quarterEndMonth = (financialYearInitialMonth - 1 + (quarterIndex + 1) * 3 - 1) % 12;
                date.setMonth(quarterEndMonth);
                adjustedEndTimestamp = (0, $57raR.default)((0, $hmO6M.default)(date, 1), 'yyyy-MM-dd');
            }
            return {
                ...view,
                modified: view.timelineConfig?.endTimestamp !== adjustedEndTimestamp && view.isAutosaveEnabled,
                timelineConfig: {
                    ...view.timelineConfig,
                    endTimestamp: view.isAutosaveEnabled ? adjustedEndTimestamp : view.timelineConfig.endTimestamp
                },
                draft: {
                    ...view.draft,
                    timelineConfig: {
                        ...view.draft.timelineConfig || $96c47100b2660d24$var$defaultDraftTimelineConfig,
                        endTimestamp: adjustedEndTimestamp
                    }
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'timelineConfig.endTimestamp'
                    }
                ]
            });
        }
    };
const $96c47100b2660d24$export$81e7ac11eeb27a11 = (view, summaryCardField)=>{
    if (!view.timelineConfig) return view;
    return {
        ...view,
        modified: view.modified || view.timelineConfig?.summaryCardField?.key !== summaryCardField?.key && view.isAutosaveEnabled,
        timelineConfig: {
            ...view.timelineConfig,
            summaryCardField: view.isAutosaveEnabled ? summaryCardField : view.timelineConfig.summaryCardField
        },
        draft: {
            ...view.draft,
            timelineConfig: {
                ...view.draft.timelineConfig || $96c47100b2660d24$var$defaultDraftTimelineConfig,
                summaryCardField: summaryCardField
            }
        }
    };
};
const $96c47100b2660d24$export$ce92a297988a9fb2 = (fieldKey)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent, fields: fields })=>{
        const summaryCardField = fieldKey ? fields[fieldKey] : undefined;
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>$96c47100b2660d24$export$81e7ac11eeb27a11(view, summaryCardField));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'timelineConfig.summaryCardField',
                        oldVal: currentView?.timelineConfig?.summaryCardField,
                        newVal: changedView.timelineConfig?.summaryCardField
                    }
                ]
            });
        }
    };

});


parcelRegister("2OOCq", function(module, exports) {

$parcel$export(module.exports, "clearAllFilters", () => $1a6a2b5adb5e3187$export$a718e009635f235b);
$parcel$export(module.exports, "updateQuickSearchFilter", () => $1a6a2b5adb5e3187$export$6dc2ad8bb44ad026);
$parcel$export(module.exports, "updateFieldFilter", () => $1a6a2b5adb5e3187$export$1bd56c5f8f729f0b);
$parcel$export(module.exports, "clearFieldFilter", () => $1a6a2b5adb5e3187$export$4e5bf461ea506f2f);
$parcel$export(module.exports, "clearFilter", () => $1a6a2b5adb5e3187$export$77cedf2a856f1597);
$parcel$export(module.exports, "updateNumericFilter", () => $1a6a2b5adb5e3187$export$db424b014ffddae3);
$parcel$export(module.exports, "updateFilters", () => $1a6a2b5adb5e3187$export$c1177d54e2e97cb7);
$parcel$export(module.exports, "removeFilterFromGroups", () => $1a6a2b5adb5e3187$export$5b498bf571cf7e59);

var $1yBwF = parcelRequire("1yBwF");

var $7B8wM = parcelRequire("7B8wM");

var $8m4OM = parcelRequire("8m4OM");

var $7jTnu = parcelRequire("7jTnu");

var $50ZgY = parcelRequire("50ZgY");

var $238Vi = parcelRequire("238Vi");

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");

var $NUPB6 = parcelRequire("NUPB6");

var $1i9jM = parcelRequire("1i9jM");

const $1a6a2b5adb5e3187$export$a718e009635f235b = (onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent } = props;
        const viewMutation = (view)=>{
            const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
            if ((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type')) return {
                ...view,
                filterGroups: isAutosaveEnabled ? [] : view.filterGroups,
                modified: isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    filterGroups: []
                }
            };
            return {
                ...view,
                filter: isAutosaveEnabled ? [] : view.filter,
                modified: isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    filter: []
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view && view.saveError) onError?.(view.saveError);
                else if (view && !view.saveError) onSuccess?.();
            }));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'filter'
                    }
                ]
            });
        }
    };
const $1a6a2b5adb5e3187$export$6dc2ad8bb44ad026 = (values)=>async ({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        const viewMutation = (view)=>{
            const quickSearchFilter = (0, $50ZgY.getQuickSearchFilter)(state, props);
            const currentFilter = (0, $50ZgY.getCurrentViewFilter)(state, props);
            const index = (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(currentFilter, quickSearchFilter);
            const newValue = (0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(values.map(({ stringValue: stringValue })=>stringValue)) ?? '';
            const currentValue = (0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(quickSearchFilter.values.map(({ stringValue: stringValue })=>stringValue)) ?? '';
            if (currentValue === newValue) return view;
            if (index === -1) {
                const newFilters = [
                    ...currentFilter,
                    {
                        ...quickSearchFilter,
                        values: values
                    }
                ];
                return {
                    ...view,
                    filter: isAutosaveEnabled ? newFilters : view.filter,
                    draft: {
                        ...view.draft,
                        filter: newFilters
                    }
                };
            }
            const newFilters = [
                ...currentFilter
            ];
            if (newValue !== '') newFilters.splice(index, 1, {
                ...quickSearchFilter,
                values: values
            });
            else newFilters.splice(index, 1);
            return {
                ...view,
                filter: isAutosaveEnabled ? newFilters : view.filter,
                draft: {
                    ...view.draft,
                    filter: newFilters
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView && viewSets !== getState().viewSets) setState({
            viewSets: viewSets
        });
    };
const $1a6a2b5adb5e3187$export$1bd56c5f8f729f0b = (filter, issueTypeName, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        let viewMutation;
        if ((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type')) {
            const currentViewFilterGroups = (0, $50ZgY.getCurrentViewFilterGroups)(state, props);
            const updatedGroups = (0, $1i9jM.upsertGroupFilter)(currentViewFilterGroups, filter, issueTypeName);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filterGroups: isAutosaveEnabled ? updatedGroups : view.filterGroups,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filterGroups: updatedGroups
                    }
                };
            };
        } else {
            const getFieldFilter = (0, $50ZgY.createGetFieldFilter)(filter.field, issueTypeName);
            const fieldFilter = getFieldFilter(state, props);
            const currentFilter = (0, $50ZgY.getCurrentViewFilter)(state, props);
            const newFilters = fieldFilter === undefined ? [
                ...currentFilter,
                filter
            ] : currentFilter.map((f)=>f.type === (0, $8m4OM.GENERIC_FIELD_FILTER) && f.field === filter.field ? filter : f);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filter: isAutosaveEnabled ? newFilters : view.filter,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filter: newFilters
                    }
                };
            };
        }
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view && view.saveError) onError?.(view.saveError);
                else if (view && !view.saveError) onSuccess?.();
            }));
            (0, $dVuZs.fireViewUpdatedEvent)(props.createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'filter'
                    }
                ]
            });
        }
    };
const $1a6a2b5adb5e3187$export$4e5bf461ea506f2f = (fieldKey, issueTypeName, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        const getFieldFilter = (0, $50ZgY.createGetFieldFilter)(fieldKey, issueTypeName);
        const fieldFilter = getFieldFilter(state, props);
        if (fieldFilter === undefined) return;
        let viewMutation;
        if ((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type')) {
            const currentViewFilterGroups = (0, $50ZgY.getCurrentViewFilterGroups)(state, props);
            const updatedGroups = currentViewFilterGroups.reduce((acc, group)=>{
                if (group.groupFilter === undefined ? issueTypeName !== undefined : (0, $NUPB6.getIssueTypeNameFromGroupFilter)(group.groupFilter) !== issueTypeName) acc.push(group);
                else {
                    const updatedFilters = group.filters.filter((f)=>f.type !== (0, $8m4OM.GENERIC_FIELD_FILTER) || f.field !== fieldKey);
                    if (updatedFilters.length > 0) acc.push({
                        ...group,
                        filters: updatedFilters
                    });
                }
                return acc;
            }, []);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filterGroups: isAutosaveEnabled ? updatedGroups : view.filterGroups,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filterGroups: updatedGroups
                    }
                };
            };
        } else {
            const currentFilter = (0, $50ZgY.getCurrentViewFilter)(state, props);
            const newFilters = currentFilter.filter((f)=>f.type !== (0, $8m4OM.GENERIC_FIELD_FILTER) || f.field !== fieldKey);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filter: isAutosaveEnabled ? newFilters : view.filter,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filter: newFilters
                    }
                };
            };
        }
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view && view.saveError) onError?.(view.saveError);
                else if (view && !view.saveError) onSuccess?.();
            }));
            (0, $dVuZs.fireViewUpdatedEvent)(props.createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'filter'
                    }
                ]
            });
        }
    };
const $1a6a2b5adb5e3187$export$77cedf2a856f1597 = (fieldKey, issueTypeName, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        let viewMutation;
        if ((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type')) {
            const currentViewFilterGroups = (0, $50ZgY.getCurrentViewFilterGroups)(state, props);
            const updatedGroups = currentViewFilterGroups.reduce((acc, group)=>{
                if (group.groupFilter === undefined ? issueTypeName !== undefined : (0, $NUPB6.getIssueTypeNameFromGroupFilter)(group.groupFilter) !== issueTypeName) acc.push(group);
                else {
                    const updatedFilters = group.filters.filter((f)=>f.type !== (0, $8m4OM.GENERIC_FIELD_FILTER) && f.type !== (0, $8m4OM.NUMERIC_FIELD_FILTER) && f.type !== (0, $8m4OM.INTERVAL_FIELD_FILTER) && f.type !== (0, $8m4OM.CONNECTION_FIELD_FILTER) || f.field !== fieldKey);
                    if (updatedFilters.length > 0) acc.push({
                        ...group,
                        filters: updatedFilters
                    });
                }
                return acc;
            }, []);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filterGroups: isAutosaveEnabled ? updatedGroups : view.filterGroups,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filterGroups: updatedGroups
                    }
                };
            };
        } else {
            const currentFilter = (0, $50ZgY.getCurrentViewFilter)(state, props);
            const newFilters = currentFilter.filter((f)=>f.type !== (0, $8m4OM.GENERIC_FIELD_FILTER) && f.type !== (0, $8m4OM.NUMERIC_FIELD_FILTER) && f.type !== (0, $8m4OM.INTERVAL_FIELD_FILTER) && f.type !== (0, $8m4OM.CONNECTION_FIELD_FILTER) || f.field !== fieldKey);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filter: isAutosaveEnabled ? newFilters : view.filter,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filter: newFilters
                    }
                };
            };
        }
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view && view.saveError) onError?.(view.saveError);
                else if (view && !view.saveError) onSuccess?.();
            }));
            (0, $dVuZs.fireViewUpdatedEvent)(props.createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'filter'
                    }
                ]
            });
        }
    };
const $1a6a2b5adb5e3187$export$db424b014ffddae3 = (filter, issueTypeName, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        let viewMutation;
        if ((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type')) {
            const currentViewFilterGroups = (0, $50ZgY.getCurrentViewFilterGroups)(state, props);
            const updatedGroups = (0, $1i9jM.upsertGroupFilter)(currentViewFilterGroups, filter, issueTypeName);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filterGroups: isAutosaveEnabled ? updatedGroups : view.filterGroups,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filterGroups: updatedGroups
                    }
                };
            };
        } else {
            const getNumericFilter = (0, $50ZgY.createGetNumericFilter)(filter.field, undefined);
            const numericFilter = getNumericFilter(state, props);
            const currentFilter = (0, $50ZgY.getCurrentViewFilter)(state, props);
            const index = (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(currentFilter, numericFilter);
            const newFilters = [
                ...currentFilter
            ];
            if (index === -1) newFilters.push(filter);
            else newFilters.splice(index, 1, filter);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filter: isAutosaveEnabled ? newFilters : view.filter,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filter: newFilters
                    }
                };
            };
        }
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view && view.saveError) onError?.(view.saveError);
                else if (view && !view.saveError) onSuccess?.();
            }));
        }
    };
const $1a6a2b5adb5e3187$export$c1177d54e2e97cb7 = (filters, issueTypeName, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        let viewMutation;
        if ((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type')) {
            const currentViewFilterGroups = (0, $50ZgY.getCurrentViewFilterGroups)(state, props);
            let updatedGroups = [
                ...currentViewFilterGroups
            ];
            filters.forEach((filter)=>{
                if (filter.type !== (0, $8m4OM.TEXT_FIELD_FILTER) && filter.type !== (0, $8m4OM.CONNECTION_FIELD_FILTER)) updatedGroups = (0, $1i9jM.upsertGroupFilter)(updatedGroups, filter, issueTypeName);
            });
            viewMutation = (view)=>{
                return {
                    ...view,
                    filterGroups: isAutosaveEnabled ? updatedGroups : view.filterGroups,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filterGroups: updatedGroups
                    }
                };
            };
        } else {
            const currentFilter = (0, $50ZgY.getCurrentViewFilter)(state, props);
            const newFilters = [
                ...currentFilter
            ];
            filters.forEach((updatedFilter)=>{
                const found = currentFilter.find((f)=>f.type === updatedFilter.type && f.type === (0, $8m4OM.TEXT_FIELD_FILTER) || f.type !== (0, $8m4OM.TEXT_FIELD_FILTER) && f.type === updatedFilter.type && f.field === updatedFilter.field);
                const index = (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(currentFilter, found);
                if (index === -1) newFilters.push(updatedFilter);
                newFilters.splice(index, 1, updatedFilter);
            });
            viewMutation = (view)=>{
                return {
                    ...view,
                    filter: isAutosaveEnabled ? newFilters : view.filter,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filter: newFilters
                    }
                };
            };
        }
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view && view.saveError) onError?.(view.saveError);
                else if (view && !view.saveError) onSuccess?.();
            }));
        }
    };
const $1a6a2b5adb5e3187$export$5b498bf571cf7e59 = (fieldKey, issueTypeNames)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        const currentViewFilterGroups = (0, $50ZgY.getCurrentViewFilterGroups)(state, props);
        const updatedGroups = currentViewFilterGroups.reduce((acc, group)=>{
            if (group.groupFilter === undefined) acc.push(group);
            else {
                const issueTypeName = (0, $NUPB6.getIssueTypeNameFromGroupFilter)(group.groupFilter);
                if (issueTypeName === undefined || !issueTypeNames.includes(issueTypeName)) acc.push(group);
                else {
                    const updatedFilters = group.filters.filter((f)=>f.type !== (0, $8m4OM.TEXT_FIELD_FILTER) && f.field !== fieldKey);
                    if (updatedFilters.length > 0) acc.push({
                        ...group,
                        filters: updatedFilters
                    });
                }
            }
            return acc;
        }, []);
        const viewMutation = (view)=>{
            return {
                ...view,
                filterGroups: isAutosaveEnabled ? updatedGroups : view.filterGroups,
                modified: isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    filterGroups: updatedGroups
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
        }
    };

});
parcelRegister("50ZgY", function(module, exports) {

$parcel$export(module.exports, "getCurrentViewFilter", () => $cb48a13d8eb66538$export$8a44ffea13703f99);
$parcel$export(module.exports, "getCurrentViewFilterGroups", () => $cb48a13d8eb66538$export$4722fa9dd800147);
$parcel$export(module.exports, "getCurrentViewInitialFilter", () => $cb48a13d8eb66538$export$7baf86ca75b46c7e);
$parcel$export(module.exports, "hasSharedViewNoValueFilter", () => $cb48a13d8eb66538$export$60b211d9ae58d424);
$parcel$export(module.exports, "getCurrentViewFilterForShared", () => $cb48a13d8eb66538$export$c674ebb58676ba11);
$parcel$export(module.exports, "getCurrentViewFilterGroupsForShared", () => $cb48a13d8eb66538$export$1b9fdef0f466e9fb);
$parcel$export(module.exports, "createGetFieldFilter", () => $cb48a13d8eb66538$export$b3a4eb35fd64f43d);
$parcel$export(module.exports, "createGetConnectionFieldFilter", () => $cb48a13d8eb66538$export$4503a9d0ed640d67);
$parcel$export(module.exports, "createGetNumericFilter", () => $cb48a13d8eb66538$export$7b8722da355541c);
$parcel$export(module.exports, "createGetIntervalFilter", () => $cb48a13d8eb66538$export$b3bf30856708fdb6);
$parcel$export(module.exports, "createGetFieldFilterOrEmptyFilter", () => $cb48a13d8eb66538$export$ef30ac6f17afd443);
$parcel$export(module.exports, "createGetNumericFilterOrEmptyFilter", () => $cb48a13d8eb66538$export$5ff43fd00160802d);
$parcel$export(module.exports, "createGeIntervalFilterOrEmptyFilter", () => $cb48a13d8eb66538$export$c93ae509f6e522e3);
$parcel$export(module.exports, "getQuickSearchFilter", () => $cb48a13d8eb66538$export$b8c366672e284c8e);
$parcel$export(module.exports, "isQuickSearchFilterDefined", () => $cb48a13d8eb66538$export$22abad47645348a5);
$parcel$export(module.exports, "getActiveFiltersCount", () => $cb48a13d8eb66538$export$d2ea28e46364c0c8);
$parcel$export(module.exports, "getActiveFilterGroupsFiltersCount", () => $cb48a13d8eb66538$export$8c27545665ebbbb5);
$parcel$export(module.exports, "getActivePermanentFiltersFields", () => $cb48a13d8eb66538$export$68fdb528a12e21f0);
$parcel$export(module.exports, "getActiveFiltersFieldsForGroups", () => $cb48a13d8eb66538$export$380766a9d8e8578b);
$parcel$export(module.exports, "getAllowedFiltersFields", () => $cb48a13d8eb66538$export$86a45cdfa4b49b01);
$parcel$export(module.exports, "getAvailableFiltersFields", () => $cb48a13d8eb66538$export$4027061a35c40978);

var $ahm5r = parcelRequire("ahm5r");

var $6kS6u = parcelRequire("6kS6u");

var $exWdq = parcelRequire("exWdq");

var $1yBwF = parcelRequire("1yBwF");

var $jUVzX = parcelRequire("jUVzX");

var $9yn2r = parcelRequire("9yn2r");

var $7jTnu = parcelRequire("7jTnu");

var $eTBmS = parcelRequire("eTBmS");

var $8m4OM = parcelRequire("8m4OM");

var $NUPB6 = parcelRequire("NUPB6");

var $7M0xf = parcelRequire("7M0xf");

var $238Vi = parcelRequire("238Vi");

var $1vVGo = parcelRequire("1vVGo");

var $7DWfj = parcelRequire("7DWfj");
const $cb48a13d8eb66538$var$doesFilterValueIdExistsInFieldOptions = (field, { stringValue: optionId }, issueTypes)=>{
    // undefined (=no value)
    if (optionId === undefined) return true;
    if (field === undefined) return true;
    if (field.type === (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE) {
        const issueTypeId = issueTypes.find(({ name: name })=>name === optionId)?.id;
        return issueTypeId !== undefined && field.issueTypes.includes(issueTypeId);
    }
    if (field.options === undefined) return true;
    // check optionId in field options
    return field.options.some(({ jiraOptionId: jiraOptionId })=>jiraOptionId === optionId);
};
const $cb48a13d8eb66538$var$getCurrentViewPermanentFilterProperty = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (currentView)=>currentView?.filter);
const $cb48a13d8eb66538$var$getCurrentViewFilterGroupsProperty = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (currentView)=>currentView?.filterGroups);
const $cb48a13d8eb66538$var$getCurrentViewPermanentFilterObj = (0, $ahm5r.createSelector)($cb48a13d8eb66538$var$getCurrentViewPermanentFilterProperty, (filter)=>(filter || []).filter((f)=>f.type !== (0, $8m4OM.TEXT_FIELD_FILTER) || f.localId === 'quick'));
const $cb48a13d8eb66538$var$getCurrentViewFilterGroupsObj = (0, $ahm5r.createSelector)($cb48a13d8eb66538$var$getCurrentViewFilterGroupsProperty, (filterGroups = [])=>filterGroups.map(({ groupFilter: groupFilter, filters: filters })=>({
            groupFilter: groupFilter,
            filters: filters.filter((f)=>f.type !== (0, $8m4OM.TEXT_FIELD_FILTER) || f.localId === 'quick')
        })));
const $cb48a13d8eb66538$var$getCurrentViewDraftFilterProperty = (0, $ahm5r.createSelector)((0, $238Vi.getCurrentViewDraft), (draft)=>draft?.filter || []);
const $cb48a13d8eb66538$var$getCurrentViewDraftFilterGroupsProperty = (0, $ahm5r.createSelector)((0, $238Vi.getCurrentViewDraft), (draft)=>draft?.filterGroups || []);
const $cb48a13d8eb66538$export$8a44ffea13703f99 = (0, $ahm5r.createSelector)($cb48a13d8eb66538$var$getCurrentViewPermanentFilterObj, $cb48a13d8eb66538$var$getCurrentViewDraftFilterProperty, (0, $7M0xf.getFields), (0, $238Vi.isCurrentViewAutosaveEnabled), (state, props)=>props?.issueTypes, (viewFilterObj, draftFilter, fieldsByKey, isAutosaveEnabled, issueTypes = [])=>{
    const filterData = isAutosaveEnabled ? viewFilterObj : draftFilter;
    return filterData.map((filter)=>filter.type === (0, $8m4OM.GENERIC_FIELD_FILTER) ? {
            ...filter,
            values: filter.values.filter((value)=>$cb48a13d8eb66538$var$doesFilterValueIdExistsInFieldOptions(fieldsByKey[filter.field], value, issueTypes))
        } : filter);
});
const $cb48a13d8eb66538$export$4722fa9dd800147 = (0, $ahm5r.createSelector)($cb48a13d8eb66538$var$getCurrentViewFilterGroupsObj, $cb48a13d8eb66538$var$getCurrentViewDraftFilterGroupsProperty, (0, $7M0xf.getFields), (0, $238Vi.isCurrentViewAutosaveEnabled), (state, props)=>props?.issueTypes, (filterGroups, draftFilterGroups, fieldsByKey, isAutosaveEnabled, issueTypes = [])=>{
    const filterData = isAutosaveEnabled ? filterGroups : draftFilterGroups;
    return filterData.reduce((acc, { groupFilter: groupFilter, filters: filters })=>{
        const newFilters = filters.map((filter)=>filter.type === (0, $8m4OM.GENERIC_FIELD_FILTER) ? {
                ...filter,
                values: filter.values.filter((value)=>$cb48a13d8eb66538$var$doesFilterValueIdExistsInFieldOptions(fieldsByKey[filter.field], value, issueTypes))
            } : filter);
        if (newFilters.length > 0) acc.push({
            groupFilter: groupFilter,
            filters: newFilters
        });
        return acc;
    }, []);
});
const $cb48a13d8eb66538$var$createGetCurrentViewFilterGroup = (issueTypeName)=>(0, $ahm5r.createSelector)($cb48a13d8eb66538$export$4722fa9dd800147, (groups)=>{
        return groups.find(({ groupFilter: groupFilter })=>{
            if (groupFilter === undefined) return issueTypeName === undefined;
            return (0, $NUPB6.getIssueTypeNameFromGroupFilter)(groupFilter) === issueTypeName;
        });
    });
const $cb48a13d8eb66538$var$createGetCurrentViewFilterGroupFilters = (issueTypeName)=>(0, $ahm5r.createSelector)($cb48a13d8eb66538$var$createGetCurrentViewFilterGroup(issueTypeName), (group)=>group?.filters || []);
const $cb48a13d8eb66538$export$7baf86ca75b46c7e = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.initialFilter);
const $cb48a13d8eb66538$export$60b211d9ae58d424 = (field)=>(0, $ahm5r.createSelector)($cb48a13d8eb66538$export$7baf86ca75b46c7e, (_, props)=>props, (initialFilter, props)=>{
        if (!props?.isSharedView) return true;
        const fieldFilter = initialFilter?.find((f)=>'field' in f && f.field === field.key);
        if (!fieldFilter || fieldFilter.type !== (0, $8m4OM.GENERIC_FIELD_FILTER)) return true;
        return !!fieldFilter?.values?.find(({ stringValue: stringValue })=>!stringValue);
    });
const $cb48a13d8eb66538$export$c674ebb58676ba11 = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$8a44ffea13703f99, $cb48a13d8eb66538$export$7baf86ca75b46c7e, (0, $7DWfj.getCurrentViewGroupBy), (0, $7DWfj.getCurrentViewVerticalGroupBy), (filters, initialFilters, groupBy, verticalGroupBy)=>{
    const getGroupFilter = (f)=>'field' in f && f.field === groupBy?.key;
    const getVerticalGroupFilter = (f)=>'field' in f && f.field === verticalGroupBy?.key;
    const groupFilter = initialFilters?.find(getGroupFilter);
    const verticalGroupByFilter = initialFilters?.find(getVerticalGroupFilter);
    const localGroupFilter = filters.find(getGroupFilter);
    const localVerticalGroupFilter = filters.find(getVerticalGroupFilter);
    const mergedFilters = [
        ...filters
    ];
    // use group filter configured in normal view until user overrides this locally in shared view
    if (groupFilter && !localGroupFilter) mergedFilters.push(groupFilter);
    if (verticalGroupByFilter && !localVerticalGroupFilter) mergedFilters.push(verticalGroupByFilter);
    return mergedFilters;
});
const $cb48a13d8eb66538$export$1b9fdef0f466e9fb = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$4722fa9dd800147, (0, $7DWfj.getCurrentViewGroupBy), (0, $7DWfj.getCurrentViewVerticalGroupBy), (_filters, _groupBy, _verticalGroupBy)=>{
    return [];
});
const $cb48a13d8eb66538$export$b3a4eb35fd64f43d = (field, issueTypeName)=>(0, $ahm5r.createSelector)((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type') ? $cb48a13d8eb66538$var$createGetCurrentViewFilterGroupFilters(issueTypeName) : $cb48a13d8eb66538$export$8a44ffea13703f99, (filters)=>{
        const retVal = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(filters, (f)=>f.type === (0, $8m4OM.GENERIC_FIELD_FILTER) && f.field === field);
        return retVal;
    });
const $cb48a13d8eb66538$export$4503a9d0ed640d67 = (field)=>(0, $ahm5r.createSelector)($cb48a13d8eb66538$export$8a44ffea13703f99, (filters)=>{
        return filters.find((f)=>f.type === (0, $8m4OM.CONNECTION_FIELD_FILTER) && f.field === field);
    });
const $cb48a13d8eb66538$export$7b8722da355541c = (field, issueTypeName)=>(0, $ahm5r.createSelector)((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type') ? $cb48a13d8eb66538$var$createGetCurrentViewFilterGroupFilters(issueTypeName) : $cb48a13d8eb66538$export$8a44ffea13703f99, (filters)=>{
        const retVal = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(filters, (f)=>f.type === (0, $8m4OM.NUMERIC_FIELD_FILTER) && f.field === field);
        return retVal;
    });
const $cb48a13d8eb66538$export$b3bf30856708fdb6 = (field, issueTypeName)=>(0, $ahm5r.createSelector)((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type') ? $cb48a13d8eb66538$var$createGetCurrentViewFilterGroupFilters(issueTypeName) : $cb48a13d8eb66538$export$8a44ffea13703f99, (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(filters, (filter)=>filter.type === (0, $8m4OM.INTERVAL_FIELD_FILTER) && filter.field === field));
const $cb48a13d8eb66538$export$ef30ac6f17afd443 = (fieldKey, issueTypeName)=>{
    const getFieldFilter = $cb48a13d8eb66538$export$b3a4eb35fd64f43d(fieldKey, issueTypeName);
    return (0, $ahm5r.createSelector)(getFieldFilter, (0, $7M0xf.getFields), (fieldFilter, fields)=>fieldFilter || {
            type: (0, $8m4OM.GENERIC_FIELD_FILTER),
            field: fieldKey,
            values: [],
            fieldType: fields[fieldKey]?.type
        });
};
const $cb48a13d8eb66538$export$5ff43fd00160802d = (fieldKey, issueTypeName)=>{
    const getFieldFilter = $cb48a13d8eb66538$export$7b8722da355541c(fieldKey, issueTypeName);
    return (0, $ahm5r.createSelector)(getFieldFilter, (0, $7M0xf.getFields), (fieldFilter, fields)=>fieldFilter || {
            type: (0, $8m4OM.NUMERIC_FIELD_FILTER),
            field: fieldKey,
            fieldType: fields[fieldKey].type,
            values: []
        });
};
const $cb48a13d8eb66538$export$c93ae509f6e522e3 = (fieldKey, issueTypeName)=>{
    const getFieldFilter = $cb48a13d8eb66538$export$b3bf30856708fdb6(fieldKey, issueTypeName);
    const emptyIntervalFilter = {
        type: (0, $8m4OM.INTERVAL_FIELD_FILTER),
        field: fieldKey,
        values: []
    };
    return (0, $ahm5r.createSelector)(getFieldFilter, (fieldFilter)=>fieldFilter || emptyIntervalFilter);
};
const $cb48a13d8eb66538$export$b8c366672e284c8e = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$8a44ffea13703f99, (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))(filters.filter((f)=>f.type === (0, $8m4OM.TEXT_FIELD_FILTER) && f.localId === 'quick')) || {
        type: (0, $8m4OM.TEXT_FIELD_FILTER),
        localId: 'quick',
        values: []
    });
/**
 * Filters as represented in the state might be empty or referencing fields
 * that are no longer available on the prroject. this filter ensures that only
 * filters that actually can modify the issue set are used for counting active filters.
 */ // TODO: This should change once support for replacement of ConnectionFieldFilter is added in filter groups https://pi-dev-sandbox.atlassian.net/browse/POL-16843
const $cb48a13d8eb66538$var$isApplicableFilter = (filter, fields)=>{
    if (filter.type === (0, $8m4OM.TEXT_FIELD_FILTER)) return filter.values.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($9yn2r)))(filter.values[0].stringValue) !== '';
    return filter.values.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, filter.field);
};
const $cb48a13d8eb66538$export$22abad47645348a5 = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$b8c366672e284c8e, (textFilter)=>$cb48a13d8eb66538$var$isApplicableFilter(textFilter, {}));
const $cb48a13d8eb66538$export$d2ea28e46364c0c8 = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$8a44ffea13703f99, (0, $7M0xf.getFields), (filters, fields)=>filters.filter((filter)=>$cb48a13d8eb66538$var$isApplicableFilter(filter, fields)).length);
const $cb48a13d8eb66538$export$8c27545665ebbbb5 = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$4722fa9dd800147, (0, $7M0xf.getFields), (groups, fields)=>groups.reduce((acc, { filters: filters })=>acc + filters.filter((filter)=>$cb48a13d8eb66538$var$isApplicableFilter(filter, fields)).length, 0));
const $cb48a13d8eb66538$export$68fdb528a12e21f0 = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$8a44ffea13703f99, (0, $7M0xf.getFields), (filters, fields = {})=>{
    const activeFiltersFields = filters// eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, filter)=>{
        if (filter.type === (0, $8m4OM.GENERIC_FIELD_FILTER) || filter.type === (0, $8m4OM.NUMERIC_FIELD_FILTER) || filter.type === (0, $8m4OM.INTERVAL_FIELD_FILTER) || filter.type === (0, $8m4OM.CONNECTION_FIELD_FILTER)) {
            if (filter.values.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, filter.field)) acc[filter.field] = fields[filter.field];
        }
        return acc;
    }, {});
    return Object.values(activeFiltersFields);
});
const $cb48a13d8eb66538$export$380766a9d8e8578b = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$4722fa9dd800147, (0, $7M0xf.getFields), (state, props)=>props?.issueTypes, (filterGroups, fields, issueTypes = [])=>{
    return filterGroups.reduce((groups, { groupFilter: groupFilter, filters: filters })=>{
        // Filter out groups that have issue types that are not in the project
        if (groupFilter) {
            const issueTypeName = (0, $NUPB6.getIssueTypeNameFromGroupFilter)(groupFilter);
            if (!issueTypes.find(({ name: name })=>name === issueTypeName)) return groups;
        }
        groups.push({
            issueTypeName: groupFilter ? (0, $NUPB6.getIssueTypeNameFromGroupFilter)(groupFilter) : undefined,
            fields: filters.reduce((acc, filter)=>{
                if (filter.type === (0, $8m4OM.GENERIC_FIELD_FILTER) || filter.type === (0, $8m4OM.NUMERIC_FIELD_FILTER) || filter.type === (0, $8m4OM.INTERVAL_FIELD_FILTER) || filter.type === (0, $8m4OM.CONNECTION_FIELD_FILTER)) {
                    if (filter.values.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, filter.field)) acc.push(fields[filter.field]);
                }
                return acc;
            }, [])
        });
        return groups;
    }, []);
});
const $cb48a13d8eb66538$export$86a45cdfa4b49b01 = (0, $ahm5r.createSelector)((0, $7M0xf.getFields), (fields = {})=>{
    // Allowed field types to filter on
    const allowedFieldTypes = [
        (0, $eTBmS.FIELD_TYPES).NUMBER,
        (0, $eTBmS.FIELD_TYPES).FORMULA,
        (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES,
        (0, $eTBmS.FIELD_TYPES).RATING,
        (0, $eTBmS.FIELD_TYPES).CHECKBOX,
        (0, $eTBmS.FIELD_TYPES).SLIDER,
        (0, $eTBmS.FIELD_TYPES).INSIGHTS,
        (0, $eTBmS.FIELD_TYPES).ASSIGNEE,
        (0, $eTBmS.FIELD_TYPES).REPORTER,
        (0, $eTBmS.FIELD_TYPES).CREATOR,
        (0, $eTBmS.FIELD_TYPES).PEOPLE,
        (0, $eTBmS.FIELD_TYPES).JSW_PEOPLE,
        (0, $eTBmS.FIELD_TYPES).SINGLE_SELECT,
        (0, $eTBmS.FIELD_TYPES).MULTI_SELECT,
        (0, $eTBmS.FIELD_TYPES).JSW_MULTI_SELECT,
        (0, $eTBmS.FIELD_TYPES).LABELS,
        (0, $eTBmS.FIELD_TYPES).CUSTOM_LABELS,
        (0, $eTBmS.FIELD_TYPES).STATUS,
        (0, $eTBmS.FIELD_TYPES).ISSUE_ID,
        (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL,
        (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT,
        (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT_STATUS,
        (0, $eTBmS.FIELD_TYPES).INTERVAL,
        (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS,
        (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS,
        (0, $eTBmS.FIELD_TYPES).REACTIONS,
        (0, $eTBmS.FIELD_TYPES).PROJECT,
        (0, $eTBmS.FIELD_TYPES).CONNECTION,
        (0, $eTBmS.FIELD_TYPES).TEAM,
        (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE,
        ...(0, $7jTnu.fg)('jpd_platform_goals_field_support') ? [
            (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS
        ] : []
    ];
    return Object.keys(fields).map((key)=>fields[key]).filter(({ type: type })=>allowedFieldTypes.some((t)=>t === type));
});
const $cb48a13d8eb66538$export$4027061a35c40978 = (0, $ahm5r.createSelector)($cb48a13d8eb66538$export$86a45cdfa4b49b01, $cb48a13d8eb66538$export$68fdb528a12e21f0, (allowedFields, activeFiltersFields)=>allowedFields.filter((key)=>!(0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(activeFiltersFields, {
            key: key
        })));

});
parcelRegister("NUPB6", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeNameFromGroupFilter", () => $51d84e06e42c8c10$export$b6d7267bd7a08bdd);
$parcel$export(module.exports, "createGroupFilterFromIssueTypeName", () => $51d84e06e42c8c10$export$3e48fa295c899cdb);


var $eTBmS = parcelRequire("eTBmS");

var $8m4OM = parcelRequire("8m4OM");
const $51d84e06e42c8c10$export$b6d7267bd7a08bdd = (groupFilter)=>{
    if (groupFilter?.type !== (0, $8m4OM.GENERIC_FIELD_FILTER)) return undefined;
    if (groupFilter.field !== (0, $9a5f06039e1dff5a$export$dd03acb09519222)) return undefined;
    if (groupFilter.values.length === 0) return undefined;
    if (groupFilter.values[0].stringValue === undefined) return undefined;
    return groupFilter.values[0].stringValue;
};
const $51d84e06e42c8c10$export$3e48fa295c899cdb = (issueTypeName)=>({
        type: (0, $8m4OM.GENERIC_FIELD_FILTER),
        field: (0, $9a5f06039e1dff5a$export$dd03acb09519222),
        fieldType: (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE,
        values: [
            {
                stringValue: issueTypeName
            }
        ]
    });

});


parcelRegister("1i9jM", function(module, exports) {

$parcel$export(module.exports, "upsertGroupFilter", () => $0ec9ad7604391abd$export$f2ed879e01b5c1f8);

var $NUPB6 = parcelRequire("NUPB6");
const $0ec9ad7604391abd$export$f2ed879e01b5c1f8 = (filterGroups, filter, issueTypeName)=>{
    // If there is no group for this issue type, create new based on issue type name
    if (issueTypeName === undefined) {
        if (!filterGroups.find((group)=>group.groupFilter === undefined)) // Place "All ideas" group at the beginning
        return [
            {
                groupFilter: undefined,
                filters: [
                    filter
                ]
            },
            ...filterGroups
        ];
    } else if (!filterGroups.find((group)=>group.groupFilter && (0, $NUPB6.getIssueTypeNameFromGroupFilter)(group.groupFilter) === issueTypeName)) // Place new group at the end
    return [
        ...filterGroups,
        {
            groupFilter: (0, $NUPB6.createGroupFilterFromIssueTypeName)(issueTypeName),
            filters: [
                filter
            ]
        }
    ];
    // Otherwise update existing group
    const updatedGroups = filterGroups.map((group)=>{
        if (group.groupFilter === undefined ? issueTypeName !== undefined : (0, $NUPB6.getIssueTypeNameFromGroupFilter)(group.groupFilter) !== issueTypeName) return group;
        return {
            ...group,
            filters: group.filters.find((f)=>'field' in f && f.field === filter.field) === undefined ? [
                ...group.filters,
                filter
            ] : group.filters.map((f)=>'field' in f && f.field === filter.field && f.type === filter.type ? filter : f)
        };
    });
    return updatedGroups.filter((group)=>group.filters.length > 0);
};

});


parcelRegister("f3aih", function(module, exports) {

$parcel$export(module.exports, "updateConnectionFieldFilter", () => $35f2fa9ae1f1e261$export$c640d81da10e7f54);

var $50ZgY = parcelRequire("50ZgY");

var $238Vi = parcelRequire("238Vi");

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $35f2fa9ae1f1e261$export$c640d81da10e7f54 = (filter, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        const allFiltersAppliedOnView = (0, $50ZgY.getCurrentViewFilter)(state, props);
        const indexOfFilter = allFiltersAppliedOnView.findIndex((appliedFilter)=>appliedFilter.type === filter.type && appliedFilter.field === filter.field);
        const filterExistsWithinAppliedFilters = indexOfFilter !== -1;
        const newFilters = filterExistsWithinAppliedFilters ? allFiltersAppliedOnView.map((appliedFilter, index)=>index === indexOfFilter ? filter : appliedFilter) : [
            ...allFiltersAppliedOnView,
            filter
        ];
        const viewMutation = (view)=>{
            return {
                ...view,
                filter: isAutosaveEnabled ? newFilters : view.filter,
                modified: isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    filter: newFilters
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view === undefined) return;
                if (view.saveError === undefined) return onSuccess?.();
                return onError?.(view.saveError);
            }));
            (0, $dVuZs.fireViewUpdatedEvent)(props.createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'filter'
                    }
                ]
            });
        }
    };

});

parcelRegister("ksLZv", function(module, exports) {

$parcel$export(module.exports, "updateIntervalFilter", () => $c24714c67aaa5f05$export$c524b8ce3aa98e83);

var $7B8wM = parcelRequire("7B8wM");

var $7jTnu = parcelRequire("7jTnu");

var $50ZgY = parcelRequire("50ZgY");

var $238Vi = parcelRequire("238Vi");

var $hpem9 = parcelRequire("hpem9");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");

var $1i9jM = parcelRequire("1i9jM");
const $c24714c67aaa5f05$var$createNewFilters = (newFilter, oldFilter, viewFilters)=>{
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(viewFilters, oldFilter);
    if (index === -1) return [
        ...viewFilters,
        newFilter
    ];
    const newFilters = [
        ...viewFilters
    ];
    newFilters.splice(index, 1, newFilter);
    return newFilters;
};
const $c24714c67aaa5f05$export$c524b8ce3aa98e83 = (filter, issueTypeName, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        let viewMutation;
        if ((0, $7jTnu.fg)('jpd_filter_groups_by_issue_type')) {
            const currentViewFilterGroups = (0, $50ZgY.getCurrentViewFilterGroups)(state, props);
            const updatedGroups = (0, $1i9jM.upsertGroupFilter)(currentViewFilterGroups, filter, issueTypeName);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filterGroups: isAutosaveEnabled ? updatedGroups : view.filterGroups,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filterGroups: updatedGroups
                    }
                };
            };
        } else {
            const currentFilter = (0, $50ZgY.getCurrentViewFilter)(state, props);
            const getIntervalFilter = (0, $50ZgY.createGetIntervalFilter)(filter.field, undefined);
            const newFilters = $c24714c67aaa5f05$var$createNewFilters(filter, getIntervalFilter(state, props), currentFilter);
            viewMutation = (view)=>{
                return {
                    ...view,
                    filter: isAutosaveEnabled ? newFilters : view.filter,
                    modified: isAutosaveEnabled,
                    draft: {
                        ...view.draft,
                        filter: newFilters
                    }
                };
            };
        }
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view && view.saveError) onError?.(view.saveError);
                else if (view && !view.saveError) onSuccess?.();
            }));
        }
    };

});

parcelRegister("4Tjok", function(module, exports) {

$parcel$export(module.exports, "setGroupBy", () => $8eab145b7a1f8521$export$3b589469d04138c6);
$parcel$export(module.exports, "setVerticalGroupBy", () => $8eab145b7a1f8521$export$bb95584f70cbc865);
$parcel$export(module.exports, "setHideEmptyGroups", () => $8eab145b7a1f8521$export$4b9a6f292d890056);
$parcel$export(module.exports, "setGroupValues", () => $8eab145b7a1f8521$export$4d10292ce9e6c5d6);
$parcel$export(module.exports, "setHideEmptyColumns", () => $8eab145b7a1f8521$export$5ad94b838718009a);
$parcel$export(module.exports, "setVerticalGroupValues", () => $8eab145b7a1f8521$export$a208553b3af374c6);

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $8eab145b7a1f8521$export$3b589469d04138c6 = (groupBy)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>{
            const changedProperties = {
                groupBy: groupBy,
                verticalGroupBy: undefined,
                groupValues: [],
                verticalGroupValues: []
            };
            return {
                ...view,
                ...view.isAutosaveEnabled ? changedProperties : {},
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    ...changedProperties
                }
            };
        });
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'groupBy',
                        oldVal: currentView?.groupBy,
                        newVal: changedView.groupBy
                    }
                ]
            });
        }
    };
const $8eab145b7a1f8521$export$bb95584f70cbc865 = (verticalGroupBy, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>{
            const changedProperties = {
                verticalGroupBy: verticalGroupBy,
                verticalGroupValues: [],
                modified: true
            };
            return {
                ...view,
                ...view.isAutosaveEnabled ? changedProperties : {},
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    ...changedProperties
                }
            };
        });
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                if (view && view.saveError) onError?.(view.saveError);
                else if (view && !view.saveError) onSuccess?.();
            }));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'verticalGroupBy',
                        oldVal: currentView?.verticalGroupBy,
                        newVal: changedView.verticalGroupBy
                    }
                ]
            });
        }
    };
const $8eab145b7a1f8521$export$4b9a6f292d890056 = (hideEmptyGroups)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                hideEmptyGroups: view.isAutosaveEnabled ? hideEmptyGroups : view.hideEmptyGroups,
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    hideEmptyGroups: hideEmptyGroups
                }
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'hideEmptyGroups',
                        oldVal: currentView?.hideEmptyGroups,
                        newVal: changedView.hideEmptyGroups
                    }
                ]
            });
        }
    };
const $8eab145b7a1f8521$export$4d10292ce9e6c5d6 = (groupValues)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                groupValues: view.isAutosaveEnabled ? groupValues : view.groupValues,
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    groupValues: groupValues
                }
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'groupValues'
                    }
                ]
            });
        }
    };
const $8eab145b7a1f8521$export$5ad94b838718009a = (hideEmptyColumns)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, currentView: currentView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                hideEmptyColumns: view.isAutosaveEnabled ? hideEmptyColumns : view.hideEmptyColumns,
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    hideEmptyColumns: hideEmptyColumns
                }
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'hideEmptyColumns',
                        oldVal: currentView?.hideEmptyColumns,
                        newVal: changedView.hideEmptyColumns
                    }
                ]
            });
        }
    };
const $8eab145b7a1f8521$export$a208553b3af374c6 = (verticalGroupValues)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                verticalGroupValues: view.isAutosaveEnabled ? verticalGroupValues : view.verticalGroupValues,
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    verticalGroupValues: verticalGroupValues
                }
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
        }
    };

});

parcelRegister("c4GFV", function(module, exports) {

$parcel$export(module.exports, "setSelection", () => $02ac6b4586cd5fe2$export$f6e36f80a8190133);
$parcel$export(module.exports, "toggleSelection", () => $02ac6b4586cd5fe2$export$6853837031592033);
$parcel$export(module.exports, "clearSelection", () => $02ac6b4586cd5fe2$export$a3d02541b0ebf605);

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $jFHCE = parcelRequire("jFHCE");

var $3zv7S = parcelRequire("3zv7S");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $02ac6b4586cd5fe2$var$toggle = ({ selectedIssues: selectedIssues }, id)=>{
    if (selectedIssues[id]) return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(selectedIssues, [
        id
    ]);
    return {
        ...selectedIssues,
        [id]: true
    };
};
const $02ac6b4586cd5fe2$export$f6e36f80a8190133 = (ids)=>({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                selectedIssues: (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))((0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(ids, (id)=>id), ()=>true)
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };
const $02ac6b4586cd5fe2$export$6853837031592033 = (id)=>({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                selectedIssues: $02ac6b4586cd5fe2$var$toggle(view, id)
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };
const $02ac6b4586cd5fe2$export$a3d02541b0ebf605 = (clearIds)=>({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                selectedIssues: (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(Object.keys(view.selectedIssues), (result, id)=>clearIds.includes(id) ? result : {
                        ...result,
                        [id]: true
                    }, {})
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };

});

parcelRegister("bmUNY", function(module, exports) {

$parcel$export(module.exports, "setLayoutType", () => $c9b19b698c884289$export$df003386147115f8);


var $6SinZ = parcelRequire("6SinZ");

var $f38tt = parcelRequire("f38tt");

var $7DWfj = parcelRequire("7DWfj");

var $mJiEA = parcelRequire("mJiEA");

var $hpem9 = parcelRequire("hpem9");

var $2uYQG = parcelRequire("2uYQG");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $c9b19b698c884289$export$df003386147115f8 = (layoutType)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const viewMutation = (view)=>{
            const newView = {
                ...view,
                layoutType: view.isAutosaveEnabled ? layoutType : view.layoutType,
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    layoutType: layoutType
                }
            };
            const summaryCardField = (0, $mJiEA.getCurrentViewSummaryCardField)(getState(), props);
            if (view.kind === (0, $6SinZ.VIEW_KIND_TIMELINE) && layoutType === (0, $f38tt.ViewLayoutType).SUMMARY && !summaryCardField) {
                const firstFieldKey = (0, $7DWfj.getCurrentViewFieldKeys)(getState(), props).find((key)=>key !== (0, $9a5f06039e1dff5a$export$469f8bf472cb9ca));
                if (firstFieldKey) return (0, $2uYQG.updateSummaryCardFieldInView)(newView, props.fields[firstFieldKey]);
            }
            return newView;
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
        }
    };

});

parcelRegister("7buaW", function(module, exports) {

$parcel$export(module.exports, "loadViews", () => $31ba618b9cd7519d$export$49bbed9aa7a8df7f);
$parcel$export(module.exports, "loadView", () => $31ba618b9cd7519d$export$416273f1c1913a1c);

var $cSmYj = parcelRequire("cSmYj");

var $9g7yh = parcelRequire("9g7yh");

var $40zJW = parcelRequire("40zJW");

var $6SinZ = parcelRequire("6SinZ");

var $5zHFN = parcelRequire("5zHFN");

var $eKYK5 = parcelRequire("eKYK5");

var $1itML = parcelRequire("1itML");

var $7jTnu = parcelRequire("7jTnu");

var $8okDh = parcelRequire("8okDh");

var $jDdjf = parcelRequire("jDdjf");

var $k1VCL = parcelRequire("k1VCL");

var $238Vi = parcelRequire("238Vi");

var $1vVGo = parcelRequire("1vVGo");

var $7DWfj = parcelRequire("7DWfj");

var $gFtrn = parcelRequire("gFtrn");

var $dUql0 = parcelRequire("dUql0");

var $gxJaN = parcelRequire("gxJaN");

var $hbBW0 = parcelRequire("hbBW0");

var $9zEQq = parcelRequire("9zEQq");

var $2RFOq = parcelRequire("2RFOq");

var $egEA8 = parcelRequire("egEA8");

var $cyCtl = parcelRequire("cyCtl");

var $2Qu2F = parcelRequire("2Qu2F");

var $hsfc2 = parcelRequire("hsfc2");

var $8fYYH = parcelRequire("8fYYH");
const $31ba618b9cd7519d$var$getCurrentViewWithFallback = (currentViewSlug, viewSets)=>{
    const mainViewSet = viewSets.filter((viewSet)=>viewSet.type === 'PRIORITIZE');
    const currentView = (0, $hsfc2.findViewWithSlug)(mainViewSet, currentViewSlug);
    if (currentView !== undefined) return currentView;
    return mainViewSet[0]?.views[0];
};
const $31ba618b9cd7519d$export$49bbed9aa7a8df7f = (isInit)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { containerAri: containerAri, fields: fields, onViewLoadingFailed: onViewLoadingFailed, hasNoProjectPermissions: hasNoProjectPermissions, currentViewSlug: currentViewSlug, viewRemote: viewRemote, createAnalyticsEvent: createAnalyticsEvent, cloudId: cloudId })=>{
        if (isInit) setState((0, $k1VCL.initialState));
        if (hasNoProjectPermissions) return;
        // Bail early if we don't have what we need to load
        if (containerAri === undefined || fields === undefined || Object.keys(fields).length === 0) return;
        const fieldKeys = Object.keys(fields);
        const loadingProps = {
            containerAri: containerAri,
            fieldKeys: fieldKeys
        };
        const { forceReloadOnNextUpdate: forceReloadOnNextUpdate, meta: { loadingProps: previousLoadingProps } } = getState();
        // Only load again when the props this function depends on have changed
        // a) containerAri changed
        // b) field key set has changed. any other change to the field object should not trigger a backend load
        // c) views aren't loaded yet
        let { viewSets: viewSets } = getState();
        if (!forceReloadOnNextUpdate && containerAri === previousLoadingProps?.containerAri && (0, $5zHFN.isShallowEqual)(fieldKeys, previousLoadingProps?.fieldKeys) && viewSets.length) return;
        try {
            // when user changes to another project, load the views
            // or when the project stays the same, the views are empty
            if (forceReloadOnNextUpdate || containerAri !== previousLoadingProps?.containerAri || !viewSets.length) {
                (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_VIEWS_START));
                setState({
                    meta: {
                        loading: true,
                        error: undefined,
                        loadingProps: loadingProps
                    }
                });
                viewSets = await viewRemote.fetchAll(fields, currentViewSlug, (0, $hsfc2.checkIsViewCollapsed));
                (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_VIEWS_END));
                dispatch((0, $2RFOq.setViewSets)(viewSets));
                const currentView = $31ba618b9cd7519d$var$getCurrentViewWithFallback(currentViewSlug, viewSets);
                const currentViewId = currentView?.viewId;
                const currentViewUUID = currentView?.uuid;
                if (currentView !== undefined && currentViewId !== undefined) {
                    (0, $cyCtl.trackAtlasAnalytics)(currentView, fields);
                    (0, $cyCtl.trackAtlasSiteAnalytics)(currentView, fields, cloudId, createAnalyticsEvent);
                    dispatch((0, $hbBW0.refreshIssueRanking)(currentViewId));
                    if (currentView.kind === (0, $6SinZ.VIEW_KIND_TIMELINE)) {
                        dispatch((0, $egEA8.refreshArrangementInformation)(currentViewId));
                        if (currentViewUUID) dispatch((0, $gxJaN.loadViewMarkers)(currentViewUUID));
                    }
                }
                setState({
                    meta: {
                        ...getState().meta,
                        loading: false
                    }
                });
                if (forceReloadOnNextUpdate) dispatch((0, $9zEQq.setForceReloadViewOnNextUpdate)(false));
                return;
            }
            // update existing views in state with updated field data
            const resolvedFieldsByKey = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))((0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(fields), ({ key: key })=>key);
            const isFilterValid = (f)=>f.type !== 'FIELD' || resolvedFieldsByKey[f.field] !== undefined || f.values.length === 0;
            const updatedViewSets = viewSets.map((viewSet)=>{
                const updatedViews = viewSet.views.map((view)=>({
                        ...view,
                        filter: view.filter.filter(isFilterValid),
                        ...(0, $7jTnu.fg)('jpd_filter_groups_by_issue_type') && {
                            filterGroups: view.filterGroups.map((group)=>({
                                    ...group,
                                    filters: group.filters.filter(isFilterValid)
                                }))
                        },
                        fields: view.fields.filter((fk)=>resolvedFieldsByKey[fk] !== undefined),
                        hidden: view.hidden.filter((fk)=>resolvedFieldsByKey[fk] !== undefined),
                        sortBy: view.sortBy?.filter((s)=>resolvedFieldsByKey[s.fieldKey] !== undefined)
                    }));
                return {
                    ...viewSet,
                    views: updatedViews
                };
            });
            setState({
                meta: {
                    ...getState().meta,
                    loading: false
                },
                viewSets: updatedViewSets
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_VIEWS_END));
            setState({
                meta: {
                    loading: false,
                    error: error,
                    loadingProps: undefined
                },
                viewSets: []
            });
            onViewLoadingFailed(error);
        }
    };
const $31ba618b9cd7519d$export$416273f1c1913a1c = (id, realtimeView, onSuccess)=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const state = getState();
        const { cloudId: cloudId, viewRemote: viewRemote, onViewLoadingFailed: onViewLoadingFailed, fields: fields } = props;
        const viewAri = (0, $jDdjf.createViewAri)(cloudId, id.toString());
        const existingView = (0, $7DWfj.createGetViewByAri)(viewAri)(state);
        if (// undefined means that it wasn't RT view event
        realtimeView === undefined && !(0, $8fYYH.isViewAriInViewSets)(viewAri, state.viewSets)) return {
            isDraftReset: false
        };
        try {
            const transformedView = realtimeView || await viewRemote.fetchView(viewAri, fields);
            const viewToUpdate = (0, $7DWfj.createGetViewByAri)(viewAri)(getState());
            if (viewToUpdate?.updatedAtTimestamp && transformedView?.updatedAtTimestamp) {
                const viewUpdatedAt = new Date(viewToUpdate.updatedAtTimestamp);
                const transformedViewUpdatedAt = new Date(transformedView.updatedAtTimestamp);
                if (transformedViewUpdatedAt <= viewUpdatedAt) return {
                    isDraftReset: false
                };
            }
            // do nothing if another update request has started for the view
            // to avoid updating the state with old configuration
            if (viewToUpdate?.saving) return {
                isDraftReset: false
            };
            const { viewSets: viewSets } = getState();
            const existingViewSet = (0, $hsfc2.findViewSet)(viewSets, (viewSet)=>viewSet.id === transformedView.viewSetId);
            // do nothing if the view is created/updated in non-existing viewset
            // should be fixed once real-time events and separate queries for viewsets are introduced
            if (!existingViewSet) return {
                isDraftReset: false
            };
            const updatedViewSets = viewSets.map((viewSet)=>{
                if (viewSet.type === 'PRIORITIZE') return {
                    ...viewSet,
                    views: transformedView.viewSetId === viewSet.id ? (0, $8fYYH.upsertView)(viewSet.views, transformedView) : viewSet.views,
                    viewSets: viewSet.viewSets?.map((subViewSet)=>{
                        if (transformedView.viewSetId === subViewSet.id) return {
                            ...subViewSet,
                            views: (0, $8fYYH.upsertView)(subViewSet.views, transformedView)
                        };
                        return subViewSet;
                    })
                };
                return viewSet;
            });
            dispatch((0, $2RFOq.setViewSets)(updatedViewSets));
            onSuccess?.();
            const currentView = (0, $1vVGo.getCurrentView)(state, props);
            const isCurrentViewUpdated = existingView && currentView?.id === existingView.id;
            const updatedView = (0, $7DWfj.createGetViewByAri)(viewAri)(getState()); // needs new state since we updated it with setViewSets above
            const currentViewHasUnsavedChanges = (0, $238Vi.hasViewUnsavedChanges)(state, props);
            if (updatedView && isCurrentViewUpdated) {
                const currentViewConfigurations = (0, $2Qu2F.getAutosaveAffectedViewConfigurations)(existingView);
                const updatedViewConfigurations = (0, $2Qu2F.getAutosaveAffectedViewConfigurations)(updatedView);
                const hasConfigChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(currentViewConfigurations, updatedViewConfigurations) || existingView.isAutosaveEnabled !== updatedView.isAutosaveEnabled;
                if (currentViewHasUnsavedChanges && !hasConfigChanged) // restoring existing unsaved changes (draft) in case if properties not related to autosave config have changed
                dispatch((0, $gFtrn.setDraft)(existingView.draft));
                if (existingView.kind === (0, $6SinZ.VIEW_KIND_TIMELINE)) // restoring existing arrangementInformation
                dispatch((0, $egEA8.setArrangementInformation)(viewAri, existingView.timelineConfig?.arrangementInformation));
                return {
                    isDraftReset: currentViewHasUnsavedChanges && hasConfigChanged
                };
            }
            // restoring existing unsaved changes (draft) for current view if loaded view was different
            if (currentView && currentViewHasUnsavedChanges) dispatch((0, $gFtrn.setDraft)(currentView.draft));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof (0, $1itML.ViewNotFoundError)) dispatch((0, $dUql0.deleteViewFromState)(id));
            else if (error instanceof (0, $eKYK5.AccessNotPermittedError)) dispatch((0, $dUql0.deleteViewFromState)(id));
            else onViewLoadingFailed(error);
        }
        return {
            isDraftReset: false
        };
    };

});
parcelRegister("k1VCL", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $75acf509353512b2$export$d4c72bab9d6cc13a);
const $75acf509353512b2$export$d4c72bab9d6cc13a = {
    meta: {
        loading: true,
        error: undefined,
        loadingProps: undefined
    },
    viewSets: [],
    containerProps: undefined,
    hasUnsavedChanges: false,
    forceReloadOnNextUpdate: false,
    hasManageCurrentViewPermission: false
};

});

parcelRegister("9zEQq", function(module, exports) {

$parcel$export(module.exports, "setForceReloadViewOnNextUpdate", () => $39c0f5e65fcdf104$export$3754c2d91de44c18);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $39c0f5e65fcdf104$export$3754c2d91de44c18 = (value)=>({ setState: setState })=>{
        setState({
            forceReloadOnNextUpdate: value
        });
    };

});

parcelRegister("2RFOq", function(module, exports) {

$parcel$export(module.exports, "setViewSets", () => $2acd5fa36df54e74$export$61e8caffba15b03c);

var $7jTnu = parcelRequire("7jTnu");


var $8BCIS = parcelRequire("8BCIS");

var $ee86w = parcelRequire("ee86w");

var $Mrqhh = parcelRequire("Mrqhh");

var $hsfc2 = parcelRequire("hsfc2");
const $2acd5fa36df54e74$export$61e8caffba15b03c = (viewSets)=>({ setState: setState, dispatch: dispatch }, { fields: fields, router: router, currentViewSlug: currentViewSlug, currentViewSection: currentViewSection, isSharedView: isSharedView, isCollectionView: isCollectionView, selectedIssue: selectedIssue, onViewNotAvailableRedirect: onViewNotAvailableRedirect })=>{
        let hasCurrentView = false;
        const updated = viewSets.map((viewSet)=>{
            const views = viewSet.views.map((remoteView)=>{
                const modRemoteView = (0, $hsfc2.internRemoteView)(fields, remoteView, isSharedView, isCollectionView);
                if (currentViewSlug !== undefined && (0, $hsfc2.doesViewMatchSlug)(modRemoteView, currentViewSlug) && isSharedView !== true) {
                    hasCurrentView = true;
                    router.routeTo({
                        section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
                        resource: modRemoteView.slug
                    }, {
                        clearParameters: false,
                        replaceInHistory: true
                    });
                }
                return modRemoteView;
            });
            const newViewSets = viewSet.viewSets?.map((vSet)=>({
                    ...vSet,
                    views: vSet.views.map((remoteView)=>{
                        const modRemoteView = (0, $hsfc2.internRemoteView)(fields, remoteView, isSharedView, isCollectionView);
                        if (currentViewSlug !== undefined && (0, $hsfc2.doesViewMatchSlug)(modRemoteView, currentViewSlug) && isSharedView !== true) {
                            hasCurrentView = true;
                            router.routeTo({
                                section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
                                resource: modRemoteView.slug
                            }, {
                                clearParameters: false,
                                replaceInHistory: true
                            });
                        }
                        return modRemoteView;
                    })
                }));
            return {
                ...viewSet,
                views: views,
                viewSets: newViewSets
            };
        });
        // if there isn't a current view yet, we take the first view of the capture viewset (if there is one) including nested sections,
        // then of the prioritize viewset, otherwise the first view of a viewset that has some views
        // NOTE: in that case we do not clear the URL parameters when rerouting to the default view. This makes
        // sure we redirect to the selected issue correctly.
        let newCurrentView;
        let sectionId;
        if (currentViewSection === (0, $446867fcb16be82a$export$4fce57eba3db1f42) && !hasCurrentView) {
            const getFirstAvailableViewIdInViewSetWithType = (0, $hsfc2.getFirstAvailableViewIdInViewSet)(updated);
            const viewData = getFirstAvailableViewIdInViewSetWithType('CAPTURE') || getFirstAvailableViewIdInViewSetWithType('PRIORITIZE');
            // `setViewSets(...)` is called for `loadView` and `loadViews` actions
            // and in case when user picks a project, first the redirect chain look like
            // 1. /browse/:projectKey
            // 2. /jira/polaris/projects/:projectKey/ideas
            // 3. /jira/polaris/projects/DSA/ideas/view/1052268
            //
            // We want to replace `2.` with `3.` item in the history stack
            // as going back to `2.` would cause an infinite spinner
            const replaceInHistory = currentViewSlug === undefined;
            let redirected = false;
            if (currentViewSlug !== undefined && !selectedIssue && (0, $7jTnu.fg)('polaris_view_not_available')) ;
            else if (viewData?.view !== undefined && isSharedView !== true) {
                router.routeTo({
                    section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
                    resource: viewData.view.slug
                }, {
                    clearParameters: false,
                    replaceInHistory: replaceInHistory
                });
                redirected = true;
                newCurrentView = viewData.view;
                sectionId = viewData.sectionId;
            } else {
                const firstViewSetWithViews = updated.find((viewSet)=>viewSet.views !== undefined && viewSet.views.length > 0);
                if (firstViewSetWithViews !== undefined && isSharedView !== true) {
                    router.routeTo({
                        section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
                        resource: firstViewSetWithViews.views[0].slug
                    }, {
                        clearParameters: false,
                        replaceInHistory: replaceInHistory
                    });
                    redirected = true;
                    [newCurrentView] = firstViewSetWithViews.views;
                }
            }
            if (redirected && (0, $7jTnu.fg)('polaris_view_not_available')) onViewNotAvailableRedirect?.();
        }
        setState({
            viewSets: updated
        });
        if (sectionId !== undefined) dispatch((0, $Mrqhh.updateState)({
            id: sectionId,
            collapsed: true
        }));
        if (newCurrentView?.viewId !== undefined) {
            dispatch((0, $8BCIS.loadViewComments)(newCurrentView.viewId));
            dispatch((0, $ee86w.loadViewDescription)(newCurrentView.viewId));
        }
    };

});

parcelRegister("8fYYH", function(module, exports) {

$parcel$export(module.exports, "upsertView", () => $41330af76535b63e$export$857a42f60c2195e0);
$parcel$export(module.exports, "isViewAriInViewSets", () => $41330af76535b63e$export$dab2970f440869a6);
const $41330af76535b63e$export$857a42f60c2195e0 = (views, newView)=>{
    let isExisting = false;
    const updatedViews = views.map((view)=>{
        if (view.viewId === newView.viewId) {
            isExisting = true;
            const baseView = {
                ...newView,
                id: view.id,
                fetchCommentsTimestamp: view.fetchCommentsTimestamp,
                selectedIssues: view.selectedIssues,
                collapsedSwimlanes: view.collapsedSwimlanes,
                issueRanking: view.issueRanking,
                comments: view.comments,
                isEditingTitle: view.isEditingTitle,
                // real-time events don't contain the last viewed timestamp
                lastCommentsViewedTimestamp: newView.lastCommentsViewedTimestamp || view.lastCommentsViewedTimestamp
            };
            return {
                ...baseView,
                commentsLoadingStatus: view.commentsLoadingStatus
            };
        }
        return view;
    });
    return isExisting ? updatedViews : [
        ...updatedViews,
        newView
    ];
};
const $41330af76535b63e$export$dab2970f440869a6 = (viewAri, viewSets)=>viewSets.some((viewSet)=>{
        if (viewSet.views.some((view)=>view.viewId === viewAri)) return true;
        return viewSet.viewSets ? $41330af76535b63e$export$dab2970f440869a6(viewAri, viewSet.viewSets) : false;
    });

});


parcelRegister("cvur5", function(module, exports) {

$parcel$export(module.exports, "setFieldValues", () => $7b48625348d3bd81$export$69b675e91ad00a6c);
$parcel$export(module.exports, "setFieldValuesReverseOrder", () => $7b48625348d3bd81$export$fabf479dfda6b162);

var $jYCU4 = parcelRequire("jYCU4");

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $7b48625348d3bd81$export$69b675e91ad00a6c = (fieldValues, dimension)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const viewMutation = (view)=>{
            const matrixConfig = (0, $jYCU4.getCurrentViewMatrixConfig)(state, props);
            if (matrixConfig === undefined) return view;
            const newAxes = matrixConfig.axes.map((axis)=>{
                if (axis.dimension === dimension) {
                    const fieldOptions = axis.reversed ? [
                        ...fieldValues
                    ].reverse() : fieldValues;
                    return {
                        ...axis,
                        fieldOptions: fieldOptions
                    };
                }
                return axis;
            });
            const newMatrixConfig = {
                ...matrixConfig,
                axes: newAxes
            };
            return {
                ...view,
                matrixConfig: view.isAutosaveEnabled ? newMatrixConfig : view.matrixConfig,
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    matrixConfig: newMatrixConfig
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(props.createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: `matrixConfig.axes.${dimension}.fieldOptions`
                    }
                ]
            });
        }
    };
const $7b48625348d3bd81$export$fabf479dfda6b162 = (isReverseOrder, dimension)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const viewMutation = (view)=>{
            const matrixConfig = (0, $jYCU4.getCurrentViewMatrixConfig)(state, props);
            if (matrixConfig === undefined) return view;
            const newAxes = matrixConfig.axes.map((axis)=>{
                if (axis.dimension === dimension) return {
                    ...axis,
                    reversed: isReverseOrder
                };
                return axis;
            });
            const newMatrixConfig = {
                ...matrixConfig,
                axes: newAxes
            };
            return {
                ...view,
                matrixConfig: view.isAutosaveEnabled ? newMatrixConfig : view.matrixConfig,
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    matrixConfig: newMatrixConfig
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(props.createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: `matrixConfig.axes.${dimension}.reversed`
                    }
                ]
            });
        }
    };

});

parcelRegister("bDsnq", function(module, exports) {

$parcel$export(module.exports, "setMatrixXAxis", () => $ac6e389b3bd3745b$export$dcf9dd013f522ca3);
$parcel$export(module.exports, "setMatrixYAxis", () => $ac6e389b3bd3745b$export$24b638f354257ef2);
$parcel$export(module.exports, "setMatrixZAxis", () => $ac6e389b3bd3745b$export$2c75f254164947b5);

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");

var $3Wk5l = parcelRequire("3Wk5l");


const $ac6e389b3bd3745b$var$setMatrixAxisInternal = (oldView, allFields, fieldKey, dimension)=>{
    const { view: view, previousField: previousField } = (0, $3Wk5l.changeFieldForMatrixAxis)(oldView, dimension, fieldKey, allFields);
    const changedView = (0, $3Wk5l.addFieldToMatrixViewFieldsOrUnhide)(view, fieldKey);
    return (0, $3Wk5l.addFieldToMatrixHiddenViewFields)(changedView, previousField);
};
const $ac6e389b3bd3745b$export$dcf9dd013f522ca3 = (xAxis)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, fields: fields, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>$ac6e389b3bd3745b$var$setMatrixAxisInternal(view, fields, xAxis, 'x'));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'matrixConfig.axes.x'
                    }
                ]
            });
        }
    };
const $ac6e389b3bd3745b$export$24b638f354257ef2 = (yAxis)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, fields: fields, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>$ac6e389b3bd3745b$var$setMatrixAxisInternal(view, fields, yAxis, 'y'));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'matrixConfig.axes.y'
                    }
                ]
            });
        }
    };
const $ac6e389b3bd3745b$export$2c75f254164947b5 = (zAxis)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, fields: fields, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>$ac6e389b3bd3745b$var$setMatrixAxisInternal(view, fields, zAxis, 'z'));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'matrixConfig.axes.z'
                    }
                ]
            });
        }
    };

});
parcelRegister("3Wk5l", function(module, exports) {

$parcel$export(module.exports, "addFieldToMatrixHiddenViewFields", () => $7b08e40e3710840b$export$8097d8b232ffe999);
$parcel$export(module.exports, "addFieldToMatrixViewFieldsOrUnhide", () => $7b08e40e3710840b$export$d3fd5afd1f4a0d1b);
$parcel$export(module.exports, "changeFieldForMatrixAxis", () => $7b08e40e3710840b$export$7bea77176ba0e6ff);
const $7b08e40e3710840b$export$8097d8b232ffe999 = (view, fieldKey)=>{
    const viewOrDraft = view.isAutosaveEnabled ? view : view.draft;
    let { hidden: hidden = [] } = viewOrDraft;
    const { fields: fields = [], matrixConfig: { axes: axes = [] } = {} } = viewOrDraft;
    if (fieldKey !== undefined && fields.includes(fieldKey) && !hidden.includes(fieldKey) && !axes.some((axis)=>axis.field?.key === fieldKey)) {
        hidden = [
            ...hidden,
            fieldKey
        ];
        return {
            ...view,
            hidden: view.isAutosaveEnabled ? hidden : view.hidden,
            modified: view.isAutosaveEnabled,
            draft: {
                ...view.draft,
                hidden: hidden
            }
        };
    }
    return view;
};
const $7b08e40e3710840b$export$d3fd5afd1f4a0d1b = (view, fieldKey)=>{
    if (fieldKey === undefined) return view;
    const viewOrDraft = view.isAutosaveEnabled ? view : view.draft;
    let { fields: fields = [], hidden: hidden = [] } = viewOrDraft;
    let modified = view.modified || false;
    if (!fields.includes(fieldKey)) {
        fields = [
            ...fields,
            fieldKey
        ];
        modified = true;
    }
    if (hidden.includes(fieldKey)) {
        hidden = hidden.filter((field)=>field !== fieldKey);
        modified = true;
    }
    const changedProperties = {
        fields: fields,
        hidden: hidden
    };
    return {
        ...view,
        ...view.isAutosaveEnabled ? changedProperties : {},
        modified: view.isAutosaveEnabled ? modified : false,
        draft: {
            ...view.draft,
            ...changedProperties
        }
    };
};
const $7b08e40e3710840b$export$7bea77176ba0e6ff = (view, dimension, fieldKey, allFields)=>{
    const viewOrDraft = view.isAutosaveEnabled ? view : view.draft;
    let { matrixConfig: { axes: axes = [] } = {} } = viewOrDraft;
    axes = [
        ...axes
    ];
    let previousField;
    for(let i = axes.length - 1; i >= 0; i -= 1)if (axes[i].dimension === dimension) {
        previousField = axes[i].field?.key;
        axes.splice(i, 1);
    }
    if (fieldKey === previousField) return {
        view: view,
        previousField: previousField
    };
    if (fieldKey !== undefined) axes = [
        ...axes,
        {
            dimension: dimension,
            field: allFields[fieldKey]
        }
    ];
    const newMatrixConfig = {
        ...viewOrDraft.matrixConfig,
        axes: axes
    };
    return {
        view: {
            ...view,
            matrixConfig: view.isAutosaveEnabled ? newMatrixConfig : view.matrixConfig,
            modified: view.isAutosaveEnabled,
            draft: {
                ...view.draft,
                matrixConfig: newMatrixConfig
            }
        },
        previousField: previousField
    };
};

});


parcelRegister("bzPYi", function(module, exports) {

$parcel$export(module.exports, "switchMatrixXAndYAxis", () => $e20d41eb57b902e6$export$e14e22cbdcebb663);

var $5zHFN = parcelRequire("5zHFN");

var $jYCU4 = parcelRequire("jYCU4");

var $hpem9 = parcelRequire("hpem9");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $e20d41eb57b902e6$export$e14e22cbdcebb663 = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const viewMutation = (view)=>{
            const matrixConfig = (0, $jYCU4.getCurrentViewMatrixConfig)(state, props);
            if (matrixConfig === undefined) return view;
            const newAxes = matrixConfig.axes.map((axis)=>{
                if (axis.dimension === 'x') return {
                    ...axis,
                    dimension: 'y'
                };
                if (axis.dimension === 'y') return {
                    ...axis,
                    dimension: 'x'
                };
                return axis;
            });
            if ((0, $5zHFN.isShallowEqual)(newAxes, matrixConfig.axes)) return view;
            const newMatrixConfig = {
                ...matrixConfig,
                axes: newAxes
            };
            return {
                ...view,
                matrixConfig: view.isAutosaveEnabled ? newMatrixConfig : view.matrixConfig,
                modified: view.isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    matrixConfig: newMatrixConfig
                }
            };
        };
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(props.currentViewSlug), viewMutation);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id));
        }
    };

});

parcelRegister("8vhs6", function(module, exports) {

$parcel$export(module.exports, "setHasManageCurrentViewPermission", () => $47607b4850c3f213$export$a93b9e2dd96c6c15);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $47607b4850c3f213$export$a93b9e2dd96c6c15 = (hasManageCurrentViewPermission)=>async ({ setState: setState })=>{
        setState({
            hasManageCurrentViewPermission: hasManageCurrentViewPermission
        });
    };

});

parcelRegister("fQ9h5", function(module, exports) {

$parcel$export(module.exports, "rankViews", () => $690dad362f2c34cd$export$4a7bdc7f5489c108);
$parcel$export(module.exports, "refreshViewsRanks", () => $690dad362f2c34cd$export$a85bce1e7927e737);

var $crnx3 = parcelRequire("crnx3");

var $6kS6u = parcelRequire("6kS6u");

var $8oKDI = parcelRequire("8oKDI");

var $7DWfj = parcelRequire("7DWfj");

var $dVuZs = parcelRequire("dVuZs");

var $e1eg1 = parcelRequire("e1eg1");

var $hsfc2 = parcelRequire("hsfc2");
const $690dad362f2c34cd$export$4a7bdc7f5489c108 = (rankPayload, onSuccess, onError)=>async ({ getState: getState, setState: setState }, { viewRemote: viewRemote, onViewUpdateFailed: onViewUpdateFailed, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { id: id, index: index, parentId: parentId } = rankPayload;
        const idAri = (0, $8oKDI.toAri)(id);
        const parentIdAri = (0, $8oKDI.toAri)(parentId);
        const { viewSets: viewSets } = getState();
        const prioritizeViewSet = (0, $hsfc2.findViewSet)(viewSets, (v)=>v.type === 'PRIORITIZE');
        if (prioritizeViewSet) {
            // Save all original views
            const flatViews = [
                ...prioritizeViewSet.views
            ];
            prioritizeViewSet.viewSets?.forEach(({ views: views })=>{
                flatViews.push(...views);
            });
            try {
                if (idAri && parentIdAri) {
                    // Populate a new views
                    const node = await viewRemote.updateViewRank({
                        viewId: idAri,
                        rank: index + 1,
                        containerId: parentIdAri
                    });
                    if (node.views.length > 0) {
                        const rankedViews = [
                            ...node.views
                        ].sort(({ rank: rankA }, { rank: rankB })=>rankA - rankB);
                        const rankedViewSets = [
                            ...node.viewsets
                        ];
                        // Item was moved into section
                        if (parentId !== prioritizeViewSet.id) {
                            // First find moved item and remove it from it's original position
                            const updatedViewSet = viewSets.map((v)=>{
                                if (v.id === prioritizeViewSet.id) return {
                                    ...v,
                                    views: v.views.filter((view)=>view.viewId !== id),
                                    viewSets: v.viewSets?.map((vSet)=>{
                                        if (vSet.id === parentId) return {
                                            ...vSet,
                                            views: rankedViews.map(({ id: viewId, rank: rank })=>{
                                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                                const oldView = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(flatViews, {
                                                    viewId: viewId
                                                });
                                                const newView = {
                                                    ...oldView,
                                                    viewSetId: parentId
                                                };
                                                return {
                                                    ...newView,
                                                    ...{
                                                        rank: rank
                                                    }
                                                };
                                            })
                                        };
                                        return {
                                            ...vSet,
                                            views: vSet.views.filter((view)=>view.viewId !== id)
                                        };
                                    })
                                };
                                return v;
                            });
                            setState({
                                viewSets: updatedViewSet
                            });
                        } else {
                            // Update views with new ranks.
                            const newViews = rankedViews.map(({ id: viewId, rank: rank })=>{
                                const oldView = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(flatViews, {
                                    viewId: viewId
                                });
                                if (!oldView) return undefined;
                                return {
                                    ...oldView,
                                    rank: rank
                                };
                            }).filter(Boolean);
                            const newViewSetsUnsafe = rankedViewSets.map((vSet)=>{
                                const { collapsed: collapsed } = prioritizeViewSet.viewSets?.find(({ id: origId })=>origId === vSet.id) ?? {};
                                const setInState = (0, $hsfc2.findViewSet)(viewSets, (v)=>v.id === vSet.id);
                                if (setInState === undefined) return undefined;
                                const updatedSet = {
                                    ...setInState,
                                    rank: vSet.rank,
                                    collapsed: collapsed || false,
                                    views: vSet.views.map(({ id: viewId, rank: rank })=>{
                                        const oldView = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(flatViews, {
                                            viewId: viewId
                                        });
                                        if (!oldView) return undefined;
                                        return {
                                            ...oldView,
                                            rank: rank
                                        };
                                    }).filter(Boolean).sort(({ rank: rankA }, { rank: rankB })=>rankA - rankB)
                                };
                                return updatedSet;
                            });
                            const newViewSets = (0, (/*@__PURE__*/$parcel$interopDefault($crnx3)))(newViewSetsUnsafe);
                            // Update state with latest ranked views.
                            const updatedViewSet = viewSets.map((v)=>{
                                if (v.id === prioritizeViewSet.id) return {
                                    ...prioritizeViewSet,
                                    views: newViews,
                                    viewSets: newViewSets
                                };
                                return v;
                            });
                            setState({
                                viewSets: updatedViewSet
                            });
                        }
                    }
                    onSuccess && onSuccess();
                    const movedView = flatViews.find((v)=>v.viewId === idAri);
                    if (movedView) (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, movedView, {
                        movedFrom: movedView.viewSetId,
                        movedTo: parentIdAri
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $e1eg1.logViewError)('actions.rank', Object.assign(error));
                onViewUpdateFailed(error);
                onError && onError(error);
            }
        }
    };
const $690dad362f2c34cd$export$a85bce1e7927e737 = ()=>async ({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const { viewRemote: viewRemote, onViewUpdateFailed: onViewUpdateFailed } = props;
        const { viewSets: viewSets } = state;
        const currentViewAri = (0, $7DWfj.getCurrentViewAri)(state, props);
        try {
            const result = await viewRemote.fetchViewRanks();
            const prioritizeViewSet = result.viewsets?.find(({ type: type })=>type === 'PRIORITIZE');
            if (!prioritizeViewSet) return;
            const updatedViewSet = viewSets.map((rootViewSet)=>{
                if (rootViewSet.type !== 'PRIORITIZE') return rootViewSet;
                return {
                    ...rootViewSet,
                    views: prioritizeViewSet.views.map(({ id: id, rank: rank })=>{
                        const foundView = (0, $hsfc2.findView)(viewSets, ({ viewId: viewId })=>id === viewId);
                        if (!foundView) return undefined;
                        return {
                            ...foundView,
                            rank: rank
                        };
                    }).filter(Boolean).sort(({ rank: rankA }, { rank: rankB })=>rankA - rankB),
                    viewSets: prioritizeViewSet.viewsets.map(({ id: id, views: views, rank: rank, name: name, type: type })=>{
                        const foundViewSet = (0, $hsfc2.findViewSet)(viewSets, (vSet)=>id === vSet.id);
                        return {
                            id: id,
                            name: name,
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            type: type || 'SECTION',
                            collapsed: !!views.find((view)=>view.id === currentViewAri) || !!foundViewSet?.collapsed,
                            rank: rank,
                            views: views.map((view)=>{
                                const foundView = (0, $hsfc2.findView)(viewSets, ({ viewId: viewId })=>view.id === viewId);
                                if (!foundView) return undefined;
                                return {
                                    ...foundView,
                                    rank: view.rank
                                };
                            }).filter(Boolean).sort(({ rank: rankA }, { rank: rankB })=>rankA - rankB)
                        };
                    }).filter(Boolean).sort(({ rank: rankA }, { rank: rankB })=>rankA - rankB)
                };
            });
            setState({
                viewSets: updatedViewSet
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onViewUpdateFailed(error);
        }
    };

});

parcelRegister("gI1h5", function(module, exports) {

$parcel$export(module.exports, "moveIssuesToTopOfCurrentView", () => $9716cae4dcef9a8e$export$ae6fdfed66eec124);
$parcel$export(module.exports, "setPermanentSortFieldsOfCurrentView", () => $9716cae4dcef9a8e$export$95c8ce50042a0335);
$parcel$export(module.exports, "setSortModeOfCurrentViewToProjectRank", () => $9716cae4dcef9a8e$export$a0f4211f0e4ba46);
$parcel$export(module.exports, "setSortModeOfCurrentViewToViewRank", () => $9716cae4dcef9a8e$export$25cde230cdf77b9f);
$parcel$export(module.exports, "moveIssueInCurrentView", () => $9716cae4dcef9a8e$export$6cc08473b3cb58a1);
$parcel$export(module.exports, "insertIssueAtIndexInCurrentView", () => $9716cae4dcef9a8e$export$6dec2e2b1877b8e7);
$parcel$export(module.exports, "insertBulkIssueAtIndexInCurrentView", () => $9716cae4dcef9a8e$export$e99615da6f7e995f);

var $5zHFN = parcelRequire("5zHFN");

var $238Vi = parcelRequire("238Vi");

var $2PfqD = parcelRequire("2PfqD");

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $9716cae4dcef9a8e$var$sync = (rankingRemote, listId, viewIssueRanking, sortedIds)=>{
    if ((0, $5zHFN.isShallowEqual)(viewIssueRanking, sortedIds)) return Promise.resolve();
    return rankingRemote.moveBatchFirst({
        listId: listId,
        items: viewIssueRanking !== undefined && sortedIds.length < viewIssueRanking.length ? viewIssueRanking : sortedIds
    });
};
const $9716cae4dcef9a8e$var$updateSortConfigurationOfCurrentView = (permanentSortConfigurationTransition, sideEffects, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const { currentViewSlug: currentViewSlug, rankingRemote: rankingRemote, onViewUpdateFailed: onViewUpdateFailed, createAnalyticsEvent: createAnalyticsEvent } = props;
        const isAutosaveEnabled = (0, $238Vi.isCurrentViewAutosaveEnabled)(state, props);
        const { changedView: changedView, viewSets: viewSets, currentView: currentView } = (0, $gJX7c.updateViewState)(state.viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>{
            if (!permanentSortConfigurationTransition) return view;
            const permanentSortConfig = permanentSortConfigurationTransition ? permanentSortConfigurationTransition(view) : view;
            const draftSortConfig = permanentSortConfigurationTransition ? permanentSortConfigurationTransition(view.draft) : view.draft;
            return {
                ...view,
                ...isAutosaveEnabled && {
                    sortBy: permanentSortConfig.sortBy,
                    sortMode: permanentSortConfig.sortMode
                },
                issueRanking: permanentSortConfig.issueRanking,
                modified: isAutosaveEnabled,
                draft: {
                    ...view.draft,
                    sortBy: draftSortConfig.sortBy,
                    sortMode: draftSortConfig.sortMode
                }
            };
        });
        if (currentView && currentView.viewId && sideEffects) sideEffects(rankingRemote, currentView.viewId, currentView.issueRanking).catch(onViewUpdateFailed);
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            if (permanentSortConfigurationTransition !== undefined) {
                dispatch((0, $hpem9.saveViewWithAutoSave)(changedView.id, (view)=>{
                    if (view && view.saveError) onError?.(view.saveError);
                    else if (view && !view.saveError) onSuccess?.();
                }));
                const updatedItems = [];
                if (currentView?.sortMode !== changedView.sortMode) updatedItems.push({
                    name: 'sortMode',
                    oldVal: currentView?.sortMode,
                    newVal: changedView.sortMode
                });
                if (currentView?.sortBy !== changedView.sortBy) updatedItems.push({
                    name: 'sortBy',
                    oldVal: currentView?.sortBy,
                    newVal: changedView.sortBy
                });
                (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                    updatedItems: updatedItems
                });
            }
        }
    };
const $9716cae4dcef9a8e$export$ae6fdfed66eec124 = (ids, sortedIssueIdsOnCreation)=>$9716cae4dcef9a8e$var$updateSortConfigurationOfCurrentView((view)=>(0, $2PfqD.withMovedIssuesToTop)(view, ids, sortedIssueIdsOnCreation), (rankingRemote, viewId)=>rankingRemote.moveBatchFirst({
            listId: viewId,
            items: ids
        }));
const $9716cae4dcef9a8e$export$95c8ce50042a0335 = (sortFields, onSuccess, onError)=>$9716cae4dcef9a8e$var$updateSortConfigurationOfCurrentView((view)=>(0, $2PfqD.withSortFieldsSet)(view, sortFields), undefined, onSuccess, onError);
const $9716cae4dcef9a8e$export$a0f4211f0e4ba46 = (clearIssueRanking = false)=>$9716cae4dcef9a8e$var$updateSortConfigurationOfCurrentView((view)=>(0, $2PfqD.withProjectRankMode)(view, clearIssueRanking));
const $9716cae4dcef9a8e$export$25cde230cdf77b9f = (rankedIssueIds, overrideCurrentIssueRanking = false)=>$9716cae4dcef9a8e$var$updateSortConfigurationOfCurrentView((view)=>(0, $2PfqD.withViewRankMode)(view, rankedIssueIds, overrideCurrentIssueRanking), (rankingRemote, viewId)=>{
        if (overrideCurrentIssueRanking) return rankingRemote.create({
            listId: viewId,
            items: rankedIssueIds
        });
        return rankingRemote.get({
            listId: viewId
        }).then((result)=>{
            if (result === undefined) return rankingRemote.create({
                listId: viewId,
                items: rankedIssueIds
            });
            return Promise.resolve();
        });
    });
const $9716cae4dcef9a8e$export$6cc08473b3cb58a1 = (id, destinationBeforeId, destinationAfterId, sortedIssueIdsOnCreation)=>$9716cae4dcef9a8e$var$updateSortConfigurationOfCurrentView((view)=>(0, $2PfqD.withMovedIssue)(view, id, destinationBeforeId, destinationAfterId, sortedIssueIdsOnCreation), (rankingRemote, viewId, viewIssueRanking)=>$9716cae4dcef9a8e$var$sync(rankingRemote, viewId, viewIssueRanking, sortedIssueIdsOnCreation).then(()=>{
            if (destinationBeforeId !== undefined) return rankingRemote.moveBefore({
                listId: viewId,
                items: [
                    id
                ],
                refId: destinationBeforeId
            });
            if (destinationAfterId !== undefined) return rankingRemote.moveAfter({
                listId: viewId,
                items: [
                    id
                ],
                refId: destinationAfterId
            });
            return Promise.reject(new Error('invalid input'));
        }));
const $9716cae4dcef9a8e$export$6dec2e2b1877b8e7 = (index, id, sortedIds)=>$9716cae4dcef9a8e$var$updateSortConfigurationOfCurrentView((view)=>(0, $2PfqD.withInsertedIssue)(view, id, index, sortedIds), (rankingRemote, viewId, viewIssueRanking)=>$9716cae4dcef9a8e$var$sync(rankingRemote, viewId, viewIssueRanking, sortedIds).then(()=>{
            if (index === 0) return rankingRemote.moveFirst({
                listId: viewId,
                itemId: id
            });
            const baseRanking = viewIssueRanking !== undefined && sortedIds.length < viewIssueRanking.length ? viewIssueRanking : sortedIds;
            if (baseRanking[index - 1] !== undefined) return rankingRemote.moveAfter({
                listId: viewId,
                items: [
                    id
                ],
                refId: baseRanking[index - 1]
            });
            return Promise.reject(new Error('invalid input'));
        }));
const $9716cae4dcef9a8e$export$e99615da6f7e995f = (index, ids, sortedIds)=>$9716cae4dcef9a8e$var$updateSortConfigurationOfCurrentView((view)=>(0, $2PfqD.withInsertedIssuesBulk)(view, ids, index, sortedIds), (rankingRemote, viewId, viewIssueRanking)=>$9716cae4dcef9a8e$var$sync(rankingRemote, viewId, viewIssueRanking, sortedIds).then(()=>{
            if (index === 0) return rankingRemote.moveBatchFirst({
                listId: viewId,
                items: ids
            });
            const baseRanking = viewIssueRanking !== undefined && sortedIds.length < viewIssueRanking.length ? viewIssueRanking : sortedIds;
            if (baseRanking[index - 1] !== undefined) return rankingRemote.moveAfter({
                listId: viewId,
                items: ids,
                refId: baseRanking[index - 1]
            });
            return Promise.reject(new Error('invalid input'));
        }));

});

parcelRegister("eQSXY", function(module, exports) {

$parcel$export(module.exports, "initSwimlanes", () => $4bbe54f94b98ee9a$export$93a060e80e1f3683);
$parcel$export(module.exports, "toogleSwimlane", () => $4bbe54f94b98ee9a$export$2cf67bfd2488ab3a);
$parcel$export(module.exports, "toggleAllSwimlanes", () => $4bbe54f94b98ee9a$export$166972b586106bbc);

var $7DWfj = parcelRequire("7DWfj");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $4bbe54f94b98ee9a$export$93a060e80e1f3683 = (swimlanes)=>({ setState: setState, getState: getState }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                collapsedSwimlanes: Object.fromEntries(Object.values(swimlanes).map((key)=>[
                        key,
                        false
                    ]))
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };
const $4bbe54f94b98ee9a$export$2cf67bfd2488ab3a = (verticalGropIdentity, isHiddenByDefault)=>({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>{
            const collapsedSwimlanes = {
                ...view.collapsedSwimlanes
            };
            collapsedSwimlanes[verticalGropIdentity] = isHiddenByDefault && collapsedSwimlanes[verticalGropIdentity] === undefined ? false : !collapsedSwimlanes[verticalGropIdentity];
            return {
                ...view,
                collapsedSwimlanes: collapsedSwimlanes
            };
        });
        if (changedView) setState({
            viewSets: viewSets
        });
    };
const $4bbe54f94b98ee9a$export$166972b586106bbc = ()=>({ getState: getState, setState: setState }, props)=>{
        const { currentViewSlug: currentViewSlug } = props;
        const areAllRowGroupsCollapsed = (0, $7DWfj.areCurrentViewAllSwimlanesCollapsed)(getState(), props);
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>{
            const collapsedSwimlanes = {
                ...view.collapsedSwimlanes
            };
            Object.keys(collapsedSwimlanes).forEach((key)=>{
                collapsedSwimlanes[key] = !areAllRowGroupsCollapsed;
            });
            return {
                ...view,
                collapsedSwimlanes: collapsedSwimlanes
            };
        });
        if (changedView) setState({
            viewSets: viewSets
        });
    };

});

parcelRegister("gJziQ", function(module, exports) {

$parcel$export(module.exports, "syncViewsWithNavigation", () => $12bd7dc12e2b5ea3$export$88032d87c5a4296);

var $gtr2v = parcelRequire("gtr2v");

var $6zXPf = parcelRequire("6zXPf");

var $iPZok = parcelRequire("iPZok");


var $7buaW = parcelRequire("7buaW");

var $2RFOq = parcelRequire("2RFOq");

var $hsfc2 = parcelRequire("hsfc2");
const $12bd7dc12e2b5ea3$var$createNewViewSet = (cloudId, id, name)=>{
    const viewSetAri = (0, $gtr2v.AnyAri).create({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'viewset',
        resourceId: String(id)
    }).toString();
    const newViewSet = {
        id: viewSetAri,
        name: name,
        type: 'SECTION',
        rank: 0,
        collapsed: false,
        views: []
    };
    return newViewSet;
};
const $12bd7dc12e2b5ea3$var$createNewView = ({ cloudId: cloudId, viewSetId: viewSetId, id: id, name: name, kind: kind, emoji: emoji, viewLegacyId: viewLegacyId })=>{
    const viewAri = (0, $gtr2v.AnyAri).create({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'view',
        resourceId: String(id)
    }).toString();
    const newView = (0, $hsfc2.createNewViewEntity)(viewSetId, kind, name, 0, false);
    newView.viewId = viewAri;
    newView.emoji = emoji;
    if ((0, $6zXPf.getWillShowNav4)()) newView.viewLegacyId = viewLegacyId || parseInt(id, 10);
    else newView.viewLegacyId = parseInt(id, 10);
    newView.modified = false;
    return newView;
};
const $12bd7dc12e2b5ea3$var$updateExistingView = (view, name, emoji)=>{
    if (view.title === name && (view.emoji || '') === (emoji || '')) return view;
    const updatedView = {
        ...view,
        title: name,
        emoji: emoji
    };
    return updatedView;
};
const $12bd7dc12e2b5ea3$export$88032d87c5a4296 = (navigationViews)=>({ getState: getState, dispatch: dispatch }, { cloudId: cloudId, router: router, fields: fields, currentViewSlug: currentViewSlug, isSharedView: isSharedView, isCollectionView: isCollectionView })=>{
        if (getState().meta.loading || !getState().meta.loadingProps?.containerAri || !(0, $6zXPf.getWillShowNav4)()) return;
        let hasChanges = false;
        const viewSets = getState().viewSets;
        const changedViews = {};
        let manuallyCreatedView;
        const deletedViews = {};
        const updatedViewSets = viewSets.map((viewSet)=>{
            if (viewSet.type !== 'PRIORITIZE') return viewSet;
            const updatedViewSet = {
                ...viewSet,
                viewSets: viewSet.viewSets || [],
                views: viewSet.views || []
            };
            const viewsMap = updatedViewSet.views?.reduce((acc, view)=>{
                const { viewId: viewId } = view;
                if (!viewId) return acc;
                deletedViews[viewId] = view;
                return Object.assign(acc, {
                    [viewId]: view
                });
            }, {});
            const viewSetsMap = viewSet.viewSets?.reduce((acc, innerViewSet)=>{
                const { id: id } = innerViewSet;
                if (!id) return acc;
                innerViewSet.views?.forEach((view)=>{
                    const { viewId: viewId } = view;
                    if (!viewId) return;
                    deletedViews[viewId] = view;
                    viewsMap[viewId] = view;
                });
                return Object.assign(acc, {
                    [id]: innerViewSet
                });
            }, {}) || {};
            navigationViews.forEach((navView)=>{
                if (navView.viewType === 'SECTION') {
                    if ((0, $iPZok.isFakeId)(navView.id)) return;
                    const newViewSet = $12bd7dc12e2b5ea3$var$createNewViewSet(cloudId, String(navView.polarisId), navView.name);
                    if (!viewSetsMap[newViewSet.id]) {
                        updatedViewSet.viewSets = [
                            ...updatedViewSet.viewSets || [],
                            newViewSet
                        ];
                        viewSetsMap[newViewSet.id] = newViewSet;
                        hasChanges = true;
                    }
                    navView.views?.forEach((innerNavView)=>{
                        if (!innerNavView.viewType) return;
                        if ((0, $iPZok.isFakeId)(innerNavView.id)) return;
                        const newView = $12bd7dc12e2b5ea3$var$createNewView({
                            cloudId: cloudId,
                            viewSetId: newViewSet.id,
                            id: isCollectionView && (0, $6zXPf.getWillShowNav4)() ? innerNavView.id : String(innerNavView.polarisId),
                            name: innerNavView.name,
                            kind: innerNavView.viewType,
                            emoji: innerNavView.emoji,
                            viewLegacyId: isCollectionView && (0, $6zXPf.getWillShowNav4)() ? innerNavView.polarisId : undefined
                        });
                        if (!newView.viewId) return;
                        if (viewsMap[newView.viewId]) {
                            const updatedView = $12bd7dc12e2b5ea3$var$updateExistingView(viewsMap[newView.viewId], innerNavView.name, innerNavView.emoji);
                            if (updatedView !== viewsMap[newView.viewId]) {
                                changedViews[newView.viewId] = updatedView;
                                hasChanges = true;
                            }
                            delete deletedViews[newView.viewId];
                        } else {
                            viewSetsMap[newViewSet.id].views = [
                                ...viewSetsMap[newViewSet.id].views || [],
                                newView
                            ];
                            hasChanges = true;
                            if (innerNavView.isManuallyCreated) manuallyCreatedView = newView;
                        }
                    });
                    return;
                }
                if (!navView.viewType) return;
                if ((0, $iPZok.isFakeId)(navView.id)) return;
                const newView = $12bd7dc12e2b5ea3$var$createNewView({
                    cloudId: cloudId,
                    viewSetId: viewSet.id,
                    id: isCollectionView && (0, $6zXPf.getWillShowNav4)() ? navView.id : String(navView.polarisId),
                    name: navView.name,
                    kind: navView.viewType,
                    emoji: navView.emoji,
                    viewLegacyId: isCollectionView && (0, $6zXPf.getWillShowNav4)() ? navView.polarisId : undefined
                });
                if (!newView.viewId) return;
                if (viewsMap[newView.viewId]) {
                    const updatedView = $12bd7dc12e2b5ea3$var$updateExistingView(viewsMap[newView.viewId], navView.name, navView.emoji);
                    if (updatedView !== viewsMap[newView.viewId]) {
                        changedViews[newView.viewId] = updatedView;
                        hasChanges = true;
                    }
                    delete deletedViews[newView.viewId];
                } else {
                    updatedViewSet.views = [
                        ...viewSet.views || [],
                        newView
                    ];
                    hasChanges = true;
                    if (navView.isManuallyCreated) manuallyCreatedView = newView;
                }
            });
            return {
                ...updatedViewSet,
                views: updatedViewSet.views?.map((view)=>{
                    const { viewId: viewId } = view;
                    if (!viewId) return view;
                    if (deletedViews[viewId]) return undefined;
                    if (changedViews[viewId]) return {
                        ...changedViews[viewId]
                    };
                    return view;
                }).filter(Boolean),
                viewSets: updatedViewSet.viewSets?.map((innerViewSet)=>({
                        ...innerViewSet,
                        views: innerViewSet.views?.map((view)=>{
                            const { viewId: viewId } = view;
                            if (!viewId) return view;
                            if (deletedViews[viewId]) return undefined;
                            if (changedViews[viewId]) return {
                                ...changedViews[viewId]
                            };
                            return view;
                        }).filter(Boolean)
                    }))
            };
        });
        if (hasChanges || Object.keys(deletedViews).length) {
            dispatch((0, $2RFOq.setViewSets)(updatedViewSets));
            const viewIdToLoad = isCollectionView && manuallyCreatedView?.viewId && (0, $6zXPf.getWillShowNav4)() ? (0, $gtr2v.AnyAri).parse(manuallyCreatedView.viewId).resourceId : manuallyCreatedView?.viewLegacyId;
            if (viewIdToLoad) dispatch((0, $7buaW.loadView)(viewIdToLoad, undefined, ()=>{
                if (manuallyCreatedView === undefined) return;
                const modRemoteView = (0, $hsfc2.internRemoteView)(fields, manuallyCreatedView, isSharedView, isCollectionView);
                if (currentViewSlug !== undefined && !(0, $hsfc2.doesViewMatchSlug)(modRemoteView, currentViewSlug) && isSharedView !== true) router.routeTo({
                    section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
                    resource: modRemoteView.slug
                });
            }));
            else {
                const isCurrentViewDeleted = Object.values(deletedViews).some((view)=>{
                    return isSharedView !== true && currentViewSlug !== undefined && (0, $hsfc2.doesViewMatchSlug)(view, currentViewSlug);
                });
                if (currentViewSlug !== undefined && isCurrentViewDeleted && isSharedView !== true) {
                    const getFirstAvailableViewIdInViewSetWithType = (0, $hsfc2.getFirstAvailableViewIdInViewSet)(updatedViewSets);
                    const newCurrentViewData = getFirstAvailableViewIdInViewSetWithType('CAPTURE') ?? getFirstAvailableViewIdInViewSetWithType('PRIORITIZE');
                    newCurrentViewData?.view?.slug && router.routeTo({
                        section: (0, $446867fcb16be82a$export$4fce57eba3db1f42),
                        resource: newCurrentViewData?.view?.slug
                    });
                }
            }
        }
    };

});

parcelRegister("dnEJE", function(module, exports) {

$parcel$export(module.exports, "renameCurrentView", () => $2508dfb58a0b1184$export$16c7316753f09606);
$parcel$export(module.exports, "setEditCurrentViewTitle", () => $2508dfb58a0b1184$export$f485906262a3ae56);
$parcel$export(module.exports, "renameView", () => $2508dfb58a0b1184$export$cbdb30d002054b2e);
$parcel$export(module.exports, "addViewEmoji", () => $2508dfb58a0b1184$export$26891b139ebf57cf);
$parcel$export(module.exports, "addCurrentViewEmoji", () => $2508dfb58a0b1184$export$d6dc3e3618e40d1b);

var $hpem9 = parcelRequire("hpem9");

var $dVuZs = parcelRequire("dVuZs");

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");

var $9vY0e = parcelRequire("9vY0e");
const $2508dfb58a0b1184$export$16c7316753f09606 = (title, onAfterSave)=>({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, onSyncViewName: onSyncViewName })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                title: title,
                isEditingTitle: false,
                modified: true
            }));
        if (!changedView) return;
        setState({
            viewSets: viewSets
        });
        dispatch((0, $hpem9.saveView)(changedView.id, onAfterSave));
        const viewId = (0, $9vY0e.getUniversalViewId)(changedView);
        if (viewId) onSyncViewName(viewId, changedView.kind, title);
    };
const $2508dfb58a0b1184$export$f485906262a3ae56 = (isEditing)=>({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                isEditingTitle: isEditing
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };
const $2508dfb58a0b1184$export$cbdb30d002054b2e = (id, title, onAfterSave)=>({ getState: getState, setState: setState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.id === id, (view)=>({
                ...view,
                title: title,
                isEditingTitle: false,
                modified: true
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveView)(changedView.id, onAfterSave));
            (0, $dVuZs.fireViewUpdatedEvent)(createAnalyticsEvent, changedView, {
                updatedItems: [
                    {
                        name: 'name'
                    }
                ]
            });
        }
    };
const $2508dfb58a0b1184$export$26891b139ebf57cf = (id, emoji)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (view)=>view.id === id, (view)=>({
                ...view,
                emoji: emoji,
                modified: true
            }));
        if (changedView) {
            setState({
                viewSets: viewSets
            });
            dispatch((0, $hpem9.saveView)(changedView.id));
        }
    };
const $2508dfb58a0b1184$export$d6dc3e3618e40d1b = (emoji)=>({ getState: getState, setState: setState, dispatch: dispatch }, { currentViewSlug: currentViewSlug, onSyncViewEmoji: onSyncViewEmoji })=>{
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(getState().viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                emoji: emoji,
                modified: true
            }));
        if (!changedView) return;
        setState({
            viewSets: viewSets
        });
        dispatch((0, $hpem9.saveView)(changedView.id));
        const viewId = (0, $9vY0e.getUniversalViewId)(changedView);
        if (viewId) onSyncViewEmoji(viewId, changedView.kind, emoji);
    };

});

parcelRegister("eG9EU", function(module, exports) {

$parcel$export(module.exports, "setUnsavedChanges", () => $48d4c937a43d54d3$export$278d42400282afa6);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $48d4c937a43d54d3$export$278d42400282afa6 = (unsavedChanges)=>({ setState: setState })=>{
        setState({
            hasUnsavedChanges: unsavedChanges
        });
    };

});

parcelRegister("1H8iA", function(module, exports) {

$parcel$export(module.exports, "setLastSelectedIssueTypeId", () => $26ef70348e9e83a3$export$8f1201260697587f);

var $gJX7c = parcelRequire("gJX7c");

var $hsfc2 = parcelRequire("hsfc2");
const $26ef70348e9e83a3$export$8f1201260697587f = (issueTypeId)=>async ({ getState: getState, setState: setState }, { currentViewSlug: currentViewSlug })=>{
        const state = getState();
        const { changedView: changedView, viewSets: viewSets } = (0, $gJX7c.updateViewState)(state.viewSets, (0, $hsfc2.currentViewFilter)(currentViewSlug), (view)=>({
                ...view,
                lastSelectedIssueTypeId: issueTypeId
            }));
        if (changedView) setState({
            viewSets: viewSets
        });
    };

});


parcelRegister("2zM3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $32cb8d96cf0e222a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $32cb8d96cf0e222a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewDeleted: {
        "id": "polaris-common.controllers.views.view-deleted",
        "defaultMessage": "The view you had opened was deleted by {userName, select, undefined {another user} other {{userName}}}"
    },
    viewUpdated: {
        "id": "polaris-common.controllers.views.view-updated",
        "defaultMessage": "The view's configuration was saved by {userName, select, undefined {someone else} other {{userName}}}, so we've reset your changes"
    }
});

});




parcelRegister("4znIY", function(module, exports) {

$parcel$export(module.exports, "useHasViewSetsError", () => $dc5d9309a6daedd3$export$eab3c05f376c367d);
$parcel$export(module.exports, "useHasCurrentView", () => $dc5d9309a6daedd3$export$3ca9e390654cca);
$parcel$export(module.exports, "useCurrentViewKind", () => $dc5d9309a6daedd3$export$fbea0e405c4ea145);
$parcel$export(module.exports, "usePreviousViewKind", () => $dc5d9309a6daedd3$export$4f70156ffb583c98);
$parcel$export(module.exports, "useAllViewFields", () => $dc5d9309a6daedd3$export$fcbd86fa8f928f0f);
$parcel$export(module.exports, "useCurrentViewFields", () => $dc5d9309a6daedd3$export$91dbe90818272dec);
$parcel$export(module.exports, "useCurrentViewFieldKeys", () => $dc5d9309a6daedd3$export$ddfae192763a4e35);
$parcel$export(module.exports, "useCurrentViewHiddenFieldKeys", () => $dc5d9309a6daedd3$export$d5bafa4546856cfb);
$parcel$export(module.exports, "useCurrentViewVisibleFields", () => $dc5d9309a6daedd3$export$40ca69ba2ce48efb);
$parcel$export(module.exports, "useCurrentViewId", () => $dc5d9309a6daedd3$export$801506630c7c2739);
$parcel$export(module.exports, "useCurrentViewSlug", () => $dc5d9309a6daedd3$export$b61f4aaa98a40ed1);
$parcel$export(module.exports, "useCurrentViewAri", () => $dc5d9309a6daedd3$export$4a70f6e9f97b2e86);
$parcel$export(module.exports, "useCurrentViewFieldsUnsupportedForSharing", () => $dc5d9309a6daedd3$export$6424b3e0d6103158);
$parcel$export(module.exports, "useCurrentViewHasAtlasFieldsInConfig", () => $dc5d9309a6daedd3$export$19181e430bb0765e);
$parcel$export(module.exports, "useCurrentViewHasStatusFieldsInConfig", () => $dc5d9309a6daedd3$export$4ddf6694fb4df08e);
$parcel$export(module.exports, "useCurrentViewHasTypeField", () => $dc5d9309a6daedd3$export$83078954f9560683);
$parcel$export(module.exports, "useCurrentViewProjectId", () => $dc5d9309a6daedd3$export$991f4ea7db83905d);
$parcel$export(module.exports, "useCurrentViewSortBy", () => $dc5d9309a6daedd3$export$66c3949700e16547);
$parcel$export(module.exports, "useCurrentViewPermanentSortBy", () => $dc5d9309a6daedd3$export$8dab3a8c0f8f2887);
$parcel$export(module.exports, "useCurrentViewSortByField", () => $dc5d9309a6daedd3$export$f596d1c8fb67cea7);
$parcel$export(module.exports, "useCurrentSortByFieldCount", () => $dc5d9309a6daedd3$export$6b66a45b52f2092);
$parcel$export(module.exports, "useCurrentViewIssueRanking", () => $dc5d9309a6daedd3$export$49fb9199418ad53e);
$parcel$export(module.exports, "useCurrentViewSortMode", () => $dc5d9309a6daedd3$export$c15575f566190f15);
$parcel$export(module.exports, "useCurrentViewInViewSortMode", () => $dc5d9309a6daedd3$export$3839677d97dfd970);
$parcel$export(module.exports, "useIsManualIdeaRankingPossibleInCurrentView", () => $dc5d9309a6daedd3$export$d3aaf729b79e1dbb);
$parcel$export(module.exports, "useHasSharedViewConfigError", () => $dc5d9309a6daedd3$export$6660ac9dc8af6f60);
$parcel$export(module.exports, "useCurrentViewGroupBy", () => $dc5d9309a6daedd3$export$23594f934df22b9);
$parcel$export(module.exports, "useCurrentViewHideEmptyGroups", () => $dc5d9309a6daedd3$export$77152ca874240d3b);
$parcel$export(module.exports, "useCurrentViewHideEmptyBoardColumns", () => $dc5d9309a6daedd3$export$5b74c0a76afd4f6b);
$parcel$export(module.exports, "useCurrentViewVerticalGroupBy", () => $dc5d9309a6daedd3$export$ec71175f8f377894);
$parcel$export(module.exports, "useCurrentViewContainsArchived", () => $dc5d9309a6daedd3$export$d0918ecd1ffe2b4d);
$parcel$export(module.exports, "useCurrentViewGroupValues", () => $dc5d9309a6daedd3$export$7b99e6ef309a21a2);
$parcel$export(module.exports, "useCurrentViewVerticalGroupValues", () => $dc5d9309a6daedd3$export$9ca57cd6922eb81d);
$parcel$export(module.exports, "useSelectedIssueIds", () => $dc5d9309a6daedd3$export$e4c5c56c158df062);
$parcel$export(module.exports, "useCurrentViewSelectedIssueIdsAsList", () => $dc5d9309a6daedd3$export$73db1b6d559d1cdf);
$parcel$export(module.exports, "useCurrentViewTitle", () => $dc5d9309a6daedd3$export$4334cb7bb3bb1fd5);
$parcel$export(module.exports, "useCurrentViewUUID", () => $dc5d9309a6daedd3$export$7861f6d98463d18f);
$parcel$export(module.exports, "useCurrentViewRank", () => $dc5d9309a6daedd3$export$3df892b432d3ad4a);
$parcel$export(module.exports, "useCurrentViewEmoji", () => $dc5d9309a6daedd3$export$8ee3f63f4a93ef1f);
$parcel$export(module.exports, "useCurrentViewDescription", () => $dc5d9309a6daedd3$export$d123fb4c7c9b59cd);
$parcel$export(module.exports, "useViewDescriptionLoadingStatus", () => $dc5d9309a6daedd3$export$505e8cd7574ee94f);
$parcel$export(module.exports, "useAutoOpenSidebarCondition", () => $dc5d9309a6daedd3$export$c60eaaa6023f26b5);
$parcel$export(module.exports, "useCurrentViewIsEditingTitle", () => $dc5d9309a6daedd3$export$e25ac63ffecb2802);
$parcel$export(module.exports, "useCurrentViewFieldCount", () => $dc5d9309a6daedd3$export$3fad9aabd9ff34d1);
$parcel$export(module.exports, "useCurrentViewCollapsedSwimlanes", () => $dc5d9309a6daedd3$export$f3bfd09e9f75221e);
$parcel$export(module.exports, "useCurrentViewTableColumnSizesByFieldKey", () => $dc5d9309a6daedd3$export$41d571c889be0009);
$parcel$export(module.exports, "useCurrentViewTableColumnSize", () => $dc5d9309a6daedd3$export$a45914b045364368);
$parcel$export(module.exports, "useCanManageCurrentView", () => $dc5d9309a6daedd3$export$bd5b60e4e12f5aac);
$parcel$export(module.exports, "useCurrentViewAccessLevel", () => $dc5d9309a6daedd3$export$56e58c1034fc5299);
$parcel$export(module.exports, "useIsCurrentViewGroupedList", () => $dc5d9309a6daedd3$export$beeaec3b505996a7);
$parcel$export(module.exports, "useViewSetName", () => $dc5d9309a6daedd3$export$c4e44c99063514c5);
$parcel$export(module.exports, "useViewIdsInViewSet", () => $dc5d9309a6daedd3$export$4b282f0dbee79fe3);
$parcel$export(module.exports, "useAllIdeasViewId", () => $dc5d9309a6daedd3$export$4cc9a32fcba81ecb);
$parcel$export(module.exports, "usePinnedViewId", () => $dc5d9309a6daedd3$export$200fb1d8836b0696);
$parcel$export(module.exports, "usePinnedViewFields", () => $dc5d9309a6daedd3$export$eced229b51d0d052);
$parcel$export(module.exports, "usePinnedViewFieldsForSmartCard", () => $dc5d9309a6daedd3$export$726555ef35ffa48b);
$parcel$export(module.exports, "useArchiveViewId", () => $dc5d9309a6daedd3$export$bdcbebad0e3851cb);
$parcel$export(module.exports, "useViewSlugByRank", () => $dc5d9309a6daedd3$export$6041ff8e4e880ddf);
$parcel$export(module.exports, "useHasViewsAtlasFields", () => $dc5d9309a6daedd3$export$d816dbdad7b8817);
$parcel$export(module.exports, "useIsCurrentViewInCaptureSet", () => $dc5d9309a6daedd3$export$f4f19290a9abc833);
$parcel$export(module.exports, "useViewUUID", () => $dc5d9309a6daedd3$export$735f1ad2de478282);
$parcel$export(module.exports, "useViewAri", () => $dc5d9309a6daedd3$export$b6b78fb187396ce9);
$parcel$export(module.exports, "useViewSlug", () => $dc5d9309a6daedd3$export$5ce0e651e95b8146);
$parcel$export(module.exports, "useViewKind", () => $dc5d9309a6daedd3$export$b63d810955f435e8);
$parcel$export(module.exports, "useViewTitle", () => $dc5d9309a6daedd3$export$8836f3a3dbe72038);
$parcel$export(module.exports, "useViewEmoji", () => $dc5d9309a6daedd3$export$681219aaf7605d9f);
$parcel$export(module.exports, "useViewContainsArchived", () => $dc5d9309a6daedd3$export$ccd9ee8afaae6d5b);
$parcel$export(module.exports, "useViewFilter", () => $dc5d9309a6daedd3$export$a151b224eb5d6f74);
$parcel$export(module.exports, "useViewFilterLength", () => $dc5d9309a6daedd3$export$c21f92b1fbcefbcf);
$parcel$export(module.exports, "useViewFilterTypes", () => $dc5d9309a6daedd3$export$eed06533b9d0c8f6);
$parcel$export(module.exports, "useViewFieldTypes", () => $dc5d9309a6daedd3$export$414f6e1c77373b9a);
$parcel$export(module.exports, "useViewFieldKeys", () => $dc5d9309a6daedd3$export$f9969a6c4cc42a1c);
$parcel$export(module.exports, "useViewFieldKeysByAri", () => $dc5d9309a6daedd3$export$9f6c625b5c73222f);
$parcel$export(module.exports, "useValidIssueSubmissionFormFieldKeys", () => $dc5d9309a6daedd3$export$fc6c1ee39ba6fada);
$parcel$export(module.exports, "useInvalidIssueSubmissionFormFieldLabels", () => $dc5d9309a6daedd3$export$10182bd3f9bb4dce);
$parcel$export(module.exports, "useViewSortFieldTypes", () => $dc5d9309a6daedd3$export$f7ebb070be6582dc);
$parcel$export(module.exports, "useViewGroupBy", () => $dc5d9309a6daedd3$export$23b8f03d0ca70cf8);
$parcel$export(module.exports, "useViewGroupValues", () => $dc5d9309a6daedd3$export$7ee5ac52f62e894a);
$parcel$export(module.exports, "useViewTypeCount", () => $dc5d9309a6daedd3$export$26a4a92f70a221c5);
$parcel$export(module.exports, "useViewsCountFromViewSetTypes", () => $dc5d9309a6daedd3$export$c52e95650b26b4c9);
$parcel$export(module.exports, "useSystemViewsContainingArchived", () => $dc5d9309a6daedd3$export$a654e333608d27fe);
$parcel$export(module.exports, "useSystemViewsNotContainingArchived", () => $dc5d9309a6daedd3$export$d5dc136422ce3421);
$parcel$export(module.exports, "useCurrentViewXAxisField", () => $dc5d9309a6daedd3$export$da76acc4b144e61);
$parcel$export(module.exports, "useCurrentViewYAxisField", () => $dc5d9309a6daedd3$export$8aa863dd02fe5f12);
$parcel$export(module.exports, "useCurrentViewXAxis", () => $dc5d9309a6daedd3$export$cff831211aefab53);
$parcel$export(module.exports, "useCurrentViewYAxis", () => $dc5d9309a6daedd3$export$ba931817c61d02e2);
$parcel$export(module.exports, "useCurrentViewZAxis", () => $dc5d9309a6daedd3$export$b6a841611a23d51c);
$parcel$export(module.exports, "useCurrentViewConfigured", () => $dc5d9309a6daedd3$export$e2d397e41953000d);
$parcel$export(module.exports, "useCurrentMatrixOptionsHasReverseOrder", () => $dc5d9309a6daedd3$export$50729bf13d5e392e);
$parcel$export(module.exports, "useCurrentMatrixFieldOptions", () => $dc5d9309a6daedd3$export$fc5171b79d010494);
$parcel$export(module.exports, "useCurrentViewTimelineMarkers", () => $dc5d9309a6daedd3$export$12c33fffcd8e2293);
$parcel$export(module.exports, "useCurrentViewTimelineMode", () => $dc5d9309a6daedd3$export$c3f99cf44594f91c);
$parcel$export(module.exports, "useCurrentViewStartDateField", () => $dc5d9309a6daedd3$export$95477f0965d5a07b);
$parcel$export(module.exports, "useCurrentViewEndDateField", () => $dc5d9309a6daedd3$export$4751b7e28c0799ea);
$parcel$export(module.exports, "useCurrentViewTimelineIntervalStartDate", () => $dc5d9309a6daedd3$export$41c42b0966e8dc3e);
$parcel$export(module.exports, "useCurrentViewTimelineIntervalEndDate", () => $dc5d9309a6daedd3$export$788af0b1aca129f2);
$parcel$export(module.exports, "useCurrentViewSummaryCardField", () => $dc5d9309a6daedd3$export$49c919623c4a7e0e);
$parcel$export(module.exports, "useHasUnsavedChanges", () => $dc5d9309a6daedd3$export$d85ed874af6294e9);
$parcel$export(module.exports, "useCurrentViewArrangementInformation", () => $dc5d9309a6daedd3$export$e40e504ce855afb7);
$parcel$export(module.exports, "useIsCurrentViewAutosaveEnabled", () => $dc5d9309a6daedd3$export$f7798877d15f3614);
$parcel$export(module.exports, "useHasVerticalGroupByUnsavedChanges", () => $dc5d9309a6daedd3$export$b58f4c0b32b944a);
$parcel$export(module.exports, "useHasGroupByUnsavedChanges", () => $dc5d9309a6daedd3$export$29c63891e7d1e239);
$parcel$export(module.exports, "useHasFiltersUnsavedChanges", () => $dc5d9309a6daedd3$export$ca574dc9a980ff8);
$parcel$export(module.exports, "useHasSortUnsavedChanges", () => $dc5d9309a6daedd3$export$5871acf91c40a235);
$parcel$export(module.exports, "useHasFieldsUnsavedChanges", () => $dc5d9309a6daedd3$export$43633c3c22fddaf2);
$parcel$export(module.exports, "useHasMatrixXAxisUnsavedChanges", () => $dc5d9309a6daedd3$export$6e56755299ab7ef0);
$parcel$export(module.exports, "useHasMatrixYAxisUnsavedChanges", () => $dc5d9309a6daedd3$export$90264e2a80211e74);
$parcel$export(module.exports, "useHasMatrixZAxisUnsavedChanges", () => $dc5d9309a6daedd3$export$496ccbf86f0e16f0);
$parcel$export(module.exports, "useHasTimelineConfigUnsavedChanges", () => $dc5d9309a6daedd3$export$62f8ac151a9a7067);
$parcel$export(module.exports, "useHasLayoutTypeUnsavedChanges", () => $dc5d9309a6daedd3$export$35fe3ca7f01d0248);
$parcel$export(module.exports, "useHasViewUnsavedChanges", () => $dc5d9309a6daedd3$export$e0cda647115ce1);
$parcel$export(module.exports, "useCurrentViewLayoutType", () => $dc5d9309a6daedd3$export$85d398798ef59b95);
$parcel$export(module.exports, "useViewIdsConfiguredByField", () => $dc5d9309a6daedd3$export$7ca9638a48d73e2);
$parcel$export(module.exports, "usePrioritizeViews", () => $dc5d9309a6daedd3$export$cf4d4f56c95d18fd);
$parcel$export(module.exports, "useViewAnalyticsData", () => $dc5d9309a6daedd3$export$18fa221ffbd573c9);
$parcel$export(module.exports, "useAllViewsNameAndIds", () => $dc5d9309a6daedd3$export$a5c19d17aeeac897);
$parcel$export(module.exports, "useCurrentViewRankFieldKey", () => $dc5d9309a6daedd3$export$d874b677cc715da7);
$parcel$export(module.exports, "useCurrentViewVisibleFieldKeys", () => $dc5d9309a6daedd3$export$de2e658806072a22);
$parcel$export(module.exports, "useCurrentViewColumnIds", () => $dc5d9309a6daedd3$export$cac33b5596be3635);
$parcel$export(module.exports, "useIsFieldVisibleInCurrentView", () => $dc5d9309a6daedd3$export$ee25dd74640e16aa);
$parcel$export(module.exports, "useCurrentViewVisibleIssueActionFields", () => $dc5d9309a6daedd3$export$a98588ca4064a16b);
$parcel$export(module.exports, "usePinnedViewActionFieldKeys", () => $dc5d9309a6daedd3$export$ba29815e12cbe31);
$parcel$export(module.exports, "useCurrentViewActionFieldKeys", () => $dc5d9309a6daedd3$export$2731283689f6abe4);
$parcel$export(module.exports, "useBoardViewVisibleFields", () => $dc5d9309a6daedd3$export$4ee9f4ceac12f4d4);
$parcel$export(module.exports, "useMatrixViewVisibleFields", () => $dc5d9309a6daedd3$export$abbd195de5f0f3cb);
$parcel$export(module.exports, "useTimelineViewVisibleFields", () => $dc5d9309a6daedd3$export$301c85abdd9aa231);
$parcel$export(module.exports, "useStatusCategoriesForPublishedView", () => $dc5d9309a6daedd3$export$e158690ae807086b);
$parcel$export(module.exports, "useCurrentViewSummaryCardFieldKey", () => $dc5d9309a6daedd3$export$76ff15920dd87b14);
$parcel$export(module.exports, "useHasReachedViewFieldsLimit", () => $dc5d9309a6daedd3$export$88196a639ac369b3);
$parcel$export(module.exports, "useCanManageView", () => $dc5d9309a6daedd3$export$f7520036241cebec);
$parcel$export(module.exports, "useRemoveViewIfNoAccess", () => $dc5d9309a6daedd3$export$9fb1de3efd945914);
$parcel$export(module.exports, "useViewAccessLevel", () => $dc5d9309a6daedd3$export$ad155a33c34c6cec);
$parcel$export(module.exports, "useCanManageAdvancedSortConfig", () => $dc5d9309a6daedd3$export$75a7a6424bd21069);
$parcel$export(module.exports, "useCurrentViewLastSelectedIssueTypeId", () => $dc5d9309a6daedd3$export$e1b1e542390290f1);
$parcel$export(module.exports, "useCurrentViewConnectionFieldKeys", () => $dc5d9309a6daedd3$export$8f67703d50e884e7);
$parcel$export(module.exports, "useCurrentViewHasConnectionFields", () => $dc5d9309a6daedd3$export$e810b5be9f4da246);
$parcel$export(module.exports, "useCurrentViewHasGlobalConnectionFields", () => $dc5d9309a6daedd3$export$c98ef173ed9364d5);
$parcel$export(module.exports, "useCurrentViewHasCrossProjectConnectionFields", () => $dc5d9309a6daedd3$export$92808cef6b54cf04);
$parcel$export(module.exports, "useIsCurrentViewAvailable", () => $dc5d9309a6daedd3$export$a4dc4c8bb49fb3d4);
$parcel$export(module.exports, "useCurrentViewConnectionFieldsIssueTypes", () => $dc5d9309a6daedd3$export$9e7ca5139d4c2b98);

var $jn3Ea = parcelRequire("jn3Ea");

var $70fba = parcelRequire("70fba");

var $3Jfcg = parcelRequire("3Jfcg");

var $5zam7 = parcelRequire("5zam7");

var $iB16t = parcelRequire("iB16t");

var $69PvG = parcelRequire("69PvG");

var $eFrz1 = parcelRequire("eFrz1");

var $cQ9m7 = parcelRequire("cQ9m7");

var $5xmeX = parcelRequire("5xmeX");

var $hbF3h = parcelRequire("hbF3h");

var $7jTnu = parcelRequire("7jTnu");

var $kmMXp = parcelRequire("kmMXp");

var $Xp2c2 = parcelRequire("Xp2c2");

var $a7FjO = parcelRequire("a7FjO");

var $238Vi = parcelRequire("238Vi");

var $1vVGo = parcelRequire("1vVGo");

var $7DWfj = parcelRequire("7DWfj");

var $dIHYC = parcelRequire("dIHYC");

var $jYCU4 = parcelRequire("jYCU4");

var $jAuoP = parcelRequire("jAuoP");

var $mJiEA = parcelRequire("mJiEA");

var $6AI7I = parcelRequire("6AI7I");

var $9PAQN = parcelRequire("9PAQN");
const $dc5d9309a6daedd3$export$6ee9dc95d0f33cb9 = (0, $a7FjO.createViewHook)((0, $1vVGo.getCurrentView));
const $dc5d9309a6daedd3$export$eab3c05f376c367d = (0, $a7FjO.createViewHook)((0, $9PAQN.getHasViewSetsError));
const $dc5d9309a6daedd3$export$3ca9e390654cca = (0, $a7FjO.createViewHook)((0, $7DWfj.getHasCurrentView));
const $dc5d9309a6daedd3$export$fbea0e405c4ea145 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewKind));
const $dc5d9309a6daedd3$export$4f70156ffb583c98 = (0, $a7FjO.createViewHook)((0, $7DWfj.getPreviousViewKind));
const $dc5d9309a6daedd3$export$fcbd86fa8f928f0f = (0, $a7FjO.createViewHook)((0, $7DWfj.getAllViewFields));
const $dc5d9309a6daedd3$export$91dbe90818272dec = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewFields));
const $dc5d9309a6daedd3$export$7e37cbe73ac86747 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewHiddenFields));
const $dc5d9309a6daedd3$export$ddfae192763a4e35 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewFieldKeys));
const $dc5d9309a6daedd3$export$d5bafa4546856cfb = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewHiddenFieldKeys));
const $dc5d9309a6daedd3$export$40ca69ba2ce48efb = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewVisibleFields));
const $dc5d9309a6daedd3$export$801506630c7c2739 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewId));
const $dc5d9309a6daedd3$export$b61f4aaa98a40ed1 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewSlug));
const $dc5d9309a6daedd3$export$4a70f6e9f97b2e86 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewAri));
const $dc5d9309a6daedd3$export$6424b3e0d6103158 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewFieldsUnsupportedForSharing));
const $dc5d9309a6daedd3$export$19181e430bb0765e = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewHasAtlasFieldsInConfig));
const $dc5d9309a6daedd3$export$4ddf6694fb4df08e = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewHasStatusFieldsInConfig));
const $dc5d9309a6daedd3$export$83078954f9560683 = (0, $hbF3h.functionUnionWithCondition)(()=>(0, $7jTnu.fg)('jpd_issue-types-instrumentation'), (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewHasTypeField)), ()=>undefined);
const $dc5d9309a6daedd3$export$991f4ea7db83905d = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewProjectId));
const $dc5d9309a6daedd3$export$66c3949700e16547 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewSortBy));
const $dc5d9309a6daedd3$export$8dab3a8c0f8f2887 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewPermanentSortBy));
const $dc5d9309a6daedd3$export$f596d1c8fb67cea7 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.getCurrentViewSortByField));
const $dc5d9309a6daedd3$export$6b66a45b52f2092 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewSortByFieldCount));
const $dc5d9309a6daedd3$export$49fb9199418ad53e = (0, $a7FjO.createViewHook)((0, $6AI7I.getCurrentViewIssueRanking));
const $dc5d9309a6daedd3$export$c15575f566190f15 = (0, $a7FjO.createViewHook)((0, $6AI7I.getCurrentViewSortMode));
const $dc5d9309a6daedd3$export$3839677d97dfd970 = (0, $a7FjO.createViewHook)((0, $6AI7I.isCurrentViewSortModeViewRank));
const $dc5d9309a6daedd3$export$d3aaf729b79e1dbb = (0, $a7FjO.createViewHook)((0, $6AI7I.isManualIdeaRankingPossibleInCurrentView));
const $dc5d9309a6daedd3$export$6660ac9dc8af6f60 = (0, $a7FjO.createViewHook)((0, $1vVGo.hasSharedViewConfigError));
const $dc5d9309a6daedd3$export$df1bc432d6c01533 = (0, $a7FjO.createViewHook)((0, $7DWfj.isLastView));
const $dc5d9309a6daedd3$export$23594f934df22b9 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewGroupBy));
const $dc5d9309a6daedd3$export$77152ca874240d3b = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentHideEmptyGroups));
const $dc5d9309a6daedd3$export$5b74c0a76afd4f6b = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentHideEmptyBoardColumns));
const $dc5d9309a6daedd3$export$ec71175f8f377894 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewVerticalGroupBy));
const $dc5d9309a6daedd3$export$d0918ecd1ffe2b4d = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewContainsArchived));
const $dc5d9309a6daedd3$export$7b99e6ef309a21a2 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewGroupValues));
const $dc5d9309a6daedd3$export$9ca57cd6922eb81d = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewVerticalGroupValues));
const $dc5d9309a6daedd3$export$e4c5c56c158df062 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewSelectedIssueIds));
const $dc5d9309a6daedd3$export$23e27dafe5486fac = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewBulkEditHoveredFieldKey));
const $dc5d9309a6daedd3$export$73db1b6d559d1cdf = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewSelectedIssueIdsAsList));
const $dc5d9309a6daedd3$export$4334cb7bb3bb1fd5 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewTitle));
const $dc5d9309a6daedd3$export$7861f6d98463d18f = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewUUID));
const $dc5d9309a6daedd3$export$3df892b432d3ad4a = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewRank));
const $dc5d9309a6daedd3$export$8ee3f63f4a93ef1f = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewEmoji));
const $dc5d9309a6daedd3$export$d123fb4c7c9b59cd = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewDescription));
const $dc5d9309a6daedd3$export$3a21fa4200abb1a1 = (0, $a7FjO.createViewHook)((0, $7DWfj.getIsCurrentViewDescriptionEmpty));
const $dc5d9309a6daedd3$export$505e8cd7574ee94f = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewDescriptionLoadingStatus));
const $dc5d9309a6daedd3$export$c60eaaa6023f26b5 = ()=>{
    const viewUUID = $dc5d9309a6daedd3$export$7861f6d98463d18f();
    const isEmptyDescription = $dc5d9309a6daedd3$export$3a21fa4200abb1a1();
    const accountId = (0, $kmMXp.useCurrentUser)();
    const isSharedView = (0, $5xmeX.useIsSharedView)();
    const isCollectionView = (0, $5xmeX.useIsCollectionView)();
    const hasVisited = (0, $iB16t.useHasSeenView)(viewUUID, accountId, !(isSharedView || isCollectionView));
    const currentViewAri = $dc5d9309a6daedd3$export$4a70f6e9f97b2e86();
    const { loadViewDescription: loadViewDescription } = (0, $Xp2c2.useViewActions)();
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        if (currentViewAri && isEmptyDescription && hasVisited === false) loadViewDescription(currentViewAri);
    }, [
        currentViewAri,
        isEmptyDescription,
        loadViewDescription,
        hasVisited
    ]);
    // always auto open sidebar in published views
    if (isSharedView) return !isEmptyDescription;
    if (hasVisited === undefined) return undefined;
    return !isEmptyDescription && !hasVisited;
};
const $dc5d9309a6daedd3$export$e25ac63ffecb2802 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewIsEditingTitle));
const $dc5d9309a6daedd3$export$3fad9aabd9ff34d1 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewFieldCount));
const $dc5d9309a6daedd3$export$f3bfd09e9f75221e = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewCollapsedSwimlanes));
const $dc5d9309a6daedd3$export$af2f7bffd04dea85 = (0, $a7FjO.createViewHook)((0, $7DWfj.areCurrentViewAllSwimlanesCollapsed));
const $dc5d9309a6daedd3$export$8448b254f7d3d756 = (0, $a7FjO.createViewHook)((0, $dIHYC.getCurrentViewTableColumnSizes));
const $dc5d9309a6daedd3$export$41d571c889be0009 = (0, $a7FjO.createViewHook)((0, $dIHYC.getCurrentViewTableColumnSizesByFieldKey));
const $dc5d9309a6daedd3$export$a45914b045364368 = (0, $a7FjO.createHigherLevelViewHook)((0, $dIHYC.getCurrentViewTableColumnSize));
const $dc5d9309a6daedd3$export$bd5b60e4e12f5aac = (0, $a7FjO.createViewHook)((0, $jAuoP.getCanManageCurrentView));
const $dc5d9309a6daedd3$export$56e58c1034fc5299 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewAccessLevel));
const $dc5d9309a6daedd3$export$beeaec3b505996a7 = (0, $a7FjO.createViewHook)((0, $7DWfj.isCurrentViewGroupedList));
const $dc5d9309a6daedd3$export$c4e44c99063514c5 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewSetName));
const $dc5d9309a6daedd3$export$4b282f0dbee79fe3 = (0, $a7FjO.createHigherLevelViewHook)((0, $9PAQN.createGetViewIdsInSet));
const $dc5d9309a6daedd3$export$4cc9a32fcba81ecb = (0, $a7FjO.createViewHook)((0, $9PAQN.getAllIdeasViewId));
const $dc5d9309a6daedd3$export$200fb1d8836b0696 = (0, $a7FjO.createViewHook)((0, $9PAQN.getPinnedViewId));
const $dc5d9309a6daedd3$export$eced229b51d0d052 = (0, $a7FjO.createViewHook)((0, $9PAQN.getPinnedViewFields));
const $dc5d9309a6daedd3$export$726555ef35ffa48b = (0, $a7FjO.createViewHook)((0, $9PAQN.getPinnedViewFieldsForSmartCard));
const $dc5d9309a6daedd3$export$bdcbebad0e3851cb = (0, $a7FjO.createViewHook)((0, $7DWfj.getArchiveViewId));
const $dc5d9309a6daedd3$export$6041ff8e4e880ddf = (0, $a7FjO.createHigherLevelViewHook)((0, $9PAQN.getViewSlugByRank));
const $dc5d9309a6daedd3$export$d816dbdad7b8817 = (0, $a7FjO.createViewHook)((0, $7DWfj.getViewsHasAtlasFieldsInConfig));
const $dc5d9309a6daedd3$export$f4f19290a9abc833 = (0, $a7FjO.createViewHook)((0, $9PAQN.getIsCurrentViewInCaptureSet));
const $dc5d9309a6daedd3$export$735f1ad2de478282 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewUUID));
const $dc5d9309a6daedd3$export$b6b78fb187396ce9 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewAri));
const $dc5d9309a6daedd3$export$5ce0e651e95b8146 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewSlug));
const $dc5d9309a6daedd3$export$b63d810955f435e8 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewKind));
const $dc5d9309a6daedd3$export$8836f3a3dbe72038 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewTitle));
const $dc5d9309a6daedd3$export$681219aaf7605d9f = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewEmoji));
const $dc5d9309a6daedd3$export$ccd9ee8afaae6d5b = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewContainsArchived));
const $dc5d9309a6daedd3$export$a151b224eb5d6f74 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewFilter));
const $dc5d9309a6daedd3$export$c21f92b1fbcefbcf = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewFilterLength));
const $dc5d9309a6daedd3$export$eed06533b9d0c8f6 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewFilterTypes));
const $dc5d9309a6daedd3$export$414f6e1c77373b9a = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewFieldTypes));
const $dc5d9309a6daedd3$export$f9969a6c4cc42a1c = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewFieldKeys));
const $dc5d9309a6daedd3$export$9f6c625b5c73222f = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewFieldKeysByAri));
const $dc5d9309a6daedd3$export$fc6c1ee39ba6fada = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetValidIssueSubmissionFormFieldKeys));
const $dc5d9309a6daedd3$export$10182bd3f9bb4dce = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetInvalidIssueSubmissionFormFieldLabels));
const $dc5d9309a6daedd3$export$f7ebb070be6582dc = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewSortFieldTypes));
const $dc5d9309a6daedd3$export$23b8f03d0ca70cf8 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewGroupBy));
const $dc5d9309a6daedd3$export$7ee5ac52f62e894a = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetViewGroupValues));
const $dc5d9309a6daedd3$export$26a4a92f70a221c5 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.getViewTypeCount));
const $dc5d9309a6daedd3$export$c52e95650b26b4c9 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.getViewsCountFromViewSetTypes));
const $dc5d9309a6daedd3$export$a654e333608d27fe = (0, $a7FjO.createViewHook)((0, $9PAQN.getSystemViewsContainingArchived));
const $dc5d9309a6daedd3$export$d5dc136422ce3421 = (0, $a7FjO.createViewHook)((0, $9PAQN.getSystemViewsNotContainingArchived));
const $dc5d9309a6daedd3$export$da76acc4b144e61 = (0, $a7FjO.createViewHook)((0, $jYCU4.getCurrentViewXAxisField));
const $dc5d9309a6daedd3$export$8aa863dd02fe5f12 = (0, $a7FjO.createViewHook)((0, $jYCU4.getCurrentViewYAxisField));
const $dc5d9309a6daedd3$export$2481f34bf8f48d00 = (0, $a7FjO.createViewHook)((0, $jYCU4.getCurrentViewZAxisField));
const $dc5d9309a6daedd3$export$cff831211aefab53 = (0, $a7FjO.createViewHook)((0, $jYCU4.getCurrentViewXAxis));
const $dc5d9309a6daedd3$export$ba931817c61d02e2 = (0, $a7FjO.createViewHook)((0, $jYCU4.getCurrentViewYAxis));
const $dc5d9309a6daedd3$export$b6a841611a23d51c = (0, $a7FjO.createViewHook)((0, $jYCU4.getCurrentViewZAxis));
const $dc5d9309a6daedd3$export$e2d397e41953000d = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewConfigured));
const $dc5d9309a6daedd3$export$50729bf13d5e392e = (0, $a7FjO.createHigherLevelViewHook)((0, $jYCU4.getMatrixOptionsHasReverseOrder));
const $dc5d9309a6daedd3$export$fc5171b79d010494 = (0, $a7FjO.createHigherLevelViewHook)((0, $jYCU4.getMatrixFieldOptions));
const $dc5d9309a6daedd3$export$12c33fffcd8e2293 = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewTimelineMarkers));
const $dc5d9309a6daedd3$export$c3f99cf44594f91c = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewTimelineModeOrDefault));
const $dc5d9309a6daedd3$export$95477f0965d5a07b = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewTimelineStartDateField));
const $dc5d9309a6daedd3$export$4751b7e28c0799ea = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewTimelineEndDateField));
const $dc5d9309a6daedd3$export$41c42b0966e8dc3e = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewTimelineIntervalStartDate));
const $dc5d9309a6daedd3$export$788af0b1aca129f2 = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewTimelineIntervalEndDate));
const $dc5d9309a6daedd3$export$49c919623c4a7e0e = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewSummaryCardField));
const $dc5d9309a6daedd3$export$d85ed874af6294e9 = (0, $a7FjO.createViewHook)((0, $7DWfj.getHasUnsavedChanges));
const $dc5d9309a6daedd3$export$e40e504ce855afb7 = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewArrangementInformation));
const $dc5d9309a6daedd3$export$f7798877d15f3614 = (0, $a7FjO.createViewHook)((0, $238Vi.isCurrentViewAutosaveEnabled));
const $dc5d9309a6daedd3$export$b58f4c0b32b944a = (0, $a7FjO.createViewHook)((0, $238Vi.hasVerticalGroupByUnsavedChanges));
const $dc5d9309a6daedd3$export$29c63891e7d1e239 = (0, $a7FjO.createViewHook)((0, $238Vi.hasGroupByUnsavedChanges));
const $dc5d9309a6daedd3$export$ca574dc9a980ff8 = (0, $a7FjO.createViewHook)((0, $238Vi.hasFiltersUnsavedChanges));
const $dc5d9309a6daedd3$export$5871acf91c40a235 = (0, $a7FjO.createViewHook)((0, $238Vi.hasSortUnsavedChanges));
const $dc5d9309a6daedd3$export$43633c3c22fddaf2 = (0, $a7FjO.createViewHook)((0, $238Vi.hasFieldsUnsavedChanges));
const $dc5d9309a6daedd3$export$6e56755299ab7ef0 = (0, $a7FjO.createViewHook)((0, $238Vi.hasMatrixXAxisUnsavedChanges));
const $dc5d9309a6daedd3$export$90264e2a80211e74 = (0, $a7FjO.createViewHook)((0, $238Vi.hasMatrixYAxisUnsavedChanges));
const $dc5d9309a6daedd3$export$496ccbf86f0e16f0 = (0, $a7FjO.createViewHook)((0, $238Vi.hasMatrixZAxisUnsavedChanges));
const $dc5d9309a6daedd3$export$62f8ac151a9a7067 = (0, $a7FjO.createViewHook)((0, $238Vi.hasTimelineConfigUnsavedChanges));
const $dc5d9309a6daedd3$export$b47aab759da7190a = (0, $a7FjO.createViewHook)((0, $238Vi.hasFieldRollupUnsavedChanges));
const $dc5d9309a6daedd3$export$35fe3ca7f01d0248 = (0, $a7FjO.createViewHook)((0, $238Vi.hasLayoutTypeUnsavedChanges));
const $dc5d9309a6daedd3$export$e0cda647115ce1 = (0, $a7FjO.createViewHook)((0, $238Vi.hasViewUnsavedChanges));
const $dc5d9309a6daedd3$export$85d398798ef59b95 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewLayoutType));
const $dc5d9309a6daedd3$export$7ca9638a48d73e2 = (0, $a7FjO.createHigherLevelViewHook)((0, $9PAQN.getViewIdsConfiguredByField));
const $dc5d9309a6daedd3$export$cf4d4f56c95d18fd = (0, $a7FjO.createViewHook)((0, $9PAQN.getPrioritizeViews));
const $dc5d9309a6daedd3$export$18fa221ffbd573c9 = (0, $a7FjO.createViewHook)((0, $7DWfj.getViewAnalyticsData));
const $dc5d9309a6daedd3$export$d4da83893d6c2991 = (0, $a7FjO.createViewHook)((0, $7DWfj.isCurrentViewGeneratedByTemplate));
const $dc5d9309a6daedd3$export$a5c19d17aeeac897 = (0, $a7FjO.createViewHook)((0, $7DWfj.getAllViewsNameAndIds));
const $dc5d9309a6daedd3$export$d874b677cc715da7 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewRankFieldKey));
const $dc5d9309a6daedd3$export$de2e658806072a22 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewVisibleFieldKeys));
const $dc5d9309a6daedd3$export$cac33b5596be3635 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewColumnIds));
const $dc5d9309a6daedd3$export$ee25dd74640e16aa = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.isFieldVisibleInCurrentView));
const $dc5d9309a6daedd3$export$a98588ca4064a16b = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewVisibleIssueActionFields));
const $dc5d9309a6daedd3$export$ba29815e12cbe31 = (0, $a7FjO.createViewHook)((0, $7DWfj.getPinnedViewActionFieldKeys));
const $dc5d9309a6daedd3$export$2731283689f6abe4 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewActionFieldKeys));
const $dc5d9309a6daedd3$export$4ee9f4ceac12f4d4 = ()=>{
    const visibleFields = $dc5d9309a6daedd3$export$40ca69ba2ce48efb();
    const fieldGroupedBy = $dc5d9309a6daedd3$export$23594f934df22b9();
    if (!fieldGroupedBy) return visibleFields;
    return [
        fieldGroupedBy,
        ...visibleFields.filter((field)=>field.key !== fieldGroupedBy.key)
    ];
};
const $dc5d9309a6daedd3$export$abbd195de5f0f3cb = ()=>{
    const visibleFields = $dc5d9309a6daedd3$export$40ca69ba2ce48efb();
    const xAxisField = $dc5d9309a6daedd3$export$da76acc4b144e61();
    const yAxisField = $dc5d9309a6daedd3$export$8aa863dd02fe5f12();
    const zAxisField = $dc5d9309a6daedd3$export$2481f34bf8f48d00();
    if (!xAxisField || !yAxisField) return visibleFields;
    if (zAxisField) return [
        xAxisField,
        yAxisField,
        zAxisField,
        ...visibleFields.filter((field)=>field.key !== xAxisField.key && field.key !== yAxisField.key && field.key !== zAxisField.key)
    ];
    return [
        xAxisField,
        yAxisField,
        ...visibleFields.filter((field)=>field.key !== xAxisField.key && field.key !== yAxisField.key && field.key)
    ];
};
const $dc5d9309a6daedd3$export$301c85abdd9aa231 = ()=>{
    const visibleFields = $dc5d9309a6daedd3$export$40ca69ba2ce48efb();
    const fieldStartDate = $dc5d9309a6daedd3$export$95477f0965d5a07b();
    const fieldEndDate = $dc5d9309a6daedd3$export$4751b7e28c0799ea();
    if (!fieldStartDate || !fieldEndDate) return visibleFields;
    return [
        fieldStartDate,
        fieldEndDate,
        ...visibleFields.filter((field)=>field.key !== fieldStartDate.key && field.key !== fieldEndDate.key)
    ];
};
const $dc5d9309a6daedd3$export$32364deb0ccc0c79 = ()=>{
    const timelineStartDate = $dc5d9309a6daedd3$export$41c42b0966e8dc3e();
    const timelineEndDate = $dc5d9309a6daedd3$export$788af0b1aca129f2();
    if (!timelineStartDate || !timelineEndDate) return [];
    return [
        timelineStartDate,
        timelineEndDate
    ];
};
const $dc5d9309a6daedd3$export$e158690ae807086b = (0, $a7FjO.createViewHook)((0, $7DWfj.getStatusCategoriesForPublishedView));
const $dc5d9309a6daedd3$export$76ff15920dd87b14 = (0, $a7FjO.createViewHook)((0, $mJiEA.getCurrentViewSummaryCardFieldKey));
const $dc5d9309a6daedd3$export$88196a639ac369b3 = ()=>{
    const entityLimitMessage = (0, $cQ9m7.useEntityLimitMessage)();
    const fieldCount = $dc5d9309a6daedd3$export$3fad9aabd9ff34d1();
    const fieldsLimit = (0, $70fba.useEntityLimitsByType)((0, $69PvG.ENTITY_LIMIT_TYPE).FIELDS_PER_VIEW);
    if (fieldsLimit && fieldCount >= fieldsLimit) return entityLimitMessage((0, $69PvG.ENTITY_LIMIT_TYPE).FIELDS_PER_VIEW, fieldsLimit);
    return null;
};
const $dc5d9309a6daedd3$export$f7520036241cebec = (viewId, shouldLoadViewPermissions)=>{
    const viewUUID = $dc5d9309a6daedd3$export$735f1ad2de478282(viewId);
    const isCollectionView = (0, $5xmeX.useIsCollectionView)();
    const collectionId = (0, $3Jfcg.useEnvironmentContainer)()?.id ?? '';
    const canManageViewBasedOnViewUUID = (0, $5zam7.useCanManageViewBasedOnViewPermissions)(viewUUID, viewId, shouldLoadViewPermissions ?? !isCollectionView);
    const canEditCollection = (0, $jn3Ea.useCanEditCollection)({
        collectionUUID: collectionId,
        forceLoading: isCollectionView
    });
    if (isCollectionView) return canEditCollection;
    return canManageViewBasedOnViewUUID.canEdit;
};
const $dc5d9309a6daedd3$export$9fb1de3efd945914 = (viewId)=>{
    const { deleteView: deleteView } = (0, $Xp2c2.useViewActions)();
    const viewUUID = $dc5d9309a6daedd3$export$735f1ad2de478282(viewId);
    const isCollectionView = (0, $5xmeX.useIsCollectionView)();
    const canManageViewBasedOnViewUUID = (0, $5zam7.useCanManageViewBasedOnViewPermissions)(viewUUID, viewId, false);
    if (!isCollectionView && viewId && viewUUID && !canManageViewBasedOnViewUUID.canView) deleteView(viewId, true);
};
const $dc5d9309a6daedd3$export$ad155a33c34c6cec = (viewId, shouldLoadViewPermissions)=>{
    const viewUUID = $dc5d9309a6daedd3$export$735f1ad2de478282(viewId);
    const viewAccessLevel = (0, $5zam7.useViewAccessLevelBasedOnViewPermissions)(viewUUID, viewId, !!shouldLoadViewPermissions);
    return viewAccessLevel;
};
const $dc5d9309a6daedd3$export$75a7a6424bd21069 = ()=>{
    const canManageCurrentView = $dc5d9309a6daedd3$export$bd5b60e4e12f5aac();
    return canManageCurrentView;
};
const $dc5d9309a6daedd3$export$e1b1e542390290f1 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewLastSelectedIssueTypeId));
const $dc5d9309a6daedd3$export$8f67703d50e884e7 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewConnectionFieldKeys));
const $dc5d9309a6daedd3$export$e810b5be9f4da246 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewHasConnectionFields));
const $dc5d9309a6daedd3$export$c98ef173ed9364d5 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewHasGlobalConnectionFields));
const $dc5d9309a6daedd3$export$92808cef6b54cf04 = (0, $a7FjO.createHigherLevelViewHook)((0, $7DWfj.createGetCurrentViewHasCrossProjectConnectionFields));
const $dc5d9309a6daedd3$export$a4dc4c8bb49fb3d4 = (0, $a7FjO.createViewHook)((0, $7DWfj.getIsCurrentViewAvailable));
const $dc5d9309a6daedd3$export$9e7ca5139d4c2b98 = (0, $a7FjO.createViewHook)((0, $7DWfj.getCurrentViewConnectionFieldsIssueTypes));

});
parcelRegister("jn3Ea", function(module, exports) {

$parcel$export(module.exports, "useCollectionsOwners", () => $7d9b494d63eea394$export$dfb5b0c810a754bd);
$parcel$export(module.exports, "useCollectionOwner", () => $7d9b494d63eea394$export$600bf7f135fe5a5);
$parcel$export(module.exports, "useIsLicensedUser", () => $7d9b494d63eea394$export$8130629f6db139c2);
$parcel$export(module.exports, "useCanEditCollection", () => $7d9b494d63eea394$export$19cfc4d4f1ca4b85);
$parcel$export(module.exports, "useHasReachedCollectionsLimitMessage", () => $7d9b494d63eea394$export$843965bc002bccc5);

var $eJOHy = parcelRequire("eJOHy");

var $70fba = parcelRequire("70fba");

var $5zam7 = parcelRequire("5zam7");

var $3PaO7 = parcelRequire("3PaO7");

var $cQ9m7 = parcelRequire("cQ9m7");

var $8q7lT = parcelRequire("8q7lT");

var $iW0U8 = parcelRequire("iW0U8");

var $lvKO5 = parcelRequire("lvKO5");

var $g1LS3 = parcelRequire("g1LS3");

var $ftsgu = parcelRequire("ftsgu");
const $7d9b494d63eea394$export$dfb5b0c810a754bd = ()=>{
    const ownerIds = (0, $g1LS3.useCollectionsOwnersIds)();
    const users = (0, $ftsgu.useUsers)();
    return (0, $eJOHy.useMemo)(()=>ownerIds.reduce((acc, ownerId)=>{
            const owner = users[ownerId];
            if (owner) acc[ownerId] = owner;
            return acc;
        }, {}), [
        ownerIds,
        users
    ]);
};
const $7d9b494d63eea394$export$600bf7f135fe5a5 = ({ collectionUUID: collectionUUID })=>{
    const ownerId = (0, $g1LS3.useCollectionOwnerId)({
        collectionUUID: collectionUUID
    }) || '';
    const user = (0, $ftsgu.useUser)(ownerId);
    return user;
};
const $7d9b494d63eea394$export$ab1d6c07816dcf75 = ({ collectionUUID: collectionUUID })=>{
    const ownerId = (0, $g1LS3.useCollectionOwnerId)({
        collectionUUID: collectionUUID
    });
    const currentUserId = (0, $8q7lT.useAccountId)();
    const { isAdmin: isAdmin } = (0, $lvKO5.useTenantContext)() ?? {};
    const isLicensedUser = $7d9b494d63eea394$export$8130629f6db139c2();
    return isLicensedUser && (isAdmin || currentUserId === ownerId);
};
const $7d9b494d63eea394$export$19cfc4d4f1ca4b85 = ({ collectionUUID: collectionUUID, forceLoading: forceLoading })=>{
    const isLicensedUser = $7d9b494d63eea394$export$8130629f6db139c2();
    const { canEdit: canEdit } = (0, $5zam7.useCanManageViewBasedOnViewPermissions)(collectionUUID, undefined, forceLoading, true);
    return isLicensedUser && canEdit;
};
const $7d9b494d63eea394$export$8130629f6db139c2 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $iW0U8.useApplicationPermissions)() ?? {};
    return hasProductDiscoveryAccess;
};
const $7d9b494d63eea394$export$843965bc002bccc5 = ()=>{
    const entityLimitMessage = (0, $cQ9m7.useEntityLimitMessage)();
    const collectionsCount = (0, $g1LS3.useCollectionsCount)();
    const collectionsLimit = (0, $70fba.useEntityLimitsByType)((0, $3PaO7.ENTITY_LIMIT_TYPE).COLLECTIONS_PER_SITE);
    if (collectionsLimit && collectionsCount >= collectionsLimit) return entityLimitMessage((0, $3PaO7.ENTITY_LIMIT_TYPE).COLLECTIONS_PER_SITE, collectionsLimit);
    return null;
};

});
parcelRegister("70fba", function(module, exports) {

$parcel$export(module.exports, "useEntityLimits", () => $0fd336666ed55076$export$27563114e215d5d2);
$parcel$export(module.exports, "useEntityLimitsByType", () => $0fd336666ed55076$export$131d1f6522e0008b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $9hA9V = parcelRequire("9hA9V");

var $kWnq6 = parcelRequire("kWnq6");
const $0fd336666ed55076$export$27563114e215d5d2 = (0, $iJq0l.createHook)((0, $9hA9V.EntityLimitsStore), {
    selector: (0, $kWnq6.getEntityLimits)
});
const $0fd336666ed55076$export$131d1f6522e0008b = (limitType)=>{
    const [entityLimits] = $0fd336666ed55076$export$27563114e215d5d2();
    return entityLimits?.[limitType] ?? null;
};

});
parcelRegister("9hA9V", function(module, exports) {

$parcel$export(module.exports, "EntityLimitsStore", () => $452bdbda586fa6cd$export$1ae04e764bd1943c);
$parcel$export(module.exports, "EntityLimitsContainer", () => $452bdbda586fa6cd$export$6cb5289bbfe5ddf1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $ctDTN = parcelRequire("ctDTN");

var $j6LR4 = parcelRequire("j6LR4");
const $452bdbda586fa6cd$var$actions = {
    loadEntityLimits: $ctDTN.loadEntityLimits
};
const $452bdbda586fa6cd$export$1ae04e764bd1943c = (0, $GtRbT.createStore)({
    initialState: (0, $j6LR4.EMPTY_STATE),
    actions: $452bdbda586fa6cd$var$actions,
    name: 'PolarisEntityLimitsStore'
});
const $452bdbda586fa6cd$export$3ad3f015953a20eb = (0, $iJq0l.createActionsHook)($452bdbda586fa6cd$export$1ae04e764bd1943c);
const $452bdbda586fa6cd$export$6cb5289bbfe5ddf1 = (0, $6E16M.createContainer)($452bdbda586fa6cd$export$1ae04e764bd1943c, {
    onInit: ()=>({ dispatch: dispatch })=>dispatch((0, $ctDTN.loadEntityLimits)())
});

});
parcelRegister("ctDTN", function(module, exports) {

$parcel$export(module.exports, "loadEntityLimits", () => $4b19a804cbb9f0ae$export$793a286ad01e9c6a);

var $gCeeo = parcelRequire("gCeeo");

var $1GLN2 = parcelRequire("1GLN2");
const $4b19a804cbb9f0ae$export$793a286ad01e9c6a = ()=>async ({ getState: getState, setState: setState }, { createAnalyticsEvent: createAnalyticsEvent })=>{
        const { meta: { loaded: loaded, loading: loading } } = getState();
        // Fetch only once
        if (loaded || loading) return;
        setState({
            meta: {
                loaded: false,
                loading: true
            },
            entityLimits: undefined
        });
        try {
            const entityLimits = await (0, $1GLN2.fetchEntityLimits)();
            setState({
                meta: {
                    loaded: true,
                    loading: false
                },
                entityLimits: entityLimits
            });
        } catch  {
            (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadLimits failure');
        }
    };

});
parcelRegister("1GLN2", function(module, exports) {

$parcel$export(module.exports, "fetchEntityLimits", () => $a89c2167069800d4$export$bd0a928e99c83c9f);

var $1Ozm9 = parcelRequire("1Ozm9");

var $3PaO7 = parcelRequire("3PaO7");

var $69PvG = parcelRequire("69PvG");
const $a89c2167069800d4$var$ENTITY_LIMIT_TYPE = {
    ...(0, $69PvG.ENTITY_LIMIT_TYPE),
    ...(0, $3PaO7.ENTITY_LIMIT_TYPE)
};
const $a89c2167069800d4$export$bd0a928e99c83c9f = async ()=>{
    const entityLimits = {};
    const response = await (0, $1Ozm9.default)('/gateway/api/polaris/rest/limits');
    // Convert the response to the format expected by the UI
    for (const [key, value] of Object.entries(response?.limits ?? {})){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const limitType = $a89c2167069800d4$var$ENTITY_LIMIT_TYPE[key];
        if (limitType) entityLimits[limitType] = value;
    }
    return entityLimits;
};

});
parcelRegister("3PaO7", function(module, exports) {

$parcel$export(module.exports, "ENTITY_LIMIT_TYPE", () => $a06ca80ccf2c653b$export$f1b0aa924e1e86ca);
/**
 * The types of entity limits for collections
 */ const $a06ca80ccf2c653b$export$f1b0aa924e1e86ca = {
    VIEWS_PER_COLLECTION: 'viewsPerCollection',
    COLLECTIONS_PER_SITE: 'collectionsPerSite'
};

});

parcelRegister("69PvG", function(module, exports) {

$parcel$export(module.exports, "ENTITY_LIMIT_TYPE", () => $80dfb4371d5ab1ab$export$f1b0aa924e1e86ca);
/**
 * The types of entity limits for a project
 */ const $80dfb4371d5ab1ab$export$f1b0aa924e1e86ca = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    FIELDS_PER_VIEW: 'fieldsPerView',
    IDEAS_SEARCH_MAX_RESULTS: 'ideasSearchMaxResults',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};

});



parcelRegister("j6LR4", function(module, exports) {

$parcel$export(module.exports, "EMPTY_STATE", () => $adb6c6eece32e26f$export$f040258c471d4154);
const $adb6c6eece32e26f$export$f040258c471d4154 = {
    entityLimits: undefined,
    meta: {
        loaded: false,
        loading: false,
        loadingError: undefined
    }
};

});


parcelRegister("kWnq6", function(module, exports) {

$parcel$export(module.exports, "getEntityLimits", () => $a8e4a58c3fa7ea61$export$cb3b1a64aebe85bd);
const $a8e4a58c3fa7ea61$export$cb3b1a64aebe85bd = (state)=>state?.entityLimits ?? null;

});


parcelRegister("5zam7", function(module, exports) {

$parcel$export(module.exports, "useCanManageViewBasedOnViewPermissions", () => $99cb3db58f2bbc51$export$d342013c34d97e01);
$parcel$export(module.exports, "useViewAccessLevelBasedOnViewPermissions", () => $99cb3db58f2bbc51$export$a208046e6420a9ab);
$parcel$export(module.exports, "useLoadViewAccessAction", () => $99cb3db58f2bbc51$export$d9da44900b816e54);

var $eJOHy = parcelRequire("eJOHy");

var $cByZ7 = parcelRequire("cByZ7");

var $3Ku0X = parcelRequire("3Ku0X");

var $fRXNt = parcelRequire("fRXNt");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8a7IK = parcelRequire("8a7IK");

var $fkpML = parcelRequire("fkpML");

var $eE8M5 = parcelRequire("eE8M5");
const $99cb3db58f2bbc51$var$useLoadViewAccess = (viewUUID, viewId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { loadCurrentUserViewAccess: loadCurrentUserViewAccess } = (0, $fkpML.useActions)();
    return (0, $eJOHy.useCallback)(async ()=>{
        if (!viewUUID) return;
        const result = await loadCurrentUserViewAccess(viewUUID);
        if (result.role) {
            // https://data-portal.internal.atlassian.com/analytics/registry/69714
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData currentUserRoleLoaded', {
                viewUUID: viewUUID,
                viewId: viewId,
                role: (0, $8a7IK.transformRoleAriToRole)(result.role)
            });
            (0, $3Ku0X.sendPendoTrackEvent)({
                actionSubjectAndAction: 'viewAccessData currentUserRoleLoaded',
                actionSubjectId: 'viewAccessData',
                attributes: {
                    viewUUID: viewUUID,
                    viewId: viewId || '',
                    role: (0, $8a7IK.transformRoleAriToRole)(result.role)
                }
            });
        }
        return result;
    }, [
        createAnalyticsEvent,
        loadCurrentUserViewAccess,
        viewId,
        viewUUID
    ]);
};
const $99cb3db58f2bbc51$export$d342013c34d97e01 = (viewUUID, viewId, forceLoading = true, isCollection = false)=>{
    const viewAccessMap = (0, $eE8M5.useViewAccessMap)();
    const canManageViews = (0, $eE8M5.useHasManageViewsPermission)();
    const isViewPermissionsEnabled = (0, $fRXNt.useIsViewPermissionsEnabled)();
    const loadViewAccess = $99cb3db58f2bbc51$var$useLoadViewAccess(viewUUID, viewId);
    if (viewUUID === undefined) return {
        canEdit: false,
        canView: false
    };
    if (!isViewPermissionsEnabled) return {
        canEdit: canManageViews,
        canView: true
    };
    const viewAccess = viewAccessMap[viewUUID];
    if (!viewAccess && forceLoading) {
        loadViewAccess();
        return {
            canEdit: false,
            canView: true
        };
    }
    return {
        canEdit: (canManageViews || isCollection) && viewAccess?.state === 'succeeded' && viewAccess.role === (0, $cByZ7.ACCESS_ROLE_EDITOR_ARI),
        canView: viewAccess?.state !== 'no-access'
    };
};
const $99cb3db58f2bbc51$export$a208046e6420a9ab = (viewUUID, viewId, forceLoading = true)=>{
    const viewAccessMap = (0, $eE8M5.useViewAccessMap)();
    const isViewPermissionsEnabled = (0, $fRXNt.useIsViewPermissionsEnabled)();
    const loadViewAccess = $99cb3db58f2bbc51$var$useLoadViewAccess(viewUUID, viewId);
    if (viewUUID === undefined || !isViewPermissionsEnabled) return undefined;
    const viewAccess = viewAccessMap[viewUUID];
    if (!viewAccess && forceLoading) {
        loadViewAccess();
        return undefined;
    }
    if (viewAccess?.state === 'succeeded') return viewAccess.accessLevel;
    return undefined;
};
const $99cb3db58f2bbc51$export$d9da44900b816e54 = ()=>{
    const isViewPermissionsEnabled = (0, $fRXNt.useIsViewPermissionsEnabled)();
    const { loadCurrentUserViewAccess: loadCurrentUserViewAccess } = (0, $fkpML.useActions)();
    if (isViewPermissionsEnabled) return loadCurrentUserViewAccess;
    return undefined;
};

});
parcelRegister("cByZ7", function(module, exports) {

$parcel$export(module.exports, "VIEW_ACCESS_LEVEL_RESTRICTED", () => $4cc57c20f91715ec$export$9c2d53699d994b5a);
$parcel$export(module.exports, "VIEW_ACCESS_LEVELS", () => $4cc57c20f91715ec$export$54010017a2d4d01e);
$parcel$export(module.exports, "ACCESS_ROLE_EDITOR", () => $4cc57c20f91715ec$export$607d7028cf1291b5);
$parcel$export(module.exports, "ACCESS_ROLE_VIEWER", () => $4cc57c20f91715ec$export$7067053a04ed7c90);
$parcel$export(module.exports, "ACCESS_ROLE_EDITOR_ARI", () => $4cc57c20f91715ec$export$3f064e77a6e03694);
$parcel$export(module.exports, "ACCESS_ROLE_VIEWER_ARI", () => $4cc57c20f91715ec$export$180be1cd3d7b9696);
$parcel$export(module.exports, "PRINCIPAL_TYPES", () => $4cc57c20f91715ec$export$89e3f48fb47402b6);
$parcel$export(module.exports, "ACCESS_ROLE_ERRORS", () => $4cc57c20f91715ec$export$21f6b56572a7f593);
const $4cc57c20f91715ec$export$57830ed530bd3e8c = 'OPEN';
const $4cc57c20f91715ec$export$85f060b47f6fb5b = 'LIMITED';
const $4cc57c20f91715ec$export$9c2d53699d994b5a = 'RESTRICTED';
const $4cc57c20f91715ec$export$54010017a2d4d01e = {
    OPEN: $4cc57c20f91715ec$export$57830ed530bd3e8c,
    LIMITED: $4cc57c20f91715ec$export$85f060b47f6fb5b,
    RESTRICTED: $4cc57c20f91715ec$export$9c2d53699d994b5a
};
const $4cc57c20f91715ec$export$607d7028cf1291b5 = 'EDITOR';
const $4cc57c20f91715ec$export$7067053a04ed7c90 = 'VIEWER';
const $4cc57c20f91715ec$export$3f064e77a6e03694 = 'ari:cloud:jira-product-discovery::role/view/editor';
const $4cc57c20f91715ec$export$180be1cd3d7b9696 = 'ari:cloud:jira-product-discovery::role/view/viewer';
const $4cc57c20f91715ec$export$895cb5011e48c06d = 'CREATOR';
const $4cc57c20f91715ec$export$6d36c7abacdc3f35 = 'CONTRIBUTOR';
const $4cc57c20f91715ec$export$4a1c887504192e78 = 'user';
const $4cc57c20f91715ec$export$4050c956318f649b = 'group';
const $4cc57c20f91715ec$export$89e3f48fb47402b6 = {
    PROFILE: $4cc57c20f91715ec$export$4a1c887504192e78,
    GROUP: $4cc57c20f91715ec$export$4050c956318f649b
};
const $4cc57c20f91715ec$export$589db1214b30dbd8 = 'MISSING_MANAGE_DISCOVERY_VIEWS_PERMISSION';
const $4cc57c20f91715ec$export$997e64f01159ffc = 'MISSING_BROWSE_PROJECTS_PERMISSION';
const $4cc57c20f91715ec$export$21f6b56572a7f593 = {
    MISSING_MANAGE_DISCOVERY_VIEWS_PERMISSION: $4cc57c20f91715ec$export$589db1214b30dbd8,
    MISSING_BROWSE_PROJECTS_PERMISSION: $4cc57c20f91715ec$export$997e64f01159ffc
};

});

parcelRegister("fRXNt", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumEdition", () => $b0ffb33e1d479a9f$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $b0ffb33e1d479a9f$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $b0ffb33e1d479a9f$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $b0ffb33e1d479a9f$export$304793dd2c5f4db0);

var $7jTnu = parcelRequire("7jTnu");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");
const $b0ffb33e1d479a9f$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    if ((0, $7jTnu.fg)('polaris_force-premium')) return true;
    const jpdEdition = (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $a9ldn.toEdition)((0, $a9ldn.PREMIUM_EDITION));
};
const $b0ffb33e1d479a9f$export$642bac71144485ad = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const jpdEdition = (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $a9ldn.toEdition)((0, $a9ldn.STANDARD_EDITION));
};
const $b0ffb33e1d479a9f$export$a94405ffcb20c356 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    return isPremium;
};
const $b0ffb33e1d479a9f$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    return isPremium;
};
const $b0ffb33e1d479a9f$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    const isStandard = $b0ffb33e1d479a9f$export$642bac71144485ad();
    if (isStandard && (0, $7jTnu.fg)('jpd_issues_relationships_eap_lighthouse_customer')) return true;
    return isPremium;
};

});

parcelRegister("8a7IK", function(module, exports) {

$parcel$export(module.exports, "transformRoleAriToRole", () => $3bae5772400d05d5$export$fdb46ee0756a1020);

var $cByZ7 = parcelRequire("cByZ7");
const $3bae5772400d05d5$export$fdb46ee0756a1020 = (roleAri)=>roleAri === (0, $cByZ7.ACCESS_ROLE_EDITOR_ARI) ? (0, $cByZ7.ACCESS_ROLE_EDITOR) : (0, $cByZ7.ACCESS_ROLE_VIEWER);

});

parcelRegister("fkpML", function(module, exports) {

$parcel$export(module.exports, "createViewAccessStateHook", () => $8216829275ef38b5$export$936fa67d4fb5fe0);
$parcel$export(module.exports, "useActions", () => $8216829275ef38b5$export$bc923229a7fa61e7);
$parcel$export(module.exports, "PermissionsSettingsProvider", () => $8216829275ef38b5$export$ac1a1c2d5f8c8bf4);
$parcel$export(module.exports, "usePermissionsEditMode", () => $8216829275ef38b5$export$88496a5be4bb39);
$parcel$export(module.exports, "useNonEditablePrincipalIds", () => $8216829275ef38b5$export$200c6c7e24a8efac);

var $eJOHy = parcelRequire("eJOHy");

var $cByZ7 = parcelRequire("cByZ7");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $imdHP = parcelRequire("imdHP");

var $5V0oD = parcelRequire("5V0oD");

var $8YHj5 = parcelRequire("8YHj5");

var $8CYhV = parcelRequire("8CYhV");

var $jLcRQ = parcelRequire("jLcRQ");

var $cBwvx = parcelRequire("cBwvx");

var $4gmLZ = parcelRequire("4gmLZ");

var $hCoqy = parcelRequire("hCoqy");

var $e50zx = parcelRequire("e50zx");
const $8216829275ef38b5$var$actions = {
    addViewAccessPrincipals: $imdHP.addViewAccessPrincipals,
    changeViewAccessPrincipalRole: $5V0oD.changeViewAccessPrincipalRole,
    clearFailures: $8YHj5.clearFailures,
    clearSkippedAccountFailures: $8CYhV.clearSkippedAccountFailures,
    loadCurrentUserViewAccess: $jLcRQ.loadCurrentUserViewAccess,
    loadViewPermissionsConfig: $cBwvx.loadViewPermissionsConfig,
    removeViewAccessPrincipals: $4gmLZ.removeViewAccessPrincipals,
    setHasManageViewsPermission: $hCoqy.setHasManageViewsPermission,
    updateViewAccessLevel: $e50zx.updateViewAccessLevel
};
const $8216829275ef38b5$var$initialState = {
    config: {
        isAddingPrincipals: false,
        error: undefined,
        skippedAccountFailures: []
    },
    accessLevel: (0, $cByZ7.VIEW_ACCESS_LEVELS).LIMITED,
    additionalAccess: {
        profiles: [],
        groups: []
    },
    hasManageViewsPermission: false,
    viewAccessMap: {}
};
const $8216829275ef38b5$var$Store = (0, $GtRbT.createStore)({
    initialState: $8216829275ef38b5$var$initialState,
    actions: $8216829275ef38b5$var$actions,
    name: 'PolarisViewAccessStore'
});
const $8216829275ef38b5$export$936fa67d4fb5fe0 = (selector)=>(0, $iJq0l.createStateHook)($8216829275ef38b5$var$Store, {
        selector: selector
    });
const $8216829275ef38b5$export$bc923229a7fa61e7 = (0, $iJq0l.createActionsHook)($8216829275ef38b5$var$Store);
const $8216829275ef38b5$var$PermissionsSettingsContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    editingMode: 'view',
    nonEditablePrincipalIds: new Set()
});
const $8216829275ef38b5$export$ac1a1c2d5f8c8bf4 = ({ children: children, editingMode: editingMode, nonEditablePrincipalIds: nonEditablePrincipalIds })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            editingMode: editingMode,
            nonEditablePrincipalIds: new Set(nonEditablePrincipalIds)
        }), [
        editingMode,
        nonEditablePrincipalIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8216829275ef38b5$var$PermissionsSettingsContext.Provider, {
        value: value
    }, children);
};
const $8216829275ef38b5$export$88496a5be4bb39 = ()=>(0, $eJOHy.useContext)($8216829275ef38b5$var$PermissionsSettingsContext).editingMode;
const $8216829275ef38b5$export$200c6c7e24a8efac = ()=>(0, $eJOHy.useContext)($8216829275ef38b5$var$PermissionsSettingsContext).nonEditablePrincipalIds;

});
parcelRegister("imdHP", function(module, exports) {

$parcel$export(module.exports, "addViewAccessPrincipals", () => $a98c718e6e7fba78$export$70f695287ec6d520);

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $cByZ7 = parcelRequire("cByZ7");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $gCeeo = parcelRequire("gCeeo");

var $k2y9F = parcelRequire("k2y9F");

var $3Tjbs = parcelRequire("3Tjbs");

var $g62ka = parcelRequire("g62ka");

var $cBwvx = parcelRequire("cBwvx");
const $a98c718e6e7fba78$var$ufoExperienceType = 'addViewAccessPrincipals';
const $a98c718e6e7fba78$export$70f695287ec6d520 = ({ viewUUID: viewUUID, principals: principals, role: role, viewId: viewId, createAnalyticsEvent: createAnalyticsEvent, onActionFailed: onActionFailed })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const accessLevel = getState().accessLevel;
        setState({
            config: {
                ...getState().config,
                isAddingPrincipals: true,
                failures: undefined
            }
        });
        const roleAri = (0, $g62ka.transformRoleToRoleAri)(role);
        const accounts = principals.filter((e)=>e.type === (0, $cByZ7.PRINCIPAL_TYPES).PROFILE).map((item)=>({
                id: item.id,
                role: roleAri
            }));
        const groups = principals.filter((e)=>e.type === (0, $cByZ7.PRINCIPAL_TYPES).GROUP).map((item)=>({
                id: item.id,
                role: roleAri
            }));
        try {
            (0, $b5oGV.experience).viewPermissions.updatePrincipals.start();
            await (0, $k2y9F.applyAddViewAccessPrincipals)(viewUUID, accounts, groups);
            await dispatch((0, $cBwvx.loadViewPermissionsConfig)({
                viewUUID: viewUUID,
                viewId: viewId,
                createAnalyticsEvent: createAnalyticsEvent
            }));
            const currentState = getState();
            setState({
                config: {
                    ...currentState.config,
                    isAddingPrincipals: false,
                    skippedAccountFailures: currentState.config.skippedAccountFailures.filter((skippedAccount)=>!principals.some((principal)=>principal.id === skippedAccount.accountId))
                }
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/69639
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData principalAdded', {
                accessLevel: accessLevel,
                viewUuid: viewUUID,
                viewId: viewId,
                role: role,
                newUserCount: accounts.length,
                newGroupCount: groups.length
            });
            (0, $3Ku0X.sendPendoTrackEvent)({
                actionSubjectAndAction: 'viewAccessData principalAdded',
                actionSubjectId: 'viewAccessData',
                attributes: {
                    accessLevel: accessLevel,
                    viewUuid: viewUUID,
                    viewId: viewId || '',
                    role: role,
                    newUserCount: accounts.length,
                    newGroupCount: groups.length
                }
            });
            (0, $b5oGV.experience).viewPermissions.updatePrincipals.success({
                metadata: {
                    type: $a98c718e6e7fba78$var$ufoExperienceType
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            await dispatch((0, $cBwvx.loadViewPermissionsConfig)({
                viewUUID: viewUUID,
                viewId: viewId,
                createAnalyticsEvent: createAnalyticsEvent
            }));
            let errorResponse = error.originalResponse;
            try {
                if (typeof error.originalResponse?.json === 'function') errorResponse = await error.originalResponse.json();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (subError) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-access.add-view-access-principals.parse-error', subError));
            }
            if ((0, $3Tjbs.isSetViewAccessPrincipalRolesErrorResponse)(errorResponse)) {
                let hasSkippedAccounts = false;
                let hasFailures = false;
                if (errorResponse.details.skippedAccounts && errorResponse.details.skippedAccounts.length > 0) {
                    hasSkippedAccounts = true;
                    // https://data-portal.internal.atlassian.com/analytics/registry/69691
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData setRoleFailureSkippedAccounts', {
                        viewUuid: viewUUID,
                        viewId: viewId,
                        missingManageViewsPermissionCount: errorResponse.details.skippedAccounts.filter((item)=>item.errorCode === (0, $cByZ7.ACCESS_ROLE_ERRORS).MISSING_MANAGE_DISCOVERY_VIEWS_PERMISSION).length,
                        missingProjectAccessCount: errorResponse.details.skippedAccounts.filter((item)=>item.errorCode === (0, $cByZ7.ACCESS_ROLE_ERRORS).MISSING_BROWSE_PROJECTS_PERMISSION).length
                    });
                    (0, $3Ku0X.sendPendoTrackEvent)({
                        actionSubjectAndAction: 'viewAccessData setRoleFailureSkippedAccounts',
                        actionSubjectId: 'viewAccessData',
                        attributes: {
                            viewUuid: viewUUID,
                            viewId: viewId || '',
                            missingManageViewsPermissionCount: errorResponse.details.skippedAccounts.filter((item)=>item.errorCode === (0, $cByZ7.ACCESS_ROLE_ERRORS).MISSING_MANAGE_DISCOVERY_VIEWS_PERMISSION).length,
                            missingProjectAccessCount: errorResponse.details.skippedAccounts.filter((item)=>item.errorCode === (0, $cByZ7.ACCESS_ROLE_ERRORS).MISSING_BROWSE_PROJECTS_PERMISSION).length
                        }
                    });
                    const skippedAccounts = errorResponse.details.skippedAccounts.map((item)=>{
                        const foundPrincipal = principals.find((principal)=>principal.id === item.accountId);
                        return {
                            ...item,
                            requestedRole: role,
                            name: foundPrincipal?.name ?? '',
                            avatarUrl: foundPrincipal?.avatarUrl
                        };
                    });
                    const currentState = getState();
                    setState({
                        config: {
                            ...currentState.config,
                            skippedAccountFailures: [
                                ...currentState.config.skippedAccountFailures.filter((item)=>!skippedAccounts.some((skippedAccount)=>skippedAccount.accountId === item.accountId)),
                                ...skippedAccounts
                            ]
                        }
                    });
                }
                if (errorResponse.details.failures) {
                    hasFailures = true;
                    // https://data-portal.internal.atlassian.com/analytics/registry/69692
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData setRoleFailure', {
                        viewUuid: viewUUID,
                        viewId: viewId,
                        failuresCount: errorResponse.details.failures.accountIds.length + errorResponse.details.failures.groupIds.length
                    });
                    (0, $3Ku0X.sendPendoTrackEvent)({
                        actionSubjectAndAction: 'viewAccessData setRoleFailure',
                        actionSubjectId: 'viewAccessData',
                        attributes: {
                            viewUuid: viewUUID,
                            viewId: viewId || '',
                            failuresCount: errorResponse.details.failures.accountIds.length + errorResponse.details.failures.groupIds.length
                        }
                    });
                    setState({
                        config: {
                            ...getState().config,
                            failures: {
                                role: role,
                                principals: [
                                    ...errorResponse.details.failures.accountIds.map((id)=>({
                                            id: id,
                                            name: principals.find((principal)=>principal.id === id)?.name ?? '',
                                            type: (0, $cByZ7.PRINCIPAL_TYPES).PROFILE
                                        })),
                                    ...errorResponse.details.failures.groupIds.map((id)=>({
                                            id: id,
                                            name: principals.find((principal)=>principal.id === id)?.name ?? '',
                                            type: (0, $cByZ7.PRINCIPAL_TYPES).GROUP
                                        }))
                                ]
                            }
                        }
                    });
                }
                if (hasSkippedAccounts || hasFailures) (0, $b5oGV.experience).viewPermissions.updatePrincipals.successWithReason({
                    metadata: {
                        error: `UpdatePrincipals: ${error.message}`,
                        type: $a98c718e6e7fba78$var$ufoExperienceType
                    }
                });
                else (0, $b5oGV.experience).viewPermissions.updatePrincipals.failure({
                    metadata: {
                        error: `UpdatePrincipals: ${error.message}`,
                        type: $a98c718e6e7fba78$var$ufoExperienceType
                    }
                });
                setState({
                    config: {
                        ...getState().config,
                        isAddingPrincipals: false
                    }
                });
            } else {
                if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isAccessForbiddenError)(error) || (0, $fVlmn.isNotFoundError)(error)) (0, $b5oGV.experience).viewPermissions.updatePrincipals.abort({
                    metadata: {
                        error: `UpdatePrincipals: ${error.message}`,
                        type: $a98c718e6e7fba78$var$ufoExperienceType
                    }
                });
                else (0, $b5oGV.experience).viewPermissions.updatePrincipals.failure({
                    metadata: {
                        error: `UpdatePrincipals: ${error.message}`,
                        type: $a98c718e6e7fba78$var$ufoExperienceType
                    }
                });
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-access.add-view-access-principals', error));
                setState({
                    config: {
                        ...getState().config,
                        isAddingPrincipals: false
                    }
                });
                onActionFailed?.(error);
            }
        }
    };

});
parcelRegister("k2y9F", function(module, exports) {

$parcel$export(module.exports, "fetchCurrentUserPermissions", () => $071401dc14a8c41b$export$81272e53313506bb);
$parcel$export(module.exports, "fetchViewPermissionsConfig", () => $071401dc14a8c41b$export$d4072d1684e86d65);
$parcel$export(module.exports, "applyUpdateViewAccessLevel", () => $071401dc14a8c41b$export$9b725185fd273405);
$parcel$export(module.exports, "applyAddViewAccessPrincipals", () => $071401dc14a8c41b$export$79bc480e2f9b7cad);
$parcel$export(module.exports, "applyRemoveViewAccessPrincipals", () => $071401dc14a8c41b$export$dc630f27e7237ed);

var $1Ozm9 = parcelRequire("1Ozm9");

var $jGzN3 = parcelRequire("jGzN3");

var $jbIuO = parcelRequire("jbIuO");
const $071401dc14a8c41b$var$getFetchCurrentUserPermissionsUrl = (viewUUID)=>`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/views/${viewUUID}/access/my-access`;
const $071401dc14a8c41b$var$getFetchViewPermissionsConfigUrl = (viewUUID)=>`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/views/${viewUUID}/access`;
const $071401dc14a8c41b$var$getUpdateViewAccessLevelUrl = (viewUUID)=>`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/views/${viewUUID}/access/level`;
const $071401dc14a8c41b$var$getAddViewAccessPrincipalsUrl = (viewUUID)=>`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/views/${viewUUID}/access/set`;
const $071401dc14a8c41b$var$getRemoveViewAccessPrincipalsUrl = (viewUUID)=>`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/views/${viewUUID}/access/remove`;
const $071401dc14a8c41b$export$81272e53313506bb = (viewUUID)=>(0, $1Ozm9.default)($071401dc14a8c41b$var$getFetchCurrentUserPermissionsUrl(viewUUID));
const $071401dc14a8c41b$export$d4072d1684e86d65 = (viewUUID, abortSignal)=>(0, $1Ozm9.default)($071401dc14a8c41b$var$getFetchViewPermissionsConfigUrl(viewUUID), {
        signal: abortSignal
    });
const $071401dc14a8c41b$export$9b725185fd273405 = ({ viewUUID: viewUUID, accessLevel: accessLevel })=>(0, $jGzN3.performPostRequest)($071401dc14a8c41b$var$getUpdateViewAccessLevelUrl(viewUUID), {
        body: JSON.stringify({
            accessLevel: accessLevel
        })
    });
const $071401dc14a8c41b$export$79bc480e2f9b7cad = (viewUUID, accounts, groups)=>(0, $jGzN3.performPostRequest)($071401dc14a8c41b$var$getAddViewAccessPrincipalsUrl(viewUUID), {
        body: JSON.stringify({
            accounts: accounts,
            groups: groups
        })
    });
const $071401dc14a8c41b$export$dc630f27e7237ed = (viewUUID, accounts, groups)=>(0, $jGzN3.performPostRequest)($071401dc14a8c41b$var$getRemoveViewAccessPrincipalsUrl(viewUUID), {
        body: JSON.stringify({
            accounts: accounts,
            groups: groups
        })
    });

});
parcelRegister("jbIuO", function(module, exports) {

$parcel$export(module.exports, "getJpdViewsServicePathPrefix", () => $f413c7737786871c$export$1d2754f769c8a3c6);
const $f413c7737786871c$export$1d2754f769c8a3c6 = ()=>{
    return '/gateway/api/jpd';
};

});


parcelRegister("3Tjbs", function(module, exports) {

$parcel$export(module.exports, "isSetViewAccessPrincipalRolesErrorResponse", () => $af52159a54977be6$export$a48c46da9dd81356);
const $af52159a54977be6$var$isObject = (arg)=>typeof arg === 'object' && arg !== null;
const $af52159a54977be6$var$isFailuresObject = (arg)=>$af52159a54977be6$var$isObject(arg) && $af52159a54977be6$var$isStringArray(arg.accountIds) && $af52159a54977be6$var$isStringArray(arg.groupIds);
const $af52159a54977be6$var$isStringArray = (arg)=>Array.isArray(arg) && arg.every((item)=>typeof item === 'string');
const $af52159a54977be6$var$isSkippedAccountsArray = (arg)=>Array.isArray(arg) && arg.every((item)=>$af52159a54977be6$var$isObject(item) && typeof item.accountId === 'string' && typeof item.errorCode === 'string');
const $af52159a54977be6$export$a48c46da9dd81356 = (arg)=>{
    if ($af52159a54977be6$var$isObject(arg) && typeof arg.status === 'number' && typeof arg.error === 'string' && typeof arg.path === 'string' && $af52159a54977be6$var$isObject(arg.details)) {
        if ($af52159a54977be6$var$isObject(arg.details.failures) && !$af52159a54977be6$var$isFailuresObject(arg.details.failures)) return false;
        if (Array.isArray(arg.details.skippedAccounts) && !$af52159a54977be6$var$isSkippedAccountsArray(arg.details.skippedAccounts)) return false;
        return true;
    }
    return false;
};

});

parcelRegister("g62ka", function(module, exports) {

$parcel$export(module.exports, "transformRoleToRoleAri", () => $fb5efcfe0eb78d96$export$3f73b76568f89641);

var $cByZ7 = parcelRequire("cByZ7");
const $fb5efcfe0eb78d96$export$3f73b76568f89641 = (role)=>role === (0, $cByZ7.ACCESS_ROLE_EDITOR) ? (0, $cByZ7.ACCESS_ROLE_EDITOR_ARI) : (0, $cByZ7.ACCESS_ROLE_VIEWER_ARI);

});

parcelRegister("cBwvx", function(module, exports) {

$parcel$export(module.exports, "loadViewPermissionsConfig", () => $8727b9bf8f314aec$export$ed3afb9ac0ecbe72);

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $cByZ7 = parcelRequire("cByZ7");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $gCeeo = parcelRequire("gCeeo");

var $k2y9F = parcelRequire("k2y9F");
let $8727b9bf8f314aec$var$controller;
const $8727b9bf8f314aec$export$ed3afb9ac0ecbe72 = ({ viewUUID: viewUUID, viewId: viewId, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
        setState({
            config: {
                ...getState().config,
                error: undefined
            }
        });
        (0, $b5oGV.experience).viewPermissions.loadViewAccess.start();
        try {
            // cancel previous ongoing requests if any
            $8727b9bf8f314aec$var$controller?.abort();
            $8727b9bf8f314aec$var$controller = new AbortController();
            const viewAccess = await (0, $k2y9F.fetchViewPermissionsConfig)(viewUUID, $8727b9bf8f314aec$var$controller.signal);
            setState({
                ...viewAccess,
                config: {
                    ...getState().config,
                    error: undefined
                }
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/69637
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData loaded', {
                viewUuid: viewUUID,
                viewId: viewId,
                accessLevel: viewAccess.accessLevel,
                userCount: viewAccess.additionalAccess.profiles.length,
                groupCount: viewAccess.additionalAccess.groups.length,
                hidden: viewAccess.accessLevel === (0, $cByZ7.VIEW_ACCESS_LEVELS).RESTRICTED && viewAccess.additionalAccess.profiles.length === 1 && viewAccess.additionalAccess.groups.length === 0
            });
            (0, $3Ku0X.sendPendoTrackEvent)({
                actionSubjectAndAction: 'viewAccessData loaded',
                actionSubjectId: 'viewAccessData',
                attributes: {
                    viewUuid: viewUUID,
                    viewId: viewId || '',
                    accessLevel: viewAccess.accessLevel,
                    userCount: viewAccess.additionalAccess.profiles.length,
                    groupCount: viewAccess.additionalAccess.groups.length,
                    hidden: viewAccess.accessLevel === (0, $cByZ7.VIEW_ACCESS_LEVELS).RESTRICTED && viewAccess.additionalAccess.profiles.length === 1 && viewAccess.additionalAccess.groups.length === 0
                }
            });
            (0, $b5oGV.experience).viewPermissions.loadViewAccess.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof DOMException && error.name === 'AbortError') {
                (0, $b5oGV.experience).viewPermissions.loadViewAccess.abort(error);
                return;
            }
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isAccessForbiddenError)(error) || (0, $fVlmn.isNotFoundError)(error)) (0, $b5oGV.experience).viewPermissions.loadViewAccess.abort(error);
            else (0, $b5oGV.experience).viewPermissions.loadViewAccess.failure(error);
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-access.load-view-access', error));
            setState({
                config: {
                    ...getState().config,
                    error: error
                }
            });
        }
    };

});


parcelRegister("5V0oD", function(module, exports) {

$parcel$export(module.exports, "changeViewAccessPrincipalRole", () => $fa55b0d4d119fef8$export$b4427b4fbdc69f20);

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $cByZ7 = parcelRequire("cByZ7");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $gCeeo = parcelRequire("gCeeo");

var $k2y9F = parcelRequire("k2y9F");

var $3Tjbs = parcelRequire("3Tjbs");

var $g62ka = parcelRequire("g62ka");

var $imdHP = parcelRequire("imdHP");

var $cBwvx = parcelRequire("cBwvx");
const $fa55b0d4d119fef8$var$ufoExperienceType = 'changeViewAccessPrincipalRole';
const $fa55b0d4d119fef8$export$b4427b4fbdc69f20 = ({ viewUUID: viewUUID, viewId: viewId, name: name, id: id, role: role, type: type, avatarUrl: avatarUrl, createAnalyticsEvent: createAnalyticsEvent, onActionFailed: onActionFailed })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { additionalAccess: additionalAccess, config: config, accessLevel: accessLevel } = getState();
        const roleAri = (0, $g62ka.transformRoleToRoleAri)(role);
        const oldRoleAri = type === (0, $cByZ7.PRINCIPAL_TYPES).PROFILE ? additionalAccess.profiles.find((item)=>item.accountId === id)?.role : additionalAccess.groups.find((item)=>item.groupId === id)?.role;
        if (!oldRoleAri) {
            await dispatch((0, $imdHP.addViewAccessPrincipals)({
                viewUUID: viewUUID,
                principals: [
                    {
                        id: id,
                        name: name,
                        type: type,
                        avatarUrl: avatarUrl
                    }
                ],
                role: role,
                viewId: viewId,
                createAnalyticsEvent: createAnalyticsEvent,
                onActionFailed: onActionFailed
            }));
            return;
        }
        try {
            (0, $b5oGV.experience).viewPermissions.updatePrincipals.start();
            setState({
                additionalAccess: {
                    profiles: type === (0, $cByZ7.PRINCIPAL_TYPES).PROFILE ? additionalAccess.profiles.map((item)=>item.accountId === id ? {
                            ...item,
                            role: roleAri
                        } : item) : additionalAccess.profiles,
                    groups: type === (0, $cByZ7.PRINCIPAL_TYPES).GROUP ? additionalAccess.groups.map((item)=>item.groupId === id ? {
                            ...item,
                            role: roleAri
                        } : item) : additionalAccess.groups
                },
                config: {
                    ...config,
                    failures: undefined,
                    skippedAccountFailures: config.skippedAccountFailures.filter((skippedAccount)=>skippedAccount.accountId !== id)
                }
            });
            await (0, $k2y9F.applyAddViewAccessPrincipals)(viewUUID, type === (0, $cByZ7.PRINCIPAL_TYPES).PROFILE ? [
                {
                    id: id,
                    role: roleAri
                }
            ] : [], type === (0, $cByZ7.PRINCIPAL_TYPES).GROUP ? [
                {
                    id: id,
                    role: roleAri
                }
            ] : []);
            await dispatch((0, $cBwvx.loadViewPermissionsConfig)({
                viewUUID: viewUUID,
                viewId: viewId,
                createAnalyticsEvent: createAnalyticsEvent
            }));
            // https://data-portal.internal.atlassian.com/analytics/registry/69640
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData roleChanged', {
                viewUuid: viewUUID,
                viewId: viewId,
                accessLevel: accessLevel,
                principalType: type,
                role: role
            });
            (0, $3Ku0X.sendPendoTrackEvent)({
                actionSubjectAndAction: 'viewAccessData roleChanged',
                actionSubjectId: 'viewAccessData',
                attributes: {
                    viewUuid: viewUUID,
                    viewId: viewId || '',
                    accessLevel: accessLevel,
                    principalType: type,
                    role: role
                }
            });
            (0, $b5oGV.experience).viewPermissions.updatePrincipals.success({
                metadata: {
                    type: $fa55b0d4d119fef8$var$ufoExperienceType
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            let errorResponse = error.originalResponse;
            try {
                if (typeof error.originalResponse?.json === 'function') errorResponse = await error.originalResponse.json();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (subError) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-access.change-view-access-principals-role.parse-error', subError));
            }
            const currentState = getState();
            if ((0, $3Tjbs.isSetViewAccessPrincipalRolesErrorResponse)(errorResponse)) {
                let hasSkippedAccounts = false;
                let hasFailures = false;
                if (errorResponse.details.skippedAccounts?.[0]) {
                    hasSkippedAccounts = true;
                    // https://data-portal.internal.atlassian.com/analytics/registry/69691
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData setRoleFailureSkippedAccounts', {
                        viewUuid: viewUUID,
                        viewId: viewId,
                        missingManageViewsPermissionCount: errorResponse.details.skippedAccounts.filter((item)=>item.errorCode === (0, $cByZ7.ACCESS_ROLE_ERRORS).MISSING_MANAGE_DISCOVERY_VIEWS_PERMISSION).length,
                        missingProjectAccessCount: errorResponse.details.skippedAccounts.filter((item)=>item.errorCode === (0, $cByZ7.ACCESS_ROLE_ERRORS).MISSING_BROWSE_PROJECTS_PERMISSION).length
                    });
                    (0, $3Ku0X.sendPendoTrackEvent)({
                        actionSubjectAndAction: 'viewAccessData setRoleFailureSkippedAccounts',
                        actionSubjectId: 'viewAccessData',
                        attributes: {
                            viewUuid: viewUUID,
                            viewId: viewId || '',
                            missingManageViewsPermissionCount: errorResponse.details.skippedAccounts.filter((item)=>item.errorCode === (0, $cByZ7.ACCESS_ROLE_ERRORS).MISSING_MANAGE_DISCOVERY_VIEWS_PERMISSION).length,
                            missingProjectAccessCount: errorResponse.details.skippedAccounts.filter((item)=>item.errorCode === (0, $cByZ7.ACCESS_ROLE_ERRORS).MISSING_BROWSE_PROJECTS_PERMISSION).length
                        }
                    });
                    setState({
                        config: {
                            ...currentState.config,
                            skippedAccountFailures: [
                                ...currentState.config.skippedAccountFailures.filter((item)=>item.accountId !== errorResponse.details.skippedAccounts?.[0]?.accountId),
                                {
                                    accountId: errorResponse.details.skippedAccounts[0].accountId,
                                    errorCode: errorResponse.details.skippedAccounts[0].errorCode,
                                    name: name,
                                    requestedRole: role,
                                    avatarUrl: avatarUrl
                                }
                            ]
                        },
                        additionalAccess: {
                            profiles: type === (0, $cByZ7.PRINCIPAL_TYPES).PROFILE ? currentState.additionalAccess.profiles.map((item)=>item.accountId === id ? {
                                    ...item,
                                    role: oldRoleAri
                                } : item) : currentState.additionalAccess.profiles,
                            groups: currentState.additionalAccess.groups
                        }
                    });
                }
                if (errorResponse.details.failures && (errorResponse.details.failures.accountIds.length || errorResponse.details.failures.groupIds.length)) {
                    hasFailures = true;
                    // https://data-portal.internal.atlassian.com/analytics/registry/69692
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData setRoleFailure', {
                        viewUuid: viewUUID,
                        viewId: viewId,
                        failuresCount: 1
                    });
                    (0, $3Ku0X.sendPendoTrackEvent)({
                        actionSubjectAndAction: 'viewAccessData setRoleFailure',
                        actionSubjectId: 'viewAccessData',
                        attributes: {
                            viewUuid: viewUUID,
                            viewId: viewId || '',
                            failuresCount: 1
                        }
                    });
                    setState({
                        config: {
                            ...currentState.config,
                            failures: {
                                role: role,
                                principals: [
                                    {
                                        id: id,
                                        name: name,
                                        type: type
                                    }
                                ]
                            }
                        },
                        additionalAccess: {
                            profiles: type === (0, $cByZ7.PRINCIPAL_TYPES).PROFILE ? currentState.additionalAccess.profiles.map((item)=>item.accountId === id ? {
                                    ...item,
                                    role: oldRoleAri
                                } : item) : currentState.additionalAccess.profiles,
                            groups: type === (0, $cByZ7.PRINCIPAL_TYPES).GROUP ? currentState.additionalAccess.groups.map((item)=>item.groupId === id ? {
                                    ...item,
                                    role: oldRoleAri
                                } : item) : currentState.additionalAccess.groups
                        }
                    });
                }
                if (hasSkippedAccounts || hasFailures) (0, $b5oGV.experience).viewPermissions.updatePrincipals.successWithReason({
                    metadata: {
                        error: `UpdatePrincipals: ${error.message}`,
                        type: $fa55b0d4d119fef8$var$ufoExperienceType
                    }
                });
                else (0, $b5oGV.experience).viewPermissions.updatePrincipals.failure({
                    metadata: {
                        error: `UpdatePrincipals: ${error.message}`,
                        type: $fa55b0d4d119fef8$var$ufoExperienceType
                    }
                });
            } else {
                if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isAccessForbiddenError)(error) || (0, $fVlmn.isNotFoundError)(error)) (0, $b5oGV.experience).viewPermissions.updatePrincipals.abort({
                    metadata: {
                        error: `UpdatePrincipals: ${error.message}`,
                        type: $fa55b0d4d119fef8$var$ufoExperienceType
                    }
                });
                else (0, $b5oGV.experience).viewPermissions.updatePrincipals.failure({
                    metadata: {
                        error: `UpdatePrincipals: ${error.message}`,
                        type: $fa55b0d4d119fef8$var$ufoExperienceType
                    }
                });
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-access.change-view-access-principals-role', error));
                onActionFailed?.(error);
            }
        }
    };

});

parcelRegister("8YHj5", function(module, exports) {

$parcel$export(module.exports, "clearFailures", () => $1fab37724a12fcd9$export$fbc15850eabdf9d4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1fab37724a12fcd9$export$fbc15850eabdf9d4 = ()=>async ({ getState: getState, setState: setState })=>{
        setState({
            config: {
                ...getState().config,
                failures: undefined
            }
        });
    };

});

parcelRegister("8CYhV", function(module, exports) {

$parcel$export(module.exports, "clearSkippedAccountFailures", () => $fbf5f252b8faae67$export$446815edb3b2d7c1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $fbf5f252b8faae67$export$446815edb3b2d7c1 = ()=>async ({ getState: getState, setState: setState })=>{
        setState({
            config: {
                ...getState().config,
                skippedAccountFailures: []
            }
        });
    };

});

parcelRegister("jLcRQ", function(module, exports) {

$parcel$export(module.exports, "loadCurrentUserViewAccess", () => $3f134c43459f1a77$export$dc29a7932655bab9);

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $cByZ7 = parcelRequire("cByZ7");

var $b5oGV = parcelRequire("b5oGV");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $k2y9F = parcelRequire("k2y9F");
const $3f134c43459f1a77$export$dc29a7932655bab9 = (viewUUID, reload = false)=>async ({ getState: getState, setState: setState })=>{
        const viewAccessMap = getState().viewAccessMap;
        const currentViewAccess = viewAccessMap[viewUUID];
        if (currentViewAccess && !reload) return {
            role: currentViewAccess.state === 'succeeded' ? currentViewAccess.role : undefined,
            accessLevel: currentViewAccess.state === 'succeeded' ? currentViewAccess.accessLevel : undefined,
            state: currentViewAccess.state
        };
        if (!reload) setState({
            viewAccessMap: {
                ...viewAccessMap,
                [viewUUID]: {
                    state: 'loading'
                }
            }
        });
        (0, $b5oGV.experience).viewPermissions.loadCurrentUserViewPermissions.start();
        try {
            const response = await (0, $k2y9F.fetchCurrentUserPermissions)(viewUUID);
            let role;
            if (response.permissions.read_view) role = (0, $cByZ7.ACCESS_ROLE_VIEWER_ARI);
            if (response.permissions.edit_view) role = (0, $cByZ7.ACCESS_ROLE_EDITOR_ARI);
            if (role === undefined) throw new Error('polaris.view-access.load-current-user-view-access-role: invalid response');
            (0, $b5oGV.experience).viewPermissions.loadCurrentUserViewPermissions.success();
            setState({
                viewAccessMap: {
                    ...getState().viewAccessMap,
                    [viewUUID]: {
                        role: role,
                        accessLevel: response.accessLevel,
                        state: 'succeeded'
                    }
                }
            });
            return {
                role: role,
                accessLevel: response.accessLevel,
                state: 'succeeded'
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if ((0, $fVlmn.isAccessForbiddenError)(error)) {
                (0, $b5oGV.experience).viewPermissions.loadCurrentUserViewPermissions.abort(error);
                setState({
                    viewAccessMap: {
                        ...getState().viewAccessMap,
                        [viewUUID]: {
                            state: 'no-access'
                        }
                    }
                });
                return {
                    role: undefined,
                    accessLevel: undefined,
                    state: 'no-access'
                };
            }
            if ((0, $8KUFq.isClientFetchError)(error)) (0, $b5oGV.experience).viewPermissions.loadCurrentUserViewPermissions.abort(error);
            else (0, $b5oGV.experience).viewPermissions.loadCurrentUserViewPermissions.failure(error);
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-access.load-current-user-view-access-role', error));
            setState({
                viewAccessMap: {
                    ...getState().viewAccessMap,
                    [viewUUID]: {
                        state: 'failed'
                    }
                }
            });
            return {
                role: undefined,
                accessLevel: undefined,
                state: 'failed'
            };
        }
    };

});

parcelRegister("4gmLZ", function(module, exports) {

$parcel$export(module.exports, "removeViewAccessPrincipals", () => $6dcaf97965211b34$export$feafc951a1311c6d);

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $cByZ7 = parcelRequire("cByZ7");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $gCeeo = parcelRequire("gCeeo");

var $k2y9F = parcelRequire("k2y9F");
const $6dcaf97965211b34$var$ufoExperienceType = 'removeViewAccessPrincipals';
const $6dcaf97965211b34$export$feafc951a1311c6d = ({ viewUUID: viewUUID, accounts: accounts, groups: groups, viewId: viewId, createAnalyticsEvent: createAnalyticsEvent, onActionFailed: onActionFailed })=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const accessLevel = state.accessLevel;
        const filterOutDeletedAccounts = (item)=>!accounts.includes(item.accountId);
        const filterOutDeletedGroups = (item)=>!groups.includes(item.groupId);
        const newAdditionalAccess = {
            profiles: state.additionalAccess.profiles.filter(filterOutDeletedAccounts),
            groups: state.additionalAccess.groups.filter(filterOutDeletedGroups)
        };
        setState({
            additionalAccess: newAdditionalAccess,
            config: {
                ...state.config,
                skippedAccountFailures: state.config.skippedAccountFailures.filter(({ accountId: accountId })=>!accounts.includes(accountId))
            }
        });
        try {
            (0, $b5oGV.experience).viewPermissions.updatePrincipals.start();
            await (0, $k2y9F.applyRemoveViewAccessPrincipals)(viewUUID, accounts, groups);
            // https://data-portal.internal.atlassian.com/analytics/registry/69641
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData principalRemoved', {
                viewUuid: viewUUID,
                viewId: viewId,
                accessLevel: accessLevel,
                principalType: accounts.length > 0 ? (0, $cByZ7.PRINCIPAL_TYPES).PROFILE : (0, $cByZ7.PRINCIPAL_TYPES).GROUP
            });
            (0, $3Ku0X.sendPendoTrackEvent)({
                actionSubjectAndAction: 'viewAccessData principalRemoved',
                actionSubjectId: 'viewAccessData',
                attributes: {
                    viewUuid: viewUUID,
                    viewId: viewId || '',
                    accessLevel: accessLevel,
                    principalType: accounts.length > 0 ? (0, $cByZ7.PRINCIPAL_TYPES).PROFILE : (0, $cByZ7.PRINCIPAL_TYPES).GROUP
                }
            });
            (0, $b5oGV.experience).viewPermissions.updatePrincipals.success({
                metadata: {
                    type: $6dcaf97965211b34$var$ufoExperienceType
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isAccessForbiddenError)(error) || (0, $fVlmn.isNotFoundError)(error)) (0, $b5oGV.experience).viewPermissions.updatePrincipals.abort({
                metadata: {
                    error: `UpdatePrincipals: ${error.message}`,
                    type: $6dcaf97965211b34$var$ufoExperienceType
                }
            });
            else (0, $b5oGV.experience).viewPermissions.updatePrincipals.failure({
                metadata: {
                    error: `UpdatePrincipals: ${error.message}`,
                    type: $6dcaf97965211b34$var$ufoExperienceType
                }
            });
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-access.remove-view-access-principals', error));
            const filterOutNonDeletedAccounts = (item)=>accounts.includes(item.accountId);
            const filterOutNonDeletedGroups = (item)=>groups.includes(item.groupId);
            const currentState = getState();
            setState({
                additionalAccess: {
                    profiles: [
                        ...currentState.additionalAccess.profiles.filter(filterOutDeletedAccounts),
                        ...state.additionalAccess.profiles.filter(filterOutNonDeletedAccounts)
                    ],
                    groups: [
                        ...currentState.additionalAccess.groups.filter(filterOutDeletedGroups),
                        ...state.additionalAccess.groups.filter(filterOutNonDeletedGroups)
                    ]
                }
            });
            onActionFailed?.(error);
        }
    };

});

parcelRegister("hCoqy", function(module, exports) {

$parcel$export(module.exports, "setHasManageViewsPermission", () => $0d29ccc0c0219715$export$1edeb51bfd21bb4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0d29ccc0c0219715$export$1edeb51bfd21bb4c = (hasManageViewsPermission)=>({ setState: setState })=>{
        setState({
            hasManageViewsPermission: hasManageViewsPermission
        });
    };

});

parcelRegister("e50zx", function(module, exports) {

$parcel$export(module.exports, "updateViewAccessLevel", () => $086a81cda4f670a6$export$c93cd493e48509bf);

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $gCeeo = parcelRequire("gCeeo");

var $k2y9F = parcelRequire("k2y9F");

var $cBwvx = parcelRequire("cBwvx");
const $086a81cda4f670a6$export$c93cd493e48509bf = ({ viewUUID: viewUUID, accessLevel: accessLevel, viewId: viewId, createAnalyticsEvent: createAnalyticsEvent, onActionFailed: onActionFailed })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const oldAccessLevel = getState().accessLevel;
        setState({
            accessLevel: accessLevel
        });
        try {
            (0, $b5oGV.experience).viewPermissions.updateViewAccess.start();
            await (0, $k2y9F.applyUpdateViewAccessLevel)({
                viewUUID: viewUUID,
                accessLevel: accessLevel
            });
            await dispatch((0, $cBwvx.loadViewPermissionsConfig)({
                viewUUID: viewUUID,
                viewId: viewId,
                createAnalyticsEvent: createAnalyticsEvent
            }));
            // https://data-portal.internal.atlassian.com/analytics/registry/69638
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewAccessData accessLevelChanged', {
                viewUuid: viewUUID,
                viewId: viewId,
                from: oldAccessLevel,
                to: accessLevel
            });
            (0, $3Ku0X.sendPendoTrackEvent)({
                actionSubjectAndAction: 'viewAccessData accessLevelChanged',
                actionSubjectId: 'viewAccessData',
                attributes: {
                    viewUuid: viewUUID,
                    viewId: viewId || '',
                    from: oldAccessLevel,
                    to: accessLevel
                }
            });
            (0, $b5oGV.experience).viewPermissions.updateViewAccess.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if ((0, $8KUFq.isClientFetchError)(error) || (0, $fVlmn.isAccessForbiddenError)(error) || (0, $fVlmn.isNotFoundError)(error)) (0, $b5oGV.experience).viewPermissions.updateViewAccess.abort(error);
            else (0, $b5oGV.experience).viewPermissions.updateViewAccess.failure(error);
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-access.update-access-level', error));
            setState({
                accessLevel: oldAccessLevel
            });
            onActionFailed?.(error);
        }
    };

});


parcelRegister("eE8M5", function(module, exports) {

$parcel$export(module.exports, "useViewAccessMap", () => $cec90e15f391b14c$export$a55c023f67faa3d7);
$parcel$export(module.exports, "useHasManageViewsPermission", () => $cec90e15f391b14c$export$7ab99da117b7f9b2);
$parcel$export(module.exports, "useCurrentViewAccessConfig", () => $cec90e15f391b14c$export$2be8bcc0a68ad15f);
$parcel$export(module.exports, "useCurrentViewAccess", () => $cec90e15f391b14c$export$df1534b95da02b67);

var $fkpML = parcelRequire("fkpML");
const $cec90e15f391b14c$var$getViewAccessMap = (state)=>state.viewAccessMap;
const $cec90e15f391b14c$var$getHasManageViewsPermission = (state)=>state.hasManageViewsPermission;
const $cec90e15f391b14c$var$getCurrentViewAccessConfig = (state)=>state.config;
const $cec90e15f391b14c$var$getCurrentViewAccess = (state)=>({
        accessLevel: state.accessLevel,
        additionalAccess: state.additionalAccess
    });
const $cec90e15f391b14c$export$a55c023f67faa3d7 = (0, $fkpML.createViewAccessStateHook)($cec90e15f391b14c$var$getViewAccessMap);
const $cec90e15f391b14c$export$7ab99da117b7f9b2 = (0, $fkpML.createViewAccessStateHook)($cec90e15f391b14c$var$getHasManageViewsPermission);
const $cec90e15f391b14c$export$2be8bcc0a68ad15f = (0, $fkpML.createViewAccessStateHook)($cec90e15f391b14c$var$getCurrentViewAccessConfig);
const $cec90e15f391b14c$export$df1534b95da02b67 = (0, $fkpML.createViewAccessStateHook)($cec90e15f391b14c$var$getCurrentViewAccess);

});


parcelRegister("cQ9m7", function(module, exports) {

$parcel$export(module.exports, "useEntityLimitMessage", () => $38772bbdd3805853$export$5742ba1ea30fad0);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6K8rv = parcelRequire("6K8rv");
const $38772bbdd3805853$export$5742ba1ea30fad0 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)((limitType, limitValue)=>{
        const message = (0, $6K8rv.getLimitMessageDescriptor)(limitType);
        return message ? formatMessage(message, {
            limit: limitValue
        }) : null;
    }, [
        formatMessage
    ]);
};

});
parcelRegister("6K8rv", function(module, exports) {

$parcel$export(module.exports, "getLimitMessageDescriptor", () => $5904685b0f1d4e24$export$73d6edc517ef6f51);

var $3LdZJ = parcelRequire("3LdZJ");
const $5904685b0f1d4e24$export$73d6edc517ef6f51 = (limitType)=>(0, $3LdZJ.default)[limitType] || null;

});
parcelRegister("3LdZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $16fb962f4092d279$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");

var $3PaO7 = parcelRequire("3PaO7");

var $69PvG = parcelRequire("69PvG");
var $16fb962f4092d279$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "polaris-component-limits.common.title",
        "defaultMessage": "Unavailable"
    },
    /* eslint-disable jira/i18n/id-named-by-package */ [(0, $69PvG.ENTITY_LIMIT_TYPE).COMMENTS_PER_VIEW]: {
        "id": "polaris-component-limits.common.comments-per-view",
        "defaultMessage": "This view has reached its maximum of {limit, plural, one {# comment} other {# comments}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).FIELDS_PER_VIEW]: {
        "id": "polaris-component-limits.common.fields-per-view",
        "defaultMessage": "This view has reached its maximum of {limit, plural, one {# field} other {# fields}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).FIELDS_PER_PROJECT]: {
        "id": "polaris-component-limits.common.fields-per-project",
        "defaultMessage": "This project has reached its maximum of {limit, plural, one {# field} other {# fields}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).IDEAS_SEARCH_MAX_RESULTS]: {
        "id": "polaris-component-limits.common.ideas-search-max-results",
        "defaultMessage": "This search has reached its maximum of {limit, plural, one {# result} other {# results}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).INSIGHTS_PER_IDEA]: {
        "id": "polaris-component-limits.common.insights-per-idea",
        "defaultMessage": "This idea has reached its maximum of {limit, plural, one {# insight} other {# insights}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).INSIGHTS_PER_PROJECT]: {
        "id": "polaris-component-limits.common.insights-per-project",
        "defaultMessage": "This project has reached its maximum of {limit, plural, one {# insight} other {# insights}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).LABELS_PER_SNIPPET]: {
        "id": "polaris-component-limits.common.labels-per-snippet",
        "defaultMessage": "This snippet has reached its maximum of {limit, plural, one {# label} other {# labels}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).OPTIONS_PER_FIELD]: {
        "id": "polaris-component-limits.common.options-per-field",
        "defaultMessage": "This field has reached its maximum of {limit, plural, one {# option} other {# options}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
        "id": "polaris-component-limits.common.play-contributions-per-play",
        "defaultMessage": "This vote has reached its maximum of {limit, plural, one {# vote contribution} other {# vote contributions}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
        "id": "polaris-component-limits.common.play-contributions-per-project",
        "defaultMessage": "This project has reached its maximum of {limit, plural, one {# vote contribution} other {# vote contributions}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).PLAYS_PER_PROJECT]: {
        "id": "polaris-component-limits.common.plays-per-project",
        "defaultMessage": "This project has reached its maximum of {limit, plural, one {# vote} other {# votes}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).SNIPPETS_PER_INSIGHT]: {
        "id": "polaris-component-limits.common.snippets-per-insight",
        "defaultMessage": "This insight has reached its maximum of {limit, plural, one {# snippet} other {# snippets}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).VIEWS_PER_PROJECT]: {
        "id": "polaris-component-limits.common.views-per-project",
        "defaultMessage": "This project has reached its maximum of {limit, plural, one {# view} other {# views}}."
    },
    [(0, $3PaO7.ENTITY_LIMIT_TYPE).VIEWS_PER_COLLECTION]: {
        "id": "polaris-component-limits.common.views-per-collection",
        "defaultMessage": "This roadmap has reached its maximum of {limit, plural, one {# view} other {# views}}."
    },
    [(0, $69PvG.ENTITY_LIMIT_TYPE).VIEWSETS_PER_PROJECT]: {
        "id": "polaris-component-limits.common.viewsets-per-project",
        "defaultMessage": "This project has reached its maximum of {limit, plural, one {# section} other {# sections}}."
    },
    [(0, $3PaO7.ENTITY_LIMIT_TYPE).COLLECTIONS_PER_SITE]: {
        "id": "polaris-component-limits.common.collections-per-site",
        "defaultMessage": "This site has reached its maximum of {limit, plural, one {# roadmap} other {# roadmaps}}."
    }
});

});



parcelRegister("g1LS3", function(module, exports) {

$parcel$export(module.exports, "CollectionsContainer", () => $d2b8ac08655b3efe$export$80cb348e37947c6a);
$parcel$export(module.exports, "useCollectionsActions", () => $d2b8ac08655b3efe$export$ba61932a631ba139);
$parcel$export(module.exports, "useCollectionsOwnersIds", () => $d2b8ac08655b3efe$export$47ee56d816ebfe18);
$parcel$export(module.exports, "useFilteredCollections", () => $d2b8ac08655b3efe$export$a4dbccbfbbac764d);
$parcel$export(module.exports, "useCollectionsLoading", () => $d2b8ac08655b3efe$export$c4791ba8ac9a58e5);
$parcel$export(module.exports, "useCollectionsHasError", () => $d2b8ac08655b3efe$export$1b07b501c3f8f216);
$parcel$export(module.exports, "useCollectionsCount", () => $d2b8ac08655b3efe$export$41be1fea11eb73ec);
$parcel$export(module.exports, "useCollectionName", () => $d2b8ac08655b3efe$export$71661e51ce252508);
$parcel$export(module.exports, "useCollectionEmoji", () => $d2b8ac08655b3efe$export$c35637e36ec6f8fd);
$parcel$export(module.exports, "useCollectionJql", () => $d2b8ac08655b3efe$export$3ddba651313f7cb0);
$parcel$export(module.exports, "useCollectionViews", () => $d2b8ac08655b3efe$export$4d3e73040770b6);
$parcel$export(module.exports, "useCollectionLoading", () => $d2b8ac08655b3efe$export$6073e01a27128de4);
$parcel$export(module.exports, "useCollectionError", () => $d2b8ac08655b3efe$export$5a7fad0d58c5f5e2);
$parcel$export(module.exports, "useCollectionHasError", () => $d2b8ac08655b3efe$export$a864c959274a94b8);
$parcel$export(module.exports, "useCollectionViewsCount", () => $d2b8ac08655b3efe$export$1a42c92187206222);
$parcel$export(module.exports, "useHasFetchedCollectionViews", () => $d2b8ac08655b3efe$export$32becd83126d3e5b);
$parcel$export(module.exports, "useCollectionOwnerId", () => $d2b8ac08655b3efe$export$333713f4878fc62d);
$parcel$export(module.exports, "useCollectionDescription", () => $d2b8ac08655b3efe$export$31549a29278f29ca);
$parcel$export(module.exports, "useCollectionProjectKeys", () => $d2b8ac08655b3efe$export$627b89d60c64164a);
$parcel$export(module.exports, "useCollectionFiltersJql", () => $d2b8ac08655b3efe$export$6a559aa025c2caf0);
$parcel$export(module.exports, "useProjectCollectionsCount", () => $d2b8ac08655b3efe$export$e785641239dc5c88);
$parcel$export(module.exports, "useIsCollectionDescriptionLoading", () => $d2b8ac08655b3efe$export$d01e52f887fd0aef);
$parcel$export(module.exports, "useCollectionDescriptionHasError", () => $d2b8ac08655b3efe$export$d8d51044786d761);

var $jvwCK = parcelRequire("jvwCK");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $6fY02 = parcelRequire("6fY02");

var $g4I3Q = parcelRequire("g4I3Q");
const $d2b8ac08655b3efe$var$initialState = {
    collections: {},
    isLoading: true,
    error: undefined,
    descriptions: {}
};
const $d2b8ac08655b3efe$var$Store = (0, $GtRbT.createStore)({
    initialState: $d2b8ac08655b3efe$var$initialState,
    actions: $6fY02,
    name: 'PolarisCollections'
});
const $d2b8ac08655b3efe$export$80cb348e37947c6a = (0, $6E16M.createContainer)($d2b8ac08655b3efe$var$Store);
const $d2b8ac08655b3efe$export$ba61932a631ba139 = (0, $iJq0l.createActionsHook)($d2b8ac08655b3efe$var$Store);
const $d2b8ac08655b3efe$var$getCollections = (state)=>state.collections;
const $d2b8ac08655b3efe$var$getCollectionsList = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollections, (collections)=>Object.values(collections).map((c)=>c?.data).filter(Boolean));
const $d2b8ac08655b3efe$var$getCollectionIds = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollections, (collections)=>Object.keys(collections));
const $d2b8ac08655b3efe$var$getCollectionsLoading = (state)=>state.isLoading;
const $d2b8ac08655b3efe$var$getCollectionsError = (state)=>state.error;
const $d2b8ac08655b3efe$var$getCollectionsHasError = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionsError, (error)=>!!error);
const $d2b8ac08655b3efe$var$getCollectionsOwnersIds = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionsList, (collections)=>(0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(collections.map(({ ownerId: ownerId })=>ownerId).filter(Boolean)));
const $d2b8ac08655b3efe$var$getFilteredCollections = (0, $4MchI.createSelector)((state)=>$d2b8ac08655b3efe$var$getCollectionsList(state), (_, { text: text })=>text, (_, { ownerIds: ownerIds })=>ownerIds, (_, { projects: projects })=>projects, (collections, text, ownerIds, projects)=>collections ? collections.filter((collection)=>(0, $g4I3Q.filterCollectionByText)(text)(collection) && (0, $g4I3Q.filterCollectionByOwnerIds)(ownerIds)(collection) && (0, $g4I3Q.filterCollectionByProjectKeys)(projects)(collection)) : []);
const $d2b8ac08655b3efe$var$getCollectionsCount = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionsList, (collections)=>collections.length);
const $d2b8ac08655b3efe$export$47ee56d816ebfe18 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionsOwnersIds
});
const $d2b8ac08655b3efe$export$a4dbccbfbbac764d = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getFilteredCollections
});
const $d2b8ac08655b3efe$export$2b5787016ed09c4d = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollections
});
const $d2b8ac08655b3efe$export$c4791ba8ac9a58e5 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionsLoading
});
const $d2b8ac08655b3efe$export$1b07b501c3f8f216 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionsHasError
});
const $d2b8ac08655b3efe$export$41be1fea11eb73ec = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionsCount
});
const $d2b8ac08655b3efe$export$e9fd0b8259ad0113 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionIds
});
const $d2b8ac08655b3efe$var$getCollectionWithMeta = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollections, (_, { collectionUUID: collectionUUID })=>collectionUUID, (collections, collectionUUID)=>collectionUUID ? collections[collectionUUID] : undefined);
const $d2b8ac08655b3efe$var$getCollection = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionWithMeta, (collection)=>collection?.data);
const $d2b8ac08655b3efe$var$getCollectionName = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>collection?.name);
const $d2b8ac08655b3efe$var$getCollectionEmoji = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>collection?.emoji);
const $d2b8ac08655b3efe$var$getCollectionJql = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>collection?.jql);
const $d2b8ac08655b3efe$var$getCollectionViews = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>collection?.views || []);
const $d2b8ac08655b3efe$var$hasFetchedCollectionViews = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>Array.isArray(collection?.views));
const $d2b8ac08655b3efe$var$getIsCollectionLoading = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionWithMeta, (collection)=>!!collection?.isLoading && !collection?.data?.views);
const $d2b8ac08655b3efe$var$getCollectionProjectKeys = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>collection?.projectKeys);
const $d2b8ac08655b3efe$var$getCollectionFiltersJql = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>collection?.filtersJql);
const $d2b8ac08655b3efe$var$getProjectCollectionsCount = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollections, (collections)=>Object.values(collections).flatMap((collection)=>collection?.data?.projectKeys).filter((key)=>!!key).reduce((acc, projectKey)=>{
        acc[projectKey] = (acc[projectKey] ?? 0) + 1;
        return acc;
    }, {}));
const $d2b8ac08655b3efe$var$getError = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionWithMeta, (collection)=>collection?.error);
const $d2b8ac08655b3efe$var$hasError = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getError, (error)=>!!error);
const $d2b8ac08655b3efe$var$getCollectionViewsOwnersIds = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionViews, (views)=>(0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(views.map(({ ownerId: ownerId })=>ownerId).filter(Boolean)));
const $d2b8ac08655b3efe$var$getCollectionView = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionViews, (_, { viewUUID: viewUUID })=>viewUUID, (views, viewUUID)=>viewUUID ? views.find((view)=>view.uuid === viewUUID) : undefined);
const $d2b8ac08655b3efe$var$getCollectionViewTitle = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionView, (view)=>view?.title);
const $d2b8ac08655b3efe$var$getCollectionViewsCount = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>collection?.views?.length || collection?.viewsCount);
const $d2b8ac08655b3efe$var$getCollectionOwnerId = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollection, (collection)=>collection?.ownerId);
const $d2b8ac08655b3efe$var$getDescriptions = (state)=>state.descriptions;
const $d2b8ac08655b3efe$var$getCollectionDescriptionWithMeta = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getDescriptions, (_, { collectionUUID: collectionUUID })=>collectionUUID, (descriptions, collectionUUID)=>collectionUUID ? descriptions[collectionUUID] : undefined);
const $d2b8ac08655b3efe$var$getCollectionDescription = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>descriptionWithMeta?.description);
const $d2b8ac08655b3efe$var$getIsCollectionDescriptionLoading = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>!!descriptionWithMeta?.isLoading);
const $d2b8ac08655b3efe$var$getCollectionDescriptionHasError = (0, $4MchI.createSelector)($d2b8ac08655b3efe$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>!!descriptionWithMeta?.error);
const $d2b8ac08655b3efe$export$6cd28814d92fa9c9 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollection
});
const $d2b8ac08655b3efe$export$71661e51ce252508 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionName
});
const $d2b8ac08655b3efe$export$c35637e36ec6f8fd = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionEmoji
});
const $d2b8ac08655b3efe$export$3ddba651313f7cb0 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionJql
});
const $d2b8ac08655b3efe$export$4d3e73040770b6 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionViews
});
const $d2b8ac08655b3efe$export$6073e01a27128de4 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getIsCollectionLoading
});
const $d2b8ac08655b3efe$export$5a7fad0d58c5f5e2 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getError
});
const $d2b8ac08655b3efe$export$a864c959274a94b8 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$hasError
});
const $d2b8ac08655b3efe$export$794fd3b80c093caa = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionViewsOwnersIds
});
const $d2b8ac08655b3efe$export$61588707ea3d7293 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionView
});
const $d2b8ac08655b3efe$export$652691088e3ed5ff = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionViewTitle
});
const $d2b8ac08655b3efe$export$1a42c92187206222 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionViewsCount
});
const $d2b8ac08655b3efe$export$32becd83126d3e5b = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$hasFetchedCollectionViews
});
const $d2b8ac08655b3efe$export$333713f4878fc62d = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionOwnerId
});
const $d2b8ac08655b3efe$export$31549a29278f29ca = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionDescription
});
const $d2b8ac08655b3efe$export$627b89d60c64164a = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionProjectKeys
});
const $d2b8ac08655b3efe$export$6a559aa025c2caf0 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionFiltersJql
});
const $d2b8ac08655b3efe$export$e785641239dc5c88 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getProjectCollectionsCount
});
const $d2b8ac08655b3efe$export$d01e52f887fd0aef = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getIsCollectionDescriptionLoading
});
const $d2b8ac08655b3efe$export$d8d51044786d761 = (0, $iJq0l.createStateHook)($d2b8ac08655b3efe$var$Store, {
    selector: $d2b8ac08655b3efe$var$getCollectionDescriptionHasError
});

});
parcelRegister("6fY02", function(module, exports) {

$parcel$export(module.exports, "initialize", () => (parcelRequire("aU6fm")).initialize);
$parcel$export(module.exports, "createCollection", () => (parcelRequire("aU6fm")).createCollection);
$parcel$export(module.exports, "deleteCollection", () => (parcelRequire("aU6fm")).deleteCollection);
$parcel$export(module.exports, "updateCollection", () => (parcelRequire("aU6fm")).updateCollection);
$parcel$export(module.exports, "loadCollection", () => (parcelRequire("aU6fm")).loadCollection);
$parcel$export(module.exports, "loadCollections", () => (parcelRequire("aU6fm")).loadCollections);
$parcel$export(module.exports, "copyCollection", () => (parcelRequire("aU6fm")).copyCollection);
$parcel$export(module.exports, "getCollectionData", () => (parcelRequire("aU6fm")).getCollectionData);
$parcel$export(module.exports, "syncStateWithCollectionStoreAfterViewDelete", () => (parcelRequire("aU6fm")).syncStateWithCollectionStoreAfterViewDelete);
$parcel$export(module.exports, "createView", () => (parcelRequire("h2BRl")).createView);
$parcel$export(module.exports, "deleteView", () => (parcelRequire("h2BRl")).deleteView);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => (parcelRequire("h2BRl")).fetchCollectionsViewsCounts);
$parcel$export(module.exports, "loadCollectionDescription", () => (parcelRequire("2WnXd")).loadCollectionDescription);
$parcel$export(module.exports, "updateCollectionDescription", () => (parcelRequire("2WnXd")).updateCollectionDescription);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $aU6fm = parcelRequire("aU6fm");

var $h2BRl = parcelRequire("h2BRl");

var $2WnXd = parcelRequire("2WnXd");

});
parcelRegister("aU6fm", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $e8772898257018c1$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "initialize", () => $e8772898257018c1$export$2a47f398eeff8b01);
$parcel$export(module.exports, "loadCollection", () => $e8772898257018c1$export$1f19ddbd9e78c2f5);
$parcel$export(module.exports, "loadCollections", () => $e8772898257018c1$export$569b2ddb07e9ef58);
$parcel$export(module.exports, "deleteCollection", () => $e8772898257018c1$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $e8772898257018c1$export$c0683150b517c317);
$parcel$export(module.exports, "copyCollection", () => $e8772898257018c1$export$36928e43600c4b00);
$parcel$export(module.exports, "getCollectionData", () => $e8772898257018c1$export$d071b5a3ecbd2134);
$parcel$export(module.exports, "syncStateWithCollectionStoreAfterViewDelete", () => $e8772898257018c1$export$64e824699282d339);

var $gYnSx = parcelRequire("gYnSx");

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $gCeeo = parcelRequire("gCeeo");

var $gtzis = parcelRequire("gtzis");

var $dFdvS = parcelRequire("dFdvS");
const $e8772898257018c1$export$c74125a8e3af6bb2 = ({ name: name, color: color, emoji: emoji, jql: jql, ownerId: ownerId, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState }, { onCollectionCreate: onCollectionCreate })=>{
        try {
            return await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.createCollection, async ()=>{
                const newCollection = await (0, $dFdvS.createCollection)({
                    name: name,
                    color: color,
                    emoji: emoji,
                    jql: jql
                });
                const state = getState();
                setState({
                    collections: {
                        ...state.collections,
                        [newCollection.uuid]: {
                            data: {
                                ...newCollection,
                                ownerId: ownerId
                            }
                        }
                    }
                });
                const actionSubjectAndAction = 'collection created';
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction);
                (0, $3Ku0X.sendPendoTrackEvent)({
                    actionSubjectAndAction: actionSubjectAndAction
                });
                // Ensure that onCollectionCreate always receives
                // a fresh reference
                onCollectionCreate?.({
                    ...newCollection
                });
                return newCollection;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.createCollectionFailed', error));
                throw error;
            }
        }
    };
const $e8772898257018c1$export$2a47f398eeff8b01 = (collections)=>({ setState: setState })=>{
        setState({
            collections: collections.reduce((acc, collection)=>{
                acc[collection.uuid] = {
                    data: collection
                };
                return acc;
            }, {}),
            isLoading: false,
            error: undefined
        });
    };
const $e8772898257018c1$export$1f19ddbd9e78c2f5 = (collectionUUID, shouldIncludeViews)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID] || {
            data: undefined
        };
        if (existingCollection.isLoading || existingCollection.data?.views !== undefined) return;
        const loadExperience = shouldIncludeViews ? (0, $b5oGV.experience).collections.loadCollectionViews : (0, $b5oGV.experience).collections.loadCollection;
        try {
            await (0, $8XCY1.wrapWithExperience)(loadExperience, async ()=>{
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            isLoading: true,
                            error: undefined
                        }
                    }
                });
                const newCollection = await (0, $dFdvS.fetchCollection)(collectionUUID, shouldIncludeViews);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            data: {
                                ...existingCollection.data,
                                ...newCollection
                            },
                            isLoading: false
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionLoadingFailed', error));
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            isLoading: false,
                            error: error
                        }
                    }
                });
            }
        }
    };
const $e8772898257018c1$export$569b2ddb07e9ef58 = ()=>async ({ setState: setState, dispatch: dispatch })=>{
        try {
            return await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.loadCollections, async ()=>{
                setState({
                    collections: {},
                    isLoading: true
                });
                const collections = await (0, $dFdvS.fetchAllCollections)();
                dispatch($e8772898257018c1$export$2a47f398eeff8b01(collections));
                return collections;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.allCollectionsLoadingFailed', error));
                setState({
                    isLoading: false,
                    error: error
                });
            }
        }
        return undefined;
    };
const $e8772898257018c1$export$3d16e031f6551662 = (collectionUUID, { deleteOnlyOnClientSide: deleteOnlyOnClientSide } = {
    deleteOnlyOnClientSide: false
})=>async ({ setState: setState, getState: getState }, { onCollectionDelete: onCollectionDelete })=>{
        const state = getState();
        try {
            await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.deleteCollection, async ()=>{
                const { [collectionUUID]: _, ...collections } = state.collections;
                if (!deleteOnlyOnClientSide) await (0, $dFdvS.deleteCollection)(collectionUUID);
                setState({
                    collections: collections
                });
                onCollectionDelete?.(collectionUUID);
            });
        } catch (error) {
            if (error instanceof Error) (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionDeletionFailed', error));
            throw error;
        }
    };
const $e8772898257018c1$export$c0683150b517c317 = (collectionUUID, collection)=>async ({ setState: setState, getState: getState }, { onCollectionUpdate: onCollectionUpdate })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID];
        const data = existingCollection?.data;
        if (!data) return;
        try {
            await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.updateCollection, async ()=>{
                const { name: name, color: color, emoji: emoji, projectKeys: projectKeys, filtersJql: filtersJql } = collection;
                const jql = projectKeys !== undefined || filtersJql !== undefined ? (0, $gtzis.getJQLForCollection)(projectKeys ?? data.projectKeys, filtersJql ?? data.filtersJql) : data.jql;
                const updatedCollection = {
                    name: name || data.name,
                    color: 'color' in collection ? color : data.color,
                    emoji: 'emoji' in collection ? emoji : data.emoji,
                    jql: jql
                };
                await (0, $dFdvS.updateCollection)(collectionUUID, updatedCollection);
                const updatedCollectionData = {
                    ...data,
                    ...updatedCollection,
                    projectKeys: projectKeys ?? data.projectKeys,
                    filtersJql: filtersJql ?? data.filtersJql
                };
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: updatedCollectionData
                        }
                    }
                });
                // Ensure that onCollectionUpdate always receives
                // a fresh reference
                onCollectionUpdate?.({
                    ...updatedCollectionData
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionUpdateFailed', error));
            throw error;
        }
    };
const $e8772898257018c1$export$36928e43600c4b00 = (collectionUUID, newCollectionName, newCollectionOwnerId, collectionTemporaryData)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const collectionToCopy = state.collections[collectionUUID]?.data || collectionTemporaryData;
            if (!collectionToCopy || !newCollectionOwnerId) return;
            return await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.copyCollection, async ()=>{
                const { uuid: uuid } = await (0, $dFdvS.cloneCollection)(collectionUUID, newCollectionName);
                setState({
                    collections: {
                        ...state.collections,
                        [uuid]: {
                            isLoading: false,
                            error: undefined,
                            data: {
                                ...collectionToCopy,
                                name: newCollectionName,
                                ownerId: newCollectionOwnerId,
                                uuid: uuid
                            }
                        }
                    }
                });
                return uuid;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.copyCollectionFailed', error));
                throw error;
            }
        }
    };
const $e8772898257018c1$export$d071b5a3ecbd2134 = (collectionUUID)=>async ({ getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID] || {
            data: undefined
        };
        if (existingCollection.data?.views !== undefined) return existingCollection.data;
        try {
            return await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.loadCollection, async ()=>{
                const collection = await (0, $dFdvS.fetchCollection)(collectionUUID, true);
                return collection;
            });
        } catch (error) {
            if (error instanceof Error) (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionLoadingFailed', error));
        }
    };
const $e8772898257018c1$export$64e824699282d339 = (collectionUUID, viewUUID)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const collection = state.collections && state.collections[collectionUUID];
        if (!collection || !collection.data) return;
        const currentViewsCount = collection.data.viewsCount ?? 0;
        const viewsCount = currentViewsCount > 0 ? currentViewsCount - 1 : 0;
        const views = collection.data.views?.filter((view)=>view.uuid !== viewUUID);
        setState({
            collections: {
                ...state.collections,
                [collectionUUID]: {
                    data: {
                        ...collection.data,
                        views: views,
                        viewsCount: viewsCount
                    }
                }
            }
        });
    };

});
parcelRegister("gtzis", function(module, exports) {

$parcel$export(module.exports, "getJQLForCollection", () => $818429028dabd958$export$8d4a8272ec8d3589);
$parcel$export(module.exports, "extractProjectKeysFromJql", () => $818429028dabd958$export$35840c54e03d7673);
$parcel$export(module.exports, "extractFiltersJqlFromJql", () => $818429028dabd958$export$bcd3615366d8d128);
$parcel$export(module.exports, "getFieldsFromJql", () => $818429028dabd958$export$54e99094db1a28af);

var $f26C8 = parcelRequire("f26C8");
var $9qsUT = parcelRequire("9qsUT");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");
const $818429028dabd958$var$quoteProjectKey = (projectKey)=>`"${projectKey}"`;
const $818429028dabd958$var$PROJECT_FIELD_KEY = 'project';
const $818429028dabd958$export$8d4a8272ec8d3589 = (projectsKeys = [], filtersJql = '')=>{
    const jast = new (0, $9qsUT.JastBuilder)().build(filtersJql);
    projectsKeys.length && jast.query?.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field($818429028dabd958$var$PROJECT_FIELD_KEY), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN)), (0, $f26C8.default).listOperand(projectsKeys.map($818429028dabd958$var$quoteProjectKey).map((0, $f26C8.default).byText.valueOperand))), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
    if (jast.query?.orderBy) jast.query.removeOrderBy();
    return (0, $1jiqw.print)(jast);
};
const $818429028dabd958$var$projectInRegex = /project\s+in\s+\((.*?)\)/;
const $818429028dabd958$var$projectKeyRegex = /"(.*?)"/g;
const $818429028dabd958$export$35840c54e03d7673 = (jql)=>{
    // Extract the part of the JQL related to `project in (...)`
    const projectInMatch = $818429028dabd958$var$projectInRegex.exec(jql);
    const projectKeys = [];
    if (projectInMatch) {
        const projectInClause = projectInMatch[1];
        let match;
        // Extract all project keys inside the quotes within the `project in (...)` clause
        // eslint-disable-next-line no-cond-assign
        while((match = $818429028dabd958$var$projectKeyRegex.exec(projectInClause)) !== null)projectKeys.push(match[1]);
    }
    return projectKeys;
};
const $818429028dabd958$export$bcd3615366d8d128 = (jql)=>{
    const jast = new (0, $9qsUT.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return '';
    const clauses = where.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    const projectKeysClause = clauses.find((c)=>c.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) && c.field.value === $818429028dabd958$var$PROJECT_FIELD_KEY);
    if (projectKeysClause) projectKeysClause.remove();
    return (0, $1jiqw.print)(jast);
};
const $818429028dabd958$var$getFieldsFromClauses = ([clause, ...rest])=>{
    if (!clause) return [];
    if (clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) return [
        clause.field.value,
        ...$818429028dabd958$var$getFieldsFromClauses(rest)
    ];
    if (clause.clauseType === (0, $2a3824620e125bfd$export$e356b89f8c8d2fcb)) return $818429028dabd958$var$getFieldsFromClauses([
        clause.clause,
        ...rest
    ]);
    return $818429028dabd958$var$getFieldsFromClauses([
        ...clause.clauses,
        ...rest
    ]);
};
const $818429028dabd958$var$getFieldKeyFromFieldName = (fieldKeys)=>(fieldName)=>fieldKeys[fieldName.replace(/\[.+\]$/, '').toLowerCase()];
const $818429028dabd958$export$54e99094db1a28af = (jql, fieldKeys)=>{
    const jast = new (0, $9qsUT.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return [];
    const clauses = where.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    return $818429028dabd958$var$getFieldsFromClauses(clauses).map($818429028dabd958$var$getFieldKeyFromFieldName(fieldKeys)).filter((field)=>!!field);
};

});
const $2a3824620e125bfd$export$7a58b23488ea076b = 'compound';
const $2a3824620e125bfd$export$ae56b4ef248a2b6a = 'terminal';
const $2a3824620e125bfd$export$e356b89f8c8d2fcb = 'not';

const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';

parcelRegister("f26C8", function(module, exports) {

$parcel$export(module.exports, "internalCreators", () => $54a2df64babed64e$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $54a2df64babed64e$export$2e2bcd8739ae039);

var $8gbOL = parcelRequire("8gbOL");

var $lmH0l = parcelRequire("lmH0l");

var $2caal = parcelRequire("2caal");

var $6LAlr = parcelRequire("6LAlr");

var $NDSAF = parcelRequire("NDSAF");

var $1d8p9 = parcelRequire("1d8p9");

var $72SeG = parcelRequire("72SeG");

var $5qiTO = parcelRequire("5qiTO");

var $q681h = parcelRequire("q681h");

var $5WHbI = parcelRequire("5WHbI");

var $5pxYG = parcelRequire("5pxYG");

var $i8g3z = parcelRequire("i8g3z");

var $hE0gi = parcelRequire("hE0gi");

var $83AJ4 = parcelRequire("83AJ4");

var $d0MpM = parcelRequire("d0MpM");

var $lDhFj = parcelRequire("lDhFj");

var $6Dx67 = parcelRequire("6Dx67");

var $hbAhR = parcelRequire("hbAhR");

var $89aGW = parcelRequire("89aGW");

var $8XEos = parcelRequire("8XEos");

var $52A7I = parcelRequire("52A7I");

var $jArsO = parcelRequire("jArsO");
const $54a2df64babed64e$export$64d991963cfb5532 = {
    query: (0, $8XEos.queryInternal),
    compoundClause: (0, $lmH0l.compoundClauseInternal),
    compoundOperator: (0, $2caal.compoundOperatorInternal),
    terminalClause: (0, $52A7I.terminalClauseInternal),
    notClause: (0, $5WHbI.notClauseInternal),
    notClauseOperator: (0, $5pxYG.notClauseOperatorInternal),
    predicate: (0, $6Dx67.predicateInternal),
    predicateOperator: (0, $hbAhR.predicateOperatorInternal),
    field: (0, $6LAlr.fieldInternal),
    property: (0, $89aGW.propertyInternal),
    operator: (0, $i8g3z.operatorInternal),
    valueOperand: (0, $jArsO.valueOperandInternal),
    keywordOperand: (0, $5qiTO.keywordOperandInternal),
    functionOperand: (0, $NDSAF.functionOperandInternal),
    functionString: (0, $1d8p9.functionStringInternal),
    argument: (0, $8gbOL.argumentInternal),
    listOperand: (0, $q681h.listOperandInternal),
    orderBy: (0, $hE0gi.orderByInternal),
    orderByOperator: (0, $lDhFj.orderByOperatorInternal),
    orderByField: (0, $d0MpM.orderByFieldInternal),
    orderByDirection: (0, $83AJ4.orderByDirectionInternal)
};
var $54a2df64babed64e$export$2e2bcd8739ae039 = {
    jast: $72SeG.jast,
    query: $8XEos.query,
    compoundClause: $lmH0l.compoundClause,
    compoundOperator: $2caal.compoundOperator,
    terminalClause: $52A7I.terminalClause,
    notClause: $5WHbI.notClause,
    notClauseOperator: $5pxYG.notClauseOperator,
    predicate: $6Dx67.predicate,
    predicateOperator: $hbAhR.predicateOperator,
    field: $6LAlr.field,
    property: $89aGW.property,
    operator: $i8g3z.operator,
    valueOperand: $jArsO.valueOperand,
    keywordOperand: $5qiTO.keywordOperand,
    functionOperand: $NDSAF.functionOperand,
    functionString: $1d8p9.functionString,
    argument: $8gbOL.argument,
    listOperand: $q681h.listOperand,
    orderBy: $hE0gi.orderBy,
    orderByOperator: $lDhFj.orderByOperator,
    orderByField: $d0MpM.orderByField,
    orderByDirection: $83AJ4.orderByDirection,
    byText: {
        argument: (0, $8gbOL.argumentByText),
        valueOperand: (0, $jArsO.valueOperandByText)
    }
};

});
parcelRegister("8gbOL", function(module, exports) {

$parcel$export(module.exports, "argument", () => $9899f3160c8155c6$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $9899f3160c8155c6$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $9899f3160c8155c6$export$84c43d23f51170cb);

var $h8zsn = parcelRequire("h8zsn");
var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $9899f3160c8155c6$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $9899f3160c8155c6$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $9899f3160c8155c6$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $9899f3160c8155c6$export$6ea29ee575e3f5ff = (value)=>$9899f3160c8155c6$export$5b341d50fa5bcdd5(value, (0, $ykU4x.sanitiseJqlString)(value));
const $9899f3160c8155c6$export$84c43d23f51170cb = (text)=>$9899f3160c8155c6$export$5b341d50fa5bcdd5((0, $h8zsn.normaliseJqlString)(text), text);
const $9899f3160c8155c6$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $9899f3160c8155c6$var$acceptArgument,
        enterNode: $9899f3160c8155c6$var$enterNode,
        exitNode: $9899f3160c8155c6$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
parcelRegister("h8zsn", function(module, exports) {

$parcel$export(module.exports, "normaliseJqlString", () => $e879e944a9dd4709$export$cecf78a779acc0ff);
const $e879e944a9dd4709$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $e879e944a9dd4709$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $e879e944a9dd4709$export$b86601123607fee5 = (maybeQuotedString)=>$e879e944a9dd4709$export$7a0b99b892e0dda8(maybeQuotedString) || $e879e944a9dd4709$export$d5efd6512db694fd(maybeQuotedString);
const $e879e944a9dd4709$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($e879e944a9dd4709$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("ykU4x", function(module, exports) {

$parcel$export(module.exports, "sanitiseJqlString", () => $c0a3cffda0853f39$export$3eb9033c48208278);

var $6PCNA = parcelRequire("6PCNA");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $c0a3cffda0853f39$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $c0a3cffda0853f39$export$3eb9033c48208278 = (jqlString)=>{
    if ($c0a3cffda0853f39$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("6PCNA", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4f959a1cf3d02dc6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $4f959a1cf3d02dc6$var$reHasRegExpChar = RegExp($4f959a1cf3d02dc6$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $4f959a1cf3d02dc6$var$escapeRegExp(string) {
    string = $cz1WF(string);
    return string && $4f959a1cf3d02dc6$var$reHasRegExpChar.test(string) ? string.replace($4f959a1cf3d02dc6$var$reRegExpChar, '\\$&') : string;
}
module.exports = $4f959a1cf3d02dc6$var$escapeRegExp;

});


parcelRegister("fa1eE", function(module, exports) {

$parcel$export(module.exports, "noChildren", () => $b71c996bd5b4efee$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $b71c996bd5b4efee$export$a4685923af2913a);
const $b71c996bd5b4efee$export$470bef71e654b804 = ()=>[];
const $b71c996bd5b4efee$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("lmH0l", function(module, exports) {

$parcel$export(module.exports, "compoundClause", () => $7990dc2160e1df04$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $7990dc2160e1df04$export$cd65eed8c10b0911);


var $569g0 = parcelRequire("569g0");

var $fa1eE = parcelRequire("fa1eE");
function $7990dc2160e1df04$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $7990dc2160e1df04$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $7990dc2160e1df04$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $7990dc2160e1df04$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $7990dc2160e1df04$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $7990dc2160e1df04$export$cd65eed8c10b0911(operator, clauses);
};
const $7990dc2160e1df04$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $7990dc2160e1df04$var$acceptCompoundClause,
        enterNode: $7990dc2160e1df04$var$enterNode,
        exitNode: $7990dc2160e1df04$var$exitNode,
        getChildren: $7990dc2160e1df04$var$getChildren,
        parent: null,
        appendClause: $569g0.appendClause,
        remove: $569g0.remove,
        removeClause: $569g0.removeClause,
        replace: $569g0.replace,
        replaceClause: $569g0.replaceClause
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
const $07f17d613ee96ad1$export$98dda21ec825792 = 'query';
const $07f17d613ee96ad1$export$2d205682cc545947 = 'clause';
const $07f17d613ee96ad1$export$d2f212d8ddbc8d1d = 'operand';
const $07f17d613ee96ad1$export$da0f73edded4a63d = 'order_by';

parcelRegister("569g0", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $fa1eE = parcelRequire("fa1eE");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $fa1eE.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $fa1eE.assignParent)(this);
}

});


parcelRegister("2caal", function(module, exports) {

$parcel$export(module.exports, "compoundOperator", () => $b3ac9a1079c049ae$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $b3ac9a1079c049ae$export$63c33bc3fe74fee6);

var $fa1eE = parcelRequire("fa1eE");
function $b3ac9a1079c049ae$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $b3ac9a1079c049ae$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $b3ac9a1079c049ae$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $b3ac9a1079c049ae$export$84bb3ebbba491aee = (value)=>$b3ac9a1079c049ae$export$63c33bc3fe74fee6(value, []);
const $b3ac9a1079c049ae$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $b3ac9a1079c049ae$var$acceptCompoundOperator,
        enterNode: $b3ac9a1079c049ae$var$enterNode,
        exitNode: $b3ac9a1079c049ae$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("6LAlr", function(module, exports) {

$parcel$export(module.exports, "field", () => $40455f5cc088ebfe$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $40455f5cc088ebfe$export$2193f8c541622b6);

var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $40455f5cc088ebfe$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $40455f5cc088ebfe$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $40455f5cc088ebfe$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $40455f5cc088ebfe$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $40455f5cc088ebfe$export$e0f35d825088c098 = (value, properties)=>{
    return $40455f5cc088ebfe$export$2193f8c541622b6(value, (0, $ykU4x.sanitiseJqlString)(value), properties);
};
const $40455f5cc088ebfe$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $40455f5cc088ebfe$var$acceptField,
        enterNode: $40455f5cc088ebfe$var$enterNode,
        exitNode: $40455f5cc088ebfe$var$exitNode,
        getChildren: $40455f5cc088ebfe$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("NDSAF", function(module, exports) {

$parcel$export(module.exports, "functionOperand", () => $3d621d62a26d18dc$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $3d621d62a26d18dc$export$c1f2ce91dc05872a);


var $fa1eE = parcelRequire("fa1eE");
function $3d621d62a26d18dc$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $3d621d62a26d18dc$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $3d621d62a26d18dc$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $3d621d62a26d18dc$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $3d621d62a26d18dc$export$4f981b0e83488ce = (functionString, args = [])=>$3d621d62a26d18dc$export$c1f2ce91dc05872a(functionString, args);
const $3d621d62a26d18dc$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $3d621d62a26d18dc$var$acceptFunctionOperand,
        enterNode: $3d621d62a26d18dc$var$enterNode,
        exitNode: $3d621d62a26d18dc$var$exitNode,
        getChildren: $3d621d62a26d18dc$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
const $862dfd240457f00b$export$38accfc5a5d1c113 = 'value';
const $862dfd240457f00b$export$f6049126fd97001f = 'keyword';
const $862dfd240457f00b$export$19c7c729db381f9d = 'function';
const $862dfd240457f00b$export$fabec4aebba3f4df = 'list';
const $862dfd240457f00b$export$1c46dca02aac24dd = 'empty';


parcelRegister("1d8p9", function(module, exports) {

$parcel$export(module.exports, "functionString", () => $0c094943ece8f752$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $0c094943ece8f752$export$7aa9944588b7a69f);

var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $0c094943ece8f752$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $0c094943ece8f752$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $0c094943ece8f752$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $0c094943ece8f752$export$4e1bb9a7ff8d0ef9 = (value)=>$0c094943ece8f752$export$7aa9944588b7a69f(value, (0, $ykU4x.sanitiseJqlString)(value));
const $0c094943ece8f752$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $0c094943ece8f752$var$acceptFunctionString,
        enterNode: $0c094943ece8f752$var$enterNode,
        exitNode: $0c094943ece8f752$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("72SeG", function(module, exports) {

$parcel$export(module.exports, "jast", () => $a25d6c4a0f00f5da$export$b9e70a00f479ff43);
const $a25d6c4a0f00f5da$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("5qiTO", function(module, exports) {

$parcel$export(module.exports, "keywordOperand", () => $152e52666e87d978$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $152e52666e87d978$export$7cc55480b054047b);


var $fa1eE = parcelRequire("fa1eE");
function $152e52666e87d978$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $152e52666e87d978$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $152e52666e87d978$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $152e52666e87d978$export$2edd4971ed69f2ce = ()=>$152e52666e87d978$export$7cc55480b054047b((0, $862dfd240457f00b$export$1c46dca02aac24dd));
const $152e52666e87d978$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $152e52666e87d978$var$acceptKeywordOperand,
        enterNode: $152e52666e87d978$var$enterNode,
        exitNode: $152e52666e87d978$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("q681h", function(module, exports) {

$parcel$export(module.exports, "listOperand", () => $da0279a594b64f69$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $da0279a594b64f69$export$663c7831528c984b);


var $a9ys9 = parcelRequire("a9ys9");

var $fa1eE = parcelRequire("fa1eE");
function $da0279a594b64f69$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $da0279a594b64f69$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $da0279a594b64f69$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $da0279a594b64f69$var$getChildren() {
    return [
        ...this.values
    ];
}
const $da0279a594b64f69$export$769866c3e9d41d50 = (values)=>$da0279a594b64f69$export$663c7831528c984b(values);
const $da0279a594b64f69$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $da0279a594b64f69$var$acceptListOperand,
        enterNode: $da0279a594b64f69$var$enterNode,
        exitNode: $da0279a594b64f69$var$exitNode,
        getChildren: $da0279a594b64f69$var$getChildren,
        parent: null,
        appendOperand: $a9ys9.appendOperand
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("a9ys9", function(module, exports) {

$parcel$export(module.exports, "appendOperand", () => $8339039101fa111c$export$d94c54f1aee177c4);


var $fa1eE = parcelRequire("fa1eE");
function $8339039101fa111c$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $fa1eE.assignParent)(this);
}

});


parcelRegister("5WHbI", function(module, exports) {

$parcel$export(module.exports, "notClause", () => $cf05e1bf306c2cdd$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $cf05e1bf306c2cdd$export$b25621824fea4548);


var $lmKuC = parcelRequire("lmKuC");

var $fa1eE = parcelRequire("fa1eE");

var $5pxYG = parcelRequire("5pxYG");
function $cf05e1bf306c2cdd$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $cf05e1bf306c2cdd$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $cf05e1bf306c2cdd$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $cf05e1bf306c2cdd$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $cf05e1bf306c2cdd$export$b4734a9fedb4d44e = (clause)=>{
    return $cf05e1bf306c2cdd$export$b25621824fea4548(clause, (0, $5pxYG.notClauseOperator)());
};
const $cf05e1bf306c2cdd$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $cf05e1bf306c2cdd$var$acceptNotClause,
        enterNode: $cf05e1bf306c2cdd$var$enterNode,
        exitNode: $cf05e1bf306c2cdd$var$exitNode,
        getChildren: $cf05e1bf306c2cdd$var$getChildren,
        parent: null,
        remove: $lmKuC.remove,
        removeClause: $lmKuC.removeClause,
        replace: $lmKuC.replace,
        replaceClause: $lmKuC.replaceClause
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("lmKuC", function(module, exports) {

$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $fa1eE = parcelRequire("fa1eE");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $fa1eE.assignParent)(this);
    }
}

});

parcelRegister("5pxYG", function(module, exports) {

$parcel$export(module.exports, "notClauseOperator", () => $1b4f1909e547322d$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $1b4f1909e547322d$export$1b15a32bb57b9020);

var $jPlb3 = parcelRequire("jPlb3");

var $fa1eE = parcelRequire("fa1eE");
function $1b4f1909e547322d$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $1b4f1909e547322d$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $1b4f1909e547322d$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $1b4f1909e547322d$export$d2cd8239f99c13d3 = ()=>$1b4f1909e547322d$export$1b15a32bb57b9020();
const $1b4f1909e547322d$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $jPlb3.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $1b4f1909e547322d$var$acceptNotClauseOperator,
        enterNode: $1b4f1909e547322d$var$enterNode,
        exitNode: $1b4f1909e547322d$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
parcelRegister("jPlb3", function(module, exports) {

$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $cee78cdd174c9cda$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $cee78cdd174c9cda$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $cee78cdd174c9cda$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $cee78cdd174c9cda$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $cee78cdd174c9cda$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $cee78cdd174c9cda$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $cee78cdd174c9cda$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $cee78cdd174c9cda$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $cee78cdd174c9cda$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $cee78cdd174c9cda$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $cee78cdd174c9cda$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $cee78cdd174c9cda$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $cee78cdd174c9cda$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $cee78cdd174c9cda$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $cee78cdd174c9cda$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $cee78cdd174c9cda$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $cee78cdd174c9cda$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $cee78cdd174c9cda$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $cee78cdd174c9cda$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $cee78cdd174c9cda$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $cee78cdd174c9cda$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $cee78cdd174c9cda$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $cee78cdd174c9cda$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $cee78cdd174c9cda$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $cee78cdd174c9cda$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $cee78cdd174c9cda$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $cee78cdd174c9cda$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $cee78cdd174c9cda$export$77c793736847e030);
const $cee78cdd174c9cda$export$c6c71ceedb15cda9 = 'not';
const $cee78cdd174c9cda$export$466517a888d00195 = '=';
const $cee78cdd174c9cda$export$6d0d8810623974a5 = '!=';
const $cee78cdd174c9cda$export$bcbb090ab3c498b3 = '>';
const $cee78cdd174c9cda$export$4bf1a4aa659c6ea4 = '<';
const $cee78cdd174c9cda$export$83ce674214a54b2a = '>=';
const $cee78cdd174c9cda$export$9629fd1727ef62ee = '<=';
const $cee78cdd174c9cda$export$c4e3fb55e320e979 = 'in';
const $cee78cdd174c9cda$export$f9857532eaa24ddc = 'not in';
const $cee78cdd174c9cda$export$221595834b8766ab = '~';
const $cee78cdd174c9cda$export$fcefabf94a9bffbf = '!~';
const $cee78cdd174c9cda$export$4feeb3f4ff56bcef = 'is';
const $cee78cdd174c9cda$export$d08d969a0da27188 = 'is not';
const $cee78cdd174c9cda$export$8f907e179985256d = 'was';
const $cee78cdd174c9cda$export$cc7b9d0b3ee23193 = 'was in';
const $cee78cdd174c9cda$export$585d3c004af078bb = 'was not in';
const $cee78cdd174c9cda$export$123eaa9ccc2d9445 = 'was not';
const $cee78cdd174c9cda$export$15f5b446ba8c941e = 'changed';
const $cee78cdd174c9cda$export$643c6101f3fc8547 = [
    $cee78cdd174c9cda$export$466517a888d00195,
    $cee78cdd174c9cda$export$6d0d8810623974a5
];
const $cee78cdd174c9cda$export$329664c9cf18cca6 = [
    $cee78cdd174c9cda$export$221595834b8766ab,
    $cee78cdd174c9cda$export$fcefabf94a9bffbf
];
const $cee78cdd174c9cda$export$1b167a3705885a8b = [
    $cee78cdd174c9cda$export$4bf1a4aa659c6ea4,
    $cee78cdd174c9cda$export$bcbb090ab3c498b3,
    $cee78cdd174c9cda$export$9629fd1727ef62ee,
    $cee78cdd174c9cda$export$83ce674214a54b2a
];
const $cee78cdd174c9cda$export$f25cf16c2270312f = [
    $cee78cdd174c9cda$export$c4e3fb55e320e979,
    $cee78cdd174c9cda$export$f9857532eaa24ddc
];
const $cee78cdd174c9cda$export$eb58cfffe4a6b805 = [
    $cee78cdd174c9cda$export$4feeb3f4ff56bcef,
    $cee78cdd174c9cda$export$d08d969a0da27188
];
const $cee78cdd174c9cda$export$c22a981f581de218 = [
    $cee78cdd174c9cda$export$8f907e179985256d,
    $cee78cdd174c9cda$export$123eaa9ccc2d9445
];
const $cee78cdd174c9cda$export$6d08c4699bb75284 = [
    $cee78cdd174c9cda$export$cc7b9d0b3ee23193,
    $cee78cdd174c9cda$export$585d3c004af078bb
];
const $cee78cdd174c9cda$export$b7dc214eef214c1c = [
    $cee78cdd174c9cda$export$15f5b446ba8c941e
];
const $cee78cdd174c9cda$export$184799fc79ccac89 = [
    ...$cee78cdd174c9cda$export$643c6101f3fc8547,
    ...$cee78cdd174c9cda$export$329664c9cf18cca6,
    ...$cee78cdd174c9cda$export$1b167a3705885a8b,
    ...$cee78cdd174c9cda$export$f25cf16c2270312f,
    ...$cee78cdd174c9cda$export$eb58cfffe4a6b805,
    ...$cee78cdd174c9cda$export$c22a981f581de218,
    ...$cee78cdd174c9cda$export$6d08c4699bb75284,
    ...$cee78cdd174c9cda$export$b7dc214eef214c1c
];
const $cee78cdd174c9cda$export$77c793736847e030 = [
    $cee78cdd174c9cda$export$c4e3fb55e320e979,
    $cee78cdd174c9cda$export$f9857532eaa24ddc,
    $cee78cdd174c9cda$export$cc7b9d0b3ee23193,
    $cee78cdd174c9cda$export$585d3c004af078bb
];

});



parcelRegister("i8g3z", function(module, exports) {

$parcel$export(module.exports, "operator", () => $43a4abca705ed742$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $43a4abca705ed742$export$649025bc60ab9c3b);

var $fa1eE = parcelRequire("fa1eE");
function $43a4abca705ed742$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $43a4abca705ed742$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $43a4abca705ed742$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $43a4abca705ed742$export$dbd72860f701d4f3 = (value)=>$43a4abca705ed742$export$649025bc60ab9c3b(value, value);
const $43a4abca705ed742$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $43a4abca705ed742$var$acceptOperator,
        enterNode: $43a4abca705ed742$var$enterNode,
        exitNode: $43a4abca705ed742$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("hE0gi", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $c0a3843a9e7de571$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $c0a3843a9e7de571$export$e4eb1fa6bc8465c1);


var $ekRIJ = parcelRequire("ekRIJ");

var $fa1eE = parcelRequire("fa1eE");

var $lDhFj = parcelRequire("lDhFj");
function $c0a3843a9e7de571$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $c0a3843a9e7de571$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $c0a3843a9e7de571$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $c0a3843a9e7de571$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $c0a3843a9e7de571$export$f18af21d6f4dafd8 = (fields)=>{
    return $c0a3843a9e7de571$export$e4eb1fa6bc8465c1(fields, (0, $lDhFj.orderByOperator)());
};
const $c0a3843a9e7de571$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $c0a3843a9e7de571$var$acceptOrderBy,
        enterNode: $c0a3843a9e7de571$var$enterNode,
        exitNode: $c0a3843a9e7de571$var$exitNode,
        getChildren: $c0a3843a9e7de571$var$getChildren,
        parent: null,
        prependOrderField: $ekRIJ.prependOrderField,
        setOrderDirection: $ekRIJ.setOrderDirection,
        replace: $ekRIJ.replace,
        replaceOrderField: $ekRIJ.replaceOrderField,
        remove: $ekRIJ.remove,
        removeOrderField: $ekRIJ.removeOrderField
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("ekRIJ", function(module, exports) {

$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $fa1eE = parcelRequire("fa1eE");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $fa1eE.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $fa1eE.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("lDhFj", function(module, exports) {

$parcel$export(module.exports, "orderByOperator", () => $3dd1a82964518ff4$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $3dd1a82964518ff4$export$739e30af23a08da0);


var $fa1eE = parcelRequire("fa1eE");
function $3dd1a82964518ff4$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $3dd1a82964518ff4$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $3dd1a82964518ff4$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $3dd1a82964518ff4$export$c7307b67924c61ea = ()=>$3dd1a82964518ff4$export$739e30af23a08da0();
const $3dd1a82964518ff4$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $adec16a85d57f51f$export$ca51f5fd60a74517),
        position: position,
        accept: $3dd1a82964518ff4$var$acceptOrderByOperator,
        enterNode: $3dd1a82964518ff4$var$enterNode,
        exitNode: $3dd1a82964518ff4$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
const $adec16a85d57f51f$export$ca51f5fd60a74517 = 'ORDER BY';
const $adec16a85d57f51f$export$6d60017b9e092e73 = 'ASC';
const $adec16a85d57f51f$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("83AJ4", function(module, exports) {

$parcel$export(module.exports, "orderByDirection", () => $c704c2d23a3fd91f$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $c704c2d23a3fd91f$export$8c65cac1a7852d1f);

var $fa1eE = parcelRequire("fa1eE");
function $c704c2d23a3fd91f$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $c704c2d23a3fd91f$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $c704c2d23a3fd91f$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $c704c2d23a3fd91f$export$864d934efed3ccaa = (value)=>$c704c2d23a3fd91f$export$8c65cac1a7852d1f(value);
const $c704c2d23a3fd91f$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $c704c2d23a3fd91f$var$acceptOrderByDirection,
        enterNode: $c704c2d23a3fd91f$var$enterNode,
        exitNode: $c704c2d23a3fd91f$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("d0MpM", function(module, exports) {

$parcel$export(module.exports, "orderByField", () => $38c966c2448f3b7a$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $38c966c2448f3b7a$export$661a7786e3d15926);

var $hKUyp = parcelRequire("hKUyp");

var $fa1eE = parcelRequire("fa1eE");
function $38c966c2448f3b7a$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $38c966c2448f3b7a$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $38c966c2448f3b7a$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $38c966c2448f3b7a$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $38c966c2448f3b7a$export$942df63e5e3d3899 = (field, direction)=>$38c966c2448f3b7a$export$661a7786e3d15926(field, direction);
const $38c966c2448f3b7a$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $38c966c2448f3b7a$var$acceptOrderByField,
        enterNode: $38c966c2448f3b7a$var$enterNode,
        exitNode: $38c966c2448f3b7a$var$exitNode,
        getChildren: $38c966c2448f3b7a$var$getChildren,
        parent: null,
        setOrderDirection: $hKUyp.setOrderDirection,
        replace: $hKUyp.replace,
        remove: $hKUyp.remove
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("hKUyp", function(module, exports) {

$parcel$export(module.exports, "setOrderDirection", () => $e6633080911e1e18$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $e6633080911e1e18$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $e6633080911e1e18$export$cd7f480d6b8286c3);

var $fa1eE = parcelRequire("fa1eE");
function $e6633080911e1e18$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $fa1eE.assignParent)(this);
}
function $e6633080911e1e18$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $e6633080911e1e18$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("6Dx67", function(module, exports) {

$parcel$export(module.exports, "predicate", () => $425b3c9785c66bdc$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $425b3c9785c66bdc$export$a767a27ad05a38a2);

var $fa1eE = parcelRequire("fa1eE");
function $425b3c9785c66bdc$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $425b3c9785c66bdc$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $425b3c9785c66bdc$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $425b3c9785c66bdc$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $425b3c9785c66bdc$export$5fc51e445ce24faf = (operator, operand)=>$425b3c9785c66bdc$export$a767a27ad05a38a2(operator, operand);
const $425b3c9785c66bdc$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $425b3c9785c66bdc$var$acceptPredicate,
        enterNode: $425b3c9785c66bdc$var$enterNode,
        exitNode: $425b3c9785c66bdc$var$exitNode,
        getChildren: $425b3c9785c66bdc$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("hbAhR", function(module, exports) {

$parcel$export(module.exports, "predicateOperator", () => $48cdeafcf75d3a91$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $48cdeafcf75d3a91$export$c69d893689716768);

var $fa1eE = parcelRequire("fa1eE");
function $48cdeafcf75d3a91$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $48cdeafcf75d3a91$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $48cdeafcf75d3a91$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $48cdeafcf75d3a91$export$5419b7f16910ea62 = (value)=>$48cdeafcf75d3a91$export$c69d893689716768(value, value);
const $48cdeafcf75d3a91$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $48cdeafcf75d3a91$var$acceptPredicateOperator,
        enterNode: $48cdeafcf75d3a91$var$enterNode,
        exitNode: $48cdeafcf75d3a91$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("89aGW", function(module, exports) {

$parcel$export(module.exports, "property", () => $1ed758994e0eb78c$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $1ed758994e0eb78c$export$1cbd90994fef1fad);

var $fa1eE = parcelRequire("fa1eE");
function $1ed758994e0eb78c$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $1ed758994e0eb78c$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $1ed758994e0eb78c$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $1ed758994e0eb78c$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $1ed758994e0eb78c$export$d541bacb2bda4494 = (key, path = [])=>$1ed758994e0eb78c$export$1cbd90994fef1fad(key, path);
const $1ed758994e0eb78c$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $1ed758994e0eb78c$var$acceptProperty,
        enterNode: $1ed758994e0eb78c$var$enterNode,
        exitNode: $1ed758994e0eb78c$var$exitNode,
        getChildren: $1ed758994e0eb78c$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("8XEos", function(module, exports) {

$parcel$export(module.exports, "query", () => $d6ce43aac43752fe$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $d6ce43aac43752fe$export$bc2d6e2e1fd9014);


var $qZ8nR = parcelRequire("qZ8nR");

var $fa1eE = parcelRequire("fa1eE");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $d6ce43aac43752fe$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $d6ce43aac43752fe$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $d6ce43aac43752fe$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $d6ce43aac43752fe$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $d6ce43aac43752fe$export$2fa187e846a241c4 = (where, orderBy)=>$d6ce43aac43752fe$export$bc2d6e2e1fd9014(where, orderBy);
const $d6ce43aac43752fe$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $d6ce43aac43752fe$var$acceptQuery,
        enterNode: $d6ce43aac43752fe$var$enterNode,
        exitNode: $d6ce43aac43752fe$var$exitNode,
        getChildren: $d6ce43aac43752fe$var$getChildren,
        parent: null,
        appendClause: $qZ8nR.appendClause,
        prependOrderField: $qZ8nR.prependOrderField,
        setOrderDirection: $qZ8nR.setOrderDirection,
        removeClause: $qZ8nR.removeClause,
        replaceClause: $qZ8nR.replaceClause,
        replaceOrderBy: $qZ8nR.replaceOrderBy,
        removeOrderBy: $qZ8nR.removeOrderBy
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("qZ8nR", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $f26C8 = parcelRequire("f26C8");

var $fa1eE = parcelRequire("fa1eE");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $f26C8.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $f26C8.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $fa1eE.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $f26C8.default).orderBy([
            orderField
        ]);
        (0, $fa1eE.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $fa1eE.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $fa1eE.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("52A7I", function(module, exports) {

$parcel$export(module.exports, "terminalClause", () => $c357857da31d9c1c$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $c357857da31d9c1c$export$cc08e43598d091fc);


var $2mQsQ = parcelRequire("2mQsQ");

var $fa1eE = parcelRequire("fa1eE");
function $c357857da31d9c1c$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $c357857da31d9c1c$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $c357857da31d9c1c$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $c357857da31d9c1c$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $c357857da31d9c1c$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $c357857da31d9c1c$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $c357857da31d9c1c$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $c357857da31d9c1c$var$acceptTerminalClause,
        enterNode: $c357857da31d9c1c$var$enterNode,
        exitNode: $c357857da31d9c1c$var$exitNode,
        getChildren: $c357857da31d9c1c$var$getChildren,
        parent: null,
        setOperator: $2mQsQ.setOperator,
        setOperand: $2mQsQ.setOperand,
        appendOperand: $2mQsQ.appendOperand,
        remove: $2mQsQ.remove,
        replace: $2mQsQ.replace
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("2mQsQ", function(module, exports) {

$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $f26C8 = parcelRequire("f26C8");

var $fa1eE = parcelRequire("fa1eE");
function setOperator(operator) {
    this.operator = operator;
    (0, $fa1eE.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $fa1eE.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $f26C8.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("jArsO", function(module, exports) {

$parcel$export(module.exports, "valueOperand", () => $19d73696559a6b33$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $19d73696559a6b33$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $19d73696559a6b33$export$3ac9155bde56a45f);


var $h8zsn = parcelRequire("h8zsn");
var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $19d73696559a6b33$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $19d73696559a6b33$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $19d73696559a6b33$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $19d73696559a6b33$export$2b6e4d2ed8d53bf3 = (value)=>$19d73696559a6b33$export$79c37d97caac8627(value, (0, $ykU4x.sanitiseJqlString)(value));
const $19d73696559a6b33$export$3ac9155bde56a45f = (text)=>$19d73696559a6b33$export$79c37d97caac8627((0, $h8zsn.normaliseJqlString)(text), text);
const $19d73696559a6b33$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $19d73696559a6b33$var$acceptValueOperand,
        enterNode: $19d73696559a6b33$var$enterNode,
        exitNode: $19d73696559a6b33$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});


parcelRegister("9qsUT", function(module, exports) {

$parcel$export(module.exports, "JastBuilder", () => $f7e455d2ca709d45$export$99cae18a5a6ba8cf);

var $jz1xX = parcelRequire("jz1xX");

var $LFmXM = parcelRequire("LFmXM");

var $bFJ48 = parcelRequire("bFJ48");
var $41LBU = parcelRequire("41LBU");

var $f26C8 = parcelRequire("f26C8");

var $cWGfC = parcelRequire("cWGfC");
var $ax34Q = parcelRequire("ax34Q");

var $cjb70 = parcelRequire("cjb70");
class $f7e455d2ca709d45$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $cWGfC.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $cjb70.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $f26C8.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $f26C8.default).jast(undefined, value, [
                new (0, $ax34Q.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $LFmXM.default)((value)=>{
            const chars = (0, $jz1xX.CharStreams).fromString(value);
            const lexer = new (0, $bFJ48.JQLLexer)(chars);
            return new (0, $jz1xX.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $LFmXM.default)((tokens)=>new (0, $41LBU.JQLParser)(tokens));
    }
}

});
parcelRegister("jz1xX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e3e27c5f9836a7a6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3e27c5f9836a7a6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3e27c5f9836a7a6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gZZg5")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("86N5m")), module.exports);

// export * from "./ANTLRFileStream";
$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7ERej")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("jY97w")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("h5rBk")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("cBsOS")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d0TlQ")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("3wxwf")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("lXg5i")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8Mk1Z")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("arOt9")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("1y11S")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("b6VR9")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("cNbax")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6gsRs")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("4Allj")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d7mTm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6iuj6")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("2iaul")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d4sFB")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gTQRB")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8I7Eq")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6Npyx")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8tp3s")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("4qcTm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("dDGsq")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("bvca3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("djIaX")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5NlfZ")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("adfkv")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("ct3k0")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("lWPhg")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("24a4y")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("1uFvm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gBCh3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("9moap")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("iB1aK")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("2G93d")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5fKqt")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("dAoWy")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("kKHPj")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("3sjft")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7twhW")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5t4I3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7kyUa")), module.exports);

});
parcelRegister("gZZg5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("86N5m", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7ERej", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $59358f274fb6c10c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $esDFm = parcelRequire("esDFm");

var $d4sFB = parcelRequire("d4sFB");
const $59358f274fb6c10c$var$READ_BUFFER_SIZE = 1024;
const $59358f274fb6c10c$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $59358f274fb6c10c$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $gwEr2(this.LA(1) === $d4sFB.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $d4sFB.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $d4sFB.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "consume", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "LA", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "index", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "size", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "mark", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "release", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "seek", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "getText", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "sourceName", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $59358f274fb6c10c$var$ANTLRInputStream;

});
parcelRegister("gwEr2", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $igDjg = parcelRequire("igDjg");
'use strict';
function $c07f0014105f4d3c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c07f0014105f4d3c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c07f0014105f4d3c$var$_typeof(o);
}
function $c07f0014105f4d3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c07f0014105f4d3c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c07f0014105f4d3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c07f0014105f4d3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c07f0014105f4d3c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c07f0014105f4d3c$var$_toPropertyKey(arg) {
    var key = $c07f0014105f4d3c$var$_toPrimitive(arg, "string");
    return $c07f0014105f4d3c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c07f0014105f4d3c$var$_toPrimitive(input, hint) {
    if ($c07f0014105f4d3c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c07f0014105f4d3c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c07f0014105f4d3c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $9Ej6r = parcelRequire("9Ej6r");
var $c07f0014105f4d3c$var$_require$codes = $9Ej6r.codes, $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT = $c07f0014105f4d3c$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_ARG_TYPE, $c07f0014105f4d3c$var$ERR_INVALID_ARG_VALUE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_ARG_VALUE, $c07f0014105f4d3c$var$ERR_INVALID_RETURN_VALUE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_RETURN_VALUE, $c07f0014105f4d3c$var$ERR_MISSING_ARGS = $c07f0014105f4d3c$var$_require$codes.ERR_MISSING_ARGS;

var $jc4ou = parcelRequire("jc4ou");

var $7WF8Y = parcelRequire("7WF8Y");
var $c07f0014105f4d3c$var$inspect = $7WF8Y.inspect;

var $7WF8Y = parcelRequire("7WF8Y");
var $c07f0014105f4d3c$require$_require$types = $7WF8Y.types;
var $c07f0014105f4d3c$var$isPromise = $c07f0014105f4d3c$require$_require$types.isPromise, $c07f0014105f4d3c$var$isRegExp = $c07f0014105f4d3c$require$_require$types.isRegExp;

var $c07f0014105f4d3c$var$objectAssign = (parcelRequire("10hUt"))();

var $c07f0014105f4d3c$var$objectIs = (parcelRequire("4LgTG"))();

var $c07f0014105f4d3c$var$RegExpPrototypeTest = (parcelRequire("2TUjA"))('RegExp.prototype.test');
var $c07f0014105f4d3c$var$errorCache = new Map();
var $c07f0014105f4d3c$var$isDeepEqual;
var $c07f0014105f4d3c$var$isDeepStrictEqual;
var $c07f0014105f4d3c$var$parseExpressionAt;
var $c07f0014105f4d3c$var$findNodeAround;
var $c07f0014105f4d3c$var$decoder;

function $c07f0014105f4d3c$var$lazyLoadComparison() {
    var comparison = (parcelRequire("lV95c"));
    $c07f0014105f4d3c$var$isDeepEqual = comparison.isDeepEqual;
    $c07f0014105f4d3c$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $c07f0014105f4d3c$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $c07f0014105f4d3c$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $c07f0014105f4d3c$var$escapeFn = function escapeFn(str) {
    return $c07f0014105f4d3c$var$meta[str.charCodeAt(0)];
};
var $c07f0014105f4d3c$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $c07f0014105f4d3c$var$assert = module.exports = $c07f0014105f4d3c$var$ok;
var $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $c07f0014105f4d3c$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $jc4ou(obj);
}
function $c07f0014105f4d3c$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($c07f0014105f4d3c$var$warned === false) {
            $c07f0014105f4d3c$var$warned = true;
            var warn = $igDjg.emitWarning ? $igDjg.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $c07f0014105f4d3c$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $jc4ou(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$c07f0014105f4d3c$var$assert.fail = $c07f0014105f4d3c$var$fail;
// The AssertionError is defined in internal/error.
$c07f0014105f4d3c$var$assert.AssertionError = $jc4ou;
function $c07f0014105f4d3c$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $jc4ou({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $c07f0014105f4d3c$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $c07f0014105f4d3c$var$innerOk.apply(void 0, [
        $c07f0014105f4d3c$var$ok,
        args.length
    ].concat(args));
}
$c07f0014105f4d3c$var$assert.ok = $c07f0014105f4d3c$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $c07f0014105f4d3c$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$c07f0014105f4d3c$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$c07f0014105f4d3c$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if (!$c07f0014105f4d3c$var$isDeepEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$c07f0014105f4d3c$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if ($c07f0014105f4d3c$var$isDeepEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $c07f0014105f4d3c$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if (!$c07f0014105f4d3c$var$isDeepStrictEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$c07f0014105f4d3c$var$assert.notDeepStrictEqual = $c07f0014105f4d3c$var$notDeepStrictEqual;
function $c07f0014105f4d3c$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if ($c07f0014105f4d3c$var$isDeepStrictEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $c07f0014105f4d3c$var$notDeepStrictEqual
    });
}
$c07f0014105f4d3c$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$c07f0014105f4d3c$var$objectIs(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$c07f0014105f4d3c$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$objectIs(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $c07f0014105f4d3c$var$Comparison = /*#__PURE__*/ $c07f0014105f4d3c$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $c07f0014105f4d3c$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $c07f0014105f4d3c$var$isRegExp(obj[key]) && $c07f0014105f4d3c$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $c07f0014105f4d3c$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$c07f0014105f4d3c$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $c07f0014105f4d3c$var$Comparison(actual, keys);
            var b = new $c07f0014105f4d3c$var$Comparison(expected, keys, actual);
            var err = new $jc4ou({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $c07f0014105f4d3c$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $c07f0014105f4d3c$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($c07f0014105f4d3c$var$isRegExp(expected)) return $c07f0014105f4d3c$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($c07f0014105f4d3c$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $jc4ou({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $c07f0014105f4d3c$var$isRegExp(expected[key]) && $c07f0014105f4d3c$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $c07f0014105f4d3c$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $c07f0014105f4d3c$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL;
}
function $c07f0014105f4d3c$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $c07f0014105f4d3c$var$isPromise(obj) || obj !== null && $c07f0014105f4d3c$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $c07f0014105f4d3c$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$c07f0014105f4d3c$var$checkIsPromise(resultPromise)) throw new $c07f0014105f4d3c$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($c07f0014105f4d3c$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $c07f0014105f4d3c$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($c07f0014105f4d3c$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $c07f0014105f4d3c$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $c07f0014105f4d3c$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$c07f0014105f4d3c$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $c07f0014105f4d3c$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $c07f0014105f4d3c$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $c07f0014105f4d3c$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$c07f0014105f4d3c$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $c07f0014105f4d3c$var$expectsError.apply(void 0, [
        throws,
        $c07f0014105f4d3c$var$getActual(promiseFn)
    ].concat(args));
};
$c07f0014105f4d3c$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $c07f0014105f4d3c$var$waitForActual(promiseFn).then(function(result) {
        return $c07f0014105f4d3c$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$c07f0014105f4d3c$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $c07f0014105f4d3c$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $c07f0014105f4d3c$var$getActual(fn)
    ].concat(args));
};
$c07f0014105f4d3c$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $c07f0014105f4d3c$var$waitForActual(fn).then(function(result) {
        return $c07f0014105f4d3c$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$c07f0014105f4d3c$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($c07f0014105f4d3c$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $c07f0014105f4d3c$var$inspect(err);
        var newErr = new $jc4ou({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $c07f0014105f4d3c$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$c07f0014105f4d3c$var$isRegExp(regexp)) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $c07f0014105f4d3c$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($c07f0014105f4d3c$var$_typeof(string), " (").concat($c07f0014105f4d3c$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($c07f0014105f4d3c$var$inspect(regexp), ". Input:\n\n").concat($c07f0014105f4d3c$var$inspect(string), "\n"));
        var err = new $jc4ou({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$c07f0014105f4d3c$var$assert.match = function match(string, regexp, message) {
    $c07f0014105f4d3c$var$internalMatch(string, regexp, message, match, 'match');
};
$c07f0014105f4d3c$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $c07f0014105f4d3c$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $c07f0014105f4d3c$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $c07f0014105f4d3c$var$innerOk.apply(void 0, [
        $c07f0014105f4d3c$var$strict,
        args.length
    ].concat(args));
}
$c07f0014105f4d3c$var$assert.strict = $c07f0014105f4d3c$var$objectAssign($c07f0014105f4d3c$var$strict, $c07f0014105f4d3c$var$assert, {
    equal: $c07f0014105f4d3c$var$assert.strictEqual,
    deepEqual: $c07f0014105f4d3c$var$assert.deepStrictEqual,
    notEqual: $c07f0014105f4d3c$var$assert.notStrictEqual,
    notDeepEqual: $c07f0014105f4d3c$var$assert.notDeepStrictEqual
});
$c07f0014105f4d3c$var$assert.strict.strict = $c07f0014105f4d3c$var$assert.strict;

});
parcelRegister("9Ej6r", function(module, exports) {

$parcel$export(module.exports, "codes", () => $7066aaed797d201d$export$e45cb6485273080e, (v) => $7066aaed797d201d$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $7066aaed797d201d$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $7066aaed797d201d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7066aaed797d201d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7066aaed797d201d$var$_typeof(o);
}
function $7066aaed797d201d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7066aaed797d201d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7066aaed797d201d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7066aaed797d201d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7066aaed797d201d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7066aaed797d201d$var$_toPropertyKey(arg) {
    var key = $7066aaed797d201d$var$_toPrimitive(arg, "string");
    return $7066aaed797d201d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7066aaed797d201d$var$_toPrimitive(input, hint) {
    if ($7066aaed797d201d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7066aaed797d201d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7066aaed797d201d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7066aaed797d201d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7066aaed797d201d$var$_setPrototypeOf(subClass, superClass);
}
function $7066aaed797d201d$var$_setPrototypeOf(o, p) {
    $7066aaed797d201d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7066aaed797d201d$var$_setPrototypeOf(o, p);
}
function $7066aaed797d201d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7066aaed797d201d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7066aaed797d201d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7066aaed797d201d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7066aaed797d201d$var$_possibleConstructorReturn(this, result);
    };
}
function $7066aaed797d201d$var$_possibleConstructorReturn(self, call) {
    if (call && ($7066aaed797d201d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7066aaed797d201d$var$_assertThisInitialized(self);
}
function $7066aaed797d201d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7066aaed797d201d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7066aaed797d201d$var$_getPrototypeOf(o) {
    $7066aaed797d201d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7066aaed797d201d$var$_getPrototypeOf(o);
}
var $7066aaed797d201d$var$codes = {};
// Lazy loaded
var $7066aaed797d201d$var$assert;
var $7066aaed797d201d$var$util;
function $7066aaed797d201d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $7066aaed797d201d$var$_inherits(NodeError, _Base);
        var _super = $7066aaed797d201d$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $7066aaed797d201d$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $7066aaed797d201d$var$_createClass(NodeError);
    }(Base);
    $7066aaed797d201d$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $7066aaed797d201d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $7066aaed797d201d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7066aaed797d201d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $7066aaed797d201d$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$7066aaed797d201d$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$7066aaed797d201d$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($7066aaed797d201d$var$assert === undefined) $7066aaed797d201d$var$assert = (parcelRequire("gwEr2"));
    $7066aaed797d201d$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $7066aaed797d201d$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($7066aaed797d201d$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($7066aaed797d201d$var$oneOf(expected, 'type'));
    else {
        var type = $7066aaed797d201d$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($7066aaed797d201d$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($7066aaed797d201d$var$_typeof(actual));
    return msg;
}, TypeError);

$7066aaed797d201d$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($7066aaed797d201d$var$util === undefined) $7066aaed797d201d$var$util = (parcelRequire("7WF8Y"));
    var inspected = $7066aaed797d201d$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$7066aaed797d201d$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($7066aaed797d201d$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$7066aaed797d201d$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($7066aaed797d201d$var$assert === undefined) $7066aaed797d201d$var$assert = (parcelRequire("gwEr2"));
    $7066aaed797d201d$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$7066aaed797d201d$export$e45cb6485273080e = $7066aaed797d201d$var$codes;

});
parcelRegister("7WF8Y", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $igDjg = parcelRequire("igDjg");
var $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $5c8ddd78d1eb5694$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$5c8ddd78d1eb5694$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($5c8ddd78d1eb5694$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($5c8ddd78d1eb5694$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($5c8ddd78d1eb5694$var$isNull(x) || !$5c8ddd78d1eb5694$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $5c8ddd78d1eb5694$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $igDjg !== 'undefined' && $igDjg.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $igDjg === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($igDjg.throwDeprecation) throw new Error(msg);
            else if ($igDjg.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $5c8ddd78d1eb5694$var$debugs = {};
var $5c8ddd78d1eb5694$var$debugEnvRegex = /^$/;
var $5c8ddd78d1eb5694$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$5c8ddd78d1eb5694$var$debugs[set]) {
        if ($5c8ddd78d1eb5694$var$debugEnvRegex.test(set)) {
            var pid = $igDjg.pid;
            $5c8ddd78d1eb5694$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $5c8ddd78d1eb5694$var$debugs[set] = function() {};
    }
    return $5c8ddd78d1eb5694$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $5c8ddd78d1eb5694$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $5c8ddd78d1eb5694$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($5c8ddd78d1eb5694$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $5c8ddd78d1eb5694$var$stylizeWithColor;
    return $5c8ddd78d1eb5694$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $5c8ddd78d1eb5694$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$5c8ddd78d1eb5694$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$5c8ddd78d1eb5694$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $5c8ddd78d1eb5694$var$stylizeWithColor(str, styleType) {
    var style = $5c8ddd78d1eb5694$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $5c8ddd78d1eb5694$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $5c8ddd78d1eb5694$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $5c8ddd78d1eb5694$var$stylizeNoColor(str, styleType) {
    return str;
}
function $5c8ddd78d1eb5694$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $5c8ddd78d1eb5694$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $5c8ddd78d1eb5694$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$5c8ddd78d1eb5694$var$isString(ret)) ret = $5c8ddd78d1eb5694$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $5c8ddd78d1eb5694$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $5c8ddd78d1eb5694$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($5c8ddd78d1eb5694$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $5c8ddd78d1eb5694$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($5c8ddd78d1eb5694$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($5c8ddd78d1eb5694$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($5c8ddd78d1eb5694$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($5c8ddd78d1eb5694$var$isError(value)) return $5c8ddd78d1eb5694$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($5c8ddd78d1eb5694$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($5c8ddd78d1eb5694$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($5c8ddd78d1eb5694$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($5c8ddd78d1eb5694$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($5c8ddd78d1eb5694$var$isError(value)) base = ' ' + $5c8ddd78d1eb5694$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($5c8ddd78d1eb5694$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $5c8ddd78d1eb5694$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $5c8ddd78d1eb5694$var$reduceToSingleString(output, base, braces);
}
function $5c8ddd78d1eb5694$var$formatPrimitive(ctx, value) {
    if ($5c8ddd78d1eb5694$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($5c8ddd78d1eb5694$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($5c8ddd78d1eb5694$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($5c8ddd78d1eb5694$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($5c8ddd78d1eb5694$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $5c8ddd78d1eb5694$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $5c8ddd78d1eb5694$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($5c8ddd78d1eb5694$var$hasOwnProperty(value, String(i))) output.push($5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$5c8ddd78d1eb5694$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($5c8ddd78d1eb5694$var$isNull(recurseTimes)) str = $5c8ddd78d1eb5694$var$formatValue(ctx, desc.value, null);
            else str = $5c8ddd78d1eb5694$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($5c8ddd78d1eb5694$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $5c8ddd78d1eb5694$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("eQQyY"));
function $5c8ddd78d1eb5694$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $5c8ddd78d1eb5694$var$isArray;
function $5c8ddd78d1eb5694$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $5c8ddd78d1eb5694$var$isBoolean;
function $5c8ddd78d1eb5694$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $5c8ddd78d1eb5694$var$isNull;
function $5c8ddd78d1eb5694$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $5c8ddd78d1eb5694$var$isNullOrUndefined;
function $5c8ddd78d1eb5694$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $5c8ddd78d1eb5694$var$isNumber;
function $5c8ddd78d1eb5694$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $5c8ddd78d1eb5694$var$isString;
function $5c8ddd78d1eb5694$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $5c8ddd78d1eb5694$var$isSymbol;
function $5c8ddd78d1eb5694$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $5c8ddd78d1eb5694$var$isUndefined;
function $5c8ddd78d1eb5694$var$isRegExp(re) {
    return $5c8ddd78d1eb5694$var$isObject(re) && $5c8ddd78d1eb5694$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $5c8ddd78d1eb5694$var$isRegExp;
module.exports.types.isRegExp = $5c8ddd78d1eb5694$var$isRegExp;
function $5c8ddd78d1eb5694$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $5c8ddd78d1eb5694$var$isObject;
function $5c8ddd78d1eb5694$var$isDate(d) {
    return $5c8ddd78d1eb5694$var$isObject(d) && $5c8ddd78d1eb5694$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $5c8ddd78d1eb5694$var$isDate;
module.exports.types.isDate = $5c8ddd78d1eb5694$var$isDate;
function $5c8ddd78d1eb5694$var$isError(e) {
    return $5c8ddd78d1eb5694$var$isObject(e) && ($5c8ddd78d1eb5694$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $5c8ddd78d1eb5694$var$isError;
module.exports.types.isNativeError = $5c8ddd78d1eb5694$var$isError;
function $5c8ddd78d1eb5694$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $5c8ddd78d1eb5694$var$isFunction;
function $5c8ddd78d1eb5694$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $5c8ddd78d1eb5694$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("fMvDf"));
function $5c8ddd78d1eb5694$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $5c8ddd78d1eb5694$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $5c8ddd78d1eb5694$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $5c8ddd78d1eb5694$var$timestamp() {
    var d = new Date();
    var time = [
        $5c8ddd78d1eb5694$var$pad(d.getHours()),
        $5c8ddd78d1eb5694$var$pad(d.getMinutes()),
        $5c8ddd78d1eb5694$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $5c8ddd78d1eb5694$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $5c8ddd78d1eb5694$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lpcNn"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$5c8ddd78d1eb5694$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $5c8ddd78d1eb5694$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol && original[$5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol]) {
        var fn = original[$5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol;
function $5c8ddd78d1eb5694$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $5c8ddd78d1eb5694$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $igDjg.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $igDjg.nextTick($5c8ddd78d1eb5694$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $5c8ddd78d1eb5694$var$callbackify;

});
parcelRegister("eQQyY", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $8NKMi = parcelRequire("8NKMi");

var $7qnIS = parcelRequire("7qnIS");

var $3eoyd = parcelRequire("3eoyd");

var $cC7Tq = parcelRequire("cC7Tq");
function $acfeb1ef2847c7f3$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $acfeb1ef2847c7f3$var$BigIntSupported = typeof BigInt !== 'undefined';
var $acfeb1ef2847c7f3$var$SymbolSupported = typeof Symbol !== 'undefined';
var $acfeb1ef2847c7f3$var$ObjectToString = $acfeb1ef2847c7f3$var$uncurryThis(Object.prototype.toString);
var $acfeb1ef2847c7f3$var$numberValue = $acfeb1ef2847c7f3$var$uncurryThis(Number.prototype.valueOf);
var $acfeb1ef2847c7f3$var$stringValue = $acfeb1ef2847c7f3$var$uncurryThis(String.prototype.valueOf);
var $acfeb1ef2847c7f3$var$booleanValue = $acfeb1ef2847c7f3$var$uncurryThis(Boolean.prototype.valueOf);
if ($acfeb1ef2847c7f3$var$BigIntSupported) var $acfeb1ef2847c7f3$var$bigIntValue = $acfeb1ef2847c7f3$var$uncurryThis(BigInt.prototype.valueOf);
if ($acfeb1ef2847c7f3$var$SymbolSupported) var $acfeb1ef2847c7f3$var$symbolValue = $acfeb1ef2847c7f3$var$uncurryThis(Symbol.prototype.valueOf);
function $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $8NKMi;
module.exports.isGeneratorFunction = $7qnIS;
module.exports.isTypedArray = $cC7Tq;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $acfeb1ef2847c7f3$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $acfeb1ef2847c7f3$var$isPromise;
function $acfeb1ef2847c7f3$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $cC7Tq(value) || $acfeb1ef2847c7f3$var$isDataView(value);
}
module.exports.isArrayBufferView = $acfeb1ef2847c7f3$var$isArrayBufferView;
function $acfeb1ef2847c7f3$var$isUint8Array(value) {
    return $3eoyd(value) === 'Uint8Array';
}
module.exports.isUint8Array = $acfeb1ef2847c7f3$var$isUint8Array;
function $acfeb1ef2847c7f3$var$isUint8ClampedArray(value) {
    return $3eoyd(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $acfeb1ef2847c7f3$var$isUint8ClampedArray;
function $acfeb1ef2847c7f3$var$isUint16Array(value) {
    return $3eoyd(value) === 'Uint16Array';
}
module.exports.isUint16Array = $acfeb1ef2847c7f3$var$isUint16Array;
function $acfeb1ef2847c7f3$var$isUint32Array(value) {
    return $3eoyd(value) === 'Uint32Array';
}
module.exports.isUint32Array = $acfeb1ef2847c7f3$var$isUint32Array;
function $acfeb1ef2847c7f3$var$isInt8Array(value) {
    return $3eoyd(value) === 'Int8Array';
}
module.exports.isInt8Array = $acfeb1ef2847c7f3$var$isInt8Array;
function $acfeb1ef2847c7f3$var$isInt16Array(value) {
    return $3eoyd(value) === 'Int16Array';
}
module.exports.isInt16Array = $acfeb1ef2847c7f3$var$isInt16Array;
function $acfeb1ef2847c7f3$var$isInt32Array(value) {
    return $3eoyd(value) === 'Int32Array';
}
module.exports.isInt32Array = $acfeb1ef2847c7f3$var$isInt32Array;
function $acfeb1ef2847c7f3$var$isFloat32Array(value) {
    return $3eoyd(value) === 'Float32Array';
}
module.exports.isFloat32Array = $acfeb1ef2847c7f3$var$isFloat32Array;
function $acfeb1ef2847c7f3$var$isFloat64Array(value) {
    return $3eoyd(value) === 'Float64Array';
}
module.exports.isFloat64Array = $acfeb1ef2847c7f3$var$isFloat64Array;
function $acfeb1ef2847c7f3$var$isBigInt64Array(value) {
    return $3eoyd(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $acfeb1ef2847c7f3$var$isBigInt64Array;
function $acfeb1ef2847c7f3$var$isBigUint64Array(value) {
    return $3eoyd(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $acfeb1ef2847c7f3$var$isBigUint64Array;
function $acfeb1ef2847c7f3$var$isMapToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Map]';
}
$acfeb1ef2847c7f3$var$isMapToString.working = typeof Map !== 'undefined' && $acfeb1ef2847c7f3$var$isMapToString(new Map());
function $acfeb1ef2847c7f3$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isMapToString.working ? $acfeb1ef2847c7f3$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $acfeb1ef2847c7f3$var$isMap;
function $acfeb1ef2847c7f3$var$isSetToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Set]';
}
$acfeb1ef2847c7f3$var$isSetToString.working = typeof Set !== 'undefined' && $acfeb1ef2847c7f3$var$isSetToString(new Set());
function $acfeb1ef2847c7f3$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isSetToString.working ? $acfeb1ef2847c7f3$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $acfeb1ef2847c7f3$var$isSet;
function $acfeb1ef2847c7f3$var$isWeakMapToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WeakMap]';
}
$acfeb1ef2847c7f3$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $acfeb1ef2847c7f3$var$isWeakMapToString(new WeakMap());
function $acfeb1ef2847c7f3$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isWeakMapToString.working ? $acfeb1ef2847c7f3$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $acfeb1ef2847c7f3$var$isWeakMap;
function $acfeb1ef2847c7f3$var$isWeakSetToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WeakSet]';
}
$acfeb1ef2847c7f3$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $acfeb1ef2847c7f3$var$isWeakSetToString(new WeakSet());
function $acfeb1ef2847c7f3$var$isWeakSet(value) {
    return $acfeb1ef2847c7f3$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $acfeb1ef2847c7f3$var$isWeakSet;
function $acfeb1ef2847c7f3$var$isArrayBufferToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$acfeb1ef2847c7f3$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $acfeb1ef2847c7f3$var$isArrayBufferToString(new ArrayBuffer());
function $acfeb1ef2847c7f3$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isArrayBufferToString.working ? $acfeb1ef2847c7f3$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $acfeb1ef2847c7f3$var$isArrayBuffer;
function $acfeb1ef2847c7f3$var$isDataViewToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object DataView]';
}
$acfeb1ef2847c7f3$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $acfeb1ef2847c7f3$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $acfeb1ef2847c7f3$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isDataViewToString.working ? $acfeb1ef2847c7f3$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $acfeb1ef2847c7f3$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $acfeb1ef2847c7f3$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $acfeb1ef2847c7f3$var$isSharedArrayBuffer(value) {
    if (typeof $acfeb1ef2847c7f3$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working === 'undefined') $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working = $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(new $acfeb1ef2847c7f3$var$SharedArrayBufferCopy());
    return $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working ? $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(value) : value instanceof $acfeb1ef2847c7f3$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $acfeb1ef2847c7f3$var$isSharedArrayBuffer;
function $acfeb1ef2847c7f3$var$isAsyncFunction(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $acfeb1ef2847c7f3$var$isAsyncFunction;
function $acfeb1ef2847c7f3$var$isMapIterator(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $acfeb1ef2847c7f3$var$isMapIterator;
function $acfeb1ef2847c7f3$var$isSetIterator(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $acfeb1ef2847c7f3$var$isSetIterator;
function $acfeb1ef2847c7f3$var$isGeneratorObject(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $acfeb1ef2847c7f3$var$isGeneratorObject;
function $acfeb1ef2847c7f3$var$isWebAssemblyCompiledModule(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $acfeb1ef2847c7f3$var$isWebAssemblyCompiledModule;
function $acfeb1ef2847c7f3$var$isNumberObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$numberValue);
}
module.exports.isNumberObject = $acfeb1ef2847c7f3$var$isNumberObject;
function $acfeb1ef2847c7f3$var$isStringObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$stringValue);
}
module.exports.isStringObject = $acfeb1ef2847c7f3$var$isStringObject;
function $acfeb1ef2847c7f3$var$isBooleanObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$booleanValue);
}
module.exports.isBooleanObject = $acfeb1ef2847c7f3$var$isBooleanObject;
function $acfeb1ef2847c7f3$var$isBigIntObject(value) {
    return $acfeb1ef2847c7f3$var$BigIntSupported && $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$bigIntValue);
}
module.exports.isBigIntObject = $acfeb1ef2847c7f3$var$isBigIntObject;
function $acfeb1ef2847c7f3$var$isSymbolObject(value) {
    return $acfeb1ef2847c7f3$var$SymbolSupported && $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$symbolValue);
}
module.exports.isSymbolObject = $acfeb1ef2847c7f3$var$isSymbolObject;
function $acfeb1ef2847c7f3$var$isBoxedPrimitive(value) {
    return $acfeb1ef2847c7f3$var$isNumberObject(value) || $acfeb1ef2847c7f3$var$isStringObject(value) || $acfeb1ef2847c7f3$var$isBooleanObject(value) || $acfeb1ef2847c7f3$var$isBigIntObject(value) || $acfeb1ef2847c7f3$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $acfeb1ef2847c7f3$var$isBoxedPrimitive;
function $acfeb1ef2847c7f3$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($acfeb1ef2847c7f3$var$isArrayBuffer(value) || $acfeb1ef2847c7f3$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $acfeb1ef2847c7f3$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("7qnIS", function(module, exports) {
'use strict';
var $567d5cfb22b1b184$var$toStr = Object.prototype.toString;
var $567d5cfb22b1b184$var$fnToStr = Function.prototype.toString;
var $567d5cfb22b1b184$var$isFnRegex = /^\s*(?:function)?\*/;

var $567d5cfb22b1b184$var$hasToStringTag = (parcelRequire("5nSZG"))();
var $567d5cfb22b1b184$var$getProto = Object.getPrototypeOf;
var $567d5cfb22b1b184$var$getGeneratorFunc = function() {
    if (!$567d5cfb22b1b184$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $567d5cfb22b1b184$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($567d5cfb22b1b184$var$isFnRegex.test($567d5cfb22b1b184$var$fnToStr.call(fn))) return true;
    if (!$567d5cfb22b1b184$var$hasToStringTag) {
        var str = $567d5cfb22b1b184$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$567d5cfb22b1b184$var$getProto) return false;
    if (typeof $567d5cfb22b1b184$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $567d5cfb22b1b184$var$getGeneratorFunc();
        $567d5cfb22b1b184$var$GeneratorFunction = generatorFunc ? $567d5cfb22b1b184$var$getProto(generatorFunc) : false;
    }
    return $567d5cfb22b1b184$var$getProto(fn) === $567d5cfb22b1b184$var$GeneratorFunction;
};

});

parcelRegister("3eoyd", function(module, exports) {
'use strict';

var $9xfpK = parcelRequire("9xfpK");

var $4DPeP = parcelRequire("4DPeP");

var $6zl1T = parcelRequire("6zl1T");

var $f8M6V = parcelRequire("f8M6V");

var $kwOoE = parcelRequire("kwOoE");

var $9SzeH = parcelRequire("9SzeH");
var $25a5b9308bd94906$var$$toString = $f8M6V('Object.prototype.toString');

var $25a5b9308bd94906$var$hasToStringTag = (parcelRequire("5nSZG"))();
var $25a5b9308bd94906$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $25a5b9308bd94906$var$typedArrays = $4DPeP();
var $25a5b9308bd94906$var$$slice = $f8M6V('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $25a5b9308bd94906$var$$indexOf = $f8M6V('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $25a5b9308bd94906$var$cache = {
    __proto__: null
};
if ($25a5b9308bd94906$var$hasToStringTag && $kwOoE && $9SzeH) $9xfpK($25a5b9308bd94906$var$typedArrays, function(typedArray) {
    var arr = new $25a5b9308bd94906$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $9SzeH) {
        var proto = $9SzeH(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $kwOoE(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $9SzeH(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $kwOoE(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $25a5b9308bd94906$var$cache['$' + typedArray] = $6zl1T(descriptor.get);
    }
});
else $9xfpK($25a5b9308bd94906$var$typedArrays, function(typedArray) {
    var arr = new $25a5b9308bd94906$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $25a5b9308bd94906$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $6zl1T(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $25a5b9308bd94906$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $9xfpK(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $25a5b9308bd94906$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $25a5b9308bd94906$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $25a5b9308bd94906$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $9xfpK(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $25a5b9308bd94906$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $25a5b9308bd94906$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$25a5b9308bd94906$var$hasToStringTag) {
        /** @type {string} */ var tag = $25a5b9308bd94906$var$$slice($25a5b9308bd94906$var$$toString(value), 8, -1);
        if ($25a5b9308bd94906$var$$indexOf($25a5b9308bd94906$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $25a5b9308bd94906$var$trySlices(value);
    }
    if (!$kwOoE) return null;
     // unknown engine
    return $25a5b9308bd94906$var$tryTypedArrays(value);
};

});
parcelRegister("9xfpK", function(module, exports) {
'use strict';

var $81Pfa = parcelRequire("81Pfa");
var $6f1327188da2d457$var$toStr = Object.prototype.toString;
var $6f1327188da2d457$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($6f1327188da2d457$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($6f1327188da2d457$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $6f1327188da2d457$var$isArray(x) {
    return $6f1327188da2d457$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$81Pfa(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($6f1327188da2d457$var$isArray(list)) $6f1327188da2d457$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $6f1327188da2d457$var$forEachString(list, iterator, receiver);
    else $6f1327188da2d457$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("81Pfa", function(module, exports) {
'use strict';
var $5d862aa4803ed1a0$var$fnToStr = Function.prototype.toString;
var $5d862aa4803ed1a0$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $5d862aa4803ed1a0$var$badArrayLike;
var $5d862aa4803ed1a0$var$isCallableMarker;
if (typeof $5d862aa4803ed1a0$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $5d862aa4803ed1a0$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $5d862aa4803ed1a0$var$isCallableMarker;
        }
    });
    $5d862aa4803ed1a0$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $5d862aa4803ed1a0$var$reflectApply(function() {
        throw 42;
    }, null, $5d862aa4803ed1a0$var$badArrayLike);
} catch (_) {
    if (_ !== $5d862aa4803ed1a0$var$isCallableMarker) $5d862aa4803ed1a0$var$reflectApply = null;
}
else $5d862aa4803ed1a0$var$reflectApply = null;
var $5d862aa4803ed1a0$var$constructorRegex = /^\s*class\b/;
var $5d862aa4803ed1a0$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $5d862aa4803ed1a0$var$fnToStr.call(value);
        return $5d862aa4803ed1a0$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $5d862aa4803ed1a0$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($5d862aa4803ed1a0$var$isES6ClassFn(value)) return false;
        $5d862aa4803ed1a0$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $5d862aa4803ed1a0$var$toStr = Object.prototype.toString;
var $5d862aa4803ed1a0$var$objectClass = '[object Object]';
var $5d862aa4803ed1a0$var$fnClass = '[object Function]';
var $5d862aa4803ed1a0$var$genClass = '[object GeneratorFunction]';
var $5d862aa4803ed1a0$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $5d862aa4803ed1a0$var$ddaClass2 = '[object HTML document.all class]';
var $5d862aa4803ed1a0$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $5d862aa4803ed1a0$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $5d862aa4803ed1a0$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $5d862aa4803ed1a0$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $5d862aa4803ed1a0$var$all = document.all;
    if ($5d862aa4803ed1a0$var$toStr.call($5d862aa4803ed1a0$var$all) === $5d862aa4803ed1a0$var$toStr.call(document.all)) $5d862aa4803ed1a0$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($5d862aa4803ed1a0$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $5d862aa4803ed1a0$var$toStr.call(value);
            return (str === $5d862aa4803ed1a0$var$ddaClass || str === $5d862aa4803ed1a0$var$ddaClass2 || str === $5d862aa4803ed1a0$var$ddaClass3 // opera 12.16
             || str === $5d862aa4803ed1a0$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $5d862aa4803ed1a0$var$reflectApply ? function isCallable(value) {
    if ($5d862aa4803ed1a0$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $5d862aa4803ed1a0$var$reflectApply(value, null, $5d862aa4803ed1a0$var$badArrayLike);
    } catch (e) {
        if (e !== $5d862aa4803ed1a0$var$isCallableMarker) return false;
    }
    return !$5d862aa4803ed1a0$var$isES6ClassFn(value) && $5d862aa4803ed1a0$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($5d862aa4803ed1a0$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($5d862aa4803ed1a0$var$hasToStringTag) return $5d862aa4803ed1a0$var$tryFunctionObject(value);
    if ($5d862aa4803ed1a0$var$isES6ClassFn(value)) return false;
    var strClass = $5d862aa4803ed1a0$var$toStr.call(value);
    if (strClass !== $5d862aa4803ed1a0$var$fnClass && strClass !== $5d862aa4803ed1a0$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $5d862aa4803ed1a0$var$tryFunctionObject(value);
};

});


parcelRegister("4DPeP", function(module, exports) {
'use strict';

var $fCSU3 = parcelRequire("fCSU3");
var $36128cca598aa228$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $fCSU3.length; i++)if (typeof $36128cca598aa228$var$g[$fCSU3[i]] === 'function') // @ts-expect-error
    out[out.length] = $fCSU3[i];
    return out;
};

});
parcelRegister("fCSU3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("cC7Tq", function(module, exports) {
'use strict';

var $3eoyd = parcelRequire("3eoyd");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$3eoyd(value);
};

});


parcelRegister("fMvDf", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lpcNn", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("jc4ou", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $igDjg = parcelRequire("igDjg");
'use strict';
function $df928be34e98853c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df928be34e98853c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df928be34e98853c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $df928be34e98853c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df928be34e98853c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df928be34e98853c$var$_defineProperty(obj, key, value) {
    key = $df928be34e98853c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $df928be34e98853c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $df928be34e98853c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $df928be34e98853c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $df928be34e98853c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $df928be34e98853c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $df928be34e98853c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $df928be34e98853c$var$_toPropertyKey(arg) {
    var key = $df928be34e98853c$var$_toPrimitive(arg, "string");
    return $df928be34e98853c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $df928be34e98853c$var$_toPrimitive(input, hint) {
    if ($df928be34e98853c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($df928be34e98853c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $df928be34e98853c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $df928be34e98853c$var$_setPrototypeOf(subClass, superClass);
}
function $df928be34e98853c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $df928be34e98853c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $df928be34e98853c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $df928be34e98853c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $df928be34e98853c$var$_possibleConstructorReturn(this, result);
    };
}
function $df928be34e98853c$var$_possibleConstructorReturn(self, call) {
    if (call && ($df928be34e98853c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $df928be34e98853c$var$_assertThisInitialized(self);
}
function $df928be34e98853c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $df928be34e98853c$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $df928be34e98853c$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$df928be34e98853c$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $df928be34e98853c$var$_construct(Class, arguments, $df928be34e98853c$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $df928be34e98853c$var$_setPrototypeOf(Wrapper, Class);
    };
    return $df928be34e98853c$var$_wrapNativeSuper(Class);
}
function $df928be34e98853c$var$_construct(Parent, args, Class) {
    if ($df928be34e98853c$var$_isNativeReflectConstruct()) $df928be34e98853c$var$_construct = Reflect.construct.bind();
    else $df928be34e98853c$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $df928be34e98853c$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $df928be34e98853c$var$_construct.apply(null, arguments);
}
function $df928be34e98853c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $df928be34e98853c$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $df928be34e98853c$var$_setPrototypeOf(o, p) {
    $df928be34e98853c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $df928be34e98853c$var$_setPrototypeOf(o, p);
}
function $df928be34e98853c$var$_getPrototypeOf(o) {
    $df928be34e98853c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $df928be34e98853c$var$_getPrototypeOf(o);
}
function $df928be34e98853c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $df928be34e98853c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $df928be34e98853c$var$_typeof(o);
}

var $7WF8Y = parcelRequire("7WF8Y");
var $df928be34e98853c$var$inspect = $7WF8Y.inspect;

var $9Ej6r = parcelRequire("9Ej6r");
var $df928be34e98853c$var$ERR_INVALID_ARG_TYPE = $9Ej6r.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $df928be34e98853c$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $df928be34e98853c$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $df928be34e98853c$var$blue = '';
var $df928be34e98853c$var$green = '';
var $df928be34e98853c$var$red = '';
var $df928be34e98853c$var$white = '';
var $df928be34e98853c$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $df928be34e98853c$var$kMaxShortLength = 10;
function $df928be34e98853c$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $df928be34e98853c$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $df928be34e98853c$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $df928be34e98853c$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $df928be34e98853c$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $df928be34e98853c$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $df928be34e98853c$var$_typeof(actual) === 'object' && $df928be34e98853c$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $df928be34e98853c$var$kMaxShortLength) {
            if (($df928be34e98853c$var$_typeof(actual) !== 'object' || actual === null) && ($df928be34e98853c$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($df928be34e98853c$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $igDjg.stderr && $igDjg.stderr.isTTY ? $igDjg.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($df928be34e98853c$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($df928be34e98853c$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $df928be34e98853c$var$kReadableOperator[operator] + "\n".concat($df928be34e98853c$var$green, "+ actual").concat($df928be34e98853c$var$white, " ").concat($df928be34e98853c$var$red, "- expected").concat($df928be34e98853c$var$white);
    var skippedMsg = " ".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($df928be34e98853c$var$red, "-").concat($df928be34e98853c$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($df928be34e98853c$var$green, "+").concat($df928be34e98853c$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$df928be34e98853c$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $df928be34e98853c$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($df928be34e98853c$var$green, "+").concat($df928be34e98853c$var$white, " ").concat(actualLine);
                other += "\n".concat($df928be34e98853c$var$red, "-").concat($df928be34e98853c$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white).concat(other, "\n") + "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $df928be34e98853c$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $df928be34e98853c$var$_inherits(AssertionError, _Error);
    var _super = $df928be34e98853c$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $df928be34e98853c$var$_classCallCheck(this, AssertionError);
        if ($df928be34e98853c$var$_typeof(options) !== 'object' || options === null) throw new $df928be34e98853c$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($igDjg.stderr && $igDjg.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($igDjg.stderr && $igDjg.stderr.getColorDepth && $igDjg.stderr.getColorDepth() !== 1) {
                    $df928be34e98853c$var$blue = "\x1B[34m";
                    $df928be34e98853c$var$green = "\x1B[32m";
                    $df928be34e98853c$var$white = "\x1B[39m";
                    $df928be34e98853c$var$red = "\x1B[31m";
                } else {
                    $df928be34e98853c$var$blue = '';
                    $df928be34e98853c$var$green = '';
                    $df928be34e98853c$var$white = '';
                    $df928be34e98853c$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($df928be34e98853c$var$_typeof(actual) === 'object' && actual !== null && $df928be34e98853c$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $df928be34e98853c$var$copyError(actual);
                expected = $df928be34e98853c$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $df928be34e98853c$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $df928be34e98853c$var$kReadableOperator[operator];
                var res = $df928be34e98853c$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $df928be34e98853c$var$_typeof(actual) === 'object' && actual !== null) base = $df928be34e98853c$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $df928be34e98853c$var$inspectValue(actual);
                var other = '';
                var knownOperators = $df928be34e98853c$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($df928be34e98853c$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($df928be34e98853c$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($df928be34e98853c$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($df928be34e98853c$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $df928be34e98853c$var$_possibleConstructorReturn(_this);
    }
    $df928be34e98853c$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $df928be34e98853c$var$inspect(this, $df928be34e98853c$var$_objectSpread($df928be34e98853c$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $df928be34e98853c$var$_wrapNativeSuper(Error), $df928be34e98853c$var$inspect.custom);
module.exports = $df928be34e98853c$var$AssertionError;

});

parcelRegister("10hUt", function(module, exports) {
'use strict';

var $9CbYT = parcelRequire("9CbYT");
var $0bb3af0d2c3ea2e8$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $0bb3af0d2c3ea2e8$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $9CbYT;
    if ($0bb3af0d2c3ea2e8$var$lacksProperEnumerationOrder()) return $9CbYT;
    if ($0bb3af0d2c3ea2e8$var$assignHasPendingExceptions()) return $9CbYT;
    return Object.assign;
};

});
parcelRegister("9CbYT", function(module, exports) {
'use strict';

var $iJBzN = parcelRequire("iJBzN");

var $7000f4db814cc860$var$hasSymbols = (parcelRequire("cwWvF"))();

var $f8M6V = parcelRequire("f8M6V");

var $cAzwJ = parcelRequire("cAzwJ");
var $7000f4db814cc860$var$$push = $f8M6V('Array.prototype.push');
var $7000f4db814cc860$var$$propIsEnumerable = $f8M6V('Object.prototype.propertyIsEnumerable');
var $7000f4db814cc860$var$originalGetSymbols = $7000f4db814cc860$var$hasSymbols ? $cAzwJ.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $cAzwJ(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $cAzwJ(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $iJBzN(from);
        var getSymbols = $7000f4db814cc860$var$hasSymbols && ($cAzwJ.getOwnPropertySymbols || $7000f4db814cc860$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($7000f4db814cc860$var$$propIsEnumerable(from, key)) $7000f4db814cc860$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($7000f4db814cc860$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});


parcelRegister("lV95c", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $ff55f7860a99da96$var$_slicedToArray(arr, i) {
    return $ff55f7860a99da96$var$_arrayWithHoles(arr) || $ff55f7860a99da96$var$_iterableToArrayLimit(arr, i) || $ff55f7860a99da96$var$_unsupportedIterableToArray(arr, i) || $ff55f7860a99da96$var$_nonIterableRest();
}
function $ff55f7860a99da96$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ff55f7860a99da96$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ff55f7860a99da96$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ff55f7860a99da96$var$_arrayLikeToArray(o, minLen);
}
function $ff55f7860a99da96$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ff55f7860a99da96$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ff55f7860a99da96$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ff55f7860a99da96$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ff55f7860a99da96$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ff55f7860a99da96$var$_typeof(o);
}
var $ff55f7860a99da96$var$regexFlagsSupported = /a/g.flags !== undefined;
var $ff55f7860a99da96$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $ff55f7860a99da96$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $ff55f7860a99da96$var$objectIs = Object.is ? Object.is : (parcelRequire("gh4Iw"));
var $ff55f7860a99da96$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $ff55f7860a99da96$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("fLjZy"));
function $ff55f7860a99da96$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $ff55f7860a99da96$var$hasOwnProperty = $ff55f7860a99da96$var$uncurryThis(Object.prototype.hasOwnProperty);
var $ff55f7860a99da96$var$propertyIsEnumerable = $ff55f7860a99da96$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $ff55f7860a99da96$var$objectToString = $ff55f7860a99da96$var$uncurryThis(Object.prototype.toString);

var $7WF8Y = parcelRequire("7WF8Y");
var $ff55f7860a99da96$require$_require$types = $7WF8Y.types;
var $ff55f7860a99da96$var$isAnyArrayBuffer = $ff55f7860a99da96$require$_require$types.isAnyArrayBuffer, $ff55f7860a99da96$var$isArrayBufferView = $ff55f7860a99da96$require$_require$types.isArrayBufferView, $ff55f7860a99da96$var$isDate = $ff55f7860a99da96$require$_require$types.isDate, $ff55f7860a99da96$var$isMap = $ff55f7860a99da96$require$_require$types.isMap, $ff55f7860a99da96$var$isRegExp = $ff55f7860a99da96$require$_require$types.isRegExp, $ff55f7860a99da96$var$isSet = $ff55f7860a99da96$require$_require$types.isSet, $ff55f7860a99da96$var$isNativeError = $ff55f7860a99da96$require$_require$types.isNativeError, $ff55f7860a99da96$var$isBoxedPrimitive = $ff55f7860a99da96$require$_require$types.isBoxedPrimitive, $ff55f7860a99da96$var$isNumberObject = $ff55f7860a99da96$require$_require$types.isNumberObject, $ff55f7860a99da96$var$isStringObject = $ff55f7860a99da96$require$_require$types.isStringObject, $ff55f7860a99da96$var$isBooleanObject = $ff55f7860a99da96$require$_require$types.isBooleanObject, $ff55f7860a99da96$var$isBigIntObject = $ff55f7860a99da96$require$_require$types.isBigIntObject, $ff55f7860a99da96$var$isSymbolObject = $ff55f7860a99da96$require$_require$types.isSymbolObject, $ff55f7860a99da96$var$isFloat32Array = $ff55f7860a99da96$require$_require$types.isFloat32Array, $ff55f7860a99da96$var$isFloat64Array = $ff55f7860a99da96$require$_require$types.isFloat64Array;
function $ff55f7860a99da96$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $ff55f7860a99da96$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($ff55f7860a99da96$var$isNonIndex).concat($ff55f7860a99da96$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $ff55f7860a99da96$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $ff55f7860a99da96$var$ONLY_ENUMERABLE = undefined;
var $ff55f7860a99da96$var$kStrict = true;
var $ff55f7860a99da96$var$kLoose = false;
var $ff55f7860a99da96$var$kNoIterator = 0;
var $ff55f7860a99da96$var$kIsArray = 1;
var $ff55f7860a99da96$var$kIsSet = 2;
var $ff55f7860a99da96$var$kIsMap = 3;
// Check if they have the same source and flags
function $ff55f7860a99da96$var$areSimilarRegExps(a, b) {
    return $ff55f7860a99da96$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $ff55f7860a99da96$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $ff55f7860a99da96$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $ff55f7860a99da96$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $ff55f7860a99da96$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $ff55f7860a99da96$var$isEqualBoxedPrimitive(val1, val2) {
    if ($ff55f7860a99da96$var$isNumberObject(val1)) return $ff55f7860a99da96$var$isNumberObject(val2) && $ff55f7860a99da96$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($ff55f7860a99da96$var$isStringObject(val1)) return $ff55f7860a99da96$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($ff55f7860a99da96$var$isBooleanObject(val1)) return $ff55f7860a99da96$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($ff55f7860a99da96$var$isBigIntObject(val1)) return $ff55f7860a99da96$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $ff55f7860a99da96$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $ff55f7860a99da96$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $ff55f7860a99da96$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($ff55f7860a99da96$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $ff55f7860a99da96$var$numberIsNaN(val1) && $ff55f7860a99da96$var$numberIsNaN(val2);
        if ($ff55f7860a99da96$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $ff55f7860a99da96$var$_typeof(val1) !== 'object') {
            if (val2 === null || $ff55f7860a99da96$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $ff55f7860a99da96$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $ff55f7860a99da96$var$objectToString(val1);
    var val2Tag = $ff55f7860a99da96$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val1, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        var keys2 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val2, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$ff55f7860a99da96$var$isMap(val1) && $ff55f7860a99da96$var$isMap(val2) || !$ff55f7860a99da96$var$isSet(val1) && $ff55f7860a99da96$var$isSet(val2)) return false;
    }
    if ($ff55f7860a99da96$var$isDate(val1)) {
        if (!$ff55f7860a99da96$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($ff55f7860a99da96$var$isRegExp(val1)) {
        if (!$ff55f7860a99da96$var$isRegExp(val2) || !$ff55f7860a99da96$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($ff55f7860a99da96$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($ff55f7860a99da96$var$isArrayBufferView(val1)) {
        if (!strict && ($ff55f7860a99da96$var$isFloat32Array(val1) || $ff55f7860a99da96$var$isFloat64Array(val1))) {
            if (!$ff55f7860a99da96$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$ff55f7860a99da96$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $ff55f7860a99da96$var$getOwnNonIndexProperties(val1, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        var _keys2 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val2, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kNoIterator, _keys);
    } else if ($ff55f7860a99da96$var$isSet(val1)) {
        if (!$ff55f7860a99da96$var$isSet(val2) || val1.size !== val2.size) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsSet);
    } else if ($ff55f7860a99da96$var$isMap(val1)) {
        if (!$ff55f7860a99da96$var$isMap(val2) || val1.size !== val2.size) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsMap);
    } else if ($ff55f7860a99da96$var$isAnyArrayBuffer(val1)) {
        if (!$ff55f7860a99da96$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($ff55f7860a99da96$var$isBoxedPrimitive(val1) && !$ff55f7860a99da96$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kNoIterator);
}
function $ff55f7860a99da96$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $ff55f7860a99da96$var$propertyIsEnumerable(val, k);
    });
}
function $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$ff55f7860a99da96$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($ff55f7860a99da96$var$propertyIsEnumerable(val1, key)) {
                    if (!$ff55f7860a99da96$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($ff55f7860a99da96$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $ff55f7860a99da96$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $ff55f7860a99da96$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $ff55f7860a99da96$var$kNoIterator || iterationType === $ff55f7860a99da96$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $ff55f7860a99da96$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $ff55f7860a99da96$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $ff55f7860a99da96$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($ff55f7860a99da96$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim) {
    switch($ff55f7860a99da96$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($ff55f7860a99da96$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $ff55f7860a99da96$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$ff55f7860a99da96$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $ff55f7860a99da96$var$innerDeepEqual(item, curB, false, memo);
}
function $ff55f7860a99da96$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $ff55f7860a99da96$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($ff55f7860a99da96$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$ff55f7860a99da96$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $ff55f7860a99da96$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($ff55f7860a99da96$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$ff55f7860a99da96$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$ff55f7860a99da96$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $ff55f7860a99da96$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $ff55f7860a99da96$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($ff55f7860a99da96$var$innerDeepEqual(key1, key2, strict, memo) && $ff55f7860a99da96$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $ff55f7860a99da96$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $ff55f7860a99da96$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $ff55f7860a99da96$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($ff55f7860a99da96$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$ff55f7860a99da96$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$ff55f7860a99da96$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $ff55f7860a99da96$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $ff55f7860a99da96$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($ff55f7860a99da96$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$ff55f7860a99da96$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$ff55f7860a99da96$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$ff55f7860a99da96$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $ff55f7860a99da96$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $ff55f7860a99da96$var$kIsSet) {
        if (!$ff55f7860a99da96$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $ff55f7860a99da96$var$kIsMap) {
        if (!$ff55f7860a99da96$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $ff55f7860a99da96$var$kIsArray) for(; i < a.length; i++){
        if ($ff55f7860a99da96$var$hasOwnProperty(a, i)) {
            if (!$ff55f7860a99da96$var$hasOwnProperty(b, i) || !$ff55f7860a99da96$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($ff55f7860a99da96$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$ff55f7860a99da96$var$hasOwnProperty(b, key) || !$ff55f7860a99da96$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$ff55f7860a99da96$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$isDeepEqual(val1, val2) {
    return $ff55f7860a99da96$var$innerDeepEqual(val1, val2, $ff55f7860a99da96$var$kLoose);
}
function $ff55f7860a99da96$var$isDeepStrictEqual(val1, val2) {
    return $ff55f7860a99da96$var$innerDeepEqual(val1, val2, $ff55f7860a99da96$var$kStrict);
}
module.exports = {
    isDeepEqual: $ff55f7860a99da96$var$isDeepEqual,
    isDeepStrictEqual: $ff55f7860a99da96$var$isDeepStrictEqual
};

});
parcelRegister("fLjZy", function(module, exports) {
'use strict';

var $6zl1T = parcelRequire("6zl1T");

var $hSIPK = parcelRequire("hSIPK");

var $4ehKb = parcelRequire("4ehKb");

var $eh0Ub = parcelRequire("eh0Ub");

var $c4AUD = parcelRequire("c4AUD");
var $b79ac0c428ccfd21$var$polyfill = $6zl1T($eh0Ub(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $hSIPK($b79ac0c428ccfd21$var$polyfill, {
    getPolyfill: $eh0Ub,
    implementation: $4ehKb,
    shim: $c4AUD
});
module.exports = $b79ac0c428ccfd21$var$polyfill;

});
parcelRegister("4ehKb", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("eh0Ub", function(module, exports) {
'use strict';

var $4ehKb = parcelRequire("4ehKb");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $4ehKb;
};

});

parcelRegister("c4AUD", function(module, exports) {
'use strict';

var $hSIPK = parcelRequire("hSIPK");

var $eh0Ub = parcelRequire("eh0Ub");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $eh0Ub();
    $hSIPK(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("esDFm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $a872730e1966eaf0$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $a872730e1966eaf0$var$NotNull;
function $a872730e1966eaf0$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $a872730e1966eaf0$var$Nullable;
function $a872730e1966eaf0$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $a872730e1966eaf0$var$Override;
function $a872730e1966eaf0$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $a872730e1966eaf0$var$SuppressWarnings;

});

parcelRegister("d4sFB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $9841e360291f6c03$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($9841e360291f6c03$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("jY97w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e89ab20be58c2533$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $cNbax = parcelRequire("cNbax");

var $6iuj6 = parcelRequire("6iuj6");

var $esDFm = parcelRequire("esDFm");

var $5EAbA = parcelRequire("5EAbA");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $e89ab20be58c2533$var$BailErrorStrategy extends $cNbax.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $5EAbA.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $6iuj6.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $5EAbA.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "recover", null);
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "recoverInline", null);
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $e89ab20be58c2533$var$BailErrorStrategy;

});
parcelRegister("cNbax", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9502b98abfaa9eda$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9502b98abfaa9eda$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $d7mTm = parcelRequire("d7mTm");

var $6iuj6 = parcelRequire("6iuj6");

var $6og9T = parcelRequire("6og9T");

var $4qcTm = parcelRequire("4qcTm");

var $haz8F = parcelRequire("haz8F");

var $2G93d = parcelRequire("2G93d");

var $esDFm = parcelRequire("esDFm");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $9502b98abfaa9eda$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $17Oz4.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $4qcTm.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $6iuj6.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $d7mTm.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $6og9T.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $17Oz4.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($2G93d.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $9TBHo.ATNStateType.BLOCK_START:
            case $9TBHo.ATNStateType.STAR_BLOCK_START:
            case $9TBHo.ATNStateType.PLUS_BLOCK_START:
            case $9TBHo.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $6iuj6.InputMismatchException(recognizer);
            case $9TBHo.ATNStateType.PLUS_LOOP_BACK:
            case $9TBHo.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $2G93d.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $6iuj6.InputMismatchException(recognizer);
        else throw new $6iuj6.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $haz8F.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $2G93d.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $2G93d.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $2G93d.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $2G93d.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $6og9T.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($2G93d.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $2G93d.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reset", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportError", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "recover", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "sync", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $9502b98abfaa9eda$var$DefaultErrorStrategy;

});
parcelRegister("17Oz4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0d1dab0077cad626$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $esDFm = parcelRequire("esDFm");
const $0d1dab0077cad626$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $0d1dab0077cad626$var$ATNState {
    constructor(){
        this.stateNumber = $0d1dab0077cad626$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $0d1dab0077cad626$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "hashCode", null);
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "equals", null);
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $0d1dab0077cad626$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($0d1dab0077cad626$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("9TBHo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $73467e5304f76889$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($73467e5304f76889$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("d7mTm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $98cdafa8e98c4b36$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $98cdafa8e98c4b36$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");

var $dlxNc = parcelRequire("dlxNc");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $98cdafa8e98c4b36$var$FailedPredicateException = class FailedPredicateException extends $lWPhg.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $dlxNc.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$98cdafa8e98c4b36$var$__decorate([
    $esDFm.NotNull
], $98cdafa8e98c4b36$var$FailedPredicateException, "formatMessage", null);
$98cdafa8e98c4b36$var$FailedPredicateException = $98cdafa8e98c4b36$var$__decorate([
    $98cdafa8e98c4b36$var$__param(0, $esDFm.NotNull)
], $98cdafa8e98c4b36$var$FailedPredicateException);
module.exports.FailedPredicateException = $98cdafa8e98c4b36$var$FailedPredicateException;

});
parcelRegister("lWPhg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $ffa6ca695057706e$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $ffa6ca695057706e$var$RecognitionException;

});

parcelRegister("dlxNc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9b77730a2147488d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9b77730a2147488d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $esDFm = parcelRequire("esDFm");

var $8DW9a = parcelRequire("8DW9a");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $9b77730a2147488d$var$PredicateTransition = class PredicateTransition extends $5sT1a.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $8DW9a.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "serializationType", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "isEpsilon", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "matches", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $9b77730a2147488d$var$PredicateTransition.prototype, "toString", null);
$9b77730a2147488d$var$PredicateTransition = $9b77730a2147488d$var$__decorate([
    $9b77730a2147488d$var$__param(0, $esDFm.NotNull)
], $9b77730a2147488d$var$PredicateTransition);
module.exports.PredicateTransition = $9b77730a2147488d$var$PredicateTransition;

});
parcelRegister("5sT1a", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $i2NOt = parcelRequire("i2NOt");
/**
 *
 * @author Sam Harwell
 */ class $3faa3ead218da507$var$AbstractPredicateTransition extends $i2NOt.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $3faa3ead218da507$var$AbstractPredicateTransition;

});
parcelRegister("i2NOt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d22f0dc3629a2b33$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d22f0dc3629a2b33$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $esDFm = parcelRequire("esDFm");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $d22f0dc3629a2b33$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$d22f0dc3629a2b33$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$d22f0dc3629a2b33$var$__decorate([
    $esDFm.NotNull
], $d22f0dc3629a2b33$var$Transition.prototype, "target", void 0);
$d22f0dc3629a2b33$var$Transition = $d22f0dc3629a2b33$var$__decorate([
    $d22f0dc3629a2b33$var$__param(0, $esDFm.NotNull)
], $d22f0dc3629a2b33$var$Transition);
module.exports.Transition = $d22f0dc3629a2b33$var$Transition;

});


parcelRegister("8DW9a", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $64af120133c02755$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $64af120133c02755$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $fJumX = parcelRequire("fJumX");

var $crbOk = parcelRequire("crbOk");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $g4Hat = parcelRequire("g4Hat");
function $64af120133c02755$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $64af120133c02755$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $64af120133c02755$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($64af120133c02755$var$SemanticContext._NONE === undefined) $64af120133c02755$var$SemanticContext._NONE = new $64af120133c02755$var$SemanticContext.Predicate();
        return $64af120133c02755$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $64af120133c02755$var$SemanticContext.NONE) return b;
        if (b === $64af120133c02755$var$SemanticContext.NONE) return a;
        let result = new $64af120133c02755$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $64af120133c02755$var$SemanticContext.NONE || b === $64af120133c02755$var$SemanticContext.NONE) return $64af120133c02755$var$SemanticContext.NONE;
        let result = new $64af120133c02755$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $64af120133c02755$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $i99P2.MurmurHash.initialize();
            hashCode = $i99P2.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $i99P2.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $i99P2.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $i99P2.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $64af120133c02755$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $i99P2.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $g4Hat.join(this.opnds, "&&");
        }
    };
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "operands", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "toString", null);
    AND = $64af120133c02755$var$__decorate([
        $64af120133c02755$var$__param(0, $esDFm.NotNull),
        $64af120133c02755$var$__param(1, $esDFm.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $64af120133c02755$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $i99P2.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $g4Hat.join(this.opnds, "||");
        }
    };
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "operands", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "toString", null);
    OR = $64af120133c02755$var$__decorate([
        $64af120133c02755$var$__param(0, $esDFm.NotNull),
        $64af120133c02755$var$__param(1, $esDFm.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($64af120133c02755$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("fJumX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b7429dac6dd82255$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b7429dac6dd82255$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $ikPYR = parcelRequire("ikPYR");

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $b7429dac6dd82255$var$INITAL_CAPACITY = 16; // must be power of 2
const $b7429dac6dd82255$var$LOAD_FACTOR = 0.75;
class $b7429dac6dd82255$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $b7429dac6dd82255$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($b7429dac6dd82255$var$INITAL_CAPACITY * $b7429dac6dd82255$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $b7429dac6dd82255$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $ikPYR.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $i99P2.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $i99P2.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $b7429dac6dd82255$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $b7429dac6dd82255$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $gwEr2(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $b7429dac6dd82255$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($b7429dac6dd82255$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($b7429dac6dd82255$var$INITAL_CAPACITY * $b7429dac6dd82255$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$b7429dac6dd82255$var$__decorate([
    $esDFm.NotNull
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "comparator", void 0);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "hashCode", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "equals", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "add", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "size", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "isEmpty", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "contains", null);
$b7429dac6dd82255$var$__decorate([
    $b7429dac6dd82255$var$__param(0, $esDFm.Nullable)
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "containsFast", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, Symbol.iterator, null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "toArray", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "containsAll", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "addAll", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "clear", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "toString", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.SuppressWarnings("unchecked")
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "asElementType", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.SuppressWarnings("unchecked")
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $b7429dac6dd82255$var$Array2DHashSet;

});
parcelRegister("ikPYR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d5926a811e8c9536$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");

var $73sQO = parcelRequire("73sQO");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $d5926a811e8c9536$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $i99P2.MurmurHash.hashCode([
            obj
        ]);
        else return $73sQO.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $73sQO.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$d5926a811e8c9536$var$DefaultEqualityComparator.INSTANCE = new $d5926a811e8c9536$var$DefaultEqualityComparator();
$d5926a811e8c9536$var$__decorate([
    $esDFm.Override
], $d5926a811e8c9536$var$DefaultEqualityComparator.prototype, "hashCode", null);
$d5926a811e8c9536$var$__decorate([
    $esDFm.Override
], $d5926a811e8c9536$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $d5926a811e8c9536$var$DefaultEqualityComparator;

});
parcelRegister("i99P2", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $d360afbc1084b137$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($d360afbc1084b137$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("73sQO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $522f31675a8ff093$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $522f31675a8ff093$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$522f31675a8ff093$var$ObjectEqualityComparator.INSTANCE = new $522f31675a8ff093$var$ObjectEqualityComparator();
$522f31675a8ff093$var$__decorate([
    $esDFm.Override
], $522f31675a8ff093$var$ObjectEqualityComparator.prototype, "hashCode", null);
$522f31675a8ff093$var$__decorate([
    $esDFm.Override
], $522f31675a8ff093$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $522f31675a8ff093$var$ObjectEqualityComparator;

});



parcelRegister("crbOk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $90e12b08060db581$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");

var $73sQO = parcelRequire("73sQO");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $90e12b08060db581$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $i99P2.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$73sQO.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$90e12b08060db581$var$ArrayEqualityComparator.INSTANCE = new $90e12b08060db581$var$ArrayEqualityComparator();
$90e12b08060db581$var$__decorate([
    $esDFm.Override
], $90e12b08060db581$var$ArrayEqualityComparator.prototype, "hashCode", null);
$90e12b08060db581$var$__decorate([
    $esDFm.Override
], $90e12b08060db581$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $90e12b08060db581$var$ArrayEqualityComparator;

});

parcelRegister("g4Hat", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $bb3e8152647e0789$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $bb3e8152647e0789$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $bb3e8152647e0789$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $bb3e8152647e0789$var$join;
function $bb3e8152647e0789$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $bb3e8152647e0789$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $bb3e8152647e0789$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $bb3e8152647e0789$var$toMap;
function $bb3e8152647e0789$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $bb3e8152647e0789$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("6iuj6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $495beedc9f8e5b02$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $495beedc9f8e5b02$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $495beedc9f8e5b02$var$InputMismatchException = class InputMismatchException extends $lWPhg.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$495beedc9f8e5b02$var$InputMismatchException = $495beedc9f8e5b02$var$__decorate([
    $495beedc9f8e5b02$var$__param(0, $esDFm.NotNull)
], $495beedc9f8e5b02$var$InputMismatchException);
module.exports.InputMismatchException = $495beedc9f8e5b02$var$InputMismatchException;

});

parcelRegister("6og9T", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4a7184b7a0008122$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4a7184b7a0008122$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $crbOk = parcelRequire("crbOk");

var $eOyS9 = parcelRequire("eOyS9");

var $4Q2DM = parcelRequire("4Q2DM");

var $gTQRB = parcelRequire("gTQRB");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $4a7184b7a0008122$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET = $4a7184b7a0008122$var$IntervalSet.of($gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE);
            $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($4a7184b7a0008122$var$IntervalSet._EMPTY_SET == null) {
            $4a7184b7a0008122$var$IntervalSet._EMPTY_SET = new $4a7184b7a0008122$var$IntervalSet();
            $4a7184b7a0008122$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $4a7184b7a0008122$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $4a7184b7a0008122$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($4Q2DM.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $4a7184b7a0008122$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $4a7184b7a0008122$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($4a7184b7a0008122$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $4a7184b7a0008122$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $4a7184b7a0008122$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $4a7184b7a0008122$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $4a7184b7a0008122$var$IntervalSet(this._intervals);
        if (a instanceof $4a7184b7a0008122$var$IntervalSet) return $4a7184b7a0008122$var$IntervalSet.subtract(this, a);
        let other = new $4a7184b7a0008122$var$IntervalSet();
        other.addAll(a);
        return $4a7184b7a0008122$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $4a7184b7a0008122$var$IntervalSet();
        let result = new $4a7184b7a0008122$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $4Q2DM.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $4Q2DM.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $4a7184b7a0008122$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $4a7184b7a0008122$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $4a7184b7a0008122$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $i99P2.MurmurHash.update(hash, I.a);
            hash = $i99P2.MurmurHash.update(hash, I.b);
        }
        hash = $i99P2.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $4a7184b7a0008122$var$IntervalSet)) return false;
        return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $2G93d.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $2G93d.Token.EOF) return "<EOF>";
        else if (a === $2G93d.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $eOyS9.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $4Q2DM.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $4Q2DM.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $4Q2DM.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "addAll", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "complement", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "subtract", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "or", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "and", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "contains", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "isNil", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "hashCode", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "equals", null);
$4a7184b7a0008122$var$__decorate([
    $4a7184b7a0008122$var$__param(0, $esDFm.NotNull)
], $4a7184b7a0008122$var$IntervalSet.prototype, "toStringVocabulary", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull,
    $4a7184b7a0008122$var$__param(0, $esDFm.NotNull)
], $4a7184b7a0008122$var$IntervalSet.prototype, "elementName", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "size", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "remove", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull
], $4a7184b7a0008122$var$IntervalSet, "of", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull
], $4a7184b7a0008122$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $4a7184b7a0008122$var$IntervalSet;

});
parcelRegister("eOyS9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ac90c92821ee5cb0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $yEtb9 = parcelRequire("yEtb9");

var $esDFm = parcelRequire("esDFm");
const $ac90c92821ee5cb0$var$EMPTY_DATA = new Int32Array(0);
const $ac90c92821ee5cb0$var$INITIAL_SIZE = 4;
const $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $ac90c92821ee5cb0$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $ac90c92821ee5cb0$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $ac90c92821ee5cb0$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $ac90c92821ee5cb0$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $yEtb9.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $ac90c92821ee5cb0$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE) newLength = $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.NotNull
], $ac90c92821ee5cb0$var$IntegerList.prototype, "_data", void 0);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "equals", null);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "hashCode", null);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $ac90c92821ee5cb0$var$IntegerList;

});
parcelRegister("yEtb9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $06829183f5129d07$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($06829183f5129d07$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("4Q2DM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $385e111c1c7cf931$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $esDFm = parcelRequire("esDFm");
const $385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $385e111c1c7cf931$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $385e111c1c7cf931$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE) return new $385e111c1c7cf931$var$Interval(a, b);
        if ($385e111c1c7cf931$var$Interval.cache[a] == null) $385e111c1c7cf931$var$Interval.cache[a] = new $385e111c1c7cf931$var$Interval(a, a);
        return $385e111c1c7cf931$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $385e111c1c7cf931$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $385e111c1c7cf931$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $385e111c1c7cf931$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $385e111c1c7cf931$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $385e111c1c7cf931$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$385e111c1c7cf931$var$Interval._INVALID = new $385e111c1c7cf931$var$Interval(-1, -2);
$385e111c1c7cf931$var$Interval.cache = new Array($385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE + 1);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "equals", null);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "hashCode", null);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "toString", null);
module.exports.Interval = $385e111c1c7cf931$var$Interval;

});

parcelRegister("gTQRB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c4daca03ecd98d11$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $arOt9 = parcelRequire("arOt9");

var $9AKkH = parcelRequire("9AKkH");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $kkkg9 = parcelRequire("kkkg9");

var $6Npyx = parcelRequire("6Npyx");

var $esDFm = parcelRequire("esDFm");

var $24a4y = parcelRequire("24a4y");

var $2G93d = parcelRequire("2G93d");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $c4daca03ecd98d11$var$Lexer extends $24a4y.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $arOt9.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $9AKkH.IntegerStack();
        this._mode = $c4daca03ecd98d11$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $2G93d.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $2G93d.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $2G93d.Token.INVALID_TYPE;
        this._channel = $2G93d.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $c4daca03ecd98d11$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $2G93d.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $2G93d.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $6Npyx.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $c4daca03ecd98d11$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $d4sFB.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $2G93d.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $c4daca03ecd98d11$var$Lexer.SKIP) continue outer;
                }while (this._type === $c4daca03ecd98d11$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $c4daca03ecd98d11$var$Lexer.SKIP;
    }
    more() {
        this._type = $c4daca03ecd98d11$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($kkkg9.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($kkkg9.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $2G93d.Token.EOF, undefined, $2G93d.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $2G93d.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($4Q2DM.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $2G93d.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $6Npyx.LexerNoViableAltException) {
            if (this._input.LA(1) !== $d4sFB.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$c4daca03ecd98d11$var$Lexer.DEFAULT_MODE = 0;
$c4daca03ecd98d11$var$Lexer.MORE = -2;
$c4daca03ecd98d11$var$Lexer.SKIP = -3;
$c4daca03ecd98d11$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$c4daca03ecd98d11$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "nextToken", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "tokenFactory", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "inputStream", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "sourceName", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "line", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $c4daca03ecd98d11$var$Lexer;

});
parcelRegister("arOt9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $79b3931d4343143e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $8Mk1Z = parcelRequire("8Mk1Z");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $79b3931d4343143e$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $8Mk1Z.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($4Q2DM.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $8Mk1Z.CommonToken(type, text);
    }
}
$79b3931d4343143e$var$__decorate([
    $esDFm.Override
], $79b3931d4343143e$var$CommonTokenFactory.prototype, "create", null);
$79b3931d4343143e$var$__decorate([
    $esDFm.Override
], $79b3931d4343143e$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $79b3931d4343143e$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($79b3931d4343143e$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("8Mk1Z", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6642582fa895ffd2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6642582fa895ffd2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
let $6642582fa895ffd2$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2G93d.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $2G93d.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($4Q2DM.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $6642582fa895ffd2$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$6642582fa895ffd2$var$__decorate([
    $esDFm.NotNull
], $6642582fa895ffd2$var$CommonToken.prototype, "source", void 0);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "type", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "line", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "text", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "charPositionInLine", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "channel", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "startIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "stopIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "tokenIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "tokenSource", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "inputStream", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "toString", null);
$6642582fa895ffd2$var$__decorate([
    $6642582fa895ffd2$var$__param(0, $esDFm.NotNull)
], $6642582fa895ffd2$var$CommonToken, "fromToken", null);
$6642582fa895ffd2$var$CommonToken = $6642582fa895ffd2$var$__decorate([
    $6642582fa895ffd2$var$__param(2, $esDFm.NotNull)
], $6642582fa895ffd2$var$CommonToken);
module.exports.CommonToken = $6642582fa895ffd2$var$CommonToken;

});
parcelRegister("2G93d", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $d4sFB = parcelRequire("d4sFB");
var $1f3686587010d661$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $d4sFB.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($1f3686587010d661$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("9AKkH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $eOyS9 = parcelRequire("eOyS9");
/**
 *
 * @author Sam Harwell
 */ class $6fbb6a9751bc0f5e$var$IntegerStack extends $eOyS9.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $6fbb6a9751bc0f5e$var$IntegerStack;

});

parcelRegister("kkkg9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ecc564042155c9fa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ecc564042155c9fa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $dg39p = parcelRequire("dg39p");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $6co2U = parcelRequire("6co2U");

var $lbAqv = parcelRequire("lbAqv");

var $5jw7S = parcelRequire("5jw7S");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $gTQRB = parcelRequire("gTQRB");

var $khqMx = parcelRequire("khqMx");

var $6Npyx = parcelRequire("6Npyx");

var $esDFm = parcelRequire("esDFm");

var $jjTpW = parcelRequire("jjTpW");

var $haz8F = parcelRequire("haz8F");

var $U6v4o = parcelRequire("U6v4o");

var $2G93d = parcelRequire("2G93d");

var $gwEr2 = parcelRequire("gwEr2");
/** "dup" of ParserInterpreter */ let $ecc564042155c9fa$var$LexerATNSimulator = class LexerATNSimulator extends $lbAqv.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $gTQRB.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $gTQRB.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $lbAqv.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $d4sFB.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $d4sFB.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $jjTpW.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $lbAqv.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $lbAqv.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $d4sFB.IntStream.EOF && input.index === this.startIndex) return $2G93d.Token.EOF;
            throw new $6Npyx.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $gwEr2(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $d4sFB.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $haz8F.PredictionContext.EMPTY_FULL;
        let configs = new $jjTpW.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $9qlOq.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $U6v4o.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $haz8F.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $khqMx.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($d4sFB.IntStream.EOF, $gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $6co2U.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $gwEr2(!configs.hasSemanticContext);
        let proposed = new $5jw7S.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $5jw7S.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $U6v4o.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $dg39p.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($4Q2DM.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "copyState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "match", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.Override
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "reset", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "matchATN", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "execATN", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "computeTargetState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "accept", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "computeStartState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "closure", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(3, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "captureSimState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "addDFAState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getDFA", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getText", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "consume", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getTokenName", null);
$ecc564042155c9fa$var$LexerATNSimulator = $ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $ecc564042155c9fa$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($ecc564042155c9fa$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $ecc564042155c9fa$var$LexerATNSimulator;

});
parcelRegister("dg39p", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $9a6f36ab46ef5323$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $9a6f36ab46ef5323$var$AcceptStateInfo;

});

parcelRegister("lDQMG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fc162f50821f0f08$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fc162f50821f0f08$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $dkveu = parcelRequire("dkveu");

var $dLpRd = parcelRequire("dLpRd");

var $6og9T = parcelRequire("6og9T");

var $2xNwj = parcelRequire("2xNwj");

var $en89P = parcelRequire("en89P");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $2G93d = parcelRequire("2G93d");

var $gwEr2 = parcelRequire("gwEr2");
/** */ let $fc162f50821f0f08$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $dLpRd.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $dLpRd.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $haz8F.PredictionContext.getCachedContext(context, this.contextCache, new $haz8F.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $gwEr2(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $en89P.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $haz8F.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $2xNwj.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $dLpRd.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $dLpRd.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($2G93d.Token.EPSILON)) return following;
        let expected = new $6og9T.IntervalSet();
        expected.addAll(following);
        expected.remove($2G93d.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2G93d.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($2G93d.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($2G93d.Token.EPSILON)) expected.add($2G93d.Token.EOF);
        return expected;
    }
};
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "states", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "decisionToState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeNameToStartState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeToStartState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "decisionToDFA", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeToDFA", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "nextTokens", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "removeState", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull),
    $fc162f50821f0f08$var$__param(1, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "defineMode", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "defineDecisionState", null);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "getExpectedTokens", null);
$fc162f50821f0f08$var$ATN = $fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN);
module.exports.ATN = $fc162f50821f0f08$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($fc162f50821f0f08$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $fc162f50821f0f08$var$ATN;

});
parcelRegister("dkveu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $fJumX = parcelRequire("fJumX");
class $9b455ecf1c961528$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $9b455ecf1c961528$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $9b455ecf1c961528$var$Array2DHashMap) this.backingStore = new $fJumX.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $fJumX.Array2DHashSet(new $9b455ecf1c961528$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $9b455ecf1c961528$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $9b455ecf1c961528$var$Array2DHashMap;

});

parcelRegister("dLpRd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a053b8dbd76d12f6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a053b8dbd76d12f6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $fJumX = parcelRequire("fJumX");

var $6co2U = parcelRequire("6co2U");

var $cXSly = parcelRequire("cXSly");

var $5jw7S = parcelRequire("5jw7S");

var $hZ9cR = parcelRequire("hZ9cR");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $izkyd = parcelRequire("izkyd");

var $5t4I3 = parcelRequire("5t4I3");
let $a053b8dbd76d12f6$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $izkyd.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
                this.s0full = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $cXSly.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $cXSly.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $hZ9cR.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "states", void 0);
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "atnStartState", void 0);
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "atn", void 0);
$a053b8dbd76d12f6$var$DFA = $a053b8dbd76d12f6$var$__decorate([
    $a053b8dbd76d12f6$var$__param(0, $esDFm.NotNull)
], $a053b8dbd76d12f6$var$DFA);
module.exports.DFA = $a053b8dbd76d12f6$var$DFA;

});
parcelRegister("6co2U", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $48368415f2c032d4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $dkveu = parcelRequire("dkveu");

var $fJumX = parcelRequire("fJumX");

var $crbOk = parcelRequire("crbOk");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $lVdCV = parcelRequire("lVdCV");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $8Uwhy = parcelRequire("8Uwhy");

var $8DW9a = parcelRequire("8DW9a");

var $gwEr2 = parcelRequire("gwEr2");

var $g4Hat = parcelRequire("g4Hat");
class $48368415f2c032d4$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$48368415f2c032d4$var$KeyTypeEqualityComparer.INSTANCE = new $48368415f2c032d4$var$KeyTypeEqualityComparer();
function $48368415f2c032d4$var$NewKeyedConfigMap(map) {
    if (map) return new $dkveu.Array2DHashMap(map);
    else return new $dkveu.Array2DHashMap($48368415f2c032d4$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $48368415f2c032d4$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $lVdCV.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $gwEr2(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $48368415f2c032d4$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $9qlOq.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $gwEr2(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $8Uwhy.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $haz8F.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $haz8F.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $gwEr2(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$8DW9a.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $gwEr2(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $9qlOq.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $48368415f2c032d4$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $g4Hat.equals(this._conflictInfo, obj._conflictInfo) && $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $crbOk.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$48368415f2c032d4$var$__decorate([
    $esDFm.NotNull
], $48368415f2c032d4$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "size", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "isEmpty", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "contains", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, Symbol.iterator, null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "toArray", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "containsAll", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "clear", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "equals", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $48368415f2c032d4$var$ATNConfigSet;

});
parcelRegister("9qlOq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6dc7763ca4711224$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6dc7763ca4711224$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $dkveu = parcelRequire("dkveu");

var $axZym = parcelRequire("axZym");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $8DW9a = parcelRequire("8DW9a");

var $gwEr2 = parcelRequire("gwEr2");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $6dc7763ca4711224$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $gwEr2((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $8DW9a.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $8DW9a.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $6dc7763ca4711224$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $6dc7763ca4711224$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $6dc7763ca4711224$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $gwEr2(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $8DW9a.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $haz8F.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $8DW9a.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $8DW9a.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $6dc7763ca4711224$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $6dc7763ca4711224$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $6dc7763ca4711224$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $axZym.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $73sQO.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $i99P2.MurmurHash.initialize(7);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.alt);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.context);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $i99P2.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $dkveu.Array2DHashMap($haz8F.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $8DW9a.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "_state", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "_context", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "state", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull,
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig.prototype, "context", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "semanticContext", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "clone", null);
$6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig.prototype, "transformImpl", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "equals", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "hashCode", null);
$6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(3, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig, "create", null);
$6dc7763ca4711224$var$ATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig);
module.exports.ATNConfig = $6dc7763ca4711224$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $6dc7763ca4711224$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$6dc7763ca4711224$var$SemanticContextATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$ActionATNConfig = class ActionATNConfig extends $6dc7763ca4711224$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $8DW9a.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$6dc7763ca4711224$var$ActionATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $6dc7763ca4711224$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$6dc7763ca4711224$var$ActionSemanticContextATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig);

});
parcelRegister("axZym", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $17Oz4 = parcelRequire("17Oz4");
class $7adcbba0a09e732a$var$DecisionState extends $17Oz4.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $7adcbba0a09e732a$var$DecisionState;

});

parcelRegister("haz8F", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c7fea0a7ff7ccaf2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c7fea0a7ff7ccaf2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $dkveu = parcelRequire("dkveu");

var $fJumX = parcelRequire("fJumX");

var $yEtb9 = parcelRequire("yEtb9");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $8Uwhy = parcelRequire("8Uwhy");

var $gwEr2 = parcelRequire("gwEr2");
const $c7fea0a7ff7ccaf2$var$INITIAL_HASH = 1;
class $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        hash = $i99P2.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        hash = $i99P2.MurmurHash.update(hash, parent);
        hash = $i99P2.MurmurHash.update(hash, returnState);
        hash = $i99P2.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        for (let parent of parents)hash = $i99P2.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $i99P2.MurmurHash.update(hash, returnState);
        hash = $i99P2.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL : $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $c7fea0a7ff7ccaf2$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL : $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $8Uwhy.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(context0) ? context0 : $c7fea0a7ff7ccaf2$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(context1) ? context1 : $c7fea0a7ff7ccaf2$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $gwEr2(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $c7fea0a7ff7ccaf2$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$PredictionContext.prototype, "hashCode", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(1, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(2, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$PredictionContext, "join", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(1, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(2, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $c7fea0a7ff7ccaf2$var$PredictionContext;
class $c7fea0a7ff7ccaf2$var$EmptyPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(fullContext){
        super($c7fea0a7ff7ccaf2$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "toStrings", null);
let $c7fea0a7ff7ccaf2$var$ArrayPredictionContext = class ArrayPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $c7fea0a7ff7ccaf2$var$PredictionContext.calculateHashCode(parents, returnStates));
        $gwEr2(parents.length === returnStates.length);
        $gwEr2(returnStates.length > 1 || returnStates[0] !== $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $yEtb9.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $c7fea0a7ff7ccaf2$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $gwEr2(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $c7fea0a7ff7ccaf2$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $fJumX.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $8Uwhy.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "parents", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$ArrayPredictionContext = $c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext);
let $c7fea0a7ff7ccaf2$var$SingletonPredictionContext = class SingletonPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(parent, returnState){
        super($c7fea0a7ff7ccaf2$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "parent", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$SingletonPredictionContext = $c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $c7fea0a7ff7ccaf2$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $c7fea0a7ff7ccaf2$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $c7fea0a7ff7ccaf2$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $dkveu.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $c7fea0a7ff7ccaf2$var$__decorate([
        $esDFm.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $c7fea0a7ff7ccaf2$var$__decorate([
        $esDFm.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($c7fea0a7ff7ccaf2$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("8Uwhy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $67cc983af147926c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $dkveu = parcelRequire("dkveu");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $gwEr2 = parcelRequire("gwEr2");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $67cc983af147926c$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $67cc983af147926c$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $haz8F.PredictionContext.join(x, y, this);
        let operands = new $67cc983af147926c$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $haz8F.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $67cc983af147926c$var$PredictionContextCache;
$67cc983af147926c$var$PredictionContextCache.UNCACHED = new $67cc983af147926c$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $gwEr2(x != null);
            $gwEr2(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($67cc983af147926c$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("lVdCV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $7WF8Y = parcelRequire("7WF8Y");

var $i99P2 = parcelRequire("i99P2");
/**
 * Private empty array used to construct empty BitSets
 */ const $ff597dd62e8c3e1d$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $ff597dd62e8c3e1d$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $ff597dd62e8c3e1d$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $ff597dd62e8c3e1d$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $ff597dd62e8c3e1d$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $ff597dd62e8c3e1d$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $ff597dd62e8c3e1d$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $ff597dd62e8c3e1d$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $ff597dd62e8c3e1d$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $ff597dd62e8c3e1d$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($ff597dd62e8c3e1d$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $ff597dd62e8c3e1d$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($ff597dd62e8c3e1d$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $ff597dd62e8c3e1d$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        const lastWord = $ff597dd62e8c3e1d$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $ff597dd62e8c3e1d$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $ff597dd62e8c3e1d$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$ff597dd62e8c3e1d$var$getIndex(fromIndex)] & $ff597dd62e8c3e1d$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $ff597dd62e8c3e1d$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $ff597dd62e8c3e1d$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($ff597dd62e8c3e1d$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $ff597dd62e8c3e1d$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $ff597dd62e8c3e1d$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        let lastWord = $ff597dd62e8c3e1d$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $ff597dd62e8c3e1d$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $ff597dd62e8c3e1d$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $i99P2.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $ff597dd62e8c3e1d$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $ff597dd62e8c3e1d$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $ff597dd62e8c3e1d$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $ff597dd62e8c3e1d$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$7WF8Y.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $ff597dd62e8c3e1d$var$BitSet;
class $ff597dd62e8c3e1d$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $ff597dd62e8c3e1d$var$unIndex(this.index) + $ff597dd62e8c3e1d$var$findLSBSet(bits);
                this.mask = $ff597dd62e8c3e1d$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("cXSly", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $970526d2c9830e83$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $lbAqv = parcelRequire("lbAqv");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");

var $24a4y = parcelRequire("24a4y");

var $5t4I3 = parcelRequire("5t4I3");
/** A DFA walker that knows how to dump them to serialized strings. */ class $970526d2c9830e83$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $24a4y.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $lbAqv.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $lbAqv.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $haz8F.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $lbAqv.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$970526d2c9830e83$var$__decorate([
    $esDFm.NotNull
], $970526d2c9830e83$var$DFASerializer.prototype, "dfa", void 0);
$970526d2c9830e83$var$__decorate([
    $esDFm.NotNull
], $970526d2c9830e83$var$DFASerializer.prototype, "vocabulary", void 0);
$970526d2c9830e83$var$__decorate([
    $esDFm.Override
], $970526d2c9830e83$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $970526d2c9830e83$var$DFASerializer;

});
parcelRegister("lbAqv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f6c6e19f6a67273a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f6c6e19f6a67273a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $6co2U = parcelRequire("6co2U");

var $5jw7S = parcelRequire("5jw7S");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");
let $f6c6e19f6a67273a$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$f6c6e19f6a67273a$var$__decorate([
    $esDFm.NotNull
], $f6c6e19f6a67273a$var$ATNSimulator.prototype, "atn", void 0);
$f6c6e19f6a67273a$var$__decorate([
    $esDFm.NotNull
], $f6c6e19f6a67273a$var$ATNSimulator, "ERROR", null);
$f6c6e19f6a67273a$var$ATNSimulator = $f6c6e19f6a67273a$var$__decorate([
    $f6c6e19f6a67273a$var$__param(0, $esDFm.NotNull)
], $f6c6e19f6a67273a$var$ATNSimulator);
module.exports.ATNSimulator = $f6c6e19f6a67273a$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($f6c6e19f6a67273a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $f6c6e19f6a67273a$var$ATNSimulator;

});
parcelRegister("5jw7S", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3de7a5a6cf99484b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3de7a5a6cf99484b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $lVdCV = parcelRequire("lVdCV");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");

var $gwEr2 = parcelRequire("gwEr2");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $3de7a5a6cf99484b$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $gwEr2(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $gwEr2(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $lVdCV.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $lDQMG.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize(7);
        hash = $i99P2.MurmurHash.update(hash, this.configs.hashCode());
        hash = $i99P2.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $3de7a5a6cf99484b$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "configs", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "edges", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "contextEdges", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "hashCode", null);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "equals", null);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $3de7a5a6cf99484b$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $3de7a5a6cf99484b$var$__decorate([
        $esDFm.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $3de7a5a6cf99484b$var$__decorate([
        $esDFm.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $3de7a5a6cf99484b$var$__decorate([
        $3de7a5a6cf99484b$var$__param(0, $esDFm.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($3de7a5a6cf99484b$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("24a4y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1813c4a7a7427bce$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1813c4a7a7427bce$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $b6VR9 = parcelRequire("b6VR9");

var $adfkv = parcelRequire("adfkv");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");

var $g4Hat = parcelRequire("g4Hat");
class $1813c4a7a7427bce$var$Recognizer {
    constructor(){
        this._listeners = [
            $b6VR9.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $2G93d.Token.EOF);
            result = intermediateResult;
            $1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $g4Hat.toMap(ruleNames);
            $1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $2G93d.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $adfkv.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$1813c4a7a7427bce$var$Recognizer.EOF = -1;
$1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache = new WeakMap();
$1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache = new WeakMap();
$1813c4a7a7427bce$var$__decorate([
    $esDFm.SuppressWarnings("serial"),
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "_listeners", void 0);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getTokenTypeMap", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getRuleIndexMap", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "serializedATN", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "atn", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull,
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "interpreter", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull,
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "getErrorHeader", null);
$1813c4a7a7427bce$var$__decorate([
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "addErrorListener", null);
$1813c4a7a7427bce$var$__decorate([
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "removeErrorListener", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $1813c4a7a7427bce$var$Recognizer;

});
parcelRegister("b6VR9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $816d225174e7b521$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $816d225174e7b521$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $816d225174e7b521$var$ConsoleErrorListener.INSTANCE = new $816d225174e7b521$var$ConsoleErrorListener();

});

parcelRegister("adfkv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $76f7027510cb365c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $76f7027510cb365c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $76f7027510cb365c$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$76f7027510cb365c$var$__decorate([
    $esDFm.Override,
    $76f7027510cb365c$var$__param(0, $esDFm.NotNull),
    $76f7027510cb365c$var$__param(4, $esDFm.NotNull)
], $76f7027510cb365c$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $76f7027510cb365c$var$ProxyErrorListener;

});


parcelRegister("5t4I3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3fb35060e4517eb3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $3fb35060e4517eb3$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $2G93d.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $3fb35060e4517eb3$var$VocabularyImpl.EMPTY_VOCABULARY = new $3fb35060e4517eb3$var$VocabularyImpl([], [], []);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "literalNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "displayNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "maxTokenType", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getLiteralName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getSymbolicName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getDisplayName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $3fb35060e4517eb3$var$VocabularyImpl;

});


parcelRegister("hZ9cR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d17f465c3764290d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d17f465c3764290d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $cXSly = parcelRequire("cXSly");

var $esDFm = parcelRequire("esDFm");

var $5t4I3 = parcelRequire("5t4I3");
let $d17f465c3764290d$var$LexerDFASerializer = class LexerDFASerializer extends $cXSly.DFASerializer {
    constructor(dfa){
        super(dfa, $5t4I3.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$d17f465c3764290d$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $d17f465c3764290d$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$d17f465c3764290d$var$LexerDFASerializer = $d17f465c3764290d$var$__decorate([
    $d17f465c3764290d$var$__param(0, $esDFm.NotNull)
], $d17f465c3764290d$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $d17f465c3764290d$var$LexerDFASerializer;

});

parcelRegister("izkyd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d84b6fdbd708b59b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $lVdCV = parcelRequire("lVdCV");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
class $d84b6fdbd708b59b$var$StarLoopEntryState extends $axZym.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $lVdCV.BitSet();
    }
    get stateType() {
        return $9TBHo.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$d84b6fdbd708b59b$var$__decorate([
    $esDFm.Override
], $d84b6fdbd708b59b$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $d84b6fdbd708b59b$var$StarLoopEntryState;

});


parcelRegister("2xNwj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1da51385954c77a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $aTslC = parcelRequire("aTslC");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $1da51385954c77a9$var$InvalidState extends $aTslC.BasicState {
    get stateType() {
        return $9TBHo.ATNStateType.INVALID_TYPE;
    }
}
$1da51385954c77a9$var$__decorate([
    $esDFm.Override
], $1da51385954c77a9$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $1da51385954c77a9$var$InvalidState;

});
parcelRegister("aTslC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ee507addbdfb9ca$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $7ee507addbdfb9ca$var$BasicState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.BASIC;
    }
}
$7ee507addbdfb9ca$var$__decorate([
    $esDFm.Override
], $7ee507addbdfb9ca$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $7ee507addbdfb9ca$var$BasicState;

});


parcelRegister("en89P", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a7698a95bc07b861$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a7698a95bc07b861$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $fJumX = parcelRequire("fJumX");

var $9qlOq = parcelRequire("9qlOq");

var $lVdCV = parcelRequire("lVdCV");

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $2G93d = parcelRequire("2G93d");

var $4EBHJ = parcelRequire("4EBHJ");
let $a7698a95bc07b861$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $6og9T.IntervalSet();
            look[alt] = current;
            let lookBusy = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $haz8F.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $lVdCV.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $6og9T.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $fJumX.Array2DHashSet(), new $lVdCV.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $9qlOq.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($haz8F.PredictionContext.isEmptyLocal(ctx)) {
                look.add($2G93d.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($2G93d.Token.EOF);
                return;
            }
        }
        if (s instanceof $U6v4o.RuleStopState) {
            if (ctx.isEmpty && !$haz8F.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($2G93d.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $acKOx.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $5sT1a.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $4EBHJ.WildcardTransition) look.addAll($6og9T.IntervalSet.of($2G93d.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $grncH.NotSetTransition) set = set.complement($6og9T.IntervalSet.of($2G93d.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $a7698a95bc07b861$var$LL1Analyzer.HIT_PRED = $2G93d.Token.INVALID_TYPE;
$a7698a95bc07b861$var$__decorate([
    $esDFm.NotNull
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "atn", void 0);
$a7698a95bc07b861$var$__decorate([
    $esDFm.NotNull,
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(1, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "LOOK", null);
$a7698a95bc07b861$var$__decorate([
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(2, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(3, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(4, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(5, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "_LOOK", null);
$a7698a95bc07b861$var$LL1Analyzer = $a7698a95bc07b861$var$__decorate([
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer);
module.exports.LL1Analyzer = $a7698a95bc07b861$var$LL1Analyzer;

});
parcelRegister("grncH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bf812ac15f890a0f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bf812ac15f890a0f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $4mzjd = parcelRequire("4mzjd");
let $bf812ac15f890a0f$var$NotSetTransition = class NotSetTransition extends $4mzjd.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "serializationType", null);
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "matches", null);
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "toString", null);
$bf812ac15f890a0f$var$NotSetTransition = $bf812ac15f890a0f$var$__decorate([
    $bf812ac15f890a0f$var$__param(0, $esDFm.NotNull),
    $bf812ac15f890a0f$var$__param(1, $esDFm.Nullable)
], $bf812ac15f890a0f$var$NotSetTransition);
module.exports.NotSetTransition = $bf812ac15f890a0f$var$NotSetTransition;

});
parcelRegister("4mzjd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $32d49b192b3581d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $32d49b192b3581d1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");

var $i2NOt = parcelRequire("i2NOt");
/** A transition containing a set of values. */ let $32d49b192b3581d1$var$SetTransition = class SetTransition extends $i2NOt.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $6og9T.IntervalSet.of($2G93d.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$32d49b192b3581d1$var$__decorate([
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "set", void 0);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override
], $32d49b192b3581d1$var$SetTransition.prototype, "serializationType", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "label", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override
], $32d49b192b3581d1$var$SetTransition.prototype, "matches", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "toString", null);
$32d49b192b3581d1$var$SetTransition = $32d49b192b3581d1$var$__decorate([
    $32d49b192b3581d1$var$__param(0, $esDFm.NotNull),
    $32d49b192b3581d1$var$__param(1, $esDFm.Nullable)
], $32d49b192b3581d1$var$SetTransition);
module.exports.SetTransition = $32d49b192b3581d1$var$SetTransition;

});


parcelRegister("U6v4o", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a8a45ddfa7016cf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $0a8a45ddfa7016cf$var$RuleStopState extends $17Oz4.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $9TBHo.ATNStateType.RULE_STOP;
    }
}
$0a8a45ddfa7016cf$var$__decorate([
    $esDFm.Override
], $0a8a45ddfa7016cf$var$RuleStopState.prototype, "nonStopStateNumber", null);
$0a8a45ddfa7016cf$var$__decorate([
    $esDFm.Override
], $0a8a45ddfa7016cf$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $0a8a45ddfa7016cf$var$RuleStopState;

});

parcelRegister("acKOx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $76df56aac7091e8d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $76df56aac7091e8d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
/** */ let $76df56aac7091e8d$var$RuleTransition = class RuleTransition extends $i2NOt.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$76df56aac7091e8d$var$__decorate([
    $esDFm.NotNull
], $76df56aac7091e8d$var$RuleTransition.prototype, "followState", void 0);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "serializationType", null);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "isEpsilon", null);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "matches", null);
$76df56aac7091e8d$var$RuleTransition = $76df56aac7091e8d$var$__decorate([
    $76df56aac7091e8d$var$__param(0, $esDFm.NotNull),
    $76df56aac7091e8d$var$__param(3, $esDFm.NotNull)
], $76df56aac7091e8d$var$RuleTransition);
module.exports.RuleTransition = $76df56aac7091e8d$var$RuleTransition;

});

parcelRegister("4EBHJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $36382520b7b8202f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $36382520b7b8202f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $36382520b7b8202f$var$WildcardTransition = class WildcardTransition extends $i2NOt.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$36382520b7b8202f$var$__decorate([
    $esDFm.Override
], $36382520b7b8202f$var$WildcardTransition.prototype, "serializationType", null);
$36382520b7b8202f$var$__decorate([
    $esDFm.Override
], $36382520b7b8202f$var$WildcardTransition.prototype, "matches", null);
$36382520b7b8202f$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $36382520b7b8202f$var$WildcardTransition.prototype, "toString", null);
$36382520b7b8202f$var$WildcardTransition = $36382520b7b8202f$var$__decorate([
    $36382520b7b8202f$var$__param(0, $esDFm.NotNull)
], $36382520b7b8202f$var$WildcardTransition);
module.exports.WildcardTransition = $36382520b7b8202f$var$WildcardTransition;

});



parcelRegister("khqMx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ec3a2b803d986844$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ec3a2b803d986844$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $crbOk = parcelRequire("crbOk");

var $hv3tp = parcelRequire("hv3tp");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $ec3a2b803d986844$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $i99P2.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $i99P2.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $i99P2.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $hv3tp.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $hv3tp.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $hv3tp.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $crbOk.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "lexerActions", null);
$ec3a2b803d986844$var$__decorate([
    $ec3a2b803d986844$var$__param(0, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "execute", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.Override
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "hashCode", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.Override
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "equals", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull,
    $ec3a2b803d986844$var$__param(1, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor, "append", null);
$ec3a2b803d986844$var$LexerActionExecutor = $ec3a2b803d986844$var$__decorate([
    $ec3a2b803d986844$var$__param(0, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $ec3a2b803d986844$var$LexerActionExecutor;

});
parcelRegister("hv3tp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cbd806a78853c705$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cbd806a78853c705$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $cbd806a78853c705$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this._offset);
        hash = $i99P2.MurmurHash.update(hash, this._action);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$cbd806a78853c705$var$__decorate([
    $esDFm.NotNull
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "action", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "actionType", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "execute", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "equals", null);
$cbd806a78853c705$var$LexerIndexedCustomAction = $cbd806a78853c705$var$__decorate([
    $cbd806a78853c705$var$__param(1, $esDFm.NotNull)
], $cbd806a78853c705$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $cbd806a78853c705$var$LexerIndexedCustomAction;

});


parcelRegister("6Npyx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4f2b24917d98a0c1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4f2b24917d98a0c1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");

var $4Q2DM = parcelRequire("4Q2DM");

var $g4Hat = parcelRequire("g4Hat");
let $4f2b24917d98a0c1$var$LexerNoViableAltException = class LexerNoViableAltException extends $lWPhg.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($4Q2DM.Interval.of(this._startIndex, this._startIndex));
            symbol = $g4Hat.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$4f2b24917d98a0c1$var$__decorate([
    $esDFm.Override
], $4f2b24917d98a0c1$var$LexerNoViableAltException.prototype, "inputStream", null);
$4f2b24917d98a0c1$var$__decorate([
    $esDFm.Override
], $4f2b24917d98a0c1$var$LexerNoViableAltException.prototype, "toString", null);
$4f2b24917d98a0c1$var$LexerNoViableAltException = $4f2b24917d98a0c1$var$__decorate([
    $4f2b24917d98a0c1$var$__param(1, $esDFm.NotNull)
], $4f2b24917d98a0c1$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $4f2b24917d98a0c1$var$LexerNoViableAltException;

});

parcelRegister("jjTpW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e10ac7679ae3108e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $6co2U = parcelRequire("6co2U");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $e10ac7679ae3108e$var$OrderedATNConfigSet extends $6co2U.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $e10ac7679ae3108e$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "clone", null);
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "getKey", null);
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $e10ac7679ae3108e$var$OrderedATNConfigSet;

});




parcelRegister("4qcTm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3383972d3ce7c61d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $dDGsq = parcelRequire("dDGsq");

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $3383972d3ce7c61d$var$NoViableAltException extends $lWPhg.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $dDGsq.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$3383972d3ce7c61d$var$__decorate([
    $esDFm.NotNull
], $3383972d3ce7c61d$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $3383972d3ce7c61d$var$NoViableAltException;

});
parcelRegister("dDGsq", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9edfda115552908e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9edfda115552908e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $9edfda115552908e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $g4Hat = parcelRequire("g4Hat");

var $cYBtK = parcelRequire("cYBtK");

var $es7AZ = parcelRequire("es7AZ");

var $cNbax = parcelRequire("cNbax");

var $5zuwY = parcelRequire("5zuwY");

var $9AKkH = parcelRequire("9AKkH");

var $gTQRB = parcelRequire("gTQRB");

var $esDFm = parcelRequire("esDFm");

var $bYNsJ = parcelRequire("bYNsJ");

var $l4uOS = parcelRequire("l4uOS");

var $ct3k0 = parcelRequire("ct3k0");

var $24a4y = parcelRequire("24a4y");

var $6JC52 = parcelRequire("6JC52");

var $2G93d = parcelRequire("2G93d");
class $9edfda115552908e$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "enterEveryRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "exitEveryRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "visitErrorNode", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $9edfda115552908e$var$Parser extends $24a4y.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $cNbax.DefaultErrorStrategy();
        this._precedenceStack = new $9AKkH.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $2G93d.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $9edfda115552908e$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $cYBtK.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $es7AZ.ATNDeserializer(deserializationOptions).deserialize($g4Hat.toCharArray(serializedAtn));
            $9edfda115552908e$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $9edfda115552908e$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $gTQRB.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("9W9pH")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $9edfda115552908e$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $6JC52.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $5zuwY.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $ct3k0.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($2G93d.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2G93d.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($2G93d.Token.EPSILON) && symbol === $2G93d.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $igDjg.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("gF4qM"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $bYNsJ.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $9edfda115552908e$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("gF4qM")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $l4uOS.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $9edfda115552908e$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $9edfda115552908e$var$Parser.bypassAltsAtnCache = new Map();
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "_errHandler", void 0);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "match", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "matchWildcard", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getParseListeners", null);
$9edfda115552908e$var$__decorate([
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "addParseListener", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getATNWithBypassAlts", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull,
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "errorHandler", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "inputStream", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "currentToken", null);
$9edfda115552908e$var$__decorate([
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "enterRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override,
    $9edfda115552908e$var$__param(0, $esDFm.Nullable)
], $9edfda115552908e$var$Parser.prototype, "precpred", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "getErrorListenerDispatch", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getExpectedTokens", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $9edfda115552908e$var$Parser;

});
parcelRegister("cYBtK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9728292026f6087a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $9728292026f6087a$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($9728292026f6087a$var$ATNDeserializationOptions._defaultOptions == null) {
            $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions = new $9728292026f6087a$var$ATNDeserializationOptions();
            $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$9728292026f6087a$var$__decorate([
    $esDFm.NotNull
], $9728292026f6087a$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $9728292026f6087a$var$ATNDeserializationOptions;

});

parcelRegister("es7AZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a85992867d098ad4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a85992867d098ad4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $9elhd = parcelRequire("9elhd");

var $fJumX = parcelRequire("fJumX");

var $lDQMG = parcelRequire("lDQMG");

var $cYBtK = parcelRequire("cYBtK");

var $9TBHo = parcelRequire("9TBHo");

var $elgsv = parcelRequire("elgsv");

var $6Wwgi = parcelRequire("6Wwgi");

var $aTslC = parcelRequire("aTslC");

var $lVdCV = parcelRequire("lVdCV");

var $h0Oxm = parcelRequire("h0Oxm");

var $fqwBK = parcelRequire("fqwBK");

var $axZym = parcelRequire("axZym");

var $dLpRd = parcelRequire("dLpRd");

var $4t2Am = parcelRequire("4t2Am");

var $6og9T = parcelRequire("6og9T");

var $2xNwj = parcelRequire("2xNwj");

var $lAw71 = parcelRequire("lAw71");

var $hinaj = parcelRequire("hinaj");

var $jWb5l = parcelRequire("jWb5l");

var $ermyP = parcelRequire("ermyP");

var $lPekc = parcelRequire("lPekc");

var $i50Cm = parcelRequire("i50Cm");

var $8OGST = parcelRequire("8OGST");

var $j6qbp = parcelRequire("j6qbp");

var $3fYXW = parcelRequire("3fYXW");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $l4uOS = parcelRequire("l4uOS");

var $j2EBs = parcelRequire("j2EBs");

var $6U6Db = parcelRequire("6U6Db");

var $l5c3t = parcelRequire("l5c3t");

var $dlxNc = parcelRequire("dlxNc");

var $evTXr = parcelRequire("evTXr");

var $54SKF = parcelRequire("54SKF");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $4mzjd = parcelRequire("4mzjd");

var $aj3zV = parcelRequire("aj3zV");

var $cLQen = parcelRequire("cLQen");

var $izkyd = parcelRequire("izkyd");

var $2G93d = parcelRequire("2G93d");

var $c0QqZ = parcelRequire("c0QqZ");

var $lkdkr = parcelRequire("lkdkr");

var $4EBHJ = parcelRequire("4EBHJ");
var $a85992867d098ad4$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($a85992867d098ad4$var$UnicodeDeserializingMode || ($a85992867d098ad4$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $a85992867d098ad4$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $cYBtK.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $a85992867d098ad4$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $a85992867d098ad4$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$a85992867d098ad4$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $a85992867d098ad4$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$a85992867d098ad4$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $lDQMG.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $9TBHo.ATNStateType.INVALID_TYPE) {
                atn.addState(new $2xNwj.InvalidState());
                continue;
            }
            let ruleIndex = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $9TBHo.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $fqwBK.BlockStartState) {
                let endStateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $2G93d.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $U6v4o.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $dLpRd.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $a85992867d098ad4$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $a85992867d098ad4$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            let trg = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $fJumX.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $acKOx.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $4t2Am.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $fqwBK.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $6U6Db.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $j2EBs.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $cLQen.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $izkyd.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $9elhd.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $hinaj.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $9elhd.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $dLpRd.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $6Wwgi.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $h0Oxm.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $3fYXW.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $U6v4o.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $4t2Am.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $4t2Am.EpsilonTransition(endState));
                let matchState = new $aTslC.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $elgsv.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $4t2Am.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $a85992867d098ad4$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $6og9T.IntervalSet();
            sets.push(set);
            let containsEof = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $3fYXW.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $U6v4o.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $lVdCV.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $9TBHo.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $j2EBs.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $izkyd.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $aj3zV.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $3fYXW.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $3fYXW.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $aj3zV.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $cLQen.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $izkyd.StarLoopEntryState);
            }
            if (state instanceof $3fYXW.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $54SKF.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $fqwBK.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $h0Oxm.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $axZym.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $U6v4o.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $U6v4o.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $aTslC.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $4t2Am.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $elgsv.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $evTXr.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $4mzjd.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $U6v4o.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $9TBHo.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $4t2Am.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $6og9T.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $4t2Am.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $h0Oxm.BlockEndState)) continue;
                if (transition instanceof $grncH.NotSetTransition) continue;
                if (transition instanceof $elgsv.AtomTransition || transition instanceof $evTXr.RangeTransition || transition instanceof $4mzjd.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $6og9T.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $grncH.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $elgsv.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $evTXr.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $4mzjd.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $aTslC.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $4t2Am.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $lVdCV.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $U6v4o.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $lkdkr.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $4t2Am.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $evTXr.RangeTransition(target, $2G93d.Token.EOF, arg2);
                else return new $evTXr.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $acKOx.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $dlxNc.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $l5c3t.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $elgsv.AtomTransition(target, $2G93d.Token.EOF);
                else return new $elgsv.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $9elhd.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $4mzjd.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $grncH.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $4EBHJ.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $9TBHo.ATNStateType.INVALID_TYPE:
                return new $2xNwj.InvalidState();
            case $9TBHo.ATNStateType.BASIC:
                s = new $aTslC.BasicState();
                break;
            case $9TBHo.ATNStateType.RULE_START:
                s = new $54SKF.RuleStartState();
                break;
            case $9TBHo.ATNStateType.BLOCK_START:
                s = new $6Wwgi.BasicBlockStartState();
                break;
            case $9TBHo.ATNStateType.PLUS_BLOCK_START:
                s = new $j2EBs.PlusBlockStartState();
                break;
            case $9TBHo.ATNStateType.STAR_BLOCK_START:
                s = new $aj3zV.StarBlockStartState();
                break;
            case $9TBHo.ATNStateType.TOKEN_START:
                s = new $c0QqZ.TokensStartState();
                break;
            case $9TBHo.ATNStateType.RULE_STOP:
                s = new $U6v4o.RuleStopState();
                break;
            case $9TBHo.ATNStateType.BLOCK_END:
                s = new $h0Oxm.BlockEndState();
                break;
            case $9TBHo.ATNStateType.STAR_LOOP_BACK:
                s = new $cLQen.StarLoopbackState();
                break;
            case $9TBHo.ATNStateType.STAR_LOOP_ENTRY:
                s = new $izkyd.StarLoopEntryState();
                break;
            case $9TBHo.ATNStateType.PLUS_LOOP_BACK:
                s = new $6U6Db.PlusLoopbackState();
                break;
            case $9TBHo.ATNStateType.LOOP_END:
                s = new $3fYXW.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $lAw71.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $hinaj.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $jWb5l.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $ermyP.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $lPekc.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $i50Cm.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $8OGST.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $j6qbp.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $a85992867d098ad4$var$ATNDeserializer.BASE_SERIALIZED_UUID = $lkdkr.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $lkdkr.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP = $lkdkr.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $a85992867d098ad4$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $a85992867d098ad4$var$ATNDeserializer.SERIALIZED_UUID = $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP;
$a85992867d098ad4$var$__decorate([
    $esDFm.NotNull
], $a85992867d098ad4$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$a85992867d098ad4$var$__decorate([
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "deserialize", null);
$a85992867d098ad4$var$__decorate([
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$a85992867d098ad4$var$__decorate([
    $esDFm.NotNull,
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $a85992867d098ad4$var$ATNDeserializer;

});
parcelRegister("9elhd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6b85ecfc8f932b00$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6b85ecfc8f932b00$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $6b85ecfc8f932b00$var$ActionTransition = class ActionTransition extends $i2NOt.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "serializationType", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "isEpsilon", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "matches", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "toString", null);
$6b85ecfc8f932b00$var$ActionTransition = $6b85ecfc8f932b00$var$__decorate([
    $6b85ecfc8f932b00$var$__param(0, $esDFm.NotNull)
], $6b85ecfc8f932b00$var$ActionTransition);
module.exports.ActionTransition = $6b85ecfc8f932b00$var$ActionTransition;

});

parcelRegister("elgsv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a70fcb33cb62f153$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a70fcb33cb62f153$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
/** TODO: make all transitions sets? no, should remove set edges */ let $a70fcb33cb62f153$var$AtomTransition = class AtomTransition extends $i2NOt.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $6og9T.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override
], $a70fcb33cb62f153$var$AtomTransition.prototype, "serializationType", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a70fcb33cb62f153$var$AtomTransition.prototype, "label", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override
], $a70fcb33cb62f153$var$AtomTransition.prototype, "matches", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a70fcb33cb62f153$var$AtomTransition.prototype, "toString", null);
$a70fcb33cb62f153$var$AtomTransition = $a70fcb33cb62f153$var$__decorate([
    $a70fcb33cb62f153$var$__param(0, $esDFm.NotNull)
], $a70fcb33cb62f153$var$AtomTransition);
module.exports.AtomTransition = $a70fcb33cb62f153$var$AtomTransition;

});

parcelRegister("6Wwgi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $50e12f5dabf960d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $50e12f5dabf960d1$var$BasicBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.BLOCK_START;
    }
}
$50e12f5dabf960d1$var$__decorate([
    $esDFm.Override
], $50e12f5dabf960d1$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $50e12f5dabf960d1$var$BasicBlockStartState;

});
parcelRegister("fqwBK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $axZym = parcelRequire("axZym");
/**  The start of a regular `(...)` block. */ class $b3b293f71aea38f4$var$BlockStartState extends $axZym.DecisionState {
}
module.exports.BlockStartState = $b3b293f71aea38f4$var$BlockStartState;

});


parcelRegister("h0Oxm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c629a360f3a068ca$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** Terminal node of a simple `(a|b|c)` block. */ class $c629a360f3a068ca$var$BlockEndState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.BLOCK_END;
    }
}
$c629a360f3a068ca$var$__decorate([
    $esDFm.Override
], $c629a360f3a068ca$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $c629a360f3a068ca$var$BlockEndState;

});

parcelRegister("4t2Am", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $340be0435f71aac4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $340be0435f71aac4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $340be0435f71aac4$var$EpsilonTransition = class EpsilonTransition extends $i2NOt.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "serializationType", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "isEpsilon", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "matches", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $340be0435f71aac4$var$EpsilonTransition.prototype, "toString", null);
$340be0435f71aac4$var$EpsilonTransition = $340be0435f71aac4$var$__decorate([
    $340be0435f71aac4$var$__param(0, $esDFm.NotNull)
], $340be0435f71aac4$var$EpsilonTransition);
module.exports.EpsilonTransition = $340be0435f71aac4$var$EpsilonTransition;

});

parcelRegister("lAw71", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fb75de970db175c7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fb75de970db175c7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $fb75de970db175c7$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._channel);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $fb75de970db175c7$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "actionType", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "isPositionDependent", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override,
    $fb75de970db175c7$var$__param(0, $esDFm.NotNull)
], $fb75de970db175c7$var$LexerChannelAction.prototype, "execute", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "hashCode", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "equals", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $fb75de970db175c7$var$LexerChannelAction;

});

parcelRegister("hinaj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c976164228d63343$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c976164228d63343$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $c976164228d63343$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._ruleIndex);
        hash = $i99P2.MurmurHash.update(hash, this._actionIndex);
        return $i99P2.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $c976164228d63343$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "actionType", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "isPositionDependent", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override,
    $c976164228d63343$var$__param(0, $esDFm.NotNull)
], $c976164228d63343$var$LexerCustomAction.prototype, "execute", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "hashCode", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $c976164228d63343$var$LexerCustomAction;

});

parcelRegister("jWb5l", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e83c08696b675ccd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e83c08696b675ccd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $e83c08696b675ccd$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._mode);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $e83c08696b675ccd$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "actionType", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "isPositionDependent", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override,
    $e83c08696b675ccd$var$__param(0, $esDFm.NotNull)
], $e83c08696b675ccd$var$LexerModeAction.prototype, "execute", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "hashCode", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "equals", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $e83c08696b675ccd$var$LexerModeAction;

});

parcelRegister("ermyP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a835166398566135$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a835166398566135$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a835166398566135$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "actionType", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "isPositionDependent", null);
$a835166398566135$var$__decorate([
    $esDFm.Override,
    $a835166398566135$var$__param(0, $esDFm.NotNull)
], $a835166398566135$var$LexerMoreAction.prototype, "execute", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "hashCode", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "equals", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $a835166398566135$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($a835166398566135$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("lPekc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fe397901d0b681ed$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fe397901d0b681ed$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $fe397901d0b681ed$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "actionType", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override,
    $fe397901d0b681ed$var$__param(0, $esDFm.NotNull)
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "execute", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "hashCode", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "equals", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $fe397901d0b681ed$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($fe397901d0b681ed$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("i50Cm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d2992c51027ada37$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d2992c51027ada37$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $d2992c51027ada37$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._mode);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $d2992c51027ada37$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "actionType", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override,
    $d2992c51027ada37$var$__param(0, $esDFm.NotNull)
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "execute", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "hashCode", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "equals", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $d2992c51027ada37$var$LexerPushModeAction;

});

parcelRegister("8OGST", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $66b4422a2a20edad$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $66b4422a2a20edad$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $66b4422a2a20edad$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "actionType", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "isPositionDependent", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override,
    $66b4422a2a20edad$var$__param(0, $esDFm.NotNull)
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "execute", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "hashCode", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "equals", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $66b4422a2a20edad$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($66b4422a2a20edad$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("j6qbp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de82e34741a62417$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de82e34741a62417$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $de82e34741a62417$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._type);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $de82e34741a62417$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "actionType", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "isPositionDependent", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override,
    $de82e34741a62417$var$__param(0, $esDFm.NotNull)
], $de82e34741a62417$var$LexerTypeAction.prototype, "execute", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "hashCode", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "equals", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $de82e34741a62417$var$LexerTypeAction;

});

parcelRegister("3fYXW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $25f2105603fe5855$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** Mark the end of a * or + loop. */ class $25f2105603fe5855$var$LoopEndState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.LOOP_END;
    }
}
$25f2105603fe5855$var$__decorate([
    $esDFm.Override
], $25f2105603fe5855$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $25f2105603fe5855$var$LoopEndState;

});

parcelRegister("l4uOS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f571e0d4afb01ff2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f571e0d4afb01ff2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $dg39p = parcelRequire("dg39p");

var $9elhd = parcelRequire("9elhd");

var $fJumX = parcelRequire("fJumX");

var $yEtb9 = parcelRequire("yEtb9");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $6co2U = parcelRequire("6co2U");

var $lbAqv = parcelRequire("lbAqv");

var $9TBHo = parcelRequire("9TBHo");

var $elgsv = parcelRequire("elgsv");

var $lVdCV = parcelRequire("lVdCV");

var $3AFtK = parcelRequire("3AFtK");

var $axZym = parcelRequire("axZym");

var $5jw7S = parcelRequire("5jw7S");

var $eOyS9 = parcelRequire("eOyS9");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $4qcTm = parcelRequire("4qcTm");

var $73sQO = parcelRequire("73sQO");

var $5NlfZ = parcelRequire("5NlfZ");

var $haz8F = parcelRequire("haz8F");

var $8Uwhy = parcelRequire("8Uwhy");

var $2cmeG = parcelRequire("2cmeG");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $8DW9a = parcelRequire("8DW9a");

var $4mzjd = parcelRequire("4mzjd");

var $fO6gt = parcelRequire("fO6gt");

var $2G93d = parcelRequire("2G93d");

var $5t4I3 = parcelRequire("5t4I3");

var $gwEr2 = parcelRequire("gwEr2");
const $f571e0d4afb01ff2$var$MAX_SHORT_VALUE = 0xFFFF;
const $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $f571e0d4afb01ff2$var$ParserATNSimulator = class ParserATNSimulator extends $lbAqv.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $2cmeG.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $gwEr2(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $2cmeG.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $5NlfZ.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $5NlfZ.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $fO6gt.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $fO6gt.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $gwEr2(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $gwEr2(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $fO6gt.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $fO6gt.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $gwEr2(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $gwEr2(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $4Q2DM.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $lbAqv.ATNSimulator.ERROR) {
                let errorState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $d4sFB.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $axZym.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $gwEr2(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $2cmeG.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $2cmeG.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $8Uwhy.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $lbAqv.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $gwEr2(D.isAcceptState || D.prediction === $lDQMG.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $gwEr2(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $lDQMG.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $f571e0d4afb01ff2$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $gwEr2(!useContext);
                    $gwEr2(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $d4sFB.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $lVdCV.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $U6v4o.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $6co2U.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $U6v4o.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $gwEr2(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $gwEr2(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $fO6gt.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $lbAqv.ATNSimulator.ERROR) return undefined;
        $gwEr2(!useContext || !target.configs.dipsIntoOuterContext);
        return new $fO6gt.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $6co2U.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $6co2U.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $U6v4o.RuleStopState) {
                    $gwEr2(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $d4sFB.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $2G93d.Token.EOF && reachIntermediate.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $2G93d.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $d4sFB.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$2cmeG.PredictionMode.hasConfigInRuleStopState(reach))) {
                $gwEr2(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $eOyS9.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $lbAqv.ATNSimulator.ERROR);
            return [
                $lbAqv.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($2cmeG.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $6co2U.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $U6v4o.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $fO6gt.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $haz8F.PredictionContext.EMPTY_FULL : $haz8F.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $8Uwhy.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $fO6gt.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $6co2U.ATNConfigSet();
        while(true){
            let reachIntermediate = new $6co2U.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($9qlOq.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $fO6gt.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $6co2U.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $8DW9a.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $8DW9a.SemanticContext.NONE;
            else if (altToPred[i] !== $8DW9a.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $yEtb9.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $gwEr2(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $8DW9a.SemanticContext.NONE) pairs.push(new $5jw7S.DFAState.PredPrediction(pred, i));
            else if (pred !== $8DW9a.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $5jw7S.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $lVdCV.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $8DW9a.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $8Uwhy.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $6co2U.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $U6v4o.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $9qlOq.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $gwEr2(depth > $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $haz8F.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $haz8F.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $haz8F.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $haz8F.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $9TBHo.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $9elhd.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $acKOx.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $U6v4o.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $gwEr2(newDepth > $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $acKOx.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$haz8F.PredictionContext.isEmptyLocal(config.context))) {
                        $gwEr2(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $haz8F.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($2G93d.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $8DW9a.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $8DW9a.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$haz8F.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $lVdCV.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $lVdCV.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $3AFtK.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $lVdCV.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $2G93d.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $elgsv.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $4mzjd.SetTransition) {
                    let not = t instanceof $grncH.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $4qcTm.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $lDQMG.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $lDQMG.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $U6v4o.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $gwEr2(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $gwEr2(context !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $5t4I3.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $6co2U.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $gwEr2(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $dg39p.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $dg39p.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $5jw7S.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $gwEr2(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$f571e0d4afb01ff2$var$ParserATNSimulator.debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.dfa_debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.retry_debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Override
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reset", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getStartState", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "execDFA", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "execATN", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "computeTargetState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "computeStartState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(4, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "closure", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(6, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "closureImpl", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getRuleName", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "actionTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Nullable,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Nullable,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "predTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "ruleTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "isConflicted", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getTokenName", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "noViableAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(4, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.Nullable),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "createDFAState", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(5, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(6, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$f571e0d4afb01ff2$var$ParserATNSimulator = $f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $f571e0d4afb01ff2$var$ParserATNSimulator;

});
parcelRegister("3AFtK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $29d4e8b3dd9d0c91$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $esDFm = parcelRequire("esDFm");

var $g4Hat = parcelRequire("g4Hat");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $29d4e8b3dd9d0c91$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $29d4e8b3dd9d0c91$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $g4Hat.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$29d4e8b3dd9d0c91$var$__decorate([
    $esDFm.Override
], $29d4e8b3dd9d0c91$var$ConflictInfo.prototype, "equals", null);
$29d4e8b3dd9d0c91$var$__decorate([
    $esDFm.Override
], $29d4e8b3dd9d0c91$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $29d4e8b3dd9d0c91$var$ConflictInfo;

});

parcelRegister("5NlfZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $43820489bf2012b7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $5zuwY = parcelRequire("5zuwY");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $1uFvm = parcelRequire("1uFvm");

var $6JC52 = parcelRequire("6JC52");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $43820489bf2012b7$var$ParserRuleContext extends $1uFvm.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $43820489bf2012b7$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $5zuwY.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $6JC52.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $1uFvm.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $6JC52.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $5zuwY.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $5zuwY.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $43820489bf2012b7$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $6JC52.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $6JC52.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $4Q2DM.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $4Q2DM.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $4Q2DM.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$43820489bf2012b7$var$ParserRuleContext.EMPTY = new $43820489bf2012b7$var$ParserRuleContext();
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "parent", null);
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "childCount", null);
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $43820489bf2012b7$var$ParserRuleContext;

});
parcelRegister("5zuwY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $40e7e769cc652e20$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $esDFm = parcelRequire("esDFm");

var $6JC52 = parcelRequire("6JC52");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $40e7e769cc652e20$var$ErrorNode extends $6JC52.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$40e7e769cc652e20$var$__decorate([
    $esDFm.Override
], $40e7e769cc652e20$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $40e7e769cc652e20$var$ErrorNode;

});
parcelRegister("6JC52", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4e747c0024dd6c45$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
class $4e747c0024dd6c45$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $4Q2DM.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $2G93d.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "getChild", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "parent", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "setParent", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "payload", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "sourceInterval", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "childCount", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "accept", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "text", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "toStringTree", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $4e747c0024dd6c45$var$TerminalNode;

});


parcelRegister("1uFvm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1168c9c90534f342$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $24a4y = parcelRequire("24a4y");

var $8FZwR = parcelRequire("8FZwR");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $hLP94 = parcelRequire("hLP94");

var $5NlfZ = parcelRequire("5NlfZ");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $1168c9c90534f342$var$RuleContext extends $8FZwR.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $1168c9c90534f342$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $4Q2DM.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $lDQMG.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $hLP94.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $24a4y.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $5NlfZ.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "sourceInterval", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "ruleContext", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "parent", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "setParent", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "payload", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "text", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "getChild", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "childCount", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "accept", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $1168c9c90534f342$var$RuleContext;

});
parcelRegister("8FZwR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $6511e1766b7044d6$var$RuleNode {
}
module.exports.RuleNode = $6511e1766b7044d6$var$RuleNode;

});

parcelRegister("hLP94", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cefe7fdd17d6991a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cefe7fdd17d6991a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $8Mk1Z = parcelRequire("8Mk1Z");

var $5zuwY = parcelRequire("5zuwY");

var $esDFm = parcelRequire("esDFm");

var $dDGsq = parcelRequire("dDGsq");

var $5NlfZ = parcelRequire("5NlfZ");

var $8FZwR = parcelRequire("8FZwR");

var $6JC52 = parcelRequire("6JC52");

var $2G93d = parcelRequire("2G93d");

var $g4Hat = parcelRequire("g4Hat");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $cefe7fdd17d6991a$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $dDGsq.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $g4Hat.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $g4Hat.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $dDGsq.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $8FZwR.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $lDQMG.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $5zuwY.ErrorNode) return t.toString();
        else if (t instanceof $6JC52.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $cefe7fdd17d6991a$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $cefe7fdd17d6991a$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $cefe7fdd17d6991a$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $6JC52.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $5NlfZ.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$cefe7fdd17d6991a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $cefe7fdd17d6991a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $5NlfZ.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $5NlfZ.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($cefe7fdd17d6991a$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $8Mk1Z.CommonToken($2G93d.Token.INVALID_TYPE, "...");
                    t.children[i] = new $6JC52.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $cefe7fdd17d6991a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$cefe7fdd17d6991a$var$__decorate([
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "toStringTree", null);
$cefe7fdd17d6991a$var$__decorate([
    $esDFm.NotNull,
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "getAncestors", null);
$cefe7fdd17d6991a$var$__decorate([
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $cefe7fdd17d6991a$var$Trees;

});



parcelRegister("2cmeG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $199df35814bac0d8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $dkveu = parcelRequire("dkveu");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $U6v4o = parcelRequire("U6v4o");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $199df35814bac0d8$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($199df35814bac0d8$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $dkveu.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $i99P2.MurmurHash.initialize(7);
            hashCode = $i99P2.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $i99P2.MurmurHash.update(hashCode, o.context);
            hashCode = $i99P2.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $199df35814bac0d8$var$__decorate([
        $esDFm.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $199df35814bac0d8$var$__decorate([
        $esDFm.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $U6v4o.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $U6v4o.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($199df35814bac0d8$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("fO6gt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b8206294aba6be67$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b8206294aba6be67$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/**
 *
 * @author Sam Harwell
 */ let $b8206294aba6be67$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $5NlfZ.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$b8206294aba6be67$var$SimulatorState = $b8206294aba6be67$var$__decorate([
    $b8206294aba6be67$var$__param(1, $esDFm.NotNull)
], $b8206294aba6be67$var$SimulatorState);
module.exports.SimulatorState = $b8206294aba6be67$var$SimulatorState;

});


parcelRegister("j2EBs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ddcdb33017a842a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $ddcdb33017a842a9$var$PlusBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.PLUS_BLOCK_START;
    }
}
$ddcdb33017a842a9$var$__decorate([
    $esDFm.Override
], $ddcdb33017a842a9$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $ddcdb33017a842a9$var$PlusBlockStartState;

});

parcelRegister("6U6Db", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $506d1dd5405be440$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $506d1dd5405be440$var$PlusLoopbackState extends $axZym.DecisionState {
    get stateType() {
        return $9TBHo.ATNStateType.PLUS_LOOP_BACK;
    }
}
$506d1dd5405be440$var$__decorate([
    $esDFm.Override
], $506d1dd5405be440$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $506d1dd5405be440$var$PlusLoopbackState;

});

parcelRegister("l5c3t", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f5936a7914ccad6f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f5936a7914ccad6f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $esDFm = parcelRequire("esDFm");

var $8DW9a = parcelRequire("8DW9a");
/**
 *
 * @author Sam Harwell
 */ let $f5936a7914ccad6f$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $5sT1a.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $8DW9a.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "matches", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "toString", null);
$f5936a7914ccad6f$var$PrecedencePredicateTransition = $f5936a7914ccad6f$var$__decorate([
    $f5936a7914ccad6f$var$__param(0, $esDFm.NotNull)
], $f5936a7914ccad6f$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $f5936a7914ccad6f$var$PrecedencePredicateTransition;

});

parcelRegister("evTXr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a90f5dfe3a55f17e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a90f5dfe3a55f17e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $a90f5dfe3a55f17e$var$RangeTransition = class RangeTransition extends $i2NOt.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $6og9T.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "serializationType", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "label", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "matches", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "toString", null);
$a90f5dfe3a55f17e$var$RangeTransition = $a90f5dfe3a55f17e$var$__decorate([
    $a90f5dfe3a55f17e$var$__param(0, $esDFm.NotNull)
], $a90f5dfe3a55f17e$var$RangeTransition);
module.exports.RangeTransition = $a90f5dfe3a55f17e$var$RangeTransition;

});

parcelRegister("54SKF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3b27cc07a8f55191$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
class $3b27cc07a8f55191$var$RuleStartState extends $17Oz4.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $9TBHo.ATNStateType.RULE_START;
    }
}
$3b27cc07a8f55191$var$__decorate([
    $esDFm.Override
], $3b27cc07a8f55191$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $3b27cc07a8f55191$var$RuleStartState;

});

parcelRegister("aj3zV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $780e745635507ed4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/** The block that begins a closure loop. */ class $780e745635507ed4$var$StarBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.STAR_BLOCK_START;
    }
}
$780e745635507ed4$var$__decorate([
    $esDFm.Override
], $780e745635507ed4$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $780e745635507ed4$var$StarBlockStartState;

});

parcelRegister("cLQen", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $94c263cb0220bf37$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
class $94c263cb0220bf37$var$StarLoopbackState extends $17Oz4.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $9TBHo.ATNStateType.STAR_LOOP_BACK;
    }
}
$94c263cb0220bf37$var$__decorate([
    $esDFm.Override
], $94c263cb0220bf37$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $94c263cb0220bf37$var$StarLoopbackState;

});

parcelRegister("c0QqZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8bee2881bedcfb48$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
/** The Tokens rule start state linking to each lexer rule start state */ class $8bee2881bedcfb48$var$TokensStartState extends $axZym.DecisionState {
    get stateType() {
        return $9TBHo.ATNStateType.TOKEN_START;
    }
}
$8bee2881bedcfb48$var$__decorate([
    $esDFm.Override
], $8bee2881bedcfb48$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $8bee2881bedcfb48$var$TokensStartState;

});

parcelRegister("lkdkr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $i99P2 = parcelRequire("i99P2");
class $f865ce06460c5d56$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $f865ce06460c5d56$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $i99P2.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $f865ce06460c5d56$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $f865ce06460c5d56$var$UUID;

});


parcelRegister("bYNsJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8b8baa7f19328023$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8b8baa7f19328023$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $8b8baa7f19328023$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$8b8baa7f19328023$var$__decorate([
    $esDFm.NotNull
], $8b8baa7f19328023$var$ParseInfo.prototype, "getDecisionInfo", null);
$8b8baa7f19328023$var$__decorate([
    $esDFm.NotNull
], $8b8baa7f19328023$var$ParseInfo.prototype, "getLLDecisions", null);
$8b8baa7f19328023$var$ParseInfo = $8b8baa7f19328023$var$__decorate([
    $8b8baa7f19328023$var$__param(0, $esDFm.NotNull)
], $8b8baa7f19328023$var$ParseInfo);
module.exports.ParseInfo = $8b8baa7f19328023$var$ParseInfo;

});

parcelRegister("ct3k0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $913ac514b76a37df$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $adfkv = parcelRequire("adfkv");

var $esDFm = parcelRequire("esDFm");
/**
 * @author Sam Harwell
 */ class $913ac514b76a37df$var$ProxyParserErrorListener extends $adfkv.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $913ac514b76a37df$var$ProxyParserErrorListener;

});

parcelRegister("9W9pH", function(module, exports) {

let $73c0d5268630ef84$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $73c0d5268630ef84$var$load("39h9p").then(()=>parcelRequire('3i2SZ'));

});

parcelRegister("gF4qM", function(module, exports) {

let $c213e98fde436fb7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c213e98fde436fb7$var$load("2mTYh").then(()=>parcelRequire('8rjeX'));

});




parcelRegister("5EAbA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $41dcc1f37efdf89f$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $41dcc1f37efdf89f$var$ParseCancellationException;

});


parcelRegister("h5rBk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c708504646673e71$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c708504646673e71$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $8Mk1Z = parcelRequire("8Mk1Z");

var $4Q2DM = parcelRequire("4Q2DM");

var $gTQRB = parcelRequire("gTQRB");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $c708504646673e71$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $2G93d.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $gwEr2(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $2G93d.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2G93d.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $2G93d.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $gwEr2(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $2G93d.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $2G93d.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $4Q2DM.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $4Q2DM.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2G93d.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($4Q2DM.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $8Mk1Z.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $8Mk1Z.CommonToken;
    }
};
$c708504646673e71$var$__decorate([
    $esDFm.NotNull
], $c708504646673e71$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "tokenSource", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "index", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "mark", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "release", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "seek", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "size", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "consume", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "get", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "LA", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "LT", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "sourceName", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "getText", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$c708504646673e71$var$BufferedTokenStream = $c708504646673e71$var$__decorate([
    $c708504646673e71$var$__param(0, $esDFm.NotNull)
], $c708504646673e71$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $c708504646673e71$var$BufferedTokenStream;

});

parcelRegister("cBsOS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("d0TlQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $3wxwf = parcelRequire("3wxwf");

var $lXg5i = parcelRequire("lXg5i");

var $d4sFB = parcelRequire("d4sFB");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $9796360e323bb25a$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $3wxwf.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $lXg5i.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($9796360e323bb25a$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("3wxwf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $eIoqK = parcelRequire("eIoqK");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $290e5c7608340dee$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $290e5c7608340dee$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $290e5c7608340dee$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $290e5c7608340dee$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $gwEr2(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$eIoqK.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $gwEr2(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$eIoqK.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($eIoqK.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($eIoqK.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($eIoqK.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($290e5c7608340dee$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("eIoqK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $ab682023343875fe$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $ab682023343875fe$var$isHighSurrogate;
function $ab682023343875fe$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $ab682023343875fe$var$isLowSurrogate;
function $ab682023343875fe$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $ab682023343875fe$var$isSupplementaryCodePoint;

});


parcelRegister("lXg5i", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ffbb95ad08ca6a0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $d4sFB = parcelRequire("d4sFB");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $ffbb95ad08ca6a0e$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $gwEr2(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $ffbb95ad08ca6a0e$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $gwEr2(this.LA(1) === $d4sFB.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($4Q2DM.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $d4sFB.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $d4sFB.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "consume", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "index", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "size", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "mark", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "release", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "seek", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "sourceName", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "toString", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "LA", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $ffbb95ad08ca6a0e$var$CodePointCharStream;

});


parcelRegister("1y11S", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1209c3d1bc2cac22$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1209c3d1bc2cac22$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $h5rBk = parcelRequire("h5rBk");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $1209c3d1bc2cac22$var$CommonTokenStream = class CommonTokenStream extends $h5rBk.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $2G93d.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $2G93d.Token.EOF) break;
        }
        return n;
    }
};
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "tryLB", null);
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "tryLT", null);
$1209c3d1bc2cac22$var$CommonTokenStream = $1209c3d1bc2cac22$var$__decorate([
    $1209c3d1bc2cac22$var$__param(0, $esDFm.NotNull)
], $1209c3d1bc2cac22$var$CommonTokenStream);
module.exports.CommonTokenStream = $1209c3d1bc2cac22$var$CommonTokenStream;

});

parcelRegister("6gsRs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $48fa9fed976e4bf6$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($48fa9fed976e4bf6$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("4Allj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $356b147161a3df5a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $356b147161a3df5a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $lVdCV = parcelRequire("lVdCV");

var $esDFm = parcelRequire("esDFm");

var $4Q2DM = parcelRequire("4Q2DM");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $356b147161a3df5a$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $lVdCV.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$356b147161a3df5a$var$__decorate([
    $esDFm.Override
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(6, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(5, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(5, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$356b147161a3df5a$var$__decorate([
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.NotNull,
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $356b147161a3df5a$var$DiagnosticErrorListener;

});

parcelRegister("2iaul", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1ab565ff78924252$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $1ab565ff78924252$var$InterpreterRuleContext extends $5NlfZ.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$1ab565ff78924252$var$__decorate([
    $esDFm.Override
], $1ab565ff78924252$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $1ab565ff78924252$var$InterpreterRuleContext;

});

parcelRegister("8I7Eq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $65785e22623bca95$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $65785e22623bca95$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $gTQRB = parcelRequire("gTQRB");

var $kkkg9 = parcelRequire("kkkg9");

var $esDFm = parcelRequire("esDFm");

var $esDFm = parcelRequire("esDFm");
let $65785e22623bca95$var$LexerInterpreter = class LexerInterpreter extends $gTQRB.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $kkkg9.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$65785e22623bca95$var$__decorate([
    $esDFm.NotNull
], $65785e22623bca95$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "atn", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "grammarFileName", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "ruleNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "channelNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "modeNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "vocabulary", null);
$65785e22623bca95$var$LexerInterpreter = $65785e22623bca95$var$__decorate([
    $65785e22623bca95$var$__param(1, $esDFm.NotNull)
], $65785e22623bca95$var$LexerInterpreter);
module.exports.LexerInterpreter = $65785e22623bca95$var$LexerInterpreter;

});

parcelRegister("8tp3s", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $62b4778561d490bb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $62b4778561d490bb$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $arOt9 = parcelRequire("arOt9");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $62b4778561d490bb$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $arOt9.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $2G93d.Token.EOF, "EOF", $2G93d.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $2G93d.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "charPositionInLine", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "nextToken", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "line", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "inputStream", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "sourceName", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull,
    $62b4778561d490bb$var$__param(0, $esDFm.NotNull)
], $62b4778561d490bb$var$ListTokenSource.prototype, "tokenFactory", null);
$62b4778561d490bb$var$ListTokenSource = $62b4778561d490bb$var$__decorate([
    $62b4778561d490bb$var$__param(0, $esDFm.NotNull)
], $62b4778561d490bb$var$ListTokenSource);
module.exports.ListTokenSource = $62b4778561d490bb$var$ListTokenSource;

});

parcelRegister("bvca3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("djIaX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9b1f511704f60b2d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9b1f511704f60b2d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $lVdCV = parcelRequire("lVdCV");

var $d7mTm = parcelRequire("d7mTm");

var $6iuj6 = parcelRequire("6iuj6");

var $2iaul = parcelRequire("2iaul");

var $3fYXW = parcelRequire("3fYXW");

var $esDFm = parcelRequire("esDFm");

var $esDFm = parcelRequire("esDFm");

var $dDGsq = parcelRequire("dDGsq");

var $l4uOS = parcelRequire("l4uOS");

var $lWPhg = parcelRequire("lWPhg");

var $izkyd = parcelRequire("izkyd");

var $2G93d = parcelRequire("2G93d");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $9b1f511704f60b2d$var$ParserInterpreter = class ParserInterpreter extends $dDGsq.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $l4uOS.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $lVdCV.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $l4uOS.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $17Oz4.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $9TBHo.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $lWPhg.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $3fYXW.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $2G93d.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $d7mTm.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $d7mTm.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $2iaul.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $6iuj6.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $2G93d.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $2G93d.Token.INVALID_TYPE, tok.text, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$9b1f511704f60b2d$var$__decorate([
    $esDFm.NotNull
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "reset", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "atn", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "vocabulary", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "ruleNames", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "grammarFileName", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$9b1f511704f60b2d$var$ParserInterpreter = $9b1f511704f60b2d$var$__decorate([
    $9b1f511704f60b2d$var$__param(1, $esDFm.NotNull)
], $9b1f511704f60b2d$var$ParserInterpreter);
module.exports.ParserInterpreter = $9b1f511704f60b2d$var$ParserInterpreter;

});

parcelRegister("gBCh3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c16dca7b4f738f44$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $c16dca7b4f738f44$var$RuleContextWithAltNum extends $5NlfZ.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $lDQMG.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$c16dca7b4f738f44$var$__decorate([
    $esDFm.Override
], $c16dca7b4f738f44$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $c16dca7b4f738f44$var$RuleContextWithAltNum;

});

parcelRegister("9moap", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $6d08ea266c6ae7f4$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $6d08ea266c6ae7f4$var$RuleDependency;

});

parcelRegister("iB1aK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $d89c977dc44fdf68$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $d89c977dc44fdf68$var$RuleVersion;

});

parcelRegister("5fKqt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dAoWy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kKHPj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3sjft", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2842eafbba1c332c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $2842eafbba1c332c$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $4Q2DM.Interval) interval = intervalOrProgram;
        else interval = $4Q2DM.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $2G93d.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $2842eafbba1c332c$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $2842eafbba1c332c$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $2842eafbba1c332c$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $2842eafbba1c332c$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $2842eafbba1c332c$var$TokenStreamRewriter;
$2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$2842eafbba1c332c$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $2842eafbba1c332c$var$RewriteOperation;
class $2842eafbba1c332c$var$InsertBeforeOp extends $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $2G93d.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $2842eafbba1c332c$var$InsertAfterOp extends $2842eafbba1c332c$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $2842eafbba1c332c$var$ReplaceOp extends $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$ReplaceOp.prototype, "execute", null);
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("7twhW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7kyUa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("bFJ48", function(module, exports) {

$parcel$export(module.exports, "JQLLexer", () => $9bd1437ae34b6680$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $es7AZ = parcelRequire("es7AZ");

var $gTQRB = parcelRequire("gTQRB");

var $kkkg9 = parcelRequire("kkkg9");

var $5t4I3 = parcelRequire("5t4I3");

var $g4Hat = parcelRequire("g4Hat");
class $9bd1437ae34b6680$export$375c79404cc64c7f extends (0, $gTQRB.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $5t4I3.VocabularyImpl)($9bd1437ae34b6680$export$375c79404cc64c7f._LITERAL_NAMES, $9bd1437ae34b6680$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $kkkg9.LexerATNSimulator)($9bd1437ae34b6680$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $9bd1437ae34b6680$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $g4Hat.join([
            $9bd1437ae34b6680$export$375c79404cc64c7f._serializedATNSegment0,
            $9bd1437ae34b6680$export$375c79404cc64c7f._serializedATNSegment1,
            $9bd1437ae34b6680$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$9bd1437ae34b6680$export$375c79404cc64c7f.__ATN) $9bd1437ae34b6680$export$375c79404cc64c7f.__ATN = new (0, $es7AZ.ATNDeserializer)().deserialize($g4Hat.toCharArray($9bd1437ae34b6680$export$375c79404cc64c7f._serializedATN));
        return $9bd1437ae34b6680$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("41LBU", function(module, exports) {

$parcel$export(module.exports, "JQLParser", () => $3bedfc54d1944a38$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $es7AZ = parcelRequire("es7AZ");

var $4qcTm = parcelRequire("4qcTm");

var $dDGsq = parcelRequire("dDGsq");

var $5NlfZ = parcelRequire("5NlfZ");

var $l4uOS = parcelRequire("l4uOS");

var $lWPhg = parcelRequire("lWPhg");

var $2G93d = parcelRequire("2G93d");

var $5t4I3 = parcelRequire("5t4I3");

var $g4Hat = parcelRequire("g4Hat");
class $3bedfc54d1944a38$export$9c4772e191bdb810 extends (0, $dDGsq.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $5t4I3.VocabularyImpl)($3bedfc54d1944a38$export$9c4772e191bdb810._LITERAL_NAMES, $3bedfc54d1944a38$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $l4uOS.ParserATNSimulator)($3bedfc54d1944a38$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $3bedfc54d1944a38$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BANG | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $3bedfc54d1944a38$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $3bedfc54d1944a38$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $3bedfc54d1944a38$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $3bedfc54d1944a38$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $3bedfc54d1944a38$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BANG:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.BANG || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $3bedfc54d1944a38$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $3bedfc54d1944a38$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $3bedfc54d1944a38$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $3bedfc54d1944a38$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $3bedfc54d1944a38$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $3bedfc54d1944a38$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $3bedfc54d1944a38$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $3bedfc54d1944a38$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $3bedfc54d1944a38$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.ON | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.DURING | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $3bedfc54d1944a38$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.ON | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.DURING | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $3bedfc54d1944a38$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.FROM | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.TO | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.ON | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.DURING | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $3bedfc54d1944a38$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.EQUALS || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $3bedfc54d1944a38$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.LIKE || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $3bedfc54d1944a38$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.LT | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.GT | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.GTEQ | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $3bedfc54d1944a38$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IN);
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $3bedfc54d1944a38$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $3bedfc54d1944a38$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $3bedfc54d1944a38$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($3bedfc54d1944a38$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $3bedfc54d1944a38$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $3bedfc54d1944a38$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $3bedfc54d1944a38$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $3bedfc54d1944a38$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $3bedfc54d1944a38$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $3bedfc54d1944a38$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $3bedfc54d1944a38$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.STRING - 37 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $3bedfc54d1944a38$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $3bedfc54d1944a38$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $3bedfc54d1944a38$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $3bedfc54d1944a38$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $3bedfc54d1944a38$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $3bedfc54d1944a38$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $3bedfc54d1944a38$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $3bedfc54d1944a38$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $3bedfc54d1944a38$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $3bedfc54d1944a38$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $3bedfc54d1944a38$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $3bedfc54d1944a38$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $3bedfc54d1944a38$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $3bedfc54d1944a38$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $3bedfc54d1944a38$export$9c4772e191bdb810.FROM:
                case $3bedfc54d1944a38$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $3bedfc54d1944a38$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.AFTER | 1 << $3bedfc54d1944a38$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $3bedfc54d1944a38$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $3bedfc54d1944a38$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $3bedfc54d1944a38$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.FROM || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $3bedfc54d1944a38$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $3bedfc54d1944a38$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($3bedfc54d1944a38$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $3bedfc54d1944a38$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $3bedfc54d1944a38$export$9c4772e191bdb810.ASC || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $3bedfc54d1944a38$export$9c4772e191bdb810.ASC || _la === $3bedfc54d1944a38$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$3bedfc54d1944a38$export$9c4772e191bdb810.__ATN) $3bedfc54d1944a38$export$9c4772e191bdb810.__ATN = new (0, $es7AZ.ATNDeserializer)().deserialize($g4Hat.toCharArray($3bedfc54d1944a38$export$9c4772e191bdb810._serializedATN));
        return $3bedfc54d1944a38$export$9c4772e191bdb810.__ATN;
    }
}
class $3bedfc54d1944a38$export$ff413535b9575c8 extends (0, $5NlfZ.ParserRuleContext) {
    EOF() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$4148a879cab28017 extends (0, $5NlfZ.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$d69831d387793480 extends (0, $5NlfZ.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$f16819001158b9e);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.OR);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$f16819001158b9e extends (0, $5NlfZ.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.AND);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$5e9146f8d5cf1330 extends (0, $5NlfZ.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$a136a0e9655bfb04 extends (0, $5NlfZ.ParserRuleContext) {
    LPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$23486a2f2ddd5bcd extends (0, $5NlfZ.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$93924a205c12d32c extends (0, $5NlfZ.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $3bedfc54d1944a38$export$c428f709a58396e5 extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$1b131204ef9fa33d extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$d83706ee80a9852a extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$2934b8ff22fddd2d extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$8b84310182afcf93 extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$5df295dc7a2cac7c extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$9ac3367aee261b32 extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$7a7defca8628a13c extends $3bedfc54d1944a38$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$e77e479a48133015);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$41e475fc1988e413 extends (0, $5NlfZ.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b76fe5387fdd7efd extends (0, $5NlfZ.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$d821da0716b3ec95 extends (0, $5NlfZ.ParserRuleContext) {
    LT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$178478bfa8292f72 extends (0, $5NlfZ.ParserRuleContext) {
    IN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$e64c31d2830b66e4 extends (0, $5NlfZ.ParserRuleContext) {
    IS() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$7e283636700e4a6c extends (0, $5NlfZ.ParserRuleContext) {
    WAS() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b9118b1ed9a78d66 extends (0, $5NlfZ.ParserRuleContext) {
    WAS() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$493d626ed78ca66 extends (0, $5NlfZ.ParserRuleContext) {
    CHANGED() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b33300c3d916229a extends (0, $5NlfZ.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $3bedfc54d1944a38$export$11fec15307d2e17b extends $3bedfc54d1944a38$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b8b24f99f985ebb3 extends $3bedfc54d1944a38$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$b02d0b6637ce0593 extends (0, $5NlfZ.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$401a038855cc5b15 extends (0, $5NlfZ.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$bde73d8ad7c8b71e extends (0, $5NlfZ.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$8737d94a1880e8b3 extends (0, $5NlfZ.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$2eaac5a9828bf647 extends (0, $5NlfZ.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$d85a062f90025e5c extends (0, $5NlfZ.ParserRuleContext) {
    EMPTY() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$2e17d457b0933bec extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$ebf0cc785e9ee41a extends (0, $5NlfZ.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$1f5f7ac816788f44 extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$83d7c13849b931c3 extends (0, $5NlfZ.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$a95583953c237f88);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$9cb97a63f2be4864 extends (0, $5NlfZ.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$c419f717bfc46a5d extends (0, $5NlfZ.ParserRuleContext) {
    LPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$f6cd3e372f5ab120 extends (0, $5NlfZ.ParserRuleContext) {
    RPAREN() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$e20ce4a2ed16372c extends (0, $5NlfZ.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$a95583953c237f88 extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$9fa1e4d63f31b911 extends (0, $5NlfZ.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$e77e479a48133015 extends (0, $5NlfZ.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $3bedfc54d1944a38$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$dc01290aee731418 extends (0, $5NlfZ.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$75412b8b6a6442e1 extends (0, $5NlfZ.ParserRuleContext) {
    DURING() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$ad402332075c8656 extends (0, $5NlfZ.ParserRuleContext) {
    BY() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$4239d7c0fbafd3f1 extends (0, $5NlfZ.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$6b796c5a4b8c18e extends (0, $5NlfZ.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$534469b9c8f44139 extends (0, $5NlfZ.ParserRuleContext) {
    ORDER() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($3bedfc54d1944a38$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $3bedfc54d1944a38$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA);
        else return this.getToken($3bedfc54d1944a38$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $3bedfc54d1944a38$export$c7d8f03f36952a46 extends (0, $5NlfZ.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $3bedfc54d1944a38$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($3bedfc54d1944a38$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $3bedfc54d1944a38$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("cWGfC", function(module, exports) {

$parcel$export(module.exports, "JastBuilderErrorListener", () => $8ed05ca5be2fe9a4$export$d0857f60ff1f385);

var $ax34Q = parcelRequire("ax34Q");

var $cic90 = parcelRequire("cic90");
class $8ed05ca5be2fe9a4$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $ax34Q.JQLParseError)(msg));
            else this.errors.push(new (0, $cic90.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("ax34Q", function(module, exports) {

$parcel$export(module.exports, "JQLParseError", () => $9e9c710caa518509$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $9e9c710caa518509$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("cic90", function(module, exports) {

$parcel$export(module.exports, "JQLSyntaxError", () => $c6a39dd8b4312990$export$3276184116160c41);

var $ax34Q = parcelRequire("ax34Q");
class $c6a39dd8b4312990$export$3276184116160c41 extends (0, $ax34Q.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("cjb70", function(module, exports) {

$parcel$export(module.exports, "QueryVisitor", () => $2a1afdbc2890cabf$export$418003b930734805);

var $f26C8 = parcelRequire("f26C8");

var $hGsJJ = parcelRequire("hGsJJ");

var $15Hkp = parcelRequire("15Hkp");

var $9J9F3 = parcelRequire("9J9F3");
class $2a1afdbc2890cabf$export$418003b930734805 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.whereVisitor = new (0, $9J9F3.WhereVisitor)(this.tokens), this.orderByVisitor = new (0, $15Hkp.OrderByVisitor)(this.tokens), this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $f26C8.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("hGsJJ", function(module, exports) {

$parcel$export(module.exports, "JastBuildingVisitor", () => $fd8c709f2549b18d$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $fd8c709f2549b18d$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $fd8c709f2549b18d$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $fd8c709f2549b18d$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $fd8c709f2549b18d$export$7c2714a5250b9239);
class $fd8c709f2549b18d$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $fd8c709f2549b18d$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $fd8c709f2549b18d$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $fd8c709f2549b18d$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$fd8c709f2549b18d$export$85a4e6d858dbc6fb(node.payload));
const $fd8c709f2549b18d$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("15Hkp", function(module, exports) {

$parcel$export(module.exports, "OrderByVisitor", () => $597e371973c3cf34$export$2774b71b99734811);


var $f26C8 = parcelRequire("f26C8");

var $dlsVE = parcelRequire("dlsVE");

var $hGsJJ = parcelRequire("hGsJJ");

var $8Iahr = parcelRequire("8Iahr");
class $597e371973c3cf34$export$2774b71b99734811 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.searchSortVisitor = new $597e371973c3cf34$var$SearchSortVisitor(this.tokens), this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $f26C8.internalCreators).orderByOperator((0, $hGsJJ.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $dlsVE.notUndefined));
            return (0, $f26C8.internalCreators).orderBy(fields, operator, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $597e371973c3cf34$var$SearchSortVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $8Iahr.FieldVisitor)(this.tokens), this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $f26C8.internalCreators).orderByDirection((0, $adec16a85d57f51f$export$2ea27ea5f2121899), (0, $hGsJJ.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $f26C8.internalCreators).orderByDirection((0, $adec16a85d57f51f$export$6d60017b9e092e73), (0, $hGsJJ.getPositionFromToken)(asc.payload));
            return (0, $f26C8.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("dlsVE", function(module, exports) {

$parcel$export(module.exports, "notUndefined", () => $66fcbe4c481eea3d$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $66fcbe4c481eea3d$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("8Iahr", function(module, exports) {

$parcel$export(module.exports, "FieldVisitor", () => $30d306b6cc02da67$export$c6a85c4c3bf2317d);

var $f26C8 = parcelRequire("f26C8");

var $6BLGV = parcelRequire("6BLGV");

var $hGsJJ = parcelRequire("hGsJJ");

var $3wodm = parcelRequire("3wodm");
class $30d306b6cc02da67$export$c6a85c4c3bf2317d extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $3wodm.StringVisitor)(this.tokens), this.fieldPropertyVisitor = new $30d306b6cc02da67$var$FieldPropertyVisitor(this.tokens), this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $f26C8.internalCreators).field(text, text, undefined, (0, $hGsJJ.getPositionFromContext)(ctx));
        }, this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $f26C8.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $f26C8.internalCreators).field(text, text, properties, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $30d306b6cc02da67$var$FieldPropertyVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $6BLGV.ArgumentVisitor)(this.tokens), this.propertyArgumentVisitor = new $30d306b6cc02da67$var$PropertyArgumentVisitor(this.tokens), this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $f26C8.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $30d306b6cc02da67$var$PropertyArgumentVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $6BLGV.ArgumentVisitor)(this.tokens), this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("6BLGV", function(module, exports) {

$parcel$export(module.exports, "ArgumentVisitor", () => $6751b6f00c118d3b$export$46b5a1f6d962d533);

var $f26C8 = parcelRequire("f26C8");

var $hGsJJ = parcelRequire("hGsJJ");

var $3wodm = parcelRequire("3wodm");
class $6751b6f00c118d3b$export$46b5a1f6d962d533 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $3wodm.StringVisitor)(this.tokens), this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $f26C8.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $f26C8.internalCreators).argument(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("3wodm", function(module, exports) {

$parcel$export(module.exports, "StringVisitor", () => $d977c104e06c125d$export$617850cb96304515);

var $hGsJJ = parcelRequire("hGsJJ");
class $d977c104e06c125d$export$617850cb96304515 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $hGsJJ.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("9J9F3", function(module, exports) {

$parcel$export(module.exports, "WhereVisitor", () => $1f45af89f25f3114$export$c573472f1d20e15d);


var $f26C8 = parcelRequire("f26C8");

var $dlsVE = parcelRequire("dlsVE");

var $hGsJJ = parcelRequire("hGsJJ");

var $715r8 = parcelRequire("715r8");
class $1f45af89f25f3114$export$c573472f1d20e15d extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.terminalClauseVisitor = new (0, $715r8.TerminalClauseVisitor)(this.tokens), this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        }, this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $dlsVE.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $f26C8.internalCreators).compoundOperator((0, $f6415dda43b7f459$export$7b8f0a728d79a753), (0, $hGsJJ.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $f26C8.internalCreators).compoundClause(operator, clauses, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $dlsVE.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $f26C8.internalCreators).compoundOperator((0, $f6415dda43b7f459$export$6d6d48d210d3ca97), (0, $hGsJJ.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $f26C8.internalCreators).compoundClause(operator, clauses, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $f26C8.internalCreators).notClause(clause, (0, $f26C8.internalCreators).notClauseOperator((0, $hGsJJ.getPositionFromToken)(notToken.payload)), (0, $hGsJJ.getPositionFromContext)(ctx));
            return clause;
        }, this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
parcelRegister("715r8", function(module, exports) {

$parcel$export(module.exports, "TerminalClauseVisitor", () => $663e4a591a2538f3$export$14576ae5bd1874a9);

var $f26C8 = parcelRequire("f26C8");

var $dlsVE = parcelRequire("dlsVE");

var $hGsJJ = parcelRequire("hGsJJ");

var $8Iahr = parcelRequire("8Iahr");

var $gXyzc = parcelRequire("gXyzc");

var $izFrb = parcelRequire("izFrb");

var $8oPHJ = parcelRequire("8oPHJ");
class $663e4a591a2538f3$export$14576ae5bd1874a9 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $8Iahr.FieldVisitor)(this.tokens), this.terminalClauseRhsVisitor = new $663e4a591a2538f3$var$TerminalClauseRhsVisitor(this.tokens), this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $hGsJJ.getPositionFromContext)(ctx);
            return (0, $f26C8.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $663e4a591a2538f3$var$TerminalClauseRhsVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operatorVisitor = new (0, $izFrb.OperatorVisitor)(this.tokens), this.terminalClauseOperandVisitor = new $663e4a591a2538f3$var$TerminalClauseOperandVisitor(this.tokens), this.predicateVisitor = new (0, $8oPHJ.PredicateVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $dlsVE.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $dlsVE.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $dlsVE.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        }, // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $663e4a591a2538f3$var$TerminalClauseOperandVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $gXyzc.OperandVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        }, this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $dlsVE.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("gXyzc", function(module, exports) {

$parcel$export(module.exports, "OperandVisitor", () => $5b99f195f57794e4$export$ef8ae1aa15d9c9af);


var $f26C8 = parcelRequire("f26C8");

var $dlsVE = parcelRequire("dlsVE");

var $6BLGV = parcelRequire("6BLGV");

var $hGsJJ = parcelRequire("hGsJJ");

var $lkyYt = parcelRequire("lkyYt");

var $3wodm = parcelRequire("3wodm");
class $5b99f195f57794e4$export$ef8ae1aa15d9c9af extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $3wodm.StringVisitor)(this.tokens), this.numberVisitor = new (0, $lkyYt.NumberVisitor)(this.tokens), this.functionNameVisitor = new $5b99f195f57794e4$var$FunctionNameVisitor(this.tokens), this.argumentListVisitor = new $5b99f195f57794e4$var$ArgumentListVisitor(this.tokens), this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $dlsVE.notUndefined));
            return operandContext?.accept(this);
        }, this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $f26C8.internalCreators).keywordOperand((0, $862dfd240457f00b$export$1c46dca02aac24dd), (0, $hGsJJ.getPositionFromToken)(ctx.EMPTY().payload));
        }, this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $f26C8.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        }, this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $dlsVE.notUndefined));
            return (0, $f26C8.internalCreators).listOperand(values, (0, $hGsJJ.getPositionFromContext)(ctx));
        }, this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $f26C8.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $5b99f195f57794e4$var$FunctionNameVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $3wodm.StringVisitor)(this.tokens), this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $f26C8.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $f26C8.internalCreators).functionString(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
            }
        };
    }
}
class $5b99f195f57794e4$var$ArgumentListVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $6BLGV.ArgumentVisitor)(this.tokens), this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("lkyYt", function(module, exports) {

$parcel$export(module.exports, "NumberVisitor", () => $13b9a4d8a58447ff$export$a55432f0884633e4);

var $f26C8 = parcelRequire("f26C8");

var $hGsJJ = parcelRequire("hGsJJ");
class $13b9a4d8a58447ff$export$a55432f0884633e4 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $f26C8.internalCreators).valueOperand(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("izFrb", function(module, exports) {

$parcel$export(module.exports, "OperatorVisitor", () => $a4639125907d4fdb$export$e56f89ba95b51d2a);

var $f26C8 = parcelRequire("f26C8");

var $8okjU = parcelRequire("8okjU");

var $hGsJJ = parcelRequire("hGsJJ");
class $a4639125907d4fdb$export$e56f89ba95b51d2a extends (0, $hGsJJ.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $8okjU.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $f26C8.internalCreators).operator(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $8okjU.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $f26C8.internalCreators).operator(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $8okjU.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $f26C8.internalCreators).operator(text, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $hGsJJ.normalizeText)(text);
        if (!(0, $8okjU.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $f26C8.internalCreators).operator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args), // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $hGsJJ.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $hGsJJ.getPositionFromToken)(startToken, stopToken);
                if ((0, $8okjU.isOperator)(value)) return (0, $f26C8.internalCreators).operator(value, text, position);
            }
        };
    }
}

});
parcelRegister("8okjU", function(module, exports) {

$parcel$export(module.exports, "isOperator", () => $b8349c898e9c75d9$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $b8349c898e9c75d9$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $b8349c898e9c75d9$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $b8349c898e9c75d9$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $b8349c898e9c75d9$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $b8349c898e9c75d9$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $b8349c898e9c75d9$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $b8349c898e9c75d9$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $b8349c898e9c75d9$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $b8349c898e9c75d9$export$b09522e4061bbdd6);

var $jPlb3 = parcelRequire("jPlb3");
const $b8349c898e9c75d9$export$4e40859592ee7ac2 = (operator)=>(0, $jPlb3.OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$6d0fc196fa8a1673 = (operator)=>(0, $jPlb3.EQUALS_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$ad91b6d6a89cb64e = (operator)=>(0, $jPlb3.LIKE_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$4477c442bd5c2a6d = (operator)=>(0, $jPlb3.COMPARISON_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$c5e1cdef30e30bff = (operator)=>(0, $jPlb3.IN_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$ccc3334744e395c7 = (operator)=>(0, $jPlb3.IS_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$2b1c5d7e7856f91d = (operator)=>(0, $jPlb3.WAS_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$55d8c9b20d99509f = (operator)=>(0, $jPlb3.WAS_IN_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$b65d23d23ade534b = (operator)=>(0, $jPlb3.CHANGED_OPERATORS).includes(operator);
const $b8349c898e9c75d9$export$b09522e4061bbdd6 = (operator)=>(0, $jPlb3.LIST_OPERATORS).includes(operator);

});


parcelRegister("8oPHJ", function(module, exports) {

$parcel$export(module.exports, "PredicateVisitor", () => $420de384afcf5c4a$export$33bb52a35c693109);

var $f26C8 = parcelRequire("f26C8");

var $3uowR = parcelRequire("3uowR");

var $dlsVE = parcelRequire("dlsVE");

var $hGsJJ = parcelRequire("hGsJJ");

var $gXyzc = parcelRequire("gXyzc");
class $420de384afcf5c4a$export$33bb52a35c693109 extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.predicateOperatorVisitor = new $420de384afcf5c4a$var$PredicateOperatorVisitor(this.tokens), this.predicateOperandVisitor = new $420de384afcf5c4a$var$PredicateOperandVisitor(this.tokens), this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $hGsJJ.getPositionFromContext)(ctx);
            return (0, $f26C8.internalCreators).predicate(operator, operand, position);
        }, this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $hGsJJ.getPositionFromContext)(ctx);
            return (0, $f26C8.internalCreators).predicate(operator, operand, position);
        }, this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $dlsVE.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $420de384afcf5c4a$var$PredicateOperatorVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $3uowR.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $f26C8.internalCreators).predicateOperator(value, text, (0, $hGsJJ.getPositionFromContext)(ctx));
        };
    }
}
class $420de384afcf5c4a$var$PredicateOperandVisitor extends (0, $hGsJJ.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $gXyzc.OperandVisitor)(this.tokens), this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("3uowR", function(module, exports) {

$parcel$export(module.exports, "isPredicateOperator", () => $577d846c3e6a050f$export$188978ad94919403);

var $cd96m = parcelRequire("cd96m");
const $577d846c3e6a050f$export$188978ad94919403 = (operator)=>(0, $cd96m.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("cd96m", function(module, exports) {

$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $6fe28dbc2f8a0a99$export$e200440af9f1d9f);
const $6fe28dbc2f8a0a99$export$3d56e2ae1b4bbbf9 = 'after';
const $6fe28dbc2f8a0a99$export$f0a816341603bb63 = 'before';
const $6fe28dbc2f8a0a99$export$cdc81c84f768d513 = 'by';
const $6fe28dbc2f8a0a99$export$8a5280c65e704c3d = 'during';
const $6fe28dbc2f8a0a99$export$71f882dcac65f97a = 'from';
const $6fe28dbc2f8a0a99$export$5685a35c6b0a7ee8 = 'on';
const $6fe28dbc2f8a0a99$export$5a83c4789e531a = 'to';
const $6fe28dbc2f8a0a99$export$e200440af9f1d9f = [
    $6fe28dbc2f8a0a99$export$3d56e2ae1b4bbbf9,
    $6fe28dbc2f8a0a99$export$f0a816341603bb63,
    $6fe28dbc2f8a0a99$export$cdc81c84f768d513,
    $6fe28dbc2f8a0a99$export$8a5280c65e704c3d,
    $6fe28dbc2f8a0a99$export$71f882dcac65f97a,
    $6fe28dbc2f8a0a99$export$5685a35c6b0a7ee8,
    $6fe28dbc2f8a0a99$export$5a83c4789e531a
];

});







parcelRegister("1jiqw", function(module, exports) {

$parcel$export(module.exports, "print", () => $c24354720bbe7250$export$c2d084dc44961371);

var $8sbs2 = parcelRequire("8sbs2");

var $9xrcu = parcelRequire("9xrcu");

var $gWLgz = parcelRequire("gWLgz");
const $c24354720bbe7250$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gWLgz.printDocToString)((0, $9xrcu.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("9xrcu", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $4d18f5eec7d6c329$export$f0ef38932978952);


var $dl9fK = parcelRequire("dl9fK");

var $b8gMN = parcelRequire("b8gMN");
const $4d18f5eec7d6c329$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $4d18f5eec7d6c329$export$27a275559a5c8102 extends (0, $dl9fK.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $b8gMN.ifBreak)((0, $b8gMN.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $b8gMN.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $b8gMN.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $b8gMN.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $b8gMN.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $4d18f5eec7d6c329$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $b8gMN.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $b8gMN.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $b8gMN.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $b8gMN.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $b8gMN.group)([
            query.where.accept(this),
            (0, $b8gMN.ifBreak)((0, $b8gMN.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $b8gMN.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $b8gMN.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $4d18f5eec7d6c329$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $4d18f5eec7d6c329$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("dl9fK", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $eca78231bf7c6646$export$51be62b46ee668fd);
class $eca78231bf7c6646$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("b8gMN", function(module, exports) {

$parcel$export(module.exports, "group", () => $5fbb607da15f7724$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $5fbb607da15f7724$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $5fbb607da15f7724$export$dc84f6841f96b7da);
const $5fbb607da15f7724$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $5fbb607da15f7724$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $5fbb607da15f7724$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gWLgz", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $ae252d48f146c7f1$export$316fc7e94b95b118);
const $ae252d48f146c7f1$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $ae252d48f146c7f1$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $ae252d48f146c7f1$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $ae252d48f146c7f1$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $ae252d48f146c7f1$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $ae252d48f146c7f1$var$printGroup(doc, context);
        case 'if-break':
            return $ae252d48f146c7f1$var$printIfBreak(doc, context);
        case 'new-line':
            return $ae252d48f146c7f1$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $ae252d48f146c7f1$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $ae252d48f146c7f1$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $ae252d48f146c7f1$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $ae252d48f146c7f1$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $ae252d48f146c7f1$var$printDoc(doc.breakContents, context);
    return $ae252d48f146c7f1$var$printDoc(doc.flatContents, context);
};
const $ae252d48f146c7f1$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $ae252d48f146c7f1$var$defaultPrintWidth = 100;
const $ae252d48f146c7f1$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $ae252d48f146c7f1$var$defaultPrintWidth } = options;
    const output = $ae252d48f146c7f1$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});



parcelRegister("dFdvS", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $b3fa99eb812b8349$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "fetchCollection", () => $b3fa99eb812b8349$export$efeb96fc7f2aeaf9);
$parcel$export(module.exports, "fetchAllCollections", () => $b3fa99eb812b8349$export$fb62ec897a9d1e05);
$parcel$export(module.exports, "deleteCollection", () => $b3fa99eb812b8349$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $b3fa99eb812b8349$export$c0683150b517c317);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $b3fa99eb812b8349$export$4ead91e2f6058f41);
$parcel$export(module.exports, "fetchCollectionDescription", () => $b3fa99eb812b8349$export$8cd86b5346d1e786);
$parcel$export(module.exports, "cloneCollection", () => $b3fa99eb812b8349$export$d753eba18153f51e);
$parcel$export(module.exports, "getIdeasCountForCollection", () => $b3fa99eb812b8349$export$d355ccab36abee74);

var $1Ozm9 = parcelRequire("1Ozm9");

var $jGzN3 = parcelRequire("jGzN3");

var $jbIuO = parcelRequire("jbIuO");

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $gtzis = parcelRequire("gtzis");

var $5AElp = parcelRequire("5AElp");
const $b3fa99eb812b8349$var$generateProjectKeys = (jql)=>{
    return (0, $gtzis.extractProjectKeysFromJql)(jql);
};
const $b3fa99eb812b8349$export$c74125a8e3af6bb2 = (collectionToCreate)=>(0, $jGzN3.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections`, {
        body: JSON.stringify(collectionToCreate)
    }).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(response.jql),
            filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(response.jql)
        }));
const $b3fa99eb812b8349$export$efeb96fc7f2aeaf9 = (collectionUUID, shouldIncludeViews = false)=>(0, $1Ozm9.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}${shouldIncludeViews ? '?expand=views' : ''}`).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            views: response.views?.map((0, $5AElp.transformView)),
            projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(response.jql),
            filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(response.jql)
        }));
const $b3fa99eb812b8349$export$fb62ec897a9d1e05 = ()=>(0, $1Ozm9.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections`).then(({ collections: collections })=>collections.map((collection)=>({
                uuid: collection.uuid,
                name: collection.name,
                emoji: collection.emoji,
                color: collection.color,
                jql: collection.jql,
                ownerId: collection.owner,
                projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(collection.jql),
                filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(collection.jql)
            })));
const $b3fa99eb812b8349$export$3d16e031f6551662 = async (collectionUUID)=>{
    await (0, $jGzN3.performDeleteRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`);
};
const $b3fa99eb812b8349$export$c0683150b517c317 = async (collectionUUID, collectionToUpdate)=>{
    await (0, $jGzN3.performPutRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`, {
        body: JSON.stringify(collectionToUpdate)
    });
};
const $b3fa99eb812b8349$export$4ead91e2f6058f41 = (collectionsUUIDs)=>(0, $jGzN3.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/views-count`, {
        body: JSON.stringify({
            uuids: collectionsUUIDs
        })
    });
const $b3fa99eb812b8349$export$8cd86b5346d1e786 = (collectionUUID)=>(0, $1Ozm9.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/description`);
const $b3fa99eb812b8349$export$d753eba18153f51e = (collectionUUID, newCollectionName)=>(0, $jGzN3.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/clone`, {
        body: JSON.stringify({
            name: newCollectionName
        })
    });
const $b3fa99eb812b8349$export$d355ccab36abee74 = (jql)=>(0, $jGzN3.performPostRequest)('/rest/polaris/issues/searchCountForJql', {
        body: JSON.stringify({
            jql: jql,
            archived: 'ACTIVE_ONLY'
        })
    }).then((response)=>response.count).catch((error)=>{
        (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.getIdeasCountForCollectionFailed', error));
        throw error;
    });

});
parcelRegister("5AElp", function(module, exports) {

$parcel$export(module.exports, "transformView", () => $8a756033577bb028$export$601ea8be46c5c28c);
const $8a756033577bb028$export$601ea8be46c5c28c = (view)=>({
        uuid: view.uuid,
        ownerId: view.owner,
        kind: view.visualizationType,
        title: view.name,
        emoji: view.emoji,
        description: view.description,
        apiResponse: view
    });

});



parcelRegister("h2BRl", function(module, exports) {

$parcel$export(module.exports, "createView", () => $5dac4001e33bc8d8$export$d7febe7b891e79f0);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $5dac4001e33bc8d8$export$4ead91e2f6058f41);
$parcel$export(module.exports, "deleteView", () => $5dac4001e33bc8d8$export$443d89549b135c95);

var $huH03 = parcelRequire("huH03");

var $gYnSx = parcelRequire("gYnSx");

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $7e8wG = parcelRequire("7e8wG");

var $dFdvS = parcelRequire("dFdvS");

var $l7vPF = parcelRequire("l7vPF");
const $5dac4001e33bc8d8$export$d7febe7b891e79f0 = (collectionUUID, view)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const existingCollection = state.collections[collectionUUID];
            const data = existingCollection?.data;
            if (!data) return;
            return await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.createView, async ()=>{
                const newView = await (0, $l7vPF.createView)(collectionUUID, view);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: {
                                ...data,
                                views: [
                                    ...data?.views || [],
                                    newView
                                ]
                            }
                        }
                    }
                });
                return newView;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionViewCreationFailed', error));
                throw error;
            }
        }
    };
const $5dac4001e33bc8d8$export$4ead91e2f6058f41 = ()=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const collectionsUUIDs = Object.keys(state.collections);
        if (collectionsUUIDs.length === 0) return;
        try {
            await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.loadViewCount, async ()=>{
                const collectionsViewsCountMap = await (0, $dFdvS.fetchCollectionsViewsCounts)(collectionsUUIDs);
                setState({
                    collections: (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(state.collections, (collection)=>{
                        if (collection?.data) return {
                            ...collection,
                            data: {
                                ...collection.data,
                                viewsCount: collectionsViewsCountMap[collection.data.uuid] || 0
                            }
                        };
                        return collection;
                    })
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionsViewsCountLoadingFailed', error));
            throw error;
        }
    };
const $5dac4001e33bc8d8$export$443d89549b135c95 = (collectionUUID, viewUUID)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const existingCollection = state.collections[collectionUUID];
            const data = existingCollection?.data;
            if (!data) return;
            await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.deleteView, async ()=>{
                await (0, $l7vPF.deleteView)(collectionUUID, viewUUID);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: {
                                ...data,
                                viewsCount: data.viewsCount ? data.viewsCount - 1 : undefined,
                                views: data?.views?.filter((view)=>view.uuid !== viewUUID)
                            }
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionViewDeletionFailed', error));
                throw error;
            }
        }
    };

});
parcelRegister("l7vPF", function(module, exports) {

$parcel$export(module.exports, "createView", () => $effb13e1705e51cf$export$d7febe7b891e79f0);
$parcel$export(module.exports, "deleteView", () => $effb13e1705e51cf$export$443d89549b135c95);

var $jGzN3 = parcelRequire("jGzN3");

var $jbIuO = parcelRequire("jbIuO");

var $5AElp = parcelRequire("5AElp");
const $effb13e1705e51cf$export$d7febe7b891e79f0 = (collectionUUID, viewToCreate)=>(0, $jGzN3.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views`, {
        body: JSON.stringify(viewToCreate)
    }).then((0, $5AElp.transformView));
const $effb13e1705e51cf$export$443d89549b135c95 = async (collectionUUID, viewUUID)=>{
    await (0, $jGzN3.performDeleteRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views/${viewUUID}`);
};

});


parcelRegister("2WnXd", function(module, exports) {

$parcel$export(module.exports, "loadCollectionDescription", () => $74ca0f1a0621ac97$export$da25d48c64ab9a24);
$parcel$export(module.exports, "updateCollectionDescription", () => $74ca0f1a0621ac97$export$95146d83152efba8);

var $gYnSx = parcelRequire("gYnSx");

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $7e8wG = parcelRequire("7e8wG");

var $dFdvS = parcelRequire("dFdvS");
const $74ca0f1a0621ac97$export$da25d48c64ab9a24 = (collectionUUID)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingDescription = state.descriptions[collectionUUID];
        if (existingDescription?.isLoading || existingDescription && !existingDescription.error) return;
        try {
            await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.loadCollectionDescription, async ()=>{
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: undefined,
                            isLoading: true,
                            error: undefined
                        }
                    }
                });
                const newDescription = await (0, $dFdvS.fetchCollectionDescription)(collectionUUID);
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: newDescription ?? undefined,
                            isLoading: false
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionDescriptionLoadingFailed', error));
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: undefined,
                            isLoading: false,
                            error: error
                        }
                    }
                });
            }
            throw error;
        }
    };
const $74ca0f1a0621ac97$export$95146d83152efba8 = (collectionUUID, description)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID];
        const data = existingCollection?.data;
        if (!data) return;
        try {
            await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.updateCollectionDescription, async ()=>{
                await (0, $dFdvS.updateCollection)(collectionUUID, {
                    ...data,
                    description: description
                });
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            isLoading: false,
                            error: undefined,
                            description: description
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionDescriptionUpdateFailed', error));
            throw error;
        }
    };

});


parcelRegister("g4I3Q", function(module, exports) {

$parcel$export(module.exports, "filterCollectionByOwnerIds", () => $451b093972638939$export$a5af2fa2fc5a6608);
$parcel$export(module.exports, "filterCollectionByProjectKeys", () => $451b093972638939$export$197fb91166111e5e);
$parcel$export(module.exports, "filterCollectionByText", () => $451b093972638939$export$29aabb123440d65b);
const $451b093972638939$export$a5af2fa2fc5a6608 = (ownerIds)=>(collection)=>!ownerIds?.length || ownerIds.some((accountId)=>accountId === collection.ownerId);
const $451b093972638939$export$197fb91166111e5e = (projectKeys)=>(collection)=>!projectKeys?.length || projectKeys.some((projectKey)=>collection.projectKeys.includes(projectKey));
const $451b093972638939$export$29aabb123440d65b = (search = '')=>{
    const searchLower = search.toLocaleLowerCase();
    return ({ name: name })=>!search || name?.toLocaleLowerCase().includes(searchLower);
};

});


parcelRegister("ftsgu", function(module, exports) {

$parcel$export(module.exports, "useUsersActions", () => $d3eb147b4444cb03$export$ce5232cfdede81f9);
$parcel$export(module.exports, "useUsersLoading", () => $d3eb147b4444cb03$export$b692480955bb2db9);
$parcel$export(module.exports, "useUsersHasError", () => $d3eb147b4444cb03$export$4e610026de3ff756);
$parcel$export(module.exports, "useUsers", () => $d3eb147b4444cb03$export$90f4370c54dd43c9);
$parcel$export(module.exports, "useUser", () => $d3eb147b4444cb03$export$23bbbc4533528f03);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $kDg2U = parcelRequire("kDg2U");
const $d3eb147b4444cb03$var$initialState = {
    users: {},
    isLoading: false,
    error: undefined
};
const $d3eb147b4444cb03$var$Store = (0, $GtRbT.createStore)({
    initialState: $d3eb147b4444cb03$var$initialState,
    actions: $kDg2U,
    name: 'PolarisCollectionsUsers'
});
const $d3eb147b4444cb03$export$ce5232cfdede81f9 = (0, $iJq0l.createActionsHook)($d3eb147b4444cb03$var$Store);
const $d3eb147b4444cb03$var$getUsers = (state)=>state.users;
const $d3eb147b4444cb03$var$getUsersList = (0, $4MchI.createSelector)($d3eb147b4444cb03$var$getUsers, (users)=>Object.values(users).map((u)=>u).filter(Boolean));
const $d3eb147b4444cb03$var$getUsersLoading = (state)=>state.isLoading;
const $d3eb147b4444cb03$var$getUsersError = (state)=>state.error;
const $d3eb147b4444cb03$var$getUsersHasError = (0, $4MchI.createSelector)($d3eb147b4444cb03$var$getUsersError, (error)=>!!error);
const $d3eb147b4444cb03$var$getUserById = (0, $4MchI.createSelector)($d3eb147b4444cb03$var$getUsers, (_, accountId)=>accountId, (users, accountId)=>users[accountId]);
const $d3eb147b4444cb03$export$b692480955bb2db9 = (0, $iJq0l.createStateHook)($d3eb147b4444cb03$var$Store, {
    selector: $d3eb147b4444cb03$var$getUsersLoading
});
const $d3eb147b4444cb03$export$4e610026de3ff756 = (0, $iJq0l.createStateHook)($d3eb147b4444cb03$var$Store, {
    selector: $d3eb147b4444cb03$var$getUsersHasError
});
const $d3eb147b4444cb03$export$9f9fc69c60c8ea5b = (0, $iJq0l.createStateHook)($d3eb147b4444cb03$var$Store, {
    selector: $d3eb147b4444cb03$var$getUsersList
});
const $d3eb147b4444cb03$export$90f4370c54dd43c9 = (0, $iJq0l.createStateHook)($d3eb147b4444cb03$var$Store, {
    selector: $d3eb147b4444cb03$var$getUsers
});
const $d3eb147b4444cb03$export$23bbbc4533528f03 = (0, $iJq0l.createStateHook)($d3eb147b4444cb03$var$Store, {
    selector: $d3eb147b4444cb03$var$getUserById
});

});
parcelRegister("kDg2U", function(module, exports) {

$parcel$export(module.exports, "loadUsers", () => $e58f239d0166419a$export$2c3a8e05396a78be);

var $9g7yh = parcelRequire("9g7yh");

var $gYnSx = parcelRequire("gYnSx");

var $b5oGV = parcelRequire("b5oGV");

var $8XCY1 = parcelRequire("8XCY1");

var $7e8wG = parcelRequire("7e8wG");

var $k35cN = parcelRequire("k35cN");
const $e58f239d0166419a$export$2c3a8e05396a78be = (accountIds)=>async ({ setState: setState, getState: getState })=>{
        if (accountIds.length === 0) return;
        const state = getState();
        if (accountIds.every((accountId)=>state.users[accountId])) return;
        try {
            await (0, $8XCY1.wrapWithExperience)((0, $b5oGV.experience).collections.loadUsers, async ()=>{
                setState({
                    isLoading: true
                });
                const users = await (0, $k35cN.fetchUsers)(accountIds);
                setState({
                    users: (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(users, 'accountId'),
                    isLoading: false
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.collectionUsersLoadingFailed', error));
                setState({
                    isLoading: false,
                    error: error
                });
            }
            throw error;
        }
    };

});
parcelRegister("k35cN", function(module, exports) {

$parcel$export(module.exports, "fetchUsers", () => $ec30722de131ae7d$export$2bb8333a9210be15);

var $1Ozm9 = parcelRequire("1Ozm9");
const $ec30722de131ae7d$export$6081577a3e8cd046 = (accountIds)=>{
    const mainQuery = new URLSearchParams(accountIds.map((accountId)=>[
            'accountId',
            accountId
        ]));
    mainQuery.append('maxResults', '200');
    return `${mainQuery}`;
};
const $ec30722de131ae7d$export$2bb8333a9210be15 = async (accountIds)=>{
    const query = $ec30722de131ae7d$export$6081577a3e8cd046(accountIds);
    return (0, $1Ozm9.default)(`/rest/api/3/user/bulk?${query}`).then((response)=>response.values);
};

});




parcelRegister("iB16t", function(module, exports) {

$parcel$export(module.exports, "useHasSeenView", () => $98f4ac59dddaf5e2$export$c85a728fcd2c10ae);
$parcel$export(module.exports, "useMarkViewAsSeenLocally", () => $98f4ac59dddaf5e2$export$90fd623c08e2afa5);

var $eJOHy = parcelRequire("eJOHy");

var $8q7lT = parcelRequire("8q7lT");

var $9Uhca = parcelRequire("9Uhca");

var $1Rifx = parcelRequire("1Rifx");
const $98f4ac59dddaf5e2$export$c85a728fcd2c10ae = (viewUUID, accountId, waitForBackendData = true)=>{
    const lastSeen = (0, $9Uhca.useLastSeenRecord)(viewUUID);
    const [locallySeenView, setlocallySeenView] = (0, $eJOHy.useState)(undefined);
    const [loadedLocallySeen, setLoadedLocallySeen] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (viewUUID === undefined) return;
        (0, $1Rifx.getLocallySeen)(viewUUID, accountId).then((seen)=>{
            setlocallySeenView(seen);
            setLoadedLocallySeen(true);
        });
    }, [
        accountId,
        viewUUID
    ]);
    if (viewUUID === undefined || !loadedLocallySeen) return undefined;
    if (locallySeenView === true) return true;
    if (!waitForBackendData) return false;
    if (lastSeen === undefined || lastSeen.loading || lastSeen.error) return undefined;
    if (accountId === undefined) return undefined;
    return lastSeen.data[accountId] !== undefined;
};
const $98f4ac59dddaf5e2$export$90fd623c08e2afa5 = ()=>{
    const accountId = (0, $8q7lT.useAccountId)();
    return (0, $eJOHy.useCallback)((viewUUID)=>{
        (0, $1Rifx.setLocallySeen)(viewUUID, accountId !== null ? accountId : undefined);
    }, [
        accountId
    ]);
};

});
parcelRegister("9Uhca", function(module, exports) {

$parcel$export(module.exports, "useLastSeenRecord", () => $5d01e56356aa3ffa$export$874633b83477d296);
$parcel$export(module.exports, "useLastSeenRecordAvailable", () => $5d01e56356aa3ffa$export$f8e2eb5965a6f323);
$parcel$export(module.exports, "useUserData", () => $5d01e56356aa3ffa$export$52a7e4f3f505b7fa);
$parcel$export(module.exports, "useSortedVisitors", () => $5d01e56356aa3ffa$export$eec81e8e283410bb);
$parcel$export(module.exports, "useActions", () => $5d01e56356aa3ffa$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useViewLastSeen", () => $5d01e56356aa3ffa$export$c327e3789f7dba22);

var $eJOHy = parcelRequire("eJOHy");

var $bkDtm = parcelRequire("bkDtm");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5BRaf = parcelRequire("5BRaf");

var $f8oKH = parcelRequire("f8oKH");
const $5d01e56356aa3ffa$var$initialState = {
    lastSeen: {},
    users: {}
};
const $5d01e56356aa3ffa$var$Store = (0, $GtRbT.createStore)({
    initialState: $5d01e56356aa3ffa$var$initialState,
    actions: $5BRaf.actions,
    name: 'PolarisViewMetadataStore'
});
const $5d01e56356aa3ffa$var$useLastSeenRecords = (0, $iJq0l.createStateHook)($5d01e56356aa3ffa$var$Store, {
    selector: (state)=>state.lastSeen
});
const $5d01e56356aa3ffa$export$874633b83477d296 = (viewUUID)=>{
    const lastSeenRecords = $5d01e56356aa3ffa$var$useLastSeenRecords();
    if (viewUUID === undefined) return undefined;
    return lastSeenRecords[viewUUID];
};
const $5d01e56356aa3ffa$export$f8e2eb5965a6f323 = (viewUUID)=>{
    const lastSeen = $5d01e56356aa3ffa$export$874633b83477d296(viewUUID);
    if (lastSeen === undefined || lastSeen.loading || lastSeen.error) return undefined;
    return true;
};
const $5d01e56356aa3ffa$export$52a7e4f3f505b7fa = (0, $iJq0l.createStateHook)($5d01e56356aa3ffa$var$Store, {
    selector: (state, { viewUUID: viewUUID })=>state.users[viewUUID] || {}
});
const $5d01e56356aa3ffa$export$eec81e8e283410bb = (0, $iJq0l.createStateHook)($5d01e56356aa3ffa$var$Store, {
    selector: (state, { viewUUID: viewUUID })=>(0, $f8oKH.getSortedLastVisitors)(state, viewUUID)
});
const $5d01e56356aa3ffa$export$bc923229a7fa61e7 = (0, $iJq0l.createActionsHook)($5d01e56356aa3ffa$var$Store);
const $5d01e56356aa3ffa$export$c327e3789f7dba22 = (viewUUID)=>{
    const [data, setData] = (0, $eJOHy.useState)({
        loading: true,
        data: {}
    });
    const record = $5d01e56356aa3ffa$export$874633b83477d296(viewUUID);
    const { loadViewsLastSeen: loadViewsLastSeen } = $5d01e56356aa3ffa$export$bc923229a7fa61e7();
    const viewIds = (0, $bkDtm.useViewIdsByViewUUID)({
        viewUUID: viewUUID
    });
    (0, $eJOHy.useEffect)(()=>{
        if (record !== undefined) setData(record);
        else loadViewsLastSeen(viewIds);
    }, [
        loadViewsLastSeen,
        viewIds,
        record
    ]);
    return data;
};

});
parcelRegister("bkDtm", function(module, exports) {

$parcel$export(module.exports, "useSetViews", () => $71be7d130e467baa$export$dc97f80247b49dc8);
$parcel$export(module.exports, "useViewIdsByViewUUID", () => $71be7d130e467baa$export$6d1d014ec492152c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $71be7d130e467baa$var$initialState = {
    views: [],
    viewsByPolarisApiId: {},
    viewsByUUID: {},
    viewsByAri: {}
};
const $71be7d130e467baa$var$Store = (0, $GtRbT.createStore)({
    initialState: $71be7d130e467baa$var$initialState,
    actions: {
        setViews: (views)=>({ setState: setState })=>{
                const viewsByPolarisApiId = {};
                const viewsByUUID = {};
                const viewsByAri = {};
                views.forEach((view)=>{
                    viewsByPolarisApiId[view.viewPolarisApiId] = view;
                    viewsByUUID[view.viewUUID] = view;
                    viewsByAri[view.viewAri] = view;
                });
                setState({
                    views: views,
                    viewsByPolarisApiId: viewsByPolarisApiId,
                    viewsByUUID: viewsByUUID,
                    viewsByAri: viewsByAri
                });
            }
    },
    name: 'PolarisViewIdMappingStore'
});
const $71be7d130e467baa$var$useActions = (0, $iJq0l.createActionsHook)($71be7d130e467baa$var$Store);
const $71be7d130e467baa$export$dc97f80247b49dc8 = ()=>{
    const { setViews: setViews } = $71be7d130e467baa$var$useActions();
    return setViews;
};
const $71be7d130e467baa$export$97d0cf0e2e540d98 = (0, $iJq0l.createStateHook)($71be7d130e467baa$var$Store, {
    selector: (state, { polarisApiId: polarisApiId })=>state.viewsByPolarisApiId[polarisApiId]
});
const $71be7d130e467baa$export$cc385f2444013598 = (0, $iJq0l.createStateHook)($71be7d130e467baa$var$Store, {
    selector: (state, { viewAri: viewAri })=>state.viewsByAri[viewAri]
});
const $71be7d130e467baa$export$6d1d014ec492152c = (0, $iJq0l.createStateHook)($71be7d130e467baa$var$Store, {
    selector: (state, { viewUUID: viewUUID })=>viewUUID !== undefined ? state.viewsByUUID[viewUUID] : undefined
});

});

parcelRegister("5BRaf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5f77275ae3c26501$export$e324594224ef24da);

var $LWfQs = parcelRequire("LWfQs");

var $f3jqC = parcelRequire("f3jqC");

var $1rWJk = parcelRequire("1rWJk");

var $gh4dM = parcelRequire("gh4dM");
const $5f77275ae3c26501$export$e324594224ef24da = {
    loadViewsLastSeen: $1rWJk.loadViewsLastSeen,
    updateViewLastSeenStateInternal: $gh4dM.updateViewLastSeenStateInternal,
    fetchUserData: $f3jqC.fetchUserData,
    cleanupViewLastSeenState: $LWfQs.cleanupViewLastSeenState
};

});
parcelRegister("LWfQs", function(module, exports) {

$parcel$export(module.exports, "cleanupViewLastSeenState", () => $363970a4cb717b80$export$97d5cfea1a8947c7);

var $jFHCE = parcelRequire("jFHCE");
const $363970a4cb717b80$export$97d5cfea1a8947c7 = (viewUUID)=>async ({ setState: setState, getState: getState })=>{
        setState({
            lastSeen: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(getState().lastSeen, viewUUID)
            }
        });
    };

});

parcelRegister("f3jqC", function(module, exports) {

$parcel$export(module.exports, "fetchUserData", () => $97b5d8cbbca276ce$export$1b2474068ca80b61);

var $au0Nw = parcelRequire("au0Nw");
const $97b5d8cbbca276ce$export$1b2474068ca80b61 = (viewUUID, accountIds)=>(api)=>{
        const { setState: setState, getState: getState } = api;
        const userDataInState = getState().users[viewUUID];
        const usersToFetch = accountIds.filter((accountId)=>{
            const isAlreadyHandled = userDataInState !== undefined && userDataInState[accountId] !== undefined && (userDataInState[accountId].data !== undefined || userDataInState[accountId].error !== undefined || userDataInState[accountId].loading);
            return !isAlreadyHandled;
        });
        const loadingStates = {};
        usersToFetch.forEach((accountId)=>{
            loadingStates[accountId] = {
                loading: true
            };
        });
        setState({
            users: {
                ...getState().users,
                [viewUUID]: {
                    ...getState().users[viewUUID] || {},
                    ...loadingStates
                }
            }
        });
        (0, $au0Nw.getUsersInBulk)(usersToFetch).then((users)=>{
            const userMap = {};
            users.forEach((user)=>{
                if (user === null) return;
                userMap[user.accountId] = {
                    data: user,
                    loading: false
                };
            });
            setState({
                users: {
                    ...getState().users,
                    [viewUUID]: {
                        ...getState().users[viewUUID] || {},
                        ...userMap
                    }
                }
            });
        }).catch((error)=>{
            const userMap = {};
            usersToFetch.forEach((accountId)=>{
                userMap[accountId] = {
                    error: error,
                    loading: false
                };
            });
            setState({
                users: {
                    ...getState().users,
                    [viewUUID]: {
                        ...getState().users[viewUUID] || {},
                        ...userMap
                    }
                }
            });
        });
    };

});
parcelRegister("au0Nw", function(module, exports) {

$parcel$export(module.exports, "getUsersInBulk", () => $19d9b1961094fd23$export$a8fb73726b15def4);

var $1Ozm9 = parcelRequire("1Ozm9");
const $19d9b1961094fd23$export$a8fb73726b15def4 = (accountIds)=>{
    if (!accountIds.length) return Promise.resolve([]);
    // https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-users/#api-rest-api-3-user-bulk-get
    return (0, $1Ozm9.default)(`/rest/api/3/user/bulk?maxResults=200&accountId=${accountIds.join('&accountId=')}`).then(({ values: values })=>values);
};

});


parcelRegister("1rWJk", function(module, exports) {

$parcel$export(module.exports, "loadViewsLastSeen", () => $258c1b85d3699e45$export$87a7956aac839bc8);

var $230HG = parcelRequire("230HG");
const $258c1b85d3699e45$var$handleErrorState = (viewUUID, { getState: getState, setState: setState })=>(error)=>{
        setState({
            lastSeen: {
                ...getState().lastSeen,
                [viewUUID]: {
                    loading: false,
                    data: {},
                    error: error
                }
            }
        });
    };
const $258c1b85d3699e45$var$setViewsLastSeenState = (viewUUID, { getState: getState, setState: setState })=>(data)=>{
        if (data instanceof Error) throw data;
        setState({
            lastSeen: {
                ...getState().lastSeen,
                [viewUUID]: {
                    loading: false,
                    data: data
                }
            }
        });
    };
const $258c1b85d3699e45$var$loadFromViewsService = (viewIds)=>{
    const loadAllPages = (nextPageKey)=>(0, $230HG.getViewLastSeen)(viewIds.viewUUID, 100, nextPageKey).then(async (raw)=>{
            const data = {};
            raw.data.forEach((lv)=>{
                data[lv.aaid] = new Date(lv.timestamp);
            });
            const additionalPages = raw.pagination?.nextPageKey ? await loadAllPages(raw.pagination.nextPageKey) : {};
            return {
                ...data,
                ...additionalPages
            };
        });
    return loadAllPages();
};
const $258c1b85d3699e45$export$87a7956aac839bc8 = (viewIds)=>async (api)=>{
        const { setState: setState, getState: getState } = api;
        if (!viewIds) return;
        if (getState().lastSeen[viewIds.viewUUID]?.loading || getState().lastSeen[viewIds.viewUUID]?.data) return;
        setState({
            lastSeen: {
                ...getState().lastSeen,
                [viewIds.viewUUID]: {
                    loading: true,
                    data: {}
                }
            }
        });
        $258c1b85d3699e45$var$loadFromViewsService(viewIds).then($258c1b85d3699e45$var$setViewsLastSeenState(viewIds.viewUUID, api)).catch($258c1b85d3699e45$var$handleErrorState(viewIds.viewUUID, api));
    };

});
parcelRegister("230HG", function(module, exports) {

$parcel$export(module.exports, "getViewLastSeen", () => $18c8559705090948$export$7c3fbd80e6118de5);

var $jGzN3 = parcelRequire("jGzN3");

var $jbIuO = parcelRequire("jbIuO");
const $18c8559705090948$var$getViewLastSeenURL = (viewUUID, limit, nextPageKey)=>`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/views/${viewUUID}/last-viewed?limit=${limit}${nextPageKey ? `&nextPageKey=${nextPageKey}` : ''}`;
const $18c8559705090948$export$7c3fbd80e6118de5 = async (viewUUID, limit, nextPageKey)=>(0, $jGzN3.performGetRequest)($18c8559705090948$var$getViewLastSeenURL(viewUUID, limit, nextPageKey));

});


parcelRegister("gh4dM", function(module, exports) {

$parcel$export(module.exports, "updateViewLastSeenStateInternal", () => $a344ed5503cdb1b5$export$6debb829e9bbf441);
const $a344ed5503cdb1b5$export$6debb829e9bbf441 = (viewUUID, data)=>async (api)=>{
        const { setState: setState, getState: getState } = api;
        setState({
            lastSeen: {
                ...getState().lastSeen,
                [viewUUID]: {
                    loading: true,
                    data: data,
                    error: undefined
                }
            }
        });
    };

});


parcelRegister("f8oKH", function(module, exports) {

$parcel$export(module.exports, "getSortedLastVisitors", () => $a18d6917430ee9da$export$c62830d94947fbd4);
const $a18d6917430ee9da$export$c62830d94947fbd4 = (state, viewUUID)=>{
    const lastSeenRecord = state.lastSeen[viewUUID];
    if (lastSeenRecord === undefined) return [];
    const { data: data } = lastSeenRecord;
    return Object.keys(data).sort((a, b)=>data[b].getTime() - data[a].getTime());
};

});


parcelRegister("1Rifx", function(module, exports) {

$parcel$export(module.exports, "getLocallySeen", () => $f79490a307547739$export$32be4c7d49b2b78e);
$parcel$export(module.exports, "setLocallySeen", () => $f79490a307547739$export$d774575240436c34);

var $fclB9 = parcelRequire("fclB9");
const $f79490a307547739$var$locallySeenStorage = (0, $fclB9.createIndexedDBStorageProvider)('jpd-view-visits');
const $f79490a307547739$var$getKey = (viewUUID, accountId)=>`${viewUUID}-${accountId || 'anonymous'}`;
const $f79490a307547739$export$32be4c7d49b2b78e = async (viewUUID, accountId)=>{
    return $f79490a307547739$var$locallySeenStorage.get($f79490a307547739$var$getKey(viewUUID, accountId));
};
const $f79490a307547739$export$d774575240436c34 = async (viewUUID, accountId)=>{
    return $f79490a307547739$var$locallySeenStorage.set($f79490a307547739$var$getKey(viewUUID, accountId), true);
};

});
parcelRegister("fclB9", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $c1555772a5bddb48$export$6ba36c4f5fb8919d);

var $5PQOA = parcelRequire("5PQOA");

var $czeV6 = parcelRequire("czeV6");
const $c1555772a5bddb48$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $czeV6.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $czeV6.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("czeV6", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $83715273b7a8b6ec$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $83715273b7a8b6ec$export$8432fe49db7d8865);

var $98dDj = parcelRequire("98dDj");
const $83715273b7a8b6ec$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $83715273b7a8b6ec$var$createCustomStore = ()=>(0, $98dDj.createStore)('keyval-store', 'keyval');
let $83715273b7a8b6ec$var$customStore;
const $83715273b7a8b6ec$var$getStore = ()=>{
    let store = $83715273b7a8b6ec$var$customStore;
    if (!store) {
        $83715273b7a8b6ec$var$customStore = $83715273b7a8b6ec$var$createCustomStore();
        store = $83715273b7a8b6ec$var$customStore;
    }
    return store;
};
const $83715273b7a8b6ec$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $83715273b7a8b6ec$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$83715273b7a8b6ec$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $98dDj.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $83715273b7a8b6ec$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $98dDj.get)(prefix(key), $83715273b7a8b6ec$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $98dDj.del)(prefixedKey, $83715273b7a8b6ec$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $98dDj.get)(KEYS_STORE_PREFIX, $83715273b7a8b6ec$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $98dDj.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $98dDj.update)(prefixedKey, value);
            else (0, $98dDj.set)(prefixedKey, value, $83715273b7a8b6ec$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $83715273b7a8b6ec$var$customStore = $83715273b7a8b6ec$var$createCustomStore();
        }
    };
};
const $83715273b7a8b6ec$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("98dDj", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6a5f6fa33a187ce0$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $6a5f6fa33a187ce0$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $6a5f6fa33a187ce0$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $6a5f6fa33a187ce0$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $6a5f6fa33a187ce0$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $6a5f6fa33a187ce0$export$c8aa84257229cac8);
function $6a5f6fa33a187ce0$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $6a5f6fa33a187ce0$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $6a5f6fa33a187ce0$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $6a5f6fa33a187ce0$var$defaultGetStoreFunc;
function $6a5f6fa33a187ce0$var$defaultGetStore() {
    if (!$6a5f6fa33a187ce0$var$defaultGetStoreFunc) $6a5f6fa33a187ce0$var$defaultGetStoreFunc = $6a5f6fa33a187ce0$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $6a5f6fa33a187ce0$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$3988ae62b71be9a3(key, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$6a5f6fa33a187ce0$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$adaa4cf7ef1b65be(key, value, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$daa0a5170277c7a8(entries, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$5df405cccea42673(keys, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$6a5f6fa33a187ce0$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$722fbec263ad908a(key, updater, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$1d2f21e549771e67(key, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$c8aa84257229cac8(keys, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$42ffd38884aecdac(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
function $6a5f6fa33a187ce0$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$ed97f33186d4b816(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$68c286be0e7e55b7(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAll());
        const items = [];
        return $6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$3e9f948b41964866(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAllKeys()),
            $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});





parcelRegister("eFrz1", function(module, exports) {

$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $a5e28192b76c8457$export$e44126cd87ea434);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $8GOss = parcelRequire("8GOss");
function $a5e28192b76c8457$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $eJOHy.useRef)(false);
    const depsRef = (0, $eJOHy.useRef)(dependencies);
    (0, $eJOHy.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $8GOss.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});

parcelRegister("dIHYC", function(module, exports) {

$parcel$export(module.exports, "getCurrentViewTableColumnSizes", () => $ad4d92db17129c97$export$dc3a67ff9670958b);
$parcel$export(module.exports, "getCurrentViewTableColumnSizesByFieldKey", () => $ad4d92db17129c97$export$85420f626eb1a301);
$parcel$export(module.exports, "getCurrentViewTableColumnSize", () => $ad4d92db17129c97$export$639e2f2a2daf3ea5);

var $ahm5r = parcelRequire("ahm5r");

var $1vVGo = parcelRequire("1vVGo");
const $ad4d92db17129c97$export$dc3a67ff9670958b = (0, $ahm5r.createSelector)((0, $1vVGo.getCurrentView), (view)=>view?.tableColumnSizes ?? []);
const $ad4d92db17129c97$export$85420f626eb1a301 = (0, $ahm5r.createSelector)($ad4d92db17129c97$export$dc3a67ff9670958b, (sizes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const map = {};
    sizes.forEach(({ fieldKey: fieldKey, size: size })=>{
        map[fieldKey] = size;
    });
    return map;
});
const $ad4d92db17129c97$export$639e2f2a2daf3ea5 = (fieldKey)=>(0, $ahm5r.createSelector)($ad4d92db17129c97$export$dc3a67ff9670958b, (sizes)=>sizes.find((col)=>col.fieldKey === fieldKey)?.size);

});


parcelRegister("1jdTF", function(module, exports) {

$parcel$export(module.exports, "useIsProjectAvailable", () => $149ccc4aa6a57897$export$a6b15771fcc6cf2);
$parcel$export(module.exports, "useIsProjectOnboarded", () => $149ccc4aa6a57897$export$6ef6b6bc1e981143);
$parcel$export(module.exports, "useProjectOnboardedAtTimestamp", () => $149ccc4aa6a57897$export$f2b111196019fd1c);
$parcel$export(module.exports, "useProjectInitialTemplate", () => $149ccc4aa6a57897$export$327374584f1f8271);
$parcel$export(module.exports, "useProjectTemplateVersion", () => $149ccc4aa6a57897$export$f205b5e85121583f);
$parcel$export(module.exports, "useSelectedDeliveryProject", () => $149ccc4aa6a57897$export$11d034a9ebc0823c);
$parcel$export(module.exports, "useError", () => $149ccc4aa6a57897$export$5027865de34f9ec6);
$parcel$export(module.exports, "useIsProjectLoading", () => $149ccc4aa6a57897$export$5dbeb21f14ba9ef9);
$parcel$export(module.exports, "useJiraRankFieldKey", () => $149ccc4aa6a57897$export$2448115a0927b8a0);

var $gtr2v = parcelRequire("gtr2v");

var $ln6Iy = parcelRequire("ln6Iy");

var $47Jx0 = parcelRequire("47Jx0");

var $iJq0l = parcelRequire("iJq0l");

var $bovaw = parcelRequire("bovaw");
const $149ccc4aa6a57897$export$a6b15771fcc6cf2 = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>!!state.project.id
});
const $149ccc4aa6a57897$export$f87be37f8e8be65 = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.project?.key
});
const $149ccc4aa6a57897$export$654dd2c557853fbe = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.project?.name
});
const $149ccc4aa6a57897$export$6ef6b6bc1e981143 = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.project?.onboarded
});
const $149ccc4aa6a57897$export$f2b111196019fd1c = (0, $iJq0l.createStateHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.project?.onboardedAtTimestamp
});
const $149ccc4aa6a57897$export$327374584f1f8271 = (0, $iJq0l.createStateHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.projectTemplate?.initialProjectTemplate
});
const $149ccc4aa6a57897$export$f205b5e85121583f = (0, $iJq0l.createStateHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.project?.templateVersion
});
const $149ccc4aa6a57897$export$11d034a9ebc0823c = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.project?.selectedDeliveryProject
});
const $149ccc4aa6a57897$export$5027865de34f9ec6 = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.meta.project.error
});
const $149ccc4aa6a57897$export$5dbeb21f14ba9ef9 = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.meta.project.loading
});
const $149ccc4aa6a57897$export$2448115a0927b8a0 = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.project?.jiraRankFieldKey
});
const $149ccc4aa6a57897$export$dacbed68c36ce4dd = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>state.project?.avatarUrls
});
const $149ccc4aa6a57897$export$9ccb20079b201aff = (0, $iJq0l.createHook)((0, $bovaw.ProjectStore), {
    selector: ({ project: project })=>project.key && (0, $47Jx0.getNextgenSettingsUrl)((0, $ln6Iy.SOFTWARE_PROJECT), project.key)
});
const $149ccc4aa6a57897$export$7719ba7bd9e73f2a = (0, $iJq0l.createStateHook)((0, $bovaw.ProjectStore), {
    selector: (state)=>{
        if (!state.project || state.project.id === undefined) return undefined;
        const id = (0, $gtr2v.AnyAri).parse(state.project.id).resourceId;
        if (id === undefined || state.project.key === undefined || state.project.name === undefined || state.project.avatarUrls === undefined) return undefined;
        return {
            id: id,
            key: state.project.key,
            name: state.project.name,
            avatarUrls: state.project.avatarUrls
        };
    }
});

});
parcelRegister("bovaw", function(module, exports) {

$parcel$export(module.exports, "ProjectStore", () => $a1db32c25c6408b5$export$93d91060b9af7e2a);
$parcel$export(module.exports, "useProjectActions", () => $a1db32c25c6408b5$export$f766143b99f9fece);
$parcel$export(module.exports, "ProjectContainer", () => $a1db32c25c6408b5$export$4ee32776d0814bc1);
$parcel$export(module.exports, "createProjectHook", () => $a1db32c25c6408b5$export$92022e0ad7b7b24f);
$parcel$export(module.exports, "createHigherLevelProjectHook", () => $a1db32c25c6408b5$export$203f93cfd6f371d5);

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $jKYOg = parcelRequire("jKYOg");

var $739bA = parcelRequire("739bA");
const $a1db32c25c6408b5$export$93d91060b9af7e2a = (0, $jxALV.createPolarisStore)({
    initialState: (0, $739bA.EMPTY_STATE),
    actions: $jKYOg.actions,
    name: 'PolarisProjectStore'
});
const { Container: $a1db32c25c6408b5$var$Container, useActions: $a1db32c25c6408b5$var$useActions, createHook: $a1db32c25c6408b5$var$createHook, createHigherLevelHook: $a1db32c25c6408b5$var$createHigherLevelHook } = (0, $YvHeB.createJpdContainer)($a1db32c25c6408b5$export$93d91060b9af7e2a, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $jKYOg.actions).loadProjectInformation());
            dispatch((0, $jKYOg.actions).loadProject(false, true));
            dispatch((0, $jKYOg.actions).loadPlays(true));
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $jKYOg.actions).loadProject());
            dispatch((0, $jKYOg.actions).loadPlays());
        },
    onCleanup: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $jKYOg.actions).unLoadProject());
        }
});
const $a1db32c25c6408b5$export$f766143b99f9fece = $a1db32c25c6408b5$var$useActions;
const $a1db32c25c6408b5$export$4ee32776d0814bc1 = $a1db32c25c6408b5$var$Container;
const $a1db32c25c6408b5$export$92022e0ad7b7b24f = $a1db32c25c6408b5$var$createHook;
const $a1db32c25c6408b5$export$203f93cfd6f371d5 = $a1db32c25c6408b5$var$createHigherLevelHook;

});
parcelRegister("jKYOg", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cf6e36d9cd5abee2$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7JmE0 = parcelRequire("7JmE0");

var $4fBg9 = parcelRequire("4fBg9");

var $c4T8M = parcelRequire("c4T8M");

var $4fvOG = parcelRequire("4fvOG");

var $2NErV = parcelRequire("2NErV");

var $kRQgN = parcelRequire("kRQgN");

var $1eYnc = parcelRequire("1eYnc");

var $a51L9 = parcelRequire("a51L9");
const $cf6e36d9cd5abee2$export$e324594224ef24da = {
    loadProject: $4fvOG.loadProject,
    loadProjectInformation: $c4T8M.loadProjectInformation,
    unLoadProject: $1eYnc.unLoadProject,
    setSelectedDeliveryProject: $kRQgN.setSelectedDeliveryProject,
    updateProjectDetails: $a51L9.updateProjectDetails,
    setProjectError: $4fBg9.setProjectError,
    applyProjectTemplate: $7JmE0.applyProjectTemplate,
    getProjectTemplate: $7JmE0.getProjectTemplate,
    checkProjectOnboarded: $7JmE0.checkProjectOnboarded,
    checkIsBlankAndNeedsRestore: $7JmE0.checkIsBlankAndNeedsRestore,
    ...$2NErV,
    /**
	 * this action has no side effects. It is a helper accessor to get the container
	 * props in through the hook API and forwarded to the reselect selectors
	 */ getContainerProps: ()=>(ops, props)=>props
};

});
parcelRegister("7JmE0", function(module, exports) {

$parcel$export(module.exports, "getProjectTemplate", () => $a2f939c0bc680ea4$export$9b8a2a0164366b4e);
$parcel$export(module.exports, "applyProjectTemplate", () => $a2f939c0bc680ea4$export$3f25e491b8bcdffc);
$parcel$export(module.exports, "checkProjectOnboarded", () => $a2f939c0bc680ea4$export$401fbaa7b24fcf0f);
$parcel$export(module.exports, "checkIsBlankAndNeedsRestore", () => $a2f939c0bc680ea4$export$c4276414018b43e7);

var $gtr2v = parcelRequire("gtr2v");

var $eu0ZO = parcelRequire("eu0ZO");

var $b5oGV = parcelRequire("b5oGV");

var $jnihY = parcelRequire("jnihY");

var $2fLkF = parcelRequire("2fLkF");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $57ulE = parcelRequire("57ulE");
const $a2f939c0bc680ea4$var$getPolarisDefaultProjectTemplateVersion = ()=>{
    return (0, $7jTnu.fg)('polaris-issue-terminology-refresh') ? 'v21' : 'v20';
};
const $a2f939c0bc680ea4$var$logError = (error)=>{
    (0, $57ulE.logPolarisError)('controllers.project.actions.applyTemplate', error);
};
const $a2f939c0bc680ea4$export$9b8a2a0164366b4e = ()=>({ getState: getState })=>{
        const { projectTemplate: projectTemplate } = getState();
        return projectTemplate;
    };
const $a2f939c0bc680ea4$var$POLARIS_API_TEMPLATES = [
    (0, $eu0ZO.ProjectTemplateEnum).DISCOVERY,
    (0, $eu0ZO.ProjectTemplateEnum).ROADMAP,
    // GALILEO-2516 START
    (0, $eu0ZO.ProjectTemplateEnum).PRIORITIZATION,
    // GALILEO-2516 END
    // GALILEO-4584 START
    (0, $eu0ZO.ProjectTemplateEnum).PORTFOLIO_MANAGEMENT,
    // GALILEO-4584 END
    (0, $eu0ZO.ProjectTemplateEnum).BLUEPRINTS
];
const $a2f939c0bc680ea4$var$CUSTOM_PROJECT_TEMPLATE_TO_VERSION = new Map([
    [
        (0, $eu0ZO.ProjectTemplateEnum).PRIORITIZATION,
        'prio_v1'
    ]
]);
const $a2f939c0bc680ea4$var$NEW_ROADMAP_TEMPLATE_VERSION = 'roadmap_v1';
const $a2f939c0bc680ea4$var$PORTFOLIO_MANAGEMENT_TEMPLATE_VERSION = 'portfolio_v1';
const $a2f939c0bc680ea4$var$BLUEPRINTS_TEMPLATE_VERSION = 'blueprints_v1';
const $a2f939c0bc680ea4$export$e09f6027d5481731 = (projectTemplate)=>{
    const polarisApiTemplates = [
        ...$a2f939c0bc680ea4$var$POLARIS_API_TEMPLATES
    ];
    if ((0, $7jTnu.fg)('polaris_check_if_blank_project_needs_restore')) polarisApiTemplates.push((0, $eu0ZO.ProjectTemplateEnum).BLANK);
    return projectTemplate ? polarisApiTemplates.includes(projectTemplate?.initialProjectTemplate) : false;
};
const $a2f939c0bc680ea4$export$d199a1011e92debc = (projectTemplate, isOnboardingExperimentEnabled)=>{
    const templateKey = projectTemplate?.initialProjectTemplate;
    if (templateKey && templateKey === (0, $eu0ZO.ProjectTemplateEnum).ROADMAP && (0, $epTsa.expVal)('jpd_roadmap_template', 'use_roadmap_template', false)) return $a2f939c0bc680ea4$var$NEW_ROADMAP_TEMPLATE_VERSION;
    if (templateKey && templateKey === (0, $eu0ZO.ProjectTemplateEnum).PORTFOLIO_MANAGEMENT) return $a2f939c0bc680ea4$var$PORTFOLIO_MANAGEMENT_TEMPLATE_VERSION;
    if ((0, $7jTnu.fg)('jpd-view-templates-sample-project')) {
        if (templateKey && templateKey === (0, $eu0ZO.ProjectTemplateEnum).BLUEPRINTS) return $a2f939c0bc680ea4$var$BLUEPRINTS_TEMPLATE_VERSION;
    }
    if (templateKey && $a2f939c0bc680ea4$var$CUSTOM_PROJECT_TEMPLATE_TO_VERSION.has(templateKey)) return $a2f939c0bc680ea4$var$CUSTOM_PROJECT_TEMPLATE_TO_VERSION.get(templateKey) || $a2f939c0bc680ea4$var$getPolarisDefaultProjectTemplateVersion();
    if (isOnboardingExperimentEnabled) return (0, $jnihY.getDefaultProjectTemplateVersionVariant)();
    return $a2f939c0bc680ea4$var$getPolarisDefaultProjectTemplateVersion();
};
const $a2f939c0bc680ea4$export$3f25e491b8bcdffc = (isOnboardingExperimentEnabled, issueTypes)=>async ({ getState: getState }, { apolloClient: apolloClient, cloudId: cloudId })=>{
        const { project: project, projectTemplate: projectTemplate } = getState();
        const templateVersion = $a2f939c0bc680ea4$export$d199a1011e92debc(projectTemplate, isOnboardingExperimentEnabled);
        if (!project.id) {
            const error = new Error('Cannot onboard missing project. Action must not be called without known project id.');
            $a2f939c0bc680ea4$var$logError(error);
            throw error;
        }
        if (!$a2f939c0bc680ea4$export$e09f6027d5481731(projectTemplate)) return true;
        // skip if no issue types
        if (issueTypes.length === 0) return true;
        if (templateVersion === 'none') {
            (0, $b5oGV.experience).project.applyTemplate.abort('Template version unknown');
            const error = new Error('Cannot onboard without known template. Template version must be set.');
            $a2f939c0bc680ea4$var$logError(error);
            throw error;
        }
        (0, $b5oGV.experience).project.applyTemplate.mark((0, $b5oGV.experience).project.applyTemplate.marks.APPLY_TEMPLATE_POLLING_START_MARK);
        await (0, $2fLkF.projectRemote).applyProjectTemplate(apolloClient, project.id, (0, $gtr2v.AnyAri).create({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issuetype',
            resourceId: issueTypes[0]
        }).toString(), templateVersion);
        return true;
    };
const $a2f939c0bc680ea4$export$401fbaa7b24fcf0f = ()=>async ({ getState: getState }, { apolloClient: apolloClient, projectRemote: projectRemote })=>{
        const { project: project, projectTemplate: projectTemplate } = getState();
        if (!project.id) {
            const error = new Error('Cannot check missing project');
            $a2f939c0bc680ea4$var$logError(error);
            return false;
        }
        if (!$a2f939c0bc680ea4$export$e09f6027d5481731(projectTemplate)) {
            const { onboardingStatus: onboardingStatus } = await projectRemote.getOnboardingInformation();
            return onboardingStatus === (0, $eu0ZO.ProjectOnboardingStatusEnum).DONE;
        }
        const { isOnboarded: isOnboarded } = await (0, $2fLkF.projectRemote).checkProjectOnboarded(apolloClient, project.id);
        return isOnboarded;
    };
const $a2f939c0bc680ea4$export$c4276414018b43e7 = ()=>async ({ getState: getState }, { projectRemote: projectRemote })=>{
        const { project: project, projectTemplate: projectTemplate } = getState();
        if (!project.id) {
            const error = new Error('Cannot check restoration need of missing project');
            $a2f939c0bc680ea4$var$logError(error);
            return false;
        }
        if (projectTemplate?.initialProjectTemplate !== (0, $eu0ZO.ProjectTemplateEnum).BLANK) return false;
        const { needsRestore: needsRestore } = await projectRemote.getNeedsRestore();
        return needsRestore;
    };

});
parcelRegister("eu0ZO", function(module, exports) {

$parcel$export(module.exports, "ProjectOnboardingStatusEnum", () => $a14d6f9733483dfd$export$d589b6154fdcf1ba);
$parcel$export(module.exports, "ProjectTemplateEnum", () => $a14d6f9733483dfd$export$58f839397dbcfc56);
const $a14d6f9733483dfd$export$d589b6154fdcf1ba = {
    UNKNOWN: 'UNKNOWN',
    TASK_CREATION_FAILED: 'TASK_CREATION_FAILED',
    QUEUEING_FAILED: 'QUEUEING_FAILED',
    QUEUED: 'QUEUED',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE',
    FAILED: 'FAILED'
};
const $a14d6f9733483dfd$export$58f839397dbcfc56 = {
    DISCOVERY: 'jira.polaris:discovery',
    BLANK: 'jira.polaris:blank-project',
    ROADMAP: 'jira.polaris:roadmap',
    PRIORITIZATION: 'jira.polaris:prioritization',
    PORTFOLIO_MANAGEMENT: 'jira.polaris:portfolio',
    BLUEPRINTS: 'jira.polaris:blueprints'
};

});

parcelRegister("jnihY", function(module, exports) {

$parcel$export(module.exports, "JPD_TEMPLATE_DEFAULT", () => $8a4e9c6072bd127d$export$45ef3382556e27ef);
$parcel$export(module.exports, "JPD_TEMPLATE_V21", () => $8a4e9c6072bd127d$export$94b35f8189d15f98);
$parcel$export(module.exports, "JPD_ONBOARDING_TEMPLATES", () => $8a4e9c6072bd127d$export$eba68d9b397ac445);
$parcel$export(module.exports, "getDefaultProjectTemplateVersionVariant", () => $8a4e9c6072bd127d$export$ad7fc50cea2c61dc);
$parcel$export(module.exports, "useShouldShowOnboardingExperience", () => $8a4e9c6072bd127d$export$9e7e5346f7a4775c);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $6Yd06 = parcelRequire("6Yd06");

var $2HPtd = parcelRequire("2HPtd");
const $8a4e9c6072bd127d$export$45ef3382556e27ef = 'v20';
const $8a4e9c6072bd127d$export$94b35f8189d15f98 = 'v21';
const $8a4e9c6072bd127d$export$eba68d9b397ac445 = [
    $8a4e9c6072bd127d$export$45ef3382556e27ef,
    $8a4e9c6072bd127d$export$94b35f8189d15f98
];
const $8a4e9c6072bd127d$var$DEFAULT_TEMPLATE_TO_VERSION = {
    v20: {
        default: $8a4e9c6072bd127d$export$45ef3382556e27ef
    },
    v21: {
        default: $8a4e9c6072bd127d$export$94b35f8189d15f98
    }
};
const $8a4e9c6072bd127d$export$ad7fc50cea2c61dc = ()=>{
    const templateVersion = (0, $7jTnu.fg)('polaris-issue-terminology-refresh') ? 'v21' : 'v20';
    return $8a4e9c6072bd127d$var$DEFAULT_TEMPLATE_TO_VERSION[templateVersion].default;
};
const $8a4e9c6072bd127d$export$9e7e5346f7a4775c = (projectAri)=>{
    const [fetchEarliestOnboardedProjectTimeStamp] = (0, $2HPtd.useFetchEarliestOnboardedProject)();
    const [earliestOnboardedProjectTemplate, setEarliestOnboardedProjectTemplate] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    (0, $eJOHy.useEffect)(()=>{
        if (!projectAri) return;
        fetchEarliestOnboardedProjectTimeStamp(projectAri).then(({ template: template })=>setEarliestOnboardedProjectTemplate(template)).catch((error)=>{
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.experiment-check.error', 'Failed to fetch earliest onboarded project for current cloud id', error);
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        fetchEarliestOnboardedProjectTimeStamp,
        projectAri
    ]);
    if (isLoading) return null;
    return earliestOnboardedProjectTemplate === null || $8a4e9c6072bd127d$export$eba68d9b397ac445.includes(earliestOnboardedProjectTemplate ?? '');
};

});
parcelRegister("2HPtd", function(module, exports) {

$parcel$export(module.exports, "useFetchEarliestOnboardedProject", () => $4211cabb19182849$export$894197571c567436);

var $eJOHy = parcelRequire("eJOHy");

var $1fMqv = parcelRequire("1fMqv");

var $kuAvn = parcelRequire("kuAvn");
const $4211cabb19182849$var$GET_EARLIEST_ONBOARDED_PROJECT_FOR_CLOUDID_QUERY = (0, $kuAvn.default)`
    query jira_polaris_GetEarliestOnboardedProjectForCloudId($ari: ID!) {
        polarisGetEarliestOnboardedProjectForCloudId(id: $ari) {
            datetime
            template
        }
    }
`;
const $4211cabb19182849$export$894197571c567436 = ()=>{
    const client = (0, $1fMqv.useApolloClient)();
    return [
        (0, $eJOHy.useCallback)(async (ari)=>{
            const { data: data, errors: errors } = await client.query({
                query: $4211cabb19182849$var$GET_EARLIEST_ONBOARDED_PROJECT_FOR_CLOUDID_QUERY,
                variables: {
                    ari: ari
                }
            });
            if (errors !== undefined) throw new Error(`polaris.GetEarliestOnboardedProjectForCloudId.error:${errors.map((e)=>e.message).join(', ')}`);
            return {
                timestamp: data.polarisGetEarliestOnboardedProjectForCloudId?.datetime,
                template: data.polarisGetEarliestOnboardedProjectForCloudId?.template
            };
        }, [
            client
        ])
    ];
};

});


parcelRegister("2fLkF", function(module, exports) {

$parcel$export(module.exports, "projectRemote", () => $3f82f4dba440a2e5$export$228033e6e180a935);

var $h4wO6 = parcelRequire("h4wO6");

var $hFNJg = parcelRequire("hFNJg");
const $3f82f4dba440a2e5$export$228033e6e180a935 = {
    checkProjectOnboarded: $hFNJg.checkProjectOnboarded,
    applyProjectTemplate: $h4wO6.applyProjectTemplate
};

});
parcelRegister("h4wO6", function(module, exports) {

$parcel$export(module.exports, "applyProjectTemplate", () => $2bbefd47eec1f18f$export$3f25e491b8bcdffc);

var $kuAvn = parcelRequire("kuAvn");
const $2bbefd47eec1f18f$var$APPLY_PROJECT_TEMPLATE_QUERY = (0, $kuAvn.default)`
mutation jira_polaris_ApplyProjectTemplate($input: ApplyPolarisProjectTemplateInput!) {
    applyPolarisProjectTemplate(input: $input) {
        success
        errors {
            message
        }
    }
}
`;
const $2bbefd47eec1f18f$export$3f25e491b8bcdffc = async (client, projectAri, ideaTypeAri, template)=>{
    const { errors: errors } = await client.mutate({
        mutation: $2bbefd47eec1f18f$var$APPLY_PROJECT_TEMPLATE_QUERY,
        variables: {
            input: {
                project: projectAri,
                ideaType: ideaTypeAri,
                template: template
            }
        }
    });
    if (errors !== undefined) throw new Error(`polaris-ideas.apply-project-template-error:${errors.map((e)=>e.message).join(', ')}`);
    return true;
};

});

parcelRegister("hFNJg", function(module, exports) {

$parcel$export(module.exports, "checkProjectOnboarded", () => $14e49019a116b6da$export$401fbaa7b24fcf0f);

var $kuAvn = parcelRequire("kuAvn");
const $14e49019a116b6da$var$GET_PROJECT_ONBOARDED_QUERY = (0, $kuAvn.default)`
query jira_polaris_GetProjectOnboardedQuery($ari: ID!) {
    polarisProject(id: $ari, skipRefresh: true) {
        id
        onboarded
        ideaTypes {
            id
        }
    }
}`;
const $14e49019a116b6da$export$401fbaa7b24fcf0f = async (client, ari)=>{
    const { data: data, errors: errors } = await client.query({
        query: $14e49019a116b6da$var$GET_PROJECT_ONBOARDED_QUERY,
        variables: {
            ari: ari
        },
        fetchPolicy: 'no-cache'
    });
    if (errors !== undefined) throw new Error(`polaris-ideas.check-project-onboarding-error:${errors.map((e)=>e.message).join(', ')}`);
    return {
        isOnboarded: !!data.polarisProject?.onboarded,
        ideaTypeAri: data.polarisProject?.ideaTypes?.[0].id || null
    };
};

});



parcelRegister("4fBg9", function(module, exports) {

$parcel$export(module.exports, "setProjectError", () => $7d03ae1244ede314$export$2ba6c0505b1682c1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $7d03ae1244ede314$export$2ba6c0505b1682c1 = (error)=>({ getState: getState, setState: setState })=>{
        setState({
            meta: {
                ...getState().meta,
                project: {
                    ...getState().meta.project,
                    error: error
                }
            }
        });
    };

});

parcelRegister("c4T8M", function(module, exports) {

$parcel$export(module.exports, "loadProjectInformation", () => $fa229d8cebdc1427$export$2272fda8000aa626);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $fa229d8cebdc1427$export$2272fda8000aa626 = ()=>async ({ setState: setState }, { projectRemote: projectRemote })=>{
        projectRemote.getOnboardingInformation?.().then((onboardingInformation)=>{
            setState({
                projectTemplate: onboardingInformation
            });
        });
    };

});

parcelRegister("4fvOG", function(module, exports) {

$parcel$export(module.exports, "loadProject", () => $b6218f8dac7315b7$export$b73ab9d85c102e56);

var $8KUFq = parcelRequire("8KUFq");

var $b5oGV = parcelRequire("b5oGV");

var $5zHFN = parcelRequire("5zHFN");

var $fVlmn = parcelRequire("fVlmn");

var $8okDh = parcelRequire("8okDh");

var $739bA = parcelRequire("739bA");

var $iidnT = parcelRequire("iidnT");
const $b6218f8dac7315b7$export$b73ab9d85c102e56 = (reloadMode = false, fireAnalyticsEvent = false)=>async ({ getState: getState, setState: setState }, { containerAri: containerAri, projectFetcher: projectFetcher, onProjectLoadingError: onProjectLoadingError, isSiteAdmin: isSiteAdmin })=>{
        const loadingProps = {
            containerAri: containerAri
        };
        const { meta: { loadingProps: previousLoadingProps } } = getState();
        const isLoadingPropsChanged = !(0, $5zHFN.isShallowEqual)(loadingProps, previousLoadingProps);
        // Only load again when the props this function depends on have changed
        if (!reloadMode && !isLoadingPropsChanged) return;
        setState({
            ...(0, $739bA.EMPTY_STATE),
            meta: {
                ...getState().meta,
                loadingProps: loadingProps,
                project: {
                    loading: true,
                    error: undefined
                }
            },
            projectTemplate: getState().projectTemplate
        });
        (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_PROJECT_START));
        try {
            const project = await (0, $iidnT.fetch)({
                projectFetcher: projectFetcher,
                containerAri: containerAri,
                noCache: reloadMode || isLoadingPropsChanged,
                fireAnalyticsEvent: fireAnalyticsEvent,
                isSiteAdmin: isSiteAdmin
            });
            (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_PROJECT_END));
            setState({
                meta: {
                    ...getState().meta,
                    loadingProps: loadingProps,
                    project: {
                        loading: false,
                        error: undefined
                    }
                },
                project: {
                    ...project,
                    plays: getState().project.plays
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_PROJECT_END));
            setState({
                meta: {
                    ...getState().meta,
                    loadingProps: undefined,
                    project: {
                        loading: false,
                        error: error
                    }
                },
                project: {
                    ...(0, $739bA.EMPTY_PROJECT_STATE),
                    plays: getState().project.plays
                }
            });
            onProjectLoadingError(error);
            if (!(0, $fVlmn.isPermissionError)(error) && !(0, $8KUFq.isClientFetchError)(error.networkError)) {
                if ((0, $fVlmn.isRateLimitError)(error) || (0, $fVlmn.isRateLimitError)(error.networkError)) {
                    (0, $b5oGV.experience).project.pageLoadWithRateLimit.failure(error);
                    (0, $b5oGV.experience).project.pageLoad.abort(error);
                } else {
                    (0, $b5oGV.experience).project.pageLoad.failure(error);
                    (0, $b5oGV.experience).project.pageLoadWithRateLimit.abort(error);
                }
            } else (0, $b5oGV.experience).project.pageLoad.abort(error);
        }
    };

});
parcelRegister("739bA", function(module, exports) {

$parcel$export(module.exports, "EMPTY_PROJECT_STATE", () => $6e286b738469a3af$export$9f32ff922f69354d);
$parcel$export(module.exports, "EMPTY_STATE", () => $6e286b738469a3af$export$f040258c471d4154);
const $6e286b738469a3af$export$9f32ff922f69354d = {
    id: undefined,
    name: undefined,
    key: undefined,
    jiraRankFieldKey: undefined,
    avatarUrls: undefined,
    onboarded: undefined,
    selectedDeliveryProject: undefined,
    onboardedAtTimestamp: undefined,
    templateVersion: undefined,
    plays: null
};
const $6e286b738469a3af$export$f040258c471d4154 = {
    meta: {
        loadingProps: undefined,
        project: {
            loading: false,
            error: undefined
        },
        plays: {
            loading: false,
            error: undefined
        },
        playComments: {
            loading: false,
            error: undefined
        },
        insights: {
            loading: false,
            error: undefined
        }
    },
    project: $6e286b738469a3af$export$9f32ff922f69354d,
    projectTemplate: undefined,
    permissions: [],
    containerProps: undefined
};

});

parcelRegister("iidnT", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $b8a056e33d5be9c7$export$e7aa7bc5c1b3cfb3);

var $3jw96 = parcelRequire("3jw96");

var $8oKDI = parcelRequire("8oKDI");

var $ljej9 = parcelRequire("ljej9");

var $mCNic = parcelRequire("mCNic");
const $b8a056e33d5be9c7$var$transformSelectedDeliveryProject = (selectedDeliveryProject)=>{
    if (selectedDeliveryProject !== null && selectedDeliveryProject !== undefined) {
        const ari = (0, $8oKDI.toAri)(selectedDeliveryProject);
        return ari;
    }
    return undefined;
};
const $b8a056e33d5be9c7$var$ONBOARDED_AT_ADJUST_TIME = 10; // 10 seconds
const $b8a056e33d5be9c7$var$transformOnboardedAtTimestamp = (onboardedAt)=>{
    if (onboardedAt === null || onboardedAt === undefined) return undefined;
    // Increasing "onboardedAt" returned from polaris-api, since system clocks of polaris and jira can be unsynchronised
    // "onboardedAt" should be later than any "created" field of the template-generated issues
    return (0, $3jw96.default)(new Date(onboardedAt), $b8a056e33d5be9c7$var$ONBOARDED_AT_ADJUST_TIME).toISOString();
};
/**
 * Transform graphql response to project controller type PolarisProject.
 */ const $b8a056e33d5be9c7$var$transformResponse = (response)=>{
    const ari = (0, $8oKDI.toAri)(response.id);
    if (ari === undefined) throw new Error(`polaris-project.bad-project-ari: ${response.id}`);
    return {
        id: ari,
        name: undefined,
        key: undefined,
        jiraRankFieldKey: response.rankField != null ? response.rankField : undefined,
        onboarded: response.onboarded,
        avatarUrls: undefined,
        selectedDeliveryProject: $b8a056e33d5be9c7$var$transformSelectedDeliveryProject(response.selectedDeliveryProject),
        onboardedAtTimestamp: $b8a056e33d5be9c7$var$transformOnboardedAtTimestamp(response.onboardedAt),
        templateVersion: response.onboardTemplate ?? undefined,
        // fetched in a separate calls
        plays: null
    };
};
const $b8a056e33d5be9c7$var$transform = (restProject, ari)=>({
        id: ari,
        name: restProject.name,
        key: (0, $ljej9.toProjectKey)(restProject.key),
        avatarUrls: {
            '16x16': restProject.avatarUrls['16x16'],
            '24x24': restProject.avatarUrls['24x24'],
            '32x32': restProject.avatarUrls['32x32'],
            '48x48': restProject.avatarUrls['48x48']
        },
        onboarded: true,
        selectedDeliveryProject: undefined,
        plays: [],
        onboardedAtTimestamp: undefined,
        templateVersion: undefined
    });
const $b8a056e33d5be9c7$var$fetchMinimal = async (containerAri)=>{
    const { resourceId: projectId } = (0, $8oKDI.getAriConfig)(containerAri);
    const response = await (0, $mCNic.getProject)(projectId);
    return $b8a056e33d5be9c7$var$transform(response, containerAri);
};
// Error message: [...] API-9998 permission check failed [...]
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b8a056e33d5be9c7$var$isPermissionCheckError = (error)=>error instanceof Error ? error.message.search('API-9998') !== -1 : false;
const $b8a056e33d5be9c7$export$e7aa7bc5c1b3cfb3 = async ({ containerAri: containerAri, projectFetcher: projectFetcher, noCache: noCache, fireAnalyticsEvent: fireAnalyticsEvent, isSiteAdmin: isSiteAdmin })=>{
    if (projectFetcher) try {
        const response = await projectFetcher(containerAri, noCache === true, fireAnalyticsEvent === true);
        return $b8a056e33d5be9c7$var$transformResponse(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if ($b8a056e33d5be9c7$var$isPermissionCheckError(error) && isSiteAdmin) return $b8a056e33d5be9c7$var$fetchMinimal(containerAri);
        throw error;
    }
    return $b8a056e33d5be9c7$var$fetchMinimal(containerAri);
};

});
parcelRegister("mCNic", function(module, exports) {

$parcel$export(module.exports, "getProject", () => $b933ecc3f4134e5e$export$637b60a42bb03f06);

var $1Ozm9 = parcelRequire("1Ozm9");
const $b933ecc3f4134e5e$export$637b60a42bb03f06 = (id)=>(0, $1Ozm9.default)(`/rest/api/3/project/${id}?operation=getProject`, {
        method: 'GET'
    });

});



parcelRegister("2NErV", function(module, exports) {

$parcel$export(module.exports, "createPlay", () => $ae5fbda8a7f83f08$export$43898e7e35f5fda);
$parcel$export(module.exports, "updatePlayParams", () => $ae5fbda8a7f83f08$export$110f4c54a85aa775);
$parcel$export(module.exports, "deletePlay", () => $ae5fbda8a7f83f08$export$5d77b946e9b6bd6);
$parcel$export(module.exports, "loadPlays", () => $ae5fbda8a7f83f08$export$c2ec8930161dc920);
$parcel$export(module.exports, "upsertPlayContribution", () => $ae5fbda8a7f83f08$export$cbd6392dba96378b);
$parcel$export(module.exports, "loadPlayContributions", () => $ae5fbda8a7f83f08$export$274768618dc49676);
$parcel$export(module.exports, "deletePlayContribution", () => $ae5fbda8a7f83f08$export$a5f53b9fffb7f1c6);

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $lLN5n = parcelRequire("lLN5n");

var $jDdjf = parcelRequire("jDdjf");
const $ae5fbda8a7f83f08$var$withItemReplacedAtIndex = (items, index, replace)=>{
    if (index < 0 || index > items.length - 1) throw new Error('Attempt to replace an element at index out of bounds');
    const replacement = replace(items[index]);
    if (index === 0) return [
        replacement,
        ...items.slice(1)
    ];
    if (index === items.length - 1) return [
        ...items.slice(0, -1),
        replacement
    ];
    return [
        ...items.slice(0, index),
        replacement,
        ...items.slice(index + 1)
    ];
};
const $ae5fbda8a7f83f08$var$withItemRemovedAtIndex = (items, index)=>{
    if (index < 0 || index > items.length - 1) throw new Error('Attempt to remove an element at index out of bounds');
    if (index === 0) return items.slice(1);
    if (index === items.length - 1) return items.slice(0, -1);
    return [
        ...items.slice(0, index),
        ...items.slice(index + 1)
    ];
};
const $ae5fbda8a7f83f08$var$normalizeError = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unexpected error - catched value is not an instance of an Error class');
};
const $ae5fbda8a7f83f08$var$createUpdatedContributions = (existingContributions, contribution)=>{
    if (existingContributions === undefined) return [
        contribution
    ];
    const existingContributionIndex = existingContributions.findIndex((item)=>item.id === contribution.id);
    if (existingContributionIndex === -1) return [
        ...existingContributions,
        contribution
    ];
    return $ae5fbda8a7f83f08$var$withItemReplacedAtIndex(existingContributions, existingContributionIndex, ()=>contribution);
};
const $ae5fbda8a7f83f08$export$43898e7e35f5fda = (play)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            project: {
                ...state.project,
                plays: [
                    ...state.project.plays ?? [],
                    play
                ]
            }
        });
    };
const $ae5fbda8a7f83f08$export$110f4c54a85aa775 = (playAri, parameters)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        try {
            if (state.project.plays === null) throw new Error('Attempted params update of play in the nullified plays collection');
            const playIndex = state.project.plays.findIndex(({ id: id })=>id === playAri);
            if (playIndex === -1) throw new Error('Attempted params update of a non-existing play');
            setState({
                ...state,
                project: {
                    ...state.project,
                    plays: $ae5fbda8a7f83f08$var$withItemReplacedAtIndex(state.project.plays, playIndex, (play)=>({
                            ...play,
                            parameters: parameters
                        }))
                }
            });
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.project.plays.update-play-params', $ae5fbda8a7f83f08$var$normalizeError(error)));
        }
    };
const $ae5fbda8a7f83f08$export$5d77b946e9b6bd6 = (play)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        try {
            if (state.project.plays === null) throw new Error('Attempted deletion of a play from the nullified plays collection');
            const playIndex = state.project.plays.findIndex(({ id: id })=>id === play.id);
            if (playIndex === -1) throw new Error('Attempted deletion of a non-existing play');
            setState({
                ...state,
                project: {
                    ...state.project,
                    plays: $ae5fbda8a7f83f08$var$withItemRemovedAtIndex(state.project.plays, playIndex)
                }
            });
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.project.plays.delete-play', $ae5fbda8a7f83f08$var$normalizeError(error)));
        }
    };
const $ae5fbda8a7f83f08$export$c2ec8930161dc920 = (fireAnalyticsEvent = false)=>async ({ getState: getState, setState: setState }, { apolloClient: apolloClient, containerAri: containerAri, createAnalyticsEvent: createAnalyticsEvent, onProjectLoadingError: onProjectLoadingError })=>{
        try {
            const plays = await (0, $lLN5n.fetchPlays)(apolloClient, containerAri, createAnalyticsEvent, fireAnalyticsEvent)();
            const state = getState();
            setState({
                ...state,
                meta: {
                    ...state.meta,
                    plays: {
                        loading: true,
                        error: undefined
                    }
                },
                project: {
                    ...state.project,
                    plays: plays
                }
            });
        } catch (error) {
            const state = getState();
            const normalizedError = $ae5fbda8a7f83f08$var$normalizeError(error);
            setState({
                ...state,
                meta: {
                    ...state.meta,
                    plays: {
                        loading: false,
                        error: normalizedError
                    }
                },
                project: {
                    ...state.project,
                    plays: null
                }
            });
            onProjectLoadingError(normalizedError);
        }
    };
const $ae5fbda8a7f83f08$export$cbd6392dba96378b = (playId, contribution)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        try {
            if (state.project.plays === null) throw new Error('Attempted upsert of contribution on a nullified plays collection');
            const playIndex = state.project.plays.findIndex(({ id: id })=>id === playId);
            if (playIndex === -1) throw new Error('Attempted upsert of contribution on a non-existing play');
            setState({
                ...state,
                project: {
                    ...state.project,
                    plays: $ae5fbda8a7f83f08$var$withItemReplacedAtIndex(state.project.plays, playIndex, (play)=>({
                            ...play,
                            contributions: $ae5fbda8a7f83f08$var$createUpdatedContributions(play.contributions, contribution)
                        }))
                }
            });
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.project.plays.upsert-play-contribution', $ae5fbda8a7f83f08$var$normalizeError(error)));
        }
    };
const $ae5fbda8a7f83f08$export$274768618dc49676 = (subjectId, playId)=>async ({ getState: getState, setState: setState }, { cloudId: cloudId, playContributionRemote: playContributionRemote })=>{
        const state = getState();
        try {
            if (state.project.plays === null) throw new Error('Attempted load of play contributions while plays is a nullified collection');
            const currentPlayIndex = state.project.plays.findIndex((item)=>item.id === playId);
            if (currentPlayIndex === -1) throw new Error('Attempted load of play contributions for an non-existing play');
            const subjectAri = (0, $jDdjf.createIssueAri)(cloudId, subjectId);
            const existingContribution = state.project.plays[currentPlayIndex]?.contributions?.find((item)=>item.subject === subjectAri);
            if (existingContribution === undefined) throw new Error('Attempted load of play contributions while there is no given user contribution locally');
            if (// I don't understand why are we checking the existence of a comment here but it
            // was there before I started refactoring. No tests. No comments. Nothing meaningful
            // in the commit messages history. Worth revising. I'm too scared to remove it 😅 ~ bcytrowski
            existingContribution.comment !== undefined) throw new Error('Attempted load of play contributions while there is an existing user contribution with a comment');
            setState({
                meta: {
                    ...state.meta,
                    playComments: {
                        error: undefined,
                        loading: true
                    }
                }
            });
            const contributions = await playContributionRemote.getIssueContributions(playId, subjectAri);
            const newPlayContributions = state.project.plays[currentPlayIndex].contributions?.map((contribution)=>{
                const updatedContribution = contributions?.find((item)=>item.id === contribution.id);
                if (updatedContribution) return {
                    ...updatedContribution,
                    author: contribution.author
                };
                return contribution;
            });
            const newState = {
                ...state,
                project: {
                    ...state.project,
                    plays: $ae5fbda8a7f83f08$var$withItemReplacedAtIndex(state.project.plays, currentPlayIndex, (play)=>({
                            ...play,
                            contributions: newPlayContributions
                        }))
                }
            };
            setState(newState);
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.project.plays.load-play-contributions', $ae5fbda8a7f83f08$var$normalizeError(error)));
        } finally{
            setState({
                meta: {
                    ...state.meta,
                    playComments: {
                        error: undefined,
                        loading: false
                    }
                }
            });
        }
    };
const $ae5fbda8a7f83f08$export$a5f53b9fffb7f1c6 = (playId, contributionId)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        try {
            if (state.project.plays === null) throw new Error('Attempted deletion of play contribution from nullified plays collection');
            const currentPlayIndex = state.project.plays.findIndex((item)=>item.id === playId);
            if (currentPlayIndex === -1) throw new Error('Attempted deletion of play contribution from a non-existing play');
            const playContributions = state.project.plays[currentPlayIndex].contributions;
            if (playContributions === undefined) throw new Error('Attempted deletion of play contribution from undefined play.contributions collection');
            const contributionIndex = playContributions.findIndex((contribution)=>contribution.id === contributionId);
            if (contributionIndex === -1) throw new Error('Attempted deletion of non-existing play contribution');
            setState({
                ...state,
                project: {
                    ...state.project,
                    plays: $ae5fbda8a7f83f08$var$withItemReplacedAtIndex(state.project.plays, currentPlayIndex, (play)=>({
                            ...play,
                            contributions: $ae5fbda8a7f83f08$var$withItemRemovedAtIndex(playContributions, contributionIndex)
                        }))
                }
            });
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.controllers.project.plays.delete-play-contribution', $ae5fbda8a7f83f08$var$normalizeError(error)));
        }
    };

});
parcelRegister("lLN5n", function(module, exports) {

$parcel$export(module.exports, "transformCommentUser", () => $b594bfca1176d4d2$export$48593f62a17ecd94);
$parcel$export(module.exports, "fetchPlays", () => $b594bfca1176d4d2$export$2634a01e6d033f16);

var $hUlMp = parcelRequire("hUlMp");
const $b594bfca1176d4d2$export$48593f62a17ecd94 = (user)=>{
    if (!user) return {
        accountId: 'unknown',
        avatarUrls: {
            '16x16': '#',
            '24x24': '#',
            '32x32': '#',
            '48x48': '#'
        },
        displayName: 'Unknown user',
        active: false
    };
    return {
        accountId: user.accountId,
        avatarUrls: {
            '16x16': user.picture,
            '24x24': user.picture,
            '32x32': user.picture,
            '48x48': user.picture
        },
        displayName: user.name,
        active: true
    };
};
const $b594bfca1176d4d2$export$2634a01e6d033f16 = (apolloClient, projectAri, createAnalyticsEvent, fireAnalyticsEvent)=>()=>(0, $hUlMp.getPlaysData)(apolloClient, projectAri, createAnalyticsEvent, fireAnalyticsEvent).then((plays)=>[
                ...plays.map((play)=>({
                        id: play.id,
                        kind: play.kind,
                        label: play.label,
                        parameters: play.parameters ?? {},
                        contributions: play.contributions?.map(({ aaid: aaid, subject: subject, id: id, amount: amount, comment: comment, created: created, updated: updated, account: account })=>({
                                aaid: aaid,
                                subject: subject,
                                id: id,
                                amount: amount ?? 0,
                                created: created,
                                updated: updated,
                                author: $b594bfca1176d4d2$export$48593f62a17ecd94(account),
                                comment: comment ? {
                                    id: comment.id,
                                    updated: comment.updated,
                                    created: comment.created,
                                    body: comment.content,
                                    updateAuthor: undefined
                                } : undefined
                            }))
                    }))
            ]);

});
parcelRegister("hUlMp", function(module, exports) {

$parcel$export(module.exports, "getPlaysData", () => $f6c0183fe0a91835$export$2fb7a33d3c62c97b);

var $exWdq = parcelRequire("exWdq");

var $kuAvn = parcelRequire("kuAvn");

var $b88ud = parcelRequire("b88ud");

var $gCeeo = parcelRequire("gCeeo");
const $f6c0183fe0a91835$var$PROJECT_CONFIG_PLAYS_QUERY = (0, $kuAvn.default)`
  query jira_polaris_GetPlaysDataQuery($project: ID!, $skipComment: Boolean!) {
    polarisProject(id: $project, skipRefresh: true) {
      id
      plays {
        ...Play
      }
    }
  }
  ${(0, $b88ud.PLAY_FRAGMENT)}
`;
const $f6c0183fe0a91835$export$2fb7a33d3c62c97b = async (client, projectAri, createAnalyticsEvent, fireAnalyticsEvent)=>{
    const fetchStart = new Date();
    const result = await client.query({
        query: $f6c0183fe0a91835$var$PROJECT_CONFIG_PLAYS_QUERY,
        variables: {
            project: projectAri.toString(),
            skipComment: true
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
    });
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(result, 'data.polarisProject.plays')) throw new Error('project-config.fetch-error: no plays data or no data node');
    const plays = result.data?.polarisProject?.plays ?? [];
    if (fireAnalyticsEvent === true) (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'JpdFetchPlays succeeded', {
        projectAri: projectAri,
        durationMs: new Date().getTime() - fetchStart.getTime(),
        plays: plays.length,
        plays_contributions: plays.reduce((acc, play)=>acc + (play.contributions?.length || 0), 0)
    });
    return plays;
};

});
parcelRegister("b88ud", function(module, exports) {

$parcel$export(module.exports, "PLAY_CONTRIBUTION_FRAGMENT", () => $840e3aefc603ae60$export$bff4602e60e977f7);
$parcel$export(module.exports, "PLAY_FRAGMENT", () => $840e3aefc603ae60$export$1b9bcc6f2c25bbe);

var $kuAvn = parcelRequire("kuAvn");

var $14VgG = parcelRequire("14VgG");
const $840e3aefc603ae60$export$bff4602e60e977f7 = (0, $kuAvn.default)`
  fragment PlayContribution on PolarisPlayContribution {
    id
    aaid
    amount
    subject
    created
    updated
    account {
      accountId
      name
      picture
    }
    comment @skip(if: $skipComment) {
      ...PolarisPlayContributionComment
    }
  }
  ${(0, $14VgG.PLAY_CONTRIBUTION_COMMENT_FRAGMENT)}
`;
const $840e3aefc603ae60$export$1b9bcc6f2c25bbe = (0, $kuAvn.default)`
  fragment Play on PolarisPlay {
    id
    kind
    label
    parameters
    contributions {
      ...PlayContribution
    }
  }
  ${$840e3aefc603ae60$export$bff4602e60e977f7}
`;

});
parcelRegister("14VgG", function(module, exports) {

$parcel$export(module.exports, "COMMENT_FRAGMENT", () => $7e993327a1357301$export$9cd67ccd28de10d6);
$parcel$export(module.exports, "PLAY_CONTRIBUTION_COMMENT_FRAGMENT", () => $7e993327a1357301$export$d0dbd8febc0dfe68);

var $kuAvn = parcelRequire("kuAvn");
const $7e993327a1357301$export$9cd67ccd28de10d6 = (0, $kuAvn.default)`
  fragment PolarisComment on PolarisComment {
    id
    content
    account {
      accountId
      name
      picture
    }
    created
    updated
  }
`;
const $7e993327a1357301$export$d0dbd8febc0dfe68 = (0, $kuAvn.default)`
  fragment PolarisPlayContributionComment on PolarisComment {
    id
    content
    created
    updated
  }
`;

});





parcelRegister("kRQgN", function(module, exports) {

$parcel$export(module.exports, "setSelectedDeliveryProject", () => $efe482a8a113960f$export$e96c2e5afb6f40a2);

var $5OABF = parcelRequire("5OABF");
const $efe482a8a113960f$export$e96c2e5afb6f40a2 = (deliveryProjectAri)=>async ({ getState: getState, setState: setState }, { apolloClient: apolloClient, onActionFailed: onActionFailed })=>{
        const { project: project } = getState();
        if (project.id) (0, $5OABF.setDeliveryProject)(apolloClient, project.id, deliveryProjectAri).then(()=>{
            setState({
                project: {
                    ...project,
                    selectedDeliveryProject: deliveryProjectAri
                }
            });
        }).catch((error)=>{
            onActionFailed(error);
        });
    };

});
parcelRegister("5OABF", function(module, exports) {

$parcel$export(module.exports, "setDeliveryProject", () => $4ffb717bd8af3086$export$e36eea9bca0c7df9);

var $kuAvn = parcelRequire("kuAvn");
const $4ffb717bd8af3086$var$SET_POLARIS_SELECTED_DELIVERY_PROJECT_MUTATION = (0, $kuAvn.default)`
mutation jira_polaris_SetPolarisSelectedDeliveryProject($input: SetPolarisSelectedDeliveryProjectInput!) {
    setPolarisSelectedDeliveryProject(input: $input) {
        success
        errors {
            message
        }
    }
}
`;
// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type.
const $4ffb717bd8af3086$var$handleResult = (result)=>{
    if (result.errors !== undefined) throw new Error(`polaris-ideas.set-delivery-project-error:${result.errors// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    .map((e)=>e.message).join(', ')}`);
    return true;
};
const $4ffb717bd8af3086$export$e36eea9bca0c7df9 = (client, projectAri, deliveryProjectAri)=>{
    const variables = {
        input: {
            projectId: projectAri,
            selectedDeliveryProjectId: deliveryProjectAri
        }
    };
    return client.mutate({
        mutation: $4ffb717bd8af3086$var$SET_POLARIS_SELECTED_DELIVERY_PROJECT_MUTATION,
        variables: variables
    }).then($4ffb717bd8af3086$var$handleResult);
};

});


parcelRegister("1eYnc", function(module, exports) {

$parcel$export(module.exports, "unLoadProject", () => $a8e67fdc9bf768c6$export$a2e5be018cdd705c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $739bA = parcelRequire("739bA");
const $a8e67fdc9bf768c6$export$a2e5be018cdd705c = ()=>async ({ getState: getState, setState: setState })=>{
        setState({
            meta: {
                ...getState().meta,
                loadingProps: undefined,
                project: {
                    loading: false,
                    error: undefined
                }
            },
            project: (0, $739bA.EMPTY_PROJECT_STATE)
        });
    };

});

parcelRegister("a51L9", function(module, exports) {

$parcel$export(module.exports, "updateProjectDetails", () => $553dd56331996b36$export$437db65a101218a9);

var $8oKDI = parcelRequire("8oKDI");

var $ljej9 = parcelRequire("ljej9");
const $553dd56331996b36$export$437db65a101218a9 = (key, name, avatarId)=>async ({ getState: getState, setState: setState })=>{
        const { project: project } = getState();
        if (project.id) {
            const pid = (0, $8oKDI.getAriConfig)(project.id).resourceId;
            const avatarUrls = {
                '16x16': `/secure/projectavatar?size=xsmall&s=xsmall&pid=${pid}&avatarId=${avatarId}`,
                '24x24': `/secure/projectavatar?size=small&s=small&pid=${pid}&avatarId=${avatarId}`,
                '32x32': `/secure/projectavatar?size=medium&s=medium&pid=${pid}&avatarId=${avatarId}`,
                '48x48': `/secure/projectavatar?pid=${pid}&avatarId=${avatarId}`
            };
            setState({
                project: {
                    ...project,
                    key: (0, $ljej9.toProjectKey)(key),
                    name: name,
                    avatarUrls: avatarUrls
                }
            });
        }
    };

});




parcelRegister("9AO22", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f9558ba3f58a008$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $50ltq = parcelRequire("50ltq");

var $8E9Lh = parcelRequire("8E9Lh");

var $ffZim = parcelRequire("ffZim");

var $uC972 = parcelRequire("uC972");

var $651r0 = parcelRequire("651r0");

var $cHovn = parcelRequire("cHovn");

var $59oat = parcelRequire("59oat");

var $17y5b = parcelRequire("17y5b");

var $aFbS5 = parcelRequire("aFbS5");

var $db1qQ = parcelRequire("db1qQ");

var $6JcdT = parcelRequire("6JcdT");

var $adX4t = parcelRequire("adX4t");

var $lvf3r = parcelRequire("lvf3r");

var $dkKwx = parcelRequire("dkKwx");

var $edREW = parcelRequire("edREW");

var $i8ZQM = parcelRequire("i8ZQM");

var $aDGGE = parcelRequire("aDGGE");

var $gJMbI = parcelRequire("gJMbI");

var $3la2z = parcelRequire("3la2z");

var $6CCCQ = parcelRequire("6CCCQ");

var $hAB8j = parcelRequire("hAB8j");

var $k68oL = parcelRequire("k68oL");

var $lBPXG = parcelRequire("lBPXG");

var $6hgrJ = parcelRequire("6hgrJ");

var $M3QQB = parcelRequire("M3QQB");

var $jpX1D = parcelRequire("jpX1D");

var $jD8ef = parcelRequire("jD8ef");

var $dVE1x = parcelRequire("dVE1x");

var $gXTjR = parcelRequire("gXTjR");

var $jZDOT = parcelRequire("jZDOT");

var $fPbNL = parcelRequire("fPbNL");

var $5DWvi = parcelRequire("5DWvi");

var $3PB4Y = parcelRequire("3PB4Y");

var $1ET7h = parcelRequire("1ET7h");

var $dtpA8 = parcelRequire("dtpA8");

var $jfjhg = parcelRequire("jfjhg");

var $e7p41 = parcelRequire("e7p41");

var $jfPj4 = parcelRequire("jfPj4");

var $cNkV6 = parcelRequire("cNkV6");

var $hgTd8 = parcelRequire("hgTd8");

var $3TA1a = parcelRequire("3TA1a");

var $7VEhh = parcelRequire("7VEhh");

var $iy7OM = parcelRequire("iy7OM");

var $kth50 = parcelRequire("kth50");

var $4qYoW = parcelRequire("4qYoW");
// Do not add to this list, this is a major runtime barelling point
// Instead of
//    dispatch(actions.foo(arg))
// Use
//    dispatch(actions.dispatch(foo(arg)))
// Where you've imported `foo()` directly from it's definition
const $3f9558ba3f58a008$var$actions = {
    addDeferredEvent: $4qYoW.addDeferredEvent,
    resumeRealtimeEvents: $4qYoW.resumeRealtimeEvents,
    pauseRealtimeEvents: $4qYoW.pauseRealtimeEvents,
    submitIdea: $17y5b.submitIdea,
    createAndUpdate: $17y5b.createAndUpdate,
    createAndConnect: $17y5b.createAndConnect,
    setLoading: $dtpA8.setLoading,
    setError: $5DWvi.setError,
    setIssueLinksForSelectedIssue: $1ET7h.setIssueLinksForSelectedIssue,
    moveIssue: $lBPXG.moveIssue,
    rankBefore: $lBPXG.rankBefore,
    archiveIssues: $8E9Lh.archiveIssues,
    unarchiveIssues: $8E9Lh.unarchiveIssues,
    rankAfter: $lBPXG.rankAfter,
    loadIssues: $k68oL.loadIssues,
    loadArchivedIssues: $k68oL.loadArchivedIssues,
    initialize: $lvf3r.initialize,
    initializeArchived: $lvf3r.initializeArchived,
    addPropertiesForLoadedIssue: $lvf3r.addPropertiesForLoadedIssue,
    addPropertiesForLoadedIssues: $lvf3r.addPropertiesForLoadedIssues,
    loadDeliveryProgress: $hAB8j.loadDeliveryProgress,
    refreshDeliveryProgressForSelectedIssue: $hAB8j.refreshDeliveryProgressForSelectedIssue,
    refreshDeliveryProgressForSpecificIssue: $hAB8j.refreshDeliveryProgressForSpecificIssue,
    refreshDeliveryDataForConnectionField: $hAB8j.refreshDeliveryDataForConnectionField,
    createIssue: $17y5b.createIssue,
    createIssueAfter: $17y5b.createIssueAfter,
    createIssueBefore: $17y5b.createIssueBefore,
    safelySwapRowInCreationWithCreated: $17y5b.safelySwapRowInCreationWithCreated,
    saveIssue: $17y5b.saveIssue,
    saveIssueBulk: $kth50.saveIssueBulk,
    cancelCreateIssue: $17y5b.cancelCreateIssue,
    cancelCreations: $17y5b.cancelCreations,
    updateCheckboxOrRatingNumberFieldMapping: $jfPj4.updateCheckboxOrRatingNumberFieldMapping,
    updateFieldValue: $cNkV6.updateFieldValue,
    updateFieldValues: $cNkV6.updateFieldValues,
    updateFieldValueWithBulk: $cNkV6.updateFieldValueWithBulk,
    updateFieldValueForSelectedIssue: $cNkV6.updateFieldValueForSelectedIssue,
    refreshConnectionFieldsValues: $gXTjR.refreshConnectionFieldsValues,
    resetConnectionFieldsValues: $gXTjR.resetConnectionFieldsValues,
    updateIssueConnections: $cHovn.updateIssueConnections,
    updateConnectionFieldValue: $cHovn.updateConnectionFieldValue,
    addConnectionIssuesData: $cHovn.addConnectionIssuesData,
    invalidateFieldValue: $3la2z.invalidateFieldValue,
    resetLastUpdatedIssueIds: $cNkV6.resetLastUpdatedIssueIds,
    resetLastUpdatedIssueAction: $cNkV6.resetLastUpdatedIssueAction,
    updateStatus: $3TA1a.updateStatus,
    updateField: $hgTd8.updateField,
    refreshIssues: $jZDOT.refreshIssues,
    refreshStatuses: $iy7OM.refreshStatuses,
    clearCreatedProperty: $17y5b.clearCreatedProperty,
    updateStatusInStateOnly: $3TA1a.updateStatusInStateOnly,
    updateStatusInStateOnlyWithBulk: $3TA1a.updateStatusInStateOnlyWithBulk,
    removeIssueFromState: $fPbNL.removeIssueFromState,
    deleteIssues: $aFbS5.deleteIssues,
    clonePolarisIssue: $ffZim.clonePolarisIssue,
    deleteExternalIssues: $aFbS5.deleteExternalIssues,
    createDynamicFieldSelectors: $59oat.createDynamicFieldSelectors,
    updateDynamicFieldSelector: $59oat.updateDynamicFieldSelector,
    linkIssue: $6CCCQ.linkIssue,
    linkDeliveryIssue: $6CCCQ.linkDeliveryIssue,
    unlinkIssueFromStore: $e7p41.unlinkIssueFromStore,
    unlinkDeliveryIssue: $e7p41.unlinkDeliveryIssue,
    moveIssuesToTop: $6hgrJ.moveIssuesToTop,
    adaptExternalIssueRank: $6JcdT.adaptExternalIssueRank,
    rankIdeasWithCurrentSorting: $651r0.rankIdeasWithCurrentSorting,
    incrementOpenUpdateCounter: $dVE1x.incrementOpenUpdateCounter,
    decrementOpenUpdateCounter: $dVE1x.decrementOpenUpdateCounter,
    updateExternalReferenceEntities: $adX4t.updateExternalReferenceEntities,
    toggleReaction: $jpX1D.toggleReaction,
    execWithIssueAnalyticsData: $50ltq.execWithIssueAnalyticsData,
    exportStringValues: $db1qQ.exportStringValues,
    scheduleDynamicFieldCalculation: $59oat.scheduleDynamicFieldCalculation,
    setIsSingleIssueLoaded: $3PB4Y.setIsSingleIssueLoaded,
    syncFieldValues: $jfjhg.syncFieldValues,
    loadTrackingMetadata: // Metadata action
    $7VEhh.loadTrackingMetadata,
    setCommentsForSelectedIssue: // Comments Actions
    $uC972.setCommentsForSelectedIssue,
    setTimestampIssueCommentsSeen: $uC972.setTimestampIssueCommentsSeen,
    setTimestampCommentsSeen: $uC972.setTimestampCommentsSeen,
    signalCommentsUpdates: $uC972.signalCommentsUpdates,
    createInsight: // Insights Actions
    $dkKwx.createInsight,
    updateInsightFromRemote: $gJMbI.updateInsightFromRemote,
    updateInsights: $gJMbI.updateInsights,
    updateInsightsFromProps: $gJMbI.updateInsightsFromProps,
    deleteInsight: $edREW.deleteInsight,
    deleteInsightFromRemote: $edREW.deleteInsightFromRemote,
    refreshInsights: $i8ZQM.refreshInsights,
    refreshSnippet: $i8ZQM.refreshSnippet,
    setTimestampIssueInsightsSeen: $aDGGE.setTimestampIssueInsightsSeen,
    updateIssueGoals: // Goals actions
    $jD8ef.updateIssueGoals,
    createPlayContribution: // Play actions
    $M3QQB.createPlayContribution,
    deletePlayContribution: $M3QQB.deletePlayContribution,
    deletePlayContributionFromRemote: $M3QQB.deletePlayContributionFromRemote,
    updatePlayContributionsFromProps: $M3QQB.updatePlayContributionsFromProps,
    updatePlayContribution: $M3QQB.updatePlayContribution,
    upsertPlayContributionFromRemote: $M3QQB.upsertPlayContributionFromRemote,
    /**
	 * this action has no side effects. It is a helper accessor to get the container
	 * props in through the hook API and forwarded to the reselect selectors
	 */ getContainerProps: ()=>(ops, props)=>props
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3f9558ba3f58a008$var$universalDispatch(thunk) {
    return ({ dispatch: dispatch })=>dispatch(thunk);
}
// We patch the actions to add a universal dispatcher
// Eventually the actions list should be entirely eliminated
const $3f9558ba3f58a008$var$ActionsWithDispatch = {
    ...$3f9558ba3f58a008$var$actions,
    dispatch: $3f9558ba3f58a008$var$universalDispatch
};
var $3f9558ba3f58a008$export$2e2bcd8739ae039 = $3f9558ba3f58a008$var$ActionsWithDispatch;

});
parcelRegister("50ltq", function(module, exports) {

$parcel$export(module.exports, "execWithIssueAnalyticsData", () => $cd4422f7858af42c$export$839b36bfa2395d57);

var $4TCfW = parcelRequire("4TCfW");
const $cd4422f7858af42c$export$839b36bfa2395d57 = (localIssueId, callback)=>({ getState: getState })=>{
        const analyticsData = localIssueId ? (0, $4TCfW.createGetIssueAnalyticsAttributes)(localIssueId)(getState()) : {};
        callback(analyticsData);
    };

});
parcelRegister("4TCfW", function(module, exports) {

$parcel$export(module.exports, "getProperties", () => $aed9c169bf72dbd9$export$28195c1f3490f3f1);
$parcel$export(module.exports, "getStringProperties", () => $aed9c169bf72dbd9$export$5822aeea7efbda72);
$parcel$export(module.exports, "getKeyProperties", () => $aed9c169bf72dbd9$export$cfb9d9a28a5421af);
$parcel$export(module.exports, "getNumberProperties", () => $aed9c169bf72dbd9$export$eaf974908c9ece90);
$parcel$export(module.exports, "getJiraIssueIdProperties", () => $aed9c169bf72dbd9$export$cc9d2d84f8c61e3c);
$parcel$export(module.exports, "getUserProperties", () => $aed9c169bf72dbd9$export$a577be47e15c9e4d);
$parcel$export(module.exports, "getTeamProperties", () => $aed9c169bf72dbd9$export$351bc010a6319475);
$parcel$export(module.exports, "getPeopleProperties", () => $aed9c169bf72dbd9$export$219c0f33cdd5c2e9);
$parcel$export(module.exports, "getAllGoalsAri", () => $aed9c169bf72dbd9$export$8843845f8d632889);
$parcel$export(module.exports, "getExternalReferencesProperties", () => $aed9c169bf72dbd9$export$e172e3f9ebb22198);
$parcel$export(module.exports, "getExternalReferenceEntitiesProperties", () => $aed9c169bf72dbd9$export$1c64035c8cfdb70e);
$parcel$export(module.exports, "getAllExternalReferencesPropertiesByProvider", () => $aed9c169bf72dbd9$export$9fce1ab0efd6fba6);
$parcel$export(module.exports, "getSingleOptionProperties", () => $aed9c169bf72dbd9$export$1bf8a4c5ae977961);
$parcel$export(module.exports, "getCreatedProperties", () => $aed9c169bf72dbd9$export$d300af0c04327d70);
$parcel$export(module.exports, "getCreatedProperty", () => $aed9c169bf72dbd9$export$2dd4dbf8bf4ab076);
$parcel$export(module.exports, "getConnectionProperties", () => $aed9c169bf72dbd9$export$80c4a39893d6c386);
$parcel$export(module.exports, "getIdeasInCreationCount", () => $aed9c169bf72dbd9$export$d9d7786fe75fbf8b);
$parcel$export(module.exports, "getIdeasInCreationGrouped", () => $aed9c169bf72dbd9$export$66f866517dbf474);
$parcel$export(module.exports, "getIdeasInCreation", () => $aed9c169bf72dbd9$export$133ddc5b12d28d14);
$parcel$export(module.exports, "getIssueTypeProperties", () => $aed9c169bf72dbd9$export$2b5441465ca750d3);
$parcel$export(module.exports, "getCreatedIssueIds", () => $aed9c169bf72dbd9$export$1e6b95880b5a6afd);
$parcel$export(module.exports, "getIssueIdsInCreation", () => $aed9c169bf72dbd9$export$5891ee2f15264a03);
$parcel$export(module.exports, "getProjectProperties", () => $aed9c169bf72dbd9$export$479db5e12dc5e982);
$parcel$export(module.exports, "getSelectedIssue", () => $aed9c169bf72dbd9$export$6c0d88009e457a5b);
$parcel$export(module.exports, "getSelectedIssueLocalIssueId", () => $aed9c169bf72dbd9$export$a654cb39c2007081);
$parcel$export(module.exports, "hasSelectedLocalIssueId", () => $aed9c169bf72dbd9$export$357fa721837ad1b6);
$parcel$export(module.exports, "getSelectedIssueJiraId", () => $aed9c169bf72dbd9$export$950bac2497d1aa75);
$parcel$export(module.exports, "createGetKeySelector", () => $aed9c169bf72dbd9$export$14924b965a1981dd);
$parcel$export(module.exports, "createGetIdSelector", () => $aed9c169bf72dbd9$export$710f42fb6f71356b);
$parcel$export(module.exports, "createSafeGetKeySelector", () => $aed9c169bf72dbd9$export$115e5512c983a4d8);
$parcel$export(module.exports, "createSafeGetJiraIdSelector", () => $aed9c169bf72dbd9$export$2385217f7936b0e6);
$parcel$export(module.exports, "createGetProjectSelector", () => $aed9c169bf72dbd9$export$932f560831f397e4);
$parcel$export(module.exports, "createGetProjectIdSelector", () => $aed9c169bf72dbd9$export$1b686255fde505fc);
$parcel$export(module.exports, "createGetSummary", () => $aed9c169bf72dbd9$export$65299e53ce4172b4);
$parcel$export(module.exports, "createGetDescription", () => $aed9c169bf72dbd9$export$f088d9da19e05092);
$parcel$export(module.exports, "createGetIssueType", () => $aed9c169bf72dbd9$export$2bde03fd901c6480);
$parcel$export(module.exports, "createGetStatus", () => $aed9c169bf72dbd9$export$f997dbc7ec26c5ed);
$parcel$export(module.exports, "createGetStatusesForIssues", () => $aed9c169bf72dbd9$export$91edde09c155b9c0);
$parcel$export(module.exports, "createGetIssueCreationStateProperties", () => $aed9c169bf72dbd9$export$de4fce2131268308);
$parcel$export(module.exports, "createGetStringValueSelector", () => $aed9c169bf72dbd9$export$e2d155be0c3de614);
$parcel$export(module.exports, "createGetExternalReferencesValueSelector", () => $aed9c169bf72dbd9$export$93ddfa2b68c30468);
$parcel$export(module.exports, "createGetPlatformGoalsValueSelector", () => $aed9c169bf72dbd9$export$6c55f925decac8ab);
$parcel$export(module.exports, "createGetExternalReferencePropertyValueSelector", () => $aed9c169bf72dbd9$export$b9786cf6872cd58d);
$parcel$export(module.exports, "createGetIntervalDateValuesSelector", () => $aed9c169bf72dbd9$export$fe1332a3bca94a58);
$parcel$export(module.exports, "createGetIsArchivedSelector", () => $aed9c169bf72dbd9$export$3a239b003b41e45b);
$parcel$export(module.exports, "createGetNumberValueSelector", () => $aed9c169bf72dbd9$export$3a51a5b289c02204);
$parcel$export(module.exports, "createGetFieldNumberValuesSelector", () => $aed9c169bf72dbd9$export$c52ad06ffaf85e48);
$parcel$export(module.exports, "createGetStringListValueSelector", () => $aed9c169bf72dbd9$export$8b13761aa46b9353);
$parcel$export(module.exports, "createGetSingleOptionSelector", () => $aed9c169bf72dbd9$export$e4573755e70864f7);
$parcel$export(module.exports, "createGetFieldSingleOptionSelector", () => $aed9c169bf72dbd9$export$1b97a4f9306d6ed3);
$parcel$export(module.exports, "createGetMultiOptionSelector", () => $aed9c169bf72dbd9$export$c540689784034e);
$parcel$export(module.exports, "createGetFieldMultiOptionsSelector", () => $aed9c169bf72dbd9$export$bf672e5157063678);
$parcel$export(module.exports, "createGetUserSelector", () => $aed9c169bf72dbd9$export$c2f2776527e40141);
$parcel$export(module.exports, "createGetTeamSelector", () => $aed9c169bf72dbd9$export$51784373ad8ed468);
$parcel$export(module.exports, "createGetUserByAccountIdSelector", () => $aed9c169bf72dbd9$export$85111f87a1ceed3e);
$parcel$export(module.exports, "createGetFieldUserSelector", () => $aed9c169bf72dbd9$export$da5d02be3ddf0999);
$parcel$export(module.exports, "createGetPeopleSelector", () => $aed9c169bf72dbd9$export$2eb04d711a81ced9);
$parcel$export(module.exports, "createGetPeopleByAccountIdSelector", () => $aed9c169bf72dbd9$export$2047fb5f7b1b64b4);
$parcel$export(module.exports, "createGetPeopleTransformedSelector", () => $aed9c169bf72dbd9$export$d2a49ed2b1f7dfdd);
$parcel$export(module.exports, "createGetSingularStatusSelectorForSelectedIssueHook", () => $aed9c169bf72dbd9$export$900f4ecc52ceeb14);
$parcel$export(module.exports, "createSpecificallyMemoizedDataSelector", () => $aed9c169bf72dbd9$export$deb4cf6d109ae929);
$parcel$export(module.exports, "getIsDeliveryTicketLinkedInProject", () => $aed9c169bf72dbd9$export$c65912bba1b1195f);
$parcel$export(module.exports, "createGetIssueAnalyticsAttributes", () => $aed9c169bf72dbd9$export$bed6941efbc9c35a);
$parcel$export(module.exports, "createIsFieldAssociatedToIssue", () => $aed9c169bf72dbd9$export$2e1e988cf020a96b);

var $ahm5r = parcelRequire("ahm5r");

var $75SEb = parcelRequire("75SEb");

var $4lj8A = parcelRequire("4lj8A");

var $aX8Tx = parcelRequire("aX8Tx");

var $eI1yv = parcelRequire("eI1yv");

var $exWdq = parcelRequire("exWdq");

var $1yBwF = parcelRequire("1yBwF");

var $4c94y = parcelRequire("4c94y");

var $9pL9Y = parcelRequire("9pL9Y");

var $ZFqXT = parcelRequire("ZFqXT");

var $jvwCK = parcelRequire("jvwCK");

var $3l9kN = parcelRequire("3l9kN");

var $40zJW = parcelRequire("40zJW");

var $jUVzX = parcelRequire("jUVzX");

var $e8XBu = parcelRequire("e8XBu");
var $kQ82p = parcelRequire("kQ82p");

var $7keuM = parcelRequire("7keuM");

var $3ZrK1 = parcelRequire("3ZrK1");

var $eTBmS = parcelRequire("eTBmS");

var $emfB5 = parcelRequire("emfB5");

var $62tnP = parcelRequire("62tnP");


var $8Z1Mi = parcelRequire("8Z1Mi");

var $5zHFN = parcelRequire("5zHFN");

var $jnihY = parcelRequire("jnihY");

var $3degy = parcelRequire("3degy");

var $ljej9 = parcelRequire("ljej9");

var $5tOWS = parcelRequire("5tOWS");

var $9U0CQ = parcelRequire("9U0CQ");


var $iehDF = parcelRequire("iehDF");

var $53OVi = parcelRequire("53OVi");

var $feobD = parcelRequire("feobD");


const $aed9c169bf72dbd9$export$28195c1f3490f3f1 = (state)=>state.properties;
const $aed9c169bf72dbd9$export$5822aeea7efbda72 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.string);
const $aed9c169bf72dbd9$export$cfb9d9a28a5421af = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$5822aeea7efbda72, (stringProperties)=>stringProperties.key);
const $aed9c169bf72dbd9$export$f2d2e9e1ba1c186c = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.document);
const $aed9c169bf72dbd9$export$3f02fbdb35084022 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.status);
const $aed9c169bf72dbd9$export$eaf974908c9ece90 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.number);
const $aed9c169bf72dbd9$export$cc9d2d84f8c61e3c = (state)=>$aed9c169bf72dbd9$export$eaf974908c9ece90(state).issueid || {};
const $aed9c169bf72dbd9$export$9b1a92817eb1ba25 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.stringList);
const $aed9c169bf72dbd9$export$a577be47e15c9e4d = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.user);
const $aed9c169bf72dbd9$export$351bc010a6319475 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.team);
const $aed9c169bf72dbd9$export$219c0f33cdd5c2e9 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.people);
const $aed9c169bf72dbd9$export$3ac0d17cd37489a4 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.externalReferenceEntities);
const $aed9c169bf72dbd9$export$edb1075fa7399715 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.goals);
const $aed9c169bf72dbd9$export$8843845f8d632889 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$edb1075fa7399715, (goalsProperties)=>{
    const allGoals = Object.values(goalsProperties).flatMap((goalsByIssueId)=>Object.values(goalsByIssueId)).flat();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(allGoals.filter(Boolean));
});
const $aed9c169bf72dbd9$export$e172e3f9ebb22198 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.externalReference);
const $aed9c169bf72dbd9$export$1c64035c8cfdb70e = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.externalReferenceEntities);
const $aed9c169bf72dbd9$export$9fce1ab0efd6fba6 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$e172e3f9ebb22198, (state)=>state.containerProps?.fields, (state)=>state.ids, (state)=>state.connectionIssueIds, (externalReferenceProperties, fields, ids, connectionIssueIds)=>{
    const filteredFields = fields?.filter((field)=>field.configuration?.provider);
    const providers = filteredFields?.reduce((result, field)=>{
        if (field.configuration?.provider) return Object.assign(result, {
            [field.configuration?.provider]: []
        });
        return result;
    }, {}) || {};
    Object.keys(providers).forEach((key)=>{
        const mapId = (id)=>filteredFields?.filter((field)=>field.configuration?.provider === key).map((field)=>externalReferenceProperties?.[field.key]?.[id]).filter(Boolean) || [];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        providers[key] = Array.from(new Set([
            ...(0, (/*@__PURE__*/$parcel$interopDefault($eI1yv)))(ids.map(mapId)),
            ...(0, (/*@__PURE__*/$parcel$interopDefault($eI1yv)))(connectionIssueIds.map(mapId))
        ]));
    });
    return providers;
});
const $aed9c169bf72dbd9$export$1bf8a4c5ae977961 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.singleSelect);
const $aed9c169bf72dbd9$export$ca746d92270c6240 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.multiSelect);
const $aed9c169bf72dbd9$export$d300af0c04327d70 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.created);
const $aed9c169bf72dbd9$export$2dd4dbf8bf4ab076 = ({ issueId: issueId })=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$d300af0c04327d70, (createdProperties)=>createdProperties[issueId]);
const $aed9c169bf72dbd9$export$80c4a39893d6c386 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.connection);
const $aed9c169bf72dbd9$export$d9d7786fe75fbf8b = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$d300af0c04327d70, (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ZFqXT)))((0, (/*@__PURE__*/$parcel$interopDefault($75SEb)))(props, ({ status: status })=>status === (0, $d5435e25fbd81376$export$336731f504687455) || status === (0, $d5435e25fbd81376$export$2990a40bc316c88b))));
const $aed9c169bf72dbd9$export$66f866517dbf474 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$d300af0c04327d70, (createdProperties)=>{
    const result = {};
    Object.keys(createdProperties).forEach((key)=>{
        const createdProperty = createdProperties[key];
        if (createdProperty.status === (0, $d5435e25fbd81376$export$336731f504687455) || createdProperty.status === (0, $d5435e25fbd81376$export$2990a40bc316c88b)) result[key] = createdProperty;
    });
    return result;
});
const $aed9c169bf72dbd9$export$133ddc5b12d28d14 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$66f866517dbf474, (ideas)=>Object.keys(ideas));
const $aed9c169bf72dbd9$export$2b5441465ca750d3 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.issueType);
const $aed9c169bf72dbd9$var$getInsightsProperties = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.insights);
const $aed9c169bf72dbd9$var$getAggregatedDeliveryProgressProperties = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.aggregatedDeliveryProgress);
const $aed9c169bf72dbd9$export$1e6b95880b5a6afd = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$d300af0c04327d70, (createdPoperties)=>{
    if (createdPoperties !== undefined) return Object.keys(createdPoperties);
    return [];
});
const $aed9c169bf72dbd9$export$5891ee2f15264a03 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$d300af0c04327d70, (createdProperties)=>{
    if (createdProperties !== undefined) {
        const issueIdsInCreation = (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(createdProperties, (o)=>o.status === (0, $d5435e25fbd81376$export$336731f504687455));
        return Object.keys(issueIdsInCreation);
    }
    return [];
});
const $aed9c169bf72dbd9$export$479db5e12dc5e982 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$28195c1f3490f3f1, (properties)=>properties.projects.project);
const $aed9c169bf72dbd9$export$6c0d88009e457a5b = (state)=>state.selectedIssue;
const $aed9c169bf72dbd9$export$a654cb39c2007081 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$6c0d88009e457a5b, $aed9c169bf72dbd9$export$cfb9d9a28a5421af, (selectedIssue, keyProperties)=>(0, (/*@__PURE__*/$parcel$interopDefault($4lj8A)))(keyProperties, (issueKey)=>selectedIssue === issueKey));
const $aed9c169bf72dbd9$export$357fa721837ad1b6 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$a654cb39c2007081, (issueId)=>issueId !== undefined);
const $aed9c169bf72dbd9$export$950bac2497d1aa75 = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$a654cb39c2007081, $aed9c169bf72dbd9$export$cc9d2d84f8c61e3c, (selectedIssueLocalId, jiraIdProperty)=>selectedIssueLocalId ? jiraIdProperty[selectedIssueLocalId] : undefined);
const $aed9c169bf72dbd9$export$14924b965a1981dd = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$5822aeea7efbda72, (stringProperties)=>stringProperties.key[id]);
const $aed9c169bf72dbd9$export$710f42fb6f71356b = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$eaf974908c9ece90, (numberProperties)=>numberProperties.issueid[id]);
const $aed9c169bf72dbd9$export$115e5512c983a4d8 = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$cfb9d9a28a5421af, (keyProperties)=>id === undefined ? undefined : keyProperties?.[id]);
const $aed9c169bf72dbd9$export$2385217f7936b0e6 = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$eaf974908c9ece90, (numberProperties)=>id === undefined || numberProperties.issueid === undefined || numberProperties.issueid[id] === undefined ? undefined : (0, $ljej9.toIssueId)(String(numberProperties.issueid[id])));
const $aed9c169bf72dbd9$export$932f560831f397e4 = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$479db5e12dc5e982, (projectProperties)=>{
        if (id === undefined) return undefined;
        return projectProperties?.[id];
    });
const $aed9c169bf72dbd9$export$1b686255fde505fc = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$932f560831f397e4(id), (project)=>project?.id);
const $aed9c169bf72dbd9$export$65299e53ce4172b4 = (id)=>(0, $ahm5r.createSelector)((0, $iehDF.getAllFieldsByKey), $aed9c169bf72dbd9$export$5822aeea7efbda72, (fields, stringProperties)=>{
        const { key: fieldKey } = fields.summary;
        return stringProperties[fieldKey][id];
    });
const $aed9c169bf72dbd9$export$f088d9da19e05092 = (id)=>(0, $ahm5r.createSelector)((0, $iehDF.getAllFieldsByKey), $aed9c169bf72dbd9$export$f2d2e9e1ba1c186c, (fields, documentProperties)=>{
        if (id === undefined || fields?.description === undefined) return undefined;
        const { key: fieldKey } = fields.description;
        return documentProperties[fieldKey]?.[id];
    });
const $aed9c169bf72dbd9$export$2bde03fd901c6480 = (id)=>(0, $ahm5r.createSelector)((0, $iehDF.getAllFieldsByKey), $aed9c169bf72dbd9$export$2b5441465ca750d3, (fields, issueTypeProperties)=>{
        if (id === undefined || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, (0, $9a5f06039e1dff5a$export$dd03acb09519222))) return undefined;
        const { key: fieldKey } = fields[0, $9a5f06039e1dff5a$export$dd03acb09519222];
        return issueTypeProperties[fieldKey]?.[id];
    });
const $aed9c169bf72dbd9$export$f997dbc7ec26c5ed = (id)=>(0, $ahm5r.createSelector)((0, $iehDF.getAllFieldsByKey), $aed9c169bf72dbd9$export$3f02fbdb35084022, (fields, statusProperties)=>{
        if (id === undefined || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, (0, $9a5f06039e1dff5a$export$29157f6cae91bb2f))) return undefined;
        const { key: fieldKey } = fields[0, $9a5f06039e1dff5a$export$29157f6cae91bb2f];
        return statusProperties[fieldKey] !== undefined ? statusProperties[fieldKey][id] : undefined;
    });
const $aed9c169bf72dbd9$export$91edde09c155b9c0 = (ids)=>(0, $ahm5r.createSelector)((0, $iehDF.getAllFieldsByKey), $aed9c169bf72dbd9$export$3f02fbdb35084022, (0, $iehDF.getIssuesSimiliarStatusIdsByStatusId), (state, props)=>props?.isCollectionView, (fields, statusProperties, similarStatusesIdsBystatusId, isCollectionView)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const issueStatuses = {};
        ids.forEach((id)=>{
            if (id !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(fields, (0, $9a5f06039e1dff5a$export$29157f6cae91bb2f))) {
                const { key: fieldKey } = fields[0, $9a5f06039e1dff5a$export$29157f6cae91bb2f];
                const status = statusProperties[fieldKey][id];
                if (status) {
                    if (isCollectionView) issueStatuses[id] = similarStatusesIdsBystatusId[status.id][0];
                    else issueStatuses[id] = status.id;
                }
            }
        });
        return issueStatuses;
    });
const $aed9c169bf72dbd9$export$de4fce2131268308 = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$d300af0c04327d70, (createdProperties)=>createdProperties[id]);
const $aed9c169bf72dbd9$export$e2d155be0c3de614 = (fieldKey, id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$5822aeea7efbda72, (stringProperties)=>id ? stringProperties[fieldKey]?.[id] : undefined);
const $aed9c169bf72dbd9$export$93ddfa2b68c30468 = (fieldKey, id)=>(0, $ahm5r.createSelector)((0, $iehDF.getFieldMappings), (state)=>state, (_, props)=>props, (mappings, state, props)=>fieldKey ? mappings[fieldKey].valueAccessor(state, props, id) : undefined);
const $aed9c169bf72dbd9$export$6c55f925decac8ab = (fieldKey, id)=>(0, $ahm5r.createSelector)((0, $iehDF.getFieldMappings), (state)=>state, (_, props)=>props, (mappings, state, props)=>fieldKey ? mappings[fieldKey].valueAccessor(state, props, id) : undefined);
const $aed9c169bf72dbd9$export$b9786cf6872cd58d = (fieldKey, id)=>(0, $ahm5r.createSelector)((0, $iehDF.getFieldMappings), (state)=>state, (_, props)=>props, (mappings, state, props)=>mappings[fieldKey].valueAccessor(state, props, id));
const $aed9c169bf72dbd9$export$6fa93374dadf9853 = (fieldKey, ids)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$5822aeea7efbda72, (stringProperties)=>{
        const result = {};
        if (!fieldKey) return result;
        ids.forEach((id)=>{
            if (stringProperties[fieldKey]?.[id] !== undefined) result[id] = stringProperties[fieldKey]?.[id];
        });
        return result;
    });
const $aed9c169bf72dbd9$export$fe1332a3bca94a58 = (fieldKey, ids)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$6fa93374dadf9853(fieldKey, ids), $aed9c169bf72dbd9$export$3ac0d17cd37489a4, (0, $iehDF.getFieldMappings), (0, $iehDF.createGetFieldOfType)((0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT), (0, $53OVi.getAggregatedDeliveryDates), (state)=>state, (_, props)=>props, (intervalStringValues, externalReferenceEntities, mappings, atlasProjectField, aggregatedDeliveryDates, state, props)=>{
        const result = {};
        if (!fieldKey) return result;
        const atlasProjectFieldMapping = atlasProjectField ? mappings[atlasProjectField.key] : undefined;
        const source = mappings[fieldKey]?.field?.configuration?.source || (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).MANUAL;
        ids.forEach((id)=>{
            if (atlasProjectFieldMapping) switch(source){
                case (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).ATLAS_PROJECT_TARGET_DATE:
                    {
                        const value = atlasProjectFieldMapping.valueAccessor(state, props, id);
                        const dateRange = externalReferenceEntities[value]?.dueDate?.dateRange;
                        if (value && dateRange?.start && dateRange?.end && externalReferenceEntities[value]?.state?.value !== 'pending') {
                            result[id] = {
                                isExternal: true,
                                field: {
                                    dataSource: source,
                                    fieldKey: fieldKey
                                },
                                value: {
                                    start: dateRange.start,
                                    end: dateRange.end
                                }
                            };
                            return;
                        }
                        break;
                    }
                default:
            }
            if (source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).DELIVERY_DATE) {
                const customFieldKey = mappings[fieldKey]?.field?.configuration?.customfieldKey;
                const aggregationType = mappings[fieldKey]?.field?.configuration?.aggregationType;
                const value = aggregatedDeliveryDates[id]?.find((v)=>v.fieldKey === customFieldKey && v.aggregationType.toLowerCase() === aggregationType?.toLowerCase());
                const intervalValue = (0, $3ZrK1.timestampAggDateToInterval)(value, props?.locale, props?.timezone);
                if (intervalValue) {
                    result[id] = {
                        isExternal: true,
                        field: {
                            dataSource: source,
                            fieldKey: fieldKey
                        },
                        value: intervalValue
                    };
                    return;
                }
            }
            const parsedInterval = (0, $62tnP.tryParseIntervalString)(intervalStringValues[id]);
            if (parsedInterval) result[id] = {
                isExternal: false,
                field: {
                    dataSource: source,
                    fieldKey: fieldKey
                },
                value: parsedInterval
            };
        });
        return result;
    });
const $aed9c169bf72dbd9$export$3a239b003b41e45b = (id)=>(state, props)=>{
        const archivedMappings = (0, $iehDF.getArchivedFieldMappings)(state, props);
        if (props?.archivedFieldsConfig?.archivedField?.key === undefined) return false;
        const fieldMapping = archivedMappings[props.archivedFieldsConfig.archivedField.key];
        if (fieldMapping === undefined) return false;
        return props.archivedFieldsConfig.archivedField.archivedOption?.jiraOptionId !== undefined && fieldMapping.valueAccessor(state, props, id)?.id === props?.archivedFieldsConfig?.archivedField?.archivedOption?.jiraOptionId;
    };
const $aed9c169bf72dbd9$export$3a51a5b289c02204 = (fieldKey, id, dynamicFieldInitialized)=>(state, props)=>{
        const numberMappings = (0, $iehDF.getNumberFieldMappings)(state, props);
        const fieldMapping = numberMappings[fieldKey];
        if (fieldMapping === undefined) return undefined;
        if (fieldMapping.field?.formula && dynamicFieldInitialized !== true && !(state.meta?.isSingleIssueLoaded === true && state.meta?.initialized !== true)) return undefined;
        return fieldMapping.valueAccessor(state, props, id);
    };
const $aed9c169bf72dbd9$export$c52ad06ffaf85e48 = (fieldKey, ids)=>(state, props)=>{
        if (fieldKey === undefined) return {};
        const numberMappings = (0, $iehDF.getNumberFieldMappings)(state, props);
        const fieldMapping = numberMappings[fieldKey];
        if (fieldMapping === undefined) return {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        ids.forEach((id)=>{
            result[id] = fieldMapping.valueAccessor(state, props, id);
        });
        return result;
    };
const $aed9c169bf72dbd9$export$8b13761aa46b9353 = (fieldKey, id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$9b1a92817eb1ba25, (stringListProperties)=>stringListProperties[fieldKey] && stringListProperties[fieldKey][id]);
const $aed9c169bf72dbd9$export$e4573755e70864f7 = (fieldKey, localIssueId)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$1bf8a4c5ae977961, (0, $iehDF.createGetFieldOptionsWithAriResolvedById)(fieldKey), (singleOptionProperties, fieldOptions)=>{
        const optionProps = singleOptionProperties?.[fieldKey]?.[localIssueId];
        if (fieldOptions && optionProps) {
            const { id: id } = optionProps;
            const fieldOption = fieldOptions[optionProps.id];
            if (fieldOption === undefined) return [];
            return [
                {
                    id: id,
                    value: fieldOption.value,
                    weight: fieldOption.weight || 0
                }
            ];
        }
        return [];
    });
const $aed9c169bf72dbd9$export$1b97a4f9306d6ed3 = (fieldKey, ids, useWeights = false)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$1bf8a4c5ae977961, (0, $iehDF.createGetFieldOptionsWithAriResolvedById)(fieldKey), (singleOptionProperties, fieldOptions)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        ids.forEach((localIssueId)=>{
            if (fieldKey !== undefined && fieldOptions && singleOptionProperties[fieldKey] && singleOptionProperties[fieldKey][localIssueId]) {
                const { id: id } = singleOptionProperties[fieldKey][localIssueId];
                if (fieldOptions[id] !== undefined) result[localIssueId] = useWeights === true ? fieldOptions[id].weight : fieldOptions[id].id;
            }
        });
        return result;
    });
const $aed9c169bf72dbd9$export$c540689784034e = (fieldKey, localIssueId)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$ca746d92270c6240, (0, $iehDF.createGetFieldOptionsWithAriResolvedById)(fieldKey), (0, $iehDF.createGetFieldOptions)(fieldKey), (multiOptionProperties, fieldOptions, sortedFieldOptions)=>{
        const options = [];
        const optionProps = multiOptionProperties?.[fieldKey]?.[localIssueId];
        if (fieldOptions && optionProps && sortedFieldOptions) {
            sortedFieldOptions.forEach(({ jiraOptionId: jiraOptionId })=>{
                if (optionProps.find((issueOption)=>issueOption.id === jiraOptionId)) options.push(fieldOptions[jiraOptionId]);
            });
            return options;
        }
        return options;
    });
const $aed9c169bf72dbd9$export$bf672e5157063678 = (fieldKey, ids)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$ca746d92270c6240, (0, $iehDF.createGetFieldOptionsWithAriResolvedById)(fieldKey), (optionProperties, fieldOptions)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        ids.forEach((localIssueId)=>{
            const optionProps = fieldKey && optionProperties?.[fieldKey]?.[localIssueId];
            if (fieldOptions && optionProps) {
                const weightOption = optionProps.map(({ id: id })=>{
                    if (fieldOptions[id] !== undefined) return fieldOptions[id].weight || 0;
                    return 0;
                });
                result[localIssueId] = weightOption.reduce((prevValue, currValue)=>prevValue + currValue, 0);
            }
        });
        return result;
    });
const $aed9c169bf72dbd9$export$c2f2776527e40141 = (fieldKey, id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$a577be47e15c9e4d, (userProperties)=>userProperties[fieldKey] && userProperties[fieldKey][id]);
const $aed9c169bf72dbd9$export$51784373ad8ed468 = (fieldKey, id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$351bc010a6319475, (teamProperties)=>teamProperties[fieldKey]?.[id]);
const $aed9c169bf72dbd9$export$85111f87a1ceed3e = (fieldKey, accountId)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$a577be47e15c9e4d, (userProperties)=>{
        if (userProperties[fieldKey]) {
            const userInfo = Object.values(userProperties[fieldKey]).find((user)=>user?.accountId === accountId);
            return userInfo;
        }
        return undefined;
    });
const $aed9c169bf72dbd9$export$da5d02be3ddf0999 = (fieldKey, ids)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$a577be47e15c9e4d, (userProperties)=>{
        const result = {};
        ids.forEach((localId)=>{
            if (fieldKey !== undefined && userProperties[fieldKey] && userProperties[fieldKey][localId]) {
                const userId = userProperties[fieldKey][localId]?.accountId;
                result[localId] = userId;
            }
        });
        return result;
    });
const $aed9c169bf72dbd9$export$2eb04d711a81ced9 = (fieldKey, id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$219c0f33cdd5c2e9, (peopleProperties)=>peopleProperties[fieldKey] && peopleProperties[fieldKey][id]);
const $aed9c169bf72dbd9$export$2047fb5f7b1b64b4 = (fieldKey, accountId)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$219c0f33cdd5c2e9, (peopleProperties)=>{
        if (peopleProperties[fieldKey]) {
            const userInfo = Object.values(peopleProperties[fieldKey]).flat().find((user)=>user?.accountId === accountId);
            const transformedUserInfo = userInfo && {
                id: userInfo.accountId,
                name: userInfo.displayName ?? '',
                avatarUrl: userInfo.avatarUrls?.['16x16'] ?? ''
            };
            return transformedUserInfo;
        }
        return undefined;
    });
const $aed9c169bf72dbd9$export$d2a49ed2b1f7dfdd = (fieldKey, id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$2eb04d711a81ced9(fieldKey, id), (people)=>people !== undefined && people !== null ? people.map((prop)=>({
                id: prop.accountId,
                name: prop.displayName || '',
                avatarUrl: prop.avatarUrls?.['48x48'] || '',
                src: prop.avatarUrls?.['48x48'] || ''
            })) : []);
const $aed9c169bf72dbd9$export$900f4ecc52ceeb14 = (fieldKey, id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$3f02fbdb35084022, (statusProperties)=>// @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        statusProperties[(0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))((0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(statusProperties))][id]);
const $aed9c169bf72dbd9$export$deb4cf6d109ae929 = (mappingsSelector)=>{
    // memoize relevant object for comparison
    let previousRelevantObjects;
    // memoize previous properties to return when no relevant change has occurred
    let previousData;
    return (0, $ahm5r.createSelector)(mappingsSelector, (state)=>state, (state, props)=>props, (mappings, state, props)=>{
        const accessors = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))((0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(mappings.map(({ getAllValues: getAllValues, getDependencyValues: getDependencyValues })=>getDependencyValues ? [
                getAllValues,
                getDependencyValues
            ] : getAllValues)));
        const relevantObjects = (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))((0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))((0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(accessors.map((accessor)=>accessor(state, props)))), null, undefined);
        if (previousData === undefined || previousRelevantObjects === undefined || !(0, $5zHFN.isShallowEqual)(previousRelevantObjects, relevantObjects)) {
            previousRelevantObjects = relevantObjects;
            previousData = [
                state,
                props
            ];
        }
        return previousData;
    });
};
const $aed9c169bf72dbd9$var$ISSUE_MODIFIED_TIME_THRESHOLD = 2000;
const $aed9c169bf72dbd9$var$notModifiedSelector = ()=>false;
const $aed9c169bf72dbd9$var$createGetIsIssueModified = (0, $3degy.cacheSelectorCreator)((id)=>id ? (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$e2d155be0c3de614((0, $9a5f06039e1dff5a$export$16313363fca8abe5), id), $aed9c169bf72dbd9$export$e2d155be0c3de614((0, $9a5f06039e1dff5a$export$77c57adf6bed37b8), id), (created, updated)=>created !== undefined && updated !== undefined && // Since create/updated are not always equal, we treat issue as modified only if the diff is more than ISSUE_MODIFIED_TIME_THRESHOLD milliseconds
        Math.abs((0, $e8XBu.default)((0, $kQ82p.default)(created), (0, $kQ82p.default)(updated))) > $aed9c169bf72dbd9$var$ISSUE_MODIFIED_TIME_THRESHOLD) : $aed9c169bf72dbd9$var$notModifiedSelector);
const $aed9c169bf72dbd9$export$4d89250ceb5a3b53 = (id)=>{
    const keySelector = $aed9c169bf72dbd9$export$115e5512c983a4d8(id);
    return (0, $ahm5r.createSelector)(keySelector, (_, props)=>props?.projectTemplateVersion, (issueKey, projectTemplateVersion)=>{
        const issueKeyNumber = (0, $9U0CQ.getIssueNumberFromIssueKey)(issueKey);
        // In onboarding experiment we track first 3 ideas separately, so we mark them here
        return (0, $jnihY.JPD_ONBOARDING_TEMPLATES).includes(projectTemplateVersion ?? '') && issueKeyNumber !== undefined && [
            1,
            2,
            3
        ].includes(issueKeyNumber);
    });
};
const $aed9c169bf72dbd9$var$createIsOnboardingExperimentIssueModified = (id)=>{
    const isOnboardingExperimentIssueSelector = $aed9c169bf72dbd9$export$4d89250ceb5a3b53(id);
    const isModifiedSelector = $aed9c169bf72dbd9$var$createGetIsIssueModified(id);
    return (0, $ahm5r.createSelector)(isOnboardingExperimentIssueSelector, isModifiedSelector, (isOnboardingExperimentIssue, isModified)=>isOnboardingExperimentIssue ? isModified : undefined);
};
const $aed9c169bf72dbd9$export$c65912bba1b1195f = (0, $ahm5r.createSelector)($aed9c169bf72dbd9$var$getAggregatedDeliveryProgressProperties, (aggregatedDeliveryProgressProperties)=>!!aggregatedDeliveryProgressProperties && (0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))((0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(aggregatedDeliveryProgressProperties), (val)=>val !== undefined));
const $aed9c169bf72dbd9$var$creategGetIdeaDeliveryTicketCount = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$var$getAggregatedDeliveryProgressProperties, (aggregatedDeliveryProgressProperties)=>id && aggregatedDeliveryProgressProperties[id] ? (0, $emfB5.issuesProgressFromAggregate)(aggregatedDeliveryProgressProperties[id]).total : 0);
const $aed9c169bf72dbd9$var$creategGetIdeaInsightCount = (id)=>(0, $ahm5r.createSelector)($aed9c169bf72dbd9$var$getInsightsProperties, (insightsProperties)=>id ? insightsProperties?.[id]?.length : 0);
const $aed9c169bf72dbd9$export$bed6941efbc9c35a = (id)=>{
    const keySelector = $aed9c169bf72dbd9$export$115e5512c983a4d8(id);
    const isOnboardingExperimentIssueSelector = $aed9c169bf72dbd9$export$4d89250ceb5a3b53(id);
    const isOnboardingExperimentIssueModifiedSelector = $aed9c169bf72dbd9$var$createIsOnboardingExperimentIssueModified(id);
    return (0, $ahm5r.createSelector)($aed9c169bf72dbd9$export$eaf974908c9ece90, $aed9c169bf72dbd9$export$3f02fbdb35084022, $aed9c169bf72dbd9$export$a577be47e15c9e4d, $aed9c169bf72dbd9$export$2b5441465ca750d3, $aed9c169bf72dbd9$var$creategGetIdeaInsightCount(id), (0, $feobD.createGetCommentsCount)(id || ''), $aed9c169bf72dbd9$var$creategGetIdeaDeliveryTicketCount(id), keySelector, isOnboardingExperimentIssueSelector, isOnboardingExperimentIssueModifiedSelector, (_, props)=>props?.projectId, (numberProperties, statusProperties, userProperties, issueTypeProperties, ideaInsightCount, ideaCommentCount, ideaDeliveryTicketCount, issueKey, isOnboardingExperimentIssue, isOnboardingExperimentIssueModified, projectId)=>{
        if (id === undefined) return undefined;
        const issueKeyNumber = (0, $9U0CQ.getIssueNumberFromIssueKey)(issueKey);
        return {
            // Schema https://hello.atlassian.net/wiki/spaces/DQ/pages/875384754/Jira+Product+entities#issue-schema
            issueType: issueTypeProperties[0, $9a5f06039e1dff5a$export$dd03acb09519222]?.[id]?.name?.toLowerCase(),
            issueId: numberProperties[0, $9a5f06039e1dff5a$export$48927a8f78b0130e]?.[id]?.toString(),
            assigneeId: userProperties[0, $9a5f06039e1dff5a$export$7e67ea07bd31e757]?.[id]?.accountId,
            issueTypeId: issueTypeProperties[0, $9a5f06039e1dff5a$export$dd03acb09519222]?.[id]?.id,
            issueHierarchyLevel: 0,
            issueReporter: userProperties[0, $9a5f06039e1dff5a$export$cb59b69c70ea9e18]?.[id]?.accountId,
            issueStatusId: statusProperties[0, $9a5f06039e1dff5a$export$29157f6cae91bb2f]?.[id]?.id,
            statusCategory: (0, $7keuM.statusCategoryForId)(statusProperties[0, $9a5f06039e1dff5a$export$29157f6cae91bb2f]?.[id]?.statusCategory?.id),
            statusCategoryId: statusProperties[0, $9a5f06039e1dff5a$export$29157f6cae91bb2f]?.[id]?.statusCategory?.id,
            ideaInsightCount: // JPD specific attributes
            ideaInsightCount,
            ideaDeliveryTicketCount: ideaDeliveryTicketCount,
            ideaCommentCount: ideaCommentCount,
            projectId: projectId,
            onboardingExperimentIssue: isOnboardingExperimentIssue ? issueKeyNumber : undefined,
            onboardingExperimentIssueModified: isOnboardingExperimentIssueModified
        };
    });
};
const $aed9c169bf72dbd9$export$2e1e988cf020a96b = (fieldKey, localIssueId, connectionsFieldsAssociations)=>{
    const getField = (0, $iehDF.createGetField)(fieldKey);
    const getIssueType = $aed9c169bf72dbd9$export$2bde03fd901c6480(localIssueId);
    return (0, $ahm5r.createSelector)(getField, getIssueType, (field, issueType)=>{
        if (!field || !issueType) return false;
        // global system fields and project system fields are always associated
        if ((0, $5tOWS.isGlobalSystemField)(field) || !field.custom) return true;
        return field.issueTypes.includes(issueType.id) || !!connectionsFieldsAssociations?.[field.key]?.includes(issueType.id);
    });
};

});
parcelRegister("75SEb", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $3PLp8 = parcelRequire("3PLp8");

var $1lM9j = parcelRequire("1lM9j");

var $4sprp = parcelRequire("4sprp");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $52a363cc76e51f60$var$filter(collection, predicate) {
    var func = $4sprp(collection) ? $821Ou : $3PLp8;
    return func(collection, $1lM9j(predicate, 3));
}
module.exports = $52a363cc76e51f60$var$filter;

});
parcelRegister("3PLp8", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2caae80f7af1e608$var$baseFilter(collection, predicate) {
    var result = [];
    $c3u3c(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $2caae80f7af1e608$var$baseFilter;

});


parcelRegister("4lj8A", function(module, exports) {

var $aALfT = parcelRequire("aALfT");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $3297f7e1b8cc824e$var$findKey(object, predicate) {
    return $aALfT(object, $1lM9j(predicate, 3), $75Jcs);
}
module.exports = $3297f7e1b8cc824e$var$findKey;

});
parcelRegister("aALfT", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $7b61ec1c4167fade$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $7b61ec1c4167fade$var$baseFindKey;

});


parcelRegister("eI1yv", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");
/** Used as references for various `Number` constants. */ var $ab5661a8f66a4e74$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $ab5661a8f66a4e74$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? $72Qfa(array, $ab5661a8f66a4e74$var$INFINITY) : [];
}
module.exports = $ab5661a8f66a4e74$var$flattenDeep;

});

parcelRegister("ZFqXT", function(module, exports) {

var $jAnCu = parcelRequire("jAnCu");

var $PodIB = parcelRequire("PodIB");

var $7H30b = parcelRequire("7H30b");

var $l5Z0K = parcelRequire("l5Z0K");

var $esCHN = parcelRequire("esCHN");
/** `Object#toString` result references. */ var $0b95d68878817576$var$mapTag = '[object Map]', $0b95d68878817576$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $0b95d68878817576$var$size(collection) {
    if (collection == null) return 0;
    if ($7H30b(collection)) return $l5Z0K(collection) ? $esCHN(collection) : collection.length;
    var tag = $PodIB(collection);
    if (tag == $0b95d68878817576$var$mapTag || tag == $0b95d68878817576$var$setTag) return collection.size;
    return $jAnCu(collection).length;
}
module.exports = $0b95d68878817576$var$size;

});
parcelRegister("esCHN", function(module, exports) {

var $cVaIZ = parcelRequire("cVaIZ");

var $beeZR = parcelRequire("beeZR");

var $dsEqJ = parcelRequire("dsEqJ");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $a871b4482705c524$var$stringSize(string) {
    return $beeZR(string) ? $dsEqJ(string) : $cVaIZ(string);
}
module.exports = $a871b4482705c524$var$stringSize;

});
parcelRegister("cVaIZ", function(module, exports) {

var $9U1Ux = parcelRequire("9U1Ux");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9683209b72c5c382$var$asciiSize = $9U1Ux('length');
module.exports = $9683209b72c5c382$var$asciiSize;

});

parcelRegister("dsEqJ", function(module, exports) {
/** Used to compose unicode character classes. */ var $9ccd4073599dd88e$var$rsAstralRange = '\\ud800-\\udfff', $9ccd4073599dd88e$var$rsComboMarksRange = '\\u0300-\\u036f', $9ccd4073599dd88e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $9ccd4073599dd88e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $9ccd4073599dd88e$var$rsComboRange = $9ccd4073599dd88e$var$rsComboMarksRange + $9ccd4073599dd88e$var$reComboHalfMarksRange + $9ccd4073599dd88e$var$rsComboSymbolsRange, $9ccd4073599dd88e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $9ccd4073599dd88e$var$rsAstral = '[' + $9ccd4073599dd88e$var$rsAstralRange + ']', $9ccd4073599dd88e$var$rsCombo = '[' + $9ccd4073599dd88e$var$rsComboRange + ']', $9ccd4073599dd88e$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $9ccd4073599dd88e$var$rsModifier = '(?:' + $9ccd4073599dd88e$var$rsCombo + '|' + $9ccd4073599dd88e$var$rsFitz + ')', $9ccd4073599dd88e$var$rsNonAstral = '[^' + $9ccd4073599dd88e$var$rsAstralRange + ']', $9ccd4073599dd88e$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $9ccd4073599dd88e$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $9ccd4073599dd88e$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $9ccd4073599dd88e$var$reOptMod = $9ccd4073599dd88e$var$rsModifier + '?', $9ccd4073599dd88e$var$rsOptVar = '[' + $9ccd4073599dd88e$var$rsVarRange + ']?', $9ccd4073599dd88e$var$rsOptJoin = '(?:' + $9ccd4073599dd88e$var$rsZWJ + '(?:' + [
    $9ccd4073599dd88e$var$rsNonAstral,
    $9ccd4073599dd88e$var$rsRegional,
    $9ccd4073599dd88e$var$rsSurrPair
].join('|') + ')' + $9ccd4073599dd88e$var$rsOptVar + $9ccd4073599dd88e$var$reOptMod + ')*', $9ccd4073599dd88e$var$rsSeq = $9ccd4073599dd88e$var$rsOptVar + $9ccd4073599dd88e$var$reOptMod + $9ccd4073599dd88e$var$rsOptJoin, $9ccd4073599dd88e$var$rsSymbol = '(?:' + [
    $9ccd4073599dd88e$var$rsNonAstral + $9ccd4073599dd88e$var$rsCombo + '?',
    $9ccd4073599dd88e$var$rsCombo,
    $9ccd4073599dd88e$var$rsRegional,
    $9ccd4073599dd88e$var$rsSurrPair,
    $9ccd4073599dd88e$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $9ccd4073599dd88e$var$reUnicode = RegExp($9ccd4073599dd88e$var$rsFitz + '(?=' + $9ccd4073599dd88e$var$rsFitz + ')|' + $9ccd4073599dd88e$var$rsSymbol + $9ccd4073599dd88e$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $9ccd4073599dd88e$var$unicodeSize(string) {
    var result = $9ccd4073599dd88e$var$reUnicode.lastIndex = 0;
    while($9ccd4073599dd88e$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $9ccd4073599dd88e$var$unicodeSize;

});



parcelRegister("9U0CQ", function(module, exports) {

$parcel$export(module.exports, "getIssueNumberFromIssueKey", () => $f9a01272e03e2764$export$e1c2bf905c9e45ab);
const $f9a01272e03e2764$export$e1c2bf905c9e45ab = (issueKey = '')=>{
    const parsedNumber = parseInt(issueKey.split('-')[1], 10);
    return Number.isNaN(parsedNumber) ? undefined : parsedNumber;
};

});

const $d5435e25fbd81376$export$336731f504687455 = 'IN_CREATION';
const $d5435e25fbd81376$export$2990a40bc316c88b = 'IN_TRANSITION';
const $d5435e25fbd81376$export$eaf097cc0aa4ca13 = 'CREATED';
const $d5435e25fbd81376$export$e209eb8cb8e09aba = 'unknown';
const $d5435e25fbd81376$export$7c2ebc4b06c12232 = 'noGroup';
const $d5435e25fbd81376$export$49f6ea3702b3924f = 'empty';
const $d5435e25fbd81376$export$870d962ddd4b82d4 = 'group';
const $d5435e25fbd81376$export$83b9662b3a72f081 = 'top';
const $d5435e25fbd81376$export$dbd8cce3997500ee = 'bottom';
const $d5435e25fbd81376$export$536f1c793405c625 = 'create';
const $d5435e25fbd81376$export$93be3d37558c6543 = 'update';



parcelRegister("8E9Lh", function(module, exports) {

$parcel$export(module.exports, "archiveIssues", () => $311b74de753cc91e$export$a0e5fd3852066654);
$parcel$export(module.exports, "unarchiveIssues", () => $311b74de753cc91e$export$e8699de2683bd1ed);

var $gCeeo = parcelRequire("gCeeo");

var $6Yd06 = parcelRequire("6Yd06");

var $4TCfW = parcelRequire("4TCfW");

var $cNkV6 = parcelRequire("cNkV6");
const $311b74de753cc91e$export$a0e5fd3852066654 = (localIssueIds)=>({ dispatch: dispatch, getState: getState }, props)=>{
        const { archivedFieldsConfig: archivedFieldsConfig, currentUser: currentUser, projectId: projectId, insightsRemote: insightsRemote } = props;
        if (!archivedFieldsConfig) return;
        const { archivedField: archivedField, archivedByField: archivedByField, archivedOnField: archivedOnField } = archivedFieldsConfig;
        if (!archivedField || !archivedByField || !archivedOnField) return;
        const { archivedOption: archivedOption } = archivedField;
        if (!archivedOption) return;
        dispatch((0, $cNkV6.updateFieldValues)({
            localIssueIds: localIssueIds,
            fields: {
                [archivedField.key]: {
                    newValue: {
                        id: archivedOption.jiraOptionId
                    }
                },
                [archivedByField.key]: {
                    newValue: [
                        {
                            accountId: currentUser
                        }
                    ]
                },
                [archivedOnField.key]: {
                    newValue: new Date().toISOString()
                }
            }
        }));
        if (projectId !== undefined) {
            const issueIdsToCleanUp = localIssueIds.map((localIssueId)=>(0, $4TCfW.createGetIdSelector)(localIssueId)(getState())).filter((val)=>val !== undefined).map(String);
            insightsRemote.archiveInsights?.({
                issueIds: issueIdsToCleanUp
            }).catch((err)=>(0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.archive-issues-error', 'Failed to archive insights', err));
        }
        (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'issue archived', localIssueIds.length === 1 ? {
            ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(localIssueIds[0])(getState())
        } : {
            issueCount: localIssueIds.length,
            issueIds: localIssueIds.map((id)=>(0, $4TCfW.createGetIdSelector)(id)(getState())?.toString()),
            actionType: 'bulk'
        });
    };
const $311b74de753cc91e$export$e8699de2683bd1ed = (localIssueIds)=>({ dispatch: dispatch, getState: getState }, props)=>{
        const { archivedFieldsConfig: archivedFieldsConfig, projectId: projectId, insightsRemote: insightsRemote } = props;
        if (!archivedFieldsConfig) return;
        const { archivedField: archivedField, archivedByField: archivedByField, archivedOnField: archivedOnField } = archivedFieldsConfig;
        if (!archivedField || !archivedByField || !archivedOnField) return;
        dispatch((0, $cNkV6.updateFieldValues)({
            localIssueIds: localIssueIds,
            fields: {
                [archivedField.key]: {
                    newValue: undefined
                },
                [archivedByField.key]: {
                    newValue: undefined
                },
                [archivedOnField.key]: {
                    newValue: undefined
                }
            }
        }));
        if (projectId) insightsRemote.unarchiveInsights?.({
            issueIds: localIssueIds.map((localIssueId)=>String((0, $4TCfW.createGetIdSelector)(localIssueId)(getState())))
        }).catch((err)=>(0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.unarchive-issues-error', 'Failed to unarchive insights', err));
        (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'issue unarchived', localIssueIds.length === 1 ? {
            ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(localIssueIds[0])(getState())
        } : {
            issueCount: localIssueIds.length,
            issueIds: localIssueIds.map((id)=>(0, $4TCfW.createGetIdSelector)(id)(getState())?.toString()),
            actionType: 'bulk'
        });
    };

});
parcelRegister("cNkV6", function(module, exports) {

$parcel$export(module.exports, "updateFieldValue", () => $1583714b851843d2$export$9f85478f608191c);
$parcel$export(module.exports, "updateFieldValues", () => $1583714b851843d2$export$cba83c02c8e89cdf);
$parcel$export(module.exports, "updateFieldValueForSelectedIssue", () => $1583714b851843d2$export$2fac6979dabc077e);
$parcel$export(module.exports, "updateFieldValueWithBulk", () => $1583714b851843d2$export$7f9f35be271a76f2);
$parcel$export(module.exports, "resetLastUpdatedIssueIds", () => $1583714b851843d2$export$ef0e0fca317ac69f);
$parcel$export(module.exports, "resetLastUpdatedIssueAction", () => $1583714b851843d2$export$acce39b7d4093c60);

var $fqICx = parcelRequire("fqICx");

var $4sprp = parcelRequire("4sprp");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");

var $eTBmS = parcelRequire("eTBmS");


var $b5oGV = parcelRequire("b5oGV");

var $1I887 = parcelRequire("1I887");

var $7e8wG = parcelRequire("7e8wG");

var $k2MWf = parcelRequire("k2MWf");

var $gCeeo = parcelRequire("gCeeo");

var $6Yd06 = parcelRequire("6Yd06");

var $6uWT2 = parcelRequire("6uWT2");

var $7jTnu = parcelRequire("7jTnu");

var $iehDF = parcelRequire("iehDF");

var $j9i1D = parcelRequire("j9i1D");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $BrRcR = parcelRequire("BrRcR");

var $hw9ct = parcelRequire("hw9ct");


var $cHovn = parcelRequire("cHovn");

var $dVE1x = parcelRequire("dVE1x");

var $3TA1a = parcelRequire("3TA1a");

var $jD8ef = parcelRequire("jD8ef");

var $gXTjR = parcelRequire("gXTjR");

var $81I0u = parcelRequire("81I0u");

var $4ww0y = parcelRequire("4ww0y");
const $1583714b851843d2$var$BATCH_SIZE = 5;
const $1583714b851843d2$var$updateFieldValueOnBackend = (state, props, fieldKey, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldMapping, localIssueIds, dispatch, updateIssueSuccess, updateIssueError, updateIssueTypeMoveError)=>{
    const issuesCount = localIssueIds.length;
    const isBulkEditingOperation = issuesCount > 1;
    if (isBulkEditingOperation) (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateFieldValueOnBackend.bulk.started tracked');
    dispatch((0, $dVE1x.incrementOpenUpdateCounter)(localIssueIds));
    return (0, $k2MWf.runInBatch)(localIssueIds.map((localIssueId)=>{
        const issueKey = (0, $4TCfW.createGetKeySelector)(localIssueId)(state);
        // generic update REST call to Jira
        const value = fieldMapping.getFieldValueForJiraUpdate(fieldMapping.valueAccessor(state, props, localIssueId));
        return ()=>fieldMapping.getJiraUpdateService(issueKey, value).then(()=>{
                updateIssueSuccess?.(isBulkEditingOperation, localIssueId, fieldKey);
                return undefined;
            }).catch((err)=>{
                if ((0, $4ww0y.isIncompatibleTargetIssueTypeStatusError)({
                    error: err,
                    modifiedFieldKeys: [
                        fieldKey
                    ]
                })) {
                    if (props.onIssueTypeUpdateFailed) props.onIssueTypeUpdateFailed(err, [
                        issueKey
                    ]);
                    else props.onIssueUpdateFailed(err);
                    updateIssueTypeMoveError?.(err);
                } else {
                    props.onIssueUpdateFailed(err);
                    updateIssueError?.(err, isBulkEditingOperation);
                }
                return err;
            });
    }), $1583714b851843d2$var$BATCH_SIZE).then((results)=>{
        if ((0, $4ww0y.hasIssueTypeField)([
            fieldKey
        ], state, props)) dispatch((0, $gXTjR.refreshConnectionFieldsValues)((0, $iehDF.getConfiguredConnectionFieldsKeys)(state, props)));
        if (!isBulkEditingOperation) return;
        const errorCount = results.filter((result)=>result instanceof Error).length;
        if (errorCount > 0) (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateFieldValueOnBackend.bulk.failed tracked', {
            issuesCount: issuesCount,
            errorCount: errorCount
        });
        else (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateFieldValueOnBackend.bulk.finished tracked', {
            issuesCount: issuesCount
        });
    });
};
const $1583714b851843d2$export$da9b9c34d5911743 = $1583714b851843d2$var$updateFieldValueOnBackend;
const $1583714b851843d2$var$updateFieldValuesOnBackend = (state, props, fieldKeys, localIssueIds, dispatch, updateIssuesSuccess, updateIssuesError, updateIssueTypeMoveError)=>{
    const issuesCount = localIssueIds.length;
    const isBulkEditingOperation = issuesCount > 1;
    if (isBulkEditingOperation) (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateFieldValuesOnBackend.bulk.started tracked');
    dispatch((0, $dVE1x.incrementOpenUpdateCounter)(localIssueIds));
    return (0, $k2MWf.runInBatch)(localIssueIds.map((localIssueId)=>{
        const issueKey = (0, $4TCfW.createGetKeySelector)(localIssueId)(state);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const update = fieldKeys.reduce((result, fieldKey)=>{
            const fieldMapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(state, props);
            if (!fieldMapping) return result;
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...result,
                [fieldKey]: fieldMapping.getFieldValueForJiraUpdate(fieldMapping.valueAccessor(state, props, localIssueId))
            };
        }, {});
        return ()=>props.issuesRemote.updateIssueFields({
                issueKey: issueKey,
                update: update
            }).then(()=>{
                updateIssuesSuccess?.(isBulkEditingOperation, localIssueId);
                return undefined;
            }).catch((err)=>{
                if ((0, $4ww0y.isIncompatibleTargetIssueTypeStatusError)({
                    error: err,
                    modifiedFieldKeys: fieldKeys
                })) {
                    if (props.onIssueTypeUpdateFailed) props.onIssueTypeUpdateFailed(err, [
                        issueKey
                    ]);
                    else props.onIssueUpdateFailed(err);
                    updateIssueTypeMoveError?.(err);
                } else {
                    props.onIssueUpdateFailed(err);
                    updateIssuesError?.(err, isBulkEditingOperation);
                }
                return err;
            });
    }), $1583714b851843d2$var$BATCH_SIZE).then((results)=>{
        if ((0, $4ww0y.hasIssueTypeField)(fieldKeys, state, props)) dispatch((0, $gXTjR.refreshConnectionFieldsValues)((0, $iehDF.getConfiguredConnectionFieldsKeys)(state, props)));
        if (!isBulkEditingOperation) return;
        const errorCount = results.filter((result)=>result instanceof Error).length;
        if (errorCount > 0) (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateFieldValuesOnBackend.bulk.failed tracked', {
            issuesCount: issuesCount,
            errorCount: errorCount
        });
        else (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateFieldValuesOnBackend.bulk.finished tracked', {
            issuesCount: issuesCount
        });
    });
};
const $1583714b851843d2$export$8ffc6429bff114f4 = $1583714b851843d2$var$updateFieldValuesOnBackend;
const $1583714b851843d2$var$getIsFilteredResult = (localIssueIds)=>({ getState: getState }, props)=>{
        const filteredIdsAfterStateChange = (0, $j9i1D.getFilteredIssueIds)(getState(), props);
        return !localIssueIds.every((id)=>filteredIdsAfterStateChange.includes(id));
    };
const $1583714b851843d2$export$9f85478f608191c = ({ fieldKey: fieldKey, localIssueIds: localIssueIds, newValue: newValue, removeValue: removeValue, appendMultiValues: appendMultiValues = false, performSideEffects: performSideEffects = true, skipNetworkRequest: skipNetworkRequest = false }, onSuccess, onError, onConnectionsUpdated)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const fieldMapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(state, props);
        const field = (0, $iehDF.createGetField)(fieldKey)(state, props);
        const prevLastUpdatedIssueIds = [
            ...getState().lastUpdatedIssueIds
        ];
        if (!field || !fieldMapping) return {
            filtered: undefined
        };
        if (field.type === (0, $eTBmS.FIELD_TYPES).CONNECTION) {
            setState({
                lastUpdatedIssueIds: localIssueIds,
                lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
            });
            dispatch((0, $cHovn.updateConnectionFieldValue)({
                localIssueIds: localIssueIds,
                fieldKey: fieldKey,
                newValue: newValue,
                removeValue: removeValue,
                appendMultiValues: appendMultiValues,
                onError: ()=>{
                    setState({
                        lastUpdatedIssueIds: prevLastUpdatedIssueIds
                    });
                },
                onConnectionsUpdated: onConnectionsUpdated
            }));
            return {
                filtered: dispatch($1583714b851843d2$var$getIsFilteredResult(localIssueIds))
            };
        }
        if (field.type === (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS) {
            setState({
                lastUpdatedIssueIds: localIssueIds,
                lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
            });
            dispatch((0, $jD8ef.updateGoalsFieldValue)({
                localIssueIds: localIssueIds,
                fieldKey: fieldKey,
                newValue: newValue,
                removeValue: removeValue,
                appendMultiValues: appendMultiValues,
                skipNetworkRequest: skipNetworkRequest,
                onError: ()=>{
                    setState({
                        lastUpdatedIssueIds: prevLastUpdatedIssueIds
                    });
                }
            }));
            return {
                filtered: dispatch($1583714b851843d2$var$getIsFilteredResult(localIssueIds))
            };
        }
        const updateIssueFieldExperience = (0, $b5oGV.experience).view.makeGenericIssueFieldUpdate();
        updateIssueFieldExperience.start();
        const { hasBulkChangePermissions: hasBulkChangePermissions } = props;
        const jiraIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(getState(), props);
        const updateIssueBulkSuccess = ()=>{
            updateIssueFieldExperience.success();
            (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateIssueValue.success tracked', {
                isBulkEditingOperation: true
            });
        };
        const updateIssueSuccess = (isBulkEditingOperation, localIssueId, key)=>{
            onSuccess?.();
            updateIssueFieldExperience.success();
            const issueId = jiraIdMap[localIssueId];
            (0, $1I887.fireAnalyticsEventForIssueUpdate)(props.createAnalyticsEvent({}), issueId, {
                updatedItems: [
                    {
                        name: key
                    }
                ],
                ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(localIssueId)(getState())
            });
            (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateIssueValue.success tracked', {
                isBulkEditingOperation: isBulkEditingOperation
            });
        };
        const prevProperties = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(getState().properties);
        const updateIssueTypeMoveError = (err)=>{
            // revert the optimistic state update on error
            setState({
                properties: prevProperties,
                lastUpdatedIssueIds: prevLastUpdatedIssueIds
            });
            onSuccess?.();
            updateIssueFieldExperience.successWithReason(err);
        };
        const updateIssueError = (err, isBulkEditingOperation)=>{
            if (onError) {
                // revert the optimistic state update on error
                setState({
                    properties: prevProperties,
                    lastUpdatedIssueIds: prevLastUpdatedIssueIds
                });
                onError(err);
                updateIssueFieldExperience.successWithReason(err);
                return;
            }
            if (!(0, $8KUFq.isClientFetchError)(err)) updateIssueFieldExperience.failure(err);
            (0, $gYnSx.default)({
                ...(0, $7e8wG.createErrorAnalytics)('jpd.updateIssueValue.error', err),
                attributes: {
                    isBulkEditingOperation: isBulkEditingOperation,
                    statusCode: err instanceof (0, $1uIew.ValidationError) || err instanceof (0, $1uIew.default) ? err?.statusCode : -1
                }
            });
            if (field.type === (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE) (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue.actions.update-issue-issue-type', `Failed to update issue issue type, isBulkEditingOperation: ${isBulkEditingOperation}, statusCode: ${err instanceof (0, $1uIew.ValidationError) || err instanceof (0, $1uIew.default) ? err?.statusCode : -1}`, err);
        };
        // optimistic state update
        const newMapping = (0, $4ww0y.getNewPropertiesMapping)(fieldMapping, state.properties, localIssueIds, newValue, removeValue, appendMultiValues);
        setState({
            properties: newMapping,
            lastUpdatedIssueIds: localIssueIds,
            lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
        });
        if ((0, $4ww0y.hasIssueTypeField)([
            fieldKey
        ], state, props)) dispatch((0, $gXTjR.resetConnectionFieldsValues)((0, $iehDF.getConfiguredConnectionFieldsKeys)(state, props), localIssueIds));
        const isBulkEditingOperation = localIssueIds.length > 1;
        if (performSideEffects && field.type !== (0, $eTBmS.FIELD_TYPES).REACTIONS) {
            if (field.type === (0, $eTBmS.FIELD_TYPES).STATUS) // special handling for status fields. they are updated through a different endpoint
            // it is therefore required to use the update status action, and this becomes a noop
            throw new Error('Unable to update status field through updateFieldValueAction');
            updateIssueFieldExperience.mark('backend_request_start');
            if (hasBulkChangePermissions && isBulkEditingOperation && (0, $4ww0y.isBulkOperationSupported)([
                field.key
            ], state, props)) (0, $81I0u.updateFieldValuesOnBackendBulk)(getState(), props, [
                field.key
            ], localIssueIds, dispatch, updateIssueBulkSuccess, updateIssueError, updateIssueTypeMoveError);
            else $1583714b851843d2$var$updateFieldValueOnBackend(getState(), props, field.key, fieldMapping, localIssueIds, dispatch, updateIssueSuccess, updateIssueError, updateIssueTypeMoveError);
        }
        return {
            filtered: dispatch($1583714b851843d2$var$getIsFilteredResult(localIssueIds))
        };
    };
const $1583714b851843d2$export$cba83c02c8e89cdf = (request)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        (0, $b5oGV.experience).view.updateIssueFields.start();
        const { hasBulkChangePermissions: hasBulkChangePermissions } = props;
        const jiraIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(getState(), props);
        const updateIssueSuccess = (isBulkEditingOperation)=>{
            (0, $b5oGV.experience).view.updateIssueFields.success();
            (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'jpd.updateIssueValue.success tracked', {
                isBulkEditingOperation: isBulkEditingOperation,
                isMultiValues: true
            });
        };
        const prevProperties = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(getState().properties);
        const prevLastUpdatedIssueIds = [
            ...getState().lastUpdatedIssueIds
        ];
        const updateIssueTypeMoveError = (err)=>{
            // revert the optimistic state update on error
            setState({
                properties: prevProperties,
                lastUpdatedIssueIds: prevLastUpdatedIssueIds
            });
            (0, $b5oGV.experience).view.updateIssueFields.successWithReason(err);
        };
        const updateIssueError = (err, isBulkEditingOperation)=>{
            // revert the optimistic state update on error
            setState({
                properties: prevProperties,
                lastUpdatedIssueIds: prevLastUpdatedIssueIds
            });
            if (!(0, $8KUFq.isClientFetchError)(err)) (0, $b5oGV.experience).view.updateIssueFields.failure(err);
            (0, $gYnSx.default)({
                ...(0, $7e8wG.createErrorAnalytics)('jpd.updateIssueValue.error', err),
                attributes: {
                    isBulkEditingOperation: isBulkEditingOperation,
                    isMultiValues: true,
                    statusCode: err instanceof (0, $1uIew.ValidationError) || err instanceof (0, $1uIew.default) ? err?.statusCode : -1
                }
            });
            if (Object.keys(request.fields).includes((0, $9a5f06039e1dff5a$export$dd03acb09519222))) (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.error.controllers.issue.actions.update-issue-issue-type', `Failed to update issue issue type, isBulkEditingOperation: ${isBulkEditingOperation}, isMultiValues: true, statusCode: ${err instanceof (0, $1uIew.ValidationError) || err instanceof (0, $1uIew.default) ? err?.statusCode : -1}`, err);
        };
        const { fields: fields, localIssueIds: localIssueIds } = request;
        const performSideEffects = request.performSideEffects !== undefined ? request.performSideEffects : true;
        let newState = getState();
        const fieldKeys = Object.keys(fields);
        const fieldKeysForBeUpdate = [
            ...fieldKeys
        ];
        const statusFieldValue = fields[0, $9a5f06039e1dff5a$export$29157f6cae91bb2f]?.newValue;
        const transitionsByLocalIssueIds = statusFieldValue !== undefined ? (0, $4ww0y.getTransitionsForTargetStatusByLocalIssueIds)(localIssueIds, // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Status'.
        statusFieldValue, newState, props) : {};
        let didUpdate = fieldKeys.every((fieldKey)=>{
            const { appendMultiValues: appendMultiValuesParam, removeValue: removeValue } = fields[fieldKey];
            const appendMultiValues = appendMultiValuesParam !== undefined ? appendMultiValuesParam : false;
            const fieldMapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(newState, props);
            const field = (0, $iehDF.createGetField)(fieldKey)(newState, props);
            if (!field || !fieldMapping) return false;
            let { newValue: newValue } = fields[fieldKey];
            // Below we convert newValue to full object (for status, user, people fields types)
            // as newValue can be retrieved from filters and there we don't store the full object
            if ((field.type === (0, $eTBmS.FIELD_TYPES).ASSIGNEE || field.type === (0, $eTBmS.FIELD_TYPES).REPORTER) && newValue !== undefined) newValue = Object.values(fieldMapping.getAllValues(newState, props)).find(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
            (value)=>value?.accountId === newValue.accountId);
            if ((field.type === (0, $eTBmS.FIELD_TYPES).PEOPLE || field.type === (0, $eTBmS.FIELD_TYPES).JSW_PEOPLE) && (0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(newValue)) {
                const allValues = Object.values(fieldMapping.getAllValues(newState, props)).flat();
                newValue = newValue.map((user)=>allValues.find((value)=>value?.accountId === user.accountId));
            }
            if (field.type === (0, $eTBmS.FIELD_TYPES).STATUS && newValue !== undefined) {
                const isValidStatusTransition = Object.values(transitionsByLocalIssueIds).every((transition)=>transition !== undefined);
                if (isValidStatusTransition) newValue = Object.values(fieldMapping.getAllValues(newState, props)).find(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
                (value)=>value?.id === newValue.id);
                else // Don't use newValue as the transition is invalid, instead use previous Status
                return true;
            }
            const newMapping = (0, $4ww0y.getNewPropertiesMapping)(fieldMapping, newState.properties, localIssueIds, newValue, removeValue, appendMultiValues);
            newState = {
                ...newState,
                properties: newMapping
            };
            return true;
        });
        if (!didUpdate) return {
            filtered: undefined
        };
        // optimistic state update
        setState(newState);
        if ((0, $4ww0y.hasIssueTypeField)(fieldKeys, newState, props)) dispatch((0, $gXTjR.resetConnectionFieldsValues)((0, $iehDF.getConfiguredConnectionFieldsKeys)(newState, props), localIssueIds));
        let hasFilteredIssuesByStatus = false;
        const isBulkEditingOperation = localIssueIds.length > 1;
        if (performSideEffects) {
            const fieldKeysForBulkUpdate = [];
            didUpdate = fieldKeysForBeUpdate.every((fieldKey)=>{
                const field = (0, $iehDF.createGetField)(fieldKey)(newState, props);
                if (!field) return false;
                if (field.type === (0, $eTBmS.FIELD_TYPES).STATUS) {
                    Object.entries(transitionsByLocalIssueIds).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ([issueId, transition])=>{
                        if (transition !== undefined) {
                            const { filtered: filtered } = dispatch((0, $3TA1a.updateStatus)((0, $9a5f06039e1dff5a$export$29157f6cae91bb2f), issueId, transition));
                            if (filtered) hasFilteredIssuesByStatus = true;
                        }
                    });
                    return true;
                }
                if (field.type === (0, $eTBmS.FIELD_TYPES).CONNECTION) {
                    dispatch((0, $cHovn.updateConnectionFieldValue)({
                        localIssueIds: localIssueIds,
                        fieldKey: fieldKey,
                        newValue: fields[fieldKey].newValue,
                        removeValue: fields[fieldKey].removeValue,
                        appendMultiValues: fields[fieldKey].appendMultiValues ?? false
                    }));
                    return true;
                }
                if (field.type === (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS) {
                    dispatch((0, $jD8ef.updateGoalsFieldValue)({
                        localIssueIds: localIssueIds,
                        fieldKey: fieldKey,
                        newValue: fields[fieldKey].newValue,
                        removeValue: fields[fieldKey].removeValue,
                        appendMultiValues: fields[fieldKey].appendMultiValues ?? false
                    }));
                    return true;
                }
                const fieldMapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(newState, props);
                if (!fieldMapping) return false;
                if (fieldMapping.isSupportedByIssueUpdateApi) fieldKeysForBulkUpdate.push(field.key);
                else if (hasBulkChangePermissions && isBulkEditingOperation && (0, $4ww0y.isBulkOperationSupported)([
                    field.key
                ], newState, props)) (0, $81I0u.updateFieldValuesOnBackendBulk)(newState, props, [
                    field.key
                ], localIssueIds, dispatch, updateIssueSuccess, updateIssueError, updateIssueTypeMoveError);
                else $1583714b851843d2$var$updateFieldValuesOnBackend(newState, props, [
                    field.key
                ], localIssueIds, dispatch, updateIssueSuccess, updateIssueError, updateIssueTypeMoveError);
                return true;
            });
            if (!didUpdate && !hasFilteredIssuesByStatus) return {
                filtered: undefined
            };
            if (fieldKeysForBulkUpdate.length > 0) {
                if (isBulkEditingOperation && (0, $4ww0y.isBulkOperationSupported)(fieldKeysForBulkUpdate, newState, props)) (0, $81I0u.updateFieldValuesOnBackendBulk)(newState, props, fieldKeysForBulkUpdate, localIssueIds, dispatch, updateIssueSuccess, updateIssueError, updateIssueTypeMoveError);
                else $1583714b851843d2$var$updateFieldValuesOnBackend(newState, props, fieldKeysForBulkUpdate, localIssueIds, dispatch, updateIssueSuccess, updateIssueError, updateIssueTypeMoveError);
            }
        }
        const updatedItems = Object.keys(request.fields).map((name)=>({
                name: name
            }));
        const issueId = jiraIdMap[request.localIssueIds[0]];
        const { selectedViewId: selectedViewId } = props;
        (0, $1I887.fireAnalyticsEventForIssueUpdate)(props.createAnalyticsEvent({}), issueId, request.localIssueIds.length === 1 ? {
            updatedItems: updatedItems,
            selectedViewId: selectedViewId,
            ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(request.localIssueIds[0])(getState())
        } : {
            updatedItems: updatedItems,
            issueCount: request.localIssueIds.length,
            issueIds: request.localIssueIds.map((id)=>(0, $4TCfW.createGetIdSelector)(id)(getState())?.toString()),
            actionType: 'bulk'
        });
        return {
            filtered: dispatch($1583714b851843d2$var$getIsFilteredResult(localIssueIds)) || hasFilteredIssuesByStatus
        };
    };
const $1583714b851843d2$export$2fac6979dabc077e = (request, onSuccess, onError)=>(api, props)=>{
        const state = {
            ...api.getState()
        };
        const selectedIssueLocalIssueId = (0, $4TCfW.getSelectedIssueLocalIssueId)(state);
        if (selectedIssueLocalIssueId !== undefined) $1583714b851843d2$export$9f85478f608191c({
            localIssueIds: [
                selectedIssueLocalIssueId
            ],
            ...request
        }, onSuccess, onError)(api, props);
    };
const $1583714b851843d2$export$7f9f35be271a76f2 = (localIssueId, fieldKey, newValue, onSuccess, onError, onConnectionsUpdated)=>({ getState: getState, dispatch: dispatch }, props)=>{
        const state = getState();
        const selectedIssueIds = (0, $hw9ct.getCurrentViewSelectedIssueIds)(state);
        const sortedIssueIds = (0, $BrRcR.getSortedIssueIds)(state, props);
        const field = (0, $iehDF.createGetField)(fieldKey)(state, props);
        const visibleSelectedIssueIds = sortedIssueIds.filter((id)=>selectedIssueIds.includes(id));
        // Find the localIssueId in the array and move it to the first position
        const localIssueIdIdx = visibleSelectedIssueIds.indexOf(localIssueId);
        if (localIssueIdIdx !== -1) {
            visibleSelectedIssueIds.splice(localIssueIdIdx, 1);
            visibleSelectedIssueIds.unshift(localIssueId);
        }
        // Skip updating all selected issues if the update comes from issue connections tab
        const isBulkEditingOperation = fieldKey !== (0, $9a5f06039e1dff5a$export$469f8bf472cb9ca) && localIssueIdIdx !== -1 && !state.selectedIssue;
        const isPlatformGoalsField = field?.type === (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS;
        const localIssueIdsToUpdate = isBulkEditingOperation ? visibleSelectedIssueIds : [
            localIssueId
        ];
        if (fieldKey === (0, $9a5f06039e1dff5a$export$dd03acb09519222) && isBulkEditingOperation) {
            if (!(0, $6uWT2.isIssueTypeFieldValue)(newValue)) return {
                filtered: undefined
            };
            const projectUpdateMap = {};
            localIssueIdsToUpdate.forEach((id)=>{
                const projectForLocalIssueId = state.properties.projects.project[id];
                if (!projectForLocalIssueId) return;
                if (!projectUpdateMap[projectForLocalIssueId.id]) projectUpdateMap[projectForLocalIssueId.id] = {
                    localIssueIds: [],
                    targetIssueType: undefined
                };
                projectUpdateMap[projectForLocalIssueId.id].localIssueIds.push(id);
                if (!projectUpdateMap[projectForLocalIssueId.id].targetIssueType) {
                    const foundIssueType = props.issueTypesByProjectId[projectForLocalIssueId.id]?.find((issueTypeForProject)=>issueTypeForProject.id === newValue.id || issueTypeForProject.name === newValue.name);
                    if (foundIssueType) projectUpdateMap[projectForLocalIssueId.id].targetIssueType = foundIssueType;
                }
            });
            const results = Object.values(projectUpdateMap).map((updateValues)=>{
                if (updateValues.targetIssueType !== undefined && updateValues.localIssueIds.length > 0) return dispatch($1583714b851843d2$export$9f85478f608191c({
                    fieldKey: fieldKey,
                    localIssueIds: updateValues.localIssueIds,
                    newValue: updateValues.targetIssueType,
                    skipNetworkRequest: false
                }, onSuccess, onError));
                return {
                    filtered: undefined
                };
            });
            return {
                filtered: results.some((result)=>result.filtered)
            };
        }
        return dispatch($1583714b851843d2$export$9f85478f608191c({
            fieldKey: fieldKey,
            localIssueIds: localIssueIdsToUpdate,
            newValue: newValue,
            skipNetworkRequest: isPlatformGoalsField
        }, onSuccess, onError, onConnectionsUpdated));
    };
const $1583714b851843d2$export$ef0e0fca317ac69f = ()=>({ setState: setState, getState: getState })=>{
        // not set empty array again to prevent selectors re-calculations
        if (getState().lastUpdatedIssueIds.length === 0) return;
        setState({
            lastUpdatedIssueIds: []
        });
    };
const $1583714b851843d2$export$acce39b7d4093c60 = ()=>({ setState: setState, getState: getState })=>{
        if (!getState().lastUpdatedAction) return;
        setState({
            lastUpdatedAction: undefined
        });
    };

});
parcelRegister("6uWT2", function(module, exports) {

$parcel$export(module.exports, "isIssueTypeFieldValue", () => $9f693c0ba84f2463$export$a98e321a39a720c1);
const $9f693c0ba84f2463$var$isProperShape = (v)=>{
    return Object.hasOwn(v, 'id') && Object.hasOwn(v, 'name') && Object.hasOwn(v, 'iconUrl');
};
const $9f693c0ba84f2463$export$a98e321a39a720c1 = (v)=>{
    return typeof v === 'object' && v !== null && $9f693c0ba84f2463$var$isProperShape(v) && typeof v.id === 'string' && typeof v.name === 'string' && typeof v.iconUrl === 'string';
};

});

parcelRegister("j9i1D", function(module, exports) {

$parcel$export(module.exports, "getActiveFiltersGroupValuesOld", () => $2730da984df982aa$export$97993148305d6887);
$parcel$export(module.exports, "getActiveFiltersGroupValues", () => $2730da984df982aa$export$8200b046c56b4d84);
$parcel$export(module.exports, "createIsInFilterResult", () => $2730da984df982aa$export$3c49f695ce87c121);
$parcel$export(module.exports, "getFilteredIssueIds", () => $2730da984df982aa$export$7a57a09bf274fce6);
$parcel$export(module.exports, "getFilteredIssueCount", () => $2730da984df982aa$export$589c122e94692c);

var $ahm5r = parcelRequire("ahm5r");

var $KSas2 = parcelRequire("KSas2");

var $dCU5j = parcelRequire("dCU5j");

var $jUVzX = parcelRequire("jUVzX");

var $40zJW = parcelRequire("40zJW");

var $8m4OM = parcelRequire("8m4OM");

var $7jTnu = parcelRequire("7jTnu");

var $eTBmS = parcelRequire("eTBmS");

var $hbF3h = parcelRequire("hbF3h");

var $NUPB6 = parcelRequire("NUPB6");

var $iehDF = parcelRequire("iehDF");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $aQTwe = parcelRequire("aQTwe");

var $dlpDx = parcelRequire("dlpDx");
const $2730da984df982aa$var$EMPTY_FILTER = [];
const $2730da984df982aa$var$EMPTY_FILTER_GROUPS = [];
const $2730da984df982aa$var$getCurrentFilter = (0, $ahm5r.createSelector)((0, $iehDF.getFields), (_state, props)=>props?.filter, (fields, filter)=>{
    if (!filter) return $2730da984df982aa$var$EMPTY_FILTER;
    return filter.filter((filterValue)=>{
        // text filters do not have fields
        if (filterValue.type === (0, $8m4OM.TEXT_FIELD_FILTER)) return true;
        return fields.some((field)=>field.key === filterValue.field);
    });
});
const $2730da984df982aa$var$getCurrentFilterGroups = (0, $ahm5r.createSelector)((0, $iehDF.getFields), (_state, props)=>props?.filterGroups, (fields, filterGroups)=>{
    if (!filterGroups) return $2730da984df982aa$var$EMPTY_FILTER_GROUPS;
    return filterGroups.reduce((acc, group)=>{
        const newFilters = group.filters.filter((filter)=>{
            if (filter.type === (0, $8m4OM.TEXT_FIELD_FILTER)) return true;
            return fields.some((field)=>field.key === filter.field);
        });
        if (newFilters.length > 0) acc.push({
            ...group,
            filters: newFilters
        });
        return acc;
    }, []);
});
const $2730da984df982aa$export$97993148305d6887 = (0, $ahm5r.createSelector)($2730da984df982aa$var$getCurrentFilter, (0, $iehDF.getAllFieldsByKey), (filters, fieldsByKey)=>{
    const retVal = [];
    filters.forEach((filter)=>{
        if (filter.type === 'FIELD' && fieldsByKey[filter.field]) retVal.push({
            field: fieldsByKey[filter.field],
            groupValues: filter.values.map(({ stringValue: stringValue })=>stringValue)
        });
        else if (filter.type === 'NUMBER' && fieldsByKey[filter.field]) retVal.push({
            field: fieldsByKey[filter.field],
            groupValues: filter.values
        });
    });
    return retVal;
});
const $2730da984df982aa$export$8200b046c56b4d84 = (0, $ahm5r.createSelector)($2730da984df982aa$var$getCurrentFilterGroups, (0, $iehDF.getAllFieldsByKey), (groups, fieldsByKey)=>{
    const retVal = [];
    const allIdeasGroup = groups.find((group)=>group.groupFilter === undefined);
    if (!allIdeasGroup) return [];
    allIdeasGroup.filters.forEach((filter)=>{
        if (filter.type === 'FIELD' && fieldsByKey[filter.field]) retVal.push({
            field: fieldsByKey[filter.field],
            groupValues: filter.values.map(({ stringValue: stringValue })=>stringValue)
        });
        else if (filter.type === 'NUMBER' && fieldsByKey[filter.field]) retVal.push({
            field: fieldsByKey[filter.field],
            groupValues: filter.values
        });
    });
    return retVal;
});
const $2730da984df982aa$export$d8c0eb07bf0860f6 = ({ groupBy: groupBy, verticalGroupBy: verticalGroupBy, fieldMapping: fieldMapping, connectionFieldKeys: connectionFieldKeys, filter: filter })=>(state, props, id)=>{
        const filterFunc = fieldMapping.getFilter(filter);
        if (!filterFunc || (0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(filterFunc)) return false;
        const jiraIdToLocalIssueId = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        const identities = (0, $aQTwe.createGetIssueGroupIdentities)({
            localIssueId: id,
            groupBy: groupBy,
            verticalGroupBy: verticalGroupBy
        })(state, props);
        const connectionIds = connectionFieldKeys.map((fieldKey)=>{
            const visibleConnections = identities.map(({ group: group, column: column })=>(0, $dlpDx.createGetConnectionFieldIssueIdsWithOptions)(fieldKey, id, {
                    group: group,
                    column: column
                })(state, props)).flat();
            return visibleConnections.map((c)=>jiraIdToLocalIssueId[c.id]).filter(Boolean);
        }).flat();
        // check if issue summary or one of the issue connections matches the search filter
        return [
            id,
            ...connectionIds
        ].some((issueId)=>filterFunc.filterFunction(fieldMapping.valueAccessor(state, props, issueId), state, props, issueId));
    };
const $2730da984df982aa$var$getFilterFunctionOld = (0, $ahm5r.createSelector)($2730da984df982aa$var$getCurrentFilter, (0, $iehDF.getFieldMappingsAsList), (_, props)=>props?.connectionFieldKeys, (_, props)=>props?.verticalGroupBy, (_, props)=>props?.groupBy, (filters, fieldMappings, connectionFieldKeys = [], verticalGroupBy, groupBy)=>{
    return (state, props, id)=>(0, (/*@__PURE__*/$parcel$interopDefault($KSas2)))($2730da984df982aa$var$getResolvedFilters(filters, fieldMappings, groupBy, verticalGroupBy, connectionFieldKeys), (func)=>func(state, props, id));
});
const $2730da984df982aa$var$getResolvedFilters = (filters, fieldMappings, groupBy, verticalGroupBy, connectionFieldKeys)=>{
    const conjunctFilters = [];
    const disjunctFilters = {};
    const quickFilters = {};
    filters.forEach((filter)=>{
        fieldMappings.forEach((mapping)=>{
            const filterValueFunc = mapping.getFilter(filter);
            if (filterValueFunc !== undefined) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(filterValueFunc)) {
                    const filterFunc = (state, props, id)=>{
                        const value = mapping.valueAccessor(state, props, id);
                        return filterValueFunc(value, state, props, id);
                    };
                    conjunctFilters.push(filterFunc);
                } else if (filterValueFunc.disjunctionIdentifier !== undefined) {
                    const filterFunc = (state, props, id)=>{
                        const value = mapping.valueAccessor(state, props, id);
                        return filterValueFunc.filterFunction(value, state, props, id);
                    };
                    if (!('localId' in filter) || filter.localId !== 'quick') disjunctFilters[filterValueFunc.disjunctionIdentifier] = [
                        ...disjunctFilters[filterValueFunc.disjunctionIdentifier] || [],
                        filterFunc
                    ];
                    else // eslint-disable-next-line no-lonely-if
                    if ((0, $7jTnu.fg)('jpd-quick-search-for-connections-in-view')) {
                        const quickSearchFilterFunc = $2730da984df982aa$export$d8c0eb07bf0860f6({
                            groupBy: groupBy,
                            verticalGroupBy: verticalGroupBy,
                            connectionFieldKeys: connectionFieldKeys,
                            fieldMapping: mapping,
                            filter: filter
                        });
                        quickFilters[filterValueFunc.disjunctionIdentifier] = [
                            ...quickFilters[filterValueFunc.disjunctionIdentifier] || [],
                            quickSearchFilterFunc
                        ];
                    } else quickFilters[filterValueFunc.disjunctionIdentifier] = [
                        ...quickFilters[filterValueFunc.disjunctionIdentifier] || [],
                        filterFunc
                    ];
                }
            }
        });
    });
    const resolvedQuickFilters = (0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(quickFilters).map((filtersGroup)=>(state, props, id)=>(0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(filtersGroup, (func)=>func(state, props, id)));
    const resolvedDisjunctFilters = (0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(disjunctFilters).map((disjunctionGroup)=>(state, props, id)=>(0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(disjunctionGroup, (func)=>func(state, props, id)));
    return [
        ...conjunctFilters,
        ...resolvedDisjunctFilters,
        ...resolvedQuickFilters
    ];
};
const $2730da984df982aa$export$e5c710199d9a5150 = (group, fieldMappings)=>{
    if (group.groupFilter !== undefined) {
        if ((0, $NUPB6.getIssueTypeNameFromGroupFilter)(group.groupFilter) === undefined) return;
        const issueTypeMapping = fieldMappings.find((mapping)=>mapping.field?.type === (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE);
        if (issueTypeMapping === undefined) return;
        const issueTypeFilterFunc = issueTypeMapping.getFilter(group.groupFilter);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(issueTypeFilterFunc)) return;
        return (state, props, id)=>{
            const value = issueTypeMapping.valueAccessor(state, props, id);
            return issueTypeFilterFunc(value, state, props, id);
        };
    }
    return ()=>true; // Always returns true for "All ideas" filters group
};
const $2730da984df982aa$export$4d2a5b62ef91607b = (0, $ahm5r.createSelector)($2730da984df982aa$var$getCurrentFilterGroups, (0, $iehDF.getFieldMappingsAsList), (_, props)=>props?.connectionFieldKeys, (_, props)=>props?.verticalGroupBy, (_, props)=>props?.groupBy, (groups, fieldMappings, connectionFieldKeys = [], verticalGroupBy, groupBy)=>{
    const resolvedFilters = [];
    groups.forEach((group)=>{
        const issueTypeFilter = $2730da984df982aa$export$e5c710199d9a5150(group, fieldMappings);
        if (issueTypeFilter !== undefined) resolvedFilters.push({
            group: (state, props, id)=>(0, (/*@__PURE__*/$parcel$interopDefault($KSas2)))($2730da984df982aa$var$getResolvedFilters(group.filters, fieldMappings, groupBy, verticalGroupBy, connectionFieldKeys), (func)=>func(state, props, id)),
            issueType: issueTypeFilter
        });
    });
    return (state, props, id)=>{
        const filtersMatchingIssueType = resolvedFilters.filter((func)=>func.issueType(state, props, id) === true);
        if (filtersMatchingIssueType.length === 0) return true;
        return filtersMatchingIssueType.every((filter)=>filter.issueType(state, props, id) && filter.group(state, props, id));
    };
});
const $2730da984df982aa$var$getFilterRelevantFieldMappingsOld = (0, $ahm5r.createSelector)($2730da984df982aa$var$getCurrentFilter, (0, $iehDF.getFieldMappingsAsList), (filters, fieldMappings)=>{
    const mappings = [];
    filters.forEach((filter)=>{
        fieldMappings.forEach((mapping)=>{
            const filterValueFunc = mapping.getFilter(filter);
            if (filterValueFunc !== undefined) mappings.push(mapping);
        });
    });
    return mappings;
});
const $2730da984df982aa$var$getFilterRelevantFieldMappings = (0, $ahm5r.createSelector)($2730da984df982aa$var$getCurrentFilterGroups, (0, $iehDF.getFieldMappingsAsList), (groups, fieldMappings)=>{
    const mappings = [];
    groups.forEach((group)=>{
        group.filters.forEach((filter)=>{
            fieldMappings.forEach((mapping)=>{
                const filterValueFunc = mapping.getFilter(filter);
                if (filterValueFunc !== undefined) mappings.push(mapping);
            });
        });
    });
    return mappings;
});
const $2730da984df982aa$var$getFilterRelevantPropertiesOld = (0, $4TCfW.createSpecificallyMemoizedDataSelector)($2730da984df982aa$var$getFilterRelevantFieldMappingsOld);
const $2730da984df982aa$var$getFilterRelevantProperties = (0, $4TCfW.createSpecificallyMemoizedDataSelector)($2730da984df982aa$var$getFilterRelevantFieldMappings);
const $2730da984df982aa$export$3c49f695ce87c121 = (fieldKey, filter, id)=>(0, $ahm5r.createSelector)((0, $iehDF.getFieldMappings), (state)=>state, (state, props)=>props, (fieldMappings, state, props)=>{
        if (filter !== undefined) {
            const fieldMapping = fieldMappings[fieldKey];
            if (fieldMapping !== undefined) {
                const filterValueFunc = fieldMapping.getFilter(filter);
                if (filterValueFunc !== undefined) {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(filterValueFunc)) {
                        const value = fieldMapping.valueAccessor(state, props, id);
                        return filterValueFunc(value, state, props, id);
                    }
                    if (filterValueFunc.disjunctionIdentifier !== undefined) {
                        const value = fieldMapping.valueAccessor(state, props, id);
                        return filterValueFunc.filterFunction(value, state, props, id);
                    }
                }
            }
        }
        return false;
    });
const $2730da984df982aa$export$7a57a09bf274fce6 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jpd_filter_groups_by_issue_type'), (0, $ahm5r.createSelector)((0, $iWbQb.getIssueIdsConsideringArchived), $2730da984df982aa$var$getFilterRelevantProperties, $2730da984df982aa$export$4d2a5b62ef91607b, (issueIds, [state, props], filter)=>issueIds.filter((id)=>filter(state, props, id))), (0, $ahm5r.createSelector)((0, $iWbQb.getIssueIdsConsideringArchived), $2730da984df982aa$var$getFilterRelevantPropertiesOld, $2730da984df982aa$var$getFilterFunctionOld, (issueIds, [state, props], filter)=>issueIds.filter((id)=>filter(state, props, id))));
const $2730da984df982aa$export$589c122e94692c = (0, $ahm5r.createSelector)($2730da984df982aa$export$7a57a09bf274fce6, (0, $4TCfW.getIssueIdsInCreation), (issueIds, issueIdsInCreation)=>issueIds.filter((id)=>!issueIdsInCreation.includes(id)).length);

});
parcelRegister("iWbQb", function(module, exports) {

$parcel$export(module.exports, "getRankedIssueIds", () => $bcd716ea1559a7db$export$9dcdab37511fde8f);
$parcel$export(module.exports, "getRankedIssueCount", () => $bcd716ea1559a7db$export$2b026d06e52ac7d8);
$parcel$export(module.exports, "getLastUpdatedIssueIds", () => $bcd716ea1559a7db$export$98be913319c074db);
$parcel$export(module.exports, "getAreEventsDeferred", () => $bcd716ea1559a7db$export$681fddecaf78d9);
$parcel$export(module.exports, "getLastIssuesUpdateWithTimestamp", () => $bcd716ea1559a7db$export$f84c0199224ea21b);
$parcel$export(module.exports, "getLastUpdatedAction", () => $bcd716ea1559a7db$export$aa0afc027dbdfb2e);
$parcel$export(module.exports, "getConnectionIssueIds", () => $bcd716ea1559a7db$export$efb75da3b4317b4f);
$parcel$export(module.exports, "getIssuesWithBasicProperties", () => $bcd716ea1559a7db$export$3277929ee6383fa9);
$parcel$export(module.exports, "getActiveIssueCount", () => $bcd716ea1559a7db$export$fb19f9982e0d3221);
$parcel$export(module.exports, "getArchivedIssueCount", () => $bcd716ea1559a7db$export$a64b27dae6bd00f7);
$parcel$export(module.exports, "getIssuesWithBasicPropertiesMap", () => $bcd716ea1559a7db$export$5ba8ea0c064a732);
$parcel$export(module.exports, "getConnectedIssuesWithBasicPropertiesMap", () => $bcd716ea1559a7db$export$a6878bff5cb123e8);
$parcel$export(module.exports, "getJiraIdToLocalIssueId", () => $bcd716ea1559a7db$export$b2bff6aa45f61aab);
$parcel$export(module.exports, "getPlatformGoalsFieldKey", () => $bcd716ea1559a7db$export$a5ef400afb7915a2);
$parcel$export(module.exports, "createGetIssuesForMerge", () => $bcd716ea1559a7db$export$5be99b76bbab6bd2);
$parcel$export(module.exports, "createGetUnarchivedIssuesForIssueSelect", () => $bcd716ea1559a7db$export$deabd0a880bbe985);
$parcel$export(module.exports, "getIssueIdsForDynamicFormula", () => $bcd716ea1559a7db$export$918fbd88c923bd1e);
$parcel$export(module.exports, "getLocalIssueIdsByJiraIssueId", () => $bcd716ea1559a7db$export$79fe70401be4634c);
$parcel$export(module.exports, "getLocalIssueIdToJiraId", () => $bcd716ea1559a7db$export$8f4c133f68cc4346);
$parcel$export(module.exports, "getLocalIssueIdToJiraKey", () => $bcd716ea1559a7db$export$1716f5f25dc5ef50);
$parcel$export(module.exports, "getLocalIssueIdForJiraIssueId", () => $bcd716ea1559a7db$export$dcd367ebd00f9188);
$parcel$export(module.exports, "getExternalIssueIdsByJiraIssueId", () => $bcd716ea1559a7db$export$1ca6d4c52d47d6b1);
$parcel$export(module.exports, "getCurrentUserManuallyCreatedIssueIds", () => $bcd716ea1559a7db$export$d601ab6d4610cfc2);
$parcel$export(module.exports, "createGetIsIssueFromDifferentContainerByLocalId", () => $bcd716ea1559a7db$export$8900c2cc6f2c4205);
$parcel$export(module.exports, "createGetIsIssueFromDifferentContainerByJiraId", () => $bcd716ea1559a7db$export$922d26d699d499cb);
$parcel$export(module.exports, "getAllIssueIdsConsideringArchived", () => $bcd716ea1559a7db$export$cdea914955520b37);
$parcel$export(module.exports, "getIssueIdsConsideringArchived", () => $bcd716ea1559a7db$export$79eb03f8161cd3ec);

var $ahm5r = parcelRequire("ahm5r");

var $5spib = parcelRequire("5spib");

var $exWdq = parcelRequire("exWdq");

var $dCU5j = parcelRequire("dCU5j");

var $9g7yh = parcelRequire("9g7yh");

var $ibLUB = parcelRequire("ibLUB");

var $eTBmS = parcelRequire("eTBmS");


var $8Z1Mi = parcelRequire("8Z1Mi");

var $ljej9 = parcelRequire("ljej9");

var $T9VAH = parcelRequire("T9VAH");

var $2yCra = parcelRequire("2yCra");

var $795ti = parcelRequire("795ti");

var $amUSo = parcelRequire("amUSo");

var $2Wt2d = parcelRequire("2Wt2d");

var $iehDF = parcelRequire("iehDF");

var $4TCfW = parcelRequire("4TCfW");

var $53OVi = parcelRequire("53OVi");
const $bcd716ea1559a7db$export$9dcdab37511fde8f = (state)=>state.ids;
const $bcd716ea1559a7db$export$2b026d06e52ac7d8 = (state)=>state.ids.length;
const $bcd716ea1559a7db$export$98be913319c074db = (state)=>state.lastUpdatedIssueIds;
const $bcd716ea1559a7db$export$681fddecaf78d9 = (state)=>!!state.defferRealTimeEventsCounter && state.defferRealTimeEventsCounter > 0;
const $bcd716ea1559a7db$export$f84c0199224ea21b = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$98be913319c074db, (issueIds)=>{
    return {
        issueIds: issueIds,
        timestamp: Date.now()
    };
});
const $bcd716ea1559a7db$export$aa0afc027dbdfb2e = (state)=>state.lastUpdatedAction;
const $bcd716ea1559a7db$export$efb75da3b4317b4f = (state)=>state.connectionIssueIds;
const $bcd716ea1559a7db$export$d68f5a51e9a95425 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, $bcd716ea1559a7db$export$efb75da3b4317b4f, (localIssueIds, connectionIssueIds)=>[
        ...localIssueIds,
        ...connectionIssueIds
    ]);
const $bcd716ea1559a7db$var$getIssueIdRelevantFieldMappings = (0, $ahm5r.createSelector)((0, $iehDF.getFields), (0, $2Wt2d.getIssueIdField), // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
({ containerProps: containerProps })=>containerProps?.issuesRemote, (fields, id, issuesRemote)=>[
        (0, $T9VAH.fieldMapping)(issuesRemote, fields, id)
    ]);
const $bcd716ea1559a7db$var$getIssueIdRelevantProperties = (0, $4TCfW.createSpecificallyMemoizedDataSelector)($bcd716ea1559a7db$var$getIssueIdRelevantFieldMappings);
const $bcd716ea1559a7db$var$getIssuesWithBasicPropertiesInternal = (localIssueIds, numberProperties, stringProperties, singleOptionProperties, archivedFieldsConfig)=>{
    const archivedFieldKey = archivedFieldsConfig?.archivedField?.key;
    const isArchivedOption = archivedFieldsConfig?.archivedField?.archivedOption;
    const result = localIssueIds.map((localIssueId)=>({
            localIssueId: localIssueId,
            id: numberProperties[0, $9a5f06039e1dff5a$export$48927a8f78b0130e]?.[localIssueId],
            key: stringProperties[0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b]?.[localIssueId],
            summary: stringProperties[0, $9a5f06039e1dff5a$export$469f8bf472cb9ca]?.[localIssueId],
            isArchived: archivedFieldKey !== undefined && isArchivedOption !== undefined && singleOptionProperties[archivedFieldKey]?.[localIssueId]?.id === isArchivedOption.jiraOptionId
        }));
    return result;
};
const $bcd716ea1559a7db$export$3277929ee6383fa9 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, (0, $4TCfW.getNumberProperties), (0, $4TCfW.getStringProperties), (0, $4TCfW.getSingleOptionProperties), (_, props)=>props?.archivedFieldsConfig, $bcd716ea1559a7db$var$getIssuesWithBasicPropertiesInternal);
const $bcd716ea1559a7db$export$5bace9f224fd5e0b = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$efb75da3b4317b4f, (0, $4TCfW.getNumberProperties), (0, $4TCfW.getStringProperties), (0, $4TCfW.getSingleOptionProperties), (_, props)=>props?.archivedFieldsConfig, $bcd716ea1559a7db$var$getIssuesWithBasicPropertiesInternal);
const $bcd716ea1559a7db$var$getArchivedSingleOptionProperties = (0, $ahm5r.createSelector)((0, $4TCfW.getSingleOptionProperties), (_, props)=>props?.archivedFieldsConfig?.archivedField?.key, (_, props)=>props?.archivedFieldsConfig?.archivedField?.archivedOption?.jiraOptionId, (singleOptionProperties, archivedFieldKey, archivedFieldOptionId)=>archivedFieldKey !== undefined && archivedFieldOptionId !== undefined && singleOptionProperties[archivedFieldKey] || undefined);
const $bcd716ea1559a7db$var$getIssueIdsWithArchivedProperty = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, $bcd716ea1559a7db$var$getArchivedSingleOptionProperties, (_, props)=>props?.archivedFieldsConfig?.archivedField?.archivedOption?.jiraOptionId, (localIssueIds, archivedSingleOptionProperties, archivedFieldOptionId)=>{
    const isArchivedOption = archivedFieldOptionId;
    const result = localIssueIds.map((localIssueId)=>({
            localIssueId: localIssueId,
            isArchived: isArchivedOption !== undefined && archivedSingleOptionProperties?.[localIssueId]?.id === archivedFieldOptionId
        }));
    return result;
});
const $bcd716ea1559a7db$export$fb19f9982e0d3221 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$3277929ee6383fa9, (issuesWithBasicProperties)=>issuesWithBasicProperties.filter(({ isArchived: isArchived })=>!isArchived).length);
const $bcd716ea1559a7db$export$a64b27dae6bd00f7 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$3277929ee6383fa9, (issuesWithBasicProperties)=>issuesWithBasicProperties.filter(({ isArchived: isArchived })=>isArchived).length);
const $bcd716ea1559a7db$export$5ba8ea0c064a732 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$3277929ee6383fa9, (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(issues, (issue)=>issue.localIssueId));
const $bcd716ea1559a7db$export$a6878bff5cb123e8 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$5bace9f224fd5e0b, (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(issues, (issue)=>issue.localIssueId));
const $bcd716ea1559a7db$export$b2bff6aa45f61aab = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, $bcd716ea1559a7db$export$efb75da3b4317b4f, (0, $4TCfW.getJiraIssueIdProperties), (localIssueIds, connectionIssueIds, jiraIssueIds)=>{
    const mapping = {};
    const mapLocalIssueIds = (localIssueId)=>{
        if (jiraIssueIds[localIssueId] !== undefined) mapping[jiraIssueIds[localIssueId]] = localIssueId;
    };
    localIssueIds.forEach(mapLocalIssueIds);
    connectionIssueIds.forEach(mapLocalIssueIds);
    return mapping;
});
const $bcd716ea1559a7db$export$a5ef400afb7915a2 = (0, $ahm5r.createSelector)((0, $2Wt2d.getPlatformGoalsField), (platformGoalsField)=>platformGoalsField?.key);
const $bcd716ea1559a7db$export$5be99b76bbab6bd2 = (localIssueIds)=>(0, $ahm5r.createSelector)((0, $iehDF.getFields), (0, $2Wt2d.getDescriptionField), (state, props)=>[
            state,
            props
        ], (fields, descriptionField, [state, props])=>{
        const { properties: properties } = state;
        const result = localIssueIds.map((localIssueId)=>({
                localIssueId: localIssueId,
                id: properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e]?.[localIssueId],
                key: properties.string[0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b]?.[localIssueId],
                summary: properties.string[0, $9a5f06039e1dff5a$export$469f8bf472cb9ca]?.[localIssueId],
                description: descriptionField !== undefined ? (0, $T9VAH.fieldMapping)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
                props?.issuesRemote, fields, descriptionField).valueAccessor(state, props, localIssueId) : undefined,
                issuetype: properties.issueType[0, $9a5f06039e1dff5a$export$dd03acb09519222]?.[localIssueId],
                // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                externalIssueData: (0, $53OVi.createGetLinkedIssueData)(localIssueId)(state, props),
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fieldsForUpdate: fields.reduce((fieldsResult, field)=>{
                    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
                    const mapping = (0, $T9VAH.fieldMapping)(props?.issuesRemote, fields, field);
                    if (!mapping || !mapping.isSupportedByIssueUpdateApi || !field.editable || field.key === (0, $9a5f06039e1dff5a$export$cb59b69c70ea9e18) || field.key === (0, $9a5f06039e1dff5a$export$469f8bf472cb9ca)) return fieldsResult;
                    if (field.configuration?.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).DELIVERY_DATE && mapping.valueAccessorRealValues) return {
                        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                        ...fieldsResult,
                        [field.key]: mapping.getFieldValueForJiraUpdate(mapping.valueAccessorRealValues(state, props, localIssueId)) || null
                    };
                    return {
                        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                        ...fieldsResult,
                        [field.key]: mapping.getFieldValueForJiraUpdate(mapping.valueAccessor(state, props, localIssueId)) || null
                    };
                }, {})
            }));
        return result;
    });
const $bcd716ea1559a7db$export$5bf9b219321236c1 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, (0, $iehDF.getFields), (0, $2Wt2d.getDescriptionField), (state, props)=>[
        state,
        props
    ], (localIssueIds, fields, descriptionField, [state, props])=>{
    const { properties: properties } = state;
    const archivedFieldKey = props?.archivedFieldsConfig?.archivedField?.key;
    const isArchivedOption = props?.archivedFieldsConfig?.archivedField?.archivedOption;
    return localIssueIds.map((localIssueId)=>({
            localIssueId: localIssueId,
            id: properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e]?.[localIssueId],
            key: properties.string[0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b]?.[localIssueId],
            summary: properties.string[0, $9a5f06039e1dff5a$export$469f8bf472cb9ca]?.[localIssueId],
            issuetype: properties.issueType[0, $9a5f06039e1dff5a$export$dd03acb09519222]?.[localIssueId],
            isArchived: archivedFieldKey !== undefined && isArchivedOption !== undefined && properties.singleSelect[archivedFieldKey]?.[localIssueId]?.id === isArchivedOption.jiraOptionId
        }));
});
const $bcd716ea1559a7db$export$deabd0a880bbe985 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$5bf9b219321236c1, (issues)=>issues.filter(({ isArchived: isArchived })=>!isArchived));
const $bcd716ea1559a7db$export$918fbd88c923bd1e = (0, $ahm5r.createSelector)($bcd716ea1559a7db$var$getIssueIdsWithArchivedProperty, (_, props)=>props?.containsArchived || false, (0, $4TCfW.getIssueIdsInCreation), (issueIdsWithArchivedProperty, containsArchived, inCreation)=>issueIdsWithArchivedProperty.filter((issue)=>(!containsArchived && !issue.isArchived || containsArchived && issue.isArchived) && !inCreation.includes(issue.localIssueId)).map((issue)=>issue.localIssueId));
const $bcd716ea1559a7db$export$79fe70401be4634c = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, $bcd716ea1559a7db$export$efb75da3b4317b4f, $bcd716ea1559a7db$var$getIssueIdRelevantProperties, (localIssueIds, connectionIssueIds, [{ properties: properties }])=>{
    const map = {};
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(properties.number, (0, $9a5f06039e1dff5a$export$48927a8f78b0130e))) {
        const mapLocalIssueIds = (localIssueId)=>{
            const jiraId = properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e][localIssueId];
            if (jiraId !== undefined) map[jiraId] = localIssueId;
        };
        localIssueIds.forEach(mapLocalIssueIds);
        connectionIssueIds.forEach(mapLocalIssueIds);
    }
    return map;
});
const $bcd716ea1559a7db$var$EMPTY_MAP = Object.freeze({});
const $bcd716ea1559a7db$export$8f4c133f68cc4346 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, $bcd716ea1559a7db$export$efb75da3b4317b4f, $bcd716ea1559a7db$var$getIssueIdRelevantProperties, (localIssueIds, connectionIssueIds, [{ properties: properties }])=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(properties.number, (0, $9a5f06039e1dff5a$export$48927a8f78b0130e))) return $bcd716ea1559a7db$var$EMPTY_MAP;
    const map = {};
    const mapLocalIssueIds = (localIssueId)=>{
        const id = properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e][localIssueId];
        if (id !== undefined) map[localIssueId] = String(id);
    };
    localIssueIds.forEach(mapLocalIssueIds);
    connectionIssueIds.forEach(mapLocalIssueIds);
    return map;
});
const $bcd716ea1559a7db$export$1716f5f25dc5ef50 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, $bcd716ea1559a7db$export$efb75da3b4317b4f, $bcd716ea1559a7db$var$getIssueIdRelevantProperties, (localIssueIds, connectionIssueIds, [{ properties: properties }])=>{
    const hasNoIssueIds = localIssueIds.length === 0 && connectionIssueIds.length === 0;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(properties.string, (0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b)) || hasNoIssueIds) return $bcd716ea1559a7db$var$EMPTY_MAP;
    const map = {};
    const mapLocalIssueIds = (localIssueId)=>{
        const jiraKey = (0, $ljej9.toIssueKey)(String(properties.string[0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b][localIssueId]));
        if (jiraKey !== undefined) map[localIssueId] = jiraKey;
    };
    localIssueIds.forEach(mapLocalIssueIds);
    connectionIssueIds.forEach(mapLocalIssueIds);
    return map;
});
const $bcd716ea1559a7db$export$dcd367ebd00f9188 = (jiraIssueId)=>(0, $ahm5r.createSelector)($bcd716ea1559a7db$export$79fe70401be4634c, (idMap)=>idMap[+jiraIssueId]);
const $bcd716ea1559a7db$export$1ca6d4c52d47d6b1 = (0, $ahm5r.createSelector)((0, $53OVi.getExternalIssueData), (externalIssues)=>{
    const map = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(externalIssues, (issue, key)=>{
        map[issue.issueId] = key;
    });
    return map;
});
const $bcd716ea1559a7db$export$f3768a93224b698b = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, (0, $2Wt2d.getCreatorField), (state, props)=>({
        state: state,
        props: props
    }), (localIssueIds, creatorField, { state: state, props: props })=>{
    if (!creatorField || !props?.currentUser || !state.containerProps?.issuesRemote) return [];
    const creatorFieldMapping = (0, $795ti.userMapping)(state.containerProps.issuesRemote, creatorField);
    const filterFunction = creatorFieldMapping.getFilter({
        type: 'FIELD',
        field: creatorField?.key,
        fieldType: (0, $eTBmS.FIELD_TYPES).CREATOR,
        values: [
            {
                stringValue: props.currentUser
            }
        ]
    });
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(filterFunction)) return [];
    return localIssueIds.filter((id)=>filterFunction(creatorFieldMapping.valueAccessor(state, props, id), state, props, id));
});
const $bcd716ea1559a7db$export$d601ab6d4610cfc2 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$f3768a93224b698b, (0, $2Wt2d.getCreatedField), (state, props)=>({
        state: state,
        props: props
    }), (issueIds, createdField, { state: state, props: props })=>{
    if (!createdField || !state.containerProps?.issuesRemote || !props?.projectOnboardedAt) return [];
    const createdFieldMapping = (0, $2yCra.stringMapping)(state.containerProps.issuesRemote, createdField);
    return issueIds.filter((id)=>{
        const createdAt = createdFieldMapping.valueAccessor(state, undefined, id);
        return createdAt !== undefined && props.projectOnboardedAt && (0, $ibLUB.default)(new Date(createdAt), new Date(props.projectOnboardedAt));
    });
});
const $bcd716ea1559a7db$export$8900c2cc6f2c4205 = (id)=>(0, $ahm5r.createSelector)($bcd716ea1559a7db$export$efb75da3b4317b4f, (connectionIssueIds)=>!!id && connectionIssueIds.includes(id));
const $bcd716ea1559a7db$export$922d26d699d499cb = (jiraIssueId)=>(0, $ahm5r.createSelector)($bcd716ea1559a7db$export$dcd367ebd00f9188(jiraIssueId), $bcd716ea1559a7db$export$efb75da3b4317b4f, (id, connectionIssueIds)=>connectionIssueIds.includes(id));
const $bcd716ea1559a7db$var$filterOutArchivedEdge = (issueIds, basicIssuesMap, containsArchived)=>{
    const newIssueIds = issueIds.filter((issueId)=>containsArchived && basicIssuesMap[issueId]?.isArchived || !containsArchived && !basicIssuesMap[issueId]?.isArchived);
    if (!containsArchived) return newIssueIds.slice(0, (0, $amUSo.ISSUES_PAGE_LIMIT));
    return newIssueIds;
};
const $bcd716ea1559a7db$export$cdea914955520b37 = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$d68f5a51e9a95425, $bcd716ea1559a7db$export$5ba8ea0c064a732, (_, props)=>props?.containsArchived || false, $bcd716ea1559a7db$var$filterOutArchivedEdge);
const $bcd716ea1559a7db$export$79eb03f8161cd3ec = (0, $ahm5r.createSelector)($bcd716ea1559a7db$export$9dcdab37511fde8f, $bcd716ea1559a7db$export$5ba8ea0c064a732, (_, props)=>props?.containsArchived || false, $bcd716ea1559a7db$var$filterOutArchivedEdge);

});
parcelRegister("amUSo", function(module, exports) {

$parcel$export(module.exports, "ISSUES_PAGE_LIMIT", () => $58c6a51d53b44ff8$export$6ea61c4310270975);
$parcel$export(module.exports, "EMPTY_PROPERTIES", () => $58c6a51d53b44ff8$export$91224bea01cc6006);
$parcel$export(module.exports, "EMPTY_STATE", () => $58c6a51d53b44ff8$export$f040258c471d4154);
$parcel$export(module.exports, "JPD_CONNECTION_ISSUE_LINK_TYPE", () => $58c6a51d53b44ff8$export$e5b97ab8c68eee79);
const $58c6a51d53b44ff8$export$6ea61c4310270975 = 5000;
const $58c6a51d53b44ff8$export$91224bea01cc6006 = {
    number: {},
    string: {},
    stringList: {},
    status: {},
    issueType: {},
    user: {},
    people: {},
    singleSelect: {},
    multiSelect: {},
    created: {},
    insights: {},
    insightsMetadata: {},
    linkedDeliveryIssues: {},
    plays: {},
    externalReference: {},
    lexoRank: {},
    document: {},
    commentsMetadata: {},
    externalReferenceEntities: {},
    reactions: {},
    aggregatedDeliveryProgress: {},
    aggregatedDeliveryDates: {},
    issueMetadata: {},
    projects: {},
    connection: {},
    team: {},
    goals: {}
};
const $58c6a51d53b44ff8$var$EMPTY_DYNAMIC_PROPERTIES = {
    numberValue: {},
    numberValues: {},
    dateValue: {},
    dateValues: {}
};
const $58c6a51d53b44ff8$export$f040258c471d4154 = {
    meta: {
        initialized: false,
        initializedArchived: false,
        loading: false,
        loadingArchivedIssues: false,
        loadingLinkedIssues: false,
        error: undefined,
        archivedError: undefined,
        loadingProps: undefined,
        isSingleIssueLoaded: false,
        singleIssueLoadedTimestamp: undefined,
        fullDeliveryDataInitialized: false,
        isIssueStatusRollbackInProgress: false
    },
    selectedIssue: undefined,
    defferRealTimeEvents: [],
    lastUpdatedIssueIds: [],
    lastUpdatedAction: undefined,
    ids: [],
    connectionIssueIds: [],
    externalIssueRanking: undefined,
    properties: $58c6a51d53b44ff8$export$91224bea01cc6006,
    dynamicProperties: $58c6a51d53b44ff8$var$EMPTY_DYNAMIC_PROPERTIES,
    externalIssueData: {},
    containerProps: undefined,
    openUpdateCounter: {},
    prefechedIssues: undefined,
    prefetchedPrimaryIssueList: undefined,
    archivedPrimaryIssueList: undefined,
    archivedIssues: undefined
};
const $58c6a51d53b44ff8$export$e5b97ab8c68eee79 = 'Discovery - Connected';

});


parcelRegister("aQTwe", function(module, exports) {

$parcel$export(module.exports, "createGetGroupIdentities", () => $de98a991da3bdf08$export$b64ecb131aed80b4);
$parcel$export(module.exports, "createGetIssueGroupIdentities", () => $de98a991da3bdf08$export$90e280873c63f304);

var $ahm5r = parcelRequire("ahm5r");

var $eTBmS = parcelRequire("eTBmS");

var $3degy = parcelRequire("3degy");

var $iehDF = parcelRequire("iehDF");

var $iWbQb = parcelRequire("iWbQb");
const $de98a991da3bdf08$export$cafe92e163cb3ef9 = {};
const $de98a991da3bdf08$export$b64ecb131aed80b4 = (fieldKey)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state, props)=>{
        const mapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(state, props);
        if (fieldKey === undefined || mapping === undefined) return $de98a991da3bdf08$export$cafe92e163cb3ef9;
        const cached = (0, $3degy.cacheSelectorCreator)(mapping.getGroupIdentitiesSelector);
        if (mapping.field?.type === (0, $eTBmS.FIELD_TYPES).CONNECTION) return cached(fieldKey, (0, $iWbQb.getAllIssueIdsConsideringArchived))(state, props);
        return cached(fieldKey, (0, $iWbQb.getRankedIssueIds))(state);
    };
const $de98a991da3bdf08$export$90e280873c63f304 = ({ localIssueId: localIssueId, groupBy: groupBy, verticalGroupBy: verticalGroupBy })=>(0, $ahm5r.createSelector)($de98a991da3bdf08$export$b64ecb131aed80b4(groupBy), $de98a991da3bdf08$export$b64ecb131aed80b4(verticalGroupBy), (groupIdentities, verticalGroupIdentities)=>{
        const issueVerticalGroupIdentities = verticalGroupIdentities[localIssueId]?.length ? verticalGroupIdentities[localIssueId] : [
            {
                value: undefined
            }
        ];
        const issueGroupIdentities = groupIdentities[localIssueId]?.length ? groupIdentities[localIssueId] : [
            {
                value: undefined
            }
        ];
        const identities = [];
        issueVerticalGroupIdentities.forEach((verticalIdentity)=>{
            issueGroupIdentities.forEach((groupIdentity)=>{
                identities.push({
                    group: verticalGroupBy ? {
                        fieldKey: verticalGroupBy,
                        fieldValue: verticalIdentity.value
                    } : undefined,
                    column: groupBy ? {
                        fieldKey: groupBy,
                        fieldValue: groupIdentity.value
                    } : undefined
                });
            });
        });
        return identities;
    });

});

parcelRegister("dlpDx", function(module, exports) {

$parcel$export(module.exports, "createGetAllIssueIdsMatchingConnectionFieldFilters", () => $22980a4c6dc120ec$export$b37a0629593be861);
$parcel$export(module.exports, "createIsIssueMatchingConnectionFieldFilter", () => $22980a4c6dc120ec$export$1140f0368dfa5bcb);
$parcel$export(module.exports, "createGetConnectionFieldIssueIds", () => $22980a4c6dc120ec$export$9c772ab64317564b);
$parcel$export(module.exports, "createGetConnectionFieldIssueIdsWithOptions", () => $22980a4c6dc120ec$export$d68a9cb0dc20e951);
$parcel$export(module.exports, "createGetColumnAndGroupAwareConnections", () => $22980a4c6dc120ec$export$ce7b3cdc56e8f353);
$parcel$export(module.exports, "createGetSelectedIssuesConnectionFieldIssuesCount", () => $22980a4c6dc120ec$export$866caf415fc0e834);
$parcel$export(module.exports, "getSelectedIssueConfiguredConnectionFields", () => $22980a4c6dc120ec$export$5640cd7dd0bca881);
$parcel$export(module.exports, "getSelectedIssueConfiguredConnectionFieldsCount", () => $22980a4c6dc120ec$export$6ccca9c73456f8c4);
$parcel$export(module.exports, "createGetSelectedIssueConnectionsCount", () => $22980a4c6dc120ec$export$ff632f7cc6196d5b);
$parcel$export(module.exports, "createGetIsConnectionFieldThatNeedsDeliveryData", () => $22980a4c6dc120ec$export$2a41b55765d95cf4);
$parcel$export(module.exports, "getConnectionFieldsThatNeedDeliveryData", () => $22980a4c6dc120ec$export$ed5b9164f6908892);
$parcel$export(module.exports, "createGetConnectionsValuesMap", () => $22980a4c6dc120ec$export$5262aef2423258d);
$parcel$export(module.exports, "createGetConnectionsValueSelector", () => $22980a4c6dc120ec$export$5e07bb3bfcb1439f);

var $ahm5r = parcelRequire("ahm5r");

var $22aul = parcelRequire("22aul");

var $cSmYj = parcelRequire("cSmYj");

var $jOCpp = parcelRequire("jOCpp");

var $dCU5j = parcelRequire("dCU5j");

var $eTBmS = parcelRequire("eTBmS");

var $8m4OM = parcelRequire("8m4OM");

var $7jTnu = parcelRequire("7jTnu");

var $8Z1Mi = parcelRequire("8Z1Mi");

var $dmtjA = parcelRequire("dmtjA");

var $T9VAH = parcelRequire("T9VAH");

var $iehDF = parcelRequire("iehDF");

var $1nkQQ = parcelRequire("1nkQQ");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");
const $22980a4c6dc120ec$export$b37a0629593be861 = (localIssueId, fieldKey)=>(0, $ahm5r.createSelector)((0, $iWbQb.getIssueIdsConsideringArchived), (0, $iehDF.createGetField)(fieldKey), (state, props)=>({
            state: state,
            props: props
        }), (issueIds, connectionField, { state: state, props: props })=>{
        const projectIssuesIds = issueIds.filter((issueId)=>{
            const issueType = (0, $4TCfW.createGetIssueType)(issueId)(state, props);
            const projectId = (0, $4TCfW.createGetProjectIdSelector)(issueId)(state);
            return issueId !== localIssueId && (0, $dmtjA.isMatchingConnectionFieldFilter)({
                filters: connectionField?.configuration?.issueTypeFilters || [],
                issueTypeId: issueType?.id,
                issueTypeName: issueType?.name,
                projectId: projectId
            });
        });
        return projectIssuesIds;
    });
const $22980a4c6dc120ec$export$1140f0368dfa5bcb = (localIssueId = '', fieldKey)=>(0, $ahm5r.createSelector)((0, $iehDF.createGetField)(fieldKey), (state, props)=>({
            state: state,
            props: props
        }), (connectionField, { state: state, props: props })=>{
        const issueType = (0, $4TCfW.createGetIssueType)(localIssueId)(state, props);
        return (0, $dmtjA.isMatchingConnectionFieldFilter)({
            filters: connectionField?.configuration?.issueTypeFilters || [],
            issueTypeId: issueType?.id,
            issueTypeName: issueType?.name
        });
    });
const $22980a4c6dc120ec$var$filterArchivedConnectionFieldIssueIds = (connections = [], issuesWithBasicPropertiesMap, connectedIssuesWithBasicPropertiesMap, connectionIssueIds, jiraIdToLocalIssueId)=>connections.filter(({ id: id })=>{
        const localId = jiraIdToLocalIssueId[parseInt(id, 10)];
        if (!localId) return true;
        if ((0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar')) {
            if (issuesWithBasicPropertiesMap[localId]) return !issuesWithBasicPropertiesMap[localId]?.isArchived;
            if (connectedIssuesWithBasicPropertiesMap[localId]) return !connectedIssuesWithBasicPropertiesMap[localId]?.isArchived;
            return false;
        }
        return issuesWithBasicPropertiesMap[localId] && !issuesWithBasicPropertiesMap[localId]?.isArchived || connectionIssueIds.includes(localId);
    });
const $22980a4c6dc120ec$var$EMPTY_CONNECTIONS = [];
const $22980a4c6dc120ec$export$9c772ab64317564b = (fieldKey, localIssueId)=>(0, $ahm5r.createSelector)((0, $4TCfW.getConnectionProperties), (0, $iWbQb.getIssuesWithBasicPropertiesMap), (0, $iWbQb.getConnectedIssuesWithBasicPropertiesMap), (0, $iWbQb.getConnectionIssueIds), (0, $iWbQb.getJiraIdToLocalIssueId), (connectionProperties, issuesWithBasicPropertiesMap, connectedIssuesWithBasicPropertiesMap, connectionIssueIds, jiraIdToLocalIssueId)=>{
        if (!localIssueId) return $22980a4c6dc120ec$var$EMPTY_CONNECTIONS;
        const result = $22980a4c6dc120ec$var$filterArchivedConnectionFieldIssueIds(connectionProperties[fieldKey]?.[localIssueId], issuesWithBasicPropertiesMap, connectedIssuesWithBasicPropertiesMap, connectionIssueIds, jiraIdToLocalIssueId);
        const sortedResult = [
            ...result
        ].sort(({ id: id1 }, { id: id2 })=>Number(id1) - Number(id2));
        return sortedResult;
    });
const $22980a4c6dc120ec$var$getFilters = ({ containerProps: containerProps })=>containerProps?.filter;
const $22980a4c6dc120ec$export$7496a746d74b33b0 = (value)=>typeof value === 'object' && value !== null && 'id' in value && typeof value.id === 'string';
const $22980a4c6dc120ec$export$4d601978fcee45a8 = ({ fieldKey: fieldKey, fieldValue: fieldValue }, filterType)=>{
    if (typeof fieldValue === 'number' && filterType === (0, $8m4OM.NUMERIC_FIELD_FILTER)) return {
        type: (0, $8m4OM.NUMERIC_FIELD_FILTER),
        field: fieldKey,
        values: [
            {
                operator: 'EQ',
                numericValue: fieldValue
            }
        ]
    };
    if (filterType === (0, $8m4OM.GENERIC_FIELD_FILTER)) {
        if (Array.isArray(fieldValue)) return {
            type: (0, $8m4OM.GENERIC_FIELD_FILTER),
            field: fieldKey,
            values: fieldValue.filter($22980a4c6dc120ec$export$7496a746d74b33b0).map(({ id: id })=>({
                    stringValue: id
                }))
        };
        if ($22980a4c6dc120ec$export$7496a746d74b33b0(fieldValue)) return {
            type: (0, $8m4OM.GENERIC_FIELD_FILTER),
            field: fieldKey,
            values: [
                {
                    stringValue: fieldValue.id
                }
            ]
        };
    }
    return undefined;
};
const $22980a4c6dc120ec$export$d68a9cb0dc20e951 = (fieldKey, localIssueId, { column: column, group: group })=>{
    const getConnectionFieldIssueIds = $22980a4c6dc120ec$export$9c772ab64317564b(fieldKey, localIssueId);
    const getMappingColumn = (0, $ahm5r.createSelector)(({ containerProps: containerProps })=>containerProps?.issuesRemote, (0, $iehDF.getFields), (0, $iehDF.getAllFieldsByKey), (issuesRemote, fields, fieldsByKey)=>column && issuesRemote && (0, $T9VAH.fieldMapping)(issuesRemote, fields, fieldsByKey[column.fieldKey]));
    const getMappingGroup = (0, $ahm5r.createSelector)(({ containerProps: containerProps })=>containerProps?.issuesRemote, (0, $iehDF.getFields), (0, $iehDF.getAllFieldsByKey), (issuesRemote, fields, fieldsByKey)=>group && issuesRemote && (0, $T9VAH.fieldMapping)(issuesRemote, fields, fieldsByKey[group.fieldKey]));
    const getConnectionFieldFilters = (0, $ahm5r.createSelector)($22980a4c6dc120ec$var$getFilters, (filters)=>{
        return filters?.filter((filter)=>{
            return filter.type === (0, $8m4OM.CONNECTION_FIELD_FILTER) && filter.field === fieldKey;
        }) ?? [];
    });
    const getShouldMatchColumn = (0, $ahm5r.createSelector)(getConnectionFieldFilters, (connectionFieldFilters)=>connectionFieldFilters.some((filter)=>filter.values.some((value)=>value.enumValue === (0, $8m4OM.CONNECTION_FIELD_FILTER_BOARD_COLUMN))));
    const getShouldMatchGroup = (0, $ahm5r.createSelector)(getConnectionFieldFilters, (connectionFieldFilters)=>connectionFieldFilters.some((filter)=>filter.values.some((value)=>value.enumValue === (0, $8m4OM.CONNECTION_FIELD_FILTER_VIEW_GROUP))));
    // For memoized result
    let lastResult = [];
    return (0, $ahm5r.createSelector)(getConnectionFieldIssueIds, (0, $iWbQb.getJiraIdToLocalIssueId), getMappingColumn, getMappingGroup, getShouldMatchColumn, getShouldMatchGroup, (state, props)=>({
            state: state,
            props: props
        }), (issueIds, jiraIdToLocalIssueId, mappingColumn, mappingGroup, shouldMatchColumn, shouldMatchGroup, { state: state, props: props })=>{
        const columnFilterType = column?.fieldKey ? (0, $1nkQQ.createGetFilterTypeForField)(column?.fieldKey)(state, props) : undefined;
        const groupFilterType = group?.fieldKey ? (0, $1nkQQ.createGetFilterTypeForField)(group?.fieldKey)(state, props) : undefined;
        const isMatching = (issueId, option, shouldMatch, mapping, filterType)=>{
            if (shouldMatch === false || mapping === undefined || option === undefined || filterType === undefined) return true;
            const filter = $22980a4c6dc120ec$export$4d601978fcee45a8(option, filterType);
            const filterFunction = filter ? mapping.getFilter(filter) : undefined;
            if (filterFunction === undefined) return false;
            const localId = jiraIdToLocalIssueId[parseInt(issueId, 10)];
            const fieldValue = mapping.valueAccessor(state, props, localId);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(filterFunction)) return filterFunction(fieldValue, state, props, localId);
            return filterFunction.filterFunction(fieldValue, state, props, localId);
        };
        const result = issueIds.filter((v)=>isMatching(v.id, column, shouldMatchColumn, mappingColumn, columnFilterType) && isMatching(v.id, group, shouldMatchGroup, mappingGroup, groupFilterType));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($22aul)))(result, lastResult)) // So that we don't send new array to React. This should prevent extra renders.
        return lastResult;
        // Update the memoized value
        lastResult = result;
        return result;
    });
};
const $22980a4c6dc120ec$var$createGetSelectedIssueConnectionFieldIssueIds = (connectionFieldKey)=>(0, $ahm5r.createSelector)((0, $4TCfW.getSelectedIssueLocalIssueId), (0, $4TCfW.getConnectionProperties), (0, $iWbQb.getIssuesWithBasicPropertiesMap), (0, $iWbQb.getConnectedIssuesWithBasicPropertiesMap), (0, $iWbQb.getConnectionIssueIds), (0, $iWbQb.getJiraIdToLocalIssueId), (localIssueId, connectionProperties, issuesWithBasicPropertiesMap, connectedIssuesWithBasicPropertiesMap, connectionIssueIds, jiraIdToLocalIssueId)=>{
        if (!localIssueId) return $22980a4c6dc120ec$var$EMPTY_CONNECTIONS;
        const result = $22980a4c6dc120ec$var$filterArchivedConnectionFieldIssueIds(connectionProperties[connectionFieldKey]?.[localIssueId], issuesWithBasicPropertiesMap, connectedIssuesWithBasicPropertiesMap, connectionIssueIds, jiraIdToLocalIssueId);
        const sortedResult = [
            ...result
        ].sort(({ id: id1 }, { id: id2 })=>Number(id1) - Number(id2));
        return sortedResult;
    });
const $22980a4c6dc120ec$var$EMPTY_CONNECTIONS_MAP = new Map();
const $22980a4c6dc120ec$export$ce7b3cdc56e8f353 = (issues, connectionFieldKeys)=>{
    let lastResult;
    return (0, $ahm5r.createSelector)((0, $iehDF.getAllFieldsByKey), (0, $iehDF.getFields), (0, $iWbQb.getJiraIdToLocalIssueId), ({ containerProps: containerProps })=>containerProps?.issuesRemote, (state, props)=>({
            state: state,
            props: props
        }), (fieldsByKey, fields, jiraIdToLocalIssueId, issueRemote, { state: state, props: props })=>{
        if (!issueRemote) return $22980a4c6dc120ec$var$EMPTY_CONNECTIONS_MAP;
        const connectionsMap = new Map();
        issues.forEach(({ id: id, localIssueId: localIssueId, group: group, column: column })=>{
            if (!connectionsMap.has(id)) connectionsMap.set(id, []);
            const issueConnectionFields = connectionsMap.get(id);
            connectionFieldKeys.forEach((fieldKey)=>{
                const field = fieldsByKey[fieldKey];
                if (!field) return;
                if ((0, $7jTnu.fg)('jpd-hide-connection-field-of-same-type-on-card')) {
                    const isMatchingFieldFilter = $22980a4c6dc120ec$export$1140f0368dfa5bcb(localIssueId, fieldKey)(state, props);
                    if (isMatchingFieldFilter) return;
                }
                const filteredConnections = $22980a4c6dc120ec$export$d68a9cb0dc20e951(field.key, localIssueId, {
                    column: column,
                    group: group
                })(state, props);
                const highlightedField = field.configuration?.issueViewLayout?.fields[0];
                const highlightedFieldMapping = highlightedField ? (0, $T9VAH.fieldMapping)(issueRemote, fields, fieldsByKey[highlightedField]) : undefined;
                const connections = filteredConnections.map((connection)=>{
                    const connectionLocalIssueId = jiraIdToLocalIssueId[parseInt(connection.id, 10)];
                    return {
                        summary: (0, $4TCfW.createGetSummary)(connectionLocalIssueId)(state, props),
                        highlightedFieldValue: highlightedFieldMapping?.valueAccessor(state, props, connectionLocalIssueId)
                    };
                });
                if (!connections.length) return;
                issueConnectionFields?.push({
                    field: field,
                    key: field.key,
                    value: {
                        highlightedField: highlightedField ? fieldsByKey[highlightedField] : undefined,
                        connections: connections
                    }
                });
            });
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(lastResult, connectionsMap)) return lastResult;
        lastResult = connectionsMap;
        return connectionsMap;
    });
};
const $22980a4c6dc120ec$export$866caf415fc0e834 = (fieldKey)=>(0, $ahm5r.createSelector)($22980a4c6dc120ec$var$createGetSelectedIssueConnectionFieldIssueIds(fieldKey), (ids)=>ids.length);
const $22980a4c6dc120ec$export$5640cd7dd0bca881 = (0, $ahm5r.createSelector)((0, $4TCfW.getSelectedIssueLocalIssueId), (0, $iehDF.getFields), (state, props)=>({
        state: state,
        props: props
    }), (localIssueId, fields, { state: state, props: props })=>{
    const issueType = (0, $4TCfW.createGetIssueType)(localIssueId)(state, props);
    return fields.reduce((res, field)=>{
        const isFieldAssociatedToIssue = issueType?.id && (field.issueTypes?.includes(issueType.id) || !!props?.connectionsFieldsAssociations?.[field.key]?.includes(issueType.id));
        if (issueType && field.type === (0, $eTBmS.FIELD_TYPES).CONNECTION && field.configuration?.issueTypeFilters && field.configuration.issueTypeFilters.length > 0 && !(0, $dmtjA.isMatchingConnectionFieldFilter)({
            filters: field.configuration.issueTypeFilters,
            issueTypeId: issueType?.id,
            issueTypeName: issueType?.name
        }) && isFieldAssociatedToIssue) res.push(field);
        return res;
    }, []);
});
const $22980a4c6dc120ec$export$6ccca9c73456f8c4 = (0, $ahm5r.createSelector)($22980a4c6dc120ec$export$5640cd7dd0bca881, (fields)=>fields.length);
const $22980a4c6dc120ec$export$ff632f7cc6196d5b = (visibleConnectionFieldKeys)=>(0, $ahm5r.createSelector)((0, $4TCfW.getSelectedIssueLocalIssueId), (0, $4TCfW.getConnectionProperties), (0, $iWbQb.getIssuesWithBasicPropertiesMap), (0, $iWbQb.getConnectedIssuesWithBasicPropertiesMap), (0, $iWbQb.getConnectionIssueIds), (0, $iWbQb.getJiraIdToLocalIssueId), $22980a4c6dc120ec$export$5640cd7dd0bca881, (localIssueId, connectionProperties, issuesWithBasicPropertiesMap, connectedIssuesWithBasicPropertiesMap, connectionIssueIds, jiraIdToLocalIssueId, fields)=>{
        if (!localIssueId) return 0;
        return fields.filter(({ type: type, key: key })=>visibleConnectionFieldKeys.includes(key) && type === (0, $eTBmS.FIELD_TYPES).CONNECTION).reduce((acc, field)=>{
            const connections = connectionProperties[field.key]?.[localIssueId];
            if (!connections) return acc;
            const filteredConnections = $22980a4c6dc120ec$var$filterArchivedConnectionFieldIssueIds(connections, issuesWithBasicPropertiesMap, connectedIssuesWithBasicPropertiesMap, connectionIssueIds, jiraIdToLocalIssueId);
            return (0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))([
                ...acc,
                ...filteredConnections
            ], 'id');
        }, []).length;
    });
const $22980a4c6dc120ec$var$getConnectionFields = (_state, props)=>props.fields?.filter(({ type: type })=>type === (0, $eTBmS.FIELD_TYPES).CONNECTION);
const $22980a4c6dc120ec$var$isConnectionFieldThatNeedsDeliveryData = ({ connectionField: connectionField, allFieldsByKey: allFieldsByKey })=>{
    const highlightedFieldKey = connectionField.configuration?.issueViewLayout?.fields?.[0];
    if (!highlightedFieldKey) return false;
    const highlightedField = allFieldsByKey[highlightedFieldKey];
    return highlightedField?.type === (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS || highlightedField?.type === (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS || highlightedField?.type === (0, $eTBmS.FIELD_TYPES).INTERVAL && highlightedField?.configuration?.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).DELIVERY_DATE;
};
const $22980a4c6dc120ec$export$2a41b55765d95cf4 = (fieldKey)=>(0, $ahm5r.createSelector)((0, $iehDF.getAllFieldsByKey), (allFieldsByKey)=>{
        if (!fieldKey) return false;
        const connectionField = allFieldsByKey[fieldKey];
        if (!connectionField || connectionField.type !== (0, $eTBmS.FIELD_TYPES).CONNECTION) return false;
        return $22980a4c6dc120ec$var$isConnectionFieldThatNeedsDeliveryData({
            connectionField: connectionField,
            allFieldsByKey: allFieldsByKey
        });
    });
const $22980a4c6dc120ec$export$ed5b9164f6908892 = (0, $ahm5r.createSelector)($22980a4c6dc120ec$var$getConnectionFields, (0, $iehDF.getAllFieldsByKey), (connectionFields, allFieldsByKey)=>{
    return connectionFields?.filter((connectionField)=>$22980a4c6dc120ec$var$isConnectionFieldThatNeedsDeliveryData({
            connectionField: connectionField,
            allFieldsByKey: allFieldsByKey
        })) ?? [];
});
const $22980a4c6dc120ec$export$5262aef2423258d = (fieldKey)=>(0, $ahm5r.createSelector)((0, $iehDF.getFieldMappings), (state)=>state, (_, props)=>props, (mappings, state, props)=>fieldKey ? mappings[fieldKey].getAllValues(state, props) : undefined);
const $22980a4c6dc120ec$export$5e07bb3bfcb1439f = (fieldKey, id)=>(0, $ahm5r.createSelector)((0, $iehDF.getFieldMappings), (state)=>state, (_, props)=>props, (mappings, state, props)=>fieldKey ? mappings[fieldKey].valueAccessor(state, props, id) : undefined);

});
parcelRegister("22aul", function(module, exports) {

module.exports = (parcelRequire("5RKoQ"));

});

parcelRegister("dmtjA", function(module, exports) {

$parcel$export(module.exports, "isMatchingConnectionFieldFilter", () => $8fdbed594882ece2$export$bf910e112b58c423);

var $evg82 = parcelRequire("evg82");
const $8fdbed594882ece2$export$bf910e112b58c423 = ({ filters: filters, issueTypeId: issueTypeId, issueTypeName: issueTypeName, projectId: projectId })=>{
    if (!issueTypeId) return false;
    return filters.some((filter)=>{
        if ((0, $evg82.isIssueTypeNameFilter)(filter) && issueTypeName) return filter.names.includes(issueTypeName) && (!projectId || filter.projectIds.includes(projectId));
        // In case of unsupported filter type
        return false;
    });
};

});

parcelRegister("1nkQQ", function(module, exports) {

$parcel$export(module.exports, "createGetFilterTypeForField", () => $3260cbc268ed9094$export$661712aed1311a4);

var $ahm5r = parcelRequire("ahm5r");

var $eTBmS = parcelRequire("eTBmS");

var $iehDF = parcelRequire("iehDF");
const $3260cbc268ed9094$export$661712aed1311a4 = (fieldKey)=>(0, $ahm5r.createSelector)((0, $iehDF.getAllFieldsByKey), (fieldsByKey)=>{
        const field = fieldsByKey[fieldKey];
        if (field !== undefined) switch(field.type){
            case (0, $eTBmS.FIELD_TYPES).SUMMARY:
                return 'TEXT';
            case (0, $eTBmS.FIELD_TYPES).INTERVAL:
                return 'INTERVAL';
            case (0, $eTBmS.FIELD_TYPES).NUMBER:
            case (0, $eTBmS.FIELD_TYPES).SLIDER:
            case (0, $eTBmS.FIELD_TYPES).RATING:
            case (0, $eTBmS.FIELD_TYPES).FORMULA:
            case (0, $eTBmS.FIELD_TYPES).LINKED_ISSUES:
            case (0, $eTBmS.FIELD_TYPES).CHECKBOX:
            case (0, $eTBmS.FIELD_TYPES).INSIGHTS:
                return 'NUMBER';
            case (0, $eTBmS.FIELD_TYPES).ASSIGNEE:
            case (0, $eTBmS.FIELD_TYPES).CREATOR:
            case (0, $eTBmS.FIELD_TYPES).REPORTER:
            case (0, $eTBmS.FIELD_TYPES).PEOPLE:
            case (0, $eTBmS.FIELD_TYPES).JSW_PEOPLE:
            case (0, $eTBmS.FIELD_TYPES).SINGLE_SELECT:
            case (0, $eTBmS.FIELD_TYPES).MULTI_SELECT:
            case (0, $eTBmS.FIELD_TYPES).JSW_MULTI_SELECT:
            case (0, $eTBmS.FIELD_TYPES).LABELS:
            case (0, $eTBmS.FIELD_TYPES).CUSTOM_LABELS:
            case (0, $eTBmS.FIELD_TYPES).STATUS:
            case (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL:
            case (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT:
            case (0, $eTBmS.FIELD_TYPES).REACTIONS:
            case (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE:
            case (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS:
            case (0, $eTBmS.FIELD_TYPES).CONNECTION:
            case (0, $eTBmS.FIELD_TYPES).TEAM:
                return 'FIELD';
            default:
                return undefined;
        }
        return undefined;
    });

});



parcelRegister("BrRcR", function(module, exports) {

$parcel$export(module.exports, "createIdeaComparatorForFieldComparator", () => $dbc7a7375c86618d$export$9bf70e9dc752444);
$parcel$export(module.exports, "createCombinedComparator", () => $dbc7a7375c86618d$export$cb40b705a6de4166);
$parcel$export(module.exports, "getSortedIssueIds", () => $dbc7a7375c86618d$export$99b0f5e503ff4821);
$parcel$export(module.exports, "getSortedIssueIndex", () => $dbc7a7375c86618d$export$2578a99bcf5ec6ca);
$parcel$export(module.exports, "getSortedUnfilteredIssueIds", () => $dbc7a7375c86618d$export$1dc2c1dfd43d21ad);
$parcel$export(module.exports, "getSortedUnfilteredIssueKeys", () => $dbc7a7375c86618d$export$1b053bd4faeab9fb);
$parcel$export(module.exports, "getIsSorted", () => $dbc7a7375c86618d$export$b396bd9c8a178c9c);
$parcel$export(module.exports, "getHiddenByFilter", () => $dbc7a7375c86618d$export$f483caee4cbe9474);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");

var $8sbs2 = parcelRequire("8sbs2");


var $3degy = parcelRequire("3degy");

var $dNpTr = parcelRequire("dNpTr");


var $T9VAH = parcelRequire("T9VAH");

var $iehDF = parcelRequire("iehDF");

var $j9i1D = parcelRequire("j9i1D");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $2Vdqq = parcelRequire("2Vdqq");
const $dbc7a7375c86618d$var$EMPTY_SORT = [];
const $dbc7a7375c86618d$var$rankComparator = (idsWithOrder)=>(a, b)=>idsWithOrder[a] - idsWithOrder[b];
const $dbc7a7375c86618d$export$912bb685303c4ec7 = (keys)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const indexMap = {};
    keys.forEach((key, i)=>{
        if (key === undefined) return;
        // String needed for flow
        indexMap[String(key)] = i;
    });
    return indexMap;
};
const $dbc7a7375c86618d$export$b7f949634924df57 = (idsInOrder, mapping)=>{
    const jiraIdsToIndex = $dbc7a7375c86618d$export$912bb685303c4ec7(idsInOrder);
    return (a, b)=>{
        const issueIdA = mapping[a];
        const issueIdB = mapping[b];
        if (issueIdA === issueIdB) return 0;
        if (issueIdA === undefined) return 1;
        if (issueIdB === undefined) return -1;
        const indexA = jiraIdsToIndex[issueIdA];
        const indexB = jiraIdsToIndex[issueIdB];
        if (indexA === indexB) return 0;
        if (indexA === undefined) return 1;
        if (indexB === undefined) return -1;
        return indexA - indexB;
    };
};
const $dbc7a7375c86618d$export$9bf70e9dc752444 = (state, props, // eslint-disable-next-line @typescript-eslint/no-explicit-any
accessor, // eslint-disable-next-line @typescript-eslint/no-explicit-any
comparator, comparatorWithMapping, ascending)=>(a, b)=>comparatorWithMapping ? comparatorWithMapping(state, props, accessor(state, props, a), accessor(state, props, b), ascending ? 'ASC' : 'DESC') : comparator(accessor(state, props, a), accessor(state, props, b), ascending ? 'ASC' : 'DESC');
const $dbc7a7375c86618d$export$cb40b705a6de4166 = (comparators)=>(a, b)=>{
        for(let i = 0; i < comparators.length; i += 1){
            const val = comparators[i](a, b);
            if (val !== 0) return val;
        }
        return 0;
    };
const $dbc7a7375c86618d$export$71fbd2775e15628d = (0, $ahm5r.createSelector)((0, $iehDF.getFields), (_state, props)=>props?.sortBy, (fields, sortBy)=>{
    if (!sortBy) return $dbc7a7375c86618d$var$EMPTY_SORT;
    return sortBy.filter((sortField)=>fields.find((field)=>field.key === sortField.fieldKey));
});
const $dbc7a7375c86618d$export$baabb4740933b6e7 = (_state, props)=>{
    if (props?.sortMode !== (0, $f3f1bd644cfe4e35$export$46fe69a6d17f56c4) || props?.sortBy?.length) return props?.sortMode;
};
const $dbc7a7375c86618d$var$getCurrentExternalRank = (state, props)=>state.externalIssueRanking || props?.externalIssueRanking;
const $dbc7a7375c86618d$var$getSortRelevantFieldMappings = (0, $ahm5r.createSelector)($dbc7a7375c86618d$export$71fbd2775e15628d, (0, $iehDF.getAllFieldsByKey), (0, $iehDF.getFields), // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
({ containerProps: containerProps })=>containerProps?.issuesRemote, (sortBy, fieldsByKey, fields, issuesRemote)=>{
    const mappings = [];
    sortBy.forEach((sort)=>{
        mappings.push((0, $T9VAH.fieldMapping)(issuesRemote, fields, fieldsByKey[sort.fieldKey]));
    });
    return mappings;
});
const $dbc7a7375c86618d$var$getSortRelevantProperties = (0, $4TCfW.createSpecificallyMemoizedDataSelector)($dbc7a7375c86618d$var$getSortRelevantFieldMappings);
const $dbc7a7375c86618d$var$getRankedIssueIdsIndexMap = (0, $ahm5r.createSelector)((0, $iWbQb.getRankedIssueIds), (issueIds)=>issueIds.reduce((result, issueId, index)=>Object.assign(result, {
            [issueId]: index
        }), {}));
const $dbc7a7375c86618d$export$db334a9919f68732 = (0, $ahm5r.createSelector)($dbc7a7375c86618d$export$71fbd2775e15628d, $dbc7a7375c86618d$export$baabb4740933b6e7, $dbc7a7375c86618d$var$getCurrentExternalRank, $dbc7a7375c86618d$var$getRankedIssueIdsIndexMap, $dbc7a7375c86618d$var$getSortRelevantProperties, (0, $iehDF.getAllFieldsByKey), (0, $iehDF.getFields), (0, $iWbQb.getLocalIssueIdToJiraId), // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
({ containerProps: containerProps })=>containerProps?.issuesRemote, (sortBy, sortMode, externalRank, rankedIssueIdsIndexMap, // eslint-disable-next-line @typescript-eslint/no-explicit-any
[state, props], fieldsByKey, fields, localIssueIdToJiraId, issuesRemote)=>{
    if (sortMode === (0, $f3f1bd644cfe4e35$export$a95cb1c0dd162f95)) {
        const { valueAccessor: valueAccessor, comparator: comparator, comparatorWithMapping: comparatorWithMapping } = (0, $T9VAH.fieldMapping)(issuesRemote, fields, fieldsByKey.created);
        const comparatorForCreatedField = $dbc7a7375c86618d$export$9bf70e9dc752444(state, props, valueAccessor, comparator, comparatorWithMapping, 'ASC');
        return $dbc7a7375c86618d$export$cb40b705a6de4166([
            $dbc7a7375c86618d$export$b7f949634924df57(externalRank || [], localIssueIdToJiraId),
            comparatorForCreatedField
        ]);
    }
    const configuredComparators = sortBy.reduce((comparators, sort)=>{
        const mapping = (0, $T9VAH.fieldMapping)(issuesRemote, fields, fieldsByKey[sort.fieldKey]);
        const comparator = $dbc7a7375c86618d$export$9bf70e9dc752444(state, props, mapping.valueAccessor, mapping.comparator, mapping.comparatorWithMapping, sort.asc);
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...comparators,
            comparator
        ];
    }, []);
    return $dbc7a7375c86618d$export$cb40b705a6de4166([
        ...configuredComparators,
        $dbc7a7375c86618d$var$rankComparator(rankedIssueIdsIndexMap)
    ]);
});
const $dbc7a7375c86618d$export$5c52df6057f1bd8c = (baseIssueIdListSelector)=>(0, $ahm5r.createSelector)((0, $ahm5r.createSelector)(baseIssueIdListSelector, $dbc7a7375c86618d$export$db334a9919f68732, (baseIssueIdList, comparator)=>{
        baseIssueIdList.sort(comparator);
        return baseIssueIdList.slice(0);
    }), (0, $4TCfW.getCreatedProperties), (sorted, createdProperties)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(createdProperties)) return sorted;
        const createdIssueIds = Object.keys(createdProperties);
        // get relevant recently created ids (either in creation state or it is also included in the base list (and not filtered out)
        const relevantCreatedIssuesIds = createdIssueIds.filter((createdId)=>createdProperties[createdId].status !== (0, $d5435e25fbd81376$export$eaf097cc0aa4ca13) || sorted.includes(createdId));
        // remove created issueIds from baseIssueIdList
        const filtered = sorted.filter((id)=>relevantCreatedIssuesIds.indexOf(id) === -1);
        const relevantCreatedProperties = (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(createdProperties, relevantCreatedIssuesIds);
        // add createdIssueIds according to their rank position
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(createdIssueIds)) return (0, $2Vdqq.addCreatedIssueIdsToSortedIds)(relevantCreatedProperties, filtered);
        return filtered;
    });
const $dbc7a7375c86618d$export$99b0f5e503ff4821 = (0, $dNpTr.wrapWithDeepEqualityCheck)($dbc7a7375c86618d$export$5c52df6057f1bd8c((0, $j9i1D.getFilteredIssueIds)));
const $dbc7a7375c86618d$export$2578a99bcf5ec6ca = (localIssueId)=>(0, $ahm5r.createSelector)($dbc7a7375c86618d$export$99b0f5e503ff4821, (sortedLocalIssueIds)=>sortedLocalIssueIds.indexOf(localIssueId));
const $dbc7a7375c86618d$export$1dc2c1dfd43d21ad = (0, $dNpTr.wrapWithDeepEqualityCheck)($dbc7a7375c86618d$export$5c52df6057f1bd8c((0, $iWbQb.getIssueIdsConsideringArchived)));
const $dbc7a7375c86618d$export$1b053bd4faeab9fb = (0, $ahm5r.createSelector)($dbc7a7375c86618d$export$1dc2c1dfd43d21ad, (0, $iWbQb.getLocalIssueIdToJiraKey), // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
// @ts-expect-error([Part of upgrade 4.9-5.4]) - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<{}>'.
(localIssueIds, idsToKeys)=>localIssueIds.map((id)=>idsToKeys[id]).filter(Boolean));
const $dbc7a7375c86618d$export$b396bd9c8a178c9c = (0, $ahm5r.createSelector)($dbc7a7375c86618d$export$71fbd2775e15628d, (sortBy)=>sortBy.length > 0);
const $dbc7a7375c86618d$export$f483caee4cbe9474 = (0, $3degy.cacheSelectorCreator)((localIssueId, position)=>(0, $ahm5r.createSelector)($dbc7a7375c86618d$export$99b0f5e503ff4821, $dbc7a7375c86618d$export$1dc2c1dfd43d21ad, (sortedIssueIds, sortedUnfilteredIssueIds)=>{
        const filteredIssuesIssueIdx = sortedIssueIds.indexOf(localIssueId);
        const unfilteredIssuesIssueIdx = sortedUnfilteredIssueIds.indexOf(localIssueId);
        if (filteredIssuesIssueIdx === -1 || unfilteredIssuesIssueIdx === -1) return 0;
        if (position === 'before') {
            const prevIssueId = sortedIssueIds[filteredIssuesIssueIdx - 1];
            const unfilteredIssuesPrevIssueIdx = sortedUnfilteredIssueIds.indexOf(prevIssueId);
            if (unfilteredIssuesPrevIssueIdx === -1) return 0;
            return unfilteredIssuesIssueIdx - unfilteredIssuesPrevIssueIdx - 1;
        }
        if (position === 'after') {
            const nextIssueId = sortedIssueIds[filteredIssuesIssueIdx + 1];
            const unfilteredIssuesNextIssueIdx = sortedUnfilteredIssueIds.indexOf(nextIssueId);
            if (unfilteredIssuesNextIssueIdx === -1) return 0;
            return unfilteredIssuesNextIssueIdx - unfilteredIssuesIssueIdx - 1;
        }
        return 0;
    }));

});
parcelRegister("2Vdqq", function(module, exports) {

$parcel$export(module.exports, "addCreatedIssueIdsToSortedIds", () => $1f36706b53ae0197$export$ea305425c8c9cc48);
const $1f36706b53ae0197$export$2ba55c65e05894fe = (newSorted, issueCreatedProperty, id, visitedIds)=>{
    // do nothing if anchor id is undefined
    if (id === undefined) return;
    // if has already been called from the recursion, then exit.
    if (visitedIds.indexOf(id) !== -1) return;
    visitedIds.push(id);
    const createdProperty = issueCreatedProperty[id];
    // if id is not in the part of the createdProperty or is already been in the sorted array, exit.
    if (createdProperty === undefined || newSorted.indexOf(id) !== -1) return;
    // look at the left element
    const { anchorBefore: anchorBefore } = createdProperty;
    if (anchorBefore !== undefined) {
        $1f36706b53ae0197$export$2ba55c65e05894fe(newSorted, issueCreatedProperty, anchorBefore, visitedIds);
        const beforeIndex = newSorted.indexOf(anchorBefore);
        if (beforeIndex !== -1) {
            // already added or not a createdIssueId
            newSorted.splice(beforeIndex + 1, 0, id);
            return; // no need to look at the "right" element
        }
    }
    // look at the right element
    const { anchorAfter: anchorAfter } = createdProperty;
    if (anchorAfter !== undefined) {
        $1f36706b53ae0197$export$2ba55c65e05894fe(newSorted, issueCreatedProperty, anchorAfter, visitedIds);
        const afterIndex = newSorted.indexOf(anchorAfter);
        if (afterIndex !== -1) {
            // already added or not a createdIssueId
            newSorted.splice(afterIndex, 1, id, anchorAfter);
            return;
        }
    }
    // no before or after anchor => add as last
    newSorted.push(id);
};
const $1f36706b53ae0197$export$ea305425c8c9cc48 = (createProperty, sorted)=>{
    const newSorted = [
        ...sorted
    ];
    const createdIssueIds = Object.keys(createProperty);
    createdIssueIds.forEach((id)=>{
        $1f36706b53ae0197$export$2ba55c65e05894fe(newSorted, createProperty, id, []);
    });
    return newSorted;
};

});


parcelRegister("cHovn", function(module, exports) {

$parcel$export(module.exports, "updateIssueConnections", () => $06cafbaef04e22a8$export$8f6b5f750ade448);
$parcel$export(module.exports, "updateConnectionFieldValue", () => $06cafbaef04e22a8$export$b90539bc4cb6453d);
$parcel$export(module.exports, "addConnectionIssuesData", () => $06cafbaef04e22a8$export$283d157f3f31ac33);

var $apIeD = parcelRequire("apIeD");

var $4q8Hz = parcelRequire("4q8Hz");


var $b5oGV = parcelRequire("b5oGV");

var $8KUFq = parcelRequire("8KUFq");

var $dlpDx = parcelRequire("dlpDx");

var $iWbQb = parcelRequire("iWbQb");

var $3DqTy = parcelRequire("3DqTy");

var $dUuWP = parcelRequire("dUuWP");

var $g3PIQ = parcelRequire("g3PIQ");

var $iehDF = parcelRequire("iehDF");

var $1JQrj = parcelRequire("1JQrj");
class $06cafbaef04e22a8$var$UpdateIssueConnectionsError extends Error {
}
const $06cafbaef04e22a8$var$getIssueIds = ({ issueIdArgs: issueIdArgs, localIssueIdToJiraId: localIssueIdToJiraId, jiraIdToLocalIssueId: jiraIdToLocalIssueId })=>{
    if ('localIssueId' in issueIdArgs) return {
        localIssueId: issueIdArgs.localIssueId,
        sourceIssueId: localIssueIdToJiraId[issueIdArgs.localIssueId]
    };
    return {
        localIssueId: jiraIdToLocalIssueId[Number(issueIdArgs.issueId)],
        sourceIssueId: issueIdArgs.issueId
    };
};
const $06cafbaef04e22a8$export$8f6b5f750ade448 = ({ issuesToConnect: issuesToConnect = [], issuesToDisconnect: issuesToDisconnect = [], onError: onError, ...issueIdArgs })=>async ({ setState: setState, getState: getState }, props)=>{
        (0, $b5oGV.experience).connections.issueConnectionFieldValueUpdate.start();
        const state = getState();
        const previousProperties = {
            ...state.properties
        };
        const localIssueIdToJiraId = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
        const jiraIdToLocalIssueId = (0, $iWbQb.getJiraIdToLocalIssueId)(state);
        const { sourceIssueId: sourceIssueId, localIssueId: localIssueId } = $06cafbaef04e22a8$var$getIssueIds({
            issueIdArgs: issueIdArgs,
            jiraIdToLocalIssueId: jiraIdToLocalIssueId,
            localIssueIdToJiraId: localIssueIdToJiraId
        });
        const issuesToConnectFiltered = (0, $1JQrj.getFilteredIssuesForConnections)(localIssueId, issuesToConnect, state, props);
        if (!issuesToConnectFiltered.length && !issuesToDisconnect.length) {
            (0, $b5oGV.experience).connections.issueConnectionFieldValueUpdate.abort();
            return;
        }
        const { issuesRemote: issuesRemote, onIssueUpdateFailed: onIssueUpdateFailed } = props;
        const optimisticProperties = (0, $dUuWP.updateConnectionsProperties)({
            issuesToDisconnect: issuesToDisconnect,
            issuesToConnect: issuesToConnectFiltered,
            localIssueId: localIssueId,
            state: state,
            props: props
        });
        setState({
            properties: optimisticProperties
        });
        let failedAddConnections;
        let failedDeleteConnections;
        let failedAddConnectionsResultError;
        let failedDeleteConnectionsResultError;
        try {
            const addConnectionsPromise = issuesToConnectFiltered.length > 0 ? issuesRemote.createConnections({
                issueFrom: sourceIssueId,
                issueTo: issuesToConnectFiltered.map(({ id: id })=>id)
            }).then(({ failures: failures })=>(0, $1JQrj.getFailedConnections)(failures, issuesToConnectFiltered, 'create')) : Promise.resolve([]);
            const deleteConnectionsPromise = issuesToDisconnect.length > 0 ? issuesRemote.deleteConnections({
                issueFrom: sourceIssueId,
                issueTo: issuesToDisconnect.map(({ id: id })=>id)
            }).then(({ failures: failures })=>(0, $1JQrj.getFailedConnections)(failures, issuesToDisconnect, 'delete')) : Promise.resolve([]);
            const [failedAddConnectionsResult, failedDeleteConnectionsResult] = await Promise.allSettled([
                addConnectionsPromise,
                deleteConnectionsPromise
            ]);
            if (failedAddConnectionsResult.status === 'rejected') {
                failedAddConnectionsResultError = (0, $1JQrj.getRejectedPromiseError)(failedAddConnectionsResult.reason);
                (0, $1JQrj.logUpdateIssueConnectionsError)(failedAddConnectionsResultError, 'create');
                failedAddConnections = issuesToConnectFiltered;
            } else failedAddConnections = failedAddConnectionsResult.value;
            if (failedDeleteConnectionsResult.status === 'rejected') {
                failedDeleteConnectionsResultError = (0, $1JQrj.getRejectedPromiseError)(failedDeleteConnectionsResult.reason);
                (0, $1JQrj.logUpdateIssueConnectionsError)(failedDeleteConnectionsResultError, 'delete');
                failedDeleteConnections = issuesToDisconnect;
            } else failedDeleteConnections = failedDeleteConnectionsResult.value;
            if (failedAddConnections.length || failedDeleteConnections.length) throw new $06cafbaef04e22a8$var$UpdateIssueConnectionsError();
            (0, $b5oGV.experience).connections.issueConnectionFieldValueUpdate.success({
                metadata: {
                    isCreatingConnections: issuesToConnectFiltered.length > 0,
                    isDeletingConnections: issuesToDisconnect.length > 0
                }
            });
        } catch (error) {
            if ((0, $8KUFq.isClientFetchError)(error)) (0, $b5oGV.experience).connections.issueConnectionFieldValueUpdate.abort();
            else (0, $b5oGV.experience).connections.issueConnectionFieldValueUpdate.failure({
                metadata: {
                    isCreatingConnections: issuesToConnectFiltered.length > 0,
                    creatingConnectionsError: failedAddConnectionsResultError?.message,
                    isDeletingConnections: issuesToDisconnect.length > 0,
                    deletingConnectionsError: failedDeleteConnectionsResultError?.message
                }
            });
            if (error instanceof Error) {
                if (error instanceof $06cafbaef04e22a8$var$UpdateIssueConnectionsError) {
                    // revert optimistic update for failed connections
                    const revertedProperties = (0, $dUuWP.updateConnectionsProperties)({
                        issuesToDisconnect: failedAddConnections ?? issuesToConnectFiltered,
                        issuesToConnect: failedDeleteConnections ?? issuesToDisconnect,
                        localIssueId: localIssueId,
                        state: {
                            ...state,
                            properties: optimisticProperties
                        },
                        props: props
                    });
                    setState({
                        properties: revertedProperties
                    });
                } else {
                    // Log error in case of runtime error caused by code in this action or it's dependencies
                    (0, $1JQrj.logUpdateIssueConnectionsError)(error);
                    // and revert all changed properties in case of runtime error
                    setState({
                        properties: previousProperties
                    });
                }
                onIssueUpdateFailed(error);
                onError?.(error);
            }
        }
    };
const $06cafbaef04e22a8$export$745dc714ae10875d = (updatesMap, onFinished)=>async ({ setState: setState, getState: getState }, props)=>{
        if (updatesMap.size === 0) return;
        (0, $b5oGV.experience).connections.issueConnectionFieldsValuesUpdateBulk.start();
        const { issuesRemote: issuesRemote, onIssueUpdateFailed: onIssueUpdateFailed, onIssueBulkUpdate: onIssueBulkUpdate } = props;
        const previousProperties = {
            ...getState().properties
        };
        const optimisticState = {
            ...getState()
        };
        const localIssueIdToJiraId = (0, $iWbQb.getLocalIssueIdToJiraId)(optimisticState, props);
        const addConnections = [];
        const deleteConnections = [];
        updatesMap.forEach(({ issuesToConnect: issuesToConnect, issuesToDisconnect: issuesToDisconnect }, localIssueId)=>{
            const issuesToConnectFiltered = (0, $1JQrj.getFilteredIssuesForConnections)(localIssueId, issuesToConnect, optimisticState, props);
            if (!issuesToConnectFiltered.length && !issuesToDisconnect.length) return;
            optimisticState.properties = (0, $dUuWP.updateConnectionsProperties)({
                issuesToDisconnect: issuesToDisconnect,
                issuesToConnect: issuesToConnectFiltered,
                localIssueId: localIssueId,
                state: optimisticState,
                props: props
            });
            if (issuesToConnectFiltered.length > 0) addConnections.push({
                issueFrom: localIssueIdToJiraId[localIssueId],
                issueTo: issuesToConnectFiltered.map(({ id: id })=>id)
            });
            if (issuesToDisconnect.length > 0) deleteConnections.push({
                issueFrom: localIssueIdToJiraId[localIssueId],
                issueTo: issuesToDisconnect.map(({ id: id })=>id)
            });
        });
        if (addConnections.length === 0 && deleteConnections.length === 0) {
            (0, $b5oGV.experience).connections.issueConnectionFieldsValuesUpdateBulk.abort();
            return;
        }
        setState(optimisticState);
        try {
            const [createConnectionsResponse, deleteConnectionsResponse] = await Promise.all([
                addConnections.length > 0 ? issuesRemote.createConnectionsBulk(addConnections) : undefined,
                deleteConnections.length > 0 ? issuesRemote.deleteConnectionsBulk(deleteConnections) : undefined
            ]);
            onIssueBulkUpdate({
                getUpdateIssueFieldsBulkProgress: (0, $1JQrj.createGetUpdateIssueFieldsBulkProgress)(createConnectionsResponse, deleteConnectionsResponse, props),
                taskId: `${createConnectionsResponse?.taskId ?? ''}-${deleteConnectionsResponse?.taskId ?? ''}`,
                onFinished: onFinished
            });
            (0, $b5oGV.experience).connections.issueConnectionFieldsValuesUpdateBulk.success({
                metadata: {
                    isCreatingConnections: addConnections.length > 0,
                    isDeletingConnections: deleteConnections.length > 0
                }
            });
        } catch (error) {
            if ((0, $8KUFq.isClientFetchError)(error)) (0, $b5oGV.experience).connections.issueConnectionFieldsValuesUpdateBulk.abort();
            else (0, $b5oGV.experience).connections.issueConnectionFieldsValuesUpdateBulk.failure({
                metadata: {
                    isCreatingConnections: addConnections.length > 0,
                    isDeletingConnections: deleteConnections.length > 0
                }
            });
            setState({
                properties: previousProperties
            });
            if (error instanceof Error) {
                (0, $1JQrj.logUpdateIssueConnectionsError)(error, undefined, true);
                onIssueUpdateFailed(error);
            }
        }
    };
const $06cafbaef04e22a8$export$b90539bc4cb6453d = ({ fieldKey: fieldKey, localIssueIds: localIssueIds, newValue: newValueUnknown, removeValue: removeValueUnknown, appendMultiValues: appendMultiValues, onError: onError, onConnectionsUpdated: onConnectionsUpdated })=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        if (localIssueIds.length === 0) return;
        const state = getState();
        const newValue = Array.isArray(newValueUnknown) ? newValueUnknown.filter((0, $3DqTy.isConnectionFieldValue)) : [];
        const removeValue = Array.isArray(removeValueUnknown) ? removeValueUnknown.filter((0, $3DqTy.isConnectionFieldValue)) : [];
        const updateIssueConnectionsBulkRequest = localIssueIds.reduce((acc, localIssueId)=>{
            const currentConnections = (0, $dlpDx.createGetConnectionFieldIssueIds)(fieldKey, localIssueId)(state, props);
            const issuesToConnect = (0, (/*@__PURE__*/$parcel$interopDefault($apIeD)))(newValue, currentConnections, 'id');
            const issuesToDisconnect = appendMultiValues ? (0, (/*@__PURE__*/$parcel$interopDefault($4q8Hz)))(removeValue, currentConnections, 'id') : (0, (/*@__PURE__*/$parcel$interopDefault($apIeD)))(currentConnections, newValue, 'id');
            acc.set(localIssueId, {
                issuesToConnect: issuesToConnect,
                issuesToDisconnect: issuesToDisconnect
            });
            return acc;
        }, new Map());
        if (localIssueIds.length === 1) {
            const localIssueId = localIssueIds[0];
            await dispatch($06cafbaef04e22a8$export$8f6b5f750ade448({
                localIssueId: localIssueId,
                issuesToConnect: updateIssueConnectionsBulkRequest.get(localIssueId)?.issuesToConnect,
                issuesToDisconnect: updateIssueConnectionsBulkRequest.get(localIssueId)?.issuesToDisconnect,
                onError: onError
            }));
            onConnectionsUpdated?.();
        } else await dispatch($06cafbaef04e22a8$export$745dc714ae10875d(updateIssueConnectionsBulkRequest, onConnectionsUpdated));
    };
const $06cafbaef04e22a8$export$283d157f3f31ac33 = (issuesData)=>async ({ getState: getState, setState: setState }, props)=>{
        if (issuesData.length === 0) return;
        const jiraIdToLocalIssueId = (0, $iWbQb.getJiraIdToLocalIssueId)(getState());
        const fieldMappings = (0, $iehDF.getFieldMappings)(getState(), props);
        const keyMapping = fieldMappings[0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b];
        const summaryMapping = fieldMappings[0, $9a5f06039e1dff5a$export$469f8bf472cb9ca];
        const issueTypeMapping = fieldMappings[0, $9a5f06039e1dff5a$export$dd03acb09519222];
        const issueIdMapping = fieldMappings[0, $9a5f06039e1dff5a$export$48927a8f78b0130e];
        const projectMapping = fieldMappings[0, $9a5f06039e1dff5a$export$1fd24e9c03ef9b18];
        const newConnectionIds = [];
        const properties = {
            ...getState().properties
        };
        const updatedProperties = issuesData.reduce((acc, externalIssue)=>{
            if (jiraIdToLocalIssueId[Number(externalIssue.issueId)]) return acc;
            const externalIssueLocalId = (0, $g3PIQ.generateLocalIssueId)();
            newConnectionIds.push(externalIssueLocalId);
            let modifiedProperties = acc;
            modifiedProperties = (0, $1JQrj.updateFieldProperties)(modifiedProperties, keyMapping, externalIssueLocalId, externalIssue.issueKey);
            modifiedProperties = (0, $1JQrj.updateFieldProperties)(modifiedProperties, summaryMapping, externalIssueLocalId, externalIssue.summary);
            modifiedProperties = (0, $1JQrj.updateFieldProperties)(modifiedProperties, issueTypeMapping, externalIssueLocalId, externalIssue.issueType);
            modifiedProperties = (0, $1JQrj.updateFieldProperties)(modifiedProperties, issueIdMapping, externalIssueLocalId, externalIssue.issueId);
            modifiedProperties = (0, $1JQrj.updateFieldProperties)(modifiedProperties, projectMapping, externalIssueLocalId, externalIssue.project);
            return modifiedProperties;
        }, properties);
        setState({
            properties: updatedProperties,
            ...newConnectionIds.length > 0 && {
                connectionIssueIds: [
                    ...getState().connectionIssueIds,
                    ...newConnectionIds
                ]
            }
        });
    };

});
parcelRegister("4q8Hz", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $lk1pL = parcelRequire("lk1pL");

var $1lM9j = parcelRequire("1lM9j");

var $l76qh = parcelRequire("l76qh");

var $9gcs2 = parcelRequire("9gcs2");

var $1ilzu = parcelRequire("1ilzu");
/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */ var $33805722d8bf59dd$var$intersectionBy = $l76qh(function(arrays) {
    var iteratee = $1ilzu(arrays), mapped = $lylkU(arrays, $9gcs2);
    if (iteratee === $1ilzu(mapped)) iteratee = undefined;
    else mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $lk1pL(mapped, $1lM9j(iteratee, 2)) : [];
});
module.exports = $33805722d8bf59dd$var$intersectionBy;

});

parcelRegister("dUuWP", function(module, exports) {

$parcel$export(module.exports, "updateConnectionsProperties", () => $e1d2a4d584e09b36$export$f217229b0b85493b);

var $5spib = parcelRequire("5spib");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $iehDF = parcelRequire("iehDF");

var $dmtjA = parcelRequire("dmtjA");
const $e1d2a4d584e09b36$export$f217229b0b85493b = ({ issuesToConnect: issuesToConnect = [], issuesToDisconnect: issuesToDisconnect = [], localIssueId: localIssueId, state: state, props: props })=>{
    const localIssueIdToJiraId = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
    const localIssueIdsByJiraIssueId = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
    const connectionProperties = (0, $4TCfW.getConnectionProperties)(state);
    let newProperties = {
        ...state.properties
    }; // don't need to create copy
    const update = (issueFromLocalId, issueToJiraId, fieldKey, action)=>{
        const mapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(state, props);
        if (!mapping) return;
        const destinationIssueType = (0, $4TCfW.createGetIssueType)(localIssueIdsByJiraIssueId[issueToJiraId])(state, props);
        const connectionFieldFilters = mapping.field?.configuration?.issueTypeFilters || [];
        const projectId = (0, $4TCfW.createGetProjectIdSelector)(localIssueIdsByJiraIssueId[issueToJiraId])(state);
        const sourceIssueType = (0, $4TCfW.createGetIssueType)(issueFromLocalId)(state, props);
        const areMatchingIssueTypes = sourceIssueType?.id === destinationIssueType?.id || sourceIssueType?.name === destinationIssueType?.name;
        if (!(0, $dmtjA.isMatchingConnectionFieldFilter)({
            filters: connectionFieldFilters,
            issueTypeId: destinationIssueType?.id,
            issueTypeName: destinationIssueType?.name,
            projectId: projectId
        }) || !sourceIssueType || !destinationIssueType || areMatchingIssueTypes) return;
        newProperties = mapping.modifyImmutableIfMultiValueField(newProperties, issueFromLocalId, action === 'link' ? [
            {
                id: issueToJiraId
            }
        ] : [], action === 'unlink' ? [
            {
                id: issueToJiraId
            }
        ] : []);
    };
    const iterate = (id, key, action)=>{
        const localIssueId2 = (0, $iWbQb.getLocalIssueIdForJiraIssueId)(id)(state, props);
        update(localIssueId, id, key, action);
        if (localIssueId2) update(localIssueId2, localIssueIdToJiraId[localIssueId], key, action);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(connectionProperties, (_, key)=>{
        issuesToConnect.forEach(({ id: id })=>iterate(id, key, 'link'));
        issuesToDisconnect.forEach(({ id: id })=>iterate(id, key, 'unlink'));
    });
    return newProperties;
};

});

parcelRegister("g3PIQ", function(module, exports) {

$parcel$export(module.exports, "generateLocalIssueId", () => $b4843658e7b392f2$export$ad62ab8233bebc53);
$parcel$export(module.exports, "generateLocalExternalIssueId", () => $b4843658e7b392f2$export$525ce2268695c3bd);

var $aXKmr = parcelRequire("aXKmr");
const $b4843658e7b392f2$export$ad62ab8233bebc53 = ()=>(0, $aXKmr.v4)();
const $b4843658e7b392f2$export$525ce2268695c3bd = ()=>(0, $aXKmr.v4)();

});

parcelRegister("1JQrj", function(module, exports) {

$parcel$export(module.exports, "logUpdateIssueConnectionsError", () => $8fb9856da685b6cc$export$9aa914cc4e8374b4);
$parcel$export(module.exports, "getFailedConnections", () => $8fb9856da685b6cc$export$4d9e28618ca7c49e);
$parcel$export(module.exports, "createGetUpdateIssueFieldsBulkProgress", () => $8fb9856da685b6cc$export$bb709c0b5cc7ef9);
$parcel$export(module.exports, "getFilteredIssuesForConnections", () => $8fb9856da685b6cc$export$af0376a22a6ec5b0);
$parcel$export(module.exports, "updateFieldProperties", () => $8fb9856da685b6cc$export$54e1c6f21d4ceb26);
$parcel$export(module.exports, "getRejectedPromiseError", () => $8fb9856da685b6cc$export$375dbe4235aae063);


var $6Yd06 = parcelRequire("6Yd06");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");
const $8fb9856da685b6cc$var$NULL_LINK_ERROR = 'Link cannot be null';
const $8fb9856da685b6cc$export$9aa914cc4e8374b4 = (error, operation, isBulk = false)=>{
    const operationString = operation ? `.${operation}` : '';
    (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)(isBulk ? `polaris.issue.action.updateIssueConnectionsBulk${operationString}` : `polaris.issue.action.updateIssueConnections${operationString}`, 'Failed to update issue connections', error);
};
const $8fb9856da685b6cc$export$4d9e28618ca7c49e = (failures, issues, operation)=>{
    return failures.map(({ issueTo: issueTo, error: error })=>{
        // we don't support realtime events yet,
        // so we need to filter out the null link error for delete operation in case a connection was already deleted
        if (operation === 'delete' && error === $8fb9856da685b6cc$var$NULL_LINK_ERROR) return null;
        $8fb9856da685b6cc$export$9aa914cc4e8374b4(new Error(error), operation);
        return issues.find(({ id: id })=>id === issueTo.toString());
    }).filter(Boolean);
};
const $8fb9856da685b6cc$var$runningStatusResponse = {
    progress: 0,
    status: 'RUNNING',
    failures: []
};
const $8fb9856da685b6cc$var$completeStatusResponse = {
    progress: 100,
    status: 'COMPLETE',
    failures: []
};
const $8fb9856da685b6cc$export$bb709c0b5cc7ef9 = (createConnectionsResponse, deleteConnectionsResponse, props)=>{
    const { issuesRemote: issuesRemote } = props;
    let createConnectionsStatus = createConnectionsResponse ? $8fb9856da685b6cc$var$runningStatusResponse : $8fb9856da685b6cc$var$completeStatusResponse;
    let deleteConnectionsStatus = deleteConnectionsResponse ? $8fb9856da685b6cc$var$runningStatusResponse : $8fb9856da685b6cc$var$completeStatusResponse;
    return async ()=>{
        [createConnectionsStatus, deleteConnectionsStatus] = await Promise.all([
            createConnectionsStatus.progress !== 100 && createConnectionsResponse ? issuesRemote.getConnectionBulkStatus(createConnectionsResponse.taskId) : createConnectionsStatus,
            deleteConnectionsStatus.progress !== 100 && deleteConnectionsResponse ? issuesRemote.getConnectionBulkStatus(deleteConnectionsResponse.taskId) : deleteConnectionsStatus
        ]);
        const commonProgress = (createConnectionsStatus.progress + deleteConnectionsStatus.progress) / 2;
        const commonStatus = createConnectionsStatus.status === 'COMPLETE' && deleteConnectionsStatus.status === 'COMPLETE' ? 'COMPLETE' : 'RUNNING';
        if (commonStatus === 'COMPLETE') {
            const failures = [
                ...createConnectionsStatus.failures.map(({ issueToFailures: issueToFailures })=>issueToFailures).flat().map((failure)=>({
                        ...failure,
                        operation: 'create'
                    })),
                ...deleteConnectionsStatus.failures.map(({ issueToFailures: issueToFailures })=>issueToFailures).flat().map((failure)=>({
                        ...failure,
                        operation: 'delete'
                    }))
            ];
            failures.forEach(({ error: error, operation: operation })=>{
                $8fb9856da685b6cc$export$9aa914cc4e8374b4(new Error(error), operation, true);
            });
        }
        return {
            progress: commonProgress,
            status: commonStatus
        };
    };
};
const $8fb9856da685b6cc$export$af0376a22a6ec5b0 = (localIssueId, issues, state, props)=>{
    const localIssueIdToJiraId = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
    const jiraIdToLocalIssueId = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
    const issueTypeProperties = (0, $4TCfW.getIssueTypeProperties)(state)[0, $9a5f06039e1dff5a$export$dd03acb09519222];
    return issues.filter(({ id: id })=>// Don't connect issue to itself
        id !== localIssueIdToJiraId[localIssueId] && // Don't connect issue to the same issue type
        issueTypeProperties?.[localIssueId]?.id !== issueTypeProperties?.[jiraIdToLocalIssueId[Number(id)]]?.id);
};
const $8fb9856da685b6cc$export$54e1c6f21d4ceb26 = (properties, mapping, localIssueId, value)=>{
    const modifiedProperties = mapping?.setImmutable(properties, localIssueId, value);
    return modifiedProperties ?? properties;
};
const $8fb9856da685b6cc$export$375dbe4235aae063 = (rejectedPromiseReason)=>{
    if (rejectedPromiseReason instanceof Error) return rejectedPromiseReason;
    if (typeof rejectedPromiseReason === 'string') return new Error(rejectedPromiseReason);
    if (typeof rejectedPromiseReason === 'object') return new Error(JSON.stringify(rejectedPromiseReason));
    if (rejectedPromiseReason === undefined) return new Error('Unknown error');
    return new Error(rejectedPromiseReason.toString());
};

});


parcelRegister("dVE1x", function(module, exports) {

$parcel$export(module.exports, "incrementOpenUpdateCounter", () => $f3f19bbf81fab662$export$3ef527d40762cfd0);
$parcel$export(module.exports, "decrementOpenUpdateCounter", () => $f3f19bbf81fab662$export$a36260956a3e149);
const $f3f19bbf81fab662$export$3ef527d40762cfd0 = (ids)=>({ getState: getState, setState: setState })=>{
        const { openUpdateCounter: openUpdateCounter } = getState();
        ids.forEach((id)=>{
            openUpdateCounter[id] = (openUpdateCounter[id] || 0) + 1;
        });
        setState({
            openUpdateCounter: openUpdateCounter
        });
    };
const $f3f19bbf81fab662$export$a36260956a3e149 = (id)=>({ getState: getState, setState: setState })=>{
        setState({
            openUpdateCounter: {
                ...getState().openUpdateCounter,
                [id]: (getState().openUpdateCounter[id] || 1) - 1
            }
        });
    };

});

parcelRegister("3TA1a", function(module, exports) {

$parcel$export(module.exports, "updateStatusInStateOnly", () => $2809f050b039bddc$export$7dc74072a5ae8c9d);
$parcel$export(module.exports, "updateStatus", () => $2809f050b039bddc$export$dd127eb7207846ef);
$parcel$export(module.exports, "updateStatusInStateOnlyWithBulk", () => $2809f050b039bddc$export$6c06c3b758c6e267);

var $1I887 = parcelRequire("1I887");

var $k2MWf = parcelRequire("k2MWf");

var $7jTnu = parcelRequire("7jTnu");

var $j6dzD = parcelRequire("j6dzD");

var $j9i1D = parcelRequire("j9i1D");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $BrRcR = parcelRequire("BrRcR");

var $hw9ct = parcelRequire("hw9ct");


var $dVE1x = parcelRequire("dVE1x");

var $jZDOT = parcelRequire("jZDOT");
const $2809f050b039bddc$var$mutateStatusState = ({ getState: getState, setState: setState }, fieldKey, localIssueId, status)=>{
    const updateAction = (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined;
    const newState = {
        ...getState(),
        lastUpdatedIssueIds: [
            localIssueId
        ],
        lastUpdatedAction: updateAction,
        properties: {
            ...getState().properties,
            status: {
                ...getState().properties.status,
                [fieldKey]: {
                    ...getState().properties.status[fieldKey],
                    [localIssueId]: status
                }
            }
        }
    };
    setState(newState);
    return newState;
};
const $2809f050b039bddc$var$isTransitionForStatusAllowed = (id, newStatus, state, props)=>{
    const issueType = (0, $4TCfW.createGetIssueType)(id)(state, props);
    const oldStatus = (0, $4TCfW.createGetStatus)(id)(state, props);
    if (issueType === undefined || oldStatus === undefined) return false;
    const getTransitionForStatus = (0, $j6dzD.createGetTransitionForStatus)(issueType.id, oldStatus, // @ts-expect-error - TS2345 - Argument of type 'Status' is not assignable to parameter of type 'IssueStatusProperty'.
    newStatus);
    const transition = getTransitionForStatus({
        transitions: props.workflowTransitions
    });
    return oldStatus.id === newStatus.id || !!transition;
};
const $2809f050b039bddc$export$7dc74072a5ae8c9d = (fieldKey, localIssueId, status)=>(storeActionApi)=>$2809f050b039bddc$var$mutateStatusState(storeActionApi, fieldKey, localIssueId, status);
const $2809f050b039bddc$var$setIsIssueStatusRollbackInProgress = (inProgress)=>(storeActionApi)=>{
        const state = storeActionApi.getState();
        storeActionApi.setState({
            ...state,
            meta: {
                ...state.meta,
                isIssueStatusRollbackInProgress: inProgress
            }
        });
    };
const $2809f050b039bddc$export$dd127eb7207846ef = (fieldKey, localIssueId, transition, // eslint-disable-next-line @typescript-eslint/no-explicit-any
onSuccess, onError)=>(storeActionApi, props)=>{
        const state = {
            ...storeActionApi.getState()
        };
        const issueKey = (0, $4TCfW.createGetKeySelector)(localIssueId)(state);
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        const oldStatus = (0, $4TCfW.createGetStatus)(localIssueId)(state, props);
        const newState = $2809f050b039bddc$var$mutateStatusState(storeActionApi, fieldKey, localIssueId, transition.to);
        storeActionApi.dispatch((0, $dVE1x.incrementOpenUpdateCounter)([
            localIssueId
        ]));
        props.issuesRemote.transitionIssue({
            issueKey: issueKey,
            transition: transition
        }).then(()=>{
            onSuccess?.();
            (0, $1I887.fireAnalyticsEventForIssueUpdate)(props.createAnalyticsEvent({}), localIdMap[localIssueId], {
                updatedItems: [
                    {
                        name: fieldKey
                    }
                ],
                ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(localIssueId)(storeActionApi.getState())
            });
        }).catch((e)=>{
            // rollback the status
            if (!oldStatus?.id || oldStatus?.id === transition.to.id) {
                const jiraIssueId = Object.entries(localIdMap).find(([, value])=>value === localIssueId)?.[0];
                if (jiraIssueId) {
                    storeActionApi.dispatch($2809f050b039bddc$var$setIsIssueStatusRollbackInProgress(true));
                    // the issue status was already optimistically updated in the state, we need to reload the failed issue to get its actual (old) status
                    storeActionApi.dispatch((0, $jZDOT.refreshIssues)({
                        jiraIssueIds: [
                            jiraIssueId
                        ],
                        callback: ()=>{
                            storeActionApi.dispatch($2809f050b039bddc$var$setIsIssueStatusRollbackInProgress(false));
                        }
                    }));
                }
            } else $2809f050b039bddc$var$mutateStatusState(storeActionApi, fieldKey, localIssueId, oldStatus);
            props.onIssueStatusUpdateFailed?.(e);
            onError?.(e);
        });
        const filteredIdsAfterStateChange = (0, $j9i1D.getFilteredIssueIds)(newState, props);
        return {
            filtered: !filteredIdsAfterStateChange.includes(localIssueId)
        };
    };
const $2809f050b039bddc$export$6c06c3b758c6e267 = ({ localIssueId: localIssueId, fieldKey: fieldKey, oldStatus: oldStatus, newStatus: newStatus, updateField: updateField, onNotAllowedTransitions: onNotAllowedTransitions })=>({ getState: getState, dispatch: dispatch }, props)=>{
        const state = getState();
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        const selectedIssueIds = (0, $hw9ct.getCurrentViewSelectedIssueIds)(state);
        const sortedIssueIds = (0, $BrRcR.getSortedIssueIds)(state, props);
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        const visibleSelectedIssueIds = sortedIssueIds.filter((id)=>selectedIssueIds.includes(id));
        // the status value type we get from the field is incomplete even though it contains
        // all the field that we need. that is why we have to resort to a type check
        // failure ignore annotations
        // @ts-expect-error - TS2345 - Argument of type 'Status' is not assignable to parameter of type 'IssueStatusProperty'.
        dispatch($2809f050b039bddc$export$7dc74072a5ae8c9d(fieldKey, localIssueId, newStatus));
        // Skip updating all selected issues if the update comes from issue connections tab
        const isBulkEditingOperation = visibleSelectedIssueIds.indexOf(localIssueId) !== -1 && !state.selectedIssue;
        // if bulk editing is enabled, update all other selected ideas and try to updated the status of each idea
        if (isBulkEditingOperation) {
            const notAllowedIssueKeys = [];
            const otherLocalIssueIds = visibleSelectedIssueIds.filter((id)=>{
                if (localIssueId === id) return false;
                const isStatusTransitionAllowed = $2809f050b039bddc$var$isTransitionForStatusAllowed(id, newStatus, state, props);
                if (!isStatusTransitionAllowed) {
                    const key = (0, $4TCfW.createGetKeySelector)(id)(state);
                    notAllowedIssueKeys.push(key);
                }
                return isStatusTransitionAllowed;
            });
            otherLocalIssueIds.forEach((id)=>{
                const oldOtherIssueStatus = state.properties.status?.status?.[id];
                // @ts-expect-error - TS2345 - Argument of type 'Status' is not assignable to parameter of type 'IssueStatusProperty'.
                dispatch($2809f050b039bddc$export$7dc74072a5ae8c9d(fieldKey, id, newStatus));
                (0, $1I887.fireAnalyticsEventForIssueUpdate)(createAnalyticsEvent({}), localIdMap[id], {
                    updatedItems: [
                        {
                            name: 'status',
                            oldValue: {
                                id: oldOtherIssueStatus?.id,
                                name: oldOtherIssueStatus?.name
                            },
                            newValue: {
                                id: newStatus?.id,
                                name: newStatus?.name
                            }
                        }
                    ],
                    action: 'bulk',
                    ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(id)(state)
                });
            });
            const updateOperations = otherLocalIssueIds.map((id)=>()=>new Promise((resolve, reject)=>{
                        updateField(fieldKey, true, id, newStatus, undefined, state, ()=>resolve(undefined), (e)=>reject(e));
                    }));
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            (0, $k2MWf.runInBatch)(updateOperations, 5).then(()=>{});
            if (notAllowedIssueKeys.length) onNotAllowedTransitions(notAllowedIssueKeys);
        }
        (0, $1I887.fireAnalyticsEventForIssueUpdate)(createAnalyticsEvent({}), localIdMap[localIssueId], {
            updatedItems: [
                {
                    name: 'status',
                    oldValue: {
                        id: oldStatus?.id,
                        name: oldStatus?.name
                    },
                    newValue: {
                        id: newStatus?.id,
                        name: newStatus?.name
                    }
                }
            ],
            action: isBulkEditingOperation ? 'bulk' : 'single',
            ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(localIssueId)(state)
        });
    };

});
parcelRegister("j6dzD", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeToTransitionsMap", () => $399a06d54a94800a$export$102b2f5286418eda);
$parcel$export(module.exports, "createGetValidTransitionsForIssueTypeAndStatus", () => $399a06d54a94800a$export$681f8d0f08c8ab7e);
$parcel$export(module.exports, "createGetTransitionForStatus", () => $399a06d54a94800a$export$7f9ac38d8f2de3a9);

var $ahm5r = parcelRequire("ahm5r");

var $75SEb = parcelRequire("75SEb");

var $1yBwF = parcelRequire("1yBwF");
const $399a06d54a94800a$export$102b2f5286418eda = (state)=>state.transitions;
const $399a06d54a94800a$export$d19c0c4312ebd835 = (issueTypeId)=>(0, $ahm5r.createSelector)($399a06d54a94800a$export$102b2f5286418eda, (map)=>{
        if (issueTypeId === undefined) return [];
        return map[issueTypeId];
    });
const $399a06d54a94800a$export$681f8d0f08c8ab7e = (issueTypeId, status)=>{
    const getTransitionsForIssueType = $399a06d54a94800a$export$d19c0c4312ebd835(issueTypeId);
    return (0, $ahm5r.createSelector)(getTransitionsForIssueType, (transitions)=>{
        if (transitions === undefined || issueTypeId === undefined || status === undefined) return [];
        return (0, (/*@__PURE__*/$parcel$interopDefault($75SEb)))(transitions, (transition)=>transition.isGlobal || transition.from?.id !== undefined && transition.from.id === status.id);
    });
};
const $399a06d54a94800a$export$c4bc8b2172ec67b1 = (issueTypeId, status)=>{
    const getValidTransitionsForIssueTypeAndStatus = $399a06d54a94800a$export$681f8d0f08c8ab7e(issueTypeId, status);
    return (0, $ahm5r.createSelector)(getValidTransitionsForIssueTypeAndStatus, (transitions)=>transitions.map(({ to: to })=>to));
};
const $399a06d54a94800a$export$7f9ac38d8f2de3a9 = (issueTypeId, fromStatus, toStatus)=>{
    const getValidTransitionsForIssueTypeAndStatus = $399a06d54a94800a$export$681f8d0f08c8ab7e(issueTypeId, fromStatus);
    return (0, $ahm5r.createSelector)(getValidTransitionsForIssueTypeAndStatus, (transitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($1yBwF)))((0, (/*@__PURE__*/$parcel$interopDefault($75SEb)))(transitions, ({ to: to })=>to.id === toStatus.id)));
};

});

parcelRegister("jZDOT", function(module, exports) {

$parcel$export(module.exports, "refreshIssues", () => $51b09ae4e06d40c9$export$a1f64180fa7d784);

var $lsLcV = parcelRequire("lsLcV");

var $dbfHE = parcelRequire("dbfHE");

var $2zs80 = parcelRequire("2zs80");

var $7B8wM = parcelRequire("7B8wM");

var $cSmYj = parcelRequire("cSmYj");

var $3zv7S = parcelRequire("3zv7S");

var $80xRm = parcelRequire("80xRm");

var $6DCNy = parcelRequire("6DCNy");

var $aa6Wo = parcelRequire("aa6Wo");

var $gyMEu = parcelRequire("gyMEu");

var $7jTnu = parcelRequire("7jTnu");

var $eTBmS = parcelRequire("eTBmS");


var $amUSo = parcelRequire("amUSo");

var $iehDF = parcelRequire("iehDF");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $g3PIQ = parcelRequire("g3PIQ");

var $6ovHY = parcelRequire("6ovHY");

var $hAB8j = parcelRequire("hAB8j");
const $51b09ae4e06d40c9$var$throttleFetchIssuesRanksInterval = 300000;
const $51b09ae4e06d40c9$var$ISSUE_FETCH_CHUNK_SIZE = 250; // the backend is limited to 250 ids
const $51b09ae4e06d40c9$export$45dbadd959efce25 = (state, props, remoteIssuesByLocalIssueId)=>{
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const externalIdMap = (0, $iWbQb.getExternalIssueIdsByJiraIssueId)(state, props);
    const externalIssueDataNew = {};
    Object.values(remoteIssuesByLocalIssueId).forEach((remoteIssue)=>{
        const externalId = externalIdMap[remoteIssue.id];
        if (externalId !== undefined) externalIssueDataNew[externalId] = {
            ...state.externalIssueData[externalId],
            status: remoteIssue.fields.status
        };
    });
    if (Object.keys(externalIssueDataNew).length > 0) // this is a known external issue. update it!
    return {
        ...state,
        externalIssueData: {
            ...state.externalIssueData,
            ...externalIssueDataNew
        }
    };
    // unknown external issue. if it isn't linked to a polaris idea, we don't care about it
    return state;
};
// trigger once in interval
const $51b09ae4e06d40c9$var$throttledFetchRanks = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(({ getState: getState, setState: setState }, props, idMap)=>{
    const { projectId: projectId, issueTypeIds: issueTypeIds, rankField: rankField, hasNoProjectPermissions: hasNoProjectPermissions } = props;
    // Bail early if we don't yet have all the information needed to load issues
    // or if the rank has not changed, unless it's a newly created issue
    if (!rankField || !projectId || !issueTypeIds || issueTypeIds.length === 0 || hasNoProjectPermissions) return Promise.resolve();
    // a rank change has happened in the backend. refresh ranks
    return props.issuesRemote.fetchRanks({
        rankField: rankField,
        issueTypeIds: issueTypeIds,
        archivedFilter: 'ACTIVE_ONLY',
        maxResults: (0, $amUSo.ISSUES_PAGE_LIMIT)
    }).then((response)=>{
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(getState(), props);
        // ensure local id map contains the idea in question (create case)
        const completeLocalIdMap = {
            ...localIdMap,
            ...idMap
        };
        const issues = (0, $6ovHY.sortIssuesByRank)({
            issues: response.issues,
            rankField: rankField
        });
        const remoteSortedIds = issues.map((issue)=>completeLocalIdMap[+issue.id]).filter(Boolean);
        const newIds = (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(getState().ids, (localIssueId)=>(0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(remoteSortedIds, localIssueId));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newIds, getState().ids)) setState({
            ids: newIds
        });
    });
}, $51b09ae4e06d40c9$var$throttleFetchIssuesRanksInterval);
const $51b09ae4e06d40c9$var$isRankChanged = (state, props, remoteIssuesByLocalIssueId)=>{
    const { rankField: rankField } = props;
    return Object.entries(remoteIssuesByLocalIssueId).some(([idForUpdate, remoteIssue])=>{
        const lexoRank = rankField ? remoteIssue.fields[rankField] : undefined;
        return state.properties.lexoRank[idForUpdate] !== lexoRank;
    });
};
const $51b09ae4e06d40c9$var$calculateRefreshedIdeaState = (state, props, remoteIssuesByLocalIssueId, shouldSkipGoalsUpdate, excludeFieldKeys = [])=>{
    const { issueTypeIds: issueTypeIds = [], projectId: projectId, projectIds: projectIds, rankField: rankField, isSharedView: isSharedView } = props;
    const ideaTypeIds = issueTypeIds;
    const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
    const fieldMappings = (0, $iehDF.getFieldMappings)(state, props);
    let localState = state;
    Object.entries(remoteIssuesByLocalIssueId).forEach(([idForUpdate, remoteIssue])=>{
        const isValidType = ideaTypeIds.includes(remoteIssue.fields.issuetype.id);
        const localId = localIdMap[remoteIssue.id];
        let isInCurrentContainer = false;
        if (projectIds && projectIds.length > 0) isInCurrentContainer = projectIds.includes(remoteIssue.fields.project.id);
        else isInCurrentContainer = String(projectId) === String(remoteIssue.fields.project.id);
        if (isSharedView || isValidType) {
            const newProperties = (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(fieldMappings, (result, mapping)=>{
                // Check if the field type is PLATFORM_GOALS and the action is cloning issue and skip the update as it was updated in updateGoalsFieldValue
                if (shouldSkipGoalsUpdate && mapping.field?.type === (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS) return result;
                if (mapping.field && excludeFieldKeys.includes(mapping.field.key)) return result;
                if ((mapping.field?.type === (0, $eTBmS.FIELD_TYPES).REACTIONS || mapping.field?.type === (0, $eTBmS.FIELD_TYPES).VOTES) && (0, $7jTnu.fg)('polaris_ideas_reactions_disappear_fix')) // Skip updating reactions and votes fields since getValueFromJiraIssue returns undefined.
                // This preserves existing reaction/vote data in the state in case when
                // `setImmutable` can filter out already defined reactions/votes.
                // Today `plays (votes)` don't implement setImmutable and just return existing value.
                return result;
                const fieldValue = mapping.getValueFromJiraIssue(remoteIssue);
                return mapping.setImmutable(result, idForUpdate, fieldValue !== null ? fieldValue : undefined);
            }, {
                ...localState.properties
            });
            const lexoRank = rankField !== undefined ? remoteIssue.fields[rankField] : undefined;
            if (lexoRank && rankField) newProperties.lexoRank = {
                ...newProperties.lexoRank,
                [idForUpdate]: lexoRank
            };
            newProperties.issueMetadata = {
                ...localState.properties.issueMetadata,
                [idForUpdate]: (0, $gyMEu.getMetaFromJiraSearchIssue)(remoteIssue, props.polarisIssueLinkType, props.hiddenIssueLinkTypes)
            };
            if (isInCurrentContainer) {
                // distinguish update and create cases
                const idsToRank = localId ? localState.ids : [
                    ...localState.ids,
                    idForUpdate
                ];
                let ids = idsToRank;
                if (rankField) ids = (0, $6ovHY.sortIdsByRank)({
                    ids: idsToRank,
                    lexoRankProperties: newProperties.lexoRank
                });
                localState = {
                    ...localState,
                    ids: ids,
                    properties: newProperties
                };
            } else localState = {
                ...localState,
                ids: (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(localState.ids, [
                    localId
                ]),
                connectionIssueIds: [
                    ...localState.connectionIssueIds,
                    idForUpdate
                ],
                properties: newProperties
            };
        } else if (localId) // not a valid polaris idea, but part of the local store. remove it (type or project has changed)
        localState = {
            ...localState,
            ids: (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(localState.ids, [
                localId
            ])
        };
    });
    // no idea issue affected, return state unchanged
    return localState;
};
const $51b09ae4e06d40c9$var$hasNewlyCreatedIssue = (state, props, remoteIssues)=>{
    const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
    return remoteIssues.some(({ id: id })=>localIdMap[id] === undefined);
};
const $51b09ae4e06d40c9$var$fetchIssuesRanks = (idMap)=>(storeApi, props)=>{
        $51b09ae4e06d40c9$var$throttledFetchRanks(storeApi, props, idMap);
    };
const $51b09ae4e06d40c9$var$getRemoteIssuesByLocalIssueId = (localIdMap, remoteIssues)=>remoteIssues.reduce((acc, remoteIssue)=>{
        const localId = localIdMap[remoteIssue.id];
        const idForUpdate = localId === undefined ? (0, $g3PIQ.generateLocalIssueId)() : localId;
        acc[idForUpdate] = remoteIssue;
        return acc;
    }, {});
const $51b09ae4e06d40c9$var$filterPrimaryListIssues = (response)=>{
    const primaryIssueList = response.issueLists?.primary;
    if (primaryIssueList !== undefined) return response.issues.filter((issue)=>primaryIssueList.includes(issue.id));
    return response.issues;
};
const $51b09ae4e06d40c9$export$a1f64180fa7d784 = (0, $aa6Wo.asyncSwitchAction)(({ jiraIssueIds: jiraIssueIds, refreshAllLoaded: refreshAllLoaded, excludeFieldKeys: excludeFieldKeys = [] }, { getState: getState }, props)=>{
    const { issuesRemote: issuesRemote, hasNoProjectPermissions: hasNoProjectPermissions, isSharedView: isSharedView } = props;
    // Disable real-time refresh issue for Shared view
    if (hasNoProjectPermissions || isSharedView) return Promise.resolve(undefined);
    let fields = (0, $iehDF.getFieldKeys)(getState(), props).filter((key)=>!excludeFieldKeys.includes(key));
    if (!fields.includes((0, $9a5f06039e1dff5a$export$dd03acb09519222))) fields = [
        ...fields,
        (0, $9a5f06039e1dff5a$export$dd03acb09519222)
    ];
    const issueIds = refreshAllLoaded ? Object.values((0, $4TCfW.getJiraIssueIdProperties)(getState())).map((id)=>id.toString()) : jiraIssueIds;
    if (issueIds.length < $51b09ae4e06d40c9$var$ISSUE_FETCH_CHUNK_SIZE) return issuesRemote.fetch({
        issueIdsOrKeys: issueIds,
        fields: fields
    });
    const chunks = (0, (/*@__PURE__*/$parcel$interopDefault($lsLcV)))(issueIds, $51b09ae4e06d40c9$var$ISSUE_FETCH_CHUNK_SIZE);
    return Promise.all(chunks.map((ids)=>issuesRemote.fetch({
            issueIdsOrKeys: ids,
            fields: fields
        })));
}, (response, { loadIssueDeliveryProgress: loadIssueDeliveryProgress = true, shouldSkipGoalsUpdate: shouldSkipGoalsUpdate = false, callback: callback, excludeFieldKeys: excludeFieldKeys }, { dispatch: dispatch, getState: getState, setState: setState }, props)=>{
    // Bail early if we don't yet have all the information needed to load issues
    if (!response) return;
    const flatIssues = Array.isArray(response) ? response.flatMap($51b09ae4e06d40c9$var$filterPrimaryListIssues) : $51b09ae4e06d40c9$var$filterPrimaryListIssues(response);
    const state = getState();
    const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
    const remoteIssuesByLocalIssueId = $51b09ae4e06d40c9$var$getRemoteIssuesByLocalIssueId(localIdMap, flatIssues);
    const newState = $51b09ae4e06d40c9$var$calculateRefreshedIdeaState(state, props, remoteIssuesByLocalIssueId, shouldSkipGoalsUpdate, excludeFieldKeys);
    const stateWithExternalChanged = $51b09ae4e06d40c9$export$45dbadd959efce25(newState, props, remoteIssuesByLocalIssueId);
    setState(stateWithExternalChanged);
    const idMap = Object.entries(remoteIssuesByLocalIssueId).reduce((acc, [localIssueId, remoteIssue])=>{
        acc[remoteIssue.id] = localIssueId;
        return acc;
    }, {});
    if ($51b09ae4e06d40c9$var$hasNewlyCreatedIssue(state, props, flatIssues) || $51b09ae4e06d40c9$var$isRankChanged(state, props, remoteIssuesByLocalIssueId)) (0, (/*@__PURE__*/$parcel$interopDefault($dbfHE)))(()=>dispatch($51b09ae4e06d40c9$var$fetchIssuesRanks(idMap)));
    if (loadIssueDeliveryProgress) {
        const jiraIssueIds = flatIssues.map((issue)=>issue.id);
        dispatch((0, $hAB8j.loadDeliveryProgress)(undefined, undefined, jiraIssueIds));
    }
    // Execute callback after issue refresh
    (0, (/*@__PURE__*/$parcel$interopDefault($dbfHE)))(()=>callback?.());
}, (error, _, __, { onIssueLoadingFailed: onIssueLoadingFailed })=>onIssueLoadingFailed(error));

});
parcelRegister("aa6Wo", function(module, exports) {

$parcel$export(module.exports, "asyncSwitchAction", () => $77e14fac76ea81b3$export$4817591eab41e4f8);

var $exWdq = parcelRequire("exWdq");

var $4c94y = parcelRequire("4c94y");

var $2uIj6 = parcelRequire("2uIj6");

var $jUVzX = parcelRequire("jUVzX");

var $jvwCK = parcelRequire("jvwCK");

var $aXKmr = parcelRequire("aXKmr");
const $77e14fac76ea81b3$var$argsShallowEqual = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(a),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(b)
    ]).every((key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(b, key)) return false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(a, key)) return false;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
        if (!Object.is(a[key], b[key])) return false;
        return true;
    });
const $77e14fac76ea81b3$var$createCache = ()=>{
    const actionCache = [];
    return {
        inCache: (args, executionIdentifier)=>(0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(actionCache, ({ args: cachedArgs, executionIdentifier: cachedExecutionIdentifier })=>$77e14fac76ea81b3$var$argsShallowEqual(cachedArgs, args) && cachedExecutionIdentifier === executionIdentifier),
        update: (args, executionIdentifier)=>{
            // remove any tuple with the shallow equal arguments
            (0, (/*@__PURE__*/$parcel$interopDefault($2uIj6)))(actionCache, ({ args: cachedArgs })=>$77e14fac76ea81b3$var$argsShallowEqual(cachedArgs, args));
            // add new tuple
            actionCache.push({
                args: args,
                executionIdentifier: executionIdentifier
            });
        },
        clear: (args)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($2uIj6)))(actionCache, ({ args: cachedArgs })=>$77e14fac76ea81b3$var$argsShallowEqual(cachedArgs, args));
        }
    };
};
const $77e14fac76ea81b3$export$4817591eab41e4f8 = (asyncProvider, responseHandler, errorHandler)=>{
    const cache = $77e14fac76ea81b3$var$createCache();
    return (args)=>(storeActionApi, props)=>{
            const executionIdentifier = (0, $aXKmr.v4)();
            cache.update(args, executionIdentifier);
            asyncProvider(args, storeActionApi, props).then((response)=>{
                if (!cache.inCache(args, executionIdentifier)) // has been overwritten by new request. ignore response
                return;
                responseHandler(response, args, storeActionApi, props);
                cache.clear(args);
            }).catch((err)=>{
                if (!cache.inCache(args, executionIdentifier)) // has been overwritten by new request. ignore error
                return;
                if (errorHandler !== undefined) errorHandler(err, args, storeActionApi, props);
            });
        };
};

});
parcelRegister("2uIj6", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $8zFlp = parcelRequire("8zFlp");
/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */ function $1d10c093b23a8fad$var$remove(array, predicate) {
    var result = [];
    if (!(array && array.length)) return result;
    var index = -1, indexes = [], length = array.length;
    predicate = $1lM9j(predicate, 3);
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
        }
    }
    $8zFlp(array, indexes);
    return result;
}
module.exports = $1d10c093b23a8fad$var$remove;

});
parcelRegister("8zFlp", function(module, exports) {

var $4qFnH = parcelRequire("4qFnH");

var $cn6El = parcelRequire("cn6El");
/** Used for built-in method references. */ var $63e1a9bcec0a9033$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $63e1a9bcec0a9033$var$splice = $63e1a9bcec0a9033$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */ function $63e1a9bcec0a9033$var$basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while(length--){
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
            var previous = index;
            if ($cn6El(index)) $63e1a9bcec0a9033$var$splice.call(array, index, 1);
            else $4qFnH(array, index);
        }
    }
    return array;
}
module.exports = $63e1a9bcec0a9033$var$basePullAt;

});



parcelRegister("gyMEu", function(module, exports) {

$parcel$export(module.exports, "getCommentsMeta", () => $a0d9049818debaf9$export$fef4b4c61db91ef5);
$parcel$export(module.exports, "getMetaFromJiraSearchIssue", () => $a0d9049818debaf9$export$dbe55f048bf45a1c);

var $80xRm = parcelRequire("80xRm");
const $a0d9049818debaf9$export$fef4b4c61db91ef5 = (comments)=>{
    const lastCommentByCreatedDate = (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(comments, (comment)=>comment.created).pop();
    return {
        count: comments.length,
        lastCreated: comments.length > 0 ? lastCommentByCreatedDate?.created ?? undefined : undefined,
        lastCreatedAuthor: comments.length > 0 ? lastCommentByCreatedDate?.author?.accountId ?? undefined : undefined
    };
};
const $a0d9049818debaf9$export$dbe55f048bf45a1c = (response, polarisIssueLinkType, hiddenIssueLinkTypes)=>{
    if ('meta' in response) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return response.meta;
    const issueLinksCount = response.fields.issuelinks?.filter((issueLink)=>{
        const linkedIssueKey = issueLink?.inwardIssue?.key || issueLink?.outwardIssue?.key;
        if (!linkedIssueKey) return false;
        if (issueLink.type.id !== polarisIssueLinkType && !hiddenIssueLinkTypes.includes(issueLink.type.id)) return true;
        return false;
    })?.length || 0;
    return {
        issueLinks: {
            count: issueLinksCount
        },
        comments: $a0d9049818debaf9$export$fef4b4c61db91ef5(response.fields.comment?.comments || [])
    };
};

});

parcelRegister("6ovHY", function(module, exports) {

$parcel$export(module.exports, "sortIssuesByRank", () => $7464ff17d708e735$export$ef6f4bfac1dbd489);
$parcel$export(module.exports, "sortIdsByRank", () => $7464ff17d708e735$export$2df664d8dd9ed329);

var $80xRm = parcelRequire("80xRm");
const $7464ff17d708e735$export$ef6f4bfac1dbd489 = ({ issues: issues, rankField: rankField })=>rankField !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(issues, [
        (issue)=>issue.fields[rankField]
    ]) : issues;
const $7464ff17d708e735$export$2df664d8dd9ed329 = ({ ids: ids, lexoRankProperties: lexoRankProperties })=>lexoRankProperties !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(ids, [
        (id)=>lexoRankProperties[id]
    ]) : ids;

});

parcelRegister("hAB8j", function(module, exports) {

$parcel$export(module.exports, "loadDeliveryProgress", () => $6c74fa970621f8e3$export$6637d3e61c225d20);
$parcel$export(module.exports, "refreshDeliveryProgressForSelectedIssue", () => $6c74fa970621f8e3$export$2eeb771d024a4d63);
$parcel$export(module.exports, "refreshDeliveryProgressForSpecificIssue", () => $6c74fa970621f8e3$export$133889930a4edcde);
$parcel$export(module.exports, "initDeliveryProgress", () => $6c74fa970621f8e3$export$7d6c7b5b6add75fc);
$parcel$export(module.exports, "refreshDeliveryDataForConnectionField", () => $6c74fa970621f8e3$export$de34fe748ea4c056);

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");

var $iehDF = parcelRequire("iehDF");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $lr3tD = parcelRequire("lr3tD");

var $dlpDx = parcelRequire("dlpDx");

var $iEc0P = parcelRequire("iEc0P");

var $jCJ41 = parcelRequire("jCJ41");

var $arOh8 = parcelRequire("arOh8");

var $fgz1G = parcelRequire("fgz1G");

var $dCYgo = parcelRequire("dCYgo");
const $6c74fa970621f8e3$export$6637d3e61c225d20 = (providedDeliveryStrategy, calculationMode, issueIds, archivedOnly)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        if ((0, $7jTnu.fg)('jpd_support-delivery-data-loading-connected-issues')) {
            if (props.isSharedView) {
                dispatch((0, $fgz1G.loadAggregatedDeliveryProgress)(true, providedDeliveryStrategy, calculationMode, issueIds, archivedOnly));
                return;
            }
            if (issueIds && issueIds.length > 0) dispatch($6c74fa970621f8e3$export$247cd9012e18932e(issueIds, {
                shouldLoadLinkedIssues: true
            }));
            else {
                setState((0, $iEc0P.setLoadingLinkedIssuesState)(getState(), true));
                await Promise.all([
                    dispatch((0, $fgz1G.loadAggregatedDeliveryProgress)(false, providedDeliveryStrategy, calculationMode, issueIds, archivedOnly)),
                    dispatch($6c74fa970621f8e3$export$471168e0678b917d())
                ]);
                setState((0, $iEc0P.setLoadingLinkedIssuesState)(getState(), false));
            }
        } else dispatch((0, $fgz1G.loadAggregatedDeliveryProgress)(true, providedDeliveryStrategy, calculationMode, issueIds, archivedOnly));
    };
const $6c74fa970621f8e3$export$2eeb771d024a4d63 = (options)=>({ dispatch: dispatch, getState: getState }, props)=>{
        const { isSharedView: isSharedView } = props;
        if (!(0, $7jTnu.fg)('jpd-connections-support-on-published-views')) {
            if (isSharedView) return;
        }
        const selectedIssueLocalIssueId = (0, $4TCfW.getSelectedIssueLocalIssueId)(getState());
        if (!selectedIssueLocalIssueId) return;
        const jiraId = (0, $4TCfW.getSelectedIssueJiraId)(getState());
        if (jiraId === undefined) return;
        if ((0, $7jTnu.fg)('jpd_support-delivery-data-loading-connected-issues')) {
            const issueIdsToRefresh = [
                String(jiraId)
            ];
            if (options?.includeConnections) {
                const connectionFieldsWithHighlightedDeliveryField = (0, $dlpDx.getConnectionFieldsThatNeedDeliveryData)(getState(), props);
                const connectedIssueIds = connectionFieldsWithHighlightedDeliveryField?.reduce((acc, { key: connectionFieldKey })=>{
                    const connectionsForIssue = (0, $dlpDx.createGetConnectionsValueSelector)(connectionFieldKey, selectedIssueLocalIssueId)(getState(), props)?.map(({ id: id })=>id) ?? [];
                    acc.push(...connectionsForIssue);
                    return acc;
                }, []);
                issueIdsToRefresh.push(...new Set(connectedIssueIds));
            }
            dispatch($6c74fa970621f8e3$export$247cd9012e18932e(issueIdsToRefresh));
        } else dispatch($6c74fa970621f8e3$export$133889930a4edcde(String(jiraId)));
    };
const $6c74fa970621f8e3$export$133889930a4edcde = (issueId)=>({ getState: getState, setState: setState }, props)=>{
        const { fields: fields, projectId: projectId, isSharedView: isSharedView, isCollectionView: isCollectionView } = props;
        if (isSharedView) return;
        if (issueId === undefined) return;
        const localIssueId = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(getState(), props)[issueId];
        if (!localIssueId) return;
        const safeProjectId = isCollectionView ? (0, $lr3tD.createGetProject)(localIssueId)(getState())?.id : projectId;
        if (safeProjectId === undefined) return;
        const calculationMode = (0, $iehDF.getDeliveryCalculationMode)(getState(), props);
        const calculationStrategy = (0, $iehDF.getDeliveryCalculationStrategy)(getState(), props);
        const analyticsAttributes = {
            deliveryDatesCount: 0,
            deliveryDatesPresent: false,
            calculationMode: calculationMode
        };
        const dateFieldConfigurations = (0, $arOh8.getFieldConfigurations)(fields);
        if (dateFieldConfigurations.length > 0) {
            analyticsAttributes.deliveryDatesCount = dateFieldConfigurations.length;
            analyticsAttributes.deliveryDatesPresent = true;
        }
        const fetchAggregatedStartTimestamp = Date.now();
        props.issuesRemote.fetchAggregatedDeliveryProgress({
            projectId: safeProjectId,
            issueIds: [
                issueId
            ],
            calculationStrategy: calculationStrategy,
            calculationMode: calculationMode,
            dateFieldConfigurations: dateFieldConfigurations
        }).then(({ ideaToProgressAggregation: ideaToProgressAggregation, ideaDateAggregation: ideaDateAggregation })=>{
            const aggregatedDeliveryDates = {
                ...getState().properties.aggregatedDeliveryDates
            };
            if (ideaDateAggregation && ideaDateAggregation[issueId]) aggregatedDeliveryDates[localIssueId] = ideaDateAggregation[issueId];
            setState({
                properties: {
                    ...getState().properties,
                    aggregatedDeliveryProgress: {
                        ...getState().properties.aggregatedDeliveryProgress,
                        [localIssueId]: ideaToProgressAggregation[issueId]
                    },
                    aggregatedDeliveryDates: aggregatedDeliveryDates
                }
            });
        }).catch((error)=>{
            (0, $jCJ41.fireErrorAnalytics)(props.createAnalyticsEvent, fetchAggregatedStartTimestamp);
            props.onDeliveryDataFetchFailed(error);
        });
        (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'deliveryData loaded', analyticsAttributes);
    };
const $6c74fa970621f8e3$export$247cd9012e18932e = (issueIds, options)=>async ({ getState: getState, setState: setState }, props)=>{
        if (issueIds.length === 0) return;
        if (options?.shouldLoadLinkedIssues) setState((0, $iEc0P.setLoadingLinkedIssuesState)(getState(), true));
        const analyticsAttributes = {
            deliveryDatesCount: 0,
            deliveryDatesPresent: false
        };
        const dateFieldConfigurations = (0, $arOh8.getFieldConfigurations)(props.fields);
        if (dateFieldConfigurations.length > 0) {
            analyticsAttributes.deliveryDatesCount = dateFieldConfigurations.length;
            analyticsAttributes.deliveryDatesPresent = true;
        }
        const fetchAggregatedStartTimestamp = Date.now();
        try {
            const response = await props.issuesRemote.fetchAggregatedDeliveryProgressForIssues({
                issueIds: issueIds,
                dateFieldConfigurations: dateFieldConfigurations
            });
            const jiraIdToLocalIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(getState(), props);
            const aggregatedDeliveryProgressByLocalId = (0, $dCYgo.replaceOmitRecordKeys)(response.ideaToProgressAggregation, jiraIdToLocalIdMap);
            const aggregatedDeliveryDatesByLocalId = (0, $dCYgo.replaceOmitRecordKeys)(response.ideaDateAggregation, jiraIdToLocalIdMap);
            setState({
                properties: {
                    ...getState().properties,
                    aggregatedDeliveryProgress: {
                        ...getState().properties.aggregatedDeliveryProgress,
                        ...aggregatedDeliveryProgressByLocalId
                    },
                    aggregatedDeliveryDates: {
                        ...getState().properties.aggregatedDeliveryDates,
                        ...aggregatedDeliveryDatesByLocalId
                    }
                },
                meta: {
                    ...getState().meta,
                    loadingLinkedIssues: false
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'deliveryData loaded', analyticsAttributes);
        } catch (error) {
            (0, $jCJ41.fireErrorAnalytics)(props.createAnalyticsEvent, fetchAggregatedStartTimestamp);
            setState((0, $iEc0P.setLoadingLinkedIssuesState)(getState(), false));
            props.onDeliveryDataFetchFailed(error instanceof Error ? error : new Error('Error fetching delivery data for specific issues'));
        }
    };
const $6c74fa970621f8e3$export$471168e0678b917d = ()=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const connectionIssueIds = getState().connectionIssueIds;
        if (!connectionIssueIds || connectionIssueIds.length === 0) return;
        const connectionFieldsWithHighlightedDeliveryField = (0, $dlpDx.getConnectionFieldsThatNeedDeliveryData)(getState(), props);
        if (connectionFieldsWithHighlightedDeliveryField.length === 0) return;
        const connectionJiraIssueIds = connectionIssueIds.map((localIssueId)=>(0, $4TCfW.createGetIdSelector)(localIssueId)(getState()));
        const jiraIdsToLoadDeliveryData = connectionFieldsWithHighlightedDeliveryField.reduce((acc, { key: connectionFieldKey })=>{
            if (!connectionFieldKey) return acc;
            const connectionsMap = (0, $dlpDx.createGetConnectionsValuesMap)(connectionFieldKey)(getState(), props);
            if (!connectionsMap) return acc;
            Object.values(connectionsMap).forEach((connectionFieldValue)=>{
                if (!connectionFieldValue) return;
                const matchingIssueIds = connectionFieldValue.map(({ id: id })=>id).filter((issueId)=>connectionJiraIssueIds.includes(parseInt(issueId, 10)));
                acc.push(...matchingIssueIds);
            });
            return acc;
        }, []);
        if (jiraIdsToLoadDeliveryData.length === 0) return;
        await dispatch($6c74fa970621f8e3$export$247cd9012e18932e(Array.from(new Set(jiraIdsToLoadDeliveryData))));
    };
const $6c74fa970621f8e3$export$7d6c7b5b6add75fc = ()=>({ dispatch: dispatch }, props)=>{
        if (props.singleIdeaVisible) dispatch($6c74fa970621f8e3$export$2eeb771d024a4d63({
            includeConnections: true
        }));
        else {
            dispatch((0, $fgz1G.loadAggregatedDeliveryProgress)());
            if (!props.isSharedView && (0, $7jTnu.fg)('jpd_support-delivery-data-loading-connected-issues')) dispatch($6c74fa970621f8e3$export$471168e0678b917d());
        }
    };
const $6c74fa970621f8e3$export$de34fe748ea4c056 = (connectionFieldKey)=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const connectionIssueIds = getState().connectionIssueIds;
        if (!connectionIssueIds || connectionIssueIds.length === 0) return;
        const isConnectionFieldThatNeedsDeliveryData = (0, $dlpDx.createGetIsConnectionFieldThatNeedsDeliveryData)(connectionFieldKey)(getState(), props);
        if (!isConnectionFieldThatNeedsDeliveryData) return;
        const connectionsMap = (0, $dlpDx.createGetConnectionsValuesMap)(connectionFieldKey)(getState(), props);
        if (!connectionsMap) return;
        const connectionJiraIssueIds = connectionIssueIds.map((localIssueId)=>(0, $4TCfW.createGetIdSelector)(localIssueId)(getState()));
        const jiraIdsToLoadDeliveryData = Object.values(connectionsMap).reduce((acc, connectionFieldValue)=>{
            if (!connectionFieldValue) return acc;
            const matchingIssueIds = connectionFieldValue.map(({ id: id })=>id).filter((issueId)=>connectionJiraIssueIds.includes(parseInt(issueId, 10)));
            acc.push(...matchingIssueIds);
            return acc;
        }, []);
        if (jiraIdsToLoadDeliveryData.length === 0) return;
        await dispatch($6c74fa970621f8e3$export$247cd9012e18932e(Array.from(new Set(jiraIdsToLoadDeliveryData))));
    };

});
parcelRegister("lr3tD", function(module, exports) {

$parcel$export(module.exports, "createGetProject", () => $a0737a8aca46b4ef$export$52aae2837a080935);
$parcel$export(module.exports, "createGetProjectId", () => $a0737a8aca46b4ef$export$dca2f59ee95e69a2);
$parcel$export(module.exports, "createGetProjectIds", () => $a0737a8aca46b4ef$export$624cf300728cc90b);
$parcel$export(module.exports, "getAllIssuesProjectIds", () => $a0737a8aca46b4ef$export$f5a8f852c87bb1c7);

var $ahm5r = parcelRequire("ahm5r");

var $jvwCK = parcelRequire("jvwCK");

var $4TCfW = parcelRequire("4TCfW");
const $a0737a8aca46b4ef$export$52aae2837a080935 = (localIssueId)=>(0, $ahm5r.createSelector)((0, $4TCfW.getProperties), (properties)=>{
        if (localIssueId === undefined) return;
        return properties.projects?.project?.[localIssueId];
    });
const $a0737a8aca46b4ef$export$dca2f59ee95e69a2 = (localIssueId)=>(0, $ahm5r.createSelector)($a0737a8aca46b4ef$export$52aae2837a080935(localIssueId), (project)=>project?.id);
const $a0737a8aca46b4ef$export$624cf300728cc90b = (localIssueIds)=>(0, $ahm5r.createSelector)((0, $4TCfW.getProperties), (properties)=>properties.projects?.project ? (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(localIssueIds.map((localIssueId)=>properties.projects?.project?.[localIssueId].id)) : []);
const $a0737a8aca46b4ef$export$f5a8f852c87bb1c7 = (0, $ahm5r.createSelector)((0, $4TCfW.getProperties), (properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(Object.values(properties.projects?.project || {}).map(({ id: id })=>id)));

});

parcelRegister("iEc0P", function(module, exports) {

$parcel$export(module.exports, "setLoadingLinkedIssuesState", () => $cd1cd0777347343b$export$d16aab99e191c949);
$parcel$export(module.exports, "updateIssuesRanks", () => $cd1cd0777347343b$export$7c3f4505c4f13cd5);
$parcel$export(module.exports, "enrichPlayContributionPayload", () => $cd1cd0777347343b$export$eb5cdbb04621fd4d);

var $HXbds = parcelRequire("HXbds");

var $3xiug = parcelRequire("3xiug");

var $1O6Yz = parcelRequire("1O6Yz");

var $iWbQb = parcelRequire("iWbQb");
const $cd1cd0777347343b$export$d16aab99e191c949 = (state, loading)=>({
        ...state,
        meta: {
            ...state.meta,
            loadingLinkedIssues: loading
        }
    });
const $cd1cd0777347343b$export$7c3f4505c4f13cd5 = (localIssueIds)=>({ getState: getState, setState: setState }, props)=>{
        const { projectId: projectId, issueTypeIds: issueTypeIds, rankField: rankField, hasNoProjectPermissions: hasNoProjectPermissions } = props;
        if (!rankField || !projectId || !issueTypeIds || issueTypeIds.length === 0 || hasNoProjectPermissions) return Promise.resolve();
        const jiraIdByLocalIssueId = (0, $iWbQb.getLocalIssueIdToJiraId)(getState(), props);
        const issueIds = localIssueIds.map((id)=>jiraIdByLocalIssueId[id]);
        return props.issuesRemote.fetchRanks({
            rankField: rankField,
            issueIdsOrKeys: issueIds,
            issueTypeIds: issueTypeIds
        }).then((response)=>{
            const localIssueIdByJiraId = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(getState(), props);
            const lexoRanks = response?.issues?.reduce((acc, issue)=>{
                const lexoRank = issue.fields?.[rankField];
                const localIssueId = localIssueIdByJiraId[issue.id];
                if (lexoRank && localIssueId) Object.assign(acc, {
                    [localIssueId]: lexoRank
                });
                return acc;
            }, {});
            if (lexoRanks) setState({
                properties: {
                    ...getState().properties,
                    lexoRank: {
                        ...getState().properties.lexoRank,
                        ...lexoRanks
                    }
                }
            });
        });
    };
function $cd1cd0777347343b$export$eb5cdbb04621fd4d(contribution, localPlays) {
    // Check if the contribution already has user account data then return it as is
    if (contribution?.author?.accountId && contribution?.author.displayName) return contribution;
    const accountId = contribution?.author?.accountId;
    // Try to enrich contribution with the user account data from the other contributions
    for (const localPlay of Object.values(localPlays))for (const localContributions of Object.values(localPlay)){
        const localContribution = localContributions.find(({ aaid: aaid })=>aaid === accountId);
        if (localContribution) {
            const enrichedContribution = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))('author', (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))((0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))({}, 'author', contribution), localContribution?.author), contribution);
            return enrichedContribution;
        }
    }
    // contribution cannot be enriched return as is
    return contribution;
}

});

parcelRegister("jCJ41", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $c1b5c415900687a6$export$a27c21aa3ed8f0f1);

var $gCeeo = parcelRequire("gCeeo");
const $c1b5c415900687a6$export$a27c21aa3ed8f0f1 = (createAnalyticsEvent, fetchStartTimestamp)=>{
    (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadDeliveryData failure', {
        durationMs: fetchStartTimestamp - Date.now()
    });
};

});

parcelRegister("arOh8", function(module, exports) {

$parcel$export(module.exports, "getFieldConfigurations", () => $739f931fe4a13ce5$export$de8a29ff6778b3b7);

var $8Z1Mi = parcelRequire("8Z1Mi");
function $739f931fe4a13ce5$export$de8a29ff6778b3b7(fields) {
    const dateFieldConfigurations = [];
    fields?.forEach((field)=>{
        if (field?.configuration?.source === (0, $8Z1Mi.INTERVAL_FIELD_SOURCES).DELIVERY_DATE && field?.configuration?.customfieldKey && field?.configuration?.aggregationType) dateFieldConfigurations.push({
            fieldKey: field.configuration.customfieldKey,
            aggregationType: field.configuration.aggregationType
        });
    });
    return dateFieldConfigurations;
}

});

parcelRegister("fgz1G", function(module, exports) {

$parcel$export(module.exports, "loadAggregatedDeliveryProgress", () => $299a57dfe411c262$export$12a1609f29cbb864);

var $7jTnu = parcelRequire("7jTnu");

var $eTBmS = parcelRequire("eTBmS");

var $nFHtT = parcelRequire("nFHtT");

var $gCeeo = parcelRequire("gCeeo");

var $gCeeo = parcelRequire("gCeeo");

var $iWbQb = parcelRequire("iWbQb");

var $iEc0P = parcelRequire("iEc0P");

var $jCJ41 = parcelRequire("jCJ41");

var $arOh8 = parcelRequire("arOh8");

var $dCYgo = parcelRequire("dCYgo");
const $299a57dfe411c262$export$12a1609f29cbb864 = (// remove this arg when cleaning up `jpd_support-delivery-data-loading-connected-issues`
shouldLoadLinkedIssues = false, providedDeliveryStrategy, providedCalculationMode, issueIds, archivedOnly)=>async ({ getState: getState, setState: setState }, props)=>{
        if (!(0, $7jTnu.fg)('jpd_support-delivery-data-loading-connected-issues')) {
            if (shouldLoadLinkedIssues) setState((0, $iEc0P.setLoadingLinkedIssuesState)(getState(), true));
        }
        const jiraIdToLocalIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(getState(), props);
        const { fields: fields, createAnalyticsEvent: createAnalyticsEvent, isCollectionView: isCollectionView, projectId: projectId } = props;
        if (projectId === undefined && !isCollectionView) return;
        const deliveryField = fields?.find((field)=>field.type === (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS && field.global);
        const calculationStrategy = providedDeliveryStrategy || deliveryField?.presentation?.type || (0, $nFHtT.DELIVERY_CALCULATION_STRATEGIES).DEFAULT;
        const calculationMode = providedCalculationMode || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        deliveryField?.formula?.parameters?.calculationMode || (0, $nFHtT.DELIVERY_CALCULATION_MODE).ISSUE_COUNT;
        const analyticsAttributes = {
            deliveryDatesCount: 0,
            deliveryDatesPresent: false,
            calculationMode: calculationMode
        };
        const dateFieldConfigurations = (0, $arOh8.getFieldConfigurations)(fields);
        if (dateFieldConfigurations.length > 0) {
            analyticsAttributes.deliveryDatesCount = dateFieldConfigurations.length;
            analyticsAttributes.deliveryDatesPresent = true;
        }
        const fetchAggregatedStartTimestamp = Date.now();
        let archivedFilter;
        if (!Array.isArray(issueIds) || issueIds?.length === 0) archivedFilter = archivedOnly ? 'ARCHIVED_ONLY' : 'ACTIVE_ONLY';
        const handleResponse = (response)=>{
            const { properties: properties, meta: meta } = getState();
            const aggregatedDeliveryProgressByLocalId = (0, $dCYgo.replaceOmitRecordKeys)(response.ideaToProgressAggregation, jiraIdToLocalIdMap);
            const aggregatedDeliveryDatesByLocalId = (0, $dCYgo.replaceOmitRecordKeys)(response.ideaDateAggregation, jiraIdToLocalIdMap);
            if (!issueIds || issueIds.length === 0) {
                const sumOfAllProgressIssues = Object.values(response.ideaToProgressAggregation).flat().reduce((acc, val)=>acc + val, 0);
                (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadDeliveryData success', {
                    durationMs: Date.now() - fetchAggregatedStartTimestamp,
                    sumOfAllProgressIssues: sumOfAllProgressIssues,
                    archived: archivedFilter === 'ARCHIVED_ONLY'
                });
            }
            setState({
                properties: {
                    ...properties,
                    aggregatedDeliveryProgress: {
                        ...properties.aggregatedDeliveryProgress,
                        ...aggregatedDeliveryProgressByLocalId
                    },
                    aggregatedDeliveryDates: {
                        ...properties.aggregatedDeliveryDates,
                        ...aggregatedDeliveryDatesByLocalId
                    }
                },
                meta: {
                    ...meta,
                    restrictedDeliveryIssuesCount: response.aggregationLimit,
                    fullDeliveryDataInitialized: true,
                    ...(0, $7jTnu.fg)('jpd_support-delivery-data-loading-connected-issues') ? {} : {
                        loadingLinkedIssues: false
                    }
                }
            });
        };
        if ((0, $7jTnu.fg)('jpd_support-delivery-data-loading-connected-issues')) {
            try {
                const response = await props.issuesRemote.fetchAggregatedDeliveryProgress({
                    projectId: projectId ?? '',
                    issueIds: issueIds,
                    calculationStrategy: calculationStrategy,
                    calculationMode: calculationMode,
                    dateFieldConfigurations: dateFieldConfigurations,
                    archivedFilter: archivedFilter
                });
                handleResponse(response);
            } catch (error) {
                (0, $jCJ41.fireErrorAnalytics)(props.createAnalyticsEvent, fetchAggregatedStartTimestamp);
                setState((0, $iEc0P.setLoadingLinkedIssuesState)(getState(), false));
                props.onDeliveryDataFetchFailed(error instanceof Error ? error : new Error('Error fetching aggregated delivery data'));
            }
            (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'deliveryData loaded', analyticsAttributes);
        } else {
            props.issuesRemote.fetchAggregatedDeliveryProgress({
                projectId: projectId ?? '',
                issueIds: issueIds,
                calculationStrategy: calculationStrategy,
                calculationMode: calculationMode,
                dateFieldConfigurations: dateFieldConfigurations,
                archivedFilter: archivedFilter
            }).then(handleResponse).catch((error)=>{
                (0, $jCJ41.fireErrorAnalytics)(props.createAnalyticsEvent, fetchAggregatedStartTimestamp);
                setState((0, $iEc0P.setLoadingLinkedIssuesState)(getState(), false));
                props.onDeliveryDataFetchFailed(error);
            });
            (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'deliveryData loaded', analyticsAttributes);
        }
    };

});
parcelRegister("dCYgo", function(module, exports) {

$parcel$export(module.exports, "replaceOmitRecordKeys", () => $23cb1ebb7d458527$export$cda7e904e7cef162);
const $23cb1ebb7d458527$export$cda7e904e7cef162 = (record, keyReplacementMap)=>{
    const result = {};
    for (const [key, value] of Object.entries(record)){
        const localId = keyReplacementMap[key];
        if (localId) result[localId] = value;
    }
    return result;
};

});





parcelRegister("jD8ef", function(module, exports) {

$parcel$export(module.exports, "updateIssueGoals", () => $ecefc8a6dc9ae72f$export$11af7c38c5584411);
$parcel$export(module.exports, "updateGoalsFieldValue", () => $ecefc8a6dc9ae72f$export$f305956ac1dd4f73);

var $2zs80 = parcelRequire("2zs80");

var $7BEaI = parcelRequire("7BEaI");

var $fqICx = parcelRequire("fqICx");

var $7jTnu = parcelRequire("7jTnu");

var $jDdjf = parcelRequire("jDdjf");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

// Function to batch requests
// Atlas API supports 50 linking/unlinking relationships per request so we batch them
const $ecefc8a6dc9ae72f$var$BATCH_SIZE = 50;
const $ecefc8a6dc9ae72f$var$batchRequests = async (relationships, requestFn)=>{
    const batches = [];
    for(let i = 0; i < Math.ceil(relationships.length / $ecefc8a6dc9ae72f$var$BATCH_SIZE); i++){
        const batch = requestFn({
            relationships: relationships.slice(i * $ecefc8a6dc9ae72f$var$BATCH_SIZE, (i + 1) * $ecefc8a6dc9ae72f$var$BATCH_SIZE)
        });
        batches.push(batch);
    }
    return Promise.all(batches);
};
const $ecefc8a6dc9ae72f$export$11af7c38c5584411 = ({ fieldKey: fieldKey, issueId: issueId, goalsToLink: goalsToLink = [], goalsToUnlink: goalsToUnlink = [], skipNetworkRequest: skipNetworkRequest, onError: onError })=>async ({ getState: getState, setState: setState }, props)=>{
        if (!goalsToLink.length && !goalsToUnlink.length) return;
        const state = getState();
        const { issuesRemote: issuesRemote, onIssueUpdateFailed: onIssueUpdateFailed, cloudId: cloudId } = props;
        const localIssueId = (0, $iWbQb.getLocalIssueIdForJiraIssueId)(issueId)(state, props);
        const goals = (0, $4TCfW.createGetPlatformGoalsValueSelector)(fieldKey, localIssueId)(state, props);
        const currentGoals = goals || [];
        // Add new goals (merge unique values)
        const newGoals = Array.from(new Set([
            ...currentGoals,
            ...goalsToLink
        ]));
        // Remove goals to unlink
        const updatedGoals = newGoals.filter((goal)=>!goalsToUnlink.includes(goal));
        const issueAri = (0, $jDdjf.createIssueAri)(cloudId, issueId);
        // Optimistic update only for goals property
        const previousProperties = {
            ...getState().properties
        };
        setState({
            ...state,
            properties: {
                ...state.properties,
                goals: {
                    ...state.properties.goals,
                    [fieldKey]: {
                        ...state.properties.goals?.[fieldKey],
                        [localIssueId]: updatedGoals
                    }
                }
            },
            lastUpdatedIssueIds: [
                localIssueId
            ],
            lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
        });
        if (skipNetworkRequest) return;
        try {
            const promises = [];
            if (goalsToLink.length) {
                const linkRelationships = goalsToLink.map((goal)=>({
                        from: issueAri,
                        to: goal
                    }));
                promises.push($ecefc8a6dc9ae72f$var$batchRequests(linkRelationships, issuesRemote.linkGoals));
            }
            if (goalsToUnlink.length) {
                const unlinkRelationships = goalsToUnlink.map((goal)=>({
                        from: issueAri,
                        to: goal
                    }));
                promises.push($ecefc8a6dc9ae72f$var$batchRequests(unlinkRelationships, issuesRemote.unlinkGoals));
            }
            await Promise.all(promises);
        } catch (error) {
            // Revert optimistic update only for goals property
            setState({
                properties: previousProperties
            });
            if (error instanceof Error) {
                onIssueUpdateFailed(error);
                onError?.(error);
            }
        }
    };
const $ecefc8a6dc9ae72f$export$6630b282a313f773 = (fieldKey, issueGoalsMap)=>async ({ setState: setState, getState: getState }, props)=>{
        if (issueGoalsMap.size === 0) return;
        const state = getState();
        const { issuesRemote: issuesRemote, onIssueUpdateFailed: onIssueUpdateFailed, cloudId: cloudId } = props;
        const jiraIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(getState(), props);
        // Create relationships for all issues
        const linkRelationships = Array.from(issueGoalsMap.entries()).flatMap(([localIssueId, { goalsToLink: goalsToLink }])=>{
            if (!goalsToLink.length) return [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const issueId = jiraIdMap[localIssueId];
            const issueAri = (0, $jDdjf.createIssueAri)(cloudId, issueId);
            return goalsToLink.map((goal)=>({
                    from: issueAri,
                    to: goal
                }));
        });
        const unlinkRelationships = Array.from(issueGoalsMap.entries()).flatMap(([localIssueId, { goalsToUnlink: goalsToUnlink }])=>{
            if (!goalsToUnlink.length) return [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const issueId = jiraIdMap[localIssueId];
            const issueAri = (0, $jDdjf.createIssueAri)(cloudId, issueId);
            return goalsToUnlink.map((goal)=>({
                    from: issueAri,
                    to: goal
                }));
        });
        const previousProperties = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(state.properties);
        const updatedGoalsState = {
            ...state.properties.goals?.[fieldKey]
        };
        for (const [localIssueId, { goalsToLink: goalsToLink, goalsToUnlink: goalsToUnlink }] of issueGoalsMap){
            const currentGoals = state.properties.goals?.[fieldKey]?.[localIssueId] || [];
            const newGoals = Array.from(new Set([
                ...currentGoals,
                ...goalsToLink
            ]));
            updatedGoalsState[localIssueId] = newGoals.filter((goal)=>!goalsToUnlink.includes(goal));
        }
        setState({
            ...state,
            properties: {
                ...state.properties,
                goals: {
                    ...state.properties.goals,
                    [fieldKey]: updatedGoalsState
                }
            },
            lastUpdatedIssueIds: Array.from(issueGoalsMap.keys()),
            lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
        });
        try {
            const promises = [];
            if (linkRelationships.length) promises.push($ecefc8a6dc9ae72f$var$batchRequests(linkRelationships, issuesRemote.linkGoals));
            if (unlinkRelationships.length) promises.push($ecefc8a6dc9ae72f$var$batchRequests(unlinkRelationships, issuesRemote.unlinkGoals));
            await Promise.all(promises);
        } catch (error) {
            // Revert optimistic update only for goals property
            setState({
                properties: previousProperties
            });
            if (error instanceof Error) onIssueUpdateFailed(error);
        }
    };
const $ecefc8a6dc9ae72f$export$f305956ac1dd4f73 = ({ fieldKey: fieldKey, localIssueIds: localIssueIds, newValue: newValue, removeValue: removeValue, appendMultiValues: appendMultiValues, skipNetworkRequest: skipNetworkRequest = false, onError: onError })=>({ getState: getState, dispatch: dispatch }, props)=>{
        if (localIssueIds.length === 0) return;
        const state = getState();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const newGoalsValue = newValue || [];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const removeGoalsValue = removeValue || [];
        const updateIssueGoalsBulkRequest = localIssueIds.reduce((acc, localIssueId)=>{
            const currentGoals = (0, $4TCfW.createGetPlatformGoalsValueSelector)(fieldKey, localIssueId)(state, props) || [];
            const goalsToLink = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(newGoalsValue, currentGoals);
            const goalsToUnlink = appendMultiValues ? (0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(removeGoalsValue, currentGoals) : (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(currentGoals, newGoalsValue);
            acc.set(localIssueId, {
                goalsToLink: goalsToLink,
                goalsToUnlink: goalsToUnlink
            });
            return acc;
        }, new Map());
        if (localIssueIds.length === 1) {
            const localIssueId = localIssueIds[0];
            const jiraIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const issueId = jiraIdMap[localIssueId];
            dispatch($ecefc8a6dc9ae72f$export$11af7c38c5584411({
                fieldKey: fieldKey,
                issueId: issueId,
                goalsToLink: updateIssueGoalsBulkRequest.get(localIssueId)?.goalsToLink,
                goalsToUnlink: updateIssueGoalsBulkRequest.get(localIssueId)?.goalsToUnlink,
                skipNetworkRequest: skipNetworkRequest,
                onError: onError
            }));
        } else dispatch($ecefc8a6dc9ae72f$export$6630b282a313f773(fieldKey, updateIssueGoalsBulkRequest));
    };

});

parcelRegister("gXTjR", function(module, exports) {

$parcel$export(module.exports, "resetConnectionFieldsValues", () => $fc3c0c5cd7ec6471$export$67b983d0492f8bf0);
$parcel$export(module.exports, "refreshConnectionFieldsValues", () => $fc3c0c5cd7ec6471$export$c9e788f68782f792);

var $7BEaI = parcelRequire("7BEaI");

var $6Yd06 = parcelRequire("6Yd06");

var $iehDF = parcelRequire("iehDF");

var $iWbQb = parcelRequire("iWbQb");

var $amUSo = parcelRequire("amUSo");
const $fc3c0c5cd7ec6471$export$67b983d0492f8bf0 = (connectionFieldKeys, localIssueIdsToReset = [])=>async ({ getState: getState, setState: setState }, props)=>{
        if (connectionFieldKeys.length === 0) return;
        const state = getState();
        const allConnectionFieldsMappings = (0, $iehDF.getConnectionFieldMappings)(state, props);
        const connectionFieldMappings = connectionFieldKeys.map((fieldKey)=>allConnectionFieldsMappings[fieldKey]).filter(Boolean);
        let newProperties = {
            ...state.properties
        };
        const localIssueIdToJiraId = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
        const jiraIssueIdsToReset = localIssueIdsToReset.map((localId)=>localIssueIdToJiraId[localId]);
        state.ids.forEach((localIssueId)=>{
            connectionFieldMappings.forEach((fieldMapping)=>{
                // In case localIssueIdsToReset is not provided we reset all the connections fields to empty values
                if (localIssueIdsToReset.length === 0) {
                    newProperties = fieldMapping.setImmutable(newProperties, localIssueId, []);
                    return;
                }
                // In case localIssueIdsToReset is provided we remove only corresponding ids from the connection fields
                const currentValue = fieldMapping.valueAccessor(state, props, localIssueId) || [];
                const currentValueIds = currentValue.map(({ id: id })=>id);
                const changedIds = (0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(jiraIssueIdsToReset, currentValueIds);
                if (changedIds.length > 0) newProperties = fieldMapping.modifyImmutableIfMultiValueField(newProperties, localIssueId, undefined, changedIds.map((id)=>({
                        id: id
                    })));
            });
        });
        setState({
            properties: newProperties
        });
    };
const $fc3c0c5cd7ec6471$export$c9e788f68782f792 = (fieldKeys)=>async ({ getState: getState, setState: setState }, props)=>{
        if (fieldKeys.length === 0) return;
        const state = getState();
        const { issuesRemote: issuesRemote } = props;
        const allConnectionFieldsMappings = (0, $iehDF.getConnectionFieldMappings)(state, props);
        const connectionFieldMappings = fieldKeys.map((fieldKey)=>allConnectionFieldsMappings[fieldKey]).filter(Boolean);
        try {
            const { issues: issues } = await issuesRemote.fetch({
                archivedFilter: 'ACTIVE_ONLY',
                fields: fieldKeys,
                maxResults: (0, $amUSo.ISSUES_PAGE_LIMIT)
            });
            let newProperties = {
                ...getState().properties
            };
            const localIssueIdToJiraId = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
            connectionFieldMappings.forEach((fieldMapping)=>{
                state.ids.forEach((localIssueId)=>{
                    const jiraIssueId = localIssueIdToJiraId[localIssueId];
                    const issue = issues.find(({ id: id })=>id === jiraIssueId);
                    if (!issue) return;
                    const fieldValue = fieldMapping.getValueFromJiraIssue(issue);
                    newProperties = fieldMapping.setImmutable(newProperties, localIssueId, fieldValue);
                });
            });
            setState({
                properties: newProperties
            });
        } catch (error) {
            if (error instanceof Error) (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.issue.action.refreshConnectionFieldsValues', 'Failed to refresh connection fields values', error);
        }
    };

});

parcelRegister("81I0u", function(module, exports) {

$parcel$export(module.exports, "updateFieldValuesOnBackendBulk", () => $a2bc14f0d93746ca$export$254f826d7226d0f1);

var $eezJL = parcelRequire("eezJL");

var $2ApNu = parcelRequire("2ApNu");

var $9NWOK = parcelRequire("9NWOK");

var $iehDF = parcelRequire("iehDF");

var $4TCfW = parcelRequire("4TCfW");

var $dVE1x = parcelRequire("dVE1x");

var $gXTjR = parcelRequire("gXTjR");

var $4ww0y = parcelRequire("4ww0y");

var $e1NSt = parcelRequire("e1NSt");
const $a2bc14f0d93746ca$var$getMainApolloError = (error)=>{
    const UNKNOWN_ERROR = 'Unknown error';
    const graphQLErrors = error?.graphQLErrors;
    if (!graphQLErrors?.length) return null;
    // Find the error with the highest status code and use it as the main error
    const mainError = graphQLErrors.reduce((acc, currError)=>{
        const statusCode = currError.extensions?.statusCode ?? null;
        if (!statusCode || statusCode <= (acc.statusCode ?? 0)) return acc;
        return {
            statusCode: statusCode,
            message: currError.message ?? UNKNOWN_ERROR
        };
    }, {
        statusCode: null,
        message: UNKNOWN_ERROR
    });
    return mainError.statusCode ? new (0, $9NWOK.IssueErrorConstructor)(mainError.message, [
        {
            error: mainError.message
        }
    ], mainError.statusCode) : null;
};
const $a2bc14f0d93746ca$export$254f826d7226d0f1 = (state, props, fieldKeys, localIssueIds, dispatch, updateIssuesSuccess, updateIssuesError, updateIssueTypeMoveError)=>{
    dispatch((0, $dVE1x.incrementOpenUpdateCounter)(localIssueIds));
    const selectedIssueAris = localIssueIds.map((localIssueId)=>{
        const issueId = String((0, $4TCfW.createGetIdSelector)(localIssueId)(state));
        return (0, $2ApNu.JiraIssueAri).create({
            siteId: props.cloudId,
            issueId: issueId
        }).toString();
    });
    const selectedIssueKeys = localIssueIds.map((localIssueId)=>{
        return (0, $4TCfW.createGetKeySelector)(localIssueId)(state);
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    let editedFieldsInput = {};
    fieldKeys.forEach((fieldKey)=>{
        const fieldMapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(state, props);
        const getFieldValueFn = fieldMapping?.getFieldValueForJiraBulkUpdate;
        if (!getFieldValueFn) return Promise.reject(new Error('Bulk update not supported for this field'));
        const editedFieldInput = getFieldValueFn(// since we are bulk editing, we can get the value from the first issue
        fieldMapping.valueAccessor(state, props, localIssueIds[0]));
        if (editedFieldInput) editedFieldsInput = {
            ...(0, $e1NSt.mergeObjects)([
                editedFieldsInput,
                editedFieldInput
            ])
        };
    });
    return props.issuesRemote.updateIssueFieldsBulk({
        input: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            bulkOperationType: 'BULK_EDIT',
            bulkOperationInput: {
                bulkEditInput: {
                    selectedActions: fieldKeys,
                    selectedIssueIds: selectedIssueAris,
                    editedFieldsInput: editedFieldsInput,
                    sendBulkNotification: true
                }
            }
        }
    }).then((progress)=>{
        if (!progress?.taskId) throw new Error('Invalid progress response');
        props.onIssueBulkUpdate({
            taskId: progress.taskId,
            getUpdateIssueFieldsBulkProgress: props.issuesRemote.getUpdateIssueFieldsBulkProgress,
            onFinished: ()=>{
                // In case fieldKeys include fields of ISSUE_TYPE type, then we need to refresh all connection fields for all issues
                // after the bulk update is done. This is because the issue type change is affecting the connection fields.
                if ((0, $4ww0y.hasIssueTypeField)(fieldKeys, state, props)) dispatch((0, $gXTjR.refreshConnectionFieldsValues)((0, $iehDF.getConfiguredConnectionFieldsKeys)(state, props)));
            }
        });
        updateIssuesSuccess && updateIssuesSuccess(true);
        return progress;
    }).catch((err)=>{
        let error = err;
        if (err instanceof (0, $eezJL.ApolloError)) {
            const mainApolloError = $a2bc14f0d93746ca$var$getMainApolloError(err);
            if (mainApolloError) error = mainApolloError;
        }
        if ((0, $4ww0y.isIncompatibleTargetIssueTypeStatusError)({
            error: error,
            modifiedFieldKeys: fieldKeys
        })) {
            if (props.onIssueTypeUpdateFailed) props.onIssueTypeUpdateFailed(error, selectedIssueKeys);
            else props.onIssueUpdateFailed(error);
            updateIssueTypeMoveError?.(error);
        } else {
            props.onIssueUpdateFailed(error);
            updateIssuesError?.(error, true);
        }
        return error;
    });
};

});
parcelRegister("9NWOK", function(module, exports) {

$parcel$export(module.exports, "IssueErrorConstructor", () => $b474b6d96c0f21c1$export$49662438d8ad1eb6);

var $fJuTR = parcelRequire("fJuTR");
class $b474b6d96c0f21c1$export$49662438d8ad1eb6 extends (0, $fJuTR.default) {
    constructor(message, errors = [], statusCode = null){
        super(message, {
            cause: errors[0]
        }), this.name = 'IssueError';
        this.errors = errors;
        this.statusCode = statusCode;
    }
}

});

parcelRegister("4ww0y", function(module, exports) {

$parcel$export(module.exports, "getNewPropertiesMapping", () => $d01cc77cd6ec1219$export$8e92a6fb7305b557);
$parcel$export(module.exports, "getTransitionsForTargetStatusByLocalIssueIds", () => $d01cc77cd6ec1219$export$4aac9eb5e977f06b);
$parcel$export(module.exports, "isBulkOperationSupported", () => $d01cc77cd6ec1219$export$4bec64e51e0f06b3);
$parcel$export(module.exports, "hasIssueTypeField", () => $d01cc77cd6ec1219$export$8c7b99d67fda1bd2);
$parcel$export(module.exports, "isIncompatibleTargetIssueTypeStatusError", () => $d01cc77cd6ec1219$export$3f9268afb252f2ef);

var $4sprp = parcelRequire("4sprp");

var $eTBmS = parcelRequire("eTBmS");


var $1uIew = parcelRequire("1uIew");


var $j6dzD = parcelRequire("j6dzD");

var $iehDF = parcelRequire("iehDF");

var $4TCfW = parcelRequire("4TCfW");
const $d01cc77cd6ec1219$export$8e92a6fb7305b557 = (fieldMapping, oldPropertyMap, localIssueIds, newValue, removeValue, appendMultiValues)=>{
    // In case of connection field, we don't want to update the properties here
    // It is done inside updateConnectionFieldValue since it requires more logic to update the properties
    if (fieldMapping.field?.type === (0, $eTBmS.FIELD_TYPES).CONNECTION) return oldPropertyMap;
    // In case of platform goals field, we don't want to update the properties here
    // It is done inside updateGoalsFieldValue since it requires more logic to update the properties
    if (fieldMapping.field?.type === (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS) return oldPropertyMap;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(localIssueIds)) {
        let newMapping = oldPropertyMap;
        localIssueIds.forEach((localIssueId)=>{
            newMapping = $d01cc77cd6ec1219$export$8e92a6fb7305b557(fieldMapping, newMapping, localIssueId, newValue, removeValue, appendMultiValues);
        });
        return newMapping;
    }
    return fieldMapping.isMultiValueField && appendMultiValues ? fieldMapping.modifyImmutableIfMultiValueField(oldPropertyMap, localIssueIds, newValue, removeValue) : fieldMapping.setImmutable(oldPropertyMap, localIssueIds, newValue);
};
const $d01cc77cd6ec1219$export$4aac9eb5e977f06b = (localIssueIds, toStatus, state, props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    localIssueIds.reduce((acc, issueId)=>{
        const issueType = (0, $4TCfW.createGetIssueType)(issueId)(state, props);
        const status = (0, $4TCfW.createGetStatus)(issueId)(state, props);
        if (issueType === undefined || status === undefined) {
            acc[issueId] = undefined;
            return acc;
        }
        const getTransitionForStatus = (0, $j6dzD.createGetTransitionForStatus)(issueType.id, status, toStatus);
        const transition = getTransitionForStatus({
            transitions: props.workflowTransitions
        });
        acc[issueId] = transition;
        return acc;
    }, {});
const $d01cc77cd6ec1219$export$4bec64e51e0f06b3 = (fieldKeys, state, props)=>fieldKeys.every((fieldKey)=>{
        const fieldMapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(state, props);
        return fieldMapping?.getFieldValueForJiraBulkUpdate;
    });
const $d01cc77cd6ec1219$export$8c7b99d67fda1bd2 = (fieldKeys, state, props)=>{
    const fields = (0, $iehDF.getAllFieldsByKey)(state, props);
    return fieldKeys.some((fieldKey)=>fields[fieldKey]?.type === (0, $eTBmS.FIELD_TYPES).ISSUE_TYPE);
};
const $d01cc77cd6ec1219$export$3f9268afb252f2ef = ({ modifiedFieldKeys: modifiedFieldKeys, error: error })=>{
    if (modifiedFieldKeys.includes((0, $9a5f06039e1dff5a$export$dd03acb09519222))) {
        if (error.name === 'IssueError' && 'statusCode' in error && error.statusCode === (0, $44ccf6b895337c89$export$9de493bcd9b1d977)) return true;
        if (error instanceof (0, $1uIew.ValidationError) && Array.isArray(error.errors) && error.errors[0] && error.errors[0].field === (0, $9a5f06039e1dff5a$export$dd03acb09519222) && error.errors[0].error === 'The issue type selected is invalid.') return true;
    }
    return false;
};

});
const $44ccf6b895337c89$export$ff39ebd4bb12b718 = 201;
const $44ccf6b895337c89$export$3288b14b6745c572 = 204;
const $44ccf6b895337c89$export$9de493bcd9b1d977 = 400;
const $44ccf6b895337c89$export$67d19e9a991baa07 = 401;
const $44ccf6b895337c89$export$a3269a3914b007e3 = 403;
const $44ccf6b895337c89$export$8bca792d963eb0ef = 404;
const $44ccf6b895337c89$export$4a3cb39801694eee = 407;
const $44ccf6b895337c89$export$fa405bbf47d510e2 = 408;
const $44ccf6b895337c89$export$c09e7ea0fc79f34f = 409;
const $44ccf6b895337c89$export$5244030134e99 = 412;
const $44ccf6b895337c89$export$f90ac1df0b60853d = 413;
const $44ccf6b895337c89$export$a447d0a965e16776 = 422;
const $44ccf6b895337c89$export$3b48aba8957000cd = 426;
const $44ccf6b895337c89$export$6763168a631449a2 = 429;
const $44ccf6b895337c89$export$e813cd7045fcc98d = 500;
const $44ccf6b895337c89$export$2ce38d41a306034e = 502;
const $44ccf6b895337c89$export$974c37534b0191b1 = 503;
const $44ccf6b895337c89$export$5400e8dddac3fcf3 = 504;


parcelRegister("e1NSt", function(module, exports) {

$parcel$export(module.exports, "mergeObjects", () => $d29e9c0e05089d45$export$2321aea138b44780);
const $d29e9c0e05089d45$export$2321aea138b44780 = (objects)=>{
    const result = {};
    for (const object of objects){
        for(const key in object)if (typeof object === 'object' && object && key in object) {
            if (result[key]) {
                const value = result[key];
                if (Array.isArray(value)) value.push(object[key]);
                else result[key] = [
                    result[key],
                    object[key]
                ];
            } else result[key] = object[key];
        }
    }
    return result;
};

});




parcelRegister("ffZim", function(module, exports) {

$parcel$export(module.exports, "clonePolarisIssue", () => $b50d686390f17a08$export$1a6c23a9ba2b4022);


var $k2MWf = parcelRequire("k2MWf");

var $ljej9 = parcelRequire("ljej9");

var $6Yd06 = parcelRequire("6Yd06");


var $j6dzD = parcelRequire("j6dzD");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $3UByz = parcelRequire("3UByz");

var $17y5b = parcelRequire("17y5b");

var $jZDOT = parcelRequire("jZDOT");

var $3TA1a = parcelRequire("3TA1a");

var $jD8ef = parcelRequire("jD8ef");
const $b50d686390f17a08$var$copyTheInsights = (sourceIssueId, targetIssueId)=>async (_, { projectId: projectId, insightsRemote: insightsRemote })=>{
        if (projectId === undefined) return;
        await insightsRemote.copyInsights?.({
            source: {
                projectId: projectId,
                issueId: sourceIssueId ? String(sourceIssueId) : undefined
            },
            destination: {
                projectId: projectId,
                issueId: targetIssueId ? String(targetIssueId) : undefined
            }
        });
    };
const $b50d686390f17a08$var$copyAttachments = (sourceIssueId, sourceIssueKey, targetIssueKey)=>async (_, props)=>{
        const { projectId: projectId, issuesRemote: issuesRemote, insightsRemote: insightsRemote } = props;
        if (projectId === undefined) return;
        await (0, $3UByz.copyMediaAndAttachments)(insightsRemote, issuesRemote, sourceIssueId, sourceIssueKey, targetIssueKey);
    };
const $b50d686390f17a08$var$copyLinkedIssues = async (issuesRemote, issueLinks, targetIssueKey)=>{
    await (0, $k2MWf.runInBatch)(issueLinks.map((link)=>()=>link?.inwardIssue // unfortunately using a filter doesn't resolve possible type problems (undefined values)
             ? issuesRemote.createIssueLink({
                issueLinkTypeId: link.type.id,
                inwardIssueKey: link.inwardIssue.key,
                outwardIssueKey: targetIssueKey
            }) : Promise.resolve()), 5);
};
const $b50d686390f17a08$var$copyStatus = (issueId, value)=>({ getState: getState, dispatch: dispatch }, props)=>{
        const issueTypeSelector = (0, $4TCfW.createGetIssueType)(issueId);
        const issueType = issueTypeSelector(getState(), props);
        const getStatus = (0, $4TCfW.createGetStatus)(issueId);
        const status = getStatus(getState(), props);
        if (issueType === undefined || status === undefined) return Promise.reject();
        const getTransitionForStatus = (0, $j6dzD.createGetTransitionForStatus)(issueType.id, status, value);
        const transition = getTransitionForStatus({
            transitions: props.workflowTransitions
        });
        if (transition !== undefined) return new Promise((resolve, reject)=>dispatch((0, $3TA1a.updateStatus)((0, $9a5f06039e1dff5a$export$29157f6cae91bb2f), issueId, transition, resolve, reject)));
        return Promise.resolve();
    };
const $b50d686390f17a08$var$copyGoals = (fieldKey, sourceLocalIssueId, targetLocalIssueId)=>({ getState: getState, dispatch: dispatch }, props)=>{
        if (!fieldKey) return;
        const goals = (0, $4TCfW.createGetPlatformGoalsValueSelector)(fieldKey, sourceLocalIssueId)(getState(), props) || [];
        dispatch((0, $jD8ef.updateGoalsFieldValue)({
            fieldKey: fieldKey,
            localIssueIds: [
                targetLocalIssueId
            ],
            newValue: goals
        }));
    };
const $b50d686390f17a08$var$copyFields = (sourceLocalIssueId, targetLocalIssueId, targetIssueKey, description, fieldsForUpdate)=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const getStatus = (0, $4TCfW.createGetStatus)(sourceLocalIssueId);
        const status = getStatus(getState(), props);
        if (status !== undefined) await dispatch($b50d686390f17a08$var$copyStatus(targetLocalIssueId, status));
        await props.issuesRemote.updateIssueFields({
            issueKey: targetIssueKey,
            update: fieldsForUpdate
        });
        if (description != null) await props.issuesRemote.updateIssueDescription({
            issueKey: targetIssueKey,
            description: description
        });
    };
const $b50d686390f17a08$var$copyEverything = (sourceLocalIssueId, targetLocalIssueId, targetIssueKey, targetIssueId, issueLinks)=>async ({ getState: getState, dispatch: dispatch }, props)=>{
        const state = getState();
        const { id: id, key: key, fieldsForUpdate: fieldsForUpdate, description: description } = (0, $iWbQb.createGetIssuesForMerge)([
            sourceLocalIssueId
        ])(state, props)[0];
        const goalsFieldKey = (0, $iWbQb.getPlatformGoalsFieldKey)(state, props);
        await dispatch($b50d686390f17a08$var$copyFields(sourceLocalIssueId, targetLocalIssueId, targetIssueKey, description, fieldsForUpdate));
        await dispatch($b50d686390f17a08$var$copyGoals(goalsFieldKey, sourceLocalIssueId, targetLocalIssueId));
        await $b50d686390f17a08$var$copyLinkedIssues(props.issuesRemote, issueLinks, targetIssueKey);
        await dispatch($b50d686390f17a08$var$copyTheInsights(id, targetIssueId));
        await dispatch($b50d686390f17a08$var$copyAttachments(id, (0, $ljej9.toIssueKey)(key), targetIssueKey));
    };
const $b50d686390f17a08$export$1a6c23a9ba2b4022 = ({ localIssueId: localIssueId, summary: summary, issueLinks: issueLinks, issueType: issueType, onSuccess: onSuccess, onFailure: onFailure })=>async ({ dispatch: dispatch })=>{
        const newSummary = summary.slice(0, (0, $6ce8f7ca3ca282e1$export$b6c6d141b2149b4b));
        dispatch((0, $17y5b.createAndUpdate)({
            issueType: issueType,
            summary: newSummary,
            analyticsSource: 'cloneIssueScreen',
            updateOperation: (newLocalIssueId, _, issue)=>{
                if (issue === null || typeof issue !== 'object') return;
                const issueKey = (0, $ljej9.toIssueKey)(String(issue.key));
                dispatch($b50d686390f17a08$var$copyEverything(localIssueId, newLocalIssueId, issueKey, Number(issue.id), issueLinks)).then(()=>dispatch((0, $jZDOT.refreshIssues)({
                        jiraIssueIds: [
                            issue.id
                        ],
                        shouldSkipGoalsUpdate: true
                    }))).then(()=>onSuccess({
                        id: newLocalIssueId,
                        key: issueKey,
                        summary: newSummary
                    })).catch((err)=>{
                    const error = err instanceof Error ? err : new Error('Unknown error');
                    (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.clone-ideas-error', 'Failed to clone the idea', error);
                    onFailure(error);
                });
            }
        }));
    };

});
const $6ce8f7ca3ca282e1$export$b6c6d141b2149b4b = 255;
const $6ce8f7ca3ca282e1$export$6105b6cbec3400d8 = 24;
const $6ce8f7ca3ca282e1$export$f620cea8bc0acc40 = 1e14;
const $6ce8f7ca3ca282e1$export$f0912582372d56ad = 10000;
const $6ce8f7ca3ca282e1$export$bd6f44214f84c29a = 4102;
const $6ce8f7ca3ca282e1$export$aa53f670803b96e = 3165;

parcelRegister("3UByz", function(module, exports) {

$parcel$export(module.exports, "copyMediaAndAttachments", () => $d2ed7858066b34a4$export$8ff6adb1dc345c40);

var $ivkPv = parcelRequire("ivkPv");

var $k2MWf = parcelRequire("k2MWf");

var $f0rpU = parcelRequire("f0rpU");

var $k69gu = parcelRequire("k69gu");

var $hWyxk = parcelRequire("hWyxk");

var $bf8pY = parcelRequire("bf8pY");
const $d2ed7858066b34a4$export$8ff6adb1dc345c40 = async (insightsRemote, issuesRemote, sourceIssueId, sourceIssueKey, targetIssueKey)=>Promise.all([
        issuesRemote.fetchIssue({
            issueIdOrKey: sourceIssueKey
        }),
        issuesRemote.fetchIssueAttachments({
            issueIdOrKey: sourceIssueKey
        })
    ]).then(async ([{ issue: issue }, issueAttachmentsResponse])=>{
        const commentMediaIds = (0, $ivkPv.getAllMediaIdsFromComments)(issue.fields.comment?.comments || []);
        const files = issueAttachmentsResponse.tokensWithFiles[0]?.files;
        if (!Array.isArray(files)) return undefined;
        const token = issueAttachmentsResponse.tokensWithFiles[0]?.token;
        if (!token) throw new Error('media token for read attachments is empty');
        const insightsWithSnippetData = await insightsRemote.fetchInsightsWithSnippetData?.({
            issueId: String(sourceIssueId)
        }) ?? [];
        const snippetsAttachmentsMap = (0, $f0rpU.getInsightsAttachments)(insightsWithSnippetData.map(({ snippets: snippets })=>({
                snippets: snippets.map(({ data: data })=>({
                        data: data
                    }))
            }))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, attachment)=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...result,
                [attachment.attachmentId]: true
            }), {});
        const insightsMediaIds = (0, $f0rpU.getInsightsMediaIds)(insightsWithSnippetData.map(({ description: description })=>({
                description: description
            })));
        return (0, $k2MWf.runInBatch)(files.filter((file)=>file.attachmentMediaApiId && !snippetsAttachmentsMap[file.attachmentId] && !commentMediaIds.includes(file.attachmentMediaApiId) && !insightsMediaIds.includes(file.attachmentMediaApiId)).map((file)=>()=>issuesRemote.createIssueAttachment({
                    issueIdOrKey: targetIssueKey,
                    fileId: file.attachmentMediaApiId
                }).catch(async (err)=>{
                    // if attachment uploaded to different media collection
                    if (err.statusCode === 403) {
                        const [blob, attachment] = await Promise.all([
                            (0, $bf8pY.getFileBinary)(issueAttachmentsResponse.endpointUrl, issueAttachmentsResponse.clientId, token, file.attachmentMediaApiId),
                            (0, $hWyxk.getAttachment)(file.attachmentId)
                        ]);
                        const formData = new FormData();
                        formData.append('file', blob, attachment.filename);
                        return (0, $k69gu.createAttachments)(targetIssueKey, formData);
                    }
                    throw err;
                })), 5);
    });

});
parcelRegister("f0rpU", function(module, exports) {

$parcel$export(module.exports, "getInsightsAttachments", () => $aa2456273d75619e$export$8bdaba83527ab5c1);
$parcel$export(module.exports, "getInsightsMediaIds", () => $aa2456273d75619e$export$7437a5aa327c2c7e);

var $eI1yv = parcelRequire("eI1yv");

var $ivkPv = parcelRequire("ivkPv");
const $aa2456273d75619e$export$8bdaba83527ab5c1 = (insights)=>// @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
    (0, (/*@__PURE__*/$parcel$interopDefault($eI1yv)))(insights.map((insight)=>insight.snippets?.map((snippet)=>{
            if (snippet.data && Array.isArray(snippet.data?.content)) return snippet.data.content;
            if (snippet.data?.content && 'preview' in snippet.data?.content && snippet.data?.content?.preview !== undefined) return [
                snippet.data?.content?.preview
            ];
            return [];
        }))) // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
    .filter(Boolean) // @ts-expect-error([Part of upgrade 4.9-5.4]) - 'contentItem' is of type 'unknown'.
    .filter((contentItem)=>contentItem.type === 'attachment');
const $aa2456273d75619e$export$7437a5aa327c2c7e = (insights)=>(0, (/*@__PURE__*/$parcel$interopDefault($eI1yv)))(insights.map((insight)=>(0, $ivkPv.getMediaIds)(insight.description)));

});

parcelRegister("k69gu", function(module, exports) {

$parcel$export(module.exports, "createAttachments", () => $f7e64a1f7c0d27c3$export$c4d56e24d433d67a);

var $1uIew = parcelRequire("1uIew");
const $f7e64a1f7c0d27c3$var$createAttachmentsApiUrl = (issueKeyOrId)=>`/rest/api/3/issue/${issueKeyOrId}/attachments`;
const $f7e64a1f7c0d27c3$export$c4d56e24d433d67a = (issueKeyOrId, formData)=>fetch($f7e64a1f7c0d27c3$var$createAttachmentsApiUrl(issueKeyOrId), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'X-Atlassian-Token': 'no-check'
        },
        body: formData
    }).then((response)=>{
        if (!response.ok) throw new (0, $1uIew.default)(response.status, 'Failed to copy attachments');
        return response.json();
    });

});

parcelRegister("hWyxk", function(module, exports) {

$parcel$export(module.exports, "getAttachment", () => $a5bea6f22db6a03b$export$d9406b141a18b745);

var $1Ozm9 = parcelRequire("1Ozm9");
const $a5bea6f22db6a03b$var$getAttachmentApiUrl = (attachmentId)=>`/rest/api/3/attachment/${attachmentId}`;
const $a5bea6f22db6a03b$export$d9406b141a18b745 = (attachmentId)=>(0, $1Ozm9.default)($a5bea6f22db6a03b$var$getAttachmentApiUrl(attachmentId));

});

parcelRegister("bf8pY", function(module, exports) {

$parcel$export(module.exports, "getFileBinary", () => $6309096a6366d44a$export$94432bda5f8ee0b0);

var $1uIew = parcelRequire("1uIew");
const $6309096a6366d44a$export$94432bda5f8ee0b0 = (endpointUrl, clientId, token, attachmentMediaApiId)=>fetch(`${endpointUrl}/file/${attachmentMediaApiId}/binary`, {
        headers: {
            authorization: `Bearer ${token}`,
            'x-client-id': clientId
        }
    }).then((resposne)=>{
        if (resposne.ok) return resposne.blob();
        throw new (0, $1uIew.default)(resposne.status, 'Failed to fetch file blob from media');
    });

});


parcelRegister("17y5b", function(module, exports) {

$parcel$export(module.exports, "cancelCreations", () => $ae057e080bec9b88$export$e297a5f5ad9f2786);
$parcel$export(module.exports, "createIssue", () => $ae057e080bec9b88$export$b61347e00e271b8e);
$parcel$export(module.exports, "createIssueAfter", () => $ae057e080bec9b88$export$92c9ffeffb08e354);
$parcel$export(module.exports, "createIssueBefore", () => $ae057e080bec9b88$export$978eacecb1d2c4a7);
$parcel$export(module.exports, "cancelCreateIssue", () => $ae057e080bec9b88$export$f71093f5a7e9fcf9);
$parcel$export(module.exports, "saveIssue", () => $ae057e080bec9b88$export$145c27579a3e7c0a);
$parcel$export(module.exports, "createAndUpdate", () => $ae057e080bec9b88$export$708dfc137ebb6f7b);
$parcel$export(module.exports, "createAndConnect", () => $ae057e080bec9b88$export$6bf5ec2facb27b17);
$parcel$export(module.exports, "clearCreatedProperty", () => $ae057e080bec9b88$export$cbb9025f442bf2ad);
$parcel$export(module.exports, "submitIdea", () => $ae057e080bec9b88$export$f6831b188469e7df);
$parcel$export(module.exports, "safelySwapRowInCreationWithCreated", () => $ae057e080bec9b88$export$b2b683a22fb35867);

var $cSmYj = parcelRequire("cSmYj");

var $jFHCE = parcelRequire("jFHCE");

var $3zv7S = parcelRequire("3zv7S");

var $3l9kN = parcelRequire("3l9kN");

var $12DRg = parcelRequire("12DRg");

var $ln6Iy = parcelRequire("ln6Iy");

var $gCeeo = parcelRequire("gCeeo");


var $eTBmS = parcelRequire("eTBmS");

var $iehDF = parcelRequire("iehDF");

var $j9i1D = parcelRequire("j9i1D");

var $4TCfW = parcelRequire("4TCfW");

var $BrRcR = parcelRequire("BrRcR");


var $g3PIQ = parcelRequire("g3PIQ");

var $cHovn = parcelRequire("cHovn");

var $dVE1x = parcelRequire("dVE1x");

var $9448e = parcelRequire("9448e");

var $jkDvC = parcelRequire("jkDvC");
const $ae057e080bec9b88$export$e297a5f5ad9f2786 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const localIssueIds = (0, $4TCfW.getIssueIdsInCreation)(state);
        if (localIssueIds !== undefined && localIssueIds.length > 0) {
            const { ids: ids, properties: properties } = state;
            const { created: created } = properties;
            const newIds = (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(ids, ...localIssueIds);
            const newCreated = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(created, localIssueIds);
            setState({
                properties: {
                    ...properties,
                    created: newCreated
                },
                ids: newIds
            });
        }
    };
// Finds propper index of the issue where to place the new created issue id in the sorted list
// When we created a new issue it appears in certain place in the list, but after it's saved
// it can move to a different place because of sorting, we need to find the right place
// which are stable issues ids( not in creation state )
const $ae057e080bec9b88$var$getCreateIssuePosition = (createdIssueIds, ids, positionIndex, direction)=>{
    let idx = positionIndex;
    while(ids[idx]){
        if (!createdIssueIds.includes(ids[idx])) return ids[idx];
        idx += direction;
    }
    return undefined;
};
const $ae057e080bec9b88$export$b61347e00e271b8e = (positionIndex, localIssueId, grouping = {
    groupType: (0, $d5435e25fbd81376$export$e209eb8cb8e09aba)
})=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        // cancel already existing issue creations that have not been confirmed yet
        dispatch($ae057e080bec9b88$export$e297a5f5ad9f2786());
        // we need to take state after `dispatch`
        // otherwise we will override `cancelCreations()` results
        const state = getState();
        // generate UUID if not passed in
        const newId = localIssueId ?? (0, $g3PIQ.generateLocalIssueId)();
        const ids = (0, $BrRcR.getSortedIssueIds)(state, props);
        const createdIssueIds = (()=>{
            if ((grouping.groupType === (0, $d5435e25fbd81376$export$870d962ddd4b82d4) || grouping.groupType === (0, $d5435e25fbd81376$export$49f6ea3702b3924f) || grouping.groupType === (0, $d5435e25fbd81376$export$7c2ebc4b06c12232)) && grouping.rankingAllowed) return (0, $4TCfW.getIssueIdsInCreation)(state);
            return (0, $4TCfW.getCreatedIssueIds)(state);
        })();
        const rankBefore = $ae057e080bec9b88$var$getCreateIssuePosition(createdIssueIds, ids, positionIndex, 1);
        const rankAfter = $ae057e080bec9b88$var$getCreateIssuePosition(createdIssueIds, ids, positionIndex - 1, -1);
        const newState = (0, $jkDvC.createIssueInternal)({
            state: state,
            newId: newId,
            rankBefore: rankBefore,
            rankAfter: rankAfter,
            grouping: grouping
        });
        setState(newState);
    };
const $ae057e080bec9b88$export$92c9ffeffb08e354 = (anchor, localIssueId, grouping)=>({ getState: getState, dispatch: dispatch }, props)=>{
        const indexSelector = (0, $BrRcR.getSortedIssueIndex)(anchor);
        const positionIndex = indexSelector(getState(), props);
        dispatch($ae057e080bec9b88$export$b61347e00e271b8e(positionIndex + 1, localIssueId, grouping));
    };
const $ae057e080bec9b88$export$978eacecb1d2c4a7 = (anchor, localIssueId, grouping)=>({ getState: getState, dispatch: dispatch }, props)=>{
        const indexSelector = (0, $BrRcR.getSortedIssueIndex)(anchor);
        const positionIndex = indexSelector(getState(), props);
        dispatch($ae057e080bec9b88$export$b61347e00e271b8e(positionIndex, localIssueId, grouping));
    };
const $ae057e080bec9b88$export$f71093f5a7e9fcf9 = (localIssueId)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const { ids: ids, properties: properties } = state;
        const { created: created } = properties;
        const newIds = ids.filter((id)=>id !== localIssueId);
        const newCreated = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(created, [
            localIssueId
        ]);
        setState({
            properties: {
                ...properties,
                created: newCreated
            },
            ids: newIds
        });
    };
const $ae057e080bec9b88$export$145c27579a3e7c0a = (id, issueTypeId, summary, clonedCreatedProperty, clonedIds, onCreatedIssueFiltered, onIssueSaved, onIssueSaveError)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        dispatch((0, $dVE1x.incrementOpenUpdateCounter)([
            id
        ]));
        (0, $jkDvC.saveIssueInternal)(getState, setState, dispatch, props, id, issueTypeId, summary, clonedCreatedProperty, clonedIds, onCreatedIssueFiltered, onIssueSaved, onIssueSaveError);
    };
const $ae057e080bec9b88$export$708dfc137ebb6f7b = ({ issueType: issueType, summary: summary, analyticsSource: analyticsSource, optimisticUpdateFields: optimisticUpdateFields = {}, onOptimisticCreationFinished: onOptimisticCreationFinished = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), updateOperation: updateOperation = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) })=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { projectId: projectId, rankField: rankField, isRankingEnabled: isRankingEnabled, issuesRemote: issuesRemote, onIssueCreationFailed: onIssueCreationFailed, createAnalyticsEvent: createAnalyticsEvent } = props;
        if (projectId === undefined || issueType === undefined) // TODO proper error handling
        throw new Error('project / issueType undefined');
        const state = getState();
        const id = (0, $g3PIQ.generateLocalIssueId)();
        const optimisticProperties = {
            ...state.properties,
            issueType: {
                ...state.properties.issueType,
                [(0, $9a5f06039e1dff5a$export$dd03acb09519222)]: {
                    ...state.properties.issueType[0, $9a5f06039e1dff5a$export$dd03acb09519222],
                    [id]: issueType
                }
            },
            string: {
                ...state.properties.string,
                summary: {
                    ...state.properties.string.summary,
                    [id]: summary
                }
            },
            created: {
                ...state.properties.created,
                [id]: {
                    status: (0, $d5435e25fbd81376$export$2990a40bc316c88b),
                    groupType: (0, $d5435e25fbd81376$export$e209eb8cb8e09aba),
                    anchorBefore: undefined,
                    anchorAfter: undefined
                }
            }
        };
        const fieldMappings = (0, $iehDF.getFieldMappings)(state, props);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.entries(optimisticUpdateFields).forEach(([fieldKey, fieldValue])=>{
            fieldMappings[fieldKey].setMutable(optimisticProperties, id, fieldValue);
        });
        setState({
            properties: optimisticProperties,
            ids: [
                ...state.ids,
                id
            ]
        });
        onOptimisticCreationFinished(id);
        dispatch((0, $dVE1x.incrementOpenUpdateCounter)([
            id
        ]));
        issuesRemote.createIssue({
            rankField: rankField,
            issueTypeId: Number(issueType.id),
            fieldsMap: {
                summary: summary
            },
            isRankingEnabled: isRankingEnabled,
            onCreated: (jiraIssueId)=>(0, $jkDvC.updateLocalIssueIdToJiraId)(id, Number(jiraIssueId), getState, setState)
        }).then((response)=>{
            const stateForUpdateOperation = getState();
            const { created: created } = stateForUpdateOperation.properties;
            const newCreated = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(created, id);
            const properties = {
                ...stateForUpdateOperation.properties,
                created: newCreated
            };
            const updatedProperties = (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(fieldMappings, (acc, mapping)=>{
                const v = mapping.getValueFromJiraIssue(response);
                return mapping.setImmutable(acc, id, v !== null ? v : undefined);
            }, properties);
            const newState = {
                ...getState(),
                properties: updatedProperties
            };
            setState(newState);
            const filteredIds = (0, $j9i1D.getFilteredIssueIds)(newState, props);
            const isFiltered = !filteredIds.includes(id);
            updateOperation(id, newState, response, isFiltered);
            const analyticsEvent = createAnalyticsEvent({});
            analyticsEvent.context.push({
                objectId: String(response.id),
                objectType: 'issue',
                source: analyticsSource
            });
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'issue created', String(response.id), {
                ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(id)(getState()),
                projectType: (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)
            });
        }).catch((error)=>{
            onIssueCreationFailed(error, issueType.id);
        });
    };
const $ae057e080bec9b88$export$6bf5ec2facb27b17 = ({ localIssueIdToConnect: localIssueIdToConnect, summary: summary, issueType: issueType, analyticsSource: analyticsSource })=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { projectId: projectId, rankField: rankField, isRankingEnabled: isRankingEnabled, issuesRemote: issuesRemote, onIssueCreationFailed: onIssueCreationFailed, createAnalyticsEvent: createAnalyticsEvent } = props;
        if (projectId === undefined || issueType === undefined) // TODO proper error handling
        throw new Error('project / issueType undefined');
        const state = getState();
        const localIssueId = (0, $g3PIQ.generateLocalIssueId)();
        try {
            const createdIssue = await issuesRemote.createIssue({
                rankField: rankField,
                issueTypeId: Number(issueType.id),
                fieldsMap: {
                    summary: summary
                },
                isRankingEnabled: isRankingEnabled,
                onCreated: (jiraIssueId)=>(0, $jkDvC.updateLocalIssueIdToJiraId)(localIssueId, Number(jiraIssueId), getState, setState)
            });
            const stateAfterUpdate = getState();
            const fieldMappings = (0, $iehDF.getFieldMappings)(stateAfterUpdate, props);
            const updatedProperties = (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(fieldMappings, (acc, mapping)=>{
                const value = mapping.getValueFromJiraIssue(createdIssue);
                return mapping.setImmutable(acc, localIssueId, value ?? undefined);
            }, stateAfterUpdate.properties);
            setState({
                properties: updatedProperties,
                ids: [
                    ...state.ids,
                    localIssueId
                ]
            });
            dispatch((0, $cHovn.updateIssueConnections)({
                localIssueId: localIssueIdToConnect,
                issuesToConnect: [
                    {
                        id: createdIssue.id
                    }
                ]
            }));
            const analyticsEvent = createAnalyticsEvent({});
            analyticsEvent.context.push({
                objectId: String(createdIssue.id),
                objectType: 'issue',
                source: analyticsSource
            });
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'issue created', String(createdIssue.id), {
                ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(localIssueId)(getState()),
                projectType: (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)
            });
        } catch (error) {
            if (error instanceof Error) onIssueCreationFailed(error, issueType.id);
        }
    };
const $ae057e080bec9b88$export$cbb9025f442bf2ad = ()=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const { properties: properties } = state;
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const created = (0, $4TCfW.getCreatedProperties)(state, props);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const createdIssueIds = (0, $4TCfW.getCreatedIssueIds)(state, props);
        const newCreated = {};
        createdIssueIds.forEach((id)=>{
            if (created[id].status !== (0, $d5435e25fbd81376$export$eaf097cc0aa4ca13)) newCreated[id] = created[id];
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newCreated, properties.created)) return;
        setState({
            properties: {
                ...properties,
                created: newCreated
            }
        });
    };
const $ae057e080bec9b88$export$f6831b188469e7df = (issueTypeId, summary, optimisticUpdateFields, onSuccessfullyCreated, onCreationFinished, onCreationFailed, analyticsSource)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { projectId: projectId, rankField: rankField, isRankingEnabled: isRankingEnabled, issuesRemote: issuesRemote, onIssueCreationFailed: onIssueCreationFailed, createAnalyticsEvent: createAnalyticsEvent } = props;
        if (projectId === undefined || issueTypeId === undefined) throw new Error('project / issueType undefined');
        const state = getState();
        const id = (0, $g3PIQ.generateLocalIssueId)();
        const optimisticProperties = {
            ...state.properties,
            string: {
                ...state.properties.string,
                summary: {
                    ...state.properties.string.summary,
                    [id]: summary
                }
            },
            created: {
                ...state.properties.created,
                [id]: {
                    status: (0, $d5435e25fbd81376$export$2990a40bc316c88b),
                    groupType: (0, $d5435e25fbd81376$export$e209eb8cb8e09aba),
                    anchorBefore: undefined,
                    anchorAfter: undefined
                }
            }
        };
        const fieldMappings = (0, $iehDF.getFieldMappings)(state, props);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.entries(optimisticUpdateFields).forEach(([fieldKey, fieldValue])=>{
            fieldMappings[fieldKey].setMutable(optimisticProperties, id, fieldValue);
        });
        setState({
            properties: optimisticProperties,
            ids: [
                ...state.ids,
                id
            ]
        });
        dispatch((0, $dVE1x.incrementOpenUpdateCounter)([
            id
        ]));
        issuesRemote.createIssue({
            rankField: rankField,
            issueTypeId: Number(issueTypeId),
            fieldsMap: optimisticUpdateFields,
            isRankingEnabled: isRankingEnabled,
            onCreated: (jiraIssueId)=>(0, $jkDvC.updateLocalIssueIdToJiraId)(id, Number(jiraIssueId), getState, setState)
        }).then(async (response)=>{
            const stateForUpdateOperation = getState();
            const { created: created } = stateForUpdateOperation.properties;
            const newCreated = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(created, id);
            const properties = {
                ...stateForUpdateOperation.properties,
                created: newCreated
            };
            const updatedProperties = (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(fieldMappings, (acc, mapping)=>{
                const v = mapping.getValueFromJiraIssue(response);
                return mapping.setImmutable(acc, id, v !== null ? v : undefined);
            }, properties);
            const teamFieldKey = props.fields?.find((field)=>field.type === (0, $eTBmS.FIELD_TYPES).TEAM)?.key;
            const avatarUrl = await (0, $9448e.getTeamAvatarUrlForIssue)(response, teamFieldKey, props.cloudId);
            if (teamFieldKey && avatarUrl) {
                const updatedTeamValue = updatedProperties.team[teamFieldKey][id];
                if (updatedTeamValue) updatedProperties.team[teamFieldKey][id] = {
                    ...updatedTeamValue,
                    avatarUrl: avatarUrl
                };
            }
            const newState = {
                ...getState(),
                properties: updatedProperties
            };
            setState(newState);
            const filteredIds = (0, $j9i1D.getFilteredIssueIds)(newState, props);
            const isFiltered = !filteredIds.includes(id);
            const analyticsEvent = createAnalyticsEvent({});
            analyticsEvent.context.push({
                objectId: String(response.id),
                objectType: 'issue',
                source: analyticsSource
            });
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'issue created', String(response.id), {
                ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(id)(getState()),
                projectType: (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)
            });
            onSuccessfullyCreated(response.key, isFiltered);
        }).catch((error)=>{
            setState(state);
            onIssueCreationFailed(error, issueTypeId);
            onCreationFailed(error);
        }).finally(()=>onCreationFinished());
    };
const $ae057e080bec9b88$export$b2b683a22fb35867 = (createdId, createdInstance)=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const { properties: properties } = state;
        const { created: created } = properties;
        const createdRankingAllowed = createdInstance.groupType === (0, $d5435e25fbd81376$export$870d962ddd4b82d4) || createdInstance.groupType === (0, $d5435e25fbd81376$export$49f6ea3702b3924f) || createdInstance.groupType === (0, $d5435e25fbd81376$export$7c2ebc4b06c12232) ? createdInstance.rankingAllowed : undefined;
        const createdAnchorBefore = createdInstance.anchorBefore;
        const createdAnchorAfter = createdInstance.anchorAfter;
        const ids = (0, $BrRcR.getSortedIssueIds)(state, props);
        if (ids[0] !== createdId) return;
        if (createdRankingAllowed) return;
        if (createdAnchorAfter === undefined || createdAnchorBefore) return;
        const inCreationId = Object.keys(created).find((key)=>created[key].status === (0, $d5435e25fbd81376$export$336731f504687455) && created[key].anchorBefore === undefined && created[key].anchorAfter === createdAnchorAfter);
        if (!inCreationId) return;
        const nextState = {
            ...state,
            properties: {
                ...properties,
                created: {
                    ...created,
                    [inCreationId]: {
                        ...created[inCreationId],
                        anchorBefore: undefined,
                        anchorAfter: createdId
                    }
                }
            }
        };
        setState(nextState);
    };

});
parcelRegister("9448e", function(module, exports) {

$parcel$export(module.exports, "getTeamAvatarUrlForIssue", () => $8444e0fc54a9516a$export$45eca18d83af3fe4);

var $1Ozm9 = parcelRequire("1Ozm9");
const $8444e0fc54a9516a$var$fetchTeamAvatarUrl = async (teamId, cloudId)=>{
    try {
        return (0, $1Ozm9.default)(`/gateway/api/v4/teams/${teamId}?siteId=${cloudId}`).then((response)=>response.smallAvatarImageUrl);
    } catch (error) {
        return undefined;
    }
};
const $8444e0fc54a9516a$export$45eca18d83af3fe4 = async (newIssue, teamFieldKey, cloudId)=>{
    if (!teamFieldKey || !cloudId) return;
    const teamValue = newIssue.fields[teamFieldKey];
    if (!teamValue || !Object.hasOwn(teamValue, 'id') || teamValue.avatarUrl) return;
    return $8444e0fc54a9516a$var$fetchTeamAvatarUrl(teamValue.id, cloudId);
};

});

parcelRegister("jkDvC", function(module, exports) {

$parcel$export(module.exports, "createIssueInternal", () => $cc6838286ac0531e$export$f5e46624bd50fcf);
$parcel$export(module.exports, "updateLocalIssueIdToJiraId", () => $cc6838286ac0531e$export$ced2293e9962060c);
$parcel$export(module.exports, "getFieldsToUpdate", () => $cc6838286ac0531e$export$21d99a2a1259b5d6);
$parcel$export(module.exports, "getFieldsToUpdatePayload", () => $cc6838286ac0531e$export$e74a6e0fd6f8849c);
$parcel$export(module.exports, "saveIssueInternal", () => $cc6838286ac0531e$export$c87ad381dda60a2c);

var $jFHCE = parcelRequire("jFHCE");

var $3zv7S = parcelRequire("3zv7S");

var $7jTnu = parcelRequire("7jTnu");


var $gCeeo = parcelRequire("gCeeo");

var $iehDF = parcelRequire("iehDF");

var $j9i1D = parcelRequire("j9i1D");


var $dVE1x = parcelRequire("dVE1x");

var $cNkV6 = parcelRequire("cNkV6");
const $cc6838286ac0531e$var$getNewSortedIds = (ids, newId, before, after)=>{
    const newIds = [
        ...ids
    ];
    if (before === undefined && after === undefined) newIds.push(newId);
    if (before !== undefined) {
        const index = newIds.indexOf(before);
        newIds.splice(index, 0, newId);
    }
    if (before === undefined && after !== undefined) {
        const index = newIds.indexOf(after);
        newIds.splice(index + 1, 0, newId);
    }
    return newIds;
};
const $cc6838286ac0531e$export$a2d53d769f911abc = (state, id)=>{
    const { properties: properties } = state;
    const { created: created } = properties;
    const newCreated = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(created, id);
    return {
        ...state,
        properties: {
            ...properties,
            created: newCreated
        }
    };
};
const $cc6838286ac0531e$export$f5e46624bd50fcf = ({ state: state, newId: newId, rankBefore: rankBefore, rankAfter: rankAfter, grouping: grouping })=>{
    const { properties: properties } = state;
    const { created: created } = properties;
    const rankedIds = state.ids;
    const newIds = $cc6838286ac0531e$var$getNewSortedIds(rankedIds, newId, rankBefore, rankAfter);
    const newProperties = {
        ...properties,
        created: {
            ...created,
            [newId]: {
                ...grouping,
                status: (0, $d5435e25fbd81376$export$336731f504687455),
                anchorBefore: rankAfter,
                anchorAfter: rankBefore
            }
        }
    };
    return {
        ...state,
        ids: newIds,
        properties: newProperties
    };
};
const $cc6838286ac0531e$export$4844f16798e29b0a = (state, id, fieldMappings, fetchResponse)=>{
    const { properties: properties } = state;
    const newProperties = (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(fieldMappings, (acc, mapping)=>{
        const fieldValue = mapping.getValueFromJiraIssue(fetchResponse);
        return mapping.setImmutable(acc, id, fieldValue !== null ? fieldValue : undefined);
    }, properties);
    return {
        ...state,
        properties: {
            ...newProperties
        }
    };
};
const $cc6838286ac0531e$export$ced2293e9962060c = (localIssueId, jiraIssueId, getState, setState)=>{
    const { properties: properties } = getState();
    const { number: number } = properties;
    const issueIds = number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e];
    setState({
        properties: {
            ...properties,
            number: {
                ...number,
                [(0, $9a5f06039e1dff5a$export$48927a8f78b0130e)]: {
                    ...issueIds,
                    [localIssueId]: jiraIssueId
                }
            }
        }
    });
};
const $cc6838286ac0531e$export$21d99a2a1259b5d6 = (createdIssueData)=>{
    const fieldsToUpdate = {};
    if (createdIssueData.groupType === (0, $d5435e25fbd81376$export$870d962ddd4b82d4)) {
        const { fieldKey: fieldKey, fieldValue: fieldValue } = createdIssueData;
        if (// In case view is grouped by issue type, issue is created with specific issue type defined by user selection
        // in the input. In this case we don't want to update issue type of issue from grouping after creation.
        fieldValue && fieldKey !== (0, $9a5f06039e1dff5a$export$dd03acb09519222)) fieldsToUpdate[fieldKey] = fieldValue;
    }
    return fieldsToUpdate;
};
const $cc6838286ac0531e$export$e74a6e0fd6f8849c = (fieldsToUpdate)=>{
    return Object.entries(fieldsToUpdate).reduce((acc, [keyToUpdate, valueToUpdate])=>{
        acc[keyToUpdate] = {
            newValue: valueToUpdate,
            appendMultiValues: true
        };
        return acc;
    }, {});
};
const $cc6838286ac0531e$export$c87ad381dda60a2c = (getState, setState, dispatch, props, id, issueTypeId, summary, clonedCreatedProperty, clonedIds, onCreatedIssueFiltered, onIssueSaved, onIssueSaveError)=>{
    const { projectId: projectId, rankField: rankField, isRankingEnabled: isRankingEnabled, createAnalyticsEvent: createAnalyticsEvent, issuesRemote: issuesRemote } = props;
    if (projectId === undefined || issueTypeId === undefined) {
        props.onIssueCreationFailed(new Error('project / issueType undefined'), issueTypeId);
        return;
    }
    const state = getState();
    const { ids: ids, properties: properties } = state;
    const { created: created, string: string } = properties;
    let createdIssueData = created[id];
    if (!createdIssueData) // +----------------------+
    // |                      |
    // |     createIssue      |
    // |                      |
    // +----------------------+
    // 	 +----------------------+
    // 	 |                      |
    // 	 |     cancelIssues     |
    // 	 |                      |
    // 	 +----------------------+
    // 							 +---------------------------------+
    // 							 |                                 |
    // 							 |   Type in CreateIdeaRow input   |                                          |
    // 							 |                                 |                                          |
    // 							 +---------------------------------+                                          |
    // 																+-----------------------------------------|------------------------+
    // 																| +--------------------------+            |                        |
    // 																| |   FORM SUBMISSION        |            |                        |
    // 																| |   HIT ENTER / ON BLUR    |            |                        |
    // 																| +--------------------------+            |                        |
    // 																|   +-------------------------------------|---------+              |                    RACE CONDITION
    // 																|   |                                     |         |              |
    // 																|   |     saveIssue                       |-------------------------------------------  We expect to have
    // 																|   |                                     |         |              |                    `created[id]` in the state
    // 																|   +-------------------------------------|---------+              |                    but it was removed by
    // 																+-----------------------------------------|------------------------+                    `createIssue` call
    // 																										  |
    // 																+-----------------------------------------|------------------------+
    // 																| +--------------------------+            |                        |
    // 																| |   CLICK CREATE AN INPUT  |            |                        |
    // 																| +--------------------------+            |                        |
    // 																|                                         |                        |
    // 																|    +----------------------+             |                        |
    // 																|    |                      |             |                        |
    // 																|    |     createIssue      |             |                        |
    // 																|    |                      |             |                        |
    // 																|    +----------------------+             |                        |
    // 																|         +----------------------+        |                        |
    // 																|         |                      |        |                        |
    // 																|         |     cancelIssues     |        |                        |
    // 																|         |                      |        |                        |
    // 																|         +----------------------+        |                        |
    // 																+-----------------------------------------|------------------------+
    // 																										  |
    // 																										  |
    // 																										  |
    //
    // There is possibility that race condition may happen
    // and at the moment when `getState()` is called
    // the `created` property was cleared out by `createIssue` action.
    // To fix that particular case, we pass clones of `clonedCreatedProperty` and `clonedIds`
    // to ensure that `saveAction()` can correctly finish its work.
    createdIssueData = clonedCreatedProperty;
    let shouldUpdateIds = false;
    let updatedIds = [];
    let index = ids.indexOf(id);
    let anchorAfterId = ids[index + 1];
    if (index === -1) {
        shouldUpdateIds = true;
        index = clonedIds.indexOf(id);
        anchorAfterId = clonedIds[index + 1];
        updatedIds = $cc6838286ac0531e$var$getNewSortedIds(ids, id, anchorAfterId);
    }
    const anchorAfterIssueKey = properties.string[0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b]?.[anchorAfterId];
    setState({
        properties: {
            ...properties,
            // optimistic update of summary
            string: {
                ...string,
                [(0, $9a5f06039e1dff5a$export$469f8bf472cb9ca)]: {
                    ...string[0, $9a5f06039e1dff5a$export$469f8bf472cb9ca],
                    [id]: summary
                }
            },
            // change status of created issue to 'in transition'
            created: {
                ...created,
                [id]: {
                    ...createdIssueData,
                    status: (0, $d5435e25fbd81376$export$2990a40bc316c88b)
                }
            }
        },
        // Ensure that `ids` contains `created[id]`
        ids: shouldUpdateIds ? updatedIds : ids
    });
    let fieldsToUpdate = {};
    if ((0, $7jTnu.fg)('jpd_quick_import_copy_paste_rest_req')) fieldsToUpdate = $cc6838286ac0531e$export$21d99a2a1259b5d6(createdIssueData);
    else if (createdIssueData.groupType === (0, $d5435e25fbd81376$export$870d962ddd4b82d4)) {
        const { fieldKey: fieldKey, fieldValue: fieldValue } = createdIssueData;
        if (// In case view is grouped by issue type, issue is created with specific issue type defined by user selection
        // in the input. In this case we don't want to update issue type of issue from grouping after creation.
        fieldValue && fieldKey !== (0, $9a5f06039e1dff5a$export$dd03acb09519222)) fieldsToUpdate[fieldKey] = fieldValue;
    }
    const fetchStart = performance.now();
    dispatch((0, $dVE1x.incrementOpenUpdateCounter)([
        id
    ]));
    issuesRemote.createIssue({
        rankField: rankField,
        issueTypeId: Number(issueTypeId),
        fieldsMap: {
            summary: summary
        },
        isRankingEnabled: isRankingEnabled,
        onCreated: (jiraIssueId)=>$cc6838286ac0531e$export$ced2293e9962060c(id, Number(jiraIssueId), getState, setState),
        anchorAfterIssueKey: anchorAfterIssueKey
    }).then((response)=>{
        const fieldMappings = (0, $iehDF.getFieldMappings)(getState(), props);
        // update issue data
        const stateAfterFetch = $cc6838286ac0531e$export$4844f16798e29b0a(getState(), id, fieldMappings, response);
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'createIdea success', {
            durationMs: Math.round(performance.now() - fetchStart)
        });
        // Clone `created[id]`
        // before removing it from the state after calling `clearCreatedIssueState`
        const clonedCreatedPropertyAfterFetch = {
            ...state.properties.created[id]
        };
        const stateWithClearCreatedIssue = $cc6838286ac0531e$export$a2d53d769f911abc(stateAfterFetch, id);
        setState({
            ...stateWithClearCreatedIssue
        });
        setState({
            lastUpdatedIssueIds: [
                id
            ]
        });
        onIssueSaved?.({
            issueId: response.id,
            localIssueId: id,
            createdProperty: clonedCreatedPropertyAfterFetch
        });
        if (Object.keys(fieldsToUpdate).length > 0) dispatch((0, $cNkV6.updateFieldValues)({
            fields: (0, $7jTnu.fg)('jpd_quick_import_copy_paste_rest_req') ? $cc6838286ac0531e$export$e74a6e0fd6f8849c(fieldsToUpdate) : Object.entries(fieldsToUpdate).reduce((acc, [keyToUpdate, valueToUpdate])=>{
                acc[keyToUpdate] = {
                    newValue: valueToUpdate,
                    appendMultiValues: true
                };
                return acc;
            }, {}),
            localIssueIds: [
                id
            ]
        }));
        setState({
            lastUpdatedAction: (0, $d5435e25fbd81376$export$536f1c793405c625)
        });
        const filteredIssueIds = (0, $j9i1D.getFilteredIssueIds)(getState(), props);
        if (!filteredIssueIds.includes(id)) onCreatedIssueFiltered(id);
    }).catch((error)=>{
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'createIdea failure', {
            durationMs: Math.round(performance.now() - fetchStart)
        });
        props.onIssueCreationFailed(error, issueTypeId);
        onIssueSaveError && onIssueSaveError(error);
    });
};

});



parcelRegister("uC972", function(module, exports) {

$parcel$export(module.exports, "setCommentsForSelectedIssue", () => $7489c6d3dd118587$export$d87d38ab54e48c01);
$parcel$export(module.exports, "setTimestampIssueCommentsSeen", () => $7489c6d3dd118587$export$e27f99464bfb1cf7);
$parcel$export(module.exports, "setTimestampCommentsSeen", () => $7489c6d3dd118587$export$d0042b8dee813f29);
$parcel$export(module.exports, "signalCommentsUpdates", () => $7489c6d3dd118587$export$9d6cf64e5bc76fc4);

var $gyMEu = parcelRequire("gyMEu");

var $7jTnu = parcelRequire("7jTnu");

var $iWbQb = parcelRequire("iWbQb");

var $feobD = parcelRequire("feobD");

var $4TCfW = parcelRequire("4TCfW");


var $lr3tD = parcelRequire("lr3tD");
const $7489c6d3dd118587$export$d87d38ab54e48c01 = (issueKey, comments)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const selectedIssueLocalIssueId = (0, $4TCfW.getSelectedIssueLocalIssueId)(state);
        const keyProperties = (0, $4TCfW.getKeyProperties)(state);
        if (selectedIssueLocalIssueId === undefined || keyProperties[selectedIssueLocalIssueId] !== issueKey) return;
        setState({
            lastUpdatedIssueIds: [
                selectedIssueLocalIssueId
            ],
            lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined,
            properties: {
                ...state.properties,
                issueMetadata: {
                    ...state.properties.issueMetadata,
                    [selectedIssueLocalIssueId]: {
                        ...state.properties.issueMetadata[selectedIssueLocalIssueId],
                        comments: (0, $gyMEu.getCommentsMeta)(comments)
                    }
                }
            }
        });
    };
const $7489c6d3dd118587$export$e27f99464bfb1cf7 = (localIssueId, timestampCurrentUserSeenComments)=>async ({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const isIssueHavingUnseenComments = (0, $feobD.createIsIssueHavingUnseenComments)(localIssueId)(state, props);
        if (!isIssueHavingUnseenComments) return;
        const { issuesRemote: issuesRemote } = props;
        setState({
            properties: {
                ...state.properties,
                commentsMetadata: {
                    ...state.properties.commentsMetadata,
                    [localIssueId]: {
                        timestampCurrentUserSeenComments: timestampCurrentUserSeenComments
                    }
                }
            }
        });
        const jiraIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
        const issueId = jiraIdMap[localIssueId];
        if (issueId !== undefined) issuesRemote.updateLastCommentsViewedTimestamp({
            issueId: issueId,
            timestamp: new Date(timestampCurrentUserSeenComments).toISOString(),
            projectId: (0, $lr3tD.createGetProject)(localIssueId)(state)?.id
        });
    };
const $7489c6d3dd118587$export$d0042b8dee813f29 = (timestampCurrentUserSeenComments)=>async ({ getState: getState, dispatch: dispatch })=>{
        const state = getState();
        const localIssueId = (0, $4TCfW.getSelectedIssueLocalIssueId)(state);
        if (localIssueId === undefined) return;
        dispatch($7489c6d3dd118587$export$e27f99464bfb1cf7(localIssueId, timestampCurrentUserSeenComments));
    };
const $7489c6d3dd118587$export$9d6cf64e5bc76fc4 = ()=>async ({ getState: getState }, props)=>{
        const { onUpdateComments: onUpdateComments } = props;
        const state = getState();
        const issueKey = (0, $4TCfW.getSelectedIssue)(state);
        if (issueKey !== undefined) onUpdateComments?.({
            issueKey: issueKey
        });
    };

});

parcelRegister("651r0", function(module, exports) {

$parcel$export(module.exports, "rankIdeasWithCurrentSorting", () => $ed4a32b7a47e54d4$export$be78e952f2b14ec0);

var $9F2Gy = parcelRequire("9F2Gy");

var $iWbQb = parcelRequire("iWbQb");

var $BrRcR = parcelRequire("BrRcR");
const $ed4a32b7a47e54d4$var$updateRankOnBackend = ({ getState: getState }, props)=>{
    const keys = (0, $BrRcR.getSortedUnfilteredIssueKeys)(getState(), props);
    if (keys.length <= 1) return;
    props.issuesRemote.rankIssues({
        issueKeys: keys,
        rankBeforeIssueKey: keys[0],
        rankAfterIssueKey: undefined,
        rankCustomFieldId: props.rankField !== undefined ? (0, $9F2Gy.toRankCustomFieldId)(props.rankField) : undefined
    }).catch(props.onIssueUpdateFailed);
};
const $ed4a32b7a47e54d4$var$updateStateRanking = ({ setState: setState, getState: getState }, props)=>{
    const sortedIssueIds = (0, $BrRcR.getSortedUnfilteredIssueIds)(getState(), props);
    const issueIdsConsideringArchived = (0, $iWbQb.getIssueIdsConsideringArchived)(getState(), {
        ...props,
        containsArchived: !props.containsArchived
    });
    if (sortedIssueIds.length <= 1) return;
    setState({
        ids: [
            ...sortedIssueIds,
            ...issueIdsConsideringArchived
        ]
    });
};
const $ed4a32b7a47e54d4$export$be78e952f2b14ec0 = ()=>(storeActionApi, props)=>{
        const { isRankingEnabled: isRankingEnabled } = props;
        if (!isRankingEnabled) return;
        $ed4a32b7a47e54d4$var$updateRankOnBackend(storeActionApi, props);
        $ed4a32b7a47e54d4$var$updateStateRanking(storeActionApi, props);
    };

});
parcelRegister("9F2Gy", function(module, exports) {

$parcel$export(module.exports, "toRankCustomFieldId", () => $9bcc0c1c0fe14a8f$export$b856656073f169b9);
const $9bcc0c1c0fe14a8f$export$b856656073f169b9 = (value)=>{
    let id = value;
    if (id.includes('customfield_', 0)) [, id] = value.split('_');
    return id;
};

});


parcelRegister("59oat", function(module, exports) {

$parcel$export(module.exports, "createDynamicFieldSelectors", () => $e7c02033deb46e60$export$f51f18619c3d429c);
$parcel$export(module.exports, "scheduleDynamicFieldCalculation", () => $e7c02033deb46e60$export$61a8f068a8003cc9);
$parcel$export(module.exports, "updateDynamicFieldSelector", () => $e7c02033deb46e60$export$f096d7f9a3105298);

var $b5oGV = parcelRequire("b5oGV");

var $6XSXq = parcelRequire("6XSXq");

var $3degy = parcelRequire("3degy");

var $2kRwo = parcelRequire("2kRwo");
const $e7c02033deb46e60$var$createDynamicPropertyMaps = (fields, dynamicProperties)=>{
    // only concern ourselves with dynamic fields. Currently defined as fields that have a formula.
    const dynamicFields = (fields || []).filter((field)=>field.formula !== undefined);
    // use the dynamic fields utils to create the dynamic properties state structure
    return (0, $2kRwo.resolveDynamicFields)(dynamicFields, dynamicProperties);
};
const $e7c02033deb46e60$export$f51f18619c3d429c = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { fields: fields })=>{
        const dynamicProperties = $e7c02033deb46e60$var$createDynamicPropertyMaps(fields, getState().dynamicProperties);
        // write to state
        setState({
            dynamicProperties: dynamicProperties
        });
        dispatch($e7c02033deb46e60$export$61a8f068a8003cc9());
    };
const $e7c02033deb46e60$export$61a8f068a8003cc9 = ()=>({ getState: getState }, props)=>{
        if (!getState().meta.initialized) return;
        if (props.onDynamicFieldStoreInitialized() !== undefined) {
            // added/removed field
            if (props.fields?.length !== getState().prevContainerProps?.fields?.length) props.fields?.forEach((field)=>{
                props.onDynamicFieldInitialized(field.key);
            });
            return;
        }
        const cacheNode = (0, $3degy.getCacheValue)((0, $2kRwo.createFullPropertyValuesSelectorInternal));
        cacheNode && [
            ...cacheNode.args.values()
        ].forEach((node)=>{
            (0, $6XSXq.callWhenIdle)(()=>{
                (0, $b5oGV.experience).formulaField.precalculateFormulaFieldAllValuesSelector.start();
                node.selector?.(getState(), props);
                (0, $b5oGV.experience).formulaField.precalculateFormulaFieldAllValuesSelector.success();
            });
        });
        Object.keys(getState().dynamicProperties.numberValues).forEach((fieldKey)=>{
            const selector = getState().dynamicProperties.numberValues[fieldKey];
            if (fieldKey === undefined) return;
            (0, $6XSXq.callWhenIdle)(()=>{
                (0, $b5oGV.experience).formulaField.precalculateFormulaFieldAllValuesSelector.start();
                selector?.(getState(), props);
                (0, $b5oGV.experience).formulaField.precalculateFormulaFieldAllValuesSelector.success();
                props.onDynamicFieldInitialized(fieldKey);
            });
        });
        Object.keys(getState().dynamicProperties.dateValues).forEach((fieldKey)=>{
            const selector = getState().dynamicProperties.dateValues[fieldKey];
            if (fieldKey === undefined) return;
            (0, $6XSXq.callWhenIdle)(()=>{
                (0, $b5oGV.experience).formulaField.precalculateFormulaFieldAllValuesSelector.start();
                selector?.(getState(), props);
                (0, $b5oGV.experience).formulaField.precalculateFormulaFieldAllValuesSelector.success();
                props.onDynamicFieldInitialized(fieldKey);
            });
        });
    };
const $e7c02033deb46e60$export$f096d7f9a3105298 = (field)=>({ getState: getState, setState: setState })=>{
        const dynamicProperties = $e7c02033deb46e60$var$createDynamicPropertyMaps([
            field
        ], getState().dynamicProperties);
        if (Object.keys(dynamicProperties.numberValue).length) setState({
            dynamicProperties: {
                ...getState().dynamicProperties,
                numberValue: {
                    ...getState().dynamicProperties.numberValue,
                    ...dynamicProperties.numberValue
                }
            }
        });
        if (Object.keys(dynamicProperties.dateValue).length) setState({
            dynamicProperties: {
                ...getState().dynamicProperties,
                dateValue: {
                    ...getState().dynamicProperties.dateValue,
                    ...dynamicProperties.dateValue
                }
            }
        });
        if (Object.keys(dynamicProperties.numberValues).length) setState({
            dynamicProperties: {
                ...getState().dynamicProperties,
                numberValues: {
                    ...getState().dynamicProperties.numberValues,
                    ...dynamicProperties.numberValues
                }
            }
        });
        if (Object.keys(dynamicProperties.dateValues).length) setState({
            dynamicProperties: {
                ...getState().dynamicProperties,
                dateValues: {
                    ...getState().dynamicProperties.dateValues,
                    ...dynamicProperties.dateValues
                }
            }
        });
    };

});
parcelRegister("6XSXq", function(module, exports) {

$parcel$export(module.exports, "callWhenIdle", () => $8638770e300a4099$export$d2542992df1e054);
const $8638770e300a4099$export$d2542992df1e054 = (callback, timeout = 200)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const callbackId = window.requestIdleCallback(callback);
        return ()=>cancelIdleCallback(callbackId);
    }
    const timer = setTimeout(callback, timeout);
    return ()=>{
        clearTimeout(timer);
    };
};

});

parcelRegister("2kRwo", function(module, exports) {

$parcel$export(module.exports, "createFullPropertyValuesSelectorInternal", () => $96cd386a317bb144$export$b07917cdefa4d90b);
$parcel$export(module.exports, "resolveDynamicFields", () => $96cd386a317bb144$export$bdaa24d785354dc2);
$parcel$export(module.exports, "createValueSelectorForFormula", () => $96cd386a317bb144$export$e9a17b3cf691d6e4);

var $ahm5r = parcelRequire("ahm5r");

var $3degy = parcelRequire("3degy");

var $iWbQb = parcelRequire("iWbQb");

var $fLnZn = parcelRequire("fLnZn");
const $96cd386a317bb144$export$b07917cdefa4d90b = (fieldSelectorCreator)=>{
    const perIssueSelectorsSelector = (0, $ahm5r.createSelector)((0, $iWbQb.getIssueIdsForDynamicFormula), (issueIds)=>(0, $ahm5r.createStructuredSelector)(issueIds.reduce((result, issueId)=>Object.assign(result, {
                [issueId]: fieldSelectorCreator(issueId)
            }), {})));
    return (state, props)=>{
        const perIssueSelectors = perIssueSelectorsSelector(state, props);
        return perIssueSelectors(state, props);
    };
};
const $96cd386a317bb144$export$3541ae470955b93d = (0, $3degy.cacheSelectorCreator)($96cd386a317bb144$export$b07917cdefa4d90b);
const $96cd386a317bb144$var$EMPTY_SELECTOR = ()=>undefined;
const $96cd386a317bb144$var$EMPTY_SELECTOR_CREATOR = ()=>$96cd386a317bb144$var$EMPTY_SELECTOR;
/**
 * Attempts to apply a resolver to a field. If the resolver returns a selector creator function,
 * it is assumed that that resolver can handle the current dynamic field. That function will be used
 * as the cache filler function for that dynamic field handler.
 */ const $96cd386a317bb144$var$applyResolver = (maps, field)=>{
    if (field.formula === undefined) return maps;
    const selectorCreator = field.hasCyclicFormulaDependency ? $96cd386a317bb144$var$EMPTY_SELECTOR_CREATOR : (0, $fLnZn.getNumberSelectorForFormula)(field.formula, field.play?.id);
    if (selectorCreator === undefined) return maps;
    return {
        ...maps,
        numberValue: {
            ...maps.numberValue,
            [field.key]: selectorCreator
        },
        numberValues: {
            ...maps.numberValues,
            [field.key]: $96cd386a317bb144$export$3541ae470955b93d(selectorCreator)
        }
    };
};
const $96cd386a317bb144$var$applyDatesResolver = (maps, field)=>{
    if (field.formula === undefined) return maps;
    const selectorCreator = (0, $fLnZn.getDateSelectorForFormula)(field.formula, field.play?.id);
    if (selectorCreator === undefined) return maps;
    return {
        ...maps,
        dateValue: {
            ...maps.dateValue,
            [field.key]: selectorCreator
        },
        dateValues: {
            ...maps.dateValues,
            [field.key]: $96cd386a317bb144$export$3541ae470955b93d(selectorCreator)
        }
    };
};
const $96cd386a317bb144$export$bdaa24d785354dc2 = (fields, maps)=>fields.reduce((merged, field)=>$96cd386a317bb144$var$applyDatesResolver($96cd386a317bb144$var$applyResolver(merged, field), field), maps);
const $96cd386a317bb144$export$e9a17b3cf691d6e4 = (formula)=>{
    const selectorCreator = (0, $fLnZn.getNumberSelectorForFormula)(formula);
    if (selectorCreator === undefined) return undefined;
    return $96cd386a317bb144$export$3541ae470955b93d(selectorCreator);
};

});
parcelRegister("fLnZn", function(module, exports) {

$parcel$export(module.exports, "getNumberSelectorForFormula", () => $14e1ab2c37377273$export$dff13bc7b825cb5d);
$parcel$export(module.exports, "getDateSelectorForFormula", () => $14e1ab2c37377273$export$a57e13599f278e78);

var $3degy = parcelRequire("3degy");

var $2jABX = parcelRequire("2jABX");

var $as15M = parcelRequire("as15M");

var $6tIwq = parcelRequire("6tIwq");

var $2zHux = parcelRequire("2zHux");

var $8oFO8 = parcelRequire("8oFO8");

var $5UOun = parcelRequire("5UOun");

var $h1E7D = parcelRequire("h1E7D");

var $FKIgD = parcelRequire("FKIgD");

var $53aSP = parcelRequire("53aSP");

var $cNHl0 = parcelRequire("cNHl0");

var $gRZDU = parcelRequire("gRZDU");

/**
 * Collect all resolvers in this array. The main field resolution code will attempt to map
 * all dynamic fields to all resolvers, and use the ones that can be applied automatically.
 * Adding new resolvers is thus a declarative operation in this package alone.
 */ const $14e1ab2c37377273$var$numberResolvers = [
    (0, $6tIwq.compositionResolver),
    (0, $2zHux.constantResolver),
    (0, $8oFO8.dataPointsCountDynamicFieldResolver),
    (0, $h1E7D.discreteResolver),
    (0, $FKIgD.exprResolver),
    (0, $53aSP.fieldResolver),
    (0, $2jABX.issuePlayTotalSpentDynamicFieldResolver),
    (0, $5UOun.linkedIssuesCountDynamicFieldResolver),
    (0, $cNHl0.multiselectCountResolver),
    (0, $gRZDU.normalizationResolver),
    (0, $as15M.propertyAggregationSumResolver)
];
const $14e1ab2c37377273$var$datesResolvers = [
    (0, $8oFO8.dataPointsCreatedDynamicFieldResolver)
];
const $14e1ab2c37377273$var$getSelectorForFormula = (resolvers, formula, playId)=>{
    let selectorCreator;
    resolvers.find((resolver)=>{
        const creator = resolver(formula, playId);
        if (creator !== undefined) {
            selectorCreator = creator;
            return true;
        }
        return false;
    });
    if (selectorCreator !== undefined) return (0, $3degy.cacheSelectorCreator)(selectorCreator);
    return selectorCreator;
};
const $14e1ab2c37377273$export$dff13bc7b825cb5d = (0, $3degy.cacheSelectorCreator)((formula, playId)=>$14e1ab2c37377273$var$getSelectorForFormula($14e1ab2c37377273$var$numberResolvers, formula, playId), {
    useJsonEquality: true
});
const $14e1ab2c37377273$export$a57e13599f278e78 = (0, $3degy.cacheSelectorCreator)((formula, playId)=>$14e1ab2c37377273$var$getSelectorForFormula($14e1ab2c37377273$var$datesResolvers, formula, playId), {
    useJsonEquality: true
});

});
parcelRegister("2jABX", function(module, exports) {

$parcel$export(module.exports, "issuePlayTotalSpentDynamicFieldResolver", () => $1619c5e166fed986$export$3835c42775215297);

var $fLExA = parcelRequire("fLExA");

var $4q6Sr = parcelRequire("4q6Sr");
const $1619c5e166fed986$var$FORMULA_TEMPLATE = 'play_agg';
const $1619c5e166fed986$export$3835c42775215297 = (formula, playId)=>{
    if (formula === undefined || formula.template !== $1619c5e166fed986$var$FORMULA_TEMPLATE) return undefined;
    const curriedCreateGetIdeaPlayTotalBudget = (0, (/*@__PURE__*/$parcel$interopDefault($fLExA)))((0, $4q6Sr.createGetIdeaPlayTotalBudget));
    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    return curriedCreateGetIdeaPlayTotalBudget(playId);
};

});
parcelRegister("4q6Sr", function(module, exports) {

$parcel$export(module.exports, "createGetIdeaPlayTotalBudget", () => $ec149d19342f9aa9$export$48be84047c28655d);
$parcel$export(module.exports, "createGetPlaysMediaIds", () => $ec149d19342f9aa9$export$f3ca0a1b7fc484e7);
$parcel$export(module.exports, "createGetIdeaPlaysIdsWithContributions", () => $ec149d19342f9aa9$export$e172528c0f8b7df8);
$parcel$export(module.exports, "createGetIdeaPlayTotalContributors", () => $ec149d19342f9aa9$export$60c7a4734f10d54);
$parcel$export(module.exports, "createGetIdeaPlayContributions", () => $ec149d19342f9aa9$export$9a15c997ce8d94e1);
$parcel$export(module.exports, "createGetIdeaPlayUserContribution", () => $ec149d19342f9aa9$export$314b0b687fa6404c);
$parcel$export(module.exports, "createGetIdeaPlayContributorsAvatars", () => $ec149d19342f9aa9$export$3128616e71aef697);
$parcel$export(module.exports, "createGetPlayContributionsStats", () => $ec149d19342f9aa9$export$255e8e6f8ae89dd);
$parcel$export(module.exports, "createGetPlayContributionsAmountIssuesCounts", () => $ec149d19342f9aa9$export$1aa7184b4702752d);

var $ahm5r = parcelRequire("ahm5r");

var $aX8Tx = parcelRequire("aX8Tx");

var $eI1yv = parcelRequire("eI1yv");

var $jOCpp = parcelRequire("jOCpp");

var $8oKDI = parcelRequire("8oKDI");

var $ivkPv = parcelRequire("ivkPv");

var $4TCfW = parcelRequire("4TCfW");
const $ec149d19342f9aa9$var$EMPTY_CONTRIBUTIONS = Object.freeze({});
const $ec149d19342f9aa9$export$8f700a4bf2988eeb = (state)=>(0, $4TCfW.getProperties)(state).plays;
const $ec149d19342f9aa9$export$8a51c84bc55e3eb1 = (playId)=>(0, $ahm5r.createSelector)($ec149d19342f9aa9$export$8f700a4bf2988eeb, (playContributionsMap)=>{
        const playResourceId = (0, $8oKDI.getAriConfig)(playId).resourceId;
        return playContributionsMap[playResourceId] ?? $ec149d19342f9aa9$var$EMPTY_CONTRIBUTIONS;
    });
const $ec149d19342f9aa9$export$48be84047c28655d = (playId, id)=>{
    const playContributions = $ec149d19342f9aa9$export$8a51c84bc55e3eb1(playId);
    return (0, $ahm5r.createSelector)(playContributions, (contributionsMap)=>(contributionsMap[id] ?? []).reduce((acc, { amount: amount = 0 })=>acc + amount, 0));
};
const $ec149d19342f9aa9$export$f3ca0a1b7fc484e7 = (0, $ahm5r.createSelector)($ec149d19342f9aa9$export$8f700a4bf2988eeb, (contributionsMap)=>(0, (/*@__PURE__*/$parcel$interopDefault($eI1yv)))((0, (/*@__PURE__*/$parcel$interopDefault($eI1yv)))(Object.values(contributionsMap).map((contributions)=>Object.values(contributions))).map((contribution)=>(0, $ivkPv.getMediaIds)(contribution?.comment?.body))));
const $ec149d19342f9aa9$export$e172528c0f8b7df8 = (localIssueId)=>(0, $ahm5r.createSelector)($ec149d19342f9aa9$export$8f700a4bf2988eeb, (contributionsMap)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.keys(contributionsMap).reduce((result, playId)=>{
            Object.keys(contributionsMap[playId]).forEach((id)=>{
                if (localIssueId !== id || contributionsMap[playId][id].length === 0) return;
                Object.assign(result, {
                    [playId]: contributionsMap[playId][id]
                });
            });
            return result;
        }, {}));
const $ec149d19342f9aa9$export$60c7a4734f10d54 = (playId, id)=>{
    const playContributions = $ec149d19342f9aa9$export$8a51c84bc55e3eb1(playId);
    return (0, $ahm5r.createSelector)(playContributions, (contributionsMap)=>(contributionsMap[id] ?? []).length);
};
const $ec149d19342f9aa9$export$9a15c997ce8d94e1 = (playId, id)=>{
    const playContributions = $ec149d19342f9aa9$export$8a51c84bc55e3eb1(playId);
    return (0, $ahm5r.createSelector)(playContributions, (contributionsMap)=>contributionsMap[id] ?? []);
};
const $ec149d19342f9aa9$export$314b0b687fa6404c = (playId, localIssueId, accountId)=>{
    const getIdeaPlayContributions = $ec149d19342f9aa9$export$9a15c997ce8d94e1(playId, localIssueId);
    return (0, $ahm5r.createSelector)(getIdeaPlayContributions, (contributions)=>contributions.filter(({ aaid: aaid })=>aaid === accountId)[0]);
};
const $ec149d19342f9aa9$export$3128616e71aef697 = (playId, localIssueId)=>{
    const getIdeaPlayContributions = $ec149d19342f9aa9$export$9a15c997ce8d94e1(playId, localIssueId);
    return (0, $ahm5r.createSelector)(getIdeaPlayContributions, (contributions)=>{
        const c = contributions.map(({ author: author })=>{
            if (author === undefined) return undefined;
            return {
                href: '#',
                src: author.avatarUrls['48x48']
            };
        }).filter(Boolean);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(c, 'src');
    });
};
const $ec149d19342f9aa9$export$255e8e6f8ae89dd = (playId)=>{
    const playContributions = $ec149d19342f9aa9$export$8a51c84bc55e3eb1(playId);
    return (0, $ahm5r.createSelector)(playContributions, (contributionsMap)=>{
        const contributions = (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(Object.keys(contributionsMap).map((key)=>contributionsMap[key]));
        const stats = contributions.reduce((acc, { amount: amount })=>({
                votes: acc.votes + (amount ?? 0),
                comments: acc.comments + 1
            }), {
            votes: 0,
            comments: 0
        });
        const voters = [
            ...new Set(contributions.map(({ aaid: aaid })=>aaid))
        ].length;
        return {
            ...stats,
            voters: voters
        };
    });
};
const $ec149d19342f9aa9$export$1aa7184b4702752d = (playId, ids)=>{
    const playContributions = $ec149d19342f9aa9$export$8a51c84bc55e3eb1(playId);
    return (0, $ahm5r.createSelector)(playContributions, (contributions)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        ids.forEach((localId)=>{
            result[localId] = (contributions[localId] ?? []).reduce((acc, { amount: amount = 0 })=>acc + amount, 0);
        });
        return result;
    });
};

});


parcelRegister("as15M", function(module, exports) {

$parcel$export(module.exports, "propertyAggregationSumResolver", () => $669d4a6149eff12a$export$680f1a59dc48dcc4);

var $ahm5r = parcelRequire("ahm5r");

var $a97Xf = parcelRequire("a97Xf");

var $gXFKK = parcelRequire("gXFKK");

var $7SDB8 = parcelRequire("7SDB8");
const $669d4a6149eff12a$var$FORMULA_TEMPLATE = 'property_agg';
const $669d4a6149eff12a$var$AGGREGATION = 'sum';
const $669d4a6149eff12a$export$680f1a59dc48dcc4 = (formula)=>{
    if (formula === undefined || formula.template !== $669d4a6149eff12a$var$FORMULA_TEMPLATE) return undefined;
    if (formula.parameters.agg !== $669d4a6149eff12a$var$AGGREGATION) return undefined;
    const propertyKeyForAggregation = formula.parameters.key;
    return (localIssueId)=>{
        const getIdeaSnippets = (0, $7SDB8.createGetSnippets)(localIssueId, formula.parameters.filter, formula.parameters.oauthClientId);
        return (0, $ahm5r.createSelector)(getIdeaSnippets, (snippets)=>{
            const propValues = snippets.map(({ properties: properties })=>{
                const value = (0, $gXFKK.getSnippetPropertyValue)(properties, propertyKeyForAggregation);
                if (typeof value === 'number') return value;
                return undefined;
            }).filter(Boolean);
            return (0, (/*@__PURE__*/$parcel$interopDefault($a97Xf)))(propValues);
        });
    };
};

});
parcelRegister("gXFKK", function(module, exports) {

$parcel$export(module.exports, "isConfigurePropertiesAction", () => $c6598b83480062d6$export$6ec9eabdf6ea0372);
$parcel$export(module.exports, "validSnippetActions", () => $c6598b83480062d6$export$8376f65bc8c94bd3);
$parcel$export(module.exports, "getSnippetPropertyValue", () => $c6598b83480062d6$export$2a1ef78d6143f0f3);
$parcel$export(module.exports, "getSnippetPropertyName", () => $c6598b83480062d6$export$62e8e1cdca2a9315);
$parcel$export(module.exports, "getSnippetPropertyType", () => $c6598b83480062d6$export$39886ac8332997c1);
$parcel$export(module.exports, "getSnippetPropertyNameDecoration", () => $c6598b83480062d6$export$414f9ec54b8dcc79);
$parcel$export(module.exports, "getSnippetPropertyValueDecoration", () => $c6598b83480062d6$export$e528d9d8d3f8352e);

var $57raR = parcelRequire("57raR");
var $5fuQp = parcelRequire("5fuQp");
var $fTjQo = parcelRequire("fTjQo");
var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");
const $c6598b83480062d6$export$6ec9eabdf6ea0372 = (action)=>action.type === 'ConfigurePropertiesAction';
const $c6598b83480062d6$export$8376f65bc8c94bd3 = (actions)=>actions?.filter($c6598b83480062d6$export$6ec9eabdf6ea0372) || [];
const $c6598b83480062d6$export$2a1ef78d6143f0f3 = (properties, key)=>{
    if (!properties) return null;
    const value = properties[key];
    if (typeof value === 'object' && !Array.isArray(value) && value !== null) return value.value;
    return value;
};
const $c6598b83480062d6$export$62e8e1cdca2a9315 = (properties, key)=>{
    const value = properties[key];
    if (typeof value === 'object' && !Array.isArray(value) && value !== null) return value.name;
    return key;
};
const $c6598b83480062d6$export$39886ac8332997c1 = (properties, key)=>{
    const value = properties[key];
    if (typeof value === 'object' && !Array.isArray(value) && value !== null) return value.type;
    return undefined;
};
const $c6598b83480062d6$var$camelcase = (value)=>value.charAt(0).toUpperCase() + value.slice(1);
const $c6598b83480062d6$export$414f9ec54b8dcc79 = (name)=>$c6598b83480062d6$var$camelcase(name);
const $c6598b83480062d6$export$e528d9d8d3f8352e = (value, type)=>{
    switch(type){
        case 'timestamp':
            {
                if (typeof value !== 'number') return value;
                const t = (0, $kQ82p.default)((0, $fTjQo.default)(value));
                if ((0, $dBLX0.default)(t)) return (0, $57raR.default)(new Date(t), 'EEEE, MMMM d, yyyy hh:mm a');
                return value;
            }
        case 'duration':
            if (typeof value !== 'number') return value;
            if ((0, $dBLX0.default)(value)) return (0, $5fuQp.default)(0, value);
            return value;
        default:
            if (typeof value === 'string') return $c6598b83480062d6$var$camelcase(value);
            if (Array.isArray(value)) return value.join(', ');
            return value;
    }
};

});

parcelRegister("7SDB8", function(module, exports) {

$parcel$export(module.exports, "createGetInsights", () => $cb59c0ee759be806$export$c4d9aab5f90f2ac2);
$parcel$export(module.exports, "createGetSnippets", () => $cb59c0ee759be806$export$1a18b5836b200c0c);
$parcel$export(module.exports, "createGetInsight", () => $cb59c0ee759be806$export$4ce0137c58ac43af);
$parcel$export(module.exports, "getSortedSnippetLabels", () => $cb59c0ee759be806$export$6c40d18d405344ae);
$parcel$export(module.exports, "getLastSnippetRefresh", () => $cb59c0ee759be806$export$6eab420b1bdd3925);
$parcel$export(module.exports, "getInsightRefreshErrors", () => $cb59c0ee759be806$export$32b377cdaba59cf9);
$parcel$export(module.exports, "getRefreshErrorSnippetsIds", () => $cb59c0ee759be806$export$6c539df961aad432);
$parcel$export(module.exports, "getInsightRefreshErrorCount", () => $cb59c0ee759be806$export$9d22f2260e62d098);
$parcel$export(module.exports, "createGetTimestampCurrentUserSeenInsights", () => $cb59c0ee759be806$export$7800c34257ddd8c9);
$parcel$export(module.exports, "createIsIssueHavingUnseenInsights", () => $cb59c0ee759be806$export$bf8f3dc7c1c95827);
$parcel$export(module.exports, "createGetInsightsForIssue", () => $cb59c0ee759be806$export$62bf0592dd655762);
$parcel$export(module.exports, "createGetInsightsCount", () => $cb59c0ee759be806$export$2531b53a2ccda20c);

var $ahm5r = parcelRequire("ahm5r");

var $6kS6u = parcelRequire("6kS6u");

var $aX8Tx = parcelRequire("aX8Tx");

var $1ilzu = parcelRequire("1ilzu");

var $79hL0 = parcelRequire("79hL0");

var $huH03 = parcelRequire("huH03");

var $6NFx3 = parcelRequire("6NFx3");

var $9pL9Y = parcelRequire("9pL9Y");

var $aiymM = parcelRequire("aiymM");

var $a97Xf = parcelRequire("a97Xf");

var $40zJW = parcelRequire("40zJW");

var $gtr2v = parcelRequire("gtr2v");

var $eiZIr = parcelRequire("eiZIr");

var $3degy = parcelRequire("3degy");

var $gXFKK = parcelRequire("gXFKK");

var $etL83 = parcelRequire("etL83");
const $cb59c0ee759be806$var$getInsightsRaw = (state)=>state.properties.insights;
const $cb59c0ee759be806$export$4c6fae6b2186be47 = (0, $ahm5r.createSelector)($cb59c0ee759be806$var$getInsightsRaw, (insights)=>{
    const newInsights = {};
    return Object.keys(insights).reduce((acc, key)=>Object.assign(acc, {
            [key]: insights[key]?.filter((insight)=>{
                if (insight.play) return false;
                try {
                    // "ari:cloud:jira-product-discovery::item/ac8c6712-6167-4153-8495-6c58253f89a8/158882"
                    return (0, $gtr2v.AnyAri).parse(insight.id).resourceType !== 'item';
                } catch (e) {
                // do nothing
                }
                return true;
            })
        }), newInsights);
});
const $cb59c0ee759be806$var$getInsightsMetadataMap = (state)=>state.properties.insightsMetadata;
const $cb59c0ee759be806$export$c4d9aab5f90f2ac2 = (0, $3degy.cacheSelectorCreator)((id, filter = (0, $eiZIr.TRUE_CONSTANT))=>(0, $ahm5r.createSelector)($cb59c0ee759be806$export$4c6fae6b2186be47, (insights)=>(insights[id] || []).filter((insight)=>(0, $etL83.testInsight)(insight, filter))));
const $cb59c0ee759be806$export$1a18b5836b200c0c = (0, $3degy.cacheSelectorCreator)((id, filter = (0, $eiZIr.TRUE_CONSTANT), oauthClientId)=>{
    const getInsightsForIssue = $cb59c0ee759be806$export$c4d9aab5f90f2ac2(id, filter);
    return (0, $ahm5r.createSelector)(getInsightsForIssue, (insights)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(insights.map(({ snippets: snippets })=>snippets)).filter((snippet)=>oauthClientId === undefined || snippet.appInfo !== undefined && snippet.appInfo?.oauthClientId === oauthClientId));
});
const $cb59c0ee759be806$export$4ce0137c58ac43af = (insightId)=>(0, $ahm5r.createSelector)($cb59c0ee759be806$export$4c6fae6b2186be47, (insightsMap)=>{
        const insights = (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(Object.values(insightsMap));
        return (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(insights, ({ id: id })=>id === insightId);
    });
const $cb59c0ee759be806$var$getAllInsights = (0, $ahm5r.createSelector)($cb59c0ee759be806$export$4c6fae6b2186be47, (insightsByIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))((0, (/*@__PURE__*/$parcel$interopDefault($79hL0)))(insightsByIssue, (insights)=>insights)));
const $cb59c0ee759be806$var$getAllSnippets = (0, $ahm5r.createSelector)($cb59c0ee759be806$var$getAllInsights, (insights)=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))((0, (/*@__PURE__*/$parcel$interopDefault($79hL0)))(insights, ({ snippets: snippets })=>snippets)));
const $cb59c0ee759be806$var$getAllSnippetRefreshStates = (0, $ahm5r.createSelector)($cb59c0ee759be806$var$getAllSnippets, (snippets)=>snippets.map(({ refresh: refresh })=>refresh).filter(Boolean));
const $cb59c0ee759be806$export$6c40d18d405344ae = (0, $ahm5r.createSelector)($cb59c0ee759be806$var$getAllSnippets, (snippets)=>{
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(snippets.map((snippet)=>{
        const value = (0, $gXFKK.getSnippetPropertyValue)(snippet.properties, 'labels');
        return Array.isArray(value) ? value : [];
    }));
    result.sort();
    return (0, (/*@__PURE__*/$parcel$interopDefault($aiymM)))(result);
});
const $cb59c0ee759be806$export$6eab420b1bdd3925 = (0, $ahm5r.createSelector)($cb59c0ee759be806$var$getAllSnippetRefreshStates, (refreshs)=>(0, (/*@__PURE__*/$parcel$interopDefault($6NFx3)))(refreshs.map(({ last: last })=>last).filter(Boolean)));
const $cb59c0ee759be806$var$createGetInsightsByRefreshCondition = (condition)=>(0, $ahm5r.createSelector)($cb59c0ee759be806$export$4c6fae6b2186be47, (insightsByIssue)=>{
        const insightsWithSnippetsMeetingCondition = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(insightsByIssue, (insights)=>insights.map((insight)=>{
                const validSnippets = insight.snippets.filter(({ refresh: refresh })=>refresh !== undefined && condition(refresh));
                if (validSnippets.length > 0) return {
                    ...insight,
                    snippets: validSnippets
                };
                return undefined;
            }).filter(Boolean));
        return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(insightsWithSnippetsMeetingCondition, (insights)=>insights.length > 0);
    });
const $cb59c0ee759be806$export$32b377cdaba59cf9 = $cb59c0ee759be806$var$createGetInsightsByRefreshCondition((refresh)=>refresh?.error !== undefined && refresh.error !== null);
const $cb59c0ee759be806$export$6c539df961aad432 = (0, $ahm5r.createSelector)($cb59c0ee759be806$export$32b377cdaba59cf9, (insightRefreshErrors)=>{
    const insightErrorsSet = new Set();
    Object.values(insightRefreshErrors).forEach((insights)=>{
        insights.forEach(({ snippets: snippets })=>{
            snippets.forEach(({ appInfo: appInfo })=>{
                if (appInfo?.oauthClientId) insightErrorsSet.add(appInfo?.oauthClientId);
            });
        });
    });
    return insightErrorsSet;
});
const $cb59c0ee759be806$var$countSnippets = (conditionalInsights)=>(0, (/*@__PURE__*/$parcel$interopDefault($a97Xf)))((0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(conditionalInsights).map((insights)=>insights !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($a97Xf)))(insights.map(({ snippets: snippets })=>snippets.length)) : 0));
const $cb59c0ee759be806$export$9d22f2260e62d098 = (0, $ahm5r.createSelector)($cb59c0ee759be806$export$32b377cdaba59cf9, $cb59c0ee759be806$var$countSnippets);
const $cb59c0ee759be806$var$getCurrentUser = (state, props)=>props?.currentUser;
const $cb59c0ee759be806$export$7800c34257ddd8c9 = (localIssueId)=>(state)=>$cb59c0ee759be806$var$getInsightsMetadataMap(state)[localIssueId]?.timestampCurrentUserSeenInsights;
const $cb59c0ee759be806$export$bf8f3dc7c1c95827 = (localIssueId)=>(0, $ahm5r.createSelector)($cb59c0ee759be806$export$62bf0592dd655762(localIssueId), $cb59c0ee759be806$var$getInsightsMetadataMap, $cb59c0ee759be806$var$getCurrentUser, (insights, metadataMap, currentUser)=>{
        const metadata = metadataMap[localIssueId];
        if (insights === undefined || insights.length === 0 || currentUser === undefined) return false;
        if (metadata === undefined) return true;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const lastInsight = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(insights);
        const latestCreatedTimestamp = new Date(lastInsight.created).getTime();
        return latestCreatedTimestamp > metadata.timestampCurrentUserSeenInsights && lastInsight.account?.accountId !== currentUser;
    });
const $cb59c0ee759be806$export$2531b53a2ccda20c = (localIssueId)=>(0, $ahm5r.createSelector)($cb59c0ee759be806$export$4c6fae6b2186be47, (insightsMap)=>insightsMap[localIssueId]?.length ?? 0);
const $cb59c0ee759be806$export$62bf0592dd655762 = (localIssueId)=>(0, $ahm5r.createSelector)($cb59c0ee759be806$export$4c6fae6b2186be47, (insightsMap)=>insightsMap[localIssueId] ?? []);

});
parcelRegister("aiymM", function(module, exports) {

var $k2slY = parcelRequire("k2slY");
/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */ function $77f63e4d519e3420$var$sortedUniq(array) {
    return array && array.length ? $k2slY(array) : [];
}
module.exports = $77f63e4d519e3420$var$sortedUniq;

});
parcelRegister("k2slY", function(module, exports) {

var $2wri1 = parcelRequire("2wri1");
/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $e969fcf7af46a615$var$baseSortedUniq(array, iteratee) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        if (!index || !$2wri1(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
        }
    }
    return result;
}
module.exports = $e969fcf7af46a615$var$baseSortedUniq;

});


parcelRegister("eiZIr", function(module, exports) {

$parcel$export(module.exports, "CONJUNCTION", () => $6cd9cc4b8efd1042$export$d5538ef2fb1b1e29);
$parcel$export(module.exports, "DISJUNCTION", () => $6cd9cc4b8efd1042$export$e9f1316935b9723);
$parcel$export(module.exports, "NEGATION", () => $6cd9cc4b8efd1042$export$ad93d1c2e5d187f5);
$parcel$export(module.exports, "INCLUDE_STRING_LIST_PROPERTY", () => $6cd9cc4b8efd1042$export$ff5e91ad4926ead8);
$parcel$export(module.exports, "CONSTANT", () => $6cd9cc4b8efd1042$export$3eb140a03bae4ea2);
$parcel$export(module.exports, "TRUE_CONSTANT", () => $6cd9cc4b8efd1042$export$ca27da5b10c7a375);
const $6cd9cc4b8efd1042$export$d5538ef2fb1b1e29 = 'conjunction';
const $6cd9cc4b8efd1042$export$e9f1316935b9723 = 'disjunction';
const $6cd9cc4b8efd1042$export$ad93d1c2e5d187f5 = 'negation';
const $6cd9cc4b8efd1042$export$ff5e91ad4926ead8 = 'includeInStringListProperty';
const $6cd9cc4b8efd1042$export$3eb140a03bae4ea2 = 'const';
const $6cd9cc4b8efd1042$export$ca27da5b10c7a375 = {
    template: $6cd9cc4b8efd1042$export$3eb140a03bae4ea2,
    parameters: {
        value: true
    }
};
const $6cd9cc4b8efd1042$export$f5cbab1b2e08d7c7 = {
    template: $6cd9cc4b8efd1042$export$3eb140a03bae4ea2,
    parameters: {
        value: false
    }
};

});

parcelRegister("etL83", function(module, exports) {

$parcel$export(module.exports, "testInsight", () => $507adb43c7691ea1$export$e64702e8b5af2783);

var $aX8Tx = parcelRequire("aX8Tx");

var $eiZIr = parcelRequire("eiZIr");

var $gXFKK = parcelRequire("gXFKK");
const $507adb43c7691ea1$var$testStringListInclusionFilterInsight = (insight, filter)=>{
    const { propertyKey: propertyKey, values: values } = filter.parameters;
    const mergedValues = (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(insight.snippets.map((snippet)=>(0, $gXFKK.getSnippetPropertyValue)(snippet.properties, propertyKey) || []));
    return values.every((expectedValue)=>mergedValues.includes(expectedValue));
};
const $507adb43c7691ea1$export$e64702e8b5af2783 = (insight, filter)=>{
    switch(filter.template){
        case 0, $eiZIr.DISJUNCTION:
            return filter.parameters.filters.map((subFilter)=>$507adb43c7691ea1$export$e64702e8b5af2783(insight, subFilter)).some((value)=>value);
        case 0, $eiZIr.CONJUNCTION:
            return filter.parameters.filters.map((subFilter)=>$507adb43c7691ea1$export$e64702e8b5af2783(insight, subFilter)).every((value)=>value);
        case 0, $eiZIr.NEGATION:
            return !$507adb43c7691ea1$export$e64702e8b5af2783(insight, filter.parameters.formula);
        case 0, $eiZIr.CONSTANT:
            return filter.parameters.value;
        case 0, $eiZIr.INCLUDE_STRING_LIST_PROPERTY:
            return $507adb43c7691ea1$var$testStringListInclusionFilterInsight(insight, filter);
        default:
            throw new Error('Unhandled operation');
    }
};
const $507adb43c7691ea1$export$5643450d1921459a = (subFilters)=>({
        template: (0, $eiZIr.CONJUNCTION),
        parameters: {
            filters: subFilters
        }
    });
const $507adb43c7691ea1$export$3a99a411a71472eb = (subFilters)=>({
        template: (0, $eiZIr.DISJUNCTION),
        parameters: {
            filters: subFilters
        }
    });
const $507adb43c7691ea1$export$7c1f1cb9472db04b = (formula)=>({
        template: (0, $eiZIr.NEGATION),
        parameters: {
            formula: formula
        }
    });
const $507adb43c7691ea1$export$fc21e37e3fa95c4c = (label)=>({
        template: (0, $eiZIr.INCLUDE_STRING_LIST_PROPERTY),
        parameters: {
            propertyKey: 'labels',
            values: [
                label
            ]
        }
    });
const $507adb43c7691ea1$export$31ea7e3f9c300c1a = (filter)=>{
    if (filter.template === (0, $eiZIr.CONJUNCTION)) return (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(filter.parameters.filters.map((subFilter)=>subFilter.template === (0, $eiZIr.INCLUDE_STRING_LIST_PROPERTY) ? subFilter.parameters.values : undefined).filter(Boolean));
    return undefined;
};
const $507adb43c7691ea1$export$13102f16bdc9a153 = (labels)=>$507adb43c7691ea1$export$5643450d1921459a(labels.map($507adb43c7691ea1$export$fc21e37e3fa95c4c));

});



parcelRegister("6tIwq", function(module, exports) {

$parcel$export(module.exports, "compositionResolver", () => $5775d57942f8ea84$export$ffce3a552d1ab358);

var $ahm5r = parcelRequire("ahm5r");

var $fLnZn = parcelRequire("fLnZn");
const $5775d57942f8ea84$var$FORMULA_TEMPLATE = 'composition';
const $5775d57942f8ea84$var$prodResult = (...values)=>{
    let result = 1;
    let hasUndefined = false;
    let hasZero = false;
    values.every((value)=>{
        if (value === undefined) {
            hasUndefined = true;
            return false;
        }
        // fixing NaN when Infinity * 0
        if (value === 0) hasZero = true;
        if (hasZero) return true;
        result *= value;
        return true;
    });
    if (hasUndefined) return 0;
    if (hasZero) return 0;
    if (result !== undefined) return result;
    return 0;
};
const $5775d57942f8ea84$var$quotResult = (...values)=>{
    let result;
    values.every((value, index)=>{
        if (index === 0) {
            result = value;
            return true;
        }
        // if any of the divisors is 0, undefined or the result of a division by 0 (= Infinity)
        // we early return Infinity (= imposible division)
        if (value === 0 || value === undefined || value === Infinity) {
            result = Infinity;
            return false;
        }
        if (result !== undefined) result /= value;
        return true;
    });
    if (result !== undefined) return result;
    return 0;
};
const $5775d57942f8ea84$var$sumResult = (...values)=>{
    let notUndefined = false;
    let result = 0;
    values.forEach((value)=>{
        if (value !== undefined) notUndefined = true;
        result += value !== undefined ? value : 0;
        return true;
    });
    if (notUndefined) return result;
    return 0;
};
const $5775d57942f8ea84$var$diffResult = (...values)=>{
    let notUndefined = false;
    const result = values.reduce((a, b)=>{
        if (a !== undefined || b !== undefined) notUndefined = true;
        return (a === undefined ? 0 : a) - (b === undefined ? 0 : b);
    });
    if (notUndefined) return result;
    return 0;
};
const $5775d57942f8ea84$var$noopResult = ()=>undefined;
const $5775d57942f8ea84$export$ffce3a552d1ab358 = (formula)=>{
    if (formula === undefined || formula.template !== $5775d57942f8ea84$var$FORMULA_TEMPLATE) return undefined;
    const termResolvers = formula.parameters.formulas.map((term)=>(0, $fLnZn.getNumberSelectorForFormula)(term));
    return (localIssueId)=>{
        const issueSelectors = [];
        termResolvers.forEach((termResolver)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const selector = termResolver?.(localIssueId);
            if (selector !== undefined) issueSelectors.push(selector);
        });
        switch(formula.parameters.agg){
            case 'prod':
                return (0, $ahm5r.createSelector)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                issueSelectors, $5775d57942f8ea84$var$prodResult);
            case 'quot':
                return (0, $ahm5r.createSelector)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                issueSelectors, $5775d57942f8ea84$var$quotResult);
            case 'sum':
                return (0, $ahm5r.createSelector)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                issueSelectors, $5775d57942f8ea84$var$sumResult);
            case 'diff':
                return (0, $ahm5r.createSelector)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                issueSelectors, $5775d57942f8ea84$var$diffResult);
            default:
                return $5775d57942f8ea84$var$noopResult;
        }
    };
};

});

parcelRegister("2zHux", function(module, exports) {

$parcel$export(module.exports, "constantResolver", () => $19b1506ab72a8166$export$db29f9993cde07d7);
const $19b1506ab72a8166$var$FORMULA_TEMPLATE = 'const';
const $19b1506ab72a8166$export$db29f9993cde07d7 = (formula)=>{
    if (formula === undefined || formula.template !== $19b1506ab72a8166$var$FORMULA_TEMPLATE) return undefined;
    return ()=>()=>formula.parameters.value;
};

});

parcelRegister("8oFO8", function(module, exports) {

$parcel$export(module.exports, "dataPointsCountDynamicFieldResolver", () => $21edc2c096134d84$export$49effdfc48ac18f0);
$parcel$export(module.exports, "dataPointsCreatedDynamicFieldResolver", () => $21edc2c096134d84$export$d82e40e7f4a16b17);

var $ahm5r = parcelRequire("ahm5r");

var $7SDB8 = parcelRequire("7SDB8");
const $21edc2c096134d84$var$FORMULA_TEMPLATE = 'num_data_points';
const $21edc2c096134d84$var$any = (lst, predicate)=>lst.find(predicate) !== undefined;
const $21edc2c096134d84$export$49effdfc48ac18f0 = (formula)=>{
    if (formula === undefined || formula.template !== $21edc2c096134d84$var$FORMULA_TEMPLATE) return undefined;
    return (localIssueId)=>{
        const ideaInsights = (0, $7SDB8.createGetInsights)(localIssueId, formula.parameters?.filter);
        return (0, $ahm5r.createSelector)(ideaInsights, (insights)=>formula.parameters === undefined || formula.parameters.oauthClientId === undefined ? insights.length : insights.reduce((acc, insight)=>acc + ($21edc2c096134d84$var$any(insight.snippets, (s)=>s.appInfo?.oauthClientId === formula.parameters?.oauthClientId) ? 1 : 0), 0));
    };
};
const $21edc2c096134d84$export$d82e40e7f4a16b17 = (formula)=>{
    if (formula === undefined || formula.template !== $21edc2c096134d84$var$FORMULA_TEMPLATE) return undefined;
    return (localIssueId)=>{
        const ideaInsights = (0, $7SDB8.createGetInsights)(localIssueId, formula.parameters?.filter);
        return (0, $ahm5r.createSelector)(ideaInsights, (insights)=>{
            const list = formula.parameters === undefined || formula.parameters.oauthClientId === undefined ? insights : insights.filter((insight)=>$21edc2c096134d84$var$any(insight.snippets, (s)=>s.appInfo?.oauthClientId === formula.parameters?.oauthClientId));
            return list.map((item)=>item.created);
        });
    };
};

});

parcelRegister("5UOun", function(module, exports) {

$parcel$export(module.exports, "linkedIssuesCountDynamicFieldResolver", () => $eaa6ffc1d779c563$export$405c076860dfc72);

var $53OVi = parcelRequire("53OVi");
const $eaa6ffc1d779c563$var$FORMULA_TEMPLATE = 'num_linked_issues';
const $eaa6ffc1d779c563$export$405c076860dfc72 = (formula)=>{
    if (formula === undefined || formula.template !== $eaa6ffc1d779c563$var$FORMULA_TEMPLATE) return undefined;
    return 0, $53OVi.createGetLinkedIssuesCount;
};

});

parcelRegister("h1E7D", function(module, exports) {

$parcel$export(module.exports, "discreteResolver", () => $464271c21d4fd9f7$export$845764b1c78d3b4b);

var $ahm5r = parcelRequire("ahm5r");

var $1ilzu = parcelRequire("1ilzu");

var $fLnZn = parcelRequire("fLnZn");
const $464271c21d4fd9f7$var$FORMULA_TEMPLATE = 'discretization';
const $464271c21d4fd9f7$export$845764b1c78d3b4b = (formula)=>{
    if (formula === undefined || formula.template !== $464271c21d4fd9f7$var$FORMULA_TEMPLATE) return undefined;
    const { upperBounds: upperBounds, values: values } = formula.parameters;
    const termResolver = (0, $fLnZn.getNumberSelectorForFormula)(formula.parameters.formula);
    if (!termResolver) return undefined;
    return (localIssueId)=>(0, $ahm5r.createSelector)(termResolver(localIssueId), (value)=>{
            if (value === undefined) return undefined;
            const index = upperBounds.findIndex((upperBound)=>value < upperBound);
            if (index === -1) return (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(values);
            return values[index];
        });
};

});

parcelRegister("FKIgD", function(module, exports) {

$parcel$export(module.exports, "exprResolver", () => $8fd3da7ec8334007$export$3fc796ec36a2f199);

var $fLnZn = parcelRequire("fLnZn");
const $8fd3da7ec8334007$var$FORMULA_TEMPLATE = 'expr';
const $8fd3da7ec8334007$export$3fc796ec36a2f199 = (formula)=>{
    if (formula === undefined || formula.template !== $8fd3da7ec8334007$var$FORMULA_TEMPLATE) return undefined;
    const sub = formula.parameters.formula;
    // we just delegate directly to the subformula; no extra layer of indirection at "runtime"
    // (aka calculation time)
    return (0, $fLnZn.getNumberSelectorForFormula)(sub);
};

});

parcelRegister("53aSP", function(module, exports) {

$parcel$export(module.exports, "fieldResolver", () => $def2abc939f739de$export$2e320c88190f174e);


var $iehDF = parcelRequire("iehDF");

var $PrkLW = parcelRequire("PrkLW");

var $gRZDU = parcelRequire("gRZDU");
const $def2abc939f739de$export$2e320c88190f174e = (formula)=>{
    if (formula === undefined || formula.template !== (0, $2433d202ed5f6ea6$export$b7f6b03add5dbdea)) return undefined;
    if (formula.parameters.normalize === true) return (0, $gRZDU.normalizationResolver)({
        template: (0, $gRZDU.FORMULA_TEMPLATE),
        parameters: {
            formula: {
                template: (0, $2433d202ed5f6ea6$export$b7f6b03add5dbdea),
                parameters: {
                    id: formula.parameters.id
                }
            }
        }
    });
    return (localIssueId)=>(state, props)=>{
            if (!(0, $PrkLW.isInitialized)(state)) return undefined;
            const fieldKey = formula.parameters.id;
            const fieldsMappings = (0, $iehDF.getVisibleFieldMappings)(state, props);
            const mapping = fieldsMappings[fieldKey];
            if (mapping === undefined) return undefined;
            const value = mapping.valueAccessor(state, props, localIssueId);
            return value ?? 0;
        };
};

});
const $2433d202ed5f6ea6$export$b7f6b03add5dbdea = 'field';

parcelRegister("PrkLW", function(module, exports) {

$parcel$export(module.exports, "isInitialized", () => $a91b27c1cc85d8b9$export$3f95c6f800b78024);
$parcel$export(module.exports, "isDeliveryIssueCountRestricted", () => $a91b27c1cc85d8b9$export$90ecc80fe575f35b);
$parcel$export(module.exports, "isLoadingLinkedIssues", () => $a91b27c1cc85d8b9$export$2bb2c781f41c2594);
$parcel$export(module.exports, "isIssuesLoading", () => $a91b27c1cc85d8b9$export$6d75d04028f6b4b);
$parcel$export(module.exports, "isArchivedIssuesLoading", () => $a91b27c1cc85d8b9$export$9743defadf3562f8);
$parcel$export(module.exports, "getError", () => $a91b27c1cc85d8b9$export$e1599abf47b5b568);
$parcel$export(module.exports, "getArchivedError", () => $a91b27c1cc85d8b9$export$dde7600d8181fe39);
$parcel$export(module.exports, "getIsIssueStatusRollbackInProgress", () => $a91b27c1cc85d8b9$export$c9cca6978043562);
const $a91b27c1cc85d8b9$export$3f95c6f800b78024 = (state)=>state.meta.initialized;
const $a91b27c1cc85d8b9$export$90ecc80fe575f35b = (state)=>state.meta.restrictedDeliveryIssuesCount !== undefined;
const $a91b27c1cc85d8b9$export$2bb2c781f41c2594 = (state)=>state.meta.loadingLinkedIssues;
const $a91b27c1cc85d8b9$export$6d75d04028f6b4b = (state)=>state.meta.loading;
const $a91b27c1cc85d8b9$export$9743defadf3562f8 = (state)=>state.meta.loadingArchivedIssues;
const $a91b27c1cc85d8b9$export$e1599abf47b5b568 = (state)=>state.meta.error;
const $a91b27c1cc85d8b9$export$dde7600d8181fe39 = (state)=>state.meta.archivedError;
const $a91b27c1cc85d8b9$export$c9cca6978043562 = (state)=>state.meta.isIssueStatusRollbackInProgress;

});

parcelRegister("gRZDU", function(module, exports) {

$parcel$export(module.exports, "FORMULA_TEMPLATE", () => $b86c23b0b67b0c30$export$496795a2e64d3866);
$parcel$export(module.exports, "normalizationResolver", () => $b86c23b0b67b0c30$export$ecd272ceffb70069);

var $ahm5r = parcelRequire("ahm5r");

var $32aVU = parcelRequire("32aVU");

var $PrkLW = parcelRequire("PrkLW");

var $2kRwo = parcelRequire("2kRwo");

var $4opJt = parcelRequire("4opJt");
const $b86c23b0b67b0c30$export$496795a2e64d3866 = 'norm';
const $b86c23b0b67b0c30$export$ecd272ceffb70069 = (formula)=>{
    if (formula === undefined || formula.template !== $b86c23b0b67b0c30$export$496795a2e64d3866) return undefined;
    const valuesSelector = (0, $2kRwo.createValueSelectorForFormula)(formula.parameters.formula);
    if (!valuesSelector) return undefined;
    const nonEmptyValuesArraySelector = (0, $ahm5r.createSelector)(valuesSelector, (values)=>{
        const valuesArray = Object.values(values);
        if (valuesArray.length === 0) return undefined;
        const nonEmptyValues = new Set();
        (0, (/*@__PURE__*/$parcel$interopDefault($32aVU)))(values, (value)=>{
            if (value === Infinity) return;
            if (value === undefined) {
                nonEmptyValues.add(0);
                return;
            }
            nonEmptyValues.add(value);
        });
        if (nonEmptyValues.size === 0) return undefined;
        return Array.from(nonEmptyValues);
    });
    const minValueSelector = (0, $ahm5r.createSelector)(nonEmptyValuesArraySelector, (nonEmptyValuesArray)=>nonEmptyValuesArray ? Math.min(0, ...nonEmptyValuesArray) : undefined);
    const maxValueSelector = (0, $ahm5r.createSelector)(nonEmptyValuesArraySelector, (nonEmptyValuesArray)=>nonEmptyValuesArray ? Math.max(...nonEmptyValuesArray) : undefined);
    return (localIssueId)=>(0, $ahm5r.createSelector)((0, $PrkLW.isInitialized), (0, $ahm5r.createSelector)(valuesSelector, (values)=>values[localIssueId]), minValueSelector, maxValueSelector, (isInit, value, min, max)=>{
            if (!isInit) return undefined;
            if (value === undefined || min === undefined || max === undefined) return undefined;
            return (0, $4opJt.normalize)(value, min, max);
        });
};

});
parcelRegister("32aVU", function(module, exports) {

var $75Jcs = parcelRequire("75Jcs");

var $8etTE = parcelRequire("8etTE");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $235a0a125a926fad$var$forOwn(object, iteratee) {
    return object && $75Jcs(object, $8etTE(iteratee));
}
module.exports = $235a0a125a926fad$var$forOwn;

});

parcelRegister("4opJt", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $bfa7413f523a1caa$export$a3295358bff77e);
const $bfa7413f523a1caa$var$NORM_MIN = 0;
const $bfa7413f523a1caa$var$NORM_MAX = 100;
const $bfa7413f523a1caa$export$a3295358bff77e = (x, min, max)=>{
    if (!Number.isFinite(x)) return undefined;
    if (x < min || x > max) return undefined;
    if (min === max) {
        if (max === 0) return $bfa7413f523a1caa$var$NORM_MIN;
        return $bfa7413f523a1caa$var$NORM_MAX;
    }
    return Math.floor((x - min) * ($bfa7413f523a1caa$var$NORM_MAX - $bfa7413f523a1caa$var$NORM_MIN) / (max - min) + $bfa7413f523a1caa$var$NORM_MIN);
};

});



parcelRegister("cNHl0", function(module, exports) {

$parcel$export(module.exports, "multiselectCountResolver", () => $18a0aadbce057364$export$3d1897d0c483885e);

var $9g7yh = parcelRequire("9g7yh");

var $eTBmS = parcelRequire("eTBmS");


var $iehDF = parcelRequire("iehDF");

var $19ZHc = parcelRequire("19ZHc");

var $3MqVY = parcelRequire("3MqVY");
const $18a0aadbce057364$export$3d1897d0c483885e = (formula)=>{
    if (formula === undefined || formula.template !== (0, $5d5d7f16f4275d22$export$c169944985bd05c3)) return undefined;
    return (localIssueId)=>(state, props)=>{
            const baseField = (0, $iehDF.getAllFieldsByKey)(state, props)[formula.parameters.id];
            if (baseField === undefined) return undefined;
            if (baseField.type !== (0, $eTBmS.FIELD_TYPES).SINGLE_SELECT && baseField.type !== (0, $eTBmS.FIELD_TYPES).MULTI_SELECT && baseField.type !== (0, $eTBmS.FIELD_TYPES).JSW_MULTI_SELECT) return undefined;
            const mapping = baseField.type === (0, $eTBmS.FIELD_TYPES).SINGLE_SELECT ? (0, $19ZHc.optionMapping)(props?.issuesRemote, baseField) : (0, $3MqVY.optionsMapping)(props?.issuesRemote, baseField);
            const value = mapping.valueAccessor(state, props, localIssueId);
            if (value === undefined) return undefined;
            const arrValue = Array.isArray(value) ? value : [
                value
            ];
            const optionsById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(baseField.options, (option)=>option.jiraOptionId);
            const sumOfOptionWeights = arrValue.reduce((acc, cur)=>{
                if (!cur) return acc;
                const weight = optionsById[cur.id] ? optionsById[cur.id].weight : 1;
                return acc + weight;
            }, 0);
            return sumOfOptionWeights;
        };
};

});
const $5d5d7f16f4275d22$export$c169944985bd05c3 = 'multi-select-count';





parcelRegister("aFbS5", function(module, exports) {

$parcel$export(module.exports, "deleteExternalIssues", () => $40ff7fa8f20ddf22$export$37f9d61551cf1fd2);
$parcel$export(module.exports, "deleteIssues", () => $40ff7fa8f20ddf22$export$a8ed25a166761fe);

var $2zs80 = parcelRequire("2zs80");

var $6kS6u = parcelRequire("6kS6u");

var $7BEaI = parcelRequire("7BEaI");

var $huH03 = parcelRequire("huH03");

var $12DRg = parcelRequire("12DRg");

var $jFHCE = parcelRequire("jFHCE");

var $5m7Wy = parcelRequire("5m7Wy");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $dUuWP = parcelRequire("dUuWP");
const $40ff7fa8f20ddf22$export$37f9d61551cf1fd2 = (issueIdsToDelete)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            properties: {
                ...state.properties,
                linkedDeliveryIssues: (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(state.properties.linkedDeliveryIssues, (vals)=>(0, (/*@__PURE__*/$parcel$interopDefault($5m7Wy)))(vals, (val)=>issueIdsToDelete.includes(val)))
            },
            externalIssueData: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state.externalIssueData, issueIdsToDelete)
        });
    };
const $40ff7fa8f20ddf22$export$a8ed25a166761fe = (issueIds, performSideEffects = true, onFinish = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))))=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        if (performSideEffects) props.issuesRemote.deleteIssues({
            issueKeys: issueIds.map((id)=>state.properties.string.key[id]).filter((key)=>key),
            onFinish: (result)=>{
                const error = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(result, (caughtError)=>!!caughtError);
                if (error) props.onIssueUpdateFailed(error);
                onFinish();
            }
        });
        if ((0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar')) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(state.ids, issueIds).length > 0 || (0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(state.connectionIssueIds, issueIds).length > 0) {
                const localIssueIdToJiraId = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
                const issuesToDisconnect = issueIds.map((issueId)=>({
                        id: localIssueIdToJiraId[issueId]
                    }));
                const newState = {
                    ...state
                };
                state.ids.forEach((localIssueId)=>{
                    newState.properties = (0, $dUuWP.updateConnectionsProperties)({
                        issuesToDisconnect: issuesToDisconnect,
                        localIssueId: localIssueId,
                        state: newState,
                        props: props
                    });
                });
                state.connectionIssueIds.forEach((localIssueId)=>{
                    newState.properties = (0, $dUuWP.updateConnectionsProperties)({
                        issuesToDisconnect: issuesToDisconnect,
                        localIssueId: localIssueId,
                        state: newState,
                        props: props
                    });
                });
                setState({
                    ids: (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(state.ids, issueIds),
                    connectionIssueIds: (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(state.connectionIssueIds, issueIds),
                    properties: newState.properties
                });
            }
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(state.ids, issueIds).length > 0) {
            const localIssueIdToJiraId = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
            const issuesToDisconnect = issueIds.map((issueId)=>({
                    id: localIssueIdToJiraId[issueId]
                }));
            const newState = {
                ...state
            };
            state.ids.forEach((localIssueId)=>{
                newState.properties = (0, $dUuWP.updateConnectionsProperties)({
                    issuesToDisconnect: issuesToDisconnect,
                    localIssueId: localIssueId,
                    state: newState,
                    props: props
                });
            });
            setState({
                ids: (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(state.ids, issueIds),
                properties: newState.properties
            });
        }
        (0, $gCeeo.fireTrackAnalytics)(props.createAnalyticsEvent({}), 'issue deleted', issueIds.length === 1 ? {
            ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(issueIds[0])(state)
        } : {
            issueCount: issueIds.length,
            issueIds: issueIds.map((id)=>(0, $4TCfW.createGetIdSelector)(id)(state)?.toString()),
            actionType: 'bulk'
        });
    };

});
parcelRegister("5m7Wy", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $3PLp8 = parcelRequire("3PLp8");

var $1lM9j = parcelRequire("1lM9j");

var $4sprp = parcelRequire("4sprp");

var $iNghu = parcelRequire("iNghu");
/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */ function $3e652b37467fcd1d$var$reject(collection, predicate) {
    var func = $4sprp(collection) ? $821Ou : $3PLp8;
    return func(collection, $iNghu($1lM9j(predicate, 3)));
}
module.exports = $3e652b37467fcd1d$var$reject;

});


parcelRegister("db1qQ", function(module, exports) {

$parcel$export(module.exports, "exportStringValues", () => $0317f415561ccfb0$export$afe0414bb9c29682);

var $eTBmS = parcelRequire("eTBmS");

var $iehDF = parcelRequire("iehDF");
const $0317f415561ccfb0$export$afe0414bb9c29682 = (visibleFields, issueIds, additionalFields)=>({ getState: getState }, props)=>{
        const { locale: locale, statusCategories: statusCategories, messages: messages, formatMessage: formatMessage } = additionalFields;
        const state = getState();
        const mappings = (0, $iehDF.getFieldMappings)(state, props);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return issueIds.map((id)=>visibleFields.map(({ type: type, key: fieldKey, options: options })=>{
                let additionalParamsToConversion;
                let isFieldSupported = true;
                switch(type){
                    case (0, $eTBmS.FIELD_TYPES).SINGLE_SELECT:
                    case (0, $eTBmS.FIELD_TYPES).MULTI_SELECT:
                    case (0, $eTBmS.FIELD_TYPES).JSW_MULTI_SELECT:
                        additionalParamsToConversion = options;
                        break;
                    case (0, $eTBmS.FIELD_TYPES).DATE:
                    case (0, $eTBmS.FIELD_TYPES).UPDATED:
                    case (0, $eTBmS.FIELD_TYPES).CREATED:
                    case (0, $eTBmS.FIELD_TYPES).INTERVAL:
                        additionalParamsToConversion = locale;
                        break;
                    case (0, $eTBmS.FIELD_TYPES).DELIVERY_PROGRESS:
                    case (0, $eTBmS.FIELD_TYPES).DELIVERY_STATUS:
                        additionalParamsToConversion = {
                            statusCategories: statusCategories,
                            formatMessage: formatMessage,
                            messages: messages
                        };
                        break;
                    case (0, $eTBmS.FIELD_TYPES).REACTIONS:
                    case (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT:
                    case (0, $eTBmS.FIELD_TYPES).ATLAS_PROJECT_STATUS:
                    case (0, $eTBmS.FIELD_TYPES).ATLAS_GOAL:
                    case (0, $eTBmS.FIELD_TYPES).PLATFORM_GOALS:
                        isFieldSupported = false;
                        break;
                    default:
                        break;
                }
                return isFieldSupported ? `"${mappings[fieldKey].valueAccessorToExport(state, props, id, additionalParamsToConversion)}"` : `${formatMessage(messages.fieldNotSupported)}`;
            }));
    };

});

parcelRegister("6JcdT", function(module, exports) {

$parcel$export(module.exports, "adaptExternalIssueRank", () => $27b25127a0e4cd27$export$475d66000ff9522);

var $7B8wM = parcelRequire("7B8wM");

var $1I887 = parcelRequire("1I887");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");
const $27b25127a0e4cd27$export$475d66000ff9522 = (id, destinationBeforeId, destinationAfterId, sortedIds)=>({ getState: getState, setState: setState }, props)=>{
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(getState(), props);
        const newSortedIds = [
            ...sortedIds
        ];
        const itemIndex = (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(newSortedIds, id);
        newSortedIds.splice(itemIndex, 1);
        const toIndex = destinationBeforeId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(newSortedIds, destinationBeforeId) : (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(newSortedIds, destinationAfterId) + 1;
        newSortedIds.splice(toIndex, 0, id);
        setState({
            externalIssueRanking: newSortedIds
        });
        (0, $1I887.fireAnalyticsEventForIssueUpdate)(props.createAnalyticsEvent({}), localIdMap[id], {
            updatedItems: [
                {
                    name: 'viewRank'
                }
            ],
            ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(id)(getState())
        });
    };

});

parcelRegister("adX4t", function(module, exports) {

$parcel$export(module.exports, "updateExternalReferenceEntities", () => $d790dc35920499bb$export$ad62c7652434665f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d790dc35920499bb$export$ad62c7652434665f = (newExternalReferenceEntities)=>({ getState: getState, setState: setState })=>{
        const somethingMissing = Object.keys(newExternalReferenceEntities).find((key)=>!getState().properties.externalReferenceEntities[key]);
        if (!somethingMissing) return;
        setState({
            properties: {
                ...getState().properties,
                externalReferenceEntities: {
                    ...getState().properties.externalReferenceEntities,
                    ...newExternalReferenceEntities
                }
            }
        });
    };

});

parcelRegister("lvf3r", function(module, exports) {

$parcel$export(module.exports, "initialize", () => $eaac8c85651aeeb6$export$2a47f398eeff8b01);
$parcel$export(module.exports, "initializeArchived", () => $eaac8c85651aeeb6$export$41e9b6811fd0c0c4);
$parcel$export(module.exports, "addPropertiesForLoadedIssue", () => $eaac8c85651aeeb6$export$9504901a127102dd);
$parcel$export(module.exports, "addPropertiesForLoadedIssues", () => $eaac8c85651aeeb6$export$7b6436a07a053dd7);

var $1O6Yz = parcelRequire("1O6Yz");

var $fqICx = parcelRequire("fqICx");

var $eTBmS = parcelRequire("eTBmS");

var $7jTnu = parcelRequire("7jTnu");

var $iWbQb = parcelRequire("iWbQb");

var $59oat = parcelRequire("59oat");

var $hAB8j = parcelRequire("hAB8j");

var $7VEhh = parcelRequire("7VEhh");

var $jpX1D = parcelRequire("jpX1D");

var $9448e = parcelRequire("9448e");

var $5d1bz = parcelRequire("5d1bz");
const $eaac8c85651aeeb6$export$2a47f398eeff8b01 = (fieldKeyToAriMapPromise)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { fields: fields, insights: insights, plays: plays, rankField: rankField, issuesRemote: issuesRemote, isSharedView: isSharedView, isCollectionView: isCollectionView } = props;
        const state = getState();
        if (!issuesRemote.fetch || state.meta.loading) return;
        // No fields yet (too soon)
        if (fields === undefined || fields.length === 0) return;
        // No issues yet (too soon)
        if (!state.prefechedIssues) return;
        // no rank field id (too soon) - cannot order issues properly if this is missing
        if (rankField === undefined && !isSharedView && !isCollectionView) return;
        const { isSingleIssueLoaded: isSingleIssueLoaded } = state.meta;
        const existingMapping = {};
        // preserve existing mapping if any (e.g. when opening an idea in a new tab)
        const jiraIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
        for (const localIssueId of state.ids){
            const jiraIssueId = jiraIdMap[localIssueId];
            existingMapping[jiraIssueId] = localIssueId;
        }
        if ((0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar')) for (const localIssueId of state.connectionIssueIds){
            const jiraIssueId = jiraIdMap[localIssueId];
            existingMapping[jiraIssueId] = localIssueId;
        }
        const { ids: ids, properties: properties, externalIssueData: externalIssueData, connectionIssueIds: connectionIssueIds } = (0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') ? (0, $5d1bz.transformIssueResponse)({
            remoteIssues: state.prefechedIssues,
            primaryIssueList: state.prefetchedPrimaryIssueList,
            insights: isSingleIssueLoaded ? (0, $5d1bz.preserveExistingInsights)(insights || {}, state.properties, existingMapping) : insights,
            plays: isSingleIssueLoaded ? (0, $5d1bz.preserveExistingPlays)(plays || {}, state.properties, existingMapping) : plays,
            existingState: state,
            existingMapping: existingMapping,
            props: props,
            mergeConnectionFieldValues: false,
            skipMetaIfAlreadyLoaded: false
        }) : (0, $5d1bz.transformIssueResponseOld)({
            remoteIssues: state.prefechedIssues,
            primaryIssueList: state.prefetchedPrimaryIssueList,
            insights: isSingleIssueLoaded ? (0, $5d1bz.preserveExistingInsights)(insights || {}, state.properties, existingMapping) : insights,
            plays: isSingleIssueLoaded ? (0, $5d1bz.preserveExistingPlays)(plays || {}, state.properties, existingMapping) : plays,
            existingState: state,
            existingMapping: existingMapping,
            props: props
        });
        if (!(0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar')) (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(properties, state.properties);
        setState({
            meta: {
                ...state.meta,
                initialized: true
            },
            ids: ids,
            properties: properties,
            externalIssueData: externalIssueData,
            prefechedIssues: undefined,
            prefetchedPrimaryIssueList: undefined,
            connectionIssueIds: connectionIssueIds
        });
        dispatch((0, $59oat.scheduleDynamicFieldCalculation)());
        dispatch((0, $hAB8j.initDeliveryProgress)());
        dispatch((0, $7VEhh.loadTrackingMetadata)());
        // load reactions for all ideas
        const externalIds = state.prefechedIssues.map((issue)=>issue.id);
        const filteredExternalIds = state.prefetchedPrimaryIssueList !== undefined ? externalIds.filter((id)=>(state.prefetchedPrimaryIssueList || []).includes(id)) : externalIds;
        dispatch((0, $jpX1D.loadReactions)(filteredExternalIds, fieldKeyToAriMapPromise));
    };
const $eaac8c85651aeeb6$export$41e9b6811fd0c0c4 = (fieldKeyToAriMapPromise)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { fields: fields, insights: insights, plays: plays, issuesRemote: issuesRemote } = props;
        const state = getState();
        const { archivedIssues: archivedIssues, meta: meta } = state;
        if (!meta.initialized || meta.initializedArchived) return;
        if (!issuesRemote.fetch || meta.loadingArchivedIssues) return;
        // No fields yet (too soon)
        if (fields === undefined || fields.length === 0) return;
        // No issues yet (too soon)
        if (!archivedIssues) return;
        const existingMapping = {};
        // preserve existing mapping if any (e.g. when opening an idea in a new tab)
        const jiraIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
        for (const localIssueId of state.ids){
            const jiraIssueId = jiraIdMap[localIssueId];
            existingMapping[jiraIssueId] = localIssueId;
        }
        if ((0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar')) for (const localIssueId of state.connectionIssueIds){
            const jiraIssueId = jiraIdMap[localIssueId];
            existingMapping[jiraIssueId] = localIssueId;
        }
        const { ids: ids, connectionIssueIds: connectionIssueIds, properties: properties, externalIssueData: externalIssueData } = (0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') ? (0, $5d1bz.transformIssueResponse)({
            remoteIssues: archivedIssues,
            primaryIssueList: state.archivedPrimaryIssueList,
            insights: insights,
            plays: plays,
            existingState: state,
            existingMapping: existingMapping,
            props: props,
            mergeConnectionFieldValues: false,
            skipMetaIfAlreadyLoaded: false
        }) : (0, $5d1bz.transformIssueResponseOld)({
            remoteIssues: archivedIssues,
            insights: insights,
            plays: plays,
            existingState: state,
            existingMapping: existingMapping,
            props: props
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(properties, state.properties);
        (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(externalIssueData, state.externalIssueData);
        setState({
            meta: {
                ...state.meta,
                initializedArchived: true
            },
            ids: Array.from(new Set([
                ...state.ids,
                ...ids
            ])),
            properties: properties,
            externalIssueData: externalIssueData,
            archivedIssues: undefined,
            ...(0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') ? {
                connectionIssueIds: connectionIssueIds
            } : {}
        });
        // load reactions for archived ideas
        const externalIds = archivedIssues.map((issue)=>issue.id);
        dispatch((0, $jpX1D.loadReactions)(externalIds, fieldKeyToAriMapPromise));
        dispatch((0, $hAB8j.loadDeliveryProgress)(undefined, undefined, undefined, true));
    };
const $eaac8c85651aeeb6$export$9504901a127102dd = (remoteIssue)=>async ({ getState: getState, setState: setState }, props)=>{
        const { fields: fields, insights: insights, plays: plays } = props;
        // Bail early if we don't yet have all the information needed to load issues
        if (fields === undefined || fields.length === 0) return;
        // copy state to get around readonly flow errors for selectors
        const state = getState();
        // don't add response to issues state if all the issues have been loaded already
        if (state.meta.initialized) return;
        const runTeamAvatarUrlWorkaround = props.isCollectionView;
        const issueWithAvatar = runTeamAvatarUrlWorkaround ? (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(remoteIssue) : remoteIssue;
        if (runTeamAvatarUrlWorkaround) {
            const teamFieldKey = props.fields?.find((field)=>field.type === (0, $eTBmS.FIELD_TYPES).TEAM)?.key;
            const avatarUrl = await (0, $9448e.getTeamAvatarUrlForIssue)(issueWithAvatar, teamFieldKey, props.cloudId);
            if (teamFieldKey && avatarUrl) issueWithAvatar.fields[teamFieldKey] = {
                ...issueWithAvatar.fields[teamFieldKey],
                avatarUrl: avatarUrl
            };
        }
        const { ids: ids, properties: properties, externalIssueData: externalIssueData } = (0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') ? (0, $5d1bz.transformIssueResponse)({
            remoteIssues: [
                issueWithAvatar
            ],
            insights: insights,
            plays: plays,
            existingState: state,
            props: props,
            mergeConnectionFieldValues: false,
            skipMetaIfAlreadyLoaded: false
        }) : (0, $5d1bz.transformIssueResponseOld)({
            remoteIssues: [
                issueWithAvatar
            ],
            insights: insights,
            plays: plays,
            existingState: state,
            props: props
        });
        setState({
            ids: ids,
            properties: properties,
            externalIssueData: externalIssueData
        });
    };
const $eaac8c85651aeeb6$export$7b6436a07a053dd7 = ({ remoteIssues: remoteIssues, primaryIssueList: primaryIssueList })=>async ({ getState: getState, setState: setState }, props)=>{
        const { fields: fields, insights: insights, plays: plays } = props;
        // Bail early if we don't yet have all the information needed to load issues
        if (fields === undefined || fields.length === 0) return;
        const runTeamAvatarUrlWorkaround = props.isCollectionView;
        const remoteIssuesWithAvatar = runTeamAvatarUrlWorkaround ? await Promise.all(remoteIssues.map(async (remoteIssue)=>{
            const issueWithAvatar = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(remoteIssue);
            const teamFieldKey = props.fields?.find((field)=>field.type === (0, $eTBmS.FIELD_TYPES).TEAM)?.key;
            const avatarUrl = await (0, $9448e.getTeamAvatarUrlForIssue)(issueWithAvatar, teamFieldKey, props.cloudId);
            if (teamFieldKey && avatarUrl) issueWithAvatar.fields[teamFieldKey] = {
                ...issueWithAvatar.fields[teamFieldKey],
                avatarUrl: avatarUrl
            };
            return issueWithAvatar;
        })) : remoteIssues;
        const state = getState();
        const localIssueIdsByJiraIssueId = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        const { ids: ids, connectionIssueIds: connectionIssueIds, properties: properties, externalIssueData: externalIssueData } = (0, $5d1bz.transformIssueResponse)({
            remoteIssues: remoteIssuesWithAvatar,
            insights: insights,
            plays: plays,
            existingState: state,
            existingMapping: localIssueIdsByJiraIssueId,
            props: props,
            primaryIssueList: primaryIssueList,
            mergeConnectionFieldValues: true,
            skipMetaIfAlreadyLoaded: true
        });
        setState({
            ids: ids,
            connectionIssueIds: connectionIssueIds,
            properties: properties,
            externalIssueData: externalIssueData
        });
    };

});
parcelRegister("7VEhh", function(module, exports) {

$parcel$export(module.exports, "loadTrackingMetadata", () => $a77feea7c5f6efbc$export$71e91e1d5d565aa4);

var $8V8so = parcelRequire("8V8so");

var $16aVR = parcelRequire("16aVR");

var $jEFw5 = parcelRequire("jEFw5");

var $jDdjf = parcelRequire("jDdjf");

var $iWbQb = parcelRequire("iWbQb");
const $a77feea7c5f6efbc$var$setMetadata = (state, metadata, props)=>{
    const ariToLocalIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))((0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props), (value, issueId)=>(0, $jDdjf.createIssueAri)(props.cloudId, issueId));
    return {
        ...state,
        properties: {
            ...state.properties,
            commentsMetadata: (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(metadata.comments, (v, issueAri)=>ariToLocalIssueId[issueAri]),
            insightsMetadata: (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(metadata.insights, (v, issueAri)=>ariToLocalIssueId[issueAri])
        }
    };
};
const $a77feea7c5f6efbc$export$71e91e1d5d565aa4 = ()=>({ getState: getState, setState: setState }, props)=>{
        const { cloudId: cloudId, projectIds: projectIds, apolloClient: apolloClient, isSharedView: isSharedView } = props;
        if (!projectIds?.length || isSharedView) return;
        Promise.all(projectIds.map((pId)=>(0, $jEFw5.fetchCommentsAndInsightsMetadata)(apolloClient, (0, $jDdjf.createProjectAri)(cloudId, pId)))).then((metadatas)=>({
                comments: (0, (/*@__PURE__*/$parcel$interopDefault($16aVR)))({}, ...metadatas.map((m)=>m.comments)),
                insights: (0, (/*@__PURE__*/$parcel$interopDefault($16aVR)))({}, ...metadatas.map((m)=>m.insights))
            })).then((metadata)=>{
            setState($a77feea7c5f6efbc$var$setMetadata(getState(), metadata, props));
        });
    };

});
parcelRegister("8V8so", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $67ea34f606cb6857$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $67ea34f606cb6857$var$mapKeys;

});

parcelRegister("16aVR", function(module, exports) {

var $9AWD2 = parcelRequire("9AWD2");

var $kBNXn = parcelRequire("kBNXn");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $0cced4e66601137e$var$mergeWith = $kBNXn(function(object, source, srcIndex, customizer) {
    $9AWD2(object, source, srcIndex, customizer);
});
module.exports = $0cced4e66601137e$var$mergeWith;

});

parcelRegister("jEFw5", function(module, exports) {

$parcel$export(module.exports, "useProjectConfig", () => $619684bb2d2c7911$export$ff6c81d841d6626d);
$parcel$export(module.exports, "fetchCommentsAndInsightsMetadata", () => $619684bb2d2c7911$export$5580f28668217188);

var $kuAvn = parcelRequire("kuAvn");

var $g9yYQ = parcelRequire("g9yYQ");
const $619684bb2d2c7911$export$ff6c81d841d6626d = ()=>(0, $g9yYQ.useProjectFetcher)();
const $619684bb2d2c7911$export$9bfb8672c4f05152 = (0, $kuAvn.default)`
query jira_polaris_GetCommentAndInsightTimestampsQuery($ari: ID!) {
    polarisProject(id: $ari, skipRefresh: true) {
      id
      ...ProjectIdeasExtendedConfigGQL
    }
  }

  fragment ProjectIdeasExtendedConfigGQL on PolarisProject {
      ideas {
        id
        lastCommentsViewedTimestamp
        lastInsightsViewedTimestamp
      }
    }
`;
const $619684bb2d2c7911$var$assertNoError = (result)=>{
    if (result.errors !== undefined && result.errors !== null) throw new Error(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    `project-config.fetch-error:${result.errors.map((e)=>e.message).join(', ')}`);
};
const $619684bb2d2c7911$export$5580f28668217188 = (client, projectAri)=>client.query({
        query: $619684bb2d2c7911$export$9bfb8672c4f05152,
        variables: {
            ari: projectAri
        }
    }).then((result)=>{
        $619684bb2d2c7911$var$assertNoError(result);
        if (!result.data || result.data.polarisProject === undefined || result.data.polarisProject === null) throw new Error('project-config.fetch-error: no data or no data node');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const ariToCommentsTimestamp = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const ariToInsightsTimestamp = {};
        result.data.polarisProject.ideas.forEach((issue)=>{
            if (issue.lastCommentsViewedTimestamp !== undefined && issue.lastCommentsViewedTimestamp !== null) ariToCommentsTimestamp[issue.id] = {
                timestampCurrentUserSeenComments: new Date(issue.lastCommentsViewedTimestamp).getTime()
            };
            if (issue.lastInsightsViewedTimestamp !== undefined && issue.lastInsightsViewedTimestamp !== null) ariToInsightsTimestamp[issue.id] = {
                timestampCurrentUserSeenInsights: new Date(issue.lastInsightsViewedTimestamp).getTime()
            };
        });
        return {
            comments: ariToCommentsTimestamp,
            insights: ariToInsightsTimestamp
        };
    });

});


parcelRegister("jpX1D", function(module, exports) {

$parcel$export(module.exports, "loadReactions", () => $70d4b95395fa089b$export$152ac01d3bd5c5ea);
$parcel$export(module.exports, "toggleReaction", () => $70d4b95395fa089b$export$fb8a5038533fa3c3);

var $5spib = parcelRequire("5spib");

var $3xiug = parcelRequire("3xiug");

var $cSmYj = parcelRequire("cSmYj");

var $8V8so = parcelRequire("8V8so");

var $huH03 = parcelRequire("huH03");

var $d3vFW = parcelRequire("d3vFW");

var $eTBmS = parcelRequire("eTBmS");

var $1I887 = parcelRequire("1I887");

var $6Yd06 = parcelRequire("6Yd06");

var $7jTnu = parcelRequire("7jTnu");

var $jDdjf = parcelRequire("jDdjf");

var $iehDF = parcelRequire("iehDF");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

const $70d4b95395fa089b$export$152ac01d3bd5c5ea = (ideasIds, fieldKeyToAriMapPromise)=>async ({ getState: getState, setState: setState }, props)=>{
        const { cloudId: cloudId, reactionsClient: reactionsClient } = props;
        const state = getState();
        const fieldMappings = (0, $iehDF.getFieldMappings)(state, props);
        const ariToLocalIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))((0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props), (value, issueId)=>(0, $jDdjf.createIssueAri)(props.cloudId, issueId));
        const allIssuesAris = ideasIds.map((id)=>(0, $jDdjf.createIssueAri)(cloudId, id));
        const fieldKeyToAriMap = await fieldKeyToAriMapPromise;
        (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(fieldMappings, async (mapping)=>{
            const { field: field } = mapping;
            if (field?.type === (0, $eTBmS.FIELD_TYPES).REACTIONS) {
                const fieldAri = fieldKeyToAriMap[field.key];
                try {
                    if (fieldAri === undefined) throw new Error('Field ARI is not defined');
                    const result = await reactionsClient.getReactions(fieldAri, allIssuesAris);
                    const reactionsListByLocalIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(result, (v, issueAri)=>ariToLocalIssueId[issueAri]);
                    const reactionIdsByLocalIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(reactionsListByLocalIssueId, (reactionsList)=>reactionsList.map((reaction)=>({
                                id: reaction.emojiId,
                                count: reaction.count
                            })));
                    const newState = (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(state.properties.reactions, [
                        field.key
                    ], reactionIdsByLocalIssueId);
                    setState(newState);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (err) {
                    (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.load-reactions-by-issue-aris', 'Failed to get reactions', err);
                }
            }
        });
    };
const $70d4b95395fa089b$export$fb8a5038533fa3c3 = (fieldKey, localIssueId, reactions)=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        const reactionsIds = reactions.map((reaction)=>({
                id: reaction.emojiId,
                count: reaction.count
            }));
        const currentReactions = state.properties.reactions[fieldKey] ? state.properties.reactions[fieldKey][localIssueId] : [];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(currentReactions, reactionsIds)) return;
        const newState = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))([
            'properties',
            'reactions',
            fieldKey,
            localIssueId
        ], reactionsIds, state);
        setState({
            ...newState,
            lastUpdatedIssueIds: [
                localIssueId
            ],
            lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
        });
        (0, $1I887.fireAnalyticsEventForIssueUpdate)(props.createAnalyticsEvent({}), localIdMap[localIssueId], {
            updatedItems: [
                {
                    name: fieldKey
                }
            ],
            ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(localIssueId)(getState())
        });
    };

});

parcelRegister("5d1bz", function(module, exports) {

$parcel$export(module.exports, "preserveExistingPlays", () => $143ea4983eeb61e3$export$6ac2bdfc986ad85c);
$parcel$export(module.exports, "preserveExistingInsights", () => $143ea4983eeb61e3$export$9d5b737165a4564e);
$parcel$export(module.exports, "transformIssueResponseOld", () => $143ea4983eeb61e3$export$2d9b03d703912ffb);
$parcel$export(module.exports, "transformIssueResponse", () => $143ea4983eeb61e3$export$a68c4c0847145a11);

var $fqICx = parcelRequire("fqICx");

var $5spib = parcelRequire("5spib");

var $1O6Yz = parcelRequire("1O6Yz");


var $gyMEu = parcelRequire("gyMEu");

var $eTBmS = parcelRequire("eTBmS");

var $7jTnu = parcelRequire("7jTnu");

var $amUSo = parcelRequire("amUSo");

var $iehDF = parcelRequire("iehDF");

var $g3PIQ = parcelRequire("g3PIQ");

var $dfYVY = parcelRequire("dfYVY");

var $6ovHY = parcelRequire("6ovHY");
const $143ea4983eeb61e3$export$6ac2bdfc986ad85c = (plays, existingProperties, issueMap)=>{
    const finalPlays = {
        ...plays
    };
    for (const [playId, values] of Object.entries(existingProperties.plays))for (const localIssueId of Object.keys(values)){
        const jiraIssueId = Object.keys(issueMap).find((key)=>issueMap[key] === localIssueId);
        if (jiraIssueId) finalPlays[playId][jiraIssueId] = existingProperties.plays[playId][localIssueId];
    }
    return finalPlays;
};
const $143ea4983eeb61e3$export$9d5b737165a4564e = (insights, existingProperties, issueMap)=>{
    const finalInsights = {
        ...insights
    };
    for (const localIssueId of Object.keys(issueMap)){
        const jiraIssueId = issueMap[localIssueId];
        finalInsights[localIssueId] = existingProperties.insights[jiraIssueId];
    }
    return finalInsights;
};
const $143ea4983eeb61e3$export$6fab2b4ae9d035d1 = (issueId, mapping, fieldMappings, existingState)=>{
    if (mapping[issueId] === undefined) return false;
    return fieldMappings[0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b].getAllValues(existingState, undefined)[mapping[issueId]] !== undefined;
};
const $143ea4983eeb61e3$export$2d9b03d703912ffb = (args)=>{
    const { remoteIssues: remoteIssues, primaryIssueList: primaryIssueList, insights: insights, plays: plays, existingState: existingState, existingMapping: existingMapping = {}, props: props } = args;
    const { polarisIssueLinkType: polarisIssueLinkType, hiddenIssueLinkTypes: hiddenIssueLinkTypes, rankField: rankField } = props;
    const fieldMappings = (0, $iehDF.getFieldMappings)(existingState, props);
    const ids = [];
    const connectionIssueIds = new Set([]);
    const properties = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))((0, $amUSo.EMPTY_PROPERTIES));
    let externalIssueData = {};
    const issues = (0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') ? remoteIssues : (0, $6ovHY.sortIssuesByRank)({
        issues: remoteIssues,
        rankField: rankField
    });
    issues.forEach((issue)=>{
        const isIssueLoaded = $143ea4983eeb61e3$export$6fab2b4ae9d035d1(issue.id, existingMapping, fieldMappings, existingState);
        // reuse the existing local issue id if it already exists
        // this can be the case when loading a single idea in a new tab
        const id = existingMapping[issue.id] || (0, $g3PIQ.generateLocalIssueId)();
        if (existingMapping[issue.id] === undefined) existingMapping[issue.id] = id;
        if (primaryIssueList === undefined || primaryIssueList.includes(issue.id)) ids.push(id);
        else connectionIssueIds.add(id);
        // we do not want to override the field values of the already loaded issue (if any)
        // because some fields which are already loaded (e.g. description) would have an
        // undefined value as they are not present
        if (!isIssueLoaded) (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(fieldMappings, (mapping)=>{
            // do not attempt to map dynamic fields from jira values
            if (mapping.field?.formula !== undefined) return;
            const fieldValue = mapping.getValueFromJiraIssue(issue);
            mapping.setMutable(properties, id, fieldValue !== null ? fieldValue : undefined);
        });
        // handle lexorank
        if (rankField !== undefined) properties.lexoRank[id] = issue.fields[rankField];
        if (insights !== undefined && Array.isArray(insights[issue.id])) properties.insights[id] = insights[issue.id];
        properties.issueMetadata[id] = (0, $gyMEu.getMetaFromJiraSearchIssue)(issue, polarisIssueLinkType, hiddenIssueLinkTypes);
        const issueLinkData = (0, $dfYVY.transformIssueLinkData)(polarisIssueLinkType, hiddenIssueLinkTypes, issue);
        properties.linkedDeliveryIssues[id] = issueLinkData.deliveryIssueIds;
        externalIssueData = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(externalIssueData, issueLinkData.externalIssueData);
    });
    if (plays) {
        for (const [, play] of Object.entries(plays))for (const issueId of Object.keys(play)){
            const localIssueId = existingMapping[issueId];
            if (localIssueId) {
                if (properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e] === undefined) properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e] = {};
                fieldMappings[0, $9a5f06039e1dff5a$export$48927a8f78b0130e].setMutable(properties, localIssueId, Number.parseInt(issueId, 10));
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const issuePlaysWithContributions = Object.keys(plays).reduce((acc, key)=>{
            const play = plays[key];
            for (const issueId of Object.keys(play)){
                const localIssueId = existingMapping[issueId];
                if (Array.isArray(play[issueId])) {
                    if (acc[key] === undefined) acc[key] = {};
                    acc[key][localIssueId] = play[issueId];
                }
            }
            return acc;
        }, {});
        properties.plays = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(properties.plays, issuePlaysWithContributions);
    }
    return {
        ids: ids,
        properties: properties,
        externalIssueData: externalIssueData,
        connectionIssueIds: Array.from(connectionIssueIds)
    };
};
const $143ea4983eeb61e3$export$a68c4c0847145a11 = (args)=>{
    const { remoteIssues: remoteIssues, primaryIssueList: primaryIssueList, insights: insights, plays: plays, existingState: existingState, existingMapping: existingMapping = {}, props: props, mergeConnectionFieldValues: mergeConnectionFieldValues, skipMetaIfAlreadyLoaded: skipMetaIfAlreadyLoaded } = args;
    const { polarisIssueLinkType: polarisIssueLinkType, hiddenIssueLinkTypes: hiddenIssueLinkTypes, rankField: rankField } = props;
    const fieldMappings = (0, $iehDF.getFieldMappings)(existingState, props);
    const ids = new Set(existingState.ids);
    const connectionIssueIds = new Set(existingState.connectionIssueIds);
    const properties = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(existingState.properties);
    let externalIssueData = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(existingState.externalIssueData);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issues = (0, $6ovHY.sortIssuesByRank)({
        issues: remoteIssues,
        rankField: rankField
    });
    issues.forEach((issue)=>{
        const isIssueLoaded = $143ea4983eeb61e3$export$6fab2b4ae9d035d1(issue.id, existingMapping, fieldMappings, existingState);
        const id = existingMapping[issue.id] || (0, $g3PIQ.generateLocalIssueId)();
        if (existingMapping[issue.id] === undefined) existingMapping[issue.id] = id;
        if (primaryIssueList === undefined || primaryIssueList.includes(issue.id)) ids.add(id);
        else connectionIssueIds.add(id);
        // If issue is already loaded, only overwrite the properties that are part of the issue response
        const mappingsToIterateOver = isIssueLoaded ? Object.keys(issue.fields).map((fieldKey)=>fieldMappings[fieldKey]).filter(Boolean) : Object.values(fieldMappings);
        (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(mappingsToIterateOver, (mapping)=>{
            // do not attempt to map dynamic fields from jira values
            if (mapping.field?.formula !== undefined) return;
            let fieldValue;
            if (mapping.field?.type === (0, $eTBmS.FIELD_TYPES).CONNECTION && mergeConnectionFieldValues) {
                const additionalConnections = mapping.getValueFromJiraIssue(issue);
                const existingConnections = mapping.valueAccessor(existingState, props, id);
                const joinedConnectionIds = [
                    ...existingConnections,
                    ...additionalConnections ?? []
                ].map(({ id: connectionId })=>connectionId);
                fieldValue = Array.from(new Set(joinedConnectionIds)).map((connectionId)=>({
                        id: connectionId
                    }));
            } else fieldValue = mapping.getValueFromJiraIssue(issue);
            mapping.setMutable(properties, id, fieldValue !== null ? fieldValue : undefined);
        });
        // handle lexorank
        if (rankField !== undefined) properties.lexoRank[id] = issue.fields[rankField];
        if (insights !== undefined && Array.isArray(insights[issue.id])) properties.insights[id] = insights[issue.id];
        const shouldProcessIssueMetadata = !(0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') || !isIssueLoaded || !skipMetaIfAlreadyLoaded;
        if (shouldProcessIssueMetadata) {
            properties.issueMetadata[id] = (0, $gyMEu.getMetaFromJiraSearchIssue)(issue, polarisIssueLinkType, hiddenIssueLinkTypes);
            const issueLinkData = (0, $dfYVY.transformIssueLinkData)(polarisIssueLinkType, hiddenIssueLinkTypes, issue);
            properties.linkedDeliveryIssues[id] = issueLinkData.deliveryIssueIds;
            externalIssueData = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(externalIssueData, issueLinkData.externalIssueData);
        }
    });
    if (plays) {
        for (const [, play] of Object.entries(plays))for (const issueId of Object.keys(play)){
            const localIssueId = existingMapping[issueId];
            if (localIssueId) {
                if (properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e] === undefined) properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e] = {};
                fieldMappings[0, $9a5f06039e1dff5a$export$48927a8f78b0130e].setMutable(properties, localIssueId, Number.parseInt(issueId, 10));
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const issuePlaysWithContributions = Object.keys(plays).reduce((acc, key)=>{
            const play = plays[key];
            for (const issueId of Object.keys(play)){
                const localIssueId = existingMapping[issueId];
                if (Array.isArray(play[issueId])) {
                    if (acc[key] === undefined) acc[key] = {};
                    acc[key][localIssueId] = play[issueId];
                }
            }
            return acc;
        }, {});
        properties.plays = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(properties.plays, issuePlaysWithContributions);
    }
    const sortedIds = rankField && (0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') ? (0, $6ovHY.sortIdsByRank)({
        ids: Array.from(ids),
        lexoRankProperties: properties.lexoRank
    }) : Array.from(ids);
    const sortedConnectionIds = rankField && (0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') ? (0, $6ovHY.sortIdsByRank)({
        ids: Array.from(connectionIssueIds),
        lexoRankProperties: properties.lexoRank
    }) : Array.from(connectionIssueIds);
    return {
        ids: sortedIds,
        properties: properties,
        externalIssueData: externalIssueData,
        connectionIssueIds: sortedConnectionIds
    };
};

});
parcelRegister("dfYVY", function(module, exports) {

$parcel$export(module.exports, "transformIssueLinkData", () => $7069b0ee42adc5bb$export$1a380ee98ba90be1);

var $g3PIQ = parcelRequire("g3PIQ");
const $7069b0ee42adc5bb$var$EMPTY = {
    deliveryIssueIds: [],
    jiraLinkIssueIds: [],
    externalIssueData: {}
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7069b0ee42adc5bb$var$hasDeliveryIssueLink = (linkedIssue, deliveryLinkTypeId, issueLinks)=>issueLinks.find(// @ts-expect-error - TS7006 - Parameter 'link' implicitly has an 'any' type.
    (link)=>link && link.inwardIssue && link.inwardIssue === linkedIssue && link.type && link.type.id === deliveryLinkTypeId) !== undefined;
const $7069b0ee42adc5bb$export$1a380ee98ba90be1 = (polarisIssueLinkType, hiddenIssueLinkTypes, issue)=>{
    if (!issue.fields.issuelinks) return $7069b0ee42adc5bb$var$EMPTY;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selfToExternalIssueId = {};
    const deliveryIssueIds = [];
    const jiraLinkIssueIds = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const externalIssueData = {};
    issue.fields.issuelinks.forEach((issueLink)=>{
        const linkedIssueKey = issueLink?.inwardIssue?.key || issueLink?.outwardIssue?.key;
        if (!linkedIssueKey) return;
        const linkedExternalIssueId = selfToExternalIssueId[linkedIssueKey] || (0, $g3PIQ.generateLocalExternalIssueId)();
        const linkedIssue = issueLink.inwardIssue || issueLink.outwardIssue;
        if (!externalIssueData[linkedExternalIssueId]) externalIssueData[linkedExternalIssueId] = {
            issueId: parseInt(linkedIssue.id, 10),
            issueKey: linkedIssue.key,
            summary: linkedIssue.fields.summary,
            status: linkedIssue.fields.status,
            issueType: linkedIssue.fields.issuetype,
            priority: linkedIssue.fields.priority,
            issueLinkId: issueLink.id,
            isDeliveryIssue: polarisIssueLinkType !== undefined && $7069b0ee42adc5bb$var$hasDeliveryIssueLink(linkedIssue, polarisIssueLinkType, issue.fields.issuelinks),
            childIssues: []
        };
        if (polarisIssueLinkType !== undefined && issueLink.type.id === polarisIssueLinkType && $7069b0ee42adc5bb$var$hasDeliveryIssueLink(linkedIssue, polarisIssueLinkType, issue.fields.issuelinks)) deliveryIssueIds.push(linkedExternalIssueId);
        else if (!hiddenIssueLinkTypes.includes(issueLink.type.id)) jiraLinkIssueIds.push(linkedExternalIssueId);
    });
    return {
        deliveryIssueIds: deliveryIssueIds,
        jiraLinkIssueIds: jiraLinkIssueIds,
        externalIssueData: externalIssueData
    };
};

});



parcelRegister("dkKwx", function(module, exports) {

$parcel$export(module.exports, "createInsight", () => $c48e8e9722b96c14$export$da39b1a57e460d38);

var $exWdq = parcelRequire("exWdq");

var $8oKDI = parcelRequire("8oKDI");

var $iWbQb = parcelRequire("iWbQb");
const $c48e8e9722b96c14$export$da39b1a57e460d38 = (insight)=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        if (!insight.container) return;
        const { resourceId: resourceId } = (0, $8oKDI.getAriConfig)(insight.container);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, resourceId)) return;
        setState({
            properties: {
                ...state.properties,
                insights: {
                    ...state.properties.insights,
                    [localIdMap[resourceId]]: [
                        ...state.properties.insights[localIdMap[resourceId]] || [],
                        insight
                    ]
                }
            }
        });
    };

});

parcelRegister("edREW", function(module, exports) {

$parcel$export(module.exports, "deleteInsightFromRemote", () => $39e0f6c5816bd548$export$1033bba795b17a11);
$parcel$export(module.exports, "deleteInsight", () => $39e0f6c5816bd548$export$5525f8b7b272bf0f);

var $exWdq = parcelRequire("exWdq");

var $5m7Wy = parcelRequire("5m7Wy");

var $8oKDI = parcelRequire("8oKDI");

var $iWbQb = parcelRequire("iWbQb");
const $39e0f6c5816bd548$export$1033bba795b17a11 = (insightIdAsNumber, jiraIssueId)=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        const { cloudId: cloudId } = props;
        // sadly, there is a terrible inconsistency.  Our ARIs for events were ari:cloud:jira-polaris:...:insight/nnn
        // (we are no longer emitting events on those channels, for different reasons) but our internal objects
        // are ari:cloud:jira:...:polaris-insight/nnn
        // See POL-21 :'(
        const insightId = (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'polaris-insight',
            resourceId: String(insightIdAsNumber)
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, jiraIssueId)) return;
        const original = state.properties.insights[localIdMap[jiraIssueId]] || [];
        const trimmed = (0, (/*@__PURE__*/$parcel$interopDefault($5m7Wy)))(original, ({ id: id })=>id === insightId);
        setState({
            properties: {
                ...state.properties,
                insights: {
                    ...state.properties.insights,
                    [localIdMap[jiraIssueId]]: trimmed
                }
            }
        });
    };
const $39e0f6c5816bd548$export$5525f8b7b272bf0f = (insight)=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        if (!insight.container) return;
        const { resourceId: resourceId } = (0, $8oKDI.getAriConfig)(insight.container);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, resourceId)) return;
        setState({
            properties: {
                ...state.properties,
                insights: {
                    ...state.properties.insights,
                    [localIdMap[resourceId]]: (0, (/*@__PURE__*/$parcel$interopDefault($5m7Wy)))(state.properties.insights[localIdMap[resourceId]] || [], ({ id: id })=>id === insight.id)
                }
            }
        });
    };

});

parcelRegister("i8ZQM", function(module, exports) {

$parcel$export(module.exports, "refreshInsights", () => $cb6194b50540fa61$export$30cbf9b378cba227);
$parcel$export(module.exports, "refreshSnippet", () => $cb6194b50540fa61$export$84035e6c24de8a85);

var $huH03 = parcelRequire("huH03");

const $cb6194b50540fa61$export$30cbf9b378cba227 = (ideaId)=>({ getState: getState, setState: setState }, { projectId: projectId, insightsRemote: insightsRemote })=>{
        const state = getState();
        const jiraIssueId = state.properties.number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e][ideaId];
        if (jiraIssueId === undefined || projectId === undefined || !insightsRemote.fetchInsightsForIssue) return;
        insightsRemote.fetchInsightsForIssue({
            issueId: String(jiraIssueId)
        }).then((insights)=>{
            setState({
                properties: {
                    ...getState().properties,
                    insights: {
                        ...getState().properties.insights,
                        [ideaId]: insights || []
                    }
                }
            });
        });
    };
const $cb6194b50540fa61$var$optimisicEmptySnippetRefreshState = {
    error: null,
    errorType: null,
    last: null,
    next: null
};
const $cb6194b50540fa61$var$updateSnippet = (state, snippetId, update)=>({
        ...state,
        properties: {
            ...state.properties,
            insights: (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(state.properties.insights, (insights)=>insights.map((insight)=>{
                    let { updated: updated } = insight;
                    const snippets = insight.snippets.map((snippet)=>{
                        if (snippet.id !== snippetId) return snippet;
                        const updatedSnippet = update(snippet);
                        updated = updatedSnippet.updated;
                        return updatedSnippet;
                    });
                    return {
                        ...insight,
                        updated: updated,
                        snippets: snippets
                    };
                }))
        }
    });
const $cb6194b50540fa61$export$84035e6c24de8a85 = (snippetId)=>async ({ getState: getState, setState: setState }, { projectId: projectId, insightsRemote: insightsRemote })=>{
        if (projectId === undefined) return;
        setState($cb6194b50540fa61$var$updateSnippet(getState(), snippetId, (snippet)=>({
                ...snippet,
                refresh: {
                    ...snippet.refresh || $cb6194b50540fa61$var$optimisicEmptySnippetRefreshState,
                    queued: 'manual'
                }
            })));
        insightsRemote.refreshSnippet?.({
            id: snippetId
        }).then((snippets)=>{
            setState(snippets.filter(Boolean).reduce((acc, snippet)=>$cb6194b50540fa61$var$updateSnippet(acc, snippet.id, ()=>snippet), getState()));
        });
    };

});

parcelRegister("aDGGE", function(module, exports) {

$parcel$export(module.exports, "setTimestampIssueInsightsSeen", () => $58e1930f8c3c798a$export$bf73d8363d6828c0);

var $iWbQb = parcelRequire("iWbQb");

var $7SDB8 = parcelRequire("7SDB8");

var $lr3tD = parcelRequire("lr3tD");
const $58e1930f8c3c798a$export$bf73d8363d6828c0 = (localIssueId, timestampCurrentUserSeenInsights)=>async ({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const isIssueHavingUnseenInsights = (0, $7SDB8.createIsIssueHavingUnseenInsights)(localIssueId)(state, props);
        if (!isIssueHavingUnseenInsights) return;
        setState({
            properties: {
                ...state.properties,
                insightsMetadata: {
                    ...state.properties.insightsMetadata,
                    [localIssueId]: {
                        timestampCurrentUserSeenInsights: timestampCurrentUserSeenInsights
                    }
                }
            }
        });
        const { issuesRemote: issuesRemote } = props;
        const issueId = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props)[localIssueId];
        const projectId = props.projectId || (0, $lr3tD.createGetProject)(localIssueId)(state)?.id;
        if (!projectId) throw new Error('IssueController action setTimestampIssueInsightsSeen: projectId is undefined');
        if (issueId !== undefined) issuesRemote.updateLastInsightsViewedTimestamp({
            issueId: issueId,
            timestamp: new Date(timestampCurrentUserSeenInsights).toISOString(),
            projectId: projectId
        });
    };

});

parcelRegister("gJMbI", function(module, exports) {

$parcel$export(module.exports, "updateInsights", () => $304313e2b22288b0$export$99d4d7498a9f42d5);
$parcel$export(module.exports, "updateInsightFromRemote", () => $304313e2b22288b0$export$330cc761eeef759e);
$parcel$export(module.exports, "updateInsightsFromProps", () => $304313e2b22288b0$export$f560c8373cf9e8b0);

var $8V8so = parcelRequire("8V8so");

var $gtr2v = parcelRequire("gtr2v");

var $aa6Wo = parcelRequire("aa6Wo");

var $36jxt = parcelRequire("36jxt");

var $iWbQb = parcelRequire("iWbQb");

var $7SDB8 = parcelRequire("7SDB8");

var $jZDOT = parcelRequire("jZDOT");

var $q8Sc5 = parcelRequire("q8Sc5");
const $304313e2b22288b0$export$99d4d7498a9f42d5 = (jiraIssueId, insights)=>({ dispatch: dispatch, getState: getState, setState: setState }, props)=>{
        const state = getState();
        const localIssueId = (0, $iWbQb.getLocalIssueIdForJiraIssueId)(jiraIssueId)(state, props);
        // If the issue is not loaded yet, refresh it first and then update the insights
        if (!localIssueId) {
            dispatch((0, $jZDOT.refreshIssues)({
                jiraIssueIds: [
                    jiraIssueId
                ],
                callback: ()=>{
                    dispatch($304313e2b22288b0$export$99d4d7498a9f42d5(jiraIssueId, insights));
                }
            }));
            return;
        }
        setState({
            properties: {
                ...state.properties,
                insights: {
                    ...state.properties.insights,
                    [localIssueId]: [
                        // Add new insights
                        ...insights.filter((insight)=>!(state.properties.insights[localIssueId] || []).some((existingInsight)=>existingInsight.id === insight.id)),
                        // Update existing insights
                        ...(state.properties.insights[localIssueId] || []).map((existingInsight)=>{
                            const newInsight = insights.find((insight)=>insight.id === existingInsight.id);
                            return newInsight || existingInsight;
                        })
                    ]
                }
            }
        });
    };
const $304313e2b22288b0$export$330cc761eeef759e = (0, $aa6Wo.asyncSwitchAction)(({ insightId: insightId, insight: insight, jiraIssueId: jiraIssueId, lastExternalUpdate: lastExternalUpdate }, { getState: getState }, props)=>{
    const { cloudId: cloudId, insightsRemote: insightsRemote } = props;
    const insightAri = (0, $gtr2v.AnyAri).create({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'polaris-insight',
        resourceId: String(insightId)
    }).toString();
    const state = getState();
    const localInsight = (0, $7SDB8.createGetInsight)(insightAri)(state, props);
    if (localInsight?.updated === lastExternalUpdate) // already on the newest data, bail and don't refresh
    return Promise.resolve(undefined);
    if (insight) return Promise.resolve((0, $36jxt.transformInsight)(insight));
    return (0, $q8Sc5.getInsightTransformed)(insightsRemote, insightId, jiraIssueId, state, props);
}, (insight, { jiraIssueId: jiraIssueId }, { dispatch: dispatch })=>{
    if (insight) dispatch($304313e2b22288b0$export$99d4d7498a9f42d5(String(jiraIssueId), [
        insight
    ]));
});
const $304313e2b22288b0$export$f560c8373cf9e8b0 = ()=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        setState({
            properties: {
                ...state.properties,
                insights: (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(props.insights ?? {}, (_, issueId)=>localIdMap[issueId])
            }
        });
    };

});
parcelRegister("36jxt", function(module, exports) {

$parcel$export(module.exports, "transformInsight", () => $100167ae5cbfc925$export$ccd2d004862380);
const $100167ae5cbfc925$export$ccd2d004862380 = (polarisApiInsight)=>({
        ...polarisApiInsight,
        snippets: polarisApiInsight?.snippets ? [
            ...polarisApiInsight.snippets
        ] : [],
        play: polarisApiInsight?.play ? {
            ...polarisApiInsight.play
        } : null
    });

});

parcelRegister("q8Sc5", function(module, exports) {

$parcel$export(module.exports, "getInsightTransformed", () => $ced9b0681ae94c8b$export$48b95b82e7f82dc2);

var $exWdq = parcelRequire("exWdq");

var $iWbQb = parcelRequire("iWbQb");
const $ced9b0681ae94c8b$export$48b95b82e7f82dc2 = (insightsRemote, insightIdAsNumber, jiraIssueId, state, props)=>{
    const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, jiraIssueId) || !insightsRemote.fetchInsight) return Promise.resolve(undefined);
    return insightsRemote.fetchInsight({
        id: String(insightIdAsNumber)
    });
};

});


parcelRegister("3la2z", function(module, exports) {

$parcel$export(module.exports, "invalidateFieldValue", () => $c42eee912095b5f7$export$7368bc9f406cd0b7);

var $eTBmS = parcelRequire("eTBmS");

var $3Ku0X = parcelRequire("3Ku0X");

var $5zHFN = parcelRequire("5zHFN");

var $k2MWf = parcelRequire("k2MWf");

var $cOgsk = parcelRequire("cOgsk");

var $iehDF = parcelRequire("iehDF");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");
const $c42eee912095b5f7$var$createIssueUpdateOperation = (localIssueId, fieldKey, fieldMapping, properties, state, props)=>{
    const issueKey = (0, $4TCfW.createGetKeySelector)(localIssueId)(state);
    return ()=>{
        (0, $3Ku0X.sendPendoTrackEvent)((0, $cOgsk.EVENTS).IdeaFieldUpdated);
        return props.issuesRemote.updateIssueField({
            issueKey: issueKey,
            fieldKey: fieldKey,
            value: fieldMapping.getFieldValueForJiraUpdate(fieldMapping.valueAccessor(state, props, localIssueId))
        }).catch((error)=>props.onIssueUpdateFailed(error));
    };
};
const $c42eee912095b5f7$export$7368bc9f406cd0b7 = ({ fieldKey: fieldKey, invalidValue: invalidValue, performSideEffects: performSideEffects })=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const fieldMapping = (0, $iehDF.createGetFieldMapping)(fieldKey)(state, props);
        const ids = (0, $iWbQb.getRankedIssueIds)(state);
        const field = (0, $iehDF.createGetField)(fieldKey)(state, props);
        if (field === undefined || fieldMapping === undefined) return Promise.resolve(undefined);
        const operation = ids.reduce((result, localIssueId)=>{
            if (fieldMapping.isMultiValueField) {
                const newMapping = fieldMapping.modifyImmutableIfMultiValueField(result.properties, localIssueId, undefined, invalidValue);
                if (newMapping !== result.properties) return {
                    properties: newMapping,
                    affectedIssues: [
                        ...result.affectedIssues,
                        localIssueId
                    ]
                };
            } else {
                const previousValue = fieldMapping.valueAccessor({
                    ...getState(),
                    properties: result.properties
                }, props, localIssueId);
                if ((0, $5zHFN.isShallowEqual)(previousValue, invalidValue)) {
                    const newMapping = fieldMapping.setImmutable(state.properties, localIssueId, undefined);
                    if (newMapping !== result.properties) return {
                        properties: newMapping,
                        affectedIssues: [
                            ...result.affectedIssues,
                            localIssueId
                        ]
                    };
                }
            }
            return result;
        }, {
            properties: state.properties,
            affectedIssues: []
        });
        setState({
            properties: operation.properties
        });
        if (performSideEffects) {
            if (field.type === (0, $eTBmS.FIELD_TYPES).STATUS) // special handling for status fields. they are updated through a different endpoint
            // it is therefore required to use the update status action, and this becomes a noop
            throw new Error('Unable to update status field through invalidateFieldValue');
            else {
                // generic update REST call to Jira
                const updateOperations = operation.affectedIssues.map((localIssueId)=>$c42eee912095b5f7$var$createIssueUpdateOperation(localIssueId, field.key, fieldMapping, operation.properties, state, props));
                return (0, $k2MWf.runInBatch)(updateOperations, 4).then(()=>undefined);
            }
        }
        return Promise.resolve(undefined);
    };

});

parcelRegister("6CCCQ", function(module, exports) {

$parcel$export(module.exports, "linkIssue", () => $7bcb74451fe86397$export$32003a8f8a0c2443);
$parcel$export(module.exports, "linkDeliveryIssue", () => $7bcb74451fe86397$export$a1a14621be965097);

var $6kS6u = parcelRequire("6kS6u");

var $gyMEu = parcelRequire("gyMEu");

var $7jTnu = parcelRequire("7jTnu");

var $iehDF = parcelRequire("iehDF");

var $4TCfW = parcelRequire("4TCfW");


var $g3PIQ = parcelRequire("g3PIQ");
const $7bcb74451fe86397$var$createStateWithExternLinkedIssue = (state, props, localIssueId, issueResponse, linkedIssueResponse, isDeliveryIssue)=>{
    const getIdSelector = (0, $4TCfW.createGetIdSelector)(localIssueId);
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const baseIssueId = getIdSelector(state, props);
    const externalIssueId = (0, $g3PIQ.generateLocalExternalIssueId)();
    const issueLink = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(linkedIssueResponse.fields.issuelinks, (link)=>link?.outwardIssue?.id === baseIssueId.toString() || link?.inwardIssue?.id === baseIssueId.toString());
    const issueLinkId = issueLink && issueLink.id;
    const newState = {
        ...state,
        lastUpdatedIssueIds: [
            localIssueId
        ],
        lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
    };
    if (isDeliveryIssue === true) return {
        ...newState,
        externalIssueData: {
            ...state.externalIssueData,
            [externalIssueId]: {
                issueId: +linkedIssueResponse.id,
                issueKey: linkedIssueResponse.key,
                projectId: linkedIssueResponse.fields.project.id,
                summary: linkedIssueResponse.fields.summary,
                status: linkedIssueResponse.fields.status,
                issueType: linkedIssueResponse.fields.issuetype,
                priority: linkedIssueResponse.fields.priority,
                issueLinkId: issueLinkId,
                childIssues: [],
                isDeliveryIssue: isDeliveryIssue
            }
        },
        properties: {
            ...state.properties,
            linkedDeliveryIssues: {
                ...state.properties.linkedDeliveryIssues,
                [localIssueId]: [
                    ...state.properties.linkedDeliveryIssues[localIssueId] || [],
                    externalIssueId
                ]
            }
        }
    };
    if (issueResponse) return {
        ...newState,
        properties: {
            ...state.properties,
            issueMetadata: {
                ...state.properties.issueMetadata,
                [localIssueId]: (0, $gyMEu.getMetaFromJiraSearchIssue)(issueResponse, props.polarisIssueLinkType, props.hiddenIssueLinkTypes)
            }
        }
    };
    return state;
};
const $7bcb74451fe86397$export$32003a8f8a0c2443 = (issueId, jiraIssueId)=>({ getState: getState, setState: setState }, props)=>Promise.all([
            props.issuesRemote.fetchIssue({
                issueIdOrKey: (0, $4TCfW.createGetKeySelector)(issueId)(getState()),
                fields: (0, $iehDF.getFieldKeys)(getState(), props)
            }),
            props.issuesRemote.fetchIssue({
                issueIdOrKey: jiraIssueId,
                fields: (0, $iehDF.getFieldKeys)(getState(), props)
            })
        ]).then(([{ issue: issueResponse }, { issue: linkedIssueResponse }])=>{
            setState($7bcb74451fe86397$var$createStateWithExternLinkedIssue(getState(), props, issueId, issueResponse, linkedIssueResponse));
        });
const $7bcb74451fe86397$export$a1a14621be965097 = (issueId, jiraIssueId)=>({ getState: getState, setState: setState }, props)=>props.issuesRemote.fetchIssue({
            issueIdOrKey: jiraIssueId,
            fields: (0, $iehDF.getFieldKeys)(getState(), props)
        }).then(({ issue: linkedIssueResponse })=>{
            setState($7bcb74451fe86397$var$createStateWithExternLinkedIssue(getState(), props, issueId, null, linkedIssueResponse, true));
        });

});

parcelRegister("k68oL", function(module, exports) {

$parcel$export(module.exports, "loadIssues", () => $9dafdbb12be5756b$export$be1b46a328f9700e);
$parcel$export(module.exports, "loadArchivedIssues", () => $9dafdbb12be5756b$export$e3cdff18b00c7646);

var $fqICx = parcelRequire("fqICx");

var $gCeeo = parcelRequire("gCeeo");

var $8okDh = parcelRequire("8okDh");

var $7jTnu = parcelRequire("7jTnu");

var $amUSo = parcelRequire("amUSo");
const $9dafdbb12be5756b$export$be1b46a328f9700e = ()=>({ getState: getState, setState: setState }, props)=>{
        const { createAnalyticsEvent: createAnalyticsEvent, issuesRemote: issuesRemote, projectId: projectId, isSharedView: isSharedView } = props;
        const state = getState();
        const { isSingleIssueLoaded: isSingleIssueLoaded, singleIssueLoadedTimestamp: singleIssueLoadedTimestamp } = state.meta;
        if (state.meta.initialized || state.meta.loading) return Promise.resolve(undefined);
        if (state.prefechedIssues) return Promise.resolve(undefined);
        setState({
            meta: {
                ...state.meta,
                loading: true,
                error: undefined
            }
        });
        (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_ISSUES_START));
        const fetchStart = new Date();
        const fetchIssuesPromise = !isSharedView ? issuesRemote.fetch({
            archivedFilter: 'ACTIVE_ONLY',
            maxResults: (0, $amUSo.ISSUES_PAGE_LIMIT)
        }) : issuesRemote.fetch({});
        return fetchIssuesPromise.then((allIdeasResponse)=>{
            const { issues: issues, total: total, issueLists: issueLists, issueTypes: issueTypes, issueTypeProjectMap: issueTypeProjectMap } = allIdeasResponse;
            (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_ISSUES_END));
            const commentsCount = issues.reduce((acc, issue)=>{
                if ('meta' in issue) {
                    const count = issue.meta?.comments?.count || 0;
                    return acc + count;
                }
                return acc;
            }, 0);
            const issueLinksCount = issues.reduce((acc, issue)=>{
                if ('meta' in issue) {
                    const count = issue.meta?.issueLinks?.count || 0;
                    return acc + count;
                }
                return acc;
            }, 0);
            (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadIssues success', {
                durationMs: new Date().getTime() - fetchStart.getTime(),
                idsTotal: issues.length,
                projectId: projectId,
                commentsCount: commentsCount,
                issueLinksCount: issueLinksCount,
                responseTotal: total,
                archived: false
            });
            if (isSingleIssueLoaded) (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadIssuesWithSingleIssueLoaded success', {
                timeElapsedSinceSingleIssueLoaded: Math.round(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                (new Date().getTime() - singleIssueLoadedTimestamp) / 1000)
            });
            else (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadIssuesWithoutSingleIssueLoaded success');
            const seenIssueTypeIds = new Set();
            const prefetchedIssueTypes = props.isSharedView ? issues.reduce((acc, issue)=>{
                const issueTypeId = issue.fields.issuetype?.id;
                if (issueTypeId && !seenIssueTypeIds.has(issueTypeId)) {
                    seenIssueTypeIds.add(issueTypeId);
                    acc.push(issue.fields.issuetype);
                }
                return acc;
            }, []) : [];
            setState({
                meta: {
                    ...getState().meta,
                    loading: false,
                    error: undefined
                },
                prefechedIssues: issues,
                prefechedIssueTypes: (0, $7jTnu.fg)('jpd-connections-support-on-published-views') ? Object.values(issueTypes ?? {}) : prefetchedIssueTypes,
                prefetchedPrimaryIssueList: issueLists?.primary?.map((id)=>String(id)),
                issueTypeProjectMap: issueTypeProjectMap
            });
        }).catch((error)=>{
            (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_ISSUES_END));
            (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadIssues failure', {
                projectId: projectId,
                durationMs: new Date().getTime() - fetchStart.getTime()
            });
            setState({
                meta: {
                    ...getState().meta,
                    loading: true,
                    error: error
                },
                ids: [],
                properties: (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))((0, $amUSo.EMPTY_PROPERTIES))
            });
            return undefined;
        });
    };
const $9dafdbb12be5756b$export$e3cdff18b00c7646 = ()=>({ getState: getState, setState: setState }, props)=>{
        const { createAnalyticsEvent: createAnalyticsEvent, issuesRemote: issuesRemote, projectId: projectId, onLoadArchivedIssues: onLoadArchivedIssues } = props;
        const state = getState();
        if (state.meta.loadingArchivedIssues || state.meta.initializedArchived || state.archivedIssues) return Promise.resolve();
        setState({
            meta: {
                ...state.meta,
                loadingArchivedIssues: true,
                archivedError: undefined
            }
        });
        onLoadArchivedIssues();
        (0, $8okDh.jpdProjectPageLoad).mark((0, $8okDh.PAGE_LOAD_MARK_LOAD_ISSUES_START));
        const fetchStart = new Date();
        return issuesRemote.fetch({
            archivedFilter: 'ARCHIVED_ONLY',
            maxResults: (0, $amUSo.ISSUES_PAGE_LIMIT)
        }).then((allIdeasResponse)=>{
            const { issues: issues, issueLists: issueLists, total: total } = allIdeasResponse;
            (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadIssues success', {
                durationMs: new Date().getTime() - fetchStart.getTime(),
                idsTotal: issues.length,
                projectId: projectId,
                responseTotal: total,
                archived: true
            });
            setState({
                meta: {
                    ...getState().meta,
                    loadingArchivedIssues: false,
                    archivedError: undefined
                },
                archivedIssues: issues,
                archivedPrimaryIssueList: (0, $7jTnu.fg)('jpd_open-issues-from-diff-container-in-sidebar') ? issueLists?.primary?.map((id)=>String(id)) : undefined
            });
        }).catch((error)=>{
            (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'loadIssues failure', {
                projectId: projectId,
                durationMs: new Date().getTime() - fetchStart.getTime(),
                archived: true
            });
            setState({
                meta: {
                    ...getState().meta,
                    loadingArchivedIssues: false,
                    archivedError: error
                }
            });
        });
    };

});

parcelRegister("lBPXG", function(module, exports) {

$parcel$export(module.exports, "moveIssue", () => $c776cf176d7d6377$export$ad9ee5173d066064);
$parcel$export(module.exports, "rankBefore", () => $c776cf176d7d6377$export$cf49df19657cfeff);
$parcel$export(module.exports, "rankAfter", () => $c776cf176d7d6377$export$2ed81d12c535aabe);

var $7B8wM = parcelRequire("7B8wM");

var $9F2Gy = parcelRequire("9F2Gy");

var $1I887 = parcelRequire("1I887");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");

var $17y5b = parcelRequire("17y5b");

var $dVE1x = parcelRequire("dVE1x");

var $iEc0P = parcelRequire("iEc0P");
const $c776cf176d7d6377$export$ad9ee5173d066064 = (id, destinationBeforeId, destinationAfterId)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { rankField: rankField, isRankingEnabled: isRankingEnabled } = props;
        const localIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(getState(), props);
        const issueId = localIdMap[id];
        if (!isRankingEnabled) return;
        // move is only possible when sorted by rank - therefore it is safe to clear the temporary rank-information of newly-created issues.
        dispatch((0, $17y5b.clearCreatedProperty)());
        // mark current issue as updated locally to prevent RT updates on the same issue
        dispatch((0, $dVE1x.incrementOpenUpdateCounter)([
            id
        ]));
        // spread state into new object as the store action api gives us a read only state,
        // which leads to flow errors on the reselect selector creators
        const state = getState();
        const ids = [
            ...state.ids
        ];
        // remove ranked issue id from the ids array
        const itemIndex = (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(ids, id);
        ids.splice(itemIndex, 1);
        // calculate new position in ids
        const toIndex = destinationBeforeId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(ids, destinationBeforeId) : (0, (/*@__PURE__*/$parcel$interopDefault($7B8wM)))(ids, destinationAfterId) + 1;
        const rankKey = (0, $4TCfW.createGetKeySelector)(id)(state);
        const rankBeforeKey = destinationBeforeId !== undefined ? (0, $4TCfW.createGetKeySelector)(destinationBeforeId)(state) : undefined;
        const rankAfterKey = rankBeforeKey === undefined && destinationAfterId !== undefined ? (0, $4TCfW.createGetKeySelector)(destinationAfterId)(state) : undefined;
        // optimistic ranking: do not wait for backend response
        props.issuesRemote.rankIssues({
            issueKeys: [
                rankKey
            ],
            rankBeforeIssueKey: rankBeforeKey,
            rankAfterIssueKey: rankAfterKey,
            rankCustomFieldId: rankField !== undefined ? (0, $9F2Gy.toRankCustomFieldId)(rankField) : undefined
        }).then(()=>{
            dispatch((0, $iEc0P.updateIssuesRanks)([
                id
            ]));
        }).catch((error)=>props.onIssueUpdateFailed(error));
        // add issue id to ids again at the new position
        ids.splice(toIndex, 0, id);
        setState({
            ids: ids
        });
        (0, $1I887.fireAnalyticsEventForIssueUpdate)(props.createAnalyticsEvent({}), issueId, {
            updatedItems: [
                {
                    name: 'projectRank'
                }
            ],
            ...(0, $4TCfW.createGetIssueAnalyticsAttributes)(id)(getState())
        });
    };
const $c776cf176d7d6377$export$cf49df19657cfeff = (id, destinationBeforeId)=>$c776cf176d7d6377$export$ad9ee5173d066064(id, destinationBeforeId);
const $c776cf176d7d6377$export$2ed81d12c535aabe = (id, destinationAfterId)=>$c776cf176d7d6377$export$ad9ee5173d066064(id, undefined, destinationAfterId);

});

parcelRegister("6hgrJ", function(module, exports) {

$parcel$export(module.exports, "moveIssuesToTop", () => $81274c0a8c32a8e4$export$18d86a0a145e1981);

var $9F2Gy = parcelRequire("9F2Gy");

var $4TCfW = parcelRequire("4TCfW");

var $17y5b = parcelRequire("17y5b");

var $dVE1x = parcelRequire("dVE1x");

var $iEc0P = parcelRequire("iEc0P");
const $81274c0a8c32a8e4$export$18d86a0a145e1981 = (localIssueIds)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const { rankField: rankField, isRankingEnabled: isRankingEnabled } = props;
        if (!isRankingEnabled) return;
        const localIssueIdSet = new Set(localIssueIds);
        // move is only possible when sorted by rank - therefore it is safe to clear the temporary rank-information of newly-created issues.
        dispatch((0, $17y5b.clearCreatedProperty)());
        dispatch((0, $dVE1x.incrementOpenUpdateCounter)(localIssueIds));
        // spread state into new object as the store action api gives us a read only state,
        // which leads to flow errors on the reselect selector creators
        const state = getState();
        const topId = state.ids[0];
        const ids = [
            ...state.ids
        ].filter((id)=>!localIssueIdSet.has(id));
        const rankKeys = localIssueIds.map((id)=>(0, $4TCfW.createGetKeySelector)(id)(state));
        const rankBeforeKey = (0, $4TCfW.createGetKeySelector)(topId)(state);
        // optimistic ranking: do not wait for backend response
        props.issuesRemote.rankIssues({
            issueKeys: rankKeys,
            rankBeforeIssueKey: rankBeforeKey,
            rankAfterIssueKey: undefined,
            rankCustomFieldId: rankField !== undefined ? (0, $9F2Gy.toRankCustomFieldId)(rankField) : undefined
        }).then(()=>{
            dispatch((0, $iEc0P.updateIssuesRanks)([
                ...localIssueIdSet
            ]));
        }).catch((error)=>props.onIssueUpdateFailed(error));
        // add issue id to ids again at the new position
        ids.splice(0, 0, ...localIssueIds);
        setState({
            ids: ids
        });
    };

});

parcelRegister("M3QQB", function(module, exports) {

$parcel$export(module.exports, "createPlayContribution", () => $2045cc8b93690a3f$export$565c33f2cbbedca4);
$parcel$export(module.exports, "updatePlayContribution", () => $2045cc8b93690a3f$export$f0b666343b5582e3);
$parcel$export(module.exports, "deletePlayContribution", () => $2045cc8b93690a3f$export$a5f53b9fffb7f1c6);
$parcel$export(module.exports, "upsertPlayContributionFromRemote", () => $2045cc8b93690a3f$export$7fcb72f877bb196e);
$parcel$export(module.exports, "deletePlayContributionFromRemote", () => $2045cc8b93690a3f$export$d9f1dcc242a22d84);
$parcel$export(module.exports, "updatePlayContributionsFromProps", () => $2045cc8b93690a3f$export$3e08077fbdfbc4cf);

var $eHEbM = parcelRequire("eHEbM");

var $HXbds = parcelRequire("HXbds");

var $eKoXC = parcelRequire("eKoXC");

var $3xiug = parcelRequire("3xiug");

var $exWdq = parcelRequire("exWdq");

var $8oKDI = parcelRequire("8oKDI");

var $aa6Wo = parcelRequire("aa6Wo");

var $b8E5u = parcelRequire("b8E5u");

var $6Yd06 = parcelRequire("6Yd06");

var $7jTnu = parcelRequire("7jTnu");

var $iWbQb = parcelRequire("iWbQb");


var $i8ZQM = parcelRequire("i8ZQM");

var $iEc0P = parcelRequire("iEc0P");
const $2045cc8b93690a3f$var$getContributionPath = (playId, ideaLocalId)=>`properties.plays[${playId}][${ideaLocalId}]`;
const $2045cc8b93690a3f$export$565c33f2cbbedca4 = ({ amount: amount, comment: comment, play: play, subject: subject }, onSuccess, onError)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const { onActionFailed: onActionFailed, playContributionRemote: playContributionRemote } = props;
        try {
            const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
            const { resourceId: ideaId } = (0, $8oKDI.getAriConfig)(subject);
            const { resourceId: playId } = (0, $8oKDI.getAriConfig)(play);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, ideaId)) {
                onSuccess?.();
                return;
            }
            const ideaLocalId = localIdMap[ideaId];
            const contribution = await playContributionRemote.createPlayContribution({
                amount: amount,
                comment: comment,
                play: play,
                subject: subject
            });
            const path = $2045cc8b93690a3f$var$getContributionPath(playId, ideaLocalId);
            const remoteState = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))(path, [
                ...(0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))([], path, state),
                contribution
            ], state);
            setState({
                ...remoteState,
                lastUpdatedIssueIds: [
                    ideaLocalId
                ],
                lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
            });
            dispatch((0, $i8ZQM.refreshInsights)(ideaLocalId));
            onSuccess?.();
            return contribution;
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Unknown error');
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.plays.action.create', 'Failed to create play contribution', error);
            onActionFailed(error);
            onError?.(error);
        }
    };
const $2045cc8b93690a3f$export$f0b666343b5582e3 = (contributionId, { amount: amount, comment: comment, content: content, play: play, subject: subject }, onSuccess, onError)=>async ({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const { onActionFailed: onActionFailed, playContributionRemote: playContributionRemote } = props;
        try {
            const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
            const { resourceId: ideaId } = (0, $8oKDI.getAriConfig)(subject);
            const { resourceId: playId } = (0, $8oKDI.getAriConfig)(play);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, ideaId)) {
                onSuccess?.();
                return;
            }
            const ideaLocalId = localIdMap[ideaId];
            // Update state optimistically
            const path = $2045cc8b93690a3f$var$getContributionPath(playId, ideaLocalId);
            const contributions = (0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))([], path, state);
            const contributionIdx = (0, (/*@__PURE__*/$parcel$interopDefault($eHEbM)))([
                'id',
                contributionId
            ], contributions);
            const optimisticState = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))(`${path}[${contributionIdx}]`, (0, (/*@__PURE__*/$parcel$interopDefault($eKoXC)))((0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))({}, `${path}[${contributionIdx}]`, state), {
                amount: amount,
                comment: {
                    updated: new Date().toISOString(),
                    body: content
                },
                play: play,
                subject: subject
            }), state);
            setState(optimisticState);
            // Make a call to a service and update state with remote value
            const contribution = await playContributionRemote.updatePlayContribution(contributionId, {
                amount: amount,
                comment: comment,
                content: content
            });
            const remoteState = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))(`${path}[${contributionIdx}]`, (0, (/*@__PURE__*/$parcel$interopDefault($eKoXC)))((0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))({}, `${path}[${contributionIdx}]`, state), contribution), state);
            setState(remoteState);
            onSuccess?.();
            return contribution;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof Error) (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.plays.action.update', 'Failed to update play contribution', error);
            onActionFailed(error);
            onError?.(error);
        }
    };
const $2045cc8b93690a3f$export$a5f53b9fffb7f1c6 = (contributionId, { play: play, subject: subject })=>async ({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        const state = getState();
        const { onActionFailed: onActionFailed, playContributionRemote: playContributionRemote } = props;
        try {
            const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
            const { resourceId: ideaId } = (0, $8oKDI.getAriConfig)(subject);
            const { resourceId: playId } = (0, $8oKDI.getAriConfig)(play);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, ideaId)) return;
            const ideaLocalId = localIdMap[ideaId];
            // Update state optimistically
            const path = $2045cc8b93690a3f$var$getContributionPath(playId, ideaLocalId);
            const contributions = (0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))([], path, state);
            const newContributions = contributions.filter(({ id: id })=>id !== contributionId);
            const optimisticState = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))(path, newContributions, state);
            setState({
                ...optimisticState,
                lastUpdatedIssueIds: [
                    ideaLocalId
                ],
                lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined
            });
            // Delete contribution from polaris api
            await playContributionRemote.deletePlayContribution(contributionId);
            dispatch((0, $i8ZQM.refreshInsights)(ideaLocalId));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof Error) (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.plays.action.delete', 'Failed to delete play contribution', error);
            onActionFailed(error);
        }
    };
const $2045cc8b93690a3f$export$7fcb72f877bb196e = (0, $aa6Wo.asyncSwitchAction)(async ({ playId: playId, contribId: contribId, contribution: contribution }, _, props)=>{
    const { playContributionRemote: playContributionRemote } = props;
    if (contribution) return Promise.resolve((0, $b8E5u.transformPlayContribution)(contribution));
    try {
        return await playContributionRemote.getPlayContribution(playId, contribId);
    } catch (error) {
        if (error instanceof Error) (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.plays.action.upsert-from-remote', 'Failed to upsert play contribution from remote', error);
        return Promise.resolve(undefined);
    }
}, (contribution, { playAri: playAri, subjectId: subjectId }, { getState: getState, setState: setState }, props)=>{
    if (contribution === undefined) return;
    const state = getState();
    const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, subjectId)) return;
    const enrichedContribution = (0, $iEc0P.enrichPlayContributionPayload)(contribution, state.properties.plays);
    const ideaLocalId = localIdMap[subjectId];
    // Play id
    const { resourceId: playId } = (0, $8oKDI.getAriConfig)(playAri);
    const path = $2045cc8b93690a3f$var$getContributionPath(playId, ideaLocalId);
    const contributions = (0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))([], path, state);
    const contributionIdx = (0, (/*@__PURE__*/$parcel$interopDefault($eHEbM)))(({ id: id })=>id === enrichedContribution.id, contributions);
    let remoteState;
    if (contributionIdx === -1) remoteState = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))(path, [
        ...(0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))([], path, state),
        enrichedContribution
    ], state);
    else remoteState = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))(`${path}[${contributionIdx}]`, (0, (/*@__PURE__*/$parcel$interopDefault($eKoXC)))((0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))({}, `${path}[${contributionIdx}]`, state), enrichedContribution), state);
    setState(remoteState);
});
const $2045cc8b93690a3f$export$d9f1dcc242a22d84 = ({ playAri: playAri, subjectId: subjectId, contribAri: contribAri })=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(localIdMap, subjectId)) return;
        const ideaLocalId = localIdMap[subjectId];
        // Play id
        const { resourceId: playId } = (0, $8oKDI.getAriConfig)(playAri);
        const path = $2045cc8b93690a3f$var$getContributionPath(playId, ideaLocalId);
        const contributions = (0, (/*@__PURE__*/$parcel$interopDefault($HXbds)))([], path, state);
        const newContributions = contributions.filter(({ id: id })=>id !== contribAri);
        const optimisticState = (0, (/*@__PURE__*/$parcel$interopDefault($3xiug)))(path, newContributions, state);
        setState(optimisticState);
    };
const $2045cc8b93690a3f$export$3e08077fbdfbc4cf = ()=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const localIdMap = (0, $iWbQb.getLocalIssueIdsByJiraIssueId)(state, props);
        const plays = props.plays ?? {};
        const localPlays = Object.entries(plays).reduce((acc, [key, value])=>Object.assign(acc, {
                [key]: Object.keys(value).reduce((result, issueId)=>{
                    const localIssueId = localIdMap[issueId];
                    if (localIssueId === undefined) return result;
                    return Object.assign(result, {
                        [localIssueId]: value[issueId]
                    });
                }, {})
            }), {});
        setState({
            properties: {
                ...getState().properties,
                plays: localPlays
            }
        });
    };

});
parcelRegister("eKoXC", function(module, exports) {

var $dyMwB = parcelRequire("dyMwB");

var $abc8b9366be7ce27$var$func = $dyMwB('merge', (parcelRequire("1O6Yz")));

$abc8b9366be7ce27$var$func.placeholder = (parcelRequire("k1T10"));
module.exports = $abc8b9366be7ce27$var$func;

});

parcelRegister("b8E5u", function(module, exports) {

$parcel$export(module.exports, "transformPlayContribution", () => $cbdcc9bc5053386d$export$eb6d1956fce36d0b);

var $lLN5n = parcelRequire("lLN5n");
const $cbdcc9bc5053386d$export$eb6d1956fce36d0b = (playContribution)=>{
    const { aaid: aaid, subject: subject, id: id, amount: amount, comment: comment, created: created, updated: updated, account: account } = playContribution;
    const author = (0, $lLN5n.transformCommentUser)(account);
    return {
        aaid: aaid,
        subject: subject,
        id: id,
        amount: amount ?? 0,
        created: created,
        updated: updated,
        author: author,
        comment: comment ? {
            id: comment.id,
            updated: comment.updated,
            created: comment.created,
            body: comment.content,
            updateAuthor: undefined
        } : undefined
    };
};

});


parcelRegister("fPbNL", function(module, exports) {

$parcel$export(module.exports, "removeIssueFromState", () => $b0a065fb9b8943e0$export$ba7012c2600f3e23);

var $jFHCE = parcelRequire("jFHCE");

var $iehDF = parcelRequire("iehDF");
const $b0a065fb9b8943e0$export$ba7012c2600f3e23 = (localIssueId)=>({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const { ids: ids } = state;
        const newIds = ids.filter((id)=>id !== localIssueId);
        const fieldMappings = (0, $iehDF.getFieldMappings)(state, props);
        const properties = props.fields !== undefined ? props.fields.reduce((propertyMap, field)=>fieldMappings[field.key].remove(propertyMap, localIssueId), state.properties) : state.properties;
        const newCreated = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state.properties.created, localIssueId);
        setState({
            ids: newIds,
            properties: {
                ...properties,
                created: {
                    ...newCreated
                }
            }
        });
    };

});

parcelRegister("5DWvi", function(module, exports) {

$parcel$export(module.exports, "setError", () => $d68eadb94de850a3$export$b8d0bb2aa0adefe5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d68eadb94de850a3$export$b8d0bb2aa0adefe5 = (error)=>({ getState: getState, setState: setState })=>{
        setState({
            meta: {
                ...getState().meta,
                error: error
            }
        });
    };

});

parcelRegister("3PB4Y", function(module, exports) {

$parcel$export(module.exports, "setIsSingleIssueLoaded", () => $2cbf929e317e2da6$export$fb1a78d58d9174bb);

var $gCeeo = parcelRequire("gCeeo");
const $2cbf929e317e2da6$export$fb1a78d58d9174bb = (createAnalyticsEvent)=>({ getState: getState, setState: setState })=>{
        if (getState().meta.isSingleIssueLoaded || getState().meta.initialized) return;
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'singleIssueLoaded success');
        setState({
            meta: {
                ...getState().meta,
                isSingleIssueLoaded: true,
                singleIssueLoadedTimestamp: new Date().getTime()
            }
        });
    };

});

parcelRegister("1ET7h", function(module, exports) {

$parcel$export(module.exports, "setIssueLinksForSelectedIssue", () => $a3461e2d280588a0$export$a33aded0b26f0189);

var $gyMEu = parcelRequire("gyMEu");

var $7jTnu = parcelRequire("7jTnu");

var $iWbQb = parcelRequire("iWbQb");

var $4TCfW = parcelRequire("4TCfW");


var $dfYVY = parcelRequire("dfYVY");
const $a3461e2d280588a0$export$a33aded0b26f0189 = (issue)=>({ getState: getState, setState: setState }, props)=>{
        const { polarisIssueLinkType: polarisIssueLinkType } = props;
        const state = getState();
        const selectedIssueLocalIssueId = (0, $4TCfW.getSelectedIssueLocalIssueId)(state);
        const localIssueIdJiraIdMap = (0, $iWbQb.getLocalIssueIdToJiraId)(state, props);
        const selectedIssueJiraId = selectedIssueLocalIssueId ? localIssueIdJiraIdMap[selectedIssueLocalIssueId] : undefined;
        if (selectedIssueLocalIssueId !== undefined && selectedIssueJiraId === issue.id) {
            const issueLinkData = (0, $dfYVY.transformIssueLinkData)(polarisIssueLinkType, props.hiddenIssueLinkTypes, issue);
            setState({
                lastUpdatedIssueIds: [
                    selectedIssueLocalIssueId
                ],
                lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined,
                properties: {
                    ...state.properties,
                    linkedDeliveryIssues: {
                        ...state.properties.linkedDeliveryIssues,
                        [selectedIssueLocalIssueId]: issueLinkData.deliveryIssueIds
                    },
                    issueMetadata: {
                        ...state.properties.issueMetadata,
                        [selectedIssueLocalIssueId]: (0, $gyMEu.getMetaFromJiraSearchIssue)(issue, props.polarisIssueLinkType, props.hiddenIssueLinkTypes)
                    }
                },
                externalIssueData: {
                    ...state.externalIssueData,
                    ...issueLinkData.externalIssueData
                }
            });
        }
    };

});

parcelRegister("dtpA8", function(module, exports) {

$parcel$export(module.exports, "setLoading", () => $2b5ddb65eceb42df$export$3ac708362c1f96eb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2b5ddb65eceb42df$export$3ac708362c1f96eb = (loading)=>({ getState: getState, setState: setState })=>{
        setState({
            meta: {
                ...getState().meta,
                loading: loading
            }
        });
    };

});

parcelRegister("jfjhg", function(module, exports) {

$parcel$export(module.exports, "syncFieldValues", () => $2f7fd770a6650b5a$export$4fcc321c301be15f);

var $iehDF = parcelRequire("iehDF");
const $2f7fd770a6650b5a$export$4fcc321c301be15f = (fieldType, syncTasks)=>({ getState: getState, setState: setState }, props)=>{
        const affectedFields = (0, $iehDF.createGetFieldsOfType)(fieldType)(getState(), props);
        affectedFields.forEach((field)=>{
            const mapping = (0, $iehDF.createGetFieldMapping)(field.key)(getState(), props);
            if (mapping) {
                const allValues = mapping.getAllValues(getState(), props);
                let newMaps = getState().properties;
                Object.keys(allValues).forEach((issueId)=>{
                    const value = allValues[issueId];
                    syncTasks.forEach(({ identity: identity, newValue: newValue })=>{
                        if (identity(value)) {
                            if (newValue !== undefined) // update
                            newMaps = mapping.setImmutable(newMaps, issueId, newValue);
                            else // delete
                            newMaps = mapping.remove(newMaps, issueId);
                        }
                    });
                });
                setState({
                    properties: newMaps
                });
            }
        });
    };

});

parcelRegister("e7p41", function(module, exports) {

$parcel$export(module.exports, "unlinkDeliveryIssue", () => $f56131f4176737b0$export$174f4fb5beb171f);
$parcel$export(module.exports, "unlinkIssueFromStore", () => $f56131f4176737b0$export$8d247b4781491925);

var $75SEb = parcelRequire("75SEb");

var $4c94y = parcelRequire("4c94y");

var $4lYQk = parcelRequire("4lYQk");

var $9pL9Y = parcelRequire("9pL9Y");

var $gyMEu = parcelRequire("gyMEu");

var $7jTnu = parcelRequire("7jTnu");

var $iehDF = parcelRequire("iehDF");

var $4TCfW = parcelRequire("4TCfW");

const $f56131f4176737b0$export$2332cbd127b38eac = (state, props, issueId, issueLinkId, issueResponse, isDeliveryIssue)=>{
    const { externalIssueData: externalIssueData } = state;
    const externalIssueIdsToDelete = (0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))((0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(externalIssueData, (data)=>data.issueLinkId === issueLinkId));
    const newExternalIssueData = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(externalIssueData, (data)=>data.issueLinkId === issueLinkId);
    const linkedDeliveryIssue = state.properties.linkedDeliveryIssues[issueId];
    const newLinkedDeliveryIssues = (0, (/*@__PURE__*/$parcel$interopDefault($75SEb)))(linkedDeliveryIssue, (id)=>externalIssueIdsToDelete.indexOf(id) === -1);
    if (isDeliveryIssue === true) return {
        ...state,
        lastUpdatedIssueIds: [
            issueId
        ],
        lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined,
        properties: {
            ...state.properties,
            linkedDeliveryIssues: {
                ...state.properties.linkedDeliveryIssues,
                [issueId]: newLinkedDeliveryIssues
            }
        },
        externalIssueData: newExternalIssueData
    };
    if (issueResponse) return {
        ...state,
        lastUpdatedIssueIds: [
            issueId
        ],
        lastUpdatedAction: (0, $7jTnu.fg)('jpd_quick_import_copy_paste') ? (0, $d5435e25fbd81376$export$93be3d37558c6543) : undefined,
        properties: {
            ...state.properties,
            issueMetadata: {
                ...state.properties.issueMetadata,
                [issueId]: (0, $gyMEu.getMetaFromJiraSearchIssue)(issueResponse, props.polarisIssueLinkType, props.hiddenIssueLinkTypes)
            }
        },
        externalIssueData: newExternalIssueData
    };
    return state;
};
const $f56131f4176737b0$export$174f4fb5beb171f = (issueId, issueLinkId)=>({ getState: getState, setState: setState }, props)=>props.issuesRemote.deleteIssueLink({
            issueLinkId: issueLinkId
        }).then(()=>setState($f56131f4176737b0$export$2332cbd127b38eac(getState(), props, issueId, issueLinkId, null, true)));
const $f56131f4176737b0$export$8d247b4781491925 = (issueId, issueLinkId)=>({ getState: getState, setState: setState }, props)=>{
        props.issuesRemote.fetchIssue?.({
            issueIdOrKey: (0, $4TCfW.createGetKeySelector)(issueId)(getState()),
            fields: (0, $iehDF.getFieldKeys)(getState(), props)
        }).then(({ issue: issue })=>{
            setState($f56131f4176737b0$export$2332cbd127b38eac(getState(), props, issueId, issueLinkId, issue));
        });
    };

});

parcelRegister("jfPj4", function(module, exports) {

$parcel$export(module.exports, "updateCheckboxOrRatingNumberFieldMapping", () => $a231e804a98bad0d$export$e0a325032ecc6594);

var $eTBmS = parcelRequire("eTBmS");

var $iehDF = parcelRequire("iehDF");
const $a231e804a98bad0d$export$e0a325032ecc6594 = (field)=>({ getState: getState, setState: setState }, props)=>{
        if (field.type !== (0, $eTBmS.FIELD_TYPES).CHECKBOX && field.type !== (0, $eTBmS.FIELD_TYPES).RATING) return;
        const state = getState();
        const { ids: ids, properties: properties } = state;
        const fieldMappings = (0, $iehDF.getNumberFieldMappings)(state, props);
        const fieldMapping = fieldMappings[field.key];
        if (!fieldMapping || ids.length === 0) return;
        const updatedProperties = {
            ...properties
        };
        for (const id of ids)fieldMapping.setMutable(updatedProperties, id, fieldMapping.valueAccessor(state, props, id));
        setState({
            properties: updatedProperties
        });
    };

});

parcelRegister("hgTd8", function(module, exports) {

$parcel$export(module.exports, "updateField", () => $b47aafd0eec5b721$export$792a18290d173848);

var $eTBmS = parcelRequire("eTBmS");

var $7jTnu = parcelRequire("7jTnu");

var $j6dzD = parcelRequire("j6dzD");

var $iehDF = parcelRequire("iehDF");

var $4TCfW = parcelRequire("4TCfW");

var $cNkV6 = parcelRequire("cNkV6");

var $3TA1a = parcelRequire("3TA1a");
const $b47aafd0eec5b721$export$792a18290d173848 = (fieldKey, appendMultiValues, issueId, value, removeValue, // Note: the purpose of this parameter is to allow this function to be called in callbacks with the actual state.
// If not provided
overrideState, onSuccess, onError)=>({ getState: getState, dispatch: dispatch }, props)=>{
        const field = (0, $iehDF.createGetField)(fieldKey)(getState(), props);
        if (field === undefined) return {
            filtered: undefined
        };
        if (field.type === (0, $eTBmS.FIELD_TYPES).STATUS) {
            if (value === undefined) return {
                filtered: undefined
            };
            const issueTypeSelector = (0, $4TCfW.createGetIssueType)(issueId);
            const issueType = issueTypeSelector(overrideState || getState(), props);
            const getStatus = (0, $4TCfW.createGetStatus)(issueId);
            const status = getStatus(overrideState || getState(), props);
            if (issueType === undefined || status === undefined) return {
                filtered: undefined
            };
            const getTransitionForStatusOLD = (0, $j6dzD.createGetTransitionForStatus)(issueType.id, status, // @ts-expect-error - TS2345 - Argument of type 'TFieldValueType' is not assignable to parameter of type 'Status'.
            value);
            let transition = getTransitionForStatusOLD({
                transitions: props.workflowTransitions
            });
            if ((0, $7jTnu.fg)('jpd-aurora-roadmap-inline-edit')) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const statusValue = value;
                // In a multi projects context (like roadmap) all statuses from the projects
                // are merged into a list with only dictinct values, in order to avoid having
                // x amount of "Done" statuses even if they wont have the same id.
                // So only the first occurence of a specific status, considering its name and status category,
                // will be kept in the list.
                // Then when we update status here, the status contained in "value" is not garantee to be
                // from current issue workflow. That's why we get all existing similar statuses
                // and try to get a transition from current status to all of them. Only a transition for a status
                // of the same workflow is possible, so if it exists, that's the one we're keeping.
                const similarStatusIds = statusValue !== null ? (0, $iehDF.getIssuesSimiliarStatusIdsByStatusId)(getState(), props)[statusValue.id] : undefined;
                const allStatuses = props.statusesById ?? {};
                transition = similarStatusIds?.map((statusId)=>{
                    const getTransitionForStatus = (0, $j6dzD.createGetTransitionForStatus)(issueType.id, status, allStatuses[statusId]);
                    return getTransitionForStatus({
                        transitions: props.workflowTransitions
                    });
                }).find((t)=>!!t);
            }
            if (transition !== undefined) return dispatch((0, $3TA1a.updateStatus)(fieldKey, issueId, transition, onSuccess, onError));
            return {
                filtered: undefined
            };
        }
        if (field.type === (0, $eTBmS.FIELD_TYPES).REPORTER) {
            if (value === undefined) return {
                filtered: undefined
            };
        }
        return dispatch((0, $cNkV6.updateFieldValue)({
            fieldKey: fieldKey,
            localIssueIds: [
                issueId
            ],
            newValue: value,
            removeValue: removeValue,
            appendMultiValues: appendMultiValues
        }));
    };

});

parcelRegister("iy7OM", function(module, exports) {

$parcel$export(module.exports, "refreshStatuses", () => $d0796fdf929b88d5$export$8ee4741549171f3e);


var $iehDF = parcelRequire("iehDF");
const $d0796fdf929b88d5$export$8ee4741549171f3e = ()=>async ({ getState: getState, setState: setState }, props)=>{
        const state = getState();
        const fieldMappings = (0, $iehDF.getFieldMappings)(state, props);
        const statusFieldMapping = fieldMappings[0, $9a5f06039e1dff5a$export$29157f6cae91bb2f];
        if (!statusFieldMapping) return;
        let newProperties = {
            ...state.properties
        };
        state.ids.forEach((localIssueId)=>{
            const currentValue = statusFieldMapping.valueAccessor(state, props, localIssueId) || [];
            const foundStatus = props.statusesById?.[currentValue?.id];
            if (foundStatus) newProperties = statusFieldMapping.setImmutable(newProperties, localIssueId, foundStatus);
        });
        setState({
            properties: newProperties
        });
    };

});

parcelRegister("kth50", function(module, exports) {

$parcel$export(module.exports, "saveIssueBulk", () => $ae9b41b5933a9f3d$export$d640c63fe5bba2d5);

var $jFHCE = parcelRequire("jFHCE");


var $dVE1x = parcelRequire("dVE1x");

var $iehDF = parcelRequire("iehDF");

var $cNkV6 = parcelRequire("cNkV6");

var $jkDvC = parcelRequire("jkDvC");

var $j9i1D = parcelRequire("j9i1D");

var $8gzqE = parcelRequire("8gzqE");
const $ae9b41b5933a9f3d$export$d640c63fe5bba2d5 = (issuesMap, issueTypeId, createdProperty, onIssueSaved, onIssueSaveError, onCreatedIssueFiltered, deferJiraEvents, resumeJiraEvents)=>({ getState: getState, setState: setState, dispatch: dispatch }, props)=>{
        setState({
            lastUpdatedAction: undefined
        });
        const { issuesRemote: issuesRemote, isRankingEnabled: isRankingEnabled, rankField: rankField } = props;
        const newLocalIds = Object.keys(issuesMap);
        deferJiraEvents?.();
        dispatch((0, $dVE1x.incrementOpenUpdateCounter)(newLocalIds));
        // Building request payload
        const payloadByLocalIssueId = (0, $8gzqE.generateBulkUpdatePayload)(issuesMap);
        // Optimistic state update
        const state = getState();
        const optimisticProperties = (0, $8gzqE.updateStateProperties)(state.properties, issuesMap, createdProperty);
        // Anchor before means that item should be after
        const rankAfter = createdProperty.anchorBefore;
        const rankBefore = createdProperty.anchorAfter;
        const optimisticIds = (0, $8gzqE.getNewSortedIds)(state.ids, newLocalIds, rankBefore, rankAfter);
        setState({
            properties: optimisticProperties,
            ids: optimisticIds
        });
        const lastId = newLocalIds.at(-1) || '';
        const anchorAfterIssueKey = (0, $8gzqE.getAnchorKey)(optimisticProperties, lastId, optimisticIds);
        // Request
        return issuesRemote.createIssueBulk({
            issueTypeId: issueTypeId,
            payloadByLocalIssueId: payloadByLocalIssueId,
            isRankingEnabled: isRankingEnabled,
            rankBeforeIdeaKey: anchorAfterIssueKey,
            rankCustomFieldId: rankField,
            onBatchCreated: (idMap)=>(0, $8gzqE.updateLocalIssueIdToJiraId)(idMap, getState, setState)
        }).then((response)=>{
            // Update state with properties from response
            const stateForUpdateOperation = getState();
            const newCreated = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(stateForUpdateOperation.properties.created, newLocalIds);
            const properties = {
                ...stateForUpdateOperation.properties,
                created: newCreated
            };
            const fieldMappings = (0, $iehDF.getFieldMappings)(state, props);
            const updatedProperties = (0, $8gzqE.updatePropertiesWithResponse)(fieldMappings, newLocalIds, response, properties);
            setState({
                properties: updatedProperties
            });
            setState({
                lastUpdatedIssueIds: newLocalIds
            });
            const issueIds = Object.values(response).map((jiraResponse)=>jiraResponse.id);
            onIssueSaved?.(issueIds);
            // In case of grouping update issues with grouped values
            const fieldsToUpdate = (0, $jkDvC.getFieldsToUpdate)(createdProperty);
            if (Object.keys(fieldsToUpdate).length > 0) dispatch((0, $cNkV6.updateFieldValues)({
                fields: (0, $jkDvC.getFieldsToUpdatePayload)(fieldsToUpdate),
                localIssueIds: newLocalIds
            }));
            setState({
                lastUpdatedAction: (0, $d5435e25fbd81376$export$536f1c793405c625)
            });
            // Handle filtering
            if (onCreatedIssueFiltered) {
                const visibleIssueIds = (0, $j9i1D.getFilteredIssueIds)(getState(), props);
                const createdFilteredIds = newLocalIds.filter((id)=>!visibleIssueIds.includes(id));
                if (createdFilteredIds.length > 0) onCreatedIssueFiltered(createdFilteredIds);
            }
            resumeJiraEvents?.();
        }).catch((error)=>{
            resumeJiraEvents?.();
            props.onIssueCreationFailed(error, issueTypeId);
            onIssueSaveError && onIssueSaveError(error);
        });
    };

});
parcelRegister("8gzqE", function(module, exports) {

$parcel$export(module.exports, "generateBulkUpdatePayload", () => $87719c546c6087d6$export$95a9ee3ebdce6337);
$parcel$export(module.exports, "updateStateProperties", () => $87719c546c6087d6$export$42475c8ff6aef654);
$parcel$export(module.exports, "getNewSortedIds", () => $87719c546c6087d6$export$7b8a74469eeda69d);
$parcel$export(module.exports, "getAnchorKey", () => $87719c546c6087d6$export$5a150adcd1e181cd);
$parcel$export(module.exports, "updateLocalIssueIdToJiraId", () => $87719c546c6087d6$export$ced2293e9962060c);
$parcel$export(module.exports, "updatePropertiesWithResponse", () => $87719c546c6087d6$export$93c08319937668d2);

var $3zv7S = parcelRequire("3zv7S");

var $eTBmS = parcelRequire("eTBmS");


function $87719c546c6087d6$export$95a9ee3ebdce6337(issuesMap) {
    return Object.entries(issuesMap).reduce((payload, [issueId, summary])=>{
        // eslint-disable-next-line no-param-reassign
        payload[issueId] = {
            fields: {
                summary: summary
            }
        };
        return payload;
    }, {});
}
function $87719c546c6087d6$export$932472117f9bb21d(properties) {
    return {
        ...properties,
        string: {
            ...properties.string,
            [(0, $eTBmS.FIELD_TYPES).SUMMARY]: {
                ...properties.string[(0, $eTBmS.FIELD_TYPES).SUMMARY]
            }
        },
        created: {
            ...properties.created
        }
    };
}
function $87719c546c6087d6$export$42475c8ff6aef654(propertiesState, issuesMap, createInputProperty) {
    let anchorBefore = createInputProperty.anchorBefore;
    const copyOfProperties = $87719c546c6087d6$export$932472117f9bb21d(propertiesState);
    Object.entries(issuesMap).forEach(([localIssueId, summary])=>{
        copyOfProperties.string.summary[localIssueId] = summary;
        copyOfProperties.created[localIssueId] = {
            ...createInputProperty,
            anchorBefore: anchorBefore,
            status: (0, $d5435e25fbd81376$export$2990a40bc316c88b)
        };
        // Move anchor to next item
        anchorBefore = localIssueId;
    });
    return copyOfProperties;
}
const $87719c546c6087d6$export$7b8a74469eeda69d = (ids, newIds, before, after)=>{
    let index = ids.length;
    if (before !== undefined) index = ids.indexOf(before);
    else if (after !== undefined) index = ids.indexOf(after) + 1;
    return index > -1 ? [
        ...ids.slice(0, index),
        ...newIds,
        ...ids.slice(index)
    ] : [
        ...ids,
        ...newIds
    ];
};
function $87719c546c6087d6$export$5a150adcd1e181cd(propertiesState, lastId, ids) {
    const lastIdIndex = ids.indexOf(lastId);
    const anchorAfterId = ids[lastIdIndex + 1];
    return propertiesState.string[0, $9a5f06039e1dff5a$export$3aafeb2daa00df8b]?.[anchorAfterId];
}
const $87719c546c6087d6$export$ced2293e9962060c = (map, getState, setState)=>{
    const { properties: properties } = getState();
    const { number: number } = properties;
    const issueIds = number[0, $9a5f06039e1dff5a$export$48927a8f78b0130e];
    setState({
        properties: {
            ...properties,
            number: {
                ...number,
                [(0, $9a5f06039e1dff5a$export$48927a8f78b0130e)]: {
                    ...issueIds,
                    ...map
                }
            }
        }
    });
};
function $87719c546c6087d6$export$93c08319937668d2(fieldMappings, newLocalIds, response, properties) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(fieldMappings, (acc, mapping)=>{
        let nextAcc = acc;
        newLocalIds.forEach((id)=>{
            const responseIssue = response[id];
            const jiraValue = mapping.getValueFromJiraIssue(responseIssue);
            nextAcc = mapping.setImmutable(nextAcc, id, jiraValue !== null ? jiraValue : undefined);
        });
        return nextAcc;
    }, properties);
}

});


parcelRegister("4qYoW", function(module, exports) {

$parcel$export(module.exports, "addDeferredEvent", () => $bb32fceb915c2f79$export$2f090323c6d172b9);
$parcel$export(module.exports, "pauseRealtimeEvents", () => $bb32fceb915c2f79$export$3503d81675e9cce4);
$parcel$export(module.exports, "resumeRealtimeEvents", () => $bb32fceb915c2f79$export$3274c5d452a7bf89);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $bb32fceb915c2f79$export$2f090323c6d172b9 = (realTimeEvents)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const evenTypeList = state.defferRealTimeEvents ? [
            ...state.defferRealTimeEvents,
            ...realTimeEvents
        ] : realTimeEvents;
        setState({
            ...state,
            defferRealTimeEvents: evenTypeList
        });
    };
const $bb32fceb915c2f79$export$3503d81675e9cce4 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            defferRealTimeEventsCounter: (state.defferRealTimeEventsCounter ?? 0) + 1
        });
    };
const $bb32fceb915c2f79$export$3274c5d452a7bf89 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        if (!state.defferRealTimeEventsCounter) return [];
        const counter = state.defferRealTimeEventsCounter - 1;
        if (counter <= 0) {
            const removedItems = [
                ...state.defferRealTimeEvents ?? []
            ];
            setState({
                ...state,
                defferRealTimeEvents: [],
                defferRealTimeEventsCounter: 0
            });
            return removedItems;
        }
        setState({
            ...state,
            defferRealTimeEventsCounter: counter
        });
        return [];
    };

});





parcelRegister("hYLdy", function(module, exports) {

$parcel$export(module.exports, "useIsLoadingLinkedIssues", () => $ae81589a8264d00e$export$1fac016baae378e9);
$parcel$export(module.exports, "useIsInitialized", () => $ae81589a8264d00e$export$6bdd1309cf441b76);
$parcel$export(module.exports, "useIsIssuesLoading", () => $ae81589a8264d00e$export$76d17484bbbf8f1b);
$parcel$export(module.exports, "useError", () => $ae81589a8264d00e$export$5027865de34f9ec6);
$parcel$export(module.exports, "useIsArchivedIssuesLoading", () => $ae81589a8264d00e$export$f19f2b423cafa9e3);
$parcel$export(module.exports, "useArchivedError", () => $ae81589a8264d00e$export$ada88b0b3f44d101);
$parcel$export(module.exports, "useIsDeliveryIssueCountRestricted", () => $ae81589a8264d00e$export$1eadbbbae26565fe);
$parcel$export(module.exports, "useIsInitializedPromise", () => $ae81589a8264d00e$export$8fdb8ef3b7f301b3);
$parcel$export(module.exports, "useIsIssueStatusRollbackInProgress", () => $ae81589a8264d00e$export$e982dda1e407e917);

var $eJOHy = parcelRequire("eJOHy");

var $PrkLW = parcelRequire("PrkLW");

var $gWoBr = parcelRequire("gWoBr");
const $ae81589a8264d00e$export$1fac016baae378e9 = (0, $gWoBr.createIssueHook)((0, $PrkLW.isLoadingLinkedIssues));
const $ae81589a8264d00e$export$6bdd1309cf441b76 = (0, $gWoBr.createIssueHook)((0, $PrkLW.isInitialized));
const $ae81589a8264d00e$export$76d17484bbbf8f1b = (0, $gWoBr.createIssueHook)((0, $PrkLW.isIssuesLoading));
const $ae81589a8264d00e$export$5027865de34f9ec6 = (0, $gWoBr.createIssueHook)((0, $PrkLW.getError));
const $ae81589a8264d00e$export$f19f2b423cafa9e3 = (0, $gWoBr.createIssueHook)((0, $PrkLW.isArchivedIssuesLoading));
const $ae81589a8264d00e$export$ada88b0b3f44d101 = (0, $gWoBr.createIssueHook)((0, $PrkLW.getArchivedError));
const $ae81589a8264d00e$export$1eadbbbae26565fe = (0, $gWoBr.createIssueHook)((0, $PrkLW.isDeliveryIssueCountRestricted));
const $ae81589a8264d00e$export$8fdb8ef3b7f301b3 = ()=>{
    const initialized = $ae81589a8264d00e$export$6bdd1309cf441b76();
    const resolverRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (!initialized) return;
        if (resolverRef.current) resolverRef.current(true);
    }, [
        initialized
    ]);
    /**
	 * resolve the promise either
	 * - immediately if initialized is already true on first hook access
	 *   if the callback function gets recreated due to `initialized` changeing
	 *   this is fine, as any new listeners on the new promise will resolve immediately,
	 *   while the old listeners on the old promise still get served by the resolverRef effect
	 * - delayed, if initialized is false and switches from false to true
	 */ const promise = (0, $eJOHy.useMemo)(()=>initialized ? Promise.resolve(true) : new Promise((resolve)=>{
            resolverRef.current = resolve;
        }), [
        initialized
    ]);
    return (0, $eJOHy.useCallback)(()=>promise, [
        promise
    ]);
};
const $ae81589a8264d00e$export$e982dda1e407e917 = (0, $gWoBr.createIssueHook)((0, $PrkLW.getIsIssueStatusRollbackInProgress));

});

parcelRegister("1YLsD", function(module, exports) {

$parcel$export(module.exports, "useIsSingleIssueLoaded", () => $a46b2ec4bb4b281c$export$4e1ae317535343b7);

var $8Xoaj = parcelRequire("8Xoaj");

var $gWoBr = parcelRequire("gWoBr");
const $a46b2ec4bb4b281c$export$4e1ae317535343b7 = (0, $gWoBr.createIssueHook)((0, $8Xoaj.isSingleIssueLoaded));

});
parcelRegister("8Xoaj", function(module, exports) {

$parcel$export(module.exports, "isSingleIssueLoaded", () => $309f13639cd6a1cb$export$c4d33b0c18381a90);
const $309f13639cd6a1cb$export$c4d33b0c18381a90 = (state)=>state.meta.isSingleIssueLoaded;

});


parcelRegister("5rDh3", function(module, exports) {

$parcel$export(module.exports, "createGetUsersByAccountIdSelector", () => $f4485ab6e4901cea$export$68e2720c8e630d53);

var $ahm5r = parcelRequire("ahm5r");

var $8V8so = parcelRequire("8V8so");

var $4TCfW = parcelRequire("4TCfW");
const $f4485ab6e4901cea$export$68e2720c8e630d53 = (fieldKey)=>(0, $ahm5r.createSelector)((0, $4TCfW.getUserProperties), (userProperties)=>userProperties[fieldKey] ? (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(userProperties[fieldKey], (user)=>user?.accountId) : undefined);

});




$parcel$global.rlb("8D3kc")
//# sourceMappingURL=main.0c030bb9.js.map
